import * as C from "react";
import A, { forwardRef as sr, createContext as __, useContext as W1, useState as Ke, useEffect as Dt, useMemo as Pn, useCallback as Gt, isValidElement as Tl, PureComponent as Wl, Component as jl, useRef as On, useLayoutEffect as fd, Children as ul, createElement as K0, cloneElement as c6, Fragment as C_, useDebugValue as E_, useImperativeHandle as j1 } from "react";
import * as hd from "react-dom";
import G1 from "react-dom";
import { presetIcons as S_ } from "unocss";
function u6(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number")
    r += t;
  else if (typeof t == "object")
    if (Array.isArray(t))
      for (e = 0; e < t.length; e++)
        t[e] && (n = u6(t[e])) && (r && (r += " "), r += n);
    else
      for (e in t)
        t[e] && (r && (r += " "), r += e);
  return r;
}
function d6() {
  for (var t, e, n = 0, r = ""; n < arguments.length; )
    (t = arguments[n++]) && (e = u6(t)) && (r && (r += " "), r += e);
  return r;
}
const lm = (t) => typeof t == "boolean" ? "".concat(t) : t === 0 ? "0" : t, cm = d6, pd = (t, e) => (n) => {
  var r;
  if ((e == null ? void 0 : e.variants) == null)
    return cm(t, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: i, defaultVariants: o } = e, a = Object.keys(i).map((c) => {
    const u = n == null ? void 0 : n[c], d = o == null ? void 0 : o[c];
    if (u === null)
      return null;
    const f = lm(u) || lm(d);
    return i[c][f];
  }), s = n && Object.entries(n).reduce((c, u) => {
    let [d, f] = u;
    return f === void 0 || (c[d] = f), c;
  }, {}), l = e == null || (r = e.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, u) => {
    let { class: d, className: f, ...h } = u;
    return Object.entries(h).every((v) => {
      let [g, m] = v;
      return Array.isArray(m) ? m.includes({
        ...o,
        ...s
      }[g]) : {
        ...o,
        ...s
      }[g] === m;
    }) ? [
      ...c,
      d,
      f
    ] : c;
  }, []);
  return cm(t, a, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
var wc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function q1(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var J0 = { exports: {} }, Is = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var um;
function M_() {
  if (um)
    return Is;
  um = 1;
  var t = A, e = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, c) {
    var u, d = {}, f = null, h = null;
    c !== void 0 && (f = "" + c), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      r.call(l, u) && !o.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps)
      for (u in l = s.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: e, type: s, key: f, ref: h, props: d, _owner: i.current };
  }
  return Is.Fragment = n, Is.jsx = a, Is.jsxs = a, Is;
}
var Fs = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dm;
function T_() {
  return dm || (dm = 1, process.env.NODE_ENV !== "production" && function() {
    var t = A, e = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), v = Symbol.iterator, g = "@@iterator";
    function m(z) {
      if (z === null || typeof z != "object")
        return null;
      var xe = v && z[v] || z[g];
      return typeof xe == "function" ? xe : null;
    }
    var p = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(z) {
      {
        for (var xe = arguments.length, Pe = new Array(xe > 1 ? xe - 1 : 0), Ze = 1; Ze < xe; Ze++)
          Pe[Ze - 1] = arguments[Ze];
        b("error", z, Pe);
      }
    }
    function b(z, xe, Pe) {
      {
        var Ze = p.ReactDebugCurrentFrame, ht = Ze.getStackAddendum();
        ht !== "" && (xe += "%s", Pe = Pe.concat([ht]));
        var Et = Pe.map(function(ut) {
          return String(ut);
        });
        Et.unshift("Warning: " + xe), Function.prototype.apply.call(console[z], console, Et);
      }
    }
    var x = !1, _ = !1, M = !1, S = !1, P = !1, E;
    E = Symbol.for("react.module.reference");
    function w(z) {
      return !!(typeof z == "string" || typeof z == "function" || z === r || z === o || P || z === i || z === c || z === u || S || z === h || x || _ || M || typeof z == "object" && z !== null && (z.$$typeof === f || z.$$typeof === d || z.$$typeof === a || z.$$typeof === s || z.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      z.$$typeof === E || z.getModuleId !== void 0));
    }
    function O(z, xe, Pe) {
      var Ze = z.displayName;
      if (Ze)
        return Ze;
      var ht = xe.displayName || xe.name || "";
      return ht !== "" ? Pe + "(" + ht + ")" : Pe;
    }
    function N(z) {
      return z.displayName || "Context";
    }
    function I(z) {
      if (z == null)
        return null;
      if (typeof z.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof z == "function")
        return z.displayName || z.name || null;
      if (typeof z == "string")
        return z;
      switch (z) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof z == "object")
        switch (z.$$typeof) {
          case s:
            var xe = z;
            return N(xe) + ".Consumer";
          case a:
            var Pe = z;
            return N(Pe._context) + ".Provider";
          case l:
            return O(z, z.render, "ForwardRef");
          case d:
            var Ze = z.displayName || null;
            return Ze !== null ? Ze : I(z.type) || "Memo";
          case f: {
            var ht = z, Et = ht._payload, ut = ht._init;
            try {
              return I(ut(Et));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, j = 0, U, $, V, te, B, Z, Q;
    function ce() {
    }
    ce.__reactDisabledLog = !0;
    function k() {
      {
        if (j === 0) {
          U = console.log, $ = console.info, V = console.warn, te = console.error, B = console.group, Z = console.groupCollapsed, Q = console.groupEnd;
          var z = {
            configurable: !0,
            enumerable: !0,
            value: ce,
            writable: !0
          };
          Object.defineProperties(console, {
            info: z,
            log: z,
            warn: z,
            error: z,
            group: z,
            groupCollapsed: z,
            groupEnd: z
          });
        }
        j++;
      }
    }
    function G() {
      {
        if (j--, j === 0) {
          var z = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, z, {
              value: U
            }),
            info: H({}, z, {
              value: $
            }),
            warn: H({}, z, {
              value: V
            }),
            error: H({}, z, {
              value: te
            }),
            group: H({}, z, {
              value: B
            }),
            groupCollapsed: H({}, z, {
              value: Z
            }),
            groupEnd: H({}, z, {
              value: Q
            })
          });
        }
        j < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var K = p.ReactCurrentDispatcher, J;
    function se(z, xe, Pe) {
      {
        if (J === void 0)
          try {
            throw Error();
          } catch (ht) {
            var Ze = ht.stack.trim().match(/\n( *(at )?)/);
            J = Ze && Ze[1] || "";
          }
        return `
` + J + z;
      }
    }
    var be = !1, pe;
    {
      var Ne = typeof WeakMap == "function" ? WeakMap : Map;
      pe = new Ne();
    }
    function ae(z, xe) {
      if (!z || be)
        return "";
      {
        var Pe = pe.get(z);
        if (Pe !== void 0)
          return Pe;
      }
      var Ze;
      be = !0;
      var ht = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Et;
      Et = K.current, K.current = null, k();
      try {
        if (xe) {
          var ut = function() {
            throw Error();
          };
          if (Object.defineProperty(ut.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ut, []);
            } catch (ee) {
              Ze = ee;
            }
            Reflect.construct(z, [], ut);
          } else {
            try {
              ut.call();
            } catch (ee) {
              Ze = ee;
            }
            z.call(ut.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            Ze = ee;
          }
          z();
        }
      } catch (ee) {
        if (ee && Ze && typeof ee.stack == "string") {
          for (var lt = ee.stack.split(`
`), un = Ze.stack.split(`
`), $t = lt.length - 1, Wt = un.length - 1; $t >= 1 && Wt >= 0 && lt[$t] !== un[Wt]; )
            Wt--;
          for (; $t >= 1 && Wt >= 0; $t--, Wt--)
            if (lt[$t] !== un[Wt]) {
              if ($t !== 1 || Wt !== 1)
                do
                  if ($t--, Wt--, Wt < 0 || lt[$t] !== un[Wt]) {
                    var L = `
` + lt[$t].replace(" at new ", " at ");
                    return z.displayName && L.includes("<anonymous>") && (L = L.replace("<anonymous>", z.displayName)), typeof z == "function" && pe.set(z, L), L;
                  }
                while ($t >= 1 && Wt >= 0);
              break;
            }
        }
      } finally {
        be = !1, K.current = Et, G(), Error.prepareStackTrace = ht;
      }
      var q = z ? z.displayName || z.name : "", ie = q ? se(q) : "";
      return typeof z == "function" && pe.set(z, ie), ie;
    }
    function Re(z, xe, Pe) {
      return ae(z, !1);
    }
    function F(z) {
      var xe = z.prototype;
      return !!(xe && xe.isReactComponent);
    }
    function Ge(z, xe, Pe) {
      if (z == null)
        return "";
      if (typeof z == "function")
        return ae(z, F(z));
      if (typeof z == "string")
        return se(z);
      switch (z) {
        case c:
          return se("Suspense");
        case u:
          return se("SuspenseList");
      }
      if (typeof z == "object")
        switch (z.$$typeof) {
          case l:
            return Re(z.render);
          case d:
            return Ge(z.type, xe, Pe);
          case f: {
            var Ze = z, ht = Ze._payload, Et = Ze._init;
            try {
              return Ge(Et(ht), xe, Pe);
            } catch {
            }
          }
        }
      return "";
    }
    var $e = Object.prototype.hasOwnProperty, he = {}, ue = p.ReactDebugCurrentFrame;
    function Se(z) {
      if (z) {
        var xe = z._owner, Pe = Ge(z.type, z._source, xe ? xe.type : null);
        ue.setExtraStackFrame(Pe);
      } else
        ue.setExtraStackFrame(null);
    }
    function we(z, xe, Pe, Ze, ht) {
      {
        var Et = Function.call.bind($e);
        for (var ut in z)
          if (Et(z, ut)) {
            var lt = void 0;
            try {
              if (typeof z[ut] != "function") {
                var un = Error((Ze || "React class") + ": " + Pe + " type `" + ut + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof z[ut] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw un.name = "Invariant Violation", un;
              }
              lt = z[ut](xe, ut, Ze, Pe, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch ($t) {
              lt = $t;
            }
            lt && !(lt instanceof Error) && (Se(ht), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ze || "React class", Pe, ut, typeof lt), Se(null)), lt instanceof Error && !(lt.message in he) && (he[lt.message] = !0, Se(ht), y("Failed %s type: %s", Pe, lt.message), Se(null));
          }
      }
    }
    var D = Array.isArray;
    function T(z) {
      return D(z);
    }
    function Y(z) {
      {
        var xe = typeof Symbol == "function" && Symbol.toStringTag, Pe = xe && z[Symbol.toStringTag] || z.constructor.name || "Object";
        return Pe;
      }
    }
    function fe(z) {
      try {
        return de(z), !1;
      } catch {
        return !0;
      }
    }
    function de(z) {
      return "" + z;
    }
    function ne(z) {
      if (fe(z))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Y(z)), de(z);
    }
    var Le = p.ReactCurrentOwner, Ce = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Te, ke, ge;
    ge = {};
    function Ee(z) {
      if ($e.call(z, "ref")) {
        var xe = Object.getOwnPropertyDescriptor(z, "ref").get;
        if (xe && xe.isReactWarning)
          return !1;
      }
      return z.ref !== void 0;
    }
    function Be(z) {
      if ($e.call(z, "key")) {
        var xe = Object.getOwnPropertyDescriptor(z, "key").get;
        if (xe && xe.isReactWarning)
          return !1;
      }
      return z.key !== void 0;
    }
    function We(z, xe) {
      if (typeof z.ref == "string" && Le.current && xe && Le.current.stateNode !== xe) {
        var Pe = I(Le.current.type);
        ge[Pe] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', I(Le.current.type), z.ref), ge[Pe] = !0);
      }
    }
    function Fe(z, xe) {
      {
        var Pe = function() {
          Te || (Te = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", xe));
        };
        Pe.isReactWarning = !0, Object.defineProperty(z, "key", {
          get: Pe,
          configurable: !0
        });
      }
    }
    function qe(z, xe) {
      {
        var Pe = function() {
          ke || (ke = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", xe));
        };
        Pe.isReactWarning = !0, Object.defineProperty(z, "ref", {
          get: Pe,
          configurable: !0
        });
      }
    }
    var Ye = function(z, xe, Pe, Ze, ht, Et, ut) {
      var lt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: z,
        key: xe,
        ref: Pe,
        props: ut,
        // Record the component responsible for creating this element.
        _owner: Et
      };
      return lt._store = {}, Object.defineProperty(lt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(lt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ze
      }), Object.defineProperty(lt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ht
      }), Object.freeze && (Object.freeze(lt.props), Object.freeze(lt)), lt;
    };
    function Je(z, xe, Pe, Ze, ht) {
      {
        var Et, ut = {}, lt = null, un = null;
        Pe !== void 0 && (ne(Pe), lt = "" + Pe), Be(xe) && (ne(xe.key), lt = "" + xe.key), Ee(xe) && (un = xe.ref, We(xe, ht));
        for (Et in xe)
          $e.call(xe, Et) && !Ce.hasOwnProperty(Et) && (ut[Et] = xe[Et]);
        if (z && z.defaultProps) {
          var $t = z.defaultProps;
          for (Et in $t)
            ut[Et] === void 0 && (ut[Et] = $t[Et]);
        }
        if (lt || un) {
          var Wt = typeof z == "function" ? z.displayName || z.name || "Unknown" : z;
          lt && Fe(ut, Wt), un && qe(ut, Wt);
        }
        return Ye(z, lt, un, ht, Ze, Le.current, ut);
      }
    }
    var W = p.ReactCurrentOwner, ye = p.ReactDebugCurrentFrame;
    function oe(z) {
      if (z) {
        var xe = z._owner, Pe = Ge(z.type, z._source, xe ? xe.type : null);
        ye.setExtraStackFrame(Pe);
      } else
        ye.setExtraStackFrame(null);
    }
    var me;
    me = !1;
    function Oe(z) {
      return typeof z == "object" && z !== null && z.$$typeof === e;
    }
    function Ae() {
      {
        if (W.current) {
          var z = I(W.current.type);
          if (z)
            return `

Check the render method of \`` + z + "`.";
        }
        return "";
      }
    }
    function Qe(z) {
      {
        if (z !== void 0) {
          var xe = z.fileName.replace(/^.*[\\\/]/, ""), Pe = z.lineNumber;
          return `

Check your code at ` + xe + ":" + Pe + ".";
        }
        return "";
      }
    }
    var Nt = {};
    function on(z) {
      {
        var xe = Ae();
        if (!xe) {
          var Pe = typeof z == "string" ? z : z.displayName || z.name;
          Pe && (xe = `

Check the top-level render call using <` + Pe + ">.");
        }
        return xe;
      }
    }
    function vt(z, xe) {
      {
        if (!z._store || z._store.validated || z.key != null)
          return;
        z._store.validated = !0;
        var Pe = on(xe);
        if (Nt[Pe])
          return;
        Nt[Pe] = !0;
        var Ze = "";
        z && z._owner && z._owner !== W.current && (Ze = " It was passed a child from " + I(z._owner.type) + "."), oe(z), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Pe, Ze), oe(null);
      }
    }
    function Sn(z, xe) {
      {
        if (typeof z != "object")
          return;
        if (T(z))
          for (var Pe = 0; Pe < z.length; Pe++) {
            var Ze = z[Pe];
            Oe(Ze) && vt(Ze, xe);
          }
        else if (Oe(z))
          z._store && (z._store.validated = !0);
        else if (z) {
          var ht = m(z);
          if (typeof ht == "function" && ht !== z.entries)
            for (var Et = ht.call(z), ut; !(ut = Et.next()).done; )
              Oe(ut.value) && vt(ut.value, xe);
        }
      }
    }
    function cr(z) {
      {
        var xe = z.type;
        if (xe == null || typeof xe == "string")
          return;
        var Pe;
        if (typeof xe == "function")
          Pe = xe.propTypes;
        else if (typeof xe == "object" && (xe.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        xe.$$typeof === d))
          Pe = xe.propTypes;
        else
          return;
        if (Pe) {
          var Ze = I(xe);
          we(Pe, z.props, "prop", Ze, z);
        } else if (xe.PropTypes !== void 0 && !me) {
          me = !0;
          var ht = I(xe);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ht || "Unknown");
        }
        typeof xe.getDefaultProps == "function" && !xe.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function yc(z) {
      {
        for (var xe = Object.keys(z.props), Pe = 0; Pe < xe.length; Pe++) {
          var Ze = xe[Pe];
          if (Ze !== "children" && Ze !== "key") {
            oe(z), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ze), oe(null);
            break;
          }
        }
        z.ref !== null && (oe(z), y("Invalid attribute `ref` supplied to `React.Fragment`."), oe(null));
      }
    }
    function Ds(z, xe, Pe, Ze, ht, Et) {
      {
        var ut = w(z);
        if (!ut) {
          var lt = "";
          (z === void 0 || typeof z == "object" && z !== null && Object.keys(z).length === 0) && (lt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var un = Qe(ht);
          un ? lt += un : lt += Ae();
          var $t;
          z === null ? $t = "null" : T(z) ? $t = "array" : z !== void 0 && z.$$typeof === e ? ($t = "<" + (I(z.type) || "Unknown") + " />", lt = " Did you accidentally export a JSX literal instead of a component?") : $t = typeof z, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", $t, lt);
        }
        var Wt = Je(z, xe, Pe, ht, Et);
        if (Wt == null)
          return Wt;
        if (ut) {
          var L = xe.children;
          if (L !== void 0)
            if (Ze)
              if (T(L)) {
                for (var q = 0; q < L.length; q++)
                  Sn(L[q], z);
                Object.freeze && Object.freeze(L);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(L, z);
        }
        return z === r ? yc(Wt) : cr(Wt), Wt;
      }
    }
    function Wr(z, xe, Pe) {
      return Ds(z, xe, Pe, !0);
    }
    function ks(z, xe, Pe) {
      return Ds(z, xe, Pe, !1);
    }
    var bc = ks, xc = Wr;
    Fs.Fragment = r, Fs.jsx = bc, Fs.jsxs = xc;
  }()), Fs;
}
process.env.NODE_ENV === "production" ? J0.exports = M_() : J0.exports = T_();
var R = J0.exports;
const X1 = "-";
function A_(t) {
  const e = R_(t), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = t;
  function i(a) {
    const s = a.split(X1);
    return s[0] === "" && s.length !== 1 && s.shift(), f6(s, e) || P_(a);
  }
  function o(a, s) {
    const l = n[a] || [];
    return s && r[a] ? [...l, ...r[a]] : l;
  }
  return {
    getClassGroupId: i,
    getConflictingClassGroupIds: o
  };
}
function f6(t, e) {
  var a;
  if (t.length === 0)
    return e.classGroupId;
  const n = t[0], r = e.nextPart.get(n), i = r ? f6(t.slice(1), r) : void 0;
  if (i)
    return i;
  if (e.validators.length === 0)
    return;
  const o = t.join(X1);
  return (a = e.validators.find(({
    validator: s
  }) => s(o))) == null ? void 0 : a.classGroupId;
}
const fm = /^\[(.+)\]$/;
function P_(t) {
  if (fm.test(t)) {
    const e = fm.exec(t)[1], n = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function R_(t) {
  const {
    theme: e,
    prefix: n
  } = t, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return O_(Object.entries(t.classGroups), n).forEach(([o, a]) => {
    Q0(a, r, o, e);
  }), r;
}
function Q0(t, e, n, r) {
  t.forEach((i) => {
    if (typeof i == "string") {
      const o = i === "" ? e : hm(e, i);
      o.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (L_(i)) {
        Q0(i(r), e, n, r);
        return;
      }
      e.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(([o, a]) => {
      Q0(a, hm(e, o), n, r);
    });
  });
}
function hm(t, e) {
  let n = t;
  return e.split(X1).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function L_(t) {
  return t.isThemeGetter;
}
function O_(t, e) {
  return e ? t.map(([n, r]) => {
    const i = r.map((o) => typeof o == "string" ? e + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([a, s]) => [e + a, s])) : o);
    return [n, i];
  }) : t;
}
function D_(t) {
  if (t < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let e = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function i(o, a) {
    n.set(o, a), e++, e > t && (e = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get(o) {
      let a = n.get(o);
      if (a !== void 0)
        return a;
      if ((a = r.get(o)) !== void 0)
        return i(o, a), a;
    },
    set(o, a) {
      n.has(o) ? n.set(o, a) : i(o, a);
    }
  };
}
const h6 = "!";
function k_(t) {
  const e = t.separator, n = e.length === 1, r = e[0], i = e.length;
  return function(a) {
    const s = [];
    let l = 0, c = 0, u;
    for (let g = 0; g < a.length; g++) {
      let m = a[g];
      if (l === 0) {
        if (m === r && (n || a.slice(g, g + i) === e)) {
          s.push(a.slice(c, g)), c = g + i;
          continue;
        }
        if (m === "/") {
          u = g;
          continue;
        }
      }
      m === "[" ? l++ : m === "]" && l--;
    }
    const d = s.length === 0 ? a : a.substring(c), f = d.startsWith(h6), h = f ? d.substring(1) : d, v = u && u > c ? u - c : void 0;
    return {
      modifiers: s,
      hasImportantModifier: f,
      baseClassName: h,
      maybePostfixModifierPosition: v
    };
  };
}
function N_(t) {
  if (t.length <= 1)
    return t;
  const e = [];
  let n = [];
  return t.forEach((r) => {
    r[0] === "[" ? (e.push(...n.sort(), r), n = []) : n.push(r);
  }), e.push(...n.sort()), e;
}
function I_(t) {
  return {
    cache: D_(t.cacheSize),
    splitModifiers: k_(t),
    ...A_(t)
  };
}
const F_ = /\s+/;
function U_(t, e) {
  const {
    splitModifiers: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: i
  } = e, o = /* @__PURE__ */ new Set();
  return t.trim().split(F_).map((a) => {
    const {
      modifiers: s,
      hasImportantModifier: l,
      baseClassName: c,
      maybePostfixModifierPosition: u
    } = n(a);
    let d = r(u ? c.substring(0, u) : c), f = !!u;
    if (!d) {
      if (!u)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      if (d = r(c), !d)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      f = !1;
    }
    const h = N_(s).join(":");
    return {
      isTailwindClass: !0,
      modifierId: l ? h + h6 : h,
      classGroupId: d,
      originalClassName: a,
      hasPostfixModifier: f
    };
  }).reverse().filter((a) => {
    if (!a.isTailwindClass)
      return !0;
    const {
      modifierId: s,
      classGroupId: l,
      hasPostfixModifier: c
    } = a, u = s + l;
    return o.has(u) ? !1 : (o.add(u), i(l, c).forEach((d) => o.add(s + d)), !0);
  }).reverse().map((a) => a.originalClassName).join(" ");
}
function z_() {
  let t = 0, e, n, r = "";
  for (; t < arguments.length; )
    (e = arguments[t++]) && (n = p6(e)) && (r && (r += " "), r += n);
  return r;
}
function p6(t) {
  if (typeof t == "string")
    return t;
  let e, n = "";
  for (let r = 0; r < t.length; r++)
    t[r] && (e = p6(t[r])) && (n && (n += " "), n += e);
  return n;
}
function pm(t, ...e) {
  let n, r, i, o = a;
  function a(l) {
    const c = e.reduce((u, d) => d(u), t());
    return n = I_(c), r = n.cache.get, i = n.cache.set, o = s, s(l);
  }
  function s(l) {
    const c = r(l);
    if (c)
      return c;
    const u = U_(l, n);
    return i(l, u), u;
  }
  return function() {
    return o(z_.apply(null, arguments));
  };
}
function It(t) {
  const e = (n) => n[t] || [];
  return e.isThemeGetter = !0, e;
}
const m6 = /^\[(?:([a-z-]+):)?(.+)\]$/i, H_ = /^\d+\/\d+$/, B_ = /* @__PURE__ */ new Set(["px", "full", "screen"]), V_ = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, $_ = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, W_ = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, j_ = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function Rr(t) {
  return Fi(t) || B_.has(t) || H_.test(t);
}
function Kr(t) {
  return ds(t, "length", X_);
}
function Fi(t) {
  return !!t && !Number.isNaN(Number(t));
}
function tl(t) {
  return ds(t, "number", Fi);
}
function xa(t) {
  return !!t && Number.isInteger(Number(t));
}
function v6(t) {
  return t.endsWith("%") && Fi(t.slice(0, -1));
}
function rt(t) {
  return m6.test(t);
}
function Jr(t) {
  return V_.test(t);
}
const G_ = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function g6(t) {
  return ds(t, G_, w6);
}
function y6(t) {
  return ds(t, "position", w6);
}
const q_ = /* @__PURE__ */ new Set(["image", "url"]);
function b6(t) {
  return ds(t, q_, Z_);
}
function x6(t) {
  return ds(t, "", Y_);
}
function wa() {
  return !0;
}
function ds(t, e, n) {
  const r = m6.exec(t);
  return r ? r[1] ? typeof e == "string" ? r[1] === e : e.has(r[1]) : n(r[2]) : !1;
}
function X_(t) {
  return $_.test(t);
}
function w6() {
  return !1;
}
function Y_(t) {
  return W_.test(t);
}
function Z_(t) {
  return j_.test(t);
}
const fn = /* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isAny: wa,
  isArbitraryImage: b6,
  isArbitraryLength: Kr,
  isArbitraryNumber: tl,
  isArbitraryPosition: y6,
  isArbitraryShadow: x6,
  isArbitrarySize: g6,
  isArbitraryValue: rt,
  isInteger: xa,
  isLength: Rr,
  isNumber: Fi,
  isPercent: v6,
  isTshirtSize: Jr
}, Symbol.toStringTag, {
  value: "Module"
});
function mm() {
  const t = It("colors"), e = It("spacing"), n = It("blur"), r = It("brightness"), i = It("borderColor"), o = It("borderRadius"), a = It("borderSpacing"), s = It("borderWidth"), l = It("contrast"), c = It("grayscale"), u = It("hueRotate"), d = It("invert"), f = It("gap"), h = It("gradientColorStops"), v = It("gradientColorStopPositions"), g = It("inset"), m = It("margin"), p = It("opacity"), y = It("padding"), b = It("saturate"), x = It("scale"), _ = It("sepia"), M = It("skew"), S = It("space"), P = It("translate"), E = () => ["auto", "contain", "none"], w = () => ["auto", "hidden", "clip", "visible", "scroll"], O = () => ["auto", rt, e], N = () => [rt, e], I = () => ["", Rr, Kr], H = () => ["auto", Fi, rt], j = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], U = () => ["solid", "dashed", "dotted", "double", "none"], $ = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"], V = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], te = () => ["", "0", rt], B = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], Z = () => [Fi, tl], Q = () => [Fi, rt];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [wa],
      spacing: [Rr, Kr],
      blur: ["none", "", Jr, rt],
      brightness: Z(),
      borderColor: [t],
      borderRadius: ["none", "", "full", Jr, rt],
      borderSpacing: N(),
      borderWidth: I(),
      contrast: Z(),
      grayscale: te(),
      hueRotate: Q(),
      invert: te(),
      gap: N(),
      gradientColorStops: [t],
      gradientColorStopPositions: [v6, Kr],
      inset: O(),
      margin: O(),
      opacity: Z(),
      padding: N(),
      saturate: Z(),
      scale: Z(),
      sepia: te(),
      skew: Q(),
      space: N(),
      translate: N()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", rt]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Jr]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": B()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": B()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...j(), rt]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: w()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": w()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": w()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: E()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": E()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": E()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", xa, rt]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: O()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", rt]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: te()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: te()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", xa, rt]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [wa]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", xa, rt]
        }, rt]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": H()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": H()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [wa]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [xa, rt]
        }, rt]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": H()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": H()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", rt]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", rt]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...V()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...V(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...V(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [y]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [y]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [y]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [y]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [y]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [y]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [y]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [y]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [y]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [S]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [S]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", rt, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [rt, e, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [rt, e, "none", "full", "min", "max", "fit", "prose", {
          screen: [Jr]
        }, Jr]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [rt, e, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [rt, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [rt, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [rt, e, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Jr, Kr]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", tl]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [wa]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", rt]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Fi, tl]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Rr, rt]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", rt]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", rt]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [t]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [p]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [t]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [p]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...U(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Rr, Kr]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Rr, rt]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [t]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: N()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", rt]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", rt]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [p]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...j(), y6]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", g6]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, b6]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [t]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [v]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [p]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...U(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [p]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: U()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...U()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Rr, rt]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Rr, Kr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [t]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: I()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [t]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [p]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Rr, Kr]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [t]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Jr, x6]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [wa]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [p]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": $()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": $()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Jr, rt]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [b]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [_]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [p]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [b]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [_]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", rt]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: Q()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", rt]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: Q()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", rt]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [x]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [x]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [x]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [xa, rt]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [P]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [P]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [M]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [M]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", rt]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", t]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", rt]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [t]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": N()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": N()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": N()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": N()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": N()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": N()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": N()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": N()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": N()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": N()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": N()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": N()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": N()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": N()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": N()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": N()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": N()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": N()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", rt]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [t, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Rr, Kr, tl]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [t, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
function K_(t, {
  cacheSize: e,
  prefix: n,
  separator: r,
  extend: i = {},
  override: o = {}
}) {
  hu(t, "cacheSize", e), hu(t, "prefix", n), hu(t, "separator", r);
  for (const a in o)
    J_(t[a], o[a]);
  for (const a in i)
    Q_(t[a], i[a]);
  return t;
}
function hu(t, e, n) {
  n !== void 0 && (t[e] = n);
}
function J_(t, e) {
  if (e)
    for (const n in e)
      hu(t, n, e[n]);
}
function Q_(t, e) {
  if (e)
    for (const n in e) {
      const r = e[n];
      r !== void 0 && (t[n] = (t[n] || []).concat(r));
    }
}
function eC(t, ...e) {
  return typeof t == "function" ? pm(mm, t, ...e) : pm(() => K_(mm(), t), ...e);
}
const yi = (t) => /^(alert|info|neutral|primary|skandI|success|warning)-\d{3}$/.test(t), bi = (t) => /^\d+(\.\d+)?(r?(cap|ch|em|ex|ic|lh)|(s|l|d)?(vh|vw|vmin|vmax|vb|vi)|cqw|cqh|cqi|cqb|cmin|cmax|px|cm|mm|Q|in|pc|pt|%)$/i.test(
  t
), tC = eC({
  extend: {
    classGroups: {
      /**
       * match text-* as font sizes, includes
       *   - text-xs T-shirt size
       *   - text-[20px] arbitrary length
       *   - text-40 number
       *   - text-20px CSS length
       */
      "font-size": [
        {
          text: [
            fn.isTshirtSize,
            fn.isArbitraryLength,
            fn.isNumber,
            bi
          ]
        }
      ],
      // match color-neutral-* as text colors
      "text-color": [{ color: [yi] }],
      // match b-neutral-* as border colors
      "border-color": [{ b: [yi] }],
      // match b-*-neutral-* as border-* colors
      "border-color-x": [{ "b-x": [yi] }],
      "border-color-y": [{ "b-y": [yi] }],
      "border-color-t": [{ "b-t": [yi] }],
      "border-color-l": [{ "b-l": [yi] }],
      "border-color-b": [{ "b-b": [yi] }],
      "border-color-r": [{ "b-r": [yi] }],
      // match b-* as border width
      "border-w": [{ b: [fn.isLength, fn.isArbitraryLength, bi] }],
      "border-w-x": [{ "b-x": [fn.isLength, fn.isArbitraryLength, bi] }],
      "border-w-y": [{ "b-y": [fn.isLength, fn.isArbitraryLength, bi] }],
      "border-w-t": [{ "b-t": [fn.isLength, fn.isArbitraryLength, bi] }],
      "border-w-l": [{ "b-l": [fn.isLength, fn.isArbitraryLength, bi] }],
      "border-w-b": [{ "b-b": [fn.isLength, fn.isArbitraryLength, bi] }],
      "border-w-r": [{ "b-r": [fn.isLength, fn.isArbitraryLength, bi] }]
    }
  }
}), ve = (...t) => tC(d6(t)), _6 = pd(
  ["border-0 outline-0 ring-0 focus:ring-2", "duration-300 ease-out transition"],
  {
    variants: {
      active: {
        true: ["outline"],
        false: []
      },
      disabled: {
        true: ["cursor-not-allowed"],
        false: ["cursor-pointer"]
      },
      size: {
        m: ["p-x-4", "p-y-2", "rounded-2", "typo-text-m", "outline-2 outline-offset--2"],
        s: ["p-x-2", "p-y-1", "rounded-1", "typo-text-s", "outline-1 outline-offset--1"],
        xs: [
          "p-x-1",
          "p-y-2px",
          "rounded-1",
          "typo-button-xs",
          "uppercase",
          "outline-1 outline-offset--1"
        ]
      },
      intent: {
        primary: [],
        secondary: []
      },
      variant: {
        filled: [],
        outlined: ["outline"]
      },
      version: {
        v1: [],
        v2: []
      }
    },
    defaultVariants: {
      active: !1,
      disabled: !1,
      intent: "secondary",
      size: "m",
      variant: "outlined",
      version: "v2"
    },
    compoundVariants: [
      // border-width override
      {
        class: ["outline-1 outline-offset--1"]
      },
      {
        version: "v1",
        size: "m",
        class: ["outline-2 outline-offset--2"]
      },
      // disabled
      {
        disabled: !0,
        variant: "filled",
        class: ["bg-neutral-300 color-neutral-400"]
      },
      {
        disabled: !0,
        variant: "outlined",
        class: ["bg-neutral-100 color-neutral-400 outline-neutral-300"]
      },
      // secondary filled
      {
        disabled: !1,
        intent: "secondary",
        variant: "filled",
        class: ["bg-neutral-300 color-neutral-800  focus:ring-neutral-600 hover:bg-neutral-400"]
      },
      // secondary filled active
      {
        active: !0,
        disabled: !1,
        intent: "secondary",
        variant: "filled",
        class: ["bg-neutral-400 outline-neutral-300"]
      },
      // secondary outlined
      {
        intent: "secondary",
        variant: "outlined",
        disabled: !1,
        class: [
          "bg-neutral-100 outline-neutral-500 color-neutral-800 hover:bg-neutral-300 focus:ring-neutral-300"
        ]
      },
      // secondary outlined active
      {
        active: !0,
        intent: "secondary",
        variant: "outlined",
        disabled: !1,
        class: ["bg-neutral-400"]
      },
      // primary outlined
      {
        intent: "primary",
        variant: "outlined",
        disabled: !1,
        version: "v1",
        class: [
          "bg-neutral-100 color-neutral-800 outline-skandI-400 hover:bg-skandI-200 focus:ring-skandI-300"
        ]
      },
      {
        intent: "primary",
        variant: "outlined",
        disabled: !1,
        version: "v2",
        class: [
          "bg-neutral-100 color-neutral-800 outline-primary-400 hover:bg-primary-200 focus:ring-primary-300"
        ]
      },
      // primary outlined active
      {
        active: !0,
        intent: "primary",
        variant: "outlined",
        version: "v1",
        disabled: !1,
        class: ["bg-skandI-300"]
      },
      {
        active: !0,
        intent: "primary",
        variant: "outlined",
        version: "v2",
        disabled: !1,
        class: ["bg-primary-300"]
      },
      // primary filled
      {
        intent: "primary",
        variant: "filled",
        version: "v1",
        disabled: !1,
        class: ["bg-skandI-400 color-neutral-100  focus:ring-skandI-300 hover:bg-skandI-500"]
      },
      {
        intent: "primary",
        variant: "filled",
        version: "v2",
        disabled: !1,
        class: ["bg-primary-400 color-neutral-100  focus:ring-primary-300 hover:bg-primary-500"]
      },
      // primary filled active
      {
        intent: "primary",
        variant: "filled",
        version: "v1",
        active: !0,
        disabled: !1,
        class: ["bg-skandI-500 outline-2 outline-skandI-400"]
      },
      {
        intent: "primary",
        variant: "filled",
        version: "v2",
        active: !0,
        disabled: !1,
        class: ["bg-primary-500 outline-2 outline-primary-400"]
      }
    ]
  }
), J0e = (t) => ve(_6(t)), nC = {
  m: "m",
  medium: "m",
  s: "s",
  small: "s",
  xs: "xs",
  extraSmall: "xs"
}, rC = (t) => nC[t], md = sr(
  ({ active: t, children: e, size: n = "m", filled: r, primary: i, className: o, disabled: a, v1: s, ...l }, c) => {
    const u = rC(n), d = r ? "filled" : "outlined", f = s ? "v1" : "v2", h = i ? "primary" : "secondary";
    return /* @__PURE__ */ R.jsx(
      "button",
      {
        className: ve(
          _6({ variant: d, intent: h, size: u, active: t, disabled: a, version: f }),
          o
        ),
        disabled: a,
        ref: c,
        ...l,
        children: e
      }
    );
  }
);
md.displayName = "Button";
md.defaultProps = {
  active: !1,
  filled: !1,
  primary: !1,
  size: "m",
  v1: !1
};
var Xe;
(function(t) {
  t.Root = "root", t.Chevron = "chevron", t.Day = "day", t.DayButton = "day_button", t.CaptionLabel = "caption_label", t.Dropdowns = "dropdowns", t.Dropdown = "dropdown", t.DropdownRoot = "dropdown_root", t.Footer = "footer", t.MonthGrid = "month_grid", t.MonthCaption = "month_caption", t.MonthsDropdown = "months_dropdown", t.Month = "month", t.Months = "months", t.Nav = "nav", t.NextMonthButton = "button_next", t.PreviousMonthButton = "button_previous", t.Week = "week", t.Weeks = "weeks", t.Weekday = "weekday", t.Weekdays = "weekdays", t.WeekNumber = "week_number", t.WeekNumberHeader = "week_number_header", t.YearsDropdown = "years_dropdown";
})(Xe || (Xe = {}));
var Ot;
(function(t) {
  t.disabled = "disabled", t.hidden = "hidden", t.outside = "outside", t.focused = "focused", t.today = "today";
})(Ot || (Ot = {}));
var tn;
(function(t) {
  t.range_end = "range_end", t.range_middle = "range_middle", t.range_start = "range_start", t.selected = "selected";
})(tn || (tn = {}));
const C6 = 6048e5, iC = 864e5, vm = Symbol.for("constructDateFrom");
function cn(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && vm in t ? t[vm](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function kt(t, e) {
  return cn(e || t, t);
}
function E6(t, e, n) {
  const r = kt(t, n == null ? void 0 : n.in);
  return isNaN(e) ? cn((n == null ? void 0 : n.in) || t, NaN) : (e && r.setDate(r.getDate() + e), r);
}
function S6(t, e, n) {
  const r = kt(t, n == null ? void 0 : n.in);
  if (isNaN(e))
    return cn((n == null ? void 0 : n.in) || t, NaN);
  if (!e)
    return r;
  const i = r.getDate(), o = cn((n == null ? void 0 : n.in) || t, r.getTime());
  o.setMonth(r.getMonth() + e + 1, 0);
  const a = o.getDate();
  return i >= a ? o : (r.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    i
  ), r);
}
let oC = {};
function Gl() {
  return oC;
}
function es(t, e) {
  var s, l, c, u;
  const n = Gl(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, i = kt(t, e == null ? void 0 : e.in), o = i.getDay(), a = (o < r ? 7 : 0) + o - r;
  return i.setDate(i.getDate() - a), i.setHours(0, 0, 0, 0), i;
}
function Al(t, e) {
  return es(t, { ...e, weekStartsOn: 1 });
}
function M6(t, e) {
  const n = kt(t, e == null ? void 0 : e.in), r = n.getFullYear(), i = cn(n, 0);
  i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
  const o = Al(i), a = cn(n, 0);
  a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0);
  const s = Al(a);
  return n.getTime() >= o.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function gm(t) {
  const e = kt(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function ql(t, ...e) {
  const n = cn.bind(
    null,
    t || e.find((r) => typeof r == "object")
  );
  return e.map(n);
}
function Pl(t, e) {
  const n = kt(t, e == null ? void 0 : e.in);
  return n.setHours(0, 0, 0, 0), n;
}
function T6(t, e, n) {
  const [r, i] = ql(
    n == null ? void 0 : n.in,
    t,
    e
  ), o = Pl(r), a = Pl(i), s = +o - gm(o), l = +a - gm(a);
  return Math.round((s - l) / iC);
}
function aC(t, e) {
  const n = M6(t, e), r = cn((e == null ? void 0 : e.in) || t, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Al(r);
}
function sC(t, e, n) {
  return E6(t, e * 7, n);
}
function lC(t, e, n) {
  return S6(t, e * 12, n);
}
function cC(t, e) {
  let n, r = e == null ? void 0 : e.in;
  return t.forEach((i) => {
    !r && typeof i == "object" && (r = cn.bind(null, i));
    const o = kt(i, r);
    (!n || n < o || isNaN(+o)) && (n = o);
  }), cn(r, n || NaN);
}
function uC(t, e) {
  let n, r = e == null ? void 0 : e.in;
  return t.forEach((i) => {
    !r && typeof i == "object" && (r = cn.bind(null, i));
    const o = kt(i, r);
    (!n || n > o || isNaN(+o)) && (n = o);
  }), cn(r, n || NaN);
}
function dC(t, e, n) {
  const [r, i] = ql(
    n == null ? void 0 : n.in,
    t,
    e
  );
  return +Pl(r) == +Pl(i);
}
function A6(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function fC(t) {
  return !(!A6(t) && typeof t != "number" || isNaN(+kt(t)));
}
function hC(t, e, n) {
  const [r, i] = ql(
    n == null ? void 0 : n.in,
    t,
    e
  ), o = r.getFullYear() - i.getFullYear(), a = r.getMonth() - i.getMonth();
  return o * 12 + a;
}
function pC(t, e) {
  const n = kt(t, e == null ? void 0 : e.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function mC(t, e) {
  const n = kt(t, e == null ? void 0 : e.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function vC(t, e) {
  const n = kt(t, e == null ? void 0 : e.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function P6(t, e) {
  const n = kt(t, e == null ? void 0 : e.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function R6(t, e) {
  var s, l, c, u;
  const n = Gl(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, i = kt(t, e == null ? void 0 : e.in), o = i.getDay(), a = (o < r ? -7 : 0) + 6 - (o - r);
  return i.setDate(i.getDate() + a), i.setHours(23, 59, 59, 999), i;
}
function gC(t, e) {
  return R6(t, { ...e, weekStartsOn: 1 });
}
const yC = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, bC = (t, e, n) => {
  let r;
  const i = yC[t];
  return typeof i == "string" ? r = i : e === 1 ? r = i.one : r = i.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Sf(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const xC = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, wC = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, _C = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, CC = {
  date: Sf({
    formats: xC,
    defaultWidth: "full"
  }),
  time: Sf({
    formats: wC,
    defaultWidth: "full"
  }),
  dateTime: Sf({
    formats: _C,
    defaultWidth: "full"
  })
}, EC = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, SC = (t, e, n, r) => EC[t];
function Us(t) {
  return (e, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let i;
    if (r === "formatting" && t.formattingValues) {
      const a = t.defaultFormattingWidth || t.defaultWidth, s = n != null && n.width ? String(n.width) : a;
      i = t.formattingValues[s] || t.formattingValues[a];
    } else {
      const a = t.defaultWidth, s = n != null && n.width ? String(n.width) : t.defaultWidth;
      i = t.values[s] || t.values[a];
    }
    const o = t.argumentCallback ? t.argumentCallback(e) : e;
    return i[o];
  };
}
const MC = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, TC = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, AC = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, PC = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, RC = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, LC = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, OC = (t, e) => {
  const n = Number(t), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, DC = {
  ordinalNumber: OC,
  era: Us({
    values: MC,
    defaultWidth: "wide"
  }),
  quarter: Us({
    values: TC,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: Us({
    values: AC,
    defaultWidth: "wide"
  }),
  day: Us({
    values: PC,
    defaultWidth: "wide"
  }),
  dayPeriod: Us({
    values: RC,
    defaultWidth: "wide",
    formattingValues: LC,
    defaultFormattingWidth: "wide"
  })
};
function zs(t) {
  return (e, n = {}) => {
    const r = n.width, i = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], o = e.match(i);
    if (!o)
      return null;
    const a = o[0], s = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(s) ? NC(s, (d) => d.test(a)) : (
      // [TODO] -- I challenge you to fix the type
      kC(s, (d) => d.test(a))
    );
    let c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = e.slice(a.length);
    return { value: c, rest: u };
  };
}
function kC(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function NC(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function IC(t) {
  return (e, n = {}) => {
    const r = e.match(t.matchPattern);
    if (!r)
      return null;
    const i = r[0], o = e.match(t.parsePattern);
    if (!o)
      return null;
    let a = t.valueCallback ? t.valueCallback(o[0]) : o[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const s = e.slice(i.length);
    return { value: a, rest: s };
  };
}
const FC = /^(\d+)(th|st|nd|rd)?/i, UC = /\d+/i, zC = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, HC = {
  any: [/^b/i, /^(a|c)/i]
}, BC = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, VC = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, $C = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, WC = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, jC = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, GC = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, qC = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, XC = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, YC = {
  ordinalNumber: IC({
    matchPattern: FC,
    parsePattern: UC,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: zs({
    matchPatterns: zC,
    defaultMatchWidth: "wide",
    parsePatterns: HC,
    defaultParseWidth: "any"
  }),
  quarter: zs({
    matchPatterns: BC,
    defaultMatchWidth: "wide",
    parsePatterns: VC,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: zs({
    matchPatterns: $C,
    defaultMatchWidth: "wide",
    parsePatterns: WC,
    defaultParseWidth: "any"
  }),
  day: zs({
    matchPatterns: jC,
    defaultMatchWidth: "wide",
    parsePatterns: GC,
    defaultParseWidth: "any"
  }),
  dayPeriod: zs({
    matchPatterns: qC,
    defaultMatchWidth: "any",
    parsePatterns: XC,
    defaultParseWidth: "any"
  })
}, vd = {
  code: "en-US",
  formatDistance: bC,
  formatLong: CC,
  formatRelative: SC,
  localize: DC,
  match: YC,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function ZC(t, e) {
  const n = kt(t, e == null ? void 0 : e.in);
  return T6(n, P6(n)) + 1;
}
function L6(t, e) {
  const n = kt(t, e == null ? void 0 : e.in), r = +Al(n) - +aC(n);
  return Math.round(r / C6) + 1;
}
function O6(t, e) {
  var u, d, f, h;
  const n = kt(t, e == null ? void 0 : e.in), r = n.getFullYear(), i = Gl(), o = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((d = (u = e == null ? void 0 : e.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((h = (f = i.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, a = cn((e == null ? void 0 : e.in) || t, 0);
  a.setFullYear(r + 1, 0, o), a.setHours(0, 0, 0, 0);
  const s = es(a, e), l = cn((e == null ? void 0 : e.in) || t, 0);
  l.setFullYear(r, 0, o), l.setHours(0, 0, 0, 0);
  const c = es(l, e);
  return +n >= +s ? r + 1 : +n >= +c ? r : r - 1;
}
function KC(t, e) {
  var s, l, c, u;
  const n = Gl(), r = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, i = O6(t, e), o = cn((e == null ? void 0 : e.in) || t, 0);
  return o.setFullYear(i, 0, r), o.setHours(0, 0, 0, 0), es(o, e);
}
function D6(t, e) {
  const n = kt(t, e == null ? void 0 : e.in), r = +es(n, e) - +KC(n, e);
  return Math.round(r / C6) + 1;
}
function St(t, e) {
  const n = t < 0 ? "-" : "", r = Math.abs(t).toString().padStart(e, "0");
  return n + r;
}
const xi = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), r = n > 0 ? n : 1 - n;
    return St(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : St(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return St(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return St(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return St(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return St(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return St(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, r = t.getMilliseconds(), i = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return St(i, e.length);
  }
}, Qo = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, ym = {
  // Era
  G: function(t, e, n) {
    const r = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const r = t.getFullYear(), i = r > 0 ? r : 1 - r;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return xi.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, r) {
    const i = O6(t, r), o = i > 0 ? i : 1 - i;
    if (e === "YY") {
      const a = o % 100;
      return St(a, 2);
    }
    return e === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : St(o, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = M6(t);
    return St(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return St(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "Q":
        return String(r);
      case "QQ":
        return St(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "q":
        return String(r);
      case "qq":
        return St(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return xi.M(t, e);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      case "L":
        return String(r + 1);
      case "LL":
        return St(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, r) {
    const i = D6(t, r);
    return e === "wo" ? n.ordinalNumber(i, { unit: "week" }) : St(i, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const r = L6(t);
    return e === "Io" ? n.ordinalNumber(r, { unit: "week" }) : St(r, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : xi.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const r = ZC(t);
    return e === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : St(r, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const r = t.getDay();
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, r) {
    const i = t.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "e":
        return String(o);
      case "ee":
        return St(o, 2);
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, r) {
    const i = t.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "c":
        return String(o);
      case "cc":
        return St(o, e.length);
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const r = t.getDay(), i = r === 0 ? 7 : r;
    switch (e) {
      case "i":
        return String(i);
      case "ii":
        return St(i, e.length);
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const i = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const r = t.getHours();
    let i;
    switch (r === 12 ? i = Qo.noon : r === 0 ? i = Qo.midnight : i = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const r = t.getHours();
    let i;
    switch (r >= 17 ? i = Qo.evening : r >= 12 ? i = Qo.afternoon : r >= 4 ? i = Qo.morning : i = Qo.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let r = t.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return xi.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : xi.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const r = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : St(r, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let r = t.getHours();
    return r === 0 && (r = 24), e === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : St(r, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : xi.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : xi.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return xi.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const r = t.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      case "X":
        return xm(r);
      case "XXXX":
      case "XX":
        return bo(r);
      case "XXXXX":
      case "XXX":
      default:
        return bo(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      case "x":
        return xm(r);
      case "xxxx":
      case "xx":
        return bo(r);
      case "xxxxx":
      case "xxx":
      default:
        return bo(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + bm(r, ":");
      case "OOOO":
      default:
        return "GMT" + bo(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + bm(r, ":");
      case "zzzz":
      default:
        return "GMT" + bo(r, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const r = Math.trunc(+t / 1e3);
    return St(r, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return St(+t, e.length);
  }
};
function bm(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), i = Math.trunc(r / 60), o = r % 60;
  return o === 0 ? n + String(i) : n + String(i) + e + St(o, 2);
}
function xm(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + St(Math.abs(t) / 60, 2) : bo(t, e);
}
function bo(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), i = St(Math.trunc(r / 60), 2), o = St(r % 60, 2);
  return n + i + e + o;
}
const wm = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, k6 = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, JC = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
  if (!i)
    return wm(t, e);
  let o;
  switch (r) {
    case "P":
      o = e.dateTime({ width: "short" });
      break;
    case "PP":
      o = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = e.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", wm(r, e)).replace("{{time}}", k6(i, e));
}, QC = {
  p: k6,
  P: JC
}, eE = /^D+$/, tE = /^Y+$/, nE = ["D", "DD", "YY", "YYYY"];
function rE(t) {
  return eE.test(t);
}
function iE(t) {
  return tE.test(t);
}
function oE(t, e, n) {
  const r = aE(t, e, n);
  if (console.warn(r), nE.includes(t))
    throw new RangeError(r);
}
function aE(t, e, n) {
  const r = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const sE = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, lE = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, cE = /^'([^]*?)'?$/, uE = /''/g, dE = /[a-zA-Z]/;
function fE(t, e, n) {
  var u, d, f, h, v, g, m, p;
  const r = Gl(), i = (n == null ? void 0 : n.locale) ?? r.locale ?? vd, o = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((h = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, a = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (v = n == null ? void 0 : n.locale) == null ? void 0 : v.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((p = (m = r.locale) == null ? void 0 : m.options) == null ? void 0 : p.weekStartsOn) ?? 0, s = kt(t, n == null ? void 0 : n.in);
  if (!fC(s))
    throw new RangeError("Invalid time value");
  let l = e.match(lE).map((y) => {
    const b = y[0];
    if (b === "p" || b === "P") {
      const x = QC[b];
      return x(y, i.formatLong);
    }
    return y;
  }).join("").match(sE).map((y) => {
    if (y === "''")
      return { isToken: !1, value: "'" };
    const b = y[0];
    if (b === "'")
      return { isToken: !1, value: hE(y) };
    if (ym[b])
      return { isToken: !0, value: y };
    if (b.match(dE))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + b + "`"
      );
    return { isToken: !1, value: y };
  });
  i.localize.preprocessor && (l = i.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: o,
    weekStartsOn: a,
    locale: i
  };
  return l.map((y) => {
    if (!y.isToken)
      return y.value;
    const b = y.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && iE(b) || !(n != null && n.useAdditionalDayOfYearTokens) && rE(b)) && oE(b, e, String(t));
    const x = ym[b[0]];
    return x(s, b, i.localize, c);
  }).join("");
}
function hE(t) {
  const e = t.match(cE);
  return e ? e[1].replace(uE, "'") : t;
}
function pE(t, e) {
  const n = kt(t, e == null ? void 0 : e.in), r = n.getFullYear(), i = n.getMonth(), o = cn(n, 0);
  return o.setFullYear(r, i + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function mE(t, e) {
  return +kt(t) > +kt(e);
}
function vE(t, e) {
  return +kt(t) < +kt(e);
}
function gE(t, e, n) {
  const [r, i] = ql(
    n == null ? void 0 : n.in,
    t,
    e
  );
  return r.getFullYear() === i.getFullYear() && r.getMonth() === i.getMonth();
}
function yE(t, e, n) {
  const [r, i] = ql(
    n == null ? void 0 : n.in,
    t,
    e
  );
  return r.getFullYear() === i.getFullYear();
}
function bE(t, e, n) {
  const r = kt(t, n == null ? void 0 : n.in), i = r.getFullYear(), o = r.getDate(), a = cn((n == null ? void 0 : n.in) || t, 0);
  a.setFullYear(i, e, 15), a.setHours(0, 0, 0, 0);
  const s = pE(a);
  return r.setMonth(e, Math.min(o, s)), r;
}
function xE(t, e, n) {
  const r = kt(t, n == null ? void 0 : n.in);
  return isNaN(+r) ? cn((n == null ? void 0 : n.in) || t, NaN) : (r.setFullYear(e), r);
}
class fi {
  /**
   * Creates an instance of DateLib.
   *
   * @param options The options for the date library.
   * @param overrides Overrides for the date library functions.
   */
  constructor(e, n) {
    this.Date = Date, this.addDays = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.addDays ? this.overrides.addDays(r, i) : E6(r, i);
    }, this.addMonths = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.addMonths ? this.overrides.addMonths(r, i) : S6(r, i);
    }, this.addWeeks = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.addWeeks ? this.overrides.addWeeks(r, i) : sC(r, i);
    }, this.addYears = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.addYears ? this.overrides.addYears(r, i) : lC(r, i);
    }, this.differenceInCalendarDays = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, i) : T6(r, i);
    }, this.differenceInCalendarMonths = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, i) : hC(r, i);
    }, this.endOfISOWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfISOWeek ? this.overrides.endOfISOWeek(r) : gC(r);
    }, this.endOfMonth = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfMonth ? this.overrides.endOfMonth(r) : pC(r);
    }, this.endOfWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfWeek ? this.overrides.endOfWeek(r, this.options) : R6(r, this.options);
    }, this.endOfYear = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfYear ? this.overrides.endOfYear(r) : vC(r);
    }, this.format = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.format ? this.overrides.format(r, i, this.options) : fE(r, i, this.options);
    }, this.getISOWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.getISOWeek ? this.overrides.getISOWeek(r) : L6(r);
    }, this.getWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.getWeek ? this.overrides.getWeek(r, this.options) : D6(r, this.options);
    }, this.isAfter = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.isAfter ? this.overrides.isAfter(r, i) : mE(r, i);
    }, this.isBefore = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.isBefore ? this.overrides.isBefore(r, i) : vE(r, i);
    }, this.isDate = (r) => {
      var i;
      return (i = this.overrides) != null && i.isDate ? this.overrides.isDate(r) : A6(r);
    }, this.isSameDay = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.isSameDay ? this.overrides.isSameDay(r, i) : dC(r, i);
    }, this.isSameMonth = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.isSameMonth ? this.overrides.isSameMonth(r, i) : gE(r, i);
    }, this.isSameYear = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.isSameYear ? this.overrides.isSameYear(r, i) : yE(r, i);
    }, this.max = (r) => {
      var i;
      return (i = this.overrides) != null && i.max ? this.overrides.max(r) : cC(r);
    }, this.min = (r) => {
      var i;
      return (i = this.overrides) != null && i.min ? this.overrides.min(r) : uC(r);
    }, this.setMonth = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.setMonth ? this.overrides.setMonth(r, i) : bE(r, i);
    }, this.setYear = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.setYear ? this.overrides.setYear(r, i) : xE(r, i);
    }, this.startOfDay = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfDay ? this.overrides.startOfDay(r) : Pl(r);
    }, this.startOfISOWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfISOWeek ? this.overrides.startOfISOWeek(r) : Al(r);
    }, this.startOfMonth = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfMonth ? this.overrides.startOfMonth(r) : mC(r);
    }, this.startOfWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfWeek ? this.overrides.startOfWeek(r, this.options) : es(r, this.options);
    }, this.startOfYear = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfYear ? this.overrides.startOfYear(r) : P6(r);
    }, this.options = { locale: vd, ...e }, this.overrides = n;
  }
}
const Vo = new fi();
function wE(t, e, n = {}) {
  return Object.entries(t).filter(([, i]) => i === !0).reduce((i, [o]) => (n[o] ? i.push(n[o]) : e[Ot[o]] ? i.push(e[Ot[o]]) : e[tn[o]] && i.push(e[tn[o]]), i), [e[Xe.Day]]);
}
function _E(t) {
  return A.createElement("button", { ...t });
}
function CE(t) {
  return A.createElement("span", { ...t });
}
function EE(t) {
  const { size: e = 24, orientation: n = "left", className: r } = t;
  return A.createElement(
    "svg",
    { className: r, width: e, height: e, viewBox: "0 0 24 24" },
    n === "up" && A.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    n === "down" && A.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    n === "left" && A.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    n === "right" && A.createElement("polygon", { points: "8 18.612 14.1888889 12.5 8 6.37733333 9.91111111 4.5 18 12.5 9.91111111 20.5" })
  );
}
function SE(t) {
  const { day: e, modifiers: n, ...r } = t;
  return A.createElement("td", { ...r });
}
function ME(t) {
  const { day: e, modifiers: n, ...r } = t, i = A.useRef(null);
  return A.useEffect(() => {
    var o;
    n.focused && ((o = i.current) == null || o.focus());
  }, [n.focused]), A.createElement("button", { ref: i, ...r });
}
function TE(t) {
  const { options: e, className: n, components: r, classNames: i, ...o } = t, a = [i[Xe.Dropdown], n].join(" "), s = e == null ? void 0 : e.find(({ value: l }) => l === o.value);
  return A.createElement(
    "span",
    { "data-disabled": o.disabled, className: i[Xe.DropdownRoot] },
    A.createElement(r.Select, { className: a, ...o }, e == null ? void 0 : e.map(({ value: l, label: c, disabled: u }) => A.createElement(r.Option, { key: l, value: l, disabled: u }, c))),
    A.createElement(
      "span",
      { className: i[Xe.CaptionLabel], "aria-hidden": !0 },
      s == null ? void 0 : s.label,
      A.createElement(r.Chevron, { orientation: "down", size: 18, className: i[Xe.Chevron] })
    )
  );
}
function AE(t) {
  return A.createElement("div", { ...t });
}
function PE(t) {
  return A.createElement("div", { ...t });
}
function RE(t) {
  const { calendarMonth: e, displayIndex: n, ...r } = t;
  return A.createElement("div", { ...r }, t.children);
}
function LE(t) {
  const { calendarMonth: e, displayIndex: n, ...r } = t;
  return A.createElement("div", { ...r });
}
function OE(t) {
  return A.createElement("table", { ...t });
}
function DE(t) {
  return A.createElement("div", { ...t });
}
const N6 = __(void 0);
function Xl() {
  const t = W1(N6);
  if (t === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return t;
}
function kE(t) {
  const { components: e } = Xl();
  return A.createElement(e.Dropdown, { ...t });
}
function NE(t) {
  const { onPreviousClick: e, onNextClick: n, previousMonth: r, nextMonth: i, ...o } = t, { components: a, classNames: s, labels: { labelPrevious: l, labelNext: c } } = Xl();
  return A.createElement(
    "nav",
    { ...o },
    A.createElement(
      a.PreviousMonthButton,
      { type: "button", className: s[Xe.PreviousMonthButton], tabIndex: r ? void 0 : -1, disabled: r ? void 0 : !0, "aria-label": l(r), onClick: t.onPreviousClick },
      A.createElement(a.Chevron, { disabled: r ? void 0 : !0, className: s[Xe.Chevron], orientation: "left" })
    ),
    A.createElement(
      a.NextMonthButton,
      { type: "button", className: s[Xe.NextMonthButton], tabIndex: i ? void 0 : -1, disabled: i ? void 0 : !0, "aria-label": c(i), onClick: t.onNextClick },
      A.createElement(a.Chevron, { disabled: i ? void 0 : !0, orientation: "right", className: s[Xe.Chevron] })
    )
  );
}
function IE(t) {
  const { components: e } = Xl();
  return A.createElement(e.Button, { ...t });
}
function FE(t) {
  return A.createElement("option", { ...t });
}
function UE(t) {
  const { components: e } = Xl();
  return A.createElement(e.Button, { ...t });
}
function zE(t) {
  return A.createElement("div", { ...t });
}
function HE(t) {
  return A.createElement("select", { ...t });
}
function BE(t) {
  const { week: e, ...n } = t;
  return A.createElement("tr", { ...n });
}
function VE(t) {
  return A.createElement("th", { ...t });
}
function $E(t) {
  return A.createElement(
    "thead",
    null,
    A.createElement("tr", { ...t })
  );
}
function WE(t) {
  const { week: e, ...n } = t;
  return A.createElement("th", { ...n });
}
function jE(t) {
  return A.createElement("th", { ...t });
}
function GE(t) {
  return A.createElement("tbody", { ...t });
}
function qE(t) {
  const { components: e } = Xl();
  return A.createElement(e.Dropdown, { ...t });
}
const XE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: _E,
  CaptionLabel: CE,
  Chevron: EE,
  Day: SE,
  DayButton: ME,
  Dropdown: TE,
  DropdownNav: AE,
  Footer: PE,
  Month: RE,
  MonthCaption: LE,
  MonthGrid: OE,
  Months: DE,
  MonthsDropdown: kE,
  Nav: NE,
  NextMonthButton: IE,
  Option: FE,
  PreviousMonthButton: UE,
  Root: zE,
  Select: HE,
  Week: BE,
  WeekNumber: WE,
  WeekNumberHeader: jE,
  Weekday: VE,
  Weekdays: $E,
  Weeks: GE,
  YearsDropdown: qE
}, Symbol.toStringTag, { value: "Module" }));
function YE(t) {
  return {
    ...XE,
    ...t
  };
}
function ZE(t) {
  const e = {
    "data-mode": t.mode ?? void 0,
    "data-required": "required" in t ? t.required : void 0,
    "data-multiple-months": t.numberOfMonths && t.numberOfMonths > 1 || void 0,
    "data-week-numbers": t.showWeekNumber || void 0
  };
  return Object.entries(t).forEach(([n, r]) => {
    n.startsWith("data-") && (e[n] = r);
  }), e;
}
function KE() {
  const t = {};
  for (const e in Xe)
    t[Xe[e]] = `rdp-${Xe[e]}`;
  for (const e in Ot)
    t[Ot[e]] = `rdp-${Ot[e]}`;
  for (const e in tn)
    t[tn[e]] = `rdp-${tn[e]}`;
  return t;
}
function I6(t, e, n) {
  return (n ?? new fi(e)).format(t, "LLLL y");
}
const JE = I6;
function QE(t, e, n) {
  return (n ?? new fi(e)).format(t, "d");
}
function eS(t, e = vd) {
  var n;
  return (n = e.localize) == null ? void 0 : n.month(t);
}
function tS(t) {
  return t < 10 ? `0${t.toLocaleString()}` : `${t.toLocaleString()}`;
}
function nS() {
  return "";
}
function rS(t, e, n) {
  return (n ?? new fi(e)).format(t, "cccccc");
}
function F6(t) {
  return t.toString();
}
const iS = F6, oS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: I6,
  formatDay: QE,
  formatMonthCaption: JE,
  formatMonthDropdown: eS,
  formatWeekNumber: tS,
  formatWeekNumberHeader: nS,
  formatWeekdayName: rS,
  formatYearCaption: iS,
  formatYearDropdown: F6
}, Symbol.toStringTag, { value: "Module" }));
function aS(t) {
  return t != null && t.formatMonthCaption && !t.formatCaption && (t.formatCaption = t.formatMonthCaption), t != null && t.formatYearCaption && !t.formatYearDropdown && (t.formatYearDropdown = t.formatYearCaption), {
    ...oS,
    ...t
  };
}
function sS(t, e, n, r, i) {
  if (!e || !n)
    return;
  const { addMonths: o, startOfMonth: a, isBefore: s } = i, l = t.getFullYear(), c = [];
  let u = e;
  for (; c.length < 12 && s(u, o(n, 1)); )
    c.push(u.getMonth()), u = o(u, 1);
  return c.sort((h, v) => h - v).map((h) => {
    const v = r.formatMonthDropdown(h, i.options.locale), g = i.Date ? new i.Date(l, h) : new Date(l, h), m = e && g < a(e) || n && g > a(n) || !1;
    return { value: h, label: v, disabled: m };
  });
}
function lS(t, e = {}, n = {}) {
  let r = { ...e == null ? void 0 : e[Xe.Day] };
  return Object.entries(t).filter(([, i]) => i === !0).forEach(([i]) => {
    r = {
      ...r,
      ...n == null ? void 0 : n[i]
    };
  }), r;
}
const Mf = {}, nl = {};
function dl(t, e) {
  try {
    const r = (Mf[t] || (Mf[t] = new Intl.DateTimeFormat("en-GB", {
      timeZone: t,
      hour: "numeric",
      timeZoneName: "longOffset"
    }).format))(e).split("GMT")[1] || "";
    return r in nl ? nl[r] : _m(r, r.split(":"));
  } catch {
    if (t in nl)
      return nl[t];
    const n = t == null ? void 0 : t.match(cS);
    return n ? _m(t, n.slice(1)) : NaN;
  }
}
const cS = /([+-]\d\d):?(\d\d)?/;
function _m(t, e) {
  const n = +e[0], r = +(e[1] || 0);
  return nl[t] = n > 0 ? n * 60 + r : n * 60 - r;
}
class Nr extends Date {
  //#region static
  constructor(...e) {
    super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(dl(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), U6(this), eh(this)) : this.setTime(Date.now());
  }
  static tz(e, ...n) {
    return n.length ? new Nr(...n, e) : new Nr(Date.now(), e);
  }
  //#endregion
  //#region time zone
  withTimeZone(e) {
    return new Nr(+this, e);
  }
  getTimezoneOffset() {
    return -dl(this.timeZone, this);
  }
  //#endregion
  //#region time
  setTime(e) {
    return Date.prototype.setTime.apply(this, arguments), eh(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new Nr(+new Date(e), this.timeZone);
  }
  //#endregion
}
const Cm = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((t) => {
  if (!Cm.test(t))
    return;
  const e = t.replace(Cm, "$1UTC");
  Nr.prototype[e] && (t.startsWith("get") ? Nr.prototype[t] = function() {
    return this.internal[e]();
  } : (Nr.prototype[t] = function() {
    return Date.prototype[e].apply(this.internal, arguments), uS(this), +this;
  }, Nr.prototype[e] = function() {
    return Date.prototype[e].apply(this, arguments), eh(this), +this;
  }));
});
function eh(t) {
  t.internal.setTime(+t), t.internal.setUTCMinutes(t.internal.getUTCMinutes() - t.getTimezoneOffset());
}
function uS(t) {
  Date.prototype.setFullYear.call(t, t.internal.getUTCFullYear(), t.internal.getUTCMonth(), t.internal.getUTCDate()), Date.prototype.setHours.call(t, t.internal.getUTCHours(), t.internal.getUTCMinutes(), t.internal.getUTCSeconds(), t.internal.getUTCMilliseconds()), U6(t);
}
function U6(t) {
  const e = dl(t.timeZone, t), n = /* @__PURE__ */ new Date(+t);
  n.setUTCHours(n.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset(), i = -(/* @__PURE__ */ new Date(+n)).getTimezoneOffset(), o = r - i, a = Date.prototype.getHours.apply(t) !== t.internal.getUTCHours();
  o && a && t.internal.setUTCMinutes(t.internal.getUTCMinutes() + o);
  const s = r - e;
  s && Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + s);
  const l = dl(t.timeZone, t), u = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset() - l, d = l !== e, f = u - s;
  if (d && f) {
    Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + f);
    const h = dl(t.timeZone, t), v = l - h;
    v && (t.internal.setUTCMinutes(t.internal.getUTCMinutes() + v), Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + v));
  }
}
class Ir extends Nr {
  //#region static
  static tz(e, ...n) {
    return n.length ? new Ir(...n, e) : new Ir(Date.now(), e);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [e, n, r] = this.tzComponents(), i = `${e}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + i;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [e, n, r, i] = this.internal.toUTCString().split(" ");
    return `${e == null ? void 0 : e.slice(0, -1)} ${r} ${n} ${i}`;
  }
  toTimeString() {
    const e = this.internal.toUTCString().split(" ")[4], [n, r, i] = this.tzComponents();
    return `${e} GMT${n}${r}${i} (${dS(this.timeZone, this)})`;
  }
  toLocaleString(e, n) {
    return Date.prototype.toLocaleString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(e, n) {
    return Date.prototype.toLocaleDateString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(e, n) {
    return Date.prototype.toLocaleTimeString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const e = this.getTimezoneOffset(), n = e > 0 ? "-" : "+", r = String(Math.floor(Math.abs(e) / 60)).padStart(2, "0"), i = String(Math.abs(e) % 60).padStart(2, "0");
    return [n, r, i];
  }
  //#endregion
  withTimeZone(e) {
    return new Ir(+this, e);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new Ir(+new Date(e), this.timeZone);
  }
  //#endregion
}
function dS(t, e) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: t,
    timeZoneName: "long"
  }).format(e).slice(12);
}
function fS(t, e, n) {
  const r = n ? Ir.tz(n) : t.Date ? new t.Date() : /* @__PURE__ */ new Date(), i = e ? t.startOfISOWeek(r) : t.startOfWeek(r), o = [];
  for (let a = 0; a < 7; a++) {
    const s = t.addDays(i, a);
    o.push(s);
  }
  return o;
}
function hS(t, e, n, r, i) {
  if (!e || !n)
    return;
  const { startOfMonth: o, startOfYear: a, endOfYear: s, addYears: l, isBefore: c, isSameYear: u } = i, d = t.getMonth(), f = a(e), h = s(n), v = [];
  let g = f;
  for (; c(g, h) || u(g, h); )
    v.push(g.getFullYear()), g = l(g, 1);
  return v.map((m) => {
    const p = i.Date ? new i.Date(m, d) : new Date(m, d), y = e && p < o(e) || d && n && p > o(n) || !1, b = r.formatYearDropdown(m);
    return {
      value: m,
      label: b,
      disabled: y
    };
  });
}
function z6(t, e, n) {
  return (n ?? new fi(e)).format(t, "LLLL y");
}
const pS = z6;
function mS(t, e, n, r) {
  let i = (r ?? new fi(n)).format(t, "PPPP");
  return e != null && e.today && (i = `Today, ${i}`), i;
}
function H6(t, e, n, r) {
  let i = (r ?? new fi(n)).format(t, "PPPP");
  return e.today && (i = `Today, ${i}`), e.selected && (i = `${i}, selected`), i;
}
const vS = H6;
function gS() {
  return "";
}
function yS(t) {
  return "Choose the Month";
}
function bS(t) {
  return "Go to the Next Month";
}
function xS(t) {
  return "Go to the Previous Month";
}
function wS(t, e, n) {
  return (n ?? new fi(e)).format(t, "cccc");
}
function _S(t, e) {
  return `Week ${t}`;
}
function CS(t) {
  return "Week Number";
}
function ES(t) {
  return "Choose the Year";
}
const SS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: pS,
  labelDay: vS,
  labelDayButton: H6,
  labelGrid: z6,
  labelGridcell: mS,
  labelMonthDropdown: yS,
  labelNav: gS,
  labelNext: bS,
  labelPrevious: xS,
  labelWeekNumber: _S,
  labelWeekNumberHeader: CS,
  labelWeekday: wS,
  labelYearDropdown: ES
}, Symbol.toStringTag, { value: "Module" })), MS = 42;
function TS(t, e, n, r) {
  const i = t[0], o = t[t.length - 1], { ISOWeek: a, fixedWeeks: s } = n ?? {}, { startOfWeek: l, endOfWeek: c, startOfISOWeek: u, endOfISOWeek: d, addDays: f, differenceInCalendarDays: h, differenceInCalendarMonths: v, isAfter: g, endOfMonth: m } = r, p = a ? u(i) : l(i), y = a ? d(m(o)) : c(m(o)), b = h(y, p), x = v(o, i) + 1, _ = [];
  for (let S = 0; S <= b; S++) {
    const P = f(p, S);
    if (e && g(P, e))
      break;
    _.push(P);
  }
  const M = MS * x;
  if (s && _.length < M)
    for (let S = 0; S < 7; S++) {
      const P = f(_[_.length - 1], 1);
      _.push(P);
    }
  return _;
}
function AS(t) {
  const e = [];
  return t.reduce((n, r) => {
    const i = [], o = r.weeks.reduce((a, s) => [...a, ...s.days], i);
    return [...n, ...o];
  }, e);
}
function PS(t, e, n, r) {
  const { numberOfMonths: i = 1 } = n, o = [];
  for (let a = 0; a < i; a++) {
    const s = r.addMonths(t, a);
    if (e && s > e)
      break;
    o.push(s);
  }
  return o;
}
function Em(t, e) {
  const { month: n, defaultMonth: r, today: i = t.timeZone ? Ir.tz(t.timeZone) : e.Date ? new e.Date() : /* @__PURE__ */ new Date(), numberOfMonths: o = 1, endMonth: a, startMonth: s } = t;
  let l = n || r || i;
  const { differenceInCalendarMonths: c, addMonths: u, startOfMonth: d } = e;
  if (a && c(a, l) < 0) {
    const f = -1 * (o - 1);
    l = u(a, f);
  }
  return s && c(l, s) < 0 && (l = s), d(l);
}
class B6 {
  constructor(e, n, r = Vo) {
    this.date = e, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(e, n)), this.dateLib = r;
  }
  /**
   * Check if the day is the same as the given day: considering if it is in the
   * same display month.
   */
  isEqualTo(e) {
    return this.dateLib.isSameDay(e.date, this.date) && this.dateLib.isSameMonth(e.displayMonth, this.displayMonth);
  }
}
class RS {
  constructor(e, n) {
    this.date = e, this.weeks = n;
  }
}
class LS {
  constructor(e, n) {
    this.days = n, this.weekNumber = e;
  }
}
function OS(t, e, n, r) {
  const { startOfWeek: i, endOfWeek: o, startOfISOWeek: a, endOfISOWeek: s, endOfMonth: l, addDays: c, getWeek: u, getISOWeek: d } = r, f = t.reduce((h, v) => {
    const g = n.ISOWeek ? a(v) : i(v), m = n.ISOWeek ? s(l(v)) : o(l(v)), p = e.filter((x) => x >= g && x <= m);
    if (n.fixedWeeks && p.length < 42) {
      const x = e.filter((_) => _ > m && _ <= c(m, 7));
      p.push(...x);
    }
    const y = p.reduce((x, _) => {
      const M = n.ISOWeek ? d(_) : u(_), S = x.find((E) => E.weekNumber === M), P = new B6(_, v, r);
      return S ? S.days.push(P) : x.push(new LS(M, [P])), x;
    }, []), b = new RS(v, y);
    return h.push(b), h;
  }, []);
  return n.reverseMonths ? f.reverse() : f;
}
function DS(t, e) {
  var g;
  let { startMonth: n, endMonth: r } = t;
  const { startOfYear: i, startOfDay: o, startOfMonth: a, endOfMonth: s, addYears: l, endOfYear: c } = e, { fromYear: u, toYear: d, fromMonth: f, toMonth: h } = t;
  !n && f && (n = f), !n && u && (n = new Date(u, 0, 1)), !r && h && (r = h), !r && d && (r = new Date(d, 11, 31));
  const v = (g = t.captionLayout) == null ? void 0 : g.startsWith("dropdown");
  if (n)
    n = a(n);
  else if (u)
    n = new Date(u, 0, 1);
  else if (!n && v) {
    const m = t.today ?? (t.timeZone ? Ir.tz(t.timeZone) : e.Date ? new e.Date() : /* @__PURE__ */ new Date());
    n = i(l(m, -100));
  }
  if (r)
    r = s(r);
  else if (d)
    r = new Date(d, 11, 31);
  else if (!r && v) {
    const m = t.today ?? (t.timeZone ? Ir.tz(t.timeZone) : e.Date ? new e.Date() : /* @__PURE__ */ new Date());
    r = c(m);
  }
  return [
    n && o(n),
    r && o(r)
  ];
}
function kS(t, e, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: i, numberOfMonths: o = 1 } = n, { startOfMonth: a, addMonths: s, differenceInCalendarMonths: l } = r, c = i ? o : 1, u = a(t);
  if (!e)
    return s(u, c);
  if (!(l(e, t) < o))
    return s(u, c);
}
function NS(t, e, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: i, numberOfMonths: o } = n, { startOfMonth: a, addMonths: s, differenceInCalendarMonths: l } = r, c = i ? o ?? 1 : 1, u = a(t);
  if (!e)
    return s(u, -c);
  if (!(l(u, e) <= 0))
    return s(u, -c);
}
function IS(t) {
  const e = [];
  return t.reduce((n, r) => [...n, ...r.weeks], e);
}
function gd(t, e) {
  const [n, r] = Ke(t);
  return [e === void 0 ? n : e, r];
}
function FS(t, e) {
  const [n, r] = DS(t, e), { startOfMonth: i, endOfMonth: o } = e, a = Em(t, e), [s, l] = gd(a, t.month ? i(t.month) : void 0);
  Dt(() => {
    const M = Em(t, e);
    l(M);
  }, [t.timeZone]);
  const c = PS(s, r, t, e), u = TS(c, t.endMonth ? o(t.endMonth) : void 0, t, e), d = OS(c, u, t, e), f = IS(d), h = AS(d), v = NS(s, n, t, e), g = kS(s, r, t, e), { disableNavigation: m, onMonthChange: p } = t, y = (M) => f.some((S) => S.days.some((P) => P.isEqualTo(M))), b = (M) => {
    if (m)
      return;
    let S = i(M);
    n && S < i(n) && (S = i(n)), r && S > i(r) && (S = i(r)), l(S), p == null || p(S);
  };
  return {
    months: d,
    weeks: f,
    days: h,
    navStart: n,
    navEnd: r,
    previousMonth: v,
    nextMonth: g,
    goToMonth: b,
    goToDay: (M) => {
      y(M) || b(M.date);
    }
  };
}
function US(t, e, n, r) {
  let i, o = 0, a = !1;
  for (; o < t.length && !a; ) {
    const s = t[o], l = e(s);
    !l[Ot.disabled] && !l[Ot.hidden] && !l[Ot.outside] && (l[Ot.focused] || r != null && r.isEqualTo(s) || n(s.date) || l[Ot.today]) && (i = s, a = !0), o++;
  }
  return i || (i = t.find((s) => {
    const l = e(s);
    return !l[Ot.disabled] && !l[Ot.hidden] && !l[Ot.outside];
  })), i;
}
function ti(t, e, n = !1, r = Vo) {
  let { from: i, to: o } = t;
  const { differenceInCalendarDays: a, isSameDay: s } = r;
  return i && o ? (a(o, i) < 0 && ([i, o] = [o, i]), a(e, i) >= (n ? 1 : 0) && a(o, e) >= (n ? 1 : 0)) : !n && o ? s(o, e) : !n && i ? s(i, e) : !1;
}
function V6(t) {
  return !!(t && typeof t == "object" && "before" in t && "after" in t);
}
function Y1(t) {
  return !!(t && typeof t == "object" && "from" in t);
}
function $6(t) {
  return !!(t && typeof t == "object" && "after" in t);
}
function W6(t) {
  return !!(t && typeof t == "object" && "before" in t);
}
function j6(t) {
  return !!(t && typeof t == "object" && "dayOfWeek" in t);
}
function G6(t, e) {
  return Array.isArray(t) && t.every(e.isDate);
}
function ni(t, e, n = Vo) {
  const r = Array.isArray(e) ? e : [e], { isSameDay: i, differenceInCalendarDays: o, isAfter: a } = n;
  return r.some((s) => {
    if (typeof s == "boolean")
      return s;
    if (n.isDate(s))
      return i(t, s);
    if (G6(s, n))
      return s.includes(t);
    if (Y1(s))
      return ti(s, t, !1, n);
    if (j6(s))
      return Array.isArray(s.dayOfWeek) ? s.dayOfWeek.includes(t.getDay()) : s.dayOfWeek === t.getDay();
    if (V6(s)) {
      const l = o(s.before, t), c = o(s.after, t), u = l > 0, d = c < 0;
      return a(s.before, s.after) ? d && u : u || d;
    }
    return $6(s) ? o(t, s.after) > 0 : W6(s) ? o(s.before, t) > 0 : typeof s == "function" ? s(t) : !1;
  });
}
function zS(t, e, n, r, i, o, a) {
  const { ISOWeek: s } = o, { addDays: l, addMonths: c, addYears: u, addWeeks: d, startOfISOWeek: f, endOfISOWeek: h, startOfWeek: v, endOfWeek: g, max: m, min: p } = a;
  let b = {
    day: l,
    week: d,
    month: c,
    year: u,
    startOfWeek: (x) => s ? f(x) : v(x),
    endOfWeek: (x) => s ? h(x) : g(x)
  }[t](n, e === "after" ? 1 : -1);
  return e === "before" && r ? b = m([r, b]) : e === "after" && i && (b = p([i, b])), b;
}
function q6(t, e, n, r, i, o, a, s = 0) {
  if (s > 365)
    return;
  const l = zS(
    t,
    e,
    n.date,
    // should be refDay? or refDay.date?
    r,
    i,
    o,
    a
  ), c = !!(o.disabled && ni(l, o.disabled, a)), u = !!(o.hidden && ni(l, o.hidden, a)), d = l, f = new B6(l, d, a);
  return !c && !u ? f : q6(t, e, f, r, i, o, a, s + 1);
}
function HS(t, e, n, r, i) {
  const { autoFocus: o } = t, [a, s] = Ke(), l = US(e.days, n, r || (() => !1), a), [c, u] = Ke(o ? l : void 0);
  return {
    isFocusTarget: (g) => !!(l != null && l.isEqualTo(g)),
    setFocused: u,
    focused: c,
    blur: () => {
      s(c), u(void 0);
    },
    moveFocus: (g, m) => {
      if (!c)
        return;
      const p = q6(g, m, c, e.navStart, e.navEnd, t, i);
      p && (e.goToDay(p), u(p));
    }
  };
}
function BS(t, e, n) {
  const { disabled: r, hidden: i, modifiers: o, showOutsideDays: a, today: s } = e, { isSameDay: l, isSameMonth: c } = n, u = {
    [Ot.focused]: [],
    [Ot.outside]: [],
    [Ot.disabled]: [],
    [Ot.hidden]: [],
    [Ot.today]: []
  }, d = {}, f = {
    [tn.range_end]: [],
    [tn.range_middle]: [],
    [tn.range_start]: [],
    [tn.selected]: []
  };
  for (const h of t) {
    const { date: v, displayMonth: g } = h, m = !!(g && !c(v, g)), p = !!(r && ni(v, r, n)), y = !!(i && ni(v, i, n)) || !a && m, b = l(v, s ?? (e.timeZone ? Ir.tz(e.timeZone) : n.Date ? new n.Date() : /* @__PURE__ */ new Date()));
    m && u.outside.push(h), p && u.disabled.push(h), y && u.hidden.push(h), b && u.today.push(h), o && Object.keys(o).forEach((x) => {
      const _ = o == null ? void 0 : o[x];
      _ && ni(v, _, n) && (d[x] ? d[x].push(h) : d[x] = [h]);
    });
  }
  return (h) => {
    const v = {
      [Ot.focused]: !1,
      [Ot.disabled]: !1,
      [Ot.hidden]: !1,
      [Ot.outside]: !1,
      [Ot.today]: !1
    }, g = {
      [tn.range_end]: !1,
      [tn.range_middle]: !1,
      [tn.range_start]: !1,
      [tn.selected]: !1
    }, m = {};
    for (const p in u) {
      const y = u[p];
      v[p] = y.some((b) => b === h);
    }
    for (const p in f) {
      const y = f[p];
      g[p] = y.some((b) => b === h);
    }
    for (const p in d)
      m[p] = d[p].some((y) => y === h);
    return {
      ...g,
      ...v,
      // custom modifiers should override all the previous ones
      ...m
    };
  };
}
function VS(t, e) {
  const { selected: n, required: r, onSelect: i } = t, [o, a] = gd(n, i ? n : void 0), s = i ? n : o, { isSameDay: l } = e, c = (h) => (s == null ? void 0 : s.some((v) => l(v, h))) ?? !1, { min: u, max: d } = t;
  return {
    selected: s,
    select: (h, v, g) => {
      let m = [...s ?? []];
      if (c(h)) {
        if ((s == null ? void 0 : s.length) === u || r && (s == null ? void 0 : s.length) === 1)
          return;
        m = s == null ? void 0 : s.filter((p) => !l(p, h));
      } else
        (s == null ? void 0 : s.length) === d ? m = [h] : m = [...m, h];
      return i || a(m), i == null || i(m, h, v, g), m;
    },
    isSelected: c
  };
}
function $S(t, e, n = 0, r = 0, i = !1, o = Vo) {
  const { from: a, to: s } = e || {}, { isSameDay: l, isAfter: c, isBefore: u } = o;
  let d;
  if (!a && !s)
    d = { from: t, to: n > 0 ? void 0 : t };
  else if (a && !s)
    l(a, t) ? i ? d = { from: a, to: void 0 } : d = void 0 : u(t, a) ? d = { from: t, to: a } : d = { from: a, to: t };
  else if (a && s)
    if (l(a, t) && l(s, t))
      i ? d = { from: a, to: s } : d = void 0;
    else if (l(a, t))
      d = { from: a, to: n > 0 ? void 0 : t };
    else if (l(s, t))
      d = { from: t, to: n > 0 ? void 0 : t };
    else if (u(t, a))
      d = { from: t, to: s };
    else if (c(t, a))
      d = { from: a, to: t };
    else if (c(t, s))
      d = { from: a, to: t };
    else
      throw new Error("Invalid range");
  if (d != null && d.from && (d != null && d.to)) {
    const f = o.differenceInCalendarDays(d.to, d.from);
    r > 0 && f > r ? d = { from: t, to: void 0 } : n > 1 && f < n && (d = { from: t, to: void 0 });
  }
  return d;
}
function WS(t, e, n = Vo) {
  const r = Array.isArray(e) ? e : [e];
  let i = t.from;
  const o = n.differenceInCalendarDays(t.to, t.from), a = Math.min(o, 6);
  for (let s = 0; s <= a; s++) {
    if (r.includes(i.getDay()))
      return !0;
    i = n.addDays(i, 1);
  }
  return !1;
}
function Sm(t, e, n = Vo) {
  return ti(t, e.from, !1, n) || ti(t, e.to, !1, n) || ti(e, t.from, !1, n) || ti(e, t.to, !1, n);
}
function jS(t, e, n = Vo) {
  const r = Array.isArray(e) ? e : [e];
  if (r.filter((s) => typeof s != "function").some((s) => typeof s == "boolean" ? s : n.isDate(s) ? ti(t, s, !1, n) : G6(s, n) ? s.some((l) => ti(t, l, !1, n)) : Y1(s) ? s.from && s.to ? Sm(t, { from: s.from, to: s.to }, n) : !1 : j6(s) ? WS(t, s.dayOfWeek, n) : V6(s) ? n.isAfter(s.before, s.after) ? Sm(t, {
    from: n.addDays(s.after, 1),
    to: n.addDays(s.before, -1)
  }, n) : ni(t.from, s, n) || ni(t.to, s, n) : $6(s) || W6(s) ? ni(t.from, s, n) || ni(t.to, s, n) : !1))
    return !0;
  const a = r.filter((s) => typeof s == "function");
  if (a.length) {
    let s = t.from;
    const l = n.differenceInCalendarDays(t.to, t.from);
    for (let c = 0; c <= l; c++) {
      if (a.some((u) => u(s)))
        return !0;
      s = n.addDays(s, 1);
    }
  }
  return !1;
}
function GS(t, e) {
  const { disabled: n, excludeDisabled: r, selected: i, required: o, onSelect: a } = t, [s, l] = gd(i, a ? i : void 0), c = a ? i : s;
  return {
    selected: c,
    select: (f, h, v) => {
      const { min: g, max: m } = t, p = f ? $S(f, c, g, m, o, e) : void 0;
      return r && n && (p != null && p.from) && p.to && jS({ from: p.from, to: p.to }, n, e) && (p.from = f, p.to = void 0), a || l(p), a == null || a(p, f, h, v), p;
    },
    isSelected: (f) => c && ti(c, f, !1, e)
  };
}
function qS(t, e) {
  const { selected: n, required: r, onSelect: i } = t, [o, a] = gd(n, i ? n : void 0), s = i ? n : o, { isSameDay: l } = e;
  return {
    selected: s,
    select: (d, f, h) => {
      let v = d;
      return !r && s && s && l(d, s) && (v = void 0), i || a(v), i == null || i(v, d, f, h), v;
    },
    isSelected: (d) => s ? l(s, d) : !1
  };
}
function XS(t, e) {
  const n = qS(t, e), r = VS(t, e), i = GS(t, e);
  switch (t.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return i;
    default:
      return;
  }
}
function YS(t) {
  const { components: e, formatters: n, labels: r, dateLib: i, locale: o, classNames: a } = Pn(() => {
    const ke = { ...vd, ...t.locale };
    return {
      dateLib: new fi({
        locale: ke,
        weekStartsOn: t.weekStartsOn,
        firstWeekContainsDate: t.firstWeekContainsDate,
        useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens
      }, t.dateLib),
      components: YE(t.components),
      formatters: aS(t.formatters),
      labels: { ...SS, ...t.labels },
      locale: ke,
      classNames: { ...KE(), ...t.classNames }
    };
  }, [
    t.classNames,
    t.components,
    t.dateLib,
    t.firstWeekContainsDate,
    t.formatters,
    t.labels,
    t.locale,
    t.useAdditionalDayOfYearTokens,
    t.useAdditionalWeekYearTokens,
    t.weekStartsOn
  ]), { captionLayout: s, mode: l, onDayBlur: c, onDayClick: u, onDayFocus: d, onDayKeyDown: f, onDayMouseEnter: h, onDayMouseLeave: v, onNextClick: g, onPrevClick: m, showWeekNumber: p, styles: y } = t, { formatCaption: b, formatDay: x, formatMonthDropdown: _, formatWeekNumber: M, formatWeekNumberHeader: S, formatWeekdayName: P, formatYearDropdown: E } = n, w = FS(t, i), { days: O, months: N, navStart: I, navEnd: H, previousMonth: j, nextMonth: U, goToMonth: $ } = w, V = BS(O, t, i), { isSelected: te, select: B, selected: Z } = XS(t, i) ?? {}, { blur: Q, focused: ce, isFocusTarget: k, moveFocus: G, setFocused: K } = HS(t, w, V, te ?? (() => !1), i), { labelDayButton: J, labelGridcell: se, labelGrid: be, labelMonthDropdown: pe, labelNav: Ne, labelWeekday: ae, labelWeekNumber: Re, labelWeekNumberHeader: F, labelYearDropdown: Ge } = r, $e = Pn(() => fS(i, t.ISOWeek, t.timeZone), [i, t.ISOWeek, t.timeZone]), he = l !== void 0 || u !== void 0, ue = Gt(() => {
    j && ($(j), m == null || m(j));
  }, [j, $, m]), Se = Gt(() => {
    U && ($(U), g == null || g(U));
  }, [$, U, g]), we = Gt((ke, ge) => (Ee) => {
    Ee.preventDefault(), Ee.stopPropagation(), K(ke), B == null || B(ke.date, ge, Ee), u == null || u(ke.date, ge, Ee);
  }, [B, u, K]), D = Gt((ke, ge) => (Ee) => {
    K(ke), d == null || d(ke.date, ge, Ee);
  }, [d, K]), T = Gt((ke, ge) => (Ee) => {
    Q(), c == null || c(ke.date, ge, Ee);
  }, [Q, c]), Y = Gt((ke, ge) => (Ee) => {
    const Be = {
      ArrowLeft: ["day", t.dir === "rtl" ? "after" : "before"],
      ArrowRight: ["day", t.dir === "rtl" ? "before" : "after"],
      ArrowDown: ["week", "after"],
      ArrowUp: ["week", "before"],
      PageUp: [Ee.shiftKey ? "year" : "month", "before"],
      PageDown: [Ee.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (Be[Ee.key]) {
      Ee.preventDefault(), Ee.stopPropagation();
      const [We, Fe] = Be[Ee.key];
      G(We, Fe);
    }
    f == null || f(ke.date, ge, Ee);
  }, [G, f, t.dir]), fe = Gt((ke, ge) => (Ee) => {
    h == null || h(ke.date, ge, Ee);
  }, [h]), de = Gt((ke, ge) => (Ee) => {
    v == null || v(ke.date, ge, Ee);
  }, [v]), { className: ne, style: Le } = Pn(() => ({
    className: [a[Xe.Root], t.className].filter(Boolean).join(" "),
    style: { ...y == null ? void 0 : y[Xe.Root], ...t.style }
  }), [a, t.className, t.style, y]), Ce = ZE(t), Te = {
    dayPickerProps: t,
    selected: Z,
    select: B,
    isSelected: te,
    months: N,
    nextMonth: U,
    previousMonth: j,
    goToMonth: $,
    getModifiers: V,
    components: e,
    classNames: a,
    styles: y,
    labels: r,
    formatters: n
  };
  return A.createElement(
    N6.Provider,
    { value: Te },
    A.createElement(
      e.Root,
      { className: ne, style: Le, dir: t.dir, id: t.id, lang: t.lang, nonce: t.nonce, title: t.title, ...Ce },
      A.createElement(
        e.Months,
        { className: a[Xe.Months], style: y == null ? void 0 : y[Xe.Months] },
        !t.hideNavigation && A.createElement(e.Nav, { className: a[Xe.Nav], style: y == null ? void 0 : y[Xe.Nav], "aria-label": Ne(), onPreviousClick: ue, onNextClick: Se, previousMonth: j, nextMonth: U }),
        N.map((ke, ge) => {
          const Ee = (qe) => {
            const Ye = Number(qe.target.value), Je = i.setMonth(i.startOfMonth(ke.date), Ye);
            $(Je);
          }, Be = (qe) => {
            const Ye = i.setYear(i.startOfMonth(ke.date), Number(qe.target.value));
            $(Ye);
          }, We = sS(ke.date, I, H, n, i), Fe = hS(N[0].date, I, H, n, i);
          return A.createElement(
            e.Month,
            { className: a[Xe.Month], style: y == null ? void 0 : y[Xe.Month], key: ge, displayIndex: ge, calendarMonth: ke },
            A.createElement(e.MonthCaption, { className: a[Xe.MonthCaption], style: y == null ? void 0 : y[Xe.MonthCaption], calendarMonth: ke, displayIndex: ge }, s != null && s.startsWith("dropdown") ? A.createElement(
              e.DropdownNav,
              { className: a[Xe.Dropdowns], style: y == null ? void 0 : y[Xe.Dropdowns] },
              s === "dropdown" || s === "dropdown-months" ? A.createElement(e.MonthsDropdown, { className: a[Xe.MonthsDropdown], "aria-label": pe(), classNames: a, components: e, disabled: !!t.disableNavigation, onChange: Ee, options: We, style: y == null ? void 0 : y[Xe.Dropdown], value: ke.date.getMonth() }) : A.createElement("span", { role: "status", "aria-live": "polite" }, _(ke.date.getMonth(), o)),
              s === "dropdown" || s === "dropdown-years" ? A.createElement(e.YearsDropdown, { className: a[Xe.YearsDropdown], "aria-label": Ge(i.options), classNames: a, components: e, disabled: !!t.disableNavigation, onChange: Be, options: Fe, style: y == null ? void 0 : y[Xe.Dropdown], value: ke.date.getFullYear() }) : A.createElement("span", { role: "status", "aria-live": "polite" }, E(ke.date.getFullYear()))
            ) : A.createElement(e.CaptionLabel, { className: a[Xe.CaptionLabel], role: "status", "aria-live": "polite" }, b(ke.date, i.options, i))),
            A.createElement(
              e.MonthGrid,
              { role: "grid", "aria-multiselectable": l === "multiple" || l === "range", "aria-label": be(ke.date, i.options, i) || void 0, className: a[Xe.MonthGrid], style: y == null ? void 0 : y[Xe.MonthGrid] },
              !t.hideWeekdays && A.createElement(
                e.Weekdays,
                { className: a[Xe.Weekdays], style: y == null ? void 0 : y[Xe.Weekdays] },
                p && A.createElement(e.WeekNumberHeader, { "aria-label": F(i.options), className: a[Xe.WeekNumberHeader], style: y == null ? void 0 : y[Xe.WeekNumberHeader], scope: "col" }, S()),
                $e.map((qe, Ye) => A.createElement(e.Weekday, { "aria-label": ae(qe, i.options, i), className: a[Xe.Weekday], key: Ye, style: y == null ? void 0 : y[Xe.Weekday], scope: "col" }, P(qe, i.options, i)))
              ),
              A.createElement(e.Weeks, { className: a[Xe.Weeks], style: y == null ? void 0 : y[Xe.Weeks] }, ke.weeks.map((qe, Ye) => A.createElement(
                e.Week,
                { className: a[Xe.Week], key: qe.weekNumber, style: y == null ? void 0 : y[Xe.Week], week: qe },
                p && A.createElement(e.WeekNumber, { week: qe, style: y == null ? void 0 : y[Xe.WeekNumber], "aria-label": Re(qe.weekNumber, {
                  locale: o
                }), className: a[Xe.WeekNumber], scope: "row" }, M(qe.weekNumber)),
                qe.days.map((Je) => {
                  const { date: W } = Je, ye = V(Je);
                  if (ye[Ot.focused] = !ye.hidden && !!(ce != null && ce.isEqualTo(Je)), ye[tn.selected] = !ye.disabled && ((te == null ? void 0 : te(W)) || ye.selected), Y1(Z)) {
                    const { from: Ae, to: Qe } = Z;
                    ye[tn.range_start] = !!(Ae && Qe && i.isSameDay(W, Ae)), ye[tn.range_end] = !!(Ae && Qe && i.isSameDay(W, Qe)), ye[tn.range_middle] = ti(Z, W, !0, i);
                  }
                  const oe = lS(ye, y, t.modifiersStyles), me = wE(ye, a, t.modifiersClassNames), Oe = he ? void 0 : se(W, ye, i.options, i);
                  return A.createElement(e.Day, { key: `${i.format(W, "yyyy-MM-dd")}_${i.format(Je.displayMonth, "yyyy-MM")}`, day: Je, modifiers: ye, className: me.join(" "), style: oe, "aria-hidden": ye.hidden || void 0, "aria-selected": ye.selected || void 0, "aria-label": Oe, "data-day": i.format(W, "yyyy-MM-dd"), "data-month": Je.outside ? i.format(W, "yyyy-MM") : void 0, "data-selected": ye.selected || void 0, "data-disabled": ye.disabled || void 0, "data-hidden": ye.hidden || void 0, "data-outside": Je.outside || void 0, "data-focused": ye.focused || void 0, "data-today": ye.today || void 0 }, he ? A.createElement(e.DayButton, { className: a[Xe.DayButton], style: y == null ? void 0 : y[Xe.DayButton], type: "button", day: Je, modifiers: ye, disabled: ye.disabled || void 0, tabIndex: k(Je) ? 0 : -1, "aria-label": J(W, ye, i.options, i), onClick: we(Je, ye), onBlur: T(Je, ye), onFocus: D(Je, ye), onKeyDown: Y(Je, ye), onMouseEnter: fe(Je, ye), onMouseLeave: de(Je, ye) }, x(W, i.options, i)) : x(Je.date, i.options, i));
                })
              )))
            )
          );
        })
      ),
      t.footer && A.createElement(e.Footer, { className: a[Xe.Footer], style: y == null ? void 0 : y[Xe.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
const X6 = ({ className: t, classNames: e, styles: n, ...r }) => /* @__PURE__ */ R.jsx(
  YS,
  {
    captionLayout: "dropdown",
    className: ve(
      "w-[fit-content] b-1 b-neutral-400 rounded-2 b-solid px-3 pt-3 pb-2 bg-neutral-100 relative",
      t
    ),
    classNames: {
      months: "relative",
      nav: "absolute w-full h-20px",
      button_previous: "z-1 h-20px w-20px color-neutral-400 hover:color-neutral-600 cursor-pointer b-0 b-none bg-transparent absolute left-2",
      button_next: "z-1 h-20px w-20px  color-neutral-400 hover:color-neutral-600 cursor-pointer b-0 b-none bg-transparent absolute right-2",
      month: "",
      month_caption: "flex justify-center items-center pt-1px",
      dropdowns: "flex items-center gap-3",
      dropdown_root: "relative",
      dropdown: "appearance-none opacity-0 cursor-pointer absolute z-1 w-full",
      caption_label: ve("flex items-center gap-1 color-neutral-600 typo-text-s"),
      month_grid: "mt-3 border-spacing-x-1 border-spacing-y-2px",
      weekday: "h-24px w-24px color-neutral-800 typo-text-s",
      day: ve(
        "h-24px w-24px text-center rounded-3 cursor-pointer",
        "color-neutral-600 typo-text-s hover:bg-neutral-200",
        "[&.today]:color-neutral-800 [&.today]:typo-text-s-em",
        "[&.selected]:color-neutral-800 [&.selected]:typo-text-s-em [&.selected]:bg-neutral-200",
        "[&.outside]:color-neutral-400",
        "[&.disabled]:color-neutral-400 [&.disabled]:pointer-events-none"
      ),
      day_button: ve(
        "h-24px w-24px outline-none bg-transparent b-0 b-none cursor-pointer",
        "flex items-center justify-center"
      ),
      selected: "selected",
      today: "today",
      outside: "outside",
      disabled: "disabled",
      hidden: "hidden invisible",
      ...e
    },
    components: {
      Chevron: ({ className: i, orientation: o, ...a }) => /* @__PURE__ */ R.jsx(
        "div",
        {
          className: ve(
            "i-skand-dropdown",
            o === "up" && "rotate-180 text-3",
            o === "left" && "rotate-90 text-4",
            o === "right" && "rotate-270 text-4",
            o === "down" && "text-2 color-neutral-400",
            i
          ),
          ...a
        }
      )
    },
    showOutsideDays: !0,
    styles: {
      day_button: {
        color: "inherit",
        cursor: "inherit",
        fontFamily: "inherit",
        fontSize: "inherit",
        fontStyle: "inherit",
        fontWeight: "inherit",
        lineHeight: "inherit"
      },
      ...n
    },
    ...r
  }
);
X6.displayName = "Calendar";
const ZS = sr(
  ({ className: t, ...e }, n) => /* @__PURE__ */ R.jsx(
    "input",
    {
      className: ve(
        "appearance-none",
        "checked:color-neutral-600",
        "checked:i-skand-boxchecked",
        "color-neutral-600",
        "i-skand-boxunchecked",
        "text-3",
        t
      ),
      ref: n,
      type: "checkbox",
      ...e
    }
  )
);
ZS.displayName = "CheckBox";
function Mm(t, e) {
  if (typeof t == "function")
    return t(e);
  t != null && (t.current = e);
}
function Y6(...t) {
  return (e) => {
    let n = !1;
    const r = t.map((i) => {
      const o = Mm(i, e);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : Mm(t[i], null);
        }
      };
  };
}
function io(...t) {
  return C.useCallback(Y6(...t), t);
}
function KS(t, e) {
  const n = C.createContext(e), r = (o) => {
    const { children: a, ...s } = o, l = C.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ R.jsx(n.Provider, { value: l, children: a });
  };
  r.displayName = t + "Provider";
  function i(o) {
    const a = C.useContext(n);
    if (a)
      return a;
    if (e !== void 0)
      return e;
    throw new Error(`\`${o}\` must be used within \`${t}\``);
  }
  return [r, i];
}
function yd(t, e = []) {
  let n = [];
  function r(o, a) {
    const s = C.createContext(a), l = n.length;
    n = [...n, a];
    const c = (d) => {
      var p;
      const { scope: f, children: h, ...v } = d, g = ((p = f == null ? void 0 : f[t]) == null ? void 0 : p[l]) || s, m = C.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ R.jsx(g.Provider, { value: m, children: h });
    };
    c.displayName = o + "Provider";
    function u(d, f) {
      var g;
      const h = ((g = f == null ? void 0 : f[t]) == null ? void 0 : g[l]) || s, v = C.useContext(h);
      if (v)
        return v;
      if (a !== void 0)
        return a;
      throw new Error(`\`${d}\` must be used within \`${o}\``);
    }
    return [c, u];
  }
  const i = () => {
    const o = n.map((a) => C.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[t]) || o;
      return C.useMemo(
        () => ({ [`__scope${t}`]: { ...s, [t]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = t, [r, JS(i, ...e)];
}
function JS(...t) {
  const e = t[0];
  if (t.length === 1)
    return e;
  const n = () => {
    const r = t.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: c }) => {
        const d = l(o)[`__scope${c}`];
        return { ...s, ...d };
      }, {});
      return C.useMemo(() => ({ [`__scope${e.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = e.scopeName, n;
}
function Ur(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (t == null || t(i), n === !1 || !i.defaultPrevented)
      return e == null ? void 0 : e(i);
  };
}
function Cr(t) {
  const e = C.useRef(t);
  return C.useEffect(() => {
    e.current = t;
  }), C.useMemo(() => (...n) => {
    var r;
    return (r = e.current) == null ? void 0 : r.call(e, ...n);
  }, []);
}
function $o({
  prop: t,
  defaultProp: e,
  onChange: n = () => {
  }
}) {
  const [r, i] = QS({ defaultProp: e, onChange: n }), o = t !== void 0, a = o ? t : r, s = Cr(n), l = C.useCallback(
    (c) => {
      if (o) {
        const d = typeof c == "function" ? c(t) : c;
        d !== t && s(d);
      } else
        i(c);
    },
    [o, t, i, s]
  );
  return [a, l];
}
function QS({
  defaultProp: t,
  onChange: e
}) {
  const n = C.useState(t), [r] = n, i = C.useRef(r), o = Cr(e);
  return C.useEffect(() => {
    i.current !== r && (o(r), i.current = r);
  }, [r, i, o]), n;
}
function Z1(t) {
  const e = C.useRef({ value: t, previous: t });
  return C.useMemo(() => (e.current.value !== t && (e.current.previous = e.current.value, e.current.value = t), e.current.previous), [t]);
}
var li = globalThis != null && globalThis.document ? C.useLayoutEffect : () => {
};
function bd(t) {
  const [e, n] = C.useState(void 0);
  return li(() => {
    if (t) {
      n({ width: t.offsetWidth, height: t.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const o = i[0];
        let a, s;
        if ("borderBoxSize" in o) {
          const l = o.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          a = c.inlineSize, s = c.blockSize;
        } else
          a = t.offsetWidth, s = t.offsetHeight;
        n({ width: a, height: s });
      });
      return r.observe(t, { box: "border-box" }), () => r.unobserve(t);
    } else
      n(void 0);
  }, [t]), e;
}
function eM(t, e) {
  return C.useReducer((n, r) => e[n][r] ?? n, t);
}
var Yl = (t) => {
  const { present: e, children: n } = t, r = tM(e), i = typeof n == "function" ? n({ present: r.isPresent }) : C.Children.only(n), o = io(r.ref, nM(i));
  return typeof n == "function" || r.isPresent ? C.cloneElement(i, { ref: o }) : null;
};
Yl.displayName = "Presence";
function tM(t) {
  const [e, n] = C.useState(), r = C.useRef({}), i = C.useRef(t), o = C.useRef("none"), a = t ? "mounted" : "unmounted", [s, l] = eM(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return C.useEffect(() => {
    const c = _c(r.current);
    o.current = s === "mounted" ? c : "none";
  }, [s]), li(() => {
    const c = r.current, u = i.current;
    if (u !== t) {
      const f = o.current, h = _c(c);
      t ? l("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), i.current = t;
    }
  }, [t, l]), li(() => {
    if (e) {
      let c;
      const u = e.ownerDocument.defaultView ?? window, d = (h) => {
        const g = _c(r.current).includes(h.animationName);
        if (h.target === e && g && (l("ANIMATION_END"), !i.current)) {
          const m = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = m);
          });
        }
      }, f = (h) => {
        h.target === e && (o.current = _c(r.current));
      };
      return e.addEventListener("animationstart", f), e.addEventListener("animationcancel", d), e.addEventListener("animationend", d), () => {
        u.clearTimeout(c), e.removeEventListener("animationstart", f), e.removeEventListener("animationcancel", d), e.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [e, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: C.useCallback((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function _c(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function nM(t) {
  var r, i;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (i = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : i.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var K1 = C.forwardRef((t, e) => {
  const { children: n, ...r } = t, i = C.Children.toArray(n), o = i.find(iM);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? C.Children.count(a) > 1 ? C.Children.only(null) : C.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ R.jsx(th, { ...r, ref: e, children: C.isValidElement(a) ? C.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ R.jsx(th, { ...r, ref: e, children: n });
});
K1.displayName = "Slot";
var th = C.forwardRef((t, e) => {
  const { children: n, ...r } = t;
  if (C.isValidElement(n)) {
    const i = aM(n), o = oM(r, n.props);
    return n.type !== C.Fragment && (o.ref = e ? Y6(e, i) : i), C.cloneElement(n, o);
  }
  return C.Children.count(n) > 1 ? C.Children.only(null) : null;
});
th.displayName = "SlotClone";
var rM = ({ children: t }) => /* @__PURE__ */ R.jsx(R.Fragment, { children: t });
function iM(t) {
  return C.isValidElement(t) && t.type === rM;
}
function oM(t, e) {
  const n = { ...e };
  for (const r in e) {
    const i = t[r], o = e[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function aM(t) {
  var r, i;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (i = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : i.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var sM = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Sr = sM.reduce((t, e) => {
  const n = C.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? K1 : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ R.jsx(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${e}`, { ...t, [e]: n };
}, {});
function lM(t, e) {
  t && hd.flushSync(() => t.dispatchEvent(e));
}
var J1 = "Checkbox", [cM, Q0e] = yd(J1), [uM, dM] = cM(J1), Z6 = C.forwardRef(
  (t, e) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: i,
      defaultChecked: o,
      required: a,
      disabled: s,
      value: l = "on",
      onCheckedChange: c,
      form: u,
      ...d
    } = t, [f, h] = C.useState(null), v = io(e, (x) => h(x)), g = C.useRef(!1), m = f ? u || !!f.closest("form") : !0, [p = !1, y] = $o({
      prop: i,
      defaultProp: o,
      onChange: c
    }), b = C.useRef(p);
    return C.useEffect(() => {
      const x = f == null ? void 0 : f.form;
      if (x) {
        const _ = () => y(b.current);
        return x.addEventListener("reset", _), () => x.removeEventListener("reset", _);
      }
    }, [f, y]), /* @__PURE__ */ R.jsxs(uM, { scope: n, state: p, disabled: s, children: [
      /* @__PURE__ */ R.jsx(
        Sr.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": zi(p) ? "mixed" : p,
          "aria-required": a,
          "data-state": Q6(p),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...d,
          ref: v,
          onKeyDown: Ur(t.onKeyDown, (x) => {
            x.key === "Enter" && x.preventDefault();
          }),
          onClick: Ur(t.onClick, (x) => {
            y((_) => zi(_) ? !0 : !_), m && (g.current = x.isPropagationStopped(), g.current || x.stopPropagation());
          })
        }
      ),
      m && /* @__PURE__ */ R.jsx(
        fM,
        {
          control: f,
          bubbles: !g.current,
          name: r,
          value: l,
          checked: p,
          required: a,
          disabled: s,
          form: u,
          style: { transform: "translateX(-100%)" },
          defaultChecked: zi(o) ? !1 : o
        }
      )
    ] });
  }
);
Z6.displayName = J1;
var K6 = "CheckboxIndicator", J6 = C.forwardRef(
  (t, e) => {
    const { __scopeCheckbox: n, forceMount: r, ...i } = t, o = dM(K6, n);
    return /* @__PURE__ */ R.jsx(Yl, { present: r || zi(o.state) || o.state === !0, children: /* @__PURE__ */ R.jsx(
      Sr.span,
      {
        "data-state": Q6(o.state),
        "data-disabled": o.disabled ? "" : void 0,
        ...i,
        ref: e,
        style: { pointerEvents: "none", ...t.style }
      }
    ) });
  }
);
J6.displayName = K6;
var fM = (t) => {
  const { control: e, checked: n, bubbles: r = !0, defaultChecked: i, ...o } = t, a = C.useRef(null), s = Z1(n), l = bd(e);
  C.useEffect(() => {
    const u = a.current, d = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(d, "checked").set;
    if (s !== n && h) {
      const v = new Event("click", { bubbles: r });
      u.indeterminate = zi(n), h.call(u, zi(n) ? !1 : n), u.dispatchEvent(v);
    }
  }, [s, n, r]);
  const c = C.useRef(zi(n) ? !1 : n);
  return /* @__PURE__ */ R.jsx(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: i ?? c.current,
      ...o,
      tabIndex: -1,
      ref: a,
      style: {
        ...t.style,
        ...l,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function zi(t) {
  return t === "indeterminate";
}
function Q6(t) {
  return zi(t) ? "indeterminate" : t ? "checked" : "unchecked";
}
var e5 = Z6, hM = J6;
const pM = C.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ R.jsx(
  e5,
  {
    className: ve(
      "group peer",
      "h-3 w-3 rounded-sm transition",
      "outline outline-1 border-0  outline-neutral-500 outline-offset--1 bg-neutral-100",
      // in webapp-v2 there's a reset rule: `*:focus { outline: none; }`, this is to override that rule
      "focus:outline focus:outline-1 focus:outline-neutral-500 focus:outline-offset--1",
      "data-[state=checked]:bg-neutral-500 data-[state=indeterminate]:bg-neutral-500",
      "disabled:bg-neutral-300 disabled:outline-0 disabled:cursor-not-allowed",
      t
    ),
    ref: n,
    ...e,
    children: /* @__PURE__ */ R.jsxs(hM, { className: ve("relative"), children: [
      /* @__PURE__ */ R.jsx("div", { className: "i-skand-checkboxdash absolute h-3 w-3 transform-translate-y-[-50%] color-neutral-100 opacity-0 transition-opacity group-[[data-state=indeterminate]]:opacity-100" }),
      /* @__PURE__ */ R.jsx("div", { className: "i-skand-checkboxtick absolute h-3 w-3 transform-translate-y-[-50%] color-neutral-100 opacity-0 transition-opacity group-[[data-state=checked]]:opacity-100" })
    ] })
  }
));
pM.displayName = e5.displayName;
const mM = pd(["rounded-1", "inline-flex items-center"], {
  variants: {
    border: {
      false: ["b-none"],
      true: ["b-1 b-solid"]
    },
    intent: {
      alert: ["bg-alert-100 b-alert-400 color-neutral-800"],
      info: ["bg-info-100 b-info-400 color-neutral-800"],
      neutral: ["bg-neutral-100 b-neutral-400 color-neutral-800"],
      success: ["bg-success-100 b-success-400 color-neutral-800"],
      warning: ["bg-warning-100 b-warning-400 color-neutral-800"],
      annotation: ["bg-[hsla(225,100%,30%,0.5)] color-neutral-100"],
      deactivated: ["bg-neutral-100 b-neutral-400 color-neutral-500"],
      pending: ["bg-neutral-200 b-neutral-500 color-neutral-800"],
      purple: ["bg-[hsla(266,100%,95%,1)] b-[hsla(266,100%,64%,1)] color-[hsla(266,100%,64%,1)]"],
      inverted: ["bg-neutral-800 color-neutral-100"]
    },
    size: {
      xs: ["typo-text-s", "px-1 py-0"],
      small: ["typo-text-s", "px-2 py-2px"],
      middle: ["typo-text-s", "px-2 py-1"],
      large: ["typo-text-s", "px-3 py-2"]
    },
    shadow: {
      false: ["shadow-none"],
      true: ["shadow-general"]
    }
  },
  defaultVariants: {
    border: !0,
    intent: "neutral",
    size: "middle",
    shadow: !1
  }
}), vM = (t) => ve(mM(t)), gM = pd(["mr-2 text-3"], {
  variants: {
    intent: {
      alert: ["i-skand-warn color-alert-400"],
      info: ["i-skand-info color-info-400"],
      neutral: ["i-skand-warn color-neutral-400"],
      success: ["i-skand-done color-success-400"],
      warning: ["i-skand-warn color-warning-400"]
    }
  },
  defaultVariants: {
    intent: "neutral"
  }
}), ehe = (t) => ve(gM(t)), yM = pd(["mr-1 h-6px w-6px rounded-full"], {
  variants: {
    intent: {
      alert: ["bg-alert-400"],
      info: ["bg-info-400"],
      neutral: ["bg-neutral-400"],
      success: ["bg-success-400"],
      warning: ["bg-warning-400"]
    }
  },
  defaultVariants: {
    intent: "neutral"
  }
}), the = (t) => ve(yM(t)), nhe = () => ve("ml-2 i-skand-close text-3 color-neutral-500"), rhe = vM({ intent: "inverted", size: "small", shadow: !1, border: !1 });
var nr = {}, Zl = {}, bM = typeof wc == "object" && wc && wc.Object === Object && wc, t5 = bM, xM = t5, wM = typeof self == "object" && self && self.Object === Object && self, _M = xM || wM || Function("return this")(), $r = _M, CM = $r, EM = CM.Symbol, Kl = EM, Tm = Kl, n5 = Object.prototype, SM = n5.hasOwnProperty, MM = n5.toString, Hs = Tm ? Tm.toStringTag : void 0;
function TM(t) {
  var e = SM.call(t, Hs), n = t[Hs];
  try {
    t[Hs] = void 0;
    var r = !0;
  } catch {
  }
  var i = MM.call(t);
  return r && (e ? t[Hs] = n : delete t[Hs]), i;
}
var AM = TM, PM = Object.prototype, RM = PM.toString;
function LM(t) {
  return RM.call(t);
}
var OM = LM, Am = Kl, DM = AM, kM = OM, NM = "[object Null]", IM = "[object Undefined]", Pm = Am ? Am.toStringTag : void 0;
function FM(t) {
  return t == null ? t === void 0 ? IM : NM : Pm && Pm in Object(t) ? DM(t) : kM(t);
}
var Wo = FM, UM = Array.isArray, Mr = UM;
function zM(t) {
  return t != null && typeof t == "object";
}
var hi = zM, HM = Wo, BM = Mr, VM = hi, $M = "[object String]";
function WM(t) {
  return typeof t == "string" || !BM(t) && VM(t) && HM(t) == $M;
}
var jM = WM;
function GM(t) {
  return function(e, n, r) {
    for (var i = -1, o = Object(e), a = r(e), s = a.length; s--; ) {
      var l = a[t ? s : ++i];
      if (n(o[l], l, o) === !1)
        break;
    }
    return e;
  };
}
var qM = GM, XM = qM, YM = XM(), ZM = YM;
function KM(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var JM = KM, QM = Wo, eT = hi, tT = "[object Arguments]";
function nT(t) {
  return eT(t) && QM(t) == tT;
}
var rT = nT, Rm = rT, iT = hi, r5 = Object.prototype, oT = r5.hasOwnProperty, aT = r5.propertyIsEnumerable, sT = Rm(function() {
  return arguments;
}()) ? Rm : function(t) {
  return iT(t) && oT.call(t, "callee") && !aT.call(t, "callee");
}, i5 = sT, Ou = { exports: {} };
function lT() {
  return !1;
}
var cT = lT;
Ou.exports;
(function(t, e) {
  var n = $r, r = cT, i = e && !e.nodeType && e, o = i && !0 && t && !t.nodeType && t, a = o && o.exports === i, s = a ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || r;
  t.exports = c;
})(Ou, Ou.exports);
var Q1 = Ou.exports, uT = 9007199254740991, dT = /^(?:0|[1-9]\d*)$/;
function fT(t, e) {
  var n = typeof t;
  return e = e ?? uT, !!e && (n == "number" || n != "symbol" && dT.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var o5 = fT, hT = 9007199254740991;
function pT(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= hT;
}
var ep = pT, mT = Wo, vT = ep, gT = hi, yT = "[object Arguments]", bT = "[object Array]", xT = "[object Boolean]", wT = "[object Date]", _T = "[object Error]", CT = "[object Function]", ET = "[object Map]", ST = "[object Number]", MT = "[object Object]", TT = "[object RegExp]", AT = "[object Set]", PT = "[object String]", RT = "[object WeakMap]", LT = "[object ArrayBuffer]", OT = "[object DataView]", DT = "[object Float32Array]", kT = "[object Float64Array]", NT = "[object Int8Array]", IT = "[object Int16Array]", FT = "[object Int32Array]", UT = "[object Uint8Array]", zT = "[object Uint8ClampedArray]", HT = "[object Uint16Array]", BT = "[object Uint32Array]", Ft = {};
Ft[DT] = Ft[kT] = Ft[NT] = Ft[IT] = Ft[FT] = Ft[UT] = Ft[zT] = Ft[HT] = Ft[BT] = !0;
Ft[yT] = Ft[bT] = Ft[LT] = Ft[xT] = Ft[OT] = Ft[wT] = Ft[_T] = Ft[CT] = Ft[ET] = Ft[ST] = Ft[MT] = Ft[TT] = Ft[AT] = Ft[PT] = Ft[RT] = !1;
function VT(t) {
  return gT(t) && vT(t.length) && !!Ft[mT(t)];
}
var $T = VT;
function WT(t) {
  return function(e) {
    return t(e);
  };
}
var tp = WT, Du = { exports: {} };
Du.exports;
(function(t, e) {
  var n = t5, r = e && !e.nodeType && e, i = r && !0 && t && !t.nodeType && t, o = i && i.exports === r, a = o && n.process, s = function() {
    try {
      var l = i && i.require && i.require("util").types;
      return l || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  t.exports = s;
})(Du, Du.exports);
var np = Du.exports, jT = $T, GT = tp, Lm = np, Om = Lm && Lm.isTypedArray, qT = Om ? GT(Om) : jT, a5 = qT, XT = JM, YT = i5, ZT = Mr, KT = Q1, JT = o5, QT = a5, eA = Object.prototype, tA = eA.hasOwnProperty;
function nA(t, e) {
  var n = ZT(t), r = !n && YT(t), i = !n && !r && KT(t), o = !n && !r && !i && QT(t), a = n || r || i || o, s = a ? XT(t.length, String) : [], l = s.length;
  for (var c in t)
    (e || tA.call(t, c)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    JT(c, l))) && s.push(c);
  return s;
}
var s5 = nA, rA = Object.prototype;
function iA(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || rA;
  return t === n;
}
var rp = iA;
function oA(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var l5 = oA, aA = l5, sA = aA(Object.keys, Object), lA = sA, cA = rp, uA = lA, dA = Object.prototype, fA = dA.hasOwnProperty;
function hA(t) {
  if (!cA(t))
    return uA(t);
  var e = [];
  for (var n in Object(t))
    fA.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
var pA = hA;
function mA(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var fs = mA, vA = Wo, gA = fs, yA = "[object AsyncFunction]", bA = "[object Function]", xA = "[object GeneratorFunction]", wA = "[object Proxy]";
function _A(t) {
  if (!gA(t))
    return !1;
  var e = vA(t);
  return e == bA || e == xA || e == yA || e == wA;
}
var c5 = _A, CA = c5, EA = ep;
function SA(t) {
  return t != null && EA(t.length) && !CA(t);
}
var xd = SA, MA = s5, TA = pA, AA = xd;
function PA(t) {
  return AA(t) ? MA(t) : TA(t);
}
var Jl = PA, RA = ZM, LA = Jl;
function OA(t, e) {
  return t && RA(t, e, LA);
}
var u5 = OA;
function DA(t) {
  return t;
}
var d5 = DA, kA = d5;
function NA(t) {
  return typeof t == "function" ? t : kA;
}
var IA = NA, FA = u5, UA = IA;
function zA(t, e) {
  return t && FA(t, UA(e));
}
var ip = zA, HA = l5, BA = HA(Object.getPrototypeOf, Object), op = BA, VA = Wo, $A = op, WA = hi, jA = "[object Object]", GA = Function.prototype, qA = Object.prototype, f5 = GA.toString, XA = qA.hasOwnProperty, YA = f5.call(Object);
function ZA(t) {
  if (!WA(t) || VA(t) != jA)
    return !1;
  var e = $A(t);
  if (e === null)
    return !0;
  var n = XA.call(e, "constructor") && e.constructor;
  return typeof n == "function" && n instanceof n && f5.call(n) == YA;
}
var KA = ZA;
function JA(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = Array(r); ++n < r; )
    i[n] = e(t[n], n, t);
  return i;
}
var h5 = JA;
function QA() {
  this.__data__ = [], this.size = 0;
}
var eP = QA;
function tP(t, e) {
  return t === e || t !== t && e !== e;
}
var ap = tP, nP = ap;
function rP(t, e) {
  for (var n = t.length; n--; )
    if (nP(t[n][0], e))
      return n;
  return -1;
}
var wd = rP, iP = wd, oP = Array.prototype, aP = oP.splice;
function sP(t) {
  var e = this.__data__, n = iP(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : aP.call(e, n, 1), --this.size, !0;
}
var lP = sP, cP = wd;
function uP(t) {
  var e = this.__data__, n = cP(e, t);
  return n < 0 ? void 0 : e[n][1];
}
var dP = uP, fP = wd;
function hP(t) {
  return fP(this.__data__, t) > -1;
}
var pP = hP, mP = wd;
function vP(t, e) {
  var n = this.__data__, r = mP(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
var gP = vP, yP = eP, bP = lP, xP = dP, wP = pP, _P = gP;
function hs(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
hs.prototype.clear = yP;
hs.prototype.delete = bP;
hs.prototype.get = xP;
hs.prototype.has = wP;
hs.prototype.set = _P;
var _d = hs, CP = _d;
function EP() {
  this.__data__ = new CP(), this.size = 0;
}
var SP = EP;
function MP(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
var TP = MP;
function AP(t) {
  return this.__data__.get(t);
}
var PP = AP;
function RP(t) {
  return this.__data__.has(t);
}
var LP = RP, OP = $r, DP = OP["__core-js_shared__"], kP = DP, Tf = kP, Dm = function() {
  var t = /[^.]+$/.exec(Tf && Tf.keys && Tf.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function NP(t) {
  return !!Dm && Dm in t;
}
var IP = NP, FP = Function.prototype, UP = FP.toString;
function zP(t) {
  if (t != null) {
    try {
      return UP.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var p5 = zP, HP = c5, BP = IP, VP = fs, $P = p5, WP = /[\\^$.*+?()[\]{}|]/g, jP = /^\[object .+?Constructor\]$/, GP = Function.prototype, qP = Object.prototype, XP = GP.toString, YP = qP.hasOwnProperty, ZP = RegExp(
  "^" + XP.call(YP).replace(WP, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function KP(t) {
  if (!VP(t) || BP(t))
    return !1;
  var e = HP(t) ? ZP : jP;
  return e.test($P(t));
}
var JP = KP;
function QP(t, e) {
  return t == null ? void 0 : t[e];
}
var eR = QP, tR = JP, nR = eR;
function rR(t, e) {
  var n = nR(t, e);
  return tR(n) ? n : void 0;
}
var jo = rR, iR = jo, oR = $r, aR = iR(oR, "Map"), sp = aR, sR = jo, lR = sR(Object, "create"), Cd = lR, km = Cd;
function cR() {
  this.__data__ = km ? km(null) : {}, this.size = 0;
}
var uR = cR;
function dR(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var fR = dR, hR = Cd, pR = "__lodash_hash_undefined__", mR = Object.prototype, vR = mR.hasOwnProperty;
function gR(t) {
  var e = this.__data__;
  if (hR) {
    var n = e[t];
    return n === pR ? void 0 : n;
  }
  return vR.call(e, t) ? e[t] : void 0;
}
var yR = gR, bR = Cd, xR = Object.prototype, wR = xR.hasOwnProperty;
function _R(t) {
  var e = this.__data__;
  return bR ? e[t] !== void 0 : wR.call(e, t);
}
var CR = _R, ER = Cd, SR = "__lodash_hash_undefined__";
function MR(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = ER && e === void 0 ? SR : e, this;
}
var TR = MR, AR = uR, PR = fR, RR = yR, LR = CR, OR = TR;
function ps(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
ps.prototype.clear = AR;
ps.prototype.delete = PR;
ps.prototype.get = RR;
ps.prototype.has = LR;
ps.prototype.set = OR;
var DR = ps, Nm = DR, kR = _d, NR = sp;
function IR() {
  this.size = 0, this.__data__ = {
    hash: new Nm(),
    map: new (NR || kR)(),
    string: new Nm()
  };
}
var FR = IR;
function UR(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var zR = UR, HR = zR;
function BR(t, e) {
  var n = t.__data__;
  return HR(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
var Ed = BR, VR = Ed;
function $R(t) {
  var e = VR(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var WR = $R, jR = Ed;
function GR(t) {
  return jR(this, t).get(t);
}
var qR = GR, XR = Ed;
function YR(t) {
  return XR(this, t).has(t);
}
var ZR = YR, KR = Ed;
function JR(t, e) {
  var n = KR(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
var QR = JR, eL = FR, tL = WR, nL = qR, rL = ZR, iL = QR;
function ms(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
ms.prototype.clear = eL;
ms.prototype.delete = tL;
ms.prototype.get = nL;
ms.prototype.has = rL;
ms.prototype.set = iL;
var lp = ms, oL = _d, aL = sp, sL = lp, lL = 200;
function cL(t, e) {
  var n = this.__data__;
  if (n instanceof oL) {
    var r = n.__data__;
    if (!aL || r.length < lL - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new sL(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
var uL = cL, dL = _d, fL = SP, hL = TP, pL = PP, mL = LP, vL = uL;
function vs(t) {
  var e = this.__data__ = new dL(t);
  this.size = e.size;
}
vs.prototype.clear = fL;
vs.prototype.delete = hL;
vs.prototype.get = pL;
vs.prototype.has = mL;
vs.prototype.set = vL;
var cp = vs, gL = "__lodash_hash_undefined__";
function yL(t) {
  return this.__data__.set(t, gL), this;
}
var bL = yL;
function xL(t) {
  return this.__data__.has(t);
}
var wL = xL, _L = lp, CL = bL, EL = wL;
function ku(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new _L(); ++e < n; )
    this.add(t[e]);
}
ku.prototype.add = ku.prototype.push = CL;
ku.prototype.has = EL;
var SL = ku;
function ML(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r; )
    if (e(t[n], n, t))
      return !0;
  return !1;
}
var TL = ML;
function AL(t, e) {
  return t.has(e);
}
var PL = AL, RL = SL, LL = TL, OL = PL, DL = 1, kL = 2;
function NL(t, e, n, r, i, o) {
  var a = n & DL, s = t.length, l = e.length;
  if (s != l && !(a && l > s))
    return !1;
  var c = o.get(t), u = o.get(e);
  if (c && u)
    return c == e && u == t;
  var d = -1, f = !0, h = n & kL ? new RL() : void 0;
  for (o.set(t, e), o.set(e, t); ++d < s; ) {
    var v = t[d], g = e[d];
    if (r)
      var m = a ? r(g, v, d, e, t, o) : r(v, g, d, t, e, o);
    if (m !== void 0) {
      if (m)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!LL(e, function(p, y) {
        if (!OL(h, y) && (v === p || i(v, p, n, r, o)))
          return h.push(y);
      })) {
        f = !1;
        break;
      }
    } else if (!(v === g || i(v, g, n, r, o))) {
      f = !1;
      break;
    }
  }
  return o.delete(t), o.delete(e), f;
}
var m5 = NL, IL = $r, FL = IL.Uint8Array, v5 = FL;
function UL(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r, i) {
    n[++e] = [i, r];
  }), n;
}
var zL = UL;
function HL(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r) {
    n[++e] = r;
  }), n;
}
var BL = HL, Im = Kl, Fm = v5, VL = ap, $L = m5, WL = zL, jL = BL, GL = 1, qL = 2, XL = "[object Boolean]", YL = "[object Date]", ZL = "[object Error]", KL = "[object Map]", JL = "[object Number]", QL = "[object RegExp]", eO = "[object Set]", tO = "[object String]", nO = "[object Symbol]", rO = "[object ArrayBuffer]", iO = "[object DataView]", Um = Im ? Im.prototype : void 0, Af = Um ? Um.valueOf : void 0;
function oO(t, e, n, r, i, o, a) {
  switch (n) {
    case iO:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case rO:
      return !(t.byteLength != e.byteLength || !o(new Fm(t), new Fm(e)));
    case XL:
    case YL:
    case JL:
      return VL(+t, +e);
    case ZL:
      return t.name == e.name && t.message == e.message;
    case QL:
    case tO:
      return t == e + "";
    case KL:
      var s = WL;
    case eO:
      var l = r & GL;
      if (s || (s = jL), t.size != e.size && !l)
        return !1;
      var c = a.get(t);
      if (c)
        return c == e;
      r |= qL, a.set(t, e);
      var u = $L(s(t), s(e), r, i, o, a);
      return a.delete(t), u;
    case nO:
      if (Af)
        return Af.call(t) == Af.call(e);
  }
  return !1;
}
var aO = oO;
function sO(t, e) {
  for (var n = -1, r = e.length, i = t.length; ++n < r; )
    t[i + n] = e[n];
  return t;
}
var g5 = sO, lO = g5, cO = Mr;
function uO(t, e, n) {
  var r = e(t);
  return cO(t) ? r : lO(r, n(t));
}
var y5 = uO;
function dO(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = 0, o = []; ++n < r; ) {
    var a = t[n];
    e(a, n, t) && (o[i++] = a);
  }
  return o;
}
var fO = dO;
function hO() {
  return [];
}
var b5 = hO, pO = fO, mO = b5, vO = Object.prototype, gO = vO.propertyIsEnumerable, zm = Object.getOwnPropertySymbols, yO = zm ? function(t) {
  return t == null ? [] : (t = Object(t), pO(zm(t), function(e) {
    return gO.call(t, e);
  }));
} : mO, up = yO, bO = y5, xO = up, wO = Jl;
function _O(t) {
  return bO(t, wO, xO);
}
var x5 = _O, Hm = x5, CO = 1, EO = Object.prototype, SO = EO.hasOwnProperty;
function MO(t, e, n, r, i, o) {
  var a = n & CO, s = Hm(t), l = s.length, c = Hm(e), u = c.length;
  if (l != u && !a)
    return !1;
  for (var d = l; d--; ) {
    var f = s[d];
    if (!(a ? f in e : SO.call(e, f)))
      return !1;
  }
  var h = o.get(t), v = o.get(e);
  if (h && v)
    return h == e && v == t;
  var g = !0;
  o.set(t, e), o.set(e, t);
  for (var m = a; ++d < l; ) {
    f = s[d];
    var p = t[f], y = e[f];
    if (r)
      var b = a ? r(y, p, f, e, t, o) : r(p, y, f, t, e, o);
    if (!(b === void 0 ? p === y || i(p, y, n, r, o) : b)) {
      g = !1;
      break;
    }
    m || (m = f == "constructor");
  }
  if (g && !m) {
    var x = t.constructor, _ = e.constructor;
    x != _ && "constructor" in t && "constructor" in e && !(typeof x == "function" && x instanceof x && typeof _ == "function" && _ instanceof _) && (g = !1);
  }
  return o.delete(t), o.delete(e), g;
}
var TO = MO, AO = jo, PO = $r, RO = AO(PO, "DataView"), LO = RO, OO = jo, DO = $r, kO = OO(DO, "Promise"), NO = kO, IO = jo, FO = $r, UO = IO(FO, "Set"), zO = UO, HO = jo, BO = $r, VO = HO(BO, "WeakMap"), $O = VO, nh = LO, rh = sp, ih = NO, oh = zO, ah = $O, w5 = Wo, gs = p5, Bm = "[object Map]", WO = "[object Object]", Vm = "[object Promise]", $m = "[object Set]", Wm = "[object WeakMap]", jm = "[object DataView]", jO = gs(nh), GO = gs(rh), qO = gs(ih), XO = gs(oh), YO = gs(ah), xo = w5;
(nh && xo(new nh(new ArrayBuffer(1))) != jm || rh && xo(new rh()) != Bm || ih && xo(ih.resolve()) != Vm || oh && xo(new oh()) != $m || ah && xo(new ah()) != Wm) && (xo = function(t) {
  var e = w5(t), n = e == WO ? t.constructor : void 0, r = n ? gs(n) : "";
  if (r)
    switch (r) {
      case jO:
        return jm;
      case GO:
        return Bm;
      case qO:
        return Vm;
      case XO:
        return $m;
      case YO:
        return Wm;
    }
  return e;
});
var Sd = xo, Pf = cp, ZO = m5, KO = aO, JO = TO, Gm = Sd, qm = Mr, Xm = Q1, QO = a5, eD = 1, Ym = "[object Arguments]", Zm = "[object Array]", Cc = "[object Object]", tD = Object.prototype, Km = tD.hasOwnProperty;
function nD(t, e, n, r, i, o) {
  var a = qm(t), s = qm(e), l = a ? Zm : Gm(t), c = s ? Zm : Gm(e);
  l = l == Ym ? Cc : l, c = c == Ym ? Cc : c;
  var u = l == Cc, d = c == Cc, f = l == c;
  if (f && Xm(t)) {
    if (!Xm(e))
      return !1;
    a = !0, u = !1;
  }
  if (f && !u)
    return o || (o = new Pf()), a || QO(t) ? ZO(t, e, n, r, i, o) : KO(t, e, l, n, r, i, o);
  if (!(n & eD)) {
    var h = u && Km.call(t, "__wrapped__"), v = d && Km.call(e, "__wrapped__");
    if (h || v) {
      var g = h ? t.value() : t, m = v ? e.value() : e;
      return o || (o = new Pf()), i(g, m, n, r, o);
    }
  }
  return f ? (o || (o = new Pf()), JO(t, e, n, r, i, o)) : !1;
}
var rD = nD, iD = rD, Jm = hi;
function _5(t, e, n, r, i) {
  return t === e ? !0 : t == null || e == null || !Jm(t) && !Jm(e) ? t !== t && e !== e : iD(t, e, n, r, _5, i);
}
var C5 = _5, oD = cp, aD = C5, sD = 1, lD = 2;
function cD(t, e, n, r) {
  var i = n.length, o = i, a = !r;
  if (t == null)
    return !o;
  for (t = Object(t); i--; ) {
    var s = n[i];
    if (a && s[2] ? s[1] !== t[s[0]] : !(s[0] in t))
      return !1;
  }
  for (; ++i < o; ) {
    s = n[i];
    var l = s[0], c = t[l], u = s[1];
    if (a && s[2]) {
      if (c === void 0 && !(l in t))
        return !1;
    } else {
      var d = new oD();
      if (r)
        var f = r(c, u, l, t, e, d);
      if (!(f === void 0 ? aD(u, c, sD | lD, r, d) : f))
        return !1;
    }
  }
  return !0;
}
var uD = cD, dD = fs;
function fD(t) {
  return t === t && !dD(t);
}
var E5 = fD, hD = E5, pD = Jl;
function mD(t) {
  for (var e = pD(t), n = e.length; n--; ) {
    var r = e[n], i = t[r];
    e[n] = [r, i, hD(i)];
  }
  return e;
}
var vD = mD;
function gD(t, e) {
  return function(n) {
    return n == null ? !1 : n[t] === e && (e !== void 0 || t in Object(n));
  };
}
var S5 = gD, yD = uD, bD = vD, xD = S5;
function wD(t) {
  var e = bD(t);
  return e.length == 1 && e[0][2] ? xD(e[0][0], e[0][1]) : function(n) {
    return n === t || yD(n, t, e);
  };
}
var _D = wD, CD = Wo, ED = hi, SD = "[object Symbol]";
function MD(t) {
  return typeof t == "symbol" || ED(t) && CD(t) == SD;
}
var dp = MD, TD = Mr, AD = dp, PD = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, RD = /^\w*$/;
function LD(t, e) {
  if (TD(t))
    return !1;
  var n = typeof t;
  return n == "number" || n == "symbol" || n == "boolean" || t == null || AD(t) ? !0 : RD.test(t) || !PD.test(t) || e != null && t in Object(e);
}
var fp = LD, M5 = lp, OD = "Expected a function";
function hp(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(OD);
  var n = function() {
    var r = arguments, i = e ? e.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var a = t.apply(this, r);
    return n.cache = o.set(i, a) || o, a;
  };
  return n.cache = new (hp.Cache || M5)(), n;
}
hp.Cache = M5;
var DD = hp, kD = DD, ND = 500;
function ID(t) {
  var e = kD(t, function(r) {
    return n.size === ND && n.clear(), r;
  }), n = e.cache;
  return e;
}
var FD = ID, UD = FD, zD = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, HD = /\\(\\)?/g, BD = UD(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(zD, function(n, r, i, o) {
    e.push(i ? o.replace(HD, "$1") : r || n);
  }), e;
}), VD = BD, Qm = Kl, $D = h5, WD = Mr, jD = dp, GD = 1 / 0, e3 = Qm ? Qm.prototype : void 0, t3 = e3 ? e3.toString : void 0;
function T5(t) {
  if (typeof t == "string")
    return t;
  if (WD(t))
    return $D(t, T5) + "";
  if (jD(t))
    return t3 ? t3.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -GD ? "-0" : e;
}
var qD = T5, XD = qD;
function YD(t) {
  return t == null ? "" : XD(t);
}
var ZD = YD, KD = Mr, JD = fp, QD = VD, ek = ZD;
function tk(t, e) {
  return KD(t) ? t : JD(t, e) ? [t] : QD(ek(t));
}
var A5 = tk, nk = dp, rk = 1 / 0;
function ik(t) {
  if (typeof t == "string" || nk(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -rk ? "-0" : e;
}
var Md = ik, ok = A5, ak = Md;
function sk(t, e) {
  e = ok(e, t);
  for (var n = 0, r = e.length; t != null && n < r; )
    t = t[ak(e[n++])];
  return n && n == r ? t : void 0;
}
var P5 = sk, lk = P5;
function ck(t, e, n) {
  var r = t == null ? void 0 : lk(t, e);
  return r === void 0 ? n : r;
}
var uk = ck;
function dk(t, e) {
  return t != null && e in Object(t);
}
var fk = dk, hk = A5, pk = i5, mk = Mr, vk = o5, gk = ep, yk = Md;
function bk(t, e, n) {
  e = hk(e, t);
  for (var r = -1, i = e.length, o = !1; ++r < i; ) {
    var a = yk(e[r]);
    if (!(o = t != null && n(t, a)))
      break;
    t = t[a];
  }
  return o || ++r != i ? o : (i = t == null ? 0 : t.length, !!i && gk(i) && vk(a, i) && (mk(t) || pk(t)));
}
var xk = bk, wk = fk, _k = xk;
function Ck(t, e) {
  return t != null && _k(t, e, wk);
}
var Ek = Ck, Sk = C5, Mk = uk, Tk = Ek, Ak = fp, Pk = E5, Rk = S5, Lk = Md, Ok = 1, Dk = 2;
function kk(t, e) {
  return Ak(t) && Pk(e) ? Rk(Lk(t), e) : function(n) {
    var r = Mk(n, t);
    return r === void 0 && r === e ? Tk(n, t) : Sk(e, r, Ok | Dk);
  };
}
var Nk = kk;
function Ik(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
var Fk = Ik, Uk = P5;
function zk(t) {
  return function(e) {
    return Uk(e, t);
  };
}
var Hk = zk, Bk = Fk, Vk = Hk, $k = fp, Wk = Md;
function jk(t) {
  return $k(t) ? Bk(Wk(t)) : Vk(t);
}
var Gk = jk, qk = _D, Xk = Nk, Yk = d5, Zk = Mr, Kk = Gk;
function Jk(t) {
  return typeof t == "function" ? t : t == null ? Yk : typeof t == "object" ? Zk(t) ? Xk(t[0], t[1]) : qk(t) : Kk(t);
}
var Qk = Jk, eN = xd;
function tN(t, e) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!eN(n))
      return t(n, r);
    for (var i = n.length, o = e ? i : -1, a = Object(n); (e ? o-- : ++o < i) && r(a[o], o, a) !== !1; )
      ;
    return n;
  };
}
var nN = tN, rN = u5, iN = nN, oN = iN(rN), aN = oN, sN = aN, lN = xd;
function cN(t, e) {
  var n = -1, r = lN(t) ? Array(t.length) : [];
  return sN(t, function(i, o, a) {
    r[++n] = e(i, o, a);
  }), r;
}
var uN = cN, dN = h5, fN = Qk, hN = uN, pN = Mr;
function mN(t, e) {
  var n = pN(t) ? dN : hN;
  return n(t, fN(e));
}
var vN = mN;
Object.defineProperty(Zl, "__esModule", {
  value: !0
});
Zl.flattenNames = void 0;
var gN = jM, yN = Td(gN), bN = ip, xN = Td(bN), wN = KA, _N = Td(wN), CN = vN, EN = Td(CN);
function Td(t) {
  return t && t.__esModule ? t : { default: t };
}
var SN = Zl.flattenNames = function t() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = [];
  return (0, EN.default)(e, function(r) {
    Array.isArray(r) ? t(r).map(function(i) {
      return n.push(i);
    }) : (0, _N.default)(r) ? (0, xN.default)(r, function(i, o) {
      i === !0 && n.push(o), n.push(o + "-" + i);
    }) : (0, yN.default)(r) && n.push(r);
  }), n;
};
Zl.default = SN;
var Ql = {};
function MN(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r && e(t[n], n, t) !== !1; )
    ;
  return t;
}
var TN = MN, AN = jo, PN = function() {
  try {
    var t = AN(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), RN = PN, n3 = RN;
function LN(t, e, n) {
  e == "__proto__" && n3 ? n3(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
var R5 = LN, ON = R5, DN = ap, kN = Object.prototype, NN = kN.hasOwnProperty;
function IN(t, e, n) {
  var r = t[e];
  (!(NN.call(t, e) && DN(r, n)) || n === void 0 && !(e in t)) && ON(t, e, n);
}
var L5 = IN, FN = L5, UN = R5;
function zN(t, e, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, a = e.length; ++o < a; ) {
    var s = e[o], l = r ? r(n[s], t[s], s, n, t) : void 0;
    l === void 0 && (l = t[s]), i ? UN(n, s, l) : FN(n, s, l);
  }
  return n;
}
var Ad = zN, HN = Ad, BN = Jl;
function VN(t, e) {
  return t && HN(e, BN(e), t);
}
var $N = VN;
function WN(t) {
  var e = [];
  if (t != null)
    for (var n in Object(t))
      e.push(n);
  return e;
}
var jN = WN, GN = fs, qN = rp, XN = jN, YN = Object.prototype, ZN = YN.hasOwnProperty;
function KN(t) {
  if (!GN(t))
    return XN(t);
  var e = qN(t), n = [];
  for (var r in t)
    r == "constructor" && (e || !ZN.call(t, r)) || n.push(r);
  return n;
}
var JN = KN, QN = s5, eI = JN, tI = xd;
function nI(t) {
  return tI(t) ? QN(t, !0) : eI(t);
}
var pp = nI, rI = Ad, iI = pp;
function oI(t, e) {
  return t && rI(e, iI(e), t);
}
var aI = oI, Nu = { exports: {} };
Nu.exports;
(function(t, e) {
  var n = $r, r = e && !e.nodeType && e, i = r && !0 && t && !t.nodeType && t, o = i && i.exports === r, a = o ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
  function l(c, u) {
    if (u)
      return c.slice();
    var d = c.length, f = s ? s(d) : new c.constructor(d);
    return c.copy(f), f;
  }
  t.exports = l;
})(Nu, Nu.exports);
var sI = Nu.exports;
function lI(t, e) {
  var n = -1, r = t.length;
  for (e || (e = Array(r)); ++n < r; )
    e[n] = t[n];
  return e;
}
var cI = lI, uI = Ad, dI = up;
function fI(t, e) {
  return uI(t, dI(t), e);
}
var hI = fI, pI = g5, mI = op, vI = up, gI = b5, yI = Object.getOwnPropertySymbols, bI = yI ? function(t) {
  for (var e = []; t; )
    pI(e, vI(t)), t = mI(t);
  return e;
} : gI, O5 = bI, xI = Ad, wI = O5;
function _I(t, e) {
  return xI(t, wI(t), e);
}
var CI = _I, EI = y5, SI = O5, MI = pp;
function TI(t) {
  return EI(t, MI, SI);
}
var AI = TI, PI = Object.prototype, RI = PI.hasOwnProperty;
function LI(t) {
  var e = t.length, n = new t.constructor(e);
  return e && typeof t[0] == "string" && RI.call(t, "index") && (n.index = t.index, n.input = t.input), n;
}
var OI = LI, r3 = v5;
function DI(t) {
  var e = new t.constructor(t.byteLength);
  return new r3(e).set(new r3(t)), e;
}
var mp = DI, kI = mp;
function NI(t, e) {
  var n = e ? kI(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.byteLength);
}
var II = NI, FI = /\w*$/;
function UI(t) {
  var e = new t.constructor(t.source, FI.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var zI = UI, i3 = Kl, o3 = i3 ? i3.prototype : void 0, a3 = o3 ? o3.valueOf : void 0;
function HI(t) {
  return a3 ? Object(a3.call(t)) : {};
}
var BI = HI, VI = mp;
function $I(t, e) {
  var n = e ? VI(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.length);
}
var WI = $I, jI = mp, GI = II, qI = zI, XI = BI, YI = WI, ZI = "[object Boolean]", KI = "[object Date]", JI = "[object Map]", QI = "[object Number]", eF = "[object RegExp]", tF = "[object Set]", nF = "[object String]", rF = "[object Symbol]", iF = "[object ArrayBuffer]", oF = "[object DataView]", aF = "[object Float32Array]", sF = "[object Float64Array]", lF = "[object Int8Array]", cF = "[object Int16Array]", uF = "[object Int32Array]", dF = "[object Uint8Array]", fF = "[object Uint8ClampedArray]", hF = "[object Uint16Array]", pF = "[object Uint32Array]";
function mF(t, e, n) {
  var r = t.constructor;
  switch (e) {
    case iF:
      return jI(t);
    case ZI:
    case KI:
      return new r(+t);
    case oF:
      return GI(t, n);
    case aF:
    case sF:
    case lF:
    case cF:
    case uF:
    case dF:
    case fF:
    case hF:
    case pF:
      return YI(t, n);
    case JI:
      return new r();
    case QI:
    case nF:
      return new r(t);
    case eF:
      return qI(t);
    case tF:
      return new r();
    case rF:
      return XI(t);
  }
}
var vF = mF, gF = fs, s3 = Object.create, yF = function() {
  function t() {
  }
  return function(e) {
    if (!gF(e))
      return {};
    if (s3)
      return s3(e);
    t.prototype = e;
    var n = new t();
    return t.prototype = void 0, n;
  };
}(), bF = yF, xF = bF, wF = op, _F = rp;
function CF(t) {
  return typeof t.constructor == "function" && !_F(t) ? xF(wF(t)) : {};
}
var EF = CF, SF = Sd, MF = hi, TF = "[object Map]";
function AF(t) {
  return MF(t) && SF(t) == TF;
}
var PF = AF, RF = PF, LF = tp, l3 = np, c3 = l3 && l3.isMap, OF = c3 ? LF(c3) : RF, DF = OF, kF = Sd, NF = hi, IF = "[object Set]";
function FF(t) {
  return NF(t) && kF(t) == IF;
}
var UF = FF, zF = UF, HF = tp, u3 = np, d3 = u3 && u3.isSet, BF = d3 ? HF(d3) : zF, VF = BF, $F = cp, WF = TN, jF = L5, GF = $N, qF = aI, XF = sI, YF = cI, ZF = hI, KF = CI, JF = x5, QF = AI, eU = Sd, tU = OI, nU = vF, rU = EF, iU = Mr, oU = Q1, aU = DF, sU = fs, lU = VF, cU = Jl, uU = pp, dU = 1, fU = 2, hU = 4, D5 = "[object Arguments]", pU = "[object Array]", mU = "[object Boolean]", vU = "[object Date]", gU = "[object Error]", k5 = "[object Function]", yU = "[object GeneratorFunction]", bU = "[object Map]", xU = "[object Number]", N5 = "[object Object]", wU = "[object RegExp]", _U = "[object Set]", CU = "[object String]", EU = "[object Symbol]", SU = "[object WeakMap]", MU = "[object ArrayBuffer]", TU = "[object DataView]", AU = "[object Float32Array]", PU = "[object Float64Array]", RU = "[object Int8Array]", LU = "[object Int16Array]", OU = "[object Int32Array]", DU = "[object Uint8Array]", kU = "[object Uint8ClampedArray]", NU = "[object Uint16Array]", IU = "[object Uint32Array]", Lt = {};
Lt[D5] = Lt[pU] = Lt[MU] = Lt[TU] = Lt[mU] = Lt[vU] = Lt[AU] = Lt[PU] = Lt[RU] = Lt[LU] = Lt[OU] = Lt[bU] = Lt[xU] = Lt[N5] = Lt[wU] = Lt[_U] = Lt[CU] = Lt[EU] = Lt[DU] = Lt[kU] = Lt[NU] = Lt[IU] = !0;
Lt[gU] = Lt[k5] = Lt[SU] = !1;
function pu(t, e, n, r, i, o) {
  var a, s = e & dU, l = e & fU, c = e & hU;
  if (n && (a = i ? n(t, r, i, o) : n(t)), a !== void 0)
    return a;
  if (!sU(t))
    return t;
  var u = iU(t);
  if (u) {
    if (a = tU(t), !s)
      return YF(t, a);
  } else {
    var d = eU(t), f = d == k5 || d == yU;
    if (oU(t))
      return XF(t, s);
    if (d == N5 || d == D5 || f && !i) {
      if (a = l || f ? {} : rU(t), !s)
        return l ? KF(t, qF(a, t)) : ZF(t, GF(a, t));
    } else {
      if (!Lt[d])
        return i ? t : {};
      a = nU(t, d, s);
    }
  }
  o || (o = new $F());
  var h = o.get(t);
  if (h)
    return h;
  o.set(t, a), lU(t) ? t.forEach(function(m) {
    a.add(pu(m, e, n, m, t, o));
  }) : aU(t) && t.forEach(function(m, p) {
    a.set(p, pu(m, e, n, p, t, o));
  });
  var v = c ? l ? QF : JF : l ? uU : cU, g = u ? void 0 : v(t);
  return WF(g || t, function(m, p) {
    g && (p = m, m = t[p]), jF(a, p, pu(m, e, n, p, t, o));
  }), a;
}
var FU = pu, UU = FU, zU = 1, HU = 4;
function BU(t) {
  return UU(t, zU | HU);
}
var VU = BU;
Object.defineProperty(Ql, "__esModule", {
  value: !0
});
Ql.mergeClasses = void 0;
var $U = ip, WU = I5($U), jU = VU, GU = I5(jU), qU = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
};
function I5(t) {
  return t && t.__esModule ? t : { default: t };
}
var XU = Ql.mergeClasses = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = e.default && (0, GU.default)(e.default) || {};
  return n.map(function(i) {
    var o = e[i];
    return o && (0, WU.default)(o, function(a, s) {
      r[s] || (r[s] = {}), r[s] = qU({}, r[s], o[s]);
    }), i;
  }), r;
};
Ql.default = XU;
var ec = {};
Object.defineProperty(ec, "__esModule", {
  value: !0
});
ec.autoprefix = void 0;
var YU = ip, f3 = KU(YU), ZU = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
};
function KU(t) {
  return t && t.__esModule ? t : { default: t };
}
var JU = {
  borderRadius: function(e) {
    return {
      msBorderRadius: e,
      MozBorderRadius: e,
      OBorderRadius: e,
      WebkitBorderRadius: e,
      borderRadius: e
    };
  },
  boxShadow: function(e) {
    return {
      msBoxShadow: e,
      MozBoxShadow: e,
      OBoxShadow: e,
      WebkitBoxShadow: e,
      boxShadow: e
    };
  },
  userSelect: function(e) {
    return {
      WebkitTouchCallout: e,
      KhtmlUserSelect: e,
      MozUserSelect: e,
      msUserSelect: e,
      WebkitUserSelect: e,
      userSelect: e
    };
  },
  flex: function(e) {
    return {
      WebkitBoxFlex: e,
      MozBoxFlex: e,
      WebkitFlex: e,
      msFlex: e,
      flex: e
    };
  },
  flexBasis: function(e) {
    return {
      WebkitFlexBasis: e,
      flexBasis: e
    };
  },
  justifyContent: function(e) {
    return {
      WebkitJustifyContent: e,
      justifyContent: e
    };
  },
  transition: function(e) {
    return {
      msTransition: e,
      MozTransition: e,
      OTransition: e,
      WebkitTransition: e,
      transition: e
    };
  },
  transform: function(e) {
    return {
      msTransform: e,
      MozTransform: e,
      OTransform: e,
      WebkitTransform: e,
      transform: e
    };
  },
  absolute: function(e) {
    var n = e && e.split(" ");
    return {
      position: "absolute",
      top: n && n[0],
      right: n && n[1],
      bottom: n && n[2],
      left: n && n[3]
    };
  },
  extend: function(e, n) {
    var r = n[e];
    return r || {
      extend: e
    };
  }
}, QU = ec.autoprefix = function(e) {
  var n = {};
  return (0, f3.default)(e, function(r, i) {
    var o = {};
    (0, f3.default)(r, function(a, s) {
      var l = JU[s];
      l ? o = ZU({}, o, l(a)) : o[s] = a;
    }), n[i] = o;
  }), n;
};
ec.default = QU;
var tc = {};
Object.defineProperty(tc, "__esModule", {
  value: !0
});
tc.hover = void 0;
var ez = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, tz = A, Rf = nz(tz);
function nz(t) {
  return t && t.__esModule ? t : { default: t };
}
function rz(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function h3(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function iz(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var oz = tc.hover = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(r) {
    iz(i, r);
    function i() {
      var o, a, s, l;
      rz(this, i);
      for (var c = arguments.length, u = Array(c), d = 0; d < c; d++)
        u[d] = arguments[d];
      return l = (a = (s = h3(this, (o = i.__proto__ || Object.getPrototypeOf(i)).call.apply(o, [this].concat(u))), s), s.state = { hover: !1 }, s.handleMouseOver = function() {
        return s.setState({ hover: !0 });
      }, s.handleMouseOut = function() {
        return s.setState({ hover: !1 });
      }, s.render = function() {
        return Rf.default.createElement(
          n,
          { onMouseOver: s.handleMouseOver, onMouseOut: s.handleMouseOut },
          Rf.default.createElement(e, ez({}, s.props, s.state))
        );
      }, a), h3(s, l);
    }
    return i;
  }(Rf.default.Component);
};
tc.default = oz;
var nc = {};
Object.defineProperty(nc, "__esModule", {
  value: !0
});
nc.active = void 0;
var az = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, sz = A, Lf = lz(sz);
function lz(t) {
  return t && t.__esModule ? t : { default: t };
}
function cz(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function p3(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function uz(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var dz = nc.active = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(r) {
    uz(i, r);
    function i() {
      var o, a, s, l;
      cz(this, i);
      for (var c = arguments.length, u = Array(c), d = 0; d < c; d++)
        u[d] = arguments[d];
      return l = (a = (s = p3(this, (o = i.__proto__ || Object.getPrototypeOf(i)).call.apply(o, [this].concat(u))), s), s.state = { active: !1 }, s.handleMouseDown = function() {
        return s.setState({ active: !0 });
      }, s.handleMouseUp = function() {
        return s.setState({ active: !1 });
      }, s.render = function() {
        return Lf.default.createElement(
          n,
          { onMouseDown: s.handleMouseDown, onMouseUp: s.handleMouseUp },
          Lf.default.createElement(e, az({}, s.props, s.state))
        );
      }, a), p3(s, l);
    }
    return i;
  }(Lf.default.Component);
};
nc.default = dz;
var vp = {};
Object.defineProperty(vp, "__esModule", {
  value: !0
});
var fz = function(e, n) {
  var r = {}, i = function(a) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    r[a] = s;
  };
  return e === 0 && i("first-child"), e === n - 1 && i("last-child"), (e === 0 || e % 2 === 0) && i("even"), Math.abs(e % 2) === 1 && i("odd"), i("nth-child", e), r;
};
vp.default = fz;
Object.defineProperty(nr, "__esModule", {
  value: !0
});
nr.ReactCSS = nr.loop = nr.handleActive = gp = nr.handleHover = nr.hover = void 0;
var hz = Zl, pz = ys(hz), mz = Ql, vz = ys(mz), gz = ec, yz = ys(gz), bz = tc, F5 = ys(bz), xz = nc, wz = ys(xz), _z = vp, Cz = ys(_z);
function ys(t) {
  return t && t.__esModule ? t : { default: t };
}
nr.hover = F5.default;
var gp = nr.handleHover = F5.default;
nr.handleActive = wz.default;
nr.loop = Cz.default;
var Ez = nr.ReactCSS = function(e) {
  for (var n = arguments.length, r = Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  var o = (0, pz.default)(r), a = (0, vz.default)(e, o);
  return (0, yz.default)(a);
}, tt = nr.default = Ez, Sz = function(e, n, r, i, o) {
  var a = o.clientWidth, s = o.clientHeight, l = typeof e.pageX == "number" ? e.pageX : e.touches[0].pageX, c = typeof e.pageY == "number" ? e.pageY : e.touches[0].pageY, u = l - (o.getBoundingClientRect().left + window.pageXOffset), d = c - (o.getBoundingClientRect().top + window.pageYOffset);
  if (r === "vertical") {
    var f = void 0;
    if (d < 0 ? f = 0 : d > s ? f = 1 : f = Math.round(d * 100 / s) / 100, n.a !== f)
      return {
        h: n.h,
        s: n.s,
        l: n.l,
        a: f,
        source: "rgb"
      };
  } else {
    var h = void 0;
    if (u < 0 ? h = 0 : u > a ? h = 1 : h = Math.round(u * 100 / a) / 100, i !== h)
      return {
        h: n.h,
        s: n.s,
        l: n.l,
        a: h,
        source: "rgb"
      };
  }
  return null;
}, Of = {}, Mz = function(e, n, r, i) {
  if (typeof document > "u" && !i)
    return null;
  var o = i ? new i() : document.createElement("canvas");
  o.width = r * 2, o.height = r * 2;
  var a = o.getContext("2d");
  return a ? (a.fillStyle = e, a.fillRect(0, 0, o.width, o.height), a.fillStyle = n, a.fillRect(0, 0, r, r), a.translate(r, r), a.fillRect(0, 0, r, r), o.toDataURL()) : null;
}, Tz = function(e, n, r, i) {
  var o = e + "-" + n + "-" + r + (i ? "-server" : "");
  if (Of[o])
    return Of[o];
  var a = Mz(e, n, r, i);
  return Of[o] = a, a;
}, m3 = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, bs = function(e) {
  var n = e.white, r = e.grey, i = e.size, o = e.renderers, a = e.borderRadius, s = e.boxShadow, l = e.children, c = tt({
    default: {
      grid: {
        borderRadius: a,
        boxShadow: s,
        absolute: "0px 0px 0px 0px",
        background: "url(" + Tz(n, r, i, o.canvas) + ") center left"
      }
    }
  });
  return Tl(l) ? A.cloneElement(l, m3({}, l.props, { style: m3({}, l.props.style, c.grid) })) : A.createElement("div", { style: c.grid });
};
bs.defaultProps = {
  size: 8,
  white: "transparent",
  grey: "rgba(0,0,0,.08)",
  renderers: {}
};
var Az = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, Pz = function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function Rz(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function v3(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function Lz(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var yp = function(t) {
  Lz(e, t);
  function e() {
    var n, r, i, o;
    Rz(this, e);
    for (var a = arguments.length, s = Array(a), l = 0; l < a; l++)
      s[l] = arguments[l];
    return o = (r = (i = v3(this, (n = e.__proto__ || Object.getPrototypeOf(e)).call.apply(n, [this].concat(s))), i), i.handleChange = function(c) {
      var u = Sz(c, i.props.hsl, i.props.direction, i.props.a, i.container);
      u && typeof i.props.onChange == "function" && i.props.onChange(u, c);
    }, i.handleMouseDown = function(c) {
      i.handleChange(c), window.addEventListener("mousemove", i.handleChange), window.addEventListener("mouseup", i.handleMouseUp);
    }, i.handleMouseUp = function() {
      i.unbindEventListeners();
    }, i.unbindEventListeners = function() {
      window.removeEventListener("mousemove", i.handleChange), window.removeEventListener("mouseup", i.handleMouseUp);
    }, r), v3(i, o);
  }
  return Pz(e, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props.rgb, o = tt({
        default: {
          alpha: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: "0px 0px 0px 0px",
            overflow: "hidden",
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: "0px 0px 0px 0px",
            background: "linear-gradient(to right, rgba(" + i.r + "," + i.g + "," + i.b + `, 0) 0%,
           rgba(` + i.r + "," + i.g + "," + i.b + ", 1) 100%)",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: "relative",
            height: "100%",
            margin: "0 3px"
          },
          pointer: {
            position: "absolute",
            left: i.a * 100 + "%"
          },
          slider: {
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            marginTop: "1px",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          gradient: {
            background: "linear-gradient(to bottom, rgba(" + i.r + "," + i.g + "," + i.b + `, 0) 0%,
           rgba(` + i.r + "," + i.g + "," + i.b + ", 1) 100%)"
          },
          pointer: {
            left: 0,
            top: i.a * 100 + "%"
          }
        },
        overwrite: Az({}, this.props.style)
      }, {
        vertical: this.props.direction === "vertical",
        overwrite: !0
      });
      return A.createElement(
        "div",
        { style: o.alpha },
        A.createElement(
          "div",
          { style: o.checkboard },
          A.createElement(bs, { renderers: this.props.renderers })
        ),
        A.createElement("div", { style: o.gradient }),
        A.createElement(
          "div",
          {
            style: o.container,
            ref: function(s) {
              return r.container = s;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          A.createElement(
            "div",
            { style: o.pointer },
            this.props.pointer ? A.createElement(this.props.pointer, this.props) : A.createElement("div", { style: o.slider })
          )
        )
      );
    }
  }]), e;
}(Wl || jl), Oz = function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function Dz(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function kz(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Nz(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function Iz(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var Fz = 1, U5 = 38, Uz = 40, zz = [U5, Uz], Hz = function(e) {
  return zz.indexOf(e) > -1;
}, Bz = function(e) {
  return Number(String(e).replace(/%/g, ""));
}, Vz = 1, ft = function(t) {
  Iz(e, t);
  function e(n) {
    kz(this, e);
    var r = Nz(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
    return r.handleBlur = function() {
      r.state.blurValue && r.setState({ value: r.state.blurValue, blurValue: null });
    }, r.handleChange = function(i) {
      r.setUpdatedValue(i.target.value, i);
    }, r.handleKeyDown = function(i) {
      var o = Bz(i.target.value);
      if (!isNaN(o) && Hz(i.keyCode)) {
        var a = r.getArrowOffset(), s = i.keyCode === U5 ? o + a : o - a;
        r.setUpdatedValue(s, i);
      }
    }, r.handleDrag = function(i) {
      if (r.props.dragLabel) {
        var o = Math.round(r.props.value + i.movementX);
        o >= 0 && o <= r.props.dragMax && r.props.onChange && r.props.onChange(r.getValueObjectWithLabel(o), i);
      }
    }, r.handleMouseDown = function(i) {
      r.props.dragLabel && (i.preventDefault(), r.handleDrag(i), window.addEventListener("mousemove", r.handleDrag), window.addEventListener("mouseup", r.handleMouseUp));
    }, r.handleMouseUp = function() {
      r.unbindEventListeners();
    }, r.unbindEventListeners = function() {
      window.removeEventListener("mousemove", r.handleDrag), window.removeEventListener("mouseup", r.handleMouseUp);
    }, r.state = {
      value: String(n.value).toUpperCase(),
      blurValue: String(n.value).toUpperCase()
    }, r.inputId = "rc-editable-input-" + Vz++, r;
  }
  return Oz(e, [{
    key: "componentDidUpdate",
    value: function(r, i) {
      this.props.value !== this.state.value && (r.value !== this.props.value || i.value !== this.state.value) && (this.input === document.activeElement ? this.setState({ blurValue: String(this.props.value).toUpperCase() }) : this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "getValueObjectWithLabel",
    value: function(r) {
      return Dz({}, this.props.label, r);
    }
  }, {
    key: "getArrowOffset",
    value: function() {
      return this.props.arrowOffset || Fz;
    }
  }, {
    key: "setUpdatedValue",
    value: function(r, i) {
      var o = this.props.label ? this.getValueObjectWithLabel(r) : r;
      this.props.onChange && this.props.onChange(o, i), this.setState({ value: r });
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = tt({
        default: {
          wrap: {
            position: "relative"
          }
        },
        "user-override": {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        "dragLabel-true": {
          label: {
            cursor: "ew-resize"
          }
        }
      }, {
        "user-override": !0
      }, this.props);
      return A.createElement(
        "div",
        { style: i.wrap },
        A.createElement("input", {
          id: this.inputId,
          style: i.input,
          ref: function(a) {
            return r.input = a;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: "false"
        }),
        this.props.label && !this.props.hideLabel ? A.createElement(
          "label",
          {
            htmlFor: this.inputId,
            style: i.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]), e;
}(Wl || jl), $z = function(e, n, r, i) {
  var o = i.clientWidth, a = i.clientHeight, s = typeof e.pageX == "number" ? e.pageX : e.touches[0].pageX, l = typeof e.pageY == "number" ? e.pageY : e.touches[0].pageY, c = s - (i.getBoundingClientRect().left + window.pageXOffset), u = l - (i.getBoundingClientRect().top + window.pageYOffset);
  if (n === "vertical") {
    var d = void 0;
    if (u < 0)
      d = 359;
    else if (u > a)
      d = 0;
    else {
      var f = -(u * 100 / a) + 100;
      d = 360 * f / 100;
    }
    if (r.h !== d)
      return {
        h: d,
        s: r.s,
        l: r.l,
        a: r.a,
        source: "hsl"
      };
  } else {
    var h = void 0;
    if (c < 0)
      h = 0;
    else if (c > o)
      h = 359;
    else {
      var v = c * 100 / o;
      h = 360 * v / 100;
    }
    if (r.h !== h)
      return {
        h,
        s: r.s,
        l: r.l,
        a: r.a,
        source: "hsl"
      };
  }
  return null;
}, Wz = function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function jz(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function g3(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function Gz(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var xs = function(t) {
  Gz(e, t);
  function e() {
    var n, r, i, o;
    jz(this, e);
    for (var a = arguments.length, s = Array(a), l = 0; l < a; l++)
      s[l] = arguments[l];
    return o = (r = (i = g3(this, (n = e.__proto__ || Object.getPrototypeOf(e)).call.apply(n, [this].concat(s))), i), i.handleChange = function(c) {
      var u = $z(c, i.props.direction, i.props.hsl, i.container);
      u && typeof i.props.onChange == "function" && i.props.onChange(u, c);
    }, i.handleMouseDown = function(c) {
      i.handleChange(c), window.addEventListener("mousemove", i.handleChange), window.addEventListener("mouseup", i.handleMouseUp);
    }, i.handleMouseUp = function() {
      i.unbindEventListeners();
    }, r), g3(i, o);
  }
  return Wz(e, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props.direction, o = i === void 0 ? "horizontal" : i, a = tt({
        default: {
          hue: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: "0 2px",
            position: "relative",
            height: "100%",
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            left: this.props.hsl.h * 100 / 360 + "%"
          },
          slider: {
            marginTop: "1px",
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          pointer: {
            left: "0px",
            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
          }
        }
      }, { vertical: o === "vertical" });
      return A.createElement(
        "div",
        { style: a.hue },
        A.createElement(
          "div",
          {
            className: "hue-" + o,
            style: a.container,
            ref: function(l) {
              return r.container = l;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          A.createElement(
            "style",
            null,
            `
            .hue-horizontal {
              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0
                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to right, #f00 0%, #ff0
                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }

            .hue-vertical {
              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,
                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,
                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }
          `
          ),
          A.createElement(
            "div",
            { style: a.pointer },
            this.props.pointer ? A.createElement(this.props.pointer, this.props) : A.createElement("div", { style: a.slider })
          )
        )
      );
    }
  }]), e;
}(Wl || jl), sh = { exports: {} }, Ec = { exports: {} }, wt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var y3;
function qz() {
  if (y3)
    return wt;
  y3 = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, a = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, v = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, m = t ? Symbol.for("react.fundamental") : 60117, p = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
  function b(_) {
    if (typeof _ == "object" && _ !== null) {
      var M = _.$$typeof;
      switch (M) {
        case e:
          switch (_ = _.type, _) {
            case l:
            case c:
            case r:
            case o:
            case i:
            case d:
              return _;
            default:
              switch (_ = _ && _.$$typeof, _) {
                case s:
                case u:
                case v:
                case h:
                case a:
                  return _;
                default:
                  return M;
              }
          }
        case n:
          return M;
      }
    }
  }
  function x(_) {
    return b(_) === c;
  }
  return wt.AsyncMode = l, wt.ConcurrentMode = c, wt.ContextConsumer = s, wt.ContextProvider = a, wt.Element = e, wt.ForwardRef = u, wt.Fragment = r, wt.Lazy = v, wt.Memo = h, wt.Portal = n, wt.Profiler = o, wt.StrictMode = i, wt.Suspense = d, wt.isAsyncMode = function(_) {
    return x(_) || b(_) === l;
  }, wt.isConcurrentMode = x, wt.isContextConsumer = function(_) {
    return b(_) === s;
  }, wt.isContextProvider = function(_) {
    return b(_) === a;
  }, wt.isElement = function(_) {
    return typeof _ == "object" && _ !== null && _.$$typeof === e;
  }, wt.isForwardRef = function(_) {
    return b(_) === u;
  }, wt.isFragment = function(_) {
    return b(_) === r;
  }, wt.isLazy = function(_) {
    return b(_) === v;
  }, wt.isMemo = function(_) {
    return b(_) === h;
  }, wt.isPortal = function(_) {
    return b(_) === n;
  }, wt.isProfiler = function(_) {
    return b(_) === o;
  }, wt.isStrictMode = function(_) {
    return b(_) === i;
  }, wt.isSuspense = function(_) {
    return b(_) === d;
  }, wt.isValidElementType = function(_) {
    return typeof _ == "string" || typeof _ == "function" || _ === r || _ === c || _ === o || _ === i || _ === d || _ === f || typeof _ == "object" && _ !== null && (_.$$typeof === v || _.$$typeof === h || _.$$typeof === a || _.$$typeof === s || _.$$typeof === u || _.$$typeof === m || _.$$typeof === p || _.$$typeof === y || _.$$typeof === g);
  }, wt.typeOf = b, wt;
}
var _t = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b3;
function Xz() {
  return b3 || (b3 = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, a = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, v = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, m = t ? Symbol.for("react.fundamental") : 60117, p = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
    function b(ae) {
      return typeof ae == "string" || typeof ae == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ae === r || ae === c || ae === o || ae === i || ae === d || ae === f || typeof ae == "object" && ae !== null && (ae.$$typeof === v || ae.$$typeof === h || ae.$$typeof === a || ae.$$typeof === s || ae.$$typeof === u || ae.$$typeof === m || ae.$$typeof === p || ae.$$typeof === y || ae.$$typeof === g);
    }
    function x(ae) {
      if (typeof ae == "object" && ae !== null) {
        var Re = ae.$$typeof;
        switch (Re) {
          case e:
            var F = ae.type;
            switch (F) {
              case l:
              case c:
              case r:
              case o:
              case i:
              case d:
                return F;
              default:
                var Ge = F && F.$$typeof;
                switch (Ge) {
                  case s:
                  case u:
                  case v:
                  case h:
                  case a:
                    return Ge;
                  default:
                    return Re;
                }
            }
          case n:
            return Re;
        }
      }
    }
    var _ = l, M = c, S = s, P = a, E = e, w = u, O = r, N = v, I = h, H = n, j = o, U = i, $ = d, V = !1;
    function te(ae) {
      return V || (V = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), B(ae) || x(ae) === l;
    }
    function B(ae) {
      return x(ae) === c;
    }
    function Z(ae) {
      return x(ae) === s;
    }
    function Q(ae) {
      return x(ae) === a;
    }
    function ce(ae) {
      return typeof ae == "object" && ae !== null && ae.$$typeof === e;
    }
    function k(ae) {
      return x(ae) === u;
    }
    function G(ae) {
      return x(ae) === r;
    }
    function K(ae) {
      return x(ae) === v;
    }
    function J(ae) {
      return x(ae) === h;
    }
    function se(ae) {
      return x(ae) === n;
    }
    function be(ae) {
      return x(ae) === o;
    }
    function pe(ae) {
      return x(ae) === i;
    }
    function Ne(ae) {
      return x(ae) === d;
    }
    _t.AsyncMode = _, _t.ConcurrentMode = M, _t.ContextConsumer = S, _t.ContextProvider = P, _t.Element = E, _t.ForwardRef = w, _t.Fragment = O, _t.Lazy = N, _t.Memo = I, _t.Portal = H, _t.Profiler = j, _t.StrictMode = U, _t.Suspense = $, _t.isAsyncMode = te, _t.isConcurrentMode = B, _t.isContextConsumer = Z, _t.isContextProvider = Q, _t.isElement = ce, _t.isForwardRef = k, _t.isFragment = G, _t.isLazy = K, _t.isMemo = J, _t.isPortal = se, _t.isProfiler = be, _t.isStrictMode = pe, _t.isSuspense = Ne, _t.isValidElementType = b, _t.typeOf = x;
  }()), _t;
}
var x3;
function z5() {
  return x3 || (x3 = 1, process.env.NODE_ENV === "production" ? Ec.exports = qz() : Ec.exports = Xz()), Ec.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Df, w3;
function Yz() {
  if (w3)
    return Df;
  w3 = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(a).map(function(u) {
        return a[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Df = i() ? Object.assign : function(o, a) {
    for (var s, l = r(o), c, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var d in s)
        e.call(s, d) && (l[d] = s[d]);
      if (t) {
        c = t(s);
        for (var f = 0; f < c.length; f++)
          n.call(s, c[f]) && (l[c[f]] = s[c[f]]);
      }
    }
    return l;
  }, Df;
}
var kf, _3;
function bp() {
  if (_3)
    return kf;
  _3 = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return kf = t, kf;
}
var Nf, C3;
function H5() {
  return C3 || (C3 = 1, Nf = Function.call.bind(Object.prototype.hasOwnProperty)), Nf;
}
var If, E3;
function Zz() {
  if (E3)
    return If;
  E3 = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = bp(), n = {}, r = H5();
    t = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in o)
        if (r(o, u)) {
          var d;
          try {
            if (typeof o[u] != "function") {
              var f = Error(
                (l || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = o[u](a, u, l, s, null, e);
          } catch (v) {
            d = v;
          }
          if (d && !(d instanceof Error) && t(
            (l || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = c ? c() : "";
            t(
              "Failed " + s + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, If = i, If;
}
var Ff, S3;
function Kz() {
  if (S3)
    return Ff;
  S3 = 1;
  var t = z5(), e = Yz(), n = bp(), r = H5(), i = Zz(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Ff = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(B) {
      var Z = B && (c && B[c] || B[u]);
      if (typeof Z == "function")
        return Z;
    }
    var f = "<<anonymous>>", h = {
      array: p("array"),
      bigint: p("bigint"),
      bool: p("boolean"),
      func: p("function"),
      number: p("number"),
      object: p("object"),
      string: p("string"),
      symbol: p("symbol"),
      any: y(),
      arrayOf: b,
      element: x(),
      elementType: _(),
      instanceOf: M,
      node: w(),
      objectOf: P,
      oneOf: S,
      oneOfType: E,
      shape: N,
      exact: I
    };
    function v(B, Z) {
      return B === Z ? B !== 0 || 1 / B === 1 / Z : B !== B && Z !== Z;
    }
    function g(B, Z) {
      this.message = B, this.data = Z && typeof Z == "object" ? Z : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function m(B) {
      if (process.env.NODE_ENV !== "production")
        var Z = {}, Q = 0;
      function ce(G, K, J, se, be, pe, Ne) {
        if (se = se || f, pe = pe || J, Ne !== n) {
          if (l) {
            var ae = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ae.name = "Invariant Violation", ae;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Re = se + ":" + J;
            !Z[Re] && // Avoid spamming the console because they are often not actionable except for lib authors
            Q < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + pe + "` prop on `" + se + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Z[Re] = !0, Q++);
          }
        }
        return K[J] == null ? G ? K[J] === null ? new g("The " + be + " `" + pe + "` is marked as required " + ("in `" + se + "`, but its value is `null`.")) : new g("The " + be + " `" + pe + "` is marked as required in " + ("`" + se + "`, but its value is `undefined`.")) : null : B(K, J, se, be, pe);
      }
      var k = ce.bind(null, !1);
      return k.isRequired = ce.bind(null, !0), k;
    }
    function p(B) {
      function Z(Q, ce, k, G, K, J) {
        var se = Q[ce], be = U(se);
        if (be !== B) {
          var pe = $(se);
          return new g(
            "Invalid " + G + " `" + K + "` of type " + ("`" + pe + "` supplied to `" + k + "`, expected ") + ("`" + B + "`."),
            { expectedType: B }
          );
        }
        return null;
      }
      return m(Z);
    }
    function y() {
      return m(a);
    }
    function b(B) {
      function Z(Q, ce, k, G, K) {
        if (typeof B != "function")
          return new g("Property `" + K + "` of component `" + k + "` has invalid PropType notation inside arrayOf.");
        var J = Q[ce];
        if (!Array.isArray(J)) {
          var se = U(J);
          return new g("Invalid " + G + " `" + K + "` of type " + ("`" + se + "` supplied to `" + k + "`, expected an array."));
        }
        for (var be = 0; be < J.length; be++) {
          var pe = B(J, be, k, G, K + "[" + be + "]", n);
          if (pe instanceof Error)
            return pe;
        }
        return null;
      }
      return m(Z);
    }
    function x() {
      function B(Z, Q, ce, k, G) {
        var K = Z[Q];
        if (!s(K)) {
          var J = U(K);
          return new g("Invalid " + k + " `" + G + "` of type " + ("`" + J + "` supplied to `" + ce + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(B);
    }
    function _() {
      function B(Z, Q, ce, k, G) {
        var K = Z[Q];
        if (!t.isValidElementType(K)) {
          var J = U(K);
          return new g("Invalid " + k + " `" + G + "` of type " + ("`" + J + "` supplied to `" + ce + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(B);
    }
    function M(B) {
      function Z(Q, ce, k, G, K) {
        if (!(Q[ce] instanceof B)) {
          var J = B.name || f, se = te(Q[ce]);
          return new g("Invalid " + G + " `" + K + "` of type " + ("`" + se + "` supplied to `" + k + "`, expected ") + ("instance of `" + J + "`."));
        }
        return null;
      }
      return m(Z);
    }
    function S(B) {
      if (!Array.isArray(B))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function Z(Q, ce, k, G, K) {
        for (var J = Q[ce], se = 0; se < B.length; se++)
          if (v(J, B[se]))
            return null;
        var be = JSON.stringify(B, function(Ne, ae) {
          var Re = $(ae);
          return Re === "symbol" ? String(ae) : ae;
        });
        return new g("Invalid " + G + " `" + K + "` of value `" + String(J) + "` " + ("supplied to `" + k + "`, expected one of " + be + "."));
      }
      return m(Z);
    }
    function P(B) {
      function Z(Q, ce, k, G, K) {
        if (typeof B != "function")
          return new g("Property `" + K + "` of component `" + k + "` has invalid PropType notation inside objectOf.");
        var J = Q[ce], se = U(J);
        if (se !== "object")
          return new g("Invalid " + G + " `" + K + "` of type " + ("`" + se + "` supplied to `" + k + "`, expected an object."));
        for (var be in J)
          if (r(J, be)) {
            var pe = B(J, be, k, G, K + "." + be, n);
            if (pe instanceof Error)
              return pe;
          }
        return null;
      }
      return m(Z);
    }
    function E(B) {
      if (!Array.isArray(B))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var Z = 0; Z < B.length; Z++) {
        var Q = B[Z];
        if (typeof Q != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + V(Q) + " at index " + Z + "."
          ), a;
      }
      function ce(k, G, K, J, se) {
        for (var be = [], pe = 0; pe < B.length; pe++) {
          var Ne = B[pe], ae = Ne(k, G, K, J, se, n);
          if (ae == null)
            return null;
          ae.data && r(ae.data, "expectedType") && be.push(ae.data.expectedType);
        }
        var Re = be.length > 0 ? ", expected one of type [" + be.join(", ") + "]" : "";
        return new g("Invalid " + J + " `" + se + "` supplied to " + ("`" + K + "`" + Re + "."));
      }
      return m(ce);
    }
    function w() {
      function B(Z, Q, ce, k, G) {
        return H(Z[Q]) ? null : new g("Invalid " + k + " `" + G + "` supplied to " + ("`" + ce + "`, expected a ReactNode."));
      }
      return m(B);
    }
    function O(B, Z, Q, ce, k) {
      return new g(
        (B || "React class") + ": " + Z + " type `" + Q + "." + ce + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + k + "`."
      );
    }
    function N(B) {
      function Z(Q, ce, k, G, K) {
        var J = Q[ce], se = U(J);
        if (se !== "object")
          return new g("Invalid " + G + " `" + K + "` of type `" + se + "` " + ("supplied to `" + k + "`, expected `object`."));
        for (var be in B) {
          var pe = B[be];
          if (typeof pe != "function")
            return O(k, G, K, be, $(pe));
          var Ne = pe(J, be, k, G, K + "." + be, n);
          if (Ne)
            return Ne;
        }
        return null;
      }
      return m(Z);
    }
    function I(B) {
      function Z(Q, ce, k, G, K) {
        var J = Q[ce], se = U(J);
        if (se !== "object")
          return new g("Invalid " + G + " `" + K + "` of type `" + se + "` " + ("supplied to `" + k + "`, expected `object`."));
        var be = e({}, Q[ce], B);
        for (var pe in be) {
          var Ne = B[pe];
          if (r(B, pe) && typeof Ne != "function")
            return O(k, G, K, pe, $(Ne));
          if (!Ne)
            return new g(
              "Invalid " + G + " `" + K + "` key `" + pe + "` supplied to `" + k + "`.\nBad object: " + JSON.stringify(Q[ce], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(B), null, "  ")
            );
          var ae = Ne(J, pe, k, G, K + "." + pe, n);
          if (ae)
            return ae;
        }
        return null;
      }
      return m(Z);
    }
    function H(B) {
      switch (typeof B) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !B;
        case "object":
          if (Array.isArray(B))
            return B.every(H);
          if (B === null || s(B))
            return !0;
          var Z = d(B);
          if (Z) {
            var Q = Z.call(B), ce;
            if (Z !== B.entries) {
              for (; !(ce = Q.next()).done; )
                if (!H(ce.value))
                  return !1;
            } else
              for (; !(ce = Q.next()).done; ) {
                var k = ce.value;
                if (k && !H(k[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function j(B, Z) {
      return B === "symbol" ? !0 : Z ? Z["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Z instanceof Symbol : !1;
    }
    function U(B) {
      var Z = typeof B;
      return Array.isArray(B) ? "array" : B instanceof RegExp ? "object" : j(Z, B) ? "symbol" : Z;
    }
    function $(B) {
      if (typeof B > "u" || B === null)
        return "" + B;
      var Z = U(B);
      if (Z === "object") {
        if (B instanceof Date)
          return "date";
        if (B instanceof RegExp)
          return "regexp";
      }
      return Z;
    }
    function V(B) {
      var Z = $(B);
      switch (Z) {
        case "array":
        case "object":
          return "an " + Z;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Z;
        default:
          return Z;
      }
    }
    function te(B) {
      return !B.constructor || !B.constructor.name ? f : B.constructor.name;
    }
    return h.checkPropTypes = i, h.resetWarningCache = i.resetWarningCache, h.PropTypes = h, h;
  }, Ff;
}
var Uf, M3;
function Jz() {
  if (M3)
    return Uf;
  M3 = 1;
  var t = bp();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, Uf = function() {
    function r(a, s, l, c, u, d) {
      if (d !== t) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return o.PropTypes = o, o;
  }, Uf;
}
if (process.env.NODE_ENV !== "production") {
  var Qz = z5(), eH = !0;
  sh.exports = Kz()(Qz.isElement, eH);
} else
  sh.exports = Jz()();
var tH = sh.exports;
const Me = /* @__PURE__ */ q1(tH);
function nH() {
  this.__data__ = [], this.size = 0;
}
function rc(t, e) {
  return t === e || t !== t && e !== e;
}
function Pd(t, e) {
  for (var n = t.length; n--; )
    if (rc(t[n][0], e))
      return n;
  return -1;
}
var rH = Array.prototype, iH = rH.splice;
function oH(t) {
  var e = this.__data__, n = Pd(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : iH.call(e, n, 1), --this.size, !0;
}
function aH(t) {
  var e = this.__data__, n = Pd(e, t);
  return n < 0 ? void 0 : e[n][1];
}
function sH(t) {
  return Pd(this.__data__, t) > -1;
}
function lH(t, e) {
  var n = this.__data__, r = Pd(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
function pi(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
pi.prototype.clear = nH;
pi.prototype.delete = oH;
pi.prototype.get = aH;
pi.prototype.has = sH;
pi.prototype.set = lH;
function cH() {
  this.__data__ = new pi(), this.size = 0;
}
function uH(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
function dH(t) {
  return this.__data__.get(t);
}
function fH(t) {
  return this.__data__.has(t);
}
var hH = typeof global == "object" && global && global.Object === Object && global;
const B5 = hH;
var pH = typeof self == "object" && self && self.Object === Object && self, mH = B5 || pH || Function("return this")();
const Tr = mH;
var vH = Tr.Symbol;
const qi = vH;
var V5 = Object.prototype, gH = V5.hasOwnProperty, yH = V5.toString, Bs = qi ? qi.toStringTag : void 0;
function bH(t) {
  var e = gH.call(t, Bs), n = t[Bs];
  try {
    t[Bs] = void 0;
    var r = !0;
  } catch {
  }
  var i = yH.call(t);
  return r && (e ? t[Bs] = n : delete t[Bs]), i;
}
var xH = Object.prototype, wH = xH.toString;
function _H(t) {
  return wH.call(t);
}
var CH = "[object Null]", EH = "[object Undefined]", T3 = qi ? qi.toStringTag : void 0;
function Go(t) {
  return t == null ? t === void 0 ? EH : CH : T3 && T3 in Object(t) ? bH(t) : _H(t);
}
function ar(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var SH = "[object AsyncFunction]", MH = "[object Function]", TH = "[object GeneratorFunction]", AH = "[object Proxy]";
function xp(t) {
  if (!ar(t))
    return !1;
  var e = Go(t);
  return e == MH || e == TH || e == SH || e == AH;
}
var PH = Tr["__core-js_shared__"];
const zf = PH;
var A3 = function() {
  var t = /[^.]+$/.exec(zf && zf.keys && zf.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function RH(t) {
  return !!A3 && A3 in t;
}
var LH = Function.prototype, OH = LH.toString;
function qo(t) {
  if (t != null) {
    try {
      return OH.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var DH = /[\\^$.*+?()[\]{}|]/g, kH = /^\[object .+?Constructor\]$/, NH = Function.prototype, IH = Object.prototype, FH = NH.toString, UH = IH.hasOwnProperty, zH = RegExp(
  "^" + FH.call(UH).replace(DH, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function HH(t) {
  if (!ar(t) || RH(t))
    return !1;
  var e = xp(t) ? zH : kH;
  return e.test(qo(t));
}
function BH(t, e) {
  return t == null ? void 0 : t[e];
}
function Xo(t, e) {
  var n = BH(t, e);
  return HH(n) ? n : void 0;
}
var VH = Xo(Tr, "Map");
const Rl = VH;
var $H = Xo(Object, "create");
const Ll = $H;
function WH() {
  this.__data__ = Ll ? Ll(null) : {}, this.size = 0;
}
function jH(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var GH = "__lodash_hash_undefined__", qH = Object.prototype, XH = qH.hasOwnProperty;
function YH(t) {
  var e = this.__data__;
  if (Ll) {
    var n = e[t];
    return n === GH ? void 0 : n;
  }
  return XH.call(e, t) ? e[t] : void 0;
}
var ZH = Object.prototype, KH = ZH.hasOwnProperty;
function JH(t) {
  var e = this.__data__;
  return Ll ? e[t] !== void 0 : KH.call(e, t);
}
var QH = "__lodash_hash_undefined__";
function eB(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = Ll && e === void 0 ? QH : e, this;
}
function Oo(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Oo.prototype.clear = WH;
Oo.prototype.delete = jH;
Oo.prototype.get = YH;
Oo.prototype.has = JH;
Oo.prototype.set = eB;
function tB() {
  this.size = 0, this.__data__ = {
    hash: new Oo(),
    map: new (Rl || pi)(),
    string: new Oo()
  };
}
function nB(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function Rd(t, e) {
  var n = t.__data__;
  return nB(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
function rB(t) {
  var e = Rd(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
function iB(t) {
  return Rd(this, t).get(t);
}
function oB(t) {
  return Rd(this, t).has(t);
}
function aB(t, e) {
  var n = Rd(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
function mi(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
mi.prototype.clear = tB;
mi.prototype.delete = rB;
mi.prototype.get = iB;
mi.prototype.has = oB;
mi.prototype.set = aB;
var sB = 200;
function lB(t, e) {
  var n = this.__data__;
  if (n instanceof pi) {
    var r = n.__data__;
    if (!Rl || r.length < sB - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new mi(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
function zr(t) {
  var e = this.__data__ = new pi(t);
  this.size = e.size;
}
zr.prototype.clear = cH;
zr.prototype.delete = uH;
zr.prototype.get = dH;
zr.prototype.has = fH;
zr.prototype.set = lB;
var cB = function() {
  try {
    var t = Xo(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}();
const Iu = cB;
function wp(t, e, n) {
  e == "__proto__" && Iu ? Iu(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
function lh(t, e, n) {
  (n !== void 0 && !rc(t[e], n) || n === void 0 && !(e in t)) && wp(t, e, n);
}
function uB(t) {
  return function(e, n, r) {
    for (var i = -1, o = Object(e), a = r(e), s = a.length; s--; ) {
      var l = a[t ? s : ++i];
      if (n(o[l], l, o) === !1)
        break;
    }
    return e;
  };
}
var dB = uB();
const $5 = dB;
var W5 = typeof exports == "object" && exports && !exports.nodeType && exports, P3 = W5 && typeof module == "object" && module && !module.nodeType && module, fB = P3 && P3.exports === W5, R3 = fB ? Tr.Buffer : void 0, L3 = R3 ? R3.allocUnsafe : void 0;
function hB(t, e) {
  if (e)
    return t.slice();
  var n = t.length, r = L3 ? L3(n) : new t.constructor(n);
  return t.copy(r), r;
}
var pB = Tr.Uint8Array;
const Fu = pB;
function mB(t) {
  var e = new t.constructor(t.byteLength);
  return new Fu(e).set(new Fu(t)), e;
}
function vB(t, e) {
  var n = e ? mB(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.length);
}
function gB(t, e) {
  var n = -1, r = t.length;
  for (e || (e = Array(r)); ++n < r; )
    e[n] = t[n];
  return e;
}
var O3 = Object.create, yB = function() {
  function t() {
  }
  return function(e) {
    if (!ar(e))
      return {};
    if (O3)
      return O3(e);
    t.prototype = e;
    var n = new t();
    return t.prototype = void 0, n;
  };
}();
const bB = yB;
function j5(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var xB = j5(Object.getPrototypeOf, Object);
const G5 = xB;
var wB = Object.prototype;
function _p(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || wB;
  return t === n;
}
function _B(t) {
  return typeof t.constructor == "function" && !_p(t) ? bB(G5(t)) : {};
}
function Xi(t) {
  return t != null && typeof t == "object";
}
var CB = "[object Arguments]";
function D3(t) {
  return Xi(t) && Go(t) == CB;
}
var q5 = Object.prototype, EB = q5.hasOwnProperty, SB = q5.propertyIsEnumerable, MB = D3(function() {
  return arguments;
}()) ? D3 : function(t) {
  return Xi(t) && EB.call(t, "callee") && !SB.call(t, "callee");
};
const Uu = MB;
var TB = Array.isArray;
const Xn = TB;
var AB = 9007199254740991;
function Cp(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= AB;
}
function ws(t) {
  return t != null && Cp(t.length) && !xp(t);
}
function PB(t) {
  return Xi(t) && ws(t);
}
function RB() {
  return !1;
}
var X5 = typeof exports == "object" && exports && !exports.nodeType && exports, k3 = X5 && typeof module == "object" && module && !module.nodeType && module, LB = k3 && k3.exports === X5, N3 = LB ? Tr.Buffer : void 0, OB = N3 ? N3.isBuffer : void 0, DB = OB || RB;
const zu = DB;
var kB = "[object Object]", NB = Function.prototype, IB = Object.prototype, Y5 = NB.toString, FB = IB.hasOwnProperty, UB = Y5.call(Object);
function zB(t) {
  if (!Xi(t) || Go(t) != kB)
    return !1;
  var e = G5(t);
  if (e === null)
    return !0;
  var n = FB.call(e, "constructor") && e.constructor;
  return typeof n == "function" && n instanceof n && Y5.call(n) == UB;
}
var HB = "[object Arguments]", BB = "[object Array]", VB = "[object Boolean]", $B = "[object Date]", WB = "[object Error]", jB = "[object Function]", GB = "[object Map]", qB = "[object Number]", XB = "[object Object]", YB = "[object RegExp]", ZB = "[object Set]", KB = "[object String]", JB = "[object WeakMap]", QB = "[object ArrayBuffer]", eV = "[object DataView]", tV = "[object Float32Array]", nV = "[object Float64Array]", rV = "[object Int8Array]", iV = "[object Int16Array]", oV = "[object Int32Array]", aV = "[object Uint8Array]", sV = "[object Uint8ClampedArray]", lV = "[object Uint16Array]", cV = "[object Uint32Array]", Ut = {};
Ut[tV] = Ut[nV] = Ut[rV] = Ut[iV] = Ut[oV] = Ut[aV] = Ut[sV] = Ut[lV] = Ut[cV] = !0;
Ut[HB] = Ut[BB] = Ut[QB] = Ut[VB] = Ut[eV] = Ut[$B] = Ut[WB] = Ut[jB] = Ut[GB] = Ut[qB] = Ut[XB] = Ut[YB] = Ut[ZB] = Ut[KB] = Ut[JB] = !1;
function uV(t) {
  return Xi(t) && Cp(t.length) && !!Ut[Go(t)];
}
function dV(t) {
  return function(e) {
    return t(e);
  };
}
var Z5 = typeof exports == "object" && exports && !exports.nodeType && exports, fl = Z5 && typeof module == "object" && module && !module.nodeType && module, fV = fl && fl.exports === Z5, Hf = fV && B5.process, hV = function() {
  try {
    var t = fl && fl.require && fl.require("util").types;
    return t || Hf && Hf.binding && Hf.binding("util");
  } catch {
  }
}();
const I3 = hV;
var F3 = I3 && I3.isTypedArray, pV = F3 ? dV(F3) : uV;
const Ep = pV;
function ch(t, e) {
  if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
    return t[e];
}
var mV = Object.prototype, vV = mV.hasOwnProperty;
function gV(t, e, n) {
  var r = t[e];
  (!(vV.call(t, e) && rc(r, n)) || n === void 0 && !(e in t)) && wp(t, e, n);
}
function yV(t, e, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, a = e.length; ++o < a; ) {
    var s = e[o], l = r ? r(n[s], t[s], s, n, t) : void 0;
    l === void 0 && (l = t[s]), i ? wp(n, s, l) : gV(n, s, l);
  }
  return n;
}
function bV(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var xV = 9007199254740991, wV = /^(?:0|[1-9]\d*)$/;
function Sp(t, e) {
  var n = typeof t;
  return e = e ?? xV, !!e && (n == "number" || n != "symbol" && wV.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var _V = Object.prototype, CV = _V.hasOwnProperty;
function K5(t, e) {
  var n = Xn(t), r = !n && Uu(t), i = !n && !r && zu(t), o = !n && !r && !i && Ep(t), a = n || r || i || o, s = a ? bV(t.length, String) : [], l = s.length;
  for (var c in t)
    (e || CV.call(t, c)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Sp(c, l))) && s.push(c);
  return s;
}
function EV(t) {
  var e = [];
  if (t != null)
    for (var n in Object(t))
      e.push(n);
  return e;
}
var SV = Object.prototype, MV = SV.hasOwnProperty;
function TV(t) {
  if (!ar(t))
    return EV(t);
  var e = _p(t), n = [];
  for (var r in t)
    r == "constructor" && (e || !MV.call(t, r)) || n.push(r);
  return n;
}
function J5(t) {
  return ws(t) ? K5(t, !0) : TV(t);
}
function AV(t) {
  return yV(t, J5(t));
}
function PV(t, e, n, r, i, o, a) {
  var s = ch(t, n), l = ch(e, n), c = a.get(l);
  if (c) {
    lh(t, n, c);
    return;
  }
  var u = o ? o(s, l, n + "", t, e, a) : void 0, d = u === void 0;
  if (d) {
    var f = Xn(l), h = !f && zu(l), v = !f && !h && Ep(l);
    u = l, f || h || v ? Xn(s) ? u = s : PB(s) ? u = gB(s) : h ? (d = !1, u = hB(l, !0)) : v ? (d = !1, u = vB(l, !0)) : u = [] : zB(l) || Uu(l) ? (u = s, Uu(s) ? u = AV(s) : (!ar(s) || xp(s)) && (u = _B(l))) : d = !1;
  }
  d && (a.set(l, u), i(u, l, r, o, a), a.delete(l)), lh(t, n, u);
}
function Q5(t, e, n, r, i) {
  t !== e && $5(e, function(o, a) {
    if (i || (i = new zr()), ar(o))
      PV(t, e, a, n, Q5, r, i);
    else {
      var s = r ? r(ch(t, a), o, a + "", t, e, i) : void 0;
      s === void 0 && (s = o), lh(t, a, s);
    }
  }, J5);
}
function Ld(t) {
  return t;
}
function RV(t, e, n) {
  switch (n.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, n[0]);
    case 2:
      return t.call(e, n[0], n[1]);
    case 3:
      return t.call(e, n[0], n[1], n[2]);
  }
  return t.apply(e, n);
}
var U3 = Math.max;
function LV(t, e, n) {
  return e = U3(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var r = arguments, i = -1, o = U3(r.length - e, 0), a = Array(o); ++i < o; )
      a[i] = r[e + i];
    i = -1;
    for (var s = Array(e + 1); ++i < e; )
      s[i] = r[i];
    return s[e] = n(a), RV(t, this, s);
  };
}
function OV(t) {
  return function() {
    return t;
  };
}
var DV = Iu ? function(t, e) {
  return Iu(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: OV(e),
    writable: !0
  });
} : Ld;
const kV = DV;
var NV = 800, IV = 16, FV = Date.now;
function UV(t) {
  var e = 0, n = 0;
  return function() {
    var r = FV(), i = IV - (r - n);
    if (n = r, i > 0) {
      if (++e >= NV)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
var zV = UV(kV);
const HV = zV;
function BV(t, e) {
  return HV(LV(t, e, Ld), t + "");
}
function VV(t, e, n) {
  if (!ar(n))
    return !1;
  var r = typeof e;
  return (r == "number" ? ws(n) && Sp(e, n.length) : r == "string" && e in n) ? rc(n[e], t) : !1;
}
function $V(t) {
  return BV(function(e, n) {
    var r = -1, i = n.length, o = i > 1 ? n[i - 1] : void 0, a = i > 2 ? n[2] : void 0;
    for (o = t.length > 3 && typeof o == "function" ? (i--, o) : void 0, a && VV(n[0], n[1], a) && (o = i < 3 ? void 0 : o, i = 1), e = Object(e); ++r < i; ) {
      var s = n[r];
      s && t(e, s, r, o);
    }
    return e;
  });
}
var WV = $V(function(t, e, n) {
  Q5(t, e, n);
});
const kn = WV;
var ic = function(e) {
  var n = e.zDepth, r = e.radius, i = e.background, o = e.children, a = e.styles, s = a === void 0 ? {} : a, l = tt(kn({
    default: {
      wrap: {
        position: "relative",
        display: "inline-block"
      },
      content: {
        position: "relative"
      },
      bg: {
        absolute: "0px 0px 0px 0px",
        boxShadow: "0 " + n + "px " + n * 4 + "px rgba(0,0,0,.24)",
        borderRadius: r,
        background: i
      }
    },
    "zDepth-0": {
      bg: {
        boxShadow: "none"
      }
    },
    "zDepth-1": {
      bg: {
        boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
      }
    },
    "zDepth-2": {
      bg: {
        boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
      }
    },
    "zDepth-3": {
      bg: {
        boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
      }
    },
    "zDepth-4": {
      bg: {
        boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
      }
    },
    "zDepth-5": {
      bg: {
        boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
      }
    },
    square: {
      bg: {
        borderRadius: "0"
      }
    },
    circle: {
      bg: {
        borderRadius: "50%"
      }
    }
  }, s), { "zDepth-1": n === 1 });
  return A.createElement(
    "div",
    { style: l.wrap },
    A.createElement("div", { style: l.bg }),
    A.createElement(
      "div",
      { style: l.content },
      o
    )
  );
};
ic.propTypes = {
  background: Me.string,
  zDepth: Me.oneOf([0, 1, 2, 3, 4, 5]),
  radius: Me.number,
  styles: Me.object
};
ic.defaultProps = {
  background: "#fff",
  zDepth: 1,
  radius: 2,
  styles: {}
};
var jV = function() {
  return Tr.Date.now();
};
const Bf = jV;
var GV = /\s/;
function qV(t) {
  for (var e = t.length; e-- && GV.test(t.charAt(e)); )
    ;
  return e;
}
var XV = /^\s+/;
function YV(t) {
  return t && t.slice(0, qV(t) + 1).replace(XV, "");
}
var ZV = "[object Symbol]";
function Od(t) {
  return typeof t == "symbol" || Xi(t) && Go(t) == ZV;
}
var z3 = 0 / 0, KV = /^[-+]0x[0-9a-f]+$/i, JV = /^0b[01]+$/i, QV = /^0o[0-7]+$/i, e$ = parseInt;
function H3(t) {
  if (typeof t == "number")
    return t;
  if (Od(t))
    return z3;
  if (ar(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = ar(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = YV(t);
  var n = JV.test(t);
  return n || QV.test(t) ? e$(t.slice(2), n ? 2 : 8) : KV.test(t) ? z3 : +t;
}
var t$ = "Expected a function", n$ = Math.max, r$ = Math.min;
function e8(t, e, n) {
  var r, i, o, a, s, l, c = 0, u = !1, d = !1, f = !0;
  if (typeof t != "function")
    throw new TypeError(t$);
  e = H3(e) || 0, ar(n) && (u = !!n.leading, d = "maxWait" in n, o = d ? n$(H3(n.maxWait) || 0, e) : o, f = "trailing" in n ? !!n.trailing : f);
  function h(M) {
    var S = r, P = i;
    return r = i = void 0, c = M, a = t.apply(P, S), a;
  }
  function v(M) {
    return c = M, s = setTimeout(p, e), u ? h(M) : a;
  }
  function g(M) {
    var S = M - l, P = M - c, E = e - S;
    return d ? r$(E, o - P) : E;
  }
  function m(M) {
    var S = M - l, P = M - c;
    return l === void 0 || S >= e || S < 0 || d && P >= o;
  }
  function p() {
    var M = Bf();
    if (m(M))
      return y(M);
    s = setTimeout(p, g(M));
  }
  function y(M) {
    return s = void 0, f && r ? h(M) : (r = i = void 0, a);
  }
  function b() {
    s !== void 0 && clearTimeout(s), c = 0, r = l = i = s = void 0;
  }
  function x() {
    return s === void 0 ? a : y(Bf());
  }
  function _() {
    var M = Bf(), S = m(M);
    if (r = arguments, i = this, l = M, S) {
      if (s === void 0)
        return v(l);
      if (d)
        return clearTimeout(s), s = setTimeout(p, e), h(l);
    }
    return s === void 0 && (s = setTimeout(p, e)), a;
  }
  return _.cancel = b, _.flush = x, _;
}
var i$ = "Expected a function";
function o$(t, e, n) {
  var r = !0, i = !0;
  if (typeof t != "function")
    throw new TypeError(i$);
  return ar(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), e8(t, e, {
    leading: r,
    maxWait: e,
    trailing: i
  });
}
var a$ = function(e, n, r) {
  var i = r.getBoundingClientRect(), o = i.width, a = i.height, s = typeof e.pageX == "number" ? e.pageX : e.touches[0].pageX, l = typeof e.pageY == "number" ? e.pageY : e.touches[0].pageY, c = s - (r.getBoundingClientRect().left + window.pageXOffset), u = l - (r.getBoundingClientRect().top + window.pageYOffset);
  c < 0 ? c = 0 : c > o && (c = o), u < 0 ? u = 0 : u > a && (u = a);
  var d = c / o, f = 1 - u / a;
  return {
    h: n.h,
    s: d,
    v: f,
    a: n.a,
    source: "hsv"
  };
}, s$ = function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function l$(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function c$(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function u$(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var Dd = function(t) {
  u$(e, t);
  function e(n) {
    l$(this, e);
    var r = c$(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, n));
    return r.handleChange = function(i) {
      typeof r.props.onChange == "function" && r.throttle(r.props.onChange, a$(i, r.props.hsl, r.container), i);
    }, r.handleMouseDown = function(i) {
      r.handleChange(i);
      var o = r.getContainerRenderWindow();
      o.addEventListener("mousemove", r.handleChange), o.addEventListener("mouseup", r.handleMouseUp);
    }, r.handleMouseUp = function() {
      r.unbindEventListeners();
    }, r.throttle = o$(function(i, o, a) {
      i(o, a);
    }, 50), r;
  }
  return s$(e, [{
    key: "componentWillUnmount",
    value: function() {
      this.throttle.cancel(), this.unbindEventListeners();
    }
  }, {
    key: "getContainerRenderWindow",
    value: function() {
      for (var r = this.container, i = window; !i.document.contains(r) && i.parent !== i; )
        i = i.parent;
      return i;
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      var r = this.getContainerRenderWindow();
      r.removeEventListener("mousemove", this.handleChange), r.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props.style || {}, o = i.color, a = i.white, s = i.black, l = i.pointer, c = i.circle, u = tt({
        default: {
          color: {
            absolute: "0px 0px 0px 0px",
            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
            borderRadius: this.props.radius
          },
          white: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          black: {
            absolute: "0px 0px 0px 0px",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            top: -(this.props.hsv.v * 100) + 100 + "%",
            left: this.props.hsv.s * 100 + "%",
            cursor: "default"
          },
          circle: {
            width: "4px",
            height: "4px",
            boxShadow: `0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),
            0 0 1px 2px rgba(0,0,0,.4)`,
            borderRadius: "50%",
            cursor: "hand",
            transform: "translate(-2px, -2px)"
          }
        },
        custom: {
          color: o,
          white: a,
          black: s,
          pointer: l,
          circle: c
        }
      }, { custom: !!this.props.style });
      return A.createElement(
        "div",
        {
          style: u.color,
          ref: function(f) {
            return r.container = f;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        A.createElement(
          "style",
          null,
          `
          .saturation-white {
            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));
            background: linear-gradient(to right, #fff, rgba(255,255,255,0));
          }
          .saturation-black {
            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));
            background: linear-gradient(to top, #000, rgba(0,0,0,0));
          }
        `
        ),
        A.createElement(
          "div",
          { style: u.white, className: "saturation-white" },
          A.createElement("div", { style: u.black, className: "saturation-black" }),
          A.createElement(
            "div",
            { style: u.pointer },
            this.props.pointer ? A.createElement(this.props.pointer, this.props) : A.createElement("div", { style: u.circle })
          )
        )
      );
    }
  }]), e;
}(Wl || jl);
function d$(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r && e(t[n], n, t) !== !1; )
    ;
  return t;
}
var f$ = j5(Object.keys, Object);
const h$ = f$;
var p$ = Object.prototype, m$ = p$.hasOwnProperty;
function v$(t) {
  if (!_p(t))
    return h$(t);
  var e = [];
  for (var n in Object(t))
    m$.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
function Mp(t) {
  return ws(t) ? K5(t) : v$(t);
}
function g$(t, e) {
  return t && $5(t, e, Mp);
}
function y$(t, e) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!ws(n))
      return t(n, r);
    for (var i = n.length, o = e ? i : -1, a = Object(n); (e ? o-- : ++o < i) && r(a[o], o, a) !== !1; )
      ;
    return n;
  };
}
var b$ = y$(g$);
const t8 = b$;
function x$(t) {
  return typeof t == "function" ? t : Ld;
}
function w$(t, e) {
  var n = Xn(t) ? d$ : t8;
  return n(t, x$(e));
}
function Hu(t) {
  "@babel/helpers - typeof";
  return Hu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Hu(t);
}
var _$ = /^\s+/, C$ = /\s+$/;
function He(t, e) {
  if (t = t || "", e = e || {}, t instanceof He)
    return t;
  if (!(this instanceof He))
    return new He(t, e);
  var n = E$(t);
  this._originalInput = t, this._r = n.r, this._g = n.g, this._b = n.b, this._a = n.a, this._roundA = Math.round(100 * this._a) / 100, this._format = e.format || n.format, this._gradientType = e.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = n.ok;
}
He.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var e = this.toRgb();
    return (e.r * 299 + e.g * 587 + e.b * 114) / 1e3;
  },
  getLuminance: function() {
    var e = this.toRgb(), n, r, i, o, a, s;
    return n = e.r / 255, r = e.g / 255, i = e.b / 255, n <= 0.03928 ? o = n / 12.92 : o = Math.pow((n + 0.055) / 1.055, 2.4), r <= 0.03928 ? a = r / 12.92 : a = Math.pow((r + 0.055) / 1.055, 2.4), i <= 0.03928 ? s = i / 12.92 : s = Math.pow((i + 0.055) / 1.055, 2.4), 0.2126 * o + 0.7152 * a + 0.0722 * s;
  },
  setAlpha: function(e) {
    return this._a = n8(e), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var e = V3(this._r, this._g, this._b);
    return {
      h: e.h * 360,
      s: e.s,
      v: e.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var e = V3(this._r, this._g, this._b), n = Math.round(e.h * 360), r = Math.round(e.s * 100), i = Math.round(e.v * 100);
    return this._a == 1 ? "hsv(" + n + ", " + r + "%, " + i + "%)" : "hsva(" + n + ", " + r + "%, " + i + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var e = B3(this._r, this._g, this._b);
    return {
      h: e.h * 360,
      s: e.s,
      l: e.l,
      a: this._a
    };
  },
  toHslString: function() {
    var e = B3(this._r, this._g, this._b), n = Math.round(e.h * 360), r = Math.round(e.s * 100), i = Math.round(e.l * 100);
    return this._a == 1 ? "hsl(" + n + ", " + r + "%, " + i + "%)" : "hsla(" + n + ", " + r + "%, " + i + "%, " + this._roundA + ")";
  },
  toHex: function(e) {
    return $3(this._r, this._g, this._b, e);
  },
  toHexString: function(e) {
    return "#" + this.toHex(e);
  },
  toHex8: function(e) {
    return A$(this._r, this._g, this._b, this._a, e);
  },
  toHex8String: function(e) {
    return "#" + this.toHex8(e);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(Vt(this._r, 255) * 100) + "%",
      g: Math.round(Vt(this._g, 255) * 100) + "%",
      b: Math.round(Vt(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(Vt(this._r, 255) * 100) + "%, " + Math.round(Vt(this._g, 255) * 100) + "%, " + Math.round(Vt(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(Vt(this._r, 255) * 100) + "%, " + Math.round(Vt(this._g, 255) * 100) + "%, " + Math.round(Vt(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : H$[$3(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(e) {
    var n = "#" + W3(this._r, this._g, this._b, this._a), r = n, i = this._gradientType ? "GradientType = 1, " : "";
    if (e) {
      var o = He(e);
      r = "#" + W3(o._r, o._g, o._b, o._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + i + "startColorstr=" + n + ",endColorstr=" + r + ")";
  },
  toString: function(e) {
    var n = !!e;
    e = e || this._format;
    var r = !1, i = this._a < 1 && this._a >= 0, o = !n && i && (e === "hex" || e === "hex6" || e === "hex3" || e === "hex4" || e === "hex8" || e === "name");
    return o ? e === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (e === "rgb" && (r = this.toRgbString()), e === "prgb" && (r = this.toPercentageRgbString()), (e === "hex" || e === "hex6") && (r = this.toHexString()), e === "hex3" && (r = this.toHexString(!0)), e === "hex4" && (r = this.toHex8String(!0)), e === "hex8" && (r = this.toHex8String()), e === "name" && (r = this.toName()), e === "hsl" && (r = this.toHslString()), e === "hsv" && (r = this.toHsvString()), r || this.toHexString());
  },
  clone: function() {
    return He(this.toString());
  },
  _applyModification: function(e, n) {
    var r = e.apply(null, [this].concat([].slice.call(n)));
    return this._r = r._r, this._g = r._g, this._b = r._b, this.setAlpha(r._a), this;
  },
  lighten: function() {
    return this._applyModification(O$, arguments);
  },
  brighten: function() {
    return this._applyModification(D$, arguments);
  },
  darken: function() {
    return this._applyModification(k$, arguments);
  },
  desaturate: function() {
    return this._applyModification(P$, arguments);
  },
  saturate: function() {
    return this._applyModification(R$, arguments);
  },
  greyscale: function() {
    return this._applyModification(L$, arguments);
  },
  spin: function() {
    return this._applyModification(N$, arguments);
  },
  _applyCombination: function(e, n) {
    return e.apply(null, [this].concat([].slice.call(n)));
  },
  analogous: function() {
    return this._applyCombination(U$, arguments);
  },
  complement: function() {
    return this._applyCombination(I$, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(z$, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(F$, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(j3, [3]);
  },
  tetrad: function() {
    return this._applyCombination(j3, [4]);
  }
};
He.fromRatio = function(t, e) {
  if (Hu(t) == "object") {
    var n = {};
    for (var r in t)
      t.hasOwnProperty(r) && (r === "a" ? n[r] = t[r] : n[r] = rl(t[r]));
    t = n;
  }
  return He(t, e);
};
function E$(t) {
  var e = {
    r: 0,
    g: 0,
    b: 0
  }, n = 1, r = null, i = null, o = null, a = !1, s = !1;
  return typeof t == "string" && (t = W$(t)), Hu(t) == "object" && (jr(t.r) && jr(t.g) && jr(t.b) ? (e = S$(t.r, t.g, t.b), a = !0, s = String(t.r).substr(-1) === "%" ? "prgb" : "rgb") : jr(t.h) && jr(t.s) && jr(t.v) ? (r = rl(t.s), i = rl(t.v), e = T$(t.h, r, i), a = !0, s = "hsv") : jr(t.h) && jr(t.s) && jr(t.l) && (r = rl(t.s), o = rl(t.l), e = M$(t.h, r, o), a = !0, s = "hsl"), t.hasOwnProperty("a") && (n = t.a)), n = n8(n), {
    ok: a,
    format: t.format || s,
    r: Math.min(255, Math.max(e.r, 0)),
    g: Math.min(255, Math.max(e.g, 0)),
    b: Math.min(255, Math.max(e.b, 0)),
    a: n
  };
}
function S$(t, e, n) {
  return {
    r: Vt(t, 255) * 255,
    g: Vt(e, 255) * 255,
    b: Vt(n, 255) * 255
  };
}
function B3(t, e, n) {
  t = Vt(t, 255), e = Vt(e, 255), n = Vt(n, 255);
  var r = Math.max(t, e, n), i = Math.min(t, e, n), o, a, s = (r + i) / 2;
  if (r == i)
    o = a = 0;
  else {
    var l = r - i;
    switch (a = s > 0.5 ? l / (2 - r - i) : l / (r + i), r) {
      case t:
        o = (e - n) / l + (e < n ? 6 : 0);
        break;
      case e:
        o = (n - t) / l + 2;
        break;
      case n:
        o = (t - e) / l + 4;
        break;
    }
    o /= 6;
  }
  return {
    h: o,
    s: a,
    l: s
  };
}
function M$(t, e, n) {
  var r, i, o;
  t = Vt(t, 360), e = Vt(e, 100), n = Vt(n, 100);
  function a(c, u, d) {
    return d < 0 && (d += 1), d > 1 && (d -= 1), d < 1 / 6 ? c + (u - c) * 6 * d : d < 1 / 2 ? u : d < 2 / 3 ? c + (u - c) * (2 / 3 - d) * 6 : c;
  }
  if (e === 0)
    r = i = o = n;
  else {
    var s = n < 0.5 ? n * (1 + e) : n + e - n * e, l = 2 * n - s;
    r = a(l, s, t + 1 / 3), i = a(l, s, t), o = a(l, s, t - 1 / 3);
  }
  return {
    r: r * 255,
    g: i * 255,
    b: o * 255
  };
}
function V3(t, e, n) {
  t = Vt(t, 255), e = Vt(e, 255), n = Vt(n, 255);
  var r = Math.max(t, e, n), i = Math.min(t, e, n), o, a, s = r, l = r - i;
  if (a = r === 0 ? 0 : l / r, r == i)
    o = 0;
  else {
    switch (r) {
      case t:
        o = (e - n) / l + (e < n ? 6 : 0);
        break;
      case e:
        o = (n - t) / l + 2;
        break;
      case n:
        o = (t - e) / l + 4;
        break;
    }
    o /= 6;
  }
  return {
    h: o,
    s: a,
    v: s
  };
}
function T$(t, e, n) {
  t = Vt(t, 360) * 6, e = Vt(e, 100), n = Vt(n, 100);
  var r = Math.floor(t), i = t - r, o = n * (1 - e), a = n * (1 - i * e), s = n * (1 - (1 - i) * e), l = r % 6, c = [n, a, o, o, s, n][l], u = [s, n, n, a, o, o][l], d = [o, o, s, n, n, a][l];
  return {
    r: c * 255,
    g: u * 255,
    b: d * 255
  };
}
function $3(t, e, n, r) {
  var i = [gr(Math.round(t).toString(16)), gr(Math.round(e).toString(16)), gr(Math.round(n).toString(16))];
  return r && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function A$(t, e, n, r, i) {
  var o = [gr(Math.round(t).toString(16)), gr(Math.round(e).toString(16)), gr(Math.round(n).toString(16)), gr(r8(r))];
  return i && o[0].charAt(0) == o[0].charAt(1) && o[1].charAt(0) == o[1].charAt(1) && o[2].charAt(0) == o[2].charAt(1) && o[3].charAt(0) == o[3].charAt(1) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) + o[3].charAt(0) : o.join("");
}
function W3(t, e, n, r) {
  var i = [gr(r8(r)), gr(Math.round(t).toString(16)), gr(Math.round(e).toString(16)), gr(Math.round(n).toString(16))];
  return i.join("");
}
He.equals = function(t, e) {
  return !t || !e ? !1 : He(t).toRgbString() == He(e).toRgbString();
};
He.random = function() {
  return He.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function P$(t, e) {
  e = e === 0 ? 0 : e || 10;
  var n = He(t).toHsl();
  return n.s -= e / 100, n.s = kd(n.s), He(n);
}
function R$(t, e) {
  e = e === 0 ? 0 : e || 10;
  var n = He(t).toHsl();
  return n.s += e / 100, n.s = kd(n.s), He(n);
}
function L$(t) {
  return He(t).desaturate(100);
}
function O$(t, e) {
  e = e === 0 ? 0 : e || 10;
  var n = He(t).toHsl();
  return n.l += e / 100, n.l = kd(n.l), He(n);
}
function D$(t, e) {
  e = e === 0 ? 0 : e || 10;
  var n = He(t).toRgb();
  return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(e / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(e / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(e / 100)))), He(n);
}
function k$(t, e) {
  e = e === 0 ? 0 : e || 10;
  var n = He(t).toHsl();
  return n.l -= e / 100, n.l = kd(n.l), He(n);
}
function N$(t, e) {
  var n = He(t).toHsl(), r = (n.h + e) % 360;
  return n.h = r < 0 ? 360 + r : r, He(n);
}
function I$(t) {
  var e = He(t).toHsl();
  return e.h = (e.h + 180) % 360, He(e);
}
function j3(t, e) {
  if (isNaN(e) || e <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var n = He(t).toHsl(), r = [He(t)], i = 360 / e, o = 1; o < e; o++)
    r.push(He({
      h: (n.h + o * i) % 360,
      s: n.s,
      l: n.l
    }));
  return r;
}
function F$(t) {
  var e = He(t).toHsl(), n = e.h;
  return [He(t), He({
    h: (n + 72) % 360,
    s: e.s,
    l: e.l
  }), He({
    h: (n + 216) % 360,
    s: e.s,
    l: e.l
  })];
}
function U$(t, e, n) {
  e = e || 6, n = n || 30;
  var r = He(t).toHsl(), i = 360 / n, o = [He(t)];
  for (r.h = (r.h - (i * e >> 1) + 720) % 360; --e; )
    r.h = (r.h + i) % 360, o.push(He(r));
  return o;
}
function z$(t, e) {
  e = e || 6;
  for (var n = He(t).toHsv(), r = n.h, i = n.s, o = n.v, a = [], s = 1 / e; e--; )
    a.push(He({
      h: r,
      s: i,
      v: o
    })), o = (o + s) % 1;
  return a;
}
He.mix = function(t, e, n) {
  n = n === 0 ? 0 : n || 50;
  var r = He(t).toRgb(), i = He(e).toRgb(), o = n / 100, a = {
    r: (i.r - r.r) * o + r.r,
    g: (i.g - r.g) * o + r.g,
    b: (i.b - r.b) * o + r.b,
    a: (i.a - r.a) * o + r.a
  };
  return He(a);
};
He.readability = function(t, e) {
  var n = He(t), r = He(e);
  return (Math.max(n.getLuminance(), r.getLuminance()) + 0.05) / (Math.min(n.getLuminance(), r.getLuminance()) + 0.05);
};
He.isReadable = function(t, e, n) {
  var r = He.readability(t, e), i, o;
  switch (o = !1, i = j$(n), i.level + i.size) {
    case "AAsmall":
    case "AAAlarge":
      o = r >= 4.5;
      break;
    case "AAlarge":
      o = r >= 3;
      break;
    case "AAAsmall":
      o = r >= 7;
      break;
  }
  return o;
};
He.mostReadable = function(t, e, n) {
  var r = null, i = 0, o, a, s, l;
  n = n || {}, a = n.includeFallbackColors, s = n.level, l = n.size;
  for (var c = 0; c < e.length; c++)
    o = He.readability(t, e[c]), o > i && (i = o, r = He(e[c]));
  return He.isReadable(t, r, {
    level: s,
    size: l
  }) || !a ? r : (n.includeFallbackColors = !1, He.mostReadable(t, ["#fff", "#000"], n));
};
var uh = He.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, H$ = He.hexNames = B$(uh);
function B$(t) {
  var e = {};
  for (var n in t)
    t.hasOwnProperty(n) && (e[t[n]] = n);
  return e;
}
function n8(t) {
  return t = parseFloat(t), (isNaN(t) || t < 0 || t > 1) && (t = 1), t;
}
function Vt(t, e) {
  V$(t) && (t = "100%");
  var n = $$(t);
  return t = Math.min(e, Math.max(0, parseFloat(t))), n && (t = parseInt(t * e, 10) / 100), Math.abs(t - e) < 1e-6 ? 1 : t % e / parseFloat(e);
}
function kd(t) {
  return Math.min(1, Math.max(0, t));
}
function Hn(t) {
  return parseInt(t, 16);
}
function V$(t) {
  return typeof t == "string" && t.indexOf(".") != -1 && parseFloat(t) === 1;
}
function $$(t) {
  return typeof t == "string" && t.indexOf("%") != -1;
}
function gr(t) {
  return t.length == 1 ? "0" + t : "" + t;
}
function rl(t) {
  return t <= 1 && (t = t * 100 + "%"), t;
}
function r8(t) {
  return Math.round(parseFloat(t) * 255).toString(16);
}
function G3(t) {
  return Hn(t) / 255;
}
var mr = function() {
  var t = "[-\\+]?\\d+%?", e = "[-\\+]?\\d*\\.\\d+%?", n = "(?:" + e + ")|(?:" + t + ")", r = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?", i = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(n),
    rgb: new RegExp("rgb" + r),
    rgba: new RegExp("rgba" + i),
    hsl: new RegExp("hsl" + r),
    hsla: new RegExp("hsla" + i),
    hsv: new RegExp("hsv" + r),
    hsva: new RegExp("hsva" + i),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function jr(t) {
  return !!mr.CSS_UNIT.exec(t);
}
function W$(t) {
  t = t.replace(_$, "").replace(C$, "").toLowerCase();
  var e = !1;
  if (uh[t])
    t = uh[t], e = !0;
  else if (t == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var n;
  return (n = mr.rgb.exec(t)) ? {
    r: n[1],
    g: n[2],
    b: n[3]
  } : (n = mr.rgba.exec(t)) ? {
    r: n[1],
    g: n[2],
    b: n[3],
    a: n[4]
  } : (n = mr.hsl.exec(t)) ? {
    h: n[1],
    s: n[2],
    l: n[3]
  } : (n = mr.hsla.exec(t)) ? {
    h: n[1],
    s: n[2],
    l: n[3],
    a: n[4]
  } : (n = mr.hsv.exec(t)) ? {
    h: n[1],
    s: n[2],
    v: n[3]
  } : (n = mr.hsva.exec(t)) ? {
    h: n[1],
    s: n[2],
    v: n[3],
    a: n[4]
  } : (n = mr.hex8.exec(t)) ? {
    r: Hn(n[1]),
    g: Hn(n[2]),
    b: Hn(n[3]),
    a: G3(n[4]),
    format: e ? "name" : "hex8"
  } : (n = mr.hex6.exec(t)) ? {
    r: Hn(n[1]),
    g: Hn(n[2]),
    b: Hn(n[3]),
    format: e ? "name" : "hex"
  } : (n = mr.hex4.exec(t)) ? {
    r: Hn(n[1] + "" + n[1]),
    g: Hn(n[2] + "" + n[2]),
    b: Hn(n[3] + "" + n[3]),
    a: G3(n[4] + "" + n[4]),
    format: e ? "name" : "hex8"
  } : (n = mr.hex3.exec(t)) ? {
    r: Hn(n[1] + "" + n[1]),
    g: Hn(n[2] + "" + n[2]),
    b: Hn(n[3] + "" + n[3]),
    format: e ? "name" : "hex"
  } : !1;
}
function j$(t) {
  var e, n;
  return t = t || {
    level: "AA",
    size: "small"
  }, e = (t.level || "AA").toUpperCase(), n = (t.size || "small").toLowerCase(), e !== "AA" && e !== "AAA" && (e = "AA"), n !== "small" && n !== "large" && (n = "small"), {
    level: e,
    size: n
  };
}
var q3 = function(e) {
  var n = ["r", "g", "b", "a", "h", "s", "l", "v"], r = 0, i = 0;
  return w$(n, function(o) {
    if (e[o] && (r += 1, isNaN(e[o]) || (i += 1), o === "s" || o === "l")) {
      var a = /^\d+%$/;
      a.test(e[o]) && (i += 1);
    }
  }), r === i ? e : !1;
}, il = function(e, n) {
  var r = e.hex ? He(e.hex) : He(e), i = r.toHsl(), o = r.toHsv(), a = r.toRgb(), s = r.toHex();
  i.s === 0 && (i.h = n || 0, o.h = n || 0);
  var l = s === "000000" && a.a === 0;
  return {
    hsl: i,
    hex: l ? "transparent" : "#" + s,
    rgb: a,
    hsv: o,
    oldHue: e.h || n || i.h,
    source: e.source
  };
}, oo = function(e) {
  if (e === "transparent")
    return !0;
  var n = String(e).charAt(0) === "#" ? 1 : 0;
  return e.length !== 4 + n && e.length < 7 + n && He(e).isValid();
}, Tp = function(e) {
  if (!e)
    return "#fff";
  var n = il(e);
  if (n.hex === "transparent")
    return "rgba(0,0,0,0.4)";
  var r = (n.rgb.r * 299 + n.rgb.g * 587 + n.rgb.b * 114) / 1e3;
  return r >= 128 ? "#000" : "#fff";
}, Vf = function(e, n) {
  var r = e.replace("°", "");
  return He(n + " (" + r + ")")._ok;
}, Vs = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, G$ = function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function q$(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function X$(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function Y$(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var Nn = function(e) {
  var n = function(r) {
    Y$(i, r);
    function i(o) {
      q$(this, i);
      var a = X$(this, (i.__proto__ || Object.getPrototypeOf(i)).call(this));
      return a.handleChange = function(s, l) {
        var c = q3(s);
        if (c) {
          var u = il(s, s.h || a.state.oldHue);
          a.setState(u), a.props.onChangeComplete && a.debounce(a.props.onChangeComplete, u, l), a.props.onChange && a.props.onChange(u, l);
        }
      }, a.handleSwatchHover = function(s, l) {
        var c = q3(s);
        if (c) {
          var u = il(s, s.h || a.state.oldHue);
          a.props.onSwatchHover && a.props.onSwatchHover(u, l);
        }
      }, a.state = Vs({}, il(o.color, 0)), a.debounce = e8(function(s, l, c) {
        s(l, c);
      }, 100), a;
    }
    return G$(i, [{
      key: "render",
      value: function() {
        var a = {};
        return this.props.onSwatchHover && (a.onSwatchHover = this.handleSwatchHover), A.createElement(e, Vs({}, this.props, this.state, {
          onChange: this.handleChange
        }, a));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(a, s) {
        return Vs({}, il(a.color, s.oldHue));
      }
    }]), i;
  }(Wl || jl);
  return n.propTypes = Vs({}, e.propTypes), n.defaultProps = Vs({}, e.defaultProps, {
    color: {
      h: 250,
      s: 0.5,
      l: 0.2,
      a: 1
    }
  }), n;
}, Z$ = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, K$ = function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function J$(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function X3(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function Q$(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var eW = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(r) {
    Q$(i, r);
    function i() {
      var o, a, s, l;
      J$(this, i);
      for (var c = arguments.length, u = Array(c), d = 0; d < c; d++)
        u[d] = arguments[d];
      return l = (a = (s = X3(this, (o = i.__proto__ || Object.getPrototypeOf(i)).call.apply(o, [this].concat(u))), s), s.state = { focus: !1 }, s.handleFocus = function() {
        return s.setState({ focus: !0 });
      }, s.handleBlur = function() {
        return s.setState({ focus: !1 });
      }, a), X3(s, l);
    }
    return K$(i, [{
      key: "render",
      value: function() {
        return A.createElement(
          n,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          A.createElement(e, Z$({}, this.props, this.state))
        );
      }
    }]), i;
  }(A.Component);
}, Y3 = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, tW = 13, nW = function(e) {
  var n = e.color, r = e.style, i = e.onClick, o = i === void 0 ? function() {
  } : i, a = e.onHover, s = e.title, l = s === void 0 ? n : s, c = e.children, u = e.focus, d = e.focusStyle, f = d === void 0 ? {} : d, h = n === "transparent", v = tt({
    default: {
      swatch: Y3({
        background: n,
        height: "100%",
        width: "100%",
        cursor: "pointer",
        position: "relative",
        outline: "none"
      }, r, u ? f : {})
    }
  }), g = function(x) {
    return o(n, x);
  }, m = function(x) {
    return x.keyCode === tW && o(n, x);
  }, p = function(x) {
    return a(n, x);
  }, y = {};
  return a && (y.onMouseOver = p), A.createElement(
    "div",
    Y3({
      style: v.swatch,
      onClick: g,
      title: l,
      tabIndex: 0,
      onKeyDown: m
    }, y),
    c,
    h && A.createElement(bs, {
      borderRadius: v.swatch.borderRadius,
      boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    })
  );
};
const Yo = eW(nW);
var rW = function(e) {
  var n = e.direction, r = tt({
    default: {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    vertical: {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: n === "vertical" });
  return A.createElement("div", { style: r.picker });
}, iW = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, i8 = function(e) {
  var n = e.rgb, r = e.hsl, i = e.width, o = e.height, a = e.onChange, s = e.direction, l = e.style, c = e.renderers, u = e.pointer, d = e.className, f = d === void 0 ? "" : d, h = tt({
    default: {
      picker: {
        position: "relative",
        width: i,
        height: o
      },
      alpha: {
        radius: "2px",
        style: l
      }
    }
  });
  return A.createElement(
    "div",
    { style: h.picker, className: "alpha-picker " + f },
    A.createElement(yp, iW({}, h.alpha, {
      rgb: n,
      hsl: r,
      pointer: u,
      renderers: c,
      onChange: a,
      direction: s
    }))
  );
};
i8.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: rW
};
Nn(i8);
function o8(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = Array(r); ++n < r; )
    i[n] = e(t[n], n, t);
  return i;
}
var oW = "__lodash_hash_undefined__";
function aW(t) {
  return this.__data__.set(t, oW), this;
}
function sW(t) {
  return this.__data__.has(t);
}
function Bu(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new mi(); ++e < n; )
    this.add(t[e]);
}
Bu.prototype.add = Bu.prototype.push = aW;
Bu.prototype.has = sW;
function lW(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r; )
    if (e(t[n], n, t))
      return !0;
  return !1;
}
function cW(t, e) {
  return t.has(e);
}
var uW = 1, dW = 2;
function a8(t, e, n, r, i, o) {
  var a = n & uW, s = t.length, l = e.length;
  if (s != l && !(a && l > s))
    return !1;
  var c = o.get(t), u = o.get(e);
  if (c && u)
    return c == e && u == t;
  var d = -1, f = !0, h = n & dW ? new Bu() : void 0;
  for (o.set(t, e), o.set(e, t); ++d < s; ) {
    var v = t[d], g = e[d];
    if (r)
      var m = a ? r(g, v, d, e, t, o) : r(v, g, d, t, e, o);
    if (m !== void 0) {
      if (m)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!lW(e, function(p, y) {
        if (!cW(h, y) && (v === p || i(v, p, n, r, o)))
          return h.push(y);
      })) {
        f = !1;
        break;
      }
    } else if (!(v === g || i(v, g, n, r, o))) {
      f = !1;
      break;
    }
  }
  return o.delete(t), o.delete(e), f;
}
function fW(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r, i) {
    n[++e] = [i, r];
  }), n;
}
function hW(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r) {
    n[++e] = r;
  }), n;
}
var pW = 1, mW = 2, vW = "[object Boolean]", gW = "[object Date]", yW = "[object Error]", bW = "[object Map]", xW = "[object Number]", wW = "[object RegExp]", _W = "[object Set]", CW = "[object String]", EW = "[object Symbol]", SW = "[object ArrayBuffer]", MW = "[object DataView]", Z3 = qi ? qi.prototype : void 0, $f = Z3 ? Z3.valueOf : void 0;
function TW(t, e, n, r, i, o, a) {
  switch (n) {
    case MW:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case SW:
      return !(t.byteLength != e.byteLength || !o(new Fu(t), new Fu(e)));
    case vW:
    case gW:
    case xW:
      return rc(+t, +e);
    case yW:
      return t.name == e.name && t.message == e.message;
    case wW:
    case CW:
      return t == e + "";
    case bW:
      var s = fW;
    case _W:
      var l = r & pW;
      if (s || (s = hW), t.size != e.size && !l)
        return !1;
      var c = a.get(t);
      if (c)
        return c == e;
      r |= mW, a.set(t, e);
      var u = a8(s(t), s(e), r, i, o, a);
      return a.delete(t), u;
    case EW:
      if ($f)
        return $f.call(t) == $f.call(e);
  }
  return !1;
}
function AW(t, e) {
  for (var n = -1, r = e.length, i = t.length; ++n < r; )
    t[i + n] = e[n];
  return t;
}
function PW(t, e, n) {
  var r = e(t);
  return Xn(t) ? r : AW(r, n(t));
}
function RW(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = 0, o = []; ++n < r; ) {
    var a = t[n];
    e(a, n, t) && (o[i++] = a);
  }
  return o;
}
function LW() {
  return [];
}
var OW = Object.prototype, DW = OW.propertyIsEnumerable, K3 = Object.getOwnPropertySymbols, kW = K3 ? function(t) {
  return t == null ? [] : (t = Object(t), RW(K3(t), function(e) {
    return DW.call(t, e);
  }));
} : LW;
const NW = kW;
function J3(t) {
  return PW(t, Mp, NW);
}
var IW = 1, FW = Object.prototype, UW = FW.hasOwnProperty;
function zW(t, e, n, r, i, o) {
  var a = n & IW, s = J3(t), l = s.length, c = J3(e), u = c.length;
  if (l != u && !a)
    return !1;
  for (var d = l; d--; ) {
    var f = s[d];
    if (!(a ? f in e : UW.call(e, f)))
      return !1;
  }
  var h = o.get(t), v = o.get(e);
  if (h && v)
    return h == e && v == t;
  var g = !0;
  o.set(t, e), o.set(e, t);
  for (var m = a; ++d < l; ) {
    f = s[d];
    var p = t[f], y = e[f];
    if (r)
      var b = a ? r(y, p, f, e, t, o) : r(p, y, f, t, e, o);
    if (!(b === void 0 ? p === y || i(p, y, n, r, o) : b)) {
      g = !1;
      break;
    }
    m || (m = f == "constructor");
  }
  if (g && !m) {
    var x = t.constructor, _ = e.constructor;
    x != _ && "constructor" in t && "constructor" in e && !(typeof x == "function" && x instanceof x && typeof _ == "function" && _ instanceof _) && (g = !1);
  }
  return o.delete(t), o.delete(e), g;
}
var HW = Xo(Tr, "DataView");
const dh = HW;
var BW = Xo(Tr, "Promise");
const fh = BW;
var VW = Xo(Tr, "Set");
const hh = VW;
var $W = Xo(Tr, "WeakMap");
const ph = $W;
var Q3 = "[object Map]", WW = "[object Object]", ev = "[object Promise]", tv = "[object Set]", nv = "[object WeakMap]", rv = "[object DataView]", jW = qo(dh), GW = qo(Rl), qW = qo(fh), XW = qo(hh), YW = qo(ph), wo = Go;
(dh && wo(new dh(new ArrayBuffer(1))) != rv || Rl && wo(new Rl()) != Q3 || fh && wo(fh.resolve()) != ev || hh && wo(new hh()) != tv || ph && wo(new ph()) != nv) && (wo = function(t) {
  var e = Go(t), n = e == WW ? t.constructor : void 0, r = n ? qo(n) : "";
  if (r)
    switch (r) {
      case jW:
        return rv;
      case GW:
        return Q3;
      case qW:
        return ev;
      case XW:
        return tv;
      case YW:
        return nv;
    }
  return e;
});
const iv = wo;
var ZW = 1, ov = "[object Arguments]", av = "[object Array]", Sc = "[object Object]", KW = Object.prototype, sv = KW.hasOwnProperty;
function JW(t, e, n, r, i, o) {
  var a = Xn(t), s = Xn(e), l = a ? av : iv(t), c = s ? av : iv(e);
  l = l == ov ? Sc : l, c = c == ov ? Sc : c;
  var u = l == Sc, d = c == Sc, f = l == c;
  if (f && zu(t)) {
    if (!zu(e))
      return !1;
    a = !0, u = !1;
  }
  if (f && !u)
    return o || (o = new zr()), a || Ep(t) ? a8(t, e, n, r, i, o) : TW(t, e, l, n, r, i, o);
  if (!(n & ZW)) {
    var h = u && sv.call(t, "__wrapped__"), v = d && sv.call(e, "__wrapped__");
    if (h || v) {
      var g = h ? t.value() : t, m = v ? e.value() : e;
      return o || (o = new zr()), i(g, m, n, r, o);
    }
  }
  return f ? (o || (o = new zr()), zW(t, e, n, r, i, o)) : !1;
}
function Ap(t, e, n, r, i) {
  return t === e ? !0 : t == null || e == null || !Xi(t) && !Xi(e) ? t !== t && e !== e : JW(t, e, n, r, Ap, i);
}
var QW = 1, ej = 2;
function tj(t, e, n, r) {
  var i = n.length, o = i, a = !r;
  if (t == null)
    return !o;
  for (t = Object(t); i--; ) {
    var s = n[i];
    if (a && s[2] ? s[1] !== t[s[0]] : !(s[0] in t))
      return !1;
  }
  for (; ++i < o; ) {
    s = n[i];
    var l = s[0], c = t[l], u = s[1];
    if (a && s[2]) {
      if (c === void 0 && !(l in t))
        return !1;
    } else {
      var d = new zr();
      if (r)
        var f = r(c, u, l, t, e, d);
      if (!(f === void 0 ? Ap(u, c, QW | ej, r, d) : f))
        return !1;
    }
  }
  return !0;
}
function s8(t) {
  return t === t && !ar(t);
}
function nj(t) {
  for (var e = Mp(t), n = e.length; n--; ) {
    var r = e[n], i = t[r];
    e[n] = [r, i, s8(i)];
  }
  return e;
}
function l8(t, e) {
  return function(n) {
    return n == null ? !1 : n[t] === e && (e !== void 0 || t in Object(n));
  };
}
function rj(t) {
  var e = nj(t);
  return e.length == 1 && e[0][2] ? l8(e[0][0], e[0][1]) : function(n) {
    return n === t || tj(n, t, e);
  };
}
var ij = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, oj = /^\w*$/;
function Pp(t, e) {
  if (Xn(t))
    return !1;
  var n = typeof t;
  return n == "number" || n == "symbol" || n == "boolean" || t == null || Od(t) ? !0 : oj.test(t) || !ij.test(t) || e != null && t in Object(e);
}
var aj = "Expected a function";
function Rp(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(aj);
  var n = function() {
    var r = arguments, i = e ? e.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var a = t.apply(this, r);
    return n.cache = o.set(i, a) || o, a;
  };
  return n.cache = new (Rp.Cache || mi)(), n;
}
Rp.Cache = mi;
var sj = 500;
function lj(t) {
  var e = Rp(t, function(r) {
    return n.size === sj && n.clear(), r;
  }), n = e.cache;
  return e;
}
var cj = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, uj = /\\(\\)?/g, dj = lj(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(cj, function(n, r, i, o) {
    e.push(i ? o.replace(uj, "$1") : r || n);
  }), e;
});
const fj = dj;
var hj = 1 / 0, lv = qi ? qi.prototype : void 0, cv = lv ? lv.toString : void 0;
function c8(t) {
  if (typeof t == "string")
    return t;
  if (Xn(t))
    return o8(t, c8) + "";
  if (Od(t))
    return cv ? cv.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -hj ? "-0" : e;
}
function pj(t) {
  return t == null ? "" : c8(t);
}
function u8(t, e) {
  return Xn(t) ? t : Pp(t, e) ? [t] : fj(pj(t));
}
var mj = 1 / 0;
function Nd(t) {
  if (typeof t == "string" || Od(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -mj ? "-0" : e;
}
function d8(t, e) {
  e = u8(e, t);
  for (var n = 0, r = e.length; t != null && n < r; )
    t = t[Nd(e[n++])];
  return n && n == r ? t : void 0;
}
function vj(t, e, n) {
  var r = t == null ? void 0 : d8(t, e);
  return r === void 0 ? n : r;
}
function gj(t, e) {
  return t != null && e in Object(t);
}
function yj(t, e, n) {
  e = u8(e, t);
  for (var r = -1, i = e.length, o = !1; ++r < i; ) {
    var a = Nd(e[r]);
    if (!(o = t != null && n(t, a)))
      break;
    t = t[a];
  }
  return o || ++r != i ? o : (i = t == null ? 0 : t.length, !!i && Cp(i) && Sp(a, i) && (Xn(t) || Uu(t)));
}
function bj(t, e) {
  return t != null && yj(t, e, gj);
}
var xj = 1, wj = 2;
function _j(t, e) {
  return Pp(t) && s8(e) ? l8(Nd(t), e) : function(n) {
    var r = vj(n, t);
    return r === void 0 && r === e ? bj(n, t) : Ap(e, r, xj | wj);
  };
}
function Cj(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
function Ej(t) {
  return function(e) {
    return d8(e, t);
  };
}
function Sj(t) {
  return Pp(t) ? Cj(Nd(t)) : Ej(t);
}
function Mj(t) {
  return typeof t == "function" ? t : t == null ? Ld : typeof t == "object" ? Xn(t) ? _j(t[0], t[1]) : rj(t) : Sj(t);
}
function Tj(t, e) {
  var n = -1, r = ws(t) ? Array(t.length) : [];
  return t8(t, function(i, o, a) {
    r[++n] = e(i, o, a);
  }), r;
}
function Zo(t, e) {
  var n = Xn(t) ? o8 : Tj;
  return n(t, Mj(e));
}
var Aj = function(e) {
  var n = e.colors, r = e.onClick, i = e.onSwatchHover, o = tt({
    default: {
      swatches: {
        marginRight: "-10px"
      },
      swatch: {
        width: "22px",
        height: "22px",
        float: "left",
        marginRight: "10px",
        marginBottom: "10px",
        borderRadius: "4px"
      },
      clear: {
        clear: "both"
      }
    }
  });
  return A.createElement(
    "div",
    { style: o.swatches },
    Zo(n, function(a) {
      return A.createElement(Yo, {
        key: a,
        color: a,
        style: o.swatch,
        onClick: r,
        onHover: i,
        focusStyle: {
          boxShadow: "0 0 4px " + a
        }
      });
    }),
    A.createElement("div", { style: o.clear })
  );
}, Lp = function(e) {
  var n = e.onChange, r = e.onSwatchHover, i = e.hex, o = e.colors, a = e.width, s = e.triangle, l = e.styles, c = l === void 0 ? {} : l, u = e.className, d = u === void 0 ? "" : u, f = i === "transparent", h = function(m, p) {
    oo(m) && n({
      hex: m,
      source: "hex"
    }, p);
  }, v = tt(kn({
    default: {
      card: {
        width: a,
        background: "#fff",
        boxShadow: "0 1px rgba(0,0,0,.1)",
        borderRadius: "6px",
        position: "relative"
      },
      head: {
        height: "110px",
        background: i,
        borderRadius: "6px 6px 0 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative"
      },
      body: {
        padding: "10px"
      },
      label: {
        fontSize: "18px",
        color: Tp(i),
        position: "relative"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 10px 10px 10px",
        borderColor: "transparent transparent " + i + " transparent",
        position: "absolute",
        top: "-10px",
        left: "50%",
        marginLeft: "-10px"
      },
      input: {
        width: "100%",
        fontSize: "12px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "22px",
        boxShadow: "inset 0 0 0 1px #ddd",
        borderRadius: "4px",
        padding: "0 7px",
        boxSizing: "border-box"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      }
    }
  }, c), { "hide-triangle": s === "hide" });
  return A.createElement(
    "div",
    { style: v.card, className: "block-picker " + d },
    A.createElement("div", { style: v.triangle }),
    A.createElement(
      "div",
      { style: v.head },
      f && A.createElement(bs, { borderRadius: "6px 6px 0 0" }),
      A.createElement(
        "div",
        { style: v.label },
        i
      )
    ),
    A.createElement(
      "div",
      { style: v.body },
      A.createElement(Aj, { colors: o, onClick: h, onSwatchHover: r }),
      A.createElement(ft, {
        style: { input: v.input },
        value: i,
        onChange: h
      })
    )
  );
};
Lp.propTypes = {
  width: Me.oneOfType([Me.string, Me.number]),
  colors: Me.arrayOf(Me.string),
  triangle: Me.oneOf(["top", "hide"]),
  styles: Me.object
};
Lp.defaultProps = {
  width: 170,
  colors: ["#D9E3F0", "#F47373", "#697689", "#37D67A", "#2CCCE4", "#555555", "#dce775", "#ff8a65", "#ba68c8"],
  triangle: "top",
  styles: {}
};
Nn(Lp);
var _a = { 50: "#ffebee", 100: "#ffcdd2", 200: "#ef9a9a", 300: "#e57373", 400: "#ef5350", 500: "#f44336", 600: "#e53935", 700: "#d32f2f", 800: "#c62828", 900: "#b71c1c", a100: "#ff8a80", a200: "#ff5252", a400: "#ff1744", a700: "#d50000" }, Ca = { 50: "#fce4ec", 100: "#f8bbd0", 200: "#f48fb1", 300: "#f06292", 400: "#ec407a", 500: "#e91e63", 600: "#d81b60", 700: "#c2185b", 800: "#ad1457", 900: "#880e4f", a100: "#ff80ab", a200: "#ff4081", a400: "#f50057", a700: "#c51162" }, Ea = { 50: "#f3e5f5", 100: "#e1bee7", 200: "#ce93d8", 300: "#ba68c8", 400: "#ab47bc", 500: "#9c27b0", 600: "#8e24aa", 700: "#7b1fa2", 800: "#6a1b9a", 900: "#4a148c", a100: "#ea80fc", a200: "#e040fb", a400: "#d500f9", a700: "#aa00ff" }, Sa = { 50: "#ede7f6", 100: "#d1c4e9", 200: "#b39ddb", 300: "#9575cd", 400: "#7e57c2", 500: "#673ab7", 600: "#5e35b1", 700: "#512da8", 800: "#4527a0", 900: "#311b92", a100: "#b388ff", a200: "#7c4dff", a400: "#651fff", a700: "#6200ea" }, Ma = { 50: "#e8eaf6", 100: "#c5cae9", 200: "#9fa8da", 300: "#7986cb", 400: "#5c6bc0", 500: "#3f51b5", 600: "#3949ab", 700: "#303f9f", 800: "#283593", 900: "#1a237e", a100: "#8c9eff", a200: "#536dfe", a400: "#3d5afe", a700: "#304ffe" }, Ta = { 50: "#e3f2fd", 100: "#bbdefb", 200: "#90caf9", 300: "#64b5f6", 400: "#42a5f5", 500: "#2196f3", 600: "#1e88e5", 700: "#1976d2", 800: "#1565c0", 900: "#0d47a1", a100: "#82b1ff", a200: "#448aff", a400: "#2979ff", a700: "#2962ff" }, Aa = { 50: "#e1f5fe", 100: "#b3e5fc", 200: "#81d4fa", 300: "#4fc3f7", 400: "#29b6f6", 500: "#03a9f4", 600: "#039be5", 700: "#0288d1", 800: "#0277bd", 900: "#01579b", a100: "#80d8ff", a200: "#40c4ff", a400: "#00b0ff", a700: "#0091ea" }, Pa = { 50: "#e0f7fa", 100: "#b2ebf2", 200: "#80deea", 300: "#4dd0e1", 400: "#26c6da", 500: "#00bcd4", 600: "#00acc1", 700: "#0097a7", 800: "#00838f", 900: "#006064", a100: "#84ffff", a200: "#18ffff", a400: "#00e5ff", a700: "#00b8d4" }, Ra = { 50: "#e0f2f1", 100: "#b2dfdb", 200: "#80cbc4", 300: "#4db6ac", 400: "#26a69a", 500: "#009688", 600: "#00897b", 700: "#00796b", 800: "#00695c", 900: "#004d40", a100: "#a7ffeb", a200: "#64ffda", a400: "#1de9b6", a700: "#00bfa5" }, ol = { 50: "#e8f5e9", 100: "#c8e6c9", 200: "#a5d6a7", 300: "#81c784", 400: "#66bb6a", 500: "#4caf50", 600: "#43a047", 700: "#388e3c", 800: "#2e7d32", 900: "#1b5e20", a100: "#b9f6ca", a200: "#69f0ae", a400: "#00e676", a700: "#00c853" }, La = { 50: "#f1f8e9", 100: "#dcedc8", 200: "#c5e1a5", 300: "#aed581", 400: "#9ccc65", 500: "#8bc34a", 600: "#7cb342", 700: "#689f38", 800: "#558b2f", 900: "#33691e", a100: "#ccff90", a200: "#b2ff59", a400: "#76ff03", a700: "#64dd17" }, Oa = { 50: "#f9fbe7", 100: "#f0f4c3", 200: "#e6ee9c", 300: "#dce775", 400: "#d4e157", 500: "#cddc39", 600: "#c0ca33", 700: "#afb42b", 800: "#9e9d24", 900: "#827717", a100: "#f4ff81", a200: "#eeff41", a400: "#c6ff00", a700: "#aeea00" }, Da = { 50: "#fffde7", 100: "#fff9c4", 200: "#fff59d", 300: "#fff176", 400: "#ffee58", 500: "#ffeb3b", 600: "#fdd835", 700: "#fbc02d", 800: "#f9a825", 900: "#f57f17", a100: "#ffff8d", a200: "#ffff00", a400: "#ffea00", a700: "#ffd600" }, ka = { 50: "#fff8e1", 100: "#ffecb3", 200: "#ffe082", 300: "#ffd54f", 400: "#ffca28", 500: "#ffc107", 600: "#ffb300", 700: "#ffa000", 800: "#ff8f00", 900: "#ff6f00", a100: "#ffe57f", a200: "#ffd740", a400: "#ffc400", a700: "#ffab00" }, Na = { 50: "#fff3e0", 100: "#ffe0b2", 200: "#ffcc80", 300: "#ffb74d", 400: "#ffa726", 500: "#ff9800", 600: "#fb8c00", 700: "#f57c00", 800: "#ef6c00", 900: "#e65100", a100: "#ffd180", a200: "#ffab40", a400: "#ff9100", a700: "#ff6d00" }, Ia = { 50: "#fbe9e7", 100: "#ffccbc", 200: "#ffab91", 300: "#ff8a65", 400: "#ff7043", 500: "#ff5722", 600: "#f4511e", 700: "#e64a19", 800: "#d84315", 900: "#bf360c", a100: "#ff9e80", a200: "#ff6e40", a400: "#ff3d00", a700: "#dd2c00" }, Fa = { 50: "#efebe9", 100: "#d7ccc8", 200: "#bcaaa4", 300: "#a1887f", 400: "#8d6e63", 500: "#795548", 600: "#6d4c41", 700: "#5d4037", 800: "#4e342e", 900: "#3e2723" }, Ua = { 50: "#eceff1", 100: "#cfd8dc", 200: "#b0bec5", 300: "#90a4ae", 400: "#78909c", 500: "#607d8b", 600: "#546e7a", 700: "#455a64", 800: "#37474f", 900: "#263238" }, f8 = function(e) {
  var n = e.color, r = e.onClick, i = e.onSwatchHover, o = e.hover, a = e.active, s = e.circleSize, l = e.circleSpacing, c = tt({
    default: {
      swatch: {
        width: s,
        height: s,
        marginRight: l,
        marginBottom: l,
        transform: "scale(1)",
        transition: "100ms transform ease"
      },
      Swatch: {
        borderRadius: "50%",
        background: "transparent",
        boxShadow: "inset 0 0 0 " + (s / 2 + 1) + "px " + n,
        transition: "100ms box-shadow ease"
      }
    },
    hover: {
      swatch: {
        transform: "scale(1.2)"
      }
    },
    active: {
      Swatch: {
        boxShadow: "inset 0 0 0 3px " + n
      }
    }
  }, { hover: o, active: a });
  return A.createElement(
    "div",
    { style: c.swatch },
    A.createElement(Yo, {
      style: c.Swatch,
      color: n,
      onClick: r,
      onHover: i,
      focusStyle: { boxShadow: c.Swatch.boxShadow + ", 0 0 5px " + n }
    })
  );
};
f8.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};
const Pj = gp(f8);
var Op = function(e) {
  var n = e.width, r = e.onChange, i = e.onSwatchHover, o = e.colors, a = e.hex, s = e.circleSize, l = e.styles, c = l === void 0 ? {} : l, u = e.circleSpacing, d = e.className, f = d === void 0 ? "" : d, h = tt(kn({
    default: {
      card: {
        width: n,
        display: "flex",
        flexWrap: "wrap",
        marginRight: -u,
        marginBottom: -u
      }
    }
  }, c)), v = function(m, p) {
    return r({ hex: m, source: "hex" }, p);
  };
  return A.createElement(
    "div",
    { style: h.card, className: "circle-picker " + f },
    Zo(o, function(g) {
      return A.createElement(Pj, {
        key: g,
        color: g,
        onClick: v,
        onSwatchHover: i,
        active: a === g.toLowerCase(),
        circleSize: s,
        circleSpacing: u
      });
    })
  );
};
Op.propTypes = {
  width: Me.oneOfType([Me.string, Me.number]),
  circleSize: Me.number,
  circleSpacing: Me.number,
  styles: Me.object
};
Op.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [_a[500], Ca[500], Ea[500], Sa[500], Ma[500], Ta[500], Aa[500], Pa[500], Ra[500], ol[500], La[500], Oa[500], Da[500], ka[500], Na[500], Ia[500], Fa[500], Ua[500]],
  styles: {}
};
Nn(Op);
function uv(t) {
  return t === void 0;
}
var h8 = {};
Object.defineProperty(h8, "__esModule", {
  value: !0
});
var dv = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, Rj = A, fv = Lj(Rj);
function Lj(t) {
  return t && t.__esModule ? t : { default: t };
}
function Oj(t, e) {
  var n = {};
  for (var r in t)
    e.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
  return n;
}
var Mc = 24, Dj = h8.default = function(t) {
  var e = t.fill, n = e === void 0 ? "currentColor" : e, r = t.width, i = r === void 0 ? Mc : r, o = t.height, a = o === void 0 ? Mc : o, s = t.style, l = s === void 0 ? {} : s, c = Oj(t, ["fill", "width", "height", "style"]);
  return fv.default.createElement(
    "svg",
    dv({
      viewBox: "0 0 " + Mc + " " + Mc,
      style: dv({ fill: n, width: i, height: a }, l)
    }, c),
    fv.default.createElement("path", { d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z" })
  );
}, kj = function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function Nj(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Ij(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function Fj(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var p8 = function(t) {
  Fj(e, t);
  function e(n) {
    Nj(this, e);
    var r = Ij(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
    return r.toggleViews = function() {
      r.state.view === "hex" ? r.setState({ view: "rgb" }) : r.state.view === "rgb" ? r.setState({ view: "hsl" }) : r.state.view === "hsl" && (r.props.hsl.a === 1 ? r.setState({ view: "hex" }) : r.setState({ view: "rgb" }));
    }, r.handleChange = function(i, o) {
      i.hex ? oo(i.hex) && r.props.onChange({
        hex: i.hex,
        source: "hex"
      }, o) : i.r || i.g || i.b ? r.props.onChange({
        r: i.r || r.props.rgb.r,
        g: i.g || r.props.rgb.g,
        b: i.b || r.props.rgb.b,
        source: "rgb"
      }, o) : i.a ? (i.a < 0 ? i.a = 0 : i.a > 1 && (i.a = 1), r.props.onChange({
        h: r.props.hsl.h,
        s: r.props.hsl.s,
        l: r.props.hsl.l,
        a: Math.round(i.a * 100) / 100,
        source: "rgb"
      }, o)) : (i.h || i.s || i.l) && (typeof i.s == "string" && i.s.includes("%") && (i.s = i.s.replace("%", "")), typeof i.l == "string" && i.l.includes("%") && (i.l = i.l.replace("%", "")), i.s == 1 ? i.s = 0.01 : i.l == 1 && (i.l = 0.01), r.props.onChange({
        h: i.h || r.props.hsl.h,
        s: Number(uv(i.s) ? r.props.hsl.s : i.s),
        l: Number(uv(i.l) ? r.props.hsl.l : i.l),
        source: "hsl"
      }, o));
    }, r.showHighlight = function(i) {
      i.currentTarget.style.background = "#eee";
    }, r.hideHighlight = function(i) {
      i.currentTarget.style.background = "transparent";
    }, n.hsl.a !== 1 && n.view === "hex" ? r.state = {
      view: "rgb"
    } : r.state = {
      view: n.view
    }, r;
  }
  return kj(e, [{
    key: "render",
    value: function() {
      var r = this, i = tt({
        default: {
          wrap: {
            paddingTop: "16px",
            display: "flex"
          },
          fields: {
            flex: "1",
            display: "flex",
            marginLeft: "-6px"
          },
          field: {
            paddingLeft: "6px",
            width: "100%"
          },
          alpha: {
            paddingLeft: "6px",
            width: "100%"
          },
          toggle: {
            width: "32px",
            textAlign: "right",
            position: "relative"
          },
          icon: {
            marginRight: "-4px",
            marginTop: "12px",
            cursor: "pointer",
            position: "relative"
          },
          iconHighlight: {
            position: "absolute",
            width: "24px",
            height: "28px",
            background: "#eee",
            borderRadius: "4px",
            top: "10px",
            left: "12px",
            display: "none"
          },
          input: {
            fontSize: "11px",
            color: "#333",
            width: "100%",
            borderRadius: "2px",
            border: "none",
            boxShadow: "inset 0 0 0 1px #dadada",
            height: "21px",
            textAlign: "center"
          },
          label: {
            textTransform: "uppercase",
            fontSize: "11px",
            lineHeight: "11px",
            color: "#969696",
            textAlign: "center",
            display: "block",
            marginTop: "12px"
          },
          svg: {
            fill: "#333",
            width: "24px",
            height: "24px",
            border: "1px transparent solid",
            borderRadius: "5px"
          }
        },
        disableAlpha: {
          alpha: {
            display: "none"
          }
        }
      }, this.props, this.state), o = void 0;
      return this.state.view === "hex" ? o = A.createElement(
        "div",
        { style: i.fields, className: "flexbox-fix" },
        A.createElement(
          "div",
          { style: i.field },
          A.createElement(ft, {
            style: { input: i.input, label: i.label },
            label: "hex",
            value: this.props.hex,
            onChange: this.handleChange
          })
        )
      ) : this.state.view === "rgb" ? o = A.createElement(
        "div",
        { style: i.fields, className: "flexbox-fix" },
        A.createElement(
          "div",
          { style: i.field },
          A.createElement(ft, {
            style: { input: i.input, label: i.label },
            label: "r",
            value: this.props.rgb.r,
            onChange: this.handleChange
          })
        ),
        A.createElement(
          "div",
          { style: i.field },
          A.createElement(ft, {
            style: { input: i.input, label: i.label },
            label: "g",
            value: this.props.rgb.g,
            onChange: this.handleChange
          })
        ),
        A.createElement(
          "div",
          { style: i.field },
          A.createElement(ft, {
            style: { input: i.input, label: i.label },
            label: "b",
            value: this.props.rgb.b,
            onChange: this.handleChange
          })
        ),
        A.createElement(
          "div",
          { style: i.alpha },
          A.createElement(ft, {
            style: { input: i.input, label: i.label },
            label: "a",
            value: this.props.rgb.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })
        )
      ) : this.state.view === "hsl" && (o = A.createElement(
        "div",
        { style: i.fields, className: "flexbox-fix" },
        A.createElement(
          "div",
          { style: i.field },
          A.createElement(ft, {
            style: { input: i.input, label: i.label },
            label: "h",
            value: Math.round(this.props.hsl.h),
            onChange: this.handleChange
          })
        ),
        A.createElement(
          "div",
          { style: i.field },
          A.createElement(ft, {
            style: { input: i.input, label: i.label },
            label: "s",
            value: Math.round(this.props.hsl.s * 100) + "%",
            onChange: this.handleChange
          })
        ),
        A.createElement(
          "div",
          { style: i.field },
          A.createElement(ft, {
            style: { input: i.input, label: i.label },
            label: "l",
            value: Math.round(this.props.hsl.l * 100) + "%",
            onChange: this.handleChange
          })
        ),
        A.createElement(
          "div",
          { style: i.alpha },
          A.createElement(ft, {
            style: { input: i.input, label: i.label },
            label: "a",
            value: this.props.hsl.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })
        )
      )), A.createElement(
        "div",
        { style: i.wrap, className: "flexbox-fix" },
        o,
        A.createElement(
          "div",
          { style: i.toggle },
          A.createElement(
            "div",
            { style: i.icon, onClick: this.toggleViews, ref: function(s) {
              return r.icon = s;
            } },
            A.createElement(Dj, {
              style: i.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return r.hsl.a !== 1 && i.view === "hex" ? { view: "rgb" } : null;
    }
  }]), e;
}(A.Component);
p8.defaultProps = {
  view: "hex"
};
var hv = function() {
  var e = tt({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        transform: "translate(-6px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return A.createElement("div", { style: e.picker });
}, Uj = function() {
  var e = tt({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    }
  });
  return A.createElement("div", { style: e.picker });
}, Dp = function(e) {
  var n = e.width, r = e.onChange, i = e.disableAlpha, o = e.rgb, a = e.hsl, s = e.hsv, l = e.hex, c = e.renderers, u = e.styles, d = u === void 0 ? {} : u, f = e.className, h = f === void 0 ? "" : f, v = e.defaultView, g = tt(kn({
    default: {
      picker: {
        width: n,
        background: "#fff",
        borderRadius: "2px",
        boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
        boxSizing: "initial",
        fontFamily: "Menlo"
      },
      saturation: {
        width: "100%",
        paddingBottom: "55%",
        position: "relative",
        borderRadius: "2px 2px 0 0",
        overflow: "hidden"
      },
      Saturation: {
        radius: "2px 2px 0 0"
      },
      body: {
        padding: "16px 16px 12px"
      },
      controls: {
        display: "flex"
      },
      color: {
        width: "32px"
      },
      swatch: {
        marginTop: "6px",
        width: "16px",
        height: "16px",
        borderRadius: "8px",
        position: "relative",
        overflow: "hidden"
      },
      active: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "8px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
        background: "rgba(" + o.r + ", " + o.g + ", " + o.b + ", " + o.a + ")",
        zIndex: "2"
      },
      toggles: {
        flex: "1"
      },
      hue: {
        height: "10px",
        position: "relative",
        marginBottom: "8px"
      },
      Hue: {
        radius: "2px"
      },
      alpha: {
        height: "10px",
        position: "relative"
      },
      Alpha: {
        radius: "2px"
      }
    },
    disableAlpha: {
      color: {
        width: "22px"
      },
      alpha: {
        display: "none"
      },
      hue: {
        marginBottom: "0px"
      },
      swatch: {
        width: "10px",
        height: "10px",
        marginTop: "0px"
      }
    }
  }, d), { disableAlpha: i });
  return A.createElement(
    "div",
    { style: g.picker, className: "chrome-picker " + h },
    A.createElement(
      "div",
      { style: g.saturation },
      A.createElement(Dd, {
        style: g.Saturation,
        hsl: a,
        hsv: s,
        pointer: Uj,
        onChange: r
      })
    ),
    A.createElement(
      "div",
      { style: g.body },
      A.createElement(
        "div",
        { style: g.controls, className: "flexbox-fix" },
        A.createElement(
          "div",
          { style: g.color },
          A.createElement(
            "div",
            { style: g.swatch },
            A.createElement("div", { style: g.active }),
            A.createElement(bs, { renderers: c })
          )
        ),
        A.createElement(
          "div",
          { style: g.toggles },
          A.createElement(
            "div",
            { style: g.hue },
            A.createElement(xs, {
              style: g.Hue,
              hsl: a,
              pointer: hv,
              onChange: r
            })
          ),
          A.createElement(
            "div",
            { style: g.alpha },
            A.createElement(yp, {
              style: g.Alpha,
              rgb: o,
              hsl: a,
              pointer: hv,
              renderers: c,
              onChange: r
            })
          )
        )
      ),
      A.createElement(p8, {
        rgb: o,
        hsl: a,
        hex: l,
        view: v,
        onChange: r,
        disableAlpha: i
      })
    )
  );
};
Dp.propTypes = {
  width: Me.oneOfType([Me.string, Me.number]),
  disableAlpha: Me.bool,
  styles: Me.object,
  defaultView: Me.oneOf(["hex", "rgb", "hsl"])
};
Dp.defaultProps = {
  width: 225,
  disableAlpha: !1,
  styles: {}
};
Nn(Dp);
var zj = function(e) {
  var n = e.color, r = e.onClick, i = r === void 0 ? function() {
  } : r, o = e.onSwatchHover, a = e.active, s = tt({
    default: {
      color: {
        background: n,
        width: "15px",
        height: "15px",
        float: "left",
        marginRight: "5px",
        marginBottom: "5px",
        position: "relative",
        cursor: "pointer"
      },
      dot: {
        absolute: "5px 5px 5px 5px",
        background: Tp(n),
        borderRadius: "50%",
        opacity: "0"
      }
    },
    active: {
      dot: {
        opacity: "1"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      dot: {
        background: "#000"
      }
    },
    transparent: {
      dot: {
        background: "#000"
      }
    }
  }, { active: a, "color-#FFFFFF": n === "#FFFFFF", transparent: n === "transparent" });
  return A.createElement(
    Yo,
    {
      style: s.color,
      color: n,
      onClick: i,
      onHover: o,
      focusStyle: { boxShadow: "0 0 4px " + n }
    },
    A.createElement("div", { style: s.dot })
  );
}, Hj = function(e) {
  var n = e.hex, r = e.rgb, i = e.onChange, o = tt({
    default: {
      fields: {
        display: "flex",
        paddingBottom: "6px",
        paddingRight: "5px",
        position: "relative"
      },
      active: {
        position: "absolute",
        top: "6px",
        left: "5px",
        height: "9px",
        width: "9px",
        background: n
      },
      HEXwrap: {
        flex: "6",
        position: "relative"
      },
      HEXinput: {
        width: "80%",
        padding: "0px",
        paddingLeft: "20%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      HEXlabel: {
        display: "none"
      },
      RGBwrap: {
        flex: "3",
        position: "relative"
      },
      RGBinput: {
        width: "70%",
        padding: "0px",
        paddingLeft: "30%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      RGBlabel: {
        position: "absolute",
        top: "3px",
        left: "0px",
        lineHeight: "16px",
        textTransform: "uppercase",
        fontSize: "12px",
        color: "#999"
      }
    }
  }), a = function(l, c) {
    l.r || l.g || l.b ? i({
      r: l.r || r.r,
      g: l.g || r.g,
      b: l.b || r.b,
      source: "rgb"
    }, c) : i({
      hex: l.hex,
      source: "hex"
    }, c);
  };
  return A.createElement(
    "div",
    { style: o.fields, className: "flexbox-fix" },
    A.createElement("div", { style: o.active }),
    A.createElement(ft, {
      style: { wrap: o.HEXwrap, input: o.HEXinput, label: o.HEXlabel },
      label: "hex",
      value: n,
      onChange: a
    }),
    A.createElement(ft, {
      style: { wrap: o.RGBwrap, input: o.RGBinput, label: o.RGBlabel },
      label: "r",
      value: r.r,
      onChange: a
    }),
    A.createElement(ft, {
      style: { wrap: o.RGBwrap, input: o.RGBinput, label: o.RGBlabel },
      label: "g",
      value: r.g,
      onChange: a
    }),
    A.createElement(ft, {
      style: { wrap: o.RGBwrap, input: o.RGBinput, label: o.RGBlabel },
      label: "b",
      value: r.b,
      onChange: a
    })
  );
}, kp = function(e) {
  var n = e.onChange, r = e.onSwatchHover, i = e.colors, o = e.hex, a = e.rgb, s = e.styles, l = s === void 0 ? {} : s, c = e.className, u = c === void 0 ? "" : c, d = tt(kn({
    default: {
      Compact: {
        background: "#f6f6f6",
        radius: "4px"
      },
      compact: {
        paddingTop: "5px",
        paddingLeft: "5px",
        boxSizing: "initial",
        width: "240px"
      },
      clear: {
        clear: "both"
      }
    }
  }, l)), f = function(v, g) {
    v.hex ? oo(v.hex) && n({
      hex: v.hex,
      source: "hex"
    }, g) : n(v, g);
  };
  return A.createElement(
    ic,
    { style: d.Compact, styles: l },
    A.createElement(
      "div",
      { style: d.compact, className: "compact-picker " + u },
      A.createElement(
        "div",
        null,
        Zo(i, function(h) {
          return A.createElement(zj, {
            key: h,
            color: h,
            active: h.toLowerCase() === o,
            onClick: f,
            onSwatchHover: r
          });
        }),
        A.createElement("div", { style: d.clear })
      ),
      A.createElement(Hj, { hex: o, rgb: a, onChange: f })
    )
  );
};
kp.propTypes = {
  colors: Me.arrayOf(Me.string),
  styles: Me.object
};
kp.defaultProps = {
  colors: ["#4D4D4D", "#999999", "#FFFFFF", "#F44E3B", "#FE9200", "#FCDC00", "#DBDF00", "#A4DD00", "#68CCCA", "#73D8FF", "#AEA1FF", "#FDA1FF", "#333333", "#808080", "#cccccc", "#D33115", "#E27300", "#FCC400", "#B0BC00", "#68BC00", "#16A5A5", "#009CE0", "#7B64FF", "#FA28FF", "#000000", "#666666", "#B3B3B3", "#9F0500", "#C45100", "#FB9E00", "#808900", "#194D33", "#0C797D", "#0062B1", "#653294", "#AB149E"],
  styles: {}
};
Nn(kp);
var Bj = function(e) {
  var n = e.hover, r = e.color, i = e.onClick, o = e.onSwatchHover, a = {
    position: "relative",
    zIndex: "2",
    outline: "2px solid #fff",
    boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
  }, s = tt({
    default: {
      swatch: {
        width: "25px",
        height: "25px",
        fontSize: "0"
      }
    },
    hover: {
      swatch: a
    }
  }, { hover: n });
  return A.createElement(
    "div",
    { style: s.swatch },
    A.createElement(Yo, {
      color: r,
      onClick: i,
      onHover: o,
      focusStyle: a
    })
  );
};
const Vj = gp(Bj);
var Np = function(e) {
  var n = e.width, r = e.colors, i = e.onChange, o = e.onSwatchHover, a = e.triangle, s = e.styles, l = s === void 0 ? {} : s, c = e.className, u = c === void 0 ? "" : c, d = tt(kn({
    default: {
      card: {
        width: n,
        background: "#fff",
        border: "1px solid rgba(0,0,0,0.2)",
        boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
        borderRadius: "4px",
        position: "relative",
        padding: "5px",
        display: "flex",
        flexWrap: "wrap"
      },
      triangle: {
        position: "absolute",
        border: "7px solid transparent",
        borderBottomColor: "#fff"
      },
      triangleShadow: {
        position: "absolute",
        border: "8px solid transparent",
        borderBottomColor: "rgba(0,0,0,0.15)"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-14px",
        left: "10px"
      },
      triangleShadow: {
        top: "-16px",
        left: "9px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-14px",
        right: "10px"
      },
      triangleShadow: {
        top: "-16px",
        right: "9px"
      }
    },
    "bottom-left-triangle": {
      triangle: {
        top: "35px",
        left: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        left: "9px",
        transform: "rotate(180deg)"
      }
    },
    "bottom-right-triangle": {
      triangle: {
        top: "35px",
        right: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        right: "9px",
        transform: "rotate(180deg)"
      }
    }
  }, l), {
    "hide-triangle": a === "hide",
    "top-left-triangle": a === "top-left",
    "top-right-triangle": a === "top-right",
    "bottom-left-triangle": a === "bottom-left",
    "bottom-right-triangle": a === "bottom-right"
  }), f = function(v, g) {
    return i({ hex: v, source: "hex" }, g);
  };
  return A.createElement(
    "div",
    { style: d.card, className: "github-picker " + u },
    A.createElement("div", { style: d.triangleShadow }),
    A.createElement("div", { style: d.triangle }),
    Zo(r, function(h) {
      return A.createElement(Vj, {
        color: h,
        key: h,
        onClick: f,
        onSwatchHover: o
      });
    })
  );
};
Np.propTypes = {
  width: Me.oneOfType([Me.string, Me.number]),
  colors: Me.arrayOf(Me.string),
  triangle: Me.oneOf(["hide", "top-left", "top-right", "bottom-left", "bottom-right"]),
  styles: Me.object
};
Np.defaultProps = {
  width: 200,
  colors: ["#B80000", "#DB3E00", "#FCCB00", "#008B02", "#006B76", "#1273DE", "#004DCF", "#5300EB", "#EB9694", "#FAD0C3", "#FEF3BD", "#C1E1C5", "#BEDADC", "#C4DEF6", "#BED3F3", "#D4C4FB"],
  triangle: "top-left",
  styles: {}
};
Nn(Np);
var $j = function(e) {
  var n = e.direction, r = tt({
    default: {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    vertical: {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: n === "vertical" });
  return A.createElement("div", { style: r.picker });
}, Wj = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, Ip = function(e) {
  var n = e.width, r = e.height, i = e.onChange, o = e.hsl, a = e.direction, s = e.pointer, l = e.styles, c = l === void 0 ? {} : l, u = e.className, d = u === void 0 ? "" : u, f = tt(kn({
    default: {
      picker: {
        position: "relative",
        width: n,
        height: r
      },
      hue: {
        radius: "2px"
      }
    }
  }, c)), h = function(g) {
    return i({ a: 1, h: g.h, l: 0.5, s: 1 });
  };
  return A.createElement(
    "div",
    { style: f.picker, className: "hue-picker " + d },
    A.createElement(xs, Wj({}, f.hue, {
      hsl: o,
      pointer: s,
      onChange: h,
      direction: a
    }))
  );
};
Ip.propTypes = {
  styles: Me.object
};
Ip.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: $j,
  styles: {}
};
Nn(Ip);
var jj = function(e) {
  var n = e.onChange, r = e.hex, i = e.rgb, o = e.styles, a = o === void 0 ? {} : o, s = e.className, l = s === void 0 ? "" : s, c = tt(kn({
    default: {
      material: {
        width: "98px",
        height: "98px",
        padding: "16px",
        fontFamily: "Roboto"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "2px solid " + r,
        outline: "none",
        height: "30px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "1px solid #eee",
        outline: "none",
        height: "30px"
      },
      RGBlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      split: {
        display: "flex",
        marginRight: "-10px",
        paddingTop: "11px"
      },
      third: {
        flex: "1",
        paddingRight: "10px"
      }
    }
  }, a)), u = function(f, h) {
    f.hex ? oo(f.hex) && n({
      hex: f.hex,
      source: "hex"
    }, h) : (f.r || f.g || f.b) && n({
      r: f.r || i.r,
      g: f.g || i.g,
      b: f.b || i.b,
      source: "rgb"
    }, h);
  };
  return A.createElement(
    ic,
    { styles: a },
    A.createElement(
      "div",
      { style: c.material, className: "material-picker " + l },
      A.createElement(ft, {
        style: { wrap: c.HEXwrap, input: c.HEXinput, label: c.HEXlabel },
        label: "hex",
        value: r,
        onChange: u
      }),
      A.createElement(
        "div",
        { style: c.split, className: "flexbox-fix" },
        A.createElement(
          "div",
          { style: c.third },
          A.createElement(ft, {
            style: { wrap: c.RGBwrap, input: c.RGBinput, label: c.RGBlabel },
            label: "r",
            value: i.r,
            onChange: u
          })
        ),
        A.createElement(
          "div",
          { style: c.third },
          A.createElement(ft, {
            style: { wrap: c.RGBwrap, input: c.RGBinput, label: c.RGBlabel },
            label: "g",
            value: i.g,
            onChange: u
          })
        ),
        A.createElement(
          "div",
          { style: c.third },
          A.createElement(ft, {
            style: { wrap: c.RGBwrap, input: c.RGBinput, label: c.RGBlabel },
            label: "b",
            value: i.b,
            onChange: u
          })
        )
      )
    )
  );
};
Nn(jj);
var Gj = function(e) {
  var n = e.onChange, r = e.rgb, i = e.hsv, o = e.hex, a = tt({
    default: {
      fields: {
        paddingTop: "5px",
        paddingBottom: "9px",
        width: "80px",
        position: "relative"
      },
      divider: {
        height: "5px"
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        marginLeft: "40%",
        width: "40%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "5px",
        fontSize: "13px",
        paddingLeft: "3px",
        marginRight: "10px"
      },
      RGBlabel: {
        left: "0px",
        top: "0px",
        width: "34px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px",
        position: "absolute"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        marginLeft: "20%",
        width: "80%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "6px",
        fontSize: "13px",
        paddingLeft: "3px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        width: "14px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px"
      },
      fieldSymbols: {
        position: "absolute",
        top: "5px",
        right: "-7px",
        fontSize: "13px"
      },
      symbol: {
        height: "20px",
        lineHeight: "22px",
        paddingBottom: "7px"
      }
    }
  }), s = function(c, u) {
    c["#"] ? oo(c["#"]) && n({
      hex: c["#"],
      source: "hex"
    }, u) : c.r || c.g || c.b ? n({
      r: c.r || r.r,
      g: c.g || r.g,
      b: c.b || r.b,
      source: "rgb"
    }, u) : (c.h || c.s || c.v) && n({
      h: c.h || i.h,
      s: c.s || i.s,
      v: c.v || i.v,
      source: "hsv"
    }, u);
  };
  return A.createElement(
    "div",
    { style: a.fields },
    A.createElement(ft, {
      style: { wrap: a.RGBwrap, input: a.RGBinput, label: a.RGBlabel },
      label: "h",
      value: Math.round(i.h),
      onChange: s
    }),
    A.createElement(ft, {
      style: { wrap: a.RGBwrap, input: a.RGBinput, label: a.RGBlabel },
      label: "s",
      value: Math.round(i.s * 100),
      onChange: s
    }),
    A.createElement(ft, {
      style: { wrap: a.RGBwrap, input: a.RGBinput, label: a.RGBlabel },
      label: "v",
      value: Math.round(i.v * 100),
      onChange: s
    }),
    A.createElement("div", { style: a.divider }),
    A.createElement(ft, {
      style: { wrap: a.RGBwrap, input: a.RGBinput, label: a.RGBlabel },
      label: "r",
      value: r.r,
      onChange: s
    }),
    A.createElement(ft, {
      style: { wrap: a.RGBwrap, input: a.RGBinput, label: a.RGBlabel },
      label: "g",
      value: r.g,
      onChange: s
    }),
    A.createElement(ft, {
      style: { wrap: a.RGBwrap, input: a.RGBinput, label: a.RGBlabel },
      label: "b",
      value: r.b,
      onChange: s
    }),
    A.createElement("div", { style: a.divider }),
    A.createElement(ft, {
      style: { wrap: a.HEXwrap, input: a.HEXinput, label: a.HEXlabel },
      label: "#",
      value: o.replace("#", ""),
      onChange: s
    }),
    A.createElement(
      "div",
      { style: a.fieldSymbols },
      A.createElement(
        "div",
        { style: a.symbol },
        "°"
      ),
      A.createElement(
        "div",
        { style: a.symbol },
        "%"
      ),
      A.createElement(
        "div",
        { style: a.symbol },
        "%"
      )
    )
  );
}, qj = function(e) {
  var n = e.hsl, r = tt({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    },
    "black-outline": {
      picker: {
        boxShadow: "inset 0 0 0 1px #000"
      }
    }
  }, { "black-outline": n.l > 0.5 });
  return A.createElement("div", { style: r.picker });
}, Xj = function() {
  var e = tt({
    default: {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "4px 0 4px 6px",
        borderColor: "transparent transparent transparent #fff",
        position: "absolute",
        top: "1px",
        left: "1px"
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "5px 0 5px 8px",
        borderColor: "transparent transparent transparent #555"
      },
      left: {
        Extend: "triangleBorder",
        transform: "translate(-13px, -4px)"
      },
      leftInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      },
      right: {
        Extend: "triangleBorder",
        transform: "translate(20px, -14px) rotate(180deg)"
      },
      rightInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      }
    }
  });
  return A.createElement(
    "div",
    { style: e.pointer },
    A.createElement(
      "div",
      { style: e.left },
      A.createElement("div", { style: e.leftInside })
    ),
    A.createElement(
      "div",
      { style: e.right },
      A.createElement("div", { style: e.rightInside })
    )
  );
}, pv = function(e) {
  var n = e.onClick, r = e.label, i = e.children, o = e.active, a = tt({
    default: {
      button: {
        backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
        border: "1px solid #878787",
        borderRadius: "2px",
        height: "20px",
        boxShadow: "0 1px 0 0 #EAEAEA",
        fontSize: "14px",
        color: "#000",
        lineHeight: "20px",
        textAlign: "center",
        marginBottom: "10px",
        cursor: "pointer"
      }
    },
    active: {
      button: {
        boxShadow: "0 0 0 1px #878787"
      }
    }
  }, { active: o });
  return A.createElement(
    "div",
    { style: a.button, onClick: n },
    r || i
  );
}, Yj = function(e) {
  var n = e.rgb, r = e.currentColor, i = tt({
    default: {
      swatches: {
        border: "1px solid #B3B3B3",
        borderBottom: "1px solid #F0F0F0",
        marginBottom: "2px",
        marginTop: "1px"
      },
      new: {
        height: "34px",
        background: "rgb(" + n.r + "," + n.g + ", " + n.b + ")",
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
      },
      current: {
        height: "34px",
        background: r,
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
      },
      label: {
        fontSize: "14px",
        color: "#000",
        textAlign: "center"
      }
    }
  });
  return A.createElement(
    "div",
    null,
    A.createElement(
      "div",
      { style: i.label },
      "new"
    ),
    A.createElement(
      "div",
      { style: i.swatches },
      A.createElement("div", { style: i.new }),
      A.createElement("div", { style: i.current })
    ),
    A.createElement(
      "div",
      { style: i.label },
      "current"
    )
  );
}, Zj = function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function Kj(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Jj(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function Qj(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var Fp = function(t) {
  Qj(e, t);
  function e(n) {
    Kj(this, e);
    var r = Jj(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
    return r.state = {
      currentColor: n.hex
    }, r;
  }
  return Zj(e, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.styles, o = i === void 0 ? {} : i, a = r.className, s = a === void 0 ? "" : a, l = tt(kn({
        default: {
          picker: {
            background: "#DCDCDC",
            borderRadius: "4px",
            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
            boxSizing: "initial",
            width: "513px"
          },
          head: {
            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
            borderBottom: "1px solid #B1B1B1",
            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
            height: "23px",
            lineHeight: "24px",
            borderRadius: "4px 4px 0 0",
            fontSize: "13px",
            color: "#4D4D4D",
            textAlign: "center"
          },
          body: {
            padding: "15px 15px 0",
            display: "flex"
          },
          saturation: {
            width: "256px",
            height: "256px",
            position: "relative",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0",
            overflow: "hidden"
          },
          hue: {
            position: "relative",
            height: "256px",
            width: "19px",
            marginLeft: "10px",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0"
          },
          controls: {
            width: "180px",
            marginLeft: "10px"
          },
          top: {
            display: "flex"
          },
          previews: {
            width: "60px"
          },
          actions: {
            flex: "1",
            marginLeft: "20px"
          }
        }
      }, o));
      return A.createElement(
        "div",
        { style: l.picker, className: "photoshop-picker " + s },
        A.createElement(
          "div",
          { style: l.head },
          this.props.header
        ),
        A.createElement(
          "div",
          { style: l.body, className: "flexbox-fix" },
          A.createElement(
            "div",
            { style: l.saturation },
            A.createElement(Dd, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: qj,
              onChange: this.props.onChange
            })
          ),
          A.createElement(
            "div",
            { style: l.hue },
            A.createElement(xs, {
              direction: "vertical",
              hsl: this.props.hsl,
              pointer: Xj,
              onChange: this.props.onChange
            })
          ),
          A.createElement(
            "div",
            { style: l.controls },
            A.createElement(
              "div",
              { style: l.top, className: "flexbox-fix" },
              A.createElement(
                "div",
                { style: l.previews },
                A.createElement(Yj, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              A.createElement(
                "div",
                { style: l.actions },
                A.createElement(pv, { label: "OK", onClick: this.props.onAccept, active: !0 }),
                A.createElement(pv, { label: "Cancel", onClick: this.props.onCancel }),
                A.createElement(Gj, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]), e;
}(A.Component);
Fp.propTypes = {
  header: Me.string,
  styles: Me.object
};
Fp.defaultProps = {
  header: "Color Picker",
  styles: {}
};
Nn(Fp);
var eG = function(e) {
  var n = e.onChange, r = e.rgb, i = e.hsl, o = e.hex, a = e.disableAlpha, s = tt({
    default: {
      fields: {
        display: "flex",
        paddingTop: "4px"
      },
      single: {
        flex: "1",
        paddingLeft: "6px"
      },
      alpha: {
        flex: "1",
        paddingLeft: "6px"
      },
      double: {
        flex: "2"
      },
      input: {
        width: "80%",
        padding: "4px 10% 3px",
        border: "none",
        boxShadow: "inset 0 0 0 1px #ccc",
        fontSize: "11px"
      },
      label: {
        display: "block",
        textAlign: "center",
        fontSize: "11px",
        color: "#222",
        paddingTop: "3px",
        paddingBottom: "4px",
        textTransform: "capitalize"
      }
    },
    disableAlpha: {
      alpha: {
        display: "none"
      }
    }
  }, { disableAlpha: a }), l = function(u, d) {
    u.hex ? oo(u.hex) && n({
      hex: u.hex,
      source: "hex"
    }, d) : u.r || u.g || u.b ? n({
      r: u.r || r.r,
      g: u.g || r.g,
      b: u.b || r.b,
      a: r.a,
      source: "rgb"
    }, d) : u.a && (u.a < 0 ? u.a = 0 : u.a > 100 && (u.a = 100), u.a /= 100, n({
      h: i.h,
      s: i.s,
      l: i.l,
      a: u.a,
      source: "rgb"
    }, d));
  };
  return A.createElement(
    "div",
    { style: s.fields, className: "flexbox-fix" },
    A.createElement(
      "div",
      { style: s.double },
      A.createElement(ft, {
        style: { input: s.input, label: s.label },
        label: "hex",
        value: o.replace("#", ""),
        onChange: l
      })
    ),
    A.createElement(
      "div",
      { style: s.single },
      A.createElement(ft, {
        style: { input: s.input, label: s.label },
        label: "r",
        value: r.r,
        onChange: l,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    A.createElement(
      "div",
      { style: s.single },
      A.createElement(ft, {
        style: { input: s.input, label: s.label },
        label: "g",
        value: r.g,
        onChange: l,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    A.createElement(
      "div",
      { style: s.single },
      A.createElement(ft, {
        style: { input: s.input, label: s.label },
        label: "b",
        value: r.b,
        onChange: l,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    A.createElement(
      "div",
      { style: s.alpha },
      A.createElement(ft, {
        style: { input: s.input, label: s.label },
        label: "a",
        value: Math.round(r.a * 100),
        onChange: l,
        dragLabel: "true",
        dragMax: "100"
      })
    )
  );
}, tG = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, m8 = function(e) {
  var n = e.colors, r = e.onClick, i = r === void 0 ? function() {
  } : r, o = e.onSwatchHover, a = tt({
    default: {
      colors: {
        margin: "0 -10px",
        padding: "10px 0 0 10px",
        borderTop: "1px solid #eee",
        display: "flex",
        flexWrap: "wrap",
        position: "relative"
      },
      swatchWrap: {
        width: "16px",
        height: "16px",
        margin: "0 10px 10px 0"
      },
      swatch: {
        borderRadius: "3px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
      }
    },
    "no-presets": {
      colors: {
        display: "none"
      }
    }
  }, {
    "no-presets": !n || !n.length
  }), s = function(c, u) {
    i({
      hex: c,
      source: "hex"
    }, u);
  };
  return A.createElement(
    "div",
    { style: a.colors, className: "flexbox-fix" },
    n.map(function(l) {
      var c = typeof l == "string" ? { color: l } : l, u = "" + c.color + (c.title || "");
      return A.createElement(
        "div",
        { key: u, style: a.swatchWrap },
        A.createElement(Yo, tG({}, c, {
          style: a.swatch,
          onClick: s,
          onHover: o,
          focusStyle: {
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + c.color
          }
        }))
      );
    })
  );
};
m8.propTypes = {
  colors: Me.arrayOf(Me.oneOfType([Me.string, Me.shape({
    color: Me.string,
    title: Me.string
  })])).isRequired
};
var nG = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, Up = function(e) {
  var n = e.width, r = e.rgb, i = e.hex, o = e.hsv, a = e.hsl, s = e.onChange, l = e.onSwatchHover, c = e.disableAlpha, u = e.presetColors, d = e.renderers, f = e.styles, h = f === void 0 ? {} : f, v = e.className, g = v === void 0 ? "" : v, m = tt(kn({
    default: nG({
      picker: {
        width: n,
        padding: "10px 10px 0",
        boxSizing: "initial",
        background: "#fff",
        borderRadius: "4px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
      },
      saturation: {
        width: "100%",
        paddingBottom: "75%",
        position: "relative",
        overflow: "hidden"
      },
      Saturation: {
        radius: "3px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      controls: {
        display: "flex"
      },
      sliders: {
        padding: "4px 0",
        flex: "1"
      },
      color: {
        width: "24px",
        height: "24px",
        position: "relative",
        marginTop: "4px",
        marginLeft: "4px",
        borderRadius: "3px"
      },
      activeColor: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "2px",
        background: "rgba(" + r.r + "," + r.g + "," + r.b + "," + r.a + ")",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      hue: {
        position: "relative",
        height: "10px",
        overflow: "hidden"
      },
      Hue: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      alpha: {
        position: "relative",
        height: "10px",
        marginTop: "4px",
        overflow: "hidden"
      },
      Alpha: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      }
    }, h),
    disableAlpha: {
      color: {
        height: "10px"
      },
      hue: {
        height: "10px"
      },
      alpha: {
        display: "none"
      }
    }
  }, h), { disableAlpha: c });
  return A.createElement(
    "div",
    { style: m.picker, className: "sketch-picker " + g },
    A.createElement(
      "div",
      { style: m.saturation },
      A.createElement(Dd, {
        style: m.Saturation,
        hsl: a,
        hsv: o,
        onChange: s
      })
    ),
    A.createElement(
      "div",
      { style: m.controls, className: "flexbox-fix" },
      A.createElement(
        "div",
        { style: m.sliders },
        A.createElement(
          "div",
          { style: m.hue },
          A.createElement(xs, {
            style: m.Hue,
            hsl: a,
            onChange: s
          })
        ),
        A.createElement(
          "div",
          { style: m.alpha },
          A.createElement(yp, {
            style: m.Alpha,
            rgb: r,
            hsl: a,
            renderers: d,
            onChange: s
          })
        )
      ),
      A.createElement(
        "div",
        { style: m.color },
        A.createElement(bs, null),
        A.createElement("div", { style: m.activeColor })
      )
    ),
    A.createElement(eG, {
      rgb: r,
      hsl: a,
      hex: i,
      onChange: s,
      disableAlpha: c
    }),
    A.createElement(m8, {
      colors: u,
      onClick: s,
      onSwatchHover: l
    })
  );
};
Up.propTypes = {
  disableAlpha: Me.bool,
  width: Me.oneOfType([Me.string, Me.number]),
  styles: Me.object
};
Up.defaultProps = {
  disableAlpha: !1,
  width: 200,
  styles: {},
  presetColors: ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"]
};
const rG = Nn(Up);
var $s = function(e) {
  var n = e.hsl, r = e.offset, i = e.onClick, o = i === void 0 ? function() {
  } : i, a = e.active, s = e.first, l = e.last, c = tt({
    default: {
      swatch: {
        height: "12px",
        background: "hsl(" + n.h + ", 50%, " + r * 100 + "%)",
        cursor: "pointer"
      }
    },
    first: {
      swatch: {
        borderRadius: "2px 0 0 2px"
      }
    },
    last: {
      swatch: {
        borderRadius: "0 2px 2px 0"
      }
    },
    active: {
      swatch: {
        transform: "scaleY(1.8)",
        borderRadius: "3.6px/2px"
      }
    }
  }, { active: a, first: s, last: l }), u = function(f) {
    return o({
      h: n.h,
      s: 0.5,
      l: r,
      source: "hsl"
    }, f);
  };
  return A.createElement("div", { style: c.swatch, onClick: u });
}, iG = function(e) {
  var n = e.onClick, r = e.hsl, i = tt({
    default: {
      swatches: {
        marginTop: "20px"
      },
      swatch: {
        boxSizing: "border-box",
        width: "20%",
        paddingRight: "1px",
        float: "left"
      },
      clear: {
        clear: "both"
      }
    }
  }), o = 0.1;
  return A.createElement(
    "div",
    { style: i.swatches },
    A.createElement(
      "div",
      { style: i.swatch },
      A.createElement($s, {
        hsl: r,
        offset: ".80",
        active: Math.abs(r.l - 0.8) < o && Math.abs(r.s - 0.5) < o,
        onClick: n,
        first: !0
      })
    ),
    A.createElement(
      "div",
      { style: i.swatch },
      A.createElement($s, {
        hsl: r,
        offset: ".65",
        active: Math.abs(r.l - 0.65) < o && Math.abs(r.s - 0.5) < o,
        onClick: n
      })
    ),
    A.createElement(
      "div",
      { style: i.swatch },
      A.createElement($s, {
        hsl: r,
        offset: ".50",
        active: Math.abs(r.l - 0.5) < o && Math.abs(r.s - 0.5) < o,
        onClick: n
      })
    ),
    A.createElement(
      "div",
      { style: i.swatch },
      A.createElement($s, {
        hsl: r,
        offset: ".35",
        active: Math.abs(r.l - 0.35) < o && Math.abs(r.s - 0.5) < o,
        onClick: n
      })
    ),
    A.createElement(
      "div",
      { style: i.swatch },
      A.createElement($s, {
        hsl: r,
        offset: ".20",
        active: Math.abs(r.l - 0.2) < o && Math.abs(r.s - 0.5) < o,
        onClick: n,
        last: !0
      })
    ),
    A.createElement("div", { style: i.clear })
  );
}, oG = function() {
  var e = tt({
    default: {
      picker: {
        width: "14px",
        height: "14px",
        borderRadius: "6px",
        transform: "translate(-7px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return A.createElement("div", { style: e.picker });
}, zp = function(e) {
  var n = e.hsl, r = e.onChange, i = e.pointer, o = e.styles, a = o === void 0 ? {} : o, s = e.className, l = s === void 0 ? "" : s, c = tt(kn({
    default: {
      hue: {
        height: "12px",
        position: "relative"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, a));
  return A.createElement(
    "div",
    { style: c.wrap || {}, className: "slider-picker " + l },
    A.createElement(
      "div",
      { style: c.hue },
      A.createElement(xs, {
        style: c.Hue,
        hsl: n,
        pointer: i,
        onChange: r
      })
    ),
    A.createElement(
      "div",
      { style: c.swatches },
      A.createElement(iG, { hsl: n, onClick: r })
    )
  );
};
zp.propTypes = {
  styles: Me.object
};
zp.defaultProps = {
  pointer: oG,
  styles: {}
};
Nn(zp);
var v8 = {};
Object.defineProperty(v8, "__esModule", {
  value: !0
});
var mv = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, aG = A, vv = sG(aG);
function sG(t) {
  return t && t.__esModule ? t : { default: t };
}
function lG(t, e) {
  var n = {};
  for (var r in t)
    e.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
  return n;
}
var Tc = 24, cG = v8.default = function(t) {
  var e = t.fill, n = e === void 0 ? "currentColor" : e, r = t.width, i = r === void 0 ? Tc : r, o = t.height, a = o === void 0 ? Tc : o, s = t.style, l = s === void 0 ? {} : s, c = lG(t, ["fill", "width", "height", "style"]);
  return vv.default.createElement(
    "svg",
    mv({
      viewBox: "0 0 " + Tc + " " + Tc,
      style: mv({ fill: n, width: i, height: a }, l)
    }, c),
    vv.default.createElement("path", { d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" })
  );
}, uG = function(e) {
  var n = e.color, r = e.onClick, i = r === void 0 ? function() {
  } : r, o = e.onSwatchHover, a = e.first, s = e.last, l = e.active, c = tt({
    default: {
      color: {
        width: "40px",
        height: "24px",
        cursor: "pointer",
        background: n,
        marginBottom: "1px"
      },
      check: {
        color: Tp(n),
        marginLeft: "8px",
        display: "none"
      }
    },
    first: {
      color: {
        overflow: "hidden",
        borderRadius: "2px 2px 0 0"
      }
    },
    last: {
      color: {
        overflow: "hidden",
        borderRadius: "0 0 2px 2px"
      }
    },
    active: {
      check: {
        display: "block"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      check: {
        color: "#333"
      }
    },
    transparent: {
      check: {
        color: "#333"
      }
    }
  }, {
    first: a,
    last: s,
    active: l,
    "color-#FFFFFF": n === "#FFFFFF",
    transparent: n === "transparent"
  });
  return A.createElement(
    Yo,
    {
      color: n,
      style: c.color,
      onClick: i,
      onHover: o,
      focusStyle: { boxShadow: "0 0 4px " + n }
    },
    A.createElement(
      "div",
      { style: c.check },
      A.createElement(cG, null)
    )
  );
}, dG = function(e) {
  var n = e.onClick, r = e.onSwatchHover, i = e.group, o = e.active, a = tt({
    default: {
      group: {
        paddingBottom: "10px",
        width: "40px",
        float: "left",
        marginRight: "10px"
      }
    }
  });
  return A.createElement(
    "div",
    { style: a.group },
    Zo(i, function(s, l) {
      return A.createElement(uG, {
        key: s,
        color: s,
        active: s.toLowerCase() === o,
        first: l === 0,
        last: l === i.length - 1,
        onClick: n,
        onSwatchHover: r
      });
    })
  );
}, Hp = function(e) {
  var n = e.width, r = e.height, i = e.onChange, o = e.onSwatchHover, a = e.colors, s = e.hex, l = e.styles, c = l === void 0 ? {} : l, u = e.className, d = u === void 0 ? "" : u, f = tt(kn({
    default: {
      picker: {
        width: n,
        height: r
      },
      overflow: {
        height: r,
        overflowY: "scroll"
      },
      body: {
        padding: "16px 0 6px 16px"
      },
      clear: {
        clear: "both"
      }
    }
  }, c)), h = function(g, m) {
    return i({ hex: g, source: "hex" }, m);
  };
  return A.createElement(
    "div",
    { style: f.picker, className: "swatches-picker " + d },
    A.createElement(
      ic,
      null,
      A.createElement(
        "div",
        { style: f.overflow },
        A.createElement(
          "div",
          { style: f.body },
          Zo(a, function(v) {
            return A.createElement(dG, {
              key: v.toString(),
              group: v,
              active: s,
              onClick: h,
              onSwatchHover: o
            });
          }),
          A.createElement("div", { style: f.clear })
        )
      )
    )
  );
};
Hp.propTypes = {
  width: Me.oneOfType([Me.string, Me.number]),
  height: Me.oneOfType([Me.string, Me.number]),
  colors: Me.arrayOf(Me.arrayOf(Me.string)),
  styles: Me.object
  /* eslint-disable max-len */
};
Hp.defaultProps = {
  width: 320,
  height: 240,
  colors: [[_a[900], _a[700], _a[500], _a[300], _a[100]], [Ca[900], Ca[700], Ca[500], Ca[300], Ca[100]], [Ea[900], Ea[700], Ea[500], Ea[300], Ea[100]], [Sa[900], Sa[700], Sa[500], Sa[300], Sa[100]], [Ma[900], Ma[700], Ma[500], Ma[300], Ma[100]], [Ta[900], Ta[700], Ta[500], Ta[300], Ta[100]], [Aa[900], Aa[700], Aa[500], Aa[300], Aa[100]], [Pa[900], Pa[700], Pa[500], Pa[300], Pa[100]], [Ra[900], Ra[700], Ra[500], Ra[300], Ra[100]], ["#194D33", ol[700], ol[500], ol[300], ol[100]], [La[900], La[700], La[500], La[300], La[100]], [Oa[900], Oa[700], Oa[500], Oa[300], Oa[100]], [Da[900], Da[700], Da[500], Da[300], Da[100]], [ka[900], ka[700], ka[500], ka[300], ka[100]], [Na[900], Na[700], Na[500], Na[300], Na[100]], [Ia[900], Ia[700], Ia[500], Ia[300], Ia[100]], [Fa[900], Fa[700], Fa[500], Fa[300], Fa[100]], [Ua[900], Ua[700], Ua[500], Ua[300], Ua[100]], ["#000000", "#525252", "#969696", "#D9D9D9", "#FFFFFF"]],
  styles: {}
};
Nn(Hp);
var Bp = function(e) {
  var n = e.onChange, r = e.onSwatchHover, i = e.hex, o = e.colors, a = e.width, s = e.triangle, l = e.styles, c = l === void 0 ? {} : l, u = e.className, d = u === void 0 ? "" : u, f = tt(kn({
    default: {
      card: {
        width: a,
        background: "#fff",
        border: "0 solid rgba(0,0,0,0.25)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
        borderRadius: "4px",
        position: "relative"
      },
      body: {
        padding: "15px 9px 9px 15px"
      },
      label: {
        fontSize: "18px",
        color: "#fff"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent #fff transparent",
        position: "absolute"
      },
      triangleShadow: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
        position: "absolute"
      },
      hash: {
        background: "#F0F0F0",
        height: "30px",
        width: "30px",
        borderRadius: "4px 0 0 4px",
        float: "left",
        color: "#98A1A4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      input: {
        width: "100px",
        fontSize: "14px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "28px",
        boxShadow: "inset 0 0 0 1px #F0F0F0",
        boxSizing: "content-box",
        borderRadius: "0 4px 4px 0",
        float: "left",
        paddingLeft: "8px"
      },
      swatch: {
        width: "30px",
        height: "30px",
        float: "left",
        borderRadius: "4px",
        margin: "0 6px 6px 0"
      },
      clear: {
        clear: "both"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-10px",
        left: "12px"
      },
      triangleShadow: {
        top: "-11px",
        left: "12px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-10px",
        right: "12px"
      },
      triangleShadow: {
        top: "-11px",
        right: "12px"
      }
    }
  }, c), {
    "hide-triangle": s === "hide",
    "top-left-triangle": s === "top-left",
    "top-right-triangle": s === "top-right"
  }), h = function(g, m) {
    oo(g) && n({
      hex: g,
      source: "hex"
    }, m);
  };
  return A.createElement(
    "div",
    { style: f.card, className: "twitter-picker " + d },
    A.createElement("div", { style: f.triangleShadow }),
    A.createElement("div", { style: f.triangle }),
    A.createElement(
      "div",
      { style: f.body },
      Zo(o, function(v, g) {
        return A.createElement(Yo, {
          key: g,
          color: v,
          hex: v,
          style: f.swatch,
          onClick: h,
          onHover: r,
          focusStyle: {
            boxShadow: "0 0 4px " + v
          }
        });
      }),
      A.createElement(
        "div",
        { style: f.hash },
        "#"
      ),
      A.createElement(ft, {
        label: null,
        style: { input: f.input },
        value: i.replace("#", ""),
        onChange: h
      }),
      A.createElement("div", { style: f.clear })
    )
  );
};
Bp.propTypes = {
  width: Me.oneOfType([Me.string, Me.number]),
  triangle: Me.oneOf(["hide", "top-left", "top-right"]),
  colors: Me.arrayOf(Me.string),
  styles: Me.object
};
Bp.defaultProps = {
  width: 276,
  colors: ["#FF6900", "#FCB900", "#7BDCB5", "#00D084", "#8ED1FC", "#0693E3", "#ABB8C3", "#EB144C", "#F78DA7", "#9900EF"],
  triangle: "top-left",
  styles: {}
};
Nn(Bp);
var Vp = function(e) {
  var n = tt({
    default: {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        border: "2px #fff solid",
        transform: "translate(-12px, -13px)",
        background: "hsl(" + Math.round(e.hsl.h) + ", " + Math.round(e.hsl.s * 100) + "%, " + Math.round(e.hsl.l * 100) + "%)"
      }
    }
  });
  return A.createElement("div", { style: n.picker });
};
Vp.propTypes = {
  hsl: Me.shape({
    h: Me.number,
    s: Me.number,
    l: Me.number,
    a: Me.number
  })
};
Vp.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var $p = function(e) {
  var n = tt({
    default: {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        transform: "translate(-10px, -7px)",
        background: "hsl(" + Math.round(e.hsl.h) + ", 100%, 50%)",
        border: "2px white solid"
      }
    }
  });
  return A.createElement("div", { style: n.picker });
};
$p.propTypes = {
  hsl: Me.shape({
    h: Me.number,
    s: Me.number,
    l: Me.number,
    a: Me.number
  })
};
$p.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var fG = function(e) {
  var n = e.onChange, r = e.rgb, i = e.hsl, o = e.hex, a = e.hsv, s = function(h, v) {
    if (h.hex)
      oo(h.hex) && n({
        hex: h.hex,
        source: "hex"
      }, v);
    else if (h.rgb) {
      var g = h.rgb.split(",");
      Vf(h.rgb, "rgb") && n({
        r: g[0],
        g: g[1],
        b: g[2],
        a: 1,
        source: "rgb"
      }, v);
    } else if (h.hsv) {
      var m = h.hsv.split(",");
      Vf(h.hsv, "hsv") && (m[2] = m[2].replace("%", ""), m[1] = m[1].replace("%", ""), m[0] = m[0].replace("°", ""), m[1] == 1 ? m[1] = 0.01 : m[2] == 1 && (m[2] = 0.01), n({
        h: Number(m[0]),
        s: Number(m[1]),
        v: Number(m[2]),
        source: "hsv"
      }, v));
    } else if (h.hsl) {
      var p = h.hsl.split(",");
      Vf(h.hsl, "hsl") && (p[2] = p[2].replace("%", ""), p[1] = p[1].replace("%", ""), p[0] = p[0].replace("°", ""), d[1] == 1 ? d[1] = 0.01 : d[2] == 1 && (d[2] = 0.01), n({
        h: Number(p[0]),
        s: Number(p[1]),
        v: Number(p[2]),
        source: "hsl"
      }, v));
    }
  }, l = tt({
    default: {
      wrap: {
        display: "flex",
        height: "100px",
        marginTop: "4px"
      },
      fields: {
        width: "100%"
      },
      column: {
        paddingTop: "10px",
        display: "flex",
        justifyContent: "space-between"
      },
      double: {
        padding: "0px 4.4px",
        boxSizing: "border-box"
      },
      input: {
        width: "100%",
        height: "38px",
        boxSizing: "border-box",
        padding: "4px 10% 3px",
        textAlign: "center",
        border: "1px solid #dadce0",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      input2: {
        height: "38px",
        width: "100%",
        border: "1px solid #dadce0",
        boxSizing: "border-box",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        paddingLeft: "10px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label: {
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "35px",
        top: "-6px",
        left: "0",
        right: "0",
        marginLeft: "auto",
        marginRight: "auto",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label2: {
        left: "10px",
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "32px",
        top: "-6px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      single: {
        flexGrow: "1",
        margin: "0px 4.4px"
      }
    }
  }), c = r.r + ", " + r.g + ", " + r.b, u = Math.round(i.h) + "°, " + Math.round(i.s * 100) + "%, " + Math.round(i.l * 100) + "%", d = Math.round(a.h) + "°, " + Math.round(a.s * 100) + "%, " + Math.round(a.v * 100) + "%";
  return A.createElement(
    "div",
    { style: l.wrap, className: "flexbox-fix" },
    A.createElement(
      "div",
      { style: l.fields },
      A.createElement(
        "div",
        { style: l.double },
        A.createElement(ft, {
          style: { input: l.input, label: l.label },
          label: "hex",
          value: o,
          onChange: s
        })
      ),
      A.createElement(
        "div",
        { style: l.column },
        A.createElement(
          "div",
          { style: l.single },
          A.createElement(ft, {
            style: { input: l.input2, label: l.label2 },
            label: "rgb",
            value: c,
            onChange: s
          })
        ),
        A.createElement(
          "div",
          { style: l.single },
          A.createElement(ft, {
            style: { input: l.input2, label: l.label2 },
            label: "hsv",
            value: d,
            onChange: s
          })
        ),
        A.createElement(
          "div",
          { style: l.single },
          A.createElement(ft, {
            style: { input: l.input2, label: l.label2 },
            label: "hsl",
            value: u,
            onChange: s
          })
        )
      )
    )
  );
}, Wp = function(e) {
  var n = e.width, r = e.onChange, i = e.rgb, o = e.hsl, a = e.hsv, s = e.hex, l = e.header, c = e.styles, u = c === void 0 ? {} : c, d = e.className, f = d === void 0 ? "" : d, h = tt(kn({
    default: {
      picker: {
        width: n,
        background: "#fff",
        border: "1px solid #dfe1e5",
        boxSizing: "initial",
        display: "flex",
        flexWrap: "wrap",
        borderRadius: "8px 8px 0px 0px"
      },
      head: {
        height: "57px",
        width: "100%",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingLeft: "16px",
        fontSize: "20px",
        boxSizing: "border-box",
        fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
      },
      saturation: {
        width: "70%",
        padding: "0px",
        position: "relative",
        overflow: "hidden"
      },
      swatch: {
        width: "30%",
        height: "228px",
        padding: "0px",
        background: "rgba(" + i.r + ", " + i.g + ", " + i.b + ", 1)",
        position: "relative",
        overflow: "hidden"
      },
      body: {
        margin: "auto",
        width: "95%"
      },
      controls: {
        display: "flex",
        boxSizing: "border-box",
        height: "52px",
        paddingTop: "22px"
      },
      color: {
        width: "32px"
      },
      hue: {
        height: "8px",
        position: "relative",
        margin: "0px 16px 0px 16px",
        width: "100%"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, u));
  return A.createElement(
    "div",
    { style: h.picker, className: "google-picker " + f },
    A.createElement(
      "div",
      { style: h.head },
      l
    ),
    A.createElement("div", { style: h.swatch }),
    A.createElement(
      "div",
      { style: h.saturation },
      A.createElement(Dd, {
        hsl: o,
        hsv: a,
        pointer: Vp,
        onChange: r
      })
    ),
    A.createElement(
      "div",
      { style: h.body },
      A.createElement(
        "div",
        { style: h.controls, className: "flexbox-fix" },
        A.createElement(
          "div",
          { style: h.hue },
          A.createElement(xs, {
            style: h.Hue,
            hsl: o,
            radius: "4px",
            pointer: $p,
            onChange: r
          })
        )
      ),
      A.createElement(fG, {
        rgb: i,
        hsl: o,
        hex: s,
        hsv: a,
        onChange: r
      })
    )
  );
};
Wp.propTypes = {
  width: Me.oneOfType([Me.string, Me.number]),
  styles: Me.object,
  header: Me.string
};
Wp.defaultProps = {
  width: 652,
  styles: {},
  header: "Color picker"
};
Nn(Wp);
const Vn = (t, e, n) => Math.min(Math.max(n, t), e);
function gv() {
  const { innerWidth: t, innerHeight: e } = window;
  return {
    width: t,
    height: e
  };
}
function hG() {
  const [t, e] = Ke(gv());
  return Dt(() => {
    function n() {
      e(gv());
    }
    return window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, []), t;
}
const pG = ({
  children: t,
  className: e,
  width: n = 0,
  height: r = 0,
  x: i = 0,
  y: o = 0,
  disableResizeX: a = !1,
  disableResizeY: s = !1,
  disableDragX: l = !1,
  disableDragY: c = !1,
  minWidth: u = 0,
  maxWidth: d = 1 / 0,
  minHeight: f = 0,
  maxHeight: h = 1 / 0,
  resizeThreshold: v = 20,
  focused: g = !0,
  onDragStart: m = () => {
  },
  onDragMove: p = () => {
  },
  onDragEnd: y = () => {
  },
  onResizeStart: b = () => {
  },
  onResizeMove: x = () => {
  },
  onResizeEnd: _ = () => {
  }
}) => {
  const { width: M, height: S } = hG(), P = On(0), E = On(0), [w, O] = Ke(null), [N, I] = Ke(n), [H, j] = Ke(r), [U, $] = Ke(i), [V, te] = Ke(o), [B, Z] = Ke(!1), [Q, ce] = Ke(!1), [k, G] = Ke(!1), [K, J] = Ke(!1), [se, be] = Ke(!1), pe = Gt(
    (he) => {
      for (; he && he !== w; )
        he = he.parentElement;
      return he === w;
    },
    [w]
  ), Ne = Gt(
    (he) => {
      if (!w || !pe(he.target))
        return !1;
      const ue = w.getBoundingClientRect(), Se = he.x >= ue.left - v && he.x <= ue.right + v && he.y >= ue.top - v && he.y <= ue.bottom + v, we = Math.abs(he.x - ue.left), D = Math.abs(he.x - ue.right), T = Math.abs(he.y - ue.top), Y = Math.abs(he.y - ue.bottom);
      return Se && ((we <= v || D <= v) && !a || (T <= v || Y <= v) && !s);
    },
    [w, a, s, pe, v]
  ), ae = Gt(
    (he) => {
      if (!pe(he.target))
        return !1;
      let ue = he.target;
      for (; ue && ue !== w; ) {
        if (ue.className.includes("skand-rnd-enable"))
          return !0;
        if (ue.tagName === "INPUT" || ue.onclick || ue.onmousedown || ue.onpointerdown || ue.className.includes("skand-rnd-disable"))
          return !1;
        ue = ue.parentElement;
      }
      return !0;
    },
    [pe, w]
  ), Re = Gt(
    (he) => {
      if (!w)
        return;
      const ue = w.getBoundingClientRect();
      if (Ne(he)) {
        he.preventDefault();
        const Se = Math.abs(he.x - ue.left), we = Math.abs(he.x - ue.right), D = Math.abs(he.y - ue.top), T = Math.abs(he.y - ue.bottom);
        b(N, H), Z(Se <= v), ce(we <= v), G(D <= v), J(T <= v);
      } else
        ae(he) && (he.preventDefault(), m(U, V), be(!0));
    },
    [
      w,
      ae,
      Ne,
      H,
      N,
      U,
      V,
      m,
      b,
      v
    ]
  ), F = Gt(
    (he) => {
      if (!w || !w.parentElement)
        return;
      const ue = he.clientX - P.current, Se = he.clientY - E.current;
      P.current = he.clientX, E.current = he.clientY;
      const we = w.getBoundingClientRect(), D = w.parentElement.getBoundingClientRect(), T = -D.left, Y = M - D.left - we.width, fe = -D.top, de = S - D.top - we.height;
      if (se ? (l || $((ne) => Vn(T, Y, ne + ue)), c || te((ne) => Vn(fe, de, ne + Se))) : (a || (B ? (I((ne) => Vn(u, d, ne - ue)), l || $((ne) => Vn(T, Y, ne + ue))) : Q && I((ne) => Vn(u, d, ne + ue))), s || (k ? (j((ne) => Vn(f, h, ne - Se)), c || te((ne) => Vn(fe, de, ne + Se))) : K && j((ne) => Vn(f, h, ne + Se)))), g) {
        const ne = he.x >= we.left - v && he.x <= we.right + v && he.y >= we.top - v && he.y <= we.bottom + v, Le = Math.abs(he.x - we.left) <= v, Ce = Math.abs(he.x - we.right) <= v, Te = Math.abs(he.y - we.top) <= v, ke = Math.abs(he.y - we.bottom) <= v;
        (Le || Ce) && !Te && !ke && !a && ne ? document.body.style.cursor = "ew-resize" : (Te || ke) && !Le && !Ce && !s && ne ? document.body.style.cursor = "ns-resize" : (Te && Ce || ke && Le) && !a && !s && ne ? document.body.style.cursor = "nesw-resize" : (Te && Le || ke && Ce) && !a && !s && ne ? document.body.style.cursor = "nwse-resize" : document.body.style.cursor = "auto";
      }
    },
    [
      l,
      c,
      a,
      s,
      se,
      g,
      h,
      d,
      f,
      u,
      v,
      K,
      B,
      Q,
      k,
      w,
      S,
      M
    ]
  ), Ge = Gt(() => {
    se && y(U, V), (B || Q || k || K) && _(N, H), be(!1), Z(!1), ce(!1), G(!1), J(!1);
  }, [
    H,
    N,
    U,
    V,
    se,
    y,
    _,
    K,
    B,
    Q,
    k
  ]);
  Dt(() => {
    const he = () => {
      if (!w || !w.parentElement)
        return;
      const Se = w.getBoundingClientRect(), we = w.parentElement.getBoundingClientRect(), D = -we.left, T = M - we.left - Se.width, Y = -we.top, fe = S - we.top - Se.height;
      $((de) => Vn(D, T, de)), te((de) => Vn(Y, fe, de));
    }, ue = new MutationObserver(he);
    return ue.observe(document.body, {
      subtree: !0,
      childList: !0,
      attributes: !0,
      characterData: !0
    }), () => {
      ue.disconnect();
    };
  }, [w, S, M]), Dt(() => (document.addEventListener("mousemove", F), document.addEventListener("mousedown", Re), document.addEventListener("mouseup", Ge), () => {
    document.removeEventListener("mousemove", F), document.removeEventListener("mousedown", Re), document.removeEventListener("mouseup", Ge);
  }), [Re, F, Ge]), Dt(() => {
    p(U, V);
  }, [U, V, p]), Dt(() => {
    x(N, H);
  }, [H, N, x]);
  const $e = Pn(() => {
    const he = {};
    return a || (he.width = `${N}px`), s || (he.height = `${H}px`), !l && !c ? he.transform = `translate(${U}px, ${V}px)` : l ? c || (he.transform = `translateY(${V}px)`) : he.transform = `translateX(${U}px)`, he;
  }, [
    H,
    N,
    U,
    V,
    l,
    c,
    a,
    s
  ]);
  return /* @__PURE__ */ R.jsx("div", { className: ve("skand-rnd-disable", e), ref: O, style: $e, tabIndex: 0, children: t });
}, mG = [
  "#D04A6B",
  "#F69C64",
  "#F6DF64",
  "#4CB176",
  "#3F8AE2",
  "#8A1AE3",
  "#8A858E",
  "#FFFFFF"
], ihe = ({
  className: t,
  setColor: e,
  closeMenu: n,
  color: r,
  onSaveColorButton: i,
  colorSelection: o = mG,
  colorPickerHeader: a,
  openingCoordinates: s = { x: 0, y: 0 }
}) => /* @__PURE__ */ R.jsx(
  pG,
  {
    className: ve("z-36", t ?? "fixed"),
    disableResizeX: !0,
    disableResizeY: !0,
    x: s.x,
    y: s.y,
    children: /* @__PURE__ */ R.jsxs(
      "div",
      {
        className: ve(
          "flex",
          "w-220px",
          "bg-neutral-100",
          "p-10px",
          "rounded",
          "border",
          "border-solid",
          "border-neutral-400",
          "shadow-md"
        ),
        children: [
          /* @__PURE__ */ R.jsx(
            "button",
            {
              className: ve("cursor-pointer bg-transparent b-none absolute right-12px"),
              onClick: n,
              children: /* @__PURE__ */ R.jsx("div", { className: ve("text-12px text-right text-gray-400 i-skand-close") })
            }
          ),
          /* @__PURE__ */ R.jsxs("div", { className: ve("flex flex-col w-full"), children: [
            a && /* @__PURE__ */ R.jsx(
              "p",
              {
                className: ve(
                  "typo-text-small text-neutral-900 w-44 overflow-ellipsis overflow-hidden absolute whitespace-nowrap"
                ),
                children: a
              }
            ),
            /* @__PURE__ */ R.jsx("div", { className: "mt-6 w-full border-none", onClick: (l) => l.stopPropagation(), children: /* @__PURE__ */ R.jsx(
              rG,
              {
                className: "Z-10 border-none font-sans",
                color: r,
                disableAlpha: !0,
                onChange: e,
                presetColors: o,
                styles: {
                  picker: {}
                }
              }
            ) }),
            i && /* @__PURE__ */ R.jsx(
              md,
              {
                className: "h-8 cursor-pointer px-1 py-2",
                filled: !0,
                onClick: () => i(r),
                primary: !0,
                size: "xs",
                children: "Save"
              }
            )
          ] })
        ]
      }
    )
  }
), vG = ["top", "right", "bottom", "left"], Yi = Math.min, Wn = Math.max, Vu = Math.round, Ac = Math.floor, Zi = (t) => ({
  x: t,
  y: t
}), gG = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, yG = {
  start: "end",
  end: "start"
};
function mh(t, e, n) {
  return Wn(t, Yi(e, n));
}
function ci(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function ui(t) {
  return t.split("-")[0];
}
function _s(t) {
  return t.split("-")[1];
}
function jp(t) {
  return t === "x" ? "y" : "x";
}
function Gp(t) {
  return t === "y" ? "height" : "width";
}
function Cs(t) {
  return ["top", "bottom"].includes(ui(t)) ? "y" : "x";
}
function qp(t) {
  return jp(Cs(t));
}
function bG(t, e, n) {
  n === void 0 && (n = !1);
  const r = _s(t), i = qp(t), o = Gp(i);
  let a = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[o] > e.floating[o] && (a = $u(a)), [a, $u(a)];
}
function xG(t) {
  const e = $u(t);
  return [vh(t), e, vh(e)];
}
function vh(t) {
  return t.replace(/start|end/g, (e) => yG[e]);
}
function wG(t, e, n) {
  const r = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], a = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? i : r : e ? r : i;
    case "left":
    case "right":
      return e ? o : a;
    default:
      return [];
  }
}
function _G(t, e, n, r) {
  const i = _s(t);
  let o = wG(ui(t), n === "start", r);
  return i && (o = o.map((a) => a + "-" + i), e && (o = o.concat(o.map(vh)))), o;
}
function $u(t) {
  return t.replace(/left|right|bottom|top/g, (e) => gG[e]);
}
function CG(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function g8(t) {
  return typeof t != "number" ? CG(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Wu(t) {
  return {
    ...t,
    top: t.y,
    left: t.x,
    right: t.x + t.width,
    bottom: t.y + t.height
  };
}
function yv(t, e, n) {
  let {
    reference: r,
    floating: i
  } = t;
  const o = Cs(e), a = qp(e), s = Gp(a), l = ui(e), c = o === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: r.y - i.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - i.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (_s(e)) {
    case "start":
      h[a] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      h[a] += f * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const EG = async (t, e, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: a
  } = n, s = o.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(e));
  let c = await a.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: u,
    y: d
  } = yv(c, r, l), f = r, h = {}, v = 0;
  for (let g = 0; g < s.length; g++) {
    const {
      name: m,
      fn: p
    } = s[g], {
      x: y,
      y: b,
      data: x,
      reset: _
    } = await p({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: i,
      middlewareData: h,
      rects: c,
      platform: a,
      elements: {
        reference: t,
        floating: e
      }
    });
    if (u = y ?? u, d = b ?? d, h = {
      ...h,
      [m]: {
        ...h[m],
        ...x
      }
    }, _ && v <= 50) {
      v++, typeof _ == "object" && (_.placement && (f = _.placement), _.rects && (c = _.rects === !0 ? await a.getElementRects({
        reference: t,
        floating: e,
        strategy: i
      }) : _.rects), {
        x: u,
        y: d
      } = yv(c, f, l)), g = -1;
      continue;
    }
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: i,
    middlewareData: h
  };
};
async function Ol(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: a,
    elements: s,
    strategy: l
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = ci(e, t), v = g8(h), m = s[f ? d === "floating" ? "reference" : "floating" : d], p = Wu(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(m))) == null || n ? m : m.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), y = d === "floating" ? {
    ...a.floating,
    x: r,
    y: i
  } : a.reference, b = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating)), x = await (o.isElement == null ? void 0 : o.isElement(b)) ? await (o.getScale == null ? void 0 : o.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, _ = Wu(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: y,
    offsetParent: b,
    strategy: l
  }) : y);
  return {
    top: (p.top - _.top + v.top) / x.y,
    bottom: (_.bottom - p.bottom + v.bottom) / x.y,
    left: (p.left - _.left + v.left) / x.x,
    right: (_.right - p.right + v.right) / x.x
  };
}
const bv = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: a,
      elements: s
    } = e, {
      element: l,
      padding: c = 0
    } = ci(t, e) || {};
    if (l == null)
      return {};
    const u = g8(c), d = {
      x: n,
      y: r
    }, f = qp(i), h = Gp(f), v = await a.getDimensions(l), g = f === "y", m = g ? "top" : "left", p = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", b = o.reference[h] + o.reference[f] - d[f] - o.floating[h], x = d[f] - o.reference[f], _ = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l));
    let M = _ ? _[y] : 0;
    (!M || !await (a.isElement == null ? void 0 : a.isElement(_))) && (M = s.floating[y] || o.floating[h]);
    const S = b / 2 - x / 2, P = M / 2 - v[h] / 2 - 1, E = Yi(u[m], P), w = Yi(u[p], P), O = E, N = M - v[h] - w, I = M / 2 - v[h] / 2 + S, H = mh(O, I, N), U = _s(i) != null && I != H && o.reference[h] / 2 - (I < O ? E : w) - v[h] / 2 < 0 ? I < O ? O - I : N - I : 0;
    return {
      [f]: d[f] - U,
      data: {
        [f]: H,
        centerOffset: I - H + U
      }
    };
  }
}), Id = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n;
      const {
        placement: r,
        middlewareData: i,
        rects: o,
        initialPlacement: a,
        platform: s,
        elements: l
      } = e, {
        mainAxis: c = !0,
        crossAxis: u = !0,
        fallbackPlacements: d,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: v = !0,
        ...g
      } = ci(t, e), m = ui(r), p = ui(a) === a, y = await (s.isRTL == null ? void 0 : s.isRTL(l.floating)), b = d || (p || !v ? [$u(a)] : xG(a));
      !d && h !== "none" && b.push(..._G(a, v, h, y));
      const x = [a, ...b], _ = await Ol(e, g), M = [];
      let S = ((n = i.flip) == null ? void 0 : n.overflows) || [];
      if (c && M.push(_[m]), u) {
        const O = bG(r, o, y);
        M.push(_[O[0]], _[O[1]]);
      }
      if (S = [...S, {
        placement: r,
        overflows: M
      }], !M.every((O) => O <= 0)) {
        var P, E;
        const O = (((P = i.flip) == null ? void 0 : P.index) || 0) + 1, N = x[O];
        if (N)
          return {
            data: {
              index: O,
              overflows: S
            },
            reset: {
              placement: N
            }
          };
        let I = (E = S.filter((H) => H.overflows[0] <= 0).sort((H, j) => H.overflows[1] - j.overflows[1])[0]) == null ? void 0 : E.placement;
        if (!I)
          switch (f) {
            case "bestFit": {
              var w;
              const H = (w = S.map((j) => [j.placement, j.overflows.filter((U) => U > 0).reduce((U, $) => U + $, 0)]).sort((j, U) => j[1] - U[1])[0]) == null ? void 0 : w[0];
              H && (I = H);
              break;
            }
            case "initialPlacement":
              I = a;
              break;
          }
        if (r !== I)
          return {
            reset: {
              placement: I
            }
          };
      }
      return {};
    }
  };
};
function xv(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function wv(t) {
  return vG.some((e) => t[e] >= 0);
}
const y8 = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n
      } = e, {
        strategy: r = "referenceHidden",
        ...i
      } = ci(t, e);
      switch (r) {
        case "referenceHidden": {
          const o = await Ol(e, {
            ...i,
            elementContext: "reference"
          }), a = xv(o, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: wv(a)
            }
          };
        }
        case "escaped": {
          const o = await Ol(e, {
            ...i,
            altBoundary: !0
          }), a = xv(o, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: wv(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function SG(t, e) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = t, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), a = ui(n), s = _s(n), l = Cs(n) === "y", c = ["left", "top"].includes(a) ? -1 : 1, u = o && l ? -1 : 1, d = ci(e, t);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: v
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return s && typeof v == "number" && (h = s === "end" ? v * -1 : v), l ? {
    x: h * u,
    y: f * c
  } : {
    x: f * c,
    y: h * u
  };
}
const b8 = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r
      } = e, i = await SG(e, t);
      return {
        x: n + i.x,
        y: r + i.y,
        data: i
      };
    }
  };
}, x8 = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r,
        placement: i
      } = e, {
        mainAxis: o = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (m) => {
            let {
              x: p,
              y
            } = m;
            return {
              x: p,
              y
            };
          }
        },
        ...l
      } = ci(t, e), c = {
        x: n,
        y: r
      }, u = await Ol(e, l), d = Cs(ui(i)), f = jp(d);
      let h = c[f], v = c[d];
      if (o) {
        const m = f === "y" ? "top" : "left", p = f === "y" ? "bottom" : "right", y = h + u[m], b = h - u[p];
        h = mh(y, h, b);
      }
      if (a) {
        const m = d === "y" ? "top" : "left", p = d === "y" ? "bottom" : "right", y = v + u[m], b = v - u[p];
        v = mh(y, v, b);
      }
      const g = s.fn({
        ...e,
        [f]: h,
        [d]: v
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r
        }
      };
    }
  };
}, w8 = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: r,
        placement: i,
        rects: o,
        middlewareData: a
      } = e, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = ci(t, e), u = {
        x: n,
        y: r
      }, d = Cs(i), f = jp(d);
      let h = u[f], v = u[d];
      const g = ci(s, e), m = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const b = f === "y" ? "height" : "width", x = o.reference[f] - o.floating[b] + m.mainAxis, _ = o.reference[f] + o.reference[b] - m.mainAxis;
        h < x ? h = x : h > _ && (h = _);
      }
      if (c) {
        var p, y;
        const b = f === "y" ? "width" : "height", x = ["top", "left"].includes(ui(i)), _ = o.reference[d] - o.floating[b] + (x && ((p = a.offset) == null ? void 0 : p[d]) || 0) + (x ? 0 : m.crossAxis), M = o.reference[d] + o.reference[b] + (x ? 0 : ((y = a.offset) == null ? void 0 : y[d]) || 0) - (x ? m.crossAxis : 0);
        v < _ ? v = _ : v > M && (v = M);
      }
      return {
        [f]: h,
        [d]: v
      };
    }
  };
}, Xp = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      const {
        placement: n,
        rects: r,
        platform: i,
        elements: o
      } = e, {
        apply: a = () => {
        },
        ...s
      } = ci(t, e), l = await Ol(e, s), c = ui(n), u = _s(n), d = Cs(n) === "y", {
        width: f,
        height: h
      } = r.floating;
      let v, g;
      c === "top" || c === "bottom" ? (v = c, g = u === (await (i.isRTL == null ? void 0 : i.isRTL(o.floating)) ? "start" : "end") ? "left" : "right") : (g = c, v = u === "end" ? "top" : "bottom");
      const m = h - l[v], p = f - l[g], y = !e.middlewareData.shift;
      let b = m, x = p;
      if (d) {
        const M = f - l.left - l.right;
        x = u || y ? Yi(p, M) : M;
      } else {
        const M = h - l.top - l.bottom;
        b = u || y ? Yi(m, M) : M;
      }
      if (y && !u) {
        const M = Wn(l.left, 0), S = Wn(l.right, 0), P = Wn(l.top, 0), E = Wn(l.bottom, 0);
        d ? x = f - 2 * (M !== 0 || S !== 0 ? M + S : Wn(l.left, l.right)) : b = h - 2 * (P !== 0 || E !== 0 ? P + E : Wn(l.top, l.bottom));
      }
      await a({
        ...e,
        availableWidth: x,
        availableHeight: b
      });
      const _ = await i.getDimensions(o.floating);
      return f !== _.width || h !== _.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ki(t) {
  return _8(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Gn(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function vi(t) {
  var e;
  return (e = (_8(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function _8(t) {
  return t instanceof Node || t instanceof Gn(t).Node;
}
function Xt(t) {
  return t instanceof Element || t instanceof Gn(t).Element;
}
function Dn(t) {
  return t instanceof HTMLElement || t instanceof Gn(t).HTMLElement;
}
function gh(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof Gn(t).ShadowRoot;
}
function oc(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: r,
    display: i
  } = Yn(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !["inline", "contents"].includes(i);
}
function MG(t) {
  return ["table", "td", "th"].includes(Ki(t));
}
function Yp(t) {
  const e = Zp(), n = Yn(t);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function TG(t) {
  let e = Do(t);
  for (; Dn(e) && !ac(e); ) {
    if (Yp(e))
      return e;
    e = Do(e);
  }
  return null;
}
function Zp() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ac(t) {
  return ["html", "body", "#document"].includes(Ki(t));
}
function Yn(t) {
  return Gn(t).getComputedStyle(t);
}
function Fd(t) {
  return Xt(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset
  };
}
function Do(t) {
  if (Ki(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    gh(t) && t.host || // Fallback.
    vi(t)
  );
  return gh(e) ? e.host : e;
}
function C8(t) {
  const e = Do(t);
  return ac(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : Dn(e) && oc(e) ? e : C8(e);
}
function Po(t, e) {
  var n;
  e === void 0 && (e = []);
  const r = C8(t), i = r === ((n = t.ownerDocument) == null ? void 0 : n.body), o = Gn(r);
  return i ? e.concat(o, o.visualViewport || [], oc(r) ? r : []) : e.concat(r, Po(r));
}
function E8(t) {
  const e = Yn(t);
  let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const i = Dn(t), o = i ? t.offsetWidth : n, a = i ? t.offsetHeight : r, s = Vu(n) !== o || Vu(r) !== a;
  return s && (n = o, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function Kp(t) {
  return Xt(t) ? t : t.contextElement;
}
function qa(t) {
  const e = Kp(t);
  if (!Dn(e))
    return Zi(1);
  const n = e.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = E8(e);
  let a = (o ? Vu(n.width) : n.width) / r, s = (o ? Vu(n.height) : n.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const AG = /* @__PURE__ */ Zi(0);
function S8(t) {
  const e = Gn(t);
  return !Zp() || !e.visualViewport ? AG : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function PG(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== Gn(t) ? !1 : e;
}
function ko(t, e, n, r) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const i = t.getBoundingClientRect(), o = Kp(t);
  let a = Zi(1);
  e && (r ? Xt(r) && (a = qa(r)) : a = qa(t));
  const s = PG(o, n, r) ? S8(o) : Zi(0);
  let l = (i.left + s.x) / a.x, c = (i.top + s.y) / a.y, u = i.width / a.x, d = i.height / a.y;
  if (o) {
    const f = Gn(o), h = r && Xt(r) ? Gn(r) : r;
    let v = f.frameElement;
    for (; v && r && h !== f; ) {
      const g = qa(v), m = v.getBoundingClientRect(), p = Yn(v), y = m.left + (v.clientLeft + parseFloat(p.paddingLeft)) * g.x, b = m.top + (v.clientTop + parseFloat(p.paddingTop)) * g.y;
      l *= g.x, c *= g.y, u *= g.x, d *= g.y, l += y, c += b, v = Gn(v).frameElement;
    }
  }
  return Wu({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function RG(t) {
  let {
    rect: e,
    offsetParent: n,
    strategy: r
  } = t;
  const i = Dn(n), o = vi(n);
  if (n === o)
    return e;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = Zi(1);
  const l = Zi(0);
  if ((i || !i && r !== "fixed") && ((Ki(n) !== "body" || oc(o)) && (a = Fd(n)), Dn(n))) {
    const c = ko(n);
    s = qa(n), l.x = c.x + n.clientLeft, l.y = c.y + n.clientTop;
  }
  return {
    width: e.width * s.x,
    height: e.height * s.y,
    x: e.x * s.x - a.scrollLeft * s.x + l.x,
    y: e.y * s.y - a.scrollTop * s.y + l.y
  };
}
function LG(t) {
  return Array.from(t.getClientRects());
}
function M8(t) {
  return ko(vi(t)).left + Fd(t).scrollLeft;
}
function OG(t) {
  const e = vi(t), n = Fd(t), r = t.ownerDocument.body, i = Wn(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), o = Wn(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + M8(t);
  const s = -n.scrollTop;
  return Yn(r).direction === "rtl" && (a += Wn(e.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: a,
    y: s
  };
}
function DG(t, e) {
  const n = Gn(t), r = vi(t), i = n.visualViewport;
  let o = r.clientWidth, a = r.clientHeight, s = 0, l = 0;
  if (i) {
    o = i.width, a = i.height;
    const c = Zp();
    (!c || c && e === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: o,
    height: a,
    x: s,
    y: l
  };
}
function kG(t, e) {
  const n = ko(t, !0, e === "fixed"), r = n.top + t.clientTop, i = n.left + t.clientLeft, o = Dn(t) ? qa(t) : Zi(1), a = t.clientWidth * o.x, s = t.clientHeight * o.y, l = i * o.x, c = r * o.y;
  return {
    width: a,
    height: s,
    x: l,
    y: c
  };
}
function _v(t, e, n) {
  let r;
  if (e === "viewport")
    r = DG(t, n);
  else if (e === "document")
    r = OG(vi(t));
  else if (Xt(e))
    r = kG(e, n);
  else {
    const i = S8(t);
    r = {
      ...e,
      x: e.x - i.x,
      y: e.y - i.y
    };
  }
  return Wu(r);
}
function T8(t, e) {
  const n = Do(t);
  return n === e || !Xt(n) || ac(n) ? !1 : Yn(n).position === "fixed" || T8(n, e);
}
function NG(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let r = Po(t).filter((s) => Xt(s) && Ki(s) !== "body"), i = null;
  const o = Yn(t).position === "fixed";
  let a = o ? Do(t) : t;
  for (; Xt(a) && !ac(a); ) {
    const s = Yn(a), l = Yp(a);
    !l && s.position === "fixed" && (i = null), (o ? !l && !i : !l && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || oc(a) && !l && T8(t, a)) ? r = r.filter((u) => u !== a) : i = s, a = Do(a);
  }
  return e.set(t, r), r;
}
function IG(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = t;
  const a = [...n === "clippingAncestors" ? NG(e, this._c) : [].concat(n), r], s = a[0], l = a.reduce((c, u) => {
    const d = _v(e, u, i);
    return c.top = Wn(d.top, c.top), c.right = Yi(d.right, c.right), c.bottom = Yi(d.bottom, c.bottom), c.left = Wn(d.left, c.left), c;
  }, _v(e, s, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function FG(t) {
  return E8(t);
}
function UG(t, e, n) {
  const r = Dn(e), i = vi(e), o = n === "fixed", a = ko(t, !0, o, e);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Zi(0);
  if (r || !r && !o)
    if ((Ki(e) !== "body" || oc(i)) && (s = Fd(e)), r) {
      const c = ko(e, !0, o, e);
      l.x = c.x + e.clientLeft, l.y = c.y + e.clientTop;
    } else
      i && (l.x = M8(i));
  return {
    x: a.left + s.scrollLeft - l.x,
    y: a.top + s.scrollTop - l.y,
    width: a.width,
    height: a.height
  };
}
function Cv(t, e) {
  return !Dn(t) || Yn(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function A8(t, e) {
  const n = Gn(t);
  if (!Dn(t))
    return n;
  let r = Cv(t, e);
  for (; r && MG(r) && Yn(r).position === "static"; )
    r = Cv(r, e);
  return r && (Ki(r) === "html" || Ki(r) === "body" && Yn(r).position === "static" && !Yp(r)) ? n : r || TG(t) || n;
}
const zG = async function(t) {
  let {
    reference: e,
    floating: n,
    strategy: r
  } = t;
  const i = this.getOffsetParent || A8, o = this.getDimensions;
  return {
    reference: UG(e, await i(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await o(n)
    }
  };
};
function HG(t) {
  return Yn(t).direction === "rtl";
}
const BG = {
  convertOffsetParentRelativeRectToViewportRelativeRect: RG,
  getDocumentElement: vi,
  getClippingRect: IG,
  getOffsetParent: A8,
  getElementRects: zG,
  getClientRects: LG,
  getDimensions: FG,
  getScale: qa,
  isElement: Xt,
  isRTL: HG
};
function VG(t, e) {
  let n = null, r;
  const i = vi(t);
  function o() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function a(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), o();
    const {
      left: c,
      top: u,
      width: d,
      height: f
    } = t.getBoundingClientRect();
    if (s || e(), !d || !f)
      return;
    const h = Ac(u), v = Ac(i.clientWidth - (c + d)), g = Ac(i.clientHeight - (u + f)), m = Ac(c), y = {
      rootMargin: -h + "px " + -v + "px " + -g + "px " + -m + "px",
      threshold: Wn(0, Yi(1, l)) || 1
    };
    let b = !0;
    function x(_) {
      const M = _[0].intersectionRatio;
      if (M !== l) {
        if (!b)
          return a();
        M ? a(!1, M) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 100);
      }
      b = !1;
    }
    try {
      n = new IntersectionObserver(x, {
        ...y,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(x, y);
    }
    n.observe(t);
  }
  return a(!0), o;
}
function Ud(t, e, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = Kp(t), u = i || o ? [...c ? Po(c) : [], ...Po(e)] : [];
  u.forEach((p) => {
    i && p.addEventListener("scroll", n, {
      passive: !0
    }), o && p.addEventListener("resize", n);
  });
  const d = c && s ? VG(c, n) : null;
  let f = -1, h = null;
  a && (h = new ResizeObserver((p) => {
    let [y] = p;
    y && y.target === c && h && (h.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      h && h.observe(e);
    })), n();
  }), c && !l && h.observe(c), h.observe(e));
  let v, g = l ? ko(t) : null;
  l && m();
  function m() {
    const p = ko(t);
    g && (p.x !== g.x || p.y !== g.y || p.width !== g.width || p.height !== g.height) && n(), g = p, v = requestAnimationFrame(m);
  }
  return n(), () => {
    u.forEach((p) => {
      i && p.removeEventListener("scroll", n), o && p.removeEventListener("resize", n);
    }), d && d(), h && h.disconnect(), h = null, l && cancelAnimationFrame(v);
  };
}
const $G = (t, e, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: BG,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return EG(t, e, {
    ...i,
    platform: o
  });
}, P8 = (t) => {
  function e(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof t == "function" ? t(n) : t;
      return r && e(r) ? r.current != null ? bv({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? bv({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
};
var mu = typeof document < "u" ? fd : Dt;
function ju(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, r, i;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n != e.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!ju(t[r], e[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(t), n = i.length, n !== Object.keys(e).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(e, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const o = i[r];
      if (!(o === "_owner" && t.$$typeof) && !ju(t[o], e[o]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function R8(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ev(t, e) {
  const n = R8(t);
  return Math.round(e * n) / n;
}
function Sv(t) {
  const e = C.useRef(t);
  return mu(() => {
    e.current = t;
  }), e;
}
function Jp(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: o,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = t, [u, d] = C.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = C.useState(r);
  ju(f, r) || h(r);
  const [v, g] = C.useState(null), [m, p] = C.useState(null), y = C.useCallback((U) => {
    U != M.current && (M.current = U, g(U));
  }, [g]), b = C.useCallback((U) => {
    U !== S.current && (S.current = U, p(U));
  }, [p]), x = o || v, _ = a || m, M = C.useRef(null), S = C.useRef(null), P = C.useRef(u), E = Sv(l), w = Sv(i), O = C.useCallback(() => {
    if (!M.current || !S.current)
      return;
    const U = {
      placement: e,
      strategy: n,
      middleware: f
    };
    w.current && (U.platform = w.current), $G(M.current, S.current, U).then(($) => {
      const V = {
        ...$,
        isPositioned: !0
      };
      N.current && !ju(P.current, V) && (P.current = V, hd.flushSync(() => {
        d(V);
      }));
    });
  }, [f, e, n, w]);
  mu(() => {
    c === !1 && P.current.isPositioned && (P.current.isPositioned = !1, d((U) => ({
      ...U,
      isPositioned: !1
    })));
  }, [c]);
  const N = C.useRef(!1);
  mu(() => (N.current = !0, () => {
    N.current = !1;
  }), []), mu(() => {
    if (x && (M.current = x), _ && (S.current = _), x && _) {
      if (E.current)
        return E.current(x, _, O);
      O();
    }
  }, [x, _, O, E]);
  const I = C.useMemo(() => ({
    reference: M,
    floating: S,
    setReference: y,
    setFloating: b
  }), [y, b]), H = C.useMemo(() => ({
    reference: x,
    floating: _
  }), [x, _]), j = C.useMemo(() => {
    const U = {
      position: n,
      left: 0,
      top: 0
    };
    if (!H.floating)
      return U;
    const $ = Ev(H.floating, u.x), V = Ev(H.floating, u.y);
    return s ? {
      ...U,
      transform: "translate(" + $ + "px, " + V + "px)",
      ...R8(H.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: $,
      top: V
    };
  }, [n, s, H.floating, u.x, u.y]);
  return C.useMemo(() => ({
    ...u,
    update: O,
    refs: I,
    elements: H,
    floatingStyles: j
  }), [u, O, I, H, j]);
}
function WG(t) {
  let e = t.activeElement;
  for (; ((n = e) == null || (r = n.shadowRoot) == null ? void 0 : r.activeElement) != null; ) {
    var n, r;
    e = e.shadowRoot.activeElement;
  }
  return e;
}
function Gu(t, e) {
  if (!t || !e)
    return !1;
  const n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && gh(n)) {
    let r = e;
    for (; r; ) {
      if (t === r)
        return !0;
      r = r.parentNode || r.host;
    }
  }
  return !1;
}
function jG() {
  const t = navigator.userAgentData;
  return t != null && t.platform ? t.platform : navigator.platform;
}
function GG() {
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? t.brands.map((e) => {
    let {
      brand: n,
      version: r
    } = e;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
function qG(t) {
  if (t.mozInputSource === 0 && t.isTrusted)
    return !0;
  const e = /Android/i;
  return (e.test(jG()) || e.test(GG())) && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function XG(t) {
  return t.width === 0 && t.height === 0 || t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType !== "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  t.width < 1 && t.height < 1 && t.pressure === 0 && t.detail === 0;
}
function Mv(t, e) {
  const n = ["mouse", "pen"];
  return e || n.push("", void 0), n.includes(t);
}
function YG(t) {
  return "nativeEvent" in t;
}
function ZG(t) {
  return t.matches("html,body");
}
function hl(t) {
  return (t == null ? void 0 : t.ownerDocument) || document;
}
function vu(t, e) {
  if (e == null)
    return !1;
  if ("composedPath" in t)
    return t.composedPath().includes(e);
  const n = t;
  return n.target != null && e.contains(n.target);
}
function KG(t) {
  return "composedPath" in t ? t.composedPath()[0] : t.target;
}
const JG = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function QG(t) {
  return Dn(t) && t.matches(JG);
}
var L8 = typeof document < "u" ? fd : Dt;
let Wf = !1, eq = 0;
const Tv = () => "floating-ui-" + eq++;
function tq() {
  const [t, e] = C.useState(() => Wf ? Tv() : void 0);
  return L8(() => {
    t == null && e(Tv());
  }, []), C.useEffect(() => {
    Wf || (Wf = !0);
  }, []), t;
}
const nq = C[/* @__PURE__ */ "useId".toString()], rq = nq || tq;
function iq() {
  const t = /* @__PURE__ */ new Map();
  return {
    emit(e, n) {
      var r;
      (r = t.get(e)) == null || r.forEach((i) => i(n));
    },
    on(e, n) {
      t.set(e, [...t.get(e) || [], n]);
    },
    off(e, n) {
      var r;
      t.set(e, ((r = t.get(e)) == null ? void 0 : r.filter((i) => i !== n)) || []);
    }
  };
}
const oq = /* @__PURE__ */ C.createContext(null), aq = /* @__PURE__ */ C.createContext(null), sq = () => {
  var t;
  return ((t = C.useContext(oq)) == null ? void 0 : t.id) || null;
}, O8 = () => C.useContext(aq);
function D8(t) {
  return "data-floating-ui-" + t;
}
function jf(t, e) {
  let n = t.filter((i) => {
    var o;
    return i.parentId === e && ((o = i.context) == null ? void 0 : o.open);
  }), r = n;
  for (; r.length; )
    r = t.filter((i) => {
      var o;
      return (o = r) == null ? void 0 : o.some((a) => {
        var s;
        return i.parentId === a.id && ((s = i.context) == null ? void 0 : s.open);
      });
    }), n = n.concat(r);
  return n;
}
function Av(t) {
  return Dn(t.target) && t.target.tagName === "BUTTON";
}
function Pv(t) {
  return QG(t);
}
function k8(t, e) {
  e === void 0 && (e = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: i,
    elements: {
      domReference: o
    }
  } = t, {
    enabled: a = !0,
    event: s = "click",
    toggle: l = !0,
    ignoreMouse: c = !1,
    keyboardHandlers: u = !0
  } = e, d = C.useRef(), f = C.useRef(!1);
  return C.useMemo(() => a ? {
    reference: {
      onPointerDown(h) {
        d.current = h.pointerType;
      },
      onMouseDown(h) {
        h.button === 0 && (Mv(d.current, !0) && c || s !== "click" && (n && l && (!i.current.openEvent || i.current.openEvent.type === "mousedown") ? r(!1, h.nativeEvent) : (h.preventDefault(), r(!0, h.nativeEvent))));
      },
      onClick(h) {
        if (s === "mousedown" && d.current) {
          d.current = void 0;
          return;
        }
        Mv(d.current, !0) && c || (n && l && (!i.current.openEvent || i.current.openEvent.type === "click") ? r(!1, h.nativeEvent) : r(!0, h.nativeEvent));
      },
      onKeyDown(h) {
        d.current = void 0, !(h.defaultPrevented || !u || Av(h)) && (h.key === " " && !Pv(o) && (h.preventDefault(), f.current = !0), h.key === "Enter" && r(!(n && l), h.nativeEvent));
      },
      onKeyUp(h) {
        h.defaultPrevented || !u || Av(h) || Pv(o) || h.key === " " && f.current && (f.current = !1, r(!(n && l), h.nativeEvent));
      }
    }
  } : {}, [a, i, s, c, u, o, l, n, r]);
}
const lq = C[/* @__PURE__ */ "useInsertionEffect".toString()], cq = lq || ((t) => t());
function gu(t) {
  const e = C.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return cq(() => {
    e.current = t;
  }), C.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return e.current == null ? void 0 : e.current(...r);
  }, []);
}
const uq = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, dq = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, fq = (t) => {
  var e, n;
  return {
    escapeKeyBubbles: typeof t == "boolean" ? t : (e = t == null ? void 0 : t.escapeKey) != null ? e : !1,
    outsidePressBubbles: typeof t == "boolean" ? t : (n = t == null ? void 0 : t.outsidePress) != null ? n : !0
  };
};
function N8(t, e) {
  e === void 0 && (e = {});
  const {
    open: n,
    onOpenChange: r,
    events: i,
    nodeId: o,
    elements: {
      reference: a,
      domReference: s,
      floating: l
    },
    dataRef: c
  } = t, {
    enabled: u = !0,
    escapeKey: d = !0,
    outsidePress: f = !0,
    outsidePressEvent: h = "pointerdown",
    referencePress: v = !1,
    referencePressEvent: g = "pointerdown",
    ancestorScroll: m = !1,
    bubbles: p
  } = e, y = O8(), b = sq() != null, x = gu(typeof f == "function" ? f : () => !1), _ = typeof f == "function" ? x : f, M = C.useRef(!1), {
    escapeKeyBubbles: S,
    outsidePressBubbles: P
  } = fq(p), E = gu((O) => {
    if (!n || !u || !d || O.key !== "Escape")
      return;
    const N = y ? jf(y.nodesRef.current, o) : [];
    if (!S && (O.stopPropagation(), N.length > 0)) {
      let I = !0;
      if (N.forEach((H) => {
        var j;
        if ((j = H.context) != null && j.open && !H.context.dataRef.current.__escapeKeyBubbles) {
          I = !1;
          return;
        }
      }), !I)
        return;
    }
    i.emit("dismiss", {
      type: "escapeKey",
      data: {
        returnFocus: {
          preventScroll: !1
        }
      }
    }), r(!1, YG(O) ? O.nativeEvent : O);
  }), w = gu((O) => {
    const N = M.current;
    if (M.current = !1, N || typeof _ == "function" && !_(O))
      return;
    const I = KG(O), H = "[" + D8("inert") + "]", j = hl(l).querySelectorAll(H);
    let U = Xt(I) ? I : null;
    for (; U && !ac(U); ) {
      const te = Do(U);
      if (te === hl(l).body || !Xt(te))
        break;
      U = te;
    }
    if (j.length && Xt(I) && !ZG(I) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !Gu(I, l) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(j).every((te) => !Gu(U, te)))
      return;
    if (Dn(I) && l) {
      const te = I.clientWidth > 0 && I.scrollWidth > I.clientWidth, B = I.clientHeight > 0 && I.scrollHeight > I.clientHeight;
      let Z = B && O.offsetX > I.clientWidth;
      if (B && Yn(I).direction === "rtl" && (Z = O.offsetX <= I.offsetWidth - I.clientWidth), Z || te && O.offsetY > I.clientHeight)
        return;
    }
    const $ = y && jf(y.nodesRef.current, o).some((te) => {
      var B;
      return vu(O, (B = te.context) == null ? void 0 : B.elements.floating);
    });
    if (vu(O, l) || vu(O, s) || $)
      return;
    const V = y ? jf(y.nodesRef.current, o) : [];
    if (V.length > 0) {
      let te = !0;
      if (V.forEach((B) => {
        var Z;
        if ((Z = B.context) != null && Z.open && !B.context.dataRef.current.__outsidePressBubbles) {
          te = !1;
          return;
        }
      }), !te)
        return;
    }
    i.emit("dismiss", {
      type: "outsidePress",
      data: {
        returnFocus: b ? {
          preventScroll: !0
        } : qG(O) || XG(O)
      }
    }), r(!1, O);
  });
  return C.useEffect(() => {
    if (!n || !u)
      return;
    c.current.__escapeKeyBubbles = S, c.current.__outsidePressBubbles = P;
    function O(H) {
      r(!1, H);
    }
    const N = hl(l);
    d && N.addEventListener("keydown", E), _ && N.addEventListener(h, w);
    let I = [];
    return m && (Xt(s) && (I = Po(s)), Xt(l) && (I = I.concat(Po(l))), !Xt(a) && a && a.contextElement && (I = I.concat(Po(a.contextElement)))), I = I.filter((H) => {
      var j;
      return H !== ((j = N.defaultView) == null ? void 0 : j.visualViewport);
    }), I.forEach((H) => {
      H.addEventListener("scroll", O, {
        passive: !0
      });
    }), () => {
      d && N.removeEventListener("keydown", E), _ && N.removeEventListener(h, w), I.forEach((H) => {
        H.removeEventListener("scroll", O);
      });
    };
  }, [c, l, s, a, d, _, h, n, r, m, u, S, P, E, w]), C.useEffect(() => {
    M.current = !1;
  }, [_, h]), C.useMemo(() => u ? {
    reference: {
      onKeyDown: E,
      [uq[g]]: (O) => {
        v && (i.emit("dismiss", {
          type: "referencePress",
          data: {
            returnFocus: !1
          }
        }), r(!1, O.nativeEvent));
      }
    },
    floating: {
      onKeyDown: E,
      [dq[h]]: () => {
        M.current = !0;
      }
    }
  } : {}, [u, i, v, h, g, r, E]);
}
let yh;
process.env.NODE_ENV !== "production" && (yh = /* @__PURE__ */ new Set());
function I8(t) {
  var e;
  t === void 0 && (t = {});
  const {
    open: n = !1,
    onOpenChange: r,
    nodeId: i
  } = t;
  if (process.env.NODE_ENV !== "production") {
    var o;
    const S = "Floating UI: Cannot pass a virtual element to the `elements.reference` option, as it must be a real DOM element. Use `refs.setPositionReference` instead.";
    if ((o = t.elements) != null && o.reference && !Xt(t.elements.reference)) {
      var a;
      if (!((a = yh) != null && a.has(S))) {
        var s;
        (s = yh) == null || s.add(S), console.error(S);
      }
    }
  }
  const [l, c] = C.useState(null), u = ((e = t.elements) == null ? void 0 : e.reference) || l, d = Jp(t), f = O8(), h = gu((S, P) => {
    S && (g.current.openEvent = P), r == null || r(S, P);
  }), v = C.useRef(null), g = C.useRef({}), m = C.useState(() => iq())[0], p = rq(), y = C.useCallback((S) => {
    const P = Xt(S) ? {
      getBoundingClientRect: () => S.getBoundingClientRect(),
      contextElement: S
    } : S;
    d.refs.setReference(P);
  }, [d.refs]), b = C.useCallback((S) => {
    (Xt(S) || S === null) && (v.current = S, c(S)), (Xt(d.refs.reference.current) || d.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    S !== null && !Xt(S)) && d.refs.setReference(S);
  }, [d.refs]), x = C.useMemo(() => ({
    ...d.refs,
    setReference: b,
    setPositionReference: y,
    domReference: v
  }), [d.refs, b, y]), _ = C.useMemo(() => ({
    ...d.elements,
    domReference: u
  }), [d.elements, u]), M = C.useMemo(() => ({
    ...d,
    refs: x,
    elements: _,
    dataRef: g,
    nodeId: i,
    floatingId: p,
    events: m,
    open: n,
    onOpenChange: h
  }), [d, i, p, m, n, h, x, _]);
  return L8(() => {
    const S = f == null ? void 0 : f.nodesRef.current.find((P) => P.id === i);
    S && (S.context = M);
  }), C.useMemo(() => ({
    ...d,
    context: M,
    refs: x,
    elements: _
  }), [d, x, _, M]);
}
function hq(t, e) {
  e === void 0 && (e = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: i,
    events: o,
    refs: a,
    elements: {
      floating: s,
      domReference: l
    }
  } = t, {
    enabled: c = !0,
    keyboardOnly: u = !0
  } = e, d = C.useRef(""), f = C.useRef(!1), h = C.useRef();
  return C.useEffect(() => {
    if (!c)
      return;
    const g = hl(s).defaultView || window;
    function m() {
      !n && Dn(l) && l === WG(hl(l)) && (f.current = !0);
    }
    return g.addEventListener("blur", m), () => {
      g.removeEventListener("blur", m);
    };
  }, [s, l, n, c]), C.useEffect(() => {
    if (!c)
      return;
    function v(g) {
      (g.type === "referencePress" || g.type === "escapeKey") && (f.current = !0);
    }
    return o.on("dismiss", v), () => {
      o.off("dismiss", v);
    };
  }, [o, c]), C.useEffect(() => () => {
    clearTimeout(h.current);
  }, []), C.useMemo(() => c ? {
    reference: {
      onPointerDown(v) {
        let {
          pointerType: g
        } = v;
        d.current = g, f.current = !!(g && u);
      },
      onMouseLeave() {
        f.current = !1;
      },
      onFocus(v) {
        var g;
        f.current || v.type === "focus" && ((g = i.current.openEvent) == null ? void 0 : g.type) === "mousedown" && vu(i.current.openEvent, l) || r(!0, v.nativeEvent);
      },
      onBlur(v) {
        f.current = !1;
        const g = v.relatedTarget, m = Xt(g) && g.hasAttribute(D8("focus-guard")) && g.getAttribute("data-type") === "outside";
        h.current = setTimeout(() => {
          Gu(a.floating.current, g) || Gu(l, g) || m || r(!1, v.nativeEvent);
        });
      }
    }
  } : {}, [c, u, l, a, i, r]);
}
function Gf(t, e, n) {
  const r = /* @__PURE__ */ new Map();
  return {
    ...n === "floating" && {
      tabIndex: -1
    },
    ...t,
    ...e.map((i) => i ? i[n] : null).concat(t).reduce((i, o) => (o && Object.entries(o).forEach((a) => {
      let [s, l] = a;
      if (s.indexOf("on") === 0) {
        if (r.has(s) || r.set(s, []), typeof l == "function") {
          var c;
          (c = r.get(s)) == null || c.push(l), i[s] = function() {
            for (var u, d = arguments.length, f = new Array(d), h = 0; h < d; h++)
              f[h] = arguments[h];
            return (u = r.get(s)) == null ? void 0 : u.map((v) => v(...f)).find((v) => v !== void 0);
          };
        }
      } else
        i[s] = l;
    }), i), {})
  };
}
function F8(t) {
  t === void 0 && (t = []);
  const e = t, n = C.useCallback(
    (o) => Gf(o, t, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  ), r = C.useCallback(
    (o) => Gf(o, t, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  ), i = C.useCallback(
    (o) => Gf(o, t, "item"),
    // Granularly check for `item` changes, because the `getItemProps` getter
    // should be as referentially stable as possible since it may be passed as
    // a prop to many components. All `item` key values must therefore be
    // memoized.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t.map((o) => o == null ? void 0 : o.item)
  );
  return C.useMemo(() => ({
    getReferenceProps: n,
    getFloatingProps: r,
    getItemProps: i
  }), [n, r, i]);
}
const pq = ({ className: t, children: e, ...n }) => /* @__PURE__ */ R.jsx(
  "li",
  {
    className: ve(
      "color-neutral-600",
      "cursor-pointer",
      "flex-nowrap",
      "flex",
      "items-center",
      "justify-between",
      "px-2",
      "py-2px",
      "rounded-2px",
      "typo-text-s",
      "hover:bg-neutral-200",
      "hover:color-neutral-800",
      "hover:typo-text-s-em",
      "[&.disabled]:color-neutral-400",
      "[&.disabled]:hover:bg-transparent",
      "[&.disabled]:hover:color-neutral-400",
      "[&.disabled]:hover:typo-text-s",
      t
    ),
    ...n,
    children: e
  }
), mq = ({
  className: t,
  disabled: e,
  hint: n,
  label: r,
  onChange: i,
  options: o,
  placeholder: a,
  tail: s,
  value: l,
  width: c = "auto",
  xPlacement: u = "left",
  yPlacement: d = "bottom",
  warn: f,
  filterSlot: h,
  fallbackStrategy: v = "initialPlacement",
  ...g
}) => {
  const [m, p] = Ke(!1), [y, b] = Ke(l ?? null), x = Pn(() => o.find((te) => te.key === y) ?? null, [y, o]), _ = Pn(() => `${d}-${u === "left" ? "start" : "end"}`, [u, d]), M = Id({ fallbackStrategy: v }), S = Xp({
    apply({ availableWidth: te, availableHeight: B, elements: Z }) {
      Object.assign(Z.floating.style, {
        maxWidth: `${te}px`,
        maxHeight: `${Math.max(40, B)}px`
      });
    }
  }), P = v === "bestFit" ? [M, S] : [S, M], { refs: E, floatingStyles: w, context: O } = I8({
    middleware: P,
    onOpenChange: p,
    open: m,
    placement: _,
    whileElementsMounted: Ud
  }), N = k8(O, { enabled: !e }), I = N8(O), { getFloatingProps: H, getReferenceProps: j } = F8([N, I]), U = Gt(
    (te) => {
      const B = o.find((Z) => Z.key === te);
      B != null && B.disabled || (b((B == null ? void 0 : B.key) || null), p(!1), i == null || i(te));
    },
    [i, o]
  );
  Dt(() => {
    b(l ?? null);
  }, [l]);
  const $ = Pn(() => x && x.tail ? x.tail : s === void 0 ? /* @__PURE__ */ R.jsx("div", { className: ve("color-neutral-400", "i-skand-dropdown", "m-l-4") }) : s || null, [x, s]), V = !!x;
  return /* @__PURE__ */ R.jsxs(
    "div",
    {
      className: ve("group/select", "relative", "inline-block", e && "disabled", t),
      ...g,
      children: [
        /* @__PURE__ */ R.jsxs(
          "label",
          {
            className: ve(
              "transition-colors",
              "border-1",
              "border-solid",
              "flex-nowrap",
              "flex-row",
              "flex",
              "items-center",
              "justify-between",
              "p-x-3",
              "p-y-2",
              "rounded-1",
              "typo-text-s",
              "color-neutral-600",
              "cursor-pointer",
              e && f && "border-alert-300 bg-neutral-300",
              e && !f && "bg-neutral-300 border-neutral-300",
              f && !e && "border-alert-300 bg-neutral-100",
              !e && !f && "bg-neutral-100 border-neutral-400"
            ),
            ref: E.setReference,
            tabIndex: 0,
            ...j(),
            children: [
              V ? /* @__PURE__ */ R.jsxs("div", { children: [
                r && /* @__PURE__ */ R.jsx("div", { className: ve("typo-text-xxs", "color-neutral-800"), children: r }),
                /* @__PURE__ */ R.jsx("div", { className: ve("typo-text-s", "color-neutral-600"), children: x == null ? void 0 : x.name })
              ] }) : /* @__PURE__ */ R.jsx("div", { children: r ? /* @__PURE__ */ R.jsx("span", { className: ve("typo-text-s", "color-neutral-600"), children: r }) : a && /* @__PURE__ */ R.jsx("span", { className: ve("typo-text-s", "color-neutral-400"), children: a }) }),
              $
            ]
          }
        ),
        n && /* @__PURE__ */ R.jsx(
          "span",
          {
            className: ve(
              "m-t-1 transition-colors typo-text-xs",
              f ? "color-alert-300" : "color-neutral-600"
            ),
            children: n
          }
        ),
        !e && m && /* @__PURE__ */ R.jsxs(
          "ul",
          {
            className: ve(
              "absolute",
              "bg-neutral-100",
              "border-1",
              "border-neutral-400",
              "border-solid",
              "list-none",
              "overflow-auto",
              "p-1",
              "rounded-1",
              "z-1",
              (c === "full" || o.length === 0) && "w-full"
            ),
            ref: E.setFloating,
            style: w,
            tabIndex: 0,
            ...H(),
            children: [
              h,
              o.length === 0 && /* @__PURE__ */ R.jsx(
                "li",
                {
                  className: ve(
                    "color-neutral-400",
                    "flex-nowrap",
                    "flex",
                    "items-center",
                    "justify-between",
                    "px-2",
                    "py-2px",
                    "rounded-2px",
                    "typo-text-s"
                  ),
                  onClick: () => p(!1),
                  children: "No options"
                }
              ),
              o.map((te) => /* @__PURE__ */ R.jsxs(
                pq,
                {
                  className: ve("transition-colors", te.disabled && "disabled"),
                  onClick: () => U(te.key),
                  children: [
                    /* @__PURE__ */ R.jsx("div", { className: "whitespace-nowrap", children: te.name }),
                    /* @__PURE__ */ R.jsx("div", { children: te.tail })
                  ]
                },
                te.key
              ))
            ]
          }
        )
      ]
    }
  );
}, vq = [
  { name: "Red", color: "#D04A6B" },
  { name: "Orange", color: "#F69C64" },
  { name: "Green", color: "#4CB176" },
  { name: "Blue", color: "#3F8AE2" },
  { name: "Purple", color: "#8A1AE3" },
  { name: "Grey", color: "#8A858E" },
  { name: "White", color: "#FFFFFF" }
].map((t) => ({
  ...t,
  key: t.color,
  tail: /* @__PURE__ */ R.jsx(
    "div",
    {
      className: ve(
        "w-3",
        "h-3",
        "ml-4",
        "rounded-full",
        t.color === "#FFFFFF" && "ring-1 ring-inset ring-neutral-300"
      ),
      style: { background: t.color }
    }
  )
})), ohe = ({ label: t = "Colour", value: e, ...n }) => {
  const r = [...vq];
  return e && !r.find((i) => i.key === e) && r.push({
    key: e,
    name: e,
    color: e,
    tail: /* @__PURE__ */ R.jsx("div", { className: ve("w-3", "h-3", "ml-4", "rounded-full"), style: { background: e } })
  }), /* @__PURE__ */ R.jsx(
    mq,
    {
      label: t,
      options: r,
      tail: /* @__PURE__ */ R.jsx("div", { className: "i-skand-colors" }),
      value: e,
      ...n
    }
  );
}, gq = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Qp = (t, e, n) => {
  let r;
  const i = gq[t];
  return typeof i == "string" ? r = i : e === 1 ? r = i.one : r = i.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function oi(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const yq = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, bq = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, xq = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, wq = {
  date: oi({
    formats: yq,
    defaultWidth: "full"
  }),
  time: oi({
    formats: bq,
    defaultWidth: "full"
  }),
  dateTime: oi({
    formats: xq,
    defaultWidth: "full"
  })
}, _q = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, e2 = (t, e, n, r) => _q[t];
function Ws(t) {
  return (e, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let i;
    if (r === "formatting" && t.formattingValues) {
      const a = t.defaultFormattingWidth || t.defaultWidth, s = n != null && n.width ? String(n.width) : a;
      i = t.formattingValues[s] || t.formattingValues[a];
    } else {
      const a = t.defaultWidth, s = n != null && n.width ? String(n.width) : t.defaultWidth;
      i = t.values[s] || t.values[a];
    }
    const o = t.argumentCallback ? t.argumentCallback(e) : e;
    return i[o];
  };
}
const Cq = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Eq = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Sq = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Mq = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Tq = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Aq = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Pq = (t, e) => {
  const n = Number(t), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, t2 = {
  ordinalNumber: Pq,
  era: Ws({
    values: Cq,
    defaultWidth: "wide"
  }),
  quarter: Ws({
    values: Eq,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: Ws({
    values: Sq,
    defaultWidth: "wide"
  }),
  day: Ws({
    values: Mq,
    defaultWidth: "wide"
  }),
  dayPeriod: Ws({
    values: Tq,
    defaultWidth: "wide",
    formattingValues: Aq,
    defaultFormattingWidth: "wide"
  })
};
function js(t) {
  return (e, n = {}) => {
    const r = n.width, i = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], o = e.match(i);
    if (!o)
      return null;
    const a = o[0], s = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(s) ? Lq(s, (d) => d.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      Rq(s, (d) => d.test(a))
    );
    let c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = e.slice(a.length);
    return { value: c, rest: u };
  };
}
function Rq(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function Lq(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function Oq(t) {
  return (e, n = {}) => {
    const r = e.match(t.matchPattern);
    if (!r)
      return null;
    const i = r[0], o = e.match(t.parsePattern);
    if (!o)
      return null;
    let a = t.valueCallback ? t.valueCallback(o[0]) : o[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const s = e.slice(i.length);
    return { value: a, rest: s };
  };
}
const Dq = /^(\d+)(th|st|nd|rd)?/i, kq = /\d+/i, Nq = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Iq = {
  any: [/^b/i, /^(a|c)/i]
}, Fq = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Uq = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, zq = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Hq = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Bq = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Vq = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, $q = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Wq = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, n2 = {
  ordinalNumber: Oq({
    matchPattern: Dq,
    parsePattern: kq,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: js({
    matchPatterns: Nq,
    defaultMatchWidth: "wide",
    parsePatterns: Iq,
    defaultParseWidth: "any"
  }),
  quarter: js({
    matchPatterns: Fq,
    defaultMatchWidth: "wide",
    parsePatterns: Uq,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: js({
    matchPatterns: zq,
    defaultMatchWidth: "wide",
    parsePatterns: Hq,
    defaultParseWidth: "any"
  }),
  day: js({
    matchPatterns: Bq,
    defaultMatchWidth: "wide",
    parsePatterns: Vq,
    defaultParseWidth: "any"
  }),
  dayPeriod: js({
    matchPatterns: $q,
    defaultMatchWidth: "any",
    parsePatterns: Wq,
    defaultParseWidth: "any"
  })
}, jq = {
  code: "en-AU",
  formatDistance: Qp,
  formatLong: wq,
  formatRelative: e2,
  localize: t2,
  match: n2,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Gq = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, qq = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Xq = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Yq = {
  date: oi({
    formats: Gq,
    defaultWidth: "full"
  }),
  time: oi({
    formats: qq,
    defaultWidth: "full"
  }),
  dateTime: oi({
    formats: Xq,
    defaultWidth: "full"
  })
}, Zq = {
  code: "en-GB",
  formatDistance: Qp,
  formatLong: Yq,
  formatRelative: e2,
  localize: t2,
  match: n2,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Kq = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Jq = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Qq = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, eX = {
  date: oi({
    formats: Kq,
    defaultWidth: "full"
  }),
  time: oi({
    formats: Jq,
    defaultWidth: "full"
  }),
  dateTime: oi({
    formats: Qq,
    defaultWidth: "full"
  })
}, U8 = {
  code: "en-US",
  formatDistance: Qp,
  formatLong: eX,
  formatRelative: e2,
  localize: t2,
  match: n2,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, tX = () => window.navigator.language, nX = {
  "en-US": U8,
  "en-AU": jq,
  "en-GB": Zq
}, rX = (t) => {
  const e = tX(), n = nX[e];
  return n || (t ?? void 0);
};
let iX = {};
function zd() {
  return iX;
}
const z8 = 6048e5, oX = 864e5, H8 = 6e4, B8 = 36e5;
function lr(t) {
  const e = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && e === "[object Date]" ? new t.constructor(+t) : typeof t == "number" || e === "[object Number]" || typeof t == "string" || e === "[object String]" ? new Date(t) : /* @__PURE__ */ new Date(NaN);
}
function Rv(t) {
  const e = lr(t);
  return e.setHours(0, 0, 0, 0), e;
}
function Lv(t) {
  const e = lr(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function aX(t, e) {
  const n = Rv(t), r = Rv(e), i = +n - Lv(n), o = +r - Lv(r);
  return Math.round((i - o) / oX);
}
function No(t, e) {
  return t instanceof Date ? new t.constructor(e) : new Date(e);
}
function sX(t) {
  const e = lr(t), n = No(t, 0);
  return n.setFullYear(e.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function lX(t) {
  const e = lr(t);
  return aX(e, sX(e)) + 1;
}
function Dl(t, e) {
  var s, l, c, u;
  const n = zd(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, i = lr(t), o = i.getDay(), a = (o < r ? 7 : 0) + o - r;
  return i.setDate(i.getDate() - a), i.setHours(0, 0, 0, 0), i;
}
function qu(t) {
  return Dl(t, { weekStartsOn: 1 });
}
function V8(t) {
  const e = lr(t), n = e.getFullYear(), r = No(t, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const i = qu(r), o = No(t, 0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  const a = qu(o);
  return e.getTime() >= i.getTime() ? n + 1 : e.getTime() >= a.getTime() ? n : n - 1;
}
function cX(t) {
  const e = V8(t), n = No(t, 0);
  return n.setFullYear(e, 0, 4), n.setHours(0, 0, 0, 0), qu(n);
}
function uX(t) {
  const e = lr(t), n = +qu(e) - +cX(e);
  return Math.round(n / z8) + 1;
}
function $8(t, e) {
  var u, d, f, h;
  const n = lr(t), r = n.getFullYear(), i = zd(), o = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((d = (u = e == null ? void 0 : e.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((h = (f = i.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, a = No(t, 0);
  a.setFullYear(r + 1, 0, o), a.setHours(0, 0, 0, 0);
  const s = Dl(a, e), l = No(t, 0);
  l.setFullYear(r, 0, o), l.setHours(0, 0, 0, 0);
  const c = Dl(l, e);
  return n.getTime() >= s.getTime() ? r + 1 : n.getTime() >= c.getTime() ? r : r - 1;
}
function dX(t, e) {
  var s, l, c, u;
  const n = zd(), r = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, i = $8(t, e), o = No(t, 0);
  return o.setFullYear(i, 0, r), o.setHours(0, 0, 0, 0), Dl(o, e);
}
function fX(t, e) {
  const n = lr(t), r = +Dl(n, e) - +dX(n, e);
  return Math.round(r / z8) + 1;
}
function ct(t, e) {
  const n = t < 0 ? "-" : "", r = Math.abs(t).toString().padStart(e, "0");
  return n + r;
}
const wi = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), r = n > 0 ? n : 1 - n;
    return ct(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : ct(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return ct(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return ct(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return ct(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return ct(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return ct(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, r = t.getMilliseconds(), i = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return ct(i, e.length);
  }
}, ea = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Ov = {
  // Era
  G: function(t, e, n) {
    const r = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const r = t.getFullYear(), i = r > 0 ? r : 1 - r;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return wi.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, r) {
    const i = $8(t, r), o = i > 0 ? i : 1 - i;
    if (e === "YY") {
      const a = o % 100;
      return ct(a, 2);
    }
    return e === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : ct(o, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = V8(t);
    return ct(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return ct(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "Q":
        return String(r);
      case "QQ":
        return ct(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "q":
        return String(r);
      case "qq":
        return ct(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return wi.M(t, e);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      case "L":
        return String(r + 1);
      case "LL":
        return ct(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, r) {
    const i = fX(t, r);
    return e === "wo" ? n.ordinalNumber(i, { unit: "week" }) : ct(i, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const r = uX(t);
    return e === "Io" ? n.ordinalNumber(r, { unit: "week" }) : ct(r, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : wi.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const r = lX(t);
    return e === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : ct(r, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const r = t.getDay();
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, r) {
    const i = t.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "e":
        return String(o);
      case "ee":
        return ct(o, 2);
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, r) {
    const i = t.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "c":
        return String(o);
      case "cc":
        return ct(o, e.length);
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const r = t.getDay(), i = r === 0 ? 7 : r;
    switch (e) {
      case "i":
        return String(i);
      case "ii":
        return ct(i, e.length);
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const i = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const r = t.getHours();
    let i;
    switch (r === 12 ? i = ea.noon : r === 0 ? i = ea.midnight : i = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const r = t.getHours();
    let i;
    switch (r >= 17 ? i = ea.evening : r >= 12 ? i = ea.afternoon : r >= 4 ? i = ea.morning : i = ea.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let r = t.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return wi.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : wi.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const r = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : ct(r, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let r = t.getHours();
    return r === 0 && (r = 24), e === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : ct(r, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : wi.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : wi.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return wi.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const r = t.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      case "X":
        return kv(r);
      case "XXXX":
      case "XX":
        return _o(r);
      case "XXXXX":
      case "XXX":
      default:
        return _o(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      case "x":
        return kv(r);
      case "xxxx":
      case "xx":
        return _o(r);
      case "xxxxx":
      case "xxx":
      default:
        return _o(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Dv(r, ":");
      case "OOOO":
      default:
        return "GMT" + _o(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Dv(r, ":");
      case "zzzz":
      default:
        return "GMT" + _o(r, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const r = Math.trunc(t.getTime() / 1e3);
    return ct(r, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    const r = t.getTime();
    return ct(r, e.length);
  }
};
function Dv(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), i = Math.trunc(r / 60), o = r % 60;
  return o === 0 ? n + String(i) : n + String(i) + e + ct(o, 2);
}
function kv(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + ct(Math.abs(t) / 60, 2) : _o(t, e);
}
function _o(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), i = ct(Math.trunc(r / 60), 2), o = ct(r % 60, 2);
  return n + i + e + o;
}
const Nv = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, W8 = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, hX = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
  if (!i)
    return Nv(t, e);
  let o;
  switch (r) {
    case "P":
      o = e.dateTime({ width: "short" });
      break;
    case "PP":
      o = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = e.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", Nv(r, e)).replace("{{time}}", W8(i, e));
}, pX = {
  p: W8,
  P: hX
}, mX = /^D+$/, vX = /^Y+$/, gX = ["D", "DD", "YY", "YYYY"];
function yX(t) {
  return mX.test(t);
}
function bX(t) {
  return vX.test(t);
}
function xX(t, e, n) {
  const r = wX(t, e, n);
  if (console.warn(r), gX.includes(t))
    throw new RangeError(r);
}
function wX(t, e, n) {
  const r = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function _X(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function CX(t) {
  if (!_X(t) && typeof t != "number")
    return !1;
  const e = lr(t);
  return !isNaN(Number(e));
}
const EX = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, SX = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, MX = /^'([^]*?)'?$/, TX = /''/g, AX = /[a-zA-Z]/;
function PX(t, e, n) {
  var u, d, f, h, v, g, m, p;
  const r = zd(), i = (n == null ? void 0 : n.locale) ?? r.locale ?? U8, o = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((h = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, a = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (v = n == null ? void 0 : n.locale) == null ? void 0 : v.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((p = (m = r.locale) == null ? void 0 : m.options) == null ? void 0 : p.weekStartsOn) ?? 0, s = lr(t);
  if (!CX(s))
    throw new RangeError("Invalid time value");
  let l = e.match(SX).map((y) => {
    const b = y[0];
    if (b === "p" || b === "P") {
      const x = pX[b];
      return x(y, i.formatLong);
    }
    return y;
  }).join("").match(EX).map((y) => {
    if (y === "''")
      return { isToken: !1, value: "'" };
    const b = y[0];
    if (b === "'")
      return { isToken: !1, value: RX(y) };
    if (Ov[b])
      return { isToken: !0, value: y };
    if (b.match(AX))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + b + "`"
      );
    return { isToken: !1, value: y };
  });
  i.localize.preprocessor && (l = i.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: o,
    weekStartsOn: a,
    locale: i
  };
  return l.map((y) => {
    if (!y.isToken)
      return y.value;
    const b = y.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && bX(b) || !(n != null && n.useAdditionalDayOfYearTokens) && yX(b)) && xX(b, e, String(t));
    const x = Ov[b[0]];
    return x(s, b, i.localize, c);
  }).join("");
}
function RX(t) {
  const e = t.match(MX);
  return e ? e[1].replace(TX, "'") : t;
}
function LX(t, e) {
  const n = lr(t);
  if (isNaN(n.getTime()))
    throw new RangeError("Invalid time value");
  const r = (e == null ? void 0 : e.format) ?? "extended", i = (e == null ? void 0 : e.representation) ?? "complete";
  let o = "", a = "";
  const s = r === "extended" ? "-" : "", l = r === "extended" ? ":" : "";
  if (i !== "time") {
    const c = ct(n.getDate(), 2), u = ct(n.getMonth() + 1, 2);
    o = `${ct(n.getFullYear(), 4)}${s}${u}${s}${c}`;
  }
  if (i !== "date") {
    const c = n.getTimezoneOffset();
    if (c !== 0) {
      const g = Math.abs(c), m = ct(Math.trunc(g / 60), 2), p = ct(g % 60, 2);
      a = `${c < 0 ? "+" : "-"}${m}:${p}`;
    } else
      a = "Z";
    const u = ct(n.getHours(), 2), d = ct(n.getMinutes(), 2), f = ct(n.getSeconds(), 2), h = o === "" ? "" : "T", v = [u, d, f].join(l);
    o = `${o}${h}${v}${a}`;
  }
  return o;
}
function OX(t, e) {
  const n = (e == null ? void 0 : e.additionalDigits) ?? 2, r = IX(t);
  let i;
  if (r.date) {
    const l = FX(r.date, n);
    i = UX(l.restDateString, l.year);
  }
  if (!i || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const o = i.getTime();
  let a = 0, s;
  if (r.time && (a = zX(r.time), isNaN(a)))
    return /* @__PURE__ */ new Date(NaN);
  if (r.timezone) {
    if (s = HX(r.timezone), isNaN(s))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const l = new Date(o + a), c = /* @__PURE__ */ new Date(0);
    return c.setFullYear(
      l.getUTCFullYear(),
      l.getUTCMonth(),
      l.getUTCDate()
    ), c.setHours(
      l.getUTCHours(),
      l.getUTCMinutes(),
      l.getUTCSeconds(),
      l.getUTCMilliseconds()
    ), c;
  }
  return new Date(o + a + s);
}
const Pc = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, DX = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, kX = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, NX = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function IX(t) {
  const e = {}, n = t.split(Pc.dateTimeDelimiter);
  let r;
  if (n.length > 2)
    return e;
  if (/:/.test(n[0]) ? r = n[0] : (e.date = n[0], r = n[1], Pc.timeZoneDelimiter.test(e.date) && (e.date = t.split(Pc.timeZoneDelimiter)[0], r = t.substr(
    e.date.length,
    t.length
  ))), r) {
    const i = Pc.timezone.exec(r);
    i ? (e.time = r.replace(i[1], ""), e.timezone = i[1]) : e.time = r;
  }
  return e;
}
function FX(t, e) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"
  ), r = t.match(n);
  if (!r)
    return { year: NaN, restDateString: "" };
  const i = r[1] ? parseInt(r[1]) : null, o = r[2] ? parseInt(r[2]) : null;
  return {
    year: o === null ? i : o * 100,
    restDateString: t.slice((r[1] || r[2]).length)
  };
}
function UX(t, e) {
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  const n = t.match(DX);
  if (!n)
    return /* @__PURE__ */ new Date(NaN);
  const r = !!n[4], i = Gs(n[1]), o = Gs(n[2]) - 1, a = Gs(n[3]), s = Gs(n[4]), l = Gs(n[5]) - 1;
  if (r)
    return jX(e, s, l) ? BX(e, s, l) : /* @__PURE__ */ new Date(NaN);
  {
    const c = /* @__PURE__ */ new Date(0);
    return !$X(e, o, a) || !WX(e, i) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(e, o, Math.max(i, a)), c);
  }
}
function Gs(t) {
  return t ? parseInt(t) : 1;
}
function zX(t) {
  const e = t.match(kX);
  if (!e)
    return NaN;
  const n = qf(e[1]), r = qf(e[2]), i = qf(e[3]);
  return GX(n, r, i) ? n * B8 + r * H8 + i * 1e3 : NaN;
}
function qf(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function HX(t) {
  if (t === "Z")
    return 0;
  const e = t.match(NX);
  if (!e)
    return 0;
  const n = e[1] === "+" ? -1 : 1, r = parseInt(e[2]), i = e[3] && parseInt(e[3]) || 0;
  return qX(r, i) ? n * (r * B8 + i * H8) : NaN;
}
function BX(t, e, n) {
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  const i = r.getUTCDay() || 7, o = (e - 1) * 7 + n + 1 - i;
  return r.setUTCDate(r.getUTCDate() + o), r;
}
const VX = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function j8(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function $X(t, e, n) {
  return e >= 0 && e <= 11 && n >= 1 && n <= (VX[e] || (j8(t) ? 29 : 28));
}
function WX(t, e) {
  return e >= 1 && e <= (j8(t) ? 366 : 365);
}
function jX(t, e, n) {
  return e >= 1 && e <= 53 && n >= 0 && n <= 6;
}
function GX(t, e, n) {
  return t === 24 ? e === 0 && n === 0 : n >= 0 && n < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
}
function qX(t, e) {
  return e >= 0 && e <= 59;
}
const ahe = ({
  defaultValue: t,
  disabled: e,
  hint: n,
  label: r,
  onChange: i,
  placeholder: o,
  value: a,
  warn: s,
  startMonth: l,
  endMonth: c
}) => {
  const [u, d] = Ke(t ?? a ?? ""), [f, h] = Ke(!1), { refs: v, floatingStyles: g, context: m } = I8({
    middleware: [Id()],
    open: f,
    onOpenChange: h,
    placement: "bottom-end",
    whileElementsMounted: Ud
  }), p = k8(m, { toggle: !1, enabled: !e }), y = hq(m, { enabled: !e }), b = N8(m), { getReferenceProps: x, getFloatingProps: _ } = F8([p, y, b]), M = (E) => {
    const w = E === void 0 ? "" : LX(E);
    d(w), i == null || i(w), h(!1);
  }, S = Pn(() => {
    if (u === "")
      return "";
    const E = rX();
    return PX(new Date(u), "P", E ? { locale: E } : void 0);
  }, [u]), P = Pn(() => {
    if (u !== "")
      return OX(u);
  }, [u]);
  return /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    /* @__PURE__ */ R.jsxs("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ R.jsxs(
        "div",
        {
          className: ve(
            "transition-all",
            "bg-neutral-100",
            "border-1",
            "border-solid",
            "flex-nowrap",
            "flex-row",
            "flex",
            "items-center",
            "p-x-3",
            "p-y-2",
            "rounded-1",
            s ? "border-alert-300" : f ? "border-neutral-800" : "border-neutral-400",
            e && "bg-neutral-300"
          ),
          ref: v.setReference,
          tabIndex: 0,
          ...x(),
          children: [
            /* @__PURE__ */ R.jsxs("div", { className: "w-full flex flex-auto flex-row flex-wrap", children: [
              r && /* @__PURE__ */ R.jsx(
                "label",
                {
                  className: ve(
                    "transition-all",
                    "cursor-text",
                    S && ["color-neutral-800", "flex-auto", "typo-text-xxs", "w-full"],
                    S || r && o ? ["color-neutral-800", "flex-auto", "typo-text-xxs", "w-full"] : [
                      "color-neutral-600",
                      "flex-basis-auto",
                      "flex-grow-0",
                      "flex-shrink-0",
                      "typo-text-s"
                    ]
                  ),
                  children: r
                }
              ),
              !S && o && /* @__PURE__ */ R.jsx("span", { className: "color-neutral-400 typo-text-s", children: o }),
              S && /* @__PURE__ */ R.jsx(
                "span",
                {
                  className: ve(
                    "transition-colors",
                    "bg-transparent",
                    "border-0",
                    "flex-1",
                    "outline-none",
                    "typo-text-s",
                    s ? "color-neutral-400" : "color-neutral-600"
                  ),
                  children: S
                }
              )
            ] }),
            /* @__PURE__ */ R.jsx("div", { className: "i-skand-date cursor-pointer text-3 color-neutral-600" })
          ]
        }
      ),
      n && /* @__PURE__ */ R.jsx(
        "span",
        {
          className: ve("m-t-1", "typo-text-xs", s ? "color-alert-300" : "color-neutral-600"),
          children: n
        }
      )
    ] }),
    f && /* @__PURE__ */ R.jsx("div", { className: "z-1", ref: v.setFloating, style: g, ..._(), children: /* @__PURE__ */ R.jsx(
      X6,
      {
        endMonth: c,
        mode: "single",
        onSelect: M,
        selected: P,
        showOutsideDays: !0,
        startMonth: l
      }
    ) })
  ] });
}, XX = ve("group/dropdown", "relative", "inline-block"), YX = ve(
  "border-1",
  "border-solid",
  "flex-nowrap",
  "flex-row",
  "flex",
  "items-center",
  "justify-between",
  "p-x-3",
  "p-y-2",
  "rounded-1",
  "typo-text-s",
  "border-neutral-400",
  "bg-neutral-100",
  "color-neutral-600",
  "cursor-pointer",
  "group-focus-within/dropdown:bg-neutral-200",
  "group-focus/dropdown:bg-neutral-200",
  "group-[.disabled]/dropdown:border-neutral-300",
  "group-[.disabled]/dropdown:bg-neutral-300",
  "group-[.disabled]/dropdown:color-neutral-400",
  "group-[.disabled]/dropdown:cursor-not-allowed",
  "group-[.disabled]/dropdown:focus-within:bg-neutral-300",
  "group-[.disabled]/dropdown:focus:bg-neutral-300"
), ZX = ve(
  "absolute",
  "border-1",
  "border-neutral-400",
  "border-solid",
  "bg-neutral-100",
  "list-none",
  "m-y-1",
  "p-1",
  "rounded-1",
  "z-1",
  "[&.placement-right]:right-0",
  "[&.placement-top]:bottom-full",
  "invisible",
  "opacity-0",
  "group-focus-within/dropdown:opacity-100",
  "group-focus-within/dropdown:visible",
  "group-focus/dropdown:opacity-100",
  "group-focus/dropdown:visible",
  "group-[.disabled]/dropdown:invisible",
  "group-[.disabled]/dropdown:opacity-0",
  "group-[.disabled]/dropdown:focus-within:invisible",
  "group-[.disabled]/dropdown:focus-within:opacity-0",
  "group-[.disabled]/dropdown:focus:invisible",
  "group-[.disabled]/dropdown:focus:opacity-0"
), KX = ve("color-neutral-400", "i-skand-dropdown", "m-l-4");
ve(
  "color-neutral-600",
  "cursor-pointer",
  "first:m-t-0",
  "m-t-1",
  "typo-text-s"
);
const G8 = sr(
  ({
    children: t,
    label: e,
    disabled: n,
    className: r,
    tail: i,
    width: o = "auto",
    xPlacement: a = "left",
    yPlacement: s = "bottom",
    ...l
  }, c) => /* @__PURE__ */ R.jsxs("div", { className: ve(XX, n && "disabled", r), ...l, children: [
    /* @__PURE__ */ R.jsxs("label", { className: ve(YX), ref: c, tabIndex: 0, children: [
      e,
      i === null ? null : i === void 0 ? /* @__PURE__ */ R.jsx("div", { className: KX }) : i
    ] }),
    t && /* @__PURE__ */ R.jsx(
      "ul",
      {
        className: ve(
          ZX,
          o === "full" && "w-full",
          a === "right" && "placement-right",
          s === "top" && "placement-top"
        ),
        tabIndex: 0,
        children: t
      }
    )
  ] })
);
G8.displayName = "Dropdown";
G8.defaultProps = {
  disabled: !1
};
const she = ({ className: t, children: e, ...n }) => /* @__PURE__ */ R.jsx(
  "li",
  {
    className: ve(
      "color-neutral-600",
      "cursor-pointer",
      "typo-text-s",
      "px-2",
      "py-2px",
      "rounded-2px",
      "hover:bg-neutral-200",
      "hover:color-neutral-800",
      "hover:typo-text-s-em",
      t
    ),
    ...n,
    children: e
  }
);
function Xu() {
  return Xu = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Xu.apply(this, arguments);
}
function JX(t, e) {
  typeof t == "function" ? t(e) : t != null && (t.current = e);
}
function QX(...t) {
  return (e) => t.forEach(
    (n) => JX(n, e)
  );
}
const Hd = /* @__PURE__ */ sr((t, e) => {
  const { children: n, ...r } = t, i = ul.toArray(n), o = i.find(tY);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? ul.count(a) > 1 ? ul.only(null) : /* @__PURE__ */ Tl(a) ? a.props.children : null : l);
    return /* @__PURE__ */ K0(bh, Xu({}, r, {
      ref: e
    }), /* @__PURE__ */ Tl(a) ? /* @__PURE__ */ c6(a, void 0, s) : null);
  }
  return /* @__PURE__ */ K0(bh, Xu({}, r, {
    ref: e
  }), n);
});
Hd.displayName = "Slot";
const bh = /* @__PURE__ */ sr((t, e) => {
  const { children: n, ...r } = t;
  return /* @__PURE__ */ Tl(n) ? /* @__PURE__ */ c6(n, {
    ...nY(r, n.props),
    ref: e ? QX(e, n.ref) : n.ref
  }) : ul.count(n) > 1 ? ul.only(null) : null;
});
bh.displayName = "SlotClone";
const eY = ({ children: t }) => /* @__PURE__ */ K0(C_, null, t);
function tY(t) {
  return /* @__PURE__ */ Tl(t) && t.type === eY;
}
function nY(t, e) {
  const n = {
    ...e
  };
  for (const r in e) {
    const i = t[r], o = e[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = {
      ...i,
      ...o
    } : r === "className" && (n[r] = [
      i,
      o
    ].filter(Boolean).join(" "));
  }
  return {
    ...t,
    ...n
  };
}
const q8 = ({
  type: t = "info",
  message: e = "",
  clickToDismiss: n = !0,
  dismiss: r,
  props: { className: i, ...o } = {},
  size: a = "m"
}) => /* @__PURE__ */ R.jsxs(
  "div",
  {
    className: ve(
      "inline-flex items-center b-1 b-solid rounded-1",
      "shadow-[0px_2px_2px_0px_rgba(0,0,0,0.15)]",
      a === "m" && "px-2 py-1",
      a === "l" && "px-3 py-2",
      n && "cursor-pointer",
      t === "info" && "bg-info-100 b-info-400",
      t === "success" && "bg-success-100 b-success-400",
      (t === "warn" || t === "warning") && "bg-alert-100 b-alert-400",
      i
    ),
    onClick: n ? r : void 0,
    ...o,
    children: [
      /* @__PURE__ */ R.jsx(
        "div",
        {
          className: ve(
            t === "info" && "i-skand-info color-info-400",
            t === "success" && "i-skand-done color-success-400",
            (t === "warn" || t === "warning") && "i-skand-warn color-alert-400"
          )
        }
      ),
      /* @__PURE__ */ R.jsx(
        "span",
        {
          className: ve(
            "ml-2 color-neutral-800",
            a === "m" && "typo-text-xs",
            a === "l" && "typo-text-s"
          ),
          children: e
        }
      ),
      /* @__PURE__ */ R.jsx(
        "div",
        {
          className: ve(
            "i-skand-close cursor-pointer",
            "ml-2 color-neutral-600",
            a === "m" && "typo-text-xs",
            a === "l" && "typo-text-s",
            !n && "hidden"
          ),
          onClick: r
        }
      )
    ]
  }
), rY = (t) => new Promise((e) => {
  setTimeout(e, t);
});
let Rc;
const iY = new Uint8Array(16);
function oY() {
  if (!Rc && (Rc = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Rc))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Rc(iY);
}
const pn = [];
for (let t = 0; t < 256; ++t)
  pn.push((t + 256).toString(16).slice(1));
function aY(t, e = 0) {
  return (pn[t[e + 0]] + pn[t[e + 1]] + pn[t[e + 2]] + pn[t[e + 3]] + "-" + pn[t[e + 4]] + pn[t[e + 5]] + "-" + pn[t[e + 6]] + pn[t[e + 7]] + "-" + pn[t[e + 8]] + pn[t[e + 9]] + "-" + pn[t[e + 10]] + pn[t[e + 11]] + pn[t[e + 12]] + pn[t[e + 13]] + pn[t[e + 14]] + pn[t[e + 15]]).toLowerCase();
}
let Iv, Xf, Yf = 0, Zf = 0;
function sY(t, e, n) {
  let r = e && n || 0;
  const i = e || new Array(16);
  t = t || {};
  let o = t.node || Iv, a = t.clockseq !== void 0 ? t.clockseq : Xf;
  if (o == null || a == null) {
    const f = t.random || (t.rng || oY)();
    o == null && (o = Iv = [f[0] | 1, f[1], f[2], f[3], f[4], f[5]]), a == null && (a = Xf = (f[6] << 8 | f[7]) & 16383);
  }
  let s = t.msecs !== void 0 ? t.msecs : Date.now(), l = t.nsecs !== void 0 ? t.nsecs : Zf + 1;
  const c = s - Yf + (l - Zf) / 1e4;
  if (c < 0 && t.clockseq === void 0 && (a = a + 1 & 16383), (c < 0 || s > Yf) && t.nsecs === void 0 && (l = 0), l >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  Yf = s, Zf = l, Xf = a, s += 122192928e5;
  const u = ((s & 268435455) * 1e4 + l) % 4294967296;
  i[r++] = u >>> 24 & 255, i[r++] = u >>> 16 & 255, i[r++] = u >>> 8 & 255, i[r++] = u & 255;
  const d = s / 4294967296 * 1e4 & 268435455;
  i[r++] = d >>> 8 & 255, i[r++] = d & 255, i[r++] = d >>> 24 & 15 | 16, i[r++] = d >>> 16 & 255, i[r++] = a >>> 8 | 128, i[r++] = a & 255;
  for (let f = 0; f < 6; ++f)
    i[r + f] = o[f];
  return e || aY(i);
}
const Fv = (t) => {
  let e;
  const n = /* @__PURE__ */ new Set(), r = (l, c) => {
    const u = typeof l == "function" ? l(e) : l;
    if (!Object.is(u, e)) {
      const d = e;
      e = c ?? typeof u != "object" ? u : Object.assign({}, e, u), n.forEach((f) => f(e, d));
    }
  }, i = () => e, s = { setState: r, getState: i, subscribe: (l) => (n.add(l), () => n.delete(l)), destroy: () => {
    n.clear();
  } };
  return e = t(r, i, s), s;
}, lY = (t) => t ? Fv(t) : Fv;
var xh = { exports: {} }, Kf = {}, Lc = { exports: {} }, Jf = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Uv;
function cY() {
  if (Uv)
    return Jf;
  Uv = 1;
  var t = A;
  function e(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : e, r = t.useState, i = t.useEffect, o = t.useLayoutEffect, a = t.useDebugValue;
  function s(d, f) {
    var h = f(), v = r({ inst: { value: h, getSnapshot: f } }), g = v[0].inst, m = v[1];
    return o(function() {
      g.value = h, g.getSnapshot = f, l(g) && m({ inst: g });
    }, [d, h, f]), i(function() {
      return l(g) && m({ inst: g }), d(function() {
        l(g) && m({ inst: g });
      });
    }, [d]), a(h), h;
  }
  function l(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var h = f();
      return !n(d, h);
    } catch {
      return !0;
    }
  }
  function c(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : s;
  return Jf.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : u, Jf;
}
var Qf = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zv;
function uY() {
  return zv || (zv = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = A, e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(b) {
      {
        for (var x = arguments.length, _ = new Array(x > 1 ? x - 1 : 0), M = 1; M < x; M++)
          _[M - 1] = arguments[M];
        r("error", b, _);
      }
    }
    function r(b, x, _) {
      {
        var M = e.ReactDebugCurrentFrame, S = M.getStackAddendum();
        S !== "" && (x += "%s", _ = _.concat([S]));
        var P = _.map(function(E) {
          return String(E);
        });
        P.unshift("Warning: " + x), Function.prototype.apply.call(console[b], console, P);
      }
    }
    function i(b, x) {
      return b === x && (b !== 0 || 1 / b === 1 / x) || b !== b && x !== x;
    }
    var o = typeof Object.is == "function" ? Object.is : i, a = t.useState, s = t.useEffect, l = t.useLayoutEffect, c = t.useDebugValue, u = !1, d = !1;
    function f(b, x, _) {
      u || t.startTransition !== void 0 && (u = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var M = x();
      if (!d) {
        var S = x();
        o(M, S) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), d = !0);
      }
      var P = a({
        inst: {
          value: M,
          getSnapshot: x
        }
      }), E = P[0].inst, w = P[1];
      return l(function() {
        E.value = M, E.getSnapshot = x, h(E) && w({
          inst: E
        });
      }, [b, M, x]), s(function() {
        h(E) && w({
          inst: E
        });
        var O = function() {
          h(E) && w({
            inst: E
          });
        };
        return b(O);
      }, [b]), c(M), M;
    }
    function h(b) {
      var x = b.getSnapshot, _ = b.value;
      try {
        var M = x();
        return !o(_, M);
      } catch {
        return !0;
      }
    }
    function v(b, x, _) {
      return x();
    }
    var g = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", m = !g, p = m ? v : f, y = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : p;
    Qf.useSyncExternalStore = y, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Qf;
}
var Hv;
function X8() {
  return Hv || (Hv = 1, process.env.NODE_ENV === "production" ? Lc.exports = cY() : Lc.exports = uY()), Lc.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bv;
function dY() {
  if (Bv)
    return Kf;
  Bv = 1;
  var t = A, e = X8();
  function n(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var r = typeof Object.is == "function" ? Object.is : n, i = e.useSyncExternalStore, o = t.useRef, a = t.useEffect, s = t.useMemo, l = t.useDebugValue;
  return Kf.useSyncExternalStoreWithSelector = function(c, u, d, f, h) {
    var v = o(null);
    if (v.current === null) {
      var g = { hasValue: !1, value: null };
      v.current = g;
    } else
      g = v.current;
    v = s(function() {
      function p(M) {
        if (!y) {
          if (y = !0, b = M, M = f(M), h !== void 0 && g.hasValue) {
            var S = g.value;
            if (h(S, M))
              return x = S;
          }
          return x = M;
        }
        if (S = x, r(b, M))
          return S;
        var P = f(M);
        return h !== void 0 && h(S, P) ? S : (b = M, x = P);
      }
      var y = !1, b, x, _ = d === void 0 ? null : d;
      return [function() {
        return p(u());
      }, _ === null ? void 0 : function() {
        return p(_());
      }];
    }, [u, d, f, h]);
    var m = i(c, v[0], v[1]);
    return a(function() {
      g.hasValue = !0, g.value = m;
    }, [m]), l(m), m;
  }, Kf;
}
var e0 = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vv;
function fY() {
  return Vv || (Vv = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = A, e = X8();
    function n(u, d) {
      return u === d && (u !== 0 || 1 / u === 1 / d) || u !== u && d !== d;
    }
    var r = typeof Object.is == "function" ? Object.is : n, i = e.useSyncExternalStore, o = t.useRef, a = t.useEffect, s = t.useMemo, l = t.useDebugValue;
    function c(u, d, f, h, v) {
      var g = o(null), m;
      g.current === null ? (m = {
        hasValue: !1,
        value: null
      }, g.current = m) : m = g.current;
      var p = s(function() {
        var _ = !1, M, S, P = function(N) {
          if (!_) {
            _ = !0, M = N;
            var I = h(N);
            if (v !== void 0 && m.hasValue) {
              var H = m.value;
              if (v(H, I))
                return S = H, H;
            }
            return S = I, I;
          }
          var j = M, U = S;
          if (r(j, N))
            return U;
          var $ = h(N);
          return v !== void 0 && v(U, $) ? U : (M = N, S = $, $);
        }, E = f === void 0 ? null : f, w = function() {
          return P(d());
        }, O = E === null ? void 0 : function() {
          return P(E());
        };
        return [w, O];
      }, [d, f, h, v]), y = p[0], b = p[1], x = i(u, y, b);
      return a(function() {
        m.hasValue = !0, m.value = x;
      }, [x]), l(x), x;
    }
    e0.useSyncExternalStoreWithSelector = c, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), e0;
}
process.env.NODE_ENV === "production" ? xh.exports = dY() : xh.exports = fY();
var hY = xh.exports;
const pY = /* @__PURE__ */ q1(hY), { useSyncExternalStoreWithSelector: mY } = pY;
function vY(t, e = t.getState, n) {
  const r = mY(
    t.subscribe,
    t.getState,
    t.getServerState || t.getState,
    e,
    n
  );
  return E_(r), r;
}
const $v = (t) => {
  const e = typeof t == "function" ? lY(t) : t, n = (r, i) => vY(e, r, i);
  return Object.assign(n, e), n;
}, gY = (t) => t ? $v(t) : $v, r2 = gY()(() => ({
  toasts: []
})), yY = (t) => {
  r2.setState((e) => ({ toasts: e.toasts.filter((n) => n.id !== t) }));
}, lhe = (t = {}) => {
  const { body: e, id: n = sY(), lifespan: r, message: i, type: o, props: a, clickToDismiss: s } = t, l = () => yY(n);
  return r2.setState((c) => {
    const u = {
      body: e instanceof Function ? e(l) : e,
      clickToDismiss: s,
      dismiss: l,
      id: n,
      message: i instanceof Function ? i(l) : i,
      props: a,
      type: o
    };
    return { toasts: [...c.toasts, u] };
  }), r !== void 0 && rY(r).then(l), { id: n, dismiss: l };
}, che = ({ className: t, size: e, ...n }) => {
  const { toasts: r } = r2();
  return /* @__PURE__ */ R.jsx(
    "div",
    {
      className: ve("fixed bottom-18px right-18px flex flex-col items-end gap-2", t),
      ...n,
      children: r.map((i) => {
        const { body: o, clickToDismiss: a, dismiss: s, id: l, message: c, props: u, type: d } = i;
        return o || /* @__PURE__ */ R.jsx(
          q8,
          {
            clickToDismiss: a,
            dismiss: s,
            message: c,
            props: u,
            size: e,
            type: d
          },
          l
        );
      })
    }
  );
}, uhe = ({ asChild: t, ...e }) => {
  const n = t ? Hd : q8;
  return /* @__PURE__ */ R.jsx(n, { props: { className: "absolute left-3 top-3" }, type: "info", ...e });
}, dhe = ({ asChild: t, children: e, className: n, ...r }) => {
  const i = t ? Hd : "p";
  return /* @__PURE__ */ R.jsx(i, { className: ve("color-neutral-500 typo-text-l", n), ...r, children: e });
}, fhe = ({ asChild: t, children: e, className: n, ...r }) => {
  const i = t ? Hd : "p";
  return /* @__PURE__ */ R.jsx(i, { className: ve("color-neutral-500 typo-text-s", n), ...r, children: e });
}, bY = sr(
  ({ children: t, className: e, ...n }, r) => /* @__PURE__ */ R.jsx(
    "div",
    {
      className: ve("relative flex flex-col items-center gap-3 p-3 justify-center", e),
      ref: r,
      ...n,
      children: t
    }
  )
);
bY.displayName = "EmptyRoot";
var xY = C["useId".toString()] || (() => {
}), wY = 0;
function Xa(t) {
  const [e, n] = C.useState(xY());
  return li(() => {
    t || n((r) => r ?? String(wY++));
  }, [t]), t || (e ? `radix-${e}` : "");
}
function Y8(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Cr(t);
  C.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return e.addEventListener("keydown", r, { capture: !0 }), () => e.removeEventListener("keydown", r, { capture: !0 });
  }, [n, e]);
}
var _Y = "DismissableLayer", wh = "dismissableLayer.update", CY = "dismissableLayer.pointerDownOutside", EY = "dismissableLayer.focusOutside", Wv, Z8 = C.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), K8 = C.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = t, c = C.useContext(Z8), [u, d] = C.useState(null), f = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = C.useState({}), v = io(e, (S) => d(S)), g = Array.from(c.layers), [m] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), p = g.indexOf(m), y = u ? g.indexOf(u) : -1, b = c.layersWithOutsidePointerEventsDisabled.size > 0, x = y >= p, _ = TY((S) => {
      const P = S.target, E = [...c.branches].some((w) => w.contains(P));
      !x || E || (i == null || i(S), a == null || a(S), S.defaultPrevented || s == null || s());
    }, f), M = AY((S) => {
      const P = S.target;
      [...c.branches].some((w) => w.contains(P)) || (o == null || o(S), a == null || a(S), S.defaultPrevented || s == null || s());
    }, f);
    return Y8((S) => {
      y === c.layers.size - 1 && (r == null || r(S), !S.defaultPrevented && s && (S.preventDefault(), s()));
    }, f), C.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (Wv = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), jv(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = Wv);
        };
    }, [u, f, n, c]), C.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), jv());
    }, [u, c]), C.useEffect(() => {
      const S = () => h({});
      return document.addEventListener(wh, S), () => document.removeEventListener(wh, S);
    }, []), /* @__PURE__ */ R.jsx(
      Sr.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: b ? x ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: Ur(t.onFocusCapture, M.onFocusCapture),
        onBlurCapture: Ur(t.onBlurCapture, M.onBlurCapture),
        onPointerDownCapture: Ur(
          t.onPointerDownCapture,
          _.onPointerDownCapture
        )
      }
    );
  }
);
K8.displayName = _Y;
var SY = "DismissableLayerBranch", MY = C.forwardRef((t, e) => {
  const n = C.useContext(Z8), r = C.useRef(null), i = io(e, r);
  return C.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ R.jsx(Sr.div, { ...t, ref: i });
});
MY.displayName = SY;
function TY(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Cr(t), r = C.useRef(!1), i = C.useRef(() => {
  });
  return C.useEffect(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          J8(
            CY,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (e.removeEventListener("click", i.current), i.current = l, e.addEventListener("click", i.current, { once: !0 })) : l();
      } else
        e.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      e.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), e.removeEventListener("pointerdown", o), e.removeEventListener("click", i.current);
    };
  }, [e, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function AY(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Cr(t), r = C.useRef(!1);
  return C.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && J8(EY, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", i), () => e.removeEventListener("focusin", i);
  }, [e, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function jv() {
  const t = new CustomEvent(wh);
  document.dispatchEvent(t);
}
function J8(t, e, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: n });
  e && i.addEventListener(t, e, { once: !0 }), r ? lM(i, o) : i.dispatchEvent(o);
}
var t0 = "focusScope.autoFocusOnMount", n0 = "focusScope.autoFocusOnUnmount", Gv = { bubbles: !1, cancelable: !0 }, PY = "FocusScope", Q8 = C.forwardRef((t, e) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o,
    ...a
  } = t, [s, l] = C.useState(null), c = Cr(i), u = Cr(o), d = C.useRef(null), f = io(e, (g) => l(g)), h = C.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  C.useEffect(() => {
    if (r) {
      let g = function(b) {
        if (h.paused || !s)
          return;
        const x = b.target;
        s.contains(x) ? d.current = x : Li(d.current, { select: !0 });
      }, m = function(b) {
        if (h.paused || !s)
          return;
        const x = b.relatedTarget;
        x !== null && (s.contains(x) || Li(d.current, { select: !0 }));
      }, p = function(b) {
        if (document.activeElement === document.body)
          for (const _ of b)
            _.removedNodes.length > 0 && Li(s);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", m);
      const y = new MutationObserver(p);
      return s && y.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", m), y.disconnect();
      };
    }
  }, [r, s, h.paused]), C.useEffect(() => {
    if (s) {
      Xv.add(h);
      const g = document.activeElement;
      if (!s.contains(g)) {
        const p = new CustomEvent(t0, Gv);
        s.addEventListener(t0, c), s.dispatchEvent(p), p.defaultPrevented || (RY(NY(e7(s)), { select: !0 }), document.activeElement === g && Li(s));
      }
      return () => {
        s.removeEventListener(t0, c), setTimeout(() => {
          const p = new CustomEvent(n0, Gv);
          s.addEventListener(n0, u), s.dispatchEvent(p), p.defaultPrevented || Li(g ?? document.body, { select: !0 }), s.removeEventListener(n0, u), Xv.remove(h);
        }, 0);
      };
    }
  }, [s, c, u, h]);
  const v = C.useCallback(
    (g) => {
      if (!n && !r || h.paused)
        return;
      const m = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, p = document.activeElement;
      if (m && p) {
        const y = g.currentTarget, [b, x] = LY(y);
        b && x ? !g.shiftKey && p === x ? (g.preventDefault(), n && Li(b, { select: !0 })) : g.shiftKey && p === b && (g.preventDefault(), n && Li(x, { select: !0 })) : p === y && g.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ R.jsx(Sr.div, { tabIndex: -1, ...a, ref: f, onKeyDown: v });
});
Q8.displayName = PY;
function RY(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const r of t)
    if (Li(r, { select: e }), document.activeElement !== n)
      return;
}
function LY(t) {
  const e = e7(t), n = qv(e, t), r = qv(e.reverse(), t);
  return [n, r];
}
function e7(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    e.push(n.currentNode);
  return e;
}
function qv(t, e) {
  for (const n of t)
    if (!OY(n, { upTo: e }))
      return n;
}
function OY(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  for (; t; ) {
    if (e !== void 0 && t === e)
      return !1;
    if (getComputedStyle(t).display === "none")
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function DY(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function Li(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({ preventScroll: !0 }), t !== n && DY(t) && e && t.select();
  }
}
var Xv = kY();
function kY() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && (n == null || n.pause()), t = Yv(t, e), t.unshift(e);
    },
    remove(e) {
      var n;
      t = Yv(t, e), (n = t[0]) == null || n.resume();
    }
  };
}
function Yv(t, e) {
  const n = [...t], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function NY(t) {
  return t.filter((e) => e.tagName !== "A");
}
var IY = "Portal", t7 = C.forwardRef((t, e) => {
  var s;
  const { container: n, ...r } = t, [i, o] = C.useState(!1);
  li(() => o(!0), []);
  const a = n || i && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return a ? G1.createPortal(/* @__PURE__ */ R.jsx(Sr.div, { ...r, ref: e }), a) : null;
});
t7.displayName = IY;
var r0 = 0;
function FY() {
  C.useEffect(() => {
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", t[0] ?? Zv()), document.body.insertAdjacentElement("beforeend", t[1] ?? Zv()), r0++, () => {
      r0 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), r0--;
    };
  }, []);
}
function Zv() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.outline = "none", t.style.opacity = "0", t.style.position = "fixed", t.style.pointerEvents = "none", t;
}
var Dr = function() {
  return Dr = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, Dr.apply(this, arguments);
};
function n7(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function UY(t, e, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = e.length, o; r < i; r++)
      (o || !(r in e)) && (o || (o = Array.prototype.slice.call(e, 0, r)), o[r] = e[r]);
  return t.concat(o || Array.prototype.slice.call(e));
}
var yu = "right-scroll-bar-position", bu = "width-before-scroll-bar", zY = "with-scroll-bars-hidden", HY = "--removed-body-scroll-bar-size";
function i0(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function BY(t, e) {
  var n = Ke(function() {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = e, n.facade;
}
var VY = typeof window < "u" ? C.useLayoutEffect : C.useEffect, Kv = /* @__PURE__ */ new WeakMap();
function $Y(t, e) {
  var n = BY(e || null, function(r) {
    return t.forEach(function(i) {
      return i0(i, r);
    });
  });
  return VY(function() {
    var r = Kv.get(n);
    if (r) {
      var i = new Set(r), o = new Set(t), a = n.current;
      i.forEach(function(s) {
        o.has(s) || i0(s, null);
      }), o.forEach(function(s) {
        i.has(s) || i0(s, a);
      });
    }
    Kv.set(n, t);
  }, [t]), n;
}
function WY(t) {
  return t;
}
function jY(t, e) {
  e === void 0 && (e = WY);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : t;
    },
    useMedium: function(o) {
      var a = e(o, r);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(o);
      }
      n = {
        push: function(s) {
          return o(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(o), a = n;
      }
      var l = function() {
        var u = a;
        a = [], u.forEach(o);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          a.push(u), c();
        },
        filter: function(u) {
          return a = a.filter(u), n;
        }
      };
    }
  };
  return i;
}
function GY(t) {
  t === void 0 && (t = {});
  var e = jY(null);
  return e.options = Dr({ async: !0, ssr: !1 }, t), e;
}
var r7 = function(t) {
  var e = t.sideCar, n = n7(t, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = e.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return C.createElement(r, Dr({}, n));
};
r7.isSideCarExport = !0;
function qY(t, e) {
  return t.useMedium(e), r7;
}
var i7 = GY(), o0 = function() {
}, Bd = C.forwardRef(function(t, e) {
  var n = C.useRef(null), r = C.useState({
    onScrollCapture: o0,
    onWheelCapture: o0,
    onTouchMoveCapture: o0
  }), i = r[0], o = r[1], a = t.forwardProps, s = t.children, l = t.className, c = t.removeScrollBar, u = t.enabled, d = t.shards, f = t.sideCar, h = t.noIsolation, v = t.inert, g = t.allowPinchZoom, m = t.as, p = m === void 0 ? "div" : m, y = t.gapMode, b = n7(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), x = f, _ = $Y([n, e]), M = Dr(Dr({}, b), i);
  return C.createElement(
    C.Fragment,
    null,
    u && C.createElement(x, { sideCar: i7, removeScrollBar: c, shards: d, noIsolation: h, inert: v, setCallbacks: o, allowPinchZoom: !!g, lockRef: n, gapMode: y }),
    a ? C.cloneElement(C.Children.only(s), Dr(Dr({}, M), { ref: _ })) : C.createElement(p, Dr({}, M, { className: l, ref: _ }), s)
  );
});
Bd.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Bd.classNames = {
  fullWidth: bu,
  zeroRight: yu
};
var Jv, XY = function() {
  if (Jv)
    return Jv;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function YY() {
  if (!document)
    return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = XY();
  return e && t.setAttribute("nonce", e), t;
}
function ZY(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function KY(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var JY = function() {
  var t = 0, e = null;
  return {
    add: function(n) {
      t == 0 && (e = YY()) && (ZY(e, n), KY(e)), t++;
    },
    remove: function() {
      t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, QY = function() {
  var t = JY();
  return function(e, n) {
    C.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && n]);
  };
}, o7 = function() {
  var t = QY(), e = function(n) {
    var r = n.styles, i = n.dynamic;
    return t(r, i), null;
  };
  return e;
}, eZ = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, a0 = function(t) {
  return parseInt(t || "", 10) || 0;
}, tZ = function(t) {
  var e = window.getComputedStyle(document.body), n = e[t === "padding" ? "paddingLeft" : "marginLeft"], r = e[t === "padding" ? "paddingTop" : "marginTop"], i = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [a0(n), a0(r), a0(i)];
}, nZ = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return eZ;
  var e = tZ(t), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, r - n + e[2] - e[0])
  };
}, rZ = o7(), Ya = "data-scroll-locked", iZ = function(t, e, n, r) {
  var i = t.left, o = t.top, a = t.right, s = t.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(zY, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(Ya, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(yu, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(bu, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(yu, " .").concat(yu, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(bu, " .").concat(bu, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Ya, `] {
    `).concat(HY, ": ").concat(s, `px;
  }
`);
}, Qv = function() {
  var t = parseInt(document.body.getAttribute(Ya) || "0", 10);
  return isFinite(t) ? t : 0;
}, oZ = function() {
  C.useEffect(function() {
    return document.body.setAttribute(Ya, (Qv() + 1).toString()), function() {
      var t = Qv() - 1;
      t <= 0 ? document.body.removeAttribute(Ya) : document.body.setAttribute(Ya, t.toString());
    };
  }, []);
}, aZ = function(t) {
  var e = t.noRelative, n = t.noImportant, r = t.gapMode, i = r === void 0 ? "margin" : r;
  oZ();
  var o = C.useMemo(function() {
    return nZ(i);
  }, [i]);
  return C.createElement(rZ, { styles: iZ(o, !e, i, n ? "" : "!important") });
}, _h = !1;
if (typeof window < "u")
  try {
    var Oc = Object.defineProperty({}, "passive", {
      get: function() {
        return _h = !0, !0;
      }
    });
    window.addEventListener("test", Oc, Oc), window.removeEventListener("test", Oc, Oc);
  } catch {
    _h = !1;
  }
var ta = _h ? { passive: !1 } : !1, sZ = function(t) {
  return t.tagName === "TEXTAREA";
}, a7 = function(t, e) {
  if (!(t instanceof Element))
    return !1;
  var n = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    n[e] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !sZ(t) && n[e] === "visible")
  );
}, lZ = function(t) {
  return a7(t, "overflowY");
}, cZ = function(t) {
  return a7(t, "overflowX");
}, e4 = function(t, e) {
  var n = e.ownerDocument, r = e;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = s7(t, r);
    if (i) {
      var o = l7(t, r), a = o[1], s = o[2];
      if (a > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, uZ = function(t) {
  var e = t.scrollTop, n = t.scrollHeight, r = t.clientHeight;
  return [
    e,
    n,
    r
  ];
}, dZ = function(t) {
  var e = t.scrollLeft, n = t.scrollWidth, r = t.clientWidth;
  return [
    e,
    n,
    r
  ];
}, s7 = function(t, e) {
  return t === "v" ? lZ(e) : cZ(e);
}, l7 = function(t, e) {
  return t === "v" ? uZ(e) : dZ(e);
}, fZ = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, hZ = function(t, e, n, r, i) {
  var o = fZ(t, window.getComputedStyle(e).direction), a = o * r, s = n.target, l = e.contains(s), c = !1, u = a > 0, d = 0, f = 0;
  do {
    var h = l7(t, s), v = h[0], g = h[1], m = h[2], p = g - m - o * v;
    (v || p) && s7(t, s) && (d += p, f += v), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (e.contains(s) || e === s)
  );
  return (u && (i && Math.abs(d) < 1 || !i && a > d) || !u && (i && Math.abs(f) < 1 || !i && -a > f)) && (c = !0), c;
}, Dc = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, t4 = function(t) {
  return [t.deltaX, t.deltaY];
}, n4 = function(t) {
  return t && "current" in t ? t.current : t;
}, pZ = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, mZ = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, vZ = 0, na = [];
function gZ(t) {
  var e = C.useRef([]), n = C.useRef([0, 0]), r = C.useRef(), i = C.useState(vZ++)[0], o = C.useState(o7)[0], a = C.useRef(t);
  C.useEffect(function() {
    a.current = t;
  }, [t]), C.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var g = UY([t.lockRef.current], (t.shards || []).map(n4), !0).filter(Boolean);
      return g.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), g.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var s = C.useCallback(function(g, m) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !a.current.allowPinchZoom;
    var p = Dc(g), y = n.current, b = "deltaX" in g ? g.deltaX : y[0] - p[0], x = "deltaY" in g ? g.deltaY : y[1] - p[1], _, M = g.target, S = Math.abs(b) > Math.abs(x) ? "h" : "v";
    if ("touches" in g && S === "h" && M.type === "range")
      return !1;
    var P = e4(S, M);
    if (!P)
      return !0;
    if (P ? _ = S : (_ = S === "v" ? "h" : "v", P = e4(S, M)), !P)
      return !1;
    if (!r.current && "changedTouches" in g && (b || x) && (r.current = _), !_)
      return !0;
    var E = r.current || _;
    return hZ(E, m, g, E === "h" ? b : x, !0);
  }, []), l = C.useCallback(function(g) {
    var m = g;
    if (!(!na.length || na[na.length - 1] !== o)) {
      var p = "deltaY" in m ? t4(m) : Dc(m), y = e.current.filter(function(_) {
        return _.name === m.type && (_.target === m.target || m.target === _.shadowParent) && pZ(_.delta, p);
      })[0];
      if (y && y.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!y) {
        var b = (a.current.shards || []).map(n4).filter(Boolean).filter(function(_) {
          return _.contains(m.target);
        }), x = b.length > 0 ? s(m, b[0]) : !a.current.noIsolation;
        x && m.cancelable && m.preventDefault();
      }
    }
  }, []), c = C.useCallback(function(g, m, p, y) {
    var b = { name: g, delta: m, target: p, should: y, shadowParent: yZ(p) };
    e.current.push(b), setTimeout(function() {
      e.current = e.current.filter(function(x) {
        return x !== b;
      });
    }, 1);
  }, []), u = C.useCallback(function(g) {
    n.current = Dc(g), r.current = void 0;
  }, []), d = C.useCallback(function(g) {
    c(g.type, t4(g), g.target, s(g, t.lockRef.current));
  }, []), f = C.useCallback(function(g) {
    c(g.type, Dc(g), g.target, s(g, t.lockRef.current));
  }, []);
  C.useEffect(function() {
    return na.push(o), t.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, ta), document.addEventListener("touchmove", l, ta), document.addEventListener("touchstart", u, ta), function() {
      na = na.filter(function(g) {
        return g !== o;
      }), document.removeEventListener("wheel", l, ta), document.removeEventListener("touchmove", l, ta), document.removeEventListener("touchstart", u, ta);
    };
  }, []);
  var h = t.removeScrollBar, v = t.inert;
  return C.createElement(
    C.Fragment,
    null,
    v ? C.createElement(o, { styles: mZ(i) }) : null,
    h ? C.createElement(aZ, { gapMode: t.gapMode }) : null
  );
}
function yZ(t) {
  for (var e = null; t !== null; )
    t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
const bZ = qY(i7, gZ);
var c7 = C.forwardRef(function(t, e) {
  return C.createElement(Bd, Dr({}, t, { ref: e, sideCar: bZ }));
});
c7.classNames = Bd.classNames;
const u7 = c7;
var xZ = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, ra = /* @__PURE__ */ new WeakMap(), kc = /* @__PURE__ */ new WeakMap(), Nc = {}, s0 = 0, d7 = function(t) {
  return t && (t.host || d7(t.parentNode));
}, wZ = function(t, e) {
  return e.map(function(n) {
    if (t.contains(n))
      return n;
    var r = d7(n);
    return r && t.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, _Z = function(t, e, n, r) {
  var i = wZ(e, Array.isArray(t) ? t : [t]);
  Nc[n] || (Nc[n] = /* @__PURE__ */ new WeakMap());
  var o = Nc[n], a = [], s = /* @__PURE__ */ new Set(), l = new Set(i), c = function(d) {
    !d || s.has(d) || (s.add(d), c(d.parentNode));
  };
  i.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (s.has(f))
        u(f);
      else
        try {
          var h = f.getAttribute(r), v = h !== null && h !== "false", g = (ra.get(f) || 0) + 1, m = (o.get(f) || 0) + 1;
          ra.set(f, g), o.set(f, m), a.push(f), g === 1 && v && kc.set(f, !0), m === 1 && f.setAttribute(n, "true"), v || f.setAttribute(r, "true");
        } catch (p) {
          console.error("aria-hidden: cannot operate on ", f, p);
        }
    });
  };
  return u(e), s.clear(), s0++, function() {
    a.forEach(function(d) {
      var f = ra.get(d) - 1, h = o.get(d) - 1;
      ra.set(d, f), o.set(d, h), f || (kc.has(d) || d.removeAttribute(r), kc.delete(d)), h || d.removeAttribute(n);
    }), s0--, s0 || (ra = /* @__PURE__ */ new WeakMap(), ra = /* @__PURE__ */ new WeakMap(), kc = /* @__PURE__ */ new WeakMap(), Nc = {});
  };
}, f7 = function(t, e, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(t) ? t : [t]), i = e || xZ(t);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), _Z(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, i2 = "Dialog", [h7, hhe] = yd(i2), [CZ, Ar] = h7(i2), p7 = (t) => {
  const {
    __scopeDialog: e,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    modal: a = !0
  } = t, s = C.useRef(null), l = C.useRef(null), [c = !1, u] = $o({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ R.jsx(
    CZ,
    {
      scope: e,
      triggerRef: s,
      contentRef: l,
      contentId: Xa(),
      titleId: Xa(),
      descriptionId: Xa(),
      open: c,
      onOpenChange: u,
      onOpenToggle: C.useCallback(() => u((d) => !d), [u]),
      modal: a,
      children: n
    }
  );
};
p7.displayName = i2;
var m7 = "DialogTrigger", EZ = C.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = Ar(m7, n), o = io(e, i.triggerRef);
    return /* @__PURE__ */ R.jsx(
      Sr.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": s2(i.open),
        ...r,
        ref: o,
        onClick: Ur(t.onClick, i.onOpenToggle)
      }
    );
  }
);
EZ.displayName = m7;
var o2 = "DialogPortal", [SZ, v7] = h7(o2, {
  forceMount: void 0
}), g7 = (t) => {
  const { __scopeDialog: e, forceMount: n, children: r, container: i } = t, o = Ar(o2, e);
  return /* @__PURE__ */ R.jsx(SZ, { scope: e, forceMount: n, children: C.Children.map(r, (a) => /* @__PURE__ */ R.jsx(Yl, { present: n || o.open, children: /* @__PURE__ */ R.jsx(t7, { asChild: !0, container: i, children: a }) })) });
};
g7.displayName = o2;
var Yu = "DialogOverlay", y7 = C.forwardRef(
  (t, e) => {
    const n = v7(Yu, t.__scopeDialog), { forceMount: r = n.forceMount, ...i } = t, o = Ar(Yu, t.__scopeDialog);
    return o.modal ? /* @__PURE__ */ R.jsx(Yl, { present: r || o.open, children: /* @__PURE__ */ R.jsx(MZ, { ...i, ref: e }) }) : null;
  }
);
y7.displayName = Yu;
var MZ = C.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = Ar(Yu, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ R.jsx(u7, { as: K1, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ R.jsx(
        Sr.div,
        {
          "data-state": s2(i.open),
          ...r,
          ref: e,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Io = "DialogContent", b7 = C.forwardRef(
  (t, e) => {
    const n = v7(Io, t.__scopeDialog), { forceMount: r = n.forceMount, ...i } = t, o = Ar(Io, t.__scopeDialog);
    return /* @__PURE__ */ R.jsx(Yl, { present: r || o.open, children: o.modal ? /* @__PURE__ */ R.jsx(TZ, { ...i, ref: e }) : /* @__PURE__ */ R.jsx(AZ, { ...i, ref: e }) });
  }
);
b7.displayName = Io;
var TZ = C.forwardRef(
  (t, e) => {
    const n = Ar(Io, t.__scopeDialog), r = C.useRef(null), i = io(e, n.contentRef, r);
    return C.useEffect(() => {
      const o = r.current;
      if (o)
        return f7(o);
    }, []), /* @__PURE__ */ R.jsx(
      x7,
      {
        ...t,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Ur(t.onCloseAutoFocus, (o) => {
          var a;
          o.preventDefault(), (a = n.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: Ur(t.onPointerDownOutside, (o) => {
          const a = o.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || s) && o.preventDefault();
        }),
        onFocusOutside: Ur(
          t.onFocusOutside,
          (o) => o.preventDefault()
        )
      }
    );
  }
), AZ = C.forwardRef(
  (t, e) => {
    const n = Ar(Io, t.__scopeDialog), r = C.useRef(!1), i = C.useRef(!1);
    return /* @__PURE__ */ R.jsx(
      x7,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var a, s;
          (a = t.onCloseAutoFocus) == null || a.call(t, o), o.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), o.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (o) => {
          var l, c;
          (l = t.onInteractOutside) == null || l.call(t, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const a = o.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(a)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
        }
      }
    );
  }
), x7 = C.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, ...a } = t, s = Ar(Io, n), l = C.useRef(null), c = io(e, l);
    return FY(), /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
      /* @__PURE__ */ R.jsx(
        Q8,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: o,
          children: /* @__PURE__ */ R.jsx(
            K8,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": s2(s.open),
              ...a,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
        /* @__PURE__ */ R.jsx(OZ, { titleId: s.titleId }),
        /* @__PURE__ */ R.jsx(kZ, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), a2 = "DialogTitle", PZ = C.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = Ar(a2, n);
    return /* @__PURE__ */ R.jsx(Sr.h2, { id: i.titleId, ...r, ref: e });
  }
);
PZ.displayName = a2;
var w7 = "DialogDescription", RZ = C.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = Ar(w7, n);
    return /* @__PURE__ */ R.jsx(Sr.p, { id: i.descriptionId, ...r, ref: e });
  }
);
RZ.displayName = w7;
var _7 = "DialogClose", LZ = C.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = Ar(_7, n);
    return /* @__PURE__ */ R.jsx(
      Sr.button,
      {
        type: "button",
        ...r,
        ref: e,
        onClick: Ur(t.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
LZ.displayName = _7;
function s2(t) {
  return t ? "open" : "closed";
}
var C7 = "DialogTitleWarning", [phe, E7] = KS(C7, {
  contentName: Io,
  titleName: a2,
  docsSlug: "dialog"
}), OZ = ({ titleId: t }) => {
  const e = E7(C7), n = `\`${e.contentName}\` requires a \`${e.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${e.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${e.docsSlug}`;
  return C.useEffect(() => {
    t && (document.getElementById(t) || console.error(n));
  }, [n, t]), null;
}, DZ = "DialogDescriptionWarning", kZ = ({ contentRef: t, descriptionId: e }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${E7(DZ).contentName}}.`;
  return C.useEffect(() => {
    var o;
    const i = (o = t.current) == null ? void 0 : o.getAttribute("aria-describedby");
    e && i && (document.getElementById(e) || console.warn(r));
  }, [r, t, e]), null;
}, NZ = p7, IZ = g7, FZ = y7, UZ = b7;
const zZ = ({ open: t, children: e, className: n }) => /* @__PURE__ */ R.jsx(NZ, { open: t, children: /* @__PURE__ */ R.jsxs(IZ, { children: [
  /* @__PURE__ */ R.jsx(FZ, { className: "fixed inset-0 z-40 bg-black/50 backdrop-blur-sm" }),
  /* @__PURE__ */ R.jsx(
    UZ,
    {
      className: ve(
        "fixed outline-none left-1/2 top-1/2 z-50  -translate-x-1/2 -translate-y-1/2 shadow-lg border-1 border-neutral-400 rounded-md border-solid bg-neutral-100",
        n || "min-h-[128px] w-[650px] p-6 gap-6"
        // Note: This component removes default utility classes like `min-h`, `p`, etc, if overrides are provided via props. This is to ensure that user-defined values properly override defaults, as some Tailwind classes may not be overridden due to specificity when merged.
      ),
      children: e
    }
  )
] }) });
function Es(t, e = []) {
  let n = [];
  function r(o, a) {
    const s = C.createContext(a), l = n.length;
    n = [...n, a];
    function c(d) {
      const { scope: f, children: h, ...v } = d, g = (f == null ? void 0 : f[t][l]) || s, m = C.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ R.jsx(g.Provider, { value: m, children: h });
    }
    function u(d, f) {
      const h = (f == null ? void 0 : f[t][l]) || s, v = C.useContext(h);
      if (v)
        return v;
      if (a !== void 0)
        return a;
      throw new Error(`\`${d}\` must be used within \`${o}\``);
    }
    return c.displayName = o + "Provider", [c, u];
  }
  const i = () => {
    const o = n.map((a) => C.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[t]) || o;
      return C.useMemo(
        () => ({ [`__scope${t}`]: { ...s, [t]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = t, [r, HZ(i, ...e)];
}
function HZ(...t) {
  const e = t[0];
  if (t.length === 1)
    return e;
  const n = () => {
    const r = t.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: c }) => {
        const d = l(o)[`__scope${c}`];
        return { ...s, ...d };
      }, {});
      return C.useMemo(() => ({ [`__scope${e.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = e.scopeName, n;
}
function BZ(t, e) {
  typeof t == "function" ? t(e) : t != null && (t.current = e);
}
function S7(...t) {
  return (e) => t.forEach((n) => BZ(n, e));
}
function bn(...t) {
  return C.useCallback(S7(...t), t);
}
var Zu = C.forwardRef((t, e) => {
  const { children: n, ...r } = t, i = C.Children.toArray(n), o = i.find(VZ);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? C.Children.count(a) > 1 ? C.Children.only(null) : C.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ R.jsx(Ch, { ...r, ref: e, children: C.isValidElement(a) ? C.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ R.jsx(Ch, { ...r, ref: e, children: n });
});
Zu.displayName = "Slot";
var Ch = C.forwardRef((t, e) => {
  const { children: n, ...r } = t;
  if (C.isValidElement(n)) {
    const i = WZ(n);
    return C.cloneElement(n, {
      ...$Z(r, n.props),
      // @ts-ignore
      ref: e ? S7(e, i) : i
    });
  }
  return C.Children.count(n) > 1 ? C.Children.only(null) : null;
});
Ch.displayName = "SlotClone";
var M7 = ({ children: t }) => /* @__PURE__ */ R.jsx(R.Fragment, { children: t });
function VZ(t) {
  return C.isValidElement(t) && t.type === M7;
}
function $Z(t, e) {
  const n = { ...e };
  for (const r in e) {
    const i = t[r], o = e[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function WZ(t) {
  var r, i;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (i = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : i.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var jZ = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Zt = jZ.reduce((t, e) => {
  const n = C.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? Zu : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ R.jsx(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${e}`, { ...t, [e]: n };
}, {});
function GZ(t, e) {
  t && hd.flushSync(() => t.dispatchEvent(e));
}
var l2 = "Progress", c2 = 100, [qZ, mhe] = Es(l2), [XZ, YZ] = qZ(l2), T7 = C.forwardRef(
  (t, e) => {
    const {
      __scopeProgress: n,
      value: r = null,
      max: i,
      getValueLabel: o = ZZ,
      ...a
    } = t;
    (i || i === 0) && !r4(i) && console.error(KZ(`${i}`, "Progress"));
    const s = r4(i) ? i : c2;
    r !== null && !i4(r, s) && console.error(JZ(`${r}`, "Progress"));
    const l = i4(r, s) ? r : null, c = Ku(l) ? o(l, s) : void 0;
    return /* @__PURE__ */ R.jsx(XZ, { scope: n, value: l, max: s, children: /* @__PURE__ */ R.jsx(
      Zt.div,
      {
        "aria-valuemax": s,
        "aria-valuemin": 0,
        "aria-valuenow": Ku(l) ? l : void 0,
        "aria-valuetext": c,
        role: "progressbar",
        "data-state": R7(l, s),
        "data-value": l ?? void 0,
        "data-max": s,
        ...a,
        ref: e
      }
    ) });
  }
);
T7.displayName = l2;
var A7 = "ProgressIndicator", P7 = C.forwardRef(
  (t, e) => {
    const { __scopeProgress: n, ...r } = t, i = YZ(A7, n);
    return /* @__PURE__ */ R.jsx(
      Zt.div,
      {
        "data-state": R7(i.value, i.max),
        "data-value": i.value ?? void 0,
        "data-max": i.max,
        ...r,
        ref: e
      }
    );
  }
);
P7.displayName = A7;
function ZZ(t, e) {
  return `${Math.round(t / e * 100)}%`;
}
function R7(t, e) {
  return t == null ? "indeterminate" : t === e ? "complete" : "loading";
}
function Ku(t) {
  return typeof t == "number";
}
function r4(t) {
  return Ku(t) && !isNaN(t) && t > 0;
}
function i4(t, e) {
  return Ku(t) && !isNaN(t) && t <= e && t >= 0;
}
function KZ(t, e) {
  return `Invalid prop \`max\` of value \`${t}\` supplied to \`${e}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${c2}\`.`;
}
function JZ(t, e) {
  return `Invalid prop \`value\` of value \`${t}\` supplied to \`${e}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${c2} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var QZ = T7, eK = P7;
const L7 = sr(
  ({ animated: t, className: e, progress: n, v1: r, ...i }, o) => /* @__PURE__ */ R.jsx(
    QZ,
    {
      className: ve(
        "relative overflow-hidden h-2 rounded-full b-1 b-neutral-300 b-solid bg-neutral-100",
        e
      ),
      ref: o,
      ...i,
      children: /* @__PURE__ */ R.jsx(
        eK,
        {
          className: ve(
            t && "animate-pulse",
            r ? "bg-skandI-400" : "bg-primary-300",
            "h-full w-full flex-1 transition-all"
          ),
          style: { transform: `translateX(-${100 - Vn(0, 1, n) * 100}%)` }
        }
      )
    }
  )
);
L7.displayName = "Progress";
function O7(t, [e, n]) {
  return Math.min(n, Math.max(e, t));
}
function zt(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (t == null || t(i), n === !1 || !i.defaultPrevented)
      return e == null ? void 0 : e(i);
  };
}
var tK = C.createContext(void 0);
function u2(t) {
  const e = C.useContext(tK);
  return t || e || "ltr";
}
function D7(t) {
  const e = t + "CollectionProvider", [n, r] = Es(e), [i, o] = n(
    e,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (h) => {
    const { scope: v, children: g } = h, m = A.useRef(null), p = A.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ R.jsx(i, { scope: v, itemMap: p, collectionRef: m, children: g });
  };
  a.displayName = e;
  const s = t + "CollectionSlot", l = A.forwardRef(
    (h, v) => {
      const { scope: g, children: m } = h, p = o(s, g), y = bn(v, p.collectionRef);
      return /* @__PURE__ */ R.jsx(Zu, { ref: y, children: m });
    }
  );
  l.displayName = s;
  const c = t + "CollectionItemSlot", u = "data-radix-collection-item", d = A.forwardRef(
    (h, v) => {
      const { scope: g, children: m, ...p } = h, y = A.useRef(null), b = bn(v, y), x = o(c, g);
      return A.useEffect(() => (x.itemMap.set(y, { ref: y, ...p }), () => void x.itemMap.delete(y))), /* @__PURE__ */ R.jsx(Zu, { [u]: "", ref: b, children: m });
    }
  );
  d.displayName = c;
  function f(h) {
    const v = o(t + "CollectionConsumer", h);
    return A.useCallback(() => {
      const m = v.collectionRef.current;
      if (!m)
        return [];
      const p = Array.from(m.querySelectorAll(`[${u}]`));
      return Array.from(v.itemMap.values()).sort(
        (x, _) => p.indexOf(x.ref.current) - p.indexOf(_.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: a, Slot: l, ItemSlot: d },
    f,
    r
  ];
}
var k7 = ["PageUp", "PageDown"], N7 = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], I7 = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, Ss = "Slider", [Eh, nK, rK] = D7(Ss), [F7, vhe] = Es(Ss, [
  rK
]), [iK, Vd] = F7(Ss), U7 = C.forwardRef(
  (t, e) => {
    const {
      name: n,
      min: r = 0,
      max: i = 100,
      step: o = 1,
      orientation: a = "horizontal",
      disabled: s = !1,
      minStepsBetweenThumbs: l = 0,
      defaultValue: c = [r],
      value: u,
      onValueChange: d = () => {
      },
      onValueCommit: f = () => {
      },
      inverted: h = !1,
      ...v
    } = t, g = C.useRef(/* @__PURE__ */ new Set()), m = C.useRef(0), y = a === "horizontal" ? oK : aK, [b = [], x] = $o({
      prop: u,
      defaultProp: c,
      onChange: (w) => {
        var N;
        (N = [...g.current][m.current]) == null || N.focus(), d(w);
      }
    }), _ = C.useRef(b);
    function M(w) {
      const O = dK(b, w);
      E(w, O);
    }
    function S(w) {
      E(w, m.current);
    }
    function P() {
      const w = _.current[m.current];
      b[m.current] !== w && f(b);
    }
    function E(w, O, { commit: N } = { commit: !1 }) {
      const I = mK(o), H = vK(Math.round((w - r) / o) * o + r, I), j = O7(H, [r, i]);
      x((U = []) => {
        const $ = cK(U, j, O);
        if (pK($, l * o)) {
          m.current = $.indexOf(j);
          const V = String($) !== String(U);
          return V && N && f($), V ? $ : U;
        } else
          return U;
      });
    }
    return /* @__PURE__ */ R.jsx(
      iK,
      {
        scope: t.__scopeSlider,
        name: n,
        disabled: s,
        min: r,
        max: i,
        valueIndexToChangeRef: m,
        thumbs: g.current,
        values: b,
        orientation: a,
        children: /* @__PURE__ */ R.jsx(Eh.Provider, { scope: t.__scopeSlider, children: /* @__PURE__ */ R.jsx(Eh.Slot, { scope: t.__scopeSlider, children: /* @__PURE__ */ R.jsx(
          y,
          {
            "aria-disabled": s,
            "data-disabled": s ? "" : void 0,
            ...v,
            ref: e,
            onPointerDown: zt(v.onPointerDown, () => {
              s || (_.current = b);
            }),
            min: r,
            max: i,
            inverted: h,
            onSlideStart: s ? void 0 : M,
            onSlideMove: s ? void 0 : S,
            onSlideEnd: s ? void 0 : P,
            onHomeKeyDown: () => !s && E(r, 0, { commit: !0 }),
            onEndKeyDown: () => !s && E(i, b.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: w, direction: O }) => {
              if (!s) {
                const H = k7.includes(w.key) || w.shiftKey && N7.includes(w.key) ? 10 : 1, j = m.current, U = b[j], $ = o * H * O;
                E(U + $, j, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
U7.displayName = Ss;
var [z7, H7] = F7(Ss, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), oK = C.forwardRef(
  (t, e) => {
    const {
      min: n,
      max: r,
      dir: i,
      inverted: o,
      onSlideStart: a,
      onSlideMove: s,
      onSlideEnd: l,
      onStepKeyDown: c,
      ...u
    } = t, [d, f] = C.useState(null), h = bn(e, (b) => f(b)), v = C.useRef(), g = u2(i), m = g === "ltr", p = m && !o || !m && o;
    function y(b) {
      const x = v.current || d.getBoundingClientRect(), _ = [0, x.width], S = d2(_, p ? [n, r] : [r, n]);
      return v.current = x, S(b - x.left);
    }
    return /* @__PURE__ */ R.jsx(
      z7,
      {
        scope: t.__scopeSlider,
        startEdge: p ? "left" : "right",
        endEdge: p ? "right" : "left",
        direction: p ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ R.jsx(
          B7,
          {
            dir: g,
            "data-orientation": "horizontal",
            ...u,
            ref: h,
            style: {
              ...u.style,
              ["--radix-slider-thumb-transform"]: "translateX(-50%)"
            },
            onSlideStart: (b) => {
              const x = y(b.clientX);
              a == null || a(x);
            },
            onSlideMove: (b) => {
              const x = y(b.clientX);
              s == null || s(x);
            },
            onSlideEnd: () => {
              v.current = void 0, l == null || l();
            },
            onStepKeyDown: (b) => {
              const _ = I7[p ? "from-left" : "from-right"].includes(b.key);
              c == null || c({ event: b, direction: _ ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), aK = C.forwardRef(
  (t, e) => {
    const {
      min: n,
      max: r,
      inverted: i,
      onSlideStart: o,
      onSlideMove: a,
      onSlideEnd: s,
      onStepKeyDown: l,
      ...c
    } = t, u = C.useRef(null), d = bn(e, u), f = C.useRef(), h = !i;
    function v(g) {
      const m = f.current || u.current.getBoundingClientRect(), p = [0, m.height], b = d2(p, h ? [r, n] : [n, r]);
      return f.current = m, b(g - m.top);
    }
    return /* @__PURE__ */ R.jsx(
      z7,
      {
        scope: t.__scopeSlider,
        startEdge: h ? "bottom" : "top",
        endEdge: h ? "top" : "bottom",
        size: "height",
        direction: h ? 1 : -1,
        children: /* @__PURE__ */ R.jsx(
          B7,
          {
            "data-orientation": "vertical",
            ...c,
            ref: d,
            style: {
              ...c.style,
              ["--radix-slider-thumb-transform"]: "translateY(50%)"
            },
            onSlideStart: (g) => {
              const m = v(g.clientY);
              o == null || o(m);
            },
            onSlideMove: (g) => {
              const m = v(g.clientY);
              a == null || a(m);
            },
            onSlideEnd: () => {
              f.current = void 0, s == null || s();
            },
            onStepKeyDown: (g) => {
              const p = I7[h ? "from-bottom" : "from-top"].includes(g.key);
              l == null || l({ event: g, direction: p ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), B7 = C.forwardRef(
  (t, e) => {
    const {
      __scopeSlider: n,
      onSlideStart: r,
      onSlideMove: i,
      onSlideEnd: o,
      onHomeKeyDown: a,
      onEndKeyDown: s,
      onStepKeyDown: l,
      ...c
    } = t, u = Vd(Ss, n);
    return /* @__PURE__ */ R.jsx(
      Zt.span,
      {
        ...c,
        ref: e,
        onKeyDown: zt(t.onKeyDown, (d) => {
          d.key === "Home" ? (a(d), d.preventDefault()) : d.key === "End" ? (s(d), d.preventDefault()) : k7.concat(N7).includes(d.key) && (l(d), d.preventDefault());
        }),
        onPointerDown: zt(t.onPointerDown, (d) => {
          const f = d.target;
          f.setPointerCapture(d.pointerId), d.preventDefault(), u.thumbs.has(f) ? f.focus() : r(d);
        }),
        onPointerMove: zt(t.onPointerMove, (d) => {
          d.target.hasPointerCapture(d.pointerId) && i(d);
        }),
        onPointerUp: zt(t.onPointerUp, (d) => {
          const f = d.target;
          f.hasPointerCapture(d.pointerId) && (f.releasePointerCapture(d.pointerId), o(d));
        })
      }
    );
  }
), V7 = "SliderTrack", $7 = C.forwardRef(
  (t, e) => {
    const { __scopeSlider: n, ...r } = t, i = Vd(V7, n);
    return /* @__PURE__ */ R.jsx(
      Zt.span,
      {
        "data-disabled": i.disabled ? "" : void 0,
        "data-orientation": i.orientation,
        ...r,
        ref: e
      }
    );
  }
);
$7.displayName = V7;
var Sh = "SliderRange", W7 = C.forwardRef(
  (t, e) => {
    const { __scopeSlider: n, ...r } = t, i = Vd(Sh, n), o = H7(Sh, n), a = C.useRef(null), s = bn(e, a), l = i.values.length, c = i.values.map(
      (f) => G7(f, i.min, i.max)
    ), u = l > 1 ? Math.min(...c) : 0, d = 100 - Math.max(...c);
    return /* @__PURE__ */ R.jsx(
      Zt.span,
      {
        "data-orientation": i.orientation,
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: s,
        style: {
          ...t.style,
          [o.startEdge]: u + "%",
          [o.endEdge]: d + "%"
        }
      }
    );
  }
);
W7.displayName = Sh;
var Mh = "SliderThumb", j7 = C.forwardRef(
  (t, e) => {
    const n = nK(t.__scopeSlider), [r, i] = C.useState(null), o = bn(e, (s) => i(s)), a = C.useMemo(
      () => r ? n().findIndex((s) => s.ref.current === r) : -1,
      [n, r]
    );
    return /* @__PURE__ */ R.jsx(sK, { ...t, ref: o, index: a });
  }
), sK = C.forwardRef(
  (t, e) => {
    const { __scopeSlider: n, index: r, name: i, ...o } = t, a = Vd(Mh, n), s = H7(Mh, n), [l, c] = C.useState(null), u = bn(e, (y) => c(y)), d = l ? !!l.closest("form") : !0, f = bd(l), h = a.values[r], v = h === void 0 ? 0 : G7(h, a.min, a.max), g = uK(r, a.values.length), m = f == null ? void 0 : f[s.size], p = m ? fK(m, v, s.direction) : 0;
    return C.useEffect(() => {
      if (l)
        return a.thumbs.add(l), () => {
          a.thumbs.delete(l);
        };
    }, [l, a.thumbs]), /* @__PURE__ */ R.jsxs(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [s.startEdge]: `calc(${v}% + ${p}px)`
        },
        children: [
          /* @__PURE__ */ R.jsx(Eh.ItemSlot, { scope: t.__scopeSlider, children: /* @__PURE__ */ R.jsx(
            Zt.span,
            {
              role: "slider",
              "aria-label": t["aria-label"] || g,
              "aria-valuemin": a.min,
              "aria-valuenow": h,
              "aria-valuemax": a.max,
              "aria-orientation": a.orientation,
              "data-orientation": a.orientation,
              "data-disabled": a.disabled ? "" : void 0,
              tabIndex: a.disabled ? void 0 : 0,
              ...o,
              ref: u,
              style: h === void 0 ? { display: "none" } : t.style,
              onFocus: zt(t.onFocus, () => {
                a.valueIndexToChangeRef.current = r;
              })
            }
          ) }),
          d && /* @__PURE__ */ R.jsx(
            lK,
            {
              name: i ?? (a.name ? a.name + (a.values.length > 1 ? "[]" : "") : void 0),
              value: h
            },
            r
          )
        ]
      }
    );
  }
);
j7.displayName = Mh;
var lK = (t) => {
  const { value: e, ...n } = t, r = C.useRef(null), i = Z1(e);
  return C.useEffect(() => {
    const o = r.current, a = window.HTMLInputElement.prototype, l = Object.getOwnPropertyDescriptor(a, "value").set;
    if (i !== e && l) {
      const c = new Event("input", { bubbles: !0 });
      l.call(o, e), o.dispatchEvent(c);
    }
  }, [i, e]), /* @__PURE__ */ R.jsx("input", { style: { display: "none" }, ...n, ref: r, defaultValue: e });
};
function cK(t = [], e, n) {
  const r = [...t];
  return r[n] = e, r.sort((i, o) => i - o);
}
function G7(t, e, n) {
  const o = 100 / (n - e) * (t - e);
  return O7(o, [0, 100]);
}
function uK(t, e) {
  return e > 2 ? `Value ${t + 1} of ${e}` : e === 2 ? ["Minimum", "Maximum"][t] : void 0;
}
function dK(t, e) {
  if (t.length === 1)
    return 0;
  const n = t.map((i) => Math.abs(i - e)), r = Math.min(...n);
  return n.indexOf(r);
}
function fK(t, e, n) {
  const r = t / 2, o = d2([0, 50], [0, r]);
  return (r - o(e) * n) * n;
}
function hK(t) {
  return t.slice(0, -1).map((e, n) => t[n + 1] - e);
}
function pK(t, e) {
  if (e > 0) {
    const n = hK(t);
    return Math.min(...n) >= e;
  }
  return !0;
}
function d2(t, e) {
  return (n) => {
    if (t[0] === t[1] || e[0] === e[1])
      return e[0];
    const r = (e[1] - e[0]) / (t[1] - t[0]);
    return e[0] + r * (n - t[0]);
  };
}
function mK(t) {
  return (String(t).split(".")[1] || "").length;
}
function vK(t, e) {
  const n = Math.pow(10, e);
  return Math.round(t * n) / n;
}
var gK = U7, yK = $7, bK = W7, xK = j7;
const q7 = C.forwardRef(
  ({
    className: t,
    disabled: e = !1,
    max: n = 100,
    min: r = 0,
    value: i = [0],
    onValueChange: o,
    step: a = 1,
    onPointerDown: s,
    ...l
  }, c) => /* @__PURE__ */ R.jsxs(
    gK,
    {
      className: ve(
        "relative flex w-full touch-none select-none items-center",
        t,
        e && "opacity-50 cursor-not-allowed"
      ),
      disabled: e,
      max: n,
      min: r,
      onPointerDown: s,
      onValueChange: o,
      ref: c,
      step: a,
      value: i,
      ...l,
      children: [
        /* @__PURE__ */ R.jsx(yK, { className: "relative h-6px w-full grow overflow-hidden border border-neutral-400 rounded-full border-solid bg-neutral-100", children: /* @__PURE__ */ R.jsx(bK, { className: "absolute h-full bg-primary-300" }) }),
        /* @__PURE__ */ R.jsx(
          xK,
          {
            className: ve(
              "focus-visible:ring-ring block border border-neutral-400 rounded-full border-solid bg-neutral-100 ring-offset-primary-300 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
              "h-3.4 w-3.4",
              e && "pointer-events-none"
            )
          }
        )
      ]
    }
  )
);
q7.displayName = "Slider";
function X7(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: wK } = Object.prototype, { getPrototypeOf: f2 } = Object, $d = ((t) => (e) => {
  const n = wK.call(e);
  return t[n] || (t[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Pr = (t) => (t = t.toLowerCase(), (e) => $d(e) === t), Wd = (t) => (e) => typeof e === t, { isArray: Ms } = Array, kl = Wd("undefined");
function _K(t) {
  return t !== null && !kl(t) && t.constructor !== null && !kl(t.constructor) && or(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const Y7 = Pr("ArrayBuffer");
function CK(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && Y7(t.buffer), e;
}
const EK = Wd("string"), or = Wd("function"), Z7 = Wd("number"), jd = (t) => t !== null && typeof t == "object", SK = (t) => t === !0 || t === !1, xu = (t) => {
  if ($d(t) !== "object")
    return !1;
  const e = f2(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, MK = Pr("Date"), TK = Pr("File"), AK = Pr("Blob"), PK = Pr("FileList"), RK = (t) => jd(t) && or(t.pipe), LK = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || or(t.append) && ((e = $d(t)) === "formdata" || // detect form-data instance
  e === "object" && or(t.toString) && t.toString() === "[object FormData]"));
}, OK = Pr("URLSearchParams"), [DK, kK, NK, IK] = ["ReadableStream", "Request", "Response", "Headers"].map(Pr), FK = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function sc(t, e, { allOwnKeys: n = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let r, i;
  if (typeof t != "object" && (t = [t]), Ms(t))
    for (r = 0, i = t.length; r < i; r++)
      e.call(null, t[r], r, t);
  else {
    const o = n ? Object.getOwnPropertyNames(t) : Object.keys(t), a = o.length;
    let s;
    for (r = 0; r < a; r++)
      s = o[r], e.call(null, t[s], s, t);
  }
}
function K7(t, e) {
  e = e.toLowerCase();
  const n = Object.keys(t);
  let r = n.length, i;
  for (; r-- > 0; )
    if (i = n[r], e === i.toLowerCase())
      return i;
  return null;
}
const J7 = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), Q7 = (t) => !kl(t) && t !== J7;
function Th() {
  const { caseless: t } = Q7(this) && this || {}, e = {}, n = (r, i) => {
    const o = t && K7(e, i) || i;
    xu(e[o]) && xu(r) ? e[o] = Th(e[o], r) : xu(r) ? e[o] = Th({}, r) : Ms(r) ? e[o] = r.slice() : e[o] = r;
  };
  for (let r = 0, i = arguments.length; r < i; r++)
    arguments[r] && sc(arguments[r], n);
  return e;
}
const UK = (t, e, n, { allOwnKeys: r } = {}) => (sc(e, (i, o) => {
  n && or(i) ? t[o] = X7(i, n) : t[o] = i;
}, { allOwnKeys: r }), t), zK = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), HK = (t, e, n, r) => {
  t.prototype = Object.create(e.prototype, r), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), n && Object.assign(t.prototype, n);
}, BK = (t, e, n, r) => {
  let i, o, a;
  const s = {};
  if (e = e || {}, t == null)
    return e;
  do {
    for (i = Object.getOwnPropertyNames(t), o = i.length; o-- > 0; )
      a = i[o], (!r || r(a, t, e)) && !s[a] && (e[a] = t[a], s[a] = !0);
    t = n !== !1 && f2(t);
  } while (t && (!n || n(t, e)) && t !== Object.prototype);
  return e;
}, VK = (t, e, n) => {
  t = String(t), (n === void 0 || n > t.length) && (n = t.length), n -= e.length;
  const r = t.indexOf(e, n);
  return r !== -1 && r === n;
}, $K = (t) => {
  if (!t)
    return null;
  if (Ms(t))
    return t;
  let e = t.length;
  if (!Z7(e))
    return null;
  const n = new Array(e);
  for (; e-- > 0; )
    n[e] = t[e];
  return n;
}, WK = ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && f2(Uint8Array)), jK = (t, e) => {
  const r = (t && t[Symbol.iterator]).call(t);
  let i;
  for (; (i = r.next()) && !i.done; ) {
    const o = i.value;
    e.call(t, o[0], o[1]);
  }
}, GK = (t, e) => {
  let n;
  const r = [];
  for (; (n = t.exec(e)) !== null; )
    r.push(n);
  return r;
}, qK = Pr("HTMLFormElement"), XK = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, i) {
    return r.toUpperCase() + i;
  }
), o4 = (({ hasOwnProperty: t }) => (e, n) => t.call(e, n))(Object.prototype), YK = Pr("RegExp"), e9 = (t, e) => {
  const n = Object.getOwnPropertyDescriptors(t), r = {};
  sc(n, (i, o) => {
    let a;
    (a = e(i, o, t)) !== !1 && (r[o] = a || i);
  }), Object.defineProperties(t, r);
}, ZK = (t) => {
  e9(t, (e, n) => {
    if (or(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = t[n];
    if (or(r)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, KK = (t, e) => {
  const n = {}, r = (i) => {
    i.forEach((o) => {
      n[o] = !0;
    });
  };
  return Ms(t) ? r(t) : r(String(t).split(e)), n;
}, JK = () => {
}, QK = (t, e) => t != null && Number.isFinite(t = +t) ? t : e, l0 = "abcdefghijklmnopqrstuvwxyz", a4 = "0123456789", t9 = {
  DIGIT: a4,
  ALPHA: l0,
  ALPHA_DIGIT: l0 + l0.toUpperCase() + a4
}, eJ = (t = 16, e = t9.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = e;
  for (; t--; )
    n += e[Math.random() * r | 0];
  return n;
};
function tJ(t) {
  return !!(t && or(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
const nJ = (t) => {
  const e = new Array(10), n = (r, i) => {
    if (jd(r)) {
      if (e.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        e[i] = r;
        const o = Ms(r) ? [] : {};
        return sc(r, (a, s) => {
          const l = n(a, i + 1);
          !kl(l) && (o[s] = l);
        }), e[i] = void 0, o;
      }
    }
    return r;
  };
  return n(t, 0);
}, rJ = Pr("AsyncFunction"), iJ = (t) => t && (jd(t) || or(t)) && or(t.then) && or(t.catch), le = {
  isArray: Ms,
  isArrayBuffer: Y7,
  isBuffer: _K,
  isFormData: LK,
  isArrayBufferView: CK,
  isString: EK,
  isNumber: Z7,
  isBoolean: SK,
  isObject: jd,
  isPlainObject: xu,
  isReadableStream: DK,
  isRequest: kK,
  isResponse: NK,
  isHeaders: IK,
  isUndefined: kl,
  isDate: MK,
  isFile: TK,
  isBlob: AK,
  isRegExp: YK,
  isFunction: or,
  isStream: RK,
  isURLSearchParams: OK,
  isTypedArray: WK,
  isFileList: PK,
  forEach: sc,
  merge: Th,
  extend: UK,
  trim: FK,
  stripBOM: zK,
  inherits: HK,
  toFlatObject: BK,
  kindOf: $d,
  kindOfTest: Pr,
  endsWith: VK,
  toArray: $K,
  forEachEntry: jK,
  matchAll: GK,
  isHTMLForm: qK,
  hasOwnProperty: o4,
  hasOwnProp: o4,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: e9,
  freezeMethods: ZK,
  toObjectSet: KK,
  toCamelCase: XK,
  noop: JK,
  toFiniteNumber: QK,
  findKey: K7,
  global: J7,
  isContextDefined: Q7,
  ALPHABET: t9,
  generateString: eJ,
  isSpecCompliantForm: tJ,
  toJSONObject: nJ,
  isAsyncFn: rJ,
  isThenable: iJ
};
function it(t, e, n, r, i) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), n && (this.config = n), r && (this.request = r), i && (this.response = i);
}
le.inherits(it, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: le.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const n9 = it.prototype, r9 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  r9[t] = { value: t };
});
Object.defineProperties(it, r9);
Object.defineProperty(n9, "isAxiosError", { value: !0 });
it.from = (t, e, n, r, i, o) => {
  const a = Object.create(n9);
  return le.toFlatObject(t, a, function(l) {
    return l !== Error.prototype;
  }, (s) => s !== "isAxiosError"), it.call(a, t.message, e, n, r, i), a.cause = t, a.name = t.name, o && Object.assign(a, o), a;
};
const oJ = null;
function Ah(t) {
  return le.isPlainObject(t) || le.isArray(t);
}
function i9(t) {
  return le.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function s4(t, e, n) {
  return t ? t.concat(e).map(function(i, o) {
    return i = i9(i), !n && o ? "[" + i + "]" : i;
  }).join(n ? "." : "") : e;
}
function aJ(t) {
  return le.isArray(t) && !t.some(Ah);
}
const sJ = le.toFlatObject(le, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Gd(t, e, n) {
  if (!le.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), n = le.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(g, m) {
    return !le.isUndefined(m[g]);
  });
  const r = n.metaTokens, i = n.visitor || u, o = n.dots, a = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && le.isSpecCompliantForm(e);
  if (!le.isFunction(i))
    throw new TypeError("visitor must be a function");
  function c(v) {
    if (v === null)
      return "";
    if (le.isDate(v))
      return v.toISOString();
    if (!l && le.isBlob(v))
      throw new it("Blob is not supported. Use a Buffer instead.");
    return le.isArrayBuffer(v) || le.isTypedArray(v) ? l && typeof Blob == "function" ? new Blob([v]) : Buffer.from(v) : v;
  }
  function u(v, g, m) {
    let p = v;
    if (v && !m && typeof v == "object") {
      if (le.endsWith(g, "{}"))
        g = r ? g : g.slice(0, -2), v = JSON.stringify(v);
      else if (le.isArray(v) && aJ(v) || (le.isFileList(v) || le.endsWith(g, "[]")) && (p = le.toArray(v)))
        return g = i9(g), p.forEach(function(b, x) {
          !(le.isUndefined(b) || b === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? s4([g], x, o) : a === null ? g : g + "[]",
            c(b)
          );
        }), !1;
    }
    return Ah(v) ? !0 : (e.append(s4(m, g, o), c(v)), !1);
  }
  const d = [], f = Object.assign(sJ, {
    defaultVisitor: u,
    convertValue: c,
    isVisitable: Ah
  });
  function h(v, g) {
    if (!le.isUndefined(v)) {
      if (d.indexOf(v) !== -1)
        throw Error("Circular reference detected in " + g.join("."));
      d.push(v), le.forEach(v, function(p, y) {
        (!(le.isUndefined(p) || p === null) && i.call(
          e,
          p,
          le.isString(y) ? y.trim() : y,
          g,
          f
        )) === !0 && h(p, g ? g.concat(y) : [y]);
      }), d.pop();
    }
  }
  if (!le.isObject(t))
    throw new TypeError("data must be an object");
  return h(t), e;
}
function l4(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(r) {
    return e[r];
  });
}
function h2(t, e) {
  this._pairs = [], t && Gd(t, this, e);
}
const o9 = h2.prototype;
o9.append = function(e, n) {
  this._pairs.push([e, n]);
};
o9.toString = function(e) {
  const n = e ? function(r) {
    return e.call(this, r, l4);
  } : l4;
  return this._pairs.map(function(i) {
    return n(i[0]) + "=" + n(i[1]);
  }, "").join("&");
};
function lJ(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function a9(t, e, n) {
  if (!e)
    return t;
  const r = n && n.encode || lJ, i = n && n.serialize;
  let o;
  if (i ? o = i(e, n) : o = le.isURLSearchParams(e) ? e.toString() : new h2(e, n).toString(r), o) {
    const a = t.indexOf("#");
    a !== -1 && (t = t.slice(0, a)), t += (t.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return t;
}
class cJ {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, n, r) {
    return this.handlers.push({
      fulfilled: e,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    le.forEach(this.handlers, function(r) {
      r !== null && e(r);
    });
  }
}
const c4 = cJ, s9 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, uJ = typeof URLSearchParams < "u" ? URLSearchParams : h2, dJ = typeof FormData < "u" ? FormData : null, fJ = typeof Blob < "u" ? Blob : null, hJ = {
  isBrowser: !0,
  classes: {
    URLSearchParams: uJ,
    FormData: dJ,
    Blob: fJ
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, p2 = typeof window < "u" && typeof document < "u", pJ = ((t) => p2 && ["ReactNative", "NativeScript", "NS"].indexOf(t) < 0)(typeof navigator < "u" && navigator.product), mJ = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), vJ = p2 && window.location.href || "http://localhost", gJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: p2,
  hasStandardBrowserEnv: pJ,
  hasStandardBrowserWebWorkerEnv: mJ,
  origin: vJ
}, Symbol.toStringTag, { value: "Module" })), xr = {
  ...gJ,
  ...hJ
};
function yJ(t, e) {
  return Gd(t, new xr.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, i, o) {
      return xr.isNode && le.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function bJ(t) {
  return le.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function xJ(t) {
  const e = {}, n = Object.keys(t);
  let r;
  const i = n.length;
  let o;
  for (r = 0; r < i; r++)
    o = n[r], e[o] = t[o];
  return e;
}
function l9(t) {
  function e(n, r, i, o) {
    let a = n[o++];
    if (a === "__proto__")
      return !0;
    const s = Number.isFinite(+a), l = o >= n.length;
    return a = !a && le.isArray(i) ? i.length : a, l ? (le.hasOwnProp(i, a) ? i[a] = [i[a], r] : i[a] = r, !s) : ((!i[a] || !le.isObject(i[a])) && (i[a] = []), e(n, r, i[a], o) && le.isArray(i[a]) && (i[a] = xJ(i[a])), !s);
  }
  if (le.isFormData(t) && le.isFunction(t.entries)) {
    const n = {};
    return le.forEachEntry(t, (r, i) => {
      e(bJ(r), i, n, 0);
    }), n;
  }
  return null;
}
function wJ(t, e, n) {
  if (le.isString(t))
    try {
      return (e || JSON.parse)(t), le.trim(t);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(t);
}
const m2 = {
  transitional: s9,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, n) {
    const r = n.getContentType() || "", i = r.indexOf("application/json") > -1, o = le.isObject(e);
    if (o && le.isHTMLForm(e) && (e = new FormData(e)), le.isFormData(e))
      return i ? JSON.stringify(l9(e)) : e;
    if (le.isArrayBuffer(e) || le.isBuffer(e) || le.isStream(e) || le.isFile(e) || le.isBlob(e) || le.isReadableStream(e))
      return e;
    if (le.isArrayBufferView(e))
      return e.buffer;
    if (le.isURLSearchParams(e))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let s;
    if (o) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return yJ(e, this.formSerializer).toString();
      if ((s = le.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Gd(
          s ? { "files[]": e } : e,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return o || i ? (n.setContentType("application/json", !1), wJ(e)) : e;
  }],
  transformResponse: [function(e) {
    const n = this.transitional || m2.transitional, r = n && n.forcedJSONParsing, i = this.responseType === "json";
    if (le.isResponse(e) || le.isReadableStream(e))
      return e;
    if (e && le.isString(e) && (r && !this.responseType || i)) {
      const a = !(n && n.silentJSONParsing) && i;
      try {
        return JSON.parse(e);
      } catch (s) {
        if (a)
          throw s.name === "SyntaxError" ? it.from(s, it.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: xr.classes.FormData,
    Blob: xr.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
le.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  m2.headers[t] = {};
});
const v2 = m2, _J = le.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), CJ = (t) => {
  const e = {};
  let n, r, i;
  return t && t.split(`
`).forEach(function(a) {
    i = a.indexOf(":"), n = a.substring(0, i).trim().toLowerCase(), r = a.substring(i + 1).trim(), !(!n || e[n] && _J[n]) && (n === "set-cookie" ? e[n] ? e[n].push(r) : e[n] = [r] : e[n] = e[n] ? e[n] + ", " + r : r);
  }), e;
}, u4 = Symbol("internals");
function qs(t) {
  return t && String(t).trim().toLowerCase();
}
function wu(t) {
  return t === !1 || t == null ? t : le.isArray(t) ? t.map(wu) : String(t);
}
function EJ(t) {
  const e = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(t); )
    e[r[1]] = r[2];
  return e;
}
const SJ = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function c0(t, e, n, r, i) {
  if (le.isFunction(r))
    return r.call(this, e, n);
  if (i && (e = n), !!le.isString(e)) {
    if (le.isString(r))
      return e.indexOf(r) !== -1;
    if (le.isRegExp(r))
      return r.test(e);
  }
}
function MJ(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, n, r) => n.toUpperCase() + r);
}
function TJ(t, e) {
  const n = le.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(t, r + n, {
      value: function(i, o, a) {
        return this[r].call(this, e, i, o, a);
      },
      configurable: !0
    });
  });
}
class qd {
  constructor(e) {
    e && this.set(e);
  }
  set(e, n, r) {
    const i = this;
    function o(s, l, c) {
      const u = qs(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = le.findKey(i, u);
      (!d || i[d] === void 0 || c === !0 || c === void 0 && i[d] !== !1) && (i[d || l] = wu(s));
    }
    const a = (s, l) => le.forEach(s, (c, u) => o(c, u, l));
    if (le.isPlainObject(e) || e instanceof this.constructor)
      a(e, n);
    else if (le.isString(e) && (e = e.trim()) && !SJ(e))
      a(CJ(e), n);
    else if (le.isHeaders(e))
      for (const [s, l] of e.entries())
        o(l, s, r);
    else
      e != null && o(n, e, r);
    return this;
  }
  get(e, n) {
    if (e = qs(e), e) {
      const r = le.findKey(this, e);
      if (r) {
        const i = this[r];
        if (!n)
          return i;
        if (n === !0)
          return EJ(i);
        if (le.isFunction(n))
          return n.call(this, i, r);
        if (le.isRegExp(n))
          return n.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, n) {
    if (e = qs(e), e) {
      const r = le.findKey(this, e);
      return !!(r && this[r] !== void 0 && (!n || c0(this, this[r], r, n)));
    }
    return !1;
  }
  delete(e, n) {
    const r = this;
    let i = !1;
    function o(a) {
      if (a = qs(a), a) {
        const s = le.findKey(r, a);
        s && (!n || c0(r, r[s], s, n)) && (delete r[s], i = !0);
      }
    }
    return le.isArray(e) ? e.forEach(o) : o(e), i;
  }
  clear(e) {
    const n = Object.keys(this);
    let r = n.length, i = !1;
    for (; r--; ) {
      const o = n[r];
      (!e || c0(this, this[o], o, e, !0)) && (delete this[o], i = !0);
    }
    return i;
  }
  normalize(e) {
    const n = this, r = {};
    return le.forEach(this, (i, o) => {
      const a = le.findKey(r, o);
      if (a) {
        n[a] = wu(i), delete n[o];
        return;
      }
      const s = e ? MJ(o) : String(o).trim();
      s !== o && delete n[o], n[s] = wu(i), r[s] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const n = /* @__PURE__ */ Object.create(null);
    return le.forEach(this, (r, i) => {
      r != null && r !== !1 && (n[i] = e && le.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...n) {
    const r = new this(e);
    return n.forEach((i) => r.set(i)), r;
  }
  static accessor(e) {
    const r = (this[u4] = this[u4] = {
      accessors: {}
    }).accessors, i = this.prototype;
    function o(a) {
      const s = qs(a);
      r[s] || (TJ(i, a), r[s] = !0);
    }
    return le.isArray(e) ? e.forEach(o) : o(e), this;
  }
}
qd.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
le.reduceDescriptors(qd.prototype, ({ value: t }, e) => {
  let n = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(r) {
      this[n] = r;
    }
  };
});
le.freezeMethods(qd);
const wr = qd;
function u0(t, e) {
  const n = this || v2, r = e || n, i = wr.from(r.headers);
  let o = r.data;
  return le.forEach(t, function(s) {
    o = s.call(n, o, i.normalize(), e ? e.status : void 0);
  }), i.normalize(), o;
}
function c9(t) {
  return !!(t && t.__CANCEL__);
}
function Ts(t, e, n) {
  it.call(this, t ?? "canceled", it.ERR_CANCELED, e, n), this.name = "CanceledError";
}
le.inherits(Ts, it, {
  __CANCEL__: !0
});
function u9(t, e, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? t(n) : e(new it(
    "Request failed with status code " + n.status,
    [it.ERR_BAD_REQUEST, it.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function AJ(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function PJ(t, e) {
  t = t || 10;
  const n = new Array(t), r = new Array(t);
  let i = 0, o = 0, a;
  return e = e !== void 0 ? e : 1e3, function(l) {
    const c = Date.now(), u = r[o];
    a || (a = c), n[i] = l, r[i] = c;
    let d = o, f = 0;
    for (; d !== i; )
      f += n[d++], d = d % t;
    if (i = (i + 1) % t, i === o && (o = (o + 1) % t), c - a < e)
      return;
    const h = u && c - u;
    return h ? Math.round(f * 1e3 / h) : void 0;
  };
}
function RJ(t, e) {
  let n = 0;
  const r = 1e3 / e;
  let i = null;
  return function() {
    const a = this === !0, s = Date.now();
    if (a || s - n > r)
      return i && (clearTimeout(i), i = null), n = s, t.apply(null, arguments);
    i || (i = setTimeout(() => (i = null, n = Date.now(), t.apply(null, arguments)), r - (s - n)));
  };
}
const Ju = (t, e, n = 3) => {
  let r = 0;
  const i = PJ(50, 250);
  return RJ((o) => {
    const a = o.loaded, s = o.lengthComputable ? o.total : void 0, l = a - r, c = i(l), u = a <= s;
    r = a;
    const d = {
      loaded: a,
      total: s,
      progress: s ? a / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - a) / c : void 0,
      event: o,
      lengthComputable: s != null
    };
    d[e ? "download" : "upload"] = !0, t(d);
  }, n);
}, LJ = xr.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function i(o) {
      let a = o;
      return e && (n.setAttribute("href", a), a = n.href), n.setAttribute("href", a), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = i(window.location.href), function(a) {
      const s = le.isString(a) ? i(a) : a;
      return s.protocol === r.protocol && s.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
), OJ = xr.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, n, r, i, o) {
      const a = [t + "=" + encodeURIComponent(e)];
      le.isNumber(n) && a.push("expires=" + new Date(n).toGMTString()), le.isString(r) && a.push("path=" + r), le.isString(i) && a.push("domain=" + i), o === !0 && a.push("secure"), document.cookie = a.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function DJ(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function kJ(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function d9(t, e) {
  return t && !DJ(e) ? kJ(t, e) : e;
}
const d4 = (t) => t instanceof wr ? { ...t } : t;
function Fo(t, e) {
  e = e || {};
  const n = {};
  function r(c, u, d) {
    return le.isPlainObject(c) && le.isPlainObject(u) ? le.merge.call({ caseless: d }, c, u) : le.isPlainObject(u) ? le.merge({}, u) : le.isArray(u) ? u.slice() : u;
  }
  function i(c, u, d) {
    if (le.isUndefined(u)) {
      if (!le.isUndefined(c))
        return r(void 0, c, d);
    } else
      return r(c, u, d);
  }
  function o(c, u) {
    if (!le.isUndefined(u))
      return r(void 0, u);
  }
  function a(c, u) {
    if (le.isUndefined(u)) {
      if (!le.isUndefined(c))
        return r(void 0, c);
    } else
      return r(void 0, u);
  }
  function s(c, u, d) {
    if (d in e)
      return r(c, u);
    if (d in t)
      return r(void 0, c);
  }
  const l = {
    url: o,
    method: o,
    data: o,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: s,
    headers: (c, u) => i(d4(c), d4(u), !0)
  };
  return le.forEach(Object.keys(Object.assign({}, t, e)), function(u) {
    const d = l[u] || i, f = d(t[u], e[u], u);
    le.isUndefined(f) && d !== s || (n[u] = f);
  }), n;
}
const f9 = (t) => {
  const e = Fo({}, t);
  let { data: n, withXSRFToken: r, xsrfHeaderName: i, xsrfCookieName: o, headers: a, auth: s } = e;
  e.headers = a = wr.from(a), e.url = a9(d9(e.baseURL, e.url), t.params, t.paramsSerializer), s && a.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let l;
  if (le.isFormData(n)) {
    if (xr.hasStandardBrowserEnv || xr.hasStandardBrowserWebWorkerEnv)
      a.setContentType(void 0);
    else if ((l = a.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      a.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (xr.hasStandardBrowserEnv && (r && le.isFunction(r) && (r = r(e)), r || r !== !1 && LJ(e.url))) {
    const c = i && o && OJ.read(o);
    c && a.set(i, c);
  }
  return e;
}, NJ = typeof XMLHttpRequest < "u", IJ = NJ && function(t) {
  return new Promise(function(n, r) {
    const i = f9(t);
    let o = i.data;
    const a = wr.from(i.headers).normalize();
    let { responseType: s } = i, l;
    function c() {
      i.cancelToken && i.cancelToken.unsubscribe(l), i.signal && i.signal.removeEventListener("abort", l);
    }
    let u = new XMLHttpRequest();
    u.open(i.method.toUpperCase(), i.url, !0), u.timeout = i.timeout;
    function d() {
      if (!u)
        return;
      const h = wr.from(
        "getAllResponseHeaders" in u && u.getAllResponseHeaders()
      ), g = {
        data: !s || s === "text" || s === "json" ? u.responseText : u.response,
        status: u.status,
        statusText: u.statusText,
        headers: h,
        config: t,
        request: u
      };
      u9(function(p) {
        n(p), c();
      }, function(p) {
        r(p), c();
      }, g), u = null;
    }
    "onloadend" in u ? u.onloadend = d : u.onreadystatechange = function() {
      !u || u.readyState !== 4 || u.status === 0 && !(u.responseURL && u.responseURL.indexOf("file:") === 0) || setTimeout(d);
    }, u.onabort = function() {
      u && (r(new it("Request aborted", it.ECONNABORTED, i, u)), u = null);
    }, u.onerror = function() {
      r(new it("Network Error", it.ERR_NETWORK, i, u)), u = null;
    }, u.ontimeout = function() {
      let v = i.timeout ? "timeout of " + i.timeout + "ms exceeded" : "timeout exceeded";
      const g = i.transitional || s9;
      i.timeoutErrorMessage && (v = i.timeoutErrorMessage), r(new it(
        v,
        g.clarifyTimeoutError ? it.ETIMEDOUT : it.ECONNABORTED,
        i,
        u
      )), u = null;
    }, o === void 0 && a.setContentType(null), "setRequestHeader" in u && le.forEach(a.toJSON(), function(v, g) {
      u.setRequestHeader(g, v);
    }), le.isUndefined(i.withCredentials) || (u.withCredentials = !!i.withCredentials), s && s !== "json" && (u.responseType = i.responseType), typeof i.onDownloadProgress == "function" && u.addEventListener("progress", Ju(i.onDownloadProgress, !0)), typeof i.onUploadProgress == "function" && u.upload && u.upload.addEventListener("progress", Ju(i.onUploadProgress)), (i.cancelToken || i.signal) && (l = (h) => {
      u && (r(!h || h.type ? new Ts(null, t, u) : h), u.abort(), u = null);
    }, i.cancelToken && i.cancelToken.subscribe(l), i.signal && (i.signal.aborted ? l() : i.signal.addEventListener("abort", l)));
    const f = AJ(i.url);
    if (f && xr.protocols.indexOf(f) === -1) {
      r(new it("Unsupported protocol " + f + ":", it.ERR_BAD_REQUEST, t));
      return;
    }
    u.send(o || null);
  });
}, FJ = (t, e) => {
  let n = new AbortController(), r;
  const i = function(l) {
    if (!r) {
      r = !0, a();
      const c = l instanceof Error ? l : this.reason;
      n.abort(c instanceof it ? c : new Ts(c instanceof Error ? c.message : c));
    }
  };
  let o = e && setTimeout(() => {
    i(new it(`timeout ${e} of ms exceeded`, it.ETIMEDOUT));
  }, e);
  const a = () => {
    t && (o && clearTimeout(o), o = null, t.forEach((l) => {
      l && (l.removeEventListener ? l.removeEventListener("abort", i) : l.unsubscribe(i));
    }), t = null);
  };
  t.forEach((l) => l && l.addEventListener && l.addEventListener("abort", i));
  const { signal: s } = n;
  return s.unsubscribe = a, [s, () => {
    o && clearTimeout(o), o = null;
  }];
}, UJ = FJ, zJ = function* (t, e) {
  let n = t.byteLength;
  if (!e || n < e) {
    yield t;
    return;
  }
  let r = 0, i;
  for (; r < n; )
    i = r + e, yield t.slice(r, i), r = i;
}, HJ = async function* (t, e, n) {
  for await (const r of t)
    yield* zJ(ArrayBuffer.isView(r) ? r : await n(String(r)), e);
}, f4 = (t, e, n, r, i) => {
  const o = HJ(t, e, i);
  let a = 0;
  return new ReadableStream({
    type: "bytes",
    async pull(s) {
      const { done: l, value: c } = await o.next();
      if (l) {
        s.close(), r();
        return;
      }
      let u = c.byteLength;
      n && n(a += u), s.enqueue(new Uint8Array(c));
    },
    cancel(s) {
      return r(s), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, h4 = (t, e) => {
  const n = t != null;
  return (r) => setTimeout(() => e({
    lengthComputable: n,
    total: t,
    loaded: r
  }));
}, Xd = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", h9 = Xd && typeof ReadableStream == "function", Ph = Xd && (typeof TextEncoder == "function" ? ((t) => (e) => t.encode(e))(new TextEncoder()) : async (t) => new Uint8Array(await new Response(t).arrayBuffer())), BJ = h9 && (() => {
  let t = !1;
  const e = new Request(xr.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type");
  return t && !e;
})(), p4 = 64 * 1024, Rh = h9 && !!(() => {
  try {
    return le.isReadableStream(new Response("").body);
  } catch {
  }
})(), Qu = {
  stream: Rh && ((t) => t.body)
};
Xd && ((t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !Qu[e] && (Qu[e] = le.isFunction(t[e]) ? (n) => n[e]() : (n, r) => {
      throw new it(`Response type '${e}' is not supported`, it.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const VJ = async (t) => {
  if (t == null)
    return 0;
  if (le.isBlob(t))
    return t.size;
  if (le.isSpecCompliantForm(t))
    return (await new Request(t).arrayBuffer()).byteLength;
  if (le.isArrayBufferView(t))
    return t.byteLength;
  if (le.isURLSearchParams(t) && (t = t + ""), le.isString(t))
    return (await Ph(t)).byteLength;
}, $J = async (t, e) => {
  const n = le.toFiniteNumber(t.getContentLength());
  return n ?? VJ(e);
}, WJ = Xd && (async (t) => {
  let {
    url: e,
    method: n,
    data: r,
    signal: i,
    cancelToken: o,
    timeout: a,
    onDownloadProgress: s,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: f
  } = f9(t);
  c = c ? (c + "").toLowerCase() : "text";
  let [h, v] = i || o || a ? UJ([i, o], a) : [], g, m;
  const p = () => {
    !g && setTimeout(() => {
      h && h.unsubscribe();
    }), g = !0;
  };
  let y;
  try {
    if (l && BJ && n !== "get" && n !== "head" && (y = await $J(u, r)) !== 0) {
      let M = new Request(e, {
        method: "POST",
        body: r,
        duplex: "half"
      }), S;
      le.isFormData(r) && (S = M.headers.get("content-type")) && u.setContentType(S), M.body && (r = f4(M.body, p4, h4(
        y,
        Ju(l)
      ), null, Ph));
    }
    le.isString(d) || (d = d ? "cors" : "omit"), m = new Request(e, {
      ...f,
      signal: h,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: r,
      duplex: "half",
      withCredentials: d
    });
    let b = await fetch(m);
    const x = Rh && (c === "stream" || c === "response");
    if (Rh && (s || x)) {
      const M = {};
      ["status", "statusText", "headers"].forEach((P) => {
        M[P] = b[P];
      });
      const S = le.toFiniteNumber(b.headers.get("content-length"));
      b = new Response(
        f4(b.body, p4, s && h4(
          S,
          Ju(s, !0)
        ), x && p, Ph),
        M
      );
    }
    c = c || "text";
    let _ = await Qu[le.findKey(Qu, c) || "text"](b, t);
    return !x && p(), v && v(), await new Promise((M, S) => {
      u9(M, S, {
        data: _,
        headers: wr.from(b.headers),
        status: b.status,
        statusText: b.statusText,
        config: t,
        request: m
      });
    });
  } catch (b) {
    throw p(), b && b.name === "TypeError" && /fetch/i.test(b.message) ? Object.assign(
      new it("Network Error", it.ERR_NETWORK, t, m),
      {
        cause: b.cause || b
      }
    ) : it.from(b, b && b.code, t, m);
  }
}), Lh = {
  http: oJ,
  xhr: IJ,
  fetch: WJ
};
le.forEach(Lh, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const m4 = (t) => `- ${t}`, jJ = (t) => le.isFunction(t) || t === null || t === !1, p9 = {
  getAdapter: (t) => {
    t = le.isArray(t) ? t : [t];
    const { length: e } = t;
    let n, r;
    const i = {};
    for (let o = 0; o < e; o++) {
      n = t[o];
      let a;
      if (r = n, !jJ(n) && (r = Lh[(a = String(n)).toLowerCase()], r === void 0))
        throw new it(`Unknown adapter '${a}'`);
      if (r)
        break;
      i[a || "#" + o] = r;
    }
    if (!r) {
      const o = Object.entries(i).map(
        ([s, l]) => `adapter ${s} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = e ? o.length > 1 ? `since :
` + o.map(m4).join(`
`) : " " + m4(o[0]) : "as no adapter specified";
      throw new it(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: Lh
};
function d0(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new Ts(null, t);
}
function v4(t) {
  return d0(t), t.headers = wr.from(t.headers), t.data = u0.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), p9.getAdapter(t.adapter || v2.adapter)(t).then(function(r) {
    return d0(t), r.data = u0.call(
      t,
      t.transformResponse,
      r
    ), r.headers = wr.from(r.headers), r;
  }, function(r) {
    return c9(r) || (d0(t), r && r.response && (r.response.data = u0.call(
      t,
      t.transformResponse,
      r.response
    ), r.response.headers = wr.from(r.response.headers))), Promise.reject(r);
  });
}
const m9 = "1.7.2", g2 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  g2[t] = function(r) {
    return typeof r === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const g4 = {};
g2.transitional = function(e, n, r) {
  function i(o, a) {
    return "[Axios v" + m9 + "] Transitional option '" + o + "'" + a + (r ? ". " + r : "");
  }
  return (o, a, s) => {
    if (e === !1)
      throw new it(
        i(a, " has been removed" + (n ? " in " + n : "")),
        it.ERR_DEPRECATED
      );
    return n && !g4[a] && (g4[a] = !0, console.warn(
      i(
        a,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), e ? e(o, a, s) : !0;
  };
};
function GJ(t, e, n) {
  if (typeof t != "object")
    throw new it("options must be an object", it.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(t);
  let i = r.length;
  for (; i-- > 0; ) {
    const o = r[i], a = e[o];
    if (a) {
      const s = t[o], l = s === void 0 || a(s, o, t);
      if (l !== !0)
        throw new it("option " + o + " must be " + l, it.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new it("Unknown option " + o, it.ERR_BAD_OPTION);
  }
}
const Oh = {
  assertOptions: GJ,
  validators: g2
}, _i = Oh.validators;
class ed {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new c4(),
      response: new c4()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, n) {
    try {
      return await this._request(e, n);
    } catch (r) {
      if (r instanceof Error) {
        let i;
        Error.captureStackTrace ? Error.captureStackTrace(i = {}) : i = new Error();
        const o = i.stack ? i.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? o && !String(r.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + o) : r.stack = o;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(e, n) {
    typeof e == "string" ? (n = n || {}, n.url = e) : n = e || {}, n = Fo(this.defaults, n);
    const { transitional: r, paramsSerializer: i, headers: o } = n;
    r !== void 0 && Oh.assertOptions(r, {
      silentJSONParsing: _i.transitional(_i.boolean),
      forcedJSONParsing: _i.transitional(_i.boolean),
      clarifyTimeoutError: _i.transitional(_i.boolean)
    }, !1), i != null && (le.isFunction(i) ? n.paramsSerializer = {
      serialize: i
    } : Oh.assertOptions(i, {
      encode: _i.function,
      serialize: _i.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let a = o && le.merge(
      o.common,
      o[n.method]
    );
    o && le.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (v) => {
        delete o[v];
      }
    ), n.headers = wr.concat(a, o);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(g) {
      typeof g.runWhen == "function" && g.runWhen(n) === !1 || (l = l && g.synchronous, s.unshift(g.fulfilled, g.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(g) {
      c.push(g.fulfilled, g.rejected);
    });
    let u, d = 0, f;
    if (!l) {
      const v = [v4.bind(this), void 0];
      for (v.unshift.apply(v, s), v.push.apply(v, c), f = v.length, u = Promise.resolve(n); d < f; )
        u = u.then(v[d++], v[d++]);
      return u;
    }
    f = s.length;
    let h = n;
    for (d = 0; d < f; ) {
      const v = s[d++], g = s[d++];
      try {
        h = v(h);
      } catch (m) {
        g.call(this, m);
        break;
      }
    }
    try {
      u = v4.call(this, h);
    } catch (v) {
      return Promise.reject(v);
    }
    for (d = 0, f = c.length; d < f; )
      u = u.then(c[d++], c[d++]);
    return u;
  }
  getUri(e) {
    e = Fo(this.defaults, e);
    const n = d9(e.baseURL, e.url);
    return a9(n, e.params, e.paramsSerializer);
  }
}
le.forEach(["delete", "get", "head", "options"], function(e) {
  ed.prototype[e] = function(n, r) {
    return this.request(Fo(r || {}, {
      method: e,
      url: n,
      data: (r || {}).data
    }));
  };
});
le.forEach(["post", "put", "patch"], function(e) {
  function n(r) {
    return function(o, a, s) {
      return this.request(Fo(s || {}, {
        method: e,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: a
      }));
    };
  }
  ed.prototype[e] = n(), ed.prototype[e + "Form"] = n(!0);
});
const _u = ed;
class y2 {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    const r = this;
    this.promise.then((i) => {
      if (!r._listeners)
        return;
      let o = r._listeners.length;
      for (; o-- > 0; )
        r._listeners[o](i);
      r._listeners = null;
    }), this.promise.then = (i) => {
      let o;
      const a = new Promise((s) => {
        r.subscribe(s), o = s;
      }).then(i);
      return a.cancel = function() {
        r.unsubscribe(o);
      }, a;
    }, e(function(o, a, s) {
      r.reason || (r.reason = new Ts(o, a, s), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new y2(function(i) {
        e = i;
      }),
      cancel: e
    };
  }
}
const qJ = y2;
function XJ(t) {
  return function(n) {
    return t.apply(null, n);
  };
}
function YJ(t) {
  return le.isObject(t) && t.isAxiosError === !0;
}
const Dh = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Dh).forEach(([t, e]) => {
  Dh[e] = t;
});
const ZJ = Dh;
function v9(t) {
  const e = new _u(t), n = X7(_u.prototype.request, e);
  return le.extend(n, _u.prototype, e, { allOwnKeys: !0 }), le.extend(n, e, null, { allOwnKeys: !0 }), n.create = function(i) {
    return v9(Fo(t, i));
  }, n;
}
const en = v9(v2);
en.Axios = _u;
en.CanceledError = Ts;
en.CancelToken = qJ;
en.isCancel = c9;
en.VERSION = m9;
en.toFormData = Gd;
en.AxiosError = it;
en.Cancel = en.CanceledError;
en.all = function(e) {
  return Promise.all(e);
};
en.spread = XJ;
en.isAxiosError = YJ;
en.mergeConfig = Fo;
en.AxiosHeaders = wr;
en.formToJSON = (t) => l9(le.isHTMLForm(t) ? new FormData(t) : t);
en.getAdapter = p9.getAdapter;
en.HttpStatusCode = ZJ;
en.default = en;
const KJ = en, JJ = (t, e) => {
  const n = new AbortController(), r = KJ.get(t, {
    onDownloadProgress: (i) => e(i.progress ?? 0),
    responseType: "blob",
    signal: n.signal
  }).then((i) => new Blob([i.data], { type: i.headers["content-type"] }));
  return { controller: n, promise: r };
}, QJ = (t, e) => {
  const n = document.createElement("a");
  n.href = window.URL.createObjectURL(t), n.setAttribute("download", e ?? ""), n.click();
};
function y4(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function eQ(t) {
  if (Array.isArray(t))
    return t;
}
function tQ(t, e, n) {
  return (e = oQ(e)) in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function nQ(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(t)).next, e === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== e); l = !0)
          ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (c)
          throw i;
      }
    }
    return s;
  }
}
function rQ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function b4(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function kh(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? b4(Object(n), !0).forEach(function(r) {
      tQ(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : b4(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function za(t, e) {
  return eQ(t) || nQ(t, e) || aQ(t, e) || rQ();
}
function iQ(t, e) {
  if (typeof t != "object" || !t)
    return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function oQ(t) {
  var e = iQ(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function td(t) {
  "@babel/helpers - typeof";
  return td = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, td(t);
}
function aQ(t, e) {
  if (t) {
    if (typeof t == "string")
      return y4(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? y4(t, e) : void 0;
  }
}
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const b2 = "175", sQ = 0, x4 = 1, lQ = 2, g9 = 1, cQ = 2, Qr = 3, Ji = 0, Rn = 1, ei = 2, Hi = 0, Za = 1, w4 = 2, _4 = 3, C4 = 4, uQ = 5, So = 100, dQ = 101, fQ = 102, hQ = 103, pQ = 104, mQ = 200, vQ = 201, gQ = 202, yQ = 203, Nh = 204, Ih = 205, bQ = 206, xQ = 207, wQ = 208, _Q = 209, CQ = 210, EQ = 211, SQ = 212, MQ = 213, TQ = 214, Fh = 0, Uh = 1, zh = 2, ts = 3, Hh = 4, Bh = 5, Vh = 6, $h = 7, y9 = 0, AQ = 1, PQ = 2, Bi = 0, b9 = 1, RQ = 2, LQ = 3, OQ = 4, DQ = 5, kQ = 6, NQ = 7, x9 = 300, ns = 301, rs = 302, Wh = 303, jh = 304, Yd = 306, Gh = 1e3, To = 1001, qh = 1002, _r = 1003, IQ = 1004, Ic = 1005, yr = 1006, f0 = 1007, Ui = 1008, di = 1009, w9 = 1010, _9 = 1011, Nl = 1012, x2 = 1013, Uo = 1014, ri = 1015, lc = 1016, w2 = 1017, _2 = 1018, Il = 1020, C9 = 35902, E9 = 1021, S9 = 1022, br = 1023, M9 = 1024, T9 = 1025, Fl = 1026, Ul = 1027, A9 = 1028, C2 = 1029, P9 = 1030, E2 = 1031, S2 = 1033, Cu = 33776, Eu = 33777, Su = 33778, Mu = 33779, Xh = 35840, Yh = 35841, Zh = 35842, Kh = 35843, Jh = 36196, Qh = 37492, e1 = 37496, t1 = 37808, n1 = 37809, r1 = 37810, i1 = 37811, o1 = 37812, a1 = 37813, s1 = 37814, l1 = 37815, c1 = 37816, u1 = 37817, d1 = 37818, f1 = 37819, h1 = 37820, p1 = 37821, Tu = 36492, m1 = 36494, v1 = 36495, R9 = 36283, g1 = 36284, y1 = 36285, b1 = 36286, FQ = 3200, UQ = 3201, zQ = 0, HQ = 1, Ni = "", er = "srgb", zo = "srgb-linear", nd = "linear", Tt = "srgb", ia = 7680, E4 = 519, BQ = 512, VQ = 513, $Q = 514, L9 = 515, WQ = 516, jQ = 517, GQ = 518, qQ = 519, S4 = 35044, M4 = "300 es", ii = 2e3, rd = 2001;
class As {
  /**
   * Adds the given event listener to the given event type.
   *
   * @param {string} type - The type of event to listen to.
   * @param {Function} listener - The function that gets called when the event is fired.
   */
  addEventListener(e, n) {
    this._listeners === void 0 && (this._listeners = {});
    const r = this._listeners;
    r[e] === void 0 && (r[e] = []), r[e].indexOf(n) === -1 && r[e].push(n);
  }
  /**
   * Returns `true` if the given event listener has been added to the given event type.
   *
   * @param {string} type - The type of event.
   * @param {Function} listener - The listener to check.
   * @return {boolean} Whether the given event listener has been added to the given event type.
   */
  hasEventListener(e, n) {
    const r = this._listeners;
    return r === void 0 ? !1 : r[e] !== void 0 && r[e].indexOf(n) !== -1;
  }
  /**
   * Removes the given event listener from the given event type.
   *
   * @param {string} type - The type of event.
   * @param {Function} listener - The listener to remove.
   */
  removeEventListener(e, n) {
    const r = this._listeners;
    if (r === void 0)
      return;
    const i = r[e];
    if (i !== void 0) {
      const o = i.indexOf(n);
      o !== -1 && i.splice(o, 1);
    }
  }
  /**
   * Dispatches an event object.
   *
   * @param {Object} event - The event that gets fired.
   */
  dispatchEvent(e) {
    const n = this._listeners;
    if (n === void 0)
      return;
    const r = n[e.type];
    if (r !== void 0) {
      e.target = this;
      const i = r.slice(0);
      for (let o = 0, a = i.length; o < a; o++)
        i[o].call(this, e);
      e.target = null;
    }
  }
}
const gn = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0a", "0b", "0c", "0d", "0e", "0f", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1a", "1b", "1c", "1d", "1e", "1f", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2a", "2b", "2c", "2d", "2e", "2f", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3a", "3b", "3c", "3d", "3e", "3f", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4a", "4b", "4c", "4d", "4e", "4f", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5a", "5b", "5c", "5d", "5e", "5f", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6a", "6b", "6c", "6d", "6e", "6f", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7a", "7b", "7c", "7d", "7e", "7f", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8a", "8b", "8c", "8d", "8e", "8f", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9a", "9b", "9c", "9d", "9e", "9f", "a0", "a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "aa", "ab", "ac", "ad", "ae", "af", "b0", "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "ba", "bb", "bc", "bd", "be", "bf", "c0", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "ca", "cb", "cc", "cd", "ce", "cf", "d0", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "da", "db", "dc", "dd", "de", "df", "e0", "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "ea", "eb", "ec", "ed", "ee", "ef", "f0", "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "fa", "fb", "fc", "fd", "fe", "ff"];
let T4 = 1234567;
const pl = Math.PI / 180, zl = 180 / Math.PI;
function Ps() {
  const t = Math.random() * 4294967295 | 0, e = Math.random() * 4294967295 | 0, n = Math.random() * 4294967295 | 0, r = Math.random() * 4294967295 | 0;
  return (gn[t & 255] + gn[t >> 8 & 255] + gn[t >> 16 & 255] + gn[t >> 24 & 255] + "-" + gn[e & 255] + gn[e >> 8 & 255] + "-" + gn[e >> 16 & 15 | 64] + gn[e >> 24 & 255] + "-" + gn[n & 63 | 128] + gn[n >> 8 & 255] + "-" + gn[n >> 16 & 255] + gn[n >> 24 & 255] + gn[r & 255] + gn[r >> 8 & 255] + gn[r >> 16 & 255] + gn[r >> 24 & 255]).toLowerCase();
}
function dt(t, e, n) {
  return Math.max(e, Math.min(n, t));
}
function M2(t, e) {
  return (t % e + e) % e;
}
function XQ(t, e, n, r, i) {
  return r + (t - e) * (i - r) / (n - e);
}
function YQ(t, e, n) {
  return t !== e ? (n - t) / (e - t) : 0;
}
function ml(t, e, n) {
  return (1 - n) * t + n * e;
}
function ZQ(t, e, n, r) {
  return ml(t, e, 1 - Math.exp(-n * r));
}
function KQ(t, e = 1) {
  return e - Math.abs(M2(t, e * 2) - e);
}
function JQ(t, e, n) {
  return t <= e ? 0 : t >= n ? 1 : (t = (t - e) / (n - e), t * t * (3 - 2 * t));
}
function QQ(t, e, n) {
  return t <= e ? 0 : t >= n ? 1 : (t = (t - e) / (n - e), t * t * t * (t * (t * 6 - 15) + 10));
}
function eee(t, e) {
  return t + Math.floor(Math.random() * (e - t + 1));
}
function tee(t, e) {
  return t + Math.random() * (e - t);
}
function nee(t) {
  return t * (0.5 - Math.random());
}
function ree(t) {
  t !== void 0 && (T4 = t);
  let e = T4 += 1831565813;
  return e = Math.imul(e ^ e >>> 15, e | 1), e ^= e + Math.imul(e ^ e >>> 7, e | 61), ((e ^ e >>> 14) >>> 0) / 4294967296;
}
function iee(t) {
  return t * pl;
}
function oee(t) {
  return t * zl;
}
function aee(t) {
  return (t & t - 1) === 0 && t !== 0;
}
function see(t) {
  return Math.pow(2, Math.ceil(Math.log(t) / Math.LN2));
}
function lee(t) {
  return Math.pow(2, Math.floor(Math.log(t) / Math.LN2));
}
function cee(t, e, n, r, i) {
  const o = Math.cos, a = Math.sin, s = o(n / 2), l = a(n / 2), c = o((e + r) / 2), u = a((e + r) / 2), d = o((e - r) / 2), f = a((e - r) / 2), h = o((r - e) / 2), v = a((r - e) / 2);
  switch (i) {
    case "XYX":
      t.set(s * u, l * d, l * f, s * c);
      break;
    case "YZY":
      t.set(l * f, s * u, l * d, s * c);
      break;
    case "ZXZ":
      t.set(l * d, l * f, s * u, s * c);
      break;
    case "XZX":
      t.set(s * u, l * v, l * h, s * c);
      break;
    case "YXY":
      t.set(l * h, s * u, l * v, s * c);
      break;
    case "ZYZ":
      t.set(l * v, l * h, s * u, s * c);
      break;
    default:
      console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + i);
  }
}
function Ha(t, e) {
  switch (e.constructor) {
    case Float32Array:
      return t;
    case Uint32Array:
      return t / 4294967295;
    case Uint16Array:
      return t / 65535;
    case Uint8Array:
      return t / 255;
    case Int32Array:
      return Math.max(t / 2147483647, -1);
    case Int16Array:
      return Math.max(t / 32767, -1);
    case Int8Array:
      return Math.max(t / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
function wn(t, e) {
  switch (e.constructor) {
    case Float32Array:
      return t;
    case Uint32Array:
      return Math.round(t * 4294967295);
    case Uint16Array:
      return Math.round(t * 65535);
    case Uint8Array:
      return Math.round(t * 255);
    case Int32Array:
      return Math.round(t * 2147483647);
    case Int16Array:
      return Math.round(t * 32767);
    case Int8Array:
      return Math.round(t * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
const Mt = {
  DEG2RAD: pl,
  RAD2DEG: zl,
  /**
   * Generate a [UUID]{@link https://en.wikipedia.org/wiki/Universally_unique_identifier}
   * (universally unique identifier).
   *
   * @static
   * @method
   * @return {string} The UUID.
   */
  generateUUID: Ps,
  /**
   * Clamps the given value between min and max.
   *
   * @static
   * @method
   * @param {number} value - The value to clamp.
   * @param {number} min - The min value.
   * @param {number} max - The max value.
   * @return {number} The clamped value.
   */
  clamp: dt,
  /**
   * Computes the Euclidean modulo of the given parameters that
   * is `( ( n % m ) + m ) % m`.
   *
   * @static
   * @method
   * @param {number} n - The first parameter.
   * @param {number} m - The second parameter.
   * @return {number} The Euclidean modulo.
   */
  euclideanModulo: M2,
  /**
   * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
   * for the given value.
   *
   * @static
   * @method
   * @param {number} x - The value to be mapped.
   * @param {number} a1 - Minimum value for range A.
   * @param {number} a2 - Maximum value for range A.
   * @param {number} b1 - Minimum value for range B.
   * @param {number} b2 - Maximum value for range B.
   * @return {number} The mapped value.
   */
  mapLinear: XQ,
  /**
   * Returns the percentage in the closed interval `[0, 1]` of the given value
   * between the start and end point.
   *
   * @static
   * @method
   * @param {number} x - The start point
   * @param {number} y - The end point.
   * @param {number} value - A value between start and end.
   * @return {number} The interpolation factor.
   */
  inverseLerp: YQ,
  /**
   * Returns a value linearly interpolated from two known points based on the given interval -
   * `t = 0` will return `x` and `t = 1` will return `y`.
   *
   * @static
   * @method
   * @param {number} x - The start point
   * @param {number} y - The end point.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {number} The interpolated value.
   */
  lerp: ml,
  /**
   * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
   * time to maintain frame rate independent movement. For details, see
   * [Frame rate independent damping using lerp]{@link http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/}.
   *
   * @static
   * @method
   * @param {number} x - The current point.
   * @param {number} y - The target point.
   * @param {number} lambda - A higher lambda value will make the movement more sudden,
   * and a lower value will make the movement more gradual.
   * @param {number} dt - Delta time in seconds.
   * @return {number} The interpolated value.
   */
  damp: ZQ,
  /**
   * Returns a value that alternates between `0` and the given `length` parameter.
   *
   * @static
   * @method
   * @param {number} x - The value to pingpong.
   * @param {number} [length=1] - The positive value the function will pingpong to.
   * @return {number} The alternated value.
   */
  pingpong: KQ,
  /**
   * Returns a value in the range `[0,1]` that represents the percentage that `x` has
   * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
   * the `min` and `max`.
   *
   * See [Smoothstep]{@link http://en.wikipedia.org/wiki/Smoothstep} for more details.
   *
   * @static
   * @method
   * @param {number} x - The value to evaluate based on its position between min and max.
   * @param {number} min - The min value. Any x value below min will be `0`.
   * @param {number} max - The max value. Any x value above max will be `1`.
   * @return {number} The alternated value.
   */
  smoothstep: JQ,
  /**
   * A [variation on smoothstep]{@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
   * that has zero 1st and 2nd order derivatives at x=0 and x=1.
   *
   * @static
   * @method
   * @param {number} x - The value to evaluate based on its position between min and max.
   * @param {number} min - The min value. Any x value below min will be `0`.
   * @param {number} max - The max value. Any x value above max will be `1`.
   * @return {number} The alternated value.
   */
  smootherstep: QQ,
  /**
   * Returns a random integer from `<low, high>` interval.
   *
   * @static
   * @method
   * @param {number} low - The lower value boundary.
   * @param {number} high - The upper value boundary
   * @return {number} A random integer.
   */
  randInt: eee,
  /**
   * Returns a random float from `<low, high>` interval.
   *
   * @static
   * @method
   * @param {number} low - The lower value boundary.
   * @param {number} high - The upper value boundary
   * @return {number} A random float.
   */
  randFloat: tee,
  /**
   * Returns a random integer from `<-range/2, range/2>` interval.
   *
   * @static
   * @method
   * @param {number} range - Defines the value range.
   * @return {number} A random float.
   */
  randFloatSpread: nee,
  /**
   * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
   *
   * @static
   * @method
   * @param {number} [s] - The integer seed.
   * @return {number} A random float.
   */
  seededRandom: ree,
  /**
   * Converts degrees to radians.
   *
   * @static
   * @method
   * @param {number} degrees - A value in degrees.
   * @return {number} The converted value in radians.
   */
  degToRad: iee,
  /**
   * Converts radians to degrees.
   *
   * @static
   * @method
   * @param {number} radians - A value in radians.
   * @return {number} The converted value in degrees.
   */
  radToDeg: oee,
  /**
   * Returns `true` if the given number is a power of two.
   *
   * @static
   * @method
   * @param {number} value - The value to check.
   * @return {boolean} Whether the given number is a power of two or not.
   */
  isPowerOfTwo: aee,
  /**
   * Returns the smallest power of two that is greater than or equal to the given number.
   *
   * @static
   * @method
   * @param {number} value - The value to find a POT for.
   * @return {number} The smallest power of two that is greater than or equal to the given number.
   */
  ceilPowerOfTwo: see,
  /**
   * Returns the largest power of two that is less than or equal to the given number.
   *
   * @static
   * @method
   * @param {number} value - The value to find a POT for.
   * @return {number} The largest power of two that is less than or equal to the given number.
   */
  floorPowerOfTwo: lee,
  /**
   * Sets the given quaternion from the [Intrinsic Proper Euler Angles]{@link https://en.wikipedia.org/wiki/Euler_angles}
   * defined by the given angles and order.
   *
   * Rotations are applied to the axes in the order specified by order:
   * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
   *
   * @static
   * @method
   * @param {Quaternion} q - The quaternion to set.
   * @param {number} a - The rotation applied to the first axis, in radians.
   * @param {number} b - The rotation applied to the second axis, in radians.
   * @param {number} c - The rotation applied to the third axis, in radians.
   * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
   */
  setQuaternionFromProperEuler: cee,
  /**
   * Normalizes the given value according to the given typed array.
   *
   * @static
   * @method
   * @param {number} value - The float value in the range `[0,1]` to normalize.
   * @param {TypedArray} array - The typed array that defines the data type of the value.
   * @return {number} The normalize value.
   */
  normalize: wn,
  /**
   * Denormalizes the given value according to the given typed array.
   *
   * @static
   * @method
   * @param {number} value - The value to denormalize.
   * @param {TypedArray} array - The typed array that defines the data type of the value.
   * @return {number} The denormalize (float) value in the range `[0,1]`.
   */
  denormalize: Ha
};
class Pt {
  /**
   * Constructs a new 2D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   */
  constructor(e = 0, n = 0) {
    Pt.prototype.isVector2 = !0, this.x = e, this.y = n;
  }
  /**
   * Alias for {@link Vector2#x}.
   *
   * @type {number}
   */
  get width() {
    return this.x;
  }
  set width(e) {
    this.x = e;
  }
  /**
   * Alias for {@link Vector2#y}.
   *
   * @type {number}
   */
  get height() {
    return this.y;
  }
  set height(e) {
    this.y = e;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @return {Vector2} A reference to this vector.
   */
  set(e, n) {
    return this.x = e, this.y = n, this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector2} A reference to this vector.
   */
  setScalar(e) {
    return this.x = e, this.y = e, this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setX(e) {
    return this.x = e, this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setY(e) {
    return this.y = e, this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y.
   * @param {number} value - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setComponent(e, n) {
    switch (e) {
      case 0:
        this.x = n;
        break;
      case 1:
        this.y = n;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y.
   * @return {number} A vector component value.
   */
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector2} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector2} v - The vector to copy.
   * @return {Vector2} A reference to this vector.
   */
  copy(e) {
    return this.x = e.x, this.y = e.y, this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector2} v - The vector to add.
   * @return {Vector2} A reference to this vector.
   */
  add(e) {
    return this.x += e.x, this.y += e.y, this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector2} A reference to this vector.
   */
  addScalar(e) {
    return this.x += e, this.y += e, this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector2} a - The first vector.
   * @param {Vector2} b - The second vector.
   * @return {Vector2} A reference to this vector.
   */
  addVectors(e, n) {
    return this.x = e.x + n.x, this.y = e.y + n.y, this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector2} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector2} A reference to this vector.
   */
  addScaledVector(e, n) {
    return this.x += e.x * n, this.y += e.y * n, this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector2} v - The vector to subtract.
   * @return {Vector2} A reference to this vector.
   */
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector2} A reference to this vector.
   */
  subScalar(e) {
    return this.x -= e, this.y -= e, this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector2} a - The first vector.
   * @param {Vector2} b - The second vector.
   * @return {Vector2} A reference to this vector.
   */
  subVectors(e, n) {
    return this.x = e.x - n.x, this.y = e.y - n.y, this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector2} v - The vector to multiply.
   * @return {Vector2} A reference to this vector.
   */
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector2} A reference to this vector.
   */
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this;
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector2} v - The vector to divide.
   * @return {Vector2} A reference to this vector.
   */
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector2} A reference to this vector.
   */
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  /**
   * Multiplies this vector (with an implicit 1 as the 3rd component) by
   * the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to apply.
   * @return {Vector2} A reference to this vector.
   */
  applyMatrix3(e) {
    const n = this.x, r = this.y, i = e.elements;
    return this.x = i[0] * n + i[3] * r + i[6], this.y = i[1] * n + i[4] * r + i[7], this;
  }
  /**
   * If this vector's x or y value is greater than the given vector's x or y
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector2} v - The vector.
   * @return {Vector2} A reference to this vector.
   */
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this;
  }
  /**
   * If this vector's x or y value is less than the given vector's x or y
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector2} v - The vector.
   * @return {Vector2} A reference to this vector.
   */
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this;
  }
  /**
   * If this vector's x or y value is greater than the max vector's x or y
   * value, it is replaced by the corresponding value.
   * If this vector's x or y value is less than the min vector's x or y value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector2} min - The minimum x and y values.
   * @param {Vector2} max - The maximum x and y values in the desired range.
   * @return {Vector2} A reference to this vector.
   */
  clamp(e, n) {
    return this.x = dt(this.x, e.x, n.x), this.y = dt(this.y, e.y, n.y), this;
  }
  /**
   * If this vector's x or y values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x or y values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector2} A reference to this vector.
   */
  clampScalar(e, n) {
    return this.x = dt(this.x, e, n), this.y = dt(this.y, e, n), this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector2} A reference to this vector.
   */
  clampLength(e, n) {
    const r = this.length();
    return this.divideScalar(r || 1).multiplyScalar(dt(r, e, n));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector2} A reference to this vector.
   */
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x and y = -y.
   *
   * @return {Vector2} A reference to this vector.
   */
  negate() {
    return this.x = -this.x, this.y = -this.y, this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector2} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this.x * e.x + this.y * e.y;
  }
  /**
   * Calculates the cross product of the given vector with this instance.
   *
   * @param {Vector2} v - The vector to compute the cross product with.
   * @return {number} The result of the cross product.
   */
  cross(e) {
    return this.x * e.y - this.y * e.x;
  }
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector2} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Computes the angle in radians of this vector with respect to the positive x-axis.
   *
   * @return {number} The angle in radians.
   */
  angle() {
    return Math.atan2(-this.y, -this.x) + Math.PI;
  }
  /**
   * Returns the angle between the given vector and this instance in radians.
   *
   * @param {Vector2} v - The vector to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(e) {
    const n = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (n === 0)
      return Math.PI / 2;
    const r = this.dot(e) / n;
    return Math.acos(dt(r, -1, 1));
  }
  /**
   * Computes the distance from the given vector to this instance.
   *
   * @param {Vector2} v - The vector to compute the distance to.
   * @return {number} The distance.
   */
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  /**
   * Computes the squared distance from the given vector to this instance.
   * If you are just comparing the distance with another distance, you should compare
   * the distance squared instead as it is slightly more efficient to calculate.
   *
   * @param {Vector2} v - The vector to compute the squared distance to.
   * @return {number} The squared distance.
   */
  distanceToSquared(e) {
    const n = this.x - e.x, r = this.y - e.y;
    return n * n + r * r;
  }
  /**
   * Computes the Manhattan distance from the given vector to this instance.
   *
   * @param {Vector2} v - The vector to compute the Manhattan distance to.
   * @return {number} The Manhattan distance.
   */
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector2} A reference to this vector.
   */
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector2} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector2} A reference to this vector.
   */
  lerp(e, n) {
    return this.x += (e.x - this.x) * n, this.y += (e.y - this.y) * n, this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector2} v1 - The first vector.
   * @param {Vector2} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector2} A reference to this vector.
   */
  lerpVectors(e, n, r) {
    return this.x = e.x + (n.x - e.x) * r, this.y = e.y + (n.y - e.y) * r, this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector2} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(e) {
    return e.x === this.x && e.y === this.y;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]` and y
   * value to be `array[ offset + 1 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector2} A reference to this vector.
   */
  fromArray(e, n = 0) {
    return this.x = e[n], this.y = e[n + 1], this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(e = [], n = 0) {
    return e[n] = this.x, e[n + 1] = this.y, e;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector2} A reference to this vector.
   */
  fromBufferAttribute(e, n) {
    return this.x = e.getX(n), this.y = e.getY(n), this;
  }
  /**
   * Rotates this vector around the given center by the given angle.
   *
   * @param {Vector2} center - The point around which to rotate.
   * @param {number} angle - The angle to rotate, in radians.
   * @return {Vector2} A reference to this vector.
   */
  rotateAround(e, n) {
    const r = Math.cos(n), i = Math.sin(n), o = this.x - e.x, a = this.y - e.y;
    return this.x = o * r - a * i + e.x, this.y = o * i + a * r + e.y, this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector2} A reference to this vector.
   */
  random() {
    return this.x = Math.random(), this.y = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y;
  }
}
class ot {
  /**
   * Constructs a new 3x3 matrix. The arguments are supposed to be
   * in row-major order. If no arguments are provided, the constructor
   * initializes the matrix as an identity matrix.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   */
  constructor(e, n, r, i, o, a, s, l, c) {
    ot.prototype.isMatrix3 = !0, this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ], e !== void 0 && this.set(e, n, r, i, o, a, s, l, c);
  }
  /**
   * Sets the elements of the matrix.The arguments are supposed to be
   * in row-major order.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @return {Matrix3} A reference to this matrix.
   */
  set(e, n, r, i, o, a, s, l, c) {
    const u = this.elements;
    return u[0] = e, u[1] = i, u[2] = s, u[3] = n, u[4] = o, u[5] = l, u[6] = r, u[7] = a, u[8] = c, this;
  }
  /**
   * Sets this matrix to the 3x3 identity matrix.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Copies the values of the given matrix to this instance.
   *
   * @param {Matrix3} m - The matrix to copy.
   * @return {Matrix3} A reference to this matrix.
   */
  copy(e) {
    const n = this.elements, r = e.elements;
    return n[0] = r[0], n[1] = r[1], n[2] = r[2], n[3] = r[3], n[4] = r[4], n[5] = r[5], n[6] = r[6], n[7] = r[7], n[8] = r[8], this;
  }
  /**
   * Extracts the basis of this matrix into the three axis vectors provided.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix3} A reference to this matrix.
   */
  extractBasis(e, n, r) {
    return e.setFromMatrix3Column(this, 0), n.setFromMatrix3Column(this, 1), r.setFromMatrix3Column(this, 2), this;
  }
  /**
   * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  setFromMatrix4(e) {
    const n = e.elements;
    return this.set(
      n[0],
      n[4],
      n[8],
      n[1],
      n[5],
      n[9],
      n[2],
      n[6],
      n[10]
    ), this;
  }
  /**
   * Post-multiplies this matrix by the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to multiply with.
   * @return {Matrix3} A reference to this matrix.
   */
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  /**
   * Pre-multiplies this matrix by the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to multiply with.
   * @return {Matrix3} A reference to this matrix.
   */
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  /**
   * Multiples the given 3x3 matrices and stores the result
   * in this matrix.
   *
   * @param {Matrix3} a - The first matrix.
   * @param {Matrix3} b - The second matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  multiplyMatrices(e, n) {
    const r = e.elements, i = n.elements, o = this.elements, a = r[0], s = r[3], l = r[6], c = r[1], u = r[4], d = r[7], f = r[2], h = r[5], v = r[8], g = i[0], m = i[3], p = i[6], y = i[1], b = i[4], x = i[7], _ = i[2], M = i[5], S = i[8];
    return o[0] = a * g + s * y + l * _, o[3] = a * m + s * b + l * M, o[6] = a * p + s * x + l * S, o[1] = c * g + u * y + d * _, o[4] = c * m + u * b + d * M, o[7] = c * p + u * x + d * S, o[2] = f * g + h * y + v * _, o[5] = f * m + h * b + v * M, o[8] = f * p + h * x + v * S, this;
  }
  /**
   * Multiplies every component of the matrix by the given scalar.
   *
   * @param {number} s - The scalar.
   * @return {Matrix3} A reference to this matrix.
   */
  multiplyScalar(e) {
    const n = this.elements;
    return n[0] *= e, n[3] *= e, n[6] *= e, n[1] *= e, n[4] *= e, n[7] *= e, n[2] *= e, n[5] *= e, n[8] *= e, this;
  }
  /**
   * Computes and returns the determinant of this matrix.
   *
   * @return {number} The determinant.
   */
  determinant() {
    const e = this.elements, n = e[0], r = e[1], i = e[2], o = e[3], a = e[4], s = e[5], l = e[6], c = e[7], u = e[8];
    return n * a * u - n * s * c - r * o * u + r * s * l + i * o * c - i * a * l;
  }
  /**
   * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
   * You can not invert with a determinant of zero. If you attempt this, the method produces
   * a zero matrix instead.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  invert() {
    const e = this.elements, n = e[0], r = e[1], i = e[2], o = e[3], a = e[4], s = e[5], l = e[6], c = e[7], u = e[8], d = u * a - s * c, f = s * l - u * o, h = c * o - a * l, v = n * d + r * f + i * h;
    if (v === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const g = 1 / v;
    return e[0] = d * g, e[1] = (i * c - u * r) * g, e[2] = (s * r - i * a) * g, e[3] = f * g, e[4] = (u * n - i * l) * g, e[5] = (i * o - s * n) * g, e[6] = h * g, e[7] = (r * l - c * n) * g, e[8] = (a * n - r * o) * g, this;
  }
  /**
   * Transposes this matrix in place.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  transpose() {
    let e;
    const n = this.elements;
    return e = n[1], n[1] = n[3], n[3] = e, e = n[2], n[2] = n[6], n[6] = e, e = n[5], n[5] = n[7], n[7] = e, this;
  }
  /**
   * Computes the normal matrix which is the inverse transpose of the upper
   * left 3x3 portion of the given 4x4 matrix.
   *
   * @param {Matrix4} matrix4 - The 4x4 matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  getNormalMatrix(e) {
    return this.setFromMatrix4(e).invert().transpose();
  }
  /**
   * Transposes this matrix into the supplied array, and returns itself unchanged.
   *
   * @param {Array<number>} r - An array to store the transposed matrix elements.
   * @return {Matrix3} A reference to this matrix.
   */
  transposeIntoArray(e) {
    const n = this.elements;
    return e[0] = n[0], e[1] = n[3], e[2] = n[6], e[3] = n[1], e[4] = n[4], e[5] = n[7], e[6] = n[2], e[7] = n[5], e[8] = n[8], this;
  }
  /**
   * Sets the UV transform matrix from offset, repeat, rotation, and center.
   *
   * @param {number} tx - Offset x.
   * @param {number} ty - Offset y.
   * @param {number} sx - Repeat x.
   * @param {number} sy - Repeat y.
   * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
   * @param {number} cx - Center x of rotation.
   * @param {number} cy - Center y of rotation
   * @return {Matrix3} A reference to this matrix.
   */
  setUvTransform(e, n, r, i, o, a, s) {
    const l = Math.cos(o), c = Math.sin(o);
    return this.set(
      r * l,
      r * c,
      -r * (l * a + c * s) + a + e,
      -i * c,
      i * l,
      -i * (-c * a + l * s) + s + n,
      0,
      0,
      1
    ), this;
  }
  /**
   * Scales this matrix with the given scalar values.
   *
   * @param {number} sx - The amount to scale in the X axis.
   * @param {number} sy - The amount to scale in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  scale(e, n) {
    return this.premultiply(h0.makeScale(e, n)), this;
  }
  /**
   * Rotates this matrix by the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix3} A reference to this matrix.
   */
  rotate(e) {
    return this.premultiply(h0.makeRotation(-e)), this;
  }
  /**
   * Translates this matrix by the given scalar values.
   *
   * @param {number} tx - The amount to translate in the X axis.
   * @param {number} ty - The amount to translate in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  translate(e, n) {
    return this.premultiply(h0.makeTranslation(e, n)), this;
  }
  // for 2D Transforms
  /**
   * Sets this matrix as a 2D translation transform.
   *
   * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
   * @param {number} y - The amount to translate in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  makeTranslation(e, n) {
    return e.isVector2 ? this.set(
      1,
      0,
      e.x,
      0,
      1,
      e.y,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      e,
      0,
      1,
      n,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a 2D rotational transformation.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix3} A reference to this matrix.
   */
  makeRotation(e) {
    const n = Math.cos(e), r = Math.sin(e);
    return this.set(
      n,
      -r,
      0,
      r,
      n,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a 2D scale transform.
   *
   * @param {number} x - The amount to scale in the X axis.
   * @param {number} y - The amount to scale in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  makeScale(e, n) {
    return this.set(
      e,
      0,
      0,
      0,
      n,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Returns `true` if this matrix is equal with the given one.
   *
   * @param {Matrix3} matrix - The matrix to test for equality.
   * @return {boolean} Whether this matrix is equal with the given one.
   */
  equals(e) {
    const n = this.elements, r = e.elements;
    for (let i = 0; i < 9; i++)
      if (n[i] !== r[i])
        return !1;
    return !0;
  }
  /**
   * Sets the elements of the matrix from the given array.
   *
   * @param {Array<number>} array - The matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Matrix3} A reference to this matrix.
   */
  fromArray(e, n = 0) {
    for (let r = 0; r < 9; r++)
      this.elements[r] = e[r + n];
    return this;
  }
  /**
   * Writes the elements of this matrix to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The matrix elements in column-major order.
   */
  toArray(e = [], n = 0) {
    const r = this.elements;
    return e[n] = r[0], e[n + 1] = r[1], e[n + 2] = r[2], e[n + 3] = r[3], e[n + 4] = r[4], e[n + 5] = r[5], e[n + 6] = r[6], e[n + 7] = r[7], e[n + 8] = r[8], e;
  }
  /**
   * Returns a matrix with copied values from this instance.
   *
   * @return {Matrix3} A clone of this instance.
   */
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
}
const h0 = /* @__PURE__ */ new ot();
function O9(t) {
  for (let e = t.length - 1; e >= 0; --e)
    if (t[e] >= 65535)
      return !0;
  return !1;
}
function id(t) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", t);
}
function uee() {
  const t = id("canvas");
  return t.style.display = "block", t;
}
const A4 = {};
function Au(t) {
  t in A4 || (A4[t] = !0, console.warn(t));
}
function dee(t, e, n) {
  return new Promise(function(r, i) {
    function o() {
      switch (t.clientWaitSync(e, t.SYNC_FLUSH_COMMANDS_BIT, 0)) {
        case t.WAIT_FAILED:
          i();
          break;
        case t.TIMEOUT_EXPIRED:
          setTimeout(o, n);
          break;
        default:
          r();
      }
    }
    setTimeout(o, n);
  });
}
function fee(t) {
  const e = t.elements;
  e[2] = 0.5 * e[2] + 0.5 * e[3], e[6] = 0.5 * e[6] + 0.5 * e[7], e[10] = 0.5 * e[10] + 0.5 * e[11], e[14] = 0.5 * e[14] + 0.5 * e[15];
}
function hee(t) {
  const e = t.elements;
  e[11] === -1 ? (e[10] = -e[10] - 1, e[14] = -e[14]) : (e[10] = -e[10], e[14] = -e[14] + 1);
}
const P4 = /* @__PURE__ */ new ot().set(
  0.4123908,
  0.3575843,
  0.1804808,
  0.212639,
  0.7151687,
  0.0721923,
  0.0193308,
  0.1191948,
  0.9505322
), R4 = /* @__PURE__ */ new ot().set(
  3.2409699,
  -1.5373832,
  -0.4986108,
  -0.9692436,
  1.8759675,
  0.0415551,
  0.0556301,
  -0.203977,
  1.0569715
);
function pee() {
  const t = {
    enabled: !0,
    workingColorSpace: zo,
    /**
     * Implementations of supported color spaces.
     *
     * Required:
     *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
     *	- whitePoint: reference white [ x y ]
     *	- transfer: transfer function (pre-defined)
     *	- toXYZ: Matrix3 RGB to XYZ transform
     *	- fromXYZ: Matrix3 XYZ to RGB transform
     *	- luminanceCoefficients: RGB luminance coefficients
     *
     * Optional:
     *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
     *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
     *
     * Reference:
     * - https://www.russellcottrell.com/photo/matrixCalculator.htm
     */
    spaces: {},
    convert: function(i, o, a) {
      return this.enabled === !1 || o === a || !o || !a || (this.spaces[o].transfer === Tt && (i.r = ai(i.r), i.g = ai(i.g), i.b = ai(i.b)), this.spaces[o].primaries !== this.spaces[a].primaries && (i.applyMatrix3(this.spaces[o].toXYZ), i.applyMatrix3(this.spaces[a].fromXYZ)), this.spaces[a].transfer === Tt && (i.r = Ka(i.r), i.g = Ka(i.g), i.b = Ka(i.b))), i;
    },
    fromWorkingColorSpace: function(i, o) {
      return this.convert(i, this.workingColorSpace, o);
    },
    toWorkingColorSpace: function(i, o) {
      return this.convert(i, o, this.workingColorSpace);
    },
    getPrimaries: function(i) {
      return this.spaces[i].primaries;
    },
    getTransfer: function(i) {
      return i === Ni ? nd : this.spaces[i].transfer;
    },
    getLuminanceCoefficients: function(i, o = this.workingColorSpace) {
      return i.fromArray(this.spaces[o].luminanceCoefficients);
    },
    define: function(i) {
      Object.assign(this.spaces, i);
    },
    // Internal APIs
    _getMatrix: function(i, o, a) {
      return i.copy(this.spaces[o].toXYZ).multiply(this.spaces[a].fromXYZ);
    },
    _getDrawingBufferColorSpace: function(i) {
      return this.spaces[i].outputColorSpaceConfig.drawingBufferColorSpace;
    },
    _getUnpackColorSpace: function(i = this.workingColorSpace) {
      return this.spaces[i].workingColorSpaceConfig.unpackColorSpace;
    }
  }, e = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06], n = [0.2126, 0.7152, 0.0722], r = [0.3127, 0.329];
  return t.define({
    [zo]: {
      primaries: e,
      whitePoint: r,
      transfer: nd,
      toXYZ: P4,
      fromXYZ: R4,
      luminanceCoefficients: n,
      workingColorSpaceConfig: { unpackColorSpace: er },
      outputColorSpaceConfig: { drawingBufferColorSpace: er }
    },
    [er]: {
      primaries: e,
      whitePoint: r,
      transfer: Tt,
      toXYZ: P4,
      fromXYZ: R4,
      luminanceCoefficients: n,
      outputColorSpaceConfig: { drawingBufferColorSpace: er }
    }
  }), t;
}
const mt = /* @__PURE__ */ pee();
function ai(t) {
  return t < 0.04045 ? t * 0.0773993808 : Math.pow(t * 0.9478672986 + 0.0521327014, 2.4);
}
function Ka(t) {
  return t < 31308e-7 ? t * 12.92 : 1.055 * Math.pow(t, 0.41666) - 0.055;
}
let oa;
class mee {
  /**
   * Returns a data URI containing a representation of the given image.
   *
   * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
   * @param {string} [type='image/png'] - Indicates the image format.
   * @return {string} The data URI.
   */
  static getDataURL(e, n = "image/png") {
    if (/^data:/i.test(e.src) || typeof HTMLCanvasElement > "u")
      return e.src;
    let r;
    if (e instanceof HTMLCanvasElement)
      r = e;
    else {
      oa === void 0 && (oa = id("canvas")), oa.width = e.width, oa.height = e.height;
      const i = oa.getContext("2d");
      e instanceof ImageData ? i.putImageData(e, 0, 0) : i.drawImage(e, 0, 0, e.width, e.height), r = oa;
    }
    return r.toDataURL(n);
  }
  /**
   * Converts the given sRGB image data to linear color space.
   *
   * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
   * @return {HTMLCanvasElement|Object} The converted image.
   */
  static sRGBToLinear(e) {
    if (typeof HTMLImageElement < "u" && e instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap) {
      const n = id("canvas");
      n.width = e.width, n.height = e.height;
      const r = n.getContext("2d");
      r.drawImage(e, 0, 0, e.width, e.height);
      const i = r.getImageData(0, 0, e.width, e.height), o = i.data;
      for (let a = 0; a < o.length; a++)
        o[a] = ai(o[a] / 255) * 255;
      return r.putImageData(i, 0, 0), n;
    } else if (e.data) {
      const n = e.data.slice(0);
      for (let r = 0; r < n.length; r++)
        n instanceof Uint8Array || n instanceof Uint8ClampedArray ? n[r] = Math.floor(ai(n[r] / 255) * 255) : n[r] = ai(n[r]);
      return {
        data: n,
        width: e.width,
        height: e.height
      };
    } else
      return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e;
  }
}
let vee = 0;
class T2 {
  /**
   * Constructs a new video texture.
   *
   * @param {any} [data=null] - The data definition of a texture.
   */
  constructor(e = null) {
    this.isSource = !0, Object.defineProperty(this, "id", { value: vee++ }), this.uuid = Ps(), this.data = e, this.dataReady = !0, this.version = 0;
  }
  /**
   * When the property is set to `true`, the engine allocates the memory
   * for the texture (if necessary) and triggers the actual texture upload
   * to the GPU next time the source is used.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  /**
   * Serializes the source into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized source.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const n = e === void 0 || typeof e == "string";
    if (!n && e.images[this.uuid] !== void 0)
      return e.images[this.uuid];
    const r = {
      uuid: this.uuid,
      url: ""
    }, i = this.data;
    if (i !== null) {
      let o;
      if (Array.isArray(i)) {
        o = [];
        for (let a = 0, s = i.length; a < s; a++)
          i[a].isDataTexture ? o.push(p0(i[a].image)) : o.push(p0(i[a]));
      } else
        o = p0(i);
      r.url = o;
    }
    return n || (e.images[this.uuid] = r), r;
  }
}
function p0(t) {
  return typeof HTMLImageElement < "u" && t instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && t instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && t instanceof ImageBitmap ? mee.getDataURL(t) : t.data ? {
    data: Array.from(t.data),
    width: t.width,
    height: t.height,
    type: t.data.constructor.name
  } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
}
let gee = 0;
class En extends As {
  /**
   * Constructs a new texture.
   *
   * @param {?Object} [image=Texture.DEFAULT_IMAGE] - The image holding the texture data.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space.
   */
  constructor(e = En.DEFAULT_IMAGE, n = En.DEFAULT_MAPPING, r = To, i = To, o = yr, a = Ui, s = br, l = di, c = En.DEFAULT_ANISOTROPY, u = Ni) {
    super(), this.isTexture = !0, Object.defineProperty(this, "id", { value: gee++ }), this.uuid = Ps(), this.name = "", this.source = new T2(e), this.mipmaps = [], this.mapping = n, this.channel = 0, this.wrapS = r, this.wrapT = i, this.magFilter = o, this.minFilter = a, this.anisotropy = c, this.format = s, this.internalFormat = null, this.type = l, this.offset = new Pt(0, 0), this.repeat = new Pt(1, 1), this.center = new Pt(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new ot(), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.colorSpace = u, this.userData = {}, this.version = 0, this.onUpdate = null, this.renderTarget = null, this.isRenderTargetTexture = !1, this.pmremVersion = 0;
  }
  /**
   * The image object holding the texture data.
   *
   * @type {?Object}
   */
  get image() {
    return this.source.data;
  }
  set image(e = null) {
    this.source.data = e;
  }
  /**
   * Updates the texture transformation matrix from the from the properties {@link Texture#offset},
   * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
   */
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  /**
   * Returns a new texture with copied values from this instance.
   *
   * @return {Texture} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given texture to this instance.
   *
   * @param {Texture} source - The texture to copy.
   * @return {Texture} A reference to this instance.
   */
  copy(e) {
    return this.name = e.name, this.source = e.source, this.mipmaps = e.mipmaps.slice(0), this.mapping = e.mapping, this.channel = e.channel, this.wrapS = e.wrapS, this.wrapT = e.wrapT, this.magFilter = e.magFilter, this.minFilter = e.minFilter, this.anisotropy = e.anisotropy, this.format = e.format, this.internalFormat = e.internalFormat, this.type = e.type, this.offset.copy(e.offset), this.repeat.copy(e.repeat), this.center.copy(e.center), this.rotation = e.rotation, this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrix.copy(e.matrix), this.generateMipmaps = e.generateMipmaps, this.premultiplyAlpha = e.premultiplyAlpha, this.flipY = e.flipY, this.unpackAlignment = e.unpackAlignment, this.colorSpace = e.colorSpace, this.renderTarget = e.renderTarget, this.isRenderTargetTexture = e.isRenderTargetTexture, this.userData = JSON.parse(JSON.stringify(e.userData)), this.needsUpdate = !0, this;
  }
  /**
   * Serializes the texture into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized texture.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const n = e === void 0 || typeof e == "string";
    if (!n && e.textures[this.uuid] !== void 0)
      return e.textures[this.uuid];
    const r = {
      metadata: {
        version: 4.6,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(e).uuid,
      mapping: this.mapping,
      channel: this.channel,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      internalFormat: this.internalFormat,
      type: this.type,
      colorSpace: this.colorSpace,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      generateMipmaps: this.generateMipmaps,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    return Object.keys(this.userData).length > 0 && (r.userData = this.userData), n || (e.textures[this.uuid] = r), r;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires Texture#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  /**
   * Transforms the given uv vector with the textures uv transformation matrix.
   *
   * @param {Vector2} uv - The uv vector.
   * @return {Vector2} The transformed uv vector.
   */
  transformUv(e) {
    if (this.mapping !== x9)
      return e;
    if (e.applyMatrix3(this.matrix), e.x < 0 || e.x > 1)
      switch (this.wrapS) {
        case Gh:
          e.x = e.x - Math.floor(e.x);
          break;
        case To:
          e.x = e.x < 0 ? 0 : 1;
          break;
        case qh:
          Math.abs(Math.floor(e.x) % 2) === 1 ? e.x = Math.ceil(e.x) - e.x : e.x = e.x - Math.floor(e.x);
          break;
      }
    if (e.y < 0 || e.y > 1)
      switch (this.wrapT) {
        case Gh:
          e.y = e.y - Math.floor(e.y);
          break;
        case To:
          e.y = e.y < 0 ? 0 : 1;
          break;
        case qh:
          Math.abs(Math.floor(e.y) % 2) === 1 ? e.y = Math.ceil(e.y) - e.y : e.y = e.y - Math.floor(e.y);
          break;
      }
    return this.flipY && (e.y = 1 - e.y), e;
  }
  /**
   * Setting this property to `true` indicates the engine the texture
   * must be updated in the next render. This triggers a texture upload
   * to the GPU and ensures correct texture parameter configuration.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && (this.version++, this.source.needsUpdate = !0);
  }
  /**
   * Setting this property to `true` indicates the engine the PMREM
   * must be regenerated.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsPMREMUpdate(e) {
    e === !0 && this.pmremVersion++;
  }
}
En.DEFAULT_IMAGE = null;
En.DEFAULT_MAPPING = x9;
En.DEFAULT_ANISOTROPY = 1;
class Yt {
  /**
   * Constructs a new 4D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   * @param {number} [z=0] - The z value of this vector.
   * @param {number} [w=1] - The w value of this vector.
   */
  constructor(e = 0, n = 0, r = 0, i = 1) {
    Yt.prototype.isVector4 = !0, this.x = e, this.y = n, this.z = r, this.w = i;
  }
  /**
   * Alias for {@link Vector4#z}.
   *
   * @type {number}
   */
  get width() {
    return this.z;
  }
  set width(e) {
    this.z = e;
  }
  /**
   * Alias for {@link Vector4#w}.
   *
   * @type {number}
   */
  get height() {
    return this.w;
  }
  set height(e) {
    this.w = e;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @param {number} z - The value of the z component.
   * @param {number} w - The value of the w component.
   * @return {Vector4} A reference to this vector.
   */
  set(e, n, r, i) {
    return this.x = e, this.y = n, this.z = r, this.w = i, this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector4} A reference to this vector.
   */
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this.w = e, this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setX(e) {
    return this.x = e, this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setY(e) {
    return this.y = e, this;
  }
  /**
   * Sets the vector's z component to the given value
   *
   * @param {number} z - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setZ(e) {
    return this.z = e, this;
  }
  /**
   * Sets the vector's w component to the given value
   *
   * @param {number} w - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setW(e) {
    return this.w = e, this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y,
   * `2` equals to z, `3` equals to w.
   * @param {number} value - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setComponent(e, n) {
    switch (e) {
      case 0:
        this.x = n;
        break;
      case 1:
        this.y = n;
        break;
      case 2:
        this.z = n;
        break;
      case 3:
        this.w = n;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y,
   * `2` equals to z, `3` equals to w.
   * @return {number} A vector component value.
   */
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector4} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector3|Vector4} v - The vector to copy.
   * @return {Vector4} A reference to this vector.
   */
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this.w = e.w !== void 0 ? e.w : 1, this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector4} v - The vector to add.
   * @return {Vector4} A reference to this vector.
   */
  add(e) {
    return this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector4} A reference to this vector.
   */
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this.w += e, this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector4} a - The first vector.
   * @param {Vector4} b - The second vector.
   * @return {Vector4} A reference to this vector.
   */
  addVectors(e, n) {
    return this.x = e.x + n.x, this.y = e.y + n.y, this.z = e.z + n.z, this.w = e.w + n.w, this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector4} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector4} A reference to this vector.
   */
  addScaledVector(e, n) {
    return this.x += e.x * n, this.y += e.y * n, this.z += e.z * n, this.w += e.w * n, this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector4} v - The vector to subtract.
   * @return {Vector4} A reference to this vector.
   */
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this.z -= e.z, this.w -= e.w, this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector4} A reference to this vector.
   */
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this.w -= e, this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector4} a - The first vector.
   * @param {Vector4} b - The second vector.
   * @return {Vector4} A reference to this vector.
   */
  subVectors(e, n) {
    return this.x = e.x - n.x, this.y = e.y - n.y, this.z = e.z - n.z, this.w = e.w - n.w, this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector4} v - The vector to multiply.
   * @return {Vector4} A reference to this vector.
   */
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this.w *= e.w, this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector4} A reference to this vector.
   */
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
  }
  /**
   * Multiplies this vector with the given 4x4 matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector4} A reference to this vector.
   */
  applyMatrix4(e) {
    const n = this.x, r = this.y, i = this.z, o = this.w, a = e.elements;
    return this.x = a[0] * n + a[4] * r + a[8] * i + a[12] * o, this.y = a[1] * n + a[5] * r + a[9] * i + a[13] * o, this.z = a[2] * n + a[6] * r + a[10] * i + a[14] * o, this.w = a[3] * n + a[7] * r + a[11] * i + a[15] * o, this;
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector4} v - The vector to divide.
   * @return {Vector4} A reference to this vector.
   */
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this.z /= e.z, this.w /= e.w, this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector4} A reference to this vector.
   */
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  /**
   * Sets the x, y and z components of this
   * vector to the quaternion's axis and w to the angle.
   *
   * @param {Quaternion} q - The Quaternion to set.
   * @return {Vector4} A reference to this vector.
   */
  setAxisAngleFromQuaternion(e) {
    this.w = 2 * Math.acos(e.w);
    const n = Math.sqrt(1 - e.w * e.w);
    return n < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e.x / n, this.y = e.y / n, this.z = e.z / n), this;
  }
  /**
   * Sets the x, y and z components of this
   * vector to the axis of rotation and w to the angle.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper left 3x3 matrix is a pure rotation matrix.
   * @return {Vector4} A reference to this vector.
   */
  setAxisAngleFromRotationMatrix(e) {
    let n, r, i, o;
    const l = e.elements, c = l[0], u = l[4], d = l[8], f = l[1], h = l[5], v = l[9], g = l[2], m = l[6], p = l[10];
    if (Math.abs(u - f) < 0.01 && Math.abs(d - g) < 0.01 && Math.abs(v - m) < 0.01) {
      if (Math.abs(u + f) < 0.1 && Math.abs(d + g) < 0.1 && Math.abs(v + m) < 0.1 && Math.abs(c + h + p - 3) < 0.1)
        return this.set(1, 0, 0, 0), this;
      n = Math.PI;
      const b = (c + 1) / 2, x = (h + 1) / 2, _ = (p + 1) / 2, M = (u + f) / 4, S = (d + g) / 4, P = (v + m) / 4;
      return b > x && b > _ ? b < 0.01 ? (r = 0, i = 0.707106781, o = 0.707106781) : (r = Math.sqrt(b), i = M / r, o = S / r) : x > _ ? x < 0.01 ? (r = 0.707106781, i = 0, o = 0.707106781) : (i = Math.sqrt(x), r = M / i, o = P / i) : _ < 0.01 ? (r = 0.707106781, i = 0.707106781, o = 0) : (o = Math.sqrt(_), r = S / o, i = P / o), this.set(r, i, o, n), this;
    }
    let y = Math.sqrt((m - v) * (m - v) + (d - g) * (d - g) + (f - u) * (f - u));
    return Math.abs(y) < 1e-3 && (y = 1), this.x = (m - v) / y, this.y = (d - g) / y, this.z = (f - u) / y, this.w = Math.acos((c + h + p - 1) / 2), this;
  }
  /**
   * Sets the vector components to the position elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector4} A reference to this vector.
   */
  setFromMatrixPosition(e) {
    const n = e.elements;
    return this.x = n[12], this.y = n[13], this.z = n[14], this.w = n[15], this;
  }
  /**
   * If this vector's x, y, z or w value is greater than the given vector's x, y, z or w
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector4} v - The vector.
   * @return {Vector4} A reference to this vector.
   */
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this.w = Math.min(this.w, e.w), this;
  }
  /**
   * If this vector's x, y, z or w value is less than the given vector's x, y, z or w
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector4} v - The vector.
   * @return {Vector4} A reference to this vector.
   */
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this.w = Math.max(this.w, e.w), this;
  }
  /**
   * If this vector's x, y, z or w value is greater than the max vector's x, y, z or w
   * value, it is replaced by the corresponding value.
   * If this vector's x, y, z or w value is less than the min vector's x, y, z or w value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector4} min - The minimum x, y and z values.
   * @param {Vector4} max - The maximum x, y and z values in the desired range.
   * @return {Vector4} A reference to this vector.
   */
  clamp(e, n) {
    return this.x = dt(this.x, e.x, n.x), this.y = dt(this.y, e.y, n.y), this.z = dt(this.z, e.z, n.z), this.w = dt(this.w, e.w, n.w), this;
  }
  /**
   * If this vector's x, y, z or w values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x, y, z or w values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector4} A reference to this vector.
   */
  clampScalar(e, n) {
    return this.x = dt(this.x, e, n), this.y = dt(this.y, e, n), this.z = dt(this.z, e, n), this.w = dt(this.w, e, n), this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector4} A reference to this vector.
   */
  clampLength(e, n) {
    const r = this.length();
    return this.divideScalar(r || 1).multiplyScalar(dt(r, e, n));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector4} A reference to this vector.
   */
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector4} A reference to this vector.
   */
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector4} A reference to this vector.
   */
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector4} A reference to this vector.
   */
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x, y = -y, z = -z, w = -w.
   *
   * @return {Vector4} A reference to this vector.
   */
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector4} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
  }
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0, 0, 0) to (x, y, z, w). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0, 0, 0) to (x, y, z, w).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector4} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector4} A reference to this vector.
   */
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector4} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector4} A reference to this vector.
   */
  lerp(e, n) {
    return this.x += (e.x - this.x) * n, this.y += (e.y - this.y) * n, this.z += (e.z - this.z) * n, this.w += (e.w - this.w) * n, this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector4} v1 - The first vector.
   * @param {Vector4} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector4} A reference to this vector.
   */
  lerpVectors(e, n, r) {
    return this.x = e.x + (n.x - e.x) * r, this.y = e.y + (n.y - e.y) * r, this.z = e.z + (n.z - e.z) * r, this.w = e.w + (n.w - e.w) * r, this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector4} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`,
   * z value to be `array[ offset + 2 ]`, w value to be `array[ offset + 3 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector4} A reference to this vector.
   */
  fromArray(e, n = 0) {
    return this.x = e[n], this.y = e[n + 1], this.z = e[n + 2], this.w = e[n + 3], this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(e = [], n = 0) {
    return e[n] = this.x, e[n + 1] = this.y, e[n + 2] = this.z, e[n + 3] = this.w, e;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector4} A reference to this vector.
   */
  fromBufferAttribute(e, n) {
    return this.x = e.getX(n), this.y = e.getY(n), this.z = e.getZ(n), this.w = e.getW(n), this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector4} A reference to this vector.
   */
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z, yield this.w;
  }
}
class yee extends As {
  /**
   * Render target options.
   *
   * @typedef {Object} RenderTarget~Options
   * @property {boolean} [generateMipmaps=false] - Whether to generate mipmaps or not.
   * @property {number} [magFilter=LinearFilter] - The mag filter.
   * @property {number} [minFilter=LinearFilter] - The min filter.
   * @property {number} [format=RGBAFormat] - The texture format.
   * @property {number} [type=UnsignedByteType] - The texture type.
   * @property {?string} [internalFormat=null] - The texture's internal format.
   * @property {number} [wrapS=ClampToEdgeWrapping] - The texture's uv wrapping mode.
   * @property {number} [wrapT=ClampToEdgeWrapping] - The texture's uv wrapping mode.
   * @property {number} [anisotropy=1] - The texture's anisotropy value.
   * @property {string} [colorSpace=NoColorSpace] - The texture's color space.
   * @property {boolean} [depthBuffer=true] - Whether to allocate a depth buffer or not.
   * @property {boolean} [stencilBuffer=false] - Whether to allocate a stencil buffer or not.
   * @property {boolean} [resolveDepthBuffer=true] - Whether to resolve the depth buffer or not.
   * @property {boolean} [resolveStencilBuffer=true] - Whether  to resolve the stencil buffer or not.
   * @property {?Texture} [depthTexture=null] - Reference to a depth texture.
   * @property {number} [samples=0] - The MSAA samples count.
   * @property {number} [count=1] - Defines the number of color attachments . Must be at least `1`.
   */
  /**
   * Constructs a new render target.
   *
   * @param {number} [width=1] - The width of the render target.
   * @param {number} [height=1] - The height of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */
  constructor(e = 1, n = 1, r = {}) {
    super(), this.isRenderTarget = !0, this.width = e, this.height = n, this.depth = 1, this.scissor = new Yt(0, 0, e, n), this.scissorTest = !1, this.viewport = new Yt(0, 0, e, n);
    const i = { width: e, height: n, depth: 1 };
    r = Object.assign({
      generateMipmaps: !1,
      internalFormat: null,
      minFilter: yr,
      depthBuffer: !0,
      stencilBuffer: !1,
      resolveDepthBuffer: !0,
      resolveStencilBuffer: !0,
      depthTexture: null,
      samples: 0,
      count: 1
    }, r);
    const o = new En(i, r.mapping, r.wrapS, r.wrapT, r.magFilter, r.minFilter, r.format, r.type, r.anisotropy, r.colorSpace);
    o.flipY = !1, o.generateMipmaps = r.generateMipmaps, o.internalFormat = r.internalFormat, this.textures = [];
    const a = r.count;
    for (let s = 0; s < a; s++)
      this.textures[s] = o.clone(), this.textures[s].isRenderTargetTexture = !0, this.textures[s].renderTarget = this;
    this.depthBuffer = r.depthBuffer, this.stencilBuffer = r.stencilBuffer, this.resolveDepthBuffer = r.resolveDepthBuffer, this.resolveStencilBuffer = r.resolveStencilBuffer, this._depthTexture = r.depthTexture, this.samples = r.samples;
  }
  /**
   * The texture representing the default color attachment.
   *
   * @type {Texture}
   */
  get texture() {
    return this.textures[0];
  }
  set texture(e) {
    this.textures[0] = e;
  }
  set depthTexture(e) {
    this._depthTexture !== null && (this._depthTexture.renderTarget = null), e !== null && (e.renderTarget = this), this._depthTexture = e;
  }
  /**
   * Instead of saving the depth in a renderbuffer, a texture
   * can be used instead which is useful for further processing
   * e.g. in context of post-processing.
   *
   * @type {?DepthTexture}
   * @default null
   */
  get depthTexture() {
    return this._depthTexture;
  }
  /**
   * Sets the size of this render target.
   *
   * @param {number} width - The width.
   * @param {number} height - The height.
   * @param {number} [depth=1] - The depth.
   */
  setSize(e, n, r = 1) {
    if (this.width !== e || this.height !== n || this.depth !== r) {
      this.width = e, this.height = n, this.depth = r;
      for (let i = 0, o = this.textures.length; i < o; i++)
        this.textures[i].image.width = e, this.textures[i].image.height = n, this.textures[i].image.depth = r;
      this.dispose();
    }
    this.viewport.set(0, 0, e, n), this.scissor.set(0, 0, e, n);
  }
  /**
   * Returns a new render target with copied values from this instance.
   *
   * @return {RenderTarget} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the settings of the given render target. This is a structural copy so
   * no resources are shared between render targets after the copy. That includes
   * all MRT textures and the depth texture.
   *
   * @param {RenderTarget} source - The render target to copy.
   * @return {RenderTarget} A reference to this instance.
   */
  copy(e) {
    this.width = e.width, this.height = e.height, this.depth = e.depth, this.scissor.copy(e.scissor), this.scissorTest = e.scissorTest, this.viewport.copy(e.viewport), this.textures.length = 0;
    for (let n = 0, r = e.textures.length; n < r; n++) {
      this.textures[n] = e.textures[n].clone(), this.textures[n].isRenderTargetTexture = !0, this.textures[n].renderTarget = this;
      const i = Object.assign({}, e.textures[n].image);
      this.textures[n].source = new T2(i);
    }
    return this.depthBuffer = e.depthBuffer, this.stencilBuffer = e.stencilBuffer, this.resolveDepthBuffer = e.resolveDepthBuffer, this.resolveStencilBuffer = e.resolveStencilBuffer, e.depthTexture !== null && (this.depthTexture = e.depthTexture.clone()), this.samples = e.samples, this;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires RenderTarget#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
class Qi extends yee {
  /**
   * Constructs a new 3D render target.
   *
   * @param {number} [width=1] - The width of the render target.
   * @param {number} [height=1] - The height of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */
  constructor(e = 1, n = 1, r = {}) {
    super(e, n, r), this.isWebGLRenderTarget = !0;
  }
}
class D9 extends En {
  /**
   * Constructs a new data array texture.
   *
   * @param {?TypedArray} [data=null] - The buffer data.
   * @param {number} [width=1] - The width of the texture.
   * @param {number} [height=1] - The height of the texture.
   * @param {number} [depth=1] - The depth of the texture.
   */
  constructor(e = null, n = 1, r = 1, i = 1) {
    super(null), this.isDataArrayTexture = !0, this.image = { data: e, width: n, height: r, depth: i }, this.magFilter = _r, this.minFilter = _r, this.wrapR = To, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1, this.layerUpdates = /* @__PURE__ */ new Set();
  }
  /**
   * Describes that a specific layer of the texture needs to be updated.
   * Normally when {@link Texture#needsUpdate} is set to `true`, the
   * entire data texture array is sent to the GPU. Marking specific
   * layers will only transmit subsets of all mipmaps associated with a
   * specific depth in the array which is often much more performant.
   *
   * @param {number} layerIndex - The layer index that should be updated.
   */
  addLayerUpdate(e) {
    this.layerUpdates.add(e);
  }
  /**
   * Resets the layer updates registry.
   */
  clearLayerUpdates() {
    this.layerUpdates.clear();
  }
}
class bee extends En {
  /**
   * Constructs a new data array texture.
   *
   * @param {?TypedArray} [data=null] - The buffer data.
   * @param {number} [width=1] - The width of the texture.
   * @param {number} [height=1] - The height of the texture.
   * @param {number} [depth=1] - The depth of the texture.
   */
  constructor(e = null, n = 1, r = 1, i = 1) {
    super(null), this.isData3DTexture = !0, this.image = { data: e, width: n, height: r, depth: i }, this.magFilter = _r, this.minFilter = _r, this.wrapR = To, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
class Rs {
  /**
   * Constructs a new quaternion.
   *
   * @param {number} [x=0] - The x value of this quaternion.
   * @param {number} [y=0] - The y value of this quaternion.
   * @param {number} [z=0] - The z value of this quaternion.
   * @param {number} [w=1] - The w value of this quaternion.
   */
  constructor(e = 0, n = 0, r = 0, i = 1) {
    this.isQuaternion = !0, this._x = e, this._y = n, this._z = r, this._w = i;
  }
  /**
   * Interpolates between two quaternions via SLERP. This implementation assumes the
   * quaternion data are managed  in flat arrays.
   *
   * @param {Array<number>} dst - The destination array.
   * @param {number} dstOffset - An offset into the destination array.
   * @param {Array<number>} src0 - The source array of the first quaternion.
   * @param {number} srcOffset0 - An offset into the first source array.
   * @param {Array<number>} src1 -  The source array of the second quaternion.
   * @param {number} srcOffset1 - An offset into the second source array.
   * @param {number} t - The interpolation factor in the range `[0,1]`.
   * @see {@link Quaternion#slerp}
   */
  static slerpFlat(e, n, r, i, o, a, s) {
    let l = r[i + 0], c = r[i + 1], u = r[i + 2], d = r[i + 3];
    const f = o[a + 0], h = o[a + 1], v = o[a + 2], g = o[a + 3];
    if (s === 0) {
      e[n + 0] = l, e[n + 1] = c, e[n + 2] = u, e[n + 3] = d;
      return;
    }
    if (s === 1) {
      e[n + 0] = f, e[n + 1] = h, e[n + 2] = v, e[n + 3] = g;
      return;
    }
    if (d !== g || l !== f || c !== h || u !== v) {
      let m = 1 - s;
      const p = l * f + c * h + u * v + d * g, y = p >= 0 ? 1 : -1, b = 1 - p * p;
      if (b > Number.EPSILON) {
        const _ = Math.sqrt(b), M = Math.atan2(_, p * y);
        m = Math.sin(m * M) / _, s = Math.sin(s * M) / _;
      }
      const x = s * y;
      if (l = l * m + f * x, c = c * m + h * x, u = u * m + v * x, d = d * m + g * x, m === 1 - s) {
        const _ = 1 / Math.sqrt(l * l + c * c + u * u + d * d);
        l *= _, c *= _, u *= _, d *= _;
      }
    }
    e[n] = l, e[n + 1] = c, e[n + 2] = u, e[n + 3] = d;
  }
  /**
   * Multiplies two quaternions. This implementation assumes the quaternion data are managed
   * in flat arrays.
   *
   * @param {Array<number>} dst - The destination array.
   * @param {number} dstOffset - An offset into the destination array.
   * @param {Array<number>} src0 - The source array of the first quaternion.
   * @param {number} srcOffset0 - An offset into the first source array.
   * @param {Array<number>} src1 -  The source array of the second quaternion.
   * @param {number} srcOffset1 - An offset into the second source array.
   * @return {Array<number>} The destination array.
   * @see {@link Quaternion#multiplyQuaternions}.
   */
  static multiplyQuaternionsFlat(e, n, r, i, o, a) {
    const s = r[i], l = r[i + 1], c = r[i + 2], u = r[i + 3], d = o[a], f = o[a + 1], h = o[a + 2], v = o[a + 3];
    return e[n] = s * v + u * d + l * h - c * f, e[n + 1] = l * v + u * f + c * d - s * h, e[n + 2] = c * v + u * h + s * f - l * d, e[n + 3] = u * v - s * d - l * f - c * h, e;
  }
  /**
   * The x value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  /**
   * The y value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  /**
   * The z value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  /**
   * The w value of this quaternion.
   *
   * @type {number}
   * @default 1
   */
  get w() {
    return this._w;
  }
  set w(e) {
    this._w = e, this._onChangeCallback();
  }
  /**
   * Sets the quaternion components.
   *
   * @param {number} x - The x value of this quaternion.
   * @param {number} y - The y value of this quaternion.
   * @param {number} z - The z value of this quaternion.
   * @param {number} w - The w value of this quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  set(e, n, r, i) {
    return this._x = e, this._y = n, this._z = r, this._w = i, this._onChangeCallback(), this;
  }
  /**
   * Returns a new quaternion with copied values from this instance.
   *
   * @return {Quaternion} A clone of this instance.
   */
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  /**
   * Copies the values of the given quaternion to this instance.
   *
   * @param {Quaternion} quaternion - The quaternion to copy.
   * @return {Quaternion} A reference to this quaternion.
   */
  copy(e) {
    return this._x = e.x, this._y = e.y, this._z = e.z, this._w = e.w, this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion from the rotation specified by the given
   * Euler angles.
   *
   * @param {Euler} euler - The Euler angles.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromEuler(e, n = !0) {
    const r = e._x, i = e._y, o = e._z, a = e._order, s = Math.cos, l = Math.sin, c = s(r / 2), u = s(i / 2), d = s(o / 2), f = l(r / 2), h = l(i / 2), v = l(o / 2);
    switch (a) {
      case "XYZ":
        this._x = f * u * d + c * h * v, this._y = c * h * d - f * u * v, this._z = c * u * v + f * h * d, this._w = c * u * d - f * h * v;
        break;
      case "YXZ":
        this._x = f * u * d + c * h * v, this._y = c * h * d - f * u * v, this._z = c * u * v - f * h * d, this._w = c * u * d + f * h * v;
        break;
      case "ZXY":
        this._x = f * u * d - c * h * v, this._y = c * h * d + f * u * v, this._z = c * u * v + f * h * d, this._w = c * u * d - f * h * v;
        break;
      case "ZYX":
        this._x = f * u * d - c * h * v, this._y = c * h * d + f * u * v, this._z = c * u * v - f * h * d, this._w = c * u * d + f * h * v;
        break;
      case "YZX":
        this._x = f * u * d + c * h * v, this._y = c * h * d + f * u * v, this._z = c * u * v - f * h * d, this._w = c * u * d - f * h * v;
        break;
      case "XZY":
        this._x = f * u * d - c * h * v, this._y = c * h * d - f * u * v, this._z = c * u * v + f * h * d, this._w = c * u * d + f * h * v;
        break;
      default:
        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + a);
    }
    return n === !0 && this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion from the given axis and angle.
   *
   * @param {Vector3} axis - The normalized axis.
   * @param {number} angle - The angle in radians.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromAxisAngle(e, n) {
    const r = n / 2, i = Math.sin(r);
    return this._x = e.x * i, this._y = e.y * i, this._z = e.z * i, this._w = Math.cos(r), this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion from the given rotation matrix.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromRotationMatrix(e) {
    const n = e.elements, r = n[0], i = n[4], o = n[8], a = n[1], s = n[5], l = n[9], c = n[2], u = n[6], d = n[10], f = r + s + d;
    if (f > 0) {
      const h = 0.5 / Math.sqrt(f + 1);
      this._w = 0.25 / h, this._x = (u - l) * h, this._y = (o - c) * h, this._z = (a - i) * h;
    } else if (r > s && r > d) {
      const h = 2 * Math.sqrt(1 + r - s - d);
      this._w = (u - l) / h, this._x = 0.25 * h, this._y = (i + a) / h, this._z = (o + c) / h;
    } else if (s > d) {
      const h = 2 * Math.sqrt(1 + s - r - d);
      this._w = (o - c) / h, this._x = (i + a) / h, this._y = 0.25 * h, this._z = (l + u) / h;
    } else {
      const h = 2 * Math.sqrt(1 + d - r - s);
      this._w = (a - i) / h, this._x = (o + c) / h, this._y = (l + u) / h, this._z = 0.25 * h;
    }
    return this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion to the rotation required to rotate the direction vector
   * `vFrom` to the direction vector `vTo`.
   *
   * @param {Vector3} vFrom - The first (normalized) direction vector.
   * @param {Vector3} vTo - The second (normalized) direction vector.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromUnitVectors(e, n) {
    let r = e.dot(n) + 1;
    return r < Number.EPSILON ? (r = 0, Math.abs(e.x) > Math.abs(e.z) ? (this._x = -e.y, this._y = e.x, this._z = 0, this._w = r) : (this._x = 0, this._y = -e.z, this._z = e.y, this._w = r)) : (this._x = e.y * n.z - e.z * n.y, this._y = e.z * n.x - e.x * n.z, this._z = e.x * n.y - e.y * n.x, this._w = r), this.normalize();
  }
  /**
   * Returns the angle between this quaternion and the given one in radians.
   *
   * @param {Quaternion} q - The quaternion to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(e) {
    return 2 * Math.acos(Math.abs(dt(this.dot(e), -1, 1)));
  }
  /**
   * Rotates this quaternion by a given angular step to the given quaternion.
   * The method ensures that the final quaternion will not overshoot `q`.
   *
   * @param {Quaternion} q - The target quaternion.
   * @param {number} step - The angular step in radians.
   * @return {Quaternion} A reference to this quaternion.
   */
  rotateTowards(e, n) {
    const r = this.angleTo(e);
    if (r === 0)
      return this;
    const i = Math.min(1, n / r);
    return this.slerp(e, i), this;
  }
  /**
   * Sets this quaternion to the identity quaternion; that is, to the
   * quaternion that represents "no rotation".
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  identity() {
    return this.set(0, 0, 0, 1);
  }
  /**
   * Inverts this quaternion via {@link Quaternion#conjugate}. The
   * quaternion is assumed to have unit length.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  invert() {
    return this.conjugate();
  }
  /**
   * Returns the rotational conjugate of this quaternion. The conjugate of a
   * quaternion represents the same rotation in the opposite direction about
   * the rotational axis.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  conjugate() {
    return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
  }
  /**
   * Calculates the dot product of this quaternion and the given one.
   *
   * @param {Quaternion} v - The quaternion to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
  }
  /**
   * Computes the squared Euclidean length (straight-line length) of this quaternion,
   * considered as a 4 dimensional vector. This can be useful if you are comparing the
   * lengths of two quaternions, as this is a slightly more efficient calculation than
   * {@link Quaternion#length}.
   *
   * @return {number} The squared Euclidean length.
   */
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  /**
   * Computes the Euclidean length (straight-line length) of this quaternion,
   * considered as a 4 dimensional vector.
   *
   * @return {number} The Euclidean length.
   */
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  /**
   * Normalizes this quaternion - that is, calculated the quaternion that performs
   * the same rotation as this one, but has a length equal to `1`.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  normalize() {
    let e = this.length();
    return e === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e = 1 / e, this._x = this._x * e, this._y = this._y * e, this._z = this._z * e, this._w = this._w * e), this._onChangeCallback(), this;
  }
  /**
   * Multiplies this quaternion by the given one.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  multiply(e) {
    return this.multiplyQuaternions(this, e);
  }
  /**
   * Pre-multiplies this quaternion by the given one.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  premultiply(e) {
    return this.multiplyQuaternions(e, this);
  }
  /**
   * Multiplies the given quaternions and stores the result in this instance.
   *
   * @param {Quaternion} a - The first quaternion.
   * @param {Quaternion} b - The second quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  multiplyQuaternions(e, n) {
    const r = e._x, i = e._y, o = e._z, a = e._w, s = n._x, l = n._y, c = n._z, u = n._w;
    return this._x = r * u + a * s + i * c - o * l, this._y = i * u + a * l + o * s - r * c, this._z = o * u + a * c + r * l - i * s, this._w = a * u - r * s - i * l - o * c, this._onChangeCallback(), this;
  }
  /**
   * Performs a spherical linear interpolation between quaternions.
   *
   * @param {Quaternion} qb - The target quaternion.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {Quaternion} A reference to this quaternion.
   */
  slerp(e, n) {
    if (n === 0)
      return this;
    if (n === 1)
      return this.copy(e);
    const r = this._x, i = this._y, o = this._z, a = this._w;
    let s = a * e._w + r * e._x + i * e._y + o * e._z;
    if (s < 0 ? (this._w = -e._w, this._x = -e._x, this._y = -e._y, this._z = -e._z, s = -s) : this.copy(e), s >= 1)
      return this._w = a, this._x = r, this._y = i, this._z = o, this;
    const l = 1 - s * s;
    if (l <= Number.EPSILON) {
      const h = 1 - n;
      return this._w = h * a + n * this._w, this._x = h * r + n * this._x, this._y = h * i + n * this._y, this._z = h * o + n * this._z, this.normalize(), this;
    }
    const c = Math.sqrt(l), u = Math.atan2(c, s), d = Math.sin((1 - n) * u) / c, f = Math.sin(n * u) / c;
    return this._w = a * d + this._w * f, this._x = r * d + this._x * f, this._y = i * d + this._y * f, this._z = o * d + this._z * f, this._onChangeCallback(), this;
  }
  /**
   * Performs a spherical linear interpolation between the given quaternions
   * and stores the result in this quaternion.
   *
   * @param {Quaternion} qa - The source quaternion.
   * @param {Quaternion} qb - The target quaternion.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {Quaternion} A reference to this quaternion.
   */
  slerpQuaternions(e, n, r) {
    return this.copy(e).slerp(n, r);
  }
  /**
   * Sets this quaternion to a uniformly random, normalized quaternion.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  random() {
    const e = 2 * Math.PI * Math.random(), n = 2 * Math.PI * Math.random(), r = Math.random(), i = Math.sqrt(1 - r), o = Math.sqrt(r);
    return this.set(
      i * Math.sin(e),
      i * Math.cos(e),
      o * Math.sin(n),
      o * Math.cos(n)
    );
  }
  /**
   * Returns `true` if this quaternion is equal with the given one.
   *
   * @param {Quaternion} quaternion - The quaternion to test for equality.
   * @return {boolean} Whether this quaternion is equal with the given one.
   */
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
  }
  /**
   * Sets this quaternion's components from the given array.
   *
   * @param {Array<number>} array - An array holding the quaternion component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Quaternion} A reference to this quaternion.
   */
  fromArray(e, n = 0) {
    return this._x = e[n], this._y = e[n + 1], this._z = e[n + 2], this._w = e[n + 3], this._onChangeCallback(), this;
  }
  /**
   * Writes the components of this quaternion to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The quaternion components.
   */
  toArray(e = [], n = 0) {
    return e[n] = this._x, e[n + 1] = this._y, e[n + 2] = this._z, e[n + 3] = this._w, e;
  }
  /**
   * Sets the components of this quaternion from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
   * @param {number} index - The index into the attribute.
   * @return {Quaternion} A reference to this quaternion.
   */
  fromBufferAttribute(e, n) {
    return this._x = e.getX(n), this._y = e.getY(n), this._z = e.getZ(n), this._w = e.getW(n), this._onChangeCallback(), this;
  }
  /**
   * This methods defines the serialization result of this class. Returns the
   * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
   *
   * @return {Array<number>} The serialized quaternion.
   */
  toJSON() {
    return this.toArray();
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._w;
  }
}
class re {
  /**
   * Constructs a new 3D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   * @param {number} [z=0] - The z value of this vector.
   */
  constructor(e = 0, n = 0, r = 0) {
    re.prototype.isVector3 = !0, this.x = e, this.y = n, this.z = r;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @param {number} z - The value of the z component.
   * @return {Vector3} A reference to this vector.
   */
  set(e, n, r) {
    return r === void 0 && (r = this.z), this.x = e, this.y = n, this.z = r, this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector3} A reference to this vector.
   */
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setX(e) {
    return this.x = e, this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setY(e) {
    return this.y = e, this;
  }
  /**
   * Sets the vector's z component to the given value
   *
   * @param {number} z - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setZ(e) {
    return this.z = e, this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
   * @param {number} value - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setComponent(e, n) {
    switch (e) {
      case 0:
        this.x = n;
        break;
      case 1:
        this.y = n;
        break;
      case 2:
        this.z = n;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
   * @return {number} A vector component value.
   */
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector3} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector3} v - The vector to copy.
   * @return {Vector3} A reference to this vector.
   */
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector3} v - The vector to add.
   * @return {Vector3} A reference to this vector.
   */
  add(e) {
    return this.x += e.x, this.y += e.y, this.z += e.z, this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector3} A reference to this vector.
   */
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  addVectors(e, n) {
    return this.x = e.x + n.x, this.y = e.y + n.y, this.z = e.z + n.z, this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector3|Vector4} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector3} A reference to this vector.
   */
  addScaledVector(e, n) {
    return this.x += e.x * n, this.y += e.y * n, this.z += e.z * n, this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector3} v - The vector to subtract.
   * @return {Vector3} A reference to this vector.
   */
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this.z -= e.z, this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector3} A reference to this vector.
   */
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  subVectors(e, n) {
    return this.x = e.x - n.x, this.y = e.y - n.y, this.z = e.z - n.z, this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector3} v - The vector to multiply.
   * @return {Vector3} A reference to this vector.
   */
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector3} A reference to this vector.
   */
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this;
  }
  /**
   * Multiplies the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  multiplyVectors(e, n) {
    return this.x = e.x * n.x, this.y = e.y * n.y, this.z = e.z * n.z, this;
  }
  /**
   * Applies the given Euler rotation to this vector.
   *
   * @param {Euler} euler - The Euler angles.
   * @return {Vector3} A reference to this vector.
   */
  applyEuler(e) {
    return this.applyQuaternion(L4.setFromEuler(e));
  }
  /**
   * Applies a rotation specified by an axis and an angle to this vector.
   *
   * @param {Vector3} axis - A normalized vector representing the rotation axis.
   * @param {number} angle - The angle in radians.
   * @return {Vector3} A reference to this vector.
   */
  applyAxisAngle(e, n) {
    return this.applyQuaternion(L4.setFromAxisAngle(e, n));
  }
  /**
   * Multiplies this vector with the given 3x3 matrix.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @return {Vector3} A reference to this vector.
   */
  applyMatrix3(e) {
    const n = this.x, r = this.y, i = this.z, o = e.elements;
    return this.x = o[0] * n + o[3] * r + o[6] * i, this.y = o[1] * n + o[4] * r + o[7] * i, this.z = o[2] * n + o[5] * r + o[8] * i, this;
  }
  /**
   * Multiplies this vector by the given normal matrix and normalizes
   * the result.
   *
   * @param {Matrix3} m - The normal matrix.
   * @return {Vector3} A reference to this vector.
   */
  applyNormalMatrix(e) {
    return this.applyMatrix3(e).normalize();
  }
  /**
   * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
   * divides by perspective.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {Vector3} A reference to this vector.
   */
  applyMatrix4(e) {
    const n = this.x, r = this.y, i = this.z, o = e.elements, a = 1 / (o[3] * n + o[7] * r + o[11] * i + o[15]);
    return this.x = (o[0] * n + o[4] * r + o[8] * i + o[12]) * a, this.y = (o[1] * n + o[5] * r + o[9] * i + o[13]) * a, this.z = (o[2] * n + o[6] * r + o[10] * i + o[14]) * a, this;
  }
  /**
   * Applies the given Quaternion to this vector.
   *
   * @param {Quaternion} q - The Quaternion.
   * @return {Vector3} A reference to this vector.
   */
  applyQuaternion(e) {
    const n = this.x, r = this.y, i = this.z, o = e.x, a = e.y, s = e.z, l = e.w, c = 2 * (a * i - s * r), u = 2 * (s * n - o * i), d = 2 * (o * r - a * n);
    return this.x = n + l * c + a * d - s * u, this.y = r + l * u + s * c - o * d, this.z = i + l * d + o * u - a * c, this;
  }
  /**
   * Projects this vector from world space into the camera's normalized
   * device coordinate (NDC) space.
   *
   * @param {Camera} camera - The camera.
   * @return {Vector3} A reference to this vector.
   */
  project(e) {
    return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix);
  }
  /**
   * Unprojects this vector from the camera's normalized device coordinate (NDC)
   * space into world space.
   *
   * @param {Camera} camera - The camera.
   * @return {Vector3} A reference to this vector.
   */
  unproject(e) {
    return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld);
  }
  /**
   * Transforms the direction of this vector by a matrix (the upper left 3 x 3
   * subset of the given 4x4 matrix and then normalizes the result.
   *
   * @param {Matrix4} m - The matrix.
   * @return {Vector3} A reference to this vector.
   */
  transformDirection(e) {
    const n = this.x, r = this.y, i = this.z, o = e.elements;
    return this.x = o[0] * n + o[4] * r + o[8] * i, this.y = o[1] * n + o[5] * r + o[9] * i, this.z = o[2] * n + o[6] * r + o[10] * i, this.normalize();
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector3} v - The vector to divide.
   * @return {Vector3} A reference to this vector.
   */
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this.z /= e.z, this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector3} A reference to this vector.
   */
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  /**
   * If this vector's x, y or z value is greater than the given vector's x, y or z
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector3} v - The vector.
   * @return {Vector3} A reference to this vector.
   */
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this;
  }
  /**
   * If this vector's x, y or z value is less than the given vector's x, y or z
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector3} v - The vector.
   * @return {Vector3} A reference to this vector.
   */
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this;
  }
  /**
   * If this vector's x, y or z value is greater than the max vector's x, y or z
   * value, it is replaced by the corresponding value.
   * If this vector's x, y or z value is less than the min vector's x, y or z value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector3} min - The minimum x, y and z values.
   * @param {Vector3} max - The maximum x, y and z values in the desired range.
   * @return {Vector3} A reference to this vector.
   */
  clamp(e, n) {
    return this.x = dt(this.x, e.x, n.x), this.y = dt(this.y, e.y, n.y), this.z = dt(this.z, e.z, n.z), this;
  }
  /**
   * If this vector's x, y or z values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x, y or z values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector3} A reference to this vector.
   */
  clampScalar(e, n) {
    return this.x = dt(this.x, e, n), this.y = dt(this.y, e, n), this.z = dt(this.z, e, n), this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector3} A reference to this vector.
   */
  clampLength(e, n) {
    const r = this.length();
    return this.divideScalar(r || 1).multiplyScalar(dt(r, e, n));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector3} A reference to this vector.
   */
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
   *
   * @return {Vector3} A reference to this vector.
   */
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector3} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z;
  }
  // TODO lengthSquared?
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector3} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector3} A reference to this vector.
   */
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector3} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector3} A reference to this vector.
   */
  lerp(e, n) {
    return this.x += (e.x - this.x) * n, this.y += (e.y - this.y) * n, this.z += (e.z - this.z) * n, this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector3} v1 - The first vector.
   * @param {Vector3} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector3} A reference to this vector.
   */
  lerpVectors(e, n, r) {
    return this.x = e.x + (n.x - e.x) * r, this.y = e.y + (n.y - e.y) * r, this.z = e.z + (n.z - e.z) * r, this;
  }
  /**
   * Calculates the cross product of the given vector with this instance.
   *
   * @param {Vector3} v - The vector to compute the cross product with.
   * @return {Vector3} The result of the cross product.
   */
  cross(e) {
    return this.crossVectors(this, e);
  }
  /**
   * Calculates the cross product of the given vectors and stores the result
   * in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  crossVectors(e, n) {
    const r = e.x, i = e.y, o = e.z, a = n.x, s = n.y, l = n.z;
    return this.x = i * l - o * s, this.y = o * a - r * l, this.z = r * s - i * a, this;
  }
  /**
   * Projects this vector onto the given one.
   *
   * @param {Vector3} v - The vector to project to.
   * @return {Vector3} A reference to this vector.
   */
  projectOnVector(e) {
    const n = e.lengthSq();
    if (n === 0)
      return this.set(0, 0, 0);
    const r = e.dot(this) / n;
    return this.copy(e).multiplyScalar(r);
  }
  /**
   * Projects this vector onto a plane by subtracting this
   * vector projected onto the plane's normal from this vector.
   *
   * @param {Vector3} planeNormal - The plane normal.
   * @return {Vector3} A reference to this vector.
   */
  projectOnPlane(e) {
    return m0.copy(this).projectOnVector(e), this.sub(m0);
  }
  /**
   * Reflects this vector off a plane orthogonal to the given normal vector.
   *
   * @param {Vector3} normal - The (normalized) normal vector.
   * @return {Vector3} A reference to this vector.
   */
  reflect(e) {
    return this.sub(m0.copy(e).multiplyScalar(2 * this.dot(e)));
  }
  /**
   * Returns the angle between the given vector and this instance in radians.
   *
   * @param {Vector3} v - The vector to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(e) {
    const n = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (n === 0)
      return Math.PI / 2;
    const r = this.dot(e) / n;
    return Math.acos(dt(r, -1, 1));
  }
  /**
   * Computes the distance from the given vector to this instance.
   *
   * @param {Vector3} v - The vector to compute the distance to.
   * @return {number} The distance.
   */
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  /**
   * Computes the squared distance from the given vector to this instance.
   * If you are just comparing the distance with another distance, you should compare
   * the distance squared instead as it is slightly more efficient to calculate.
   *
   * @param {Vector3} v - The vector to compute the squared distance to.
   * @return {number} The squared distance.
   */
  distanceToSquared(e) {
    const n = this.x - e.x, r = this.y - e.y, i = this.z - e.z;
    return n * n + r * r + i * i;
  }
  /**
   * Computes the Manhattan distance from the given vector to this instance.
   *
   * @param {Vector3} v - The vector to compute the Manhattan distance to.
   * @return {number} The Manhattan distance.
   */
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
  }
  /**
   * Sets the vector components from the given spherical coordinates.
   *
   * @param {Spherical} s - The spherical coordinates.
   * @return {Vector3} A reference to this vector.
   */
  setFromSpherical(e) {
    return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
  }
  /**
   * Sets the vector components from the given spherical coordinates.
   *
   * @param {number} radius - The radius.
   * @param {number} phi - The phi angle in radians.
   * @param {number} theta - The theta angle in radians.
   * @return {Vector3} A reference to this vector.
   */
  setFromSphericalCoords(e, n, r) {
    const i = Math.sin(n) * e;
    return this.x = i * Math.sin(r), this.y = Math.cos(n) * e, this.z = i * Math.cos(r), this;
  }
  /**
   * Sets the vector components from the given cylindrical coordinates.
   *
   * @param {Cylindrical} c - The cylindrical coordinates.
   * @return {Vector3} A reference to this vector.
   */
  setFromCylindrical(e) {
    return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
  }
  /**
   * Sets the vector components from the given cylindrical coordinates.
   *
   * @param {number} radius - The radius.
   * @param {number} theta - The theta angle in radians.
   * @param {number} y - The y value.
   * @return {Vector3} A reference to this vector.
   */
  setFromCylindricalCoords(e, n, r) {
    return this.x = e * Math.sin(n), this.y = r, this.z = e * Math.cos(n), this;
  }
  /**
   * Sets the vector components to the position elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixPosition(e) {
    const n = e.elements;
    return this.x = n[12], this.y = n[13], this.z = n[14], this;
  }
  /**
   * Sets the vector components to the scale elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixScale(e) {
    const n = this.setFromMatrixColumn(e, 0).length(), r = this.setFromMatrixColumn(e, 1).length(), i = this.setFromMatrixColumn(e, 2).length();
    return this.x = n, this.y = r, this.z = i, this;
  }
  /**
   * Sets the vector components from the specified matrix column.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @param {number} index - The column index.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixColumn(e, n) {
    return this.fromArray(e.elements, n * 4);
  }
  /**
   * Sets the vector components from the specified matrix column.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @param {number} index - The column index.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrix3Column(e, n) {
    return this.fromArray(e.elements, n * 3);
  }
  /**
   * Sets the vector components from the given Euler angles.
   *
   * @param {Euler} e - The Euler angles to set.
   * @return {Vector3} A reference to this vector.
   */
  setFromEuler(e) {
    return this.x = e._x, this.y = e._y, this.z = e._z, this;
  }
  /**
   * Sets the vector components from the RGB components of the
   * given color.
   *
   * @param {Color} c - The color to set.
   * @return {Vector3} A reference to this vector.
   */
  setFromColor(e) {
    return this.x = e.r, this.y = e.g, this.z = e.b, this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector3} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
   * and z value to be `array[ offset + 2 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector3} A reference to this vector.
   */
  fromArray(e, n = 0) {
    return this.x = e[n], this.y = e[n + 1], this.z = e[n + 2], this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(e = [], n = 0) {
    return e[n] = this.x, e[n + 1] = this.y, e[n + 2] = this.z, e;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector3} A reference to this vector.
   */
  fromBufferAttribute(e, n) {
    return this.x = e.getX(n), this.y = e.getY(n), this.z = e.getZ(n), this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector3} A reference to this vector.
   */
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
  }
  /**
   * Sets this vector to a uniformly random point on a unit sphere.
   *
   * @return {Vector3} A reference to this vector.
   */
  randomDirection() {
    const e = Math.random() * Math.PI * 2, n = Math.random() * 2 - 1, r = Math.sqrt(1 - n * n);
    return this.x = r * Math.cos(e), this.y = n, this.z = r * Math.sin(e), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z;
  }
}
const m0 = /* @__PURE__ */ new re(), L4 = /* @__PURE__ */ new Rs();
class Ls {
  /**
   * Constructs a new bounding box.
   *
   * @param {Vector3} [min=(Infinity,Infinity,Infinity)] - A vector representing the lower boundary of the box.
   * @param {Vector3} [max=(-Infinity,-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
   */
  constructor(e = new re(1 / 0, 1 / 0, 1 / 0), n = new re(-1 / 0, -1 / 0, -1 / 0)) {
    this.isBox3 = !0, this.min = e, this.max = n;
  }
  /**
   * Sets the lower and upper boundaries of this box.
   * Please note that this method only copies the values from the given objects.
   *
   * @param {Vector3} min - The lower boundary of the box.
   * @param {Vector3} max - The upper boundary of the box.
   * @return {Box3} A reference to this bounding box.
   */
  set(e, n) {
    return this.min.copy(e), this.max.copy(n), this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given array.
   *
   * @param {Array<number>} array - An array holding 3D position data.
   * @return {Box3} A reference to this bounding box.
   */
  setFromArray(e) {
    this.makeEmpty();
    for (let n = 0, r = e.length; n < r; n += 3)
      this.expandByPoint(dr.fromArray(e, n));
    return this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
   * @return {Box3} A reference to this bounding box.
   */
  setFromBufferAttribute(e) {
    this.makeEmpty();
    for (let n = 0, r = e.count; n < r; n++)
      this.expandByPoint(dr.fromBufferAttribute(e, n));
    return this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given array.
   *
   * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
   * @return {Box3} A reference to this bounding box.
   */
  setFromPoints(e) {
    this.makeEmpty();
    for (let n = 0, r = e.length; n < r; n++)
      this.expandByPoint(e[n]);
    return this;
  }
  /**
   * Centers this box on the given center vector and sets this box's width, height and
   * depth to the given size values.
   *
   * @param {Vector3} center - The center of the box.
   * @param {Vector3} size - The x, y and z dimensions of the box.
   * @return {Box3} A reference to this bounding box.
   */
  setFromCenterAndSize(e, n) {
    const r = dr.copy(n).multiplyScalar(0.5);
    return this.min.copy(e).sub(r), this.max.copy(e).add(r), this;
  }
  /**
   * Computes the world-axis-aligned bounding box for the given 3D object
   * (including its children), accounting for the object's, and children's,
   * world transforms. The function may result in a larger box than strictly necessary.
   *
   * @param {Object3D} object - The 3D object to compute the bounding box for.
   * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
   * world-axis-aligned bounding box at the expense of more computation.
   * @return {Box3} A reference to this bounding box.
   */
  setFromObject(e, n = !1) {
    return this.makeEmpty(), this.expandByObject(e, n);
  }
  /**
   * Returns a new box with copied values from this instance.
   *
   * @return {Box3} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given box to this instance.
   *
   * @param {Box3} box - The box to copy.
   * @return {Box3} A reference to this bounding box.
   */
  copy(e) {
    return this.min.copy(e.min), this.max.copy(e.max), this;
  }
  /**
   * Makes this box empty which means in encloses a zero space in 3D.
   *
   * @return {Box3} A reference to this bounding box.
   */
  makeEmpty() {
    return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
  }
  /**
   * Returns true if this box includes zero points within its bounds.
   * Note that a box with equal lower and upper bounds still includes one
   * point, the one both bounds share.
   *
   * @return {boolean} Whether this box is empty or not.
   */
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  /**
   * Returns the center point of this box.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The center point.
   */
  getCenter(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  /**
   * Returns the dimensions of this box.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The size.
   */
  getSize(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min);
  }
  /**
   * Expands the boundaries of this box to include the given point.
   *
   * @param {Vector3} point - The point that should be included by the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByPoint(e) {
    return this.min.min(e), this.max.max(e), this;
  }
  /**
   * Expands this box equilaterally by the given vector. The width of this
   * box will be expanded by the x component of the vector in both
   * directions. The height of this box will be expanded by the y component of
   * the vector in both directions. The depth of this box will be
   * expanded by the z component of the vector in both directions.
   *
   * @param {Vector3} vector - The vector that should expand the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByVector(e) {
    return this.min.sub(e), this.max.add(e), this;
  }
  /**
   * Expands each dimension of the box by the given scalar. If negative, the
   * dimensions of the box will be contracted.
   *
   * @param {number} scalar - The scalar value that should expand the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByScalar(e) {
    return this.min.addScalar(-e), this.max.addScalar(e), this;
  }
  /**
   * Expands the boundaries of this box to include the given 3D object and
   * its children, accounting for the object's, and children's, world
   * transforms. The function may result in a larger box than strictly
   * necessary (unless the precise parameter is set to true).
   *
   * @param {Object3D} object - The 3D object that should expand the bounding box.
   * @param {boolean} precise - If set to `true`, the method expands the bounding box
   * as little as necessary at the expense of more computation.
   * @return {Box3} A reference to this bounding box.
   */
  expandByObject(e, n = !1) {
    e.updateWorldMatrix(!1, !1);
    const r = e.geometry;
    if (r !== void 0) {
      const o = r.getAttribute("position");
      if (n === !0 && o !== void 0 && e.isInstancedMesh !== !0)
        for (let a = 0, s = o.count; a < s; a++)
          e.isMesh === !0 ? e.getVertexPosition(a, dr) : dr.fromBufferAttribute(o, a), dr.applyMatrix4(e.matrixWorld), this.expandByPoint(dr);
      else
        e.boundingBox !== void 0 ? (e.boundingBox === null && e.computeBoundingBox(), Fc.copy(e.boundingBox)) : (r.boundingBox === null && r.computeBoundingBox(), Fc.copy(r.boundingBox)), Fc.applyMatrix4(e.matrixWorld), this.union(Fc);
    }
    const i = e.children;
    for (let o = 0, a = i.length; o < a; o++)
      this.expandByObject(i[o], n);
    return this;
  }
  /**
   * Returns `true` if the given point lies within or on the boundaries of this box.
   *
   * @param {Vector3} point - The point to test.
   * @return {boolean} Whether the bounding box contains the given point or not.
   */
  containsPoint(e) {
    return e.x >= this.min.x && e.x <= this.max.x && e.y >= this.min.y && e.y <= this.max.y && e.z >= this.min.z && e.z <= this.max.z;
  }
  /**
   * Returns `true` if this bounding box includes the entirety of the given bounding box.
   * If this box and the given one are identical, this function also returns `true`.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the bounding box contains the given bounding box or not.
   */
  containsBox(e) {
    return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y && this.min.z <= e.min.z && e.max.z <= this.max.z;
  }
  /**
   * Returns a point as a proportion of this box's width, height and depth.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} A point as a proportion of this box's width, height and depth.
   */
  getParameter(e, n) {
    return n.set(
      (e.x - this.min.x) / (this.max.x - this.min.x),
      (e.y - this.min.y) / (this.max.y - this.min.y),
      (e.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  /**
   * Returns `true` if the given bounding box intersects with this bounding box.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the given bounding box intersects with this bounding box.
   */
  intersectsBox(e) {
    return e.max.x >= this.min.x && e.min.x <= this.max.x && e.max.y >= this.min.y && e.min.y <= this.max.y && e.max.z >= this.min.z && e.min.z <= this.max.z;
  }
  /**
   * Returns `true` if the given bounding sphere intersects with this bounding box.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
   */
  intersectsSphere(e) {
    return this.clampPoint(e.center, dr), dr.distanceToSquared(e.center) <= e.radius * e.radius;
  }
  /**
   * Returns `true` if the given plane intersects with this bounding box.
   *
   * @param {Plane} plane - The plane to test.
   * @return {boolean} Whether the given plane intersects with this bounding box.
   */
  intersectsPlane(e) {
    let n, r;
    return e.normal.x > 0 ? (n = e.normal.x * this.min.x, r = e.normal.x * this.max.x) : (n = e.normal.x * this.max.x, r = e.normal.x * this.min.x), e.normal.y > 0 ? (n += e.normal.y * this.min.y, r += e.normal.y * this.max.y) : (n += e.normal.y * this.max.y, r += e.normal.y * this.min.y), e.normal.z > 0 ? (n += e.normal.z * this.min.z, r += e.normal.z * this.max.z) : (n += e.normal.z * this.max.z, r += e.normal.z * this.min.z), n <= -e.constant && r >= -e.constant;
  }
  /**
   * Returns `true` if the given triangle intersects with this bounding box.
   *
   * @param {Triangle} triangle - The triangle to test.
   * @return {boolean} Whether the given triangle intersects with this bounding box.
   */
  intersectsTriangle(e) {
    if (this.isEmpty())
      return !1;
    this.getCenter(Xs), Uc.subVectors(this.max, Xs), aa.subVectors(e.a, Xs), sa.subVectors(e.b, Xs), la.subVectors(e.c, Xs), Ci.subVectors(sa, aa), Ei.subVectors(la, sa), fo.subVectors(aa, la);
    let n = [
      0,
      -Ci.z,
      Ci.y,
      0,
      -Ei.z,
      Ei.y,
      0,
      -fo.z,
      fo.y,
      Ci.z,
      0,
      -Ci.x,
      Ei.z,
      0,
      -Ei.x,
      fo.z,
      0,
      -fo.x,
      -Ci.y,
      Ci.x,
      0,
      -Ei.y,
      Ei.x,
      0,
      -fo.y,
      fo.x,
      0
    ];
    return !v0(n, aa, sa, la, Uc) || (n = [1, 0, 0, 0, 1, 0, 0, 0, 1], !v0(n, aa, sa, la, Uc)) ? !1 : (zc.crossVectors(Ci, Ei), n = [zc.x, zc.y, zc.z], v0(n, aa, sa, la, Uc));
  }
  /**
   * Clamps the given point within the bounds of this box.
   *
   * @param {Vector3} point - The point to clamp.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The clamped point.
   */
  clampPoint(e, n) {
    return n.copy(e).clamp(this.min, this.max);
  }
  /**
   * Returns the euclidean distance from any edge of this box to the specified point. If
   * the given point lies inside of this box, the distance will be `0`.
   *
   * @param {Vector3} point - The point to compute the distance to.
   * @return {number} The euclidean distance.
   */
  distanceToPoint(e) {
    return this.clampPoint(e, dr).distanceTo(e);
  }
  /**
   * Returns a bounding sphere that encloses this bounding box.
   *
   * @param {Sphere} target - The target sphere that is used to store the method's result.
   * @return {Sphere} The bounding sphere that encloses this bounding box.
   */
  getBoundingSphere(e) {
    return this.isEmpty() ? e.makeEmpty() : (this.getCenter(e.center), e.radius = this.getSize(dr).length() * 0.5), e;
  }
  /**
   * Computes the intersection of this bounding box and the given one, setting the upper
   * bound of this box to the lesser of the two boxes' upper bounds and the
   * lower bound of this box to the greater of the two boxes' lower bounds. If
   * there's no overlap, makes this box empty.
   *
   * @param {Box3} box - The bounding box to intersect with.
   * @return {Box3} A reference to this bounding box.
   */
  intersect(e) {
    return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
  }
  /**
   * Computes the union of this box and another and the given one, setting the upper
   * bound of this box to the greater of the two boxes' upper bounds and the
   * lower bound of this box to the lesser of the two boxes' lower bounds.
   *
   * @param {Box3} box - The bounding box that will be unioned with this instance.
   * @return {Box3} A reference to this bounding box.
   */
  union(e) {
    return this.min.min(e.min), this.max.max(e.max), this;
  }
  /**
   * Transforms this bounding box by the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @return {Box3} A reference to this bounding box.
   */
  applyMatrix4(e) {
    return this.isEmpty() ? this : (Gr[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e), Gr[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e), Gr[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e), Gr[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e), Gr[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e), Gr[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e), Gr[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e), Gr[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e), this.setFromPoints(Gr), this);
  }
  /**
   * Adds the given offset to both the upper and lower bounds of this bounding box,
   * effectively moving it in 3D space.
   *
   * @param {Vector3} offset - The offset that should be used to translate the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  translate(e) {
    return this.min.add(e), this.max.add(e), this;
  }
  /**
   * Returns `true` if this bounding box is equal with the given one.
   *
   * @param {Box3} box - The box to test for equality.
   * @return {boolean} Whether this bounding box is equal with the given one.
   */
  equals(e) {
    return e.min.equals(this.min) && e.max.equals(this.max);
  }
}
const Gr = [
  /* @__PURE__ */ new re(),
  /* @__PURE__ */ new re(),
  /* @__PURE__ */ new re(),
  /* @__PURE__ */ new re(),
  /* @__PURE__ */ new re(),
  /* @__PURE__ */ new re(),
  /* @__PURE__ */ new re(),
  /* @__PURE__ */ new re()
], dr = /* @__PURE__ */ new re(), Fc = /* @__PURE__ */ new Ls(), aa = /* @__PURE__ */ new re(), sa = /* @__PURE__ */ new re(), la = /* @__PURE__ */ new re(), Ci = /* @__PURE__ */ new re(), Ei = /* @__PURE__ */ new re(), fo = /* @__PURE__ */ new re(), Xs = /* @__PURE__ */ new re(), Uc = /* @__PURE__ */ new re(), zc = /* @__PURE__ */ new re(), ho = /* @__PURE__ */ new re();
function v0(t, e, n, r, i) {
  for (let o = 0, a = t.length - 3; o <= a; o += 3) {
    ho.fromArray(t, o);
    const s = i.x * Math.abs(ho.x) + i.y * Math.abs(ho.y) + i.z * Math.abs(ho.z), l = e.dot(ho), c = n.dot(ho), u = r.dot(ho);
    if (Math.max(-Math.max(l, c, u), Math.min(l, c, u)) > s)
      return !1;
  }
  return !0;
}
const xee = /* @__PURE__ */ new Ls(), Ys = /* @__PURE__ */ new re(), g0 = /* @__PURE__ */ new re();
class A2 {
  /**
   * Constructs a new sphere.
   *
   * @param {Vector3} [center=(0,0,0)] - The center of the sphere
   * @param {number} [radius=-1] - The radius of the sphere.
   */
  constructor(e = new re(), n = -1) {
    this.isSphere = !0, this.center = e, this.radius = n;
  }
  /**
   * Sets the sphere's components by copying the given values.
   *
   * @param {Vector3} center - The center.
   * @param {number} radius - The radius.
   * @return {Sphere} A reference to this sphere.
   */
  set(e, n) {
    return this.center.copy(e), this.radius = n, this;
  }
  /**
   * Computes the minimum bounding sphere for list of points.
   * If the optional center point is given, it is used as the sphere's
   * center. Otherwise, the center of the axis-aligned bounding box
   * encompassing the points is calculated.
   *
   * @param {Array<Vector3>} points - A list of points in 3D space.
   * @param {Vector3} [optionalCenter] - The center of the sphere.
   * @return {Sphere} A reference to this sphere.
   */
  setFromPoints(e, n) {
    const r = this.center;
    n !== void 0 ? r.copy(n) : xee.setFromPoints(e).getCenter(r);
    let i = 0;
    for (let o = 0, a = e.length; o < a; o++)
      i = Math.max(i, r.distanceToSquared(e[o]));
    return this.radius = Math.sqrt(i), this;
  }
  /**
   * Copies the values of the given sphere to this instance.
   *
   * @param {Sphere} sphere - The sphere to copy.
   * @return {Sphere} A reference to this sphere.
   */
  copy(e) {
    return this.center.copy(e.center), this.radius = e.radius, this;
  }
  /**
   * Returns `true` if the sphere is empty (the radius set to a negative number).
   *
   * Spheres with a radius of `0` contain only their center point and are not
   * considered to be empty.
   *
   * @return {boolean} Whether this sphere is empty or not.
   */
  isEmpty() {
    return this.radius < 0;
  }
  /**
   * Makes this sphere empty which means in encloses a zero space in 3D.
   *
   * @return {Sphere} A reference to this sphere.
   */
  makeEmpty() {
    return this.center.set(0, 0, 0), this.radius = -1, this;
  }
  /**
   * Returns `true` if this sphere contains the given point inclusive of
   * the surface of the sphere.
   *
   * @param {Vector3} point - The point to check.
   * @return {boolean} Whether this sphere contains the given point or not.
   */
  containsPoint(e) {
    return e.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  /**
   * Returns the closest distance from the boundary of the sphere to the
   * given point. If the sphere contains the point, the distance will
   * be negative.
   *
   * @param {Vector3} point - The point to compute the distance to.
   * @return {number} The distance to the point.
   */
  distanceToPoint(e) {
    return e.distanceTo(this.center) - this.radius;
  }
  /**
   * Returns `true` if this sphere intersects with the given one.
   *
   * @param {Sphere} sphere - The sphere to test.
   * @return {boolean} Whether this sphere intersects with the given one or not.
   */
  intersectsSphere(e) {
    const n = this.radius + e.radius;
    return e.center.distanceToSquared(this.center) <= n * n;
  }
  /**
   * Returns `true` if this sphere intersects with the given box.
   *
   * @param {Box3} box - The box to test.
   * @return {boolean} Whether this sphere intersects with the given box or not.
   */
  intersectsBox(e) {
    return e.intersectsSphere(this);
  }
  /**
   * Returns `true` if this sphere intersects with the given plane.
   *
   * @param {Plane} plane - The plane to test.
   * @return {boolean} Whether this sphere intersects with the given plane or not.
   */
  intersectsPlane(e) {
    return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
  }
  /**
   * Clamps a point within the sphere. If the point is outside the sphere, it
   * will clamp it to the closest point on the edge of the sphere. Points
   * already inside the sphere will not be affected.
   *
   * @param {Vector3} point - The plane to clamp.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The clamped point.
   */
  clampPoint(e, n) {
    const r = this.center.distanceToSquared(e);
    return n.copy(e), r > this.radius * this.radius && (n.sub(this.center).normalize(), n.multiplyScalar(this.radius).add(this.center)), n;
  }
  /**
   * Returns a bounding box that encloses this sphere.
   *
   * @param {Box3} target - The target box that is used to store the method's result.
   * @return {Box3} The bounding box that encloses this sphere.
   */
  getBoundingBox(e) {
    return this.isEmpty() ? (e.makeEmpty(), e) : (e.set(this.center, this.center), e.expandByScalar(this.radius), e);
  }
  /**
   * Transforms this sphere with the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @return {Sphere} A reference to this sphere.
   */
  applyMatrix4(e) {
    return this.center.applyMatrix4(e), this.radius = this.radius * e.getMaxScaleOnAxis(), this;
  }
  /**
   * Translates the sphere's center by the given offset.
   *
   * @param {Vector3} offset - The offset.
   * @return {Sphere} A reference to this sphere.
   */
  translate(e) {
    return this.center.add(e), this;
  }
  /**
   * Expands the boundaries of this sphere to include the given point.
   *
   * @param {Vector3} point - The point to include.
   * @return {Sphere} A reference to this sphere.
   */
  expandByPoint(e) {
    if (this.isEmpty())
      return this.center.copy(e), this.radius = 0, this;
    Ys.subVectors(e, this.center);
    const n = Ys.lengthSq();
    if (n > this.radius * this.radius) {
      const r = Math.sqrt(n), i = (r - this.radius) * 0.5;
      this.center.addScaledVector(Ys, i / r), this.radius += i;
    }
    return this;
  }
  /**
   * Expands this sphere to enclose both the original sphere and the given sphere.
   *
   * @param {Sphere} sphere - The sphere to include.
   * @return {Sphere} A reference to this sphere.
   */
  union(e) {
    return e.isEmpty() ? this : this.isEmpty() ? (this.copy(e), this) : (this.center.equals(e.center) === !0 ? this.radius = Math.max(this.radius, e.radius) : (g0.subVectors(e.center, this.center).setLength(e.radius), this.expandByPoint(Ys.copy(e.center).add(g0)), this.expandByPoint(Ys.copy(e.center).sub(g0))), this);
  }
  /**
   * Returns `true` if this sphere is equal with the given one.
   *
   * @param {Sphere} sphere - The sphere to test for equality.
   * @return {boolean} Whether this bounding sphere is equal with the given one.
   */
  equals(e) {
    return e.center.equals(this.center) && e.radius === this.radius;
  }
  /**
   * Returns a new sphere with copied values from this instance.
   *
   * @return {Sphere} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
const qr = /* @__PURE__ */ new re(), y0 = /* @__PURE__ */ new re(), Hc = /* @__PURE__ */ new re(), Si = /* @__PURE__ */ new re(), b0 = /* @__PURE__ */ new re(), Bc = /* @__PURE__ */ new re(), x0 = /* @__PURE__ */ new re();
class k9 {
  /**
   * Constructs a new ray.
   *
   * @param {Vector3} [origin=(0,0,0)] - The origin of the ray.
   * @param {Vector3} [direction=(0,0,-1)] - The (normalized) direction of the ray.
   */
  constructor(e = new re(), n = new re(0, 0, -1)) {
    this.origin = e, this.direction = n;
  }
  /**
   * Sets the ray's components by copying the given values.
   *
   * @param {Vector3} origin - The origin.
   * @param {Vector3} direction - The direction.
   * @return {Ray} A reference to this ray.
   */
  set(e, n) {
    return this.origin.copy(e), this.direction.copy(n), this;
  }
  /**
   * Copies the values of the given ray to this instance.
   *
   * @param {Ray} ray - The ray to copy.
   * @return {Ray} A reference to this ray.
   */
  copy(e) {
    return this.origin.copy(e.origin), this.direction.copy(e.direction), this;
  }
  /**
   * Returns a vector that is located at a given distance along this ray.
   *
   * @param {number} t - The distance along the ray to retrieve a position for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} A position on the ray.
   */
  at(e, n) {
    return n.copy(this.origin).addScaledVector(this.direction, e);
  }
  /**
   * Adjusts the direction of the ray to point at the given vector in world space.
   *
   * @param {Vector3} v - The target position.
   * @return {Ray} A reference to this ray.
   */
  lookAt(e) {
    return this.direction.copy(e).sub(this.origin).normalize(), this;
  }
  /**
   * Shift the origin of this ray along its direction by the given distance.
   *
   * @param {number} t - The distance along the ray to interpolate.
   * @return {Ray} A reference to this ray.
   */
  recast(e) {
    return this.origin.copy(this.at(e, qr)), this;
  }
  /**
   * Returns the point along this ray that is closest to the given point.
   *
   * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The closest point on this ray.
   */
  closestPointToPoint(e, n) {
    n.subVectors(e, this.origin);
    const r = n.dot(this.direction);
    return r < 0 ? n.copy(this.origin) : n.copy(this.origin).addScaledVector(this.direction, r);
  }
  /**
   * Returns the distance of the closest approach between this ray and the given point.
   *
   * @param {Vector3} point - A point in 3D space to compute the distance to.
   * @return {number} The distance.
   */
  distanceToPoint(e) {
    return Math.sqrt(this.distanceSqToPoint(e));
  }
  /**
   * Returns the squared distance of the closest approach between this ray and the given point.
   *
   * @param {Vector3} point - A point in 3D space to compute the distance to.
   * @return {number} The squared distance.
   */
  distanceSqToPoint(e) {
    const n = qr.subVectors(e, this.origin).dot(this.direction);
    return n < 0 ? this.origin.distanceToSquared(e) : (qr.copy(this.origin).addScaledVector(this.direction, n), qr.distanceToSquared(e));
  }
  /**
   * Returns the squared distance between this ray and the given line segment.
   *
   * @param {Vector3} v0 - The start point of the line segment.
   * @param {Vector3} v1 - The end point of the line segment.
   * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
   * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
   * @return {number} The squared distance.
   */
  distanceSqToSegment(e, n, r, i) {
    y0.copy(e).add(n).multiplyScalar(0.5), Hc.copy(n).sub(e).normalize(), Si.copy(this.origin).sub(y0);
    const o = e.distanceTo(n) * 0.5, a = -this.direction.dot(Hc), s = Si.dot(this.direction), l = -Si.dot(Hc), c = Si.lengthSq(), u = Math.abs(1 - a * a);
    let d, f, h, v;
    if (u > 0)
      if (d = a * l - s, f = a * s - l, v = o * u, d >= 0)
        if (f >= -v)
          if (f <= v) {
            const g = 1 / u;
            d *= g, f *= g, h = d * (d + a * f + 2 * s) + f * (a * d + f + 2 * l) + c;
          } else
            f = o, d = Math.max(0, -(a * f + s)), h = -d * d + f * (f + 2 * l) + c;
        else
          f = -o, d = Math.max(0, -(a * f + s)), h = -d * d + f * (f + 2 * l) + c;
      else
        f <= -v ? (d = Math.max(0, -(-a * o + s)), f = d > 0 ? -o : Math.min(Math.max(-o, -l), o), h = -d * d + f * (f + 2 * l) + c) : f <= v ? (d = 0, f = Math.min(Math.max(-o, -l), o), h = f * (f + 2 * l) + c) : (d = Math.max(0, -(a * o + s)), f = d > 0 ? o : Math.min(Math.max(-o, -l), o), h = -d * d + f * (f + 2 * l) + c);
    else
      f = a > 0 ? -o : o, d = Math.max(0, -(a * f + s)), h = -d * d + f * (f + 2 * l) + c;
    return r && r.copy(this.origin).addScaledVector(this.direction, d), i && i.copy(y0).addScaledVector(Hc, f), h;
  }
  /**
   * Intersects this ray with the given sphere, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Sphere} sphere - The sphere to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectSphere(e, n) {
    qr.subVectors(e.center, this.origin);
    const r = qr.dot(this.direction), i = qr.dot(qr) - r * r, o = e.radius * e.radius;
    if (i > o)
      return null;
    const a = Math.sqrt(o - i), s = r - a, l = r + a;
    return l < 0 ? null : s < 0 ? this.at(l, n) : this.at(s, n);
  }
  /**
   * Returns `true` if this ray intersects with the given sphere.
   *
   * @param {Sphere} sphere - The sphere to intersect.
   * @return {boolean} Whether this ray intersects with the given sphere or not.
   */
  intersectsSphere(e) {
    return this.distanceSqToPoint(e.center) <= e.radius * e.radius;
  }
  /**
   * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
   * does not intersect with the plane.
   *
   * @param {Plane} plane - The plane to compute the distance to.
   * @return {?number} Whether this ray intersects with the given sphere or not.
   */
  distanceToPlane(e) {
    const n = e.normal.dot(this.direction);
    if (n === 0)
      return e.distanceToPoint(this.origin) === 0 ? 0 : null;
    const r = -(this.origin.dot(e.normal) + e.constant) / n;
    return r >= 0 ? r : null;
  }
  /**
   * Intersects this ray with the given plane, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Plane} plane - The plane to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectPlane(e, n) {
    const r = this.distanceToPlane(e);
    return r === null ? null : this.at(r, n);
  }
  /**
   * Returns `true` if this ray intersects with the given plane.
   *
   * @param {Plane} plane - The plane to intersect.
   * @return {boolean} Whether this ray intersects with the given plane or not.
   */
  intersectsPlane(e) {
    const n = e.distanceToPoint(this.origin);
    return n === 0 || e.normal.dot(this.direction) * n < 0;
  }
  /**
   * Intersects this ray with the given bounding box, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Box3} box - The box to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectBox(e, n) {
    let r, i, o, a, s, l;
    const c = 1 / this.direction.x, u = 1 / this.direction.y, d = 1 / this.direction.z, f = this.origin;
    return c >= 0 ? (r = (e.min.x - f.x) * c, i = (e.max.x - f.x) * c) : (r = (e.max.x - f.x) * c, i = (e.min.x - f.x) * c), u >= 0 ? (o = (e.min.y - f.y) * u, a = (e.max.y - f.y) * u) : (o = (e.max.y - f.y) * u, a = (e.min.y - f.y) * u), r > a || o > i || ((o > r || isNaN(r)) && (r = o), (a < i || isNaN(i)) && (i = a), d >= 0 ? (s = (e.min.z - f.z) * d, l = (e.max.z - f.z) * d) : (s = (e.max.z - f.z) * d, l = (e.min.z - f.z) * d), r > l || s > i) || ((s > r || r !== r) && (r = s), (l < i || i !== i) && (i = l), i < 0) ? null : this.at(r >= 0 ? r : i, n);
  }
  /**
   * Returns `true` if this ray intersects with the given box.
   *
   * @param {Box3} box - The box to intersect.
   * @return {boolean} Whether this ray intersects with the given box or not.
   */
  intersectsBox(e) {
    return this.intersectBox(e, qr) !== null;
  }
  /**
   * Intersects this ray with the given triangle, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Vector3} a - The first vertex of the triangle.
   * @param {Vector3} b - The second vertex of the triangle.
   * @param {Vector3} c - The third vertex of the triangle.
   * @param {boolean} backfaceCulling - Whether to use backface culling or not.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectTriangle(e, n, r, i, o) {
    b0.subVectors(n, e), Bc.subVectors(r, e), x0.crossVectors(b0, Bc);
    let a = this.direction.dot(x0), s;
    if (a > 0) {
      if (i)
        return null;
      s = 1;
    } else if (a < 0)
      s = -1, a = -a;
    else
      return null;
    Si.subVectors(this.origin, e);
    const l = s * this.direction.dot(Bc.crossVectors(Si, Bc));
    if (l < 0)
      return null;
    const c = s * this.direction.dot(b0.cross(Si));
    if (c < 0 || l + c > a)
      return null;
    const u = -s * Si.dot(x0);
    return u < 0 ? null : this.at(u / a, o);
  }
  /**
   * Transforms this ray with the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix4 - The transformation matrix.
   * @return {Ray} A reference to this ray.
   */
  applyMatrix4(e) {
    return this.origin.applyMatrix4(e), this.direction.transformDirection(e), this;
  }
  /**
   * Returns `true` if this ray is equal with the given one.
   *
   * @param {Ray} ray - The ray to test for equality.
   * @return {boolean} Whether this ray is equal with the given one.
   */
  equals(e) {
    return e.origin.equals(this.origin) && e.direction.equals(this.direction);
  }
  /**
   * Returns a new ray with copied values from this instance.
   *
   * @return {Ray} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
class qt {
  /**
   * Constructs a new 4x4 matrix. The arguments are supposed to be
   * in row-major order. If no arguments are provided, the constructor
   * initializes the matrix as an identity matrix.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n14] - 1-4 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n24] - 2-4 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @param {number} [n34] - 3-4 matrix element.
   * @param {number} [n41] - 4-1 matrix element.
   * @param {number} [n42] - 4-2 matrix element.
   * @param {number} [n43] - 4-3 matrix element.
   * @param {number} [n44] - 4-4 matrix element.
   */
  constructor(e, n, r, i, o, a, s, l, c, u, d, f, h, v, g, m) {
    qt.prototype.isMatrix4 = !0, this.elements = [
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ], e !== void 0 && this.set(e, n, r, i, o, a, s, l, c, u, d, f, h, v, g, m);
  }
  /**
   * Sets the elements of the matrix.The arguments are supposed to be
   * in row-major order.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n14] - 1-4 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n24] - 2-4 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @param {number} [n34] - 3-4 matrix element.
   * @param {number} [n41] - 4-1 matrix element.
   * @param {number} [n42] - 4-2 matrix element.
   * @param {number} [n43] - 4-3 matrix element.
   * @param {number} [n44] - 4-4 matrix element.
   * @return {Matrix4} A reference to this matrix.
   */
  set(e, n, r, i, o, a, s, l, c, u, d, f, h, v, g, m) {
    const p = this.elements;
    return p[0] = e, p[4] = n, p[8] = r, p[12] = i, p[1] = o, p[5] = a, p[9] = s, p[13] = l, p[2] = c, p[6] = u, p[10] = d, p[14] = f, p[3] = h, p[7] = v, p[11] = g, p[15] = m, this;
  }
  /**
   * Sets this matrix to the 4x4 identity matrix.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Returns a matrix with copied values from this instance.
   *
   * @return {Matrix4} A clone of this instance.
   */
  clone() {
    return new qt().fromArray(this.elements);
  }
  /**
   * Copies the values of the given matrix to this instance.
   *
   * @param {Matrix4} m - The matrix to copy.
   * @return {Matrix4} A reference to this matrix.
   */
  copy(e) {
    const n = this.elements, r = e.elements;
    return n[0] = r[0], n[1] = r[1], n[2] = r[2], n[3] = r[3], n[4] = r[4], n[5] = r[5], n[6] = r[6], n[7] = r[7], n[8] = r[8], n[9] = r[9], n[10] = r[10], n[11] = r[11], n[12] = r[12], n[13] = r[13], n[14] = r[14], n[15] = r[15], this;
  }
  /**
   * Copies the translation component of the given matrix
   * into this matrix's translation component.
   *
   * @param {Matrix4} m - The matrix to copy the translation component.
   * @return {Matrix4} A reference to this matrix.
   */
  copyPosition(e) {
    const n = this.elements, r = e.elements;
    return n[12] = r[12], n[13] = r[13], n[14] = r[14], this;
  }
  /**
   * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  setFromMatrix3(e) {
    const n = e.elements;
    return this.set(
      n[0],
      n[3],
      n[6],
      0,
      n[1],
      n[4],
      n[7],
      0,
      n[2],
      n[5],
      n[8],
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Extracts the basis of this matrix into the three axis vectors provided.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  extractBasis(e, n, r) {
    return e.setFromMatrixColumn(this, 0), n.setFromMatrixColumn(this, 1), r.setFromMatrixColumn(this, 2), this;
  }
  /**
   * Sets the given basis vectors to this matrix.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeBasis(e, n, r) {
    return this.set(
      e.x,
      n.x,
      r.x,
      0,
      e.y,
      n.y,
      r.y,
      0,
      e.z,
      n.z,
      r.z,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Extracts the rotation component of the given matrix
   * into this matrix's rotation component.
   *
   * Note: This method does not support reflection matrices.
   *
   * @param {Matrix4} m - The matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  extractRotation(e) {
    const n = this.elements, r = e.elements, i = 1 / ca.setFromMatrixColumn(e, 0).length(), o = 1 / ca.setFromMatrixColumn(e, 1).length(), a = 1 / ca.setFromMatrixColumn(e, 2).length();
    return n[0] = r[0] * i, n[1] = r[1] * i, n[2] = r[2] * i, n[3] = 0, n[4] = r[4] * o, n[5] = r[5] * o, n[6] = r[6] * o, n[7] = 0, n[8] = r[8] * a, n[9] = r[9] * a, n[10] = r[10] * a, n[11] = 0, n[12] = 0, n[13] = 0, n[14] = 0, n[15] = 1, this;
  }
  /**
   * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
   * the rotation specified by the given Euler angles. The rest of
   * the matrix is set to the identity. Depending on the {@link Euler#order},
   * there are six possible outcomes. See [this page]{@link https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix}
   * for a complete list.
   *
   * @param {Euler} euler - The Euler angles.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationFromEuler(e) {
    const n = this.elements, r = e.x, i = e.y, o = e.z, a = Math.cos(r), s = Math.sin(r), l = Math.cos(i), c = Math.sin(i), u = Math.cos(o), d = Math.sin(o);
    if (e.order === "XYZ") {
      const f = a * u, h = a * d, v = s * u, g = s * d;
      n[0] = l * u, n[4] = -l * d, n[8] = c, n[1] = h + v * c, n[5] = f - g * c, n[9] = -s * l, n[2] = g - f * c, n[6] = v + h * c, n[10] = a * l;
    } else if (e.order === "YXZ") {
      const f = l * u, h = l * d, v = c * u, g = c * d;
      n[0] = f + g * s, n[4] = v * s - h, n[8] = a * c, n[1] = a * d, n[5] = a * u, n[9] = -s, n[2] = h * s - v, n[6] = g + f * s, n[10] = a * l;
    } else if (e.order === "ZXY") {
      const f = l * u, h = l * d, v = c * u, g = c * d;
      n[0] = f - g * s, n[4] = -a * d, n[8] = v + h * s, n[1] = h + v * s, n[5] = a * u, n[9] = g - f * s, n[2] = -a * c, n[6] = s, n[10] = a * l;
    } else if (e.order === "ZYX") {
      const f = a * u, h = a * d, v = s * u, g = s * d;
      n[0] = l * u, n[4] = v * c - h, n[8] = f * c + g, n[1] = l * d, n[5] = g * c + f, n[9] = h * c - v, n[2] = -c, n[6] = s * l, n[10] = a * l;
    } else if (e.order === "YZX") {
      const f = a * l, h = a * c, v = s * l, g = s * c;
      n[0] = l * u, n[4] = g - f * d, n[8] = v * d + h, n[1] = d, n[5] = a * u, n[9] = -s * u, n[2] = -c * u, n[6] = h * d + v, n[10] = f - g * d;
    } else if (e.order === "XZY") {
      const f = a * l, h = a * c, v = s * l, g = s * c;
      n[0] = l * u, n[4] = -d, n[8] = c * u, n[1] = f * d + g, n[5] = a * u, n[9] = h * d - v, n[2] = v * d - h, n[6] = s * u, n[10] = g * d + f;
    }
    return n[3] = 0, n[7] = 0, n[11] = 0, n[12] = 0, n[13] = 0, n[14] = 0, n[15] = 1, this;
  }
  /**
   * Sets the rotation component of this matrix to the rotation specified by
   * the given Quaternion as outlined [here]{@link https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion}
   * The rest of the matrix is set to the identity.
   *
   * @param {Quaternion} q - The Quaternion.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationFromQuaternion(e) {
    return this.compose(wee, e, _ee);
  }
  /**
   * Sets the rotation component of the transformation matrix, looking from `eye` towards
   * `target`, and oriented by the up-direction.
   *
   * @param {Vector3} eye - The eye vector.
   * @param {Vector3} target - The target vector.
   * @param {Vector3} up - The up vector.
   * @return {Matrix4} A reference to this matrix.
   */
  lookAt(e, n, r) {
    const i = this.elements;
    return Fn.subVectors(e, n), Fn.lengthSq() === 0 && (Fn.z = 1), Fn.normalize(), Mi.crossVectors(r, Fn), Mi.lengthSq() === 0 && (Math.abs(r.z) === 1 ? Fn.x += 1e-4 : Fn.z += 1e-4, Fn.normalize(), Mi.crossVectors(r, Fn)), Mi.normalize(), Vc.crossVectors(Fn, Mi), i[0] = Mi.x, i[4] = Vc.x, i[8] = Fn.x, i[1] = Mi.y, i[5] = Vc.y, i[9] = Fn.y, i[2] = Mi.z, i[6] = Vc.z, i[10] = Fn.z, this;
  }
  /**
   * Post-multiplies this matrix by the given 4x4 matrix.
   *
   * @param {Matrix4} m - The matrix to multiply with.
   * @return {Matrix4} A reference to this matrix.
   */
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  /**
   * Pre-multiplies this matrix by the given 4x4 matrix.
   *
   * @param {Matrix4} m - The matrix to multiply with.
   * @return {Matrix4} A reference to this matrix.
   */
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  /**
   * Multiples the given 4x4 matrices and stores the result
   * in this matrix.
   *
   * @param {Matrix4} a - The first matrix.
   * @param {Matrix4} b - The second matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  multiplyMatrices(e, n) {
    const r = e.elements, i = n.elements, o = this.elements, a = r[0], s = r[4], l = r[8], c = r[12], u = r[1], d = r[5], f = r[9], h = r[13], v = r[2], g = r[6], m = r[10], p = r[14], y = r[3], b = r[7], x = r[11], _ = r[15], M = i[0], S = i[4], P = i[8], E = i[12], w = i[1], O = i[5], N = i[9], I = i[13], H = i[2], j = i[6], U = i[10], $ = i[14], V = i[3], te = i[7], B = i[11], Z = i[15];
    return o[0] = a * M + s * w + l * H + c * V, o[4] = a * S + s * O + l * j + c * te, o[8] = a * P + s * N + l * U + c * B, o[12] = a * E + s * I + l * $ + c * Z, o[1] = u * M + d * w + f * H + h * V, o[5] = u * S + d * O + f * j + h * te, o[9] = u * P + d * N + f * U + h * B, o[13] = u * E + d * I + f * $ + h * Z, o[2] = v * M + g * w + m * H + p * V, o[6] = v * S + g * O + m * j + p * te, o[10] = v * P + g * N + m * U + p * B, o[14] = v * E + g * I + m * $ + p * Z, o[3] = y * M + b * w + x * H + _ * V, o[7] = y * S + b * O + x * j + _ * te, o[11] = y * P + b * N + x * U + _ * B, o[15] = y * E + b * I + x * $ + _ * Z, this;
  }
  /**
   * Multiplies every component of the matrix by the given scalar.
   *
   * @param {number} s - The scalar.
   * @return {Matrix4} A reference to this matrix.
   */
  multiplyScalar(e) {
    const n = this.elements;
    return n[0] *= e, n[4] *= e, n[8] *= e, n[12] *= e, n[1] *= e, n[5] *= e, n[9] *= e, n[13] *= e, n[2] *= e, n[6] *= e, n[10] *= e, n[14] *= e, n[3] *= e, n[7] *= e, n[11] *= e, n[15] *= e, this;
  }
  /**
   * Computes and returns the determinant of this matrix.
   *
   * Based on the method outlined [here]{@link http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html}.
   *
   * @return {number} The determinant.
   */
  determinant() {
    const e = this.elements, n = e[0], r = e[4], i = e[8], o = e[12], a = e[1], s = e[5], l = e[9], c = e[13], u = e[2], d = e[6], f = e[10], h = e[14], v = e[3], g = e[7], m = e[11], p = e[15];
    return v * (+o * l * d - i * c * d - o * s * f + r * c * f + i * s * h - r * l * h) + g * (+n * l * h - n * c * f + o * a * f - i * a * h + i * c * u - o * l * u) + m * (+n * c * d - n * s * h - o * a * d + r * a * h + o * s * u - r * c * u) + p * (-i * s * u - n * l * d + n * s * f + i * a * d - r * a * f + r * l * u);
  }
  /**
   * Transposes this matrix in place.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  transpose() {
    const e = this.elements;
    let n;
    return n = e[1], e[1] = e[4], e[4] = n, n = e[2], e[2] = e[8], e[8] = n, n = e[6], e[6] = e[9], e[9] = n, n = e[3], e[3] = e[12], e[12] = n, n = e[7], e[7] = e[13], e[13] = n, n = e[11], e[11] = e[14], e[14] = n, this;
  }
  /**
   * Sets the position component for this matrix from the given vector,
   * without affecting the rest of the matrix.
   *
   * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
   * @param {number} y - The y component of the vector.
   * @param {number} z - The z component of the vector.
   * @return {Matrix4} A reference to this matrix.
   */
  setPosition(e, n, r) {
    const i = this.elements;
    return e.isVector3 ? (i[12] = e.x, i[13] = e.y, i[14] = e.z) : (i[12] = e, i[13] = n, i[14] = r), this;
  }
  /**
   * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
   * You can not invert with a determinant of zero. If you attempt this, the method produces
   * a zero matrix instead.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  invert() {
    const e = this.elements, n = e[0], r = e[1], i = e[2], o = e[3], a = e[4], s = e[5], l = e[6], c = e[7], u = e[8], d = e[9], f = e[10], h = e[11], v = e[12], g = e[13], m = e[14], p = e[15], y = d * m * c - g * f * c + g * l * h - s * m * h - d * l * p + s * f * p, b = v * f * c - u * m * c - v * l * h + a * m * h + u * l * p - a * f * p, x = u * g * c - v * d * c + v * s * h - a * g * h - u * s * p + a * d * p, _ = v * d * l - u * g * l - v * s * f + a * g * f + u * s * m - a * d * m, M = n * y + r * b + i * x + o * _;
    if (M === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const S = 1 / M;
    return e[0] = y * S, e[1] = (g * f * o - d * m * o - g * i * h + r * m * h + d * i * p - r * f * p) * S, e[2] = (s * m * o - g * l * o + g * i * c - r * m * c - s * i * p + r * l * p) * S, e[3] = (d * l * o - s * f * o - d * i * c + r * f * c + s * i * h - r * l * h) * S, e[4] = b * S, e[5] = (u * m * o - v * f * o + v * i * h - n * m * h - u * i * p + n * f * p) * S, e[6] = (v * l * o - a * m * o - v * i * c + n * m * c + a * i * p - n * l * p) * S, e[7] = (a * f * o - u * l * o + u * i * c - n * f * c - a * i * h + n * l * h) * S, e[8] = x * S, e[9] = (v * d * o - u * g * o - v * r * h + n * g * h + u * r * p - n * d * p) * S, e[10] = (a * g * o - v * s * o + v * r * c - n * g * c - a * r * p + n * s * p) * S, e[11] = (u * s * o - a * d * o - u * r * c + n * d * c + a * r * h - n * s * h) * S, e[12] = _ * S, e[13] = (u * g * i - v * d * i + v * r * f - n * g * f - u * r * m + n * d * m) * S, e[14] = (v * s * i - a * g * i - v * r * l + n * g * l + a * r * m - n * s * m) * S, e[15] = (a * d * i - u * s * i + u * r * l - n * d * l - a * r * f + n * s * f) * S, this;
  }
  /**
   * Multiplies the columns of this matrix by the given vector.
   *
   * @param {Vector3} v - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  scale(e) {
    const n = this.elements, r = e.x, i = e.y, o = e.z;
    return n[0] *= r, n[4] *= i, n[8] *= o, n[1] *= r, n[5] *= i, n[9] *= o, n[2] *= r, n[6] *= i, n[10] *= o, n[3] *= r, n[7] *= i, n[11] *= o, this;
  }
  /**
   * Gets the maximum scale value of the three axes.
   *
   * @return {number} The maximum scale.
   */
  getMaxScaleOnAxis() {
    const e = this.elements, n = e[0] * e[0] + e[1] * e[1] + e[2] * e[2], r = e[4] * e[4] + e[5] * e[5] + e[6] * e[6], i = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
    return Math.sqrt(Math.max(n, r, i));
  }
  /**
   * Sets this matrix as a translation transform from the given vector.
   *
   * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
   * @param {number} y - The amount to translate in the Y axis.
   * @param {number} z - The amount to translate in the z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeTranslation(e, n, r) {
    return e.isVector3 ? this.set(
      1,
      0,
      0,
      e.x,
      0,
      1,
      0,
      e.y,
      0,
      0,
      1,
      e.z,
      0,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      0,
      e,
      0,
      1,
      0,
      n,
      0,
      0,
      1,
      r,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the X axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationX(e) {
    const n = Math.cos(e), r = Math.sin(e);
    return this.set(
      1,
      0,
      0,
      0,
      0,
      n,
      -r,
      0,
      0,
      r,
      n,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the Y axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationY(e) {
    const n = Math.cos(e), r = Math.sin(e);
    return this.set(
      n,
      0,
      r,
      0,
      0,
      1,
      0,
      0,
      -r,
      0,
      n,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the Z axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationZ(e) {
    const n = Math.cos(e), r = Math.sin(e);
    return this.set(
      n,
      -r,
      0,
      0,
      r,
      n,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the given axis by
   * the given angle.
   *
   * This is a somewhat controversial but mathematically sound alternative to
   * rotating via Quaternions. See the discussion [here]{@link https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199}.
   *
   * @param {Vector3} axis - The normalized rotation axis.
   * @param {number} angle - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationAxis(e, n) {
    const r = Math.cos(n), i = Math.sin(n), o = 1 - r, a = e.x, s = e.y, l = e.z, c = o * a, u = o * s;
    return this.set(
      c * a + r,
      c * s - i * l,
      c * l + i * s,
      0,
      c * s + i * l,
      u * s + r,
      u * l - i * a,
      0,
      c * l - i * s,
      u * l + i * a,
      o * l * l + r,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a scale transformation.
   *
   * @param {number} x - The amount to scale in the X axis.
   * @param {number} y - The amount to scale in the Y axis.
   * @param {number} z - The amount to scale in the Z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeScale(e, n, r) {
    return this.set(
      e,
      0,
      0,
      0,
      0,
      n,
      0,
      0,
      0,
      0,
      r,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a shear transformation.
   *
   * @param {number} xy - The amount to shear X by Y.
   * @param {number} xz - The amount to shear X by Z.
   * @param {number} yx - The amount to shear Y by X.
   * @param {number} yz - The amount to shear Y by Z.
   * @param {number} zx - The amount to shear Z by X.
   * @param {number} zy - The amount to shear Z by Y.
   * @return {Matrix4} A reference to this matrix.
   */
  makeShear(e, n, r, i, o, a) {
    return this.set(
      1,
      r,
      o,
      0,
      e,
      1,
      a,
      0,
      n,
      i,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix to the transformation composed of the given position,
   * rotation (Quaternion) and scale.
   *
   * @param {Vector3} position - The position vector.
   * @param {Quaternion} quaternion - The rotation as a Quaternion.
   * @param {Vector3} scale - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  compose(e, n, r) {
    const i = this.elements, o = n._x, a = n._y, s = n._z, l = n._w, c = o + o, u = a + a, d = s + s, f = o * c, h = o * u, v = o * d, g = a * u, m = a * d, p = s * d, y = l * c, b = l * u, x = l * d, _ = r.x, M = r.y, S = r.z;
    return i[0] = (1 - (g + p)) * _, i[1] = (h + x) * _, i[2] = (v - b) * _, i[3] = 0, i[4] = (h - x) * M, i[5] = (1 - (f + p)) * M, i[6] = (m + y) * M, i[7] = 0, i[8] = (v + b) * S, i[9] = (m - y) * S, i[10] = (1 - (f + g)) * S, i[11] = 0, i[12] = e.x, i[13] = e.y, i[14] = e.z, i[15] = 1, this;
  }
  /**
   * Decomposes this matrix into its position, rotation and scale components
   * and provides the result in the given objects.
   *
   * Note: Not all matrices are decomposable in this way. For example, if an
   * object has a non-uniformly scaled parent, then the object's world matrix
   * may not be decomposable, and this method may not be appropriate.
   *
   * @param {Vector3} position - The position vector.
   * @param {Quaternion} quaternion - The rotation as a Quaternion.
   * @param {Vector3} scale - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  decompose(e, n, r) {
    const i = this.elements;
    let o = ca.set(i[0], i[1], i[2]).length();
    const a = ca.set(i[4], i[5], i[6]).length(), s = ca.set(i[8], i[9], i[10]).length();
    this.determinant() < 0 && (o = -o), e.x = i[12], e.y = i[13], e.z = i[14], fr.copy(this);
    const c = 1 / o, u = 1 / a, d = 1 / s;
    return fr.elements[0] *= c, fr.elements[1] *= c, fr.elements[2] *= c, fr.elements[4] *= u, fr.elements[5] *= u, fr.elements[6] *= u, fr.elements[8] *= d, fr.elements[9] *= d, fr.elements[10] *= d, n.setFromRotationMatrix(fr), r.x = o, r.y = a, r.z = s, this;
  }
  /**
  	 * Creates a perspective projection matrix. This is used internally by
  	 * {@link PerspectiveCamera#updateProjectionMatrix}.
  
  	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
  	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
  	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
  	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
  	 * @param {number} near - The distance from the camera to the near plane.
  	 * @param {number} far - The distance from the camera to the far plane.
  	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
  	 * @return {Matrix4} A reference to this matrix.
  	 */
  makePerspective(e, n, r, i, o, a, s = ii) {
    const l = this.elements, c = 2 * o / (n - e), u = 2 * o / (r - i), d = (n + e) / (n - e), f = (r + i) / (r - i);
    let h, v;
    if (s === ii)
      h = -(a + o) / (a - o), v = -2 * a * o / (a - o);
    else if (s === rd)
      h = -a / (a - o), v = -a * o / (a - o);
    else
      throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + s);
    return l[0] = c, l[4] = 0, l[8] = d, l[12] = 0, l[1] = 0, l[5] = u, l[9] = f, l[13] = 0, l[2] = 0, l[6] = 0, l[10] = h, l[14] = v, l[3] = 0, l[7] = 0, l[11] = -1, l[15] = 0, this;
  }
  /**
  	 * Creates a orthographic projection matrix. This is used internally by
  	 * {@link OrthographicCamera#updateProjectionMatrix}.
  
  	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
  	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
  	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
  	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
  	 * @param {number} near - The distance from the camera to the near plane.
  	 * @param {number} far - The distance from the camera to the far plane.
  	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
  	 * @return {Matrix4} A reference to this matrix.
  	 */
  makeOrthographic(e, n, r, i, o, a, s = ii) {
    const l = this.elements, c = 1 / (n - e), u = 1 / (r - i), d = 1 / (a - o), f = (n + e) * c, h = (r + i) * u;
    let v, g;
    if (s === ii)
      v = (a + o) * d, g = -2 * d;
    else if (s === rd)
      v = o * d, g = -1 * d;
    else
      throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + s);
    return l[0] = 2 * c, l[4] = 0, l[8] = 0, l[12] = -f, l[1] = 0, l[5] = 2 * u, l[9] = 0, l[13] = -h, l[2] = 0, l[6] = 0, l[10] = g, l[14] = -v, l[3] = 0, l[7] = 0, l[11] = 0, l[15] = 1, this;
  }
  /**
   * Returns `true` if this matrix is equal with the given one.
   *
   * @param {Matrix4} matrix - The matrix to test for equality.
   * @return {boolean} Whether this matrix is equal with the given one.
   */
  equals(e) {
    const n = this.elements, r = e.elements;
    for (let i = 0; i < 16; i++)
      if (n[i] !== r[i])
        return !1;
    return !0;
  }
  /**
   * Sets the elements of the matrix from the given array.
   *
   * @param {Array<number>} array - The matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Matrix4} A reference to this matrix.
   */
  fromArray(e, n = 0) {
    for (let r = 0; r < 16; r++)
      this.elements[r] = e[r + n];
    return this;
  }
  /**
   * Writes the elements of this matrix to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The matrix elements in column-major order.
   */
  toArray(e = [], n = 0) {
    const r = this.elements;
    return e[n] = r[0], e[n + 1] = r[1], e[n + 2] = r[2], e[n + 3] = r[3], e[n + 4] = r[4], e[n + 5] = r[5], e[n + 6] = r[6], e[n + 7] = r[7], e[n + 8] = r[8], e[n + 9] = r[9], e[n + 10] = r[10], e[n + 11] = r[11], e[n + 12] = r[12], e[n + 13] = r[13], e[n + 14] = r[14], e[n + 15] = r[15], e;
  }
}
const ca = /* @__PURE__ */ new re(), fr = /* @__PURE__ */ new qt(), wee = /* @__PURE__ */ new re(0, 0, 0), _ee = /* @__PURE__ */ new re(1, 1, 1), Mi = /* @__PURE__ */ new re(), Vc = /* @__PURE__ */ new re(), Fn = /* @__PURE__ */ new re(), O4 = /* @__PURE__ */ new qt(), D4 = /* @__PURE__ */ new Rs();
class Vr {
  /**
   * Constructs a new euler instance.
   *
   * @param {number} [x=0] - The angle of the x axis in radians.
   * @param {number} [y=0] - The angle of the y axis in radians.
   * @param {number} [z=0] - The angle of the z axis in radians.
   * @param {string} [order=Euler.DEFAULT_ORDER] - A string representing the order that the rotations are applied.
   */
  constructor(e = 0, n = 0, r = 0, i = Vr.DEFAULT_ORDER) {
    this.isEuler = !0, this._x = e, this._y = n, this._z = r, this._order = i;
  }
  /**
   * The angle of the x axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  /**
   * The angle of the y axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  /**
   * The angle of the z axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  /**
   * A string representing the order that the rotations are applied.
   *
   * @type {string}
   * @default 'XYZ'
   */
  get order() {
    return this._order;
  }
  set order(e) {
    this._order = e, this._onChangeCallback();
  }
  /**
   * Sets the Euler components.
   *
   * @param {number} x - The angle of the x axis in radians.
   * @param {number} y - The angle of the y axis in radians.
   * @param {number} z - The angle of the z axis in radians.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  set(e, n, r, i = this._order) {
    return this._x = e, this._y = n, this._z = r, this._order = i, this._onChangeCallback(), this;
  }
  /**
   * Returns a new Euler instance with copied values from this instance.
   *
   * @return {Euler} A clone of this instance.
   */
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  /**
   * Copies the values of the given Euler instance to this instance.
   *
   * @param {Euler} euler - The Euler instance to copy.
   * @return {Euler} A reference to this Euler instance.
   */
  copy(e) {
    return this._x = e._x, this._y = e._y, this._z = e._z, this._order = e._order, this._onChangeCallback(), this;
  }
  /**
   * Sets the angles of this Euler instance from a pure rotation matrix.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromRotationMatrix(e, n = this._order, r = !0) {
    const i = e.elements, o = i[0], a = i[4], s = i[8], l = i[1], c = i[5], u = i[9], d = i[2], f = i[6], h = i[10];
    switch (n) {
      case "XYZ":
        this._y = Math.asin(dt(s, -1, 1)), Math.abs(s) < 0.9999999 ? (this._x = Math.atan2(-u, h), this._z = Math.atan2(-a, o)) : (this._x = Math.atan2(f, c), this._z = 0);
        break;
      case "YXZ":
        this._x = Math.asin(-dt(u, -1, 1)), Math.abs(u) < 0.9999999 ? (this._y = Math.atan2(s, h), this._z = Math.atan2(l, c)) : (this._y = Math.atan2(-d, o), this._z = 0);
        break;
      case "ZXY":
        this._x = Math.asin(dt(f, -1, 1)), Math.abs(f) < 0.9999999 ? (this._y = Math.atan2(-d, h), this._z = Math.atan2(-a, c)) : (this._y = 0, this._z = Math.atan2(l, o));
        break;
      case "ZYX":
        this._y = Math.asin(-dt(d, -1, 1)), Math.abs(d) < 0.9999999 ? (this._x = Math.atan2(f, h), this._z = Math.atan2(l, o)) : (this._x = 0, this._z = Math.atan2(-a, c));
        break;
      case "YZX":
        this._z = Math.asin(dt(l, -1, 1)), Math.abs(l) < 0.9999999 ? (this._x = Math.atan2(-u, c), this._y = Math.atan2(-d, o)) : (this._x = 0, this._y = Math.atan2(s, h));
        break;
      case "XZY":
        this._z = Math.asin(-dt(a, -1, 1)), Math.abs(a) < 0.9999999 ? (this._x = Math.atan2(f, c), this._y = Math.atan2(s, o)) : (this._x = Math.atan2(-u, h), this._y = 0);
        break;
      default:
        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + n);
    }
    return this._order = n, r === !0 && this._onChangeCallback(), this;
  }
  /**
   * Sets the angles of this Euler instance from a normalized quaternion.
   *
   * @param {Quaternion} q - A normalized Quaternion.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromQuaternion(e, n, r) {
    return O4.makeRotationFromQuaternion(e), this.setFromRotationMatrix(O4, n, r);
  }
  /**
   * Sets the angles of this Euler instance from the given vector.
   *
   * @param {Vector3} v - The vector.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromVector3(e, n = this._order) {
    return this.set(e.x, e.y, e.z, n);
  }
  /**
   * Resets the euler angle with a new order by creating a quaternion from this
   * euler angle and then setting this euler angle with the quaternion and the
   * new order.
   *
   * Warning: This discards revolution information.
   *
   * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  reorder(e) {
    return D4.setFromEuler(this), this.setFromQuaternion(D4, e);
  }
  /**
   * Returns `true` if this Euler instance is equal with the given one.
   *
   * @param {Euler} euler - The Euler instance to test for equality.
   * @return {boolean} Whether this Euler instance is equal with the given one.
   */
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._order === this._order;
  }
  /**
   * Sets this Euler instance's components to values from the given array. The first three
   * entries of the array are assign to the x,y and z components. An optional fourth entry
   * defines the Euler order.
   *
   * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
   * @return {Euler} A reference to this Euler instance.
   */
  fromArray(e) {
    return this._x = e[0], this._y = e[1], this._z = e[2], e[3] !== void 0 && (this._order = e[3]), this._onChangeCallback(), this;
  }
  /**
   * Writes the components of this Euler instance to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number,number,number,string>} The Euler components.
   */
  toArray(e = [], n = 0) {
    return e[n] = this._x, e[n + 1] = this._y, e[n + 2] = this._z, e[n + 3] = this._order, e;
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._order;
  }
}
Vr.DEFAULT_ORDER = "XYZ";
class P2 {
  /**
   * Constructs a new layers instance, with membership
   * initially set to layer `0`.
   */
  constructor() {
    this.mask = 1;
  }
  /**
   * Sets membership to the given layer, and remove membership all other layers.
   *
   * @param {number} layer - The layer to set.
   */
  set(e) {
    this.mask = (1 << e | 0) >>> 0;
  }
  /**
   * Adds membership of the given layer.
   *
   * @param {number} layer - The layer to enable.
   */
  enable(e) {
    this.mask |= 1 << e | 0;
  }
  /**
   * Adds membership to all layers.
   */
  enableAll() {
    this.mask = -1;
  }
  /**
   * Toggles the membership of the given layer.
   *
   * @param {number} layer - The layer to toggle.
   */
  toggle(e) {
    this.mask ^= 1 << e | 0;
  }
  /**
   * Removes membership of the given layer.
   *
   * @param {number} layer - The layer to enable.
   */
  disable(e) {
    this.mask &= ~(1 << e | 0);
  }
  /**
   * Removes the membership from all layers.
   */
  disableAll() {
    this.mask = 0;
  }
  /**
   * Returns `true` if this and the given layers object have at least one
   * layer in common.
   *
   * @param {Layers} layers - The layers to test.
   * @return {boolean } Whether this and the given layers object have at least one layer in common or not.
   */
  test(e) {
    return (this.mask & e.mask) !== 0;
  }
  /**
   * Returns `true` if the given layer is enabled.
   *
   * @param {number} layer - The layer to test.
   * @return {boolean } Whether the given layer is enabled or not.
   */
  isEnabled(e) {
    return (this.mask & (1 << e | 0)) !== 0;
  }
}
let Cee = 0;
const k4 = /* @__PURE__ */ new re(), ua = /* @__PURE__ */ new Rs(), Xr = /* @__PURE__ */ new qt(), $c = /* @__PURE__ */ new re(), Zs = /* @__PURE__ */ new re(), Eee = /* @__PURE__ */ new re(), See = /* @__PURE__ */ new Rs(), N4 = /* @__PURE__ */ new re(1, 0, 0), I4 = /* @__PURE__ */ new re(0, 1, 0), F4 = /* @__PURE__ */ new re(0, 0, 1), U4 = { type: "added" }, Mee = { type: "removed" }, da = { type: "childadded", child: null }, w0 = { type: "childremoved", child: null };
class qn extends As {
  /**
   * Constructs a new 3D object.
   */
  constructor() {
    super(), this.isObject3D = !0, Object.defineProperty(this, "id", { value: Cee++ }), this.uuid = Ps(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = qn.DEFAULT_UP.clone();
    const e = new re(), n = new Vr(), r = new Rs(), i = new re(1, 1, 1);
    function o() {
      r.setFromEuler(n, !1);
    }
    function a() {
      n.setFromQuaternion(r, void 0, !1);
    }
    n._onChange(o), r._onChange(a), Object.defineProperties(this, {
      /**
       * Represents the object's local position.
       *
       * @name Object3D#position
       * @type {Vector3}
       * @default (0,0,0)
       */
      position: {
        configurable: !0,
        enumerable: !0,
        value: e
      },
      /**
       * Represents the object's local rotation as Euler angles, in radians.
       *
       * @name Object3D#rotation
       * @type {Euler}
       * @default (0,0,0)
       */
      rotation: {
        configurable: !0,
        enumerable: !0,
        value: n
      },
      /**
       * Represents the object's local rotation as Quaternions.
       *
       * @name Object3D#quaternion
       * @type {Quaternion}
       */
      quaternion: {
        configurable: !0,
        enumerable: !0,
        value: r
      },
      /**
       * Represents the object's local scale.
       *
       * @name Object3D#scale
       * @type {Vector3}
       * @default (1,1,1)
       */
      scale: {
        configurable: !0,
        enumerable: !0,
        value: i
      },
      /**
       * Represents the object's model-view matrix.
       *
       * @name Object3D#modelViewMatrix
       * @type {Matrix4}
       */
      modelViewMatrix: {
        value: new qt()
      },
      /**
       * Represents the object's normal matrix.
       *
       * @name Object3D#normalMatrix
       * @type {Matrix3}
       */
      normalMatrix: {
        value: new ot()
      }
    }), this.matrix = new qt(), this.matrixWorld = new qt(), this.matrixAutoUpdate = qn.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldAutoUpdate = qn.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.layers = new P2(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.customDepthMaterial = void 0, this.customDistanceMaterial = void 0, this.userData = {};
  }
  /**
   * A callback that is executed immediately before a 3D object is rendered to a shadow map.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Camera} shadowCamera - The shadow camera.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} depthMaterial - The depth material.
   * @param {Object} group - The geometry group data.
   */
  onBeforeShadow() {
  }
  /**
   * A callback that is executed immediately after a 3D object is rendered to a shadow map.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Camera} shadowCamera - The shadow camera.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} depthMaterial - The depth material.
   * @param {Object} group - The geometry group data.
   */
  onAfterShadow() {
  }
  /**
   * A callback that is executed immediately before a 3D object is rendered.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Object} group - The geometry group data.
   */
  onBeforeRender() {
  }
  /**
   * A callback that is executed immediately after a 3D object is rendered.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Object} group - The geometry group data.
   */
  onAfterRender() {
  }
  /**
   * Applies the given transformation matrix to the object and updates the object's position,
   * rotation and scale.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   */
  applyMatrix4(e) {
    this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(e), this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  /**
   * Applies a rotation represented by given the quaternion to the 3D object.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Object3D} A reference to this instance.
   */
  applyQuaternion(e) {
    return this.quaternion.premultiply(e), this;
  }
  /**
   * Sets the given rotation represented as an axis/angle couple to the 3D object.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   */
  setRotationFromAxisAngle(e, n) {
    this.quaternion.setFromAxisAngle(e, n);
  }
  /**
   * Sets the given rotation represented as Euler angles to the 3D object.
   *
   * @param {Euler} euler - The Euler angles.
   */
  setRotationFromEuler(e) {
    this.quaternion.setFromEuler(e, !0);
  }
  /**
   * Sets the given rotation represented as rotation matrix to the 3D object.
   *
   * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
   * a pure rotation matrix (i.e, unscaled).
   */
  setRotationFromMatrix(e) {
    this.quaternion.setFromRotationMatrix(e);
  }
  /**
   * Sets the given rotation represented as a Quaternion to the 3D object.
   *
   * @param {Quaternion} q - The Quaternion
   */
  setRotationFromQuaternion(e) {
    this.quaternion.copy(e);
  }
  /**
   * Rotates the 3D object along an axis in local space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateOnAxis(e, n) {
    return ua.setFromAxisAngle(e, n), this.quaternion.multiply(ua), this;
  }
  /**
   * Rotates the 3D object along an axis in world space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateOnWorldAxis(e, n) {
    return ua.setFromAxisAngle(e, n), this.quaternion.premultiply(ua), this;
  }
  /**
   * Rotates the 3D object around its X axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateX(e) {
    return this.rotateOnAxis(N4, e);
  }
  /**
   * Rotates the 3D object around its Y axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateY(e) {
    return this.rotateOnAxis(I4, e);
  }
  /**
   * Rotates the 3D object around its Z axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateZ(e) {
    return this.rotateOnAxis(F4, e);
  }
  /**
   * Translate the 3D object by a distance along the given axis in local space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateOnAxis(e, n) {
    return k4.copy(e).applyQuaternion(this.quaternion), this.position.add(k4.multiplyScalar(n)), this;
  }
  /**
   * Translate the 3D object by a distance along its X-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateX(e) {
    return this.translateOnAxis(N4, e);
  }
  /**
   * Translate the 3D object by a distance along its Y-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateY(e) {
    return this.translateOnAxis(I4, e);
  }
  /**
   * Translate the 3D object by a distance along its Z-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateZ(e) {
    return this.translateOnAxis(F4, e);
  }
  /**
   * Converts the given vector from this 3D object's local space to world space.
   *
   * @param {Vector3} vector - The vector to convert.
   * @return {Vector3} The converted vector.
   */
  localToWorld(e) {
    return this.updateWorldMatrix(!0, !1), e.applyMatrix4(this.matrixWorld);
  }
  /**
   * Converts the given vector from this 3D object's word space to local space.
   *
   * @param {Vector3} vector - The vector to convert.
   * @return {Vector3} The converted vector.
   */
  worldToLocal(e) {
    return this.updateWorldMatrix(!0, !1), e.applyMatrix4(Xr.copy(this.matrixWorld).invert());
  }
  /**
   * Rotates the object to face a point in world space.
   *
   * This method does not support objects having non-uniformly-scaled parent(s).
   *
   * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
   * @param {number} [y] - The y coordinate in world space.
   * @param {number} [z] - The z coordinate in world space.
   */
  lookAt(e, n, r) {
    e.isVector3 ? $c.copy(e) : $c.set(e, n, r);
    const i = this.parent;
    this.updateWorldMatrix(!0, !1), Zs.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? Xr.lookAt(Zs, $c, this.up) : Xr.lookAt($c, Zs, this.up), this.quaternion.setFromRotationMatrix(Xr), i && (Xr.extractRotation(i.matrixWorld), ua.setFromRotationMatrix(Xr), this.quaternion.premultiply(ua.invert()));
  }
  /**
   * Adds the given 3D object as a child to this 3D object. An arbitrary number of
   * objects may be added. Any current parent on an object passed in here will be
   * removed, since an object can have at most one parent.
   *
   * @fires Object3D#added
   * @fires Object3D#childadded
   * @param {Object3D} object - The 3D object to add.
   * @return {Object3D} A reference to this instance.
   */
  add(e) {
    if (arguments.length > 1) {
      for (let n = 0; n < arguments.length; n++)
        this.add(arguments[n]);
      return this;
    }
    return e === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", e), this) : (e && e.isObject3D ? (e.removeFromParent(), e.parent = this, this.children.push(e), e.dispatchEvent(U4), da.child = e, this.dispatchEvent(da), da.child = null) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", e), this);
  }
  /**
   * Removes the given 3D object as child from this 3D object.
   * An arbitrary number of objects may be removed.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @param {Object3D} object - The 3D object to remove.
   * @return {Object3D} A reference to this instance.
   */
  remove(e) {
    if (arguments.length > 1) {
      for (let r = 0; r < arguments.length; r++)
        this.remove(arguments[r]);
      return this;
    }
    const n = this.children.indexOf(e);
    return n !== -1 && (e.parent = null, this.children.splice(n, 1), e.dispatchEvent(Mee), w0.child = e, this.dispatchEvent(w0), w0.child = null), this;
  }
  /**
   * Removes this 3D object from its current parent.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @return {Object3D} A reference to this instance.
   */
  removeFromParent() {
    const e = this.parent;
    return e !== null && e.remove(this), this;
  }
  /**
   * Removes all child objects.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @return {Object3D} A reference to this instance.
   */
  clear() {
    return this.remove(...this.children);
  }
  /**
   * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
   * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
   *
   * @fires Object3D#added
   * @fires Object3D#childadded
   * @param {Object3D} object - The 3D object to attach.
   * @return {Object3D} A reference to this instance.
   */
  attach(e) {
    return this.updateWorldMatrix(!0, !1), Xr.copy(this.matrixWorld).invert(), e.parent !== null && (e.parent.updateWorldMatrix(!0, !1), Xr.multiply(e.parent.matrixWorld)), e.applyMatrix4(Xr), e.removeFromParent(), e.parent = this, this.children.push(e), e.updateWorldMatrix(!1, !0), e.dispatchEvent(U4), da.child = e, this.dispatchEvent(da), da.child = null, this;
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching ID.
   *
   * @param {number} id - The id.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectById(e) {
    return this.getObjectByProperty("id", e);
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching name.
   *
   * @param {string} name - The name.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectByName(e) {
    return this.getObjectByProperty("name", e);
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching property value.
   *
   * @param {string} name - The name of the property.
   * @param {any} value - The value.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectByProperty(e, n) {
    if (this[e] === n)
      return this;
    for (let r = 0, i = this.children.length; r < i; r++) {
      const a = this.children[r].getObjectByProperty(e, n);
      if (a !== void 0)
        return a;
    }
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns all 3D objects with a matching property value.
   *
   * @param {string} name - The name of the property.
   * @param {any} value - The value.
   * @param {Array<Object3D>} result - The method stores the result in this array.
   * @return {Array<Object3D>} The found 3D objects.
   */
  getObjectsByProperty(e, n, r = []) {
    this[e] === n && r.push(this);
    const i = this.children;
    for (let o = 0, a = i.length; o < a; o++)
      i[o].getObjectsByProperty(e, n, r);
    return r;
  }
  /**
   * Returns a vector representing the position of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's position in world space.
   */
  getWorldPosition(e) {
    return this.updateWorldMatrix(!0, !1), e.setFromMatrixPosition(this.matrixWorld);
  }
  /**
   * Returns a Quaternion representing the position of the 3D object in world space.
   *
   * @param {Quaternion} target - The target Quaternion the result is stored to.
   * @return {Quaternion} The 3D object's rotation in world space.
   */
  getWorldQuaternion(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Zs, e, Eee), e;
  }
  /**
   * Returns a vector representing the scale of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's scale in world space.
   */
  getWorldScale(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Zs, See, e), e;
  }
  /**
   * Returns a vector representing the ("look") direction of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's direction in world space.
   */
  getWorldDirection(e) {
    this.updateWorldMatrix(!0, !1);
    const n = this.matrixWorld.elements;
    return e.set(n[8], n[9], n[10]).normalize();
  }
  /**
   * Abstract method to get intersections between a casted ray and this
   * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
   * implement this method in order to use raycasting.
   *
   * @abstract
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - An array holding the result of the method.
   */
  raycast() {
  }
  /**
   * Executes the callback on this 3D object and all descendants.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverse(e) {
    e(this);
    const n = this.children;
    for (let r = 0, i = n.length; r < i; r++)
      n[r].traverse(e);
  }
  /**
   * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
   * Descendants of invisible 3D objects are not traversed.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverseVisible(e) {
    if (this.visible === !1)
      return;
    e(this);
    const n = this.children;
    for (let r = 0, i = n.length; r < i; r++)
      n[r].traverseVisible(e);
  }
  /**
   * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverseAncestors(e) {
    const n = this.parent;
    n !== null && (e(n), n.traverseAncestors(e));
  }
  /**
   * Updates the transformation matrix in local space by computing it from the current
   * position, rotation and scale values.
   */
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
  }
  /**
   * Updates the transformation matrix in world space of this 3D objects and its descendants.
   *
   * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
   * local space. The computation of the local and world matrix can be controlled with the
   * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
   * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
   *
   * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
   * when {@link Object3D#matrixWorldAutoUpdate} is set to `false`.
   */
  updateMatrixWorld(e) {
    this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e) && (this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, e = !0);
    const n = this.children;
    for (let r = 0, i = n.length; r < i; r++)
      n[r].updateMatrixWorld(e);
  }
  /**
   * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
   * update of ancestor and descendant nodes.
   *
   * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
   * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
   */
  updateWorldMatrix(e, n) {
    const r = this.parent;
    if (e === !0 && r !== null && r.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), n === !0) {
      const i = this.children;
      for (let o = 0, a = i.length; o < a; o++)
        i[o].updateWorldMatrix(!1, !0);
    }
  }
  /**
   * Serializes the 3D object into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized 3D object.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const n = e === void 0 || typeof e == "string", r = {};
    n && (e = {
      geometries: {},
      materials: {},
      textures: {},
      images: {},
      shapes: {},
      skeletons: {},
      animations: {},
      nodes: {}
    }, r.metadata = {
      version: 4.6,
      type: "Object",
      generator: "Object3D.toJSON"
    });
    const i = {};
    i.uuid = this.uuid, i.type = this.type, this.name !== "" && (i.name = this.name), this.castShadow === !0 && (i.castShadow = !0), this.receiveShadow === !0 && (i.receiveShadow = !0), this.visible === !1 && (i.visible = !1), this.frustumCulled === !1 && (i.frustumCulled = !1), this.renderOrder !== 0 && (i.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (i.userData = this.userData), i.layers = this.layers.mask, i.matrix = this.matrix.toArray(), i.up = this.up.toArray(), this.matrixAutoUpdate === !1 && (i.matrixAutoUpdate = !1), this.isInstancedMesh && (i.type = "InstancedMesh", i.count = this.count, i.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (i.instanceColor = this.instanceColor.toJSON())), this.isBatchedMesh && (i.type = "BatchedMesh", i.perObjectFrustumCulled = this.perObjectFrustumCulled, i.sortObjects = this.sortObjects, i.drawRanges = this._drawRanges, i.reservedRanges = this._reservedRanges, i.visibility = this._visibility, i.active = this._active, i.bounds = this._bounds.map((s) => ({
      boxInitialized: s.boxInitialized,
      boxMin: s.box.min.toArray(),
      boxMax: s.box.max.toArray(),
      sphereInitialized: s.sphereInitialized,
      sphereRadius: s.sphere.radius,
      sphereCenter: s.sphere.center.toArray()
    })), i.maxInstanceCount = this._maxInstanceCount, i.maxVertexCount = this._maxVertexCount, i.maxIndexCount = this._maxIndexCount, i.geometryInitialized = this._geometryInitialized, i.geometryCount = this._geometryCount, i.matricesTexture = this._matricesTexture.toJSON(e), this._colorsTexture !== null && (i.colorsTexture = this._colorsTexture.toJSON(e)), this.boundingSphere !== null && (i.boundingSphere = {
      center: i.boundingSphere.center.toArray(),
      radius: i.boundingSphere.radius
    }), this.boundingBox !== null && (i.boundingBox = {
      min: i.boundingBox.min.toArray(),
      max: i.boundingBox.max.toArray()
    }));
    function o(s, l) {
      return s[l.uuid] === void 0 && (s[l.uuid] = l.toJSON(e)), l.uuid;
    }
    if (this.isScene)
      this.background && (this.background.isColor ? i.background = this.background.toJSON() : this.background.isTexture && (i.background = this.background.toJSON(e).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (i.environment = this.environment.toJSON(e).uuid);
    else if (this.isMesh || this.isLine || this.isPoints) {
      i.geometry = o(e.geometries, this.geometry);
      const s = this.geometry.parameters;
      if (s !== void 0 && s.shapes !== void 0) {
        const l = s.shapes;
        if (Array.isArray(l))
          for (let c = 0, u = l.length; c < u; c++) {
            const d = l[c];
            o(e.shapes, d);
          }
        else
          o(e.shapes, l);
      }
    }
    if (this.isSkinnedMesh && (i.bindMode = this.bindMode, i.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (o(e.skeletons, this.skeleton), i.skeleton = this.skeleton.uuid)), this.material !== void 0)
      if (Array.isArray(this.material)) {
        const s = [];
        for (let l = 0, c = this.material.length; l < c; l++)
          s.push(o(e.materials, this.material[l]));
        i.material = s;
      } else
        i.material = o(e.materials, this.material);
    if (this.children.length > 0) {
      i.children = [];
      for (let s = 0; s < this.children.length; s++)
        i.children.push(this.children[s].toJSON(e).object);
    }
    if (this.animations.length > 0) {
      i.animations = [];
      for (let s = 0; s < this.animations.length; s++) {
        const l = this.animations[s];
        i.animations.push(o(e.animations, l));
      }
    }
    if (n) {
      const s = a(e.geometries), l = a(e.materials), c = a(e.textures), u = a(e.images), d = a(e.shapes), f = a(e.skeletons), h = a(e.animations), v = a(e.nodes);
      s.length > 0 && (r.geometries = s), l.length > 0 && (r.materials = l), c.length > 0 && (r.textures = c), u.length > 0 && (r.images = u), d.length > 0 && (r.shapes = d), f.length > 0 && (r.skeletons = f), h.length > 0 && (r.animations = h), v.length > 0 && (r.nodes = v);
    }
    return r.object = i, r;
    function a(s) {
      const l = [];
      for (const c in s) {
        const u = s[c];
        delete u.metadata, l.push(u);
      }
      return l;
    }
  }
  /**
   * Returns a new 3D object with copied values from this instance.
   *
   * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
   * @return {Object3D} A clone of this instance.
   */
  clone(e) {
    return new this.constructor().copy(this, e);
  }
  /**
   * Copies the values of the given 3D object to this instance.
   *
   * @param {Object3D} source - The 3D object to copy.
   * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
   * @return {Object3D} A reference to this instance.
   */
  copy(e, n = !0) {
    if (this.name = e.name, this.up.copy(e.up), this.position.copy(e.position), this.rotation.order = e.rotation.order, this.quaternion.copy(e.quaternion), this.scale.copy(e.scale), this.matrix.copy(e.matrix), this.matrixWorld.copy(e.matrixWorld), this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrixWorldAutoUpdate = e.matrixWorldAutoUpdate, this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate, this.layers.mask = e.layers.mask, this.visible = e.visible, this.castShadow = e.castShadow, this.receiveShadow = e.receiveShadow, this.frustumCulled = e.frustumCulled, this.renderOrder = e.renderOrder, this.animations = e.animations.slice(), this.userData = JSON.parse(JSON.stringify(e.userData)), n === !0)
      for (let r = 0; r < e.children.length; r++) {
        const i = e.children[r];
        this.add(i.clone());
      }
    return this;
  }
}
qn.DEFAULT_UP = /* @__PURE__ */ new re(0, 1, 0);
qn.DEFAULT_MATRIX_AUTO_UPDATE = !0;
qn.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
const hr = /* @__PURE__ */ new re(), Yr = /* @__PURE__ */ new re(), _0 = /* @__PURE__ */ new re(), Zr = /* @__PURE__ */ new re(), fa = /* @__PURE__ */ new re(), ha = /* @__PURE__ */ new re(), z4 = /* @__PURE__ */ new re(), C0 = /* @__PURE__ */ new re(), E0 = /* @__PURE__ */ new re(), S0 = /* @__PURE__ */ new re(), M0 = /* @__PURE__ */ new Yt(), T0 = /* @__PURE__ */ new Yt(), A0 = /* @__PURE__ */ new Yt();
class vr {
  /**
   * Constructs a new triangle.
   *
   * @param {Vector3} [a=(0,0,0)] - The first corner of the triangle.
   * @param {Vector3} [b=(0,0,0)] - The second corner of the triangle.
   * @param {Vector3} [c=(0,0,0)] - The third corner of the triangle.
   */
  constructor(e = new re(), n = new re(), r = new re()) {
    this.a = e, this.b = n, this.c = r;
  }
  /**
   * Computes the normal vector of a triangle.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's normal.
   */
  static getNormal(e, n, r, i) {
    i.subVectors(r, n), hr.subVectors(e, n), i.cross(hr);
    const o = i.lengthSq();
    return o > 0 ? i.multiplyScalar(1 / Math.sqrt(o)) : i.set(0, 0, 0);
  }
  /**
   * Computes a barycentric coordinates from the given vector.
   * Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The barycentric coordinates for the given point
   */
  static getBarycoord(e, n, r, i, o) {
    hr.subVectors(i, n), Yr.subVectors(r, n), _0.subVectors(e, n);
    const a = hr.dot(hr), s = hr.dot(Yr), l = hr.dot(_0), c = Yr.dot(Yr), u = Yr.dot(_0), d = a * c - s * s;
    if (d === 0)
      return o.set(0, 0, 0), null;
    const f = 1 / d, h = (c * l - s * u) * f, v = (a * u - s * l) * f;
    return o.set(1 - h - v, v, h);
  }
  /**
   * Returns `true` if the given point, when projected onto the plane of the
   * triangle, lies within the triangle.
   *
   * @param {Vector3} point - The point in 3D space to test.
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @return {boolean} Whether the given point, when projected onto the plane of the
   * triangle, lies within the triangle or not.
   */
  static containsPoint(e, n, r, i) {
    return this.getBarycoord(e, n, r, i, Zr) === null ? !1 : Zr.x >= 0 && Zr.y >= 0 && Zr.x + Zr.y <= 1;
  }
  /**
   * Computes the value barycentrically interpolated for the given point on the
   * triangle. Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - Position of interpolated point.
   * @param {Vector3} p1 - The first corner of the triangle.
   * @param {Vector3} p2 - The second corner of the triangle.
   * @param {Vector3} p3 - The third corner of the triangle.
   * @param {Vector3} v1 - Value to interpolate of first vertex.
   * @param {Vector3} v2 - Value to interpolate of second vertex.
   * @param {Vector3} v3 - Value to interpolate of third vertex.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The interpolated value.
   */
  static getInterpolation(e, n, r, i, o, a, s, l) {
    return this.getBarycoord(e, n, r, i, Zr) === null ? (l.x = 0, l.y = 0, "z" in l && (l.z = 0), "w" in l && (l.w = 0), null) : (l.setScalar(0), l.addScaledVector(o, Zr.x), l.addScaledVector(a, Zr.y), l.addScaledVector(s, Zr.z), l);
  }
  /**
   * Computes the value barycentrically interpolated for the given attribute and indices.
   *
   * @param {BufferAttribute} attr - The attribute to interpolate.
   * @param {number} i1 - Index of first vertex.
   * @param {number} i2 - Index of second vertex.
   * @param {number} i3 - Index of third vertex.
   * @param {Vector3} barycoord - The barycoordinate value to use to interpolate.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The interpolated attribute value.
   */
  static getInterpolatedAttribute(e, n, r, i, o, a) {
    return M0.setScalar(0), T0.setScalar(0), A0.setScalar(0), M0.fromBufferAttribute(e, n), T0.fromBufferAttribute(e, r), A0.fromBufferAttribute(e, i), a.setScalar(0), a.addScaledVector(M0, o.x), a.addScaledVector(T0, o.y), a.addScaledVector(A0, o.z), a;
  }
  /**
   * Returns `true` if the triangle is oriented towards the given direction.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} direction - The (normalized) direction vector.
   * @return {boolean} Whether the triangle is oriented towards the given direction or not.
   */
  static isFrontFacing(e, n, r, i) {
    return hr.subVectors(r, n), Yr.subVectors(e, n), hr.cross(Yr).dot(i) < 0;
  }
  /**
   * Sets the triangle's vertices by copying the given values.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */
  set(e, n, r) {
    return this.a.copy(e), this.b.copy(n), this.c.copy(r), this;
  }
  /**
   * Sets the triangle's vertices by copying the given array values.
   *
   * @param {Array<Vector3>} points - An array with 3D points.
   * @param {number} i0 - The array index representing the first corner of the triangle.
   * @param {number} i1 - The array index representing the second corner of the triangle.
   * @param {number} i2 - The array index representing the third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */
  setFromPointsAndIndices(e, n, r, i) {
    return this.a.copy(e[n]), this.b.copy(e[r]), this.c.copy(e[i]), this;
  }
  /**
   * Sets the triangle's vertices by copying the given attribute values.
   *
   * @param {BufferAttribute} attribute - A buffer attribute with 3D points data.
   * @param {number} i0 - The attribute index representing the first corner of the triangle.
   * @param {number} i1 - The attribute index representing the second corner of the triangle.
   * @param {number} i2 - The attribute index representing the third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */
  setFromAttributeAndIndices(e, n, r, i) {
    return this.a.fromBufferAttribute(e, n), this.b.fromBufferAttribute(e, r), this.c.fromBufferAttribute(e, i), this;
  }
  /**
   * Returns a new triangle with copied values from this instance.
   *
   * @return {Triangle} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given triangle to this instance.
   *
   * @param {Triangle} triangle - The triangle to copy.
   * @return {Triangle} A reference to this triangle.
   */
  copy(e) {
    return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this;
  }
  /**
   * Computes the area of the triangle.
   *
   * @return {number} The triangle's area.
   */
  getArea() {
    return hr.subVectors(this.c, this.b), Yr.subVectors(this.a, this.b), hr.cross(Yr).length() * 0.5;
  }
  /**
   * Computes the midpoint of the triangle.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's midpoint.
   */
  getMidpoint(e) {
    return e.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
  }
  /**
   * Computes the normal of the triangle.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's normal.
   */
  getNormal(e) {
    return vr.getNormal(this.a, this.b, this.c, e);
  }
  /**
   * Computes a plane the triangle lies within.
   *
   * @param {Plane} target - The target vector that is used to store the method's result.
   * @return {Plane} The plane the triangle lies within.
   */
  getPlane(e) {
    return e.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  /**
   * Computes a barycentric coordinates from the given vector.
   * Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The barycentric coordinates for the given point
   */
  getBarycoord(e, n) {
    return vr.getBarycoord(e, this.a, this.b, this.c, n);
  }
  /**
   * Computes the value barycentrically interpolated for the given point on the
   * triangle. Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - Position of interpolated point.
   * @param {Vector3} v1 - Value to interpolate of first vertex.
   * @param {Vector3} v2 - Value to interpolate of second vertex.
   * @param {Vector3} v3 - Value to interpolate of third vertex.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The interpolated value.
   */
  getInterpolation(e, n, r, i, o) {
    return vr.getInterpolation(e, this.a, this.b, this.c, n, r, i, o);
  }
  /**
   * Returns `true` if the given point, when projected onto the plane of the
   * triangle, lies within the triangle.
   *
   * @param {Vector3} point - The point in 3D space to test.
   * @return {boolean} Whether the given point, when projected onto the plane of the
   * triangle, lies within the triangle or not.
   */
  containsPoint(e) {
    return vr.containsPoint(e, this.a, this.b, this.c);
  }
  /**
   * Returns `true` if the triangle is oriented towards the given direction.
   *
   * @param {Vector3} direction - The (normalized) direction vector.
   * @return {boolean} Whether the triangle is oriented towards the given direction or not.
   */
  isFrontFacing(e) {
    return vr.isFrontFacing(this.a, this.b, this.c, e);
  }
  /**
   * Returns `true` if this triangle intersects with the given box.
   *
   * @param {Box3} box - The box to intersect.
   * @return {boolean} Whether this triangle intersects with the given box or not.
   */
  intersectsBox(e) {
    return e.intersectsTriangle(this);
  }
  /**
   * Returns the closest point on the triangle to the given point.
   *
   * @param {Vector3} p - The point to compute the closest point for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The closest point on the triangle.
   */
  closestPointToPoint(e, n) {
    const r = this.a, i = this.b, o = this.c;
    let a, s;
    fa.subVectors(i, r), ha.subVectors(o, r), C0.subVectors(e, r);
    const l = fa.dot(C0), c = ha.dot(C0);
    if (l <= 0 && c <= 0)
      return n.copy(r);
    E0.subVectors(e, i);
    const u = fa.dot(E0), d = ha.dot(E0);
    if (u >= 0 && d <= u)
      return n.copy(i);
    const f = l * d - u * c;
    if (f <= 0 && l >= 0 && u <= 0)
      return a = l / (l - u), n.copy(r).addScaledVector(fa, a);
    S0.subVectors(e, o);
    const h = fa.dot(S0), v = ha.dot(S0);
    if (v >= 0 && h <= v)
      return n.copy(o);
    const g = h * c - l * v;
    if (g <= 0 && c >= 0 && v <= 0)
      return s = c / (c - v), n.copy(r).addScaledVector(ha, s);
    const m = u * v - h * d;
    if (m <= 0 && d - u >= 0 && h - v >= 0)
      return z4.subVectors(o, i), s = (d - u) / (d - u + (h - v)), n.copy(i).addScaledVector(z4, s);
    const p = 1 / (m + g + f);
    return a = g * p, s = f * p, n.copy(r).addScaledVector(fa, a).addScaledVector(ha, s);
  }
  /**
   * Returns `true` if this triangle is equal with the given one.
   *
   * @param {Triangle} triangle - The triangle to test for equality.
   * @return {boolean} Whether this triangle is equal with the given one.
   */
  equals(e) {
    return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
  }
}
const N9 = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
}, Ti = { h: 0, s: 0, l: 0 }, Wc = { h: 0, s: 0, l: 0 };
function P0(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * 6 * (2 / 3 - n) : t;
}
class At {
  /**
   * Constructs a new color.
   *
   * Note that standard method of specifying color in three.js is with a hexadecimal triplet,
   * and that method is used throughout the rest of the documentation.
   *
   * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
   * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
   * @param {number} [g] - The green component.
   * @param {number} [b] - The blue component.
   */
  constructor(e, n, r) {
    return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(e, n, r);
  }
  /**
   * Sets the colors's components from the given values.
   *
   * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
   * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
   * @param {number} [g] - The green component.
   * @param {number} [b] - The blue component.
   * @return {Color} A reference to this color.
   */
  set(e, n, r) {
    if (n === void 0 && r === void 0) {
      const i = e;
      i && i.isColor ? this.copy(i) : typeof i == "number" ? this.setHex(i) : typeof i == "string" && this.setStyle(i);
    } else
      this.setRGB(e, n, r);
    return this;
  }
  /**
   * Sets the colors's components to the given scalar value.
   *
   * @param {number} scalar - The scalar value.
   * @return {Color} A reference to this color.
   */
  setScalar(e) {
    return this.r = e, this.g = e, this.b = e, this;
  }
  /**
   * Sets this color from a hexadecimal value.
   *
   * @param {number} hex - The hexadecimal value.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setHex(e, n = er) {
    return e = Math.floor(e), this.r = (e >> 16 & 255) / 255, this.g = (e >> 8 & 255) / 255, this.b = (e & 255) / 255, mt.toWorkingColorSpace(this, n), this;
  }
  /**
   * Sets this color from RGB values.
   *
   * @param {number} r - Red channel value between `0.0` and `1.0`.
   * @param {number} g - Green channel value between `0.0` and `1.0`.
   * @param {number} b - Blue channel value between `0.0` and `1.0`.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setRGB(e, n, r, i = mt.workingColorSpace) {
    return this.r = e, this.g = n, this.b = r, mt.toWorkingColorSpace(this, i), this;
  }
  /**
   * Sets this color from RGB values.
   *
   * @param {number} h - Hue value between `0.0` and `1.0`.
   * @param {number} s - Saturation value between `0.0` and `1.0`.
   * @param {number} l - Lightness value between `0.0` and `1.0`.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setHSL(e, n, r, i = mt.workingColorSpace) {
    if (e = M2(e, 1), n = dt(n, 0, 1), r = dt(r, 0, 1), n === 0)
      this.r = this.g = this.b = r;
    else {
      const o = r <= 0.5 ? r * (1 + n) : r + n - r * n, a = 2 * r - o;
      this.r = P0(a, o, e + 1 / 3), this.g = P0(a, o, e), this.b = P0(a, o, e - 1 / 3);
    }
    return mt.toWorkingColorSpace(this, i), this;
  }
  /**
   * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
   * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
   * any [X11 color name]{@link https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart} -
   * all 140 color names are supported).
   *
   * @param {string} style - Color as a CSS-style string.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setStyle(e, n = er) {
    function r(o) {
      o !== void 0 && parseFloat(o) < 1 && console.warn("THREE.Color: Alpha component of " + e + " will be ignored.");
    }
    let i;
    if (i = /^(\w+)\(([^\)]*)\)/.exec(e)) {
      let o;
      const a = i[1], s = i[2];
      switch (a) {
        case "rgb":
        case "rgba":
          if (o = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s))
            return r(o[4]), this.setRGB(
              Math.min(255, parseInt(o[1], 10)) / 255,
              Math.min(255, parseInt(o[2], 10)) / 255,
              Math.min(255, parseInt(o[3], 10)) / 255,
              n
            );
          if (o = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s))
            return r(o[4]), this.setRGB(
              Math.min(100, parseInt(o[1], 10)) / 100,
              Math.min(100, parseInt(o[2], 10)) / 100,
              Math.min(100, parseInt(o[3], 10)) / 100,
              n
            );
          break;
        case "hsl":
        case "hsla":
          if (o = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s))
            return r(o[4]), this.setHSL(
              parseFloat(o[1]) / 360,
              parseFloat(o[2]) / 100,
              parseFloat(o[3]) / 100,
              n
            );
          break;
        default:
          console.warn("THREE.Color: Unknown color model " + e);
      }
    } else if (i = /^\#([A-Fa-f\d]+)$/.exec(e)) {
      const o = i[1], a = o.length;
      if (a === 3)
        return this.setRGB(
          parseInt(o.charAt(0), 16) / 15,
          parseInt(o.charAt(1), 16) / 15,
          parseInt(o.charAt(2), 16) / 15,
          n
        );
      if (a === 6)
        return this.setHex(parseInt(o, 16), n);
      console.warn("THREE.Color: Invalid hex color " + e);
    } else if (e && e.length > 0)
      return this.setColorName(e, n);
    return this;
  }
  /**
   * Sets this color from a color name. Faster than {@link Color#setStyle} if
   * you don't need the other CSS-style formats.
   *
   * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
   * ```js
   * Color.NAMES.aliceblue // returns 0xF0F8FF
   * ```
   *
   * @param {string} style - The color name.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setColorName(e, n = er) {
    const r = N9[e.toLowerCase()];
    return r !== void 0 ? this.setHex(r, n) : console.warn("THREE.Color: Unknown color " + e), this;
  }
  /**
   * Returns a new color with copied values from this instance.
   *
   * @return {Color} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  /**
   * Copies the values of the given color to this instance.
   *
   * @param {Color} color - The color to copy.
   * @return {Color} A reference to this color.
   */
  copy(e) {
    return this.r = e.r, this.g = e.g, this.b = e.b, this;
  }
  /**
   * Copies the given color into this color, and then converts this color from
   * `SRGBColorSpace` to `LinearSRGBColorSpace`.
   *
   * @param {Color} color - The color to copy/convert.
   * @return {Color} A reference to this color.
   */
  copySRGBToLinear(e) {
    return this.r = ai(e.r), this.g = ai(e.g), this.b = ai(e.b), this;
  }
  /**
   * Copies the given color into this color, and then converts this color from
   * `LinearSRGBColorSpace` to `SRGBColorSpace`.
   *
   * @param {Color} color - The color to copy/convert.
   * @return {Color} A reference to this color.
   */
  copyLinearToSRGB(e) {
    return this.r = Ka(e.r), this.g = Ka(e.g), this.b = Ka(e.b), this;
  }
  /**
   * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
   *
   * @return {Color} A reference to this color.
   */
  convertSRGBToLinear() {
    return this.copySRGBToLinear(this), this;
  }
  /**
   * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
   *
   * @return {Color} A reference to this color.
   */
  convertLinearToSRGB() {
    return this.copyLinearToSRGB(this), this;
  }
  /**
   * Returns the hexadecimal value of this color.
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {number} The hexadecimal value.
   */
  getHex(e = er) {
    return mt.fromWorkingColorSpace(yn.copy(this), e), Math.round(dt(yn.r * 255, 0, 255)) * 65536 + Math.round(dt(yn.g * 255, 0, 255)) * 256 + Math.round(dt(yn.b * 255, 0, 255));
  }
  /**
   * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {string} The hexadecimal value as a string.
   */
  getHexString(e = er) {
    return ("000000" + this.getHex(e).toString(16)).slice(-6);
  }
  /**
   * Converts the colors RGB values into the HSL format and stores them into the
   * given target object.
   *
   * @param {{h:number,s:number,l:number}} target - The target object that is used to store the method's result.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {{h:number,s:number,l:number}} The HSL representation of this color.
   */
  getHSL(e, n = mt.workingColorSpace) {
    mt.fromWorkingColorSpace(yn.copy(this), n);
    const r = yn.r, i = yn.g, o = yn.b, a = Math.max(r, i, o), s = Math.min(r, i, o);
    let l, c;
    const u = (s + a) / 2;
    if (s === a)
      l = 0, c = 0;
    else {
      const d = a - s;
      switch (c = u <= 0.5 ? d / (a + s) : d / (2 - a - s), a) {
        case r:
          l = (i - o) / d + (i < o ? 6 : 0);
          break;
        case i:
          l = (o - r) / d + 2;
          break;
        case o:
          l = (r - i) / d + 4;
          break;
      }
      l /= 6;
    }
    return e.h = l, e.s = c, e.l = u, e;
  }
  /**
   * Returns the RGB values of this color and stores them into the given target object.
   *
   * @param {Color} target - The target color that is used to store the method's result.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} The RGB representation of this color.
   */
  getRGB(e, n = mt.workingColorSpace) {
    return mt.fromWorkingColorSpace(yn.copy(this), n), e.r = yn.r, e.g = yn.g, e.b = yn.b, e;
  }
  /**
   * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {string} The CSS representation of this color.
   */
  getStyle(e = er) {
    mt.fromWorkingColorSpace(yn.copy(this), e);
    const n = yn.r, r = yn.g, i = yn.b;
    return e !== er ? `color(${e} ${n.toFixed(3)} ${r.toFixed(3)} ${i.toFixed(3)})` : `rgb(${Math.round(n * 255)},${Math.round(r * 255)},${Math.round(i * 255)})`;
  }
  /**
   * Adds the given HSL values to this color's values.
   * Internally, this converts the color's RGB values to HSL, adds HSL
   * and then converts the color back to RGB.
   *
   * @param {number} h - Hue value between `0.0` and `1.0`.
   * @param {number} s - Saturation value between `0.0` and `1.0`.
   * @param {number} l - Lightness value between `0.0` and `1.0`.
   * @return {Color} A reference to this color.
   */
  offsetHSL(e, n, r) {
    return this.getHSL(Ti), this.setHSL(Ti.h + e, Ti.s + n, Ti.l + r);
  }
  /**
   * Adds the RGB values of the given color to the RGB values of this color.
   *
   * @param {Color} color - The color to add.
   * @return {Color} A reference to this color.
   */
  add(e) {
    return this.r += e.r, this.g += e.g, this.b += e.b, this;
  }
  /**
   * Adds the RGB values of the given colors and stores the result in this instance.
   *
   * @param {Color} color1 - The first color.
   * @param {Color} color2 - The second color.
   * @return {Color} A reference to this color.
   */
  addColors(e, n) {
    return this.r = e.r + n.r, this.g = e.g + n.g, this.b = e.b + n.b, this;
  }
  /**
   * Adds the given scalar value to the RGB values of this color.
   *
   * @param {number} s - The scalar to add.
   * @return {Color} A reference to this color.
   */
  addScalar(e) {
    return this.r += e, this.g += e, this.b += e, this;
  }
  /**
   * Subtracts the RGB values of the given color from the RGB values of this color.
   *
   * @param {Color} color - The color to subtract.
   * @return {Color} A reference to this color.
   */
  sub(e) {
    return this.r = Math.max(0, this.r - e.r), this.g = Math.max(0, this.g - e.g), this.b = Math.max(0, this.b - e.b), this;
  }
  /**
   * Multiplies the RGB values of the given color with the RGB values of this color.
   *
   * @param {Color} color - The color to multiply.
   * @return {Color} A reference to this color.
   */
  multiply(e) {
    return this.r *= e.r, this.g *= e.g, this.b *= e.b, this;
  }
  /**
   * Multiplies the given scalar value with the RGB values of this color.
   *
   * @param {number} s - The scalar to multiply.
   * @return {Color} A reference to this color.
   */
  multiplyScalar(e) {
    return this.r *= e, this.g *= e, this.b *= e, this;
  }
  /**
   * Linearly interpolates this color's RGB values toward the RGB values of the
   * given color. The alpha argument can be thought of as the ratio between
   * the two colors, where `0.0` is this color and `1.0` is the first argument.
   *
   * @param {Color} color - The color to converge on.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerp(e, n) {
    return this.r += (e.r - this.r) * n, this.g += (e.g - this.g) * n, this.b += (e.b - this.b) * n, this;
  }
  /**
   * Linearly interpolates between the given colors and stores the result in this instance.
   * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
   * is the first and `1.0` is the second color.
   *
   * @param {Color} color1 - The first color.
   * @param {Color} color2 - The second color.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerpColors(e, n, r) {
    return this.r = e.r + (n.r - e.r) * r, this.g = e.g + (n.g - e.g) * r, this.b = e.b + (n.b - e.b) * r, this;
  }
  /**
   * Linearly interpolates this color's HSL values toward the HSL values of the
   * given color. It differs from {@link Color#lerp} by not interpolating straight
   * from one color to the other, but instead going through all the hues in between
   * those two colors. The alpha argument can be thought of as the ratio between
   * the two colors, where 0.0 is this color and 1.0 is the first argument.
   *
   * @param {Color} color - The color to converge on.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerpHSL(e, n) {
    this.getHSL(Ti), e.getHSL(Wc);
    const r = ml(Ti.h, Wc.h, n), i = ml(Ti.s, Wc.s, n), o = ml(Ti.l, Wc.l, n);
    return this.setHSL(r, i, o), this;
  }
  /**
   * Sets the color's RGB components from the given 3D vector.
   *
   * @param {Vector3} v - The vector to set.
   * @return {Color} A reference to this color.
   */
  setFromVector3(e) {
    return this.r = e.x, this.g = e.y, this.b = e.z, this;
  }
  /**
   * Transforms this color with the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix.
   * @return {Color} A reference to this color.
   */
  applyMatrix3(e) {
    const n = this.r, r = this.g, i = this.b, o = e.elements;
    return this.r = o[0] * n + o[3] * r + o[6] * i, this.g = o[1] * n + o[4] * r + o[7] * i, this.b = o[2] * n + o[5] * r + o[8] * i, this;
  }
  /**
   * Returns `true` if this color is equal with the given one.
   *
   * @param {Color} c - The color to test for equality.
   * @return {boolean} Whether this bounding color is equal with the given one.
   */
  equals(e) {
    return e.r === this.r && e.g === this.g && e.b === this.b;
  }
  /**
   * Sets this color's RGB components from the given array.
   *
   * @param {Array<number>} array - An array holding the RGB values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Color} A reference to this color.
   */
  fromArray(e, n = 0) {
    return this.r = e[n], this.g = e[n + 1], this.b = e[n + 2], this;
  }
  /**
   * Writes the RGB components of this color to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the color components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The color components.
   */
  toArray(e = [], n = 0) {
    return e[n] = this.r, e[n + 1] = this.g, e[n + 2] = this.b, e;
  }
  /**
   * Sets the components of this color from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding color data.
   * @param {number} index - The index into the attribute.
   * @return {Color} A reference to this color.
   */
  fromBufferAttribute(e, n) {
    return this.r = e.getX(n), this.g = e.getY(n), this.b = e.getZ(n), this;
  }
  /**
   * This methods defines the serialization result of this class. Returns the color
   * as a hexadecimal value.
   *
   * @return {number} The hexadecimal value.
   */
  toJSON() {
    return this.getHex();
  }
  *[Symbol.iterator]() {
    yield this.r, yield this.g, yield this.b;
  }
}
const yn = /* @__PURE__ */ new At();
At.NAMES = N9;
let Tee = 0;
class Zd extends As {
  /**
   * Constructs a new material.
   */
  constructor() {
    super(), this.isMaterial = !0, Object.defineProperty(this, "id", { value: Tee++ }), this.uuid = Ps(), this.name = "", this.type = "Material", this.blending = Za, this.side = Ji, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = Nh, this.blendDst = Ih, this.blendEquation = So, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new At(0, 0, 0), this.blendAlpha = 0, this.depthFunc = ts, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = E4, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = ia, this.stencilZFail = ia, this.stencilZPass = ia, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.allowOverride = !0, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
  }
  /**
   * Sets the alpha value to be used when running an alpha test. The material
   * will not be rendered if the opacity is lower than this value.
   *
   * @type {number}
   * @readonly
   * @default 0
   */
  get alphaTest() {
    return this._alphaTest;
  }
  set alphaTest(e) {
    this._alphaTest > 0 != e > 0 && this.version++, this._alphaTest = e;
  }
  /**
   * An optional callback that is executed immediately before the material is used to render a 3D object.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Scene} scene - The scene.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Object3D} object - The 3D object.
   * @param {Object} group - The geometry group data.
   */
  onBeforeRender() {
  }
  /**
   * An optional callback that is executed immediately before the shader
   * program is compiled. This function is called with the shader source code
   * as a parameter. Useful for the modification of built-in materials.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}. The
   * recommended approach when customizing materials is to use `WebGPURenderer` with the new
   * Node Material system and [TSL]{@link https://github.com/mrdoob/three.js/wiki/Three.js-Shading-Language}.
   *
   * @param {{vertexShader:string,fragmentShader:string,uniforms:Object}} shaderobject - The object holds the uniforms and the vertex and fragment shader source.
   * @param {WebGLRenderer} renderer - A reference to the renderer.
   */
  onBeforeCompile() {
  }
  /**
   * In case {@link Material#onBeforeCompile} is used, this callback can be used to identify
   * values of settings used in `onBeforeCompile()`, so three.js can reuse a cached
   * shader or recompile the shader for this material as needed.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}.
   *
   * @return {string} The custom program cache key.
   */
  customProgramCacheKey() {
    return this.onBeforeCompile.toString();
  }
  /**
   * This method can be used to set default values from parameter objects.
   * It is a generic implementation so it can be used with different types
   * of materials.
   *
   * @param {Object} [values] - The material values to set.
   */
  setValues(e) {
    if (e !== void 0)
      for (const n in e) {
        const r = e[n];
        if (r === void 0) {
          console.warn(`THREE.Material: parameter '${n}' has value of undefined.`);
          continue;
        }
        const i = this[n];
        if (i === void 0) {
          console.warn(`THREE.Material: '${n}' is not a property of THREE.${this.type}.`);
          continue;
        }
        i && i.isColor ? i.set(r) : i && i.isVector3 && r && r.isVector3 ? i.copy(r) : this[n] = r;
      }
  }
  /**
   * Serializes the material into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized material.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const n = e === void 0 || typeof e == "string";
    n && (e = {
      textures: {},
      images: {}
    });
    const r = {
      metadata: {
        version: 4.6,
        type: "Material",
        generator: "Material.toJSON"
      }
    };
    r.uuid = this.uuid, r.type = this.type, this.name !== "" && (r.name = this.name), this.color && this.color.isColor && (r.color = this.color.getHex()), this.roughness !== void 0 && (r.roughness = this.roughness), this.metalness !== void 0 && (r.metalness = this.metalness), this.sheen !== void 0 && (r.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (r.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (r.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (r.emissive = this.emissive.getHex()), this.emissiveIntensity !== void 0 && this.emissiveIntensity !== 1 && (r.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (r.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (r.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (r.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (r.shininess = this.shininess), this.clearcoat !== void 0 && (r.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (r.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (r.clearcoatMap = this.clearcoatMap.toJSON(e).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (r.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (r.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid, r.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.dispersion !== void 0 && (r.dispersion = this.dispersion), this.iridescence !== void 0 && (r.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (r.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (r.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (r.iridescenceMap = this.iridescenceMap.toJSON(e).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (r.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e).uuid), this.anisotropy !== void 0 && (r.anisotropy = this.anisotropy), this.anisotropyRotation !== void 0 && (r.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (r.anisotropyMap = this.anisotropyMap.toJSON(e).uuid), this.map && this.map.isTexture && (r.map = this.map.toJSON(e).uuid), this.matcap && this.matcap.isTexture && (r.matcap = this.matcap.toJSON(e).uuid), this.alphaMap && this.alphaMap.isTexture && (r.alphaMap = this.alphaMap.toJSON(e).uuid), this.lightMap && this.lightMap.isTexture && (r.lightMap = this.lightMap.toJSON(e).uuid, r.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (r.aoMap = this.aoMap.toJSON(e).uuid, r.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (r.bumpMap = this.bumpMap.toJSON(e).uuid, r.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (r.normalMap = this.normalMap.toJSON(e).uuid, r.normalMapType = this.normalMapType, r.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (r.displacementMap = this.displacementMap.toJSON(e).uuid, r.displacementScale = this.displacementScale, r.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (r.roughnessMap = this.roughnessMap.toJSON(e).uuid), this.metalnessMap && this.metalnessMap.isTexture && (r.metalnessMap = this.metalnessMap.toJSON(e).uuid), this.emissiveMap && this.emissiveMap.isTexture && (r.emissiveMap = this.emissiveMap.toJSON(e).uuid), this.specularMap && this.specularMap.isTexture && (r.specularMap = this.specularMap.toJSON(e).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (r.specularIntensityMap = this.specularIntensityMap.toJSON(e).uuid), this.specularColorMap && this.specularColorMap.isTexture && (r.specularColorMap = this.specularColorMap.toJSON(e).uuid), this.envMap && this.envMap.isTexture && (r.envMap = this.envMap.toJSON(e).uuid, this.combine !== void 0 && (r.combine = this.combine)), this.envMapRotation !== void 0 && (r.envMapRotation = this.envMapRotation.toArray()), this.envMapIntensity !== void 0 && (r.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (r.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (r.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (r.gradientMap = this.gradientMap.toJSON(e).uuid), this.transmission !== void 0 && (r.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (r.transmissionMap = this.transmissionMap.toJSON(e).uuid), this.thickness !== void 0 && (r.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (r.thicknessMap = this.thicknessMap.toJSON(e).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== 1 / 0 && (r.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (r.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (r.size = this.size), this.shadowSide !== null && (r.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (r.sizeAttenuation = this.sizeAttenuation), this.blending !== Za && (r.blending = this.blending), this.side !== Ji && (r.side = this.side), this.vertexColors === !0 && (r.vertexColors = !0), this.opacity < 1 && (r.opacity = this.opacity), this.transparent === !0 && (r.transparent = !0), this.blendSrc !== Nh && (r.blendSrc = this.blendSrc), this.blendDst !== Ih && (r.blendDst = this.blendDst), this.blendEquation !== So && (r.blendEquation = this.blendEquation), this.blendSrcAlpha !== null && (r.blendSrcAlpha = this.blendSrcAlpha), this.blendDstAlpha !== null && (r.blendDstAlpha = this.blendDstAlpha), this.blendEquationAlpha !== null && (r.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (r.blendColor = this.blendColor.getHex()), this.blendAlpha !== 0 && (r.blendAlpha = this.blendAlpha), this.depthFunc !== ts && (r.depthFunc = this.depthFunc), this.depthTest === !1 && (r.depthTest = this.depthTest), this.depthWrite === !1 && (r.depthWrite = this.depthWrite), this.colorWrite === !1 && (r.colorWrite = this.colorWrite), this.stencilWriteMask !== 255 && (r.stencilWriteMask = this.stencilWriteMask), this.stencilFunc !== E4 && (r.stencilFunc = this.stencilFunc), this.stencilRef !== 0 && (r.stencilRef = this.stencilRef), this.stencilFuncMask !== 255 && (r.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== ia && (r.stencilFail = this.stencilFail), this.stencilZFail !== ia && (r.stencilZFail = this.stencilZFail), this.stencilZPass !== ia && (r.stencilZPass = this.stencilZPass), this.stencilWrite === !0 && (r.stencilWrite = this.stencilWrite), this.rotation !== void 0 && this.rotation !== 0 && (r.rotation = this.rotation), this.polygonOffset === !0 && (r.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (r.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (r.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (r.linewidth = this.linewidth), this.dashSize !== void 0 && (r.dashSize = this.dashSize), this.gapSize !== void 0 && (r.gapSize = this.gapSize), this.scale !== void 0 && (r.scale = this.scale), this.dithering === !0 && (r.dithering = !0), this.alphaTest > 0 && (r.alphaTest = this.alphaTest), this.alphaHash === !0 && (r.alphaHash = !0), this.alphaToCoverage === !0 && (r.alphaToCoverage = !0), this.premultipliedAlpha === !0 && (r.premultipliedAlpha = !0), this.forceSinglePass === !0 && (r.forceSinglePass = !0), this.wireframe === !0 && (r.wireframe = !0), this.wireframeLinewidth > 1 && (r.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (r.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (r.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (r.flatShading = !0), this.visible === !1 && (r.visible = !1), this.toneMapped === !1 && (r.toneMapped = !1), this.fog === !1 && (r.fog = !1), Object.keys(this.userData).length > 0 && (r.userData = this.userData);
    function i(o) {
      const a = [];
      for (const s in o) {
        const l = o[s];
        delete l.metadata, a.push(l);
      }
      return a;
    }
    if (n) {
      const o = i(e.textures), a = i(e.images);
      o.length > 0 && (r.textures = o), a.length > 0 && (r.images = a);
    }
    return r;
  }
  /**
   * Returns a new material with copied values from this instance.
   *
   * @return {Material} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given material to this instance.
   *
   * @param {Material} source - The material to copy.
   * @return {Material} A reference to this instance.
   */
  copy(e) {
    this.name = e.name, this.blending = e.blending, this.side = e.side, this.vertexColors = e.vertexColors, this.opacity = e.opacity, this.transparent = e.transparent, this.blendSrc = e.blendSrc, this.blendDst = e.blendDst, this.blendEquation = e.blendEquation, this.blendSrcAlpha = e.blendSrcAlpha, this.blendDstAlpha = e.blendDstAlpha, this.blendEquationAlpha = e.blendEquationAlpha, this.blendColor.copy(e.blendColor), this.blendAlpha = e.blendAlpha, this.depthFunc = e.depthFunc, this.depthTest = e.depthTest, this.depthWrite = e.depthWrite, this.stencilWriteMask = e.stencilWriteMask, this.stencilFunc = e.stencilFunc, this.stencilRef = e.stencilRef, this.stencilFuncMask = e.stencilFuncMask, this.stencilFail = e.stencilFail, this.stencilZFail = e.stencilZFail, this.stencilZPass = e.stencilZPass, this.stencilWrite = e.stencilWrite;
    const n = e.clippingPlanes;
    let r = null;
    if (n !== null) {
      const i = n.length;
      r = new Array(i);
      for (let o = 0; o !== i; ++o)
        r[o] = n[o].clone();
    }
    return this.clippingPlanes = r, this.clipIntersection = e.clipIntersection, this.clipShadows = e.clipShadows, this.shadowSide = e.shadowSide, this.colorWrite = e.colorWrite, this.precision = e.precision, this.polygonOffset = e.polygonOffset, this.polygonOffsetFactor = e.polygonOffsetFactor, this.polygonOffsetUnits = e.polygonOffsetUnits, this.dithering = e.dithering, this.alphaTest = e.alphaTest, this.alphaHash = e.alphaHash, this.alphaToCoverage = e.alphaToCoverage, this.premultipliedAlpha = e.premultipliedAlpha, this.forceSinglePass = e.forceSinglePass, this.visible = e.visible, this.toneMapped = e.toneMapped, this.userData = JSON.parse(JSON.stringify(e.userData)), this;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires Material#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  /**
   * Setting this property to `true` indicates the engine the material
   * needs to be recompiled.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  onBuild() {
    console.warn("Material: onBuild() has been removed.");
  }
}
class cc extends Zd {
  /**
   * Constructs a new mesh basic material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new At(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new Vr(), this.combine = y9, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.fog = e.fog, this;
  }
}
const Jt = /* @__PURE__ */ new re(), jc = /* @__PURE__ */ new Pt();
let Aee = 0;
class Hr {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {TypedArray} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, n, r = !1) {
    if (Array.isArray(e))
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    this.isBufferAttribute = !0, Object.defineProperty(this, "id", { value: Aee++ }), this.name = "", this.array = e, this.itemSize = n, this.count = e !== void 0 ? e.length / n : 0, this.normalized = r, this.usage = S4, this.updateRanges = [], this.gpuType = ri, this.version = 0;
  }
  /**
   * A callback function that is executed after the renderer has transferred the attribute
   * array data to the GPU.
   */
  onUploadCallback() {
  }
  /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  /**
   * Sets the usage of this buffer attribute.
   *
   * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
   * @return {BufferAttribute} A reference to this buffer attribute.
   */
  setUsage(e) {
    return this.usage = e, this;
  }
  /**
   * Adds a range of data in the data array to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */
  addUpdateRange(e, n) {
    this.updateRanges.push({ start: e, count: n });
  }
  /**
   * Clears the update ranges.
   */
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  /**
   * Copies the values of the given buffer attribute to this instance.
   *
   * @param {BufferAttribute} source - The buffer attribute to copy.
   * @return {BufferAttribute} A reference to this instance.
   */
  copy(e) {
    return this.name = e.name, this.array = new e.array.constructor(e.array), this.itemSize = e.itemSize, this.count = e.count, this.normalized = e.normalized, this.usage = e.usage, this.gpuType = e.gpuType, this;
  }
  /**
   * Copies a vector from the given buffer attribute to this one. The start
   * and destination position in the attribute buffers are represented by the
   * given indices.
   *
   * @param {number} index1 - The destination index into this buffer attribute.
   * @param {BufferAttribute} attribute - The buffer attribute to copy from.
   * @param {number} index2 - The source index into the given buffer attribute.
   * @return {BufferAttribute} A reference to this instance.
   */
  copyAt(e, n, r) {
    e *= this.itemSize, r *= n.itemSize;
    for (let i = 0, o = this.itemSize; i < o; i++)
      this.array[e + i] = n.array[r + i];
    return this;
  }
  /**
   * Copies the given array data into this buffer attribute.
   *
   * @param {(TypedArray|Array)} array - The array to copy.
   * @return {BufferAttribute} A reference to this instance.
   */
  copyArray(e) {
    return this.array.set(e), this;
  }
  /**
   * Applies the given 3x3 matrix to the given attribute. Works with
   * item size `2` and `3`.
   *
   * @param {Matrix3} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  applyMatrix3(e) {
    if (this.itemSize === 2)
      for (let n = 0, r = this.count; n < r; n++)
        jc.fromBufferAttribute(this, n), jc.applyMatrix3(e), this.setXY(n, jc.x, jc.y);
    else if (this.itemSize === 3)
      for (let n = 0, r = this.count; n < r; n++)
        Jt.fromBufferAttribute(this, n), Jt.applyMatrix3(e), this.setXYZ(n, Jt.x, Jt.y, Jt.z);
    return this;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  applyMatrix4(e) {
    for (let n = 0, r = this.count; n < r; n++)
      Jt.fromBufferAttribute(this, n), Jt.applyMatrix4(e), this.setXYZ(n, Jt.x, Jt.y, Jt.z);
    return this;
  }
  /**
   * Applies the given 3x3 normal matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix3} m - The normal matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  applyNormalMatrix(e) {
    for (let n = 0, r = this.count; n < r; n++)
      Jt.fromBufferAttribute(this, n), Jt.applyNormalMatrix(e), this.setXYZ(n, Jt.x, Jt.y, Jt.z);
    return this;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3` and with direction vectors.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  transformDirection(e) {
    for (let n = 0, r = this.count; n < r; n++)
      Jt.fromBufferAttribute(this, n), Jt.transformDirection(e), this.setXYZ(n, Jt.x, Jt.y, Jt.z);
    return this;
  }
  /**
   * Sets the given array data in the buffer attribute.
   *
   * @param {(TypedArray|Array)} value - The array data to set.
   * @param {number} [offset=0] - The offset in this buffer attribute's array.
   * @return {BufferAttribute} A reference to this instance.
   */
  set(e, n = 0) {
    return this.array.set(e, n), this;
  }
  /**
   * Returns the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @return {number} The returned value.
   */
  getComponent(e, n) {
    let r = this.array[e * this.itemSize + n];
    return this.normalized && (r = Ha(r, this.array)), r;
  }
  /**
   * Sets the given value to the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @param {number} value - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setComponent(e, n, r) {
    return this.normalized && (r = wn(r, this.array)), this.array[e * this.itemSize + n] = r, this;
  }
  /**
   * Returns the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The x component.
   */
  getX(e) {
    let n = this.array[e * this.itemSize];
    return this.normalized && (n = Ha(n, this.array)), n;
  }
  /**
   * Sets the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setX(e, n) {
    return this.normalized && (n = wn(n, this.array)), this.array[e * this.itemSize] = n, this;
  }
  /**
   * Returns the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The y component.
   */
  getY(e) {
    let n = this.array[e * this.itemSize + 1];
    return this.normalized && (n = Ha(n, this.array)), n;
  }
  /**
   * Sets the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} y - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setY(e, n) {
    return this.normalized && (n = wn(n, this.array)), this.array[e * this.itemSize + 1] = n, this;
  }
  /**
   * Returns the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The z component.
   */
  getZ(e) {
    let n = this.array[e * this.itemSize + 2];
    return this.normalized && (n = Ha(n, this.array)), n;
  }
  /**
   * Sets the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} z - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setZ(e, n) {
    return this.normalized && (n = wn(n, this.array)), this.array[e * this.itemSize + 2] = n, this;
  }
  /**
   * Returns the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The w component.
   */
  getW(e) {
    let n = this.array[e * this.itemSize + 3];
    return this.normalized && (n = Ha(n, this.array)), n;
  }
  /**
   * Sets the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} w - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setW(e, n) {
    return this.normalized && (n = wn(n, this.array)), this.array[e * this.itemSize + 3] = n, this;
  }
  /**
   * Sets the x and y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setXY(e, n, r) {
    return e *= this.itemSize, this.normalized && (n = wn(n, this.array), r = wn(r, this.array)), this.array[e + 0] = n, this.array[e + 1] = r, this;
  }
  /**
   * Sets the x, y and z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setXYZ(e, n, r, i) {
    return e *= this.itemSize, this.normalized && (n = wn(n, this.array), r = wn(r, this.array), i = wn(i, this.array)), this.array[e + 0] = n, this.array[e + 1] = r, this.array[e + 2] = i, this;
  }
  /**
   * Sets the x, y, z and w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @param {number} w - The value for the w component to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setXYZW(e, n, r, i, o) {
    return e *= this.itemSize, this.normalized && (n = wn(n, this.array), r = wn(r, this.array), i = wn(i, this.array), o = wn(o, this.array)), this.array[e + 0] = n, this.array[e + 1] = r, this.array[e + 2] = i, this.array[e + 3] = o, this;
  }
  /**
   * Sets the given callback function that is executed after the Renderer has transferred
   * the attribute array data to the GPU. Can be used to perform clean-up operations after
   * the upload when attribute data are not needed anymore on the CPU side.
   *
   * @param {Function} callback - The `onUpload()` callback.
   * @return {BufferAttribute} A reference to this instance.
   */
  onUpload(e) {
    return this.onUploadCallback = e, this;
  }
  /**
   * Returns a new buffer attribute with copied values from this instance.
   *
   * @return {BufferAttribute} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this);
  }
  /**
   * Serializes the buffer attribute into JSON.
   *
   * @return {Object} A JSON object representing the serialized buffer attribute.
   */
  toJSON() {
    const e = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.from(this.array),
      normalized: this.normalized
    };
    return this.name !== "" && (e.name = this.name), this.usage !== S4 && (e.usage = this.usage), e;
  }
}
class I9 extends Hr {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, n, r) {
    super(new Uint16Array(e), n, r);
  }
}
class F9 extends Hr {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Uint32Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, n, r) {
    super(new Uint32Array(e), n, r);
  }
}
class Br extends Hr {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Float32Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, n, r) {
    super(new Float32Array(e), n, r);
  }
}
let Pee = 0;
const Jn = /* @__PURE__ */ new qt(), R0 = /* @__PURE__ */ new qn(), pa = /* @__PURE__ */ new re(), Un = /* @__PURE__ */ new Ls(), Ks = /* @__PURE__ */ new Ls(), an = /* @__PURE__ */ new re();
class ao extends As {
  /**
   * Constructs a new geometry.
   */
  constructor() {
    super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", { value: Pee++ }), this.uuid = Ps(), this.name = "", this.type = "BufferGeometry", this.index = null, this.indirect = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = { start: 0, count: 1 / 0 }, this.userData = {};
  }
  /**
   * Returns the index of this geometry.
   *
   * @return {?BufferAttribute} The index. Returns `null` if no index is defined.
   */
  getIndex() {
    return this.index;
  }
  /**
   * Sets the given index to this geometry.
   *
   * @param {Array<number>|BufferAttribute} index - The index to set.
   * @return {BufferGeometry} A reference to this instance.
   */
  setIndex(e) {
    return Array.isArray(e) ? this.index = new (O9(e) ? F9 : I9)(e, 1) : this.index = e, this;
  }
  /**
   * Sets the given indirect attribute to this geometry.
   *
   * @param {BufferAttribute} indirect - The attribute holding indirect draw calls.
   * @return {BufferGeometry} A reference to this instance.
   */
  setIndirect(e) {
    return this.indirect = e, this;
  }
  /**
   * Returns the indirect attribute of this geometry.
   *
   * @return {?BufferAttribute} The indirect attribute. Returns `null` if no indirect attribute is defined.
   */
  getIndirect() {
    return this.indirect;
  }
  /**
   * Returns the buffer attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @return {BufferAttribute|InterleavedBufferAttribute|undefined} The buffer attribute.
   * Returns `undefined` if not attribute has been found.
   */
  getAttribute(e) {
    return this.attributes[e];
  }
  /**
   * Sets the given attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @param {BufferAttribute|InterleavedBufferAttribute} attribute - The attribute to set.
   * @return {BufferGeometry} A reference to this instance.
   */
  setAttribute(e, n) {
    return this.attributes[e] = n, this;
  }
  /**
   * Deletes the attribute for the given name.
   *
   * @param {string} name - The attribute name to delete.
   * @return {BufferGeometry} A reference to this instance.
   */
  deleteAttribute(e) {
    return delete this.attributes[e], this;
  }
  /**
   * Returns `true` if this geometry has an attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @return {boolean} Whether this geometry has an attribute for the given name or not.
   */
  hasAttribute(e) {
    return this.attributes[e] !== void 0;
  }
  /**
   * Adds a group to this geometry.
   *
   * @param {number} start - The first element in this draw call. That is the first
   * vertex for non-indexed geometry, otherwise the first triangle index.
   * @param {number} count - Specifies how many vertices (or indices) are part of this group.
   * @param {number} [materialIndex=0] - The material array index to use.
   */
  addGroup(e, n, r = 0) {
    this.groups.push({
      start: e,
      count: n,
      materialIndex: r
    });
  }
  /**
   * Clears all groups.
   */
  clearGroups() {
    this.groups = [];
  }
  /**
   * Sets the draw range for this geometry.
   *
   * @param {number} start - The first vertex for non-indexed geometry, otherwise the first triangle index.
   * @param {number} count - For non-indexed BufferGeometry, `count` is the number of vertices to render.
   * For indexed BufferGeometry, `count` is the number of indices to render.
   */
  setDrawRange(e, n) {
    this.drawRange.start = e, this.drawRange.count = n;
  }
  /**
   * Applies the given 4x4 transformation matrix to the geometry.
   *
   * @param {Matrix4} matrix - The matrix to apply.
   * @return {BufferGeometry} A reference to this instance.
   */
  applyMatrix4(e) {
    const n = this.attributes.position;
    n !== void 0 && (n.applyMatrix4(e), n.needsUpdate = !0);
    const r = this.attributes.normal;
    if (r !== void 0) {
      const o = new ot().getNormalMatrix(e);
      r.applyNormalMatrix(o), r.needsUpdate = !0;
    }
    const i = this.attributes.tangent;
    return i !== void 0 && (i.transformDirection(e), i.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
  }
  /**
   * Applies the rotation represented by the Quaternion to the geometry.
   *
   * @param {Quaternion} q - The Quaternion to apply.
   * @return {BufferGeometry} A reference to this instance.
   */
  applyQuaternion(e) {
    return Jn.makeRotationFromQuaternion(e), this.applyMatrix4(Jn), this;
  }
  /**
   * Rotates the geometry about the X axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */
  rotateX(e) {
    return Jn.makeRotationX(e), this.applyMatrix4(Jn), this;
  }
  /**
   * Rotates the geometry about the Y axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */
  rotateY(e) {
    return Jn.makeRotationY(e), this.applyMatrix4(Jn), this;
  }
  /**
   * Rotates the geometry about the Z axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */
  rotateZ(e) {
    return Jn.makeRotationZ(e), this.applyMatrix4(Jn), this;
  }
  /**
   * Translates the geometry. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#position} for typical
   * real-time mesh rotation.
   *
   * @param {number} x - The x offset.
   * @param {number} y - The y offset.
   * @param {number} z - The z offset.
   * @return {BufferGeometry} A reference to this instance.
   */
  translate(e, n, r) {
    return Jn.makeTranslation(e, n, r), this.applyMatrix4(Jn), this;
  }
  /**
   * Scales the geometry. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#scale} for typical
   * real-time mesh rotation.
   *
   * @param {number} x - The x scale.
   * @param {number} y - The y scale.
   * @param {number} z - The z scale.
   * @return {BufferGeometry} A reference to this instance.
   */
  scale(e, n, r) {
    return Jn.makeScale(e, n, r), this.applyMatrix4(Jn), this;
  }
  /**
   * Rotates the geometry to face a point in 3D space. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#lookAt} for typical
   * real-time mesh rotation.
   *
   * @param {Vector3} vector - The target point.
   * @return {BufferGeometry} A reference to this instance.
   */
  lookAt(e) {
    return R0.lookAt(e), R0.updateMatrix(), this.applyMatrix4(R0.matrix), this;
  }
  /**
   * Center the geometry based on its bounding box.
   *
   * @return {BufferGeometry} A reference to this instance.
   */
  center() {
    return this.computeBoundingBox(), this.boundingBox.getCenter(pa).negate(), this.translate(pa.x, pa.y, pa.z), this;
  }
  /**
   * Defines a geometry by creating a `position` attribute based on the given array of points. The array
   * can hold 2D or 3D vectors. When using two-dimensional data, the `z` coordinate for all vertices is
   * set to `0`.
   *
   * If the method is used with an existing `position` attribute, the vertex data are overwritten with the
   * data from the array. The length of the array must match the vertex count.
   *
   * @param {Array<Vector2>|Array<Vector3>} points - The points.
   * @return {BufferGeometry} A reference to this instance.
   */
  setFromPoints(e) {
    const n = this.getAttribute("position");
    if (n === void 0) {
      const r = [];
      for (let i = 0, o = e.length; i < o; i++) {
        const a = e[i];
        r.push(a.x, a.y, a.z || 0);
      }
      this.setAttribute("position", new Br(r, 3));
    } else {
      const r = Math.min(e.length, n.count);
      for (let i = 0; i < r; i++) {
        const o = e[i];
        n.setXYZ(i, o.x, o.y, o.z || 0);
      }
      e.length > n.count && console.warn("THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry."), n.needsUpdate = !0;
    }
    return this;
  }
  /**
   * Computes the bounding box of the geometry, and updates the `boundingBox` member.
   * The bounding box is not computed by the engine; it must be computed by your app.
   * You may need to recompute the bounding box if the geometry vertices are modified.
   */
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new Ls());
    const e = this.attributes.position, n = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      console.error("THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this), this.boundingBox.set(
        new re(-1 / 0, -1 / 0, -1 / 0),
        new re(1 / 0, 1 / 0, 1 / 0)
      );
      return;
    }
    if (e !== void 0) {
      if (this.boundingBox.setFromBufferAttribute(e), n)
        for (let r = 0, i = n.length; r < i; r++) {
          const o = n[r];
          Un.setFromBufferAttribute(o), this.morphTargetsRelative ? (an.addVectors(this.boundingBox.min, Un.min), this.boundingBox.expandByPoint(an), an.addVectors(this.boundingBox.max, Un.max), this.boundingBox.expandByPoint(an)) : (this.boundingBox.expandByPoint(Un.min), this.boundingBox.expandByPoint(Un.max));
        }
    } else
      this.boundingBox.makeEmpty();
    (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
  }
  /**
   * Computes the bounding sphere of the geometry, and updates the `boundingSphere` member.
   * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
   * You may need to recompute the bounding sphere if the geometry vertices are modified.
   */
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new A2());
    const e = this.attributes.position, n = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      console.error("THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this), this.boundingSphere.set(new re(), 1 / 0);
      return;
    }
    if (e) {
      const r = this.boundingSphere.center;
      if (Un.setFromBufferAttribute(e), n)
        for (let o = 0, a = n.length; o < a; o++) {
          const s = n[o];
          Ks.setFromBufferAttribute(s), this.morphTargetsRelative ? (an.addVectors(Un.min, Ks.min), Un.expandByPoint(an), an.addVectors(Un.max, Ks.max), Un.expandByPoint(an)) : (Un.expandByPoint(Ks.min), Un.expandByPoint(Ks.max));
        }
      Un.getCenter(r);
      let i = 0;
      for (let o = 0, a = e.count; o < a; o++)
        an.fromBufferAttribute(e, o), i = Math.max(i, r.distanceToSquared(an));
      if (n)
        for (let o = 0, a = n.length; o < a; o++) {
          const s = n[o], l = this.morphTargetsRelative;
          for (let c = 0, u = s.count; c < u; c++)
            an.fromBufferAttribute(s, c), l && (pa.fromBufferAttribute(e, c), an.add(pa)), i = Math.max(i, r.distanceToSquared(an));
        }
      this.boundingSphere.radius = Math.sqrt(i), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
    }
  }
  /**
   * Calculates and adds a tangent attribute to this geometry.
   *
   * The computation is only supported for indexed geometries and if position, normal, and uv attributes
   * are defined. When using a tangent space normal map, prefer the MikkTSpace algorithm provided by
   * {@link BufferGeometryUtils#computeMikkTSpaceTangents} instead.
   */
  computeTangents() {
    const e = this.index, n = this.attributes;
    if (e === null || n.position === void 0 || n.normal === void 0 || n.uv === void 0) {
      console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      return;
    }
    const r = n.position, i = n.normal, o = n.uv;
    this.hasAttribute("tangent") === !1 && this.setAttribute("tangent", new Hr(new Float32Array(4 * r.count), 4));
    const a = this.getAttribute("tangent"), s = [], l = [];
    for (let P = 0; P < r.count; P++)
      s[P] = new re(), l[P] = new re();
    const c = new re(), u = new re(), d = new re(), f = new Pt(), h = new Pt(), v = new Pt(), g = new re(), m = new re();
    function p(P, E, w) {
      c.fromBufferAttribute(r, P), u.fromBufferAttribute(r, E), d.fromBufferAttribute(r, w), f.fromBufferAttribute(o, P), h.fromBufferAttribute(o, E), v.fromBufferAttribute(o, w), u.sub(c), d.sub(c), h.sub(f), v.sub(f);
      const O = 1 / (h.x * v.y - v.x * h.y);
      isFinite(O) && (g.copy(u).multiplyScalar(v.y).addScaledVector(d, -h.y).multiplyScalar(O), m.copy(d).multiplyScalar(h.x).addScaledVector(u, -v.x).multiplyScalar(O), s[P].add(g), s[E].add(g), s[w].add(g), l[P].add(m), l[E].add(m), l[w].add(m));
    }
    let y = this.groups;
    y.length === 0 && (y = [{
      start: 0,
      count: e.count
    }]);
    for (let P = 0, E = y.length; P < E; ++P) {
      const w = y[P], O = w.start, N = w.count;
      for (let I = O, H = O + N; I < H; I += 3)
        p(
          e.getX(I + 0),
          e.getX(I + 1),
          e.getX(I + 2)
        );
    }
    const b = new re(), x = new re(), _ = new re(), M = new re();
    function S(P) {
      _.fromBufferAttribute(i, P), M.copy(_);
      const E = s[P];
      b.copy(E), b.sub(_.multiplyScalar(_.dot(E))).normalize(), x.crossVectors(M, E);
      const O = x.dot(l[P]) < 0 ? -1 : 1;
      a.setXYZW(P, b.x, b.y, b.z, O);
    }
    for (let P = 0, E = y.length; P < E; ++P) {
      const w = y[P], O = w.start, N = w.count;
      for (let I = O, H = O + N; I < H; I += 3)
        S(e.getX(I + 0)), S(e.getX(I + 1)), S(e.getX(I + 2));
    }
  }
  /**
   * Computes vertex normals for the given vertex data. For indexed geometries, the method sets
   * each vertex normal to be the average of the face normals of the faces that share that vertex.
   * For non-indexed geometries, vertices are not shared, and the method sets each vertex normal
   * to be the same as the face normal.
   */
  computeVertexNormals() {
    const e = this.index, n = this.getAttribute("position");
    if (n !== void 0) {
      let r = this.getAttribute("normal");
      if (r === void 0)
        r = new Hr(new Float32Array(n.count * 3), 3), this.setAttribute("normal", r);
      else
        for (let f = 0, h = r.count; f < h; f++)
          r.setXYZ(f, 0, 0, 0);
      const i = new re(), o = new re(), a = new re(), s = new re(), l = new re(), c = new re(), u = new re(), d = new re();
      if (e)
        for (let f = 0, h = e.count; f < h; f += 3) {
          const v = e.getX(f + 0), g = e.getX(f + 1), m = e.getX(f + 2);
          i.fromBufferAttribute(n, v), o.fromBufferAttribute(n, g), a.fromBufferAttribute(n, m), u.subVectors(a, o), d.subVectors(i, o), u.cross(d), s.fromBufferAttribute(r, v), l.fromBufferAttribute(r, g), c.fromBufferAttribute(r, m), s.add(u), l.add(u), c.add(u), r.setXYZ(v, s.x, s.y, s.z), r.setXYZ(g, l.x, l.y, l.z), r.setXYZ(m, c.x, c.y, c.z);
        }
      else
        for (let f = 0, h = n.count; f < h; f += 3)
          i.fromBufferAttribute(n, f + 0), o.fromBufferAttribute(n, f + 1), a.fromBufferAttribute(n, f + 2), u.subVectors(a, o), d.subVectors(i, o), u.cross(d), r.setXYZ(f + 0, u.x, u.y, u.z), r.setXYZ(f + 1, u.x, u.y, u.z), r.setXYZ(f + 2, u.x, u.y, u.z);
      this.normalizeNormals(), r.needsUpdate = !0;
    }
  }
  /**
   * Ensures every normal vector in a geometry will have a magnitude of `1`. This will
   * correct lighting on the geometry surfaces.
   */
  normalizeNormals() {
    const e = this.attributes.normal;
    for (let n = 0, r = e.count; n < r; n++)
      an.fromBufferAttribute(e, n), an.normalize(), e.setXYZ(n, an.x, an.y, an.z);
  }
  /**
   * Return a new non-index version of this indexed geometry. If the geometry
   * is already non-indexed, the method is a NOOP.
   *
   * @return {BufferGeometry} The non-indexed version of this indexed geometry.
   */
  toNonIndexed() {
    function e(s, l) {
      const c = s.array, u = s.itemSize, d = s.normalized, f = new c.constructor(l.length * u);
      let h = 0, v = 0;
      for (let g = 0, m = l.length; g < m; g++) {
        s.isInterleavedBufferAttribute ? h = l[g] * s.data.stride + s.offset : h = l[g] * u;
        for (let p = 0; p < u; p++)
          f[v++] = c[h++];
      }
      return new Hr(f, u, d);
    }
    if (this.index === null)
      return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
    const n = new ao(), r = this.index.array, i = this.attributes;
    for (const s in i) {
      const l = i[s], c = e(l, r);
      n.setAttribute(s, c);
    }
    const o = this.morphAttributes;
    for (const s in o) {
      const l = [], c = o[s];
      for (let u = 0, d = c.length; u < d; u++) {
        const f = c[u], h = e(f, r);
        l.push(h);
      }
      n.morphAttributes[s] = l;
    }
    n.morphTargetsRelative = this.morphTargetsRelative;
    const a = this.groups;
    for (let s = 0, l = a.length; s < l; s++) {
      const c = a[s];
      n.addGroup(c.start, c.count, c.materialIndex);
    }
    return n;
  }
  /**
   * Serializes the geometry into JSON.
   *
   * @return {Object} A JSON object representing the serialized geometry.
   */
  toJSON() {
    const e = {
      metadata: {
        version: 4.6,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON"
      }
    };
    if (e.uuid = this.uuid, e.type = this.type, this.name !== "" && (e.name = this.name), Object.keys(this.userData).length > 0 && (e.userData = this.userData), this.parameters !== void 0) {
      const l = this.parameters;
      for (const c in l)
        l[c] !== void 0 && (e[c] = l[c]);
      return e;
    }
    e.data = { attributes: {} };
    const n = this.index;
    n !== null && (e.data.index = {
      type: n.array.constructor.name,
      array: Array.prototype.slice.call(n.array)
    });
    const r = this.attributes;
    for (const l in r) {
      const c = r[l];
      e.data.attributes[l] = c.toJSON(e.data);
    }
    const i = {};
    let o = !1;
    for (const l in this.morphAttributes) {
      const c = this.morphAttributes[l], u = [];
      for (let d = 0, f = c.length; d < f; d++) {
        const h = c[d];
        u.push(h.toJSON(e.data));
      }
      u.length > 0 && (i[l] = u, o = !0);
    }
    o && (e.data.morphAttributes = i, e.data.morphTargetsRelative = this.morphTargetsRelative);
    const a = this.groups;
    a.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(a)));
    const s = this.boundingSphere;
    return s !== null && (e.data.boundingSphere = {
      center: s.center.toArray(),
      radius: s.radius
    }), e;
  }
  /**
   * Returns a new geometry with copied values from this instance.
   *
   * @return {BufferGeometry} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given geometry to this instance.
   *
   * @param {BufferGeometry} source - The geometry to copy.
   * @return {BufferGeometry} A reference to this instance.
   */
  copy(e) {
    this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
    const n = {};
    this.name = e.name;
    const r = e.index;
    r !== null && this.setIndex(r.clone());
    const i = e.attributes;
    for (const c in i) {
      const u = i[c];
      this.setAttribute(c, u.clone(n));
    }
    const o = e.morphAttributes;
    for (const c in o) {
      const u = [], d = o[c];
      for (let f = 0, h = d.length; f < h; f++)
        u.push(d[f].clone(n));
      this.morphAttributes[c] = u;
    }
    this.morphTargetsRelative = e.morphTargetsRelative;
    const a = e.groups;
    for (let c = 0, u = a.length; c < u; c++) {
      const d = a[c];
      this.addGroup(d.start, d.count, d.materialIndex);
    }
    const s = e.boundingBox;
    s !== null && (this.boundingBox = s.clone());
    const l = e.boundingSphere;
    return l !== null && (this.boundingSphere = l.clone()), this.drawRange.start = e.drawRange.start, this.drawRange.count = e.drawRange.count, this.userData = e.userData, this;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires BufferGeometry#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
const H4 = /* @__PURE__ */ new qt(), po = /* @__PURE__ */ new k9(), Gc = /* @__PURE__ */ new A2(), B4 = /* @__PURE__ */ new re(), qc = /* @__PURE__ */ new re(), Xc = /* @__PURE__ */ new re(), Yc = /* @__PURE__ */ new re(), L0 = /* @__PURE__ */ new re(), Zc = /* @__PURE__ */ new re(), V4 = /* @__PURE__ */ new re(), Kc = /* @__PURE__ */ new re();
class rr extends qn {
  /**
   * Constructs a new mesh.
   *
   * @param {BufferGeometry} [geometry] - The mesh geometry.
   * @param {Material|Array<Material>} [material] - The mesh material.
   */
  constructor(e = new ao(), n = new cc()) {
    super(), this.isMesh = !0, this.type = "Mesh", this.geometry = e, this.material = n, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.updateMorphTargets();
  }
  copy(e, n) {
    return super.copy(e, n), e.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = e.morphTargetInfluences.slice()), e.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, e.morphTargetDictionary)), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
  }
  /**
   * Sets the values of {@link Mesh#morphTargetDictionary} and {@link Mesh#morphTargetInfluences}
   * to make sure existing morph targets can influence this 3D object.
   */
  updateMorphTargets() {
    const n = this.geometry.morphAttributes, r = Object.keys(n);
    if (r.length > 0) {
      const i = n[r[0]];
      if (i !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let o = 0, a = i.length; o < a; o++) {
          const s = i[o].name || String(o);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[s] = o;
        }
      }
    }
  }
  /**
   * Returns the local-space position of the vertex at the given index, taking into
   * account the current animation state of both morph targets and skinning.
   *
   * @param {number} index - The vertex index.
   * @param {Vector3} target - The target object that is used to store the method's result.
   * @return {Vector3} The vertex position in local space.
   */
  getVertexPosition(e, n) {
    const r = this.geometry, i = r.attributes.position, o = r.morphAttributes.position, a = r.morphTargetsRelative;
    n.fromBufferAttribute(i, e);
    const s = this.morphTargetInfluences;
    if (o && s) {
      Zc.set(0, 0, 0);
      for (let l = 0, c = o.length; l < c; l++) {
        const u = s[l], d = o[l];
        u !== 0 && (L0.fromBufferAttribute(d, e), a ? Zc.addScaledVector(L0, u) : Zc.addScaledVector(L0.sub(n), u));
      }
      n.add(Zc);
    }
    return n;
  }
  /**
   * Computes intersection points between a casted ray and this line.
   *
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - The target array that holds the intersection points.
   */
  raycast(e, n) {
    const r = this.geometry, i = this.material, o = this.matrixWorld;
    i !== void 0 && (r.boundingSphere === null && r.computeBoundingSphere(), Gc.copy(r.boundingSphere), Gc.applyMatrix4(o), po.copy(e.ray).recast(e.near), !(Gc.containsPoint(po.origin) === !1 && (po.intersectSphere(Gc, B4) === null || po.origin.distanceToSquared(B4) > (e.far - e.near) ** 2)) && (H4.copy(o).invert(), po.copy(e.ray).applyMatrix4(H4), !(r.boundingBox !== null && po.intersectsBox(r.boundingBox) === !1) && this._computeIntersections(e, n, po)));
  }
  _computeIntersections(e, n, r) {
    let i;
    const o = this.geometry, a = this.material, s = o.index, l = o.attributes.position, c = o.attributes.uv, u = o.attributes.uv1, d = o.attributes.normal, f = o.groups, h = o.drawRange;
    if (s !== null)
      if (Array.isArray(a))
        for (let v = 0, g = f.length; v < g; v++) {
          const m = f[v], p = a[m.materialIndex], y = Math.max(m.start, h.start), b = Math.min(s.count, Math.min(m.start + m.count, h.start + h.count));
          for (let x = y, _ = b; x < _; x += 3) {
            const M = s.getX(x), S = s.getX(x + 1), P = s.getX(x + 2);
            i = Jc(this, p, e, r, c, u, d, M, S, P), i && (i.faceIndex = Math.floor(x / 3), i.face.materialIndex = m.materialIndex, n.push(i));
          }
        }
      else {
        const v = Math.max(0, h.start), g = Math.min(s.count, h.start + h.count);
        for (let m = v, p = g; m < p; m += 3) {
          const y = s.getX(m), b = s.getX(m + 1), x = s.getX(m + 2);
          i = Jc(this, a, e, r, c, u, d, y, b, x), i && (i.faceIndex = Math.floor(m / 3), n.push(i));
        }
      }
    else if (l !== void 0)
      if (Array.isArray(a))
        for (let v = 0, g = f.length; v < g; v++) {
          const m = f[v], p = a[m.materialIndex], y = Math.max(m.start, h.start), b = Math.min(l.count, Math.min(m.start + m.count, h.start + h.count));
          for (let x = y, _ = b; x < _; x += 3) {
            const M = x, S = x + 1, P = x + 2;
            i = Jc(this, p, e, r, c, u, d, M, S, P), i && (i.faceIndex = Math.floor(x / 3), i.face.materialIndex = m.materialIndex, n.push(i));
          }
        }
      else {
        const v = Math.max(0, h.start), g = Math.min(l.count, h.start + h.count);
        for (let m = v, p = g; m < p; m += 3) {
          const y = m, b = m + 1, x = m + 2;
          i = Jc(this, a, e, r, c, u, d, y, b, x), i && (i.faceIndex = Math.floor(m / 3), n.push(i));
        }
      }
  }
}
function Ree(t, e, n, r, i, o, a, s) {
  let l;
  if (e.side === Rn ? l = r.intersectTriangle(a, o, i, !0, s) : l = r.intersectTriangle(i, o, a, e.side === Ji, s), l === null)
    return null;
  Kc.copy(s), Kc.applyMatrix4(t.matrixWorld);
  const c = n.ray.origin.distanceTo(Kc);
  return c < n.near || c > n.far ? null : {
    distance: c,
    point: Kc.clone(),
    object: t
  };
}
function Jc(t, e, n, r, i, o, a, s, l, c) {
  t.getVertexPosition(s, qc), t.getVertexPosition(l, Xc), t.getVertexPosition(c, Yc);
  const u = Ree(t, e, n, r, qc, Xc, Yc, V4);
  if (u) {
    const d = new re();
    vr.getBarycoord(V4, qc, Xc, Yc, d), i && (u.uv = vr.getInterpolatedAttribute(i, s, l, c, d, new Pt())), o && (u.uv1 = vr.getInterpolatedAttribute(o, s, l, c, d, new Pt())), a && (u.normal = vr.getInterpolatedAttribute(a, s, l, c, d, new re()), u.normal.dot(r.direction) > 0 && u.normal.multiplyScalar(-1));
    const f = {
      a: s,
      b: l,
      c,
      normal: new re(),
      materialIndex: 0
    };
    vr.getNormal(qc, Xc, Yc, f.normal), u.face = f, u.barycoord = d;
  }
  return u;
}
class uc extends ao {
  /**
   * Constructs a new box geometry.
   *
   * @param {number} [width=1] - The width. That is, the length of the edges parallel to the X axis.
   * @param {number} [height=1] - The height. That is, the length of the edges parallel to the Y axis.
   * @param {number} [depth=1] - The depth. That is, the length of the edges parallel to the Z axis.
   * @param {number} [widthSegments=1] - Number of segmented rectangular faces along the width of the sides.
   * @param {number} [heightSegments=1] - Number of segmented rectangular faces along the height of the sides.
   * @param {number} [depthSegments=1] - Number of segmented rectangular faces along the depth of the sides.
   */
  constructor(e = 1, n = 1, r = 1, i = 1, o = 1, a = 1) {
    super(), this.type = "BoxGeometry", this.parameters = {
      width: e,
      height: n,
      depth: r,
      widthSegments: i,
      heightSegments: o,
      depthSegments: a
    };
    const s = this;
    i = Math.floor(i), o = Math.floor(o), a = Math.floor(a);
    const l = [], c = [], u = [], d = [];
    let f = 0, h = 0;
    v("z", "y", "x", -1, -1, r, n, e, a, o, 0), v("z", "y", "x", 1, -1, r, n, -e, a, o, 1), v("x", "z", "y", 1, 1, e, r, n, i, a, 2), v("x", "z", "y", 1, -1, e, r, -n, i, a, 3), v("x", "y", "z", 1, -1, e, n, r, i, o, 4), v("x", "y", "z", -1, -1, e, n, -r, i, o, 5), this.setIndex(l), this.setAttribute("position", new Br(c, 3)), this.setAttribute("normal", new Br(u, 3)), this.setAttribute("uv", new Br(d, 2));
    function v(g, m, p, y, b, x, _, M, S, P, E) {
      const w = x / S, O = _ / P, N = x / 2, I = _ / 2, H = M / 2, j = S + 1, U = P + 1;
      let $ = 0, V = 0;
      const te = new re();
      for (let B = 0; B < U; B++) {
        const Z = B * O - I;
        for (let Q = 0; Q < j; Q++) {
          const ce = Q * w - N;
          te[g] = ce * y, te[m] = Z * b, te[p] = H, c.push(te.x, te.y, te.z), te[g] = 0, te[m] = 0, te[p] = M > 0 ? 1 : -1, u.push(te.x, te.y, te.z), d.push(Q / S), d.push(1 - B / P), $ += 1;
        }
      }
      for (let B = 0; B < P; B++)
        for (let Z = 0; Z < S; Z++) {
          const Q = f + Z + j * B, ce = f + Z + j * (B + 1), k = f + (Z + 1) + j * (B + 1), G = f + (Z + 1) + j * B;
          l.push(Q, ce, G), l.push(ce, k, G), V += 6;
        }
      s.addGroup(h, V, E), h += V, f += $;
    }
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {BoxGeometry} A new instance.
   */
  static fromJSON(e) {
    return new uc(e.width, e.height, e.depth, e.widthSegments, e.heightSegments, e.depthSegments);
  }
}
function is(t) {
  const e = {};
  for (const n in t) {
    e[n] = {};
    for (const r in t[n]) {
      const i = t[n][r];
      i && (i.isColor || i.isMatrix3 || i.isMatrix4 || i.isVector2 || i.isVector3 || i.isVector4 || i.isTexture || i.isQuaternion) ? i.isRenderTargetTexture ? (console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), e[n][r] = null) : e[n][r] = i.clone() : Array.isArray(i) ? e[n][r] = i.slice() : e[n][r] = i;
    }
  }
  return e;
}
function _n(t) {
  const e = {};
  for (let n = 0; n < t.length; n++) {
    const r = is(t[n]);
    for (const i in r)
      e[i] = r[i];
  }
  return e;
}
function Lee(t) {
  const e = [];
  for (let n = 0; n < t.length; n++)
    e.push(t[n].clone());
  return e;
}
function U9(t) {
  const e = t.getRenderTarget();
  return e === null ? t.outputColorSpace : e.isXRRenderTarget === !0 ? e.texture.colorSpace : mt.workingColorSpace;
}
const Oee = { clone: is, merge: _n };
var Dee = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, kee = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`;
class eo extends Zd {
  /**
   * Constructs a new shader material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = Dee, this.fragmentShader = kee, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
      clipCullDistance: !1,
      // set to use vertex shader clipping
      multiDraw: !1
      // set to use vertex shader multi_draw / enable gl_DrawID
    }, this.defaultAttributeValues = {
      color: [1, 1, 1],
      uv: [0, 0],
      uv1: [0, 0]
    }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, e !== void 0 && this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.fragmentShader = e.fragmentShader, this.vertexShader = e.vertexShader, this.uniforms = is(e.uniforms), this.uniformsGroups = Lee(e.uniformsGroups), this.defines = Object.assign({}, e.defines), this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.fog = e.fog, this.lights = e.lights, this.clipping = e.clipping, this.extensions = Object.assign({}, e.extensions), this.glslVersion = e.glslVersion, this;
  }
  toJSON(e) {
    const n = super.toJSON(e);
    n.glslVersion = this.glslVersion, n.uniforms = {};
    for (const i in this.uniforms) {
      const a = this.uniforms[i].value;
      a && a.isTexture ? n.uniforms[i] = {
        type: "t",
        value: a.toJSON(e).uuid
      } : a && a.isColor ? n.uniforms[i] = {
        type: "c",
        value: a.getHex()
      } : a && a.isVector2 ? n.uniforms[i] = {
        type: "v2",
        value: a.toArray()
      } : a && a.isVector3 ? n.uniforms[i] = {
        type: "v3",
        value: a.toArray()
      } : a && a.isVector4 ? n.uniforms[i] = {
        type: "v4",
        value: a.toArray()
      } : a && a.isMatrix3 ? n.uniforms[i] = {
        type: "m3",
        value: a.toArray()
      } : a && a.isMatrix4 ? n.uniforms[i] = {
        type: "m4",
        value: a.toArray()
      } : n.uniforms[i] = {
        value: a
      };
    }
    Object.keys(this.defines).length > 0 && (n.defines = this.defines), n.vertexShader = this.vertexShader, n.fragmentShader = this.fragmentShader, n.lights = this.lights, n.clipping = this.clipping;
    const r = {};
    for (const i in this.extensions)
      this.extensions[i] === !0 && (r[i] = !0);
    return Object.keys(r).length > 0 && (n.extensions = r), n;
  }
}
class z9 extends qn {
  /**
   * Constructs a new camera.
   */
  constructor() {
    super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new qt(), this.projectionMatrix = new qt(), this.projectionMatrixInverse = new qt(), this.coordinateSystem = ii;
  }
  copy(e, n) {
    return super.copy(e, n), this.matrixWorldInverse.copy(e.matrixWorldInverse), this.projectionMatrix.copy(e.projectionMatrix), this.projectionMatrixInverse.copy(e.projectionMatrixInverse), this.coordinateSystem = e.coordinateSystem, this;
  }
  /**
   * Returns a vector representing the ("look") direction of the 3D object in world space.
   *
   * This method is overwritten since cameras have a different forward vector compared to other
   * 3D objects. A camera looks down its local, negative z-axis by default.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's direction in world space.
   */
  getWorldDirection(e) {
    return super.getWorldDirection(e).negate();
  }
  updateMatrixWorld(e) {
    super.updateMatrixWorld(e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  updateWorldMatrix(e, n) {
    super.updateWorldMatrix(e, n), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const Ai = /* @__PURE__ */ new re(), $4 = /* @__PURE__ */ new Pt(), W4 = /* @__PURE__ */ new Pt();
class tr extends z9 {
  /**
   * Constructs a new perspective camera.
   *
   * @param {number} [fov=50] - The vertical field of view.
   * @param {number} [aspect=1] - The aspect ratio.
   * @param {number} [near=0.1] - The camera's near plane.
   * @param {number} [far=2000] - The camera's far plane.
   */
  constructor(e = 50, n = 1, r = 0.1, i = 2e3) {
    super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = e, this.zoom = 1, this.near = r, this.far = i, this.focus = 10, this.aspect = n, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
  }
  copy(e, n) {
    return super.copy(e, n), this.fov = e.fov, this.zoom = e.zoom, this.near = e.near, this.far = e.far, this.focus = e.focus, this.aspect = e.aspect, this.view = e.view === null ? null : Object.assign({}, e.view), this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this;
  }
  /**
   * Sets the FOV by focal length in respect to the current {@link PerspectiveCamera#filmGauge}.
   *
   * The default film gauge is 35, so that the focal length can be specified for
   * a 35mm (full frame) camera.
   *
   * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
   */
  setFocalLength(e) {
    const n = 0.5 * this.getFilmHeight() / e;
    this.fov = zl * 2 * Math.atan(n), this.updateProjectionMatrix();
  }
  /**
   * Returns the focal length from the current {@link PerspectiveCamera#fov} and
   * {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The computed focal length.
   */
  getFocalLength() {
    const e = Math.tan(pl * 0.5 * this.fov);
    return 0.5 * this.getFilmHeight() / e;
  }
  /**
   * Returns the current vertical field of view angle in degrees considering {@link PerspectiveCamera#zoom}.
   *
   * @return {number} The effective FOV.
   */
  getEffectiveFOV() {
    return zl * 2 * Math.atan(
      Math.tan(pl * 0.5 * this.fov) / this.zoom
    );
  }
  /**
   * Returns the width of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
   * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The film width.
   */
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1);
  }
  /**
   * Returns the height of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
   * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The film width.
   */
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1);
  }
  /**
   * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
   * Sets `minTarget` and `maxTarget` to the coordinates of the lower-left and upper-right corners of the view rectangle.
   *
   * @param {number} distance - The viewing distance.
   * @param {Vector2} minTarget - The lower-left corner of the view rectangle is written into this vector.
   * @param {Vector2} maxTarget - The upper-right corner of the view rectangle is written into this vector.
   */
  getViewBounds(e, n, r) {
    Ai.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse), n.set(Ai.x, Ai.y).multiplyScalar(-e / Ai.z), Ai.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse), r.set(Ai.x, Ai.y).multiplyScalar(-e / Ai.z);
  }
  /**
   * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
   *
   * @param {number} distance - The viewing distance.
   * @param {Vector2} target - The target vector that is used to store result where x is width and y is height.
   * @returns {Vector2} The view size.
   */
  getViewSize(e, n) {
    return this.getViewBounds(e, $4, W4), n.subVectors(W4, $4);
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
   * the monitors are in grid like this
   *```
   *   +---+---+---+
   *   | A | B | C |
   *   +---+---+---+
   *   | D | E | F |
   *   +---+---+---+
   *```
   * then for each monitor you would call it like this:
   *```js
   * const w = 1920;
   * const h = 1080;
   * const fullWidth = w * 3;
   * const fullHeight = h * 2;
   *
   * // --A--
   * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
   * // --B--
   * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
   * // --C--
   * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
   * // --D--
   * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
   * // --E--
   * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
   * // --F--
   * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
   * ```
   *
   * Note there is no reason monitors have to be the same size or in a grid.
   *
   * @param {number} fullWidth - The full width of multiview setup.
   * @param {number} fullHeight - The full height of multiview setup.
   * @param {number} x - The horizontal offset of the subcamera.
   * @param {number} y - The vertical offset of the subcamera.
   * @param {number} width - The width of subcamera.
   * @param {number} height - The height of subcamera.
   */
  setViewOffset(e, n, r, i, o, a) {
    this.aspect = e / n, this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = n, this.view.offsetX = r, this.view.offsetY = i, this.view.width = o, this.view.height = a, this.updateProjectionMatrix();
  }
  /**
   * Removes the view offset from the projection matrix.
   */
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  /**
   * Updates the camera's projection matrix. Must be called after any change of
   * camera properties.
   */
  updateProjectionMatrix() {
    const e = this.near;
    let n = e * Math.tan(pl * 0.5 * this.fov) / this.zoom, r = 2 * n, i = this.aspect * r, o = -0.5 * i;
    const a = this.view;
    if (this.view !== null && this.view.enabled) {
      const l = a.fullWidth, c = a.fullHeight;
      o += a.offsetX * i / l, n -= a.offsetY * r / c, i *= a.width / l, r *= a.height / c;
    }
    const s = this.filmOffset;
    s !== 0 && (o += e * s / this.getFilmWidth()), this.projectionMatrix.makePerspective(o, o + i, n, n - r, e, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    const n = super.toJSON(e);
    return n.object.fov = this.fov, n.object.zoom = this.zoom, n.object.near = this.near, n.object.far = this.far, n.object.focus = this.focus, n.object.aspect = this.aspect, this.view !== null && (n.object.view = Object.assign({}, this.view)), n.object.filmGauge = this.filmGauge, n.object.filmOffset = this.filmOffset, n;
  }
}
const ma = -90, va = 1;
class Nee extends qn {
  /**
   * Constructs a new cube camera.
   *
   * @param {number} near - The camera's near plane.
   * @param {number} far - The camera's far plane.
   * @param {WebGLCubeRenderTarget} renderTarget - The cube render target.
   */
  constructor(e, n, r) {
    super(), this.type = "CubeCamera", this.renderTarget = r, this.coordinateSystem = null, this.activeMipmapLevel = 0;
    const i = new tr(ma, va, e, n);
    i.layers = this.layers, this.add(i);
    const o = new tr(ma, va, e, n);
    o.layers = this.layers, this.add(o);
    const a = new tr(ma, va, e, n);
    a.layers = this.layers, this.add(a);
    const s = new tr(ma, va, e, n);
    s.layers = this.layers, this.add(s);
    const l = new tr(ma, va, e, n);
    l.layers = this.layers, this.add(l);
    const c = new tr(ma, va, e, n);
    c.layers = this.layers, this.add(c);
  }
  /**
   * Must be called when the coordinate system of the cube camera is changed.
   */
  updateCoordinateSystem() {
    const e = this.coordinateSystem, n = this.children.concat(), [r, i, o, a, s, l] = n;
    for (const c of n)
      this.remove(c);
    if (e === ii)
      r.up.set(0, 1, 0), r.lookAt(1, 0, 0), i.up.set(0, 1, 0), i.lookAt(-1, 0, 0), o.up.set(0, 0, -1), o.lookAt(0, 1, 0), a.up.set(0, 0, 1), a.lookAt(0, -1, 0), s.up.set(0, 1, 0), s.lookAt(0, 0, 1), l.up.set(0, 1, 0), l.lookAt(0, 0, -1);
    else if (e === rd)
      r.up.set(0, -1, 0), r.lookAt(-1, 0, 0), i.up.set(0, -1, 0), i.lookAt(1, 0, 0), o.up.set(0, 0, 1), o.lookAt(0, 1, 0), a.up.set(0, 0, -1), a.lookAt(0, -1, 0), s.up.set(0, -1, 0), s.lookAt(0, 0, 1), l.up.set(0, -1, 0), l.lookAt(0, 0, -1);
    else
      throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + e);
    for (const c of n)
      this.add(c), c.updateMatrixWorld();
  }
  /**
   * Calling this method will render the given scene with the given renderer
   * into the cube render target of the camera.
   *
   * @param {(Renderer|WebGLRenderer)} renderer - The renderer.
   * @param {Scene} scene - The scene to render.
   */
  update(e, n) {
    this.parent === null && this.updateMatrixWorld();
    const { renderTarget: r, activeMipmapLevel: i } = this;
    this.coordinateSystem !== e.coordinateSystem && (this.coordinateSystem = e.coordinateSystem, this.updateCoordinateSystem());
    const [o, a, s, l, c, u] = this.children, d = e.getRenderTarget(), f = e.getActiveCubeFace(), h = e.getActiveMipmapLevel(), v = e.xr.enabled;
    e.xr.enabled = !1;
    const g = r.texture.generateMipmaps;
    r.texture.generateMipmaps = !1, e.setRenderTarget(r, 0, i), e.render(n, o), e.setRenderTarget(r, 1, i), e.render(n, a), e.setRenderTarget(r, 2, i), e.render(n, s), e.setRenderTarget(r, 3, i), e.render(n, l), e.setRenderTarget(r, 4, i), e.render(n, c), r.texture.generateMipmaps = g, e.setRenderTarget(r, 5, i), e.render(n, u), e.setRenderTarget(d, f, h), e.xr.enabled = v, r.texture.needsPMREMUpdate = !0;
  }
}
class H9 extends En {
  /**
   * Constructs a new cube texture.
   *
   * @param {Array<Image>} [images=[]] - An array holding a image for each side of a cube.
   * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space value.
   */
  constructor(e = [], n = ns, r, i, o, a, s, l, c, u) {
    super(e, n, r, i, o, a, s, l, c, u), this.isCubeTexture = !0, this.flipY = !1;
  }
  /**
   * Alias for {@link CubeTexture#image}.
   *
   * @type {Array<Image>}
   */
  get images() {
    return this.image;
  }
  set images(e) {
    this.image = e;
  }
}
class Iee extends Qi {
  /**
   * Constructs a new cube render target.
   *
   * @param {number} [size=1] - The size of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */
  constructor(e = 1, n = {}) {
    super(e, e, n), this.isWebGLCubeRenderTarget = !0;
    const r = { width: e, height: e, depth: 1 }, i = [r, r, r, r, r, r];
    this.texture = new H9(i, n.mapping, n.wrapS, n.wrapT, n.magFilter, n.minFilter, n.format, n.type, n.anisotropy, n.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = n.generateMipmaps !== void 0 ? n.generateMipmaps : !1, this.texture.minFilter = n.minFilter !== void 0 ? n.minFilter : yr;
  }
  /**
   * Converts the given equirectangular texture to a cube map.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Texture} texture - The equirectangular texture.
   * @return {WebGLCubeRenderTarget} A reference to this cube render target.
   */
  fromEquirectangularTexture(e, n) {
    this.texture.type = n.type, this.texture.colorSpace = n.colorSpace, this.texture.generateMipmaps = n.generateMipmaps, this.texture.minFilter = n.minFilter, this.texture.magFilter = n.magFilter;
    const r = {
      uniforms: {
        tEquirect: { value: null }
      },
      vertexShader: (
        /* glsl */
        `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`
      ),
      fragmentShader: (
        /* glsl */
        `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
      )
    }, i = new uc(5, 5, 5), o = new eo({
      name: "CubemapFromEquirect",
      uniforms: is(r.uniforms),
      vertexShader: r.vertexShader,
      fragmentShader: r.fragmentShader,
      side: Rn,
      blending: Hi
    });
    o.uniforms.tEquirect.value = n;
    const a = new rr(i, o), s = n.minFilter;
    return n.minFilter === Ui && (n.minFilter = yr), new Nee(1, 10, this).update(e, a), n.minFilter = s, a.geometry.dispose(), a.material.dispose(), this;
  }
  /**
   * Clears this cube render target.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
   * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
   * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
   */
  clear(e, n = !0, r = !0, i = !0) {
    const o = e.getRenderTarget();
    for (let a = 0; a < 6; a++)
      e.setRenderTarget(this, a), e.clear(n, r, i);
    e.setRenderTarget(o);
  }
}
class $a extends qn {
  constructor() {
    super(), this.isGroup = !0, this.type = "Group";
  }
}
const Fee = { type: "move" };
class O0 {
  /**
   * Constructs a new XR controller.
   */
  constructor() {
    this._targetRay = null, this._grip = null, this._hand = null;
  }
  /**
   * Returns a group representing the hand space of the XR controller.
   *
   * @return {Group} A group representing the hand space of the XR controller.
   */
  getHandSpace() {
    return this._hand === null && (this._hand = new $a(), this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = { pinching: !1 }), this._hand;
  }
  /**
   * Returns a group representing the target ray space of the XR controller.
   *
   * @return {Group} A group representing the target ray space of the XR controller.
   */
  getTargetRaySpace() {
    return this._targetRay === null && (this._targetRay = new $a(), this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new re(), this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new re()), this._targetRay;
  }
  /**
   * Returns a group representing the grip space of the XR controller.
   *
   * @return {Group} A group representing the grip space of the XR controller.
   */
  getGripSpace() {
    return this._grip === null && (this._grip = new $a(), this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new re(), this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new re()), this._grip;
  }
  /**
   * Dispatches the given event to the groups representing
   * the different coordinate spaces of the XR controller.
   *
   * @param {Object} event - The event to dispatch.
   * @return {WebXRController} A reference to this instance.
   */
  dispatchEvent(e) {
    return this._targetRay !== null && this._targetRay.dispatchEvent(e), this._grip !== null && this._grip.dispatchEvent(e), this._hand !== null && this._hand.dispatchEvent(e), this;
  }
  /**
   * Connects the controller with the given XR input source.
   *
   * @param {XRInputSource} inputSource - The input source.
   * @return {WebXRController} A reference to this instance.
   */
  connect(e) {
    if (e && e.hand) {
      const n = this._hand;
      if (n)
        for (const r of e.hand.values())
          this._getHandJoint(n, r);
    }
    return this.dispatchEvent({ type: "connected", data: e }), this;
  }
  /**
   * Disconnects the controller from the given XR input source.
   *
   * @param {XRInputSource} inputSource - The input source.
   * @return {WebXRController} A reference to this instance.
   */
  disconnect(e) {
    return this.dispatchEvent({ type: "disconnected", data: e }), this._targetRay !== null && (this._targetRay.visible = !1), this._grip !== null && (this._grip.visible = !1), this._hand !== null && (this._hand.visible = !1), this;
  }
  /**
   * Updates the controller with the given input source, XR frame and reference space.
   * This updates the transformations of the groups that represent the different
   * coordinate systems of the controller.
   *
   * @param {XRInputSource} inputSource - The input source.
   * @param {XRFrame} frame - The XR frame.
   * @param {XRReferenceSpace} referenceSpace - The reference space.
   * @return {WebXRController} A reference to this instance.
   */
  update(e, n, r) {
    let i = null, o = null, a = null;
    const s = this._targetRay, l = this._grip, c = this._hand;
    if (e && n.session.visibilityState !== "visible-blurred") {
      if (c && e.hand) {
        a = !0;
        for (const g of e.hand.values()) {
          const m = n.getJointPose(g, r), p = this._getHandJoint(c, g);
          m !== null && (p.matrix.fromArray(m.transform.matrix), p.matrix.decompose(p.position, p.rotation, p.scale), p.matrixWorldNeedsUpdate = !0, p.jointRadius = m.radius), p.visible = m !== null;
        }
        const u = c.joints["index-finger-tip"], d = c.joints["thumb-tip"], f = u.position.distanceTo(d.position), h = 0.02, v = 5e-3;
        c.inputState.pinching && f > h + v ? (c.inputState.pinching = !1, this.dispatchEvent({
          type: "pinchend",
          handedness: e.handedness,
          target: this
        })) : !c.inputState.pinching && f <= h - v && (c.inputState.pinching = !0, this.dispatchEvent({
          type: "pinchstart",
          handedness: e.handedness,
          target: this
        }));
      } else
        l !== null && e.gripSpace && (o = n.getPose(e.gripSpace, r), o !== null && (l.matrix.fromArray(o.transform.matrix), l.matrix.decompose(l.position, l.rotation, l.scale), l.matrixWorldNeedsUpdate = !0, o.linearVelocity ? (l.hasLinearVelocity = !0, l.linearVelocity.copy(o.linearVelocity)) : l.hasLinearVelocity = !1, o.angularVelocity ? (l.hasAngularVelocity = !0, l.angularVelocity.copy(o.angularVelocity)) : l.hasAngularVelocity = !1));
      s !== null && (i = n.getPose(e.targetRaySpace, r), i === null && o !== null && (i = o), i !== null && (s.matrix.fromArray(i.transform.matrix), s.matrix.decompose(s.position, s.rotation, s.scale), s.matrixWorldNeedsUpdate = !0, i.linearVelocity ? (s.hasLinearVelocity = !0, s.linearVelocity.copy(i.linearVelocity)) : s.hasLinearVelocity = !1, i.angularVelocity ? (s.hasAngularVelocity = !0, s.angularVelocity.copy(i.angularVelocity)) : s.hasAngularVelocity = !1, this.dispatchEvent(Fee)));
    }
    return s !== null && (s.visible = i !== null), l !== null && (l.visible = o !== null), c !== null && (c.visible = a !== null), this;
  }
  /**
   * Returns a group representing the hand joint for the given input joint.
   *
   * @private
   * @param {Group} hand - The group representing the hand space.
   * @param {XRHandJoint} inputjoint - The XR frame.
   * @return {Group} A group representing the hand joint for the given input joint.
   */
  _getHandJoint(e, n) {
    if (e.joints[n.jointName] === void 0) {
      const r = new $a();
      r.matrixAutoUpdate = !1, r.visible = !1, e.joints[n.jointName] = r, e.add(r);
    }
    return e.joints[n.jointName];
  }
}
class j4 extends qn {
  /**
   * Constructs a new scene.
   */
  constructor() {
    super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.backgroundRotation = new Vr(), this.environmentIntensity = 1, this.environmentRotation = new Vr(), this.overrideMaterial = null, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
  copy(e, n) {
    return super.copy(e, n), e.background !== null && (this.background = e.background.clone()), e.environment !== null && (this.environment = e.environment.clone()), e.fog !== null && (this.fog = e.fog.clone()), this.backgroundBlurriness = e.backgroundBlurriness, this.backgroundIntensity = e.backgroundIntensity, this.backgroundRotation.copy(e.backgroundRotation), this.environmentIntensity = e.environmentIntensity, this.environmentRotation.copy(e.environmentRotation), e.overrideMaterial !== null && (this.overrideMaterial = e.overrideMaterial.clone()), this.matrixAutoUpdate = e.matrixAutoUpdate, this;
  }
  toJSON(e) {
    const n = super.toJSON(e);
    return this.fog !== null && (n.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (n.object.backgroundBlurriness = this.backgroundBlurriness), this.backgroundIntensity !== 1 && (n.object.backgroundIntensity = this.backgroundIntensity), n.object.backgroundRotation = this.backgroundRotation.toArray(), this.environmentIntensity !== 1 && (n.object.environmentIntensity = this.environmentIntensity), n.object.environmentRotation = this.environmentRotation.toArray(), n;
  }
}
const D0 = /* @__PURE__ */ new re(), Uee = /* @__PURE__ */ new re(), zee = /* @__PURE__ */ new ot();
class Co {
  /**
   * Constructs a new plane.
   *
   * @param {Vector3} [normal=(1,0,0)] - A unit length vector defining the normal of the plane.
   * @param {number} [constant=0] - The signed distance from the origin to the plane.
   */
  constructor(e = new re(1, 0, 0), n = 0) {
    this.isPlane = !0, this.normal = e, this.constant = n;
  }
  /**
   * Sets the plane components by copying the given values.
   *
   * @param {Vector3} normal - The normal.
   * @param {number} constant - The constant.
   * @return {Plane} A reference to this plane.
   */
  set(e, n) {
    return this.normal.copy(e), this.constant = n, this;
  }
  /**
   * Sets the plane components by defining `x`, `y`, `z` as the
   * plane normal and `w` as the constant.
   *
   * @param {number} x - The value for the normal's x component.
   * @param {number} y - The value for the normal's y component.
   * @param {number} z - The value for the normal's z component.
   * @param {number} w - The constant value.
   * @return {Plane} A reference to this plane.
   */
  setComponents(e, n, r, i) {
    return this.normal.set(e, n, r), this.constant = i, this;
  }
  /**
   * Sets the plane from the given normal and coplanar point (that is a point
   * that lies onto the plane).
   *
   * @param {Vector3} normal - The normal.
   * @param {Vector3} point - A coplanar point.
   * @return {Plane} A reference to this plane.
   */
  setFromNormalAndCoplanarPoint(e, n) {
    return this.normal.copy(e), this.constant = -n.dot(this.normal), this;
  }
  /**
   * Sets the plane from three coplanar points. The winding order is
   * assumed to be counter-clockwise, and determines the direction of
   * the plane normal.
   *
   * @param {Vector3} a - The first coplanar point.
   * @param {Vector3} b - The second coplanar point.
   * @param {Vector3} c - The third coplanar point.
   * @return {Plane} A reference to this plane.
   */
  setFromCoplanarPoints(e, n, r) {
    const i = D0.subVectors(r, n).cross(Uee.subVectors(e, n)).normalize();
    return this.setFromNormalAndCoplanarPoint(i, e), this;
  }
  /**
   * Copies the values of the given plane to this instance.
   *
   * @param {Plane} plane - The plane to copy.
   * @return {Plane} A reference to this plane.
   */
  copy(e) {
    return this.normal.copy(e.normal), this.constant = e.constant, this;
  }
  /**
   * Normalizes the plane normal and adjusts the constant accordingly.
   *
   * @return {Plane} A reference to this plane.
   */
  normalize() {
    const e = 1 / this.normal.length();
    return this.normal.multiplyScalar(e), this.constant *= e, this;
  }
  /**
   * Negates both the plane normal and the constant.
   *
   * @return {Plane} A reference to this plane.
   */
  negate() {
    return this.constant *= -1, this.normal.negate(), this;
  }
  /**
   * Returns the signed distance from the given point to this plane.
   *
   * @param {Vector3} point - The point to compute the distance for.
   * @return {number} The signed distance.
   */
  distanceToPoint(e) {
    return this.normal.dot(e) + this.constant;
  }
  /**
   * Returns the signed distance from the given sphere to this plane.
   *
   * @param {Sphere} sphere - The sphere to compute the distance for.
   * @return {number} The signed distance.
   */
  distanceToSphere(e) {
    return this.distanceToPoint(e.center) - e.radius;
  }
  /**
   * Projects a the given point onto the plane.
   *
   * @param {Vector3} point - The point to project.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The projected point on the plane.
   */
  projectPoint(e, n) {
    return n.copy(e).addScaledVector(this.normal, -this.distanceToPoint(e));
  }
  /**
   * Returns the intersection point of the passed line and the plane. Returns
   * `null` if the line does not intersect. Returns the line's starting point if
   * the line is coplanar with the plane.
   *
   * @param {Line3} line - The line to compute the intersection for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectLine(e, n) {
    const r = e.delta(D0), i = this.normal.dot(r);
    if (i === 0)
      return this.distanceToPoint(e.start) === 0 ? n.copy(e.start) : null;
    const o = -(e.start.dot(this.normal) + this.constant) / i;
    return o < 0 || o > 1 ? null : n.copy(e.start).addScaledVector(r, o);
  }
  /**
   * Returns `true` if the given line segment intersects with (passes through) the plane.
   *
   * @param {Line3} line - The line to test.
   * @return {boolean} Whether the given line segment intersects with the plane or not.
   */
  intersectsLine(e) {
    const n = this.distanceToPoint(e.start), r = this.distanceToPoint(e.end);
    return n < 0 && r > 0 || r < 0 && n > 0;
  }
  /**
   * Returns `true` if the given bounding box intersects with the plane.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the given bounding box intersects with the plane or not.
   */
  intersectsBox(e) {
    return e.intersectsPlane(this);
  }
  /**
   * Returns `true` if the given bounding sphere intersects with the plane.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the given bounding sphere intersects with the plane or not.
   */
  intersectsSphere(e) {
    return e.intersectsPlane(this);
  }
  /**
   * Returns a coplanar vector to the plane, by calculating the
   * projection of the normal at the origin onto the plane.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The coplanar point.
   */
  coplanarPoint(e) {
    return e.copy(this.normal).multiplyScalar(-this.constant);
  }
  /**
   * Apply a 4x4 matrix to the plane. The matrix must be an affine, homogeneous transform.
   *
   * The optional normal matrix can be pre-computed like so:
   * ```js
   * const optionalNormalMatrix = new THREE.Matrix3().getNormalMatrix( matrix );
   * ```
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @param {Matrix4} [optionalNormalMatrix] - A pre-computed normal matrix.
   * @return {Plane} A reference to this plane.
   */
  applyMatrix4(e, n) {
    const r = n || zee.getNormalMatrix(e), i = this.coplanarPoint(D0).applyMatrix4(e), o = this.normal.applyMatrix3(r).normalize();
    return this.constant = -i.dot(o), this;
  }
  /**
   * Translates the plane by the distance defined by the given offset vector.
   * Note that this only affects the plane constant and will not affect the normal vector.
   *
   * @param {Vector3} offset - The offset vector.
   * @return {Plane} A reference to this plane.
   */
  translate(e) {
    return this.constant -= e.dot(this.normal), this;
  }
  /**
   * Returns `true` if this plane is equal with the given one.
   *
   * @param {Plane} plane - The plane to test for equality.
   * @return {boolean} Whether this plane is equal with the given one.
   */
  equals(e) {
    return e.normal.equals(this.normal) && e.constant === this.constant;
  }
  /**
   * Returns a new plane with copied values from this instance.
   *
   * @return {Plane} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
const mo = /* @__PURE__ */ new A2(), Qc = /* @__PURE__ */ new re();
class R2 {
  /**
   * Constructs a new frustum.
   *
   * @param {Plane} [p0] - The first plane that encloses the frustum.
   * @param {Plane} [p1] - The second plane that encloses the frustum.
   * @param {Plane} [p2] - The third plane that encloses the frustum.
   * @param {Plane} [p3] - The fourth plane that encloses the frustum.
   * @param {Plane} [p4] - The fifth plane that encloses the frustum.
   * @param {Plane} [p5] - The sixth plane that encloses the frustum.
   */
  constructor(e = new Co(), n = new Co(), r = new Co(), i = new Co(), o = new Co(), a = new Co()) {
    this.planes = [e, n, r, i, o, a];
  }
  /**
   * Sets the frustum planes by copying the given planes.
   *
   * @param {Plane} [p0] - The first plane that encloses the frustum.
   * @param {Plane} [p1] - The second plane that encloses the frustum.
   * @param {Plane} [p2] - The third plane that encloses the frustum.
   * @param {Plane} [p3] - The fourth plane that encloses the frustum.
   * @param {Plane} [p4] - The fifth plane that encloses the frustum.
   * @param {Plane} [p5] - The sixth plane that encloses the frustum.
   * @return {Frustum} A reference to this frustum.
   */
  set(e, n, r, i, o, a) {
    const s = this.planes;
    return s[0].copy(e), s[1].copy(n), s[2].copy(r), s[3].copy(i), s[4].copy(o), s[5].copy(a), this;
  }
  /**
   * Copies the values of the given frustum to this instance.
   *
   * @param {Frustum} frustum - The frustum to copy.
   * @return {Frustum} A reference to this frustum.
   */
  copy(e) {
    const n = this.planes;
    for (let r = 0; r < 6; r++)
      n[r].copy(e.planes[r]);
    return this;
  }
  /**
   * Sets the frustum planes from the given projection matrix.
   *
   * @param {Matrix4} m - The projection matrix.
   * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} coordinateSystem - The coordinate system.
   * @return {Frustum} A reference to this frustum.
   */
  setFromProjectionMatrix(e, n = ii) {
    const r = this.planes, i = e.elements, o = i[0], a = i[1], s = i[2], l = i[3], c = i[4], u = i[5], d = i[6], f = i[7], h = i[8], v = i[9], g = i[10], m = i[11], p = i[12], y = i[13], b = i[14], x = i[15];
    if (r[0].setComponents(l - o, f - c, m - h, x - p).normalize(), r[1].setComponents(l + o, f + c, m + h, x + p).normalize(), r[2].setComponents(l + a, f + u, m + v, x + y).normalize(), r[3].setComponents(l - a, f - u, m - v, x - y).normalize(), r[4].setComponents(l - s, f - d, m - g, x - b).normalize(), n === ii)
      r[5].setComponents(l + s, f + d, m + g, x + b).normalize();
    else if (n === rd)
      r[5].setComponents(s, d, g, b).normalize();
    else
      throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + n);
    return this;
  }
  /**
   * Returns `true` if the 3D object's bounding sphere is intersecting this frustum.
   *
   * Note that the 3D object must have a geometry so that the bounding sphere can be calculated.
   *
   * @param {Object3D} object - The 3D object to test.
   * @return {boolean} Whether the 3D object's bounding sphere is intersecting this frustum or not.
   */
  intersectsObject(e) {
    if (e.boundingSphere !== void 0)
      e.boundingSphere === null && e.computeBoundingSphere(), mo.copy(e.boundingSphere).applyMatrix4(e.matrixWorld);
    else {
      const n = e.geometry;
      n.boundingSphere === null && n.computeBoundingSphere(), mo.copy(n.boundingSphere).applyMatrix4(e.matrixWorld);
    }
    return this.intersectsSphere(mo);
  }
  /**
   * Returns `true` if the given sprite is intersecting this frustum.
   *
   * @param {Sprite} sprite - The sprite to test.
   * @return {boolean} Whether the sprite is intersecting this frustum or not.
   */
  intersectsSprite(e) {
    return mo.center.set(0, 0, 0), mo.radius = 0.7071067811865476, mo.applyMatrix4(e.matrixWorld), this.intersectsSphere(mo);
  }
  /**
   * Returns `true` if the given bounding sphere is intersecting this frustum.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the bounding sphere is intersecting this frustum or not.
   */
  intersectsSphere(e) {
    const n = this.planes, r = e.center, i = -e.radius;
    for (let o = 0; o < 6; o++)
      if (n[o].distanceToPoint(r) < i)
        return !1;
    return !0;
  }
  /**
   * Returns `true` if the given bounding box is intersecting this frustum.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the bounding box is intersecting this frustum or not.
   */
  intersectsBox(e) {
    const n = this.planes;
    for (let r = 0; r < 6; r++) {
      const i = n[r];
      if (Qc.x = i.normal.x > 0 ? e.max.x : e.min.x, Qc.y = i.normal.y > 0 ? e.max.y : e.min.y, Qc.z = i.normal.z > 0 ? e.max.z : e.min.z, i.distanceToPoint(Qc) < 0)
        return !1;
    }
    return !0;
  }
  /**
   * Returns `true` if the given point lies within the frustum.
   *
   * @param {Vector3} point - The point to test.
   * @return {boolean} Whether the point lies within this frustum or not.
   */
  containsPoint(e) {
    const n = this.planes;
    for (let r = 0; r < 6; r++)
      if (n[r].distanceToPoint(e) < 0)
        return !1;
    return !0;
  }
  /**
   * Returns a new frustum with copied values from this instance.
   *
   * @return {Frustum} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
class B9 extends En {
  /**
   * Constructs a new depth texture.
   *
   * @param {number} width - The width of the texture.
   * @param {number} height - The height of the texture.
   * @param {number} [type=UnsignedIntType] - The texture type.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearFilter] - The min filter value.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {number} [format=DepthFormat] - The texture format.
   */
  constructor(e, n, r = Uo, i, o, a, s = _r, l = _r, c, u = Fl) {
    if (u !== Fl && u !== Ul)
      throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    super(null, i, o, a, s, l, u, r, c), this.isDepthTexture = !0, this.image = { width: e, height: n }, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
  }
  copy(e) {
    return super.copy(e), this.source = new T2(Object.assign({}, e.image)), this.compareFunction = e.compareFunction, this;
  }
  toJSON(e) {
    const n = super.toJSON(e);
    return this.compareFunction !== null && (n.compareFunction = this.compareFunction), n;
  }
}
class Kd extends ao {
  /**
   * Constructs a new plane geometry.
   *
   * @param {number} [width=1] - The width along the X axis.
   * @param {number} [height=1] - The height along the Y axis
   * @param {number} [widthSegments=1] - The number of segments along the X axis.
   * @param {number} [heightSegments=1] - The number of segments along the Y axis.
   */
  constructor(e = 1, n = 1, r = 1, i = 1) {
    super(), this.type = "PlaneGeometry", this.parameters = {
      width: e,
      height: n,
      widthSegments: r,
      heightSegments: i
    };
    const o = e / 2, a = n / 2, s = Math.floor(r), l = Math.floor(i), c = s + 1, u = l + 1, d = e / s, f = n / l, h = [], v = [], g = [], m = [];
    for (let p = 0; p < u; p++) {
      const y = p * f - a;
      for (let b = 0; b < c; b++) {
        const x = b * d - o;
        v.push(x, -y, 0), g.push(0, 0, 1), m.push(b / s), m.push(1 - p / l);
      }
    }
    for (let p = 0; p < l; p++)
      for (let y = 0; y < s; y++) {
        const b = y + c * p, x = y + c * (p + 1), _ = y + 1 + c * (p + 1), M = y + 1 + c * p;
        h.push(b, x, M), h.push(x, _, M);
      }
    this.setIndex(h), this.setAttribute("position", new Br(v, 3)), this.setAttribute("normal", new Br(g, 3)), this.setAttribute("uv", new Br(m, 2));
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {PlaneGeometry} A new instance.
   */
  static fromJSON(e) {
    return new Kd(e.width, e.height, e.widthSegments, e.heightSegments);
  }
}
class dc extends ao {
  /**
   * Constructs a new sphere geometry.
   *
   * @param {number} [radius=1] - The sphere radius.
   * @param {number} [widthSegments=32] - The number of horizontal segments. Minimum value is `3`.
   * @param {number} [heightSegments=16] - The number of vertical segments. Minimum value is `2`.
   * @param {number} [phiStart=0] - The horizontal starting angle in radians.
   * @param {number} [phiLength=Math.PI*2] - The horizontal sweep angle size.
   * @param {number} [thetaStart=0] - The vertical starting angle in radians.
   * @param {number} [thetaLength=Math.PI] - The vertical sweep angle size.
   */
  constructor(e = 1, n = 32, r = 16, i = 0, o = Math.PI * 2, a = 0, s = Math.PI) {
    super(), this.type = "SphereGeometry", this.parameters = {
      radius: e,
      widthSegments: n,
      heightSegments: r,
      phiStart: i,
      phiLength: o,
      thetaStart: a,
      thetaLength: s
    }, n = Math.max(3, Math.floor(n)), r = Math.max(2, Math.floor(r));
    const l = Math.min(a + s, Math.PI);
    let c = 0;
    const u = [], d = new re(), f = new re(), h = [], v = [], g = [], m = [];
    for (let p = 0; p <= r; p++) {
      const y = [], b = p / r;
      let x = 0;
      p === 0 && a === 0 ? x = 0.5 / n : p === r && l === Math.PI && (x = -0.5 / n);
      for (let _ = 0; _ <= n; _++) {
        const M = _ / n;
        d.x = -e * Math.cos(i + M * o) * Math.sin(a + b * s), d.y = e * Math.cos(a + b * s), d.z = e * Math.sin(i + M * o) * Math.sin(a + b * s), v.push(d.x, d.y, d.z), f.copy(d).normalize(), g.push(f.x, f.y, f.z), m.push(M + x, 1 - b), y.push(c++);
      }
      u.push(y);
    }
    for (let p = 0; p < r; p++)
      for (let y = 0; y < n; y++) {
        const b = u[p][y + 1], x = u[p][y], _ = u[p + 1][y], M = u[p + 1][y + 1];
        (p !== 0 || a > 0) && h.push(b, x, M), (p !== r - 1 || l < Math.PI) && h.push(x, _, M);
      }
    this.setIndex(h), this.setAttribute("position", new Br(v, 3)), this.setAttribute("normal", new Br(g, 3)), this.setAttribute("uv", new Br(m, 2));
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {SphereGeometry} A new instance.
   */
  static fromJSON(e) {
    return new dc(e.radius, e.widthSegments, e.heightSegments, e.phiStart, e.phiLength, e.thetaStart, e.thetaLength);
  }
}
class Hee extends Zd {
  /**
   * Constructs a new mesh depth material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = FQ, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.depthPacking = e.depthPacking, this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this;
  }
}
class Bee extends Zd {
  /**
   * Constructs a new mesh distance material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this;
  }
}
const x1 = {
  /**
   * Whether caching is enabled or not.
   *
   * @static
   * @type {boolean}
   * @default false
   */
  enabled: !1,
  /**
   * A dictionary that holds cached files.
   *
   * @static
   * @type {Object<string,Object>}
   */
  files: {},
  /**
   * Adds a cache entry with a key to reference the file. If this key already
   * holds a file, it is overwritten.
   *
   * @static
   * @param {string} key - The key to reference the cached file.
   * @param {Object} file -  The file to be cached.
   */
  add: function(t, e) {
    this.enabled !== !1 && (this.files[t] = e);
  },
  /**
   * Gets the cached value for the given key.
   *
   * @static
   * @param {string} key - The key to reference the cached file.
   * @return {Object|undefined} The cached file. If the key does not exist `undefined` is returned.
   */
  get: function(t) {
    if (this.enabled !== !1)
      return this.files[t];
  },
  /**
   * Removes the cached file associated with the given key.
   *
   * @static
   * @param {string} key - The key to reference the cached file.
   */
  remove: function(t) {
    delete this.files[t];
  },
  /**
   * Remove all values from the cache.
   *
   * @static
   */
  clear: function() {
    this.files = {};
  }
};
class Vee {
  /**
   * Constructs a new loading manager.
   *
   * @param {Function} [onLoad] - Executes when all items have been loaded.
   * @param {Function} [onProgress] - Executes when single items have been loaded.
   * @param {Function} [onError] - Executes when an error occurs.
   */
  constructor(e, n, r) {
    const i = this;
    let o = !1, a = 0, s = 0, l;
    const c = [];
    this.onStart = void 0, this.onLoad = e, this.onProgress = n, this.onError = r, this.itemStart = function(u) {
      s++, o === !1 && i.onStart !== void 0 && i.onStart(u, a, s), o = !0;
    }, this.itemEnd = function(u) {
      a++, i.onProgress !== void 0 && i.onProgress(u, a, s), a === s && (o = !1, i.onLoad !== void 0 && i.onLoad());
    }, this.itemError = function(u) {
      i.onError !== void 0 && i.onError(u);
    }, this.resolveURL = function(u) {
      return l ? l(u) : u;
    }, this.setURLModifier = function(u) {
      return l = u, this;
    }, this.addHandler = function(u, d) {
      return c.push(u, d), this;
    }, this.removeHandler = function(u) {
      const d = c.indexOf(u);
      return d !== -1 && c.splice(d, 2), this;
    }, this.getHandler = function(u) {
      for (let d = 0, f = c.length; d < f; d += 2) {
        const h = c[d], v = c[d + 1];
        if (h.global && (h.lastIndex = 0), h.test(u))
          return v;
      }
      return null;
    };
  }
}
const $ee = /* @__PURE__ */ new Vee();
let L2 = class {
  /**
   * Constructs a new loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    this.manager = e !== void 0 ? e : $ee, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
  }
  /**
   * This method needs to be implemented by all concrete loaders. It holds the
   * logic for loading assets from the backend.
   *
   * @param {string} url - The path/URL of the file to be loaded.
   * @param {Function} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
   * @param {onErrorCallback} [onError] - Executed when errors occur.
   */
  load() {
  }
  /**
   * A async version of {@link Loader#load}.
   *
   * @param {string} url - The path/URL of the file to be loaded.
   * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
   * @return {Promise} A Promise that resolves when the asset has been loaded.
   */
  loadAsync(e, n) {
    const r = this;
    return new Promise(function(i, o) {
      r.load(e, i, n, o);
    });
  }
  /**
   * This method needs to be implemented by all concrete loaders. It holds the
   * logic for parsing the asset into three.js entities.
   *
   * @param {any} data - The data to parse.
   */
  parse() {
  }
  /**
   * Sets the `crossOrigin` String to implement CORS for loading the URL
   * from a different domain that allows CORS.
   *
   * @param {string} crossOrigin - The `crossOrigin` value.
   * @return {Loader} A reference to this instance.
   */
  setCrossOrigin(e) {
    return this.crossOrigin = e, this;
  }
  /**
   * Whether the XMLHttpRequest uses credentials such as cookies, authorization
   * headers or TLS client certificates, see [XMLHttpRequest.withCredentials]{@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials}.
   *
   * Note: This setting has no effect if you are loading files locally or from the same domain.
   *
   * @param {boolean} value - The `withCredentials` value.
   * @return {Loader} A reference to this instance.
   */
  setWithCredentials(e) {
    return this.withCredentials = e, this;
  }
  /**
   * Sets the base path for the asset.
   *
   * @param {string} path - The base path.
   * @return {Loader} A reference to this instance.
   */
  setPath(e) {
    return this.path = e, this;
  }
  /**
   * Sets the base path for dependent resources like textures.
   *
   * @param {string} resourcePath - The resource path.
   * @return {Loader} A reference to this instance.
   */
  setResourcePath(e) {
    return this.resourcePath = e, this;
  }
  /**
   * Sets the given request header.
   *
   * @param {Object} requestHeader - A [request header]{@link https://developer.mozilla.org/en-US/docs/Glossary/Request_header}
   * for configuring the HTTP request.
   * @return {Loader} A reference to this instance.
   */
  setRequestHeader(e) {
    return this.requestHeader = e, this;
  }
};
L2.DEFAULT_MATERIAL_NAME = "__DEFAULT";
class Wee extends z9 {
  /**
   * Constructs a new orthographic camera.
   *
   * @param {number} [left=-1] - The left plane of the camera's frustum.
   * @param {number} [right=1] - The right plane of the camera's frustum.
   * @param {number} [top=1] - The top plane of the camera's frustum.
   * @param {number} [bottom=-1] - The bottom plane of the camera's frustum.
   * @param {number} [near=0.1] - The camera's near plane.
   * @param {number} [far=2000] - The camera's far plane.
   */
  constructor(e = -1, n = 1, r = 1, i = -1, o = 0.1, a = 2e3) {
    super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e, this.right = n, this.top = r, this.bottom = i, this.near = o, this.far = a, this.updateProjectionMatrix();
  }
  copy(e, n) {
    return super.copy(e, n), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.near = e.near, this.far = e.far, this.zoom = e.zoom, this.view = e.view === null ? null : Object.assign({}, e.view), this;
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * @param {number} fullWidth - The full width of multiview setup.
   * @param {number} fullHeight - The full height of multiview setup.
   * @param {number} x - The horizontal offset of the subcamera.
   * @param {number} y - The vertical offset of the subcamera.
   * @param {number} width - The width of subcamera.
   * @param {number} height - The height of subcamera.
   * @see {@link PerspectiveCamera#setViewOffset}
   */
  setViewOffset(e, n, r, i, o, a) {
    this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = n, this.view.offsetX = r, this.view.offsetY = i, this.view.width = o, this.view.height = a, this.updateProjectionMatrix();
  }
  /**
   * Removes the view offset from the projection matrix.
   */
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  /**
   * Updates the camera's projection matrix. Must be called after any change of
   * camera properties.
   */
  updateProjectionMatrix() {
    const e = (this.right - this.left) / (2 * this.zoom), n = (this.top - this.bottom) / (2 * this.zoom), r = (this.right + this.left) / 2, i = (this.top + this.bottom) / 2;
    let o = r - e, a = r + e, s = i + n, l = i - n;
    if (this.view !== null && this.view.enabled) {
      const c = (this.right - this.left) / this.view.fullWidth / this.zoom, u = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
      o += c * this.view.offsetX, a = o + c * this.view.width, s -= u * this.view.offsetY, l = s - u * this.view.height;
    }
    this.projectionMatrix.makeOrthographic(o, a, s, l, this.near, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    const n = super.toJSON(e);
    return n.object.zoom = this.zoom, n.object.left = this.left, n.object.right = this.right, n.object.top = this.top, n.object.bottom = this.bottom, n.object.near = this.near, n.object.far = this.far, this.view !== null && (n.object.view = Object.assign({}, this.view)), n;
  }
}
class jee extends tr {
  /**
   * Constructs a new array camera.
   *
   * @param {Array<PerspectiveCamera>} [array=[]] - An array of perspective sub cameras.
   */
  constructor(e = []) {
    super(), this.isArrayCamera = !0, this.cameras = e, this.index = 0;
  }
}
const G4 = /* @__PURE__ */ new qt();
class Gee {
  /**
   * Constructs a new raycaster.
   *
   * @param {Vector3} origin - The origin vector where the ray casts from.
   * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
   * @param {number} [near=0] - All results returned are further away than near. Near can't be negative.
   * @param {number} [far=Infinity] - All results returned are closer than far. Far can't be lower than near.
   */
  constructor(e, n, r = 0, i = 1 / 0) {
    this.ray = new k9(e, n), this.near = r, this.far = i, this.camera = null, this.layers = new P2(), this.params = {
      Mesh: {},
      Line: { threshold: 1 },
      LOD: {},
      Points: { threshold: 1 },
      Sprite: {}
    };
  }
  /**
   * Updates the ray with a new origin and direction by copying the values from the arguments.
   *
   * @param {Vector3} origin - The origin vector where the ray casts from.
   * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
   */
  set(e, n) {
    this.ray.set(e, n);
  }
  /**
   * Uses the given coordinates and camera to compute a new origin and direction for the internal ray.
   *
   * @param {Vector2} coords - 2D coordinates of the mouse, in normalized device coordinates (NDC).
   * X and Y components should be between `-1` and `1`.
   * @param {Camera} camera - The camera from which the ray should originate.
   */
  setFromCamera(e, n) {
    n.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(n.matrixWorld), this.ray.direction.set(e.x, e.y, 0.5).unproject(n).sub(this.ray.origin).normalize(), this.camera = n) : n.isOrthographicCamera ? (this.ray.origin.set(e.x, e.y, (n.near + n.far) / (n.near - n.far)).unproject(n), this.ray.direction.set(0, 0, -1).transformDirection(n.matrixWorld), this.camera = n) : console.error("THREE.Raycaster: Unsupported camera type: " + n.type);
  }
  /**
   * Uses the given WebXR controller to compute a new origin and direction for the internal ray.
   *
   * @param {WebXRController} controller - The controller to copy the position and direction from.
   * @return {Raycaster} A reference to this raycaster.
   */
  setFromXRController(e) {
    return G4.identity().extractRotation(e.matrixWorld), this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(0, 0, -1).applyMatrix4(G4), this;
  }
  /**
   * The intersection point of a raycaster intersection test.
   * @typedef {Object} Raycaster~Intersection
   * @property {number} distance - The distance from the ray's origin to the intersection point.
   * @property {number} distanceToRay -  Some 3D objects e.g. {@link Points} provide the distance of the
   * intersection to the nearest point on the ray. For other objects it will be `undefined`.
   * @property {Vector3} point - The intersection point, in world coordinates.
   * @property {Object} face - The face that has been intersected.
   * @property {number} faceIndex - The face index.
   * @property {Object3D} object - The 3D object that has been intersected.
   * @property {Vector2} uv - U,V coordinates at point of intersection.
   * @property {Vector2} uv1 - Second set of U,V coordinates at point of intersection.
   * @property {Vector3} uv1 - Interpolated normal vector at point of intersection.
   * @property {number} instanceId - The index number of the instance where the ray
   * intersects the {@link InstancedMesh}.
   */
  /**
   * Checks all intersection between the ray and the object with or without the
   * descendants. Intersections are returned sorted by distance, closest first.
   *
   * `Raycaster` delegates to the `raycast()` method of the passed 3D object, when
   * evaluating whether the ray intersects the object or not. This allows meshes to respond
   * differently to ray casting than lines or points.
   *
   * Note that for meshes, faces must be pointed towards the origin of the ray in order
   * to be detected; intersections of the ray passing through the back of a face will not
   * be detected. To raycast against both faces of an object, you'll want to set  {@link Material#side}
   * to `THREE.DoubleSide`.
   *
   * @param {Object3D} object - The 3D object to check for intersection with the ray.
   * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
   * Otherwise it only checks intersection with the object.
   * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
   * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
   */
  intersectObject(e, n = !0, r = []) {
    return w1(e, this, r, n), r.sort(q4), r;
  }
  /**
   * Checks all intersection between the ray and the objects with or without
   * the descendants. Intersections are returned sorted by distance, closest first.
   *
   * @param {Array<Object3D>} objects - The 3D objects to check for intersection with the ray.
   * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
   * Otherwise it only checks intersection with the object.
   * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
   * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
   */
  intersectObjects(e, n = !0, r = []) {
    for (let i = 0, o = e.length; i < o; i++)
      w1(e[i], this, r, n);
    return r.sort(q4), r;
  }
}
function q4(t, e) {
  return t.distance - e.distance;
}
function w1(t, e, n, r) {
  let i = !0;
  if (t.layers.test(e.layers) && t.raycast(e, n) === !1 && (i = !1), i === !0 && r === !0) {
    const o = t.children;
    for (let a = 0, s = o.length; a < s; a++)
      w1(o[a], e, n, !0);
  }
}
function X4(t, e, n, r) {
  const i = qee(r);
  switch (n) {
    case E9:
      return t * e;
    case M9:
      return t * e;
    case T9:
      return t * e * 2;
    case A9:
      return t * e / i.components * i.byteLength;
    case C2:
      return t * e / i.components * i.byteLength;
    case P9:
      return t * e * 2 / i.components * i.byteLength;
    case E2:
      return t * e * 2 / i.components * i.byteLength;
    case S9:
      return t * e * 3 / i.components * i.byteLength;
    case br:
      return t * e * 4 / i.components * i.byteLength;
    case S2:
      return t * e * 4 / i.components * i.byteLength;
    case Cu:
    case Eu:
      return Math.floor((t + 3) / 4) * Math.floor((e + 3) / 4) * 8;
    case Su:
    case Mu:
      return Math.floor((t + 3) / 4) * Math.floor((e + 3) / 4) * 16;
    case Yh:
    case Kh:
      return Math.max(t, 16) * Math.max(e, 8) / 4;
    case Xh:
    case Zh:
      return Math.max(t, 8) * Math.max(e, 8) / 2;
    case Jh:
    case Qh:
      return Math.floor((t + 3) / 4) * Math.floor((e + 3) / 4) * 8;
    case e1:
      return Math.floor((t + 3) / 4) * Math.floor((e + 3) / 4) * 16;
    case t1:
      return Math.floor((t + 3) / 4) * Math.floor((e + 3) / 4) * 16;
    case n1:
      return Math.floor((t + 4) / 5) * Math.floor((e + 3) / 4) * 16;
    case r1:
      return Math.floor((t + 4) / 5) * Math.floor((e + 4) / 5) * 16;
    case i1:
      return Math.floor((t + 5) / 6) * Math.floor((e + 4) / 5) * 16;
    case o1:
      return Math.floor((t + 5) / 6) * Math.floor((e + 5) / 6) * 16;
    case a1:
      return Math.floor((t + 7) / 8) * Math.floor((e + 4) / 5) * 16;
    case s1:
      return Math.floor((t + 7) / 8) * Math.floor((e + 5) / 6) * 16;
    case l1:
      return Math.floor((t + 7) / 8) * Math.floor((e + 7) / 8) * 16;
    case c1:
      return Math.floor((t + 9) / 10) * Math.floor((e + 4) / 5) * 16;
    case u1:
      return Math.floor((t + 9) / 10) * Math.floor((e + 5) / 6) * 16;
    case d1:
      return Math.floor((t + 9) / 10) * Math.floor((e + 7) / 8) * 16;
    case f1:
      return Math.floor((t + 9) / 10) * Math.floor((e + 9) / 10) * 16;
    case h1:
      return Math.floor((t + 11) / 12) * Math.floor((e + 9) / 10) * 16;
    case p1:
      return Math.floor((t + 11) / 12) * Math.floor((e + 11) / 12) * 16;
    case Tu:
    case m1:
    case v1:
      return Math.ceil(t / 4) * Math.ceil(e / 4) * 16;
    case R9:
    case g1:
      return Math.ceil(t / 4) * Math.ceil(e / 4) * 8;
    case y1:
    case b1:
      return Math.ceil(t / 4) * Math.ceil(e / 4) * 16;
  }
  throw new Error(
    `Unable to determine texture byte length for ${n} format.`
  );
}
function qee(t) {
  switch (t) {
    case di:
    case w9:
      return { byteLength: 1, components: 1 };
    case Nl:
    case _9:
    case lc:
      return { byteLength: 2, components: 1 };
    case w2:
    case _2:
      return { byteLength: 2, components: 4 };
    case Uo:
    case x2:
    case ri:
      return { byteLength: 4, components: 1 };
    case C9:
      return { byteLength: 4, components: 3 };
  }
  throw new Error(`Unknown texture type ${t}.`);
}
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
  revision: b2
} }));
typeof window < "u" && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = b2);
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
function V9() {
  let t = null, e = !1, n = null, r = null;
  function i(o, a) {
    n(o, a), r = t.requestAnimationFrame(i);
  }
  return {
    start: function() {
      e !== !0 && n !== null && (r = t.requestAnimationFrame(i), e = !0);
    },
    stop: function() {
      t.cancelAnimationFrame(r), e = !1;
    },
    setAnimationLoop: function(o) {
      n = o;
    },
    setContext: function(o) {
      t = o;
    }
  };
}
function Xee(t) {
  const e = /* @__PURE__ */ new WeakMap();
  function n(s, l) {
    const c = s.array, u = s.usage, d = c.byteLength, f = t.createBuffer();
    t.bindBuffer(l, f), t.bufferData(l, c, u), s.onUploadCallback();
    let h;
    if (c instanceof Float32Array)
      h = t.FLOAT;
    else if (c instanceof Uint16Array)
      s.isFloat16BufferAttribute ? h = t.HALF_FLOAT : h = t.UNSIGNED_SHORT;
    else if (c instanceof Int16Array)
      h = t.SHORT;
    else if (c instanceof Uint32Array)
      h = t.UNSIGNED_INT;
    else if (c instanceof Int32Array)
      h = t.INT;
    else if (c instanceof Int8Array)
      h = t.BYTE;
    else if (c instanceof Uint8Array)
      h = t.UNSIGNED_BYTE;
    else if (c instanceof Uint8ClampedArray)
      h = t.UNSIGNED_BYTE;
    else
      throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + c);
    return {
      buffer: f,
      type: h,
      bytesPerElement: c.BYTES_PER_ELEMENT,
      version: s.version,
      size: d
    };
  }
  function r(s, l, c) {
    const u = l.array, d = l.updateRanges;
    if (t.bindBuffer(c, s), d.length === 0)
      t.bufferSubData(c, 0, u);
    else {
      d.sort((h, v) => h.start - v.start);
      let f = 0;
      for (let h = 1; h < d.length; h++) {
        const v = d[f], g = d[h];
        g.start <= v.start + v.count + 1 ? v.count = Math.max(
          v.count,
          g.start + g.count - v.start
        ) : (++f, d[f] = g);
      }
      d.length = f + 1;
      for (let h = 0, v = d.length; h < v; h++) {
        const g = d[h];
        t.bufferSubData(
          c,
          g.start * u.BYTES_PER_ELEMENT,
          u,
          g.start,
          g.count
        );
      }
      l.clearUpdateRanges();
    }
    l.onUploadCallback();
  }
  function i(s) {
    return s.isInterleavedBufferAttribute && (s = s.data), e.get(s);
  }
  function o(s) {
    s.isInterleavedBufferAttribute && (s = s.data);
    const l = e.get(s);
    l && (t.deleteBuffer(l.buffer), e.delete(s));
  }
  function a(s, l) {
    if (s.isInterleavedBufferAttribute && (s = s.data), s.isGLBufferAttribute) {
      const u = e.get(s);
      (!u || u.version < s.version) && e.set(s, {
        buffer: s.buffer,
        type: s.type,
        bytesPerElement: s.elementSize,
        version: s.version
      });
      return;
    }
    const c = e.get(s);
    if (c === void 0)
      e.set(s, n(s, l));
    else if (c.version < s.version) {
      if (c.size !== s.array.byteLength)
        throw new Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
      r(c.buffer, s, l), c.version = s.version;
    }
  }
  return {
    get: i,
    remove: o,
    update: a
  };
}
var Yee = `#ifdef USE_ALPHAHASH
	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;
#endif`, Zee = `#ifdef USE_ALPHAHASH
	const float ALPHA_HASH_SCALE = 0.05;
	float hash2D( vec2 value ) {
		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );
	}
	float hash3D( vec3 value ) {
		return hash2D( vec2( hash2D( value.xy ), value.z ) );
	}
	float getAlphaHashThreshold( vec3 position ) {
		float maxDeriv = max(
			length( dFdx( position.xyz ) ),
			length( dFdy( position.xyz ) )
		);
		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );
		vec2 pixScales = vec2(
			exp2( floor( log2( pixScale ) ) ),
			exp2( ceil( log2( pixScale ) ) )
		);
		vec2 alpha = vec2(
			hash3D( floor( pixScales.x * position.xyz ) ),
			hash3D( floor( pixScales.y * position.xyz ) )
		);
		float lerpFactor = fract( log2( pixScale ) );
		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;
		float a = min( lerpFactor, 1.0 - lerpFactor );
		vec3 cases = vec3(
			x * x / ( 2.0 * a * ( 1.0 - a ) ),
			( x - 0.5 * a ) / ( 1.0 - a ),
			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )
		);
		float threshold = ( x < ( 1.0 - a ) )
			? ( ( x < a ) ? cases.x : cases.y )
			: cases.z;
		return clamp( threshold , 1.0e-6, 1.0 );
	}
#endif`, Kee = `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;
#endif`, Jee = `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, Qee = `#ifdef USE_ALPHATEST
	#ifdef ALPHA_TO_COVERAGE
	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );
	if ( diffuseColor.a == 0.0 ) discard;
	#else
	if ( diffuseColor.a < alphaTest ) discard;
	#endif
#endif`, ete = `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`, tte = `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_CLEARCOAT ) 
		clearcoatSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_SHEEN ) 
		sheenSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`, nte = `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`, rte = `#ifdef USE_BATCHING
	#if ! defined( GL_ANGLE_multi_draw )
	#define gl_DrawID _gl_DrawID
	uniform int _gl_DrawID;
	#endif
	uniform highp sampler2D batchingTexture;
	uniform highp usampler2D batchingIdTexture;
	mat4 getBatchingMatrix( const in float i ) {
		int size = textureSize( batchingTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
	float getIndirectIndex( const in int i ) {
		int size = textureSize( batchingIdTexture, 0 ).x;
		int x = i % size;
		int y = i / size;
		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );
	}
#endif
#ifdef USE_BATCHING_COLOR
	uniform sampler2D batchingColorTexture;
	vec3 getBatchingColor( const in float i ) {
		int size = textureSize( batchingColorTexture, 0 ).x;
		int j = int( i );
		int x = j % size;
		int y = j / size;
		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;
	}
#endif`, ite = `#ifdef USE_BATCHING
	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );
#endif`, ote = `vec3 transformed = vec3( position );
#ifdef USE_ALPHAHASH
	vPosition = vec3( position );
#endif`, ate = `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`, ste = `float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
} // validated`, lte = `#ifdef USE_IRIDESCENCE
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {
		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
	}
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
	}
	float IorToFresnel0( float transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
	}
	vec3 evalSensitivity( float OPD, vec3 shift ) {
		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;
		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;
	}
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
		vec3 I;
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {
			return vec3( 1.0 );
		}
		float cosTheta2 = sqrt( cosTheta2Sq );
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
		vec3 C0 = R12 + Rs;
		I = C0;
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {
			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;
		}
		return max( I, vec3( 0.0 ) );
	}
#endif`, cte = `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vBumpMapUv );
		vec2 dSTdy = dFdy( vBumpMapUv );
		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );
		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`, ute = `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#ifdef ALPHA_TO_COVERAGE
		float distanceToPlane, distanceGradient;
		float clipOpacity = 1.0;
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
			distanceGradient = fwidth( distanceToPlane ) / 2.0;
			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			if ( clipOpacity == 0.0 ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			float unionClipOpacity = 1.0;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
				distanceGradient = fwidth( distanceToPlane ) / 2.0;
				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			}
			#pragma unroll_loop_end
			clipOpacity *= 1.0 - unionClipOpacity;
		#endif
		diffuseColor.a *= clipOpacity;
		if ( diffuseColor.a == 0.0 ) discard;
	#else
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			bool clipped = true;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
			}
			#pragma unroll_loop_end
			if ( clipped ) discard;
		#endif
	#endif
#endif`, dte = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`, fte = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`, hte = `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`, pte = `#if defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#elif defined( USE_COLOR )
	diffuseColor.rgb *= vColor;
#endif`, mte = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR )
	varying vec3 vColor;
#endif`, vte = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	varying vec3 vColor;
#endif`, gte = `#if defined( USE_COLOR_ALPHA )
	vColor = vec4( 1.0 );
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	vColor = vec3( 1.0 );
#endif
#ifdef USE_COLOR
	vColor *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.xyz *= instanceColor.xyz;
#endif
#ifdef USE_BATCHING_COLOR
	vec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );
	vColor.xyz *= batchingColor.xyz;
#endif`, yte = `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
#ifdef USE_ALPHAHASH
	varying vec3 vPosition;
#endif
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );
}
mat3 transposeMat3( const in mat3 m ) {
	mat3 tmp;
	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );
	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );
	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );
	return tmp;
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}
vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
} // validated`, bte = `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define cubeUV_r0 1.0
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= cubeUV_r1 ) {
			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;
		} else if ( roughness >= cubeUV_r4 ) {
			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;
		} else if ( roughness >= cubeUV_r5 ) {
			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;
		} else if ( roughness >= cubeUV_r6 ) {
			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`, xte = `vec3 transformedNormal = objectNormal;
#ifdef USE_TANGENT
	vec3 transformedTangent = objectTangent;
#endif
#ifdef USE_BATCHING
	mat3 bm = mat3( batchingMatrix );
	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );
	transformedNormal = bm * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = bm * transformedTangent;
	#endif
#endif
#ifdef USE_INSTANCING
	mat3 im = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );
	transformedNormal = im * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = im * transformedTangent;
	#endif
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;
	#ifdef FLIP_SIDED
		transformedTangent = - transformedTangent;
	#endif
#endif`, wte = `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`, _te = `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );
#endif`, Cte = `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );
	#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE
		emissiveColor = sRGBTransferEOTF( emissiveColor );
	#endif
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`, Ete = `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`, Ste = "gl_FragColor = linearToOutputTexel( gl_FragColor );", Mte = `vec4 LinearTransferOETF( in vec4 value ) {
	return value;
}
vec4 sRGBTransferEOTF( in vec4 value ) {
	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );
}
vec4 sRGBTransferOETF( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}`, Tte = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );
	#else
		vec4 envColor = vec4( 0.0 );
	#endif
	#ifdef ENVMAP_BLENDING_MULTIPLY
		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_MIX )
		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_ADD )
		outgoingLight += envColor.xyz * specularStrength * reflectivity;
	#endif
#endif`, Ate = `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform float flipEnvMap;
	uniform mat3 envMapRotation;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
	
#endif`, Pte = `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`, Rte = `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`, Lte = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`, Ote = `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`, Dte = `#ifdef USE_FOG
	varying float vFogDepth;
#endif`, kte = `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`, Nte = `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`, Ite = `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );
	#endif
}`, Fte = `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`, Ute = `LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;`, zte = `varying vec3 vViewPosition;
struct LambertMaterial {
	vec3 diffuseColor;
	float specularStrength;
};
void RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert`, Hte = `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
#if defined( USE_LIGHT_PROBES )
	uniform vec3 lightProbe[ 9 ];
#endif
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
	if ( cutoffDistance > 0.0 ) {
		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
	}
	return distanceFalloff;
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif`, Bte = `#ifdef USE_ENVMAP
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );
			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	#ifdef USE_ANISOTROPY
		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {
			#ifdef ENVMAP_TYPE_CUBE_UV
				vec3 bentNormal = cross( bitangent, viewDir );
				bentNormal = normalize( cross( bentNormal, bitangent ) );
				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );
				return getIBLRadiance( viewDir, bentNormal, roughness );
			#else
				return vec3( 0.0 );
			#endif
		}
	#endif
#endif`, Vte = `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`, $te = `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon`, Wte = `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`, jte = `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong`, Gte = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );
vec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	material.ior = ior;
	#ifdef USE_SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULAR_COLORMAP
			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;
		#endif
		#ifdef USE_SPECULAR_INTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_DISPERSION
	material.dispersion = dispersion;
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEEN_COLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );
	#ifdef USE_SHEEN_ROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;
	#endif
#endif
#ifdef USE_ANISOTROPY
	#ifdef USE_ANISOTROPYMAP
		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );
		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;
		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;
	#else
		vec2 anisotropyV = anisotropyVector;
	#endif
	material.anisotropy = length( anisotropyV );
	if( material.anisotropy == 0.0 ) {
		anisotropyV = vec2( 1.0, 0.0 );
	} else {
		anisotropyV /= material.anisotropy;
		material.anisotropy = saturate( material.anisotropy );
	}
	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );
	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;
	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;
#endif`, qte = `struct PhysicalMaterial {
	vec3 diffuseColor;
	float roughness;
	vec3 specularColor;
	float specularF90;
	float dispersion;
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
	#ifdef IOR
		float ior;
	#endif
	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif
	#ifdef USE_ANISOTROPY
		float anisotropy;
		float alphaT;
		vec3 anisotropyT;
		vec3 anisotropyB;
	#endif
};
vec3 clearcoatSpecularDirect = vec3( 0.0 );
vec3 clearcoatSpecularIndirect = vec3( 0.0 );
vec3 sheenSpecularDirect = vec3( 0.0 );
vec3 sheenSpecularIndirect = vec3(0.0 );
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
#ifdef USE_ANISOTROPY
	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {
		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );
		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );
		float v = 0.5 / ( gv + gl );
		return saturate(v);
	}
	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {
		float a2 = alphaT * alphaB;
		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );
		highp float v2 = dot( v, v );
		float w2 = a2 / v2;
		return RECIPROCAL_PI * a2 * pow2 ( w2 );
	}
#endif
#ifdef USE_CLEARCOAT
	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {
		vec3 f0 = material.clearcoatF0;
		float f90 = material.clearcoatF90;
		float roughness = material.clearcoatRoughness;
		float alpha = pow2( roughness );
		vec3 halfDir = normalize( lightDir + viewDir );
		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );
		vec3 F = F_Schlick( f0, f90, dotVH );
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
		return F * ( V * D );
	}
#endif
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {
	vec3 f0 = material.specularColor;
	float f90 = material.specularF90;
	float roughness = material.roughness;
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	#ifdef USE_IRIDESCENCE
		F = mix( F, material.iridescenceFresnel, material.iridescence );
	#endif
	#ifdef USE_ANISOTROPY
		float dotTL = dot( material.anisotropyT, lightDir );
		float dotTV = dot( material.anisotropyT, viewDir );
		float dotTH = dot( material.anisotropyT, halfDir );
		float dotBL = dot( material.anisotropyB, lightDir );
		float dotBV = dot( material.anisotropyB, viewDir );
		float dotBH = dot( material.anisotropyB, halfDir );
		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );
		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );
	#else
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
	#endif
	return F * ( V * D );
}
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;
	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;
	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );
	return saturate( DG * RECIPROCAL_PI );
}
vec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );
	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );
	vec4 r = roughness * c0 + c1;
	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;
	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;
	return fab;
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometryNormal;
		vec3 viewDir = geometryViewDir;
		vec3 position = geometryPosition;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );
	#endif
	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
	#endif
	vec3 singleScattering = vec3( 0.0 );
	vec3 multiScattering = vec3( 0.0 );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );
	#else
		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );
	#endif
	vec3 totalScattering = singleScattering + multiScattering;
	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );
	reflectedLight.indirectSpecular += radiance * singleScattering;
	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;
	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`, Xte = `
vec3 geometryPosition = - vViewPosition;
vec3 geometryNormal = normal;
vec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
vec3 geometryClearcoatNormal = vec3( 0.0 );
#ifdef USE_CLEARCOAT
	geometryClearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
	float dotNVi = saturate( dot( normal, geometryViewDir ) );
	if ( material.iridescenceThickness == 0.0 ) {
		material.iridescence = 0.0;
	} else {
		material.iridescence = saturate( material.iridescence );
	}
	if ( material.iridescence > 0.0 ) {
		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );
	}
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometryPosition, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometryPosition, directLight );
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif
		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif
		#undef SPOT_LIGHT_MAP_INDEX
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	#if defined( USE_LIGHT_PROBES )
		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );
	#endif
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );
		}
		#pragma unroll_loop_end
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`, Yte = `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )
		iblIrradiance += getIBLIrradiance( geometryNormal );
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	#ifdef USE_ANISOTROPY
		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );
	#else
		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );
	#endif
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`, Zte = `#if defined( RE_IndirectDiffuse )
	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif`, Kte = `#if defined( USE_LOGDEPTHBUF )
	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`, Jte = `#if defined( USE_LOGDEPTHBUF )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, Qte = `#ifdef USE_LOGDEPTHBUF
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, ene = `#ifdef USE_LOGDEPTHBUF
	vFragDepth = 1.0 + gl_Position.w;
	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
#endif`, tne = `#ifdef USE_MAP
	vec4 sampledDiffuseColor = texture2D( map, vMapUv );
	#ifdef DECODE_VIDEO_TEXTURE
		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );
	#endif
	diffuseColor *= sampledDiffuseColor;
#endif`, nne = `#ifdef USE_MAP
	uniform sampler2D map;
#endif`, rne = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	#if defined( USE_POINTS_UV )
		vec2 uv = vUv;
	#else
		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
	#endif
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`, ine = `#if defined( USE_POINTS_UV )
	varying vec2 vUv;
#else
	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
		uniform mat3 uvTransform;
	#endif
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, one = `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );
	metalnessFactor *= texelMetalness.b;
#endif`, ane = `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`, sne = `#ifdef USE_INSTANCING_MORPH
	float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;
	}
#endif`, lne = `#if defined( USE_MORPHCOLORS )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`, cne = `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
	}
#endif`, une = `#ifdef USE_MORPHTARGETS
	#ifndef USE_INSTANCING_MORPH
		uniform float morphTargetBaseInfluence;
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	#endif
	uniform sampler2DArray morphTargetsTexture;
	uniform ivec2 morphTargetsTextureSize;
	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
		int y = texelIndex / morphTargetsTextureSize.x;
		int x = texelIndex - y * morphTargetsTextureSize.x;
		ivec3 morphUV = ivec3( x, y, morphTargetIndex );
		return texelFetch( morphTargetsTexture, morphUV, 0 );
	}
#endif`, dne = `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
	}
#endif`, fne = `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal *= faceDirection;
	#endif
#endif
#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )
	#ifdef USE_TANGENT
		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn = getTangentFrame( - vViewPosition, normal,
		#if defined( USE_NORMALMAP )
			vNormalMapUv
		#elif defined( USE_CLEARCOAT_NORMALMAP )
			vClearcoatNormalMapUv
		#else
			vUv
		#endif
		);
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn[0] *= faceDirection;
		tbn[1] *= faceDirection;
	#endif
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	#ifdef USE_TANGENT
		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn2[0] *= faceDirection;
		tbn2[1] *= faceDirection;
	#endif
#endif
vec3 nonPerturbedNormal = normal;`, hne = `#ifdef USE_NORMALMAP_OBJECTSPACE
	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( USE_NORMALMAP_TANGENTSPACE )
	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	mapN.xy *= normalScale;
	normal = normalize( tbn * mapN );
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`, pne = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, mne = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, vne = `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
	#endif
#endif`, gne = `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef USE_NORMALMAP_OBJECTSPACE
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )
	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {
		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( uv.st );
		vec2 st1 = dFdy( uv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );
		return mat3( T * scale, B * scale, N );
	}
#endif`, yne = `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = nonPerturbedNormal;
#endif`, bne = `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	clearcoatNormal = normalize( tbn2 * clearcoatMapN );
#endif`, xne = `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif`, wne = `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`, _ne = `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`, Cne = `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;
const float Inv255 = 1. / 255.;
const vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );
const vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );
const vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );
const vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );
vec4 packDepthToRGBA( const in float v ) {
	if( v <= 0.0 )
		return vec4( 0., 0., 0., 0. );
	if( v >= 1.0 )
		return vec4( 1., 1., 1., 1. );
	float vuf;
	float af = modf( v * PackFactors.a, vuf );
	float bf = modf( vuf * ShiftRight8, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );
}
vec3 packDepthToRGB( const in float v ) {
	if( v <= 0.0 )
		return vec3( 0., 0., 0. );
	if( v >= 1.0 )
		return vec3( 1., 1., 1. );
	float vuf;
	float bf = modf( v * PackFactors.b, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec3( vuf * Inv255, gf * PackUpscale, bf );
}
vec2 packDepthToRG( const in float v ) {
	if( v <= 0.0 )
		return vec2( 0., 0. );
	if( v >= 1.0 )
		return vec2( 1., 1. );
	float vuf;
	float gf = modf( v * 256., vuf );
	return vec2( vuf * Inv255, gf );
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors4 );
}
float unpackRGBToDepth( const in vec3 v ) {
	return dot( v, UnpackFactors3 );
}
float unpackRGToDepth( const in vec2 v ) {
	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;
}
vec4 pack2HalfToRGBA( const in vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( const in vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return depth * ( near - far ) - near;
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return ( near * far ) / ( ( far - near ) * depth - far );
}`, Ene = `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`, Sne = `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_BATCHING
	mvPosition = batchingMatrix * mvPosition;
#endif
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`, Mne = `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`, Tne = `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`, Ane = `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );
	roughnessFactor *= texelRoughness.g;
#endif`, Pne = `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`, Rne = `#if NUM_SPOT_LIGHT_COORDS > 0
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#if NUM_SPOT_LIGHT_MAPS > 0
	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {
		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );
	}
	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {
		return unpackRGBATo2Half( texture2D( shadow, uv ) );
	}
	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){
		float occlusion = 1.0;
		vec2 distribution = texture2DDistribution( shadow, uv );
		float hard_shadow = step( compare , distribution.x );
		if (hard_shadow != 1.0 ) {
			float distance = compare - distribution.x ;
			float variance = max( 0.00000, distribution.y * distribution.y );
			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );
		}
		return occlusion;
	}
	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
		float shadow = 1.0;
		shadowCoord.xyz /= shadowCoord.w;
		shadowCoord.z += shadowBias;
		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
		if ( frustumTest ) {
		#if defined( SHADOWMAP_TYPE_PCF )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx0 = - texelSize.x * shadowRadius;
			float dy0 = - texelSize.y * shadowRadius;
			float dx1 = + texelSize.x * shadowRadius;
			float dy1 = + texelSize.y * shadowRadius;
			float dx2 = dx0 / 2.0;
			float dy2 = dy0 / 2.0;
			float dx3 = dx1 / 2.0;
			float dy3 = dy1 / 2.0;
			shadow = (
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )
			) * ( 1.0 / 17.0 );
		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx = texelSize.x;
			float dy = texelSize.y;
			vec2 uv = shadowCoord.xy;
			vec2 f = fract( uv * shadowMapSize + 0.5 );
			uv -= f * texelSize;
			shadow = (
				texture2DCompare( shadowMap, uv, shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
						  f.x ),
					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
						  f.x ),
					 f.y )
			) * ( 1.0 / 9.0 );
		#elif defined( SHADOWMAP_TYPE_VSM )
			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );
		#else
			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );
		#endif
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
	vec2 cubeToUV( vec3 v, float texelSizeY ) {
		vec3 absV = abs( v );
		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
		absV *= scaleToCube;
		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );
		vec2 planar = v.xy;
		float almostATexel = 1.5 * texelSizeY;
		float almostOne = 1.0 - almostATexel;
		if ( absV.z >= almostOne ) {
			if ( v.z > 0.0 )
				planar.x = 4.0 - v.x;
		} else if ( absV.x >= almostOne ) {
			float signX = sign( v.x );
			planar.x = v.z * signX + 2.0 * signX;
		} else if ( absV.y >= almostOne ) {
			float signY = sign( v.y );
			planar.x = v.x + 2.0 * signY + 2.0;
			planar.y = v.z * signY - 2.0;
		}
		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );
	}
	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		float shadow = 1.0;
		vec3 lightToPosition = shadowCoord.xyz;
		
		float lightToPositionLength = length( lightToPosition );
		if ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {
			float dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );			dp += shadowBias;
			vec3 bd3D = normalize( lightToPosition );
			vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );
			#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )
				vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;
				shadow = (
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )
				) * ( 1.0 / 9.0 );
			#else
				shadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );
			#endif
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
#endif`, Lne = `#if NUM_SPOT_LIGHT_COORDS > 0
	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`, One = `#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )
	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
	vec4 shadowWorldPosition;
#endif
#if defined( USE_SHADOWMAP )
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
#endif
#if NUM_SPOT_LIGHT_COORDS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {
		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
#endif`, Dne = `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`, kne = `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`, Nne = `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	mat4 getBoneMatrix( const in float i ) {
		int size = textureSize( boneTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
#endif`, Ine = `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`, Fne = `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`, Une = `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`, zne = `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`, Hne = `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`, Bne = `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return saturate( toneMappingExposure * color );
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 CineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
const mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(
	vec3( 1.6605, - 0.1246, - 0.0182 ),
	vec3( - 0.5876, 1.1329, - 0.1006 ),
	vec3( - 0.0728, - 0.0083, 1.1187 )
);
const mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(
	vec3( 0.6274, 0.0691, 0.0164 ),
	vec3( 0.3293, 0.9195, 0.0880 ),
	vec3( 0.0433, 0.0113, 0.8956 )
);
vec3 agxDefaultContrastApprox( vec3 x ) {
	vec3 x2 = x * x;
	vec3 x4 = x2 * x2;
	return + 15.5 * x4 * x2
		- 40.14 * x4 * x
		+ 31.96 * x4
		- 6.868 * x2 * x
		+ 0.4298 * x2
		+ 0.1191 * x
		- 0.00232;
}
vec3 AgXToneMapping( vec3 color ) {
	const mat3 AgXInsetMatrix = mat3(
		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),
		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),
		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )
	);
	const mat3 AgXOutsetMatrix = mat3(
		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),
		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),
		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )
	);
	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;
	color *= toneMappingExposure;
	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;
	color = AgXInsetMatrix * color;
	color = max( color, 1e-10 );	color = log2( color );
	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );
	color = clamp( color, 0.0, 1.0 );
	color = agxDefaultContrastApprox( color );
	color = AgXOutsetMatrix * color;
	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );
	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;
	color = clamp( color, 0.0, 1.0 );
	return color;
}
vec3 NeutralToneMapping( vec3 color ) {
	const float StartCompression = 0.8 - 0.04;
	const float Desaturation = 0.15;
	color *= toneMappingExposure;
	float x = min( color.r, min( color.g, color.b ) );
	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;
	color -= offset;
	float peak = max( color.r, max( color.g, color.b ) );
	if ( peak < StartCompression ) return color;
	float d = 1. - StartCompression;
	float newPeak = 1. - d * d / ( peak + d - StartCompression );
	color *= newPeak / peak;
	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );
	return mix( color, vec3( newPeak ), g );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`, Vne = `#ifdef USE_TRANSMISSION
	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );
	vec4 transmitted = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );
	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );
	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );
#endif`, $ne = `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	float w0( float a ) {
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );
	}
	float w1( float a ) {
		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );
	}
	float w2( float a ){
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );
	}
	float w3( float a ) {
		return ( 1.0 / 6.0 ) * ( a * a * a );
	}
	float g0( float a ) {
		return w0( a ) + w1( a );
	}
	float g1( float a ) {
		return w2( a ) + w3( a );
	}
	float h0( float a ) {
		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );
	}
	float h1( float a ) {
		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );
	}
	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {
		uv = uv * texelSize.zw + 0.5;
		vec2 iuv = floor( uv );
		vec2 fuv = fract( uv );
		float g0x = g0( fuv.x );
		float g1x = g1( fuv.x );
		float h0x = h0( fuv.x );
		float h1x = h1( fuv.x );
		float h0y = h0( fuv.y );
		float h1y = h1( fuv.y );
		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +
			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );
	}
	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {
		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );
		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );
		vec2 fLodSizeInv = 1.0 / fLodSize;
		vec2 cLodSizeInv = 1.0 / cLodSize;
		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );
		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );
		return mix( fSample, cSample, fract( lod ) );
	}
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );
	}
	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( isinf( attenuationDistance ) ) {
			return vec3( 1.0 );
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec4 transmittedLight;
		vec3 transmittance;
		#ifdef USE_DISPERSION
			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;
			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );
			for ( int i = 0; i < 3; i ++ ) {
				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );
				vec3 refractedRayExit = position + transmissionRay;
				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
				vec2 refractionCoords = ndcPos.xy / ndcPos.w;
				refractionCoords += 1.0;
				refractionCoords /= 2.0;
				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );
				transmittedLight[ i ] = transmissionSample[ i ];
				transmittedLight.a += transmissionSample.a;
				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];
			}
			transmittedLight.a /= 3.0;
		#else
			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
			vec3 refractedRayExit = position + transmissionRay;
			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
			vec2 refractionCoords = ndcPos.xy / ndcPos.w;
			refractionCoords += 1.0;
			refractionCoords /= 2.0;
			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );
		#endif
		vec3 attenuatedColor = transmittance * transmittedLight.rgb;
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;
		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );
	}
#endif`, Wne = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_SPECULARMAP
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`, jne = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	uniform mat3 mapTransform;
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	uniform mat3 alphaMapTransform;
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	uniform mat3 lightMapTransform;
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	uniform mat3 aoMapTransform;
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	uniform mat3 bumpMapTransform;
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	uniform mat3 normalMapTransform;
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_DISPLACEMENTMAP
	uniform mat3 displacementMapTransform;
	varying vec2 vDisplacementMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	uniform mat3 emissiveMapTransform;
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	uniform mat3 metalnessMapTransform;
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	uniform mat3 roughnessMapTransform;
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	uniform mat3 anisotropyMapTransform;
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	uniform mat3 clearcoatMapTransform;
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform mat3 clearcoatNormalMapTransform;
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform mat3 clearcoatRoughnessMapTransform;
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	uniform mat3 sheenColorMapTransform;
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	uniform mat3 sheenRoughnessMapTransform;
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	uniform mat3 iridescenceMapTransform;
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform mat3 iridescenceThicknessMapTransform;
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SPECULARMAP
	uniform mat3 specularMapTransform;
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	uniform mat3 specularColorMapTransform;
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	uniform mat3 specularIntensityMapTransform;
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`, Gne = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	vUv = vec3( uv, 1 ).xy;
#endif
#ifdef USE_MAP
	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ALPHAMAP
	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_LIGHTMAP
	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_AOMAP
	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_BUMPMAP
	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_NORMALMAP
	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_DISPLACEMENTMAP
	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_EMISSIVEMAP
	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_METALNESSMAP
	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ROUGHNESSMAP
	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ANISOTROPYMAP
	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOATMAP
	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCEMAP
	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_COLORMAP
	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULARMAP
	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_COLORMAP
	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_TRANSMISSIONMAP
	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_THICKNESSMAP
	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;
#endif`, qne = `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_BATCHING
		worldPosition = batchingMatrix * worldPosition;
	#endif
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`;
const Xne = `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`, Yne = `uniform sampler2D t2D;
uniform float backgroundIntensity;
varying vec2 vUv;
void main() {
	vec4 texColor = texture2D( t2D, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, Zne = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, Kne = `#ifdef ENVMAP_TYPE_CUBE
	uniform samplerCube envMap;
#elif defined( ENVMAP_TYPE_CUBE_UV )
	uniform sampler2D envMap;
#endif
uniform float flipEnvMap;
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
uniform mat3 backgroundRotation;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	#ifdef ENVMAP_TYPE_CUBE
		vec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );
	#else
		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, Jne = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, Qne = `uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;
varying vec3 vWorldDirection;
void main() {
	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );
	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, ere = `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`, tre = `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <logdepthbuf_fragment>
	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#elif DEPTH_PACKING == 3202
		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );
	#elif DEPTH_PACKING == 3203
		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );
	#endif
}`, nre = `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`, rre = `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <clipping_planes_pars_fragment>
void main () {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = packDepthToRGBA( dist );
}`, ire = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`, ore = `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, are = `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, sre = `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, lre = `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`, cre = `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, ure = `#define LAMBERT
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, dre = `#define LAMBERT
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, fre = `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`, hre = `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, pre = `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	vViewPosition = - mvPosition.xyz;
#endif
}`, mre = `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <packing>
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`, vre = `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, gre = `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, yre = `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`, bre = `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define USE_SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef USE_SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULAR_COLORMAP
		uniform sampler2D specularColorMap;
	#endif
	#ifdef USE_SPECULAR_INTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_DISPERSION
	uniform float dispersion;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEEN_COLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEEN_ROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
#ifdef USE_ANISOTROPY
	uniform vec2 anisotropyVector;
	#ifdef USE_ANISOTROPYMAP
		uniform sampler2D anisotropyMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );
		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;
	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;
	#endif
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, xre = `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, wre = `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, _re = `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
#ifdef USE_POINTS_UV
	varying vec2 vUv;
	uniform mat3 uvTransform;
#endif
void main() {
	#ifdef USE_POINTS_UV
		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	#endif
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`, Cre = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, Ere = `#include <common>
#include <batching_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, Sre = `uniform vec3 color;
uniform float opacity;
#include <common>
#include <packing>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <logdepthbuf_pars_fragment>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	#include <logdepthbuf_fragment>
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`, Mre = `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix[ 3 ];
	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, Tre = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`, at = {
  alphahash_fragment: Yee,
  alphahash_pars_fragment: Zee,
  alphamap_fragment: Kee,
  alphamap_pars_fragment: Jee,
  alphatest_fragment: Qee,
  alphatest_pars_fragment: ete,
  aomap_fragment: tte,
  aomap_pars_fragment: nte,
  batching_pars_vertex: rte,
  batching_vertex: ite,
  begin_vertex: ote,
  beginnormal_vertex: ate,
  bsdfs: ste,
  iridescence_fragment: lte,
  bumpmap_pars_fragment: cte,
  clipping_planes_fragment: ute,
  clipping_planes_pars_fragment: dte,
  clipping_planes_pars_vertex: fte,
  clipping_planes_vertex: hte,
  color_fragment: pte,
  color_pars_fragment: mte,
  color_pars_vertex: vte,
  color_vertex: gte,
  common: yte,
  cube_uv_reflection_fragment: bte,
  defaultnormal_vertex: xte,
  displacementmap_pars_vertex: wte,
  displacementmap_vertex: _te,
  emissivemap_fragment: Cte,
  emissivemap_pars_fragment: Ete,
  colorspace_fragment: Ste,
  colorspace_pars_fragment: Mte,
  envmap_fragment: Tte,
  envmap_common_pars_fragment: Ate,
  envmap_pars_fragment: Pte,
  envmap_pars_vertex: Rte,
  envmap_physical_pars_fragment: Bte,
  envmap_vertex: Lte,
  fog_vertex: Ote,
  fog_pars_vertex: Dte,
  fog_fragment: kte,
  fog_pars_fragment: Nte,
  gradientmap_pars_fragment: Ite,
  lightmap_pars_fragment: Fte,
  lights_lambert_fragment: Ute,
  lights_lambert_pars_fragment: zte,
  lights_pars_begin: Hte,
  lights_toon_fragment: Vte,
  lights_toon_pars_fragment: $te,
  lights_phong_fragment: Wte,
  lights_phong_pars_fragment: jte,
  lights_physical_fragment: Gte,
  lights_physical_pars_fragment: qte,
  lights_fragment_begin: Xte,
  lights_fragment_maps: Yte,
  lights_fragment_end: Zte,
  logdepthbuf_fragment: Kte,
  logdepthbuf_pars_fragment: Jte,
  logdepthbuf_pars_vertex: Qte,
  logdepthbuf_vertex: ene,
  map_fragment: tne,
  map_pars_fragment: nne,
  map_particle_fragment: rne,
  map_particle_pars_fragment: ine,
  metalnessmap_fragment: one,
  metalnessmap_pars_fragment: ane,
  morphinstance_vertex: sne,
  morphcolor_vertex: lne,
  morphnormal_vertex: cne,
  morphtarget_pars_vertex: une,
  morphtarget_vertex: dne,
  normal_fragment_begin: fne,
  normal_fragment_maps: hne,
  normal_pars_fragment: pne,
  normal_pars_vertex: mne,
  normal_vertex: vne,
  normalmap_pars_fragment: gne,
  clearcoat_normal_fragment_begin: yne,
  clearcoat_normal_fragment_maps: bne,
  clearcoat_pars_fragment: xne,
  iridescence_pars_fragment: wne,
  opaque_fragment: _ne,
  packing: Cne,
  premultiplied_alpha_fragment: Ene,
  project_vertex: Sne,
  dithering_fragment: Mne,
  dithering_pars_fragment: Tne,
  roughnessmap_fragment: Ane,
  roughnessmap_pars_fragment: Pne,
  shadowmap_pars_fragment: Rne,
  shadowmap_pars_vertex: Lne,
  shadowmap_vertex: One,
  shadowmask_pars_fragment: Dne,
  skinbase_vertex: kne,
  skinning_pars_vertex: Nne,
  skinning_vertex: Ine,
  skinnormal_vertex: Fne,
  specularmap_fragment: Une,
  specularmap_pars_fragment: zne,
  tonemapping_fragment: Hne,
  tonemapping_pars_fragment: Bne,
  transmission_fragment: Vne,
  transmission_pars_fragment: $ne,
  uv_pars_fragment: Wne,
  uv_pars_vertex: jne,
  uv_vertex: Gne,
  worldpos_vertex: qne,
  background_vert: Xne,
  background_frag: Yne,
  backgroundCube_vert: Zne,
  backgroundCube_frag: Kne,
  cube_vert: Jne,
  cube_frag: Qne,
  depth_vert: ere,
  depth_frag: tre,
  distanceRGBA_vert: nre,
  distanceRGBA_frag: rre,
  equirect_vert: ire,
  equirect_frag: ore,
  linedashed_vert: are,
  linedashed_frag: sre,
  meshbasic_vert: lre,
  meshbasic_frag: cre,
  meshlambert_vert: ure,
  meshlambert_frag: dre,
  meshmatcap_vert: fre,
  meshmatcap_frag: hre,
  meshnormal_vert: pre,
  meshnormal_frag: mre,
  meshphong_vert: vre,
  meshphong_frag: gre,
  meshphysical_vert: yre,
  meshphysical_frag: bre,
  meshtoon_vert: xre,
  meshtoon_frag: wre,
  points_vert: _re,
  points_frag: Cre,
  shadow_vert: Ere,
  shadow_frag: Sre,
  sprite_vert: Mre,
  sprite_frag: Tre
}, De = {
  common: {
    diffuse: { value: /* @__PURE__ */ new At(16777215) },
    opacity: { value: 1 },
    map: { value: null },
    mapTransform: { value: /* @__PURE__ */ new ot() },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new ot() },
    alphaTest: { value: 0 }
  },
  specularmap: {
    specularMap: { value: null },
    specularMapTransform: { value: /* @__PURE__ */ new ot() }
  },
  envmap: {
    envMap: { value: null },
    envMapRotation: { value: /* @__PURE__ */ new ot() },
    flipEnvMap: { value: -1 },
    reflectivity: { value: 1 },
    // basic, lambert, phong
    ior: { value: 1.5 },
    // physical
    refractionRatio: { value: 0.98 }
    // basic, lambert, phong
  },
  aomap: {
    aoMap: { value: null },
    aoMapIntensity: { value: 1 },
    aoMapTransform: { value: /* @__PURE__ */ new ot() }
  },
  lightmap: {
    lightMap: { value: null },
    lightMapIntensity: { value: 1 },
    lightMapTransform: { value: /* @__PURE__ */ new ot() }
  },
  bumpmap: {
    bumpMap: { value: null },
    bumpMapTransform: { value: /* @__PURE__ */ new ot() },
    bumpScale: { value: 1 }
  },
  normalmap: {
    normalMap: { value: null },
    normalMapTransform: { value: /* @__PURE__ */ new ot() },
    normalScale: { value: /* @__PURE__ */ new Pt(1, 1) }
  },
  displacementmap: {
    displacementMap: { value: null },
    displacementMapTransform: { value: /* @__PURE__ */ new ot() },
    displacementScale: { value: 1 },
    displacementBias: { value: 0 }
  },
  emissivemap: {
    emissiveMap: { value: null },
    emissiveMapTransform: { value: /* @__PURE__ */ new ot() }
  },
  metalnessmap: {
    metalnessMap: { value: null },
    metalnessMapTransform: { value: /* @__PURE__ */ new ot() }
  },
  roughnessmap: {
    roughnessMap: { value: null },
    roughnessMapTransform: { value: /* @__PURE__ */ new ot() }
  },
  gradientmap: {
    gradientMap: { value: null }
  },
  fog: {
    fogDensity: { value: 25e-5 },
    fogNear: { value: 1 },
    fogFar: { value: 2e3 },
    fogColor: { value: /* @__PURE__ */ new At(16777215) }
  },
  lights: {
    ambientLightColor: { value: [] },
    lightProbe: { value: [] },
    directionalLights: { value: [], properties: {
      direction: {},
      color: {}
    } },
    directionalLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    directionalShadowMap: { value: [] },
    directionalShadowMatrix: { value: [] },
    spotLights: { value: [], properties: {
      color: {},
      position: {},
      direction: {},
      distance: {},
      coneCos: {},
      penumbraCos: {},
      decay: {}
    } },
    spotLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    spotLightMap: { value: [] },
    spotShadowMap: { value: [] },
    spotLightMatrix: { value: [] },
    pointLights: { value: [], properties: {
      color: {},
      position: {},
      decay: {},
      distance: {}
    } },
    pointLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {},
      shadowCameraNear: {},
      shadowCameraFar: {}
    } },
    pointShadowMap: { value: [] },
    pointShadowMatrix: { value: [] },
    hemisphereLights: { value: [], properties: {
      direction: {},
      skyColor: {},
      groundColor: {}
    } },
    // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
    rectAreaLights: { value: [], properties: {
      color: {},
      position: {},
      width: {},
      height: {}
    } },
    ltc_1: { value: null },
    ltc_2: { value: null }
  },
  points: {
    diffuse: { value: /* @__PURE__ */ new At(16777215) },
    opacity: { value: 1 },
    size: { value: 1 },
    scale: { value: 1 },
    map: { value: null },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new ot() },
    alphaTest: { value: 0 },
    uvTransform: { value: /* @__PURE__ */ new ot() }
  },
  sprite: {
    diffuse: { value: /* @__PURE__ */ new At(16777215) },
    opacity: { value: 1 },
    center: { value: /* @__PURE__ */ new Pt(0.5, 0.5) },
    rotation: { value: 0 },
    map: { value: null },
    mapTransform: { value: /* @__PURE__ */ new ot() },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new ot() },
    alphaTest: { value: 0 }
  }
}, Or = {
  basic: {
    uniforms: /* @__PURE__ */ _n([
      De.common,
      De.specularmap,
      De.envmap,
      De.aomap,
      De.lightmap,
      De.fog
    ]),
    vertexShader: at.meshbasic_vert,
    fragmentShader: at.meshbasic_frag
  },
  lambert: {
    uniforms: /* @__PURE__ */ _n([
      De.common,
      De.specularmap,
      De.envmap,
      De.aomap,
      De.lightmap,
      De.emissivemap,
      De.bumpmap,
      De.normalmap,
      De.displacementmap,
      De.fog,
      De.lights,
      {
        emissive: { value: /* @__PURE__ */ new At(0) }
      }
    ]),
    vertexShader: at.meshlambert_vert,
    fragmentShader: at.meshlambert_frag
  },
  phong: {
    uniforms: /* @__PURE__ */ _n([
      De.common,
      De.specularmap,
      De.envmap,
      De.aomap,
      De.lightmap,
      De.emissivemap,
      De.bumpmap,
      De.normalmap,
      De.displacementmap,
      De.fog,
      De.lights,
      {
        emissive: { value: /* @__PURE__ */ new At(0) },
        specular: { value: /* @__PURE__ */ new At(1118481) },
        shininess: { value: 30 }
      }
    ]),
    vertexShader: at.meshphong_vert,
    fragmentShader: at.meshphong_frag
  },
  standard: {
    uniforms: /* @__PURE__ */ _n([
      De.common,
      De.envmap,
      De.aomap,
      De.lightmap,
      De.emissivemap,
      De.bumpmap,
      De.normalmap,
      De.displacementmap,
      De.roughnessmap,
      De.metalnessmap,
      De.fog,
      De.lights,
      {
        emissive: { value: /* @__PURE__ */ new At(0) },
        roughness: { value: 1 },
        metalness: { value: 0 },
        envMapIntensity: { value: 1 }
      }
    ]),
    vertexShader: at.meshphysical_vert,
    fragmentShader: at.meshphysical_frag
  },
  toon: {
    uniforms: /* @__PURE__ */ _n([
      De.common,
      De.aomap,
      De.lightmap,
      De.emissivemap,
      De.bumpmap,
      De.normalmap,
      De.displacementmap,
      De.gradientmap,
      De.fog,
      De.lights,
      {
        emissive: { value: /* @__PURE__ */ new At(0) }
      }
    ]),
    vertexShader: at.meshtoon_vert,
    fragmentShader: at.meshtoon_frag
  },
  matcap: {
    uniforms: /* @__PURE__ */ _n([
      De.common,
      De.bumpmap,
      De.normalmap,
      De.displacementmap,
      De.fog,
      {
        matcap: { value: null }
      }
    ]),
    vertexShader: at.meshmatcap_vert,
    fragmentShader: at.meshmatcap_frag
  },
  points: {
    uniforms: /* @__PURE__ */ _n([
      De.points,
      De.fog
    ]),
    vertexShader: at.points_vert,
    fragmentShader: at.points_frag
  },
  dashed: {
    uniforms: /* @__PURE__ */ _n([
      De.common,
      De.fog,
      {
        scale: { value: 1 },
        dashSize: { value: 1 },
        totalSize: { value: 2 }
      }
    ]),
    vertexShader: at.linedashed_vert,
    fragmentShader: at.linedashed_frag
  },
  depth: {
    uniforms: /* @__PURE__ */ _n([
      De.common,
      De.displacementmap
    ]),
    vertexShader: at.depth_vert,
    fragmentShader: at.depth_frag
  },
  normal: {
    uniforms: /* @__PURE__ */ _n([
      De.common,
      De.bumpmap,
      De.normalmap,
      De.displacementmap,
      {
        opacity: { value: 1 }
      }
    ]),
    vertexShader: at.meshnormal_vert,
    fragmentShader: at.meshnormal_frag
  },
  sprite: {
    uniforms: /* @__PURE__ */ _n([
      De.sprite,
      De.fog
    ]),
    vertexShader: at.sprite_vert,
    fragmentShader: at.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: { value: /* @__PURE__ */ new ot() },
      t2D: { value: null },
      backgroundIntensity: { value: 1 }
    },
    vertexShader: at.background_vert,
    fragmentShader: at.background_frag
  },
  backgroundCube: {
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 },
      backgroundBlurriness: { value: 0 },
      backgroundIntensity: { value: 1 },
      backgroundRotation: { value: /* @__PURE__ */ new ot() }
    },
    vertexShader: at.backgroundCube_vert,
    fragmentShader: at.backgroundCube_frag
  },
  cube: {
    uniforms: {
      tCube: { value: null },
      tFlip: { value: -1 },
      opacity: { value: 1 }
    },
    vertexShader: at.cube_vert,
    fragmentShader: at.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: { value: null }
    },
    vertexShader: at.equirect_vert,
    fragmentShader: at.equirect_frag
  },
  distanceRGBA: {
    uniforms: /* @__PURE__ */ _n([
      De.common,
      De.displacementmap,
      {
        referencePosition: { value: /* @__PURE__ */ new re() },
        nearDistance: { value: 1 },
        farDistance: { value: 1e3 }
      }
    ]),
    vertexShader: at.distanceRGBA_vert,
    fragmentShader: at.distanceRGBA_frag
  },
  shadow: {
    uniforms: /* @__PURE__ */ _n([
      De.lights,
      De.fog,
      {
        color: { value: /* @__PURE__ */ new At(0) },
        opacity: { value: 1 }
      }
    ]),
    vertexShader: at.shadow_vert,
    fragmentShader: at.shadow_frag
  }
};
Or.physical = {
  uniforms: /* @__PURE__ */ _n([
    Or.standard.uniforms,
    {
      clearcoat: { value: 0 },
      clearcoatMap: { value: null },
      clearcoatMapTransform: { value: /* @__PURE__ */ new ot() },
      clearcoatNormalMap: { value: null },
      clearcoatNormalMapTransform: { value: /* @__PURE__ */ new ot() },
      clearcoatNormalScale: { value: /* @__PURE__ */ new Pt(1, 1) },
      clearcoatRoughness: { value: 0 },
      clearcoatRoughnessMap: { value: null },
      clearcoatRoughnessMapTransform: { value: /* @__PURE__ */ new ot() },
      dispersion: { value: 0 },
      iridescence: { value: 0 },
      iridescenceMap: { value: null },
      iridescenceMapTransform: { value: /* @__PURE__ */ new ot() },
      iridescenceIOR: { value: 1.3 },
      iridescenceThicknessMinimum: { value: 100 },
      iridescenceThicknessMaximum: { value: 400 },
      iridescenceThicknessMap: { value: null },
      iridescenceThicknessMapTransform: { value: /* @__PURE__ */ new ot() },
      sheen: { value: 0 },
      sheenColor: { value: /* @__PURE__ */ new At(0) },
      sheenColorMap: { value: null },
      sheenColorMapTransform: { value: /* @__PURE__ */ new ot() },
      sheenRoughness: { value: 1 },
      sheenRoughnessMap: { value: null },
      sheenRoughnessMapTransform: { value: /* @__PURE__ */ new ot() },
      transmission: { value: 0 },
      transmissionMap: { value: null },
      transmissionMapTransform: { value: /* @__PURE__ */ new ot() },
      transmissionSamplerSize: { value: /* @__PURE__ */ new Pt() },
      transmissionSamplerMap: { value: null },
      thickness: { value: 0 },
      thicknessMap: { value: null },
      thicknessMapTransform: { value: /* @__PURE__ */ new ot() },
      attenuationDistance: { value: 0 },
      attenuationColor: { value: /* @__PURE__ */ new At(0) },
      specularColor: { value: /* @__PURE__ */ new At(1, 1, 1) },
      specularColorMap: { value: null },
      specularColorMapTransform: { value: /* @__PURE__ */ new ot() },
      specularIntensity: { value: 1 },
      specularIntensityMap: { value: null },
      specularIntensityMapTransform: { value: /* @__PURE__ */ new ot() },
      anisotropyVector: { value: /* @__PURE__ */ new Pt() },
      anisotropyMap: { value: null },
      anisotropyMapTransform: { value: /* @__PURE__ */ new ot() }
    }
  ]),
  vertexShader: at.meshphysical_vert,
  fragmentShader: at.meshphysical_frag
};
const eu = { r: 0, b: 0, g: 0 }, vo = /* @__PURE__ */ new Vr(), Are = /* @__PURE__ */ new qt();
function Pre(t, e, n, r, i, o, a) {
  const s = new At(0);
  let l = o === !0 ? 0 : 1, c, u, d = null, f = 0, h = null;
  function v(b) {
    let x = b.isScene === !0 ? b.background : null;
    return x && x.isTexture && (x = (b.backgroundBlurriness > 0 ? n : e).get(x)), x;
  }
  function g(b) {
    let x = !1;
    const _ = v(b);
    _ === null ? p(s, l) : _ && _.isColor && (p(_, 1), x = !0);
    const M = t.xr.getEnvironmentBlendMode();
    M === "additive" ? r.buffers.color.setClear(0, 0, 0, 1, a) : M === "alpha-blend" && r.buffers.color.setClear(0, 0, 0, 0, a), (t.autoClear || x) && (r.buffers.depth.setTest(!0), r.buffers.depth.setMask(!0), r.buffers.color.setMask(!0), t.clear(t.autoClearColor, t.autoClearDepth, t.autoClearStencil));
  }
  function m(b, x) {
    const _ = v(x);
    _ && (_.isCubeTexture || _.mapping === Yd) ? (u === void 0 && (u = new rr(
      new uc(1, 1, 1),
      new eo({
        name: "BackgroundCubeMaterial",
        uniforms: is(Or.backgroundCube.uniforms),
        vertexShader: Or.backgroundCube.vertexShader,
        fragmentShader: Or.backgroundCube.fragmentShader,
        side: Rn,
        depthTest: !1,
        depthWrite: !1,
        fog: !1,
        allowOverride: !1
      })
    ), u.geometry.deleteAttribute("normal"), u.geometry.deleteAttribute("uv"), u.onBeforeRender = function(M, S, P) {
      this.matrixWorld.copyPosition(P.matrixWorld);
    }, Object.defineProperty(u.material, "envMap", {
      get: function() {
        return this.uniforms.envMap.value;
      }
    }), i.update(u)), vo.copy(x.backgroundRotation), vo.x *= -1, vo.y *= -1, vo.z *= -1, _.isCubeTexture && _.isRenderTargetTexture === !1 && (vo.y *= -1, vo.z *= -1), u.material.uniforms.envMap.value = _, u.material.uniforms.flipEnvMap.value = _.isCubeTexture && _.isRenderTargetTexture === !1 ? -1 : 1, u.material.uniforms.backgroundBlurriness.value = x.backgroundBlurriness, u.material.uniforms.backgroundIntensity.value = x.backgroundIntensity, u.material.uniforms.backgroundRotation.value.setFromMatrix4(Are.makeRotationFromEuler(vo)), u.material.toneMapped = mt.getTransfer(_.colorSpace) !== Tt, (d !== _ || f !== _.version || h !== t.toneMapping) && (u.material.needsUpdate = !0, d = _, f = _.version, h = t.toneMapping), u.layers.enableAll(), b.unshift(u, u.geometry, u.material, 0, 0, null)) : _ && _.isTexture && (c === void 0 && (c = new rr(
      new Kd(2, 2),
      new eo({
        name: "BackgroundMaterial",
        uniforms: is(Or.background.uniforms),
        vertexShader: Or.background.vertexShader,
        fragmentShader: Or.background.fragmentShader,
        side: Ji,
        depthTest: !1,
        depthWrite: !1,
        fog: !1,
        allowOverride: !1
      })
    ), c.geometry.deleteAttribute("normal"), Object.defineProperty(c.material, "map", {
      get: function() {
        return this.uniforms.t2D.value;
      }
    }), i.update(c)), c.material.uniforms.t2D.value = _, c.material.uniforms.backgroundIntensity.value = x.backgroundIntensity, c.material.toneMapped = mt.getTransfer(_.colorSpace) !== Tt, _.matrixAutoUpdate === !0 && _.updateMatrix(), c.material.uniforms.uvTransform.value.copy(_.matrix), (d !== _ || f !== _.version || h !== t.toneMapping) && (c.material.needsUpdate = !0, d = _, f = _.version, h = t.toneMapping), c.layers.enableAll(), b.unshift(c, c.geometry, c.material, 0, 0, null));
  }
  function p(b, x) {
    b.getRGB(eu, U9(t)), r.buffers.color.setClear(eu.r, eu.g, eu.b, x, a);
  }
  function y() {
    u !== void 0 && (u.geometry.dispose(), u.material.dispose(), u = void 0), c !== void 0 && (c.geometry.dispose(), c.material.dispose(), c = void 0);
  }
  return {
    getClearColor: function() {
      return s;
    },
    setClearColor: function(b, x = 1) {
      s.set(b), l = x, p(s, l);
    },
    getClearAlpha: function() {
      return l;
    },
    setClearAlpha: function(b) {
      l = b, p(s, l);
    },
    render: g,
    addToRenderList: m,
    dispose: y
  };
}
function Rre(t, e) {
  const n = t.getParameter(t.MAX_VERTEX_ATTRIBS), r = {}, i = f(null);
  let o = i, a = !1;
  function s(w, O, N, I, H) {
    let j = !1;
    const U = d(I, N, O);
    o !== U && (o = U, c(o.object)), j = h(w, I, N, H), j && v(w, I, N, H), H !== null && e.update(H, t.ELEMENT_ARRAY_BUFFER), (j || a) && (a = !1, x(w, O, N, I), H !== null && t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, e.get(H).buffer));
  }
  function l() {
    return t.createVertexArray();
  }
  function c(w) {
    return t.bindVertexArray(w);
  }
  function u(w) {
    return t.deleteVertexArray(w);
  }
  function d(w, O, N) {
    const I = N.wireframe === !0;
    let H = r[w.id];
    H === void 0 && (H = {}, r[w.id] = H);
    let j = H[O.id];
    j === void 0 && (j = {}, H[O.id] = j);
    let U = j[I];
    return U === void 0 && (U = f(l()), j[I] = U), U;
  }
  function f(w) {
    const O = [], N = [], I = [];
    for (let H = 0; H < n; H++)
      O[H] = 0, N[H] = 0, I[H] = 0;
    return {
      // for backward compatibility on non-VAO support browser
      geometry: null,
      program: null,
      wireframe: !1,
      newAttributes: O,
      enabledAttributes: N,
      attributeDivisors: I,
      object: w,
      attributes: {},
      index: null
    };
  }
  function h(w, O, N, I) {
    const H = o.attributes, j = O.attributes;
    let U = 0;
    const $ = N.getAttributes();
    for (const V in $)
      if ($[V].location >= 0) {
        const B = H[V];
        let Z = j[V];
        if (Z === void 0 && (V === "instanceMatrix" && w.instanceMatrix && (Z = w.instanceMatrix), V === "instanceColor" && w.instanceColor && (Z = w.instanceColor)), B === void 0 || B.attribute !== Z || Z && B.data !== Z.data)
          return !0;
        U++;
      }
    return o.attributesNum !== U || o.index !== I;
  }
  function v(w, O, N, I) {
    const H = {}, j = O.attributes;
    let U = 0;
    const $ = N.getAttributes();
    for (const V in $)
      if ($[V].location >= 0) {
        let B = j[V];
        B === void 0 && (V === "instanceMatrix" && w.instanceMatrix && (B = w.instanceMatrix), V === "instanceColor" && w.instanceColor && (B = w.instanceColor));
        const Z = {};
        Z.attribute = B, B && B.data && (Z.data = B.data), H[V] = Z, U++;
      }
    o.attributes = H, o.attributesNum = U, o.index = I;
  }
  function g() {
    const w = o.newAttributes;
    for (let O = 0, N = w.length; O < N; O++)
      w[O] = 0;
  }
  function m(w) {
    p(w, 0);
  }
  function p(w, O) {
    const N = o.newAttributes, I = o.enabledAttributes, H = o.attributeDivisors;
    N[w] = 1, I[w] === 0 && (t.enableVertexAttribArray(w), I[w] = 1), H[w] !== O && (t.vertexAttribDivisor(w, O), H[w] = O);
  }
  function y() {
    const w = o.newAttributes, O = o.enabledAttributes;
    for (let N = 0, I = O.length; N < I; N++)
      O[N] !== w[N] && (t.disableVertexAttribArray(N), O[N] = 0);
  }
  function b(w, O, N, I, H, j, U) {
    U === !0 ? t.vertexAttribIPointer(w, O, N, H, j) : t.vertexAttribPointer(w, O, N, I, H, j);
  }
  function x(w, O, N, I) {
    g();
    const H = I.attributes, j = N.getAttributes(), U = O.defaultAttributeValues;
    for (const $ in j) {
      const V = j[$];
      if (V.location >= 0) {
        let te = H[$];
        if (te === void 0 && ($ === "instanceMatrix" && w.instanceMatrix && (te = w.instanceMatrix), $ === "instanceColor" && w.instanceColor && (te = w.instanceColor)), te !== void 0) {
          const B = te.normalized, Z = te.itemSize, Q = e.get(te);
          if (Q === void 0)
            continue;
          const ce = Q.buffer, k = Q.type, G = Q.bytesPerElement, K = k === t.INT || k === t.UNSIGNED_INT || te.gpuType === x2;
          if (te.isInterleavedBufferAttribute) {
            const J = te.data, se = J.stride, be = te.offset;
            if (J.isInstancedInterleavedBuffer) {
              for (let pe = 0; pe < V.locationSize; pe++)
                p(V.location + pe, J.meshPerAttribute);
              w.isInstancedMesh !== !0 && I._maxInstanceCount === void 0 && (I._maxInstanceCount = J.meshPerAttribute * J.count);
            } else
              for (let pe = 0; pe < V.locationSize; pe++)
                m(V.location + pe);
            t.bindBuffer(t.ARRAY_BUFFER, ce);
            for (let pe = 0; pe < V.locationSize; pe++)
              b(
                V.location + pe,
                Z / V.locationSize,
                k,
                B,
                se * G,
                (be + Z / V.locationSize * pe) * G,
                K
              );
          } else {
            if (te.isInstancedBufferAttribute) {
              for (let J = 0; J < V.locationSize; J++)
                p(V.location + J, te.meshPerAttribute);
              w.isInstancedMesh !== !0 && I._maxInstanceCount === void 0 && (I._maxInstanceCount = te.meshPerAttribute * te.count);
            } else
              for (let J = 0; J < V.locationSize; J++)
                m(V.location + J);
            t.bindBuffer(t.ARRAY_BUFFER, ce);
            for (let J = 0; J < V.locationSize; J++)
              b(
                V.location + J,
                Z / V.locationSize,
                k,
                B,
                Z * G,
                Z / V.locationSize * J * G,
                K
              );
          }
        } else if (U !== void 0) {
          const B = U[$];
          if (B !== void 0)
            switch (B.length) {
              case 2:
                t.vertexAttrib2fv(V.location, B);
                break;
              case 3:
                t.vertexAttrib3fv(V.location, B);
                break;
              case 4:
                t.vertexAttrib4fv(V.location, B);
                break;
              default:
                t.vertexAttrib1fv(V.location, B);
            }
        }
      }
    }
    y();
  }
  function _() {
    P();
    for (const w in r) {
      const O = r[w];
      for (const N in O) {
        const I = O[N];
        for (const H in I)
          u(I[H].object), delete I[H];
        delete O[N];
      }
      delete r[w];
    }
  }
  function M(w) {
    if (r[w.id] === void 0)
      return;
    const O = r[w.id];
    for (const N in O) {
      const I = O[N];
      for (const H in I)
        u(I[H].object), delete I[H];
      delete O[N];
    }
    delete r[w.id];
  }
  function S(w) {
    for (const O in r) {
      const N = r[O];
      if (N[w.id] === void 0)
        continue;
      const I = N[w.id];
      for (const H in I)
        u(I[H].object), delete I[H];
      delete N[w.id];
    }
  }
  function P() {
    E(), a = !0, o !== i && (o = i, c(o.object));
  }
  function E() {
    i.geometry = null, i.program = null, i.wireframe = !1;
  }
  return {
    setup: s,
    reset: P,
    resetDefaultState: E,
    dispose: _,
    releaseStatesOfGeometry: M,
    releaseStatesOfProgram: S,
    initAttributes: g,
    enableAttribute: m,
    disableUnusedAttributes: y
  };
}
function Lre(t, e, n) {
  let r;
  function i(c) {
    r = c;
  }
  function o(c, u) {
    t.drawArrays(r, c, u), n.update(u, r, 1);
  }
  function a(c, u, d) {
    d !== 0 && (t.drawArraysInstanced(r, c, u, d), n.update(u, r, d));
  }
  function s(c, u, d) {
    if (d === 0)
      return;
    e.get("WEBGL_multi_draw").multiDrawArraysWEBGL(r, c, 0, u, 0, d);
    let h = 0;
    for (let v = 0; v < d; v++)
      h += u[v];
    n.update(h, r, 1);
  }
  function l(c, u, d, f) {
    if (d === 0)
      return;
    const h = e.get("WEBGL_multi_draw");
    if (h === null)
      for (let v = 0; v < c.length; v++)
        a(c[v], u[v], f[v]);
    else {
      h.multiDrawArraysInstancedWEBGL(r, c, 0, u, 0, f, 0, d);
      let v = 0;
      for (let g = 0; g < d; g++)
        v += u[g] * f[g];
      n.update(v, r, 1);
    }
  }
  this.setMode = i, this.render = o, this.renderInstances = a, this.renderMultiDraw = s, this.renderMultiDrawInstances = l;
}
function Ore(t, e, n, r) {
  let i;
  function o() {
    if (i !== void 0)
      return i;
    if (e.has("EXT_texture_filter_anisotropic") === !0) {
      const S = e.get("EXT_texture_filter_anisotropic");
      i = t.getParameter(S.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else
      i = 0;
    return i;
  }
  function a(S) {
    return !(S !== br && r.convert(S) !== t.getParameter(t.IMPLEMENTATION_COLOR_READ_FORMAT));
  }
  function s(S) {
    const P = S === lc && (e.has("EXT_color_buffer_half_float") || e.has("EXT_color_buffer_float"));
    return !(S !== di && r.convert(S) !== t.getParameter(t.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
    S !== ri && !P);
  }
  function l(S) {
    if (S === "highp") {
      if (t.getShaderPrecisionFormat(t.VERTEX_SHADER, t.HIGH_FLOAT).precision > 0 && t.getShaderPrecisionFormat(t.FRAGMENT_SHADER, t.HIGH_FLOAT).precision > 0)
        return "highp";
      S = "mediump";
    }
    return S === "mediump" && t.getShaderPrecisionFormat(t.VERTEX_SHADER, t.MEDIUM_FLOAT).precision > 0 && t.getShaderPrecisionFormat(t.FRAGMENT_SHADER, t.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
  }
  let c = n.precision !== void 0 ? n.precision : "highp";
  const u = l(c);
  u !== c && (console.warn("THREE.WebGLRenderer:", c, "not supported, using", u, "instead."), c = u);
  const d = n.logarithmicDepthBuffer === !0, f = n.reverseDepthBuffer === !0 && e.has("EXT_clip_control"), h = t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS), v = t.getParameter(t.MAX_VERTEX_TEXTURE_IMAGE_UNITS), g = t.getParameter(t.MAX_TEXTURE_SIZE), m = t.getParameter(t.MAX_CUBE_MAP_TEXTURE_SIZE), p = t.getParameter(t.MAX_VERTEX_ATTRIBS), y = t.getParameter(t.MAX_VERTEX_UNIFORM_VECTORS), b = t.getParameter(t.MAX_VARYING_VECTORS), x = t.getParameter(t.MAX_FRAGMENT_UNIFORM_VECTORS), _ = v > 0, M = t.getParameter(t.MAX_SAMPLES);
  return {
    isWebGL2: !0,
    // keeping this for backwards compatibility
    getMaxAnisotropy: o,
    getMaxPrecision: l,
    textureFormatReadable: a,
    textureTypeReadable: s,
    precision: c,
    logarithmicDepthBuffer: d,
    reverseDepthBuffer: f,
    maxTextures: h,
    maxVertexTextures: v,
    maxTextureSize: g,
    maxCubemapSize: m,
    maxAttributes: p,
    maxVertexUniforms: y,
    maxVaryings: b,
    maxFragmentUniforms: x,
    vertexTextures: _,
    maxSamples: M
  };
}
function Dre(t) {
  const e = this;
  let n = null, r = 0, i = !1, o = !1;
  const a = new Co(), s = new ot(), l = { value: null, needsUpdate: !1 };
  this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function(d, f) {
    const h = d.length !== 0 || f || // enable state of previous frame - the clipping code has to
    // run another frame in order to reset the state:
    r !== 0 || i;
    return i = f, r = d.length, h;
  }, this.beginShadows = function() {
    o = !0, u(null);
  }, this.endShadows = function() {
    o = !1;
  }, this.setGlobalState = function(d, f) {
    n = u(d, f, 0);
  }, this.setState = function(d, f, h) {
    const v = d.clippingPlanes, g = d.clipIntersection, m = d.clipShadows, p = t.get(d);
    if (!i || v === null || v.length === 0 || o && !m)
      o ? u(null) : c();
    else {
      const y = o ? 0 : r, b = y * 4;
      let x = p.clippingState || null;
      l.value = x, x = u(v, f, b, h);
      for (let _ = 0; _ !== b; ++_)
        x[_] = n[_];
      p.clippingState = x, this.numIntersection = g ? this.numPlanes : 0, this.numPlanes += y;
    }
  };
  function c() {
    l.value !== n && (l.value = n, l.needsUpdate = r > 0), e.numPlanes = r, e.numIntersection = 0;
  }
  function u(d, f, h, v) {
    const g = d !== null ? d.length : 0;
    let m = null;
    if (g !== 0) {
      if (m = l.value, v !== !0 || m === null) {
        const p = h + g * 4, y = f.matrixWorldInverse;
        s.getNormalMatrix(y), (m === null || m.length < p) && (m = new Float32Array(p));
        for (let b = 0, x = h; b !== g; ++b, x += 4)
          a.copy(d[b]).applyMatrix4(y, s), a.normal.toArray(m, x), m[x + 3] = a.constant;
      }
      l.value = m, l.needsUpdate = !0;
    }
    return e.numPlanes = g, e.numIntersection = 0, m;
  }
}
function kre(t) {
  let e = /* @__PURE__ */ new WeakMap();
  function n(a, s) {
    return s === Wh ? a.mapping = ns : s === jh && (a.mapping = rs), a;
  }
  function r(a) {
    if (a && a.isTexture) {
      const s = a.mapping;
      if (s === Wh || s === jh)
        if (e.has(a)) {
          const l = e.get(a).texture;
          return n(l, a.mapping);
        } else {
          const l = a.image;
          if (l && l.height > 0) {
            const c = new Iee(l.height);
            return c.fromEquirectangularTexture(t, a), e.set(a, c), a.addEventListener("dispose", i), n(c.texture, a.mapping);
          } else
            return null;
        }
    }
    return a;
  }
  function i(a) {
    const s = a.target;
    s.removeEventListener("dispose", i);
    const l = e.get(s);
    l !== void 0 && (e.delete(s), l.dispose());
  }
  function o() {
    e = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: r,
    dispose: o
  };
}
const Wa = 4, Y4 = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582], Mo = 20, k0 = /* @__PURE__ */ new Wee(), Z4 = /* @__PURE__ */ new At();
let N0 = null, I0 = 0, F0 = 0, U0 = !1;
const Eo = (1 + Math.sqrt(5)) / 2, ga = 1 / Eo, K4 = [
  /* @__PURE__ */ new re(-Eo, ga, 0),
  /* @__PURE__ */ new re(Eo, ga, 0),
  /* @__PURE__ */ new re(-ga, 0, Eo),
  /* @__PURE__ */ new re(ga, 0, Eo),
  /* @__PURE__ */ new re(0, Eo, -ga),
  /* @__PURE__ */ new re(0, Eo, ga),
  /* @__PURE__ */ new re(-1, 1, -1),
  /* @__PURE__ */ new re(1, 1, -1),
  /* @__PURE__ */ new re(-1, 1, 1),
  /* @__PURE__ */ new re(1, 1, 1)
], Nre = /* @__PURE__ */ new re();
class J4 {
  /**
   * Constructs a new PMREM generator.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   */
  constructor(e) {
    this._renderer = e, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
  }
  /**
   * Generates a PMREM from a supplied Scene, which can be faster than using an
   * image if networking bandwidth is low. Optional sigma specifies a blur radius
   * in radians to be applied to the scene before PMREM generation. Optional near
   * and far planes ensure the scene is rendered in its entirety.
   *
   * @param {Scene} scene - The scene to be captured.
   * @param {number} [sigma=0] - The blur radius in radians.
   * @param {number} [near=0.1] - The near plane distance.
   * @param {number} [far=100] - The far plane distance.
   * @param {Object} [options={}] - The configuration options.
   * @param {number} [options.size=256] - The texture size of the PMREM.
   * @param {Vector3} [options.renderTarget=origin] - The position of the internal cube camera that renders the scene.
   * @return {WebGLRenderTarget} The resulting PMREM.
   */
  fromScene(e, n = 0, r = 0.1, i = 100, o = {}) {
    const {
      size: a = 256,
      position: s = Nre
    } = o;
    N0 = this._renderer.getRenderTarget(), I0 = this._renderer.getActiveCubeFace(), F0 = this._renderer.getActiveMipmapLevel(), U0 = this._renderer.xr.enabled, this._renderer.xr.enabled = !1, this._setSize(a);
    const l = this._allocateTargets();
    return l.depthBuffer = !0, this._sceneToCubeUV(e, r, i, l, s), n > 0 && this._blur(l, 0, 0, n), this._applyPMREM(l), this._cleanup(l), l;
  }
  /**
   * Generates a PMREM from an equirectangular texture, which can be either LDR
   * or HDR. The ideal input image size is 1k (1024 x 512),
   * as this matches best with the 256 x 256 cubemap output.
   *
   * @param {Texture} equirectangular - The equirectangular texture to be converted.
   * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
   * @return {WebGLRenderTarget} The resulting PMREM.
   */
  fromEquirectangular(e, n = null) {
    return this._fromTexture(e, n);
  }
  /**
   * Generates a PMREM from an cubemap texture, which can be either LDR
   * or HDR. The ideal input cube size is 256 x 256,
   * as this matches best with the 256 x 256 cubemap output.
   *
   * @param {Texture} cubemap - The cubemap texture to be converted.
   * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
   * @return {WebGLRenderTarget} The resulting PMREM.
   */
  fromCubemap(e, n = null) {
    return this._fromTexture(e, n);
  }
  /**
   * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileCubemapShader() {
    this._cubemapMaterial === null && (this._cubemapMaterial = tg(), this._compileMaterial(this._cubemapMaterial));
  }
  /**
   * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileEquirectangularShader() {
    this._equirectMaterial === null && (this._equirectMaterial = eg(), this._compileMaterial(this._equirectMaterial));
  }
  /**
   * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
   * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
   * one of them will cause any others to also become unusable.
   */
  dispose() {
    this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose();
  }
  // private interface
  _setSize(e) {
    this._lodMax = Math.floor(Math.log2(e)), this._cubeSize = Math.pow(2, this._lodMax);
  }
  _dispose() {
    this._blurMaterial !== null && this._blurMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
    for (let e = 0; e < this._lodPlanes.length; e++)
      this._lodPlanes[e].dispose();
  }
  _cleanup(e) {
    this._renderer.setRenderTarget(N0, I0, F0), this._renderer.xr.enabled = U0, e.scissorTest = !1, tu(e, 0, 0, e.width, e.height);
  }
  _fromTexture(e, n) {
    e.mapping === ns || e.mapping === rs ? this._setSize(e.image.length === 0 ? 16 : e.image[0].width || e.image[0].image.width) : this._setSize(e.image.width / 4), N0 = this._renderer.getRenderTarget(), I0 = this._renderer.getActiveCubeFace(), F0 = this._renderer.getActiveMipmapLevel(), U0 = this._renderer.xr.enabled, this._renderer.xr.enabled = !1;
    const r = n || this._allocateTargets();
    return this._textureToCubeUV(e, r), this._applyPMREM(r), this._cleanup(r), r;
  }
  _allocateTargets() {
    const e = 3 * Math.max(this._cubeSize, 112), n = 4 * this._cubeSize, r = {
      magFilter: yr,
      minFilter: yr,
      generateMipmaps: !1,
      type: lc,
      format: br,
      colorSpace: zo,
      depthBuffer: !1
    }, i = Q4(e, n, r);
    if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== e || this._pingPongRenderTarget.height !== n) {
      this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = Q4(e, n, r);
      const { _lodMax: o } = this;
      ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = Ire(o)), this._blurMaterial = Fre(o, e, n);
    }
    return i;
  }
  _compileMaterial(e) {
    const n = new rr(this._lodPlanes[0], e);
    this._renderer.compile(n, k0);
  }
  _sceneToCubeUV(e, n, r, i, o) {
    const l = new tr(90, 1, n, r), c = [1, -1, 1, 1, 1, 1], u = [1, 1, 1, -1, -1, -1], d = this._renderer, f = d.autoClear, h = d.toneMapping;
    d.getClearColor(Z4), d.toneMapping = Bi, d.autoClear = !1;
    const v = new cc({
      name: "PMREM.Background",
      side: Rn,
      depthWrite: !1,
      depthTest: !1
    }), g = new rr(new uc(), v);
    let m = !1;
    const p = e.background;
    p ? p.isColor && (v.color.copy(p), e.background = null, m = !0) : (v.color.copy(Z4), m = !0);
    for (let y = 0; y < 6; y++) {
      const b = y % 3;
      b === 0 ? (l.up.set(0, c[y], 0), l.position.set(o.x, o.y, o.z), l.lookAt(o.x + u[y], o.y, o.z)) : b === 1 ? (l.up.set(0, 0, c[y]), l.position.set(o.x, o.y, o.z), l.lookAt(o.x, o.y + u[y], o.z)) : (l.up.set(0, c[y], 0), l.position.set(o.x, o.y, o.z), l.lookAt(o.x, o.y, o.z + u[y]));
      const x = this._cubeSize;
      tu(i, b * x, y > 2 ? x : 0, x, x), d.setRenderTarget(i), m && d.render(g, l), d.render(e, l);
    }
    g.geometry.dispose(), g.material.dispose(), d.toneMapping = h, d.autoClear = f, e.background = p;
  }
  _textureToCubeUV(e, n) {
    const r = this._renderer, i = e.mapping === ns || e.mapping === rs;
    i ? (this._cubemapMaterial === null && (this._cubemapMaterial = tg()), this._cubemapMaterial.uniforms.flipEnvMap.value = e.isRenderTargetTexture === !1 ? -1 : 1) : this._equirectMaterial === null && (this._equirectMaterial = eg());
    const o = i ? this._cubemapMaterial : this._equirectMaterial, a = new rr(this._lodPlanes[0], o), s = o.uniforms;
    s.envMap.value = e;
    const l = this._cubeSize;
    tu(n, 0, 0, 3 * l, 2 * l), r.setRenderTarget(n), r.render(a, k0);
  }
  _applyPMREM(e) {
    const n = this._renderer, r = n.autoClear;
    n.autoClear = !1;
    const i = this._lodPlanes.length;
    for (let o = 1; o < i; o++) {
      const a = Math.sqrt(this._sigmas[o] * this._sigmas[o] - this._sigmas[o - 1] * this._sigmas[o - 1]), s = K4[(i - o - 1) % K4.length];
      this._blur(e, o - 1, o, a, s);
    }
    n.autoClear = r;
  }
  /**
   * This is a two-pass Gaussian blur for a cubemap. Normally this is done
   * vertically and horizontally, but this breaks down on a cube. Here we apply
   * the blur latitudinally (around the poles), and then longitudinally (towards
   * the poles) to approximate the orthogonally-separable blur. It is least
   * accurate at the poles, but still does a decent job.
   *
   * @private
   * @param {WebGLRenderTarget} cubeUVRenderTarget
   * @param {number} lodIn
   * @param {number} lodOut
   * @param {number} sigma
   * @param {Vector3} [poleAxis]
   */
  _blur(e, n, r, i, o) {
    const a = this._pingPongRenderTarget;
    this._halfBlur(
      e,
      a,
      n,
      r,
      i,
      "latitudinal",
      o
    ), this._halfBlur(
      a,
      e,
      r,
      r,
      i,
      "longitudinal",
      o
    );
  }
  _halfBlur(e, n, r, i, o, a, s) {
    const l = this._renderer, c = this._blurMaterial;
    a !== "latitudinal" && a !== "longitudinal" && console.error(
      "blur direction must be either latitudinal or longitudinal!"
    );
    const u = 3, d = new rr(this._lodPlanes[i], c), f = c.uniforms, h = this._sizeLods[r] - 1, v = isFinite(o) ? Math.PI / (2 * h) : 2 * Math.PI / (2 * Mo - 1), g = o / v, m = isFinite(o) ? 1 + Math.floor(u * g) : Mo;
    m > Mo && console.warn(`sigmaRadians, ${o}, is too large and will clip, as it requested ${m} samples when the maximum is set to ${Mo}`);
    const p = [];
    let y = 0;
    for (let S = 0; S < Mo; ++S) {
      const P = S / g, E = Math.exp(-P * P / 2);
      p.push(E), S === 0 ? y += E : S < m && (y += 2 * E);
    }
    for (let S = 0; S < p.length; S++)
      p[S] = p[S] / y;
    f.envMap.value = e.texture, f.samples.value = m, f.weights.value = p, f.latitudinal.value = a === "latitudinal", s && (f.poleAxis.value = s);
    const { _lodMax: b } = this;
    f.dTheta.value = v, f.mipInt.value = b - r;
    const x = this._sizeLods[i], _ = 3 * x * (i > b - Wa ? i - b + Wa : 0), M = 4 * (this._cubeSize - x);
    tu(n, _, M, 3 * x, 2 * x), l.setRenderTarget(n), l.render(d, k0);
  }
}
function Ire(t) {
  const e = [], n = [], r = [];
  let i = t;
  const o = t - Wa + 1 + Y4.length;
  for (let a = 0; a < o; a++) {
    const s = Math.pow(2, i);
    n.push(s);
    let l = 1 / s;
    a > t - Wa ? l = Y4[a - t + Wa - 1] : a === 0 && (l = 0), r.push(l);
    const c = 1 / (s - 2), u = -c, d = 1 + c, f = [u, u, d, u, d, d, u, u, d, d, u, d], h = 6, v = 6, g = 3, m = 2, p = 1, y = new Float32Array(g * v * h), b = new Float32Array(m * v * h), x = new Float32Array(p * v * h);
    for (let M = 0; M < h; M++) {
      const S = M % 3 * 2 / 3 - 1, P = M > 2 ? 0 : -1, E = [
        S,
        P,
        0,
        S + 2 / 3,
        P,
        0,
        S + 2 / 3,
        P + 1,
        0,
        S,
        P,
        0,
        S + 2 / 3,
        P + 1,
        0,
        S,
        P + 1,
        0
      ];
      y.set(E, g * v * M), b.set(f, m * v * M);
      const w = [M, M, M, M, M, M];
      x.set(w, p * v * M);
    }
    const _ = new ao();
    _.setAttribute("position", new Hr(y, g)), _.setAttribute("uv", new Hr(b, m)), _.setAttribute("faceIndex", new Hr(x, p)), e.push(_), i > Wa && i--;
  }
  return { lodPlanes: e, sizeLods: n, sigmas: r };
}
function Q4(t, e, n) {
  const r = new Qi(t, e, n);
  return r.texture.mapping = Yd, r.texture.name = "PMREM.cubeUv", r.scissorTest = !0, r;
}
function tu(t, e, n, r, i) {
  t.viewport.set(e, n, r, i), t.scissor.set(e, n, r, i);
}
function Fre(t, e, n) {
  const r = new Float32Array(Mo), i = new re(0, 1, 0);
  return new eo({
    name: "SphericalGaussianBlur",
    defines: {
      n: Mo,
      CUBEUV_TEXEL_WIDTH: 1 / e,
      CUBEUV_TEXEL_HEIGHT: 1 / n,
      CUBEUV_MAX_MIP: `${t}.0`
    },
    uniforms: {
      envMap: { value: null },
      samples: { value: 1 },
      weights: { value: r },
      latitudinal: { value: !1 },
      dTheta: { value: 0 },
      mipInt: { value: 0 },
      poleAxis: { value: i }
    },
    vertexShader: O2(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`
    ),
    blending: Hi,
    depthTest: !1,
    depthWrite: !1
  });
}
function eg() {
  return new eo({
    name: "EquirectangularToCubeUV",
    uniforms: {
      envMap: { value: null }
    },
    vertexShader: O2(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`
    ),
    blending: Hi,
    depthTest: !1,
    depthWrite: !1
  });
}
function tg() {
  return new eo({
    name: "CubemapToCubeUV",
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 }
    },
    vertexShader: O2(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`
    ),
    blending: Hi,
    depthTest: !1,
    depthWrite: !1
  });
}
function O2() {
  return (
    /* glsl */
    `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`
  );
}
function Ure(t) {
  let e = /* @__PURE__ */ new WeakMap(), n = null;
  function r(s) {
    if (s && s.isTexture) {
      const l = s.mapping, c = l === Wh || l === jh, u = l === ns || l === rs;
      if (c || u) {
        let d = e.get(s);
        const f = d !== void 0 ? d.texture.pmremVersion : 0;
        if (s.isRenderTargetTexture && s.pmremVersion !== f)
          return n === null && (n = new J4(t)), d = c ? n.fromEquirectangular(s, d) : n.fromCubemap(s, d), d.texture.pmremVersion = s.pmremVersion, e.set(s, d), d.texture;
        if (d !== void 0)
          return d.texture;
        {
          const h = s.image;
          return c && h && h.height > 0 || u && h && i(h) ? (n === null && (n = new J4(t)), d = c ? n.fromEquirectangular(s) : n.fromCubemap(s), d.texture.pmremVersion = s.pmremVersion, e.set(s, d), s.addEventListener("dispose", o), d.texture) : null;
        }
      }
    }
    return s;
  }
  function i(s) {
    let l = 0;
    const c = 6;
    for (let u = 0; u < c; u++)
      s[u] !== void 0 && l++;
    return l === c;
  }
  function o(s) {
    const l = s.target;
    l.removeEventListener("dispose", o);
    const c = e.get(l);
    c !== void 0 && (e.delete(l), c.dispose());
  }
  function a() {
    e = /* @__PURE__ */ new WeakMap(), n !== null && (n.dispose(), n = null);
  }
  return {
    get: r,
    dispose: a
  };
}
function zre(t) {
  const e = {};
  function n(r) {
    if (e[r] !== void 0)
      return e[r];
    let i;
    switch (r) {
      case "WEBGL_depth_texture":
        i = t.getExtension("WEBGL_depth_texture") || t.getExtension("MOZ_WEBGL_depth_texture") || t.getExtension("WEBKIT_WEBGL_depth_texture");
        break;
      case "EXT_texture_filter_anisotropic":
        i = t.getExtension("EXT_texture_filter_anisotropic") || t.getExtension("MOZ_EXT_texture_filter_anisotropic") || t.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
        break;
      case "WEBGL_compressed_texture_s3tc":
        i = t.getExtension("WEBGL_compressed_texture_s3tc") || t.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
        break;
      case "WEBGL_compressed_texture_pvrtc":
        i = t.getExtension("WEBGL_compressed_texture_pvrtc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
        break;
      default:
        i = t.getExtension(r);
    }
    return e[r] = i, i;
  }
  return {
    has: function(r) {
      return n(r) !== null;
    },
    init: function() {
      n("EXT_color_buffer_float"), n("WEBGL_clip_cull_distance"), n("OES_texture_float_linear"), n("EXT_color_buffer_half_float"), n("WEBGL_multisampled_render_to_texture"), n("WEBGL_render_shared_exponent");
    },
    get: function(r) {
      const i = n(r);
      return i === null && Au("THREE.WebGLRenderer: " + r + " extension not supported."), i;
    }
  };
}
function Hre(t, e, n, r) {
  const i = {}, o = /* @__PURE__ */ new WeakMap();
  function a(d) {
    const f = d.target;
    f.index !== null && e.remove(f.index);
    for (const v in f.attributes)
      e.remove(f.attributes[v]);
    f.removeEventListener("dispose", a), delete i[f.id];
    const h = o.get(f);
    h && (e.remove(h), o.delete(f)), r.releaseStatesOfGeometry(f), f.isInstancedBufferGeometry === !0 && delete f._maxInstanceCount, n.memory.geometries--;
  }
  function s(d, f) {
    return i[f.id] === !0 || (f.addEventListener("dispose", a), i[f.id] = !0, n.memory.geometries++), f;
  }
  function l(d) {
    const f = d.attributes;
    for (const h in f)
      e.update(f[h], t.ARRAY_BUFFER);
  }
  function c(d) {
    const f = [], h = d.index, v = d.attributes.position;
    let g = 0;
    if (h !== null) {
      const y = h.array;
      g = h.version;
      for (let b = 0, x = y.length; b < x; b += 3) {
        const _ = y[b + 0], M = y[b + 1], S = y[b + 2];
        f.push(_, M, M, S, S, _);
      }
    } else if (v !== void 0) {
      const y = v.array;
      g = v.version;
      for (let b = 0, x = y.length / 3 - 1; b < x; b += 3) {
        const _ = b + 0, M = b + 1, S = b + 2;
        f.push(_, M, M, S, S, _);
      }
    } else
      return;
    const m = new (O9(f) ? F9 : I9)(f, 1);
    m.version = g;
    const p = o.get(d);
    p && e.remove(p), o.set(d, m);
  }
  function u(d) {
    const f = o.get(d);
    if (f) {
      const h = d.index;
      h !== null && f.version < h.version && c(d);
    } else
      c(d);
    return o.get(d);
  }
  return {
    get: s,
    update: l,
    getWireframeAttribute: u
  };
}
function Bre(t, e, n) {
  let r;
  function i(f) {
    r = f;
  }
  let o, a;
  function s(f) {
    o = f.type, a = f.bytesPerElement;
  }
  function l(f, h) {
    t.drawElements(r, h, o, f * a), n.update(h, r, 1);
  }
  function c(f, h, v) {
    v !== 0 && (t.drawElementsInstanced(r, h, o, f * a, v), n.update(h, r, v));
  }
  function u(f, h, v) {
    if (v === 0)
      return;
    e.get("WEBGL_multi_draw").multiDrawElementsWEBGL(r, h, 0, o, f, 0, v);
    let m = 0;
    for (let p = 0; p < v; p++)
      m += h[p];
    n.update(m, r, 1);
  }
  function d(f, h, v, g) {
    if (v === 0)
      return;
    const m = e.get("WEBGL_multi_draw");
    if (m === null)
      for (let p = 0; p < f.length; p++)
        c(f[p] / a, h[p], g[p]);
    else {
      m.multiDrawElementsInstancedWEBGL(r, h, 0, o, f, 0, g, 0, v);
      let p = 0;
      for (let y = 0; y < v; y++)
        p += h[y] * g[y];
      n.update(p, r, 1);
    }
  }
  this.setMode = i, this.setIndex = s, this.render = l, this.renderInstances = c, this.renderMultiDraw = u, this.renderMultiDrawInstances = d;
}
function Vre(t) {
  const e = {
    geometries: 0,
    textures: 0
  }, n = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  function r(o, a, s) {
    switch (n.calls++, a) {
      case t.TRIANGLES:
        n.triangles += s * (o / 3);
        break;
      case t.LINES:
        n.lines += s * (o / 2);
        break;
      case t.LINE_STRIP:
        n.lines += s * (o - 1);
        break;
      case t.LINE_LOOP:
        n.lines += s * o;
        break;
      case t.POINTS:
        n.points += s * o;
        break;
      default:
        console.error("THREE.WebGLInfo: Unknown draw mode:", a);
        break;
    }
  }
  function i() {
    n.calls = 0, n.triangles = 0, n.points = 0, n.lines = 0;
  }
  return {
    memory: e,
    render: n,
    programs: null,
    autoReset: !0,
    reset: i,
    update: r
  };
}
function $re(t, e, n) {
  const r = /* @__PURE__ */ new WeakMap(), i = new Yt();
  function o(a, s, l) {
    const c = a.morphTargetInfluences, u = s.morphAttributes.position || s.morphAttributes.normal || s.morphAttributes.color, d = u !== void 0 ? u.length : 0;
    let f = r.get(s);
    if (f === void 0 || f.count !== d) {
      let E = function() {
        S.dispose(), r.delete(s), s.removeEventListener("dispose", E);
      };
      f !== void 0 && f.texture.dispose();
      const h = s.morphAttributes.position !== void 0, v = s.morphAttributes.normal !== void 0, g = s.morphAttributes.color !== void 0, m = s.morphAttributes.position || [], p = s.morphAttributes.normal || [], y = s.morphAttributes.color || [];
      let b = 0;
      h === !0 && (b = 1), v === !0 && (b = 2), g === !0 && (b = 3);
      let x = s.attributes.position.count * b, _ = 1;
      x > e.maxTextureSize && (_ = Math.ceil(x / e.maxTextureSize), x = e.maxTextureSize);
      const M = new Float32Array(x * _ * 4 * d), S = new D9(M, x, _, d);
      S.type = ri, S.needsUpdate = !0;
      const P = b * 4;
      for (let w = 0; w < d; w++) {
        const O = m[w], N = p[w], I = y[w], H = x * _ * 4 * w;
        for (let j = 0; j < O.count; j++) {
          const U = j * P;
          h === !0 && (i.fromBufferAttribute(O, j), M[H + U + 0] = i.x, M[H + U + 1] = i.y, M[H + U + 2] = i.z, M[H + U + 3] = 0), v === !0 && (i.fromBufferAttribute(N, j), M[H + U + 4] = i.x, M[H + U + 5] = i.y, M[H + U + 6] = i.z, M[H + U + 7] = 0), g === !0 && (i.fromBufferAttribute(I, j), M[H + U + 8] = i.x, M[H + U + 9] = i.y, M[H + U + 10] = i.z, M[H + U + 11] = I.itemSize === 4 ? i.w : 1);
        }
      }
      f = {
        count: d,
        texture: S,
        size: new Pt(x, _)
      }, r.set(s, f), s.addEventListener("dispose", E);
    }
    if (a.isInstancedMesh === !0 && a.morphTexture !== null)
      l.getUniforms().setValue(t, "morphTexture", a.morphTexture, n);
    else {
      let h = 0;
      for (let g = 0; g < c.length; g++)
        h += c[g];
      const v = s.morphTargetsRelative ? 1 : 1 - h;
      l.getUniforms().setValue(t, "morphTargetBaseInfluence", v), l.getUniforms().setValue(t, "morphTargetInfluences", c);
    }
    l.getUniforms().setValue(t, "morphTargetsTexture", f.texture, n), l.getUniforms().setValue(t, "morphTargetsTextureSize", f.size);
  }
  return {
    update: o
  };
}
function Wre(t, e, n, r) {
  let i = /* @__PURE__ */ new WeakMap();
  function o(l) {
    const c = r.render.frame, u = l.geometry, d = e.get(l, u);
    if (i.get(d) !== c && (e.update(d), i.set(d, c)), l.isInstancedMesh && (l.hasEventListener("dispose", s) === !1 && l.addEventListener("dispose", s), i.get(l) !== c && (n.update(l.instanceMatrix, t.ARRAY_BUFFER), l.instanceColor !== null && n.update(l.instanceColor, t.ARRAY_BUFFER), i.set(l, c))), l.isSkinnedMesh) {
      const f = l.skeleton;
      i.get(f) !== c && (f.update(), i.set(f, c));
    }
    return d;
  }
  function a() {
    i = /* @__PURE__ */ new WeakMap();
  }
  function s(l) {
    const c = l.target;
    c.removeEventListener("dispose", s), n.remove(c.instanceMatrix), c.instanceColor !== null && n.remove(c.instanceColor);
  }
  return {
    update: o,
    dispose: a
  };
}
const $9 = /* @__PURE__ */ new En(), ng = /* @__PURE__ */ new B9(1, 1), W9 = /* @__PURE__ */ new D9(), j9 = /* @__PURE__ */ new bee(), G9 = /* @__PURE__ */ new H9(), rg = [], ig = [], og = new Float32Array(16), ag = new Float32Array(9), sg = new Float32Array(4);
function Os(t, e, n) {
  const r = t[0];
  if (r <= 0 || r > 0)
    return t;
  const i = e * n;
  let o = rg[i];
  if (o === void 0 && (o = new Float32Array(i), rg[i] = o), e !== 0) {
    r.toArray(o, 0);
    for (let a = 1, s = 0; a !== e; ++a)
      s += n, t[a].toArray(o, s);
  }
  return o;
}
function nn(t, e) {
  if (t.length !== e.length)
    return !1;
  for (let n = 0, r = t.length; n < r; n++)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
function rn(t, e) {
  for (let n = 0, r = e.length; n < r; n++)
    t[n] = e[n];
}
function Jd(t, e) {
  let n = ig[e];
  n === void 0 && (n = new Int32Array(e), ig[e] = n);
  for (let r = 0; r !== e; ++r)
    n[r] = t.allocateTextureUnit();
  return n;
}
function jre(t, e) {
  const n = this.cache;
  n[0] !== e && (t.uniform1f(this.addr, e), n[0] = e);
}
function Gre(t, e) {
  const n = this.cache;
  if (e.x !== void 0)
    (n[0] !== e.x || n[1] !== e.y) && (t.uniform2f(this.addr, e.x, e.y), n[0] = e.x, n[1] = e.y);
  else {
    if (nn(n, e))
      return;
    t.uniform2fv(this.addr, e), rn(n, e);
  }
}
function qre(t, e) {
  const n = this.cache;
  if (e.x !== void 0)
    (n[0] !== e.x || n[1] !== e.y || n[2] !== e.z) && (t.uniform3f(this.addr, e.x, e.y, e.z), n[0] = e.x, n[1] = e.y, n[2] = e.z);
  else if (e.r !== void 0)
    (n[0] !== e.r || n[1] !== e.g || n[2] !== e.b) && (t.uniform3f(this.addr, e.r, e.g, e.b), n[0] = e.r, n[1] = e.g, n[2] = e.b);
  else {
    if (nn(n, e))
      return;
    t.uniform3fv(this.addr, e), rn(n, e);
  }
}
function Xre(t, e) {
  const n = this.cache;
  if (e.x !== void 0)
    (n[0] !== e.x || n[1] !== e.y || n[2] !== e.z || n[3] !== e.w) && (t.uniform4f(this.addr, e.x, e.y, e.z, e.w), n[0] = e.x, n[1] = e.y, n[2] = e.z, n[3] = e.w);
  else {
    if (nn(n, e))
      return;
    t.uniform4fv(this.addr, e), rn(n, e);
  }
}
function Yre(t, e) {
  const n = this.cache, r = e.elements;
  if (r === void 0) {
    if (nn(n, e))
      return;
    t.uniformMatrix2fv(this.addr, !1, e), rn(n, e);
  } else {
    if (nn(n, r))
      return;
    sg.set(r), t.uniformMatrix2fv(this.addr, !1, sg), rn(n, r);
  }
}
function Zre(t, e) {
  const n = this.cache, r = e.elements;
  if (r === void 0) {
    if (nn(n, e))
      return;
    t.uniformMatrix3fv(this.addr, !1, e), rn(n, e);
  } else {
    if (nn(n, r))
      return;
    ag.set(r), t.uniformMatrix3fv(this.addr, !1, ag), rn(n, r);
  }
}
function Kre(t, e) {
  const n = this.cache, r = e.elements;
  if (r === void 0) {
    if (nn(n, e))
      return;
    t.uniformMatrix4fv(this.addr, !1, e), rn(n, e);
  } else {
    if (nn(n, r))
      return;
    og.set(r), t.uniformMatrix4fv(this.addr, !1, og), rn(n, r);
  }
}
function Jre(t, e) {
  const n = this.cache;
  n[0] !== e && (t.uniform1i(this.addr, e), n[0] = e);
}
function Qre(t, e) {
  const n = this.cache;
  if (e.x !== void 0)
    (n[0] !== e.x || n[1] !== e.y) && (t.uniform2i(this.addr, e.x, e.y), n[0] = e.x, n[1] = e.y);
  else {
    if (nn(n, e))
      return;
    t.uniform2iv(this.addr, e), rn(n, e);
  }
}
function eie(t, e) {
  const n = this.cache;
  if (e.x !== void 0)
    (n[0] !== e.x || n[1] !== e.y || n[2] !== e.z) && (t.uniform3i(this.addr, e.x, e.y, e.z), n[0] = e.x, n[1] = e.y, n[2] = e.z);
  else {
    if (nn(n, e))
      return;
    t.uniform3iv(this.addr, e), rn(n, e);
  }
}
function tie(t, e) {
  const n = this.cache;
  if (e.x !== void 0)
    (n[0] !== e.x || n[1] !== e.y || n[2] !== e.z || n[3] !== e.w) && (t.uniform4i(this.addr, e.x, e.y, e.z, e.w), n[0] = e.x, n[1] = e.y, n[2] = e.z, n[3] = e.w);
  else {
    if (nn(n, e))
      return;
    t.uniform4iv(this.addr, e), rn(n, e);
  }
}
function nie(t, e) {
  const n = this.cache;
  n[0] !== e && (t.uniform1ui(this.addr, e), n[0] = e);
}
function rie(t, e) {
  const n = this.cache;
  if (e.x !== void 0)
    (n[0] !== e.x || n[1] !== e.y) && (t.uniform2ui(this.addr, e.x, e.y), n[0] = e.x, n[1] = e.y);
  else {
    if (nn(n, e))
      return;
    t.uniform2uiv(this.addr, e), rn(n, e);
  }
}
function iie(t, e) {
  const n = this.cache;
  if (e.x !== void 0)
    (n[0] !== e.x || n[1] !== e.y || n[2] !== e.z) && (t.uniform3ui(this.addr, e.x, e.y, e.z), n[0] = e.x, n[1] = e.y, n[2] = e.z);
  else {
    if (nn(n, e))
      return;
    t.uniform3uiv(this.addr, e), rn(n, e);
  }
}
function oie(t, e) {
  const n = this.cache;
  if (e.x !== void 0)
    (n[0] !== e.x || n[1] !== e.y || n[2] !== e.z || n[3] !== e.w) && (t.uniform4ui(this.addr, e.x, e.y, e.z, e.w), n[0] = e.x, n[1] = e.y, n[2] = e.z, n[3] = e.w);
  else {
    if (nn(n, e))
      return;
    t.uniform4uiv(this.addr, e), rn(n, e);
  }
}
function aie(t, e, n) {
  const r = this.cache, i = n.allocateTextureUnit();
  r[0] !== i && (t.uniform1i(this.addr, i), r[0] = i);
  let o;
  this.type === t.SAMPLER_2D_SHADOW ? (ng.compareFunction = L9, o = ng) : o = $9, n.setTexture2D(e || o, i);
}
function sie(t, e, n) {
  const r = this.cache, i = n.allocateTextureUnit();
  r[0] !== i && (t.uniform1i(this.addr, i), r[0] = i), n.setTexture3D(e || j9, i);
}
function lie(t, e, n) {
  const r = this.cache, i = n.allocateTextureUnit();
  r[0] !== i && (t.uniform1i(this.addr, i), r[0] = i), n.setTextureCube(e || G9, i);
}
function cie(t, e, n) {
  const r = this.cache, i = n.allocateTextureUnit();
  r[0] !== i && (t.uniform1i(this.addr, i), r[0] = i), n.setTexture2DArray(e || W9, i);
}
function uie(t) {
  switch (t) {
    case 5126:
      return jre;
    case 35664:
      return Gre;
    case 35665:
      return qre;
    case 35666:
      return Xre;
    case 35674:
      return Yre;
    case 35675:
      return Zre;
    case 35676:
      return Kre;
    case 5124:
    case 35670:
      return Jre;
    case 35667:
    case 35671:
      return Qre;
    case 35668:
    case 35672:
      return eie;
    case 35669:
    case 35673:
      return tie;
    case 5125:
      return nie;
    case 36294:
      return rie;
    case 36295:
      return iie;
    case 36296:
      return oie;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return aie;
    case 35679:
    case 36299:
    case 36307:
      return sie;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return lie;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return cie;
  }
}
function die(t, e) {
  t.uniform1fv(this.addr, e);
}
function fie(t, e) {
  const n = Os(e, this.size, 2);
  t.uniform2fv(this.addr, n);
}
function hie(t, e) {
  const n = Os(e, this.size, 3);
  t.uniform3fv(this.addr, n);
}
function pie(t, e) {
  const n = Os(e, this.size, 4);
  t.uniform4fv(this.addr, n);
}
function mie(t, e) {
  const n = Os(e, this.size, 4);
  t.uniformMatrix2fv(this.addr, !1, n);
}
function vie(t, e) {
  const n = Os(e, this.size, 9);
  t.uniformMatrix3fv(this.addr, !1, n);
}
function gie(t, e) {
  const n = Os(e, this.size, 16);
  t.uniformMatrix4fv(this.addr, !1, n);
}
function yie(t, e) {
  t.uniform1iv(this.addr, e);
}
function bie(t, e) {
  t.uniform2iv(this.addr, e);
}
function xie(t, e) {
  t.uniform3iv(this.addr, e);
}
function wie(t, e) {
  t.uniform4iv(this.addr, e);
}
function _ie(t, e) {
  t.uniform1uiv(this.addr, e);
}
function Cie(t, e) {
  t.uniform2uiv(this.addr, e);
}
function Eie(t, e) {
  t.uniform3uiv(this.addr, e);
}
function Sie(t, e) {
  t.uniform4uiv(this.addr, e);
}
function Mie(t, e, n) {
  const r = this.cache, i = e.length, o = Jd(n, i);
  nn(r, o) || (t.uniform1iv(this.addr, o), rn(r, o));
  for (let a = 0; a !== i; ++a)
    n.setTexture2D(e[a] || $9, o[a]);
}
function Tie(t, e, n) {
  const r = this.cache, i = e.length, o = Jd(n, i);
  nn(r, o) || (t.uniform1iv(this.addr, o), rn(r, o));
  for (let a = 0; a !== i; ++a)
    n.setTexture3D(e[a] || j9, o[a]);
}
function Aie(t, e, n) {
  const r = this.cache, i = e.length, o = Jd(n, i);
  nn(r, o) || (t.uniform1iv(this.addr, o), rn(r, o));
  for (let a = 0; a !== i; ++a)
    n.setTextureCube(e[a] || G9, o[a]);
}
function Pie(t, e, n) {
  const r = this.cache, i = e.length, o = Jd(n, i);
  nn(r, o) || (t.uniform1iv(this.addr, o), rn(r, o));
  for (let a = 0; a !== i; ++a)
    n.setTexture2DArray(e[a] || W9, o[a]);
}
function Rie(t) {
  switch (t) {
    case 5126:
      return die;
    case 35664:
      return fie;
    case 35665:
      return hie;
    case 35666:
      return pie;
    case 35674:
      return mie;
    case 35675:
      return vie;
    case 35676:
      return gie;
    case 5124:
    case 35670:
      return yie;
    case 35667:
    case 35671:
      return bie;
    case 35668:
    case 35672:
      return xie;
    case 35669:
    case 35673:
      return wie;
    case 5125:
      return _ie;
    case 36294:
      return Cie;
    case 36295:
      return Eie;
    case 36296:
      return Sie;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return Mie;
    case 35679:
    case 36299:
    case 36307:
      return Tie;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return Aie;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return Pie;
  }
}
class Lie {
  constructor(e, n, r) {
    this.id = e, this.addr = r, this.cache = [], this.type = n.type, this.setValue = uie(n.type);
  }
}
class Oie {
  constructor(e, n, r) {
    this.id = e, this.addr = r, this.cache = [], this.type = n.type, this.size = n.size, this.setValue = Rie(n.type);
  }
}
class Die {
  constructor(e) {
    this.id = e, this.seq = [], this.map = {};
  }
  setValue(e, n, r) {
    const i = this.seq;
    for (let o = 0, a = i.length; o !== a; ++o) {
      const s = i[o];
      s.setValue(e, n[s.id], r);
    }
  }
}
const z0 = /(\w+)(\])?(\[|\.)?/g;
function lg(t, e) {
  t.seq.push(e), t.map[e.id] = e;
}
function kie(t, e, n) {
  const r = t.name, i = r.length;
  for (z0.lastIndex = 0; ; ) {
    const o = z0.exec(r), a = z0.lastIndex;
    let s = o[1];
    const l = o[2] === "]", c = o[3];
    if (l && (s = s | 0), c === void 0 || c === "[" && a + 2 === i) {
      lg(n, c === void 0 ? new Lie(s, t, e) : new Oie(s, t, e));
      break;
    } else {
      let d = n.map[s];
      d === void 0 && (d = new Die(s), lg(n, d)), n = d;
    }
  }
}
class Pu {
  constructor(e, n) {
    this.seq = [], this.map = {};
    const r = e.getProgramParameter(n, e.ACTIVE_UNIFORMS);
    for (let i = 0; i < r; ++i) {
      const o = e.getActiveUniform(n, i), a = e.getUniformLocation(n, o.name);
      kie(o, a, this);
    }
  }
  setValue(e, n, r, i) {
    const o = this.map[n];
    o !== void 0 && o.setValue(e, r, i);
  }
  setOptional(e, n, r) {
    const i = n[r];
    i !== void 0 && this.setValue(e, r, i);
  }
  static upload(e, n, r, i) {
    for (let o = 0, a = n.length; o !== a; ++o) {
      const s = n[o], l = r[s.id];
      l.needsUpdate !== !1 && s.setValue(e, l.value, i);
    }
  }
  static seqWithValue(e, n) {
    const r = [];
    for (let i = 0, o = e.length; i !== o; ++i) {
      const a = e[i];
      a.id in n && r.push(a);
    }
    return r;
  }
}
function cg(t, e, n) {
  const r = t.createShader(e);
  return t.shaderSource(r, n), t.compileShader(r), r;
}
const Nie = 37297;
let Iie = 0;
function Fie(t, e) {
  const n = t.split(`
`), r = [], i = Math.max(e - 6, 0), o = Math.min(e + 6, n.length);
  for (let a = i; a < o; a++) {
    const s = a + 1;
    r.push(`${s === e ? ">" : " "} ${s}: ${n[a]}`);
  }
  return r.join(`
`);
}
const ug = /* @__PURE__ */ new ot();
function Uie(t) {
  mt._getMatrix(ug, mt.workingColorSpace, t);
  const e = `mat3( ${ug.elements.map((n) => n.toFixed(4))} )`;
  switch (mt.getTransfer(t)) {
    case nd:
      return [e, "LinearTransferOETF"];
    case Tt:
      return [e, "sRGBTransferOETF"];
    default:
      return console.warn("THREE.WebGLProgram: Unsupported color space: ", t), [e, "LinearTransferOETF"];
  }
}
function dg(t, e, n) {
  const r = t.getShaderParameter(e, t.COMPILE_STATUS), i = t.getShaderInfoLog(e).trim();
  if (r && i === "")
    return "";
  const o = /ERROR: 0:(\d+)/.exec(i);
  if (o) {
    const a = parseInt(o[1]);
    return n.toUpperCase() + `

` + i + `

` + Fie(t.getShaderSource(e), a);
  } else
    return i;
}
function zie(t, e) {
  const n = Uie(e);
  return [
    `vec4 ${t}( vec4 value ) {`,
    `	return ${n[1]}( vec4( value.rgb * ${n[0]}, value.a ) );`,
    "}"
  ].join(`
`);
}
function Hie(t, e) {
  let n;
  switch (e) {
    case b9:
      n = "Linear";
      break;
    case RQ:
      n = "Reinhard";
      break;
    case LQ:
      n = "Cineon";
      break;
    case OQ:
      n = "ACESFilmic";
      break;
    case kQ:
      n = "AgX";
      break;
    case NQ:
      n = "Neutral";
      break;
    case DQ:
      n = "Custom";
      break;
    default:
      console.warn("THREE.WebGLProgram: Unsupported toneMapping:", e), n = "Linear";
  }
  return "vec3 " + t + "( vec3 color ) { return " + n + "ToneMapping( color ); }";
}
const nu = /* @__PURE__ */ new re();
function Bie() {
  mt.getLuminanceCoefficients(nu);
  const t = nu.x.toFixed(4), e = nu.y.toFixed(4), n = nu.z.toFixed(4);
  return [
    "float luminance( const in vec3 rgb ) {",
    `	const vec3 weights = vec3( ${t}, ${e}, ${n} );`,
    "	return dot( weights, rgb );",
    "}"
  ].join(`
`);
}
function Vie(t) {
  return [
    t.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
    t.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""
  ].filter(al).join(`
`);
}
function $ie(t) {
  const e = [];
  for (const n in t) {
    const r = t[n];
    r !== !1 && e.push("#define " + n + " " + r);
  }
  return e.join(`
`);
}
function Wie(t, e) {
  const n = {}, r = t.getProgramParameter(e, t.ACTIVE_ATTRIBUTES);
  for (let i = 0; i < r; i++) {
    const o = t.getActiveAttrib(e, i), a = o.name;
    let s = 1;
    o.type === t.FLOAT_MAT2 && (s = 2), o.type === t.FLOAT_MAT3 && (s = 3), o.type === t.FLOAT_MAT4 && (s = 4), n[a] = {
      type: o.type,
      location: t.getAttribLocation(e, a),
      locationSize: s
    };
  }
  return n;
}
function al(t) {
  return t !== "";
}
function fg(t, e) {
  const n = e.numSpotLightShadows + e.numSpotLightMaps - e.numSpotLightShadowsWithMaps;
  return t.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, e.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, n).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, e.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
}
function hg(t, e) {
  return t.replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection);
}
const jie = /^[ \t]*#include +<([\w\d./]+)>/gm;
function _1(t) {
  return t.replace(jie, qie);
}
const Gie = /* @__PURE__ */ new Map();
function qie(t, e) {
  let n = at[e];
  if (n === void 0) {
    const r = Gie.get(e);
    if (r !== void 0)
      n = at[r], console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', e, r);
    else
      throw new Error("Can not resolve #include <" + e + ">");
  }
  return _1(n);
}
const Xie = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function pg(t) {
  return t.replace(Xie, Yie);
}
function Yie(t, e, n, r) {
  let i = "";
  for (let o = parseInt(e); o < parseInt(n); o++)
    i += r.replace(/\[\s*i\s*\]/g, "[ " + o + " ]").replace(/UNROLLED_LOOP_INDEX/g, o);
  return i;
}
function mg(t) {
  let e = `precision ${t.precision} float;
	precision ${t.precision} int;
	precision ${t.precision} sampler2D;
	precision ${t.precision} samplerCube;
	precision ${t.precision} sampler3D;
	precision ${t.precision} sampler2DArray;
	precision ${t.precision} sampler2DShadow;
	precision ${t.precision} samplerCubeShadow;
	precision ${t.precision} sampler2DArrayShadow;
	precision ${t.precision} isampler2D;
	precision ${t.precision} isampler3D;
	precision ${t.precision} isamplerCube;
	precision ${t.precision} isampler2DArray;
	precision ${t.precision} usampler2D;
	precision ${t.precision} usampler3D;
	precision ${t.precision} usamplerCube;
	precision ${t.precision} usampler2DArray;
	`;
  return t.precision === "highp" ? e += `
#define HIGH_PRECISION` : t.precision === "mediump" ? e += `
#define MEDIUM_PRECISION` : t.precision === "lowp" && (e += `
#define LOW_PRECISION`), e;
}
function Zie(t) {
  let e = "SHADOWMAP_TYPE_BASIC";
  return t.shadowMapType === g9 ? e = "SHADOWMAP_TYPE_PCF" : t.shadowMapType === cQ ? e = "SHADOWMAP_TYPE_PCF_SOFT" : t.shadowMapType === Qr && (e = "SHADOWMAP_TYPE_VSM"), e;
}
function Kie(t) {
  let e = "ENVMAP_TYPE_CUBE";
  if (t.envMap)
    switch (t.envMapMode) {
      case ns:
      case rs:
        e = "ENVMAP_TYPE_CUBE";
        break;
      case Yd:
        e = "ENVMAP_TYPE_CUBE_UV";
        break;
    }
  return e;
}
function Jie(t) {
  let e = "ENVMAP_MODE_REFLECTION";
  if (t.envMap)
    switch (t.envMapMode) {
      case rs:
        e = "ENVMAP_MODE_REFRACTION";
        break;
    }
  return e;
}
function Qie(t) {
  let e = "ENVMAP_BLENDING_NONE";
  if (t.envMap)
    switch (t.combine) {
      case y9:
        e = "ENVMAP_BLENDING_MULTIPLY";
        break;
      case AQ:
        e = "ENVMAP_BLENDING_MIX";
        break;
      case PQ:
        e = "ENVMAP_BLENDING_ADD";
        break;
    }
  return e;
}
function eoe(t) {
  const e = t.envMapCubeUVHeight;
  if (e === null)
    return null;
  const n = Math.log2(e) - 2, r = 1 / e;
  return { texelWidth: 1 / (3 * Math.max(Math.pow(2, n), 7 * 16)), texelHeight: r, maxMip: n };
}
function toe(t, e, n, r) {
  const i = t.getContext(), o = n.defines;
  let a = n.vertexShader, s = n.fragmentShader;
  const l = Zie(n), c = Kie(n), u = Jie(n), d = Qie(n), f = eoe(n), h = Vie(n), v = $ie(o), g = i.createProgram();
  let m, p, y = n.glslVersion ? "#version " + n.glslVersion + `
` : "";
  n.isRawShaderMaterial ? (m = [
    "#define SHADER_TYPE " + n.shaderType,
    "#define SHADER_NAME " + n.shaderName,
    v
  ].filter(al).join(`
`), m.length > 0 && (m += `
`), p = [
    "#define SHADER_TYPE " + n.shaderType,
    "#define SHADER_NAME " + n.shaderName,
    v
  ].filter(al).join(`
`), p.length > 0 && (p += `
`)) : (m = [
    mg(n),
    "#define SHADER_TYPE " + n.shaderType,
    "#define SHADER_NAME " + n.shaderName,
    v,
    n.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
    n.batching ? "#define USE_BATCHING" : "",
    n.batchingColor ? "#define USE_BATCHING_COLOR" : "",
    n.instancing ? "#define USE_INSTANCING" : "",
    n.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
    n.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
    n.useFog && n.fog ? "#define USE_FOG" : "",
    n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
    n.map ? "#define USE_MAP" : "",
    n.envMap ? "#define USE_ENVMAP" : "",
    n.envMap ? "#define " + u : "",
    n.lightMap ? "#define USE_LIGHTMAP" : "",
    n.aoMap ? "#define USE_AOMAP" : "",
    n.bumpMap ? "#define USE_BUMPMAP" : "",
    n.normalMap ? "#define USE_NORMALMAP" : "",
    n.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
    n.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
    n.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
    n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
    n.anisotropy ? "#define USE_ANISOTROPY" : "",
    n.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
    n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
    n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
    n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
    n.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
    n.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
    n.specularMap ? "#define USE_SPECULARMAP" : "",
    n.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
    n.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
    n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
    n.metalnessMap ? "#define USE_METALNESSMAP" : "",
    n.alphaMap ? "#define USE_ALPHAMAP" : "",
    n.alphaHash ? "#define USE_ALPHAHASH" : "",
    n.transmission ? "#define USE_TRANSMISSION" : "",
    n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
    n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
    n.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
    n.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
    //
    n.mapUv ? "#define MAP_UV " + n.mapUv : "",
    n.alphaMapUv ? "#define ALPHAMAP_UV " + n.alphaMapUv : "",
    n.lightMapUv ? "#define LIGHTMAP_UV " + n.lightMapUv : "",
    n.aoMapUv ? "#define AOMAP_UV " + n.aoMapUv : "",
    n.emissiveMapUv ? "#define EMISSIVEMAP_UV " + n.emissiveMapUv : "",
    n.bumpMapUv ? "#define BUMPMAP_UV " + n.bumpMapUv : "",
    n.normalMapUv ? "#define NORMALMAP_UV " + n.normalMapUv : "",
    n.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + n.displacementMapUv : "",
    n.metalnessMapUv ? "#define METALNESSMAP_UV " + n.metalnessMapUv : "",
    n.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + n.roughnessMapUv : "",
    n.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + n.anisotropyMapUv : "",
    n.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + n.clearcoatMapUv : "",
    n.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + n.clearcoatNormalMapUv : "",
    n.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + n.clearcoatRoughnessMapUv : "",
    n.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + n.iridescenceMapUv : "",
    n.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + n.iridescenceThicknessMapUv : "",
    n.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + n.sheenColorMapUv : "",
    n.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + n.sheenRoughnessMapUv : "",
    n.specularMapUv ? "#define SPECULARMAP_UV " + n.specularMapUv : "",
    n.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + n.specularColorMapUv : "",
    n.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + n.specularIntensityMapUv : "",
    n.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + n.transmissionMapUv : "",
    n.thicknessMapUv ? "#define THICKNESSMAP_UV " + n.thicknessMapUv : "",
    //
    n.vertexTangents && n.flatShading === !1 ? "#define USE_TANGENT" : "",
    n.vertexColors ? "#define USE_COLOR" : "",
    n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
    n.vertexUv1s ? "#define USE_UV1" : "",
    n.vertexUv2s ? "#define USE_UV2" : "",
    n.vertexUv3s ? "#define USE_UV3" : "",
    n.pointsUvs ? "#define USE_POINTS_UV" : "",
    n.flatShading ? "#define FLAT_SHADED" : "",
    n.skinning ? "#define USE_SKINNING" : "",
    n.morphTargets ? "#define USE_MORPHTARGETS" : "",
    n.morphNormals && n.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
    n.morphColors ? "#define USE_MORPHCOLORS" : "",
    n.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + n.morphTextureStride : "",
    n.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + n.morphTargetsCount : "",
    n.doubleSided ? "#define DOUBLE_SIDED" : "",
    n.flipSided ? "#define FLIP_SIDED" : "",
    n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
    n.shadowMapEnabled ? "#define " + l : "",
    n.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
    n.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
    n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
    n.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
    "uniform mat4 modelMatrix;",
    "uniform mat4 modelViewMatrix;",
    "uniform mat4 projectionMatrix;",
    "uniform mat4 viewMatrix;",
    "uniform mat3 normalMatrix;",
    "uniform vec3 cameraPosition;",
    "uniform bool isOrthographic;",
    "#ifdef USE_INSTANCING",
    "	attribute mat4 instanceMatrix;",
    "#endif",
    "#ifdef USE_INSTANCING_COLOR",
    "	attribute vec3 instanceColor;",
    "#endif",
    "#ifdef USE_INSTANCING_MORPH",
    "	uniform sampler2D morphTexture;",
    "#endif",
    "attribute vec3 position;",
    "attribute vec3 normal;",
    "attribute vec2 uv;",
    "#ifdef USE_UV1",
    "	attribute vec2 uv1;",
    "#endif",
    "#ifdef USE_UV2",
    "	attribute vec2 uv2;",
    "#endif",
    "#ifdef USE_UV3",
    "	attribute vec2 uv3;",
    "#endif",
    "#ifdef USE_TANGENT",
    "	attribute vec4 tangent;",
    "#endif",
    "#if defined( USE_COLOR_ALPHA )",
    "	attribute vec4 color;",
    "#elif defined( USE_COLOR )",
    "	attribute vec3 color;",
    "#endif",
    "#ifdef USE_SKINNING",
    "	attribute vec4 skinIndex;",
    "	attribute vec4 skinWeight;",
    "#endif",
    `
`
  ].filter(al).join(`
`), p = [
    mg(n),
    "#define SHADER_TYPE " + n.shaderType,
    "#define SHADER_NAME " + n.shaderName,
    v,
    n.useFog && n.fog ? "#define USE_FOG" : "",
    n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
    n.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
    n.map ? "#define USE_MAP" : "",
    n.matcap ? "#define USE_MATCAP" : "",
    n.envMap ? "#define USE_ENVMAP" : "",
    n.envMap ? "#define " + c : "",
    n.envMap ? "#define " + u : "",
    n.envMap ? "#define " + d : "",
    f ? "#define CUBEUV_TEXEL_WIDTH " + f.texelWidth : "",
    f ? "#define CUBEUV_TEXEL_HEIGHT " + f.texelHeight : "",
    f ? "#define CUBEUV_MAX_MIP " + f.maxMip + ".0" : "",
    n.lightMap ? "#define USE_LIGHTMAP" : "",
    n.aoMap ? "#define USE_AOMAP" : "",
    n.bumpMap ? "#define USE_BUMPMAP" : "",
    n.normalMap ? "#define USE_NORMALMAP" : "",
    n.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
    n.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
    n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
    n.anisotropy ? "#define USE_ANISOTROPY" : "",
    n.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
    n.clearcoat ? "#define USE_CLEARCOAT" : "",
    n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
    n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
    n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
    n.dispersion ? "#define USE_DISPERSION" : "",
    n.iridescence ? "#define USE_IRIDESCENCE" : "",
    n.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
    n.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
    n.specularMap ? "#define USE_SPECULARMAP" : "",
    n.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
    n.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
    n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
    n.metalnessMap ? "#define USE_METALNESSMAP" : "",
    n.alphaMap ? "#define USE_ALPHAMAP" : "",
    n.alphaTest ? "#define USE_ALPHATEST" : "",
    n.alphaHash ? "#define USE_ALPHAHASH" : "",
    n.sheen ? "#define USE_SHEEN" : "",
    n.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
    n.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
    n.transmission ? "#define USE_TRANSMISSION" : "",
    n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
    n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
    n.vertexTangents && n.flatShading === !1 ? "#define USE_TANGENT" : "",
    n.vertexColors || n.instancingColor || n.batchingColor ? "#define USE_COLOR" : "",
    n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
    n.vertexUv1s ? "#define USE_UV1" : "",
    n.vertexUv2s ? "#define USE_UV2" : "",
    n.vertexUv3s ? "#define USE_UV3" : "",
    n.pointsUvs ? "#define USE_POINTS_UV" : "",
    n.gradientMap ? "#define USE_GRADIENTMAP" : "",
    n.flatShading ? "#define FLAT_SHADED" : "",
    n.doubleSided ? "#define DOUBLE_SIDED" : "",
    n.flipSided ? "#define FLIP_SIDED" : "",
    n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
    n.shadowMapEnabled ? "#define " + l : "",
    n.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
    n.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
    n.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
    n.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
    n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
    n.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
    "uniform mat4 viewMatrix;",
    "uniform vec3 cameraPosition;",
    "uniform bool isOrthographic;",
    n.toneMapping !== Bi ? "#define TONE_MAPPING" : "",
    n.toneMapping !== Bi ? at.tonemapping_pars_fragment : "",
    // this code is required here because it is used by the toneMapping() function defined below
    n.toneMapping !== Bi ? Hie("toneMapping", n.toneMapping) : "",
    n.dithering ? "#define DITHERING" : "",
    n.opaque ? "#define OPAQUE" : "",
    at.colorspace_pars_fragment,
    // this code is required here because it is used by the various encoding/decoding function defined below
    zie("linearToOutputTexel", n.outputColorSpace),
    Bie(),
    n.useDepthPacking ? "#define DEPTH_PACKING " + n.depthPacking : "",
    `
`
  ].filter(al).join(`
`)), a = _1(a), a = fg(a, n), a = hg(a, n), s = _1(s), s = fg(s, n), s = hg(s, n), a = pg(a), s = pg(s), n.isRawShaderMaterial !== !0 && (y = `#version 300 es
`, m = [
    h,
    "#define attribute in",
    "#define varying out",
    "#define texture2D texture"
  ].join(`
`) + `
` + m, p = [
    "#define varying in",
    n.glslVersion === M4 ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
    n.glslVersion === M4 ? "" : "#define gl_FragColor pc_fragColor",
    "#define gl_FragDepthEXT gl_FragDepth",
    "#define texture2D texture",
    "#define textureCube texture",
    "#define texture2DProj textureProj",
    "#define texture2DLodEXT textureLod",
    "#define texture2DProjLodEXT textureProjLod",
    "#define textureCubeLodEXT textureLod",
    "#define texture2DGradEXT textureGrad",
    "#define texture2DProjGradEXT textureProjGrad",
    "#define textureCubeGradEXT textureGrad"
  ].join(`
`) + `
` + p);
  const b = y + m + a, x = y + p + s, _ = cg(i, i.VERTEX_SHADER, b), M = cg(i, i.FRAGMENT_SHADER, x);
  i.attachShader(g, _), i.attachShader(g, M), n.index0AttributeName !== void 0 ? i.bindAttribLocation(g, 0, n.index0AttributeName) : n.morphTargets === !0 && i.bindAttribLocation(g, 0, "position"), i.linkProgram(g);
  function S(O) {
    if (t.debug.checkShaderErrors) {
      const N = i.getProgramInfoLog(g).trim(), I = i.getShaderInfoLog(_).trim(), H = i.getShaderInfoLog(M).trim();
      let j = !0, U = !0;
      if (i.getProgramParameter(g, i.LINK_STATUS) === !1)
        if (j = !1, typeof t.debug.onShaderError == "function")
          t.debug.onShaderError(i, g, _, M);
        else {
          const $ = dg(i, _, "vertex"), V = dg(i, M, "fragment");
          console.error(
            "THREE.WebGLProgram: Shader Error " + i.getError() + " - VALIDATE_STATUS " + i.getProgramParameter(g, i.VALIDATE_STATUS) + `

Material Name: ` + O.name + `
Material Type: ` + O.type + `

Program Info Log: ` + N + `
` + $ + `
` + V
          );
        }
      else
        N !== "" ? console.warn("THREE.WebGLProgram: Program Info Log:", N) : (I === "" || H === "") && (U = !1);
      U && (O.diagnostics = {
        runnable: j,
        programLog: N,
        vertexShader: {
          log: I,
          prefix: m
        },
        fragmentShader: {
          log: H,
          prefix: p
        }
      });
    }
    i.deleteShader(_), i.deleteShader(M), P = new Pu(i, g), E = Wie(i, g);
  }
  let P;
  this.getUniforms = function() {
    return P === void 0 && S(this), P;
  };
  let E;
  this.getAttributes = function() {
    return E === void 0 && S(this), E;
  };
  let w = n.rendererExtensionParallelShaderCompile === !1;
  return this.isReady = function() {
    return w === !1 && (w = i.getProgramParameter(g, Nie)), w;
  }, this.destroy = function() {
    r.releaseStatesOfProgram(this), i.deleteProgram(g), this.program = void 0;
  }, this.type = n.shaderType, this.name = n.shaderName, this.id = Iie++, this.cacheKey = e, this.usedTimes = 1, this.program = g, this.vertexShader = _, this.fragmentShader = M, this;
}
let noe = 0;
class roe {
  constructor() {
    this.shaderCache = /* @__PURE__ */ new Map(), this.materialCache = /* @__PURE__ */ new Map();
  }
  update(e) {
    const n = e.vertexShader, r = e.fragmentShader, i = this._getShaderStage(n), o = this._getShaderStage(r), a = this._getShaderCacheForMaterial(e);
    return a.has(i) === !1 && (a.add(i), i.usedTimes++), a.has(o) === !1 && (a.add(o), o.usedTimes++), this;
  }
  remove(e) {
    const n = this.materialCache.get(e);
    for (const r of n)
      r.usedTimes--, r.usedTimes === 0 && this.shaderCache.delete(r.code);
    return this.materialCache.delete(e), this;
  }
  getVertexShaderID(e) {
    return this._getShaderStage(e.vertexShader).id;
  }
  getFragmentShaderID(e) {
    return this._getShaderStage(e.fragmentShader).id;
  }
  dispose() {
    this.shaderCache.clear(), this.materialCache.clear();
  }
  _getShaderCacheForMaterial(e) {
    const n = this.materialCache;
    let r = n.get(e);
    return r === void 0 && (r = /* @__PURE__ */ new Set(), n.set(e, r)), r;
  }
  _getShaderStage(e) {
    const n = this.shaderCache;
    let r = n.get(e);
    return r === void 0 && (r = new ioe(e), n.set(e, r)), r;
  }
}
class ioe {
  constructor(e) {
    this.id = noe++, this.code = e, this.usedTimes = 0;
  }
}
function ooe(t, e, n, r, i, o, a) {
  const s = new P2(), l = new roe(), c = /* @__PURE__ */ new Set(), u = [], d = i.logarithmicDepthBuffer, f = i.vertexTextures;
  let h = i.precision;
  const v = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distanceRGBA",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite"
  };
  function g(E) {
    return c.add(E), E === 0 ? "uv" : `uv${E}`;
  }
  function m(E, w, O, N, I) {
    const H = N.fog, j = I.geometry, U = E.isMeshStandardMaterial ? N.environment : null, $ = (E.isMeshStandardMaterial ? n : e).get(E.envMap || U), V = $ && $.mapping === Yd ? $.image.height : null, te = v[E.type];
    E.precision !== null && (h = i.getMaxPrecision(E.precision), h !== E.precision && console.warn("THREE.WebGLProgram.getParameters:", E.precision, "not supported, using", h, "instead."));
    const B = j.morphAttributes.position || j.morphAttributes.normal || j.morphAttributes.color, Z = B !== void 0 ? B.length : 0;
    let Q = 0;
    j.morphAttributes.position !== void 0 && (Q = 1), j.morphAttributes.normal !== void 0 && (Q = 2), j.morphAttributes.color !== void 0 && (Q = 3);
    let ce, k, G, K;
    if (te) {
      const vt = Or[te];
      ce = vt.vertexShader, k = vt.fragmentShader;
    } else
      ce = E.vertexShader, k = E.fragmentShader, l.update(E), G = l.getVertexShaderID(E), K = l.getFragmentShaderID(E);
    const J = t.getRenderTarget(), se = t.state.buffers.depth.getReversed(), be = I.isInstancedMesh === !0, pe = I.isBatchedMesh === !0, Ne = !!E.map, ae = !!E.matcap, Re = !!$, F = !!E.aoMap, Ge = !!E.lightMap, $e = !!E.bumpMap, he = !!E.normalMap, ue = !!E.displacementMap, Se = !!E.emissiveMap, we = !!E.metalnessMap, D = !!E.roughnessMap, T = E.anisotropy > 0, Y = E.clearcoat > 0, fe = E.dispersion > 0, de = E.iridescence > 0, ne = E.sheen > 0, Le = E.transmission > 0, Ce = T && !!E.anisotropyMap, Te = Y && !!E.clearcoatMap, ke = Y && !!E.clearcoatNormalMap, ge = Y && !!E.clearcoatRoughnessMap, Ee = de && !!E.iridescenceMap, Be = de && !!E.iridescenceThicknessMap, We = ne && !!E.sheenColorMap, Fe = ne && !!E.sheenRoughnessMap, qe = !!E.specularMap, Ye = !!E.specularColorMap, Je = !!E.specularIntensityMap, W = Le && !!E.transmissionMap, ye = Le && !!E.thicknessMap, oe = !!E.gradientMap, me = !!E.alphaMap, Oe = E.alphaTest > 0, Ae = !!E.alphaHash, Qe = !!E.extensions;
    let Nt = Bi;
    E.toneMapped && (J === null || J.isXRRenderTarget === !0) && (Nt = t.toneMapping);
    const on = {
      shaderID: te,
      shaderType: E.type,
      shaderName: E.name,
      vertexShader: ce,
      fragmentShader: k,
      defines: E.defines,
      customVertexShaderID: G,
      customFragmentShaderID: K,
      isRawShaderMaterial: E.isRawShaderMaterial === !0,
      glslVersion: E.glslVersion,
      precision: h,
      batching: pe,
      batchingColor: pe && I._colorsTexture !== null,
      instancing: be,
      instancingColor: be && I.instanceColor !== null,
      instancingMorph: be && I.morphTexture !== null,
      supportsVertexTextures: f,
      outputColorSpace: J === null ? t.outputColorSpace : J.isXRRenderTarget === !0 ? J.texture.colorSpace : zo,
      alphaToCoverage: !!E.alphaToCoverage,
      map: Ne,
      matcap: ae,
      envMap: Re,
      envMapMode: Re && $.mapping,
      envMapCubeUVHeight: V,
      aoMap: F,
      lightMap: Ge,
      bumpMap: $e,
      normalMap: he,
      displacementMap: f && ue,
      emissiveMap: Se,
      normalMapObjectSpace: he && E.normalMapType === HQ,
      normalMapTangentSpace: he && E.normalMapType === zQ,
      metalnessMap: we,
      roughnessMap: D,
      anisotropy: T,
      anisotropyMap: Ce,
      clearcoat: Y,
      clearcoatMap: Te,
      clearcoatNormalMap: ke,
      clearcoatRoughnessMap: ge,
      dispersion: fe,
      iridescence: de,
      iridescenceMap: Ee,
      iridescenceThicknessMap: Be,
      sheen: ne,
      sheenColorMap: We,
      sheenRoughnessMap: Fe,
      specularMap: qe,
      specularColorMap: Ye,
      specularIntensityMap: Je,
      transmission: Le,
      transmissionMap: W,
      thicknessMap: ye,
      gradientMap: oe,
      opaque: E.transparent === !1 && E.blending === Za && E.alphaToCoverage === !1,
      alphaMap: me,
      alphaTest: Oe,
      alphaHash: Ae,
      combine: E.combine,
      //
      mapUv: Ne && g(E.map.channel),
      aoMapUv: F && g(E.aoMap.channel),
      lightMapUv: Ge && g(E.lightMap.channel),
      bumpMapUv: $e && g(E.bumpMap.channel),
      normalMapUv: he && g(E.normalMap.channel),
      displacementMapUv: ue && g(E.displacementMap.channel),
      emissiveMapUv: Se && g(E.emissiveMap.channel),
      metalnessMapUv: we && g(E.metalnessMap.channel),
      roughnessMapUv: D && g(E.roughnessMap.channel),
      anisotropyMapUv: Ce && g(E.anisotropyMap.channel),
      clearcoatMapUv: Te && g(E.clearcoatMap.channel),
      clearcoatNormalMapUv: ke && g(E.clearcoatNormalMap.channel),
      clearcoatRoughnessMapUv: ge && g(E.clearcoatRoughnessMap.channel),
      iridescenceMapUv: Ee && g(E.iridescenceMap.channel),
      iridescenceThicknessMapUv: Be && g(E.iridescenceThicknessMap.channel),
      sheenColorMapUv: We && g(E.sheenColorMap.channel),
      sheenRoughnessMapUv: Fe && g(E.sheenRoughnessMap.channel),
      specularMapUv: qe && g(E.specularMap.channel),
      specularColorMapUv: Ye && g(E.specularColorMap.channel),
      specularIntensityMapUv: Je && g(E.specularIntensityMap.channel),
      transmissionMapUv: W && g(E.transmissionMap.channel),
      thicknessMapUv: ye && g(E.thicknessMap.channel),
      alphaMapUv: me && g(E.alphaMap.channel),
      //
      vertexTangents: !!j.attributes.tangent && (he || T),
      vertexColors: E.vertexColors,
      vertexAlphas: E.vertexColors === !0 && !!j.attributes.color && j.attributes.color.itemSize === 4,
      pointsUvs: I.isPoints === !0 && !!j.attributes.uv && (Ne || me),
      fog: !!H,
      useFog: E.fog === !0,
      fogExp2: !!H && H.isFogExp2,
      flatShading: E.flatShading === !0,
      sizeAttenuation: E.sizeAttenuation === !0,
      logarithmicDepthBuffer: d,
      reverseDepthBuffer: se,
      skinning: I.isSkinnedMesh === !0,
      morphTargets: j.morphAttributes.position !== void 0,
      morphNormals: j.morphAttributes.normal !== void 0,
      morphColors: j.morphAttributes.color !== void 0,
      morphTargetsCount: Z,
      morphTextureStride: Q,
      numDirLights: w.directional.length,
      numPointLights: w.point.length,
      numSpotLights: w.spot.length,
      numSpotLightMaps: w.spotLightMap.length,
      numRectAreaLights: w.rectArea.length,
      numHemiLights: w.hemi.length,
      numDirLightShadows: w.directionalShadowMap.length,
      numPointLightShadows: w.pointShadowMap.length,
      numSpotLightShadows: w.spotShadowMap.length,
      numSpotLightShadowsWithMaps: w.numSpotLightShadowsWithMaps,
      numLightProbes: w.numLightProbes,
      numClippingPlanes: a.numPlanes,
      numClipIntersection: a.numIntersection,
      dithering: E.dithering,
      shadowMapEnabled: t.shadowMap.enabled && O.length > 0,
      shadowMapType: t.shadowMap.type,
      toneMapping: Nt,
      decodeVideoTexture: Ne && E.map.isVideoTexture === !0 && mt.getTransfer(E.map.colorSpace) === Tt,
      decodeVideoTextureEmissive: Se && E.emissiveMap.isVideoTexture === !0 && mt.getTransfer(E.emissiveMap.colorSpace) === Tt,
      premultipliedAlpha: E.premultipliedAlpha,
      doubleSided: E.side === ei,
      flipSided: E.side === Rn,
      useDepthPacking: E.depthPacking >= 0,
      depthPacking: E.depthPacking || 0,
      index0AttributeName: E.index0AttributeName,
      extensionClipCullDistance: Qe && E.extensions.clipCullDistance === !0 && r.has("WEBGL_clip_cull_distance"),
      extensionMultiDraw: (Qe && E.extensions.multiDraw === !0 || pe) && r.has("WEBGL_multi_draw"),
      rendererExtensionParallelShaderCompile: r.has("KHR_parallel_shader_compile"),
      customProgramCacheKey: E.customProgramCacheKey()
    };
    return on.vertexUv1s = c.has(1), on.vertexUv2s = c.has(2), on.vertexUv3s = c.has(3), c.clear(), on;
  }
  function p(E) {
    const w = [];
    if (E.shaderID ? w.push(E.shaderID) : (w.push(E.customVertexShaderID), w.push(E.customFragmentShaderID)), E.defines !== void 0)
      for (const O in E.defines)
        w.push(O), w.push(E.defines[O]);
    return E.isRawShaderMaterial === !1 && (y(w, E), b(w, E), w.push(t.outputColorSpace)), w.push(E.customProgramCacheKey), w.join();
  }
  function y(E, w) {
    E.push(w.precision), E.push(w.outputColorSpace), E.push(w.envMapMode), E.push(w.envMapCubeUVHeight), E.push(w.mapUv), E.push(w.alphaMapUv), E.push(w.lightMapUv), E.push(w.aoMapUv), E.push(w.bumpMapUv), E.push(w.normalMapUv), E.push(w.displacementMapUv), E.push(w.emissiveMapUv), E.push(w.metalnessMapUv), E.push(w.roughnessMapUv), E.push(w.anisotropyMapUv), E.push(w.clearcoatMapUv), E.push(w.clearcoatNormalMapUv), E.push(w.clearcoatRoughnessMapUv), E.push(w.iridescenceMapUv), E.push(w.iridescenceThicknessMapUv), E.push(w.sheenColorMapUv), E.push(w.sheenRoughnessMapUv), E.push(w.specularMapUv), E.push(w.specularColorMapUv), E.push(w.specularIntensityMapUv), E.push(w.transmissionMapUv), E.push(w.thicknessMapUv), E.push(w.combine), E.push(w.fogExp2), E.push(w.sizeAttenuation), E.push(w.morphTargetsCount), E.push(w.morphAttributeCount), E.push(w.numDirLights), E.push(w.numPointLights), E.push(w.numSpotLights), E.push(w.numSpotLightMaps), E.push(w.numHemiLights), E.push(w.numRectAreaLights), E.push(w.numDirLightShadows), E.push(w.numPointLightShadows), E.push(w.numSpotLightShadows), E.push(w.numSpotLightShadowsWithMaps), E.push(w.numLightProbes), E.push(w.shadowMapType), E.push(w.toneMapping), E.push(w.numClippingPlanes), E.push(w.numClipIntersection), E.push(w.depthPacking);
  }
  function b(E, w) {
    s.disableAll(), w.supportsVertexTextures && s.enable(0), w.instancing && s.enable(1), w.instancingColor && s.enable(2), w.instancingMorph && s.enable(3), w.matcap && s.enable(4), w.envMap && s.enable(5), w.normalMapObjectSpace && s.enable(6), w.normalMapTangentSpace && s.enable(7), w.clearcoat && s.enable(8), w.iridescence && s.enable(9), w.alphaTest && s.enable(10), w.vertexColors && s.enable(11), w.vertexAlphas && s.enable(12), w.vertexUv1s && s.enable(13), w.vertexUv2s && s.enable(14), w.vertexUv3s && s.enable(15), w.vertexTangents && s.enable(16), w.anisotropy && s.enable(17), w.alphaHash && s.enable(18), w.batching && s.enable(19), w.dispersion && s.enable(20), w.batchingColor && s.enable(21), E.push(s.mask), s.disableAll(), w.fog && s.enable(0), w.useFog && s.enable(1), w.flatShading && s.enable(2), w.logarithmicDepthBuffer && s.enable(3), w.reverseDepthBuffer && s.enable(4), w.skinning && s.enable(5), w.morphTargets && s.enable(6), w.morphNormals && s.enable(7), w.morphColors && s.enable(8), w.premultipliedAlpha && s.enable(9), w.shadowMapEnabled && s.enable(10), w.doubleSided && s.enable(11), w.flipSided && s.enable(12), w.useDepthPacking && s.enable(13), w.dithering && s.enable(14), w.transmission && s.enable(15), w.sheen && s.enable(16), w.opaque && s.enable(17), w.pointsUvs && s.enable(18), w.decodeVideoTexture && s.enable(19), w.decodeVideoTextureEmissive && s.enable(20), w.alphaToCoverage && s.enable(21), E.push(s.mask);
  }
  function x(E) {
    const w = v[E.type];
    let O;
    if (w) {
      const N = Or[w];
      O = Oee.clone(N.uniforms);
    } else
      O = E.uniforms;
    return O;
  }
  function _(E, w) {
    let O;
    for (let N = 0, I = u.length; N < I; N++) {
      const H = u[N];
      if (H.cacheKey === w) {
        O = H, ++O.usedTimes;
        break;
      }
    }
    return O === void 0 && (O = new toe(t, w, E, o), u.push(O)), O;
  }
  function M(E) {
    if (--E.usedTimes === 0) {
      const w = u.indexOf(E);
      u[w] = u[u.length - 1], u.pop(), E.destroy();
    }
  }
  function S(E) {
    l.remove(E);
  }
  function P() {
    l.dispose();
  }
  return {
    getParameters: m,
    getProgramCacheKey: p,
    getUniforms: x,
    acquireProgram: _,
    releaseProgram: M,
    releaseShaderCache: S,
    // Exposed for resource monitoring & error feedback via renderer.info:
    programs: u,
    dispose: P
  };
}
function aoe() {
  let t = /* @__PURE__ */ new WeakMap();
  function e(a) {
    return t.has(a);
  }
  function n(a) {
    let s = t.get(a);
    return s === void 0 && (s = {}, t.set(a, s)), s;
  }
  function r(a) {
    t.delete(a);
  }
  function i(a, s, l) {
    t.get(a)[s] = l;
  }
  function o() {
    t = /* @__PURE__ */ new WeakMap();
  }
  return {
    has: e,
    get: n,
    remove: r,
    update: i,
    dispose: o
  };
}
function soe(t, e) {
  return t.groupOrder !== e.groupOrder ? t.groupOrder - e.groupOrder : t.renderOrder !== e.renderOrder ? t.renderOrder - e.renderOrder : t.material.id !== e.material.id ? t.material.id - e.material.id : t.z !== e.z ? t.z - e.z : t.id - e.id;
}
function vg(t, e) {
  return t.groupOrder !== e.groupOrder ? t.groupOrder - e.groupOrder : t.renderOrder !== e.renderOrder ? t.renderOrder - e.renderOrder : t.z !== e.z ? e.z - t.z : t.id - e.id;
}
function gg() {
  const t = [];
  let e = 0;
  const n = [], r = [], i = [];
  function o() {
    e = 0, n.length = 0, r.length = 0, i.length = 0;
  }
  function a(d, f, h, v, g, m) {
    let p = t[e];
    return p === void 0 ? (p = {
      id: d.id,
      object: d,
      geometry: f,
      material: h,
      groupOrder: v,
      renderOrder: d.renderOrder,
      z: g,
      group: m
    }, t[e] = p) : (p.id = d.id, p.object = d, p.geometry = f, p.material = h, p.groupOrder = v, p.renderOrder = d.renderOrder, p.z = g, p.group = m), e++, p;
  }
  function s(d, f, h, v, g, m) {
    const p = a(d, f, h, v, g, m);
    h.transmission > 0 ? r.push(p) : h.transparent === !0 ? i.push(p) : n.push(p);
  }
  function l(d, f, h, v, g, m) {
    const p = a(d, f, h, v, g, m);
    h.transmission > 0 ? r.unshift(p) : h.transparent === !0 ? i.unshift(p) : n.unshift(p);
  }
  function c(d, f) {
    n.length > 1 && n.sort(d || soe), r.length > 1 && r.sort(f || vg), i.length > 1 && i.sort(f || vg);
  }
  function u() {
    for (let d = e, f = t.length; d < f; d++) {
      const h = t[d];
      if (h.id === null)
        break;
      h.id = null, h.object = null, h.geometry = null, h.material = null, h.group = null;
    }
  }
  return {
    opaque: n,
    transmissive: r,
    transparent: i,
    init: o,
    push: s,
    unshift: l,
    finish: u,
    sort: c
  };
}
function loe() {
  let t = /* @__PURE__ */ new WeakMap();
  function e(r, i) {
    const o = t.get(r);
    let a;
    return o === void 0 ? (a = new gg(), t.set(r, [a])) : i >= o.length ? (a = new gg(), o.push(a)) : a = o[i], a;
  }
  function n() {
    t = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: e,
    dispose: n
  };
}
function coe() {
  const t = {};
  return {
    get: function(e) {
      if (t[e.id] !== void 0)
        return t[e.id];
      let n;
      switch (e.type) {
        case "DirectionalLight":
          n = {
            direction: new re(),
            color: new At()
          };
          break;
        case "SpotLight":
          n = {
            position: new re(),
            direction: new re(),
            color: new At(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;
        case "PointLight":
          n = {
            position: new re(),
            color: new At(),
            distance: 0,
            decay: 0
          };
          break;
        case "HemisphereLight":
          n = {
            direction: new re(),
            skyColor: new At(),
            groundColor: new At()
          };
          break;
        case "RectAreaLight":
          n = {
            color: new At(),
            position: new re(),
            halfWidth: new re(),
            halfHeight: new re()
          };
          break;
      }
      return t[e.id] = n, n;
    }
  };
}
function uoe() {
  const t = {};
  return {
    get: function(e) {
      if (t[e.id] !== void 0)
        return t[e.id];
      let n;
      switch (e.type) {
        case "DirectionalLight":
          n = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Pt()
          };
          break;
        case "SpotLight":
          n = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Pt()
          };
          break;
        case "PointLight":
          n = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Pt(),
            shadowCameraNear: 1,
            shadowCameraFar: 1e3
          };
          break;
      }
      return t[e.id] = n, n;
    }
  };
}
let doe = 0;
function foe(t, e) {
  return (e.castShadow ? 2 : 0) - (t.castShadow ? 2 : 0) + (e.map ? 1 : 0) - (t.map ? 1 : 0);
}
function hoe(t) {
  const e = new coe(), n = uoe(), r = {
    version: 0,
    hash: {
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1,
      numSpotMaps: -1,
      numLightProbes: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotLightMap: [],
    spotShadow: [],
    spotShadowMap: [],
    spotLightMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: [],
    numSpotLightShadowsWithMaps: 0,
    numLightProbes: 0
  };
  for (let c = 0; c < 9; c++)
    r.probe.push(new re());
  const i = new re(), o = new qt(), a = new qt();
  function s(c) {
    let u = 0, d = 0, f = 0;
    for (let E = 0; E < 9; E++)
      r.probe[E].set(0, 0, 0);
    let h = 0, v = 0, g = 0, m = 0, p = 0, y = 0, b = 0, x = 0, _ = 0, M = 0, S = 0;
    c.sort(foe);
    for (let E = 0, w = c.length; E < w; E++) {
      const O = c[E], N = O.color, I = O.intensity, H = O.distance, j = O.shadow && O.shadow.map ? O.shadow.map.texture : null;
      if (O.isAmbientLight)
        u += N.r * I, d += N.g * I, f += N.b * I;
      else if (O.isLightProbe) {
        for (let U = 0; U < 9; U++)
          r.probe[U].addScaledVector(O.sh.coefficients[U], I);
        S++;
      } else if (O.isDirectionalLight) {
        const U = e.get(O);
        if (U.color.copy(O.color).multiplyScalar(O.intensity), O.castShadow) {
          const $ = O.shadow, V = n.get(O);
          V.shadowIntensity = $.intensity, V.shadowBias = $.bias, V.shadowNormalBias = $.normalBias, V.shadowRadius = $.radius, V.shadowMapSize = $.mapSize, r.directionalShadow[h] = V, r.directionalShadowMap[h] = j, r.directionalShadowMatrix[h] = O.shadow.matrix, y++;
        }
        r.directional[h] = U, h++;
      } else if (O.isSpotLight) {
        const U = e.get(O);
        U.position.setFromMatrixPosition(O.matrixWorld), U.color.copy(N).multiplyScalar(I), U.distance = H, U.coneCos = Math.cos(O.angle), U.penumbraCos = Math.cos(O.angle * (1 - O.penumbra)), U.decay = O.decay, r.spot[g] = U;
        const $ = O.shadow;
        if (O.map && (r.spotLightMap[_] = O.map, _++, $.updateMatrices(O), O.castShadow && M++), r.spotLightMatrix[g] = $.matrix, O.castShadow) {
          const V = n.get(O);
          V.shadowIntensity = $.intensity, V.shadowBias = $.bias, V.shadowNormalBias = $.normalBias, V.shadowRadius = $.radius, V.shadowMapSize = $.mapSize, r.spotShadow[g] = V, r.spotShadowMap[g] = j, x++;
        }
        g++;
      } else if (O.isRectAreaLight) {
        const U = e.get(O);
        U.color.copy(N).multiplyScalar(I), U.halfWidth.set(O.width * 0.5, 0, 0), U.halfHeight.set(0, O.height * 0.5, 0), r.rectArea[m] = U, m++;
      } else if (O.isPointLight) {
        const U = e.get(O);
        if (U.color.copy(O.color).multiplyScalar(O.intensity), U.distance = O.distance, U.decay = O.decay, O.castShadow) {
          const $ = O.shadow, V = n.get(O);
          V.shadowIntensity = $.intensity, V.shadowBias = $.bias, V.shadowNormalBias = $.normalBias, V.shadowRadius = $.radius, V.shadowMapSize = $.mapSize, V.shadowCameraNear = $.camera.near, V.shadowCameraFar = $.camera.far, r.pointShadow[v] = V, r.pointShadowMap[v] = j, r.pointShadowMatrix[v] = O.shadow.matrix, b++;
        }
        r.point[v] = U, v++;
      } else if (O.isHemisphereLight) {
        const U = e.get(O);
        U.skyColor.copy(O.color).multiplyScalar(I), U.groundColor.copy(O.groundColor).multiplyScalar(I), r.hemi[p] = U, p++;
      }
    }
    m > 0 && (t.has("OES_texture_float_linear") === !0 ? (r.rectAreaLTC1 = De.LTC_FLOAT_1, r.rectAreaLTC2 = De.LTC_FLOAT_2) : (r.rectAreaLTC1 = De.LTC_HALF_1, r.rectAreaLTC2 = De.LTC_HALF_2)), r.ambient[0] = u, r.ambient[1] = d, r.ambient[2] = f;
    const P = r.hash;
    (P.directionalLength !== h || P.pointLength !== v || P.spotLength !== g || P.rectAreaLength !== m || P.hemiLength !== p || P.numDirectionalShadows !== y || P.numPointShadows !== b || P.numSpotShadows !== x || P.numSpotMaps !== _ || P.numLightProbes !== S) && (r.directional.length = h, r.spot.length = g, r.rectArea.length = m, r.point.length = v, r.hemi.length = p, r.directionalShadow.length = y, r.directionalShadowMap.length = y, r.pointShadow.length = b, r.pointShadowMap.length = b, r.spotShadow.length = x, r.spotShadowMap.length = x, r.directionalShadowMatrix.length = y, r.pointShadowMatrix.length = b, r.spotLightMatrix.length = x + _ - M, r.spotLightMap.length = _, r.numSpotLightShadowsWithMaps = M, r.numLightProbes = S, P.directionalLength = h, P.pointLength = v, P.spotLength = g, P.rectAreaLength = m, P.hemiLength = p, P.numDirectionalShadows = y, P.numPointShadows = b, P.numSpotShadows = x, P.numSpotMaps = _, P.numLightProbes = S, r.version = doe++);
  }
  function l(c, u) {
    let d = 0, f = 0, h = 0, v = 0, g = 0;
    const m = u.matrixWorldInverse;
    for (let p = 0, y = c.length; p < y; p++) {
      const b = c[p];
      if (b.isDirectionalLight) {
        const x = r.directional[d];
        x.direction.setFromMatrixPosition(b.matrixWorld), i.setFromMatrixPosition(b.target.matrixWorld), x.direction.sub(i), x.direction.transformDirection(m), d++;
      } else if (b.isSpotLight) {
        const x = r.spot[h];
        x.position.setFromMatrixPosition(b.matrixWorld), x.position.applyMatrix4(m), x.direction.setFromMatrixPosition(b.matrixWorld), i.setFromMatrixPosition(b.target.matrixWorld), x.direction.sub(i), x.direction.transformDirection(m), h++;
      } else if (b.isRectAreaLight) {
        const x = r.rectArea[v];
        x.position.setFromMatrixPosition(b.matrixWorld), x.position.applyMatrix4(m), a.identity(), o.copy(b.matrixWorld), o.premultiply(m), a.extractRotation(o), x.halfWidth.set(b.width * 0.5, 0, 0), x.halfHeight.set(0, b.height * 0.5, 0), x.halfWidth.applyMatrix4(a), x.halfHeight.applyMatrix4(a), v++;
      } else if (b.isPointLight) {
        const x = r.point[f];
        x.position.setFromMatrixPosition(b.matrixWorld), x.position.applyMatrix4(m), f++;
      } else if (b.isHemisphereLight) {
        const x = r.hemi[g];
        x.direction.setFromMatrixPosition(b.matrixWorld), x.direction.transformDirection(m), g++;
      }
    }
  }
  return {
    setup: s,
    setupView: l,
    state: r
  };
}
function yg(t) {
  const e = new hoe(t), n = [], r = [];
  function i(u) {
    c.camera = u, n.length = 0, r.length = 0;
  }
  function o(u) {
    n.push(u);
  }
  function a(u) {
    r.push(u);
  }
  function s() {
    e.setup(n);
  }
  function l(u) {
    e.setupView(n, u);
  }
  const c = {
    lightsArray: n,
    shadowsArray: r,
    camera: null,
    lights: e,
    transmissionRenderTarget: {}
  };
  return {
    init: i,
    state: c,
    setupLights: s,
    setupLightsView: l,
    pushLight: o,
    pushShadow: a
  };
}
function poe(t) {
  let e = /* @__PURE__ */ new WeakMap();
  function n(i, o = 0) {
    const a = e.get(i);
    let s;
    return a === void 0 ? (s = new yg(t), e.set(i, [s])) : o >= a.length ? (s = new yg(t), a.push(s)) : s = a[o], s;
  }
  function r() {
    e = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: n,
    dispose: r
  };
}
const moe = `void main() {
	gl_Position = vec4( position, 1.0 );
}`, voe = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
#include <packing>
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( squared_mean - mean * mean );
	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );
}`;
function goe(t, e, n) {
  let r = new R2();
  const i = new Pt(), o = new Pt(), a = new Yt(), s = new Hee({ depthPacking: UQ }), l = new Bee(), c = {}, u = n.maxTextureSize, d = { [Ji]: Rn, [Rn]: Ji, [ei]: ei }, f = new eo({
    defines: {
      VSM_SAMPLES: 8
    },
    uniforms: {
      shadow_pass: { value: null },
      resolution: { value: new Pt() },
      radius: { value: 4 }
    },
    vertexShader: moe,
    fragmentShader: voe
  }), h = f.clone();
  h.defines.HORIZONTAL_PASS = 1;
  const v = new ao();
  v.setAttribute(
    "position",
    new Hr(
      new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]),
      3
    )
  );
  const g = new rr(v, f), m = this;
  this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = g9;
  let p = this.type;
  this.render = function(M, S, P) {
    if (m.enabled === !1 || m.autoUpdate === !1 && m.needsUpdate === !1 || M.length === 0)
      return;
    const E = t.getRenderTarget(), w = t.getActiveCubeFace(), O = t.getActiveMipmapLevel(), N = t.state;
    N.setBlending(Hi), N.buffers.color.setClear(1, 1, 1, 1), N.buffers.depth.setTest(!0), N.setScissorTest(!1);
    const I = p !== Qr && this.type === Qr, H = p === Qr && this.type !== Qr;
    for (let j = 0, U = M.length; j < U; j++) {
      const $ = M[j], V = $.shadow;
      if (V === void 0) {
        console.warn("THREE.WebGLShadowMap:", $, "has no shadow.");
        continue;
      }
      if (V.autoUpdate === !1 && V.needsUpdate === !1)
        continue;
      i.copy(V.mapSize);
      const te = V.getFrameExtents();
      if (i.multiply(te), o.copy(V.mapSize), (i.x > u || i.y > u) && (i.x > u && (o.x = Math.floor(u / te.x), i.x = o.x * te.x, V.mapSize.x = o.x), i.y > u && (o.y = Math.floor(u / te.y), i.y = o.y * te.y, V.mapSize.y = o.y)), V.map === null || I === !0 || H === !0) {
        const Z = this.type !== Qr ? { minFilter: _r, magFilter: _r } : {};
        V.map !== null && V.map.dispose(), V.map = new Qi(i.x, i.y, Z), V.map.texture.name = $.name + ".shadowMap", V.camera.updateProjectionMatrix();
      }
      t.setRenderTarget(V.map), t.clear();
      const B = V.getViewportCount();
      for (let Z = 0; Z < B; Z++) {
        const Q = V.getViewport(Z);
        a.set(
          o.x * Q.x,
          o.y * Q.y,
          o.x * Q.z,
          o.y * Q.w
        ), N.viewport(a), V.updateMatrices($, Z), r = V.getFrustum(), x(S, P, V.camera, $, this.type);
      }
      V.isPointLightShadow !== !0 && this.type === Qr && y(V, P), V.needsUpdate = !1;
    }
    p = this.type, m.needsUpdate = !1, t.setRenderTarget(E, w, O);
  };
  function y(M, S) {
    const P = e.update(g);
    f.defines.VSM_SAMPLES !== M.blurSamples && (f.defines.VSM_SAMPLES = M.blurSamples, h.defines.VSM_SAMPLES = M.blurSamples, f.needsUpdate = !0, h.needsUpdate = !0), M.mapPass === null && (M.mapPass = new Qi(i.x, i.y)), f.uniforms.shadow_pass.value = M.map.texture, f.uniforms.resolution.value = M.mapSize, f.uniforms.radius.value = M.radius, t.setRenderTarget(M.mapPass), t.clear(), t.renderBufferDirect(S, null, P, f, g, null), h.uniforms.shadow_pass.value = M.mapPass.texture, h.uniforms.resolution.value = M.mapSize, h.uniforms.radius.value = M.radius, t.setRenderTarget(M.map), t.clear(), t.renderBufferDirect(S, null, P, h, g, null);
  }
  function b(M, S, P, E) {
    let w = null;
    const O = P.isPointLight === !0 ? M.customDistanceMaterial : M.customDepthMaterial;
    if (O !== void 0)
      w = O;
    else if (w = P.isPointLight === !0 ? l : s, t.localClippingEnabled && S.clipShadows === !0 && Array.isArray(S.clippingPlanes) && S.clippingPlanes.length !== 0 || S.displacementMap && S.displacementScale !== 0 || S.alphaMap && S.alphaTest > 0 || S.map && S.alphaTest > 0) {
      const N = w.uuid, I = S.uuid;
      let H = c[N];
      H === void 0 && (H = {}, c[N] = H);
      let j = H[I];
      j === void 0 && (j = w.clone(), H[I] = j, S.addEventListener("dispose", _)), w = j;
    }
    if (w.visible = S.visible, w.wireframe = S.wireframe, E === Qr ? w.side = S.shadowSide !== null ? S.shadowSide : S.side : w.side = S.shadowSide !== null ? S.shadowSide : d[S.side], w.alphaMap = S.alphaMap, w.alphaTest = S.alphaTest, w.map = S.map, w.clipShadows = S.clipShadows, w.clippingPlanes = S.clippingPlanes, w.clipIntersection = S.clipIntersection, w.displacementMap = S.displacementMap, w.displacementScale = S.displacementScale, w.displacementBias = S.displacementBias, w.wireframeLinewidth = S.wireframeLinewidth, w.linewidth = S.linewidth, P.isPointLight === !0 && w.isMeshDistanceMaterial === !0) {
      const N = t.properties.get(w);
      N.light = P;
    }
    return w;
  }
  function x(M, S, P, E, w) {
    if (M.visible === !1)
      return;
    if (M.layers.test(S.layers) && (M.isMesh || M.isLine || M.isPoints) && (M.castShadow || M.receiveShadow && w === Qr) && (!M.frustumCulled || r.intersectsObject(M))) {
      M.modelViewMatrix.multiplyMatrices(P.matrixWorldInverse, M.matrixWorld);
      const I = e.update(M), H = M.material;
      if (Array.isArray(H)) {
        const j = I.groups;
        for (let U = 0, $ = j.length; U < $; U++) {
          const V = j[U], te = H[V.materialIndex];
          if (te && te.visible) {
            const B = b(M, te, E, w);
            M.onBeforeShadow(t, M, S, P, I, B, V), t.renderBufferDirect(P, null, I, B, M, V), M.onAfterShadow(t, M, S, P, I, B, V);
          }
        }
      } else if (H.visible) {
        const j = b(M, H, E, w);
        M.onBeforeShadow(t, M, S, P, I, j, null), t.renderBufferDirect(P, null, I, j, M, null), M.onAfterShadow(t, M, S, P, I, j, null);
      }
    }
    const N = M.children;
    for (let I = 0, H = N.length; I < H; I++)
      x(N[I], S, P, E, w);
  }
  function _(M) {
    M.target.removeEventListener("dispose", _);
    for (const P in c) {
      const E = c[P], w = M.target.uuid;
      w in E && (E[w].dispose(), delete E[w]);
    }
  }
}
const yoe = {
  [Fh]: Uh,
  [zh]: Vh,
  [Hh]: $h,
  [ts]: Bh,
  [Uh]: Fh,
  [Vh]: zh,
  [$h]: Hh,
  [Bh]: ts
};
function boe(t, e) {
  function n() {
    let W = !1;
    const ye = new Yt();
    let oe = null;
    const me = new Yt(0, 0, 0, 0);
    return {
      setMask: function(Oe) {
        oe !== Oe && !W && (t.colorMask(Oe, Oe, Oe, Oe), oe = Oe);
      },
      setLocked: function(Oe) {
        W = Oe;
      },
      setClear: function(Oe, Ae, Qe, Nt, on) {
        on === !0 && (Oe *= Nt, Ae *= Nt, Qe *= Nt), ye.set(Oe, Ae, Qe, Nt), me.equals(ye) === !1 && (t.clearColor(Oe, Ae, Qe, Nt), me.copy(ye));
      },
      reset: function() {
        W = !1, oe = null, me.set(-1, 0, 0, 0);
      }
    };
  }
  function r() {
    let W = !1, ye = !1, oe = null, me = null, Oe = null;
    return {
      setReversed: function(Ae) {
        if (ye !== Ae) {
          const Qe = e.get("EXT_clip_control");
          Ae ? Qe.clipControlEXT(Qe.LOWER_LEFT_EXT, Qe.ZERO_TO_ONE_EXT) : Qe.clipControlEXT(Qe.LOWER_LEFT_EXT, Qe.NEGATIVE_ONE_TO_ONE_EXT), ye = Ae;
          const Nt = Oe;
          Oe = null, this.setClear(Nt);
        }
      },
      getReversed: function() {
        return ye;
      },
      setTest: function(Ae) {
        Ae ? J(t.DEPTH_TEST) : se(t.DEPTH_TEST);
      },
      setMask: function(Ae) {
        oe !== Ae && !W && (t.depthMask(Ae), oe = Ae);
      },
      setFunc: function(Ae) {
        if (ye && (Ae = yoe[Ae]), me !== Ae) {
          switch (Ae) {
            case Fh:
              t.depthFunc(t.NEVER);
              break;
            case Uh:
              t.depthFunc(t.ALWAYS);
              break;
            case zh:
              t.depthFunc(t.LESS);
              break;
            case ts:
              t.depthFunc(t.LEQUAL);
              break;
            case Hh:
              t.depthFunc(t.EQUAL);
              break;
            case Bh:
              t.depthFunc(t.GEQUAL);
              break;
            case Vh:
              t.depthFunc(t.GREATER);
              break;
            case $h:
              t.depthFunc(t.NOTEQUAL);
              break;
            default:
              t.depthFunc(t.LEQUAL);
          }
          me = Ae;
        }
      },
      setLocked: function(Ae) {
        W = Ae;
      },
      setClear: function(Ae) {
        Oe !== Ae && (ye && (Ae = 1 - Ae), t.clearDepth(Ae), Oe = Ae);
      },
      reset: function() {
        W = !1, oe = null, me = null, Oe = null, ye = !1;
      }
    };
  }
  function i() {
    let W = !1, ye = null, oe = null, me = null, Oe = null, Ae = null, Qe = null, Nt = null, on = null;
    return {
      setTest: function(vt) {
        W || (vt ? J(t.STENCIL_TEST) : se(t.STENCIL_TEST));
      },
      setMask: function(vt) {
        ye !== vt && !W && (t.stencilMask(vt), ye = vt);
      },
      setFunc: function(vt, Sn, cr) {
        (oe !== vt || me !== Sn || Oe !== cr) && (t.stencilFunc(vt, Sn, cr), oe = vt, me = Sn, Oe = cr);
      },
      setOp: function(vt, Sn, cr) {
        (Ae !== vt || Qe !== Sn || Nt !== cr) && (t.stencilOp(vt, Sn, cr), Ae = vt, Qe = Sn, Nt = cr);
      },
      setLocked: function(vt) {
        W = vt;
      },
      setClear: function(vt) {
        on !== vt && (t.clearStencil(vt), on = vt);
      },
      reset: function() {
        W = !1, ye = null, oe = null, me = null, Oe = null, Ae = null, Qe = null, Nt = null, on = null;
      }
    };
  }
  const o = new n(), a = new r(), s = new i(), l = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap();
  let u = {}, d = {}, f = /* @__PURE__ */ new WeakMap(), h = [], v = null, g = !1, m = null, p = null, y = null, b = null, x = null, _ = null, M = null, S = new At(0, 0, 0), P = 0, E = !1, w = null, O = null, N = null, I = null, H = null;
  const j = t.getParameter(t.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
  let U = !1, $ = 0;
  const V = t.getParameter(t.VERSION);
  V.indexOf("WebGL") !== -1 ? ($ = parseFloat(/^WebGL (\d)/.exec(V)[1]), U = $ >= 1) : V.indexOf("OpenGL ES") !== -1 && ($ = parseFloat(/^OpenGL ES (\d)/.exec(V)[1]), U = $ >= 2);
  let te = null, B = {};
  const Z = t.getParameter(t.SCISSOR_BOX), Q = t.getParameter(t.VIEWPORT), ce = new Yt().fromArray(Z), k = new Yt().fromArray(Q);
  function G(W, ye, oe, me) {
    const Oe = new Uint8Array(4), Ae = t.createTexture();
    t.bindTexture(W, Ae), t.texParameteri(W, t.TEXTURE_MIN_FILTER, t.NEAREST), t.texParameteri(W, t.TEXTURE_MAG_FILTER, t.NEAREST);
    for (let Qe = 0; Qe < oe; Qe++)
      W === t.TEXTURE_3D || W === t.TEXTURE_2D_ARRAY ? t.texImage3D(ye, 0, t.RGBA, 1, 1, me, 0, t.RGBA, t.UNSIGNED_BYTE, Oe) : t.texImage2D(ye + Qe, 0, t.RGBA, 1, 1, 0, t.RGBA, t.UNSIGNED_BYTE, Oe);
    return Ae;
  }
  const K = {};
  K[t.TEXTURE_2D] = G(t.TEXTURE_2D, t.TEXTURE_2D, 1), K[t.TEXTURE_CUBE_MAP] = G(t.TEXTURE_CUBE_MAP, t.TEXTURE_CUBE_MAP_POSITIVE_X, 6), K[t.TEXTURE_2D_ARRAY] = G(t.TEXTURE_2D_ARRAY, t.TEXTURE_2D_ARRAY, 1, 1), K[t.TEXTURE_3D] = G(t.TEXTURE_3D, t.TEXTURE_3D, 1, 1), o.setClear(0, 0, 0, 1), a.setClear(1), s.setClear(0), J(t.DEPTH_TEST), a.setFunc(ts), $e(!1), he(x4), J(t.CULL_FACE), F(Hi);
  function J(W) {
    u[W] !== !0 && (t.enable(W), u[W] = !0);
  }
  function se(W) {
    u[W] !== !1 && (t.disable(W), u[W] = !1);
  }
  function be(W, ye) {
    return d[W] !== ye ? (t.bindFramebuffer(W, ye), d[W] = ye, W === t.DRAW_FRAMEBUFFER && (d[t.FRAMEBUFFER] = ye), W === t.FRAMEBUFFER && (d[t.DRAW_FRAMEBUFFER] = ye), !0) : !1;
  }
  function pe(W, ye) {
    let oe = h, me = !1;
    if (W) {
      oe = f.get(ye), oe === void 0 && (oe = [], f.set(ye, oe));
      const Oe = W.textures;
      if (oe.length !== Oe.length || oe[0] !== t.COLOR_ATTACHMENT0) {
        for (let Ae = 0, Qe = Oe.length; Ae < Qe; Ae++)
          oe[Ae] = t.COLOR_ATTACHMENT0 + Ae;
        oe.length = Oe.length, me = !0;
      }
    } else
      oe[0] !== t.BACK && (oe[0] = t.BACK, me = !0);
    me && t.drawBuffers(oe);
  }
  function Ne(W) {
    return v !== W ? (t.useProgram(W), v = W, !0) : !1;
  }
  const ae = {
    [So]: t.FUNC_ADD,
    [dQ]: t.FUNC_SUBTRACT,
    [fQ]: t.FUNC_REVERSE_SUBTRACT
  };
  ae[hQ] = t.MIN, ae[pQ] = t.MAX;
  const Re = {
    [mQ]: t.ZERO,
    [vQ]: t.ONE,
    [gQ]: t.SRC_COLOR,
    [Nh]: t.SRC_ALPHA,
    [CQ]: t.SRC_ALPHA_SATURATE,
    [wQ]: t.DST_COLOR,
    [bQ]: t.DST_ALPHA,
    [yQ]: t.ONE_MINUS_SRC_COLOR,
    [Ih]: t.ONE_MINUS_SRC_ALPHA,
    [_Q]: t.ONE_MINUS_DST_COLOR,
    [xQ]: t.ONE_MINUS_DST_ALPHA,
    [EQ]: t.CONSTANT_COLOR,
    [SQ]: t.ONE_MINUS_CONSTANT_COLOR,
    [MQ]: t.CONSTANT_ALPHA,
    [TQ]: t.ONE_MINUS_CONSTANT_ALPHA
  };
  function F(W, ye, oe, me, Oe, Ae, Qe, Nt, on, vt) {
    if (W === Hi) {
      g === !0 && (se(t.BLEND), g = !1);
      return;
    }
    if (g === !1 && (J(t.BLEND), g = !0), W !== uQ) {
      if (W !== m || vt !== E) {
        if ((p !== So || x !== So) && (t.blendEquation(t.FUNC_ADD), p = So, x = So), vt)
          switch (W) {
            case Za:
              t.blendFuncSeparate(t.ONE, t.ONE_MINUS_SRC_ALPHA, t.ONE, t.ONE_MINUS_SRC_ALPHA);
              break;
            case w4:
              t.blendFunc(t.ONE, t.ONE);
              break;
            case _4:
              t.blendFuncSeparate(t.ZERO, t.ONE_MINUS_SRC_COLOR, t.ZERO, t.ONE);
              break;
            case C4:
              t.blendFuncSeparate(t.ZERO, t.SRC_COLOR, t.ZERO, t.SRC_ALPHA);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", W);
              break;
          }
        else
          switch (W) {
            case Za:
              t.blendFuncSeparate(t.SRC_ALPHA, t.ONE_MINUS_SRC_ALPHA, t.ONE, t.ONE_MINUS_SRC_ALPHA);
              break;
            case w4:
              t.blendFunc(t.SRC_ALPHA, t.ONE);
              break;
            case _4:
              t.blendFuncSeparate(t.ZERO, t.ONE_MINUS_SRC_COLOR, t.ZERO, t.ONE);
              break;
            case C4:
              t.blendFunc(t.ZERO, t.SRC_COLOR);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", W);
              break;
          }
        y = null, b = null, _ = null, M = null, S.set(0, 0, 0), P = 0, m = W, E = vt;
      }
      return;
    }
    Oe = Oe || ye, Ae = Ae || oe, Qe = Qe || me, (ye !== p || Oe !== x) && (t.blendEquationSeparate(ae[ye], ae[Oe]), p = ye, x = Oe), (oe !== y || me !== b || Ae !== _ || Qe !== M) && (t.blendFuncSeparate(Re[oe], Re[me], Re[Ae], Re[Qe]), y = oe, b = me, _ = Ae, M = Qe), (Nt.equals(S) === !1 || on !== P) && (t.blendColor(Nt.r, Nt.g, Nt.b, on), S.copy(Nt), P = on), m = W, E = !1;
  }
  function Ge(W, ye) {
    W.side === ei ? se(t.CULL_FACE) : J(t.CULL_FACE);
    let oe = W.side === Rn;
    ye && (oe = !oe), $e(oe), W.blending === Za && W.transparent === !1 ? F(Hi) : F(W.blending, W.blendEquation, W.blendSrc, W.blendDst, W.blendEquationAlpha, W.blendSrcAlpha, W.blendDstAlpha, W.blendColor, W.blendAlpha, W.premultipliedAlpha), a.setFunc(W.depthFunc), a.setTest(W.depthTest), a.setMask(W.depthWrite), o.setMask(W.colorWrite);
    const me = W.stencilWrite;
    s.setTest(me), me && (s.setMask(W.stencilWriteMask), s.setFunc(W.stencilFunc, W.stencilRef, W.stencilFuncMask), s.setOp(W.stencilFail, W.stencilZFail, W.stencilZPass)), Se(W.polygonOffset, W.polygonOffsetFactor, W.polygonOffsetUnits), W.alphaToCoverage === !0 ? J(t.SAMPLE_ALPHA_TO_COVERAGE) : se(t.SAMPLE_ALPHA_TO_COVERAGE);
  }
  function $e(W) {
    w !== W && (W ? t.frontFace(t.CW) : t.frontFace(t.CCW), w = W);
  }
  function he(W) {
    W !== sQ ? (J(t.CULL_FACE), W !== O && (W === x4 ? t.cullFace(t.BACK) : W === lQ ? t.cullFace(t.FRONT) : t.cullFace(t.FRONT_AND_BACK))) : se(t.CULL_FACE), O = W;
  }
  function ue(W) {
    W !== N && (U && t.lineWidth(W), N = W);
  }
  function Se(W, ye, oe) {
    W ? (J(t.POLYGON_OFFSET_FILL), (I !== ye || H !== oe) && (t.polygonOffset(ye, oe), I = ye, H = oe)) : se(t.POLYGON_OFFSET_FILL);
  }
  function we(W) {
    W ? J(t.SCISSOR_TEST) : se(t.SCISSOR_TEST);
  }
  function D(W) {
    W === void 0 && (W = t.TEXTURE0 + j - 1), te !== W && (t.activeTexture(W), te = W);
  }
  function T(W, ye, oe) {
    oe === void 0 && (te === null ? oe = t.TEXTURE0 + j - 1 : oe = te);
    let me = B[oe];
    me === void 0 && (me = { type: void 0, texture: void 0 }, B[oe] = me), (me.type !== W || me.texture !== ye) && (te !== oe && (t.activeTexture(oe), te = oe), t.bindTexture(W, ye || K[W]), me.type = W, me.texture = ye);
  }
  function Y() {
    const W = B[te];
    W !== void 0 && W.type !== void 0 && (t.bindTexture(W.type, null), W.type = void 0, W.texture = void 0);
  }
  function fe() {
    try {
      t.compressedTexImage2D(...arguments);
    } catch (W) {
      console.error("THREE.WebGLState:", W);
    }
  }
  function de() {
    try {
      t.compressedTexImage3D(...arguments);
    } catch (W) {
      console.error("THREE.WebGLState:", W);
    }
  }
  function ne() {
    try {
      t.texSubImage2D(...arguments);
    } catch (W) {
      console.error("THREE.WebGLState:", W);
    }
  }
  function Le() {
    try {
      t.texSubImage3D(...arguments);
    } catch (W) {
      console.error("THREE.WebGLState:", W);
    }
  }
  function Ce() {
    try {
      t.compressedTexSubImage2D(...arguments);
    } catch (W) {
      console.error("THREE.WebGLState:", W);
    }
  }
  function Te() {
    try {
      t.compressedTexSubImage3D(...arguments);
    } catch (W) {
      console.error("THREE.WebGLState:", W);
    }
  }
  function ke() {
    try {
      t.texStorage2D(...arguments);
    } catch (W) {
      console.error("THREE.WebGLState:", W);
    }
  }
  function ge() {
    try {
      t.texStorage3D(...arguments);
    } catch (W) {
      console.error("THREE.WebGLState:", W);
    }
  }
  function Ee() {
    try {
      t.texImage2D(...arguments);
    } catch (W) {
      console.error("THREE.WebGLState:", W);
    }
  }
  function Be() {
    try {
      t.texImage3D(...arguments);
    } catch (W) {
      console.error("THREE.WebGLState:", W);
    }
  }
  function We(W) {
    ce.equals(W) === !1 && (t.scissor(W.x, W.y, W.z, W.w), ce.copy(W));
  }
  function Fe(W) {
    k.equals(W) === !1 && (t.viewport(W.x, W.y, W.z, W.w), k.copy(W));
  }
  function qe(W, ye) {
    let oe = c.get(ye);
    oe === void 0 && (oe = /* @__PURE__ */ new WeakMap(), c.set(ye, oe));
    let me = oe.get(W);
    me === void 0 && (me = t.getUniformBlockIndex(ye, W.name), oe.set(W, me));
  }
  function Ye(W, ye) {
    const me = c.get(ye).get(W);
    l.get(ye) !== me && (t.uniformBlockBinding(ye, me, W.__bindingPointIndex), l.set(ye, me));
  }
  function Je() {
    t.disable(t.BLEND), t.disable(t.CULL_FACE), t.disable(t.DEPTH_TEST), t.disable(t.POLYGON_OFFSET_FILL), t.disable(t.SCISSOR_TEST), t.disable(t.STENCIL_TEST), t.disable(t.SAMPLE_ALPHA_TO_COVERAGE), t.blendEquation(t.FUNC_ADD), t.blendFunc(t.ONE, t.ZERO), t.blendFuncSeparate(t.ONE, t.ZERO, t.ONE, t.ZERO), t.blendColor(0, 0, 0, 0), t.colorMask(!0, !0, !0, !0), t.clearColor(0, 0, 0, 0), t.depthMask(!0), t.depthFunc(t.LESS), a.setReversed(!1), t.clearDepth(1), t.stencilMask(4294967295), t.stencilFunc(t.ALWAYS, 0, 4294967295), t.stencilOp(t.KEEP, t.KEEP, t.KEEP), t.clearStencil(0), t.cullFace(t.BACK), t.frontFace(t.CCW), t.polygonOffset(0, 0), t.activeTexture(t.TEXTURE0), t.bindFramebuffer(t.FRAMEBUFFER, null), t.bindFramebuffer(t.DRAW_FRAMEBUFFER, null), t.bindFramebuffer(t.READ_FRAMEBUFFER, null), t.useProgram(null), t.lineWidth(1), t.scissor(0, 0, t.canvas.width, t.canvas.height), t.viewport(0, 0, t.canvas.width, t.canvas.height), u = {}, te = null, B = {}, d = {}, f = /* @__PURE__ */ new WeakMap(), h = [], v = null, g = !1, m = null, p = null, y = null, b = null, x = null, _ = null, M = null, S = new At(0, 0, 0), P = 0, E = !1, w = null, O = null, N = null, I = null, H = null, ce.set(0, 0, t.canvas.width, t.canvas.height), k.set(0, 0, t.canvas.width, t.canvas.height), o.reset(), a.reset(), s.reset();
  }
  return {
    buffers: {
      color: o,
      depth: a,
      stencil: s
    },
    enable: J,
    disable: se,
    bindFramebuffer: be,
    drawBuffers: pe,
    useProgram: Ne,
    setBlending: F,
    setMaterial: Ge,
    setFlipSided: $e,
    setCullFace: he,
    setLineWidth: ue,
    setPolygonOffset: Se,
    setScissorTest: we,
    activeTexture: D,
    bindTexture: T,
    unbindTexture: Y,
    compressedTexImage2D: fe,
    compressedTexImage3D: de,
    texImage2D: Ee,
    texImage3D: Be,
    updateUBOMapping: qe,
    uniformBlockBinding: Ye,
    texStorage2D: ke,
    texStorage3D: ge,
    texSubImage2D: ne,
    texSubImage3D: Le,
    compressedTexSubImage2D: Ce,
    compressedTexSubImage3D: Te,
    scissor: We,
    viewport: Fe,
    reset: Je
  };
}
function xoe(t, e, n, r, i, o, a) {
  const s = e.has("WEBGL_multisampled_render_to_texture") ? e.get("WEBGL_multisampled_render_to_texture") : null, l = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent), c = new Pt(), u = /* @__PURE__ */ new WeakMap();
  let d;
  const f = /* @__PURE__ */ new WeakMap();
  let h = !1;
  try {
    h = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
  } catch {
  }
  function v(D, T) {
    return h ? (
      // eslint-disable-next-line compat/compat
      new OffscreenCanvas(D, T)
    ) : id("canvas");
  }
  function g(D, T, Y) {
    let fe = 1;
    const de = we(D);
    if ((de.width > Y || de.height > Y) && (fe = Y / Math.max(de.width, de.height)), fe < 1)
      if (typeof HTMLImageElement < "u" && D instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && D instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && D instanceof ImageBitmap || typeof VideoFrame < "u" && D instanceof VideoFrame) {
        const ne = Math.floor(fe * de.width), Le = Math.floor(fe * de.height);
        d === void 0 && (d = v(ne, Le));
        const Ce = T ? v(ne, Le) : d;
        return Ce.width = ne, Ce.height = Le, Ce.getContext("2d").drawImage(D, 0, 0, ne, Le), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + de.width + "x" + de.height + ") to (" + ne + "x" + Le + ")."), Ce;
      } else
        return "data" in D && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + de.width + "x" + de.height + ")."), D;
    return D;
  }
  function m(D) {
    return D.generateMipmaps;
  }
  function p(D) {
    t.generateMipmap(D);
  }
  function y(D) {
    return D.isWebGLCubeRenderTarget ? t.TEXTURE_CUBE_MAP : D.isWebGL3DRenderTarget ? t.TEXTURE_3D : D.isWebGLArrayRenderTarget || D.isCompressedArrayTexture ? t.TEXTURE_2D_ARRAY : t.TEXTURE_2D;
  }
  function b(D, T, Y, fe, de = !1) {
    if (D !== null) {
      if (t[D] !== void 0)
        return t[D];
      console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + D + "'");
    }
    let ne = T;
    if (T === t.RED && (Y === t.FLOAT && (ne = t.R32F), Y === t.HALF_FLOAT && (ne = t.R16F), Y === t.UNSIGNED_BYTE && (ne = t.R8)), T === t.RED_INTEGER && (Y === t.UNSIGNED_BYTE && (ne = t.R8UI), Y === t.UNSIGNED_SHORT && (ne = t.R16UI), Y === t.UNSIGNED_INT && (ne = t.R32UI), Y === t.BYTE && (ne = t.R8I), Y === t.SHORT && (ne = t.R16I), Y === t.INT && (ne = t.R32I)), T === t.RG && (Y === t.FLOAT && (ne = t.RG32F), Y === t.HALF_FLOAT && (ne = t.RG16F), Y === t.UNSIGNED_BYTE && (ne = t.RG8)), T === t.RG_INTEGER && (Y === t.UNSIGNED_BYTE && (ne = t.RG8UI), Y === t.UNSIGNED_SHORT && (ne = t.RG16UI), Y === t.UNSIGNED_INT && (ne = t.RG32UI), Y === t.BYTE && (ne = t.RG8I), Y === t.SHORT && (ne = t.RG16I), Y === t.INT && (ne = t.RG32I)), T === t.RGB_INTEGER && (Y === t.UNSIGNED_BYTE && (ne = t.RGB8UI), Y === t.UNSIGNED_SHORT && (ne = t.RGB16UI), Y === t.UNSIGNED_INT && (ne = t.RGB32UI), Y === t.BYTE && (ne = t.RGB8I), Y === t.SHORT && (ne = t.RGB16I), Y === t.INT && (ne = t.RGB32I)), T === t.RGBA_INTEGER && (Y === t.UNSIGNED_BYTE && (ne = t.RGBA8UI), Y === t.UNSIGNED_SHORT && (ne = t.RGBA16UI), Y === t.UNSIGNED_INT && (ne = t.RGBA32UI), Y === t.BYTE && (ne = t.RGBA8I), Y === t.SHORT && (ne = t.RGBA16I), Y === t.INT && (ne = t.RGBA32I)), T === t.RGB && Y === t.UNSIGNED_INT_5_9_9_9_REV && (ne = t.RGB9_E5), T === t.RGBA) {
      const Le = de ? nd : mt.getTransfer(fe);
      Y === t.FLOAT && (ne = t.RGBA32F), Y === t.HALF_FLOAT && (ne = t.RGBA16F), Y === t.UNSIGNED_BYTE && (ne = Le === Tt ? t.SRGB8_ALPHA8 : t.RGBA8), Y === t.UNSIGNED_SHORT_4_4_4_4 && (ne = t.RGBA4), Y === t.UNSIGNED_SHORT_5_5_5_1 && (ne = t.RGB5_A1);
    }
    return (ne === t.R16F || ne === t.R32F || ne === t.RG16F || ne === t.RG32F || ne === t.RGBA16F || ne === t.RGBA32F) && e.get("EXT_color_buffer_float"), ne;
  }
  function x(D, T) {
    let Y;
    return D ? T === null || T === Uo || T === Il ? Y = t.DEPTH24_STENCIL8 : T === ri ? Y = t.DEPTH32F_STENCIL8 : T === Nl && (Y = t.DEPTH24_STENCIL8, console.warn("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.")) : T === null || T === Uo || T === Il ? Y = t.DEPTH_COMPONENT24 : T === ri ? Y = t.DEPTH_COMPONENT32F : T === Nl && (Y = t.DEPTH_COMPONENT16), Y;
  }
  function _(D, T) {
    return m(D) === !0 || D.isFramebufferTexture && D.minFilter !== _r && D.minFilter !== yr ? Math.log2(Math.max(T.width, T.height)) + 1 : D.mipmaps !== void 0 && D.mipmaps.length > 0 ? D.mipmaps.length : D.isCompressedTexture && Array.isArray(D.image) ? T.mipmaps.length : 1;
  }
  function M(D) {
    const T = D.target;
    T.removeEventListener("dispose", M), P(T), T.isVideoTexture && u.delete(T);
  }
  function S(D) {
    const T = D.target;
    T.removeEventListener("dispose", S), w(T);
  }
  function P(D) {
    const T = r.get(D);
    if (T.__webglInit === void 0)
      return;
    const Y = D.source, fe = f.get(Y);
    if (fe) {
      const de = fe[T.__cacheKey];
      de.usedTimes--, de.usedTimes === 0 && E(D), Object.keys(fe).length === 0 && f.delete(Y);
    }
    r.remove(D);
  }
  function E(D) {
    const T = r.get(D);
    t.deleteTexture(T.__webglTexture);
    const Y = D.source, fe = f.get(Y);
    delete fe[T.__cacheKey], a.memory.textures--;
  }
  function w(D) {
    const T = r.get(D);
    if (D.depthTexture && (D.depthTexture.dispose(), r.remove(D.depthTexture)), D.isWebGLCubeRenderTarget)
      for (let fe = 0; fe < 6; fe++) {
        if (Array.isArray(T.__webglFramebuffer[fe]))
          for (let de = 0; de < T.__webglFramebuffer[fe].length; de++)
            t.deleteFramebuffer(T.__webglFramebuffer[fe][de]);
        else
          t.deleteFramebuffer(T.__webglFramebuffer[fe]);
        T.__webglDepthbuffer && t.deleteRenderbuffer(T.__webglDepthbuffer[fe]);
      }
    else {
      if (Array.isArray(T.__webglFramebuffer))
        for (let fe = 0; fe < T.__webglFramebuffer.length; fe++)
          t.deleteFramebuffer(T.__webglFramebuffer[fe]);
      else
        t.deleteFramebuffer(T.__webglFramebuffer);
      if (T.__webglDepthbuffer && t.deleteRenderbuffer(T.__webglDepthbuffer), T.__webglMultisampledFramebuffer && t.deleteFramebuffer(T.__webglMultisampledFramebuffer), T.__webglColorRenderbuffer)
        for (let fe = 0; fe < T.__webglColorRenderbuffer.length; fe++)
          T.__webglColorRenderbuffer[fe] && t.deleteRenderbuffer(T.__webglColorRenderbuffer[fe]);
      T.__webglDepthRenderbuffer && t.deleteRenderbuffer(T.__webglDepthRenderbuffer);
    }
    const Y = D.textures;
    for (let fe = 0, de = Y.length; fe < de; fe++) {
      const ne = r.get(Y[fe]);
      ne.__webglTexture && (t.deleteTexture(ne.__webglTexture), a.memory.textures--), r.remove(Y[fe]);
    }
    r.remove(D);
  }
  let O = 0;
  function N() {
    O = 0;
  }
  function I() {
    const D = O;
    return D >= i.maxTextures && console.warn("THREE.WebGLTextures: Trying to use " + D + " texture units while this GPU supports only " + i.maxTextures), O += 1, D;
  }
  function H(D) {
    const T = [];
    return T.push(D.wrapS), T.push(D.wrapT), T.push(D.wrapR || 0), T.push(D.magFilter), T.push(D.minFilter), T.push(D.anisotropy), T.push(D.internalFormat), T.push(D.format), T.push(D.type), T.push(D.generateMipmaps), T.push(D.premultiplyAlpha), T.push(D.flipY), T.push(D.unpackAlignment), T.push(D.colorSpace), T.join();
  }
  function j(D, T) {
    const Y = r.get(D);
    if (D.isVideoTexture && ue(D), D.isRenderTargetTexture === !1 && D.version > 0 && Y.__version !== D.version) {
      const fe = D.image;
      if (fe === null)
        console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
      else if (fe.complete === !1)
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
      else {
        k(Y, D, T);
        return;
      }
    }
    n.bindTexture(t.TEXTURE_2D, Y.__webglTexture, t.TEXTURE0 + T);
  }
  function U(D, T) {
    const Y = r.get(D);
    if (D.version > 0 && Y.__version !== D.version) {
      k(Y, D, T);
      return;
    }
    n.bindTexture(t.TEXTURE_2D_ARRAY, Y.__webglTexture, t.TEXTURE0 + T);
  }
  function $(D, T) {
    const Y = r.get(D);
    if (D.version > 0 && Y.__version !== D.version) {
      k(Y, D, T);
      return;
    }
    n.bindTexture(t.TEXTURE_3D, Y.__webglTexture, t.TEXTURE0 + T);
  }
  function V(D, T) {
    const Y = r.get(D);
    if (D.version > 0 && Y.__version !== D.version) {
      G(Y, D, T);
      return;
    }
    n.bindTexture(t.TEXTURE_CUBE_MAP, Y.__webglTexture, t.TEXTURE0 + T);
  }
  const te = {
    [Gh]: t.REPEAT,
    [To]: t.CLAMP_TO_EDGE,
    [qh]: t.MIRRORED_REPEAT
  }, B = {
    [_r]: t.NEAREST,
    [IQ]: t.NEAREST_MIPMAP_NEAREST,
    [Ic]: t.NEAREST_MIPMAP_LINEAR,
    [yr]: t.LINEAR,
    [f0]: t.LINEAR_MIPMAP_NEAREST,
    [Ui]: t.LINEAR_MIPMAP_LINEAR
  }, Z = {
    [BQ]: t.NEVER,
    [qQ]: t.ALWAYS,
    [VQ]: t.LESS,
    [L9]: t.LEQUAL,
    [$Q]: t.EQUAL,
    [GQ]: t.GEQUAL,
    [WQ]: t.GREATER,
    [jQ]: t.NOTEQUAL
  };
  function Q(D, T) {
    if (T.type === ri && e.has("OES_texture_float_linear") === !1 && (T.magFilter === yr || T.magFilter === f0 || T.magFilter === Ic || T.magFilter === Ui || T.minFilter === yr || T.minFilter === f0 || T.minFilter === Ic || T.minFilter === Ui) && console.warn("THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device."), t.texParameteri(D, t.TEXTURE_WRAP_S, te[T.wrapS]), t.texParameteri(D, t.TEXTURE_WRAP_T, te[T.wrapT]), (D === t.TEXTURE_3D || D === t.TEXTURE_2D_ARRAY) && t.texParameteri(D, t.TEXTURE_WRAP_R, te[T.wrapR]), t.texParameteri(D, t.TEXTURE_MAG_FILTER, B[T.magFilter]), t.texParameteri(D, t.TEXTURE_MIN_FILTER, B[T.minFilter]), T.compareFunction && (t.texParameteri(D, t.TEXTURE_COMPARE_MODE, t.COMPARE_REF_TO_TEXTURE), t.texParameteri(D, t.TEXTURE_COMPARE_FUNC, Z[T.compareFunction])), e.has("EXT_texture_filter_anisotropic") === !0) {
      if (T.magFilter === _r || T.minFilter !== Ic && T.minFilter !== Ui || T.type === ri && e.has("OES_texture_float_linear") === !1)
        return;
      if (T.anisotropy > 1 || r.get(T).__currentAnisotropy) {
        const Y = e.get("EXT_texture_filter_anisotropic");
        t.texParameterf(D, Y.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(T.anisotropy, i.getMaxAnisotropy())), r.get(T).__currentAnisotropy = T.anisotropy;
      }
    }
  }
  function ce(D, T) {
    let Y = !1;
    D.__webglInit === void 0 && (D.__webglInit = !0, T.addEventListener("dispose", M));
    const fe = T.source;
    let de = f.get(fe);
    de === void 0 && (de = {}, f.set(fe, de));
    const ne = H(T);
    if (ne !== D.__cacheKey) {
      de[ne] === void 0 && (de[ne] = {
        texture: t.createTexture(),
        usedTimes: 0
      }, a.memory.textures++, Y = !0), de[ne].usedTimes++;
      const Le = de[D.__cacheKey];
      Le !== void 0 && (de[D.__cacheKey].usedTimes--, Le.usedTimes === 0 && E(T)), D.__cacheKey = ne, D.__webglTexture = de[ne].texture;
    }
    return Y;
  }
  function k(D, T, Y) {
    let fe = t.TEXTURE_2D;
    (T.isDataArrayTexture || T.isCompressedArrayTexture) && (fe = t.TEXTURE_2D_ARRAY), T.isData3DTexture && (fe = t.TEXTURE_3D);
    const de = ce(D, T), ne = T.source;
    n.bindTexture(fe, D.__webglTexture, t.TEXTURE0 + Y);
    const Le = r.get(ne);
    if (ne.version !== Le.__version || de === !0) {
      n.activeTexture(t.TEXTURE0 + Y);
      const Ce = mt.getPrimaries(mt.workingColorSpace), Te = T.colorSpace === Ni ? null : mt.getPrimaries(T.colorSpace), ke = T.colorSpace === Ni || Ce === Te ? t.NONE : t.BROWSER_DEFAULT_WEBGL;
      t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, T.flipY), t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, T.premultiplyAlpha), t.pixelStorei(t.UNPACK_ALIGNMENT, T.unpackAlignment), t.pixelStorei(t.UNPACK_COLORSPACE_CONVERSION_WEBGL, ke);
      let ge = g(T.image, !1, i.maxTextureSize);
      ge = Se(T, ge);
      const Ee = o.convert(T.format, T.colorSpace), Be = o.convert(T.type);
      let We = b(T.internalFormat, Ee, Be, T.colorSpace, T.isVideoTexture);
      Q(fe, T);
      let Fe;
      const qe = T.mipmaps, Ye = T.isVideoTexture !== !0, Je = Le.__version === void 0 || de === !0, W = ne.dataReady, ye = _(T, ge);
      if (T.isDepthTexture)
        We = x(T.format === Ul, T.type), Je && (Ye ? n.texStorage2D(t.TEXTURE_2D, 1, We, ge.width, ge.height) : n.texImage2D(t.TEXTURE_2D, 0, We, ge.width, ge.height, 0, Ee, Be, null));
      else if (T.isDataTexture)
        if (qe.length > 0) {
          Ye && Je && n.texStorage2D(t.TEXTURE_2D, ye, We, qe[0].width, qe[0].height);
          for (let oe = 0, me = qe.length; oe < me; oe++)
            Fe = qe[oe], Ye ? W && n.texSubImage2D(t.TEXTURE_2D, oe, 0, 0, Fe.width, Fe.height, Ee, Be, Fe.data) : n.texImage2D(t.TEXTURE_2D, oe, We, Fe.width, Fe.height, 0, Ee, Be, Fe.data);
          T.generateMipmaps = !1;
        } else
          Ye ? (Je && n.texStorage2D(t.TEXTURE_2D, ye, We, ge.width, ge.height), W && n.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, ge.width, ge.height, Ee, Be, ge.data)) : n.texImage2D(t.TEXTURE_2D, 0, We, ge.width, ge.height, 0, Ee, Be, ge.data);
      else if (T.isCompressedTexture)
        if (T.isCompressedArrayTexture) {
          Ye && Je && n.texStorage3D(t.TEXTURE_2D_ARRAY, ye, We, qe[0].width, qe[0].height, ge.depth);
          for (let oe = 0, me = qe.length; oe < me; oe++)
            if (Fe = qe[oe], T.format !== br)
              if (Ee !== null)
                if (Ye) {
                  if (W)
                    if (T.layerUpdates.size > 0) {
                      const Oe = X4(Fe.width, Fe.height, T.format, T.type);
                      for (const Ae of T.layerUpdates) {
                        const Qe = Fe.data.subarray(
                          Ae * Oe / Fe.data.BYTES_PER_ELEMENT,
                          (Ae + 1) * Oe / Fe.data.BYTES_PER_ELEMENT
                        );
                        n.compressedTexSubImage3D(t.TEXTURE_2D_ARRAY, oe, 0, 0, Ae, Fe.width, Fe.height, 1, Ee, Qe);
                      }
                      T.clearLayerUpdates();
                    } else
                      n.compressedTexSubImage3D(t.TEXTURE_2D_ARRAY, oe, 0, 0, 0, Fe.width, Fe.height, ge.depth, Ee, Fe.data);
                } else
                  n.compressedTexImage3D(t.TEXTURE_2D_ARRAY, oe, We, Fe.width, Fe.height, ge.depth, 0, Fe.data, 0, 0);
              else
                console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
            else
              Ye ? W && n.texSubImage3D(t.TEXTURE_2D_ARRAY, oe, 0, 0, 0, Fe.width, Fe.height, ge.depth, Ee, Be, Fe.data) : n.texImage3D(t.TEXTURE_2D_ARRAY, oe, We, Fe.width, Fe.height, ge.depth, 0, Ee, Be, Fe.data);
        } else {
          Ye && Je && n.texStorage2D(t.TEXTURE_2D, ye, We, qe[0].width, qe[0].height);
          for (let oe = 0, me = qe.length; oe < me; oe++)
            Fe = qe[oe], T.format !== br ? Ee !== null ? Ye ? W && n.compressedTexSubImage2D(t.TEXTURE_2D, oe, 0, 0, Fe.width, Fe.height, Ee, Fe.data) : n.compressedTexImage2D(t.TEXTURE_2D, oe, We, Fe.width, Fe.height, 0, Fe.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : Ye ? W && n.texSubImage2D(t.TEXTURE_2D, oe, 0, 0, Fe.width, Fe.height, Ee, Be, Fe.data) : n.texImage2D(t.TEXTURE_2D, oe, We, Fe.width, Fe.height, 0, Ee, Be, Fe.data);
        }
      else if (T.isDataArrayTexture)
        if (Ye) {
          if (Je && n.texStorage3D(t.TEXTURE_2D_ARRAY, ye, We, ge.width, ge.height, ge.depth), W)
            if (T.layerUpdates.size > 0) {
              const oe = X4(ge.width, ge.height, T.format, T.type);
              for (const me of T.layerUpdates) {
                const Oe = ge.data.subarray(
                  me * oe / ge.data.BYTES_PER_ELEMENT,
                  (me + 1) * oe / ge.data.BYTES_PER_ELEMENT
                );
                n.texSubImage3D(t.TEXTURE_2D_ARRAY, 0, 0, 0, me, ge.width, ge.height, 1, Ee, Be, Oe);
              }
              T.clearLayerUpdates();
            } else
              n.texSubImage3D(t.TEXTURE_2D_ARRAY, 0, 0, 0, 0, ge.width, ge.height, ge.depth, Ee, Be, ge.data);
        } else
          n.texImage3D(t.TEXTURE_2D_ARRAY, 0, We, ge.width, ge.height, ge.depth, 0, Ee, Be, ge.data);
      else if (T.isData3DTexture)
        Ye ? (Je && n.texStorage3D(t.TEXTURE_3D, ye, We, ge.width, ge.height, ge.depth), W && n.texSubImage3D(t.TEXTURE_3D, 0, 0, 0, 0, ge.width, ge.height, ge.depth, Ee, Be, ge.data)) : n.texImage3D(t.TEXTURE_3D, 0, We, ge.width, ge.height, ge.depth, 0, Ee, Be, ge.data);
      else if (T.isFramebufferTexture) {
        if (Je)
          if (Ye)
            n.texStorage2D(t.TEXTURE_2D, ye, We, ge.width, ge.height);
          else {
            let oe = ge.width, me = ge.height;
            for (let Oe = 0; Oe < ye; Oe++)
              n.texImage2D(t.TEXTURE_2D, Oe, We, oe, me, 0, Ee, Be, null), oe >>= 1, me >>= 1;
          }
      } else if (qe.length > 0) {
        if (Ye && Je) {
          const oe = we(qe[0]);
          n.texStorage2D(t.TEXTURE_2D, ye, We, oe.width, oe.height);
        }
        for (let oe = 0, me = qe.length; oe < me; oe++)
          Fe = qe[oe], Ye ? W && n.texSubImage2D(t.TEXTURE_2D, oe, 0, 0, Ee, Be, Fe) : n.texImage2D(t.TEXTURE_2D, oe, We, Ee, Be, Fe);
        T.generateMipmaps = !1;
      } else if (Ye) {
        if (Je) {
          const oe = we(ge);
          n.texStorage2D(t.TEXTURE_2D, ye, We, oe.width, oe.height);
        }
        W && n.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, Ee, Be, ge);
      } else
        n.texImage2D(t.TEXTURE_2D, 0, We, Ee, Be, ge);
      m(T) && p(fe), Le.__version = ne.version, T.onUpdate && T.onUpdate(T);
    }
    D.__version = T.version;
  }
  function G(D, T, Y) {
    if (T.image.length !== 6)
      return;
    const fe = ce(D, T), de = T.source;
    n.bindTexture(t.TEXTURE_CUBE_MAP, D.__webglTexture, t.TEXTURE0 + Y);
    const ne = r.get(de);
    if (de.version !== ne.__version || fe === !0) {
      n.activeTexture(t.TEXTURE0 + Y);
      const Le = mt.getPrimaries(mt.workingColorSpace), Ce = T.colorSpace === Ni ? null : mt.getPrimaries(T.colorSpace), Te = T.colorSpace === Ni || Le === Ce ? t.NONE : t.BROWSER_DEFAULT_WEBGL;
      t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, T.flipY), t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, T.premultiplyAlpha), t.pixelStorei(t.UNPACK_ALIGNMENT, T.unpackAlignment), t.pixelStorei(t.UNPACK_COLORSPACE_CONVERSION_WEBGL, Te);
      const ke = T.isCompressedTexture || T.image[0].isCompressedTexture, ge = T.image[0] && T.image[0].isDataTexture, Ee = [];
      for (let me = 0; me < 6; me++)
        !ke && !ge ? Ee[me] = g(T.image[me], !0, i.maxCubemapSize) : Ee[me] = ge ? T.image[me].image : T.image[me], Ee[me] = Se(T, Ee[me]);
      const Be = Ee[0], We = o.convert(T.format, T.colorSpace), Fe = o.convert(T.type), qe = b(T.internalFormat, We, Fe, T.colorSpace), Ye = T.isVideoTexture !== !0, Je = ne.__version === void 0 || fe === !0, W = de.dataReady;
      let ye = _(T, Be);
      Q(t.TEXTURE_CUBE_MAP, T);
      let oe;
      if (ke) {
        Ye && Je && n.texStorage2D(t.TEXTURE_CUBE_MAP, ye, qe, Be.width, Be.height);
        for (let me = 0; me < 6; me++) {
          oe = Ee[me].mipmaps;
          for (let Oe = 0; Oe < oe.length; Oe++) {
            const Ae = oe[Oe];
            T.format !== br ? We !== null ? Ye ? W && n.compressedTexSubImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + me, Oe, 0, 0, Ae.width, Ae.height, We, Ae.data) : n.compressedTexImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + me, Oe, qe, Ae.width, Ae.height, 0, Ae.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : Ye ? W && n.texSubImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + me, Oe, 0, 0, Ae.width, Ae.height, We, Fe, Ae.data) : n.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + me, Oe, qe, Ae.width, Ae.height, 0, We, Fe, Ae.data);
          }
        }
      } else {
        if (oe = T.mipmaps, Ye && Je) {
          oe.length > 0 && ye++;
          const me = we(Ee[0]);
          n.texStorage2D(t.TEXTURE_CUBE_MAP, ye, qe, me.width, me.height);
        }
        for (let me = 0; me < 6; me++)
          if (ge) {
            Ye ? W && n.texSubImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + me, 0, 0, 0, Ee[me].width, Ee[me].height, We, Fe, Ee[me].data) : n.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + me, 0, qe, Ee[me].width, Ee[me].height, 0, We, Fe, Ee[me].data);
            for (let Oe = 0; Oe < oe.length; Oe++) {
              const Qe = oe[Oe].image[me].image;
              Ye ? W && n.texSubImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + me, Oe + 1, 0, 0, Qe.width, Qe.height, We, Fe, Qe.data) : n.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + me, Oe + 1, qe, Qe.width, Qe.height, 0, We, Fe, Qe.data);
            }
          } else {
            Ye ? W && n.texSubImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + me, 0, 0, 0, We, Fe, Ee[me]) : n.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + me, 0, qe, We, Fe, Ee[me]);
            for (let Oe = 0; Oe < oe.length; Oe++) {
              const Ae = oe[Oe];
              Ye ? W && n.texSubImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + me, Oe + 1, 0, 0, We, Fe, Ae.image[me]) : n.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + me, Oe + 1, qe, We, Fe, Ae.image[me]);
            }
          }
      }
      m(T) && p(t.TEXTURE_CUBE_MAP), ne.__version = de.version, T.onUpdate && T.onUpdate(T);
    }
    D.__version = T.version;
  }
  function K(D, T, Y, fe, de, ne) {
    const Le = o.convert(Y.format, Y.colorSpace), Ce = o.convert(Y.type), Te = b(Y.internalFormat, Le, Ce, Y.colorSpace), ke = r.get(T), ge = r.get(Y);
    if (ge.__renderTarget = T, !ke.__hasExternalTextures) {
      const Ee = Math.max(1, T.width >> ne), Be = Math.max(1, T.height >> ne);
      de === t.TEXTURE_3D || de === t.TEXTURE_2D_ARRAY ? n.texImage3D(de, ne, Te, Ee, Be, T.depth, 0, Le, Ce, null) : n.texImage2D(de, ne, Te, Ee, Be, 0, Le, Ce, null);
    }
    n.bindFramebuffer(t.FRAMEBUFFER, D), he(T) ? s.framebufferTexture2DMultisampleEXT(t.FRAMEBUFFER, fe, de, ge.__webglTexture, 0, $e(T)) : (de === t.TEXTURE_2D || de >= t.TEXTURE_CUBE_MAP_POSITIVE_X && de <= t.TEXTURE_CUBE_MAP_NEGATIVE_Z) && t.framebufferTexture2D(t.FRAMEBUFFER, fe, de, ge.__webglTexture, ne), n.bindFramebuffer(t.FRAMEBUFFER, null);
  }
  function J(D, T, Y) {
    if (t.bindRenderbuffer(t.RENDERBUFFER, D), T.depthBuffer) {
      const fe = T.depthTexture, de = fe && fe.isDepthTexture ? fe.type : null, ne = x(T.stencilBuffer, de), Le = T.stencilBuffer ? t.DEPTH_STENCIL_ATTACHMENT : t.DEPTH_ATTACHMENT, Ce = $e(T);
      he(T) ? s.renderbufferStorageMultisampleEXT(t.RENDERBUFFER, Ce, ne, T.width, T.height) : Y ? t.renderbufferStorageMultisample(t.RENDERBUFFER, Ce, ne, T.width, T.height) : t.renderbufferStorage(t.RENDERBUFFER, ne, T.width, T.height), t.framebufferRenderbuffer(t.FRAMEBUFFER, Le, t.RENDERBUFFER, D);
    } else {
      const fe = T.textures;
      for (let de = 0; de < fe.length; de++) {
        const ne = fe[de], Le = o.convert(ne.format, ne.colorSpace), Ce = o.convert(ne.type), Te = b(ne.internalFormat, Le, Ce, ne.colorSpace), ke = $e(T);
        Y && he(T) === !1 ? t.renderbufferStorageMultisample(t.RENDERBUFFER, ke, Te, T.width, T.height) : he(T) ? s.renderbufferStorageMultisampleEXT(t.RENDERBUFFER, ke, Te, T.width, T.height) : t.renderbufferStorage(t.RENDERBUFFER, Te, T.width, T.height);
      }
    }
    t.bindRenderbuffer(t.RENDERBUFFER, null);
  }
  function se(D, T) {
    if (T && T.isWebGLCubeRenderTarget)
      throw new Error("Depth Texture with cube render targets is not supported");
    if (n.bindFramebuffer(t.FRAMEBUFFER, D), !(T.depthTexture && T.depthTexture.isDepthTexture))
      throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
    const fe = r.get(T.depthTexture);
    fe.__renderTarget = T, (!fe.__webglTexture || T.depthTexture.image.width !== T.width || T.depthTexture.image.height !== T.height) && (T.depthTexture.image.width = T.width, T.depthTexture.image.height = T.height, T.depthTexture.needsUpdate = !0), j(T.depthTexture, 0);
    const de = fe.__webglTexture, ne = $e(T);
    if (T.depthTexture.format === Fl)
      he(T) ? s.framebufferTexture2DMultisampleEXT(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.TEXTURE_2D, de, 0, ne) : t.framebufferTexture2D(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.TEXTURE_2D, de, 0);
    else if (T.depthTexture.format === Ul)
      he(T) ? s.framebufferTexture2DMultisampleEXT(t.FRAMEBUFFER, t.DEPTH_STENCIL_ATTACHMENT, t.TEXTURE_2D, de, 0, ne) : t.framebufferTexture2D(t.FRAMEBUFFER, t.DEPTH_STENCIL_ATTACHMENT, t.TEXTURE_2D, de, 0);
    else
      throw new Error("Unknown depthTexture format");
  }
  function be(D) {
    const T = r.get(D), Y = D.isWebGLCubeRenderTarget === !0;
    if (T.__boundDepthTexture !== D.depthTexture) {
      const fe = D.depthTexture;
      if (T.__depthDisposeCallback && T.__depthDisposeCallback(), fe) {
        const de = () => {
          delete T.__boundDepthTexture, delete T.__depthDisposeCallback, fe.removeEventListener("dispose", de);
        };
        fe.addEventListener("dispose", de), T.__depthDisposeCallback = de;
      }
      T.__boundDepthTexture = fe;
    }
    if (D.depthTexture && !T.__autoAllocateDepthBuffer) {
      if (Y)
        throw new Error("target.depthTexture not supported in Cube render targets");
      se(T.__webglFramebuffer, D);
    } else if (Y) {
      T.__webglDepthbuffer = [];
      for (let fe = 0; fe < 6; fe++)
        if (n.bindFramebuffer(t.FRAMEBUFFER, T.__webglFramebuffer[fe]), T.__webglDepthbuffer[fe] === void 0)
          T.__webglDepthbuffer[fe] = t.createRenderbuffer(), J(T.__webglDepthbuffer[fe], D, !1);
        else {
          const de = D.stencilBuffer ? t.DEPTH_STENCIL_ATTACHMENT : t.DEPTH_ATTACHMENT, ne = T.__webglDepthbuffer[fe];
          t.bindRenderbuffer(t.RENDERBUFFER, ne), t.framebufferRenderbuffer(t.FRAMEBUFFER, de, t.RENDERBUFFER, ne);
        }
    } else if (n.bindFramebuffer(t.FRAMEBUFFER, T.__webglFramebuffer), T.__webglDepthbuffer === void 0)
      T.__webglDepthbuffer = t.createRenderbuffer(), J(T.__webglDepthbuffer, D, !1);
    else {
      const fe = D.stencilBuffer ? t.DEPTH_STENCIL_ATTACHMENT : t.DEPTH_ATTACHMENT, de = T.__webglDepthbuffer;
      t.bindRenderbuffer(t.RENDERBUFFER, de), t.framebufferRenderbuffer(t.FRAMEBUFFER, fe, t.RENDERBUFFER, de);
    }
    n.bindFramebuffer(t.FRAMEBUFFER, null);
  }
  function pe(D, T, Y) {
    const fe = r.get(D);
    T !== void 0 && K(fe.__webglFramebuffer, D, D.texture, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, 0), Y !== void 0 && be(D);
  }
  function Ne(D) {
    const T = D.texture, Y = r.get(D), fe = r.get(T);
    D.addEventListener("dispose", S);
    const de = D.textures, ne = D.isWebGLCubeRenderTarget === !0, Le = de.length > 1;
    if (Le || (fe.__webglTexture === void 0 && (fe.__webglTexture = t.createTexture()), fe.__version = T.version, a.memory.textures++), ne) {
      Y.__webglFramebuffer = [];
      for (let Ce = 0; Ce < 6; Ce++)
        if (T.mipmaps && T.mipmaps.length > 0) {
          Y.__webglFramebuffer[Ce] = [];
          for (let Te = 0; Te < T.mipmaps.length; Te++)
            Y.__webglFramebuffer[Ce][Te] = t.createFramebuffer();
        } else
          Y.__webglFramebuffer[Ce] = t.createFramebuffer();
    } else {
      if (T.mipmaps && T.mipmaps.length > 0) {
        Y.__webglFramebuffer = [];
        for (let Ce = 0; Ce < T.mipmaps.length; Ce++)
          Y.__webglFramebuffer[Ce] = t.createFramebuffer();
      } else
        Y.__webglFramebuffer = t.createFramebuffer();
      if (Le)
        for (let Ce = 0, Te = de.length; Ce < Te; Ce++) {
          const ke = r.get(de[Ce]);
          ke.__webglTexture === void 0 && (ke.__webglTexture = t.createTexture(), a.memory.textures++);
        }
      if (D.samples > 0 && he(D) === !1) {
        Y.__webglMultisampledFramebuffer = t.createFramebuffer(), Y.__webglColorRenderbuffer = [], n.bindFramebuffer(t.FRAMEBUFFER, Y.__webglMultisampledFramebuffer);
        for (let Ce = 0; Ce < de.length; Ce++) {
          const Te = de[Ce];
          Y.__webglColorRenderbuffer[Ce] = t.createRenderbuffer(), t.bindRenderbuffer(t.RENDERBUFFER, Y.__webglColorRenderbuffer[Ce]);
          const ke = o.convert(Te.format, Te.colorSpace), ge = o.convert(Te.type), Ee = b(Te.internalFormat, ke, ge, Te.colorSpace, D.isXRRenderTarget === !0), Be = $e(D);
          t.renderbufferStorageMultisample(t.RENDERBUFFER, Be, Ee, D.width, D.height), t.framebufferRenderbuffer(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0 + Ce, t.RENDERBUFFER, Y.__webglColorRenderbuffer[Ce]);
        }
        t.bindRenderbuffer(t.RENDERBUFFER, null), D.depthBuffer && (Y.__webglDepthRenderbuffer = t.createRenderbuffer(), J(Y.__webglDepthRenderbuffer, D, !0)), n.bindFramebuffer(t.FRAMEBUFFER, null);
      }
    }
    if (ne) {
      n.bindTexture(t.TEXTURE_CUBE_MAP, fe.__webglTexture), Q(t.TEXTURE_CUBE_MAP, T);
      for (let Ce = 0; Ce < 6; Ce++)
        if (T.mipmaps && T.mipmaps.length > 0)
          for (let Te = 0; Te < T.mipmaps.length; Te++)
            K(Y.__webglFramebuffer[Ce][Te], D, T, t.COLOR_ATTACHMENT0, t.TEXTURE_CUBE_MAP_POSITIVE_X + Ce, Te);
        else
          K(Y.__webglFramebuffer[Ce], D, T, t.COLOR_ATTACHMENT0, t.TEXTURE_CUBE_MAP_POSITIVE_X + Ce, 0);
      m(T) && p(t.TEXTURE_CUBE_MAP), n.unbindTexture();
    } else if (Le) {
      for (let Ce = 0, Te = de.length; Ce < Te; Ce++) {
        const ke = de[Ce], ge = r.get(ke);
        n.bindTexture(t.TEXTURE_2D, ge.__webglTexture), Q(t.TEXTURE_2D, ke), K(Y.__webglFramebuffer, D, ke, t.COLOR_ATTACHMENT0 + Ce, t.TEXTURE_2D, 0), m(ke) && p(t.TEXTURE_2D);
      }
      n.unbindTexture();
    } else {
      let Ce = t.TEXTURE_2D;
      if ((D.isWebGL3DRenderTarget || D.isWebGLArrayRenderTarget) && (Ce = D.isWebGL3DRenderTarget ? t.TEXTURE_3D : t.TEXTURE_2D_ARRAY), n.bindTexture(Ce, fe.__webglTexture), Q(Ce, T), T.mipmaps && T.mipmaps.length > 0)
        for (let Te = 0; Te < T.mipmaps.length; Te++)
          K(Y.__webglFramebuffer[Te], D, T, t.COLOR_ATTACHMENT0, Ce, Te);
      else
        K(Y.__webglFramebuffer, D, T, t.COLOR_ATTACHMENT0, Ce, 0);
      m(T) && p(Ce), n.unbindTexture();
    }
    D.depthBuffer && be(D);
  }
  function ae(D) {
    const T = D.textures;
    for (let Y = 0, fe = T.length; Y < fe; Y++) {
      const de = T[Y];
      if (m(de)) {
        const ne = y(D), Le = r.get(de).__webglTexture;
        n.bindTexture(ne, Le), p(ne), n.unbindTexture();
      }
    }
  }
  const Re = [], F = [];
  function Ge(D) {
    if (D.samples > 0) {
      if (he(D) === !1) {
        const T = D.textures, Y = D.width, fe = D.height;
        let de = t.COLOR_BUFFER_BIT;
        const ne = D.stencilBuffer ? t.DEPTH_STENCIL_ATTACHMENT : t.DEPTH_ATTACHMENT, Le = r.get(D), Ce = T.length > 1;
        if (Ce)
          for (let Te = 0; Te < T.length; Te++)
            n.bindFramebuffer(t.FRAMEBUFFER, Le.__webglMultisampledFramebuffer), t.framebufferRenderbuffer(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0 + Te, t.RENDERBUFFER, null), n.bindFramebuffer(t.FRAMEBUFFER, Le.__webglFramebuffer), t.framebufferTexture2D(t.DRAW_FRAMEBUFFER, t.COLOR_ATTACHMENT0 + Te, t.TEXTURE_2D, null, 0);
        n.bindFramebuffer(t.READ_FRAMEBUFFER, Le.__webglMultisampledFramebuffer), n.bindFramebuffer(t.DRAW_FRAMEBUFFER, Le.__webglFramebuffer);
        for (let Te = 0; Te < T.length; Te++) {
          if (D.resolveDepthBuffer && (D.depthBuffer && (de |= t.DEPTH_BUFFER_BIT), D.stencilBuffer && D.resolveStencilBuffer && (de |= t.STENCIL_BUFFER_BIT)), Ce) {
            t.framebufferRenderbuffer(t.READ_FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.RENDERBUFFER, Le.__webglColorRenderbuffer[Te]);
            const ke = r.get(T[Te]).__webglTexture;
            t.framebufferTexture2D(t.DRAW_FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, ke, 0);
          }
          t.blitFramebuffer(0, 0, Y, fe, 0, 0, Y, fe, de, t.NEAREST), l === !0 && (Re.length = 0, F.length = 0, Re.push(t.COLOR_ATTACHMENT0 + Te), D.depthBuffer && D.resolveDepthBuffer === !1 && (Re.push(ne), F.push(ne), t.invalidateFramebuffer(t.DRAW_FRAMEBUFFER, F)), t.invalidateFramebuffer(t.READ_FRAMEBUFFER, Re));
        }
        if (n.bindFramebuffer(t.READ_FRAMEBUFFER, null), n.bindFramebuffer(t.DRAW_FRAMEBUFFER, null), Ce)
          for (let Te = 0; Te < T.length; Te++) {
            n.bindFramebuffer(t.FRAMEBUFFER, Le.__webglMultisampledFramebuffer), t.framebufferRenderbuffer(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0 + Te, t.RENDERBUFFER, Le.__webglColorRenderbuffer[Te]);
            const ke = r.get(T[Te]).__webglTexture;
            n.bindFramebuffer(t.FRAMEBUFFER, Le.__webglFramebuffer), t.framebufferTexture2D(t.DRAW_FRAMEBUFFER, t.COLOR_ATTACHMENT0 + Te, t.TEXTURE_2D, ke, 0);
          }
        n.bindFramebuffer(t.DRAW_FRAMEBUFFER, Le.__webglMultisampledFramebuffer);
      } else if (D.depthBuffer && D.resolveDepthBuffer === !1 && l) {
        const T = D.stencilBuffer ? t.DEPTH_STENCIL_ATTACHMENT : t.DEPTH_ATTACHMENT;
        t.invalidateFramebuffer(t.DRAW_FRAMEBUFFER, [T]);
      }
    }
  }
  function $e(D) {
    return Math.min(i.maxSamples, D.samples);
  }
  function he(D) {
    const T = r.get(D);
    return D.samples > 0 && e.has("WEBGL_multisampled_render_to_texture") === !0 && T.__useRenderToTexture !== !1;
  }
  function ue(D) {
    const T = a.render.frame;
    u.get(D) !== T && (u.set(D, T), D.update());
  }
  function Se(D, T) {
    const Y = D.colorSpace, fe = D.format, de = D.type;
    return D.isCompressedTexture === !0 || D.isVideoTexture === !0 || Y !== zo && Y !== Ni && (mt.getTransfer(Y) === Tt ? (fe !== br || de !== di) && console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture color space:", Y)), T;
  }
  function we(D) {
    return typeof HTMLImageElement < "u" && D instanceof HTMLImageElement ? (c.width = D.naturalWidth || D.width, c.height = D.naturalHeight || D.height) : typeof VideoFrame < "u" && D instanceof VideoFrame ? (c.width = D.displayWidth, c.height = D.displayHeight) : (c.width = D.width, c.height = D.height), c;
  }
  this.allocateTextureUnit = I, this.resetTextureUnits = N, this.setTexture2D = j, this.setTexture2DArray = U, this.setTexture3D = $, this.setTextureCube = V, this.rebindTextures = pe, this.setupRenderTarget = Ne, this.updateRenderTargetMipmap = ae, this.updateMultisampleRenderTarget = Ge, this.setupDepthRenderbuffer = be, this.setupFrameBufferTexture = K, this.useMultisampledRTT = he;
}
function woe(t, e) {
  function n(r, i = Ni) {
    let o;
    const a = mt.getTransfer(i);
    if (r === di)
      return t.UNSIGNED_BYTE;
    if (r === w2)
      return t.UNSIGNED_SHORT_4_4_4_4;
    if (r === _2)
      return t.UNSIGNED_SHORT_5_5_5_1;
    if (r === C9)
      return t.UNSIGNED_INT_5_9_9_9_REV;
    if (r === w9)
      return t.BYTE;
    if (r === _9)
      return t.SHORT;
    if (r === Nl)
      return t.UNSIGNED_SHORT;
    if (r === x2)
      return t.INT;
    if (r === Uo)
      return t.UNSIGNED_INT;
    if (r === ri)
      return t.FLOAT;
    if (r === lc)
      return t.HALF_FLOAT;
    if (r === E9)
      return t.ALPHA;
    if (r === S9)
      return t.RGB;
    if (r === br)
      return t.RGBA;
    if (r === M9)
      return t.LUMINANCE;
    if (r === T9)
      return t.LUMINANCE_ALPHA;
    if (r === Fl)
      return t.DEPTH_COMPONENT;
    if (r === Ul)
      return t.DEPTH_STENCIL;
    if (r === A9)
      return t.RED;
    if (r === C2)
      return t.RED_INTEGER;
    if (r === P9)
      return t.RG;
    if (r === E2)
      return t.RG_INTEGER;
    if (r === S2)
      return t.RGBA_INTEGER;
    if (r === Cu || r === Eu || r === Su || r === Mu)
      if (a === Tt)
        if (o = e.get("WEBGL_compressed_texture_s3tc_srgb"), o !== null) {
          if (r === Cu)
            return o.COMPRESSED_SRGB_S3TC_DXT1_EXT;
          if (r === Eu)
            return o.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
          if (r === Su)
            return o.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
          if (r === Mu)
            return o.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
        } else
          return null;
      else if (o = e.get("WEBGL_compressed_texture_s3tc"), o !== null) {
        if (r === Cu)
          return o.COMPRESSED_RGB_S3TC_DXT1_EXT;
        if (r === Eu)
          return o.COMPRESSED_RGBA_S3TC_DXT1_EXT;
        if (r === Su)
          return o.COMPRESSED_RGBA_S3TC_DXT3_EXT;
        if (r === Mu)
          return o.COMPRESSED_RGBA_S3TC_DXT5_EXT;
      } else
        return null;
    if (r === Xh || r === Yh || r === Zh || r === Kh)
      if (o = e.get("WEBGL_compressed_texture_pvrtc"), o !== null) {
        if (r === Xh)
          return o.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (r === Yh)
          return o.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (r === Zh)
          return o.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (r === Kh)
          return o.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      } else
        return null;
    if (r === Jh || r === Qh || r === e1)
      if (o = e.get("WEBGL_compressed_texture_etc"), o !== null) {
        if (r === Jh || r === Qh)
          return a === Tt ? o.COMPRESSED_SRGB8_ETC2 : o.COMPRESSED_RGB8_ETC2;
        if (r === e1)
          return a === Tt ? o.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : o.COMPRESSED_RGBA8_ETC2_EAC;
      } else
        return null;
    if (r === t1 || r === n1 || r === r1 || r === i1 || r === o1 || r === a1 || r === s1 || r === l1 || r === c1 || r === u1 || r === d1 || r === f1 || r === h1 || r === p1)
      if (o = e.get("WEBGL_compressed_texture_astc"), o !== null) {
        if (r === t1)
          return a === Tt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : o.COMPRESSED_RGBA_ASTC_4x4_KHR;
        if (r === n1)
          return a === Tt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : o.COMPRESSED_RGBA_ASTC_5x4_KHR;
        if (r === r1)
          return a === Tt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : o.COMPRESSED_RGBA_ASTC_5x5_KHR;
        if (r === i1)
          return a === Tt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : o.COMPRESSED_RGBA_ASTC_6x5_KHR;
        if (r === o1)
          return a === Tt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : o.COMPRESSED_RGBA_ASTC_6x6_KHR;
        if (r === a1)
          return a === Tt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : o.COMPRESSED_RGBA_ASTC_8x5_KHR;
        if (r === s1)
          return a === Tt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : o.COMPRESSED_RGBA_ASTC_8x6_KHR;
        if (r === l1)
          return a === Tt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : o.COMPRESSED_RGBA_ASTC_8x8_KHR;
        if (r === c1)
          return a === Tt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : o.COMPRESSED_RGBA_ASTC_10x5_KHR;
        if (r === u1)
          return a === Tt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : o.COMPRESSED_RGBA_ASTC_10x6_KHR;
        if (r === d1)
          return a === Tt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : o.COMPRESSED_RGBA_ASTC_10x8_KHR;
        if (r === f1)
          return a === Tt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : o.COMPRESSED_RGBA_ASTC_10x10_KHR;
        if (r === h1)
          return a === Tt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : o.COMPRESSED_RGBA_ASTC_12x10_KHR;
        if (r === p1)
          return a === Tt ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : o.COMPRESSED_RGBA_ASTC_12x12_KHR;
      } else
        return null;
    if (r === Tu || r === m1 || r === v1)
      if (o = e.get("EXT_texture_compression_bptc"), o !== null) {
        if (r === Tu)
          return a === Tt ? o.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : o.COMPRESSED_RGBA_BPTC_UNORM_EXT;
        if (r === m1)
          return o.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
        if (r === v1)
          return o.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
      } else
        return null;
    if (r === R9 || r === g1 || r === y1 || r === b1)
      if (o = e.get("EXT_texture_compression_rgtc"), o !== null) {
        if (r === Tu)
          return o.COMPRESSED_RED_RGTC1_EXT;
        if (r === g1)
          return o.COMPRESSED_SIGNED_RED_RGTC1_EXT;
        if (r === y1)
          return o.COMPRESSED_RED_GREEN_RGTC2_EXT;
        if (r === b1)
          return o.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
      } else
        return null;
    return r === Il ? t.UNSIGNED_INT_24_8 : t[r] !== void 0 ? t[r] : null;
  }
  return { convert: n };
}
const _oe = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`, Coe = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
class Eoe {
  /**
   * Constructs a new depth sensing module.
   */
  constructor() {
    this.texture = null, this.mesh = null, this.depthNear = 0, this.depthFar = 0;
  }
  /**
   * Inits the depth sensing module
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {XRWebGLDepthInformation} depthData - The XR depth data.
   * @param {XRRenderState} renderState - The XR render state.
   */
  init(e, n, r) {
    if (this.texture === null) {
      const i = new En(), o = e.properties.get(i);
      o.__webglTexture = n.texture, (n.depthNear !== r.depthNear || n.depthFar !== r.depthFar) && (this.depthNear = n.depthNear, this.depthFar = n.depthFar), this.texture = i;
    }
  }
  /**
   * Returns a plane mesh that visualizes the depth texture.
   *
   * @param {ArrayCamera} cameraXR - The XR camera.
   * @return {?Mesh} The plane mesh.
   */
  getMesh(e) {
    if (this.texture !== null && this.mesh === null) {
      const n = e.cameras[0].viewport, r = new eo({
        vertexShader: _oe,
        fragmentShader: Coe,
        uniforms: {
          depthColor: { value: this.texture },
          depthWidth: { value: n.z },
          depthHeight: { value: n.w }
        }
      });
      this.mesh = new rr(new Kd(20, 20), r);
    }
    return this.mesh;
  }
  /**
   * Resets the module
   */
  reset() {
    this.texture = null, this.mesh = null;
  }
  /**
   * Returns a texture representing the depth of the user's environment.
   *
   * @return {?Texture} The depth texture.
   */
  getDepthTexture() {
    return this.texture;
  }
}
class Soe extends As {
  /**
   * Constructs a new WebGL renderer.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGL2RenderingContext} gl - The rendering context.
   */
  constructor(e, n) {
    super();
    const r = this;
    let i = null, o = 1, a = null, s = "local-floor", l = 1, c = null, u = null, d = null, f = null, h = null, v = null;
    const g = new Eoe(), m = n.getContextAttributes();
    let p = null, y = null;
    const b = [], x = [], _ = new Pt();
    let M = null;
    const S = new tr();
    S.viewport = new Yt();
    const P = new tr();
    P.viewport = new Yt();
    const E = [S, P], w = new jee();
    let O = null, N = null;
    this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(k) {
      let G = b[k];
      return G === void 0 && (G = new O0(), b[k] = G), G.getTargetRaySpace();
    }, this.getControllerGrip = function(k) {
      let G = b[k];
      return G === void 0 && (G = new O0(), b[k] = G), G.getGripSpace();
    }, this.getHand = function(k) {
      let G = b[k];
      return G === void 0 && (G = new O0(), b[k] = G), G.getHandSpace();
    };
    function I(k) {
      const G = x.indexOf(k.inputSource);
      if (G === -1)
        return;
      const K = b[G];
      K !== void 0 && (K.update(k.inputSource, k.frame, c || a), K.dispatchEvent({ type: k.type, data: k.inputSource }));
    }
    function H() {
      i.removeEventListener("select", I), i.removeEventListener("selectstart", I), i.removeEventListener("selectend", I), i.removeEventListener("squeeze", I), i.removeEventListener("squeezestart", I), i.removeEventListener("squeezeend", I), i.removeEventListener("end", H), i.removeEventListener("inputsourceschange", j);
      for (let k = 0; k < b.length; k++) {
        const G = x[k];
        G !== null && (x[k] = null, b[k].disconnect(G));
      }
      O = null, N = null, g.reset(), e.setRenderTarget(p), h = null, f = null, d = null, i = null, y = null, ce.stop(), r.isPresenting = !1, e.setPixelRatio(M), e.setSize(_.width, _.height, !1), r.dispatchEvent({ type: "sessionend" });
    }
    this.setFramebufferScaleFactor = function(k) {
      o = k, r.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
    }, this.setReferenceSpaceType = function(k) {
      s = k, r.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
    }, this.getReferenceSpace = function() {
      return c || a;
    }, this.setReferenceSpace = function(k) {
      c = k;
    }, this.getBaseLayer = function() {
      return f !== null ? f : h;
    }, this.getBinding = function() {
      return d;
    }, this.getFrame = function() {
      return v;
    }, this.getSession = function() {
      return i;
    }, this.setSession = async function(k) {
      if (i = k, i !== null) {
        if (p = e.getRenderTarget(), i.addEventListener("select", I), i.addEventListener("selectstart", I), i.addEventListener("selectend", I), i.addEventListener("squeeze", I), i.addEventListener("squeezestart", I), i.addEventListener("squeezeend", I), i.addEventListener("end", H), i.addEventListener("inputsourceschange", j), m.xrCompatible !== !0 && await n.makeXRCompatible(), M = e.getPixelRatio(), e.getSize(_), typeof XRWebGLBinding < "u" && "createProjectionLayer" in XRWebGLBinding.prototype) {
          let K = null, J = null, se = null;
          m.depth && (se = m.stencil ? n.DEPTH24_STENCIL8 : n.DEPTH_COMPONENT24, K = m.stencil ? Ul : Fl, J = m.stencil ? Il : Uo);
          const be = {
            colorFormat: n.RGBA8,
            depthFormat: se,
            scaleFactor: o
          };
          d = new XRWebGLBinding(i, n), f = d.createProjectionLayer(be), i.updateRenderState({ layers: [f] }), e.setPixelRatio(1), e.setSize(f.textureWidth, f.textureHeight, !1), y = new Qi(
            f.textureWidth,
            f.textureHeight,
            {
              format: br,
              type: di,
              depthTexture: new B9(f.textureWidth, f.textureHeight, J, void 0, void 0, void 0, void 0, void 0, void 0, K),
              stencilBuffer: m.stencil,
              colorSpace: e.outputColorSpace,
              samples: m.antialias ? 4 : 0,
              resolveDepthBuffer: f.ignoreDepthValues === !1,
              resolveStencilBuffer: f.ignoreDepthValues === !1
            }
          );
        } else {
          const K = {
            antialias: m.antialias,
            alpha: !0,
            depth: m.depth,
            stencil: m.stencil,
            framebufferScaleFactor: o
          };
          h = new XRWebGLLayer(i, n, K), i.updateRenderState({ baseLayer: h }), e.setPixelRatio(1), e.setSize(h.framebufferWidth, h.framebufferHeight, !1), y = new Qi(
            h.framebufferWidth,
            h.framebufferHeight,
            {
              format: br,
              type: di,
              colorSpace: e.outputColorSpace,
              stencilBuffer: m.stencil,
              resolveDepthBuffer: h.ignoreDepthValues === !1,
              resolveStencilBuffer: h.ignoreDepthValues === !1
            }
          );
        }
        y.isXRRenderTarget = !0, this.setFoveation(l), c = null, a = await i.requestReferenceSpace(s), ce.setContext(i), ce.start(), r.isPresenting = !0, r.dispatchEvent({ type: "sessionstart" });
      }
    }, this.getEnvironmentBlendMode = function() {
      if (i !== null)
        return i.environmentBlendMode;
    }, this.getDepthTexture = function() {
      return g.getDepthTexture();
    };
    function j(k) {
      for (let G = 0; G < k.removed.length; G++) {
        const K = k.removed[G], J = x.indexOf(K);
        J >= 0 && (x[J] = null, b[J].disconnect(K));
      }
      for (let G = 0; G < k.added.length; G++) {
        const K = k.added[G];
        let J = x.indexOf(K);
        if (J === -1) {
          for (let be = 0; be < b.length; be++)
            if (be >= x.length) {
              x.push(K), J = be;
              break;
            } else if (x[be] === null) {
              x[be] = K, J = be;
              break;
            }
          if (J === -1)
            break;
        }
        const se = b[J];
        se && se.connect(K);
      }
    }
    const U = new re(), $ = new re();
    function V(k, G, K) {
      U.setFromMatrixPosition(G.matrixWorld), $.setFromMatrixPosition(K.matrixWorld);
      const J = U.distanceTo($), se = G.projectionMatrix.elements, be = K.projectionMatrix.elements, pe = se[14] / (se[10] - 1), Ne = se[14] / (se[10] + 1), ae = (se[9] + 1) / se[5], Re = (se[9] - 1) / se[5], F = (se[8] - 1) / se[0], Ge = (be[8] + 1) / be[0], $e = pe * F, he = pe * Ge, ue = J / (-F + Ge), Se = ue * -F;
      if (G.matrixWorld.decompose(k.position, k.quaternion, k.scale), k.translateX(Se), k.translateZ(ue), k.matrixWorld.compose(k.position, k.quaternion, k.scale), k.matrixWorldInverse.copy(k.matrixWorld).invert(), se[10] === -1)
        k.projectionMatrix.copy(G.projectionMatrix), k.projectionMatrixInverse.copy(G.projectionMatrixInverse);
      else {
        const we = pe + ue, D = Ne + ue, T = $e - Se, Y = he + (J - Se), fe = ae * Ne / D * we, de = Re * Ne / D * we;
        k.projectionMatrix.makePerspective(T, Y, fe, de, we, D), k.projectionMatrixInverse.copy(k.projectionMatrix).invert();
      }
    }
    function te(k, G) {
      G === null ? k.matrixWorld.copy(k.matrix) : k.matrixWorld.multiplyMatrices(G.matrixWorld, k.matrix), k.matrixWorldInverse.copy(k.matrixWorld).invert();
    }
    this.updateCamera = function(k) {
      if (i === null)
        return;
      let G = k.near, K = k.far;
      g.texture !== null && (g.depthNear > 0 && (G = g.depthNear), g.depthFar > 0 && (K = g.depthFar)), w.near = P.near = S.near = G, w.far = P.far = S.far = K, (O !== w.near || N !== w.far) && (i.updateRenderState({
        depthNear: w.near,
        depthFar: w.far
      }), O = w.near, N = w.far), S.layers.mask = k.layers.mask | 2, P.layers.mask = k.layers.mask | 4, w.layers.mask = S.layers.mask | P.layers.mask;
      const J = k.parent, se = w.cameras;
      te(w, J);
      for (let be = 0; be < se.length; be++)
        te(se[be], J);
      se.length === 2 ? V(w, S, P) : w.projectionMatrix.copy(S.projectionMatrix), B(k, w, J);
    };
    function B(k, G, K) {
      K === null ? k.matrix.copy(G.matrixWorld) : (k.matrix.copy(K.matrixWorld), k.matrix.invert(), k.matrix.multiply(G.matrixWorld)), k.matrix.decompose(k.position, k.quaternion, k.scale), k.updateMatrixWorld(!0), k.projectionMatrix.copy(G.projectionMatrix), k.projectionMatrixInverse.copy(G.projectionMatrixInverse), k.isPerspectiveCamera && (k.fov = zl * 2 * Math.atan(1 / k.projectionMatrix.elements[5]), k.zoom = 1);
    }
    this.getCamera = function() {
      return w;
    }, this.getFoveation = function() {
      if (!(f === null && h === null))
        return l;
    }, this.setFoveation = function(k) {
      l = k, f !== null && (f.fixedFoveation = k), h !== null && h.fixedFoveation !== void 0 && (h.fixedFoveation = k);
    }, this.hasDepthSensing = function() {
      return g.texture !== null;
    }, this.getDepthSensingMesh = function() {
      return g.getMesh(w);
    };
    let Z = null;
    function Q(k, G) {
      if (u = G.getViewerPose(c || a), v = G, u !== null) {
        const K = u.views;
        h !== null && (e.setRenderTargetFramebuffer(y, h.framebuffer), e.setRenderTarget(y));
        let J = !1;
        K.length !== w.cameras.length && (w.cameras.length = 0, J = !0);
        for (let pe = 0; pe < K.length; pe++) {
          const Ne = K[pe];
          let ae = null;
          if (h !== null)
            ae = h.getViewport(Ne);
          else {
            const F = d.getViewSubImage(f, Ne);
            ae = F.viewport, pe === 0 && (e.setRenderTargetTextures(
              y,
              F.colorTexture,
              F.depthStencilTexture
            ), e.setRenderTarget(y));
          }
          let Re = E[pe];
          Re === void 0 && (Re = new tr(), Re.layers.enable(pe), Re.viewport = new Yt(), E[pe] = Re), Re.matrix.fromArray(Ne.transform.matrix), Re.matrix.decompose(Re.position, Re.quaternion, Re.scale), Re.projectionMatrix.fromArray(Ne.projectionMatrix), Re.projectionMatrixInverse.copy(Re.projectionMatrix).invert(), Re.viewport.set(ae.x, ae.y, ae.width, ae.height), pe === 0 && (w.matrix.copy(Re.matrix), w.matrix.decompose(w.position, w.quaternion, w.scale)), J === !0 && w.cameras.push(Re);
        }
        const se = i.enabledFeatures;
        if (se && se.includes("depth-sensing") && i.depthUsage == "gpu-optimized" && d) {
          const pe = d.getDepthInformation(K[0]);
          pe && pe.isValid && pe.texture && g.init(e, pe, i.renderState);
        }
      }
      for (let K = 0; K < b.length; K++) {
        const J = x[K], se = b[K];
        J !== null && se !== void 0 && se.update(J, G, c || a);
      }
      Z && Z(k, G), G.detectedPlanes && r.dispatchEvent({ type: "planesdetected", data: G }), v = null;
    }
    const ce = new V9();
    ce.setAnimationLoop(Q), this.setAnimationLoop = function(k) {
      Z = k;
    }, this.dispose = function() {
    };
  }
}
const go = /* @__PURE__ */ new Vr(), Moe = /* @__PURE__ */ new qt();
function Toe(t, e) {
  function n(m, p) {
    m.matrixAutoUpdate === !0 && m.updateMatrix(), p.value.copy(m.matrix);
  }
  function r(m, p) {
    p.color.getRGB(m.fogColor.value, U9(t)), p.isFog ? (m.fogNear.value = p.near, m.fogFar.value = p.far) : p.isFogExp2 && (m.fogDensity.value = p.density);
  }
  function i(m, p, y, b, x) {
    p.isMeshBasicMaterial || p.isMeshLambertMaterial ? o(m, p) : p.isMeshToonMaterial ? (o(m, p), d(m, p)) : p.isMeshPhongMaterial ? (o(m, p), u(m, p)) : p.isMeshStandardMaterial ? (o(m, p), f(m, p), p.isMeshPhysicalMaterial && h(m, p, x)) : p.isMeshMatcapMaterial ? (o(m, p), v(m, p)) : p.isMeshDepthMaterial ? o(m, p) : p.isMeshDistanceMaterial ? (o(m, p), g(m, p)) : p.isMeshNormalMaterial ? o(m, p) : p.isLineBasicMaterial ? (a(m, p), p.isLineDashedMaterial && s(m, p)) : p.isPointsMaterial ? l(m, p, y, b) : p.isSpriteMaterial ? c(m, p) : p.isShadowMaterial ? (m.color.value.copy(p.color), m.opacity.value = p.opacity) : p.isShaderMaterial && (p.uniformsNeedUpdate = !1);
  }
  function o(m, p) {
    m.opacity.value = p.opacity, p.color && m.diffuse.value.copy(p.color), p.emissive && m.emissive.value.copy(p.emissive).multiplyScalar(p.emissiveIntensity), p.map && (m.map.value = p.map, n(p.map, m.mapTransform)), p.alphaMap && (m.alphaMap.value = p.alphaMap, n(p.alphaMap, m.alphaMapTransform)), p.bumpMap && (m.bumpMap.value = p.bumpMap, n(p.bumpMap, m.bumpMapTransform), m.bumpScale.value = p.bumpScale, p.side === Rn && (m.bumpScale.value *= -1)), p.normalMap && (m.normalMap.value = p.normalMap, n(p.normalMap, m.normalMapTransform), m.normalScale.value.copy(p.normalScale), p.side === Rn && m.normalScale.value.negate()), p.displacementMap && (m.displacementMap.value = p.displacementMap, n(p.displacementMap, m.displacementMapTransform), m.displacementScale.value = p.displacementScale, m.displacementBias.value = p.displacementBias), p.emissiveMap && (m.emissiveMap.value = p.emissiveMap, n(p.emissiveMap, m.emissiveMapTransform)), p.specularMap && (m.specularMap.value = p.specularMap, n(p.specularMap, m.specularMapTransform)), p.alphaTest > 0 && (m.alphaTest.value = p.alphaTest);
    const y = e.get(p), b = y.envMap, x = y.envMapRotation;
    b && (m.envMap.value = b, go.copy(x), go.x *= -1, go.y *= -1, go.z *= -1, b.isCubeTexture && b.isRenderTargetTexture === !1 && (go.y *= -1, go.z *= -1), m.envMapRotation.value.setFromMatrix4(Moe.makeRotationFromEuler(go)), m.flipEnvMap.value = b.isCubeTexture && b.isRenderTargetTexture === !1 ? -1 : 1, m.reflectivity.value = p.reflectivity, m.ior.value = p.ior, m.refractionRatio.value = p.refractionRatio), p.lightMap && (m.lightMap.value = p.lightMap, m.lightMapIntensity.value = p.lightMapIntensity, n(p.lightMap, m.lightMapTransform)), p.aoMap && (m.aoMap.value = p.aoMap, m.aoMapIntensity.value = p.aoMapIntensity, n(p.aoMap, m.aoMapTransform));
  }
  function a(m, p) {
    m.diffuse.value.copy(p.color), m.opacity.value = p.opacity, p.map && (m.map.value = p.map, n(p.map, m.mapTransform));
  }
  function s(m, p) {
    m.dashSize.value = p.dashSize, m.totalSize.value = p.dashSize + p.gapSize, m.scale.value = p.scale;
  }
  function l(m, p, y, b) {
    m.diffuse.value.copy(p.color), m.opacity.value = p.opacity, m.size.value = p.size * y, m.scale.value = b * 0.5, p.map && (m.map.value = p.map, n(p.map, m.uvTransform)), p.alphaMap && (m.alphaMap.value = p.alphaMap, n(p.alphaMap, m.alphaMapTransform)), p.alphaTest > 0 && (m.alphaTest.value = p.alphaTest);
  }
  function c(m, p) {
    m.diffuse.value.copy(p.color), m.opacity.value = p.opacity, m.rotation.value = p.rotation, p.map && (m.map.value = p.map, n(p.map, m.mapTransform)), p.alphaMap && (m.alphaMap.value = p.alphaMap, n(p.alphaMap, m.alphaMapTransform)), p.alphaTest > 0 && (m.alphaTest.value = p.alphaTest);
  }
  function u(m, p) {
    m.specular.value.copy(p.specular), m.shininess.value = Math.max(p.shininess, 1e-4);
  }
  function d(m, p) {
    p.gradientMap && (m.gradientMap.value = p.gradientMap);
  }
  function f(m, p) {
    m.metalness.value = p.metalness, p.metalnessMap && (m.metalnessMap.value = p.metalnessMap, n(p.metalnessMap, m.metalnessMapTransform)), m.roughness.value = p.roughness, p.roughnessMap && (m.roughnessMap.value = p.roughnessMap, n(p.roughnessMap, m.roughnessMapTransform)), p.envMap && (m.envMapIntensity.value = p.envMapIntensity);
  }
  function h(m, p, y) {
    m.ior.value = p.ior, p.sheen > 0 && (m.sheenColor.value.copy(p.sheenColor).multiplyScalar(p.sheen), m.sheenRoughness.value = p.sheenRoughness, p.sheenColorMap && (m.sheenColorMap.value = p.sheenColorMap, n(p.sheenColorMap, m.sheenColorMapTransform)), p.sheenRoughnessMap && (m.sheenRoughnessMap.value = p.sheenRoughnessMap, n(p.sheenRoughnessMap, m.sheenRoughnessMapTransform))), p.clearcoat > 0 && (m.clearcoat.value = p.clearcoat, m.clearcoatRoughness.value = p.clearcoatRoughness, p.clearcoatMap && (m.clearcoatMap.value = p.clearcoatMap, n(p.clearcoatMap, m.clearcoatMapTransform)), p.clearcoatRoughnessMap && (m.clearcoatRoughnessMap.value = p.clearcoatRoughnessMap, n(p.clearcoatRoughnessMap, m.clearcoatRoughnessMapTransform)), p.clearcoatNormalMap && (m.clearcoatNormalMap.value = p.clearcoatNormalMap, n(p.clearcoatNormalMap, m.clearcoatNormalMapTransform), m.clearcoatNormalScale.value.copy(p.clearcoatNormalScale), p.side === Rn && m.clearcoatNormalScale.value.negate())), p.dispersion > 0 && (m.dispersion.value = p.dispersion), p.iridescence > 0 && (m.iridescence.value = p.iridescence, m.iridescenceIOR.value = p.iridescenceIOR, m.iridescenceThicknessMinimum.value = p.iridescenceThicknessRange[0], m.iridescenceThicknessMaximum.value = p.iridescenceThicknessRange[1], p.iridescenceMap && (m.iridescenceMap.value = p.iridescenceMap, n(p.iridescenceMap, m.iridescenceMapTransform)), p.iridescenceThicknessMap && (m.iridescenceThicknessMap.value = p.iridescenceThicknessMap, n(p.iridescenceThicknessMap, m.iridescenceThicknessMapTransform))), p.transmission > 0 && (m.transmission.value = p.transmission, m.transmissionSamplerMap.value = y.texture, m.transmissionSamplerSize.value.set(y.width, y.height), p.transmissionMap && (m.transmissionMap.value = p.transmissionMap, n(p.transmissionMap, m.transmissionMapTransform)), m.thickness.value = p.thickness, p.thicknessMap && (m.thicknessMap.value = p.thicknessMap, n(p.thicknessMap, m.thicknessMapTransform)), m.attenuationDistance.value = p.attenuationDistance, m.attenuationColor.value.copy(p.attenuationColor)), p.anisotropy > 0 && (m.anisotropyVector.value.set(p.anisotropy * Math.cos(p.anisotropyRotation), p.anisotropy * Math.sin(p.anisotropyRotation)), p.anisotropyMap && (m.anisotropyMap.value = p.anisotropyMap, n(p.anisotropyMap, m.anisotropyMapTransform))), m.specularIntensity.value = p.specularIntensity, m.specularColor.value.copy(p.specularColor), p.specularColorMap && (m.specularColorMap.value = p.specularColorMap, n(p.specularColorMap, m.specularColorMapTransform)), p.specularIntensityMap && (m.specularIntensityMap.value = p.specularIntensityMap, n(p.specularIntensityMap, m.specularIntensityMapTransform));
  }
  function v(m, p) {
    p.matcap && (m.matcap.value = p.matcap);
  }
  function g(m, p) {
    const y = e.get(p).light;
    m.referencePosition.value.setFromMatrixPosition(y.matrixWorld), m.nearDistance.value = y.shadow.camera.near, m.farDistance.value = y.shadow.camera.far;
  }
  return {
    refreshFogUniforms: r,
    refreshMaterialUniforms: i
  };
}
function Aoe(t, e, n, r) {
  let i = {}, o = {}, a = [];
  const s = t.getParameter(t.MAX_UNIFORM_BUFFER_BINDINGS);
  function l(y, b) {
    const x = b.program;
    r.uniformBlockBinding(y, x);
  }
  function c(y, b) {
    let x = i[y.id];
    x === void 0 && (v(y), x = u(y), i[y.id] = x, y.addEventListener("dispose", m));
    const _ = b.program;
    r.updateUBOMapping(y, _);
    const M = e.render.frame;
    o[y.id] !== M && (f(y), o[y.id] = M);
  }
  function u(y) {
    const b = d();
    y.__bindingPointIndex = b;
    const x = t.createBuffer(), _ = y.__size, M = y.usage;
    return t.bindBuffer(t.UNIFORM_BUFFER, x), t.bufferData(t.UNIFORM_BUFFER, _, M), t.bindBuffer(t.UNIFORM_BUFFER, null), t.bindBufferBase(t.UNIFORM_BUFFER, b, x), x;
  }
  function d() {
    for (let y = 0; y < s; y++)
      if (a.indexOf(y) === -1)
        return a.push(y), y;
    return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
  }
  function f(y) {
    const b = i[y.id], x = y.uniforms, _ = y.__cache;
    t.bindBuffer(t.UNIFORM_BUFFER, b);
    for (let M = 0, S = x.length; M < S; M++) {
      const P = Array.isArray(x[M]) ? x[M] : [x[M]];
      for (let E = 0, w = P.length; E < w; E++) {
        const O = P[E];
        if (h(O, M, E, _) === !0) {
          const N = O.__offset, I = Array.isArray(O.value) ? O.value : [O.value];
          let H = 0;
          for (let j = 0; j < I.length; j++) {
            const U = I[j], $ = g(U);
            typeof U == "number" || typeof U == "boolean" ? (O.__data[0] = U, t.bufferSubData(t.UNIFORM_BUFFER, N + H, O.__data)) : U.isMatrix3 ? (O.__data[0] = U.elements[0], O.__data[1] = U.elements[1], O.__data[2] = U.elements[2], O.__data[3] = 0, O.__data[4] = U.elements[3], O.__data[5] = U.elements[4], O.__data[6] = U.elements[5], O.__data[7] = 0, O.__data[8] = U.elements[6], O.__data[9] = U.elements[7], O.__data[10] = U.elements[8], O.__data[11] = 0) : (U.toArray(O.__data, H), H += $.storage / Float32Array.BYTES_PER_ELEMENT);
          }
          t.bufferSubData(t.UNIFORM_BUFFER, N, O.__data);
        }
      }
    }
    t.bindBuffer(t.UNIFORM_BUFFER, null);
  }
  function h(y, b, x, _) {
    const M = y.value, S = b + "_" + x;
    if (_[S] === void 0)
      return typeof M == "number" || typeof M == "boolean" ? _[S] = M : _[S] = M.clone(), !0;
    {
      const P = _[S];
      if (typeof M == "number" || typeof M == "boolean") {
        if (P !== M)
          return _[S] = M, !0;
      } else if (P.equals(M) === !1)
        return P.copy(M), !0;
    }
    return !1;
  }
  function v(y) {
    const b = y.uniforms;
    let x = 0;
    const _ = 16;
    for (let S = 0, P = b.length; S < P; S++) {
      const E = Array.isArray(b[S]) ? b[S] : [b[S]];
      for (let w = 0, O = E.length; w < O; w++) {
        const N = E[w], I = Array.isArray(N.value) ? N.value : [N.value];
        for (let H = 0, j = I.length; H < j; H++) {
          const U = I[H], $ = g(U), V = x % _, te = V % $.boundary, B = V + te;
          x += te, B !== 0 && _ - B < $.storage && (x += _ - B), N.__data = new Float32Array($.storage / Float32Array.BYTES_PER_ELEMENT), N.__offset = x, x += $.storage;
        }
      }
    }
    const M = x % _;
    return M > 0 && (x += _ - M), y.__size = x, y.__cache = {}, this;
  }
  function g(y) {
    const b = {
      boundary: 0,
      // bytes
      storage: 0
      // bytes
    };
    return typeof y == "number" || typeof y == "boolean" ? (b.boundary = 4, b.storage = 4) : y.isVector2 ? (b.boundary = 8, b.storage = 8) : y.isVector3 || y.isColor ? (b.boundary = 16, b.storage = 12) : y.isVector4 ? (b.boundary = 16, b.storage = 16) : y.isMatrix3 ? (b.boundary = 48, b.storage = 48) : y.isMatrix4 ? (b.boundary = 64, b.storage = 64) : y.isTexture ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.") : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", y), b;
  }
  function m(y) {
    const b = y.target;
    b.removeEventListener("dispose", m);
    const x = a.indexOf(b.__bindingPointIndex);
    a.splice(x, 1), t.deleteBuffer(i[b.id]), delete i[b.id], delete o[b.id];
  }
  function p() {
    for (const y in i)
      t.deleteBuffer(i[y]);
    a = [], i = {}, o = {};
  }
  return {
    bind: l,
    update: c,
    dispose: p
  };
}
class Poe {
  /**
   * Constructs a new WebGL renderer.
   *
   * @param {WebGLRenderer~Options} [parameters] - The configuration parameter.
   */
  constructor(e = {}) {
    const {
      canvas: n = uee(),
      context: r = null,
      depth: i = !0,
      stencil: o = !1,
      alpha: a = !1,
      antialias: s = !1,
      premultipliedAlpha: l = !0,
      preserveDrawingBuffer: c = !1,
      powerPreference: u = "default",
      failIfMajorPerformanceCaveat: d = !1,
      reverseDepthBuffer: f = !1
    } = e;
    this.isWebGLRenderer = !0;
    let h;
    if (r !== null) {
      if (typeof WebGLRenderingContext < "u" && r instanceof WebGLRenderingContext)
        throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
      h = r.getContextAttributes().alpha;
    } else
      h = a;
    const v = new Uint32Array(4), g = new Int32Array(4);
    let m = null, p = null;
    const y = [], b = [];
    this.domElement = n, this.debug = {
      /**
       * Enables error checking and reporting when shader programs are being compiled.
       * @type {boolean}
       */
      checkShaderErrors: !0,
      /**
       * Callback for custom error reporting.
       * @type {?Function}
       */
      onShaderError: null
    }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.toneMapping = Bi, this.toneMappingExposure = 1, this.transmissionResolutionScale = 1;
    const x = this;
    let _ = !1;
    this._outputColorSpace = er;
    let M = 0, S = 0, P = null, E = -1, w = null;
    const O = new Yt(), N = new Yt();
    let I = null;
    const H = new At(0);
    let j = 0, U = n.width, $ = n.height, V = 1, te = null, B = null;
    const Z = new Yt(0, 0, U, $), Q = new Yt(0, 0, U, $);
    let ce = !1;
    const k = new R2();
    let G = !1, K = !1;
    const J = new qt(), se = new qt(), be = new re(), pe = new Yt(), Ne = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: !0 };
    let ae = !1;
    function Re() {
      return P === null ? V : 1;
    }
    let F = r;
    function Ge(L, q) {
      return n.getContext(L, q);
    }
    try {
      const L = {
        alpha: !0,
        depth: i,
        stencil: o,
        antialias: s,
        premultipliedAlpha: l,
        preserveDrawingBuffer: c,
        powerPreference: u,
        failIfMajorPerformanceCaveat: d
      };
      if ("setAttribute" in n && n.setAttribute("data-engine", `three.js r${b2}`), n.addEventListener("webglcontextlost", me, !1), n.addEventListener("webglcontextrestored", Oe, !1), n.addEventListener("webglcontextcreationerror", Ae, !1), F === null) {
        const q = "webgl2";
        if (F = Ge(q, L), F === null)
          throw Ge(q) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
      }
    } catch (L) {
      throw console.error("THREE.WebGLRenderer: " + L.message), L;
    }
    let $e, he, ue, Se, we, D, T, Y, fe, de, ne, Le, Ce, Te, ke, ge, Ee, Be, We, Fe, qe, Ye, Je, W;
    function ye() {
      $e = new zre(F), $e.init(), Ye = new woe(F, $e), he = new Ore(F, $e, e, Ye), ue = new boe(F, $e), he.reverseDepthBuffer && f && ue.buffers.depth.setReversed(!0), Se = new Vre(F), we = new aoe(), D = new xoe(F, $e, ue, we, he, Ye, Se), T = new kre(x), Y = new Ure(x), fe = new Xee(F), Je = new Rre(F, fe), de = new Hre(F, fe, Se, Je), ne = new Wre(F, de, fe, Se), We = new $re(F, he, D), ge = new Dre(we), Le = new ooe(x, T, Y, $e, he, Je, ge), Ce = new Toe(x, we), Te = new loe(), ke = new poe($e), Be = new Pre(x, T, Y, ue, ne, h, l), Ee = new goe(x, ne, he), W = new Aoe(F, Se, he, ue), Fe = new Lre(F, $e, Se), qe = new Bre(F, $e, Se), Se.programs = Le.programs, x.capabilities = he, x.extensions = $e, x.properties = we, x.renderLists = Te, x.shadowMap = Ee, x.state = ue, x.info = Se;
    }
    ye();
    const oe = new Soe(x, F);
    this.xr = oe, this.getContext = function() {
      return F;
    }, this.getContextAttributes = function() {
      return F.getContextAttributes();
    }, this.forceContextLoss = function() {
      const L = $e.get("WEBGL_lose_context");
      L && L.loseContext();
    }, this.forceContextRestore = function() {
      const L = $e.get("WEBGL_lose_context");
      L && L.restoreContext();
    }, this.getPixelRatio = function() {
      return V;
    }, this.setPixelRatio = function(L) {
      L !== void 0 && (V = L, this.setSize(U, $, !1));
    }, this.getSize = function(L) {
      return L.set(U, $);
    }, this.setSize = function(L, q, ie = !0) {
      if (oe.isPresenting) {
        console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
        return;
      }
      U = L, $ = q, n.width = Math.floor(L * V), n.height = Math.floor(q * V), ie === !0 && (n.style.width = L + "px", n.style.height = q + "px"), this.setViewport(0, 0, L, q);
    }, this.getDrawingBufferSize = function(L) {
      return L.set(U * V, $ * V).floor();
    }, this.setDrawingBufferSize = function(L, q, ie) {
      U = L, $ = q, V = ie, n.width = Math.floor(L * ie), n.height = Math.floor(q * ie), this.setViewport(0, 0, L, q);
    }, this.getCurrentViewport = function(L) {
      return L.copy(O);
    }, this.getViewport = function(L) {
      return L.copy(Z);
    }, this.setViewport = function(L, q, ie, ee) {
      L.isVector4 ? Z.set(L.x, L.y, L.z, L.w) : Z.set(L, q, ie, ee), ue.viewport(O.copy(Z).multiplyScalar(V).round());
    }, this.getScissor = function(L) {
      return L.copy(Q);
    }, this.setScissor = function(L, q, ie, ee) {
      L.isVector4 ? Q.set(L.x, L.y, L.z, L.w) : Q.set(L, q, ie, ee), ue.scissor(N.copy(Q).multiplyScalar(V).round());
    }, this.getScissorTest = function() {
      return ce;
    }, this.setScissorTest = function(L) {
      ue.setScissorTest(ce = L);
    }, this.setOpaqueSort = function(L) {
      te = L;
    }, this.setTransparentSort = function(L) {
      B = L;
    }, this.getClearColor = function(L) {
      return L.copy(Be.getClearColor());
    }, this.setClearColor = function() {
      Be.setClearColor(...arguments);
    }, this.getClearAlpha = function() {
      return Be.getClearAlpha();
    }, this.setClearAlpha = function() {
      Be.setClearAlpha(...arguments);
    }, this.clear = function(L = !0, q = !0, ie = !0) {
      let ee = 0;
      if (L) {
        let X = !1;
        if (P !== null) {
          const _e = P.texture.format;
          X = _e === S2 || _e === E2 || _e === C2;
        }
        if (X) {
          const _e = P.texture.type, Ie = _e === di || _e === Uo || _e === Nl || _e === Il || _e === w2 || _e === _2, Ue = Be.getClearColor(), ze = Be.getClearAlpha(), nt = Ue.r, et = Ue.g, Ve = Ue.b;
          Ie ? (v[0] = nt, v[1] = et, v[2] = Ve, v[3] = ze, F.clearBufferuiv(F.COLOR, 0, v)) : (g[0] = nt, g[1] = et, g[2] = Ve, g[3] = ze, F.clearBufferiv(F.COLOR, 0, g));
        } else
          ee |= F.COLOR_BUFFER_BIT;
      }
      q && (ee |= F.DEPTH_BUFFER_BIT), ie && (ee |= F.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), F.clear(ee);
    }, this.clearColor = function() {
      this.clear(!0, !1, !1);
    }, this.clearDepth = function() {
      this.clear(!1, !0, !1);
    }, this.clearStencil = function() {
      this.clear(!1, !1, !0);
    }, this.dispose = function() {
      n.removeEventListener("webglcontextlost", me, !1), n.removeEventListener("webglcontextrestored", Oe, !1), n.removeEventListener("webglcontextcreationerror", Ae, !1), Be.dispose(), Te.dispose(), ke.dispose(), we.dispose(), T.dispose(), Y.dispose(), ne.dispose(), Je.dispose(), W.dispose(), Le.dispose(), oe.dispose(), oe.removeEventListener("sessionstart", yc), oe.removeEventListener("sessionend", Ds), Wr.stop();
    };
    function me(L) {
      L.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), _ = !0;
    }
    function Oe() {
      console.log("THREE.WebGLRenderer: Context Restored."), _ = !1;
      const L = Se.autoReset, q = Ee.enabled, ie = Ee.autoUpdate, ee = Ee.needsUpdate, X = Ee.type;
      ye(), Se.autoReset = L, Ee.enabled = q, Ee.autoUpdate = ie, Ee.needsUpdate = ee, Ee.type = X;
    }
    function Ae(L) {
      console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", L.statusMessage);
    }
    function Qe(L) {
      const q = L.target;
      q.removeEventListener("dispose", Qe), Nt(q);
    }
    function Nt(L) {
      on(L), we.remove(L);
    }
    function on(L) {
      const q = we.get(L).programs;
      q !== void 0 && (q.forEach(function(ie) {
        Le.releaseProgram(ie);
      }), L.isShaderMaterial && Le.releaseShaderCache(L));
    }
    this.renderBufferDirect = function(L, q, ie, ee, X, _e) {
      q === null && (q = Ne);
      const Ie = X.isMesh && X.matrixWorld.determinant() < 0, Ue = Et(L, q, ie, ee, X);
      ue.setMaterial(ee, Ie);
      let ze = ie.index, nt = 1;
      if (ee.wireframe === !0) {
        if (ze = de.getWireframeAttribute(ie), ze === void 0)
          return;
        nt = 2;
      }
      const et = ie.drawRange, Ve = ie.attributes.position;
      let pt = et.start * nt, bt = (et.start + et.count) * nt;
      _e !== null && (pt = Math.max(pt, _e.start * nt), bt = Math.min(bt, (_e.start + _e.count) * nt)), ze !== null ? (pt = Math.max(pt, 0), bt = Math.min(bt, ze.count)) : Ve != null && (pt = Math.max(pt, 0), bt = Math.min(bt, Ve.count));
      const Kt = bt - pt;
      if (Kt < 0 || Kt === 1 / 0)
        return;
      Je.setup(X, ee, Ue, ie, ze);
      let jt, gt = Fe;
      if (ze !== null && (jt = fe.get(ze), gt = qe, gt.setIndex(jt)), X.isMesh)
        ee.wireframe === !0 ? (ue.setLineWidth(ee.wireframeLinewidth * Re()), gt.setMode(F.LINES)) : gt.setMode(F.TRIANGLES);
      else if (X.isLine) {
        let je = ee.linewidth;
        je === void 0 && (je = 1), ue.setLineWidth(je * Re()), X.isLineSegments ? gt.setMode(F.LINES) : X.isLineLoop ? gt.setMode(F.LINE_LOOP) : gt.setMode(F.LINE_STRIP);
      } else
        X.isPoints ? gt.setMode(F.POINTS) : X.isSprite && gt.setMode(F.TRIANGLES);
      if (X.isBatchedMesh)
        if (X._multiDrawInstances !== null)
          Au("THREE.WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection."), gt.renderMultiDrawInstances(X._multiDrawStarts, X._multiDrawCounts, X._multiDrawCount, X._multiDrawInstances);
        else if ($e.get("WEBGL_multi_draw"))
          gt.renderMultiDraw(X._multiDrawStarts, X._multiDrawCounts, X._multiDrawCount);
        else {
          const je = X._multiDrawStarts, dn = X._multiDrawCounts, xt = X._multiDrawCount, ur = ze ? fe.get(ze).bytesPerElement : 1, Jo = we.get(ee).currentProgram.getUniforms();
          for (let In = 0; In < xt; In++)
            Jo.setValue(F, "_gl_DrawID", In), gt.render(je[In] / ur, dn[In]);
        }
      else if (X.isInstancedMesh)
        gt.renderInstances(pt, Kt, X.count);
      else if (ie.isInstancedBufferGeometry) {
        const je = ie._maxInstanceCount !== void 0 ? ie._maxInstanceCount : 1 / 0, dn = Math.min(ie.instanceCount, je);
        gt.renderInstances(pt, Kt, dn);
      } else
        gt.render(pt, Kt);
    };
    function vt(L, q, ie) {
      L.transparent === !0 && L.side === ei && L.forceSinglePass === !1 ? (L.side = Rn, L.needsUpdate = !0, Pe(L, q, ie), L.side = Ji, L.needsUpdate = !0, Pe(L, q, ie), L.side = ei) : Pe(L, q, ie);
    }
    this.compile = function(L, q, ie = null) {
      ie === null && (ie = L), p = ke.get(ie), p.init(q), b.push(p), ie.traverseVisible(function(X) {
        X.isLight && X.layers.test(q.layers) && (p.pushLight(X), X.castShadow && p.pushShadow(X));
      }), L !== ie && L.traverseVisible(function(X) {
        X.isLight && X.layers.test(q.layers) && (p.pushLight(X), X.castShadow && p.pushShadow(X));
      }), p.setupLights();
      const ee = /* @__PURE__ */ new Set();
      return L.traverse(function(X) {
        if (!(X.isMesh || X.isPoints || X.isLine || X.isSprite))
          return;
        const _e = X.material;
        if (_e)
          if (Array.isArray(_e))
            for (let Ie = 0; Ie < _e.length; Ie++) {
              const Ue = _e[Ie];
              vt(Ue, ie, X), ee.add(Ue);
            }
          else
            vt(_e, ie, X), ee.add(_e);
      }), p = b.pop(), ee;
    }, this.compileAsync = function(L, q, ie = null) {
      const ee = this.compile(L, q, ie);
      return new Promise((X) => {
        function _e() {
          if (ee.forEach(function(Ie) {
            we.get(Ie).currentProgram.isReady() && ee.delete(Ie);
          }), ee.size === 0) {
            X(L);
            return;
          }
          setTimeout(_e, 10);
        }
        $e.get("KHR_parallel_shader_compile") !== null ? _e() : setTimeout(_e, 10);
      });
    };
    let Sn = null;
    function cr(L) {
      Sn && Sn(L);
    }
    function yc() {
      Wr.stop();
    }
    function Ds() {
      Wr.start();
    }
    const Wr = new V9();
    Wr.setAnimationLoop(cr), typeof self < "u" && Wr.setContext(self), this.setAnimationLoop = function(L) {
      Sn = L, oe.setAnimationLoop(L), L === null ? Wr.stop() : Wr.start();
    }, oe.addEventListener("sessionstart", yc), oe.addEventListener("sessionend", Ds), this.render = function(L, q) {
      if (q !== void 0 && q.isCamera !== !0) {
        console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
        return;
      }
      if (_ === !0)
        return;
      if (L.matrixWorldAutoUpdate === !0 && L.updateMatrixWorld(), q.parent === null && q.matrixWorldAutoUpdate === !0 && q.updateMatrixWorld(), oe.enabled === !0 && oe.isPresenting === !0 && (oe.cameraAutoUpdate === !0 && oe.updateCamera(q), q = oe.getCamera()), L.isScene === !0 && L.onBeforeRender(x, L, q, P), p = ke.get(L, b.length), p.init(q), b.push(p), se.multiplyMatrices(q.projectionMatrix, q.matrixWorldInverse), k.setFromProjectionMatrix(se), K = this.localClippingEnabled, G = ge.init(this.clippingPlanes, K), m = Te.get(L, y.length), m.init(), y.push(m), oe.enabled === !0 && oe.isPresenting === !0) {
        const _e = x.xr.getDepthSensingMesh();
        _e !== null && ks(_e, q, -1 / 0, x.sortObjects);
      }
      ks(L, q, 0, x.sortObjects), m.finish(), x.sortObjects === !0 && m.sort(te, B), ae = oe.enabled === !1 || oe.isPresenting === !1 || oe.hasDepthSensing() === !1, ae && Be.addToRenderList(m, L), this.info.render.frame++, G === !0 && ge.beginShadows();
      const ie = p.state.shadowsArray;
      Ee.render(ie, L, q), G === !0 && ge.endShadows(), this.info.autoReset === !0 && this.info.reset();
      const ee = m.opaque, X = m.transmissive;
      if (p.setupLights(), q.isArrayCamera) {
        const _e = q.cameras;
        if (X.length > 0)
          for (let Ie = 0, Ue = _e.length; Ie < Ue; Ie++) {
            const ze = _e[Ie];
            xc(ee, X, L, ze);
          }
        ae && Be.render(L);
        for (let Ie = 0, Ue = _e.length; Ie < Ue; Ie++) {
          const ze = _e[Ie];
          bc(m, L, ze, ze.viewport);
        }
      } else
        X.length > 0 && xc(ee, X, L, q), ae && Be.render(L), bc(m, L, q);
      P !== null && S === 0 && (D.updateMultisampleRenderTarget(P), D.updateRenderTargetMipmap(P)), L.isScene === !0 && L.onAfterRender(x, L, q), Je.resetDefaultState(), E = -1, w = null, b.pop(), b.length > 0 ? (p = b[b.length - 1], G === !0 && ge.setGlobalState(x.clippingPlanes, p.state.camera)) : p = null, y.pop(), y.length > 0 ? m = y[y.length - 1] : m = null;
    };
    function ks(L, q, ie, ee) {
      if (L.visible === !1)
        return;
      if (L.layers.test(q.layers)) {
        if (L.isGroup)
          ie = L.renderOrder;
        else if (L.isLOD)
          L.autoUpdate === !0 && L.update(q);
        else if (L.isLight)
          p.pushLight(L), L.castShadow && p.pushShadow(L);
        else if (L.isSprite) {
          if (!L.frustumCulled || k.intersectsSprite(L)) {
            ee && pe.setFromMatrixPosition(L.matrixWorld).applyMatrix4(se);
            const Ie = ne.update(L), Ue = L.material;
            Ue.visible && m.push(L, Ie, Ue, ie, pe.z, null);
          }
        } else if ((L.isMesh || L.isLine || L.isPoints) && (!L.frustumCulled || k.intersectsObject(L))) {
          const Ie = ne.update(L), Ue = L.material;
          if (ee && (L.boundingSphere !== void 0 ? (L.boundingSphere === null && L.computeBoundingSphere(), pe.copy(L.boundingSphere.center)) : (Ie.boundingSphere === null && Ie.computeBoundingSphere(), pe.copy(Ie.boundingSphere.center)), pe.applyMatrix4(L.matrixWorld).applyMatrix4(se)), Array.isArray(Ue)) {
            const ze = Ie.groups;
            for (let nt = 0, et = ze.length; nt < et; nt++) {
              const Ve = ze[nt], pt = Ue[Ve.materialIndex];
              pt && pt.visible && m.push(L, Ie, pt, ie, pe.z, Ve);
            }
          } else
            Ue.visible && m.push(L, Ie, Ue, ie, pe.z, null);
        }
      }
      const _e = L.children;
      for (let Ie = 0, Ue = _e.length; Ie < Ue; Ie++)
        ks(_e[Ie], q, ie, ee);
    }
    function bc(L, q, ie, ee) {
      const X = L.opaque, _e = L.transmissive, Ie = L.transparent;
      p.setupLightsView(ie), G === !0 && ge.setGlobalState(x.clippingPlanes, ie), ee && ue.viewport(O.copy(ee)), X.length > 0 && z(X, q, ie), _e.length > 0 && z(_e, q, ie), Ie.length > 0 && z(Ie, q, ie), ue.buffers.depth.setTest(!0), ue.buffers.depth.setMask(!0), ue.buffers.color.setMask(!0), ue.setPolygonOffset(!1);
    }
    function xc(L, q, ie, ee) {
      if ((ie.isScene === !0 ? ie.overrideMaterial : null) !== null)
        return;
      p.state.transmissionRenderTarget[ee.id] === void 0 && (p.state.transmissionRenderTarget[ee.id] = new Qi(1, 1, {
        generateMipmaps: !0,
        type: $e.has("EXT_color_buffer_half_float") || $e.has("EXT_color_buffer_float") ? lc : di,
        minFilter: Ui,
        samples: 4,
        stencilBuffer: o,
        resolveDepthBuffer: !1,
        resolveStencilBuffer: !1,
        colorSpace: mt.workingColorSpace
      }));
      const _e = p.state.transmissionRenderTarget[ee.id], Ie = ee.viewport || O;
      _e.setSize(Ie.z * x.transmissionResolutionScale, Ie.w * x.transmissionResolutionScale);
      const Ue = x.getRenderTarget();
      x.setRenderTarget(_e), x.getClearColor(H), j = x.getClearAlpha(), j < 1 && x.setClearColor(16777215, 0.5), x.clear(), ae && Be.render(ie);
      const ze = x.toneMapping;
      x.toneMapping = Bi;
      const nt = ee.viewport;
      if (ee.viewport !== void 0 && (ee.viewport = void 0), p.setupLightsView(ee), G === !0 && ge.setGlobalState(x.clippingPlanes, ee), z(L, ie, ee), D.updateMultisampleRenderTarget(_e), D.updateRenderTargetMipmap(_e), $e.has("WEBGL_multisampled_render_to_texture") === !1) {
        let et = !1;
        for (let Ve = 0, pt = q.length; Ve < pt; Ve++) {
          const bt = q[Ve], Kt = bt.object, jt = bt.geometry, gt = bt.material, je = bt.group;
          if (gt.side === ei && Kt.layers.test(ee.layers)) {
            const dn = gt.side;
            gt.side = Rn, gt.needsUpdate = !0, xe(Kt, ie, ee, jt, gt, je), gt.side = dn, gt.needsUpdate = !0, et = !0;
          }
        }
        et === !0 && (D.updateMultisampleRenderTarget(_e), D.updateRenderTargetMipmap(_e));
      }
      x.setRenderTarget(Ue), x.setClearColor(H, j), nt !== void 0 && (ee.viewport = nt), x.toneMapping = ze;
    }
    function z(L, q, ie) {
      const ee = q.isScene === !0 ? q.overrideMaterial : null;
      for (let X = 0, _e = L.length; X < _e; X++) {
        const Ie = L[X], Ue = Ie.object, ze = Ie.geometry, nt = Ie.group;
        let et = Ie.material;
        et.allowOverride === !0 && ee !== null && (et = ee), Ue.layers.test(ie.layers) && xe(Ue, q, ie, ze, et, nt);
      }
    }
    function xe(L, q, ie, ee, X, _e) {
      L.onBeforeRender(x, q, ie, ee, X, _e), L.modelViewMatrix.multiplyMatrices(ie.matrixWorldInverse, L.matrixWorld), L.normalMatrix.getNormalMatrix(L.modelViewMatrix), X.onBeforeRender(x, q, ie, ee, L, _e), X.transparent === !0 && X.side === ei && X.forceSinglePass === !1 ? (X.side = Rn, X.needsUpdate = !0, x.renderBufferDirect(ie, q, ee, X, L, _e), X.side = Ji, X.needsUpdate = !0, x.renderBufferDirect(ie, q, ee, X, L, _e), X.side = ei) : x.renderBufferDirect(ie, q, ee, X, L, _e), L.onAfterRender(x, q, ie, ee, X, _e);
    }
    function Pe(L, q, ie) {
      q.isScene !== !0 && (q = Ne);
      const ee = we.get(L), X = p.state.lights, _e = p.state.shadowsArray, Ie = X.state.version, Ue = Le.getParameters(L, X.state, _e, q, ie), ze = Le.getProgramCacheKey(Ue);
      let nt = ee.programs;
      ee.environment = L.isMeshStandardMaterial ? q.environment : null, ee.fog = q.fog, ee.envMap = (L.isMeshStandardMaterial ? Y : T).get(L.envMap || ee.environment), ee.envMapRotation = ee.environment !== null && L.envMap === null ? q.environmentRotation : L.envMapRotation, nt === void 0 && (L.addEventListener("dispose", Qe), nt = /* @__PURE__ */ new Map(), ee.programs = nt);
      let et = nt.get(ze);
      if (et !== void 0) {
        if (ee.currentProgram === et && ee.lightsStateVersion === Ie)
          return ht(L, Ue), et;
      } else
        Ue.uniforms = Le.getUniforms(L), L.onBeforeCompile(Ue, x), et = Le.acquireProgram(Ue, ze), nt.set(ze, et), ee.uniforms = Ue.uniforms;
      const Ve = ee.uniforms;
      return (!L.isShaderMaterial && !L.isRawShaderMaterial || L.clipping === !0) && (Ve.clippingPlanes = ge.uniform), ht(L, Ue), ee.needsLights = lt(L), ee.lightsStateVersion = Ie, ee.needsLights && (Ve.ambientLightColor.value = X.state.ambient, Ve.lightProbe.value = X.state.probe, Ve.directionalLights.value = X.state.directional, Ve.directionalLightShadows.value = X.state.directionalShadow, Ve.spotLights.value = X.state.spot, Ve.spotLightShadows.value = X.state.spotShadow, Ve.rectAreaLights.value = X.state.rectArea, Ve.ltc_1.value = X.state.rectAreaLTC1, Ve.ltc_2.value = X.state.rectAreaLTC2, Ve.pointLights.value = X.state.point, Ve.pointLightShadows.value = X.state.pointShadow, Ve.hemisphereLights.value = X.state.hemi, Ve.directionalShadowMap.value = X.state.directionalShadowMap, Ve.directionalShadowMatrix.value = X.state.directionalShadowMatrix, Ve.spotShadowMap.value = X.state.spotShadowMap, Ve.spotLightMatrix.value = X.state.spotLightMatrix, Ve.spotLightMap.value = X.state.spotLightMap, Ve.pointShadowMap.value = X.state.pointShadowMap, Ve.pointShadowMatrix.value = X.state.pointShadowMatrix), ee.currentProgram = et, ee.uniformsList = null, et;
    }
    function Ze(L) {
      if (L.uniformsList === null) {
        const q = L.currentProgram.getUniforms();
        L.uniformsList = Pu.seqWithValue(q.seq, L.uniforms);
      }
      return L.uniformsList;
    }
    function ht(L, q) {
      const ie = we.get(L);
      ie.outputColorSpace = q.outputColorSpace, ie.batching = q.batching, ie.batchingColor = q.batchingColor, ie.instancing = q.instancing, ie.instancingColor = q.instancingColor, ie.instancingMorph = q.instancingMorph, ie.skinning = q.skinning, ie.morphTargets = q.morphTargets, ie.morphNormals = q.morphNormals, ie.morphColors = q.morphColors, ie.morphTargetsCount = q.morphTargetsCount, ie.numClippingPlanes = q.numClippingPlanes, ie.numIntersection = q.numClipIntersection, ie.vertexAlphas = q.vertexAlphas, ie.vertexTangents = q.vertexTangents, ie.toneMapping = q.toneMapping;
    }
    function Et(L, q, ie, ee, X) {
      q.isScene !== !0 && (q = Ne), D.resetTextureUnits();
      const _e = q.fog, Ie = ee.isMeshStandardMaterial ? q.environment : null, Ue = P === null ? x.outputColorSpace : P.isXRRenderTarget === !0 ? P.texture.colorSpace : zo, ze = (ee.isMeshStandardMaterial ? Y : T).get(ee.envMap || Ie), nt = ee.vertexColors === !0 && !!ie.attributes.color && ie.attributes.color.itemSize === 4, et = !!ie.attributes.tangent && (!!ee.normalMap || ee.anisotropy > 0), Ve = !!ie.morphAttributes.position, pt = !!ie.morphAttributes.normal, bt = !!ie.morphAttributes.color;
      let Kt = Bi;
      ee.toneMapped && (P === null || P.isXRRenderTarget === !0) && (Kt = x.toneMapping);
      const jt = ie.morphAttributes.position || ie.morphAttributes.normal || ie.morphAttributes.color, gt = jt !== void 0 ? jt.length : 0, je = we.get(ee), dn = p.state.lights;
      if (G === !0 && (K === !0 || L !== w)) {
        const xn = L === w && ee.id === E;
        ge.setState(ee, L, xn);
      }
      let xt = !1;
      ee.version === je.__version ? (je.needsLights && je.lightsStateVersion !== dn.state.version || je.outputColorSpace !== Ue || X.isBatchedMesh && je.batching === !1 || !X.isBatchedMesh && je.batching === !0 || X.isBatchedMesh && je.batchingColor === !0 && X.colorTexture === null || X.isBatchedMesh && je.batchingColor === !1 && X.colorTexture !== null || X.isInstancedMesh && je.instancing === !1 || !X.isInstancedMesh && je.instancing === !0 || X.isSkinnedMesh && je.skinning === !1 || !X.isSkinnedMesh && je.skinning === !0 || X.isInstancedMesh && je.instancingColor === !0 && X.instanceColor === null || X.isInstancedMesh && je.instancingColor === !1 && X.instanceColor !== null || X.isInstancedMesh && je.instancingMorph === !0 && X.morphTexture === null || X.isInstancedMesh && je.instancingMorph === !1 && X.morphTexture !== null || je.envMap !== ze || ee.fog === !0 && je.fog !== _e || je.numClippingPlanes !== void 0 && (je.numClippingPlanes !== ge.numPlanes || je.numIntersection !== ge.numIntersection) || je.vertexAlphas !== nt || je.vertexTangents !== et || je.morphTargets !== Ve || je.morphNormals !== pt || je.morphColors !== bt || je.toneMapping !== Kt || je.morphTargetsCount !== gt) && (xt = !0) : (xt = !0, je.__version = ee.version);
      let ur = je.currentProgram;
      xt === !0 && (ur = Pe(ee, q, X));
      let Jo = !1, In = !1, Ns = !1;
      const Ht = ur.getUniforms(), Zn = je.uniforms;
      if (ue.useProgram(ur.program) && (Jo = !0, In = !0, Ns = !0), ee.id !== E && (E = ee.id, In = !0), Jo || w !== L) {
        ue.buffers.depth.getReversed() ? (J.copy(L.projectionMatrix), fee(J), hee(J), Ht.setValue(F, "projectionMatrix", J)) : Ht.setValue(F, "projectionMatrix", L.projectionMatrix), Ht.setValue(F, "viewMatrix", L.matrixWorldInverse);
        const Mn = Ht.map.cameraPosition;
        Mn !== void 0 && Mn.setValue(F, be.setFromMatrixPosition(L.matrixWorld)), he.logarithmicDepthBuffer && Ht.setValue(
          F,
          "logDepthBufFC",
          2 / (Math.log(L.far + 1) / Math.LN2)
        ), (ee.isMeshPhongMaterial || ee.isMeshToonMaterial || ee.isMeshLambertMaterial || ee.isMeshBasicMaterial || ee.isMeshStandardMaterial || ee.isShaderMaterial) && Ht.setValue(F, "isOrthographic", L.isOrthographicCamera === !0), w !== L && (w = L, In = !0, Ns = !0);
      }
      if (X.isSkinnedMesh) {
        Ht.setOptional(F, X, "bindMatrix"), Ht.setOptional(F, X, "bindMatrixInverse");
        const xn = X.skeleton;
        xn && (xn.boneTexture === null && xn.computeBoneTexture(), Ht.setValue(F, "boneTexture", xn.boneTexture, D));
      }
      X.isBatchedMesh && (Ht.setOptional(F, X, "batchingTexture"), Ht.setValue(F, "batchingTexture", X._matricesTexture, D), Ht.setOptional(F, X, "batchingIdTexture"), Ht.setValue(F, "batchingIdTexture", X._indirectTexture, D), Ht.setOptional(F, X, "batchingColorTexture"), X._colorsTexture !== null && Ht.setValue(F, "batchingColorTexture", X._colorsTexture, D));
      const Kn = ie.morphAttributes;
      if ((Kn.position !== void 0 || Kn.normal !== void 0 || Kn.color !== void 0) && We.update(X, ie, ur), (In || je.receiveShadow !== X.receiveShadow) && (je.receiveShadow = X.receiveShadow, Ht.setValue(F, "receiveShadow", X.receiveShadow)), ee.isMeshGouraudMaterial && ee.envMap !== null && (Zn.envMap.value = ze, Zn.flipEnvMap.value = ze.isCubeTexture && ze.isRenderTargetTexture === !1 ? -1 : 1), ee.isMeshStandardMaterial && ee.envMap === null && q.environment !== null && (Zn.envMapIntensity.value = q.environmentIntensity), In && (Ht.setValue(F, "toneMappingExposure", x.toneMappingExposure), je.needsLights && ut(Zn, Ns), _e && ee.fog === !0 && Ce.refreshFogUniforms(Zn, _e), Ce.refreshMaterialUniforms(Zn, ee, V, $, p.state.transmissionRenderTarget[L.id]), Pu.upload(F, Ze(je), Zn, D)), ee.isShaderMaterial && ee.uniformsNeedUpdate === !0 && (Pu.upload(F, Ze(je), Zn, D), ee.uniformsNeedUpdate = !1), ee.isSpriteMaterial && Ht.setValue(F, "center", X.center), Ht.setValue(F, "modelViewMatrix", X.modelViewMatrix), Ht.setValue(F, "normalMatrix", X.normalMatrix), Ht.setValue(F, "modelMatrix", X.matrixWorld), ee.isShaderMaterial || ee.isRawShaderMaterial) {
        const xn = ee.uniformsGroups;
        for (let Mn = 0, Ef = xn.length; Mn < Ef; Mn++) {
          const uo = xn[Mn];
          W.update(uo, ur), W.bind(uo, ur);
        }
      }
      return ur;
    }
    function ut(L, q) {
      L.ambientLightColor.needsUpdate = q, L.lightProbe.needsUpdate = q, L.directionalLights.needsUpdate = q, L.directionalLightShadows.needsUpdate = q, L.pointLights.needsUpdate = q, L.pointLightShadows.needsUpdate = q, L.spotLights.needsUpdate = q, L.spotLightShadows.needsUpdate = q, L.rectAreaLights.needsUpdate = q, L.hemisphereLights.needsUpdate = q;
    }
    function lt(L) {
      return L.isMeshLambertMaterial || L.isMeshToonMaterial || L.isMeshPhongMaterial || L.isMeshStandardMaterial || L.isShadowMaterial || L.isShaderMaterial && L.lights === !0;
    }
    this.getActiveCubeFace = function() {
      return M;
    }, this.getActiveMipmapLevel = function() {
      return S;
    }, this.getRenderTarget = function() {
      return P;
    }, this.setRenderTargetTextures = function(L, q, ie) {
      const ee = we.get(L);
      ee.__autoAllocateDepthBuffer = L.resolveDepthBuffer === !1, ee.__autoAllocateDepthBuffer === !1 && (ee.__useRenderToTexture = !1), we.get(L.texture).__webglTexture = q, we.get(L.depthTexture).__webglTexture = ee.__autoAllocateDepthBuffer ? void 0 : ie, ee.__hasExternalTextures = !0;
    }, this.setRenderTargetFramebuffer = function(L, q) {
      const ie = we.get(L);
      ie.__webglFramebuffer = q, ie.__useDefaultFramebuffer = q === void 0;
    };
    const un = F.createFramebuffer();
    this.setRenderTarget = function(L, q = 0, ie = 0) {
      P = L, M = q, S = ie;
      let ee = !0, X = null, _e = !1, Ie = !1;
      if (L) {
        const ze = we.get(L);
        if (ze.__useDefaultFramebuffer !== void 0)
          ue.bindFramebuffer(F.FRAMEBUFFER, null), ee = !1;
        else if (ze.__webglFramebuffer === void 0)
          D.setupRenderTarget(L);
        else if (ze.__hasExternalTextures)
          D.rebindTextures(L, we.get(L.texture).__webglTexture, we.get(L.depthTexture).__webglTexture);
        else if (L.depthBuffer) {
          const Ve = L.depthTexture;
          if (ze.__boundDepthTexture !== Ve) {
            if (Ve !== null && we.has(Ve) && (L.width !== Ve.image.width || L.height !== Ve.image.height))
              throw new Error("WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.");
            D.setupDepthRenderbuffer(L);
          }
        }
        const nt = L.texture;
        (nt.isData3DTexture || nt.isDataArrayTexture || nt.isCompressedArrayTexture) && (Ie = !0);
        const et = we.get(L).__webglFramebuffer;
        L.isWebGLCubeRenderTarget ? (Array.isArray(et[q]) ? X = et[q][ie] : X = et[q], _e = !0) : L.samples > 0 && D.useMultisampledRTT(L) === !1 ? X = we.get(L).__webglMultisampledFramebuffer : Array.isArray(et) ? X = et[ie] : X = et, O.copy(L.viewport), N.copy(L.scissor), I = L.scissorTest;
      } else
        O.copy(Z).multiplyScalar(V).floor(), N.copy(Q).multiplyScalar(V).floor(), I = ce;
      if (ie !== 0 && (X = un), ue.bindFramebuffer(F.FRAMEBUFFER, X) && ee && ue.drawBuffers(L, X), ue.viewport(O), ue.scissor(N), ue.setScissorTest(I), _e) {
        const ze = we.get(L.texture);
        F.framebufferTexture2D(F.FRAMEBUFFER, F.COLOR_ATTACHMENT0, F.TEXTURE_CUBE_MAP_POSITIVE_X + q, ze.__webglTexture, ie);
      } else if (Ie) {
        const ze = we.get(L.texture), nt = q;
        F.framebufferTextureLayer(F.FRAMEBUFFER, F.COLOR_ATTACHMENT0, ze.__webglTexture, ie, nt);
      } else if (L !== null && ie !== 0) {
        const ze = we.get(L.texture);
        F.framebufferTexture2D(F.FRAMEBUFFER, F.COLOR_ATTACHMENT0, F.TEXTURE_2D, ze.__webglTexture, ie);
      }
      E = -1;
    }, this.readRenderTargetPixels = function(L, q, ie, ee, X, _e, Ie) {
      if (!(L && L.isWebGLRenderTarget)) {
        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
        return;
      }
      let Ue = we.get(L).__webglFramebuffer;
      if (L.isWebGLCubeRenderTarget && Ie !== void 0 && (Ue = Ue[Ie]), Ue) {
        ue.bindFramebuffer(F.FRAMEBUFFER, Ue);
        try {
          const ze = L.texture, nt = ze.format, et = ze.type;
          if (!he.textureFormatReadable(nt)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
            return;
          }
          if (!he.textureTypeReadable(et)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
            return;
          }
          q >= 0 && q <= L.width - ee && ie >= 0 && ie <= L.height - X && F.readPixels(q, ie, ee, X, Ye.convert(nt), Ye.convert(et), _e);
        } finally {
          const ze = P !== null ? we.get(P).__webglFramebuffer : null;
          ue.bindFramebuffer(F.FRAMEBUFFER, ze);
        }
      }
    }, this.readRenderTargetPixelsAsync = async function(L, q, ie, ee, X, _e, Ie) {
      if (!(L && L.isWebGLRenderTarget))
        throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
      let Ue = we.get(L).__webglFramebuffer;
      if (L.isWebGLCubeRenderTarget && Ie !== void 0 && (Ue = Ue[Ie]), Ue)
        if (q >= 0 && q <= L.width - ee && ie >= 0 && ie <= L.height - X) {
          ue.bindFramebuffer(F.FRAMEBUFFER, Ue);
          const ze = L.texture, nt = ze.format, et = ze.type;
          if (!he.textureFormatReadable(nt))
            throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
          if (!he.textureTypeReadable(et))
            throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
          const Ve = F.createBuffer();
          F.bindBuffer(F.PIXEL_PACK_BUFFER, Ve), F.bufferData(F.PIXEL_PACK_BUFFER, _e.byteLength, F.STREAM_READ), F.readPixels(q, ie, ee, X, Ye.convert(nt), Ye.convert(et), 0);
          const pt = P !== null ? we.get(P).__webglFramebuffer : null;
          ue.bindFramebuffer(F.FRAMEBUFFER, pt);
          const bt = F.fenceSync(F.SYNC_GPU_COMMANDS_COMPLETE, 0);
          return F.flush(), await dee(F, bt, 4), F.bindBuffer(F.PIXEL_PACK_BUFFER, Ve), F.getBufferSubData(F.PIXEL_PACK_BUFFER, 0, _e), F.deleteBuffer(Ve), F.deleteSync(bt), _e;
        } else
          throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
    }, this.copyFramebufferToTexture = function(L, q = null, ie = 0) {
      const ee = Math.pow(2, -ie), X = Math.floor(L.image.width * ee), _e = Math.floor(L.image.height * ee), Ie = q !== null ? q.x : 0, Ue = q !== null ? q.y : 0;
      D.setTexture2D(L, 0), F.copyTexSubImage2D(F.TEXTURE_2D, ie, 0, 0, Ie, Ue, X, _e), ue.unbindTexture();
    };
    const $t = F.createFramebuffer(), Wt = F.createFramebuffer();
    this.copyTextureToTexture = function(L, q, ie = null, ee = null, X = 0, _e = null) {
      _e === null && (X !== 0 ? (Au("WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels."), _e = X, X = 0) : _e = 0);
      let Ie, Ue, ze, nt, et, Ve, pt, bt, Kt;
      const jt = L.isCompressedTexture ? L.mipmaps[_e] : L.image;
      if (ie !== null)
        Ie = ie.max.x - ie.min.x, Ue = ie.max.y - ie.min.y, ze = ie.isBox3 ? ie.max.z - ie.min.z : 1, nt = ie.min.x, et = ie.min.y, Ve = ie.isBox3 ? ie.min.z : 0;
      else {
        const Kn = Math.pow(2, -X);
        Ie = Math.floor(jt.width * Kn), Ue = Math.floor(jt.height * Kn), L.isDataArrayTexture ? ze = jt.depth : L.isData3DTexture ? ze = Math.floor(jt.depth * Kn) : ze = 1, nt = 0, et = 0, Ve = 0;
      }
      ee !== null ? (pt = ee.x, bt = ee.y, Kt = ee.z) : (pt = 0, bt = 0, Kt = 0);
      const gt = Ye.convert(q.format), je = Ye.convert(q.type);
      let dn;
      q.isData3DTexture ? (D.setTexture3D(q, 0), dn = F.TEXTURE_3D) : q.isDataArrayTexture || q.isCompressedArrayTexture ? (D.setTexture2DArray(q, 0), dn = F.TEXTURE_2D_ARRAY) : (D.setTexture2D(q, 0), dn = F.TEXTURE_2D), F.pixelStorei(F.UNPACK_FLIP_Y_WEBGL, q.flipY), F.pixelStorei(F.UNPACK_PREMULTIPLY_ALPHA_WEBGL, q.premultiplyAlpha), F.pixelStorei(F.UNPACK_ALIGNMENT, q.unpackAlignment);
      const xt = F.getParameter(F.UNPACK_ROW_LENGTH), ur = F.getParameter(F.UNPACK_IMAGE_HEIGHT), Jo = F.getParameter(F.UNPACK_SKIP_PIXELS), In = F.getParameter(F.UNPACK_SKIP_ROWS), Ns = F.getParameter(F.UNPACK_SKIP_IMAGES);
      F.pixelStorei(F.UNPACK_ROW_LENGTH, jt.width), F.pixelStorei(F.UNPACK_IMAGE_HEIGHT, jt.height), F.pixelStorei(F.UNPACK_SKIP_PIXELS, nt), F.pixelStorei(F.UNPACK_SKIP_ROWS, et), F.pixelStorei(F.UNPACK_SKIP_IMAGES, Ve);
      const Ht = L.isDataArrayTexture || L.isData3DTexture, Zn = q.isDataArrayTexture || q.isData3DTexture;
      if (L.isDepthTexture) {
        const Kn = we.get(L), xn = we.get(q), Mn = we.get(Kn.__renderTarget), Ef = we.get(xn.__renderTarget);
        ue.bindFramebuffer(F.READ_FRAMEBUFFER, Mn.__webglFramebuffer), ue.bindFramebuffer(F.DRAW_FRAMEBUFFER, Ef.__webglFramebuffer);
        for (let uo = 0; uo < ze; uo++)
          Ht && (F.framebufferTextureLayer(F.READ_FRAMEBUFFER, F.COLOR_ATTACHMENT0, we.get(L).__webglTexture, X, Ve + uo), F.framebufferTextureLayer(F.DRAW_FRAMEBUFFER, F.COLOR_ATTACHMENT0, we.get(q).__webglTexture, _e, Kt + uo)), F.blitFramebuffer(nt, et, Ie, Ue, pt, bt, Ie, Ue, F.DEPTH_BUFFER_BIT, F.NEAREST);
        ue.bindFramebuffer(F.READ_FRAMEBUFFER, null), ue.bindFramebuffer(F.DRAW_FRAMEBUFFER, null);
      } else if (X !== 0 || L.isRenderTargetTexture || we.has(L)) {
        const Kn = we.get(L), xn = we.get(q);
        ue.bindFramebuffer(F.READ_FRAMEBUFFER, $t), ue.bindFramebuffer(F.DRAW_FRAMEBUFFER, Wt);
        for (let Mn = 0; Mn < ze; Mn++)
          Ht ? F.framebufferTextureLayer(F.READ_FRAMEBUFFER, F.COLOR_ATTACHMENT0, Kn.__webglTexture, X, Ve + Mn) : F.framebufferTexture2D(F.READ_FRAMEBUFFER, F.COLOR_ATTACHMENT0, F.TEXTURE_2D, Kn.__webglTexture, X), Zn ? F.framebufferTextureLayer(F.DRAW_FRAMEBUFFER, F.COLOR_ATTACHMENT0, xn.__webglTexture, _e, Kt + Mn) : F.framebufferTexture2D(F.DRAW_FRAMEBUFFER, F.COLOR_ATTACHMENT0, F.TEXTURE_2D, xn.__webglTexture, _e), X !== 0 ? F.blitFramebuffer(nt, et, Ie, Ue, pt, bt, Ie, Ue, F.COLOR_BUFFER_BIT, F.NEAREST) : Zn ? F.copyTexSubImage3D(dn, _e, pt, bt, Kt + Mn, nt, et, Ie, Ue) : F.copyTexSubImage2D(dn, _e, pt, bt, nt, et, Ie, Ue);
        ue.bindFramebuffer(F.READ_FRAMEBUFFER, null), ue.bindFramebuffer(F.DRAW_FRAMEBUFFER, null);
      } else
        Zn ? L.isDataTexture || L.isData3DTexture ? F.texSubImage3D(dn, _e, pt, bt, Kt, Ie, Ue, ze, gt, je, jt.data) : q.isCompressedArrayTexture ? F.compressedTexSubImage3D(dn, _e, pt, bt, Kt, Ie, Ue, ze, gt, jt.data) : F.texSubImage3D(dn, _e, pt, bt, Kt, Ie, Ue, ze, gt, je, jt) : L.isDataTexture ? F.texSubImage2D(F.TEXTURE_2D, _e, pt, bt, Ie, Ue, gt, je, jt.data) : L.isCompressedTexture ? F.compressedTexSubImage2D(F.TEXTURE_2D, _e, pt, bt, jt.width, jt.height, gt, jt.data) : F.texSubImage2D(F.TEXTURE_2D, _e, pt, bt, Ie, Ue, gt, je, jt);
      F.pixelStorei(F.UNPACK_ROW_LENGTH, xt), F.pixelStorei(F.UNPACK_IMAGE_HEIGHT, ur), F.pixelStorei(F.UNPACK_SKIP_PIXELS, Jo), F.pixelStorei(F.UNPACK_SKIP_ROWS, In), F.pixelStorei(F.UNPACK_SKIP_IMAGES, Ns), _e === 0 && q.generateMipmaps && F.generateMipmap(dn), ue.unbindTexture();
    }, this.copyTextureToTexture3D = function(L, q, ie = null, ee = null, X = 0) {
      return Au('WebGLRenderer: copyTextureToTexture3D function has been deprecated. Use "copyTextureToTexture" instead.'), this.copyTextureToTexture(L, q, ie, ee, X);
    }, this.initRenderTarget = function(L) {
      we.get(L).__webglFramebuffer === void 0 && D.setupRenderTarget(L);
    }, this.initTexture = function(L) {
      L.isCubeTexture ? D.setTextureCube(L, 0) : L.isData3DTexture ? D.setTexture3D(L, 0) : L.isDataArrayTexture || L.isCompressedArrayTexture ? D.setTexture2DArray(L, 0) : D.setTexture2D(L, 0), ue.unbindTexture();
    }, this.resetState = function() {
      M = 0, S = 0, P = null, ue.reset(), Je.reset();
    }, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
  /**
   * Defines the coordinate system of the renderer.
   *
   * In `WebGLRenderer`, the value is always `WebGLCoordinateSystem`.
   *
   * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
   * @default WebGLCoordinateSystem
   * @readonly
   */
  get coordinateSystem() {
    return ii;
  }
  /**
   * Defines the output color space of the renderer.
   *
   * @type {SRGBColorSpace|LinearSRGBColorSpace}
   * @default SRGBColorSpace
   */
  get outputColorSpace() {
    return this._outputColorSpace;
  }
  set outputColorSpace(e) {
    this._outputColorSpace = e;
    const n = this.getContext();
    n.drawingBufferColorSpace = mt._getDrawingBufferColorSpace(e), n.unpackColorSpace = mt._getUnpackColorSpace();
  }
}
/*!
 * Photo Sphere Viewer 5.13.2
 * @copyright 2014-2015 Jérémy Heleine
 * @copyright 2015-2025 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */
var Roe = Object.defineProperty, D2 = (t, e) => {
  for (var n in e)
    Roe(t, n, { get: e[n], enumerable: !0 });
}, Loe = {};
D2(Loe, {
  ACTIONS: () => J9,
  ANIMATION_MIN_DURATION: () => C1,
  CAPTURE_EVENTS_CLASS: () => fc,
  CTRLZOOM_TIMEOUT: () => K9,
  DBLCLICK_DELAY: () => X9,
  EASINGS: () => Ru,
  ICONS: () => Er,
  IDS: () => mn,
  KEY_CODES: () => sn,
  LONGTOUCH_DELAY: () => Y9,
  MOVE_THRESHOLD: () => q9,
  SPHERE_RADIUS: () => Ho,
  TWOFINGERSOVERLAY_DELAY: () => Z9,
  VIEWER_DATA: () => to
});
var Ooe = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="40 40 432 432"><g transform="rotate(0, 256, 256)"><path fill="currentColor" d="M425.23 210.55H227.39a5 5 0 01-3.53-8.53l56.56-56.57a45.5 45.5 0 000-64.28 45.15 45.15 0 00-32.13-13.3 45.15 45.15 0 00-32.14 13.3L41.32 256l174.83 174.83a45.15 45.15 0 0032.14 13.3 45.15 45.15 0 0032.13-13.3 45.5 45.5 0 000-64.28l-56.57-56.57a5 5 0 013.54-8.53h197.84c25.06 0 45.45-20.39 45.45-45.45s-20.4-45.45-45.45-45.45z"/></g><!-- Created by Flatart from the Noun Project --></svg>
`, Doe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g fill="currentColor" transform=" translate(50, 50) rotate(45)"><rect x="-5" y="-65" width="10" height="130"/><rect x="-65" y="-5" width="130" height="10"/></g></svg>', koe = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M83.3 35.6h-17V3H32.2v32.6H16.6l33.6 32.7 33-32.7z"/><path fill="currentColor" d="M83.3 64.2v16.3H16.6V64.2H-.1v32.6H100V64.2H83.3z"/><!--Created by Michael Zenaty from the Noun Project--></svg>
`, Noe = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M100 40H87.1V18.8h-21V6H100zM100 93.2H66V80.3h21.1v-21H100zM34 93.2H0v-34h12.9v21.1h21zM12.9 40H0V6h34v12.9H12.8z"/><!--Created by Garrett Knoll from the Noun Project--></svg>
`, Ioe = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M66 7h13v21h21v13H66zM66 60.3h34v12.9H79v21H66zM0 60.3h34v34H21V73.1H0zM21 7h13v34H0V28h21z"/><!--Created by Garrett Knoll from the Noun Project--></svg>
`, Foe = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill="currentColor" d="M28.3 26.1c-1 2.6-1.9 4.8-2.6 7-2.5 7.4-5 14.7-7.2 22-1.3 4.4.5 7.2 4.3 7.8 1.3.2 2.8.2 4.2-.1 8.2-2 11.9-8.6 15.7-15.2l-2.2 2a18.8 18.8 0 0 1-7.4 5.2 2 2 0 0 1-1.6-.2c-.2-.1 0-1 0-1.4l.8-1.8L41.9 28c.5-1.4.9-3 .7-4.4-.2-2.6-3-4.4-6.3-4.4-8.8.2-15 4.5-19.5 11.8-.2.3-.2.6-.3 1.3 3.7-2.8 6.8-6.1 11.8-6.2z"/><circle fill="currentColor" cx="39.3" cy="9.2" r="8.2"/><!--Created by Arafat Uddin from the Noun Project--></svg>
`, Uoe = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 10 80 80"><g fill="currentColor"><circle r="10" cx="20" cy="20"/><circle r="10" cx="50" cy="20"/><circle r="10" cx="80" cy="20"/><circle r="10" cx="20" cy="50"/><circle r="10" cx="50" cy="50"/><circle r="10" cx="80" cy="50"/><circle r="10" cx="20" cy="80"/><circle r="10" cx="50" cy="80"/><circle r="10" cx="80" cy="80"/></g><!-- Created by Richard Kunák from the Noun Project--></svg>
`, zoe = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M14.043 12.22a7.738 7.738 0 1 0-1.823 1.822l4.985 4.985c.503.504 1.32.504 1.822 0a1.285 1.285 0 0 0 0-1.822l-4.984-4.985zm-6.305 1.043a5.527 5.527 0 1 1 0-11.053 5.527 5.527 0 0 1 0 11.053z"/><path fill="currentColor" d="M8.728 4.009H6.744v2.737H4.006V8.73h2.738v2.736h1.984V8.73h2.737V6.746H8.728z"/><!--Created by Ryan Canning from the Noun Project--></svg>
`, Hoe = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M14.043 12.22a7.738 7.738 0 1 0-1.823 1.822l4.985 4.985c.503.504 1.32.504 1.822 0a1.285 1.285 0 0 0 0-1.822l-4.984-4.985zm-6.305 1.043a5.527 5.527 0 1 1 0-11.053 5.527 5.527 0 0 1 0 11.053z"/><path fill="currentColor" d="M4.006 6.746h7.459V8.73H4.006z"/><!--Created by Ryan Canning from the Noun Project--></svg>
`, C1 = 500, q9 = 4, X9 = 300, Y9 = 500, Z9 = 100, K9 = 2e3, Ho = 10, to = "photoSphereViewer", fc = "psv--capture-event", J9 = /* @__PURE__ */ ((t) => (t.ROTATE_UP = "ROTATE_UP", t.ROTATE_DOWN = "ROTATE_DOWN", t.ROTATE_RIGHT = "ROTATE_RIGHT", t.ROTATE_LEFT = "ROTATE_LEFT", t.ZOOM_IN = "ZOOM_IN", t.ZOOM_OUT = "ZOOM_OUT", t))(J9 || {}), mn = {
  MENU: "menu",
  TWO_FINGERS: "twoFingers",
  CTRL_ZOOM: "ctrlZoom",
  ERROR: "error",
  DESCRIPTION: "description"
}, sn = {
  Enter: "Enter",
  Control: "Control",
  Escape: "Escape",
  Space: " ",
  PageUp: "PageUp",
  PageDown: "PageDown",
  ArrowLeft: "ArrowLeft",
  ArrowUp: "ArrowUp",
  ArrowRight: "ArrowRight",
  ArrowDown: "ArrowDown",
  Delete: "Delete",
  Plus: "+",
  Minus: "-"
}, Er = {
  arrow: Ooe,
  close: Doe,
  download: koe,
  fullscreenIn: Noe,
  fullscreenOut: Ioe,
  info: Foe,
  menu: Uoe,
  zoomIn: zoe,
  zoomOut: Hoe
}, Ru = {
  linear: (t) => t,
  inQuad: (t) => t * t,
  outQuad: (t) => t * (2 - t),
  inOutQuad: (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
  inCubic: (t) => t * t * t,
  outCubic: (t) => --t * t * t + 1,
  inOutCubic: (t) => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
  inQuart: (t) => t * t * t * t,
  outQuart: (t) => 1 - --t * t * t * t,
  inOutQuart: (t) => t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t,
  inQuint: (t) => t * t * t * t * t,
  outQuint: (t) => 1 + --t * t * t * t * t,
  inOutQuint: (t) => t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t,
  inSine: (t) => 1 - Math.cos(t * (Math.PI / 2)),
  outSine: (t) => Math.sin(t * (Math.PI / 2)),
  inOutSine: (t) => 0.5 - 0.5 * Math.cos(Math.PI * t),
  inExpo: (t) => Math.pow(2, 10 * (t - 1)),
  outExpo: (t) => 1 - Math.pow(2, -10 * t),
  inOutExpo: (t) => (t = t * 2 - 1) < 0 ? 0.5 * Math.pow(2, 10 * t) : 1 - 0.5 * Math.pow(2, -10 * t),
  inCirc: (t) => 1 - Math.sqrt(1 - t * t),
  outCirc: (t) => Math.sqrt(1 - (t - 1) * (t - 1)),
  inOutCirc: (t) => (t *= 2) < 1 ? 0.5 - 0.5 * Math.sqrt(1 - t * t) : 0.5 + 0.5 * Math.sqrt(1 - (t -= 2) * t)
}, Boe = {};
D2(Boe, {
  Animation: () => cd,
  Dynamic: () => sl,
  MultiDynamic: () => wy,
  PressHandler: () => rf,
  Slider: () => Cy,
  SliderDirection: () => _y,
  addClasses: () => k2,
  angle: () => ey,
  applyEulerInverse: () => A1,
  checkClosedShadowDom: () => by,
  checkStylesheet: () => yy,
  checkVersion: () => z2,
  cleanCssPosition: () => vy,
  clone: () => ef,
  createTexture: () => T1,
  cssPositionIsOrdered: () => U2,
  dasherize: () => Goe,
  deepEqual: () => hy,
  deepmerge: () => dy,
  distance: () => Q9,
  exitFullscreen: () => cy,
  firstNonNull: () => Oi,
  getAbortError: () => S1,
  getAngle: () => ny,
  getClosest: () => iy,
  getConfigParser: () => nf,
  getElement: () => ry,
  getEventTarget: () => od,
  getMatchingTarget: () => oy,
  getPosition: () => ay,
  getShortestArc: () => ty,
  getStyleProperty: () => Fr,
  getTouchData: () => E1,
  getXMPValue: () => Bn,
  greatArcDistance: () => $oe,
  hasParent: () => joe,
  invertResolvableBoolean: () => tf,
  isAbortError: () => my,
  isEmpty: () => fy,
  isExtendedPosition: () => F2,
  isFullscreenEnabled: () => sy,
  isNil: () => ln,
  isPlainObject: () => N2,
  logWarn: () => vn,
  mergePanoData: () => xy,
  parseAngle: () => Lr,
  parsePoint: () => qoe,
  parseSpeed: () => gy,
  removeClasses: () => Woe,
  requestFullscreen: () => ly,
  resolveBoolean: () => I2,
  speedToDuration: () => M1,
  sum: () => Voe,
  throttle: () => uy,
  toggleClass: () => Qd,
  wrap: () => vl
});
function vl(t, e) {
  let n = t % e;
  return n < 0 && (n += e), n;
}
function Voe(t) {
  return t.reduce((e, n) => e + n, 0);
}
function Q9(t, e) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function ey(t, e) {
  return Math.atan2(e.y - t.y, e.x - t.x);
}
function ty(t, e) {
  return [
    0,
    // direct
    Math.PI * 2,
    // clock-wise cross zero
    -Math.PI * 2
    // counter-clock-wise cross zero
  ].reduce((r, i) => {
    const o = e - t + i;
    return Math.abs(o) < Math.abs(r) ? o : r;
  }, 1 / 0);
}
function ny(t, e) {
  return Math.acos(
    Math.cos(t.pitch) * Math.cos(e.pitch) * Math.cos(t.yaw - e.yaw) + Math.sin(t.pitch) * Math.sin(e.pitch)
  );
}
function $oe([t, e], [n, r]) {
  t - n > Math.PI ? t -= 2 * Math.PI : t - n < -Math.PI && (t += 2 * Math.PI);
  const i = (n - t) * Math.cos((e + r) / 2), o = r - e;
  return Math.sqrt(i * i + o * o);
}
function ry(t) {
  return typeof t == "string" ? t.match(/^[a-z]/i) ? document.getElementById(t) : document.querySelector(t) : t;
}
function Qd(t, e, n) {
  n === void 0 ? t.classList.toggle(e) : n ? t.classList.add(e) : n || t.classList.remove(e);
}
function k2(t, e) {
  t.classList.add(...e.split(" ").filter((n) => !!n));
}
function Woe(t, e) {
  t.classList.remove(...e.split(" ").filter((n) => !!n));
}
function joe(t, e) {
  let n = t;
  do {
    if (n === e)
      return !0;
    n = n.parentElement;
  } while (n);
  return !1;
}
function iy(t, e) {
  if (!(t != null && t.matches))
    return null;
  let n = t;
  do {
    if (n.matches(e))
      return n;
    n = n.parentElement;
  } while (n);
  return null;
}
function od(t) {
  return (t == null ? void 0 : t.composedPath()[0]) || null;
}
function oy(t, e) {
  return t ? t.composedPath().find((n) => !(n instanceof HTMLElement) && !(n instanceof SVGElement) ? !1 : n.matches(e)) : null;
}
function ay(t) {
  let e = 0, n = 0, r = t;
  for (; r; )
    e += r.offsetLeft - r.scrollLeft + r.clientLeft, n += r.offsetTop - r.scrollTop + r.clientTop, r = r.offsetParent;
  return e -= window.scrollX, n -= window.scrollY, { x: e, y: n };
}
function Fr(t, e) {
  return window.getComputedStyle(t).getPropertyValue(e);
}
function E1(t) {
  if (t.touches.length < 2)
    return null;
  const e = { x: t.touches[0].clientX, y: t.touches[0].clientY }, n = { x: t.touches[1].clientX, y: t.touches[1].clientY };
  return {
    distance: Q9(e, n),
    angle: ey(e, n),
    center: { x: (e.x + n.x) / 2, y: (e.y + n.y) / 2 }
  };
}
var ad;
function sy(t, e = !1) {
  return e ? t === ad : document.fullscreenElement === t;
}
function ly(t, e = !1) {
  e ? (ad = t, t.classList.add("psv-fullscreen-emulation"), document.dispatchEvent(new Event("fullscreenchange"))) : t.requestFullscreen();
}
function cy(t = !1) {
  t ? (ad.classList.remove("psv-fullscreen-emulation"), ad = null, document.dispatchEvent(new Event("fullscreenchange"))) : document.exitFullscreen();
}
function Goe(t) {
  return t.replace(/[A-Z](?:(?=[^A-Z])|[A-Z]*(?=[A-Z][^A-Z]|$))/g, (e, n) => (n > 0 ? "-" : "") + e.toLowerCase());
}
function uy(t, e) {
  let n = !1;
  return function(...r) {
    n || (n = !0, setTimeout(() => {
      t.apply(this, r), n = !1;
    }, e));
  };
}
function N2(t) {
  if (typeof t != "object" || t === null || Object.prototype.toString.call(t) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(t) === null)
    return !0;
  let e = t;
  for (; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(t) === e;
}
function dy(t, e) {
  const n = e;
  return function r(i, o) {
    return Array.isArray(o) ? (!i || !Array.isArray(i) ? i = [] : i.length = 0, o.forEach((a, s) => {
      i[s] = r(null, a);
    })) : typeof o == "object" ? ((!i || Array.isArray(i)) && (i = {}), Object.keys(o).forEach((a) => {
      a !== "__proto__" && (typeof o[a] != "object" || !o[a] || !N2(o[a]) ? i[a] = o[a] : o[a] !== n && (i[a] ? r(i[a], o[a]) : i[a] = r(null, o[a])));
    })) : i = o, i;
  }(t, e);
}
function ef(t) {
  return dy(null, t);
}
function fy(t) {
  return !t || Object.keys(t).length === 0 && t.constructor === Object;
}
function ln(t) {
  return t == null;
}
function Oi(...t) {
  for (const e of t)
    if (!ln(e))
      return e;
  return null;
}
function hy(t, e) {
  if (t === e)
    return !0;
  if (bg(t) && bg(e)) {
    if (Object.keys(t).length !== Object.keys(e).length)
      return !1;
    for (const n of Object.keys(t))
      if (!hy(t[n], e[n]))
        return !1;
    return !0;
  } else
    return !1;
}
function bg(t) {
  return typeof t == "object" && t !== null;
}
var yt = class py extends Error {
  constructor(e, n) {
    var r;
    super(n && n instanceof Error ? `${e}: ${n.message}` : e), this.name = "PSVError", (r = Error.captureStackTrace) == null || r.call(Error, this, py);
  }
};
function I2(t, e) {
  N2(t) ? (e(t.initial, !0), t.promise.then((n) => e(n, !1))) : e(t, !0);
}
function tf(t) {
  return {
    initial: !t.initial,
    promise: t.promise.then((e) => !e)
  };
}
function S1() {
  const t = new Error("Loading was aborted.");
  return t.name = "AbortError", t;
}
function my(t) {
  return (t == null ? void 0 : t.name) === "AbortError";
}
function vn(t) {
  console.warn(`PhotoSphereViewer: ${t}`);
}
function F2(t) {
  return !t || Array.isArray(t) ? !1 : [
    ["textureX", "textureY"],
    ["yaw", "pitch"]
  ].some(([e, n]) => t[e] !== void 0 && t[n] !== void 0);
}
function Bn(t, e, n = !0) {
  let r = t.match("<GPano:" + e + ">(.*)</GPano:" + e + ">");
  if (r !== null) {
    const i = n ? parseInt(r[1], 10) : parseFloat(r[1]);
    return isNaN(i) ? null : i;
  }
  if (r = t.match("GPano:" + e + '="(.*?)"'), r !== null) {
    const i = n ? parseInt(r[1], 10) : parseFloat(r[1]);
    return isNaN(i) ? null : i;
  }
  return null;
}
var xg = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, sd = ["left", "center", "right"], ld = ["top", "center", "bottom"], wg = [...sd, ...ld], Qn = "center";
function qoe(t) {
  if (!t)
    return { x: 0.5, y: 0.5 };
  if (typeof t == "object")
    return t;
  let e = t.toLocaleLowerCase().split(" ").slice(0, 2);
  e.length === 1 && (xg[e[0]] ? e = [e[0], Qn] : e = [e[0], e[0]]);
  const n = e[1] !== "left" && e[1] !== "right" && e[0] !== "top" && e[0] !== "bottom";
  e = e.map((i) => xg[i] || i), n || e.reverse();
  const r = e.join(" ").match(/^([0-9.]+)% ([0-9.]+)%$/);
  return r ? {
    x: parseFloat(r[1]) / 100,
    y: parseFloat(r[2]) / 100
  } : { x: 0.5, y: 0.5 };
}
function vy(t, { allowCenter: e, cssOrder: n } = {
  allowCenter: !0,
  cssOrder: !0
}) {
  return t ? (typeof t == "string" && (t = t.split(" ")), t.length === 1 && (t[0] === Qn ? t = [Qn, Qn] : sd.indexOf(t[0]) !== -1 ? t = [Qn, t[0]] : ld.indexOf(t[0]) !== -1 && (t = [t[0], Qn])), t.length !== 2 || wg.indexOf(t[0]) === -1 || wg.indexOf(t[1]) === -1 ? (vn(`Unparsable position ${t}`), null) : !e && t[0] === Qn && t[1] === Qn ? (vn("Invalid position center center"), null) : (n && !U2(t) && (t = [t[1], t[0]]), t[1] === Qn && sd.indexOf(t[0]) !== -1 && (t = [Qn, t[0]]), t[0] === Qn && ld.indexOf(t[1]) !== -1 && (t = [t[1], Qn]), t)) : null;
}
function U2(t) {
  return ld.indexOf(t[0]) !== -1 && sd.indexOf(t[1]) !== -1;
}
function gy(t) {
  let e;
  if (typeof t == "string") {
    const n = t.toString().trim();
    let r = parseFloat(n.replace(/^(-?[0-9]+(?:\.[0-9]*)?).*$/, "$1"));
    const i = n.replace(/^-?[0-9]+(?:\.[0-9]*)?(.*)$/, "$1").trim();
    switch (i.match(/(pm|per minute)$/) && (r /= 60), i) {
      case "dpm":
      case "degrees per minute":
      case "dps":
      case "degrees per second":
        e = Mt.degToRad(r);
        break;
      case "rdpm":
      case "radians per minute":
      case "rdps":
      case "radians per second":
        e = r;
        break;
      case "rpm":
      case "revolutions per minute":
      case "rps":
      case "revolutions per second":
        e = r * Math.PI * 2;
        break;
      default:
        throw new yt(`Unknown speed unit "${i}"`);
    }
  } else
    e = t;
  return e;
}
function M1(t, e) {
  if (typeof t != "number") {
    const n = gy(t);
    return e / Math.abs(n) * 1e3;
  } else
    return Math.abs(t);
}
function Lr(t, e = !1, n = e) {
  let r;
  if (typeof t == "string") {
    const i = t.toLowerCase().trim().match(/^(-?[0-9]+(?:\.[0-9]*)?)(.*)$/);
    if (!i)
      throw new yt(`Unknown angle "${t}"`);
    const o = parseFloat(i[1]), a = i[2];
    if (a)
      switch (a) {
        case "deg":
        case "degs":
          r = Mt.degToRad(o);
          break;
        case "rad":
        case "rads":
          r = o;
          break;
        default:
          throw new yt(`Unknown angle unit "${a}"`);
      }
    else
      r = o;
  } else if (typeof t == "number" && !isNaN(t))
    r = t;
  else
    throw new yt(`Unknown angle "${t}"`);
  return r = vl(e ? r + Math.PI : r, Math.PI * 2), e ? Mt.clamp(r - Math.PI, -Math.PI / (n ? 2 : 1), Math.PI / (n ? 2 : 1)) : r;
}
function T1(t, e = !1) {
  const n = new En(t);
  return n.needsUpdate = !0, n.minFilter = e ? Ui : yr, n.generateMipmaps = e, n.anisotropy = e ? 2 : 1, n;
}
var _g = new Rs();
function A1(t, e) {
  _g.setFromEuler(e).invert(), t.applyQuaternion(_g);
}
function nf(t, e) {
  const n = function(r) {
    const i = ef({
      ...t,
      ...r
    }), o = {};
    for (let [a, s] of Object.entries(i)) {
      if (e && a in e)
        s = e[a](s, {
          rawConfig: i,
          defValue: t[a]
        });
      else if (!(a in t)) {
        vn(`Unknown option ${a}`);
        continue;
      }
      o[a] = s;
    }
    return o;
  };
  return n.defaults = t, n.parsers = e || {}, n;
}
function yy(t, e) {
  Fr(t, `--psv-${e}-loaded`) !== "true" && console.error(`PhotoSphereViewer: stylesheet "@photo-sphere-viewer/${e}/index.css" is not loaded`);
}
function z2(t, e, n) {
  e && e !== n && console.error(`PhotoSphereViewer: @photo-sphere-viewer/${t} is in version ${e} but @photo-sphere-viewer/core is in version ${n}`);
}
function by(t) {
  do {
    if (t instanceof ShadowRoot && t.mode === "closed") {
      console.error("PhotoSphereViewer: closed shadow DOM detected, the viewer might not work as expected");
      return;
    }
    t = t.parentNode;
  } while (t);
}
function xy(t, e, n, r) {
  const i = {
    isEquirectangular: !0,
    fullWidth: Oi(n == null ? void 0 : n.fullWidth, r == null ? void 0 : r.fullWidth),
    fullHeight: Oi(n == null ? void 0 : n.fullHeight, r == null ? void 0 : r.fullHeight),
    croppedWidth: t,
    croppedHeight: e,
    croppedX: Oi(n == null ? void 0 : n.croppedX, r == null ? void 0 : r.croppedX),
    croppedY: Oi(n == null ? void 0 : n.croppedY, r == null ? void 0 : r.croppedY),
    poseHeading: Oi(n == null ? void 0 : n.poseHeading, r == null ? void 0 : r.poseHeading, 0),
    posePitch: Oi(n == null ? void 0 : n.posePitch, r == null ? void 0 : r.posePitch, 0),
    poseRoll: Oi(n == null ? void 0 : n.poseRoll, r == null ? void 0 : r.poseRoll, 0),
    initialHeading: r == null ? void 0 : r.initialHeading,
    initialPitch: r == null ? void 0 : r.initialPitch,
    initialFov: r == null ? void 0 : r.initialFov
  };
  return !i.fullWidth && !i.fullHeight && (i.fullWidth = Math.max(t, e * 2), i.fullHeight = Math.round(i.fullWidth / 2)), i.fullWidth || (i.fullWidth = i.fullHeight * 2), i.fullHeight || (i.fullHeight = Math.round(i.fullWidth / 2)), i.croppedX === null && (i.croppedX = Math.round((i.fullWidth - t) / 2)), i.croppedY === null && (i.croppedY = Math.round((i.fullHeight - e) / 2)), Math.abs(i.fullWidth - i.fullHeight * 2) > 1 && (vn("Invalid panoData, fullWidth should be twice fullHeight"), i.fullHeight = Math.round(i.fullWidth / 2)), i.croppedX + i.croppedWidth > i.fullWidth && (vn("Invalid panoData, croppedX + croppedWidth > fullWidth"), i.croppedX = i.fullWidth - i.croppedWidth), i.croppedY + i.croppedHeight > i.fullHeight && (vn("Invalid panoData, croppedY + croppedHeight > fullHeight"), i.croppedY = i.fullHeight - i.croppedHeight), i.croppedX < 0 && (vn("Invalid panoData, croppedX < 0"), i.croppedX = 0), i.croppedY < 0 && (vn("Invalid panoData, croppedY < 0"), i.croppedY = 0), i;
}
var cd = class {
  constructor(t) {
    this.easing = Ru.linear, this.callbacks = [], this.resolved = !1, this.cancelled = !1, this.options = t, t ? (t.easing && (this.easing = typeof t.easing == "function" ? t.easing : Ru[t.easing] || Ru.linear), this.delayTimeout = setTimeout(() => {
      this.delayTimeout = void 0, this.animationFrame = window.requestAnimationFrame((e) => this.__run(e));
    }, t.delay || 0)) : this.resolved = !0;
  }
  __run(t) {
    if (this.cancelled)
      return;
    this.start || (this.start = t);
    const e = (t - this.start) / this.options.duration, n = {};
    if (e < 1) {
      for (const [r, i] of Object.entries(this.options.properties))
        if (i) {
          const o = i.start + (i.end - i.start) * this.easing(e);
          n[r] = o;
        }
      this.options.onTick(n, e), this.animationFrame = window.requestAnimationFrame((r) => this.__run(r));
    } else {
      for (const [r, i] of Object.entries(this.options.properties))
        i && (n[r] = i.end);
      this.options.onTick(n, 1), this.__resolve(!0), this.animationFrame = void 0;
    }
  }
  __resolve(t) {
    t ? this.resolved = !0 : this.cancelled = !0, this.callbacks.forEach((e) => e(t)), this.callbacks.length = 0;
  }
  /**
   * Promise chaining
   * @param [onFulfilled] - Called when the animation is complete (true) or cancelled (false)
   */
  then(t) {
    return this.resolved || this.cancelled ? Promise.resolve(this.resolved).then(t) : new Promise((e) => {
      this.callbacks.push(e);
    }).then(t);
  }
  /**
   * Cancels the animation
   */
  cancel() {
    !this.cancelled && !this.resolved && (this.__resolve(!1), this.delayTimeout && (window.clearTimeout(this.delayTimeout), this.delayTimeout = void 0), this.animationFrame && (window.cancelAnimationFrame(this.animationFrame), this.animationFrame = void 0));
  }
}, sl = class {
  constructor(t, e) {
    if (this.fn = t, this.mode = 0, this.speed = 0, this.speedMult = 0, this.currentSpeed = 0, this.target = 0, this.__current = 0, this.min = e.min, this.max = e.max, this.wrap = e.wrap, this.current = e.defaultValue, this.wrap && this.min !== 0)
      throw new yt("invalid config");
    this.fn && this.fn(this.current);
  }
  get current() {
    return this.__current;
  }
  set current(t) {
    this.__current = t;
  }
  /**
   * Changes base speed
   */
  setSpeed(t) {
    this.speed = t;
  }
  /**
   * Defines the target position
   */
  goto(t, e = 1) {
    this.mode = 2, this.target = this.wrap ? vl(t, this.max) : Mt.clamp(t, this.min, this.max), this.speedMult = e;
  }
  /**
   * Increases/decreases the target position
   */
  step(t, e = 1) {
    e === 0 ? this.setValue(this.current + t) : (this.mode !== 2 && (this.target = this.current), this.goto(this.target + t, e));
  }
  /**
   * Starts infinite movement
   */
  roll(t = !1, e = 1) {
    this.mode = 1, this.target = t ? -1 / 0 : 1 / 0, this.speedMult = e;
  }
  /**
   * Stops movement
   */
  stop() {
    this.mode = 0;
  }
  /**
   * Defines the current position and immediately stops movement
   * @param {number} value
   */
  setValue(t) {
    return this.target = this.wrap ? vl(t, this.max) : Mt.clamp(t, this.min, this.max), this.mode = 0, this.currentSpeed = 0, this.target !== this.current ? (this.current = this.target, this.fn && this.fn(this.current), !0) : !1;
  }
  /**
   * @internal
   */
  update(t) {
    if (this.mode === 2) {
      this.wrap && Math.abs(this.target - this.current) > this.max / 2 && (this.current = this.current < this.target ? this.current + this.max : this.current - this.max);
      const r = this.currentSpeed * this.currentSpeed / (this.speed * this.speedMult * 4);
      Math.abs(this.target - this.current) <= r && (this.mode = 0);
    }
    let e = this.mode === 0 ? 0 : this.speed * this.speedMult;
    this.target < this.current && (e = -e), this.currentSpeed < e ? this.currentSpeed = Math.min(
      e,
      this.currentSpeed + t / 1e3 * this.speed * this.speedMult * 2
    ) : this.currentSpeed > e && (this.currentSpeed = Math.max(
      e,
      this.currentSpeed - t / 1e3 * this.speed * this.speedMult * 2
    ));
    let n = null;
    return this.current > this.target && this.currentSpeed ? n = Math.max(this.target, this.current + this.currentSpeed * t / 1e3) : this.current < this.target && this.currentSpeed && (n = Math.min(this.target, this.current + this.currentSpeed * t / 1e3)), n !== null && (n = this.wrap ? vl(n, this.max) : Mt.clamp(n, this.min, this.max), n !== this.current) ? (this.current = n, this.fn && this.fn(this.current), !0) : !1;
  }
}, wy = class {
  constructor(t, e) {
    this.fn = t, this.dynamics = e, this.fn && this.fn(this.current);
  }
  get current() {
    return Object.entries(this.dynamics).reduce(
      (t, [e, n]) => (t[e] = n.current, t),
      {}
    );
  }
  /**
   * Changes base speed
   */
  setSpeed(t) {
    for (const e of Object.values(this.dynamics))
      e.setSpeed(t);
  }
  /**
   * Defines the target positions
   */
  goto(t, e = 1) {
    for (const [n, r] of Object.entries(t))
      this.dynamics[n].goto(r, e);
  }
  /**
   * Increase/decrease the target positions
   */
  step(t, e = 1) {
    if (e === 0)
      this.setValue(
        Object.keys(t).reduce(
          (n, r) => (n[r] = t[r] + this.dynamics[r].current, n),
          {}
        )
      );
    else
      for (const [n, r] of Object.entries(t))
        this.dynamics[n].step(r, e);
  }
  /**
   * Starts infinite movements
   */
  roll(t, e = 1) {
    for (const [n, r] of Object.entries(t))
      this.dynamics[n].roll(r, e);
  }
  /**
   * Stops movements
   */
  stop() {
    for (const t of Object.values(this.dynamics))
      t.stop();
  }
  /**
   * Defines the current positions and immediately stops movements
   */
  setValue(t) {
    let e = !1;
    for (const [n, r] of Object.entries(t))
      e = this.dynamics[n].setValue(r) || e;
    return e && this.fn && this.fn(this.current), e;
  }
  /**
   * @internal
   */
  update(t) {
    let e = !1;
    for (const n of Object.values(this.dynamics))
      e = n.update(t) || e;
    return e && this.fn && this.fn(this.current), e;
  }
}, rf = class {
  constructor(t = 200) {
    this.delay = t, this.time = 0, this.delay = t;
  }
  get pending() {
    return this.time !== 0;
  }
  down(t) {
    this.timeout && (clearTimeout(this.timeout), this.timeout = void 0), this.time = (/* @__PURE__ */ new Date()).getTime(), this.data = t;
  }
  up(t) {
    if (!this.time)
      return;
    Date.now() - this.time < this.delay ? this.timeout = setTimeout(() => {
      t(this.data), this.timeout = void 0, this.time = 0, this.data = void 0;
    }, this.delay) : (t(this.data), this.time = 0, this.data = void 0);
  }
}, _y = /* @__PURE__ */ ((t) => (t.VERTICAL = "VERTICAL", t.HORIZONTAL = "HORIZONTAL", t))(_y || {}), Cy = class {
  constructor(t, e, n) {
    this.container = t, this.direction = e, this.listener = n, this.mousedown = !1, this.mouseover = !1, this.container.addEventListener("click", this), this.container.addEventListener("mousedown", this), this.container.addEventListener("mouseenter", this), this.container.addEventListener("mouseleave", this), this.container.addEventListener("touchstart", this), this.container.addEventListener("mousemove", this, !0), this.container.addEventListener("touchmove", this, !0), window.addEventListener("mouseup", this), window.addEventListener("touchend", this);
  }
  get isVertical() {
    return this.direction === "VERTICAL";
  }
  get isHorizontal() {
    return this.direction === "HORIZONTAL";
  }
  destroy() {
    window.removeEventListener("mouseup", this), window.removeEventListener("touchend", this);
  }
  /**
   * @internal
   */
  handleEvent(t) {
    switch (t.type) {
      case "click":
        t.stopPropagation();
        break;
      case "mousedown":
        this.__onMouseDown(t);
        break;
      case "mouseenter":
        this.__onMouseEnter(t);
        break;
      case "mouseleave":
        this.__onMouseLeave(t);
        break;
      case "touchstart":
        this.__onTouchStart(t);
        break;
      case "mousemove":
        this.__onMouseMove(t);
        break;
      case "touchmove":
        this.__onTouchMove(t);
        break;
      case "mouseup":
        this.__onMouseUp(t);
        break;
      case "touchend":
        this.__onTouchEnd(t);
        break;
    }
  }
  __onMouseDown(t) {
    this.mousedown = !0, this.__update(t.clientX, t.clientY, !0);
  }
  __onMouseEnter(t) {
    this.mouseover = !0, this.__update(t.clientX, t.clientY, !0);
  }
  __onTouchStart(t) {
    this.mouseover = !0, this.mousedown = !0;
    const e = t.changedTouches[0];
    this.__update(e.clientX, e.clientY, !0);
  }
  __onMouseMove(t) {
    (this.mousedown || this.mouseover) && (t.stopPropagation(), this.__update(t.clientX, t.clientY, !0));
  }
  __onTouchMove(t) {
    if (this.mousedown || this.mouseover) {
      t.stopPropagation();
      const e = t.changedTouches[0];
      this.__update(e.clientX, e.clientY, !0);
    }
  }
  __onMouseUp(t) {
    this.mousedown && (this.mousedown = !1, this.__update(t.clientX, t.clientY, !1));
  }
  __onMouseLeave(t) {
    this.mouseover && (this.mouseover = !1, this.__update(t.clientX, t.clientY, !0));
  }
  __onTouchEnd(t) {
    if (this.mousedown) {
      this.mouseover = !1, this.mousedown = !1;
      const e = t.changedTouches[0];
      this.__update(e.clientX, e.clientY, !1);
    }
  }
  __update(t, e, n) {
    const r = this.container.getBoundingClientRect();
    let i;
    this.isVertical ? i = Mt.clamp((r.bottom - e) / r.height, 0, 1) : i = Mt.clamp((t - r.left) / r.width, 0, 1), this.listener({
      value: i,
      click: !n,
      mousedown: this.mousedown,
      mouseover: this.mouseover,
      cursor: { clientX: t, clientY: e }
    });
  }
}, Xoe = {};
D2(Xoe, {
  BeforeAnimateEvent: () => H2,
  BeforeRenderEvent: () => gl,
  BeforeRotateEvent: () => Ly,
  ClickEvent: () => ky,
  ConfigChangedEvent: () => Ln,
  DoubleClickEvent: () => zy,
  FullscreenEvent: () => yl,
  HideNotificationEvent: () => bl,
  HideOverlayEvent: () => Gy,
  HidePanelEvent: () => Vi,
  HideTooltipEvent: () => Ky,
  KeypressEvent: () => $i,
  LoadProgressEvent: () => nb,
  ObjectEnterEvent: () => Bb,
  ObjectEvent: () => of,
  ObjectHoverEvent: () => Gb,
  ObjectLeaveEvent: () => P1,
  PanoramaErrorEvent: () => ub,
  PanoramaLoadEvent: () => ob,
  PanoramaLoadedEvent: () => Ja,
  PositionUpdatedEvent: () => xl,
  ReadyEvent: () => _l,
  RenderEvent: () => _b,
  RollUpdatedEvent: () => wl,
  ShowNotificationEvent: () => Cl,
  ShowOverlayEvent: () => Tb,
  ShowPanelEvent: () => Wi,
  ShowTooltipEvent: () => Ob,
  SizeUpdatedEvent: () => El,
  StopAllEvent: () => Sl,
  TransitionDoneEvent: () => hb,
  ViewerEvent: () => Ct,
  ZoomUpdatedEvent: () => si
});
var Yoe = class extends Event {
  constructor(t, e = !1) {
    super(t, { cancelable: e });
  }
}, Ey = class extends EventTarget {
  dispatchEvent(t) {
    return super.dispatchEvent(t);
  }
  /**
   * @template T the name of event
   * @template E the class of the event
   */
  addEventListener(t, e, n) {
    super.addEventListener(t, e, n);
  }
  /**
   * @template T the name of event
   * @template E the class of the event
   */
  removeEventListener(t, e, n) {
    super.removeEventListener(t, e, n);
  }
}, Ct = class extends Yoe {
}, Sy = class My extends Ct {
  /** @internal */
  constructor(e, n) {
    super(My.type, !0), this.position = e, this.zoomLevel = n;
  }
};
Sy.type = "before-animate";
var H2 = Sy, Ty = class Ay extends Ct {
  /** @internal */
  constructor(e, n) {
    super(Ay.type), this.timestamp = e, this.elapsed = n;
  }
};
Ty.type = "before-render";
var gl = Ty, Py = class Ry extends Ct {
  /** @internal */
  constructor(e) {
    super(Ry.type, !0), this.position = e;
  }
};
Py.type = "before-rotate";
var Ly = Py, Oy = class Dy extends Ct {
  /** @internal */
  constructor(e) {
    super(Dy.type), this.data = e;
  }
};
Oy.type = "click";
var ky = Oy, Ny = class Iy extends Ct {
  /** @internal */
  constructor(e) {
    super(Iy.type), this.options = e;
  }
  /**
   * Checks if at least one of the `options` has been modified
   */
  containsOptions(...e) {
    return e.some((n) => this.options.includes(n));
  }
};
Ny.type = "config-changed";
var Ln = Ny, Fy = class Uy extends Ct {
  /** @internal */
  constructor(e) {
    super(Uy.type), this.data = e;
  }
};
Fy.type = "dblclick";
var zy = Fy, Hy = class By extends Ct {
  /** @internal */
  constructor(e) {
    super(By.type), this.fullscreenEnabled = e;
  }
};
Hy.type = "fullscreen";
var yl = Hy, Vy = class $y extends Ct {
  /** @internal */
  constructor(e) {
    super($y.type), this.notificationId = e;
  }
};
Vy.type = "hide-notification";
var bl = Vy, Wy = class jy extends Ct {
  /** @internal */
  constructor(e) {
    super(jy.type), this.overlayId = e;
  }
};
Wy.type = "hide-overlay";
var Gy = Wy, qy = class Xy extends Ct {
  /** @internal */
  constructor(e) {
    super(Xy.type), this.panelId = e;
  }
};
qy.type = "hide-panel";
var Vi = qy, Yy = class Zy extends Ct {
  /** @internal */
  constructor(e) {
    super(Zy.type), this.tooltipData = e;
  }
};
Yy.type = "hide-tooltip";
var Ky = Yy, Jy = class Qy extends Ct {
  /** @internal */
  constructor(e, n) {
    super(Qy.type, !0), this.key = e, this.originalEvent = n;
  }
};
Jy.type = "key-press";
var $i = Jy, eb = class tb extends Ct {
  /** @internal */
  constructor(e) {
    super(tb.type), this.progress = e;
  }
};
eb.type = "load-progress";
var nb = eb, rb = class ib extends Ct {
  /** @internal */
  constructor(e) {
    super(ib.type), this.panorama = e;
  }
};
rb.type = "panorama-load";
var ob = rb, ab = class sb extends Ct {
  /** @internal */
  constructor(e) {
    super(sb.type), this.data = e;
  }
};
ab.type = "panorama-loaded";
var Ja = ab, lb = class cb extends Ct {
  /** @internal */
  constructor(e, n) {
    super(cb.type), this.panorama = e, this.error = n;
  }
};
lb.type = "panorama-error";
var ub = lb, db = class fb extends Ct {
  /** @internal */
  constructor(e) {
    super(fb.type), this.completed = e;
  }
};
db.type = "transition-done";
var hb = db, pb = class mb extends Ct {
  /** @internal */
  constructor(e) {
    super(mb.type), this.position = e;
  }
};
pb.type = "position-updated";
var xl = pb, vb = class gb extends Ct {
  /** @internal */
  constructor(e) {
    super(gb.type), this.roll = e;
  }
};
vb.type = "roll-updated";
var wl = vb, yb = class bb extends Ct {
  /** @internal */
  constructor() {
    super(bb.type);
  }
};
yb.type = "ready";
var _l = yb, xb = class wb extends Ct {
  /** @internal */
  constructor() {
    super(wb.type);
  }
};
xb.type = "render";
var _b = xb, Cb = class Eb extends Ct {
  /** @internal */
  constructor(e) {
    super(Eb.type), this.notificationId = e;
  }
};
Cb.type = "show-notification";
var Cl = Cb, Sb = class Mb extends Ct {
  /** @internal */
  constructor(e) {
    super(Mb.type), this.overlayId = e;
  }
};
Sb.type = "show-overlay";
var Tb = Sb, Ab = class Pb extends Ct {
  /** @internal */
  constructor(e) {
    super(Pb.type), this.panelId = e;
  }
};
Ab.type = "show-panel";
var Wi = Ab, Rb = class Lb extends Ct {
  /** @internal */
  constructor(e, n) {
    super(Lb.type), this.tooltip = e, this.tooltipData = n;
  }
};
Rb.type = "show-tooltip";
var Ob = Rb, Db = class kb extends Ct {
  /** @internal */
  constructor(e) {
    super(kb.type), this.size = e;
  }
};
Db.type = "size-updated";
var El = Db, Nb = class Ib extends Ct {
  /** @internal */
  constructor() {
    super(Ib.type);
  }
};
Nb.type = "stop-all";
var Sl = Nb, Fb = class Ub extends Ct {
  /** @internal */
  constructor(e) {
    super(Ub.type), this.zoomLevel = e;
  }
};
Fb.type = "zoom-updated";
var si = Fb, of = class extends Ct {
  /** @internal */
  constructor(t, e, n, r, i) {
    super(t), this.originalEvent = e, this.object = n, this.viewerPoint = r, this.userDataKey = i;
  }
}, zb = class Hb extends of {
  /** @internal */
  constructor(e, n, r, i) {
    super(Hb.type, e, n, r, i);
  }
};
zb.type = "enter-object";
var Bb = zb, Vb = class $b extends of {
  /** @internal */
  constructor(e, n, r, i) {
    super($b.type, e, n, r, i);
  }
};
Vb.type = "leave-object";
var P1 = Vb, Wb = class jb extends of {
  /** @internal */
  constructor(e, n, r, i) {
    super(jb.type, e, n, r, i);
  }
};
Wb.type = "hover-object";
var Gb = Wb, B2 = class {
  constructor(t) {
    this.viewer = t;
  }
  /**
   * Initializes the adapter
   */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  /**
   * Destroys the adapter
   */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  destroy() {
  }
  /**
   * Indicates if the adapter supports transitions between panoramas
   */
  // @ts-ignore unused parameter
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  supportsTransition(t) {
    return !1;
  }
  /**
   * Indicates if the adapter supports preload of a panorama
   */
  // @ts-ignore unused parameter
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  supportsPreload(t) {
    return !1;
  }
  /**
   * Converts pixel texture coordinates to spherical radians coordinates
   * @throws {@link PSVError} when the current adapter does not support texture coordinates
   */
  // @ts-ignore unused parameter
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  textureCoordsToSphericalCoords(t, e) {
    throw new yt("Current adapter does not support texture coordinates.");
  }
  /**
   * Converts spherical radians coordinates to pixel texture coordinates
   * @throws {@link PSVError} when the current adapter does not support texture coordinates
   */
  // @ts-ignore unused parameter
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  sphericalCoordsToTextureCoords(t, e) {
    throw new yt("Current adapter does not support texture coordinates.");
  }
};
B2.supportsDownload = !1;
function Cg(t) {
  if (t) {
    for (const [, e] of [["_", t], ...Object.entries(t)])
      if (e.prototype instanceof B2)
        return z2(e.id, e.VERSION, "5.13.2"), e;
  }
  return null;
}
var Js = `${to}_touchSupport`, Cn = {
  /**
   * Indicates if the system data has been loaded
   */
  loaded: !1,
  /**
   * Device screen pixel ratio
   */
  pixelRatio: 1,
  /**
   * Device supports WebGL
   */
  isWebGLSupported: !1,
  /**
   * Maximum WebGL texture width
   */
  maxTextureWidth: 0,
  /**
   * Device supports touch events
   */
  isTouchEnabled: null,
  /**
   * @internal
   */
  __maxCanvasWidth: null,
  /**
   * If the current device is an iPhone
   */
  isIphone: !1,
  /**
   * Maximum canvas width
   */
  get maxCanvasWidth() {
    return this.__maxCanvasWidth === null && (this.__maxCanvasWidth = Joe(this.maxTextureWidth)), this.__maxCanvasWidth;
  },
  /**
   * Loads the system if not already loaded
   * @internal
   */
  load() {
    if (!this.loaded) {
      const t = Zoe();
      this.pixelRatio = window.devicePixelRatio || 1, this.isWebGLSupported = !!t, this.maxTextureWidth = t ? t.getParameter(t.MAX_TEXTURE_SIZE) : 0, this.isTouchEnabled = Koe(), this.isIphone = /iPhone/i.test(navigator.userAgent), this.loaded = !0;
    }
    if (!Cn.isWebGLSupported)
      throw new yt("WebGL 2 is not supported.");
    if (Cn.maxTextureWidth === 0)
      throw new yt("Unable to detect system capabilities");
  }
};
function Zoe() {
  try {
    return document.createElement("canvas").getContext("webgl2");
  } catch {
    return null;
  }
}
function Koe() {
  let t = "ontouchstart" in window || navigator.maxTouchPoints > 0;
  Js in localStorage && (t = localStorage[Js] === "true");
  const e = new Promise((n) => {
    const r = () => {
      window.removeEventListener("mousedown", i), window.removeEventListener("touchstart", o), clearTimeout(s);
    }, i = () => {
      r(), localStorage[Js] = !1, n(!1);
    }, o = () => {
      r(), localStorage[Js] = !0, n(!0);
    }, a = () => {
      r(), localStorage[Js] = t, n(t);
    };
    window.addEventListener("mousedown", i, !1), window.addEventListener("touchstart", o, !1);
    const s = setTimeout(a, 1e4);
  });
  return { initial: t, promise: e };
}
function Joe(t) {
  let e = t, n = !1;
  const r = document.createElement("canvas"), i = r.getContext("2d");
  for (r.width = 1, r.height = 1; e > 1024 && !n; ) {
    const o = document.createElement("canvas"), a = o.getContext("2d");
    o.width = e, o.height = e / 2;
    try {
      a.fillStyle = "white", a.fillRect(e - 1, e / 2 - 1, 1, 1), i.drawImage(o, e - 1, e / 2 - 1, 1, 1, 0, 0, 1, 1), i.getImageData(0, 0, 1, 1).data[0] > 0 && (n = !0);
    } catch {
    }
    o.width = 0, o.height = 0, n || (e /= 2);
  }
  if (n)
    return e;
  throw new yt("Unable to detect system capabilities");
}
var Qoe = nf(
  {
    resolution: 64,
    useXmpData: !0,
    blur: !1
  },
  {
    resolution: (t) => {
      if (!t || !Mt.isPowerOfTwo(t))
        throw new yt("EquirectangularAdapter resolution must be power of two.");
      return t;
    }
  }
), hc = class extends B2 {
  constructor(t, e) {
    super(t), this.config = Qoe(e), this.SPHERE_SEGMENTS = this.config.resolution, this.SPHERE_HORIZONTAL_SEGMENTS = this.SPHERE_SEGMENTS / 2;
  }
  supportsTransition() {
    return !0;
  }
  supportsPreload() {
    return !0;
  }
  textureCoordsToSphericalCoords(t, e) {
    if (ln(t.textureX) || ln(t.textureY))
      throw new yt("Texture position is missing 'textureX' or 'textureY'");
    const n = (t.textureX + e.croppedX) / e.fullWidth * Math.PI * 2, r = (t.textureY + e.croppedY) / e.fullHeight * Math.PI;
    return {
      yaw: n >= Math.PI ? n - Math.PI : n + Math.PI,
      pitch: Math.PI / 2 - r
    };
  }
  sphericalCoordsToTextureCoords(t, e) {
    const n = t.yaw / Math.PI / 2 * e.fullWidth, r = t.pitch / Math.PI * e.fullHeight;
    let i = Math.round(t.yaw < Math.PI ? n + e.fullWidth / 2 : n - e.fullWidth / 2) - e.croppedX, o = Math.round(e.fullHeight / 2 - r) - e.croppedY;
    return (i < 0 || i > e.croppedWidth || o < 0 || o > e.croppedHeight) && (i = o = void 0), { textureX: i, textureY: o };
  }
  async loadTexture(t, e = !0, n, r = this.config.useXmpData) {
    if (typeof t != "string" && (typeof t != "object" || !t.path))
      return Promise.reject(new yt("Invalid panorama url, are you using the right adapter?"));
    let i;
    typeof t == "string" ? i = {
      path: t,
      data: n
    } : i = {
      data: n,
      ...t
    };
    const o = await this.viewer.textureLoader.loadFile(
      i.path,
      e ? (u) => this.viewer.textureLoader.dispatchProgress(u) : null,
      i.path
    ), a = r ? await this.loadXMP(o) : null, s = await this.viewer.textureLoader.blobToImage(o);
    typeof i.data == "function" && (i.data = i.data(s, a));
    const l = xy(s.width, s.height, i.data, a), c = this.createEquirectangularTexture(s);
    return {
      panorama: t,
      texture: c,
      panoData: l,
      cacheKey: i.path
    };
  }
  /**
   * Loads the XMP data of an image
   */
  async loadXMP(t) {
    const e = await this.loadBlobAsString(t), n = e.indexOf("<x:xmpmeta");
    if (n === -1)
      return null;
    const r = e.indexOf("</x:xmpmeta>", n);
    if (r === -1)
      return null;
    const i = e.substring(n, r);
    return i.includes("GPano:") ? {
      fullWidth: Bn(i, "FullPanoWidthPixels"),
      fullHeight: Bn(i, "FullPanoHeightPixels"),
      croppedWidth: Bn(i, "CroppedAreaImageWidthPixels"),
      croppedHeight: Bn(i, "CroppedAreaImageHeightPixels"),
      croppedX: Bn(i, "CroppedAreaLeftPixels"),
      croppedY: Bn(i, "CroppedAreaTopPixels"),
      poseHeading: Bn(i, "PoseHeadingDegrees", !1),
      posePitch: Bn(i, "PosePitchDegrees", !1),
      poseRoll: Bn(i, "PoseRollDegrees", !1),
      initialHeading: Bn(i, "InitialViewHeadingDegrees", !1),
      initialPitch: Bn(i, "InitialViewPitchDegrees", !1),
      initialFov: Bn(i, "InitialHorizontalFOVDegrees", !1)
    } : null;
  }
  /**
   * Reads a Blob as a string
   */
  loadBlobAsString(t) {
    return new Promise((e, n) => {
      const r = new FileReader();
      r.onload = () => e(r.result), r.onerror = n, r.readAsText(t);
    });
  }
  /**
   * Creates the final texture from image and panorama data
   */
  createEquirectangularTexture(t) {
    if (this.config.blur || t.width > Cn.maxTextureWidth) {
      const e = Math.min(1, Cn.maxCanvasWidth / t.width), n = new OffscreenCanvas(Math.floor(t.width * e), Math.floor(t.height * e)), r = n.getContext("2d");
      return this.config.blur && (r.filter = `blur(${n.width / 2048}px)`), r.drawImage(t, 0, 0, n.width, n.height), T1(n);
    }
    return T1(t);
  }
  createMesh(t) {
    const e = t.croppedX / t.fullWidth * 2 * Math.PI, n = t.croppedWidth / t.fullWidth * 2 * Math.PI, r = t.croppedY / t.fullHeight * Math.PI, i = t.croppedHeight / t.fullHeight * Math.PI, o = new dc(
      Ho,
      Math.round(this.SPHERE_SEGMENTS / (2 * Math.PI) * n),
      Math.round(this.SPHERE_HORIZONTAL_SEGMENTS / Math.PI * i),
      -Math.PI / 2 + e,
      n,
      r,
      i
    ).scale(-1, 1, 1), a = new cc({ depthTest: !1, depthWrite: !1 });
    return new rr(o, a);
  }
  setTexture(t, e) {
    t.material.map = e.texture;
  }
  setTextureOpacity(t, e) {
    t.material.opacity = e, t.material.transparent = e < 1;
  }
  disposeTexture({ texture: t }) {
    t.dispose();
  }
  disposeMesh(t) {
    t.geometry.dispose(), t.material.dispose();
  }
};
hc.id = "equirectangular";
hc.VERSION = "5.13.2";
hc.supportsDownload = !0;
var qb = class extends hc {
  constructor(t, e) {
    super(t, {
      resolution: (e == null ? void 0 : e.resolution) ?? 64,
      useXmpData: !1
    });
  }
  async loadTexture(t, e) {
    const n = await super.loadTexture(t, e, null, !1);
    return n.panoData = null, n;
  }
  createMesh() {
    const t = new dc(
      Ho,
      this.SPHERE_SEGMENTS,
      this.SPHERE_HORIZONTAL_SEGMENTS
    ).scale(-1, 1, 1).toNonIndexed(), e = t.getAttribute("uv"), n = t.getAttribute("normal");
    for (let i = 0; i < e.count; i++)
      for (let o = 0; o < 3; o++) {
        const a = i * 3 + o, s = n.getX(a), l = n.getY(a), c = n.getZ(a), u = 0.947;
        if (i < e.count / 6) {
          const d = s === 0 && c === 0 ? 1 : Math.acos(l) / Math.sqrt(s * s + c * c) * (2 / Math.PI);
          e.setXY(
            a,
            s * (u / 4) * d + 1 / 4,
            c * (u / 2) * d + 1 / 2
          );
        } else {
          const d = s === 0 && c === 0 ? 1 : Math.acos(-l) / Math.sqrt(s * s + c * c) * (2 / Math.PI);
          e.setXY(
            a,
            -s * (u / 4) * d + 3 / 4,
            c * (u / 2) * d + 1 / 2
          );
        }
      }
    t.rotateX(-Math.PI / 2), t.rotateY(Math.PI);
    const r = new cc({ depthTest: !1, depthWrite: !1 });
    return new rr(t, r);
  }
};
qb.id = "dual-fisheye";
qb.VERSION = "5.13.2";
var Ko = class Xb {
  constructor(e, n) {
    this.parent = e, this.children = [], this.state = {
      visible: !0
    }, this.viewer = e instanceof Xb ? e.viewer : e, this.container = document.createElement(n.tagName ?? "div"), this.container.className = n.className || "", this.parent.children.push(this), this.parent.container.appendChild(this.container);
  }
  /**
   * Destroys the component
   */
  destroy() {
    this.parent.container.removeChild(this.container);
    const e = this.parent.children.indexOf(this);
    e !== -1 && this.parent.children.splice(e, 1), this.children.slice().forEach((n) => n.destroy()), this.children.length = 0;
  }
  /**
   * Displays or hides the component
   */
  toggle(e = !this.isVisible()) {
    e ? this.show() : this.hide();
  }
  /**
   * Hides the component
   */
  // @ts-ignore unused parameter
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  hide(e) {
    this.container.style.display = "none", this.state.visible = !1;
  }
  /**
   * Displays the component
   */
  // @ts-ignore unused parameter
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  show(e) {
    this.container.style.display = "", this.state.visible = !0;
  }
  /**
   * Checks if the component is visible
   */
  isVisible() {
    return this.state.visible;
  }
}, eae = nf({
  id: null,
  tagName: null,
  className: null,
  title: null,
  hoverScale: !1,
  collapsable: !1,
  tabbable: !0,
  icon: null,
  iconActive: null
}), jn = class extends Ko {
  constructor(t, e) {
    super(t, {
      tagName: e.tagName,
      className: `psv-button ${e.hoverScale ? "psv-button--hover-scale" : ""} ${e.className || ""}`
    }), this.state = {
      visible: !0,
      enabled: !0,
      supported: !0,
      collapsed: !1,
      active: !1,
      width: 0
    }, this.config = eae(e), e.id || (this.config.id = this.constructor.id), e.icon && this.__setIcon(e.icon), this.state.width = this.container.offsetWidth, this.config.title ? this.container.title = this.viewer.config.lang[this.config.title] ?? this.config.title : this.id && this.id in this.viewer.config.lang && (this.container.title = this.viewer.config.lang[this.id]), e.tabbable && (this.container.tabIndex = 0), this.container.addEventListener("click", (n) => {
      this.state.enabled && this.onClick(), n.stopPropagation();
    }), this.container.addEventListener("keydown", (n) => {
      n.key === sn.Enter && this.state.enabled && (this.onClick(), n.stopPropagation());
    });
  }
  get id() {
    return this.config.id;
  }
  get title() {
    return this.container.title;
  }
  get content() {
    return this.container.innerHTML;
  }
  get width() {
    return this.state.width;
  }
  get collapsable() {
    return this.config.collapsable;
  }
  show(t = !0) {
    this.isVisible() || (this.state.visible = !0, this.state.collapsed || (this.container.style.display = ""), t && this.viewer.navbar.autoSize());
  }
  hide(t = !0) {
    this.isVisible() && (this.state.visible = !1, this.container.style.display = "none", t && this.viewer.navbar.autoSize());
  }
  /**
   * Hides/shows the button depending of the result of {@link isSupported}
   * @internal
   */
  checkSupported() {
    I2(this.isSupported(), (t, e) => {
      this.state && (this.state.supported = t, e ? t || this.hide() : this.toggle(t));
    });
  }
  /**
   * Perform action when the navbar size/content changes
   * @internal
   */
  autoSize() {
  }
  /**
   * Checks if the button can be displayed
   */
  isSupported() {
    return !0;
  }
  /**
   * Changes the active state of the button
   */
  toggleActive(t = !this.state.active) {
    t !== this.state.active && (this.state.active = t, Qd(this.container, "psv-button--active", this.state.active), this.config.iconActive && this.__setIcon(this.state.active ? this.config.iconActive : this.config.icon));
  }
  /**
   * Disables the button
   */
  disable() {
    this.container.classList.add("psv-button--disabled"), this.state.enabled = !1;
  }
  /**
   * Enables the button
   */
  enable() {
    this.container.classList.remove("psv-button--disabled"), this.state.enabled = !0;
  }
  /**
   * Collapses the button in the navbar menu
   */
  collapse() {
    this.state.collapsed = !0, this.container.style.display = "none";
  }
  /**
   * Uncollapses the button from the navbar menu
   */
  uncollapse() {
    this.state.collapsed = !1, this.state.visible && (this.container.style.display = "");
  }
  __setIcon(t) {
    this.container.innerHTML = t, k2(this.container.querySelector("svg"), "psv-button-svg");
  }
}, tae = class extends jn {
  constructor(t, e) {
    var n, r;
    super(t, {
      id: e.id ?? `psvButton-${Math.random().toString(36).substring(2)}`,
      className: `psv-custom-button ${e.className || ""}`,
      hoverScale: !1,
      collapsable: e.collapsable !== !1,
      tabbable: e.tabbable !== !1,
      title: e.title
    }), this.customOnClick = e.onClick, e.content && (typeof e.content == "string" ? this.container.innerHTML = e.content : (this.container.classList.add("psv-custom-button--no-padding"), e.content.style.height = "100%", (r = (n = e.content).attachViewer) == null || r.call(n, this.viewer), this.container.appendChild(e.content))), this.state.width = this.container.offsetWidth, e.disabled && this.disable(), e.visible === !1 && this.hide();
  }
  onClick() {
    var t;
    (t = this.customOnClick) == null || t.call(this, this.viewer);
  }
}, Hl = class extends jn {
  constructor(t) {
    super(t, {
      className: "psv-description-button",
      hoverScale: !0,
      collapsable: !1,
      tabbable: !0,
      icon: Er.info
    }), this.mode = 0, this.viewer.addEventListener(bl.type, this), this.viewer.addEventListener(Cl.type, this), this.viewer.addEventListener(Vi.type, this), this.viewer.addEventListener(Wi.type, this), this.viewer.addEventListener(Ln.type, this);
  }
  destroy() {
    this.viewer.removeEventListener(bl.type, this), this.viewer.removeEventListener(Cl.type, this), this.viewer.removeEventListener(Vi.type, this), this.viewer.removeEventListener(Wi.type, this), this.viewer.removeEventListener(Ln.type, this), super.destroy();
  }
  handleEvent(t) {
    if (t instanceof Ln) {
      t.containsOptions("description") && this.autoSize(!0);
      return;
    }
    if (!this.mode)
      return;
    let e = !1;
    t instanceof bl ? e = this.mode === 1 : t instanceof Cl ? e = this.mode === 1 && t.notificationId !== mn.DESCRIPTION : t instanceof Vi ? e = this.mode === 2 : t instanceof Wi && (e = this.mode === 2 && t.panelId !== mn.DESCRIPTION), e && (this.toggleActive(!1), this.mode = 0);
  }
  onClick() {
    this.mode ? this.__close() : this.__open();
  }
  hide(t) {
    super.hide(t), this.mode && this.__close();
  }
  /**
   * This button can only be refreshed from NavbarCaption
   * @internal
   */
  autoSize(t = !1) {
    if (t) {
      const e = this.viewer.navbar.getButton("caption", !1), n = e && !e.isVisible(), r = !!this.viewer.config.description;
      n || r ? this.show(!1) : this.hide(!1);
    }
  }
  __close() {
    switch (this.mode) {
      case 1:
        this.viewer.notification.hide(mn.DESCRIPTION);
        break;
      case 2:
        this.viewer.panel.hide(mn.DESCRIPTION);
        break;
    }
  }
  __open() {
    this.toggleActive(!0), this.viewer.config.description ? (this.mode = 2, this.viewer.panel.show({
      id: mn.DESCRIPTION,
      content: `${this.viewer.config.caption ? `<p>${this.viewer.config.caption}</p>` : ""}${this.viewer.config.description}`
    })) : (this.mode = 1, this.viewer.notification.show({
      id: mn.DESCRIPTION,
      content: this.viewer.config.caption
    }));
  }
};
Hl.id = "description";
var Yb = class extends jn {
  constructor(t) {
    super(t, {
      tagName: "a",
      className: "psv-download-button",
      hoverScale: !0,
      collapsable: !0,
      tabbable: !0,
      icon: Er.download
    }), this.viewer.addEventListener(Ln.type, this), this.viewer.addEventListener(Ja.type, this);
  }
  destroy() {
    this.viewer.removeEventListener(Ln.type, this), this.viewer.removeEventListener(Ja.type, this), super.destroy();
  }
  handleEvent(t) {
    t instanceof Ln ? (t.containsOptions("downloadUrl") && this.checkSupported(), t.containsOptions("downloadUrl", "downloadName") && this.__update()) : t instanceof Ja && this.__update();
  }
  onClick() {
  }
  checkSupported() {
    this.viewer.adapter.constructor.supportsDownload || this.viewer.config.downloadUrl ? this.show() : this.hide();
  }
  __update() {
    const t = this.container;
    t.href = this.viewer.config.downloadUrl || this.viewer.config.panorama, t.target = "_blank", t.href.startsWith("data:") && !this.viewer.config.downloadName ? t.download = "panorama." + t.href.substring(0, t.href.indexOf(";")).split("/").pop() : t.download = this.viewer.config.downloadName || t.href.split("/").pop();
  }
};
Yb.id = "download";
var Zb = class extends jn {
  constructor(t) {
    super(t, {
      className: "psv-fullscreen-button",
      hoverScale: !0,
      collapsable: !1,
      tabbable: !0,
      icon: Er.fullscreenIn,
      iconActive: Er.fullscreenOut
    }), this.viewer.addEventListener(yl.type, this);
  }
  destroy() {
    this.viewer.removeEventListener(yl.type, this), super.destroy();
  }
  handleEvent(t) {
    t instanceof yl && this.toggleActive(t.fullscreenEnabled);
  }
  onClick() {
    this.viewer.toggleFullscreen();
  }
};
Zb.id = "fullscreen";
var nae = "psvButton", rae = (t, e) => `
<div class="psv-panel-menu psv-panel-menu--stripped">
  <h1 class="psv-panel-menu-title">${Er.menu} ${e}</h1>
  <ul class="psv-panel-menu-list">
    ${t.map(
  (n) => `
    <li data-psv-button="${n.id}" class="psv-panel-menu-item" tabindex="0">
      <span class="psv-panel-menu-item-icon">${n.content}</span>
      <span class="psv-panel-menu-item-label">${n.title}</span>
    </li>
    `
).join("")}
  </ul>
</div>
`, Lu = class extends jn {
  constructor(t) {
    super(t, {
      className: "psv-menu-button",
      hoverScale: !0,
      collapsable: !1,
      tabbable: !0,
      icon: Er.menu
    }), this.viewer.addEventListener(Wi.type, this), this.viewer.addEventListener(Vi.type, this), super.hide();
  }
  destroy() {
    this.viewer.removeEventListener(Wi.type, this), this.viewer.removeEventListener(Vi.type, this), super.destroy();
  }
  handleEvent(t) {
    t instanceof Wi ? this.toggleActive(t.panelId === mn.MENU) : t instanceof Vi && this.toggleActive(!1);
  }
  onClick() {
    this.state.active ? this.__hideMenu() : this.__showMenu();
  }
  hide(t) {
    super.hide(t), this.__hideMenu();
  }
  show(t) {
    super.show(t), this.state.active && this.__showMenu();
  }
  __showMenu() {
    this.viewer.panel.show({
      id: mn.MENU,
      content: rae(this.viewer.navbar.collapsed, this.viewer.config.lang.menu),
      noMargin: !0,
      clickHandler: (t) => {
        const e = t ? iy(t, ".psv-panel-menu-item") : void 0, n = e ? e.dataset[nae] : void 0;
        n && (this.viewer.navbar.getButton(n).onClick(), this.__hideMenu());
      }
    });
  }
  __hideMenu() {
    this.viewer.panel.hide(mn.MENU);
  }
};
Lu.id = "menu";
function iae(t) {
  let e = 0;
  switch (t) {
    case 0:
      e = 90;
      break;
    case 1:
      e = -90;
      break;
    case 3:
      e = 180;
      break;
    default:
      e = 0;
      break;
  }
  return Er.arrow.replace("rotate(0", `rotate(${e}`);
}
var pc = class extends jn {
  constructor(t, e) {
    super(t, {
      className: "psv-move-button",
      hoverScale: !0,
      collapsable: !1,
      tabbable: !0,
      icon: iae(e)
    }), this.direction = e, this.handler = new rf(), this.container.addEventListener("mousedown", this), this.container.addEventListener("keydown", this), this.container.addEventListener("keyup", this), this.viewer.container.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchend", this);
  }
  destroy() {
    this.__onMouseUp(), this.viewer.container.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchend", this), super.destroy();
  }
  handleEvent(t) {
    switch (t.type) {
      case "mousedown":
        this.__onMouseDown();
        break;
      case "mouseup":
        this.__onMouseUp();
        break;
      case "touchend":
        this.__onMouseUp();
        break;
      case "keydown":
        t.key === sn.Enter && this.__onMouseDown();
        break;
      case "keyup":
        t.key === sn.Enter && this.__onMouseUp();
        break;
    }
  }
  onClick() {
  }
  isSupported() {
    return tf(Cn.isTouchEnabled);
  }
  __onMouseDown() {
    if (!this.state.enabled)
      return;
    const t = {};
    switch (this.direction) {
      case 0:
        t.pitch = !1;
        break;
      case 1:
        t.pitch = !0;
        break;
      case 3:
        t.yaw = !1;
        break;
      default:
        t.yaw = !0;
        break;
    }
    this.viewer.stopAll(), this.viewer.dynamics.position.roll(t), this.handler.down();
  }
  __onMouseUp() {
    this.state.enabled && this.handler.up(() => {
      this.viewer.dynamics.position.stop(), this.viewer.resetIdleTimer();
    });
  }
};
pc.groupId = "move";
var Kb = class extends pc {
  constructor(t) {
    super(
      t,
      1
      /* DOWN */
    );
  }
};
Kb.id = "moveDown";
var Jb = class extends pc {
  constructor(t) {
    super(
      t,
      2
      /* LEFT */
    );
  }
};
Jb.id = "moveLeft";
var Qb = class extends pc {
  constructor(t) {
    super(
      t,
      3
      /* RIGHT */
    );
  }
};
Qb.id = "moveRight";
var ex = class extends pc {
  constructor(t) {
    super(
      t,
      0
      /* UP */
    );
  }
};
ex.id = "moveUp";
var V2 = class extends jn {
  constructor(t, e, n) {
    super(t, {
      className: "psv-zoom-button",
      hoverScale: !0,
      collapsable: !1,
      tabbable: !0,
      icon: e
    }), this.direction = n, this.handler = new rf(), this.container.addEventListener("mousedown", this), this.container.addEventListener("keydown", this), this.container.addEventListener("keyup", this), this.viewer.container.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchend", this);
  }
  destroy() {
    this.__onMouseUp(), this.viewer.container.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchend", this), super.destroy();
  }
  handleEvent(t) {
    switch (t.type) {
      case "mousedown":
        this.__onMouseDown();
        break;
      case "mouseup":
        this.__onMouseUp();
        break;
      case "touchend":
        this.__onMouseUp();
        break;
      case "keydown":
        t.key === sn.Enter && this.__onMouseDown();
        break;
      case "keyup":
        t.key === sn.Enter && this.__onMouseUp();
        break;
    }
  }
  onClick() {
  }
  isSupported() {
    return tf(Cn.isTouchEnabled);
  }
  __onMouseDown() {
    this.state.enabled && (this.viewer.dynamics.zoom.roll(
      this.direction === 1
      /* OUT */
    ), this.handler.down());
  }
  __onMouseUp() {
    this.state.enabled && this.handler.up(() => this.viewer.dynamics.zoom.stop());
  }
};
V2.groupId = "zoom";
var tx = class extends V2 {
  constructor(t) {
    super(
      t,
      Er.zoomIn,
      0
      /* IN */
    );
  }
};
tx.id = "zoomIn";
var nx = class extends V2 {
  constructor(t) {
    super(
      t,
      Er.zoomOut,
      1
      /* OUT */
    );
  }
};
nx.id = "zoomOut";
var $2 = class extends jn {
  constructor(t) {
    super(t, {
      className: "psv-zoom-range",
      hoverScale: !1,
      collapsable: !1,
      tabbable: !1
    }), this.zoomRange = document.createElement("div"), this.zoomRange.className = "psv-zoom-range-line", this.container.appendChild(this.zoomRange), this.zoomValue = document.createElement("div"), this.zoomValue.className = "psv-zoom-range-handle", this.zoomRange.appendChild(this.zoomValue), this.slider = new Cy(this.container, "HORIZONTAL", (e) => this.__onSliderUpdate(e)), this.mediaMinWidth = parseInt(Fr(this.container, "max-width"), 10), this.viewer.addEventListener(si.type, this), this.viewer.state.ready ? this.__moveZoomValue(this.viewer.getZoomLevel()) : this.viewer.addEventListener(_l.type, this);
  }
  destroy() {
    this.slider.destroy(), this.viewer.removeEventListener(si.type, this), this.viewer.removeEventListener(_l.type, this), super.destroy();
  }
  handleEvent(t) {
    t instanceof si ? this.__moveZoomValue(t.zoomLevel) : t instanceof _l && this.__moveZoomValue(this.viewer.getZoomLevel());
  }
  onClick() {
  }
  isSupported() {
    return tf(Cn.isTouchEnabled);
  }
  autoSize() {
    this.state.supported && (this.viewer.state.size.width <= this.mediaMinWidth && this.state.visible ? this.hide(!1) : this.viewer.state.size.width > this.mediaMinWidth && !this.state.visible && this.show(!1));
  }
  __moveZoomValue(t) {
    this.zoomValue.style.left = t / 100 * this.zoomRange.offsetWidth - this.zoomValue.offsetWidth / 2 + "px";
  }
  __onSliderUpdate(t) {
    t.mousedown && this.viewer.zoom(t.value * 100);
  }
};
$2.id = "zoomRange";
$2.groupId = "zoom";
var rx = class extends Ey {
  constructor(t) {
    super(), this.viewer = t;
  }
  /**
   * Initializes the plugin
   */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  /**
   * Destroys the plugin
   */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  destroy() {
  }
}, oae = class extends rx {
  constructor(t, e) {
    super(t), this.config = this.constructor.configParser(e);
  }
  /**
   * Update options
   */
  setOption(t, e) {
    this.setOptions({ [t]: e });
  }
  /**
   * Update options
   */
  setOptions(t) {
    const e = {
      ...this.config,
      ...t
    }, n = this.constructor, r = n.configParser, i = n.readonlyOptions, o = n.id;
    for (let [a, s] of Object.entries(t)) {
      if (!(a in r.defaults)) {
        vn(`${o}: Unknown option "${a}"`);
        continue;
      }
      if (i.includes(a)) {
        vn(`${o}: Option "${a}" cannot be updated`);
        continue;
      }
      a in r.parsers && (s = r.parsers[a](s, {
        rawConfig: e,
        defValue: r.defaults[a]
      })), this.config[a] = s;
    }
  }
};
oae.readonlyOptions = [];
function R1(t) {
  if (t) {
    for (const [, e] of [["_", t], ...Object.entries(t)])
      if (e.prototype instanceof rx)
        return z2(e.id, e.VERSION, "5.13.2"), e;
  }
  return null;
}
var Bo = {
  panorama: null,
  container: null,
  adapter: [hc, null],
  plugins: [],
  caption: null,
  description: null,
  downloadUrl: null,
  downloadName: null,
  loadingImg: null,
  loadingTxt: "",
  // empty string => `lang.loading`
  size: null,
  fisheye: 0,
  minFov: 30,
  maxFov: 90,
  defaultZoomLvl: 50,
  defaultYaw: 0,
  defaultPitch: 0,
  sphereCorrection: null,
  moveSpeed: 1,
  zoomSpeed: 1,
  moveInertia: 0.8,
  mousewheel: !0,
  mousemove: !0,
  mousewheelCtrlKey: !1,
  touchmoveTwoFingers: !1,
  panoData: null,
  requestHeaders: null,
  canvasBackground: "#000",
  defaultTransition: {
    speed: 1500,
    rotation: !0,
    effect: "fade"
  },
  rendererParameters: { alpha: !0, antialias: !0 },
  withCredentials: !1,
  navbar: [
    "zoom",
    "move",
    "download",
    "description",
    "caption",
    "fullscreen"
  ],
  lang: {
    zoom: "Zoom",
    zoomOut: "Zoom out",
    zoomIn: "Zoom in",
    moveUp: "Move up",
    moveDown: "Move down",
    moveLeft: "Move left",
    moveRight: "Move right",
    description: "Description",
    download: "Download",
    fullscreen: "Fullscreen",
    loading: "Loading...",
    menu: "Menu",
    close: "Close",
    twoFingers: "Use two fingers to navigate",
    ctrlZoom: "Use ctrl + scroll to zoom the image",
    loadError: "The panorama cannot be loaded",
    webglError: "Your browser does not seem to support WebGL"
  },
  keyboard: "fullscreen",
  keyboardActions: {
    [sn.ArrowUp]: "ROTATE_UP",
    [sn.ArrowDown]: "ROTATE_DOWN",
    [sn.ArrowRight]: "ROTATE_RIGHT",
    [sn.ArrowLeft]: "ROTATE_LEFT",
    [sn.PageUp]: "ZOOM_IN",
    [sn.PageDown]: "ZOOM_OUT",
    [sn.Plus]: "ZOOM_IN",
    [sn.Minus]: "ZOOM_OUT"
    /* ZOOM_OUT */
  }
}, Eg = {
  panorama: "Use setPanorama method to change the panorama",
  panoData: "Use setPanorama method to change the panorama",
  container: "Cannot change viewer container",
  adapter: "Cannot change adapter",
  plugins: "Cannot change plugins"
}, L1 = {
  container: (t) => {
    if (!t)
      throw new yt("No value given for container.");
    return t;
  },
  adapter: (t, { defValue: e }) => {
    if (t ? Array.isArray(t) ? t = [Cg(t[0]), t[1]] : t = [Cg(t), null] : t = e, !t[0])
      throw new yt("An undefined value was given for adapter.");
    if (!t[0].id)
      throw new yt("Adapter has no id.");
    return t;
  },
  defaultYaw: (t) => Lr(t),
  defaultPitch: (t) => Lr(t, !0),
  defaultZoomLvl: (t) => Mt.clamp(t, 0, 100),
  minFov: (t, { rawConfig: e }) => (e.maxFov < t && (vn("maxFov cannot be lower than minFov"), t = e.maxFov), Mt.clamp(t, 1, 179)),
  maxFov: (t, { rawConfig: e }) => (t < e.minFov && (t = e.minFov), Mt.clamp(t, 1, 179)),
  moveInertia: (t, { defValue: e }) => t === !0 ? e : t === !1 ? 0 : t,
  lang: (t) => ({
    ...Bo.lang,
    ...t
  }),
  keyboardActions: (t, { rawConfig: e }) => e.keyboard && typeof e.keyboard == "object" ? e.keyboard : t,
  fisheye: (t) => t === !0 ? 1 : t === !1 ? 0 : t,
  requestHeaders: (t) => t && typeof t == "object" ? () => t : typeof t == "function" ? t : null,
  defaultTransition: (t, { defValue: e }) => t === null || t.speed === 0 ? null : { ...e, ...t },
  rendererParameters: (t, { defValue: e }) => ({
    ...t,
    ...e
  }),
  plugins: (t) => t.map((e, n) => {
    if (Array.isArray(e) ? e = [R1(e[0]), e[1]] : e = [R1(e), null], !e[0])
      throw new yt(`An undefined value was given for plugin ${n}.`);
    if (!e[0].id)
      throw new yt(`Plugin ${n} has no id.`);
    return e;
  }),
  navbar: (t) => t === !1 ? null : t === !0 ? ef(Bo.navbar) : typeof t == "string" ? t.split(/[ ,]/) : t
}, aae = nf(Bo, L1), ja = class extends jn {
  constructor(t) {
    super(t, {
      className: "psv-caption",
      hoverScale: !1,
      collapsable: !1,
      tabbable: !0
    }), this.contentWidth = 0, this.state.width = 0, this.contentElt = document.createElement("div"), this.contentElt.className = "psv-caption-content", this.container.appendChild(this.contentElt), this.setCaption(this.viewer.config.caption);
  }
  hide() {
    this.contentElt.style.display = "none", this.state.visible = !1;
  }
  show() {
    this.contentElt.style.display = "", this.state.visible = !0;
  }
  onClick() {
  }
  /**
   * Changes the caption
   */
  setCaption(t) {
    this.show(), this.contentElt.innerHTML = t ?? "", this.contentElt.innerHTML ? this.contentWidth = this.contentElt.offsetWidth : this.contentWidth = 0, this.autoSize();
  }
  /**
   * Toggles content and icon depending on available space
   */
  autoSize() {
    this.toggle(this.container.offsetWidth >= this.contentWidth), this.__refreshButton();
  }
  __refreshButton() {
    var t;
    (t = this.viewer.navbar.getButton(Hl.id, !1)) == null || t.autoSize(!0);
  }
};
ja.id = "caption";
var O1 = {}, ud = {};
function sae(t, e) {
  if (!t.id)
    throw new yt("Button id is required");
  if (O1[t.id] = t, t.groupId && (ud[t.groupId] = ud[t.groupId] || []).push(t), e) {
    const n = Bo.navbar;
    switch (e) {
      case "start":
        n.unshift(t.id);
        break;
      case "end":
        n.push(t.id);
        break;
      default: {
        const [r, i] = e.split(":"), o = n.indexOf(r);
        if (!r || !i || o === -1)
          throw new yt(`Invalid defaultPosition ${e}`);
        n.splice(o + (i === "right" ? 1 : 0), 0, t.id);
      }
    }
  }
}
[
  nx,
  $2,
  tx,
  Hl,
  ja,
  Yb,
  Zb,
  Jb,
  Qb,
  ex,
  Kb
].forEach((t) => sae(t));
var lae = class extends Ko {
  /**
   * @internal
   */
  constructor(t) {
    super(t, {
      className: `psv-navbar ${fc}`
    }), this.collapsed = [], this.state.visible = !1;
  }
  /**
   * Shows the navbar
   */
  show() {
    this.viewer.container.classList.add("psv--has-navbar"), this.container.classList.add("psv-navbar--open"), this.state.visible = !0;
  }
  /**
   * Hides the navbar
   */
  hide() {
    this.viewer.container.classList.remove("psv--has-navbar"), this.container.classList.remove("psv-navbar--open"), this.state.visible = !1;
  }
  /**
   * Change the buttons visible on the navbar
   */
  setButtons(t) {
    this.children.slice().forEach((e) => e.destroy()), this.children.length = 0, t.indexOf(ja.id) !== -1 && t.indexOf(Hl.id) === -1 && t.splice(t.indexOf(ja.id), 0, Hl.id), t.forEach((e) => {
      typeof e == "object" ? new tae(this, e) : O1[e] ? new O1[e](this) : ud[e] ? ud[e].forEach((n) => {
        new n(this);
      }) : vn(`Unknown button ${e}`);
    }), new Lu(this), this.children.forEach((e) => {
      e instanceof jn && e.checkSupported();
    }), this.autoSize();
  }
  /**
   * Changes the navbar caption
   */
  setCaption(t) {
    this.children.some((e) => e instanceof ja ? (e.setCaption(t), !0) : !1);
  }
  /**
   * Returns a button by its identifier
   */
  getButton(t, e = !0) {
    const n = this.children.find((r) => r instanceof jn && r.id === t);
    return !n && e && vn(`button "${t}" not found in the navbar`), n;
  }
  /**
   * Try to focus a button, will focus the first button if the requested button does not exist.
   */
  focusButton(t) {
    var e, n;
    this.isVisible() && ((n = ((e = this.getButton(t, !1)) == null ? void 0 : e.container) || this.container.firstElementChild) == null || n.focus());
  }
  /**
   * Automatically collapses buttons
   * @internal
   */
  autoSize() {
    var r;
    this.children.forEach((i) => {
      i instanceof jn && i.autoSize();
    });
    const t = this.container.offsetWidth;
    let e = 0;
    const n = [];
    this.children.forEach((i) => {
      i.isVisible() && i instanceof jn && (e += i.width, i.collapsable && n.push(i));
    }), e !== 0 && (t < e && n.length > 0 ? (n.forEach((i) => i.collapse()), this.collapsed = n, this.getButton(Lu.id).show(!1)) : t >= e && this.collapsed.length > 0 && (this.collapsed.forEach((i) => i.uncollapse()), this.collapsed = [], this.getButton(Lu.id).hide(!1)), (r = this.getButton(ja.id, !1)) == null || r.autoSize());
  }
};
x1.enabled = !1;
var Ba = {
  enabled: !0,
  maxItems: 10,
  ttl: 10 * 60,
  items: {},
  purgeInterval: null,
  init() {
    x1.enabled && (vn("ThreeJS cache should be disabled"), x1.enabled = !1), !this.purgeInterval && this.enabled && (this.purgeInterval = setInterval(() => this.purge(), 60 * 1e3));
  },
  add(t, e, n) {
    this.enabled && e && (this.items[e] = this.items[e] ?? { files: {}, lastAccess: null }, this.items[e].files[t] = n, this.items[e].lastAccess = Date.now());
  },
  get(t, e) {
    if (this.enabled && e && this.items[e])
      return this.items[e].lastAccess = Date.now(), this.items[e].files[t];
  },
  remove(t, e) {
    this.enabled && e && this.items[e] && (delete this.items[e].files[t], Object.keys(this.items[e].files).length === 0 && delete this.items[e]);
  },
  purge() {
    Object.entries(this.items).sort(([, t], [, e]) => e.lastAccess - t.lastAccess).forEach(([t, { lastAccess: e }], n) => {
      n > 0 && (Date.now() - e >= this.ttl * 1e3 || n >= this.maxItems) && delete this.items[t];
    });
  }
}, cae = class extends Ko {
  /**
   * @internal
   */
  constructor(t) {
    super(t, { className: "psv-loader-container" }), this.loader = document.createElement("div"), this.loader.className = "psv-loader", this.container.appendChild(this.loader), this.size = this.loader.offsetWidth, this.canvas = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this.canvas.setAttribute("class", "psv-loader-canvas"), this.canvas.setAttribute("viewBox", `0 0 ${this.size} ${this.size}`), this.loader.appendChild(this.canvas), this.textColor = Fr(this.loader, "color"), this.color = Fr(this.canvas, "color"), this.border = parseInt(Fr(this.loader, "--psv-loader-border"), 10), this.thickness = parseInt(Fr(this.loader, "--psv-loader-tickness"), 10);
    const e = this.size / 2;
    this.canvas.innerHTML = `
            <circle cx="${e}" cy="${e}" r="${e}" fill="${this.color}"/>
            <path d="" fill="none" stroke="${this.textColor}" stroke-width="${this.thickness}" stroke-linecap="round"/>
        `, this.viewer.addEventListener(Ln.type, this), this.__updateContent(), this.hide();
  }
  /**
   * @internal
   */
  destroy() {
    this.viewer.removeEventListener(Ln.type, this), super.destroy();
  }
  /**
   * @internal
   */
  handleEvent(t) {
    t instanceof Ln && t.containsOptions("loadingImg", "loadingTxt", "lang") && this.__updateContent();
  }
  /**
   * Sets the loader progression
   */
  setProgress(t) {
    this.container.classList.remove("psv-loader--undefined");
    const e = Mt.clamp(t, 0, 99.999) / 100 * Math.PI * 2, n = this.size / 2, r = n, i = this.thickness / 2 + this.border, o = (this.size - this.thickness) / 2 - this.border, a = Math.sin(e) * o + n, s = -Math.cos(e) * o + n, l = t > 50 ? "1" : "0";
    this.canvas.querySelector("path").setAttributeNS(
      null,
      "d",
      `M ${r} ${i} A ${o} ${o} 0 ${l} 1 ${a} ${s}`
    );
  }
  /**
   * Animates the loader with an unknown state
   */
  showUndefined() {
    this.show(), this.setProgress(25), this.container.classList.add("psv-loader--undefined");
  }
  __updateContent() {
    const t = this.loader.querySelector(".psv-loader-image, .psv-loader-text");
    t && this.loader.removeChild(t);
    let e;
    if (this.viewer.config.loadingImg ? (e = document.createElement("img"), e.className = "psv-loader-image", e.src = this.viewer.config.loadingImg) : this.viewer.config.loadingTxt !== null && (e = document.createElement("div"), e.className = "psv-loader-text", e.innerHTML = this.viewer.config.loadingTxt || this.viewer.config.lang.loading), e) {
      const n = Math.round(Math.sqrt(2 * Math.pow(this.size / 2 - this.thickness / 2 - this.border, 2)));
      e.style.maxWidth = n + "px", e.style.maxHeight = n + "px", this.loader.appendChild(e);
    }
  }
}, uae = class extends Ko {
  /**
   * @internal
   */
  constructor(t) {
    super(t, {
      className: "psv-notification"
    }), this.state = {
      visible: !1,
      contentId: null,
      timeout: null
    }, this.content = document.createElement("div"), this.content.className = "psv-notification-content", this.container.appendChild(this.content), this.content.addEventListener("click", () => this.hide());
  }
  /**
   * Checks if the notification is visible
   */
  isVisible(t) {
    return this.state.visible && (!t || !this.state.contentId || this.state.contentId === t);
  }
  /**
   * @throws {@link PSVError} always
   * @internal
   */
  toggle() {
    throw new yt("Notification cannot be toggled");
  }
  /**
   * Displays a notification on the viewer
   *
   * @example
   * viewer.showNotification({ content: 'Hello world', timeout: 5000 })
   * @example
   * viewer.showNotification('Hello world')
   */
  show(t) {
    this.state.timeout && (clearTimeout(this.state.timeout), this.state.timeout = null), typeof t == "string" && (t = { content: t }), this.state.contentId = t.id || null, this.content.innerHTML = t.content, this.container.classList.add("psv-notification--visible"), this.state.visible = !0, this.viewer.dispatchEvent(new Cl(this.state.contentId)), t.timeout && (this.state.timeout = setTimeout(() => this.hide(this.state.contentId), t.timeout));
  }
  /**
   * Hides the notification
   */
  hide(t) {
    if (this.isVisible(t)) {
      const e = this.state.contentId;
      this.container.classList.remove("psv-notification--visible"), this.state.visible = !1, this.state.contentId = null, this.viewer.dispatchEvent(new bl(e));
    }
  }
}, dae = class extends Ko {
  /**
   * @internal
   */
  constructor(t) {
    super(t, {
      className: `psv-overlay ${fc}`
    }), this.state = {
      visible: !1,
      contentId: null,
      dismissible: !0
    }, this.image = document.createElement("div"), this.image.className = "psv-overlay-image", this.container.appendChild(this.image), this.title = document.createElement("div"), this.title.className = "psv-overlay-title", this.container.appendChild(this.title), this.text = document.createElement("div"), this.text.className = "psv-overlay-text", this.container.appendChild(this.text), this.container.addEventListener("click", this), this.viewer.addEventListener($i.type, this), super.hide();
  }
  /**
   * @internal
   */
  destroy() {
    this.viewer.removeEventListener($i.type, this), super.destroy();
  }
  /**
   * @internal
   */
  handleEvent(t) {
    t.type === "click" ? this.isVisible() && this.state.dismissible && (this.hide(), t.stopPropagation()) : t instanceof $i && this.isVisible() && this.state.dismissible && t.key === sn.Escape && (this.hide(), t.preventDefault());
  }
  /**
   * Checks if the overlay is visible
   */
  isVisible(t) {
    return this.state.visible && (!t || !this.state.contentId || this.state.contentId === t);
  }
  /**
   * @throws {@link PSVError} always
   * @internal
   */
  toggle() {
    throw new yt("Overlay cannot be toggled");
  }
  /**
   * Displays an overlay on the viewer
   */
  show(t) {
    typeof t == "string" && (t = { title: t }), this.state.contentId = t.id || null, this.state.dismissible = t.dismissible !== !1, this.image.innerHTML = t.image || "", this.title.innerHTML = t.title || "", this.text.innerHTML = t.text || "", super.show(), this.viewer.dispatchEvent(new Tb(this.state.contentId));
  }
  /**
   * Hides the overlay
   */
  hide(t) {
    if (this.isVisible(t)) {
      const e = this.state.contentId;
      super.hide(), this.state.contentId = null, this.viewer.dispatchEvent(new Gy(e));
    }
  }
}, fae = 200, H0 = "psv-panel-content--no-interaction", hae = class extends Ko {
  /**
   * @internal
   */
  constructor(e) {
    super(e, {
      className: `psv-panel ${fc}`
    }), this.state = {
      visible: !1,
      contentId: null,
      mouseX: 0,
      mouseY: 0,
      mousedown: !1,
      clickHandler: null,
      keyHandler: null,
      width: {}
    };
    const n = document.createElement("div");
    n.className = "psv-panel-resizer", this.container.appendChild(n);
    const r = document.createElement("div");
    r.className = "psv-panel-close-button", r.innerHTML = Er.close, r.title = e.config.lang.close, this.container.appendChild(r), this.content = document.createElement("div"), this.content.className = "psv-panel-content", this.container.appendChild(this.content), r.addEventListener("click", () => this.hide()), n.addEventListener("mousedown", this), n.addEventListener("touchstart", this), this.viewer.container.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchend", this), this.viewer.container.addEventListener("mousemove", this), this.viewer.container.addEventListener("touchmove", this), this.viewer.addEventListener($i.type, this);
  }
  /**
   * @internal
   */
  destroy() {
    this.viewer.removeEventListener($i.type, this), this.viewer.container.removeEventListener("mousemove", this), this.viewer.container.removeEventListener("touchmove", this), this.viewer.container.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchend", this), super.destroy();
  }
  /**
   * @internal
   */
  handleEvent(e) {
    switch (e.type) {
      case "mousedown":
        this.__onMouseDown(e);
        break;
      case "touchstart":
        this.__onTouchStart(e);
        break;
      case "mousemove":
        this.__onMouseMove(e);
        break;
      case "touchmove":
        this.__onTouchMove(e);
        break;
      case "mouseup":
        this.__onMouseUp(e);
        break;
      case "touchend":
        this.__onTouchEnd(e);
        break;
      case $i.type:
        this.__onKeyPress(e);
        break;
    }
  }
  /**
   * Checks if the panel is visible
   */
  isVisible(e) {
    return this.state.visible && (!e || !this.state.contentId || this.state.contentId === e);
  }
  /**
   * @throws {@link PSVError} always
   * @internal
   */
  toggle() {
    throw new yt("Panel cannot be toggled");
  }
  /**
   * Shows the panel
   */
  show(e) {
    typeof e == "string" && (e = { content: e });
    const n = this.isVisible(e.id);
    this.state.contentId = e.id || null, this.state.visible = !0, this.state.clickHandler && (this.content.removeEventListener("click", this.state.clickHandler), this.content.removeEventListener("keydown", this.state.keyHandler), this.state.clickHandler = null, this.state.keyHandler = null), e.id && this.state.width[e.id] ? this.container.style.width = this.state.width[e.id] : e.width ? this.container.style.width = e.width : this.container.style.width = null, this.content.innerHTML = e.content, this.content.scrollTop = 0, this.container.classList.add("psv-panel--open"), Qd(this.content, "psv-panel-content--no-margin", e.noMargin === !0), e.clickHandler && (this.state.clickHandler = (r) => {
      e.clickHandler(od(r));
    }, this.state.keyHandler = (r) => {
      r.key === sn.Enter && e.clickHandler(od(r));
    }, this.content.addEventListener("click", this.state.clickHandler), this.content.addEventListener("keydown", this.state.keyHandler), n || setTimeout(() => {
      var r;
      (r = this.content.querySelector("a,button,[tabindex]")) == null || r.focus();
    }, 300)), this.viewer.dispatchEvent(new Wi(this.state.contentId));
  }
  /**
   * Hides the panel
   */
  hide(e) {
    if (this.isVisible(e)) {
      const n = this.state.contentId;
      this.state.visible = !1, this.state.contentId = null, this.content.innerHTML = null, this.container.classList.remove("psv-panel--open"), this.state.clickHandler && (this.content.removeEventListener("click", this.state.clickHandler), this.content.removeEventListener("keydown", this.state.keyHandler), this.state.clickHandler = null, this.state.keyHandler = null), this.viewer.dispatchEvent(new Vi(n));
    }
  }
  __onMouseDown(e) {
    e.stopPropagation(), this.__startResize(e.clientX, e.clientY);
  }
  __onTouchStart(e) {
    if (e.stopPropagation(), e.touches.length === 1) {
      const n = e.touches[0];
      this.__startResize(n.clientX, n.clientY);
    }
  }
  __onMouseUp(e) {
    this.state.mousedown && (e.stopPropagation(), this.state.mousedown = !1, this.content.classList.remove(H0));
  }
  __onTouchEnd(e) {
    this.state.mousedown && (e.stopPropagation(), e.touches.length === 0 && (this.state.mousedown = !1, this.content.classList.remove(H0)));
  }
  __onMouseMove(e) {
    this.state.mousedown && (e.stopPropagation(), this.__resize(e.clientX, e.clientY));
  }
  __onTouchMove(e) {
    if (this.state.mousedown) {
      const n = e.touches[0];
      this.__resize(n.clientX, n.clientY);
    }
  }
  __onKeyPress(e) {
    this.isVisible() && e.key === sn.Escape && (this.hide(), e.preventDefault());
  }
  __startResize(e, n) {
    this.state.mouseX = e, this.state.mouseY = n, this.state.mousedown = !0, this.content.classList.add(H0);
  }
  __resize(e, n) {
    const r = e, i = n, o = Math.max(fae, this.container.offsetWidth - (r - this.state.mouseX)) + "px";
    this.state.contentId && (this.state.width[this.state.contentId] = o), this.container.style.width = o, this.state.mouseX = r, this.state.mouseY = i;
  }
}, pae = class extends Ko {
  /**
   * @internal
   */
  constructor(e, n) {
    super(e, {
      className: "psv-tooltip"
    }), this.state = {
      visible: !0,
      arrow: 0,
      border: 0,
      state: 0,
      width: 0,
      height: 0,
      pos: "",
      config: null,
      data: null,
      hideTimeout: null
    }, this.content = document.createElement("div"), this.content.className = "psv-tooltip-content", this.container.appendChild(this.content), this.arrow = document.createElement("div"), this.arrow.className = "psv-tooltip-arrow", this.container.appendChild(this.arrow), this.container.addEventListener("transitionend", this), this.container.addEventListener("touchdown", (r) => r.stopPropagation()), this.container.addEventListener("mousedown", (r) => r.stopPropagation()), this.container.style.top = "-1000px", this.container.style.left = "-1000px", this.show(n);
  }
  /**
   * @internal
   */
  handleEvent(e) {
    e.type === "transitionend" && this.__onTransitionEnd(e);
  }
  /**
   * @internal
   */
  destroy() {
    clearTimeout(this.state.hideTimeout), delete this.state.data, super.destroy();
  }
  /**
   * @throws {@link PSVError} always
   * @internal
   */
  toggle() {
    throw new yt("Tooltip cannot be toggled");
  }
  /**
   * Displays the tooltip on the viewer
   * @internal
   */
  show(e) {
    if (this.state.state !== 0)
      throw new yt("Initialized tooltip cannot be re-initialized");
    e.className && k2(this.container, e.className), e.style && Object.assign(this.container.style, e.style), this.state.state = 3, this.update(e.content, e), this.state.data = e.data, this.state.state = 1, this.viewer.dispatchEvent(new Ob(this, this.state.data)), this.__waitImages();
  }
  /**
   * Updates the content of the tooltip, optionally with a new position
   * @throws {@link PSVError} if the configuration is invalid
   */
  update(e, n) {
    this.content.innerHTML = e;
    const r = this.container.getBoundingClientRect();
    this.state.width = r.right - r.left, this.state.height = r.bottom - r.top, this.state.arrow = parseInt(Fr(this.arrow, "border-top-width"), 10), this.state.border = parseInt(Fr(this.container, "border-top-left-radius"), 10), this.move(n ?? this.state.config), this.__waitImages();
  }
  /**
   * Moves the tooltip to a new position
   * @throws {@link PSVError} if the configuration is invalid
   */
  move(e) {
    var l;
    if (this.state.state !== 1 && this.state.state !== 3)
      throw new yt("Uninitialized tooltip cannot be moved");
    e.box = e.box ?? ((l = this.state.config) == null ? void 0 : l.box) ?? { width: 0, height: 0 }, this.state.config = e;
    const n = this.container, r = this.arrow, i = {
      posClass: vy(e.position, { allowCenter: !1, cssOrder: !1 }) || ["top", "center"],
      width: this.state.width,
      height: this.state.height,
      top: 0,
      left: 0,
      arrowTop: 0,
      arrowLeft: 0
    };
    this.__computeTooltipPosition(i, e);
    let o = null, a = null;
    if (i.top < 0 ? o = "bottom" : i.top + i.height > this.viewer.state.size.height && (o = "top"), i.left < 0 ? a = "right" : i.left + i.width > this.viewer.state.size.width && (a = "left"), a || o) {
      const c = U2(i.posClass);
      o && (i.posClass[c ? 0 : 1] = o), a && (i.posClass[c ? 1 : 0] = a), this.__computeTooltipPosition(i, e);
    }
    n.style.top = i.top + "px", n.style.left = i.left + "px", r.style.top = i.arrowTop + "px", r.style.left = i.arrowLeft + "px";
    const s = i.posClass.join("-");
    s !== this.state.pos && (n.classList.remove(`psv-tooltip--${this.state.pos}`), this.state.pos = s, n.classList.add(`psv-tooltip--${this.state.pos}`));
  }
  /**
   * Hides the tooltip
   */
  hide() {
    this.container.classList.remove("psv-tooltip--visible"), this.state.state = 2, this.viewer.dispatchEvent(new Ky(this.state.data));
    const e = parseFloat(Fr(this.container, "transition-duration"));
    this.state.hideTimeout = setTimeout(() => {
      this.destroy();
    }, e * 2);
  }
  /**
   * Finalize transition
   */
  __onTransitionEnd(e) {
    if (e.propertyName === "transform")
      switch (this.state.state) {
        case 1:
          this.container.classList.add("psv-tooltip--visible"), this.state.state = 3;
          break;
        case 2:
          this.state.state = 0, this.destroy();
          break;
      }
  }
  /**
   * Computes the position of the tooltip and its arrow
   */
  __computeTooltipPosition(e, n) {
    const r = this.state.arrow, i = n.top, o = e.height, a = n.left, s = e.width, l = r + this.state.border, c = n.box.width / 2 + r * 2, u = n.box.height / 2 + r * 2;
    switch (e.posClass.join("-")) {
      case "top-left":
        e.top = i - u - o, e.left = a + l - s, e.arrowTop = o, e.arrowLeft = s - l - r;
        break;
      case "top-center":
        e.top = i - u - o, e.left = a - s / 2, e.arrowTop = o, e.arrowLeft = s / 2 - r;
        break;
      case "top-right":
        e.top = i - u - o, e.left = a - l, e.arrowTop = o, e.arrowLeft = r;
        break;
      case "bottom-left":
        e.top = i + u, e.left = a + l - s, e.arrowTop = -r * 2, e.arrowLeft = s - l - r;
        break;
      case "bottom-center":
        e.top = i + u, e.left = a - s / 2, e.arrowTop = -r * 2, e.arrowLeft = s / 2 - r;
        break;
      case "bottom-right":
        e.top = i + u, e.left = a - l, e.arrowTop = -r * 2, e.arrowLeft = r;
        break;
      case "left-top":
        e.top = i + l - o, e.left = a - c - s, e.arrowTop = o - l - r, e.arrowLeft = s;
        break;
      case "center-left":
        e.top = i - o / 2, e.left = a - c - s, e.arrowTop = o / 2 - r, e.arrowLeft = s;
        break;
      case "left-bottom":
        e.top = i - l, e.left = a - c - s, e.arrowTop = r, e.arrowLeft = s;
        break;
      case "right-top":
        e.top = i + l - o, e.left = a + c, e.arrowTop = o - l - r, e.arrowLeft = -r * 2;
        break;
      case "center-right":
        e.top = i - o / 2, e.left = a + c, e.arrowTop = o / 2 - r, e.arrowLeft = -r * 2;
        break;
      case "right-bottom":
        e.top = i - l, e.left = a + c, e.arrowTop = r, e.arrowLeft = -r * 2;
        break;
    }
  }
  /**
   * If the tooltip contains images, recompute its size once they are loaded
   */
  __waitImages() {
    const e = this.content.querySelectorAll("img");
    if (e.length > 0) {
      const n = [];
      e.forEach((r) => {
        r.complete || n.push(
          new Promise((i) => {
            r.onload = i, r.onerror = i;
          })
        );
      }), n.length && Promise.all(n).then(() => {
        if (this.state.state === 1 || this.state.state === 3) {
          const r = this.container.getBoundingClientRect();
          this.state.width = r.right - r.left, this.state.height = r.bottom - r.top, this.move(this.state.config);
        }
      });
    }
  }
}, mae = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="15 15 70 70"><path fill="currentColor" d="M50,16.2c-18.6,0-33.8,15.1-33.8,33.8S31.4,83.7,50,83.7S83.8,68.6,83.8,50S68.6,16.2,50,16.2z M50,80.2c-16.7,0-30.2-13.6-30.2-30.2S33.3,19.7,50,19.7S80.3,33.3,80.3,50S66.7,80.2,50,80.2z"/><rect fill="currentColor" x="48" y="31.7" width="4" height="28"/><rect fill="currentColor" x="48" y="63.2" width="4" height="5"/><!--Created by Shastry from the Noun Project--></svg>
`, mc = class {
  /**
   * @internal
   */
  constructor(t) {
    this.viewer = t, this.config = t.config, this.state = t.state;
  }
  /**
   * Destroys the service
   * @internal
   */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  destroy() {
  }
}, pr = new re(), ru = new Vr(0, 0, 0, "ZXY"), vae = class extends mc {
  /**
   * @internal
   */
  constructor(t) {
    super(t);
  }
  /**
   * Converts vertical FOV to zoom level
   */
  fovToZoomLevel(t) {
    const e = Math.round((t - this.config.minFov) / (this.config.maxFov - this.config.minFov) * 100);
    return Mt.clamp(e - 2 * (e - 50), 0, 100);
  }
  /**
   * Converts zoom level to vertical FOV
   */
  zoomLevelToFov(t) {
    return this.config.maxFov + t / 100 * (this.config.minFov - this.config.maxFov);
  }
  /**
   * Converts vertical FOV to horizontal FOV
   */
  vFovToHFov(t) {
    return Mt.radToDeg(2 * Math.atan(Math.tan(Mt.degToRad(t) / 2) * this.state.aspect));
  }
  /**
   * Converts horizontal FOV to vertical FOV
   */
  hFovToVFov(t) {
    return Mt.radToDeg(2 * Math.atan(Math.tan(Mt.degToRad(t) / 2) / this.state.aspect));
  }
  /**
   * @internal
   */
  getAnimationProperties(t, e, n) {
    const r = !ln(e), i = !ln(n), o = {};
    let a = null;
    if (r) {
      const s = this.viewer.getPosition(), l = ty(s.yaw, e.yaw);
      o.yaw = { start: s.yaw, end: s.yaw + l }, o.pitch = { start: s.pitch, end: e.pitch }, a = M1(t, ny(s, e));
    }
    if (i) {
      const s = this.viewer.getZoomLevel(), l = Math.abs(n - s);
      o.zoom = { start: s, end: n }, a === null && (a = M1(t, Math.PI / 4 * l / 100));
    }
    return a === null ? typeof t == "number" ? a = t : a = C1 : a = Math.max(C1, a), { duration: a, properties: o };
  }
  /**
   * @internal
   */
  getTransitionOptions(t) {
    let e;
    const n = this.config.defaultTransition ?? Bo.defaultTransition;
    return t.transition === !1 || t.transition === null ? e = null : t.transition === !0 ? e = {
      ...n
    } : typeof t.transition == "object" ? e = {
      ...n,
      ...t.transition
    } : e = this.config.defaultTransition, e;
  }
  /**
   * Converts pixel texture coordinates to spherical radians coordinates
   * @throws {@link PSVError} when the current adapter does not support texture coordinates
   */
  textureCoordsToSphericalCoords(t) {
    var n;
    if (!((n = this.state.textureData) != null && n.panoData))
      throw new yt("Current adapter does not support texture coordinates or no texture has been loaded");
    const e = this.viewer.adapter.textureCoordsToSphericalCoords(t, this.state.textureData.panoData);
    return !ru.equals(this.viewer.renderer.panoramaPose) || !ru.equals(this.viewer.renderer.sphereCorrection) ? (this.sphericalCoordsToVector3(e, pr), pr.applyEuler(this.viewer.renderer.panoramaPose), pr.applyEuler(this.viewer.renderer.sphereCorrection), this.vector3ToSphericalCoords(pr)) : e;
  }
  /**
   * Converts spherical radians coordinates to pixel texture coordinates
   * @throws {@link PSVError} when the current adapter does not support texture coordinates
   */
  sphericalCoordsToTextureCoords(t) {
    var e;
    if (!((e = this.state.textureData) != null && e.panoData))
      throw new yt("Current adapter does not support texture coordinates or no texture has been loaded");
    return (!ru.equals(this.viewer.renderer.panoramaPose) || !ru.equals(this.viewer.renderer.sphereCorrection)) && (this.sphericalCoordsToVector3(t, pr), A1(pr, this.viewer.renderer.sphereCorrection), A1(pr, this.viewer.renderer.panoramaPose), t = this.vector3ToSphericalCoords(pr)), this.viewer.adapter.sphericalCoordsToTextureCoords(t, this.state.textureData.panoData);
  }
  /**
   * Converts spherical radians coordinates to a Vector3
   */
  sphericalCoordsToVector3(t, e, n = Ho) {
    return e || (e = new re()), e.x = n * -Math.cos(t.pitch) * Math.sin(t.yaw), e.y = n * Math.sin(t.pitch), e.z = n * Math.cos(t.pitch) * Math.cos(t.yaw), e;
  }
  /**
   * Converts a Vector3 to spherical radians coordinates
   */
  vector3ToSphericalCoords(t) {
    const e = Math.acos(t.y / Math.sqrt(t.x * t.x + t.y * t.y + t.z * t.z)), n = Math.atan2(t.x, t.z);
    return {
      yaw: n < 0 ? -n : Math.PI * 2 - n,
      pitch: Math.PI / 2 - e
    };
  }
  /**
   * Converts position on the viewer to a THREE.Vector3
   */
  viewerCoordsToVector3(t) {
    const e = this.viewer.renderer.getIntersections(t).filter((n) => n.object.userData[to]);
    return e.length ? e[0].point : null;
  }
  /**
   * Converts position on the viewer to spherical radians coordinates
   */
  viewerCoordsToSphericalCoords(t) {
    const e = this.viewerCoordsToVector3(t);
    return e ? this.vector3ToSphericalCoords(e) : null;
  }
  /**
   * Converts a Vector3 to position on the viewer
   */
  vector3ToViewerCoords(t) {
    const e = t.clone();
    return e.project(this.viewer.renderer.camera), {
      x: Math.round((e.x + 1) / 2 * this.state.size.width),
      y: Math.round((1 - e.y) / 2 * this.state.size.height)
    };
  }
  /**
   * Converts spherical radians coordinates to position on the viewer
   */
  sphericalCoordsToViewerCoords(t) {
    return this.sphericalCoordsToVector3(t, pr), this.vector3ToViewerCoords(pr);
  }
  /**
   * @internal
   */
  isPointVisible(t) {
    let e, n;
    if (t instanceof re)
      e = t, n = this.vector3ToViewerCoords(t);
    else if (F2(t))
      e = this.sphericalCoordsToVector3(t, pr), n = this.vector3ToViewerCoords(e);
    else
      return !1;
    return e.dot(this.viewer.state.direction) > 0 && n.x >= 0 && n.x <= this.viewer.state.size.width && n.y >= 0 && n.y <= this.viewer.state.size.height;
  }
  /**
   * Converts pixel position to angles if present and ensure boundaries
   */
  cleanPosition(t) {
    if ("yaw" in t || "pitch" in t) {
      if (!("yaw" in t) || !("pitch" in t))
        throw new yt("Position is missing 'yaw' or 'pitch'");
      return {
        yaw: Lr(t.yaw),
        pitch: Lr(t.pitch, !0)
      };
    } else
      return this.textureCoordsToSphericalCoords(t);
  }
  /**
   * Ensure a SphereCorrection object is valid
   */
  cleanSphereCorrection(t) {
    return {
      pan: Lr((t == null ? void 0 : t.pan) || 0),
      tilt: Lr((t == null ? void 0 : t.tilt) || 0, !0),
      roll: Lr((t == null ? void 0 : t.roll) || 0, !0, !1)
    };
  }
  /**
   * Parse the pose angles of the pano data
   */
  cleanPanoramaPose(t) {
    return {
      pan: Mt.degToRad((t == null ? void 0 : t.poseHeading) || 0),
      tilt: Mt.degToRad((t == null ? void 0 : t.posePitch) || 0),
      roll: Mt.degToRad((t == null ? void 0 : t.poseRoll) || 0)
    };
  }
  /**
   * Update the panorama options if the panorama files contains "InitialView" metadata
   */
  cleanPanoramaOptions(t, e) {
    return e != null && e.isEquirectangular && (ln(t.zoom) && !ln(e.initialFov) && (t = {
      ...t,
      zoom: this.fovToZoomLevel(this.hFovToVFov(e.initialFov))
    }), ln(t.position) && !ln(e.initialHeading) && !ln(e.initialPitch) && (t = {
      ...t,
      position: {
        yaw: Lr(e.initialHeading),
        pitch: Lr(e.initialPitch, !0)
      }
    })), t;
  }
}, gae = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M33.38 33.2a1.96 1.96 0 0 0 1.5-3.23 10.61 10.61 0 0 1 7.18-17.51c.7-.06 1.31-.49 1.61-1.12a13.02 13.02 0 0 1 11.74-7.43c7.14 0 12.96 5.8 12.96 12.9 0 3.07-1.1 6.05-3.1 8.38-.7.82-.61 2.05.21 2.76.83.7 2.07.6 2.78-.22a16.77 16.77 0 0 0 4.04-10.91C72.3 7.54 64.72 0 55.4 0a16.98 16.98 0 0 0-14.79 8.7 14.6 14.6 0 0 0-12.23 14.36c0 3.46 1.25 6.82 3.5 9.45.4.45.94.69 1.5.69m45.74 43.55a22.13 22.13 0 0 1-5.23 12.4c-4 4.55-9.53 6.86-16.42 6.86-12.6 0-20.1-10.8-20.17-10.91a1.82 1.82 0 0 0-.08-.1c-5.3-6.83-14.55-23.82-17.27-28.87-.05-.1 0-.21.02-.23a6.3 6.3 0 0 1 8.24 1.85l9.38 12.59a1.97 1.97 0 0 0 3.54-1.17V25.34a4 4 0 0 1 1.19-2.87 3.32 3.32 0 0 1 2.4-.95c1.88.05 3.4 1.82 3.4 3.94v24.32a1.96 1.96 0 0 0 3.93 0v-33.1a3.5 3.5 0 0 1 7 0v35.39a1.96 1.96 0 0 0 3.93 0v-.44c.05-2.05 1.6-3.7 3.49-3.7 1.93 0 3.5 1.7 3.5 3.82v5.63c0 .24.04.48.13.71l.1.26a1.97 1.97 0 0 0 3.76-.37c.33-1.78 1.77-3.07 3.43-3.07 1.9 0 3.45 1.67 3.5 3.74l-1.77 18.1zM77.39 51c-1.25 0-2.45.32-3.5.9v-.15c0-4.27-3.33-7.74-7.42-7.74-1.26 0-2.45.33-3.5.9V16.69a7.42 7.42 0 0 0-14.85 0v1.86a7 7 0 0 0-3.28-.94 7.21 7.21 0 0 0-5.26 2.07 7.92 7.92 0 0 0-2.38 5.67v37.9l-5.83-7.82a10.2 10.2 0 0 0-13.35-2.92 4.1 4.1 0 0 0-1.53 5.48C20 64.52 28.74 80.45 34.07 87.34c.72 1.04 9.02 12.59 23.4 12.59 7.96 0 14.66-2.84 19.38-8.2a26.06 26.06 0 0 0 6.18-14.6l1.78-18.2v-.2c0-4.26-3.32-7.73-7.42-7.73z"/><!--Created by AomAm from the Noun Project--></svg>
`, yae = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 17 79 79"><path fill="currentColor" d="M38.1 29.27c-.24 0-.44.2-.44.45v10.7a.45.45 0 00.9 0v-10.7c0-.25-.2-.45-.45-.45zm10.2 26.66a11.54 11.54 0 01-8.48-6.14.45.45 0 10-.8.41 12.45 12.45 0 009.22 6.62.45.45 0 00.07-.9zm24.55-13.08a23.04 23.04 0 00-22.56-23v7.07l-.01.05a2.83 2.83 0 012.39 2.78v14.03l.09-.02h8.84v-9.22a.45.45 0 11.9 0v9.22h10.35v-.9zm0 27.33V44.66H62.5c-.02 2.01-.52 4-1.47 5.76a.45.45 0 01-.61.18.45.45 0 01-.19-.61 11.54 11.54 0 001.36-5.33h-8.83l-.1-.01a2.83 2.83 0 01-2.83 2.84h-.04-.04a2.83 2.83 0 01-2.83-2.83v-14.9a2.82 2.82 0 012.47-2.8v-7.11a23.04 23.04 0 00-22.57 23v.91h14.72V29.88a8.2 8.2 0 015.02-7.57c.22-.1.5.01.59.24.1.23-.01.5-.24.6a7.3 7.3 0 00-4.47 6.73v13.88h3.9a.45.45 0 110 .9h-3.9v.15a7.32 7.32 0 0011.23 6.17.45.45 0 01.49.76 8.22 8.22 0 01-12.62-6.93v-.15H26.82v25.52a23.04 23.04 0 0023.01 23.01 23.04 23.04 0 0023.02-23.01zm1.8-27.33v27.33A24.85 24.85 0 0149.84 95a24.85 24.85 0 01-24.82-24.82V42.85a24.85 24.85 0 0124.82-24.82 24.85 24.85 0 0124.83 24.82zM57.98 29.88v9.36a.45.45 0 11-.9 0v-9.36a7.28 7.28 0 00-3.4-6.17.45.45 0 01.49-.76 8.18 8.18 0 013.8 6.93z"/><!-- Created by Icon Island from the Noun Project --></svg>
`, af = class ix {
  constructor() {
    this.$ = ix.IDLE;
  }
  is(...e) {
    return e.some((n) => this.$ & n);
  }
  set(e) {
    this.$ = e;
  }
  add(e) {
    this.$ |= e;
  }
  remove(e) {
    this.$ &= ~e;
  }
};
af.IDLE = 0;
af.CLICK = 1;
af.MOVING = 2;
var Qt = af, bae = class extends mc {
  constructor(t) {
    super(t), this.data = {
      /** start x position of the click/touch */
      startMouseX: 0,
      /** start y position of the click/touch */
      startMouseY: 0,
      /** current x position of the cursor */
      mouseX: 0,
      /** current y position of the cursor */
      mouseY: 0,
      /** current distance between fingers */
      pinchDist: 0,
      /** accumulator for smooth movement */
      moveDelta: { yaw: 0, pitch: 0, zoom: 0 },
      accumulatorFactor: 0,
      /** when the Ctrl key is pressed */
      ctrlKeyDown: !1,
      /** temporary storage of click data between two clicks */
      dblclickData: null,
      dblclickTimeout: null,
      longtouchTimeout: null,
      twofingersTimeout: null,
      ctrlZoomTimeout: null
    }, this.step = new Qt(), this.keyHandler = new rf(), this.resizeObserver = new ResizeObserver(uy(() => this.viewer.autoSize(), 50)), this.moveThreshold = q9 * Cn.pixelRatio;
  }
  /**
   * @internal
   */
  init() {
    window.addEventListener("keydown", this, { passive: !1 }), window.addEventListener("keyup", this), this.viewer.container.addEventListener("mousedown", this), window.addEventListener("mousemove", this, { passive: !1 }), window.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchstart", this, { passive: !1 }), window.addEventListener("touchmove", this, { passive: !1 }), window.addEventListener("touchend", this, { passive: !1 }), this.viewer.container.addEventListener("wheel", this, { passive: !1 }), document.addEventListener("fullscreenchange", this), this.resizeObserver.observe(this.viewer.container), this.viewer.addEventListener(gl.type, this), this.viewer.addEventListener(Sl.type, this);
  }
  destroy() {
    window.removeEventListener("keydown", this), window.removeEventListener("keyup", this), this.viewer.container.removeEventListener("mousedown", this), window.removeEventListener("mousemove", this), window.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchstart", this), window.removeEventListener("touchmove", this), window.removeEventListener("touchend", this), this.viewer.container.removeEventListener("wheel", this), document.removeEventListener("fullscreenchange", this), this.resizeObserver.disconnect(), this.viewer.removeEventListener(gl.type, this), this.viewer.removeEventListener(Sl.type, this), clearTimeout(this.data.dblclickTimeout), clearTimeout(this.data.longtouchTimeout), clearTimeout(this.data.twofingersTimeout), clearTimeout(this.data.ctrlZoomTimeout), super.destroy();
  }
  /**
   * @internal
   */
  handleEvent(t) {
    switch (t.type) {
      case "keydown":
        this.__onKeyDown(t);
        break;
      case "keyup":
        this.__onKeyUp();
        break;
      case "mousemove":
        this.__onMouseMove(t);
        break;
      case "mouseup":
        this.__onMouseUp(t);
        break;
      case "touchmove":
        this.__onTouchMove(t);
        break;
      case "touchend":
        this.__onTouchEnd(t);
        break;
      case "fullscreenchange":
        this.__onFullscreenChange();
        break;
      case gl.type:
        this.__applyMoveDelta();
        break;
      case Sl.type:
        this.__clearMoveDelta();
        break;
    }
    if (!oy(t, "." + fc))
      switch (t.type) {
        case "mousedown":
          this.__onMouseDown(t);
          break;
        case "touchstart":
          this.__onTouchStart(t);
          break;
        case "wheel":
          this.__onMouseWheel(t);
          break;
      }
  }
  /**
   * Handles keyboard events
   */
  __onKeyDown(t) {
    var n;
    if (this.config.mousewheelCtrlKey && (this.data.ctrlKeyDown = t.key === sn.Control, this.data.ctrlKeyDown && (clearTimeout(this.data.ctrlZoomTimeout), this.viewer.overlay.hide(mn.CTRL_ZOOM))), !this.viewer.dispatchEvent(new $i(t.key, t)) || !this.state.keyboardEnabled)
      return;
    const e = (n = this.config.keyboardActions) == null ? void 0 : n[t.key];
    if (typeof e == "function") {
      e(this.viewer, t), t.preventDefault();
      return;
    }
    if (!(t.ctrlKey || t.altKey || t.shiftKey || t.metaKey) && e && !this.keyHandler.pending) {
      switch (e !== "ZOOM_IN" && e !== "ZOOM_OUT" && this.viewer.stopAll(), e) {
        case "ROTATE_UP":
          this.viewer.dynamics.position.roll({ pitch: !1 });
          break;
        case "ROTATE_DOWN":
          this.viewer.dynamics.position.roll({ pitch: !0 });
          break;
        case "ROTATE_RIGHT":
          this.viewer.dynamics.position.roll({ yaw: !1 });
          break;
        case "ROTATE_LEFT":
          this.viewer.dynamics.position.roll({ yaw: !0 });
          break;
        case "ZOOM_IN":
          this.viewer.dynamics.zoom.roll(!1);
          break;
        case "ZOOM_OUT":
          this.viewer.dynamics.zoom.roll(!0);
          break;
      }
      this.keyHandler.down(e), t.preventDefault();
    }
  }
  /**
   * Handles keyboard events
   */
  __onKeyUp() {
    this.data.ctrlKeyDown = !1, this.state.keyboardEnabled && this.keyHandler.up((t) => {
      t === "ZOOM_IN" || t === "ZOOM_OUT" ? this.viewer.dynamics.zoom.stop() : (this.viewer.dynamics.position.stop(), this.viewer.resetIdleTimer());
    });
  }
  /**
   * Handles mouse down events
   */
  __onMouseDown(t) {
    this.step.add(Qt.CLICK), this.data.startMouseX = t.clientX, this.data.startMouseY = t.clientY;
  }
  /**
   *Handles mouse up events
   */
  __onMouseUp(t) {
    this.step.is(Qt.CLICK, Qt.MOVING) && this.__stopMove(t.clientX, t.clientY, t, t.button === 2);
  }
  /**
   * Handles mouse move events
   */
  __onMouseMove(t) {
    this.config.mousemove && this.step.is(Qt.CLICK, Qt.MOVING) && (t.preventDefault(), this.__doMove(t.clientX, t.clientY)), this.__handleObjectsEvents(t);
  }
  /**
   * Handles touch events
   */
  __onTouchStart(t) {
    t.touches.length === 1 ? (this.step.add(Qt.CLICK), this.data.startMouseX = t.touches[0].clientX, this.data.startMouseY = t.touches[0].clientY, this.data.longtouchTimeout || (this.data.longtouchTimeout = setTimeout(() => {
      const e = t.touches[0];
      this.__stopMove(e.clientX, e.clientY, t, !0), this.data.longtouchTimeout = null;
    }, Y9))) : t.touches.length === 2 && (this.step.set(Qt.IDLE), this.__cancelLongTouch(), this.config.mousemove && (this.__cancelTwoFingersOverlay(), this.__startMoveZoom(t), t.preventDefault()));
  }
  /**
   * Handles touch events
   */
  __onTouchEnd(t) {
    if (this.__cancelLongTouch(), this.step.is(Qt.CLICK, Qt.MOVING)) {
      if (t.preventDefault(), this.__cancelTwoFingersOverlay(), t.touches.length === 1)
        this.__stopMove(this.data.mouseX, this.data.mouseY);
      else if (t.touches.length === 0) {
        const e = t.changedTouches[0];
        this.__stopMove(e.clientX, e.clientY, t);
      }
    }
  }
  /**
   * Handles touch move events
   */
  __onTouchMove(t) {
    if (this.__cancelLongTouch(), !!this.config.mousemove)
      if (t.touches.length === 1) {
        if (this.config.touchmoveTwoFingers)
          this.step.is(Qt.CLICK) && !this.data.twofingersTimeout && (this.data.twofingersTimeout = setTimeout(() => {
            this.viewer.overlay.show({
              id: mn.TWO_FINGERS,
              image: gae,
              title: this.config.lang.twoFingers
            });
          }, Z9));
        else if (this.step.is(Qt.CLICK, Qt.MOVING)) {
          t.preventDefault();
          const e = t.touches[0];
          this.__doMove(e.clientX, e.clientY);
        }
      } else
        this.__doMoveZoom(t), this.__cancelTwoFingersOverlay();
  }
  /**
   * Cancel the long touch timer if any
   */
  __cancelLongTouch() {
    this.data.longtouchTimeout && (clearTimeout(this.data.longtouchTimeout), this.data.longtouchTimeout = null);
  }
  /**
   * Cancel the two fingers overlay timer if any
   */
  __cancelTwoFingersOverlay() {
    this.config.touchmoveTwoFingers && (this.data.twofingersTimeout && (clearTimeout(this.data.twofingersTimeout), this.data.twofingersTimeout = null), this.viewer.overlay.hide(mn.TWO_FINGERS));
  }
  /**
   * Handles mouse wheel events
   */
  __onMouseWheel(t) {
    if (!this.config.mousewheel || !t.deltaY)
      return;
    if (this.config.mousewheelCtrlKey && !this.data.ctrlKeyDown) {
      this.viewer.overlay.show({
        id: mn.CTRL_ZOOM,
        image: yae,
        title: this.config.lang.ctrlZoom
      }), clearTimeout(this.data.ctrlZoomTimeout), this.data.ctrlZoomTimeout = setTimeout(() => this.viewer.overlay.hide(mn.CTRL_ZOOM), K9);
      return;
    }
    t.preventDefault(), t.stopPropagation();
    const e = t.deltaY / Math.abs(t.deltaY) * 5 * this.config.zoomSpeed;
    e !== 0 && this.viewer.dynamics.zoom.step(-e, 5);
  }
  /**
   * Handles fullscreen events
   */
  __onFullscreenChange() {
    const t = this.viewer.isFullscreenEnabled();
    this.config.keyboard === "fullscreen" && (t ? this.viewer.startKeyboardControl() : this.viewer.stopKeyboardControl()), this.viewer.dispatchEvent(new yl(t));
  }
  /**
   * Resets all state variables
   */
  __resetMove() {
    this.step.set(Qt.IDLE), this.data.mouseX = 0, this.data.mouseY = 0, this.data.startMouseX = 0, this.data.startMouseY = 0;
  }
  /**
   * Initializes the combines move and zoom
   */
  __startMoveZoom(t) {
    this.viewer.stopAll(), this.__resetMove();
    const e = E1(t);
    this.step.set(Qt.MOVING), this.data.accumulatorFactor = this.config.moveInertia, {
      distance: this.data.pinchDist,
      center: { x: this.data.mouseX, y: this.data.mouseY }
    } = e;
  }
  /**
   * Stops the movement
   * @description If the move threshold was not reached a click event is triggered
   */
  __stopMove(t, e, n, r = !1) {
    this.step.is(Qt.CLICK) && !this.__moveThresholdReached(t, e) && this.__doClick(t, e, n, r), this.config.moveInertia && (this.data.accumulatorFactor = Math.pow(this.config.moveInertia, 0.5)), this.__resetMove(), this.viewer.resetIdleTimer();
  }
  /**
   * Triggers an event with all coordinates when a simple click is performed
   */
  __doClick(t, e, n, r = !1) {
    const i = this.viewer.container.getBoundingClientRect(), o = t - i.left, a = e - i.top, s = this.viewer.renderer.getIntersections({ x: o, y: a }), l = s.find((c) => c.object.userData[to]);
    if (l) {
      const c = this.viewer.dataHelper.vector3ToSphericalCoords(l.point), u = {
        rightclick: r,
        originalEvent: n,
        target: od(n),
        clientX: t,
        clientY: e,
        viewerX: o,
        viewerY: a,
        yaw: c.yaw,
        pitch: c.pitch,
        objects: s.map((d) => d.object).filter((d) => !d.userData[to])
      };
      try {
        const d = this.viewer.dataHelper.sphericalCoordsToTextureCoords(u);
        Object.assign(u, d);
      } catch {
      }
      this.data.dblclickTimeout ? (Math.abs(this.data.dblclickData.clientX - u.clientX) < this.moveThreshold && Math.abs(this.data.dblclickData.clientY - u.clientY) < this.moveThreshold && this.viewer.dispatchEvent(new zy(this.data.dblclickData)), clearTimeout(this.data.dblclickTimeout), this.data.dblclickTimeout = null, this.data.dblclickData = null) : (this.viewer.dispatchEvent(new ky(u)), this.data.dblclickData = ef(u), this.data.dblclickTimeout = setTimeout(() => {
        this.data.dblclickTimeout = null, this.data.dblclickData = null;
      }, X9));
    }
  }
  /**
   * Trigger events for observed THREE objects
   */
  __handleObjectsEvents(t) {
    if (!fy(this.state.objectsObservers) && t.composedPath().includes(this.viewer.container)) {
      const e = ay(this.viewer.container), n = {
        x: t.clientX - e.x,
        y: t.clientY - e.y
      }, r = this.viewer.renderer.getIntersections(n), i = (o, a, s) => {
        this.viewer.dispatchEvent(new s(t, o, n, a));
      };
      for (const [o, a] of Object.entries(this.state.objectsObservers)) {
        const s = r.find((l) => l.object.userData[o]);
        s ? (a && s.object !== a && (i(a, o, P1), this.state.objectsObservers[o] = null), a ? i(s.object, o, Gb) : (this.state.objectsObservers[o] = s.object, i(s.object, o, Bb))) : a && (i(a, o, P1), this.state.objectsObservers[o] = null);
      }
    }
  }
  /**
   * Starts moving when crossing moveThreshold and performs movement
   */
  __doMove(t, e) {
    if (this.step.is(Qt.CLICK) && this.__moveThresholdReached(t, e))
      this.viewer.stopAll(), this.__resetMove(), this.step.set(Qt.MOVING), this.data.mouseX = t, this.data.mouseY = e, this.data.accumulatorFactor = this.config.moveInertia;
    else if (this.step.is(Qt.MOVING)) {
      const n = (t - this.data.mouseX) * Math.cos(this.state.roll) - (e - this.data.mouseY) * Math.sin(this.state.roll), r = (e - this.data.mouseY) * Math.cos(this.state.roll) + (t - this.data.mouseX) * Math.sin(this.state.roll), i = {
        yaw: this.config.moveSpeed * (n / this.state.size.width) * Mt.degToRad(this.state.hFov),
        pitch: this.config.moveSpeed * (r / this.state.size.height) * Mt.degToRad(this.state.vFov)
      };
      this.data.moveDelta.yaw += i.yaw, this.data.moveDelta.pitch += i.pitch, this.data.mouseX = t, this.data.mouseY = e;
    }
  }
  /**
   * Checks if the cursor was move beyond the move threshold
   */
  __moveThresholdReached(t, e) {
    return Math.abs(t - this.data.startMouseX) >= this.moveThreshold || Math.abs(e - this.data.startMouseY) >= this.moveThreshold;
  }
  /**
   * Perfoms combined move and zoom
   */
  __doMoveZoom(t) {
    if (this.step.is(Qt.MOVING)) {
      t.preventDefault();
      const e = E1(t);
      this.__doMove(e.center.x, e.center.y), this.data.moveDelta.zoom += this.config.zoomSpeed * ((e.distance - this.data.pinchDist) / Cn.pixelRatio), this.data.pinchDist = e.distance;
    }
  }
  __applyMoveDelta() {
    if (Math.abs(this.data.moveDelta.yaw) > 0 || Math.abs(this.data.moveDelta.pitch) > 0) {
      const e = this.viewer.getPosition();
      this.viewer.rotate({
        yaw: e.yaw - this.data.moveDelta.yaw * (1 - this.config.moveInertia),
        pitch: e.pitch + this.data.moveDelta.pitch * (1 - this.config.moveInertia)
      }), this.data.moveDelta.yaw *= this.data.accumulatorFactor, this.data.moveDelta.pitch *= this.data.accumulatorFactor, Math.abs(this.data.moveDelta.yaw) <= 1e-3 && (this.data.moveDelta.yaw = 0), Math.abs(this.data.moveDelta.pitch) <= 1e-3 && (this.data.moveDelta.pitch = 0);
    }
    if (Math.abs(this.data.moveDelta.zoom) > 0) {
      const e = this.viewer.getZoomLevel();
      this.viewer.zoom(e + this.data.moveDelta.zoom * (1 - this.config.moveInertia)), this.data.moveDelta.zoom *= this.config.moveInertia, Math.abs(this.data.moveDelta.zoom) <= 1e-3 && (this.data.moveDelta.zoom = 0);
    }
  }
  __clearMoveDelta() {
    this.data.moveDelta.yaw = 0, this.data.moveDelta.pitch = 0, this.data.moveDelta.zoom = 0;
  }
};
mt.enabled = !1;
var iu = new Pt(), Sg = new qt(), Mg = new Ls(), xae = class extends mc {
  /**
   * @internal
   */
  constructor(t) {
    super(t), this.frustumNeedsUpdate = !0, this.renderer = new Poe(this.config.rendererParameters), this.renderer.setPixelRatio(Cn.pixelRatio), this.renderer.outputColorSpace = zo, this.renderer.toneMapping = b9, this.renderer.domElement.className = "psv-canvas", this.renderer.domElement.style.background = this.config.canvasBackground, this.scene = new j4(), this.camera = new tr(50, 16 / 9, 0.1, 2 * Ho), this.camera.matrixAutoUpdate = !1;
    const e = new rr(
      new dc(Ho).scale(-1, 1, 1),
      new cc({ opacity: 0, transparent: !0, depthTest: !1, depthWrite: !1 })
    );
    e.userData = { [to]: !0 }, this.scene.add(e), this.raycaster = new Gee(), this.frustum = new R2(), this.container = document.createElement("div"), this.container.className = "psv-canvas-container", this.container.appendChild(this.renderer.domElement), this.viewer.container.appendChild(this.container), this.container.addEventListener("contextmenu", (n) => n.preventDefault()), this.viewer.addEventListener(El.type, this), this.viewer.addEventListener(si.type, this), this.viewer.addEventListener(xl.type, this), this.viewer.addEventListener(wl.type, this), this.viewer.addEventListener(Ln.type, this), this.hide();
  }
  get panoramaPose() {
    return this.mesh.rotation;
  }
  get sphereCorrection() {
    return this.meshContainer.rotation;
  }
  /**
   * @internal
   */
  init() {
    this.show(), this.renderer.setAnimationLoop((t) => this.__renderLoop(t));
  }
  /**
   * @internal
   */
  destroy() {
    this.renderer.setAnimationLoop(null), this.cleanScene(this.scene), this.renderer.dispose(), this.viewer.container.removeChild(this.container), this.viewer.removeEventListener(El.type, this), this.viewer.removeEventListener(si.type, this), this.viewer.removeEventListener(xl.type, this), this.viewer.removeEventListener(wl.type, this), this.viewer.removeEventListener(Ln.type, this), super.destroy();
  }
  /**
   * @internal
   */
  handleEvent(t) {
    switch (t.type) {
      case El.type:
        this.__onSizeUpdated();
        break;
      case si.type:
        this.__onZoomUpdated();
        break;
      case xl.type:
        this.__onPositionUpdated();
        break;
      case wl.type:
        this.__onPositionUpdated();
        break;
      case Ln.type:
        t.containsOptions("fisheye") && this.__onPositionUpdated(), t.containsOptions("canvasBackground") && (this.renderer.domElement.style.background = this.config.canvasBackground);
        break;
    }
  }
  /**
   * Hides the viewer
   */
  hide() {
    this.container.style.opacity = "0";
  }
  /**
   * Shows the viewer
   */
  show() {
    this.container.style.opacity = "1";
  }
  /**
   * Resets or replaces the THREE renderer by a custom one
   */
  setCustomRenderer(t) {
    t ? this.customRenderer = t(this.renderer) : this.customRenderer = null, this.viewer.needsUpdate();
  }
  /**
   * Updates the size of the renderer and the aspect of the camera
   */
  __onSizeUpdated() {
    this.renderer.setSize(this.state.size.width, this.state.size.height), this.camera.aspect = this.state.aspect, this.camera.updateProjectionMatrix(), this.viewer.needsUpdate(), this.frustumNeedsUpdate = !0;
  }
  /**
   * Updates the fov of the camera
   */
  __onZoomUpdated() {
    this.camera.fov = this.state.vFov, this.camera.updateProjectionMatrix(), this.viewer.needsUpdate(), this.frustumNeedsUpdate = !0;
  }
  /**
   * Updates the position of the camera
   */
  __onPositionUpdated() {
    this.camera.position.set(0, 0, 0), this.camera.lookAt(this.state.direction), this.config.fisheye && this.camera.position.copy(this.state.direction).multiplyScalar(this.config.fisheye / 2).negate(), this.camera.rotateZ(-this.state.roll), this.camera.updateMatrix(), this.camera.updateMatrixWorld(), this.viewer.needsUpdate(), this.frustumNeedsUpdate = !0;
  }
  /**
   * Main event loop, performs a render if `state.needsUpdate` is true
   */
  __renderLoop(t) {
    const e = this.timestamp ? t - this.timestamp : 0;
    this.timestamp = t, this.viewer.dispatchEvent(new gl(t, e)), this.viewer.dynamics.update(e), (this.state.needsUpdate || this.state.continuousUpdateCount > 0) && (this.state.needsUpdate = !1, (this.customRenderer || this.renderer).render(this.scene, this.camera), this.viewer.dispatchEvent(new _b()));
  }
  /**
   * Applies the texture to the scene, creates the scene if needed
   * @internal
   */
  setTexture(t) {
    this.meshContainer || (this.meshContainer = new $a(), this.scene.add(this.meshContainer)), this.state.textureData && this.viewer.adapter.disposeTexture(this.state.textureData), this.mesh && (this.meshContainer.remove(this.mesh), this.viewer.adapter.disposeMesh(this.mesh)), this.mesh = this.viewer.adapter.createMesh(t.panoData), this.viewer.adapter.setTexture(this.mesh, t, !1), this.meshContainer.add(this.mesh), this.state.textureData = t, this.viewer.needsUpdate();
  }
  /**
   * Applies a panorama data pose to a Mesh
   * @internal
   */
  setPanoramaPose(t, e = this.mesh) {
    const n = this.viewer.dataHelper.cleanPanoramaPose(t);
    e.rotation.set(n.tilt, n.pan, n.roll, "YXZ");
  }
  /**
   * Applies a SphereCorrection to a Group
   * @internal
   */
  setSphereCorrection(t, e = this.meshContainer) {
    const n = this.viewer.dataHelper.cleanSphereCorrection(t);
    e.rotation.set(n.tilt, n.pan, n.roll, "YXZ");
  }
  /**
   * Performs transition between the current and a new texture
   * @internal
   */
  transition(t, e, n) {
    const r = n.effect === "fade" || n.rotation, i = !ln(e.position), o = !ln(e.zoom), a = new H2(
      i ? this.viewer.dataHelper.cleanPosition(e.position) : void 0,
      e.zoom
    );
    this.viewer.dispatchEvent(a);
    const s = new $a(), l = this.viewer.adapter.createMesh(t.panoData);
    if (this.viewer.adapter.setTexture(l, t, !0), this.viewer.adapter.setTextureOpacity(l, 0), this.setPanoramaPose(t.panoData, l), this.setSphereCorrection(e.sphereCorrection, s), i && !n.rotation) {
      const f = this.viewer.getPosition(), h = new re(0, 1, 0);
      s.rotateOnWorldAxis(h, a.position.yaw - f.yaw);
      const v = new re(0, 1, 0).cross(this.camera.getWorldDirection(new re())).normalize();
      s.rotateOnWorldAxis(v, a.position.pitch - f.pitch);
    }
    s.add(l), this.scene.add(s), this.renderer.setRenderTarget(new Qi()), this.renderer.render(this.scene, this.camera), this.renderer.setRenderTarget(null);
    const { duration: c, properties: u } = this.viewer.dataHelper.getAnimationProperties(
      n.speed,
      n.rotation ? a.position : null,
      r ? a.zoomLevel : null
    ), d = new cd({
      properties: {
        ...u,
        opacity: { start: 0, end: 1 }
      },
      duration: c,
      easing: "inOutCubic",
      onTick: (f) => {
        switch (n.effect) {
          case "fade":
            this.viewer.adapter.setTextureOpacity(l, f.opacity);
            break;
          case "black":
          case "white":
            f.opacity < 0.5 ? this.renderer.toneMappingExposure = n.effect === "black" ? Mt.mapLinear(f.opacity, 0, 0.5, 1, 0) : Mt.mapLinear(f.opacity, 0, 0.5, 1, 4) : (this.renderer.toneMappingExposure = n.effect === "black" ? Mt.mapLinear(f.opacity, 0.5, 1, 0, 1) : Mt.mapLinear(f.opacity, 0.5, 1, 4, 1), this.mesh.visible = !1, this.viewer.adapter.setTextureOpacity(l, 1), o && !r && this.viewer.dynamics.zoom.setValue(a.zoomLevel));
            break;
        }
        i && n.rotation && this.viewer.dynamics.position.setValue({
          yaw: f.yaw,
          pitch: f.pitch
        }), o && r && this.viewer.dynamics.zoom.setValue(f.zoom), this.viewer.needsUpdate();
      }
    });
    return d.then((f) => {
      s.remove(l), this.scene.remove(s), f ? (this.viewer.adapter.disposeTexture(this.state.textureData), this.meshContainer.remove(this.mesh), this.viewer.adapter.disposeMesh(this.mesh), this.mesh = l, this.meshContainer.add(l), this.state.textureData = t, this.setPanoramaPose(t.panoData), this.setSphereCorrection(e.sphereCorrection), i && !n.rotation && this.viewer.rotate(e.position)) : (this.viewer.adapter.disposeTexture(t), this.viewer.adapter.disposeMesh(l));
    }), d;
  }
  /**
   * Returns intersections with objects in the scene
   */
  getIntersections(t) {
    var n;
    iu.x = 2 * t.x / this.state.size.width - 1, iu.y = -2 * t.y / this.state.size.height + 1, this.raycaster.setFromCamera(iu, this.camera);
    const e = this.raycaster.intersectObjects(this.scene.children, !0).filter((r) => r.object.visible).filter((r) => r.object.isMesh && !!r.object.userData);
    return (n = this.customRenderer) != null && n.getIntersections && e.push(...this.customRenderer.getIntersections(this.raycaster, iu)), e;
  }
  /**
   * Checks if an object/point is currently visible
   */
  isObjectVisible(t) {
    if (!t)
      return !1;
    if (this.frustumNeedsUpdate && (Sg.multiplyMatrices(this.camera.projectionMatrix, this.camera.matrixWorldInverse), this.frustum.setFromProjectionMatrix(Sg), this.frustumNeedsUpdate = !1), t.isVector3)
      return this.frustum.containsPoint(t);
    if (t.isMesh && t.geometry) {
      const e = t;
      return e.geometry.boundingBox || e.geometry.computeBoundingBox(), Mg.copy(e.geometry.boundingBox).applyMatrix4(e.matrixWorld), this.frustum.intersectsBox(Mg);
    } else
      return t.isObject3D ? this.frustum.intersectsObject(t) : !1;
  }
  /**
   * Adds an object to the THREE scene
   */
  addObject(t) {
    this.scene.add(t);
  }
  /**
   * Removes an object from the THREE scene
   */
  removeObject(t) {
    this.scene.remove(t);
  }
  /**
   * Calls `dispose` on all objects and textures
   * @internal
   */
  cleanScene(t) {
    const e = (n) => {
      var r;
      (r = n.map) == null || r.dispose(), n.uniforms && Object.values(n.uniforms).forEach((i) => {
        var o, a;
        (a = (o = i.value) == null ? void 0 : o.dispose) == null || a.call(o);
      }), n.dispose();
    };
    t.traverse((n) => {
      var r, i;
      (r = n.geometry) == null || r.dispose(), n.material && (Array.isArray(n.material) ? n.material.forEach((o) => {
        e(o);
      }) : e(n.material)), n instanceof j4 || (i = n.dispose) == null || i.call(n), n !== t && this.cleanScene(n);
    });
  }
}, wae = class extends L2 {
  // @ts-ignore
  load(t, e, n, r, i) {
    const o = new Request(t, {
      headers: new Headers(this.requestHeader),
      credentials: this.withCredentials ? "include" : "same-origin"
    });
    fetch(o, {
      signal: i
    }).then((a) => {
      if (a.status === 200 || a.status === 0) {
        const s = a.body.getReader(), l = a.headers.get("Content-Length") || a.headers.get("X-File-Size"), c = l ? parseInt(l) : 0, u = c !== 0;
        let d = 0;
        const f = new ReadableStream({
          start(h) {
            v();
            function v() {
              s.read().then(({ done: g, value: m }) => {
                if (g)
                  h.close();
                else {
                  d += m.byteLength;
                  const p = new ProgressEvent("progress", { lengthComputable: u, loaded: d, total: c });
                  n(p), h.enqueue(m), v();
                }
              }).catch((g) => {
                r(g);
              });
            }
          }
        });
        return new Response(f);
      } else
        throw new Error(`fetch for "${a.url}" responded with ${a.status}: ${a.statusText}`);
    }).then((a) => a.blob()).then((a) => {
      e(a);
    }).catch((a) => {
      r(a);
    });
  }
}, _ae = class extends L2 {
  // @ts-ignore
  load(t, e, n, r) {
    const i = document.createElement("img");
    function o() {
      l(), e(this);
    }
    function a(c) {
      if (l(), r != null && r.aborted) {
        const u = new Error();
        u.name = "AbortError", u.message = "The operation was aborted.", n(u);
      } else
        n(c);
    }
    function s() {
      i.src = "";
    }
    function l() {
      i.removeEventListener("load", o, !1), i.removeEventListener("error", a, !1), r == null || r.removeEventListener("abort", s, !1);
    }
    return i.addEventListener("load", o, !1), i.addEventListener("error", a, !1), r == null || r.addEventListener("abort", s, !1), !t.startsWith("data:") && this.crossOrigin !== void 0 && (i.crossOrigin = this.crossOrigin), i.src = t, i;
  }
}, Cae = class extends mc {
  /**
   * @internal
   */
  constructor(t) {
    super(t), this.abortCtrl = {}, this.fileLoader = new wae(), this.imageLoader = new _ae(), this.config.withCredentials && (this.fileLoader.setWithCredentials(!0), this.imageLoader.setCrossOrigin("use-credentials"));
  }
  /**
   * @internal
   */
  destroy() {
    this.abortLoading(), super.destroy();
  }
  /**
   * Cancels current HTTP requests
   * @internal
   */
  abortLoading() {
    Object.values(this.abortCtrl).forEach((t) => t.abort()), this.abortCtrl = {};
  }
  /**
   * Loads a Blob with FileLoader
   */
  loadFile(t, e, n) {
    const r = Ba.get(t, n);
    if (r) {
      if (r instanceof Blob)
        return e == null || e(100), Promise.resolve(r);
      Ba.remove(t, n);
    }
    return this.config.requestHeaders && this.fileLoader.setRequestHeader(this.config.requestHeaders(t)), new Promise((i, o) => {
      let a = 0;
      e == null || e(a), this.fileLoader.load(
        t,
        (s) => {
          a = 100, e == null || e(a), Ba.add(t, n, s), i(s);
        },
        (s) => {
          if (s.lengthComputable) {
            const l = s.loaded / s.total * 100;
            l > a && (a = l, e == null || e(a));
          }
        },
        (s) => {
          o(s);
        },
        this.__getAbortSignal(n)
      );
    });
  }
  /**
   * Loads an image with ImageLoader or with FileLoader if progress is tracked or if request headers are configured
   */
  loadImage(t, e, n) {
    const r = Ba.get(t, n);
    return r ? (e == null || e(100), r instanceof Blob ? this.blobToImage(r) : Promise.resolve(r)) : !e && !this.config.requestHeaders ? new Promise((i, o) => {
      this.imageLoader.load(
        t,
        (a) => {
          Ba.add(t, n, a), i(a);
        },
        (a) => {
          o(a);
        },
        this.__getAbortSignal(n)
      );
    }) : this.loadFile(t, e, n).then((i) => this.blobToImage(i));
  }
  /**
   * Converts a file loaded with {@link loadFile} into an image
   */
  blobToImage(t) {
    return new Promise((e, n) => {
      const r = document.createElement("img");
      r.onload = () => {
        URL.revokeObjectURL(r.src), e(r);
      }, r.onerror = n, r.src = URL.createObjectURL(t);
    });
  }
  /**
   * Preload a panorama file without displaying it
   */
  preloadPanorama(t) {
    return this.viewer.adapter.supportsPreload(t) ? this.viewer.adapter.loadTexture(t, !1) : Promise.reject(new yt("Current adapter does not support preload"));
  }
  /**
   * @internal
   */
  dispatchProgress(t) {
    this.viewer.loader.setProgress(t), this.viewer.dispatchEvent(new nb(Math.round(t)));
  }
  /**
   * Get an abort signal
   * the signal is shared accross all requests with the same cache key (for tiles adapters)
   */
  __getAbortSignal(t) {
    var e;
    return t ? ((e = this.abortCtrl[t]) != null && e.signal.aborted && delete this.abortCtrl[t], this.abortCtrl[t] || (this.abortCtrl[t] = new AbortController()), this.abortCtrl[t].signal) : null;
  }
}, Eae = class extends mc {
  /**
   * @internal
   */
  constructor(t) {
    super(t), this.zoom = new sl(
      (e) => {
        this.viewer.state.vFov = this.viewer.dataHelper.zoomLevelToFov(e), this.viewer.state.hFov = this.viewer.dataHelper.vFovToHFov(this.viewer.state.vFov), this.viewer.dispatchEvent(new si(e));
      },
      {
        defaultValue: this.viewer.config.defaultZoomLvl,
        min: 0,
        max: 100,
        wrap: !1
      }
    ), this.position = new wy(
      (e) => {
        this.viewer.dataHelper.sphericalCoordsToVector3(e, this.viewer.state.direction), this.viewer.dispatchEvent(new xl(e));
      },
      {
        yaw: new sl(null, {
          defaultValue: this.config.defaultYaw,
          min: 0,
          max: 2 * Math.PI,
          wrap: !0
        }),
        pitch: new sl(null, {
          defaultValue: this.config.defaultPitch,
          min: -Math.PI / 2,
          max: Math.PI / 2,
          wrap: !1
        })
      }
    ), this.roll = new sl(
      (e) => {
        this.viewer.state.roll = e, this.viewer.dispatchEvent(new wl(e));
      },
      {
        defaultValue: 0,
        min: -Math.PI,
        max: Math.PI,
        wrap: !1
      }
    ), this.updateSpeeds();
  }
  /**
   * @internal
   */
  updateSpeeds() {
    this.zoom.setSpeed(this.config.zoomSpeed * 50), this.position.setSpeed(Mt.degToRad(this.config.moveSpeed * 50)), this.roll.setSpeed(Mt.degToRad(this.config.moveSpeed * 50));
  }
  /**
   * @internal
   */
  update(t) {
    this.zoom.update(t), this.position.update(t), this.roll.update(t);
  }
}, Sae = class {
  /**
   * @internal
   */
  // eslint-disable-next-line  @typescript-eslint/no-empty-function
  constructor() {
    this.ready = !1, this.needsUpdate = !1, this.continuousUpdateCount = 0, this.keyboardEnabled = !1, this.direction = new re(0, 0, Ho), this.roll = 0, this.vFov = 60, this.hFov = 60, this.aspect = 1, this.animation = null, this.transitionAnimation = null, this.loadingPromise = null, this.idleTime = -1, this.objectsObservers = {}, this.size = {
      width: 0,
      height: 0
    };
  }
}, Mae = class extends Ey {
  constructor(t) {
    var e, n, r;
    if (super(), this.plugins = {}, this.children = [], this.parent = ry(t.container), !this.parent)
      throw new yt('"container" element not found.');
    this.parent[to] = this, this.container = document.createElement("div"), this.container.classList.add("psv-container"), this.parent.appendChild(this.container), by(this.parent), yy(this.container, "core"), this.state = new Sae(), this.config = aae(t), this.__setSize(this.config.size), this.overlay = new dae(this);
    try {
      Cn.load();
    } catch (i) {
      console.error(i), this.showError(this.config.lang.webglError);
      return;
    }
    Ba.init(), this.adapter = new this.config.adapter[0](this, this.config.adapter[1]), this.renderer = new xae(this), this.textureLoader = new Cae(this), this.eventsHandler = new bae(this), this.dataHelper = new vae(this), this.dynamics = new Eae(this), (n = (e = this.adapter).init) == null || n.call(e), this.loader = new cae(this), this.navbar = new lae(this), this.panel = new hae(this), this.notification = new uae(this), this.autoSize(), this.setCursor(null), I2(Cn.isTouchEnabled, (i) => {
      Qd(this.container, "psv--is-touch", i);
    }), this.config.plugins.forEach(([i, o]) => {
      this.plugins[i.id] = new i(this, o);
    });
    for (const i of Object.values(this.plugins))
      (r = i.init) == null || r.call(i);
    this.config.navbar && this.navbar.setButtons(this.config.navbar), this.state.loadingPromise || (this.config.panorama ? this.setPanorama(this.config.panorama, {
      sphereCorrection: this.config.sphereCorrection,
      panoData: this.config.panoData
    }) : this.loader.show());
  }
  /**
   * Destroys the viewer
   */
  destroy() {
    var t, e, n, r, i, o;
    this.stopAll(), this.stopKeyboardControl(), this.exitFullscreen();
    for (const [a, s] of Object.entries(this.plugins))
      s.destroy(), delete this.plugins[a];
    this.children.slice().forEach((a) => a.destroy()), this.children.length = 0, (t = this.eventsHandler) == null || t.destroy(), (e = this.renderer) == null || e.destroy(), (n = this.textureLoader) == null || n.destroy(), (r = this.dataHelper) == null || r.destroy(), (i = this.adapter) == null || i.destroy(), (o = this.dynamics) == null || o.destroy(), this.parent.removeChild(this.container), delete this.parent[to];
  }
  init() {
    this.eventsHandler.init(), this.renderer.init(), this.config.navbar && this.navbar.show(), this.config.keyboard === "always" && this.startKeyboardControl(), this.resetIdleTimer(), this.state.ready = !0, this.dispatchEvent(new _l());
  }
  /**
   * Restarts the idle timer
   * @internal
   */
  resetIdleTimer() {
    this.state.idleTime = performance.now();
  }
  /**
   * Stops the idle timer
   * @internal
   */
  disableIdleTimer() {
    this.state.idleTime = -1;
  }
  /**
   * Returns the instance of a plugin if it exists
   * @example By plugin identifier
   * ```js
   * viewer.getPlugin('markers')
   * ```
   * @example By plugin class with TypeScript support
   * ```ts
   * viewer.getPlugin<MarkersPlugin>(MarkersPlugin)
   * ```
   */
  getPlugin(t) {
    if (typeof t == "string")
      return this.plugins[t];
    {
      const e = R1(t);
      return e ? this.plugins[e.id] : null;
    }
  }
  /**
   * Returns the current position of the camera
   */
  getPosition() {
    return this.dataHelper.cleanPosition(this.dynamics.position.current);
  }
  /**
   * Returns the current zoom level
   */
  getZoomLevel() {
    return this.dynamics.zoom.current;
  }
  /**
   * Returns the current viewer size
   */
  getSize() {
    return { ...this.state.size };
  }
  /**
   * Checks if the viewer is in fullscreen
   */
  isFullscreenEnabled() {
    return sy(this.parent, Cn.isIphone);
  }
  /**
   * Request a new render of the scene
   */
  needsUpdate() {
    this.state.needsUpdate = !0;
  }
  /**
   * Request the scene to be continuously renderer (when using videos)
   */
  needsContinuousUpdate(t) {
    t ? this.state.continuousUpdateCount++ : this.state.continuousUpdateCount > 0 && this.state.continuousUpdateCount--;
  }
  /**
   * Resizes the scene if the viewer is resized
   */
  autoSize() {
    (this.container.clientWidth !== this.state.size.width || this.container.clientHeight !== this.state.size.height) && (this.state.size.width = Math.round(this.container.clientWidth), this.state.size.height = Math.round(this.container.clientHeight), this.state.aspect = this.state.size.width / this.state.size.height, this.state.hFov = this.dataHelper.vFovToHFov(this.state.vFov), this.dispatchEvent(new El(this.getSize())), this.navbar.autoSize());
  }
  /**
   * Loads a new panorama file
   * Loads a new panorama file, optionally changing the camera position/zoom and activating the transition animation.<br>
   * If the "options" parameter is not defined, the camera will not move and the ongoing animation will continue.<br>
   * If another loading is already in progress it will be aborted.
   * @returns promise resolved with false if the loading was aborted by another call
   */
  setPanorama(t, e = {}) {
    var o;
    this.textureLoader.abortLoading(), (o = this.state.transitionAnimation) == null || o.cancel();
    const n = this.dataHelper.getTransitionOptions(e);
    e.showLoader === void 0 && (e.showLoader = !0), e.caption === void 0 && (e.caption = this.config.caption), e.description === void 0 && (e.description = this.config.description), !e.panoData && typeof this.config.panoData == "function" && (e.panoData = this.config.panoData), this.hideError(), this.resetIdleTimer(), this.config.panorama = t, this.config.caption = e.caption, this.config.description = e.description, this.config.sphereCorrection = e.sphereCorrection;
    const r = (a) => {
      if (my(a))
        return !1;
      if (this.loader.hide(), this.state.loadingPromise = null, a)
        throw this.navbar.setCaption(null), this.showError(this.config.lang.loadError), console.error(a), this.dispatchEvent(new ub(t, a)), a;
      return this.navbar.setCaption(this.config.caption), !0;
    };
    this.navbar.setCaption(`<em>${this.config.lang.loading}</em>`), (e.showLoader || !this.state.ready) && this.loader.show(), this.dispatchEvent(new ob(t));
    const i = this.adapter.loadTexture(this.config.panorama, !0, e.panoData).then((a) => {
      if (a.panorama !== this.config.panorama)
        throw this.adapter.disposeTexture(a), S1();
      const s = this.dataHelper.cleanPanoramaOptions(e, a.panoData);
      return (!ln(s.zoom) || !ln(s.position)) && this.stopAll(), {
        textureData: a,
        cleanOptions: s
      };
    });
    return !n || !this.state.ready || !this.adapter.supportsTransition(this.config.panorama) ? this.state.loadingPromise = i.then(({ textureData: a, cleanOptions: s }) => {
      this.renderer.show(), this.renderer.setTexture(a), this.renderer.setPanoramaPose(a.panoData), this.renderer.setSphereCorrection(e.sphereCorrection), this.state.ready || this.init(), this.dispatchEvent(new Ja(a)), ln(s.zoom) || this.zoom(s.zoom), ln(s.position) || this.rotate(s.position);
    }).then(
      () => r(),
      (a) => r(a)
    ) : this.state.loadingPromise = i.then(({ textureData: a, cleanOptions: s }) => (this.loader.hide(), this.dispatchEvent(new Ja(a)), this.state.transitionAnimation = this.renderer.transition(a, s, n), this.state.transitionAnimation)).then((a) => {
      if (this.state.transitionAnimation = null, this.dispatchEvent(new hb(a)), !a)
        throw S1();
    }).then(
      () => r(),
      (a) => r(a)
    ), this.state.loadingPromise;
  }
  /**
   * Update options
   * @throws {@link PSVError} if the configuration is invalid
   */
  setOptions(t) {
    const e = {
      ...this.config,
      ...t
    };
    for (let [n, r] of Object.entries(t)) {
      if (!(n in Bo)) {
        vn(`Unknown option ${n}`);
        continue;
      }
      if (n in Eg) {
        vn(Eg[n]);
        continue;
      }
      switch (n in L1 && (r = L1[n](r, {
        rawConfig: e,
        defValue: Bo[n]
      })), this.config[n] = r, n) {
        case "mousemove":
          this.state.cursorOverride || this.setCursor(null);
          break;
        case "caption":
          this.navbar.setCaption(this.config.caption);
          break;
        case "size":
          this.resize(this.config.size);
          break;
        case "sphereCorrection":
          this.renderer.setSphereCorrection(this.config.sphereCorrection);
          break;
        case "navbar":
        case "lang":
          this.navbar.setButtons(this.config.navbar);
          break;
        case "moveSpeed":
        case "zoomSpeed":
          this.dynamics.updateSpeeds();
          break;
        case "minFov":
        case "maxFov":
          this.dynamics.zoom.setValue(this.dataHelper.fovToZoomLevel(this.state.vFov)), this.dispatchEvent(new si(this.getZoomLevel()));
          break;
        case "keyboard":
          this.config.keyboard === "always" ? this.startKeyboardControl() : this.stopKeyboardControl();
          break;
      }
    }
    this.needsUpdate(), this.dispatchEvent(new Ln(Object.keys(t)));
  }
  /**
   * Update options
   * @throws {@link PSVError} if the configuration is invalid
   */
  setOption(t, e) {
    this.setOptions({ [t]: e });
  }
  /**
   * Displays an error message over the viewer
   */
  showError(t) {
    this.overlay.show({
      id: mn.ERROR,
      image: mae,
      title: t,
      dismissible: !1
    });
  }
  /**
   *  Hides the error message
   */
  hideError() {
    this.overlay.hide(mn.ERROR);
  }
  /**
   * Rotates the view to specific position
   */
  rotate(t) {
    const e = new Ly(this.dataHelper.cleanPosition(t));
    this.dispatchEvent(e), !e.defaultPrevented && this.dynamics.position.setValue(e.position);
  }
  /**
   * Zooms to a specific level between `maxFov` and `minFov`
   */
  zoom(t) {
    this.dynamics.zoom.setValue(t);
  }
  /**
   * Increases the zoom level
   */
  zoomIn(t = 1) {
    this.dynamics.zoom.step(t);
  }
  /**
   * Decreases the zoom level
   */
  zoomOut(t = 1) {
    this.dynamics.zoom.step(-t);
  }
  /**
   * Rotates and zooms the view with a smooth animation
   */
  animate(t) {
    const e = F2(t), n = !ln(t.zoom), r = new H2(
      e ? this.dataHelper.cleanPosition(t) : void 0,
      t.zoom
    );
    if (this.dispatchEvent(r), r.defaultPrevented)
      return;
    this.stopAll();
    const { duration: i, properties: o } = this.dataHelper.getAnimationProperties(t.speed, r.position, r.zoomLevel);
    return i ? (this.state.animation = new cd({
      properties: o,
      duration: i,
      easing: t.easing || "inOutSine",
      onTick: (a) => {
        e && this.dynamics.position.setValue({
          yaw: a.yaw,
          pitch: a.pitch
        }), n && this.dynamics.zoom.setValue(a.zoom);
      }
    }), this.state.animation.then(() => {
      this.state.animation = null, this.resetIdleTimer();
    }), this.state.animation) : (e && this.rotate(r.position), n && this.zoom(r.zoomLevel), new cd(null));
  }
  /**
   * Stops the ongoing animation
   * The return value is a Promise because the is no guaranty the animation can be stopped synchronously.
   */
  stopAnimation() {
    return this.state.animation ? (this.state.animation.cancel(), this.state.animation) : Promise.resolve();
  }
  /**
   * Resizes the viewer
   */
  resize(t) {
    this.__setSize(t), this.autoSize();
  }
  __setSize(t) {
    ["width", "height"].forEach((e) => {
      t != null && t[e] && (/^[0-9.]+$/.test(t[e]) && (t[e] += "px"), this.parent.style[e] = t[e]);
    });
  }
  /**
   * Enters the fullscreen mode
   */
  enterFullscreen() {
    this.isFullscreenEnabled() || ly(this.parent, Cn.isIphone);
  }
  /**
   * Exits the fullscreen mode
   */
  exitFullscreen() {
    this.isFullscreenEnabled() && cy(Cn.isIphone);
  }
  /**
   * Enters or exits the fullscreen mode
   */
  toggleFullscreen() {
    this.isFullscreenEnabled() ? this.exitFullscreen() : this.enterFullscreen();
  }
  /**
   * Enables the keyboard controls
   */
  startKeyboardControl() {
    this.state.keyboardEnabled = !0;
  }
  /**
   * Disables the keyboard controls
   */
  stopKeyboardControl() {
    this.state.keyboardEnabled = !1;
  }
  /**
   * Creates a new tooltip
   * Use {@link Tooltip.move} to update the tooltip without re-create
   * @throws {@link PSVError} if the configuration is invalid
   */
  createTooltip(t) {
    return new pae(this, t);
  }
  /**
   * Changes the global mouse cursor
   */
  setCursor(t) {
    this.state.cursorOverride = t, t ? this.container.style.cursor = t : this.container.style.cursor = this.config.mousemove ? "move" : "default";
  }
  /**
   * Subscribes to events on objects in the three.js scene
   * @param userDataKey - only objects with the following `userData` will be observed
   */
  observeObjects(t) {
    this.state.objectsObservers[t] || (this.state.objectsObservers[t] = null);
  }
  /**
   * Unsubscribes to events on objects
   */
  unobserveObjects(t) {
    delete this.state.objectsObservers[t];
  }
  /**
   * Stops all current animations
   * @internal
   */
  stopAll() {
    return this.dispatchEvent(new Sl()), this.disableIdleTimer(), this.stopAnimation();
  }
};
function Tae(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var ox = { exports: {} };
(function(t) {
  var e = Object.prototype.hasOwnProperty, n = "~";
  function r() {
  }
  Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (n = !1));
  function i(l, c, u) {
    this.fn = l, this.context = c, this.once = u || !1;
  }
  function o(l, c, u, d, f) {
    if (typeof u != "function")
      throw new TypeError("The listener must be a function");
    var h = new i(u, d || l, f), v = n ? n + c : c;
    return l._events[v] ? l._events[v].fn ? l._events[v] = [l._events[v], h] : l._events[v].push(h) : (l._events[v] = h, l._eventsCount++), l;
  }
  function a(l, c) {
    --l._eventsCount === 0 ? l._events = new r() : delete l._events[c];
  }
  function s() {
    this._events = new r(), this._eventsCount = 0;
  }
  s.prototype.eventNames = function() {
    var c = [], u, d;
    if (this._eventsCount === 0)
      return c;
    for (d in u = this._events)
      e.call(u, d) && c.push(n ? d.slice(1) : d);
    return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(u)) : c;
  }, s.prototype.listeners = function(c) {
    var u = n ? n + c : c, d = this._events[u];
    if (!d)
      return [];
    if (d.fn)
      return [d.fn];
    for (var f = 0, h = d.length, v = new Array(h); f < h; f++)
      v[f] = d[f].fn;
    return v;
  }, s.prototype.listenerCount = function(c) {
    var u = n ? n + c : c, d = this._events[u];
    return d ? d.fn ? 1 : d.length : 0;
  }, s.prototype.emit = function(c, u, d, f, h, v) {
    var g = n ? n + c : c;
    if (!this._events[g])
      return !1;
    var m = this._events[g], p = arguments.length, y, b;
    if (m.fn) {
      switch (m.once && this.removeListener(c, m.fn, void 0, !0), p) {
        case 1:
          return m.fn.call(m.context), !0;
        case 2:
          return m.fn.call(m.context, u), !0;
        case 3:
          return m.fn.call(m.context, u, d), !0;
        case 4:
          return m.fn.call(m.context, u, d, f), !0;
        case 5:
          return m.fn.call(m.context, u, d, f, h), !0;
        case 6:
          return m.fn.call(m.context, u, d, f, h, v), !0;
      }
      for (b = 1, y = new Array(p - 1); b < p; b++)
        y[b - 1] = arguments[b];
      m.fn.apply(m.context, y);
    } else {
      var x = m.length, _;
      for (b = 0; b < x; b++)
        switch (m[b].once && this.removeListener(c, m[b].fn, void 0, !0), p) {
          case 1:
            m[b].fn.call(m[b].context);
            break;
          case 2:
            m[b].fn.call(m[b].context, u);
            break;
          case 3:
            m[b].fn.call(m[b].context, u, d);
            break;
          case 4:
            m[b].fn.call(m[b].context, u, d, f);
            break;
          default:
            if (!y)
              for (_ = 1, y = new Array(p - 1); _ < p; _++)
                y[_ - 1] = arguments[_];
            m[b].fn.apply(m[b].context, y);
        }
    }
    return !0;
  }, s.prototype.on = function(c, u, d) {
    return o(this, c, u, d, !1);
  }, s.prototype.once = function(c, u, d) {
    return o(this, c, u, d, !0);
  }, s.prototype.removeListener = function(c, u, d, f) {
    var h = n ? n + c : c;
    if (!this._events[h])
      return this;
    if (!u)
      return a(this, h), this;
    var v = this._events[h];
    if (v.fn)
      v.fn === u && (!f || v.once) && (!d || v.context === d) && a(this, h);
    else {
      for (var g = 0, m = [], p = v.length; g < p; g++)
        (v[g].fn !== u || f && !v[g].once || d && v[g].context !== d) && m.push(v[g]);
      m.length ? this._events[h] = m.length === 1 ? m[0] : m : a(this, h);
    }
    return this;
  }, s.prototype.removeAllListeners = function(c) {
    var u;
    return c ? (u = n ? n + c : c, this._events[u] && a(this, u)) : (this._events = new r(), this._eventsCount = 0), this;
  }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = n, s.EventEmitter = s, t.exports = s;
})(ox);
var Aae = ox.exports, Pae = /* @__PURE__ */ Tae(Aae), ou = new Pae(), Tn = {
  on: function(e, n) {
    return ou.on(e, n);
  },
  once: function(e, n) {
    return ou.once(e, n);
  },
  off: function(e, n) {
    return ou.off(e, n);
  },
  emit: function(e, n) {
    return ou.emit(e, n);
  }
};
Object.freeze(Tn);
var Rae = ["src", "height", "width", "hideNavbarButton", "containerClass", "littlePlanet", "onPositionChange", "onZoomChange", "onClick", "onDblclick", "onReady"], D1 = ["zoom", "fullscreen"];
function Lae(t) {
  var e = kh({}, t);
  for (var n in e)
    Rae.includes(n) && delete e[n];
  return e;
}
function Oae(t, e, n, r, i) {
  return (t - e) * (i - r) / (n - e) + r;
}
function Tg(t) {
  return t == null ? D1 : Array.isArray(t) ? t : typeof t == "string" ? t === "" ? !1 : [t] : t ? D1 : !1;
}
function Dae() {
  var t = Ke(), e = za(t, 2), n = e[0], r = e[1], i = Gt(function(o) {
    o && o !== n && r(o);
  }, [n]);
  return [n, i];
}
var ax = /* @__PURE__ */ sr(function(t, e) {
  var n = Dae(), r = za(n, 2), i = r[0], o = r[1], a = Pn(function() {
    return t;
  }, [
    // recreate options when individual props change
    t.panorama,
    t.src,
    t.size,
    t.canvasBackground,
    t.navbar,
    t.height,
    t.width,
    t.containerClass,
    t.hideNavbarButton || !0,
    t.littlePlanet,
    t.fishEye,
    t.lang,
    t.onPositionChange,
    t.onZoomChange,
    t.onClick,
    t.onDblclick,
    t.onReady,
    t.moveSpeed,
    t.zoomSpeed,
    t.moveInertia,
    t.mousewheel,
    t.mousemove,
    t.mousewheelCtrlKey,
    t.touchmoveTwoFingers,
    t.panoData,
    t.requestHeaders,
    t.withCredentials,
    t.keyboard,
    t.keyboardActions,
    t.plugins,
    t.adapter,
    t.sphereCorrection,
    t.minFov,
    t.maxFov,
    t.defaultZoomLvl,
    t.defaultYaw,
    t.defaultPitch,
    t.caption,
    t.description,
    t.downloadUrl,
    t.downloadName,
    t.loadingImg,
    t.loadingTxt,
    t.rendererParameters,
    t.defaultTransition
  ]), s = On(null), l = 130, c = Ke(-90), u = za(c, 1), d = u[0], f = Ke(2), h = za(f, 1), v = h[0], g = Ke(0), m = za(g, 1), p = m[0], y = Ke(D1), b = za(y, 2), x = b[0], _ = b[1], M = On(!0);
  Dt(function() {
    function P() {
      var E = window.innerWidth / window.innerHeight;
      l = Math.floor(Oae(E, 0.5, 1.8, 140, 115));
    }
    return window.addEventListener("resize", P), P(), function() {
      return window.removeEventListener("resize", P);
    };
  }, []), Dt(function() {
    if (i && !s.current) {
      var P, E, w, O, N, I, H, j, U, $ = new Mae(kh(kh({}, Lae(a)), {}, {
        container: i,
        panorama: a.panorama || a.src,
        size: {
          height: a.height,
          width: a.width || "100px"
        },
        fisheye: a.littlePlanet ? v : a.fisheye || !1,
        minFov: (P = a.minFov) !== null && P !== void 0 ? P : 30,
        maxFov: a.littlePlanet ? l : (E = a.maxFov) !== null && E !== void 0 ? E : 90,
        defaultZoomLvl: a.littlePlanet ? p : (w = a.defaultZoomLvl) !== null && w !== void 0 ? w : 50,
        defaultYaw: (O = a.defaultYaw) !== null && O !== void 0 ? O : 0,
        defaultPitch: a.littlePlanet ? d : (N = a.defaultPitch) !== null && N !== void 0 ? N : 0,
        sphereCorrection: a.sphereCorrection || {
          pan: 0,
          tilt: 0,
          roll: 0
        },
        moveSpeed: a.moveSpeed || 1,
        zoomSpeed: a.zoomSpeed || 1,
        // when it undefined, = true, then use input value.
        // The input value maybe false, value || true => false => true
        moveInertia: (I = a.moveInertia) !== null && I !== void 0 ? I : !0,
        mousewheel: a.littlePlanet ? !1 : (H = a.mousewheel) !== null && H !== void 0 ? H : !0,
        mousemove: (j = a.mousemove) !== null && j !== void 0 ? j : !0,
        mousewheelCtrlKey: a.mousewheelCtrlKey || !1,
        touchmoveTwoFingers: a.touchmoveTwoFingers || !1,
        panoData: a.panoData || void 0,
        requestHeaders: a.requestHeaders || void 0,
        withCredentials: a.withCredentials || !1,
        navbar: Tg(a.navbar),
        lang: a.lang || {},
        keyboard: a.keyboard || "fullscreen",
        plugins: (U = a.plugins) !== null && U !== void 0 ? U : []
      }));
      $.addEventListener("ready", function() {
        a.onReady && a.onReady($);
      }, {
        once: !0
      }), $.addEventListener("click", function(k) {
        a.onClick && a.onClick(k, $), a.littlePlanet && M.current && (M.current = !1, $.animate({
          yaw: 0,
          pitch: d,
          zoom: 75,
          speed: "3rpm"
        }).then(function() {
          $.animate({
            yaw: 0,
            pitch: 0,
            zoom: 90,
            speed: "10rpm"
          }).then(function() {
            var G;
            $.setOption("maxFov", a.maxFov || 70), $.setOption("mousewheel", (G = a.mousewheel) !== null && G !== void 0 ? G : !0);
          });
        }));
      }), $.addEventListener("dblclick", function(k) {
        a.onDblclick && a.onDblclick(k, $);
      }), $.addEventListener("zoom-updated", function(k) {
        a.onZoomChange && a.onZoomChange(k, $);
      }), $.addEventListener("position-updated", function(k) {
        a.onPositionChange && a.onPositionChange(k.position.pitch, k.position.yaw, $);
      });
      var V = Tg(a.navbar);
      if (a.littlePlanet) {
        var te, B, Z = `<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 20C16.4183 20 20 16.4183 20 12C20 11.8805 19.9974 11.7615 19.9922 11.6433C20.2479 11.4141 20.4882 11.1864 20.7118 10.9611C21.0037 10.6672 21.002 10.1923 20.708 9.90049C20.4336 9.628 20.0014 9.61143 19.7077 9.84972C19.4023 8.75248 18.8688 7.75024 18.1616 6.89725C18.4607 6.84611 18.7436 6.8084 19.0087 6.784C19.4212 6.74604 19.7247 6.38089 19.6868 5.96842C19.6488 5.55595 19.2837 5.25235 18.8712 5.29032C18.4474 5.32932 17.9972 5.39638 17.5262 5.48921C17.3267 5.52851 17.1614 5.64353 17.0543 5.79852C15.6765 4.67424 13.917 4 12 4C7.58172 4 4 7.58172 4 12C4 12.2776 4.01414 12.552 4.04175 12.8223C3.78987 12.7532 3.50899 12.8177 3.31137 13.0159C2.97651 13.3517 2.67596 13.6846 2.415 14.0113C2.15647 14.3349 2.20924 14.8069 2.53287 15.0654C2.8565 15.3239 3.32843 15.2711 3.58696 14.9475C3.78866 14.695 4.02466 14.4302 4.2938 14.1557C4.60754 15.2796 5.16056 16.3037 5.8945 17.1697C5.66824 17.3368 5.54578 17.6248 5.60398 17.919C5.68437 18.3253 6.07894 18.5896 6.48528 18.5092C6.7024 18.4662 6.92455 18.4177 7.15125 18.3637C8.49656 19.3903 10.1771 20 12 20ZM7.15125 18.3637C6.69042 18.012 6.26891 17.6114 5.8945 17.1697C5.98073 17.106 6.08204 17.0599 6.19417 17.0377C7.19089 16.8405 8.33112 16.5084 9.55581 16.0486C9.94359 15.903 10.376 16.0994 10.5216 16.4872C10.6671 16.8749 10.4708 17.3073 10.083 17.4529C9.05325 17.8395 8.0653 18.1459 7.15125 18.3637ZM19.7077 9.84972C19.6869 9.86663 19.6667 9.88483 19.6474 9.90431C18.9609 10.5957 18.0797 11.3337 17.0388 12.0753C16.7014 12.3157 16.6228 12.784 16.8631 13.1213C17.1035 13.4587 17.5718 13.5373 17.9091 13.297C18.6809 12.7471 19.3806 12.1912 19.9922 11.6433C19.965 11.0246 19.8676 10.4241 19.7077 9.84972ZM20.9366 5.37924C20.5336 5.28378 20.1294 5.53313 20.034 5.93619C19.9385 6.33925 20.1879 6.74339 20.5909 6.83886C20.985 6.93219 21.1368 7.07125 21.1932 7.16142C21.2565 7.26269 21.3262 7.52732 21.0363 8.10938C20.8516 8.48014 21.0025 8.93042 21.3732 9.1151C21.744 9.29979 22.1943 9.14894 22.379 8.77818C22.7566 8.02003 22.9422 7.12886 22.4648 6.36582C22.1206 5.81574 21.5416 5.52252 20.9366 5.37924ZM2.81481 16.2501C2.94057 15.8555 2.72259 15.4336 2.32793 15.3078C1.93327 15.1821 1.51138 15.4 1.38562 15.7947C1.19392 16.3963 1.17354 17.0573 1.53488 17.6349C1.98775 18.3587 2.84153 18.6413 3.68907 18.7224C4.1014 18.7619 4.46765 18.4596 4.50712 18.0473C4.54658 17.635 4.24432 17.2687 3.83199 17.2293C3.13763 17.1628 2.88355 16.9624 2.80651 16.8393C2.75679 16.7598 2.70479 16.5954 2.81481 16.2501ZM15.7504 14.704C16.106 14.4915 16.2218 14.0309 16.0093 13.6754C15.7967 13.3199 15.3362 13.204 14.9807 13.4166C14.4991 13.7045 13.9974 13.9881 13.4781 14.2648C12.9445 14.5491 12.4132 14.8149 11.8883 15.0615C11.5134 15.2376 11.3522 15.6843 11.5283 16.0592C11.7044 16.4341 12.1511 16.5953 12.526 16.4192C13.0739 16.1618 13.6277 15.8847 14.1834 15.5887C14.7242 15.3005 15.2474 15.0048 15.7504 14.704Z" fill="rgba(255,255,255,.7)"/>
                </svg>`, Q = {
          id: "resetLittlePlanetButton",
          content: ((te = t.lang) === null || te === void 0 ? void 0 : te.littlePlanetIcon) || Z,
          title: ((B = t.lang) === null || B === void 0 ? void 0 : B.littlePlanetButton) || "Reset Little Planet",
          className: "resetLittlePlanetButton",
          onClick: function() {
            M.current = !0, $.setOption("maxFov", l), $.setOption("mousewheel", !1), $.animate({
              yaw: 0,
              pitch: d,
              zoom: p,
              speed: "10rpm"
            });
          }
        };
        V !== !1 && !V.find(function(k) {
          return td(k) === "object" && (k == null ? void 0 : k.id) === "resetLittlePlanetButton";
        }) && V.splice(1, 0, Q);
      }
      if (a.hideNavbarButton) {
        var ce = {
          id: "hideNavbarButton",
          content: `<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none">
                            <g clip-path="url(#clip0_429_11083)">
                            <path d="M7 7.00006L17 17.0001M7 17.0001L17 7.00006" stroke="rgba(255,255,255,.7)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_429_11083">
                            <rect width="24" height="24" fill="white"/>
                            </clipPath>
                            </defs>
                            </svg>`,
          title: "Hide Navbar",
          className: "hideNavbarButton",
          onClick: function() {
            $.navbar.hide();
            var G = document.createElement("a");
            G.className = "showNavbarButton", G.innerHTML = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 26 26" style="enable-background:new 0 0 26 26;" xml:space="preserve" class="icon icon-back-to-top">
                                        <g>
                                        <path d="M13.8,1.3L21.6,9c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.1,0.3,0.1,0.4s0,0.3-0.1,0.4c-0.1,0.1-0.1,0.3-0.3,0.4
                                            c-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1c-0.2-0.1-0.3-0.2-0.4-0.3L14.2,5l0,19.1
                                            c0,0.2-0.1,0.3-0.1,0.5c0,0.1-0.1,0.3-0.3,0.4c-0.1,0.1-0.2,0.2-0.4,0.3c-0.1,0.1-0.3,0.1-0.5,0.1c-0.1,0-0.3,0-0.4-0.1
                                            c-0.1-0.1-0.3-0.1-0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.1-0.1-0.3-0.1-0.5l0-19.1l-5.7,5.7C6,10.8,5.8,10.9,5.7,11
                                            c-0.1,0.1-0.3,0.1-0.4,0.1c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.1-0.2-0.2-0.4C4.1,10.2,4,10.1,4.1,9.9
                                            c0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.3,0.3-0.4l7.7-7.8c0.1,0,0.2-0.1,0.2-0.1c0,0,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.2-0.1
                                            c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1C13.7,1.2,13.8,1.2,13.8,1.3z"></path>
                                        </g>
                                        </svg>`, G.title = "Show Navbar", G.onclick = function(K) {
              K.preventDefault(), $.navbar.show(), G.remove();
            }, document.body.appendChild(G);
          }
        };
        V !== !1 && !V.find(function(k) {
          return td(k) === "object" && (k == null ? void 0 : k.id) === "hideNavbarButton";
        }) && V.push(ce);
      }
      V !== !1 ? ($.setOption("navbar", V), _(V)) : $.navbar.hide(), Tn.on("animate", function(k) {
        $.animate(k);
      }).on("stop-animation", function() {
        $.stopAnimation();
      }).on("destroy", function() {
        $.destroy();
      }).on("rotate", function(k) {
        $.rotate(k);
      }).on("setOption", function(k) {
        var G = k.option, K = k.value;
        $.setOption(G, K);
      }).on("setOptions", function(k) {
        $.setOptions(k);
      }).on("zoom", function(k) {
        $.zoom(k);
      }).on("zoomIn", function(k) {
        $.zoomIn(k);
      }).on("zoomOut", function(k) {
        $.zoomOut(k);
      }).on("resize", function(k) {
        $.resize(k);
      }).on("enterFullscreen", function() {
        $.enterFullscreen();
      }).on("exitFullscreen", function() {
        $.exitFullscreen();
      }).on("toggleFullscreen", function() {
        $.toggleFullscreen();
      }).on("needsContinuousUpdate", function(k) {
        $.needsContinuousUpdate(k);
      }).on("observeObjects", function(k) {
        $.observeObjects(k);
      }).on("unobserveObjects", function(k) {
        $.unobserveObjects(k);
      }).on("setCursor", function(k) {
        $.setCursor(k);
      }).on("setPanorama", function(k) {
        $.setPanorama(k.path, k.options);
      }).on("showError", function(k) {
        $.showError(k);
      }).on("hideError", function() {
        $.hideError();
      }).on("startKeyboardControl", function() {
        $.startKeyboardControl();
      }).on("stopKeyboardControl", function() {
        $.stopKeyboardControl();
      }), s.current = $;
    }
  }, [i, a]), Dt(function() {
    var P = s.current;
    if (P && P.container && P.container.parentNode && P && P.container && P.container.parentNode) {
      var E, w, O, N;
      (E = P.renderer) === null || E === void 0 || (w = E.renderer) === null || w === void 0 || w.dispose(), (O = P.renderer) === null || O === void 0 || (N = O.renderer) === null || N === void 0 || N.forceContextLoss(), P.destroy();
    }
  }, [s]), Dt(function() {
    var P, E = (P = a.panorama) !== null && P !== void 0 ? P : a.src;
    s.current && E && s.current.setPanorama(E, {});
  }, [a.src, a.panorama]);
  var S = function() {
    return {
      animate: function(w) {
        Tn.emit("animate", w);
      },
      destroy: function() {
        Tn.emit("destroy", {});
      },
      createTooltip: function(w) {
        var O;
        return (O = s.current) === null || O === void 0 ? void 0 : O.createTooltip(w);
      },
      needsContinuousUpdate: function(w) {
        Tn.emit("needsContinuousUpdate", w);
      },
      observeObjects: function(w) {
        Tn.emit("observeObjects", w);
      },
      unobserveObjects: function(w) {
        Tn.emit("unobserveObjects", w);
      },
      setCursor: function(w) {
        Tn.emit("setCursor", w);
      },
      stopAnimation: function() {
        Tn.emit("stop-animation", {});
      },
      rotate: function(w) {
        Tn.emit("rotate", w);
      },
      setOption: function(w, O) {
        Tn.emit("setOption", {
          option: w,
          value: O
        });
      },
      setOptions: function(w) {
        var O;
        return (O = s.current) === null || O === void 0 ? void 0 : O.setOptions(w);
      },
      getCurrentNavbar: function() {
        return x;
      },
      zoom: function(w) {
        Tn.emit("zoom", w);
      },
      zoomIn: function(w) {
        Tn.emit("zoomIn", {
          step: w
        });
      },
      zoomOut: function(w) {
        Tn.emit("zoomOut", {
          step: w
        });
      },
      resize: function(w) {
        var O;
        return (O = s.current) === null || O === void 0 ? void 0 : O.resize(w);
      },
      enterFullscreen: function() {
        var w;
        return (w = s.current) === null || w === void 0 ? void 0 : w.enterFullscreen();
      },
      exitFullscreen: function() {
        var w;
        return (w = s.current) === null || w === void 0 ? void 0 : w.exitFullscreen();
      },
      toggleFullscreen: function() {
        var w;
        return (w = s.current) === null || w === void 0 ? void 0 : w.toggleFullscreen();
      },
      isFullscreenEnabled: function() {
        var w;
        return (w = s.current) === null || w === void 0 ? void 0 : w.isFullscreenEnabled();
      },
      getPlugin: function(w) {
        var O;
        return (O = s.current) === null || O === void 0 ? void 0 : O.getPlugin(w);
      },
      getPosition: function() {
        var w;
        return (w = s.current) === null || w === void 0 ? void 0 : w.getPosition();
      },
      getZoomLevel: function() {
        var w;
        return (w = s.current) === null || w === void 0 ? void 0 : w.getZoomLevel();
      },
      getSize: function() {
        var w;
        return (w = s.current) === null || w === void 0 ? void 0 : w.getSize();
      },
      needsUpdate: function() {
        var w;
        return (w = s.current) === null || w === void 0 ? void 0 : w.needsUpdate();
      },
      autoSize: function() {
        var w;
        return (w = s.current) === null || w === void 0 ? void 0 : w.autoSize();
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      setPanorama: function(w, O) {
        var N;
        return (N = s.current) === null || N === void 0 ? void 0 : N.setPanorama(w, O);
      },
      showError: function(w) {
        var O;
        return (O = s.current) === null || O === void 0 ? void 0 : O.showError(w);
      },
      hideError: function() {
        var w;
        return (w = s.current) === null || w === void 0 ? void 0 : w.hideError();
      },
      startKeyboardControl: function() {
        var w;
        return (w = s.current) === null || w === void 0 ? void 0 : w.startKeyboardControl();
      },
      stopKeyboardControl: function() {
        var w;
        return (w = s.current) === null || w === void 0 ? void 0 : w.stopKeyboardControl();
      }
    };
  };
  return j1(e, S, [s.current, i, a, e]), /* @__PURE__ */ A.createElement("div", {
    className: a.containerClass || "view-container",
    ref: o
  });
});
ax.displayName = "ReactPhotoSphereViewer";
var ir = function(t, e) {
  return Number(t.toFixed(e));
}, kae = function(t, e) {
  return typeof t == "number" ? t : e;
}, Bt = function(t, e, n) {
  n && typeof n == "function" && n(t, e);
}, Nae = function(t) {
  return -Math.cos(t * Math.PI) / 2 + 0.5;
}, Iae = function(t) {
  return t;
}, Fae = function(t) {
  return t * t;
}, Uae = function(t) {
  return t * (2 - t);
}, zae = function(t) {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}, Hae = function(t) {
  return t * t * t;
}, Bae = function(t) {
  return --t * t * t + 1;
}, Vae = function(t) {
  return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
}, $ae = function(t) {
  return t * t * t * t;
}, Wae = function(t) {
  return 1 - --t * t * t * t;
}, jae = function(t) {
  return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
}, Gae = function(t) {
  return t * t * t * t * t;
}, qae = function(t) {
  return 1 + --t * t * t * t * t;
}, Xae = function(t) {
  return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
}, sx = {
  easeOut: Nae,
  linear: Iae,
  easeInQuad: Fae,
  easeOutQuad: Uae,
  easeInOutQuad: zae,
  easeInCubic: Hae,
  easeOutCubic: Bae,
  easeInOutCubic: Vae,
  easeInQuart: $ae,
  easeOutQuart: Wae,
  easeInOutQuart: jae,
  easeInQuint: Gae,
  easeOutQuint: qae,
  easeInOutQuint: Xae
}, lx = function(t) {
  typeof t == "number" && cancelAnimationFrame(t);
}, kr = function(t) {
  t.mounted && (lx(t.animation), t.animate = !1, t.animation = null, t.velocity = null);
};
function cx(t, e, n, r) {
  if (t.mounted) {
    var i = (/* @__PURE__ */ new Date()).getTime(), o = 1;
    kr(t), t.animation = function() {
      if (!t.mounted)
        return lx(t.animation);
      var a = (/* @__PURE__ */ new Date()).getTime() - i, s = a / n, l = sx[e], c = l(s);
      a >= n ? (r(o), t.animation = null) : t.animation && (r(c), requestAnimationFrame(t.animation));
    }, requestAnimationFrame(t.animation);
  }
}
function Yae(t) {
  var e = t.scale, n = t.positionX, r = t.positionY;
  return !(Number.isNaN(e) || Number.isNaN(n) || Number.isNaN(r));
}
function so(t, e, n, r) {
  var i = Yae(e);
  if (!(!t.mounted || !i)) {
    var o = t.setTransformState, a = t.transformState, s = a.scale, l = a.positionX, c = a.positionY, u = e.scale - s, d = e.positionX - l, f = e.positionY - c;
    n === 0 ? o(e.scale, e.positionX, e.positionY) : cx(t, r, n, function(h) {
      var v = s + u * h, g = l + d * h, m = c + f * h;
      o(v, g, m);
    });
  }
}
function Zae(t, e, n) {
  var r = t.offsetWidth, i = t.offsetHeight, o = e.offsetWidth, a = e.offsetHeight, s = o * n, l = a * n, c = r - s, u = i - l;
  return {
    wrapperWidth: r,
    wrapperHeight: i,
    newContentWidth: s,
    newDiffWidth: c,
    newContentHeight: l,
    newDiffHeight: u
  };
}
var Kae = function(t, e, n, r, i, o, a) {
  var s = t > e ? n * (a ? 1 : 0.5) : 0, l = r > i ? o * (a ? 1 : 0.5) : 0, c = t - e - s, u = s, d = r - i - l, f = l;
  return { minPositionX: c, maxPositionX: u, minPositionY: d, maxPositionY: f };
}, W2 = function(t, e) {
  var n = t.wrapperComponent, r = t.contentComponent, i = t.setup.centerZoomedOut;
  if (!n || !r)
    throw new Error("Components are not mounted");
  var o = Zae(n, r, e), a = o.wrapperWidth, s = o.wrapperHeight, l = o.newContentWidth, c = o.newDiffWidth, u = o.newContentHeight, d = o.newDiffHeight, f = Kae(a, l, c, s, u, d, !!i);
  return f;
}, k1 = function(t, e, n, r) {
  return r ? t < e ? ir(e, 2) : t > n ? ir(n, 2) : ir(t, 2) : ir(t, 2);
}, os = function(t, e) {
  var n = W2(t, e);
  return t.bounds = n, n;
};
function sf(t, e, n, r, i, o, a) {
  var s = n.minPositionX, l = n.minPositionY, c = n.maxPositionX, u = n.maxPositionY, d = 0, f = 0;
  a && (d = i, f = o);
  var h = k1(t, s - d, c + d, r), v = k1(e, l - f, u + f, r);
  return { x: h, y: v };
}
function lf(t, e, n, r, i, o) {
  var a = t.transformState, s = a.scale, l = a.positionX, c = a.positionY, u = r - s;
  if (typeof e != "number" || typeof n != "number")
    return console.error("Mouse X and Y position were not provided!"), { x: l, y: c };
  var d = l - e * u, f = c - n * u, h = sf(d, f, i, o, 0, 0, null);
  return h;
}
function vc(t, e, n, r, i) {
  var o = i ? r : 0, a = e - o;
  return !Number.isNaN(n) && t >= n ? n : !Number.isNaN(e) && t <= a ? a : t;
}
var Ag = function(t, e) {
  var n = t.setup.panning.excluded, r = t.isInitialized, i = t.wrapperComponent, o = e.target, a = "shadowRoot" in o && "composedPath" in e, s = a ? e.composedPath().some(function(u) {
    return u instanceof Element ? i == null ? void 0 : i.contains(u) : !1;
  }) : i == null ? void 0 : i.contains(o), l = r && o && s;
  if (!l)
    return !1;
  var c = cf(o, n);
  return !c;
}, Pg = function(t) {
  var e = t.isInitialized, n = t.isPanning, r = t.setup, i = r.panning.disabled, o = e && n && !i;
  return !!o;
}, Jae = function(t, e) {
  var n = t.transformState, r = n.positionX, i = n.positionY;
  t.isPanning = !0;
  var o = e.clientX, a = e.clientY;
  t.startCoords = { x: o - r, y: a - i };
}, Qae = function(t, e) {
  var n = e.touches, r = t.transformState, i = r.positionX, o = r.positionY;
  t.isPanning = !0;
  var a = n.length === 1;
  if (a) {
    var s = n[0].clientX, l = n[0].clientY;
    t.startCoords = { x: s - i, y: l - o };
  }
};
function ese(t) {
  var e = t.transformState, n = e.positionX, r = e.positionY, i = e.scale, o = t.setup, a = o.disabled, s = o.limitToBounds, l = o.centerZoomedOut, c = t.wrapperComponent;
  if (!(a || !c || !t.bounds)) {
    var u = t.bounds, d = u.maxPositionX, f = u.minPositionX, h = u.maxPositionY, v = u.minPositionY, g = n > d || n < f, m = r > h || r < v, p = n > d ? c.offsetWidth : t.setup.minPositionX || 0, y = r > h ? c.offsetHeight : t.setup.minPositionY || 0, b = lf(t, p, y, i, t.bounds, s || l), x = b.x, _ = b.y;
    return {
      scale: i,
      positionX: g ? x : n,
      positionY: m ? _ : r
    };
  }
}
function ux(t, e, n, r, i) {
  var o = t.setup.limitToBounds, a = t.wrapperComponent, s = t.bounds, l = t.transformState, c = l.scale, u = l.positionX, d = l.positionY;
  if (!(a === null || s === null || e === u && n === d)) {
    var f = sf(e, n, s, o, r, i, a), h = f.x, v = f.y;
    t.setTransformState(c, h, v);
  }
}
var tse = function(t, e, n) {
  var r = t.startCoords, i = t.transformState, o = t.setup.panning, a = o.lockAxisX, s = o.lockAxisY, l = i.positionX, c = i.positionY;
  if (!r)
    return { x: l, y: c };
  var u = e - r.x, d = n - r.y, f = a ? l : u, h = s ? c : d;
  return { x: f, y: h };
}, as = function(t, e) {
  var n = t.setup, r = t.transformState, i = r.scale, o = n.minScale, a = n.disablePadding;
  return e > 0 && i >= o && !a ? e : 0;
}, nse = function(t) {
  var e = t.mounted, n = t.setup, r = n.disabled, i = n.velocityAnimation, o = t.transformState.scale, a = i.disabled, s = !a || o > 1 || !r || e;
  return !!s;
}, rse = function(t) {
  var e = t.mounted, n = t.velocity, r = t.bounds, i = t.setup, o = i.disabled, a = i.velocityAnimation, s = t.transformState.scale, l = a.disabled, c = !l || s > 1 || !o || e;
  return !(!c || !n || !r);
};
function ise(t, e) {
  var n = t.setup.velocityAnimation, r = n.equalToMove, i = n.animationTime, o = n.sensitivity;
  return r ? i * e * o : i;
}
function Rg(t, e, n, r, i, o, a, s, l, c) {
  if (i) {
    if (e > a && n > a) {
      var u = a + (t - a) * c;
      return u > l ? l : u < a ? a : u;
    }
    if (e < o && n < o) {
      var u = o + (t - o) * c;
      return u < s ? s : u > o ? o : u;
    }
  }
  return r ? e : k1(t, o, a, i);
}
function ose(t, e) {
  var n = 1;
  return e ? Math.min(n, t.offsetWidth / window.innerWidth) : n;
}
function ase(t, e) {
  var n = nse(t);
  if (n) {
    var r = t.lastMousePosition, i = t.velocityTime, o = t.setup, a = t.wrapperComponent, s = o.velocityAnimation.equalToMove, l = Date.now();
    if (r && i && a) {
      var c = ose(a, s), u = e.x - r.x, d = e.y - r.y, f = u / c, h = d / c, v = l - i, g = u * u + d * d, m = Math.sqrt(g) / v;
      t.velocity = { velocityX: f, velocityY: h, total: m };
    }
    t.lastMousePosition = e, t.velocityTime = l;
  }
}
function sse(t) {
  var e = t.velocity, n = t.bounds, r = t.setup, i = t.wrapperComponent, o = rse(t);
  if (!(!o || !e || !n || !i)) {
    var a = e.velocityX, s = e.velocityY, l = e.total, c = n.maxPositionX, u = n.minPositionX, d = n.maxPositionY, f = n.minPositionY, h = r.limitToBounds, v = r.alignmentAnimation, g = r.zoomAnimation, m = r.panning, p = m.lockAxisY, y = m.lockAxisX, b = g.animationType, x = v.sizeX, _ = v.sizeY, M = v.velocityAlignmentTime, S = M, P = ise(t, l), E = Math.max(P, S), w = as(t, x), O = as(t, _), N = w * i.offsetWidth / 100, I = O * i.offsetHeight / 100, H = c + N, j = u - N, U = d + I, $ = f - I, V = t.transformState, te = (/* @__PURE__ */ new Date()).getTime();
    cx(t, b, E, function(B) {
      var Z = t.transformState, Q = Z.scale, ce = Z.positionX, k = Z.positionY, G = (/* @__PURE__ */ new Date()).getTime() - te, K = G / S, J = sx[v.animationType], se = 1 - J(Math.min(1, K)), be = 1 - B, pe = ce + a * be, Ne = k + s * be, ae = Rg(pe, V.positionX, ce, y, h, u, c, j, H, se), Re = Rg(Ne, V.positionY, k, p, h, f, d, $, U, se);
      (ce !== pe || k !== Ne) && t.setTransformState(Q, ae, Re);
    });
  }
}
function Lg(t, e) {
  var n = t.transformState.scale;
  kr(t), os(t, n), window.TouchEvent !== void 0 && e instanceof TouchEvent ? Qae(t, e) : Jae(t, e);
}
function dx(t) {
  var e = t.transformState.scale, n = t.setup, r = n.minScale, i = n.alignmentAnimation, o = i.disabled, a = i.sizeX, s = i.sizeY, l = i.animationTime, c = i.animationType, u = o || e < r || !a && !s;
  if (!u) {
    var d = ese(t);
    d && so(t, d, l, c);
  }
}
function Og(t, e, n) {
  var r = t.startCoords, i = t.setup, o = i.alignmentAnimation, a = o.sizeX, s = o.sizeY;
  if (r) {
    var l = tse(t, e, n), c = l.x, u = l.y, d = as(t, a), f = as(t, s);
    ase(t, { x: c, y: u }), ux(t, c, u, d, f);
  }
}
function lse(t) {
  if (t.isPanning) {
    var e = t.setup.panning.velocityDisabled, n = t.velocity, r = t.wrapperComponent, i = t.contentComponent;
    t.isPanning = !1, t.animate = !1, t.animation = null;
    var o = r == null ? void 0 : r.getBoundingClientRect(), a = i == null ? void 0 : i.getBoundingClientRect(), s = (o == null ? void 0 : o.width) || 0, l = (o == null ? void 0 : o.height) || 0, c = (a == null ? void 0 : a.width) || 0, u = (a == null ? void 0 : a.height) || 0, d = s < c || l < u, f = !e && n && (n == null ? void 0 : n.total) > 0.1 && d;
    f ? sse(t) : dx(t);
  }
}
function j2(t, e, n, r) {
  var i = t.setup, o = i.minScale, a = i.maxScale, s = i.limitToBounds, l = vc(ir(e, 2), o, a, 0, !1), c = os(t, l), u = lf(t, n, r, l, c, s), d = u.x, f = u.y;
  return { scale: l, positionX: d, positionY: f };
}
function fx(t, e, n) {
  var r = t.transformState.scale, i = t.wrapperComponent, o = t.setup, a = o.minScale, s = o.limitToBounds, l = o.zoomAnimation, c = l.disabled, u = l.animationTime, d = l.animationType, f = c || r >= a;
  if ((r >= 1 || s) && dx(t), !(f || !i || !t.mounted)) {
    var h = e || i.offsetWidth / 2, v = n || i.offsetHeight / 2, g = j2(t, a, h, v);
    g && so(t, g, u, d);
  }
}
var ji = function() {
  return ji = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, ji.apply(this, arguments);
};
function Dg(t, e, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = e.length, o; r < i; r++)
      (o || !(r in e)) && (o || (o = Array.prototype.slice.call(e, 0, r)), o[r] = e[r]);
  return t.concat(o || Array.prototype.slice.call(e));
}
var au = {
  previousScale: 1,
  scale: 1,
  positionX: 0,
  positionY: 0
}, Qs = {
  disabled: !1,
  minPositionX: null,
  maxPositionX: null,
  minPositionY: null,
  maxPositionY: null,
  minScale: 1,
  maxScale: 8,
  limitToBounds: !0,
  centerZoomedOut: !1,
  centerOnInit: !1,
  disablePadding: !1,
  smooth: !0,
  wheel: {
    step: 0.2,
    disabled: !1,
    smoothStep: 1e-3,
    wheelDisabled: !1,
    touchPadDisabled: !1,
    activationKeys: [],
    excluded: []
  },
  panning: {
    disabled: !1,
    velocityDisabled: !1,
    lockAxisX: !1,
    lockAxisY: !1,
    allowLeftClickPan: !0,
    allowMiddleClickPan: !0,
    allowRightClickPan: !0,
    wheelPanning: !1,
    activationKeys: [],
    excluded: []
  },
  pinch: {
    step: 5,
    disabled: !1,
    excluded: []
  },
  doubleClick: {
    disabled: !1,
    step: 0.7,
    mode: "zoomIn",
    animationType: "easeOut",
    animationTime: 200,
    excluded: []
  },
  zoomAnimation: {
    disabled: !1,
    size: 0.4,
    animationTime: 200,
    animationType: "easeOut"
  },
  alignmentAnimation: {
    disabled: !1,
    sizeX: 100,
    sizeY: 100,
    animationTime: 200,
    velocityAlignmentTime: 400,
    animationType: "easeOut"
  },
  velocityAnimation: {
    disabled: !1,
    sensitivity: 1,
    animationTime: 400,
    animationType: "easeOut",
    equalToMove: !0
  }
}, hx = function(t) {
  var e, n, r, i;
  return {
    previousScale: (e = t.initialScale) !== null && e !== void 0 ? e : au.scale,
    scale: (n = t.initialScale) !== null && n !== void 0 ? n : au.scale,
    positionX: (r = t.initialPositionX) !== null && r !== void 0 ? r : au.positionX,
    positionY: (i = t.initialPositionY) !== null && i !== void 0 ? i : au.positionY
  };
}, kg = function(t) {
  var e = ji({}, Qs);
  return Object.keys(t).forEach(function(n) {
    var r = typeof t[n] < "u", i = typeof Qs[n] < "u";
    if (i && r) {
      var o = Object.prototype.toString.call(Qs[n]), a = o === "[object Object]", s = o === "[object Array]";
      a ? e[n] = ji(ji({}, Qs[n]), t[n]) : s ? e[n] = Dg(Dg([], Qs[n], !0), t[n], !0) : e[n] = t[n];
    }
  }), e;
}, px = function(t, e, n) {
  var r = t.transformState.scale, i = t.wrapperComponent, o = t.setup, a = o.maxScale, s = o.minScale, l = o.zoomAnimation, c = o.smooth, u = l.size;
  if (!i)
    throw new Error("Wrapper is not mounted");
  var d = c ? r * Math.exp(e * n) : r + e * n, f = vc(ir(d, 3), s, a, u, !1);
  return f;
};
function mx(t, e, n, r, i) {
  var o = t.wrapperComponent, a = t.transformState, s = a.scale, l = a.positionX, c = a.positionY;
  if (!o)
    return console.error("No WrapperComponent found");
  var u = o.offsetWidth, d = o.offsetHeight, f = (u / 2 - l) / s, h = (d / 2 - c) / s, v = px(t, e, n), g = j2(t, v, f, h);
  if (!g)
    return console.error("Error during zoom event. New transformation state was not calculated.");
  so(t, g, r, i);
}
function vx(t, e, n, r) {
  var i = t.setup, o = t.wrapperComponent, a = i.limitToBounds, s = hx(t.props), l = t.transformState, c = l.scale, u = l.positionX, d = l.positionY;
  if (o) {
    var f = W2(t, s.scale), h = sf(s.positionX, s.positionY, f, a, 0, 0, o), v = {
      scale: s.scale,
      positionX: h.x,
      positionY: h.y
    };
    c === s.scale && u === s.positionX && d === s.positionY || (r == null || r(), so(t, v, e, n));
  }
}
function cse(t, e, n, r) {
  var i = t.getBoundingClientRect(), o = e.getBoundingClientRect(), a = n.getBoundingClientRect(), s = o.x * r.scale, l = o.y * r.scale;
  return {
    x: (i.x - a.x + s) / r.scale,
    y: (i.y - a.y + l) / r.scale
  };
}
function use(t, e, n) {
  var r = t.wrapperComponent, i = t.contentComponent, o = t.transformState, a = t.setup, s = a.limitToBounds, l = a.minScale, c = a.maxScale;
  if (!r || !i)
    return o;
  var u = r.getBoundingClientRect(), d = e.getBoundingClientRect(), f = cse(e, r, i, o), h = f.x, v = f.y, g = d.width / o.scale, m = d.height / o.scale, p = r.offsetWidth / g, y = r.offsetHeight / m, b = vc(n || Math.min(p, y), l, c, 0, !1), x = (u.width - g * b) / 2, _ = (u.height - m * b) / 2, M = (u.left - h) * b + x, S = (u.top - v) * b + _, P = W2(t, b), E = sf(M, S, P, s, 0, 0, r), w = E.x, O = E.y;
  return { positionX: w, positionY: O, scale: b };
}
var dse = function(t) {
  return function(e, n, r) {
    e === void 0 && (e = 0.5), n === void 0 && (n = 300), r === void 0 && (r = "easeOut"), mx(t, 1, e, n, r);
  };
}, fse = function(t) {
  return function(e, n, r) {
    e === void 0 && (e = 0.5), n === void 0 && (n = 300), r === void 0 && (r = "easeOut"), mx(t, -1, e, n, r);
  };
}, hse = function(t) {
  return function(e, n, r, i, o) {
    i === void 0 && (i = 300), o === void 0 && (o = "easeOut");
    var a = t.transformState, s = a.positionX, l = a.positionY, c = a.scale, u = t.wrapperComponent, d = t.contentComponent, f = t.setup.disabled;
    if (!(f || !u || !d)) {
      var h = {
        positionX: Number.isNaN(e) ? s : e,
        positionY: Number.isNaN(n) ? l : n,
        scale: Number.isNaN(r) ? c : r
      };
      so(t, h, i, o);
    }
  };
}, pse = function(t) {
  return function(e, n) {
    e === void 0 && (e = 200), n === void 0 && (n = "easeOut"), vx(t, e, n);
  };
}, mse = function(t) {
  return function(e, n, r) {
    n === void 0 && (n = 200), r === void 0 && (r = "easeOut");
    var i = t.transformState, o = t.wrapperComponent, a = t.contentComponent;
    if (o && a) {
      var s = gx(e || i.scale, o, a);
      so(t, s, n, r);
    }
  };
}, vse = function(t) {
  return function(e, n, r, i) {
    r === void 0 && (r = 600), i === void 0 && (i = "easeOut"), kr(t);
    var o = t.wrapperComponent, a = typeof e == "string" ? document.getElementById(e) : e;
    if (o && a && o.contains(a)) {
      var s = use(t, a, n);
      so(t, s, r, i);
    }
  };
}, N1 = function(t) {
  return {
    instance: t,
    zoomIn: dse(t),
    zoomOut: fse(t),
    setTransform: hse(t),
    resetTransform: pse(t),
    centerView: mse(t),
    zoomToElement: vse(t)
  };
}, gse = function(t) {
  return {
    instance: t,
    state: t.transformState
  };
}, Rt = function(t) {
  var e = {};
  return Object.assign(e, gse(t)), Object.assign(e, N1(t)), e;
}, B0 = !1;
function V0() {
  try {
    var t = {
      get passive() {
        return B0 = !0, !1;
      }
    };
    return t;
  } catch {
    return B0 = !1, B0;
  }
}
var cf = function(t, e) {
  return e.some(function(n) {
    return t.matches("".concat(n, ", .").concat(n, ", ").concat(n, " *, .").concat(n, " *"));
  });
}, I1 = function(t) {
  t && clearTimeout(t);
}, yse = function(t, e, n) {
  return "translate(".concat(t, "px, ").concat(e, "px) scale(").concat(n, ")");
}, gx = function(t, e, n) {
  var r = n.offsetWidth * t, i = n.offsetHeight * t, o = (e.offsetWidth - r) / 2, a = (e.offsetHeight - i) / 2;
  return {
    scale: t,
    positionX: o,
    positionY: a
  };
};
function bse(t) {
  return function(e) {
    t.forEach(function(n) {
      typeof n == "function" ? n(e) : n != null && (n.current = e);
    });
  };
}
var xse = function(t, e) {
  var n = t.setup.wheel, r = n.disabled, i = n.wheelDisabled, o = n.touchPadDisabled, a = n.excluded, s = t.isInitialized, l = t.isPanning, c = e.target, u = s && !l && !r && c;
  if (!u || i && !e.ctrlKey || o && e.ctrlKey)
    return !1;
  var d = cf(c, a);
  return !d;
}, wse = function(t) {
  return t ? t.deltaY < 0 ? 1 : -1 : 0;
};
function _se(t, e) {
  var n = wse(t), r = kae(e, n);
  return r;
}
function yx(t, e, n) {
  var r = e.getBoundingClientRect(), i = 0, o = 0;
  if ("clientX" in t)
    i = (t.clientX - r.left) / n, o = (t.clientY - r.top) / n;
  else {
    var a = t.touches[0];
    i = (a.clientX - r.left) / n, o = (a.clientY - r.top) / n;
  }
  return (Number.isNaN(i) || Number.isNaN(o)) && console.error("No mouse or touch offset found"), {
    x: i,
    y: o
  };
}
var Cse = function(t, e, n, r, i) {
  var o = t.transformState.scale, a = t.wrapperComponent, s = t.setup, l = s.maxScale, c = s.minScale, u = s.zoomAnimation, d = s.disablePadding, f = u.size, h = u.disabled;
  if (!a)
    throw new Error("Wrapper is not mounted");
  var v = o + e * n;
  if (i)
    return v;
  var g = r ? !1 : !h, m = vc(ir(v, 3), c, l, f, g && !d);
  return m;
}, Ese = function(t, e) {
  var n = t.previousWheelEvent, r = t.transformState.scale, i = t.setup, o = i.maxScale, a = i.minScale;
  return n ? r < o || r > a || Math.sign(n.deltaY) !== Math.sign(e.deltaY) || n.deltaY > 0 && n.deltaY < e.deltaY || n.deltaY < 0 && n.deltaY > e.deltaY || Math.sign(n.deltaY) !== Math.sign(e.deltaY) : !1;
}, Sse = function(t, e) {
  var n = t.setup.pinch, r = n.disabled, i = n.excluded, o = t.isInitialized, a = e.target, s = o && !r && a;
  if (!s)
    return !1;
  var l = cf(a, i);
  return !l;
}, Mse = function(t) {
  var e = t.setup.pinch.disabled, n = t.isInitialized, r = t.pinchStartDistance, i = n && !e && r;
  return !!i;
}, Tse = function(t, e, n) {
  var r = n.getBoundingClientRect(), i = t.touches, o = ir(i[0].clientX - r.left, 5), a = ir(i[0].clientY - r.top, 5), s = ir(i[1].clientX - r.left, 5), l = ir(i[1].clientY - r.top, 5);
  return {
    x: (o + s) / 2 / e,
    y: (a + l) / 2 / e
  };
}, bx = function(t) {
  return Math.sqrt(Math.pow(t.touches[0].pageX - t.touches[1].pageX, 2) + Math.pow(t.touches[0].pageY - t.touches[1].pageY, 2));
}, Ase = function(t, e) {
  var n = t.pinchStartScale, r = t.pinchStartDistance, i = t.setup, o = i.maxScale, a = i.minScale, s = i.zoomAnimation, l = i.disablePadding, c = s.size, u = s.disabled;
  if (!n || r === null || !e)
    throw new Error("Pinch touches distance was not provided");
  if (e < 0)
    return t.transformState.scale;
  var d = e / r, f = d * n;
  return vc(ir(f, 2), a, o, c, !u && !l);
}, Pse = 160, Rse = 100, Lse = function(t, e) {
  var n = t.props, r = n.onWheelStart, i = n.onZoomStart;
  t.wheelStopEventTimer || (kr(t), Bt(Rt(t), e, r), Bt(Rt(t), e, i));
}, Ose = function(t, e) {
  var n = t.props, r = n.onWheel, i = n.onZoom, o = t.contentComponent, a = t.setup, s = t.transformState, l = s.scale, c = a.limitToBounds, u = a.centerZoomedOut, d = a.zoomAnimation, f = a.wheel, h = a.disablePadding, v = a.smooth, g = d.size, m = d.disabled, p = f.step, y = f.smoothStep;
  if (!o)
    throw new Error("Component not mounted");
  e.preventDefault(), e.stopPropagation();
  var b = _se(e, null), x = v ? y * Math.abs(e.deltaY) : p, _ = Cse(t, b, x, !e.ctrlKey);
  if (l !== _) {
    var M = os(t, _), S = yx(e, o, l), P = m || g === 0 || u || h, E = c && P, w = lf(t, S.x, S.y, _, M, E), O = w.x, N = w.y;
    t.previousWheelEvent = e, t.setTransformState(_, O, N), Bt(Rt(t), e, r), Bt(Rt(t), e, i);
  }
}, Dse = function(t, e) {
  var n = t.props, r = n.onWheelStop, i = n.onZoomStop;
  I1(t.wheelAnimationTimer), t.wheelAnimationTimer = setTimeout(function() {
    t.mounted && (fx(t, e.x, e.y), t.wheelAnimationTimer = null);
  }, Rse);
  var o = Ese(t, e);
  o && (I1(t.wheelStopEventTimer), t.wheelStopEventTimer = setTimeout(function() {
    t.mounted && (t.wheelStopEventTimer = null, Bt(Rt(t), e, r), Bt(Rt(t), e, i));
  }, Pse));
}, kse = function(t, e) {
  var n = bx(e);
  t.pinchStartDistance = n, t.lastDistance = n, t.pinchStartScale = t.transformState.scale, t.isPanning = !1, kr(t);
}, Nse = function(t, e) {
  var n = t.contentComponent, r = t.pinchStartDistance, i = t.transformState.scale, o = t.setup, a = o.limitToBounds, s = o.centerZoomedOut, l = o.zoomAnimation, c = l.disabled, u = l.size;
  if (!(r === null || !n)) {
    var d = Tse(e, i, n);
    if (!(!Number.isFinite(d.x) || !Number.isFinite(d.y))) {
      var f = bx(e), h = Ase(t, f);
      if (h !== i) {
        var v = os(t, h), g = c || u === 0 || s, m = a && g, p = lf(t, d.x, d.y, h, v, m), y = p.x, b = p.y;
        t.pinchMidpoint = d, t.lastDistance = f, t.setTransformState(h, y, b);
      }
    }
  }
}, Ise = function(t) {
  var e = t.pinchMidpoint;
  t.velocity = null, t.lastDistance = null, t.pinchMidpoint = null, t.pinchStartScale = null, t.pinchStartDistance = null, fx(t, e == null ? void 0 : e.x, e == null ? void 0 : e.y);
}, xx = function(t, e) {
  var n = t.props.onZoomStop, r = t.setup.doubleClick.animationTime;
  I1(t.doubleClickStopEventTimer), t.doubleClickStopEventTimer = setTimeout(function() {
    t.doubleClickStopEventTimer = null, Bt(Rt(t), e, n);
  }, r);
}, Fse = function(t, e) {
  var n = t.props, r = n.onZoomStart, i = n.onZoom, o = t.setup.doubleClick, a = o.animationTime, s = o.animationType;
  Bt(Rt(t), e, r), vx(t, a, s, function() {
    return Bt(Rt(t), e, i);
  }), xx(t, e);
};
function Use(t, e) {
  return t === "toggle" ? e === 1 ? 1 : -1 : t === "zoomOut" ? -1 : 1;
}
function zse(t, e) {
  var n = t.setup, r = t.doubleClickStopEventTimer, i = t.transformState, o = t.contentComponent, a = i.scale, s = t.props, l = s.onZoomStart, c = s.onZoom, u = n.doubleClick, d = u.disabled, f = u.mode, h = u.step, v = u.animationTime, g = u.animationType;
  if (!d && !r) {
    if (f === "reset")
      return Fse(t, e);
    if (!o)
      return console.error("No ContentComponent found");
    var m = Use(f, t.transformState.scale), p = px(t, m, h);
    if (a !== p) {
      Bt(Rt(t), e, l);
      var y = yx(e, o, a), b = j2(t, p, y.x, y.y);
      if (!b)
        return console.error("Error during zoom event. New transformation state was not calculated.");
      Bt(Rt(t), e, c), so(t, b, v, g), xx(t, e);
    }
  }
}
var Hse = function(t, e) {
  var n = t.isInitialized, r = t.setup, i = t.wrapperComponent, o = r.doubleClick, a = o.disabled, s = o.excluded, l = e.target, c = i == null ? void 0 : i.contains(l), u = n && l && c && !a;
  if (!u)
    return !1;
  var d = cf(l, s);
  return !d;
}, Bse = (
  /** @class */
  function() {
    function t(e) {
      var n = this;
      this.mounted = !0, this.onChangeCallbacks = /* @__PURE__ */ new Set(), this.onInitCallbacks = /* @__PURE__ */ new Set(), this.wrapperComponent = null, this.contentComponent = null, this.isInitialized = !1, this.bounds = null, this.previousWheelEvent = null, this.wheelStopEventTimer = null, this.wheelAnimationTimer = null, this.isPanning = !1, this.isWheelPanning = !1, this.startCoords = null, this.lastTouch = null, this.distance = null, this.lastDistance = null, this.pinchStartDistance = null, this.pinchStartScale = null, this.pinchMidpoint = null, this.doubleClickStopEventTimer = null, this.velocity = null, this.velocityTime = null, this.lastMousePosition = null, this.animate = !1, this.animation = null, this.maxBounds = null, this.pressedKeys = {}, this.mount = function() {
        n.initializeWindowEvents();
      }, this.unmount = function() {
        n.cleanupWindowEvents();
      }, this.update = function(r) {
        n.props = r, os(n, n.transformState.scale), n.setup = kg(r);
      }, this.initializeWindowEvents = function() {
        var r, i, o = V0(), a = (r = n.wrapperComponent) === null || r === void 0 ? void 0 : r.ownerDocument, s = a == null ? void 0 : a.defaultView;
        (i = n.wrapperComponent) === null || i === void 0 || i.addEventListener("wheel", n.onWheelPanning, o), s == null || s.addEventListener("mousedown", n.onPanningStart, o), s == null || s.addEventListener("mousemove", n.onPanning, o), s == null || s.addEventListener("mouseup", n.onPanningStop, o), a == null || a.addEventListener("mouseleave", n.clearPanning, o), s == null || s.addEventListener("keyup", n.setKeyUnPressed, o), s == null || s.addEventListener("keydown", n.setKeyPressed, o);
      }, this.cleanupWindowEvents = function() {
        var r, i, o = V0(), a = (r = n.wrapperComponent) === null || r === void 0 ? void 0 : r.ownerDocument, s = a == null ? void 0 : a.defaultView;
        s == null || s.removeEventListener("mousedown", n.onPanningStart, o), s == null || s.removeEventListener("mousemove", n.onPanning, o), s == null || s.removeEventListener("mouseup", n.onPanningStop, o), a == null || a.removeEventListener("mouseleave", n.clearPanning, o), s == null || s.removeEventListener("keyup", n.setKeyUnPressed, o), s == null || s.removeEventListener("keydown", n.setKeyPressed, o), document.removeEventListener("mouseleave", n.clearPanning, o), kr(n), (i = n.observer) === null || i === void 0 || i.disconnect();
      }, this.handleInitializeWrapperEvents = function(r) {
        var i = V0();
        r.addEventListener("wheel", n.onWheelZoom, i), r.addEventListener("dblclick", n.onDoubleClick, i), r.addEventListener("touchstart", n.onTouchPanningStart, i), r.addEventListener("touchmove", n.onTouchPanning, i), r.addEventListener("touchend", n.onTouchPanningStop, i);
      }, this.handleInitialize = function(r) {
        var i = n.setup.centerOnInit;
        n.applyTransformation(), n.onInitCallbacks.forEach(function(o) {
          return o(Rt(n));
        }), i && (n.setCenter(), n.observer = new ResizeObserver(function() {
          var o, a = r.offsetWidth, s = r.offsetHeight;
          (a > 0 || s > 0) && (n.onInitCallbacks.forEach(function(l) {
            return l(Rt(n));
          }), n.setCenter(), (o = n.observer) === null || o === void 0 || o.disconnect());
        }), setTimeout(function() {
          var o;
          (o = n.observer) === null || o === void 0 || o.disconnect();
        }, 5e3), n.observer.observe(r));
      }, this.onWheelZoom = function(r) {
        var i = n.setup.disabled;
        if (!i) {
          var o = xse(n, r);
          if (o) {
            var a = n.isPressingKeys(n.setup.wheel.activationKeys);
            a && (Lse(n, r), Ose(n, r), Dse(n, r));
          }
        }
      }, this.onWheelPanning = function(r) {
        var i = n.setup, o = i.disabled, a = i.wheel, s = i.panning;
        if (!(!n.wrapperComponent || !n.contentComponent || o || !a.wheelDisabled || s.disabled || !s.wheelPanning || r.ctrlKey)) {
          r.preventDefault(), r.stopPropagation();
          var l = n.transformState, c = l.positionX, u = l.positionY, d = c - r.deltaX, f = u - r.deltaY, h = s.lockAxisX ? c : d, v = s.lockAxisY ? u : f, g = n.setup.alignmentAnimation, m = g.sizeX, p = g.sizeY, y = as(n, m), b = as(n, p);
          h === c && v === u || ux(n, h, v, y, b);
        }
      }, this.onPanningStart = function(r) {
        var i = n.setup.disabled, o = n.props.onPanningStart;
        if (!i) {
          var a = Ag(n, r);
          if (a) {
            var s = n.isPressingKeys(n.setup.panning.activationKeys);
            s && (r.button === 0 && !n.setup.panning.allowLeftClickPan || r.button === 1 && !n.setup.panning.allowMiddleClickPan || r.button === 2 && !n.setup.panning.allowRightClickPan || (r.preventDefault(), r.stopPropagation(), kr(n), Lg(n, r), Bt(Rt(n), r, o)));
          }
        }
      }, this.onPanning = function(r) {
        var i = n.setup.disabled, o = n.props.onPanning;
        if (!i) {
          var a = Pg(n);
          if (a) {
            var s = n.isPressingKeys(n.setup.panning.activationKeys);
            s && (r.preventDefault(), r.stopPropagation(), Og(n, r.clientX, r.clientY), Bt(Rt(n), r, o));
          }
        }
      }, this.onPanningStop = function(r) {
        var i = n.props.onPanningStop;
        n.isPanning && (lse(n), Bt(Rt(n), r, i));
      }, this.onPinchStart = function(r) {
        var i = n.setup.disabled, o = n.props, a = o.onPinchingStart, s = o.onZoomStart;
        if (!i) {
          var l = Sse(n, r);
          l && (kse(n, r), kr(n), Bt(Rt(n), r, a), Bt(Rt(n), r, s));
        }
      }, this.onPinch = function(r) {
        var i = n.setup.disabled, o = n.props, a = o.onPinching, s = o.onZoom;
        if (!i) {
          var l = Mse(n);
          l && (r.preventDefault(), r.stopPropagation(), Nse(n, r), Bt(Rt(n), r, a), Bt(Rt(n), r, s));
        }
      }, this.onPinchStop = function(r) {
        var i = n.props, o = i.onPinchingStop, a = i.onZoomStop;
        n.pinchStartScale && (Ise(n), Bt(Rt(n), r, o), Bt(Rt(n), r, a));
      }, this.onTouchPanningStart = function(r) {
        var i = n.setup.disabled, o = n.props.onPanningStart;
        if (!i) {
          var a = Ag(n, r);
          if (a) {
            var s = n.lastTouch && +/* @__PURE__ */ new Date() - n.lastTouch < 200;
            if (s && r.touches.length === 1)
              n.onDoubleClick(r);
            else {
              n.lastTouch = +/* @__PURE__ */ new Date(), kr(n);
              var l = r.touches, c = l.length === 1, u = l.length === 2;
              c && (kr(n), Lg(n, r), Bt(Rt(n), r, o)), u && n.onPinchStart(r);
            }
          }
        }
      }, this.onTouchPanning = function(r) {
        var i = n.setup.disabled, o = n.props.onPanning;
        if (n.isPanning && r.touches.length === 1) {
          if (i)
            return;
          var a = Pg(n);
          if (!a)
            return;
          r.preventDefault(), r.stopPropagation();
          var s = r.touches[0];
          Og(n, s.clientX, s.clientY), Bt(Rt(n), r, o);
        } else
          r.touches.length > 1 && n.onPinch(r);
      }, this.onTouchPanningStop = function(r) {
        n.onPanningStop(r), n.onPinchStop(r);
      }, this.onDoubleClick = function(r) {
        var i = n.setup.disabled;
        if (!i) {
          var o = Hse(n, r);
          o && zse(n, r);
        }
      }, this.clearPanning = function(r) {
        n.isPanning && n.onPanningStop(r);
      }, this.setKeyPressed = function(r) {
        n.pressedKeys[r.key] = !0;
      }, this.setKeyUnPressed = function(r) {
        n.pressedKeys[r.key] = !1;
      }, this.isPressingKeys = function(r) {
        return r.length ? !!r.find(function(i) {
          return n.pressedKeys[i];
        }) : !0;
      }, this.setTransformState = function(r, i, o) {
        var a = n.props.onTransformed;
        if (!Number.isNaN(r) && !Number.isNaN(i) && !Number.isNaN(o)) {
          r !== n.transformState.scale && (n.transformState.previousScale = n.transformState.scale, n.transformState.scale = r), n.transformState.positionX = i, n.transformState.positionY = o, n.applyTransformation();
          var s = Rt(n);
          n.onChangeCallbacks.forEach(function(l) {
            return l(s);
          }), Bt(s, { scale: r, positionX: i, positionY: o }, a);
        } else
          console.error("Detected NaN set state values");
      }, this.setCenter = function() {
        if (n.wrapperComponent && n.contentComponent) {
          var r = gx(n.transformState.scale, n.wrapperComponent, n.contentComponent);
          n.setTransformState(r.scale, r.positionX, r.positionY);
        }
      }, this.handleTransformStyles = function(r, i, o) {
        return n.props.customTransform ? n.props.customTransform(r, i, o) : yse(r, i, o);
      }, this.applyTransformation = function() {
        if (!(!n.mounted || !n.contentComponent)) {
          var r = n.transformState, i = r.scale, o = r.positionX, a = r.positionY, s = n.handleTransformStyles(o, a, i);
          n.contentComponent.style.transform = s;
        }
      }, this.getContext = function() {
        return Rt(n);
      }, this.onChange = function(r) {
        return n.onChangeCallbacks.has(r) || n.onChangeCallbacks.add(r), function() {
          n.onChangeCallbacks.delete(r);
        };
      }, this.onInit = function(r) {
        return n.onInitCallbacks.has(r) || n.onInitCallbacks.add(r), function() {
          n.onInitCallbacks.delete(r);
        };
      }, this.init = function(r, i) {
        n.cleanupWindowEvents(), n.wrapperComponent = r, n.contentComponent = i, os(n, n.transformState.scale), n.handleInitializeWrapperEvents(r), n.handleInitialize(i), n.initializeWindowEvents(), n.isInitialized = !0;
        var o = Rt(n);
        Bt(o, void 0, n.props.onInit);
      }, this.props = e, this.setup = kg(this.props), this.transformState = hx(this.props);
    }
    return t;
  }()
), G2 = A.createContext(null), Vse = function(t, e) {
  return typeof t == "function" ? t(e) : t;
}, $se = A.forwardRef(function(t, e) {
  var n = On(new Bse(t)).current, r = Vse(t.children, N1(n));
  return j1(e, function() {
    return N1(n);
  }, [n]), Dt(function() {
    n.update(t);
  }, [n, t]), A.createElement(G2.Provider, { value: n }, r);
});
A.forwardRef(function(t, e) {
  var n = On(null), r = W1(G2);
  return Dt(function() {
    return r.onChange(function(i) {
      if (n.current) {
        var o = 0, a = 0;
        n.current.style.transform = r.handleTransformStyles(o, a, 1 / i.instance.transformState.scale);
      }
    });
  }, [r]), A.createElement("div", ji({}, t, { ref: bse([n, e]) }));
});
function Wse(t, e) {
  e === void 0 && (e = {});
  var n = e.insertAt;
  if (!(!t || typeof document > "u")) {
    var r = document.head || document.getElementsByTagName("head")[0], i = document.createElement("style");
    i.type = "text/css", n === "top" && r.firstChild ? r.insertBefore(i, r.firstChild) : r.appendChild(i), i.styleSheet ? i.styleSheet.cssText = t : i.appendChild(document.createTextNode(t));
  }
}
var jse = `.transform-component-module_wrapper__SPB86 {
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  overflow: hidden;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  margin: 0;
  padding: 0;
}
.transform-component-module_content__FBWxo {
  display: flex;
  flex-wrap: wrap;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  margin: 0;
  padding: 0;
  transform-origin: 0% 0%;
}
.transform-component-module_content__FBWxo img {
  pointer-events: none;
}
`, Ng = { wrapper: "transform-component-module_wrapper__SPB86", content: "transform-component-module_content__FBWxo" };
Wse(jse);
var Gse = function(t) {
  var e = t.children, n = t.wrapperClass, r = n === void 0 ? "" : n, i = t.contentClass, o = i === void 0 ? "" : i, a = t.wrapperStyle, s = t.contentStyle, l = t.wrapperProps, c = l === void 0 ? {} : l, u = t.contentProps, d = u === void 0 ? {} : u, f = W1(G2), h = f.init, v = f.cleanupWindowEvents, g = On(null), m = On(null);
  return Dt(function() {
    var p = g.current, y = m.current;
    return p !== null && y !== null && h && (h == null || h(p, y)), function() {
      v == null || v();
    };
  }, []), A.createElement(
    "div",
    ji({}, c, { ref: g, className: "react-transform-wrapper ".concat(Ng.wrapper, " ").concat(r), style: a }),
    A.createElement("div", ji({}, d, { ref: m, className: "react-transform-component ".concat(Ng.content, " ").concat(o), style: s }), e)
  );
};
const xhe = ({
  url: t,
  close: e,
  downloadable: n,
  zoomable: r,
  imageFileName: i,
  panoramicImageHeight: o = "60vh",
  panoramicImageWidth: a = "60vw"
}) => {
  const s = On(null), l = On(null), [c, u] = Ke(0), [d, f] = Ke(null), [h, v] = Ke("normal"), [g, m] = Ke(1), p = d === null;
  Dt(() => {
    t && (async () => {
      const E = await JJ(t, u).promise;
      f(window.URL.createObjectURL(E));
    })();
  }, [t]), Dt(() => {
    if (d) {
      const P = new Image();
      P.src = d, P.onload = () => {
        P.width / P.height >= 2 && v("panorama");
      };
    }
  }, [d]), Dt(() => {
    if (h === "panorama" && l.current) {
      const P = l.current, E = setInterval(() => {
        const O = 1 + P.getZoomLevel() / 100 * 7;
        Math.abs(O - g) > 0.01 && m(O);
      }, 100);
      return () => clearInterval(E);
    }
  }, [h, g]);
  const y = () => {
    if (h === "normal" && s.current)
      s.current.zoomIn();
    else if (h === "panorama" && l.current) {
      const P = l.current.getZoomLevel();
      l.current.zoom(P + 10);
    }
  }, b = () => {
    if (h === "normal" && s.current)
      s.current.zoomOut();
    else if (h === "panorama" && l.current) {
      const P = l.current.getZoomLevel();
      l.current.zoom(P - 10);
    }
  }, x = () => {
    v("panorama"), h === "panorama" && s.current && s.current.resetTransform(), m(1);
  }, _ = () => {
    v("normal"), h === "panorama" && s.current && s.current.resetTransform(), m(1);
  }, M = () => {
    if (l.current) {
      const E = 1 + l.current.getZoomLevel() / 100 * 7;
      m(E);
    }
  }, S = async () => {
    if (d) {
      const P = await fetch(d), E = P.headers.get("Content-Type"), w = (E == null ? void 0 : E.split("/")[1]) || "jpg", O = await P.blob();
      QJ(O, `${i}.${w}`);
    }
  };
  return /* @__PURE__ */ R.jsxs(zZ, { className: "m-4 max-h-screen max-w-screen overflow-hidden", open: !0, children: [
    /* @__PURE__ */ R.jsxs("div", { className: ve("flex", "flex-col", "relative"), children: [
      /* @__PURE__ */ R.jsxs(
        "div",
        {
          className: ve(
            "flex",
            "flex-row",
            "items-center gap-2",
            "justify-end",
            "absolute",
            "right-2",
            "top-2"
          ),
          children: [
            /* @__PURE__ */ R.jsxs("div", { className: "z-20 h-28px w-58px flex flex-row border-1px border-neutral-500 rounded-1 border-solid bg-neutral-100", children: [
              /* @__PURE__ */ R.jsx(
                "div",
                {
                  className: ve(
                    h == "panorama" && "bg-neutral-500",
                    "flex flex-1 items-center justify-center"
                  ),
                  onClick: x,
                  children: /* @__PURE__ */ R.jsx(
                    "div",
                    {
                      className: ve(
                        h == "panorama" ? "color-neutral-100" : "color-neutral-600",
                        "i-skand-panoramaimagegroup cursor-pointer text-12px"
                      )
                    }
                  )
                }
              ),
              /* @__PURE__ */ R.jsx(
                "div",
                {
                  className: ve(
                    h == "normal" && "bg-neutral-500",
                    "flex flex-1 items-center justify-center"
                  ),
                  onClick: _,
                  children: /* @__PURE__ */ R.jsx(
                    "div",
                    {
                      className: ve(
                        h == "normal" ? "color-neutral-100" : "color-neutral-600",
                        "i-skand-image cursor-pointer text-12px"
                      )
                    }
                  )
                }
              )
            ] }),
            n && !p && /* @__PURE__ */ R.jsx(
              "div",
              {
                className: "z-20 h-28px w-28px flex items-center justify-center border-1px border-neutral-500 rounded-4px border-solid bg-neutral-100",
                onClick: S,
                children: /* @__PURE__ */ R.jsx("div", { className: "i-skand-download cursor-pointer text-12px color-neutral-600 hover:color-primary-400" })
              }
            ),
            /* @__PURE__ */ R.jsx(
              "div",
              {
                className: "z-20 h-28px w-28px flex items-center justify-center border-1px border-neutral-500 rounded-4px border-solid bg-neutral-100",
                onClick: e,
                children: /* @__PURE__ */ R.jsx("div", { className: "i-skand-close cursor-pointer text-12px color-neutral-600 hover:color-primary-400" })
              }
            )
          ]
        }
      ),
      p && /* @__PURE__ */ R.jsx(
        "div",
        {
          className: ve(
            "flex",
            "h-60vh",
            "relative",
            "w-100vh",
            "justify-center",
            "items-center"
          ),
          children: /* @__PURE__ */ R.jsx(
            L7,
            {
              className: "relative w-153px b-1px b-rounded-1",
              progress: c * 100
            }
          )
        }
      ),
      r && /* @__PURE__ */ R.jsxs(
        "div",
        {
          className: ve(
            "flex",
            "flex-row",
            "absolute",
            "left-12px",
            "top-8px",
            "z-2",
            "gap-4px",
            "flex",
            "flex-row",
            "items-center",
            "justify-between"
          ),
          children: [
            /* @__PURE__ */ R.jsx(
              "div",
              {
                className: "z-20 h-28px w-28px flex items-center justify-center border-1px border-neutral-500 rounded-4px border-solid bg-neutral-100",
                onClick: b,
                children: /* @__PURE__ */ R.jsx("div", { className: "i-skand-subtract cursor-pointer text-12px color-neutral-600 hover:color-primary-400" })
              }
            ),
            /* @__PURE__ */ R.jsx("div", { className: "w-163px", children: /* @__PURE__ */ R.jsx(
              q7,
              {
                max: 8,
                min: 1,
                onValueChange: (P) => {
                  const E = P[0];
                  if (h === "normal" && s.current) {
                    const { setTransform: w, instance: O } = s.current, { positionX: N, positionY: I } = O.transformState;
                    w(N, I, E);
                  } else if (h === "panorama" && l.current) {
                    const w = (E - 1) / 7 * 100;
                    l.current.zoom(w);
                  }
                  m(E);
                },
                step: 0.1,
                value: [g]
              }
            ) }),
            /* @__PURE__ */ R.jsx(
              "div",
              {
                className: "z-20 h-28px w-28px flex items-center justify-center border-1px border-neutral-500 rounded-4px border-solid bg-neutral-100",
                onClick: y,
                children: /* @__PURE__ */ R.jsx("div", { className: "i-skand-add cursor-pointer text-12px color-neutral-600 hover:color-primary-400" })
              }
            )
          ]
        }
      ),
      d && h === "normal" && /* @__PURE__ */ R.jsx(
        $se,
        {
          initialScale: 1,
          onTransformed: (P, E) => m(E.scale),
          ref: s,
          wheel: {
            smoothStep: 0.1
          },
          children: /* @__PURE__ */ R.jsx(Gse, { children: /* @__PURE__ */ R.jsx("img", { className: ve("object-fit max-h-60vh w-fit max-w-80vw "), src: d }) })
        }
      ),
      d && h === "panorama" && /* @__PURE__ */ R.jsx(
        ax,
        {
          height: o,
          loadingImg: d,
          navbar: !1,
          onReady: () => {
            M();
          },
          ref: l,
          src: d,
          width: a
        }
      )
    ] }),
    /* @__PURE__ */ R.jsx("div", {})
  ] });
}, qse = ({
  inputRef: t,
  value: e,
  handleChange: n,
  placeholder: r,
  warn: i,
  props: o,
  disabled: a,
  className: s
}) => (fd(() => {
  const l = t.current;
  if (l) {
    l.style.height = "20px";
    const c = l.scrollHeight;
    l.style.height = c + "px";
  }
}, [t, e]), /* @__PURE__ */ R.jsx(
  "textarea",
  {
    className: ve(
      "transition-colors",
      "bg-transparent",
      "border-0",
      "min-w-1",
      "flex-1",
      // focus:outline-none is needed to overwrite browser default outline color of chromium
      "outline-none focus:outline-none",
      "typo-text-s",
      "placeholder:typo-text-s",
      "placeholder:color-neutral-400",
      i ? "color-neutral-400" : "color-neutral-600",
      "min-h-20px max-h-120px overflow-y-auto resize-none",
      s
    ),
    disabled: a,
    onChange: n,
    placeholder: r,
    ref: t,
    rows: 1,
    value: e,
    ...o
  }
)), $0 = (t) => Array.isArray(t) || typeof t == "string" ? t.length === 0 : typeof t == "number" ? isNaN(t) : !1, whe = ({
  defaultValue: t,
  hint: e,
  label: n,
  labelProps: r,
  onChange: i,
  placeholder: o,
  tail: a,
  value: s,
  warn: l,
  expandable: c,
  disabled: u,
  ...d
}) => {
  const f = On(null), h = On(null), [v, g] = Ke(t ?? s ?? "");
  Dt(() => {
    g(s ?? "");
  }, [s]);
  const m = Gt(
    (y) => {
      i == null || i(y.target.value), g(y.target.value);
    },
    [i]
  ), p = Gt(() => {
    var y, b;
    (y = f.current) == null || y.focus(), (b = h.current) == null || b.focus();
  }, []);
  return /* @__PURE__ */ R.jsxs("div", { className: "group/input flex flex-col", children: [
    /* @__PURE__ */ R.jsxs(
      "div",
      {
        className: ve(
          "transition-all",
          "bg-neutral-100",
          "border-1",
          "border-solid",
          "flex-nowrap",
          "flex-row",
          "flex",
          "items-center",
          "p-x-3",
          "p-y-2",
          "rounded-1",
          l ? "border-alert-300 focus-within:border-alert-300" : "border-neutral-400 focus-within:border-neutral-800",
          u && "bg-neutral-300"
        ),
        children: [
          /* @__PURE__ */ R.jsxs("div", { className: "relative w-full w-full flex flex-1 flex-auto flex-row flex-wrap overflow-x-hidden", children: [
            n && /* @__PURE__ */ R.jsx(
              "label",
              {
                className: ve(
                  "transition-all",
                  "cursor-text",
                  "absolute",
                  "group-focus-within/input:color-neutral-800",
                  "group-focus-within/input:flex-auto",
                  "group-focus-within/input:typo-text-xxs",
                  "group-focus-within/input:w-full",
                  !$0(v) || n && o ? ["color-neutral-800", "flex-auto", "typo-text-xxs", "w-full"] : [
                    "color-neutral-600",
                    "flex-basis-auto",
                    "flex-grow-0",
                    "flex-shrink-0",
                    "typo-text-s"
                  ]
                ),
                onClick: p,
                ...r,
                children: n
              }
            ),
            c ? /* @__PURE__ */ R.jsx(
              qse,
              {
                className: ve([
                  n && "group-focus-within/input:mt-3",
                  n && (!$0(v) || o) && "mt-3"
                ]),
                disabled: u,
                handleChange: m,
                inputRef: f,
                placeholder: o,
                props: d,
                value: v.toString(),
                warn: l
              }
            ) : /* @__PURE__ */ R.jsx(
              "input",
              {
                className: ve(
                  "transition-all",
                  "bg-transparent",
                  "border-0",
                  "min-w-1",
                  "flex-1",
                  // focus:outline-none is needed to overwrite browser default outline color of chromium
                  "outline-none focus:outline-none",
                  "typo-text-s",
                  "placeholder:typo-text-s",
                  "placeholder:color-neutral-400",
                  [
                    n && "group-focus-within/input:mt-3",
                    n && (!$0(v) || o) && "mt-3"
                  ],
                  l ? "color-neutral-400" : "color-neutral-600"
                ),
                disabled: u,
                onChange: m,
                placeholder: o,
                ref: h,
                value: v,
                ...d
              }
            )
          ] }),
          a && /* @__PURE__ */ R.jsx("div", { className: ve("flex-none"), children: a })
        ]
      }
    ),
    e && /* @__PURE__ */ R.jsx(
      "span",
      {
        className: ve("m-t-1", "typo-text-xs", l ? "color-alert-300" : "color-neutral-600"),
        children: e
      }
    )
  ] });
}, Xse = sr(
  ({ children: t, className: e, ...n }, r) => /* @__PURE__ */ R.jsx(
    "div",
    {
      className: ve(
        "my-1 list-none b-1 b-neutral-400 rounded-1 b-solid bg-neutral-100 p-1",
        e
      ),
      ref: r,
      role: "menu",
      ...n,
      children: t
    }
  )
);
Xse.displayName = "Menu";
const Yse = sr(
  ({ children: t, className: e, disabled: n, size: r = "s", ...i }, o) => /* @__PURE__ */ R.jsx(
    "button",
    {
      className: ve(
        "border-0 block w-full",
        "bg-transparent color-neutral-600 rounded-2px px-2 py-2px whitespace-nowrap text-left",
        "hover:bg-neutral-200  hover:color-neutral-800",
        "disabled:color-neutral-400",
        "disabled:hover:bg-transparent",
        "disabled:hover:color-neutral-400",
        (r === "s" || r === "small") && "typo-text-s hover:typo-text-s-em disabled:hover:typo-text-s",
        (r === "xs" || r === "extraSmall") && "typo-button-xs",
        e
      ),
      disabled: n,
      ref: o,
      role: "menuitem",
      tabIndex: 0,
      ...i,
      children: t
    }
  )
);
Yse.displayName = "MenuItem";
const Zse = ({ children: t, className: e, style: n }) => {
  const r = On(!1);
  return Dt(() => (r.current || (document.body.style.overflow = "hidden", r.current = !0), () => {
    document.body.style.overflow = "auto";
  }), []), /* @__PURE__ */ R.jsx(
    "div",
    {
      className: ve(
        "fixed left-0 top-0 z-50 h-full w-full flex items-center justify-center",
        " bg-black bg-opacity-30"
      ),
      children: /* @__PURE__ */ R.jsx(
        "div",
        {
          className: ve(
            "justify-between flex flex-col shadow-lg z-50 border-1 border-neutral-400 rounded-md border-solid bg-white",
            e || "min-h-[128px] w-[650px] p-6 gap-6"
          ),
          style: n,
          children: t
        }
      )
    }
  );
}, wx = ({ className: t, ...e }) => /* @__PURE__ */ R.jsx(
  "nav",
  {
    "aria-label": "pagination",
    className: ve("mx-auto flex w-full justify-center", t),
    role: "navigation",
    ...e
  }
);
wx.displayName = "PaginationRoot";
const _x = C.forwardRef(
  ({ className: t, ...e }, n) => /* @__PURE__ */ R.jsx(
    "ul",
    {
      className: ve("flex flex-row items-center gap-1 list-none", t),
      ref: n,
      ...e
    }
  )
);
_x.displayName = "PaginationContent";
const Di = C.forwardRef(
  ({ className: t, ...e }, n) => /* @__PURE__ */ R.jsx("li", { className: ve("h-4 w-4", t), ref: n, ...e })
);
Di.displayName = "PaginationItem";
const Qa = ({
  className: t,
  isActive: e,
  ...n
}) => /* @__PURE__ */ R.jsx(
  "a",
  {
    "aria-current": e ? "page" : void 0,
    className: ve(
      "typo-text-xs-em color-neutral-600 decoration-none h-4 w-4 flex items-center justify-center",
      "aria-[current=page]:color-neutral-800",
      "hover:color-neutral-800",
      "cursor-pointer",
      t
    ),
    ...n
  }
);
Qa.displayName = "PaginationLink";
const Cx = ({
  className: t,
  disabled: e,
  ...n
}) => /* @__PURE__ */ R.jsx(
  Qa,
  {
    "aria-disabled": e,
    "aria-label": "Go to previous page",
    className: ve(
      "color-neutral-400",
      e && "cursor-not-allowed pointer-events-none color-neutral-200",
      t
    ),
    ...n,
    children: /* @__PURE__ */ R.jsx("div", { className: ve("i-skand-dropdown h-3 w-3 rotate-90") })
  }
);
Cx.displayName = "PaginationPrevious";
const Ex = ({
  className: t,
  disabled: e,
  ...n
}) => /* @__PURE__ */ R.jsx(
  Qa,
  {
    "aria-disabled": e,
    "aria-label": "Go to next page",
    className: ve(
      "color-neutral-400",
      e && "cursor-not-allowed pointer-events-none color-neutral-200",
      t
    ),
    ...n,
    children: /* @__PURE__ */ R.jsx("div", { className: ve("i-skand-dropdown h-3 w-3 rotate-270") })
  }
);
Ex.displayName = "PaginationNext";
const F1 = ({ className: t, ...e }) => /* @__PURE__ */ R.jsxs(
  "span",
  {
    "aria-hidden": !0,
    className: ve("color-neutral-400 h-4 w-4 flex items-center justify-center", t),
    ...e,
    children: [
      /* @__PURE__ */ R.jsx("div", { className: "i-skand-more h-3 w-3" }),
      /* @__PURE__ */ R.jsx("span", { className: "sr-only", children: "More pages" })
    ]
  }
);
F1.displayName = "PaginationEllipsis";
const Kse = ({
  currentPageIndex: t,
  totalNumberOfPages: e
}) => {
  const n = e - 1, r = [];
  if (e <= 5)
    for (let i = 0; i < e; i++)
      r.push(i);
  else {
    const i = t, o = n - t;
    if (i >= 2 && o >= 2)
      for (let a = -2; a <= 2; a++)
        r.push(a + t);
    else if (i < 2 && o >= 2)
      for (let a = 0; a < 5; a++)
        r.push(a);
    else if (i >= 2 && o < 2)
      for (let a = 0; a < 5; a++)
        r.unshift(n - a);
  }
  return r;
}, Jse = ({ totalNumberOfPages: t, currentPageIndex: e }) => {
  const n = t - 1, r = 0, i = e > r, o = e < n, a = Kse({ currentPageIndex: e, totalNumberOfPages: t }), s = a.map((g) => ({
    index: g,
    isCurrent: g === e,
    label: `${g + 1}`
  })), l = a[0], c = a[a.length - 1], u = l === 0 ? !1 : { index: 0, isCurrent: !1, label: `${r + 1}` }, d = c === n ? !1 : { index: n, isCurrent: !1, label: `${n + 1}` }, f = l > 1, h = c < n - 1;
  return {
    prev: i,
    firstPage: u,
    leftEllipsis: f,
    visiblePages: s,
    rightEllipsis: h,
    lastPage: d,
    next: o
  };
}, _he = ({
  totalNumberOfPages: t,
  currentPageIndex: e,
  onChangePage: n
}) => {
  const { prev: r, firstPage: i, leftEllipsis: o, visiblePages: a, rightEllipsis: s, lastPage: l, next: c } = Jse({ currentPageIndex: e, totalNumberOfPages: t });
  return /* @__PURE__ */ R.jsx(wx, { children: /* @__PURE__ */ R.jsxs(_x, { children: [
    /* @__PURE__ */ R.jsx(Di, { children: /* @__PURE__ */ R.jsx(
      Cx,
      {
        disabled: !r,
        onClick: () => n == null ? void 0 : n(e - 1)
      }
    ) }),
    i && /* @__PURE__ */ R.jsx(Di, { children: /* @__PURE__ */ R.jsx(Qa, { onClick: () => n == null ? void 0 : n(i.index), children: i.label }) }),
    o && /* @__PURE__ */ R.jsx(Di, { children: /* @__PURE__ */ R.jsx(F1, {}) }),
    a.map((u) => /* @__PURE__ */ R.jsx(Di, { children: /* @__PURE__ */ R.jsx(Qa, { isActive: u.isCurrent, onClick: () => n == null ? void 0 : n(u.index), children: u.label }) }, u.index)),
    s && /* @__PURE__ */ R.jsx(Di, { children: /* @__PURE__ */ R.jsx(F1, {}) }),
    l && /* @__PURE__ */ R.jsx(Di, { children: /* @__PURE__ */ R.jsx(Qa, { onClick: () => n == null ? void 0 : n(l.index), children: l.label }) }),
    /* @__PURE__ */ R.jsx(Di, { children: /* @__PURE__ */ R.jsx(Ex, { disabled: !c, onClick: () => n == null ? void 0 : n(e + 1) }) })
  ] }) });
};
function Gi(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (t == null || t(i), n === !1 || !i.defaultPrevented)
      return e == null ? void 0 : e(i);
  };
}
function Ig(t, e) {
  if (typeof t == "function")
    return t(e);
  t != null && (t.current = e);
}
function Sx(...t) {
  return (e) => {
    let n = !1;
    const r = t.map((i) => {
      const o = Ig(i, e);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : Ig(t[i], null);
        }
      };
  };
}
function lo(...t) {
  return C.useCallback(Sx(...t), t);
}
function Mx(t, e = []) {
  let n = [];
  function r(o, a) {
    const s = C.createContext(a), l = n.length;
    n = [...n, a];
    const c = (d) => {
      var p;
      const { scope: f, children: h, ...v } = d, g = ((p = f == null ? void 0 : f[t]) == null ? void 0 : p[l]) || s, m = C.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ R.jsx(g.Provider, { value: m, children: h });
    };
    c.displayName = o + "Provider";
    function u(d, f) {
      var g;
      const h = ((g = f == null ? void 0 : f[t]) == null ? void 0 : g[l]) || s, v = C.useContext(h);
      if (v)
        return v;
      if (a !== void 0)
        return a;
      throw new Error(`\`${d}\` must be used within \`${o}\``);
    }
    return [c, u];
  }
  const i = () => {
    const o = n.map((a) => C.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[t]) || o;
      return C.useMemo(
        () => ({ [`__scope${t}`]: { ...s, [t]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = t, [r, Qse(i, ...e)];
}
function Qse(...t) {
  const e = t[0];
  if (t.length === 1)
    return e;
  const n = () => {
    const r = t.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: c }) => {
        const d = l(o)[`__scope${c}`];
        return { ...s, ...d };
      }, {});
      return C.useMemo(() => ({ [`__scope${e.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = e.scopeName, n;
}
function Tx(t) {
  const e = /* @__PURE__ */ ele(t), n = C.forwardRef((r, i) => {
    const { children: o, ...a } = r, s = C.Children.toArray(o), l = s.find(nle);
    if (l) {
      const c = l.props.children, u = s.map((d) => d === l ? C.Children.count(c) > 1 ? C.Children.only(null) : C.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ R.jsx(e, { ...a, ref: i, children: C.isValidElement(c) ? C.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ R.jsx(e, { ...a, ref: i, children: o });
  });
  return n.displayName = `${t}.Slot`, n;
}
function ele(t) {
  const e = C.forwardRef((n, r) => {
    const { children: i, ...o } = n;
    if (C.isValidElement(i)) {
      const a = ile(i), s = rle(o, i.props);
      return i.type !== C.Fragment && (s.ref = r ? Sx(r, a) : a), C.cloneElement(i, s);
    }
    return C.Children.count(i) > 1 ? C.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var tle = Symbol("radix.slottable");
function nle(t) {
  return C.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === tle;
}
function rle(t, e) {
  const n = { ...e };
  for (const r in e) {
    const i = t[r], o = e[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function ile(t) {
  var r, i;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (i = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : i.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var ole = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], gi = ole.reduce((t, e) => {
  const n = Tx(`Primitive.${e}`), r = C.forwardRef((i, o) => {
    const { asChild: a, ...s } = i, l = a ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ R.jsx(l, { ...s, ref: o });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {});
function ale(t, e) {
  t && hd.flushSync(() => t.dispatchEvent(e));
}
function ss(t) {
  const e = C.useRef(t);
  return C.useEffect(() => {
    e.current = t;
  }), C.useMemo(() => (...n) => {
    var r;
    return (r = e.current) == null ? void 0 : r.call(e, ...n);
  }, []);
}
function sle(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = ss(t);
  C.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return e.addEventListener("keydown", r, { capture: !0 }), () => e.removeEventListener("keydown", r, { capture: !0 });
  }, [n, e]);
}
var lle = "DismissableLayer", U1 = "dismissableLayer.update", cle = "dismissableLayer.pointerDownOutside", ule = "dismissableLayer.focusOutside", Fg, Ax = C.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Px = C.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = t, c = C.useContext(Ax), [u, d] = C.useState(null), f = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = C.useState({}), v = lo(e, (S) => d(S)), g = Array.from(c.layers), [m] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), p = g.indexOf(m), y = u ? g.indexOf(u) : -1, b = c.layersWithOutsidePointerEventsDisabled.size > 0, x = y >= p, _ = hle((S) => {
      const P = S.target, E = [...c.branches].some((w) => w.contains(P));
      !x || E || (i == null || i(S), a == null || a(S), S.defaultPrevented || s == null || s());
    }, f), M = ple((S) => {
      const P = S.target;
      [...c.branches].some((w) => w.contains(P)) || (o == null || o(S), a == null || a(S), S.defaultPrevented || s == null || s());
    }, f);
    return sle((S) => {
      y === c.layers.size - 1 && (r == null || r(S), !S.defaultPrevented && s && (S.preventDefault(), s()));
    }, f), C.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (Fg = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), Ug(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = Fg);
        };
    }, [u, f, n, c]), C.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), Ug());
    }, [u, c]), C.useEffect(() => {
      const S = () => h({});
      return document.addEventListener(U1, S), () => document.removeEventListener(U1, S);
    }, []), /* @__PURE__ */ R.jsx(
      gi.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: b ? x ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: Gi(t.onFocusCapture, M.onFocusCapture),
        onBlurCapture: Gi(t.onBlurCapture, M.onBlurCapture),
        onPointerDownCapture: Gi(
          t.onPointerDownCapture,
          _.onPointerDownCapture
        )
      }
    );
  }
);
Px.displayName = lle;
var dle = "DismissableLayerBranch", fle = C.forwardRef((t, e) => {
  const n = C.useContext(Ax), r = C.useRef(null), i = lo(e, r);
  return C.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ R.jsx(gi.div, { ...t, ref: i });
});
fle.displayName = dle;
function hle(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = ss(t), r = C.useRef(!1), i = C.useRef(() => {
  });
  return C.useEffect(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          Rx(
            cle,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (e.removeEventListener("click", i.current), i.current = l, e.addEventListener("click", i.current, { once: !0 })) : l();
      } else
        e.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      e.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), e.removeEventListener("pointerdown", o), e.removeEventListener("click", i.current);
    };
  }, [e, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function ple(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = ss(t), r = C.useRef(!1);
  return C.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && Rx(ule, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", i), () => e.removeEventListener("focusin", i);
  }, [e, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Ug() {
  const t = new CustomEvent(U1);
  document.dispatchEvent(t);
}
function Rx(t, e, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: n });
  e && i.addEventListener(t, e, { once: !0 }), r ? ale(i, o) : i.dispatchEvent(o);
}
var W0 = 0;
function mle() {
  C.useEffect(() => {
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", t[0] ?? zg()), document.body.insertAdjacentElement("beforeend", t[1] ?? zg()), W0++, () => {
      W0 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), W0--;
    };
  }, []);
}
function zg() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.outline = "none", t.style.opacity = "0", t.style.position = "fixed", t.style.pointerEvents = "none", t;
}
var j0 = "focusScope.autoFocusOnMount", G0 = "focusScope.autoFocusOnUnmount", Hg = { bubbles: !1, cancelable: !0 }, vle = "FocusScope", Lx = C.forwardRef((t, e) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o,
    ...a
  } = t, [s, l] = C.useState(null), c = ss(i), u = ss(o), d = C.useRef(null), f = lo(e, (g) => l(g)), h = C.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  C.useEffect(() => {
    if (r) {
      let g = function(b) {
        if (h.paused || !s)
          return;
        const x = b.target;
        s.contains(x) ? d.current = x : ki(d.current, { select: !0 });
      }, m = function(b) {
        if (h.paused || !s)
          return;
        const x = b.relatedTarget;
        x !== null && (s.contains(x) || ki(d.current, { select: !0 }));
      }, p = function(b) {
        if (document.activeElement === document.body)
          for (const _ of b)
            _.removedNodes.length > 0 && ki(s);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", m);
      const y = new MutationObserver(p);
      return s && y.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", m), y.disconnect();
      };
    }
  }, [r, s, h.paused]), C.useEffect(() => {
    if (s) {
      Vg.add(h);
      const g = document.activeElement;
      if (!s.contains(g)) {
        const p = new CustomEvent(j0, Hg);
        s.addEventListener(j0, c), s.dispatchEvent(p), p.defaultPrevented || (gle(_le(Ox(s)), { select: !0 }), document.activeElement === g && ki(s));
      }
      return () => {
        s.removeEventListener(j0, c), setTimeout(() => {
          const p = new CustomEvent(G0, Hg);
          s.addEventListener(G0, u), s.dispatchEvent(p), p.defaultPrevented || ki(g ?? document.body, { select: !0 }), s.removeEventListener(G0, u), Vg.remove(h);
        }, 0);
      };
    }
  }, [s, c, u, h]);
  const v = C.useCallback(
    (g) => {
      if (!n && !r || h.paused)
        return;
      const m = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, p = document.activeElement;
      if (m && p) {
        const y = g.currentTarget, [b, x] = yle(y);
        b && x ? !g.shiftKey && p === x ? (g.preventDefault(), n && ki(b, { select: !0 })) : g.shiftKey && p === b && (g.preventDefault(), n && ki(x, { select: !0 })) : p === y && g.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ R.jsx(gi.div, { tabIndex: -1, ...a, ref: f, onKeyDown: v });
});
Lx.displayName = vle;
function gle(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const r of t)
    if (ki(r, { select: e }), document.activeElement !== n)
      return;
}
function yle(t) {
  const e = Ox(t), n = Bg(e, t), r = Bg(e.reverse(), t);
  return [n, r];
}
function Ox(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    e.push(n.currentNode);
  return e;
}
function Bg(t, e) {
  for (const n of t)
    if (!ble(n, { upTo: e }))
      return n;
}
function ble(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  for (; t; ) {
    if (e !== void 0 && t === e)
      return !1;
    if (getComputedStyle(t).display === "none")
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function xle(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function ki(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({ preventScroll: !0 }), t !== n && xle(t) && e && t.select();
  }
}
var Vg = wle();
function wle() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && (n == null || n.pause()), t = $g(t, e), t.unshift(e);
    },
    remove(e) {
      var n;
      t = $g(t, e), (n = t[0]) == null || n.resume();
    }
  };
}
function $g(t, e) {
  const n = [...t], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function _le(t) {
  return t.filter((e) => e.tagName !== "A");
}
var no = globalThis != null && globalThis.document ? C.useLayoutEffect : () => {
}, Cle = C[" useId ".trim().toString()] || (() => {
}), Ele = 0;
function Sle(t) {
  const [e, n] = C.useState(Cle());
  return no(() => {
    t || n((r) => r ?? String(Ele++));
  }, [t]), t || (e ? `radix-${e}` : "");
}
var Mle = "Arrow", Dx = C.forwardRef((t, e) => {
  const { children: n, width: r = 10, height: i = 5, ...o } = t;
  return /* @__PURE__ */ R.jsx(
    gi.svg,
    {
      ...o,
      ref: e,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: t.asChild ? n : /* @__PURE__ */ R.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Dx.displayName = Mle;
var Tle = Dx;
function Ale(t) {
  const [e, n] = C.useState(void 0);
  return no(() => {
    if (t) {
      n({ width: t.offsetWidth, height: t.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const o = i[0];
        let a, s;
        if ("borderBoxSize" in o) {
          const l = o.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          a = c.inlineSize, s = c.blockSize;
        } else
          a = t.offsetWidth, s = t.offsetHeight;
        n({ width: a, height: s });
      });
      return r.observe(t, { box: "border-box" }), () => r.unobserve(t);
    } else
      n(void 0);
  }, [t]), e;
}
var q2 = "Popper", [kx, Nx] = Mx(q2), [Ple, Ix] = kx(q2), Fx = (t) => {
  const { __scopePopper: e, children: n } = t, [r, i] = C.useState(null);
  return /* @__PURE__ */ R.jsx(Ple, { scope: e, anchor: r, onAnchorChange: i, children: n });
};
Fx.displayName = q2;
var Ux = "PopperAnchor", zx = C.forwardRef(
  (t, e) => {
    const { __scopePopper: n, virtualRef: r, ...i } = t, o = Ix(Ux, n), a = C.useRef(null), s = lo(e, a);
    return C.useEffect(() => {
      o.onAnchorChange((r == null ? void 0 : r.current) || a.current);
    }), r ? null : /* @__PURE__ */ R.jsx(gi.div, { ...i, ref: s });
  }
);
zx.displayName = Ux;
var X2 = "PopperContent", [Rle, Lle] = kx(X2), Hx = C.forwardRef(
  (t, e) => {
    var J, se, be, pe, Ne, ae;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: i = 0,
      align: o = "center",
      alignOffset: a = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: f = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: v,
      ...g
    } = t, m = Ix(X2, n), [p, y] = C.useState(null), b = lo(e, (Re) => y(Re)), [x, _] = C.useState(null), M = Ale(x), S = (M == null ? void 0 : M.width) ?? 0, P = (M == null ? void 0 : M.height) ?? 0, E = r + (o !== "center" ? "-" + o : ""), w = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, O = Array.isArray(c) ? c : [c], N = O.length > 0, I = {
      padding: w,
      boundary: O.filter(Dle),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: N
    }, { refs: H, floatingStyles: j, placement: U, isPositioned: $, middlewareData: V } = Jp({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: E,
      whileElementsMounted: (...Re) => Ud(...Re, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: m.anchor
      },
      middleware: [
        b8({ mainAxis: i + P, alignmentAxis: a }),
        l && x8({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? w8() : void 0,
          ...I
        }),
        l && Id({ ...I }),
        Xp({
          ...I,
          apply: ({ elements: Re, rects: F, availableWidth: Ge, availableHeight: $e }) => {
            const { width: he, height: ue } = F.reference, Se = Re.floating.style;
            Se.setProperty("--radix-popper-available-width", `${Ge}px`), Se.setProperty("--radix-popper-available-height", `${$e}px`), Se.setProperty("--radix-popper-anchor-width", `${he}px`), Se.setProperty("--radix-popper-anchor-height", `${ue}px`);
          }
        }),
        x && P8({ element: x, padding: s }),
        kle({ arrowWidth: S, arrowHeight: P }),
        f && y8({ strategy: "referenceHidden", ...I })
      ]
    }), [te, B] = $x(U), Z = ss(v);
    no(() => {
      $ && (Z == null || Z());
    }, [$, Z]);
    const Q = (J = V.arrow) == null ? void 0 : J.x, ce = (se = V.arrow) == null ? void 0 : se.y, k = ((be = V.arrow) == null ? void 0 : be.centerOffset) !== 0, [G, K] = C.useState();
    return no(() => {
      p && K(window.getComputedStyle(p).zIndex);
    }, [p]), /* @__PURE__ */ R.jsx(
      "div",
      {
        ref: H.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...j,
          transform: $ ? j.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: G,
          ["--radix-popper-transform-origin"]: [
            (pe = V.transformOrigin) == null ? void 0 : pe.x,
            (Ne = V.transformOrigin) == null ? void 0 : Ne.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((ae = V.hide) == null ? void 0 : ae.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: t.dir,
        children: /* @__PURE__ */ R.jsx(
          Rle,
          {
            scope: n,
            placedSide: te,
            onArrowChange: _,
            arrowX: Q,
            arrowY: ce,
            shouldHideArrow: k,
            children: /* @__PURE__ */ R.jsx(
              gi.div,
              {
                "data-side": te,
                "data-align": B,
                ...g,
                ref: b,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: $ ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Hx.displayName = X2;
var Bx = "PopperArrow", Ole = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Vx = C.forwardRef(function(e, n) {
  const { __scopePopper: r, ...i } = e, o = Lle(Bx, r), a = Ole[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ R.jsx(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ R.jsx(
          Tle,
          {
            ...i,
            ref: n,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Vx.displayName = Bx;
function Dle(t) {
  return t !== null;
}
var kle = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var m, p, y;
    const { placement: n, rects: r, middlewareData: i } = e, a = ((m = i.arrow) == null ? void 0 : m.centerOffset) !== 0, s = a ? 0 : t.arrowWidth, l = a ? 0 : t.arrowHeight, [c, u] = $x(n), d = { start: "0%", center: "50%", end: "100%" }[u], f = (((p = i.arrow) == null ? void 0 : p.x) ?? 0) + s / 2, h = (((y = i.arrow) == null ? void 0 : y.y) ?? 0) + l / 2;
    let v = "", g = "";
    return c === "bottom" ? (v = a ? d : `${f}px`, g = `${-l}px`) : c === "top" ? (v = a ? d : `${f}px`, g = `${r.floating.height + l}px`) : c === "right" ? (v = `${-l}px`, g = a ? d : `${h}px`) : c === "left" && (v = `${r.floating.width + l}px`, g = a ? d : `${h}px`), { data: { x: v, y: g } };
  }
});
function $x(t) {
  const [e, n = "center"] = t.split("-");
  return [e, n];
}
var Nle = Fx, Wx = zx, Ile = Hx, Fle = Vx, Ule = "Portal", jx = C.forwardRef((t, e) => {
  var s;
  const { container: n, ...r } = t, [i, o] = C.useState(!1);
  no(() => o(!0), []);
  const a = n || i && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return a ? G1.createPortal(/* @__PURE__ */ R.jsx(gi.div, { ...r, ref: e }), a) : null;
});
jx.displayName = Ule;
function zle(t, e) {
  return C.useReducer((n, r) => e[n][r] ?? n, t);
}
var Y2 = (t) => {
  const { present: e, children: n } = t, r = Hle(e), i = typeof n == "function" ? n({ present: r.isPresent }) : C.Children.only(n), o = lo(r.ref, Ble(i));
  return typeof n == "function" || r.isPresent ? C.cloneElement(i, { ref: o }) : null;
};
Y2.displayName = "Presence";
function Hle(t) {
  const [e, n] = C.useState(), r = C.useRef(null), i = C.useRef(t), o = C.useRef("none"), a = t ? "mounted" : "unmounted", [s, l] = zle(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return C.useEffect(() => {
    const c = su(r.current);
    o.current = s === "mounted" ? c : "none";
  }, [s]), no(() => {
    const c = r.current, u = i.current;
    if (u !== t) {
      const f = o.current, h = su(c);
      t ? l("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), i.current = t;
    }
  }, [t, l]), no(() => {
    if (e) {
      let c;
      const u = e.ownerDocument.defaultView ?? window, d = (h) => {
        const g = su(r.current).includes(h.animationName);
        if (h.target === e && g && (l("ANIMATION_END"), !i.current)) {
          const m = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = m);
          });
        }
      }, f = (h) => {
        h.target === e && (o.current = su(r.current));
      };
      return e.addEventListener("animationstart", f), e.addEventListener("animationcancel", d), e.addEventListener("animationend", d), () => {
        u.clearTimeout(c), e.removeEventListener("animationstart", f), e.removeEventListener("animationcancel", d), e.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [e, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: C.useCallback((c) => {
      r.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function su(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function Ble(t) {
  var r, i;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (i = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : i.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var Vle = C[" useInsertionEffect ".trim().toString()] || no;
function $le({
  prop: t,
  defaultProp: e,
  onChange: n = () => {
  },
  caller: r
}) {
  const [i, o, a] = Wle({
    defaultProp: e,
    onChange: n
  }), s = t !== void 0, l = s ? t : i;
  {
    const u = C.useRef(t !== void 0);
    C.useEffect(() => {
      const d = u.current;
      d !== s && console.warn(
        `${r} is changing from ${d ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = s;
    }, [s, r]);
  }
  const c = C.useCallback(
    (u) => {
      var d;
      if (s) {
        const f = jle(u) ? u(t) : u;
        f !== t && ((d = a.current) == null || d.call(a, f));
      } else
        o(u);
    },
    [s, t, o, a]
  );
  return [l, c];
}
function Wle({
  defaultProp: t,
  onChange: e
}) {
  const [n, r] = C.useState(t), i = C.useRef(n), o = C.useRef(e);
  return Vle(() => {
    o.current = e;
  }, [e]), C.useEffect(() => {
    var a;
    i.current !== n && ((a = o.current) == null || a.call(o, n), i.current = n);
  }, [n, i]), [n, r, o];
}
function jle(t) {
  return typeof t == "function";
}
var uf = "Popover", [Gx, Che] = Mx(uf, [
  Nx
]), gc = Nx(), [Gle, co] = Gx(uf), qx = (t) => {
  const {
    __scopePopover: e,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    modal: a = !1
  } = t, s = gc(e), l = C.useRef(null), [c, u] = C.useState(!1), [d, f] = $le({
    prop: r,
    defaultProp: i ?? !1,
    onChange: o,
    caller: uf
  });
  return /* @__PURE__ */ R.jsx(Nle, { ...s, children: /* @__PURE__ */ R.jsx(
    Gle,
    {
      scope: e,
      contentId: Sle(),
      triggerRef: l,
      open: d,
      onOpenChange: f,
      onOpenToggle: C.useCallback(() => f((h) => !h), [f]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: C.useCallback(() => u(!0), []),
      onCustomAnchorRemove: C.useCallback(() => u(!1), []),
      modal: a,
      children: n
    }
  ) });
};
qx.displayName = uf;
var Xx = "PopoverAnchor", Yx = C.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...r } = t, i = co(Xx, n), o = gc(n), { onCustomAnchorAdd: a, onCustomAnchorRemove: s } = i;
    return C.useEffect(() => (a(), () => s()), [a, s]), /* @__PURE__ */ R.jsx(Wx, { ...o, ...r, ref: e });
  }
);
Yx.displayName = Xx;
var Zx = "PopoverTrigger", Kx = C.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...r } = t, i = co(Zx, n), o = gc(n), a = lo(e, i.triggerRef), s = /* @__PURE__ */ R.jsx(
      gi.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": nw(i.open),
        ...r,
        ref: a,
        onClick: Gi(t.onClick, i.onOpenToggle)
      }
    );
    return i.hasCustomAnchor ? s : /* @__PURE__ */ R.jsx(Wx, { asChild: !0, ...o, children: s });
  }
);
Kx.displayName = Zx;
var Z2 = "PopoverPortal", [qle, Xle] = Gx(Z2, {
  forceMount: void 0
}), Jx = (t) => {
  const { __scopePopover: e, forceMount: n, children: r, container: i } = t, o = co(Z2, e);
  return /* @__PURE__ */ R.jsx(qle, { scope: e, forceMount: n, children: /* @__PURE__ */ R.jsx(Y2, { present: n || o.open, children: /* @__PURE__ */ R.jsx(jx, { asChild: !0, container: i, children: r }) }) });
};
Jx.displayName = Z2;
var ls = "PopoverContent", Qx = C.forwardRef(
  (t, e) => {
    const n = Xle(ls, t.__scopePopover), { forceMount: r = n.forceMount, ...i } = t, o = co(ls, t.__scopePopover);
    return /* @__PURE__ */ R.jsx(Y2, { present: r || o.open, children: o.modal ? /* @__PURE__ */ R.jsx(Zle, { ...i, ref: e }) : /* @__PURE__ */ R.jsx(Kle, { ...i, ref: e }) });
  }
);
Qx.displayName = ls;
var Yle = Tx("PopoverContent.RemoveScroll"), Zle = C.forwardRef(
  (t, e) => {
    const n = co(ls, t.__scopePopover), r = C.useRef(null), i = lo(e, r), o = C.useRef(!1);
    return C.useEffect(() => {
      const a = r.current;
      if (a)
        return f7(a);
    }, []), /* @__PURE__ */ R.jsx(u7, { as: Yle, allowPinchZoom: !0, children: /* @__PURE__ */ R.jsx(
      ew,
      {
        ...t,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Gi(t.onCloseAutoFocus, (a) => {
          var s;
          a.preventDefault(), o.current || (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: Gi(
          t.onPointerDownOutside,
          (a) => {
            const s = a.detail.originalEvent, l = s.button === 0 && s.ctrlKey === !0, c = s.button === 2 || l;
            o.current = c;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: Gi(
          t.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), Kle = C.forwardRef(
  (t, e) => {
    const n = co(ls, t.__scopePopover), r = C.useRef(!1), i = C.useRef(!1);
    return /* @__PURE__ */ R.jsx(
      ew,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var a, s;
          (a = t.onCloseAutoFocus) == null || a.call(t, o), o.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), o.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (o) => {
          var l, c;
          (l = t.onInteractOutside) == null || l.call(t, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const a = o.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(a)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
        }
      }
    );
  }
), ew = C.forwardRef(
  (t, e) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: i,
      onCloseAutoFocus: o,
      disableOutsidePointerEvents: a,
      onEscapeKeyDown: s,
      onPointerDownOutside: l,
      onFocusOutside: c,
      onInteractOutside: u,
      ...d
    } = t, f = co(ls, n), h = gc(n);
    return mle(), /* @__PURE__ */ R.jsx(
      Lx,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: i,
        onUnmountAutoFocus: o,
        children: /* @__PURE__ */ R.jsx(
          Px,
          {
            asChild: !0,
            disableOutsidePointerEvents: a,
            onInteractOutside: u,
            onEscapeKeyDown: s,
            onPointerDownOutside: l,
            onFocusOutside: c,
            onDismiss: () => f.onOpenChange(!1),
            children: /* @__PURE__ */ R.jsx(
              Ile,
              {
                "data-state": nw(f.open),
                role: "dialog",
                id: f.contentId,
                ...h,
                ...d,
                ref: e,
                style: {
                  ...d.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), tw = "PopoverClose", Jle = C.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...r } = t, i = co(tw, n);
    return /* @__PURE__ */ R.jsx(
      gi.button,
      {
        type: "button",
        ...r,
        ref: e,
        onClick: Gi(t.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
Jle.displayName = tw;
var Qle = "PopoverArrow", ece = C.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...r } = t, i = gc(n);
    return /* @__PURE__ */ R.jsx(Fle, { ...i, ...r, ref: e });
  }
);
ece.displayName = Qle;
function nw(t) {
  return t ? "open" : "closed";
}
var tce = qx, nce = Yx, rce = Kx, ice = Jx, rw = Qx;
const Ehe = tce, She = rce, Mhe = nce, oce = C.forwardRef(({ className: t, align: e = "center", sideOffset: n = 4, ...r }, i) => /* @__PURE__ */ R.jsx(ice, { children: /* @__PURE__ */ R.jsx(
  rw,
  {
    align: e,
    className: ve(
      "z-50",
      // 'z-50 w-72 rounded-md border bg-popover text-popover-foreground shadow-md outline-none',
      // animate classes, not in use
      // 'data-[state=open]:animate-slide data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-popover-content-transform-origin]'
      t
    ),
    ref: i,
    sideOffset: n,
    ...r
  }
) }));
oce.displayName = rw.displayName;
const ace = sr(
  ({ children: t, className: e, progress: n = 0, ...r }, i) => /* @__PURE__ */ R.jsxs(
    md,
    {
      className: ve("relative overflow-hidden", e),
      filled: !0,
      primary: !0,
      ref: i,
      size: "m",
      ...r,
      children: [
        t,
        /* @__PURE__ */ R.jsx(
          "div",
          {
            className: "absolute bottom-0 left-0 h-3px bg-primary-300 transition-width",
            style: { width: `${n * 100}%` }
          }
        )
      ]
    }
  )
);
ace.displayName = "ProgressButton";
const sce = ({
  children: t,
  itemCount: e,
  horizontal: n = !1,
  buffer: r = 0.5,
  onScroll: i = () => {
  },
  scrollbarSpace: o = 0
}, a) => {
  const [s, l] = Ke(null), [c, u] = Ke(null), [d, f] = Ke(0), [h, v] = Ke(0), [g, m] = Ke(0), [p, y] = Ke(0), b = Pn(() => p ? Vn(0, e, Math.floor((g + (n ? d : h) * -r) / p)) : 0, [r, h, d, n, e, p, g]), x = Pn(() => p ? Vn(
    b,
    e,
    Math.ceil((g + (n ? d : h) * (1 + r)) / p)
  ) : 0, [
    p,
    n,
    d,
    h,
    b,
    e,
    g,
    r
  ]);
  j1(
    a,
    () => c === null ? null : {
      scrollBy: (S) => {
        n ? c.scrollBy(S, 0) : c.scrollBy(0, S);
      },
      scrollTo: (S) => {
        n ? c.scrollTo(S, 0) : c.scrollTo(0, S);
      },
      itemSize: p,
      start: b,
      stop: x
    },
    [c, n, p, b, x]
  ), fd(() => {
    if (s && e) {
      const S = s.getBoundingClientRect();
      y(n ? S.width : S.height);
    }
  }, [n, s, e]), Dt(() => {
    const S = () => {
      f((c == null ? void 0 : c.clientWidth) ?? 0), v((c == null ? void 0 : c.clientHeight) ?? 0);
    }, P = new ResizeObserver(S);
    return c && P.observe(c), () => {
      P.disconnect();
    };
  }, [c]);
  const _ = (S) => {
    const P = n ? S.currentTarget.scrollLeft : S.currentTarget.scrollTop;
    m(P), i(P);
  }, M = Pn(
    () => n ? { width: e * p + o } : { height: e * p + o },
    [n, e, p, o]
  );
  return /* @__PURE__ */ R.jsxs(
    "div",
    {
      className: ve("relative h-full w-full", "[will-change:transform]"),
      onScroll: _,
      ref: u,
      style: {
        overflow: n ? "auto hidden" : "hidden auto"
      },
      children: [
        G1.createPortal(
          /* @__PURE__ */ R.jsx("div", { className: "fixed opacity-0", ref: l, children: e > 0 && t({ index: 0 }) }),
          document.body
        ),
        /* @__PURE__ */ R.jsx(
          "div",
          {
            className: ve("relative h-full w-full overscroll-auto"),
            style: {
              ...M,
              overflow: n ? "hidden auto" : "auto hidden"
            },
            children: Array(x - b).fill(0).map((S, P) => /* @__PURE__ */ R.jsx(
              "div",
              {
                className: ve("absolute h-full w-full", n ? "top-0" : "left-0"),
                style: n ? {
                  left: (b + P) * p,
                  width: p
                } : {
                  top: (b + P) * p,
                  height: p
                },
                children: t({ index: b + P })
              },
              P
            ))
          }
        )
      ]
    }
  );
}, lce = sr(sce), {
  createElement: cs,
  createContext: cce,
  createRef: The,
  forwardRef: iw,
  useCallback: zn,
  useContext: ow,
  useEffect: Ro,
  useImperativeHandle: aw,
  useLayoutEffect: uce,
  useMemo: dce,
  useRef: An,
  useState: Ml
} = C, Wg = C["useId".toString()], fce = uce, df = cce(null);
df.displayName = "PanelGroupContext";
const Lo = fce, hce = typeof Wg == "function" ? Wg : () => null;
let pce = 0;
function K2(t = null) {
  const e = hce(), n = An(t || e || null);
  return n.current === null && (n.current = "" + pce++), t ?? n.current;
}
function sw({
  children: t,
  className: e = "",
  collapsedSize: n,
  collapsible: r,
  defaultSize: i,
  forwardedRef: o,
  id: a,
  maxSize: s,
  minSize: l,
  onCollapse: c,
  onExpand: u,
  onResize: d,
  order: f,
  style: h,
  tagName: v = "div",
  ...g
}) {
  const m = ow(df);
  if (m === null)
    throw Error("Panel components must be rendered within a PanelGroup container");
  const {
    collapsePanel: p,
    expandPanel: y,
    getPanelSize: b,
    getPanelStyle: x,
    groupId: _,
    isPanelCollapsed: M,
    reevaluatePanelConstraints: S,
    registerPanel: P,
    resizePanel: E,
    unregisterPanel: w
  } = m, O = K2(a), N = An({
    callbacks: {
      onCollapse: c,
      onExpand: u,
      onResize: d
    },
    constraints: {
      collapsedSize: n,
      collapsible: r,
      defaultSize: i,
      maxSize: s,
      minSize: l
    },
    id: O,
    idIsFromProps: a !== void 0,
    order: f
  });
  An({
    didLogMissingDefaultSizeWarning: !1
  }), Lo(() => {
    const {
      callbacks: H,
      constraints: j
    } = N.current, U = {
      ...j
    };
    N.current.id = O, N.current.idIsFromProps = a !== void 0, N.current.order = f, H.onCollapse = c, H.onExpand = u, H.onResize = d, j.collapsedSize = n, j.collapsible = r, j.defaultSize = i, j.maxSize = s, j.minSize = l, (U.collapsedSize !== j.collapsedSize || U.collapsible !== j.collapsible || U.maxSize !== j.maxSize || U.minSize !== j.minSize) && S(N.current, U);
  }), Lo(() => {
    const H = N.current;
    return P(H), () => {
      w(H);
    };
  }, [f, O, P, w]), aw(o, () => ({
    collapse: () => {
      p(N.current);
    },
    expand: () => {
      y(N.current);
    },
    getId() {
      return O;
    },
    getSize() {
      return b(N.current);
    },
    isCollapsed() {
      return M(N.current);
    },
    isExpanded() {
      return !M(N.current);
    },
    resize: (H) => {
      E(N.current, H);
    }
  }), [p, y, b, M, O, E]);
  const I = x(N.current, i);
  return cs(v, {
    ...g,
    children: t,
    className: e,
    id: a,
    style: {
      ...I,
      ...h
    },
    // CSS selectors
    "data-panel": "",
    "data-panel-collapsible": r || void 0,
    "data-panel-group-id": _,
    "data-panel-id": O,
    "data-panel-size": parseFloat("" + I.flexGrow).toFixed(1)
  });
}
const lw = iw((t, e) => cs(sw, {
  ...t,
  forwardedRef: e
}));
sw.displayName = "Panel";
lw.displayName = "forwardRef(Panel)";
let z1 = null, Ao = null;
function mce(t, e) {
  if (e) {
    const n = (e & hw) !== 0, r = (e & pw) !== 0, i = (e & mw) !== 0, o = (e & vw) !== 0;
    if (n)
      return i ? "se-resize" : o ? "ne-resize" : "e-resize";
    if (r)
      return i ? "sw-resize" : o ? "nw-resize" : "w-resize";
    if (i)
      return "s-resize";
    if (o)
      return "n-resize";
  }
  switch (t) {
    case "horizontal":
      return "ew-resize";
    case "intersection":
      return "move";
    case "vertical":
      return "ns-resize";
  }
}
function vce() {
  Ao !== null && (document.head.removeChild(Ao), z1 = null, Ao = null);
}
function q0(t, e) {
  const n = mce(t, e);
  z1 !== n && (z1 = n, Ao === null && (Ao = document.createElement("style"), document.head.appendChild(Ao)), Ao.innerHTML = `*{cursor: ${n}!important;}`);
}
function cw(t) {
  return t.type === "keydown";
}
function uw(t) {
  return t.type.startsWith("mouse");
}
function dw(t) {
  return t.type.startsWith("touch");
}
function ff(t) {
  if (uw(t))
    return {
      x: t.pageX,
      y: t.pageY
    };
  if (dw(t)) {
    const e = t.touches[0];
    if (e && e.pageX && e.pageY)
      return {
        x: e.pageX,
        y: e.pageY
      };
  }
  return {
    x: 1 / 0,
    y: 1 / 0
  };
}
function gce() {
  if (typeof matchMedia == "function")
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
}
function yce(t, e, n) {
  return n ? t.x < e.x + e.width && t.x + t.width > e.x && t.y < e.y + e.height && t.y + t.height > e.y : t.x <= e.x + e.width && t.x + t.width >= e.x && t.y <= e.y + e.height && t.y + t.height >= e.y;
}
function bce(t, e) {
  if (t === e)
    throw new Error("Cannot compare node with itself");
  const n = {
    a: qg(t),
    b: qg(e)
  };
  let r;
  for (; n.a.at(-1) === n.b.at(-1); )
    t = n.a.pop(), e = n.b.pop(), r = t;
  st(r);
  const i = {
    a: Gg(jg(n.a)),
    b: Gg(jg(n.b))
  };
  if (i.a === i.b) {
    const o = r.childNodes, a = {
      a: n.a.at(-1),
      b: n.b.at(-1)
    };
    let s = o.length;
    for (; s--; ) {
      const l = o[s];
      if (l === a.a)
        return 1;
      if (l === a.b)
        return -1;
    }
  }
  return Math.sign(i.a - i.b);
}
const xce = /\b(?:position|zIndex|opacity|transform|webkitTransform|mixBlendMode|filter|webkitFilter|isolation)\b/;
function wce(t) {
  const e = getComputedStyle(fw(t)).display;
  return e === "flex" || e === "inline-flex";
}
function _ce(t) {
  const e = getComputedStyle(t);
  return !!(e.position === "fixed" || e.zIndex !== "auto" && (e.position !== "static" || wce(t)) || +e.opacity < 1 || "transform" in e && e.transform !== "none" || "webkitTransform" in e && e.webkitTransform !== "none" || "mixBlendMode" in e && e.mixBlendMode !== "normal" || "filter" in e && e.filter !== "none" || "webkitFilter" in e && e.webkitFilter !== "none" || "isolation" in e && e.isolation === "isolate" || xce.test(e.willChange) || e.webkitOverflowScrolling === "touch");
}
function jg(t) {
  let e = t.length;
  for (; e--; ) {
    const n = t[e];
    if (st(n), _ce(n))
      return n;
  }
  return null;
}
function Gg(t) {
  return t && Number(getComputedStyle(t).zIndex) || 0;
}
function qg(t) {
  const e = [];
  for (; t; )
    e.push(t), t = fw(t);
  return e;
}
function fw(t) {
  var e;
  return ((e = t.parentNode) === null || e === void 0 ? void 0 : e.host) || t.parentNode;
}
const hw = 1, pw = 2, mw = 4, vw = 8, Cce = gce() === "coarse";
let ro = [], hf = !1, Ii = /* @__PURE__ */ new Map(), pf = /* @__PURE__ */ new Map();
const Bl = /* @__PURE__ */ new Set();
function Ece(t, e, n, r, i) {
  var o;
  const {
    ownerDocument: a
  } = e, s = {
    direction: n,
    element: e,
    hitAreaMargins: r,
    setResizeHandlerState: i
  }, l = (o = Ii.get(a)) !== null && o !== void 0 ? o : 0;
  return Ii.set(a, l + 1), Bl.add(s), dd(), function() {
    var u;
    pf.delete(t), Bl.delete(s);
    const d = (u = Ii.get(a)) !== null && u !== void 0 ? u : 1;
    Ii.set(a, d - 1), dd(), d === 1 && Ii.delete(a);
  };
}
function lu(t) {
  const {
    target: e
  } = t, {
    x: n,
    y: r
  } = ff(t);
  hf = !0, J2({
    target: e,
    x: n,
    y: r
  }), dd(), ro.length > 0 && (Q2("down", t), t.preventDefault());
}
function Pi(t) {
  const {
    x: e,
    y: n
  } = ff(t);
  if (!hf) {
    const {
      target: r
    } = t;
    J2({
      target: r,
      x: e,
      y: n
    });
  }
  Q2("move", t), gw(), ro.length > 0 && t.preventDefault();
}
function Ri(t) {
  const {
    target: e
  } = t, {
    x: n,
    y: r
  } = ff(t);
  pf.clear(), hf = !1, ro.length > 0 && t.preventDefault(), Q2("up", t), J2({
    target: e,
    x: n,
    y: r
  }), gw(), dd();
}
function J2({
  target: t,
  x: e,
  y: n
}) {
  ro.splice(0);
  let r = null;
  t instanceof HTMLElement && (r = t), Bl.forEach((i) => {
    const {
      element: o,
      hitAreaMargins: a
    } = i, s = o.getBoundingClientRect(), {
      bottom: l,
      left: c,
      right: u,
      top: d
    } = s, f = Cce ? a.coarse : a.fine;
    if (e >= c - f && e <= u + f && n >= d - f && n <= l + f) {
      if (r !== null && o !== r && !o.contains(r) && !r.contains(o) && // Calculating stacking order has a cost, so we should avoid it if possible
      // That is why we only check potentially intersecting handles,
      // and why we skip if the event target is within the handle's DOM
      bce(r, o) > 0) {
        let v = r, g = !1;
        for (; v && !v.contains(o); ) {
          if (yce(v.getBoundingClientRect(), s, !0)) {
            g = !0;
            break;
          }
          v = v.parentElement;
        }
        if (g)
          return;
      }
      ro.push(i);
    }
  });
}
function X0(t, e) {
  pf.set(t, e);
}
function gw() {
  let t = !1, e = !1;
  ro.forEach((r) => {
    const {
      direction: i
    } = r;
    i === "horizontal" ? t = !0 : e = !0;
  });
  let n = 0;
  pf.forEach((r) => {
    n |= r;
  }), t && e ? q0("intersection", n) : t ? q0("horizontal", n) : e ? q0("vertical", n) : vce();
}
function dd() {
  Ii.forEach((t, e) => {
    const {
      body: n
    } = e;
    n.removeEventListener("contextmenu", Ri), n.removeEventListener("mousedown", lu), n.removeEventListener("mouseleave", Pi), n.removeEventListener("mousemove", Pi), n.removeEventListener("touchmove", Pi), n.removeEventListener("touchstart", lu);
  }), window.removeEventListener("mouseup", Ri), window.removeEventListener("touchcancel", Ri), window.removeEventListener("touchend", Ri), Bl.size > 0 && (hf ? (ro.length > 0 && Ii.forEach((t, e) => {
    const {
      body: n
    } = e;
    t > 0 && (n.addEventListener("contextmenu", Ri), n.addEventListener("mouseleave", Pi), n.addEventListener("mousemove", Pi), n.addEventListener("touchmove", Pi, {
      passive: !1
    }));
  }), window.addEventListener("mouseup", Ri), window.addEventListener("touchcancel", Ri), window.addEventListener("touchend", Ri)) : Ii.forEach((t, e) => {
    const {
      body: n
    } = e;
    t > 0 && (n.addEventListener("mousedown", lu), n.addEventListener("mousemove", Pi), n.addEventListener("touchmove", Pi, {
      passive: !1
    }), n.addEventListener("touchstart", lu));
  }));
}
function Q2(t, e) {
  Bl.forEach((n) => {
    const {
      setResizeHandlerState: r
    } = n, i = ro.includes(n);
    r(t, i, e);
  });
}
function st(t, e = "Assertion failed!") {
  if (!t)
    throw console.error(e), Error(e);
}
const yw = 10;
function Vl(t, e, n = yw) {
  t = parseFloat(t.toFixed(n)), e = parseFloat(e.toFixed(n));
  const r = t - e;
  return r === 0 ? 0 : r > 0 ? 1 : -1;
}
function $n(t, e, n) {
  return Vl(t, e, n) === 0;
}
function Ga({
  panelConstraints: t,
  panelIndex: e,
  size: n
}) {
  const r = t[e];
  st(r != null);
  let {
    collapsedSize: i = 0,
    collapsible: o,
    maxSize: a = 100,
    minSize: s = 0
  } = r;
  if (Vl(n, s) < 0)
    if (o) {
      const l = (i + s) / 2;
      Vl(n, l) < 0 ? n = i : n = s;
    } else
      n = s;
  return n = Math.min(a, n), n = parseFloat(n.toFixed(yw)), n;
}
function ll({
  delta: t,
  layout: e,
  panelConstraints: n,
  pivotIndices: r,
  trigger: i
}) {
  if ($n(t, 0))
    return e;
  const o = [...e], [a, s] = r;
  st(a != null), st(s != null);
  let l = 0;
  if (i === "keyboard") {
    {
      const u = t < 0 ? s : a, d = n[u];
      if (st(d), d.collapsible) {
        const f = e[u];
        st(f != null);
        const h = n[u];
        st(h);
        const {
          collapsedSize: v = 0,
          minSize: g = 0
        } = h;
        if ($n(f, v)) {
          const m = g - f;
          Vl(m, Math.abs(t)) > 0 && (t = t < 0 ? 0 - m : m);
        }
      }
    }
    {
      const u = t < 0 ? a : s, d = n[u];
      st(d);
      const {
        collapsible: f
      } = d;
      if (f) {
        const h = e[u];
        st(h != null);
        const v = n[u];
        st(v);
        const {
          collapsedSize: g = 0,
          minSize: m = 0
        } = v;
        if ($n(h, m)) {
          const p = h - g;
          Vl(p, Math.abs(t)) > 0 && (t = t < 0 ? 0 - p : p);
        }
      }
    }
  }
  {
    const u = t < 0 ? 1 : -1;
    let d = t < 0 ? s : a, f = 0;
    for (; ; ) {
      const v = e[d];
      st(v != null);
      const m = Ga({
        panelConstraints: n,
        panelIndex: d,
        size: 100
      }) - v;
      if (f += m, d += u, d < 0 || d >= n.length)
        break;
    }
    const h = Math.min(Math.abs(t), Math.abs(f));
    t = t < 0 ? 0 - h : h;
  }
  {
    let d = t < 0 ? a : s;
    for (; d >= 0 && d < n.length; ) {
      const f = Math.abs(t) - Math.abs(l), h = e[d];
      st(h != null);
      const v = h - f, g = Ga({
        panelConstraints: n,
        panelIndex: d,
        size: v
      });
      if (!$n(h, g) && (l += h - g, o[d] = g, l.toPrecision(3).localeCompare(Math.abs(t).toPrecision(3), void 0, {
        numeric: !0
      }) >= 0))
        break;
      t < 0 ? d-- : d++;
    }
  }
  if ($n(l, 0))
    return e;
  {
    const u = t < 0 ? s : a, d = e[u];
    st(d != null);
    const f = d + l, h = Ga({
      panelConstraints: n,
      panelIndex: u,
      size: f
    });
    if (o[u] = h, !$n(h, f)) {
      let v = f - h, m = t < 0 ? s : a;
      for (; m >= 0 && m < n.length; ) {
        const p = o[m];
        st(p != null);
        const y = p + v, b = Ga({
          panelConstraints: n,
          panelIndex: m,
          size: y
        });
        if ($n(p, b) || (v -= b - p, o[m] = b), $n(v, 0))
          break;
        t > 0 ? m-- : m++;
      }
    }
  }
  const c = o.reduce((u, d) => d + u, 0);
  return $n(c, 100) ? o : e;
}
function Sce({
  layout: t,
  panelsArray: e,
  pivotIndices: n
}) {
  let r = 0, i = 100, o = 0, a = 0;
  const s = n[0];
  st(s != null), e.forEach((d, f) => {
    const {
      constraints: h
    } = d, {
      maxSize: v = 100,
      minSize: g = 0
    } = h;
    f === s ? (r = g, i = v) : (o += g, a += v);
  });
  const l = Math.min(i, 100 - o), c = Math.max(r, 100 - a), u = t[s];
  return {
    valueMax: l,
    valueMin: c,
    valueNow: u
  };
}
function $l(t, e = document) {
  return Array.from(e.querySelectorAll(`[data-panel-resize-handle-id][data-panel-group-id="${t}"]`));
}
function bw(t, e, n = document) {
  const i = $l(t, n).findIndex((o) => o.getAttribute("data-panel-resize-handle-id") === e);
  return i ?? null;
}
function xw(t, e, n) {
  const r = bw(t, e, n);
  return r != null ? [r, r + 1] : [-1, -1];
}
function ww(t, e = document) {
  var n;
  if (e instanceof HTMLElement && (e == null || (n = e.dataset) === null || n === void 0 ? void 0 : n.panelGroupId) == t)
    return e;
  const r = e.querySelector(`[data-panel-group][data-panel-group-id="${t}"]`);
  return r || null;
}
function mf(t, e = document) {
  const n = e.querySelector(`[data-panel-resize-handle-id="${t}"]`);
  return n || null;
}
function Mce(t, e, n, r = document) {
  var i, o, a, s;
  const l = mf(e, r), c = $l(t, r), u = l ? c.indexOf(l) : -1, d = (i = (o = n[u]) === null || o === void 0 ? void 0 : o.id) !== null && i !== void 0 ? i : null, f = (a = (s = n[u + 1]) === null || s === void 0 ? void 0 : s.id) !== null && a !== void 0 ? a : null;
  return [d, f];
}
function Tce({
  committedValuesRef: t,
  eagerValuesRef: e,
  groupId: n,
  layout: r,
  panelDataArray: i,
  panelGroupElement: o,
  setLayout: a
}) {
  An({
    didWarnAboutMissingResizeHandle: !1
  }), Lo(() => {
    if (!o)
      return;
    const s = $l(n, o);
    for (let l = 0; l < i.length - 1; l++) {
      const {
        valueMax: c,
        valueMin: u,
        valueNow: d
      } = Sce({
        layout: r,
        panelsArray: i,
        pivotIndices: [l, l + 1]
      }), f = s[l];
      if (f != null) {
        const h = i[l];
        st(h), f.setAttribute("aria-controls", h.id), f.setAttribute("aria-valuemax", "" + Math.round(c)), f.setAttribute("aria-valuemin", "" + Math.round(u)), f.setAttribute("aria-valuenow", d != null ? "" + Math.round(d) : "");
      }
    }
    return () => {
      s.forEach((l, c) => {
        l.removeAttribute("aria-controls"), l.removeAttribute("aria-valuemax"), l.removeAttribute("aria-valuemin"), l.removeAttribute("aria-valuenow");
      });
    };
  }, [n, r, i, o]), Ro(() => {
    if (!o)
      return;
    const s = e.current;
    st(s);
    const {
      panelDataArray: l
    } = s, c = ww(n, o);
    st(c != null, `No group found for id "${n}"`);
    const u = $l(n, o);
    st(u);
    const d = u.map((f) => {
      const h = f.getAttribute("data-panel-resize-handle-id");
      st(h);
      const [v, g] = Mce(n, h, l, o);
      if (v == null || g == null)
        return () => {
        };
      const m = (p) => {
        if (!p.defaultPrevented)
          switch (p.key) {
            case "Enter": {
              p.preventDefault();
              const y = l.findIndex((b) => b.id === v);
              if (y >= 0) {
                const b = l[y];
                st(b);
                const x = r[y], {
                  collapsedSize: _ = 0,
                  collapsible: M,
                  minSize: S = 0
                } = b.constraints;
                if (x != null && M) {
                  const P = ll({
                    delta: $n(x, _) ? S - _ : _ - x,
                    layout: r,
                    panelConstraints: l.map((E) => E.constraints),
                    pivotIndices: xw(n, h, o),
                    trigger: "keyboard"
                  });
                  r !== P && a(P);
                }
              }
              break;
            }
          }
      };
      return f.addEventListener("keydown", m), () => {
        f.removeEventListener("keydown", m);
      };
    });
    return () => {
      d.forEach((f) => f());
    };
  }, [o, t, e, n, r, i, a]);
}
function Xg(t, e) {
  if (t.length !== e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
function _w(t, e) {
  const n = t === "horizontal", {
    x: r,
    y: i
  } = ff(e);
  return n ? r : i;
}
function Ace(t, e, n, r, i) {
  const o = n === "horizontal", a = mf(e, i);
  st(a);
  const s = a.getAttribute("data-panel-group-id");
  st(s);
  let {
    initialCursorPosition: l
  } = r;
  const c = _w(n, t), u = ww(s, i);
  st(u);
  const d = u.getBoundingClientRect(), f = o ? d.width : d.height;
  return (c - l) / f * 100;
}
function Pce(t, e, n, r, i, o) {
  if (cw(t)) {
    const a = n === "horizontal";
    let s = 0;
    t.shiftKey ? s = 100 : i != null ? s = i : s = 10;
    let l = 0;
    switch (t.key) {
      case "ArrowDown":
        l = a ? 0 : s;
        break;
      case "ArrowLeft":
        l = a ? -s : 0;
        break;
      case "ArrowRight":
        l = a ? s : 0;
        break;
      case "ArrowUp":
        l = a ? 0 : -s;
        break;
      case "End":
        l = 100;
        break;
      case "Home":
        l = -100;
        break;
    }
    return l;
  } else
    return r == null ? 0 : Ace(t, e, n, r, o);
}
function Rce({
  panelDataArray: t
}) {
  const e = Array(t.length), n = t.map((o) => o.constraints);
  let r = 0, i = 100;
  for (let o = 0; o < t.length; o++) {
    const a = n[o];
    st(a);
    const {
      defaultSize: s
    } = a;
    s != null && (r++, e[o] = s, i -= s);
  }
  for (let o = 0; o < t.length; o++) {
    const a = n[o];
    st(a);
    const {
      defaultSize: s
    } = a;
    if (s != null)
      continue;
    const l = t.length - r, c = i / l;
    r++, e[o] = c, i -= c;
  }
  return e;
}
function ya(t, e, n) {
  e.forEach((r, i) => {
    const o = t[i];
    st(o);
    const {
      callbacks: a,
      constraints: s,
      id: l
    } = o, {
      collapsedSize: c = 0,
      collapsible: u
    } = s, d = n[l];
    if (d == null || r !== d) {
      n[l] = r;
      const {
        onCollapse: f,
        onExpand: h,
        onResize: v
      } = a;
      v && v(r, d), u && (f || h) && (h && (d == null || d === c) && r !== c && h(), f && (d == null || d !== c) && r === c && f());
    }
  });
}
function cu(t, e) {
  if (t.length !== e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (t[n] != e[n])
      return !1;
  return !0;
}
function Lce({
  defaultSize: t,
  dragState: e,
  layout: n,
  panelData: r,
  panelIndex: i,
  precision: o = 3
}) {
  const a = n[i];
  let s;
  return a == null ? s = t != null ? t.toPrecision(o) : "1" : r.length === 1 ? s = "1" : s = a.toPrecision(o), {
    flexBasis: 0,
    flexGrow: s,
    flexShrink: 1,
    // Without this, Panel sizes may be unintentionally overridden by their content
    overflow: "hidden",
    // Disable pointer events inside of a panel during resize
    // This avoid edge cases like nested iframes
    pointerEvents: e !== null ? "none" : void 0
  };
}
function Oce(t, e = 10) {
  let n = null;
  return (...i) => {
    n !== null && clearTimeout(n), n = setTimeout(() => {
      t(...i);
    }, e);
  };
}
function Yg(t) {
  try {
    if (typeof localStorage < "u")
      t.getItem = (e) => localStorage.getItem(e), t.setItem = (e, n) => {
        localStorage.setItem(e, n);
      };
    else
      throw new Error("localStorage not supported in this environment");
  } catch (e) {
    console.error(e), t.getItem = () => null, t.setItem = () => {
    };
  }
}
function Cw(t) {
  return `react-resizable-panels:${t}`;
}
function Ew(t) {
  return t.map((e) => {
    const {
      constraints: n,
      id: r,
      idIsFromProps: i,
      order: o
    } = e;
    return i ? r : o ? `${o}:${JSON.stringify(n)}` : JSON.stringify(n);
  }).sort((e, n) => e.localeCompare(n)).join(",");
}
function Sw(t, e) {
  try {
    const n = Cw(t), r = e.getItem(n);
    if (r) {
      const i = JSON.parse(r);
      if (typeof i == "object" && i != null)
        return i;
    }
  } catch {
  }
  return null;
}
function Dce(t, e, n) {
  var r, i;
  const o = (r = Sw(t, n)) !== null && r !== void 0 ? r : {}, a = Ew(e);
  return (i = o[a]) !== null && i !== void 0 ? i : null;
}
function kce(t, e, n, r, i) {
  var o;
  const a = Cw(t), s = Ew(e), l = (o = Sw(t, i)) !== null && o !== void 0 ? o : {};
  l[s] = {
    expandToSizes: Object.fromEntries(n.entries()),
    layout: r
  };
  try {
    i.setItem(a, JSON.stringify(l));
  } catch (c) {
    console.error(c);
  }
}
function Zg({
  layout: t,
  panelConstraints: e
}) {
  const n = [...t], r = n.reduce((o, a) => o + a, 0);
  if (n.length !== e.length)
    throw Error(`Invalid ${e.length} panel layout: ${n.map((o) => `${o}%`).join(", ")}`);
  if (!$n(r, 100))
    for (let o = 0; o < e.length; o++) {
      const a = n[o];
      st(a != null);
      const s = 100 / r * a;
      n[o] = s;
    }
  let i = 0;
  for (let o = 0; o < e.length; o++) {
    const a = n[o];
    st(a != null);
    const s = Ga({
      panelConstraints: e,
      panelIndex: o,
      size: a
    });
    a != s && (i += a - s, n[o] = s);
  }
  if (!$n(i, 0))
    for (let o = 0; o < e.length; o++) {
      const a = n[o];
      st(a != null);
      const s = a + i, l = Ga({
        panelConstraints: e,
        panelIndex: o,
        size: s
      });
      if (a !== l && (i -= l - a, n[o] = l, $n(i, 0)))
        break;
    }
  return n;
}
const Nce = 100, cl = {
  getItem: (t) => (Yg(cl), cl.getItem(t)),
  setItem: (t, e) => {
    Yg(cl), cl.setItem(t, e);
  }
}, Kg = {};
function Mw({
  autoSaveId: t = null,
  children: e,
  className: n = "",
  direction: r,
  forwardedRef: i,
  id: o = null,
  onLayout: a = null,
  keyboardResizeBy: s = null,
  storage: l = cl,
  style: c,
  tagName: u = "div",
  ...d
}) {
  const f = K2(o), h = An(null), [v, g] = Ml(null), [m, p] = Ml([]), y = An({}), b = An(/* @__PURE__ */ new Map()), x = An(0), _ = An({
    autoSaveId: t,
    direction: r,
    dragState: v,
    id: f,
    keyboardResizeBy: s,
    onLayout: a,
    storage: l
  }), M = An({
    layout: m,
    panelDataArray: [],
    panelDataArrayChanged: !1
  });
  An({
    didLogIdAndOrderWarning: !1,
    didLogPanelConstraintsWarning: !1,
    prevPanelIds: []
  }), aw(i, () => ({
    getId: () => _.current.id,
    getLayout: () => {
      const {
        layout: Q
      } = M.current;
      return Q;
    },
    setLayout: (Q) => {
      const {
        onLayout: ce
      } = _.current, {
        layout: k,
        panelDataArray: G
      } = M.current, K = Zg({
        layout: Q,
        panelConstraints: G.map((J) => J.constraints)
      });
      Xg(k, K) || (p(K), M.current.layout = K, ce && ce(K), ya(G, K, y.current));
    }
  }), []), Lo(() => {
    _.current.autoSaveId = t, _.current.direction = r, _.current.dragState = v, _.current.id = f, _.current.onLayout = a, _.current.storage = l;
  }), Tce({
    committedValuesRef: _,
    eagerValuesRef: M,
    groupId: f,
    layout: m,
    panelDataArray: M.current.panelDataArray,
    setLayout: p,
    panelGroupElement: h.current
  }), Ro(() => {
    const {
      panelDataArray: Q
    } = M.current;
    if (t) {
      if (m.length === 0 || m.length !== Q.length)
        return;
      let ce = Kg[t];
      ce == null && (ce = Oce(kce, Nce), Kg[t] = ce);
      const k = [...Q], G = new Map(b.current);
      ce(t, k, G, m, l);
    }
  }, [t, m, l]), Ro(() => {
  });
  const S = zn((Q) => {
    const {
      onLayout: ce
    } = _.current, {
      layout: k,
      panelDataArray: G
    } = M.current;
    if (Q.constraints.collapsible) {
      const K = G.map((pe) => pe.constraints), {
        collapsedSize: J = 0,
        panelSize: se,
        pivotIndices: be
      } = yo(G, Q, k);
      if (st(se != null), se !== J) {
        b.current.set(Q.id, se);
        const Ne = Va(G, Q) === G.length - 1 ? se - J : J - se, ae = ll({
          delta: Ne,
          layout: k,
          panelConstraints: K,
          pivotIndices: be,
          trigger: "imperative-api"
        });
        cu(k, ae) || (p(ae), M.current.layout = ae, ce && ce(ae), ya(G, ae, y.current));
      }
    }
  }, []), P = zn((Q) => {
    const {
      onLayout: ce
    } = _.current, {
      layout: k,
      panelDataArray: G
    } = M.current;
    if (Q.constraints.collapsible) {
      const K = G.map((Ne) => Ne.constraints), {
        collapsedSize: J = 0,
        panelSize: se,
        minSize: be = 0,
        pivotIndices: pe
      } = yo(G, Q, k);
      if (se === J) {
        const Ne = b.current.get(Q.id), ae = Ne != null && Ne >= be ? Ne : be, F = Va(G, Q) === G.length - 1 ? se - ae : ae - se, Ge = ll({
          delta: F,
          layout: k,
          panelConstraints: K,
          pivotIndices: pe,
          trigger: "imperative-api"
        });
        cu(k, Ge) || (p(Ge), M.current.layout = Ge, ce && ce(Ge), ya(G, Ge, y.current));
      }
    }
  }, []), E = zn((Q) => {
    const {
      layout: ce,
      panelDataArray: k
    } = M.current, {
      panelSize: G
    } = yo(k, Q, ce);
    return st(G != null), G;
  }, []), w = zn((Q, ce) => {
    const {
      panelDataArray: k
    } = M.current, G = Va(k, Q);
    return Lce({
      defaultSize: ce,
      dragState: v,
      layout: m,
      panelData: k,
      panelIndex: G
    });
  }, [v, m]), O = zn((Q) => {
    const {
      layout: ce,
      panelDataArray: k
    } = M.current, {
      collapsedSize: G = 0,
      collapsible: K,
      panelSize: J
    } = yo(k, Q, ce);
    return K === !0 && J === G;
  }, []), N = zn((Q) => {
    const {
      layout: ce,
      panelDataArray: k
    } = M.current, {
      collapsedSize: G = 0,
      collapsible: K,
      panelSize: J
    } = yo(k, Q, ce);
    return st(J != null), !K || J > G;
  }, []), I = zn((Q) => {
    const {
      panelDataArray: ce
    } = M.current;
    ce.push(Q), ce.sort((k, G) => {
      const K = k.order, J = G.order;
      return K == null && J == null ? 0 : K == null ? -1 : J == null ? 1 : K - J;
    }), M.current.panelDataArrayChanged = !0;
  }, []);
  Lo(() => {
    if (M.current.panelDataArrayChanged) {
      M.current.panelDataArrayChanged = !1;
      const {
        autoSaveId: Q,
        onLayout: ce,
        storage: k
      } = _.current, {
        layout: G,
        panelDataArray: K
      } = M.current;
      let J = null;
      if (Q) {
        const be = Dce(Q, K, k);
        be && (b.current = new Map(Object.entries(be.expandToSizes)), J = be.layout);
      }
      J == null && (J = Rce({
        panelDataArray: K
      }));
      const se = Zg({
        layout: J,
        panelConstraints: K.map((be) => be.constraints)
      });
      Xg(G, se) || (p(se), M.current.layout = se, ce && ce(se), ya(K, se, y.current));
    }
  }), Lo(() => {
    const Q = M.current;
    return () => {
      Q.layout = [];
    };
  }, []);
  const H = zn((Q) => function(k) {
    k.preventDefault();
    const G = h.current;
    if (!G)
      return () => null;
    const {
      direction: K,
      dragState: J,
      id: se,
      keyboardResizeBy: be,
      onLayout: pe
    } = _.current, {
      layout: Ne,
      panelDataArray: ae
    } = M.current, {
      initialLayout: Re
    } = J ?? {}, F = xw(se, Q, G);
    let Ge = Pce(k, Q, K, J, be, G);
    if (Ge === 0)
      return;
    const $e = K === "horizontal";
    document.dir === "rtl" && $e && (Ge = -Ge);
    const he = ae.map((we) => we.constraints), ue = ll({
      delta: Ge,
      layout: Re ?? Ne,
      panelConstraints: he,
      pivotIndices: F,
      trigger: cw(k) ? "keyboard" : "mouse-or-touch"
    }), Se = !cu(Ne, ue);
    (uw(k) || dw(k)) && x.current != Ge && (x.current = Ge, Se ? X0(Q, 0) : $e ? X0(Q, Ge < 0 ? hw : pw) : X0(Q, Ge < 0 ? mw : vw)), Se && (p(ue), M.current.layout = ue, pe && pe(ue), ya(ae, ue, y.current));
  }, []), j = zn((Q, ce) => {
    const {
      onLayout: k
    } = _.current, {
      layout: G,
      panelDataArray: K
    } = M.current, J = K.map((Re) => Re.constraints), {
      panelSize: se,
      pivotIndices: be
    } = yo(K, Q, G);
    st(se != null);
    const Ne = Va(K, Q) === K.length - 1 ? se - ce : ce - se, ae = ll({
      delta: Ne,
      layout: G,
      panelConstraints: J,
      pivotIndices: be,
      trigger: "imperative-api"
    });
    cu(G, ae) || (p(ae), M.current.layout = ae, k && k(ae), ya(K, ae, y.current));
  }, []), U = zn((Q, ce) => {
    const {
      layout: k,
      panelDataArray: G
    } = M.current, {
      collapsedSize: K = 0,
      collapsible: J
    } = ce, {
      collapsedSize: se = 0,
      collapsible: be,
      maxSize: pe = 100,
      minSize: Ne = 0
    } = Q.constraints, {
      panelSize: ae
    } = yo(G, Q, k);
    st(ae != null), J && be && ae === K ? K !== se && j(Q, se) : ae < Ne ? j(Q, Ne) : ae > pe && j(Q, pe);
  }, [j]), $ = zn((Q, ce) => {
    const {
      direction: k
    } = _.current, {
      layout: G
    } = M.current;
    if (!h.current)
      return;
    const K = mf(Q, h.current);
    st(K);
    const J = _w(k, ce);
    g({
      dragHandleId: Q,
      dragHandleRect: K.getBoundingClientRect(),
      initialCursorPosition: J,
      initialLayout: G
    });
  }, []), V = zn(() => {
    g(null);
  }, []), te = zn((Q) => {
    const {
      panelDataArray: ce
    } = M.current, k = Va(ce, Q);
    k >= 0 && (ce.splice(k, 1), delete y.current[Q.id], M.current.panelDataArrayChanged = !0);
  }, []), B = dce(() => ({
    collapsePanel: S,
    direction: r,
    dragState: v,
    expandPanel: P,
    getPanelSize: E,
    getPanelStyle: w,
    groupId: f,
    isPanelCollapsed: O,
    isPanelExpanded: N,
    reevaluatePanelConstraints: U,
    registerPanel: I,
    registerResizeHandle: H,
    resizePanel: j,
    startDragging: $,
    stopDragging: V,
    unregisterPanel: te,
    panelGroupElement: h.current
  }), [S, v, r, P, E, w, f, O, N, U, I, H, j, $, V, te]), Z = {
    display: "flex",
    flexDirection: r === "horizontal" ? "row" : "column",
    height: "100%",
    overflow: "hidden",
    width: "100%"
  };
  return cs(df.Provider, {
    value: B
  }, cs(u, {
    ...d,
    children: e,
    className: n,
    id: o,
    ref: h,
    style: {
      ...Z,
      ...c
    },
    // CSS selectors
    "data-panel-group": "",
    "data-panel-group-direction": r,
    "data-panel-group-id": f
  }));
}
const Tw = iw((t, e) => cs(Mw, {
  ...t,
  forwardedRef: e
}));
Mw.displayName = "PanelGroup";
Tw.displayName = "forwardRef(PanelGroup)";
function Va(t, e) {
  return t.findIndex((n) => n === e || n.id === e.id);
}
function yo(t, e, n) {
  const r = Va(t, e), o = r === t.length - 1 ? [r - 1, r] : [r, r + 1], a = n[r];
  return {
    ...e.constraints,
    panelSize: a,
    pivotIndices: o
  };
}
function Ice({
  disabled: t,
  handleId: e,
  resizeHandler: n,
  panelGroupElement: r
}) {
  Ro(() => {
    if (t || n == null || r == null)
      return;
    const i = mf(e, r);
    if (i == null)
      return;
    const o = (a) => {
      if (!a.defaultPrevented)
        switch (a.key) {
          case "ArrowDown":
          case "ArrowLeft":
          case "ArrowRight":
          case "ArrowUp":
          case "End":
          case "Home": {
            a.preventDefault(), n(a);
            break;
          }
          case "F6": {
            a.preventDefault();
            const s = i.getAttribute("data-panel-group-id");
            st(s);
            const l = $l(s, r), c = bw(s, e, r);
            st(c !== null);
            const u = a.shiftKey ? c > 0 ? c - 1 : l.length - 1 : c + 1 < l.length ? c + 1 : 0;
            l[u].focus();
            break;
          }
        }
    };
    return i.addEventListener("keydown", o), () => {
      i.removeEventListener("keydown", o);
    };
  }, [r, t, e, n]);
}
function Aw({
  children: t = null,
  className: e = "",
  disabled: n = !1,
  hitAreaMargins: r,
  id: i,
  onDragging: o,
  style: a = {},
  tabIndex: s = 0,
  tagName: l = "div",
  ...c
}) {
  const u = An(null), d = An({
    onDragging: o
  });
  Ro(() => {
    d.current.onDragging = o;
  });
  const f = ow(df);
  if (f === null)
    throw Error("PanelResizeHandle components must be rendered within a PanelGroup container");
  const {
    direction: h,
    groupId: v,
    registerResizeHandle: g,
    startDragging: m,
    stopDragging: p,
    panelGroupElement: y
  } = f, b = K2(i), [x, _] = Ml("inactive"), [M, S] = Ml(!1), [P, E] = Ml(null), w = An({
    state: x
  });
  return Lo(() => {
    w.current.state = x;
  }), Ro(() => {
    if (n)
      E(null);
    else {
      const N = g(b);
      E(() => N);
    }
  }, [n, b, g]), Ro(() => {
    var N, I;
    if (n || P == null)
      return;
    const H = u.current;
    st(H);
    const j = (U, $, V) => {
      if ($)
        switch (U) {
          case "down": {
            _("drag"), m(b, V);
            const {
              onDragging: te
            } = d.current;
            te && te(!0);
            break;
          }
          case "move": {
            const {
              state: te
            } = w.current;
            te !== "drag" && _("hover"), P(V);
            break;
          }
          case "up": {
            _("hover"), p();
            const {
              onDragging: te
            } = d.current;
            te && te(!1);
            break;
          }
        }
      else
        _("inactive");
    };
    return Ece(b, H, h, {
      // Coarse inputs (e.g. finger/touch)
      coarse: (N = r == null ? void 0 : r.coarse) !== null && N !== void 0 ? N : 15,
      // Fine inputs (e.g. mouse)
      fine: (I = r == null ? void 0 : r.fine) !== null && I !== void 0 ? I : 5
    }, j);
  }, [h, n, r, g, b, P, m, p]), Ice({
    disabled: n,
    handleId: b,
    resizeHandler: P,
    panelGroupElement: y
  }), cs(l, {
    ...c,
    children: t,
    className: e,
    id: i,
    onBlur: () => S(!1),
    onFocus: () => S(!0),
    ref: u,
    role: "separator",
    style: {
      ...{
        touchAction: "none",
        userSelect: "none"
      },
      ...a
    },
    tabIndex: s,
    // CSS selectors
    "data-panel-group-direction": h,
    "data-panel-group-id": v,
    "data-resize-handle": "",
    "data-resize-handle-active": x === "drag" ? "pointer" : M ? "keyboard" : void 0,
    "data-resize-handle-state": x,
    "data-panel-resize-handle-enabled": !n,
    "data-panel-resize-handle-id": b
  });
}
Aw.displayName = "PanelResizeHandle";
const Fce = /* @__PURE__ */ R.jsxs(
  "svg",
  {
    className: "h-4 w-4 color-neutral-400",
    fill: "none",
    height: "18",
    viewBox: "0 0 18 18",
    width: "18",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ R.jsx("circle", { cx: "9", cy: "9", fill: "white", r: "8.5", stroke: "currentColor", transform: "rotate(-180 9 9)" }),
      /* @__PURE__ */ R.jsx("path", { d: "M10.5 12.3333L14.5 8.90468L10.5 5.47611", stroke: "currentColor", strokeLinecap: "round" }),
      /* @__PURE__ */ R.jsx("path", { d: "M7.5 12.3333L3.5 8.90468L7.5 5.47611", stroke: "currentColor", strokeLinecap: "round" })
    ]
  }
), Ahe = ({
  className: t,
  ...e
}) => /* @__PURE__ */ R.jsx(
  Tw,
  {
    className: ve("flex h-full w-full data-[panel-group-direction=vertical]:flex-col", t),
    ...e
  }
), Phe = lw, Rhe = ({
  withHandle: t,
  className: e,
  ...n
}) => /* @__PURE__ */ R.jsx(
  Aw,
  {
    className: ve(
      "relative flex w-px items-center justify-center bg-neutral-400 after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:after:left-0 data-[panel-group-direction=vertical]:after:h-1 data-[panel-group-direction=vertical]:after:w-full data-[panel-group-direction=vertical]:after:-translate-y-1/2 data-[panel-group-direction=vertical]:after:translate-x-0 [&[data-panel-group-direction=vertical]>div]:rotate-90",
      e
    ),
    ...n,
    children: t && /* @__PURE__ */ R.jsx("div", { className: "z-10 h-4 w-4 flex items-center justify-center", children: Fce })
  }
), Lhe = ({ className: t, ...e }) => /* @__PURE__ */ R.jsx("div", { className: ve("animate-pulse rounded-1 bg-neutral-300", t), ...e }), Ohe = ({ className: t, color: e = "neutral" }) => /* @__PURE__ */ R.jsx(
  "div",
  {
    className: ve(
      "h-3 w-3 rounded-full",
      "b-2 b-solid",
      e === "dark" && "b-b-black/25 b-l-black/25 b-r-black/25 b-t-black",
      e === "light" && "b-b-neutral-100/25 b-l-neutral-100/25 b-r-neutral-100/25 b-t-neutral-100",
      e === "neutral" && "b-b-neutral-400 b-l-neutral-400 b-r-neutral-400 b-t-neutral-500",
      e === "primary" && "b-b-primary-100 b-l-primary-100 b-r-primary-100 b-t-primary-400",
      t
    )
  }
);
var em = "Switch", [Uce, Dhe] = Es(em), [zce, Hce] = Uce(em), Pw = C.forwardRef(
  (t, e) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: i,
      defaultChecked: o,
      required: a,
      disabled: s,
      value: l = "on",
      onCheckedChange: c,
      ...u
    } = t, [d, f] = C.useState(null), h = bn(e, (y) => f(y)), v = C.useRef(!1), g = d ? !!d.closest("form") : !0, [m = !1, p] = $o({
      prop: i,
      defaultProp: o,
      onChange: c
    });
    return /* @__PURE__ */ R.jsxs(zce, { scope: n, checked: m, disabled: s, children: [
      /* @__PURE__ */ R.jsx(
        Zt.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": m,
          "aria-required": a,
          "data-state": Ow(m),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...u,
          ref: h,
          onClick: zt(t.onClick, (y) => {
            p((b) => !b), g && (v.current = y.isPropagationStopped(), v.current || y.stopPropagation());
          })
        }
      ),
      g && /* @__PURE__ */ R.jsx(
        Bce,
        {
          control: d,
          bubbles: !v.current,
          name: r,
          value: l,
          checked: m,
          required: a,
          disabled: s,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Pw.displayName = em;
var Rw = "SwitchThumb", Lw = C.forwardRef(
  (t, e) => {
    const { __scopeSwitch: n, ...r } = t, i = Hce(Rw, n);
    return /* @__PURE__ */ R.jsx(
      Zt.span,
      {
        "data-state": Ow(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: e
      }
    );
  }
);
Lw.displayName = Rw;
var Bce = (t) => {
  const { control: e, checked: n, bubbles: r = !0, ...i } = t, o = C.useRef(null), a = Z1(n), s = bd(e);
  return C.useEffect(() => {
    const l = o.current, c = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(c, "checked").set;
    if (a !== n && d) {
      const f = new Event("click", { bubbles: r });
      d.call(l, n), l.dispatchEvent(f);
    }
  }, [a, n, r]), /* @__PURE__ */ R.jsx(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...i,
      tabIndex: -1,
      ref: o,
      style: {
        ...t.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Ow(t) {
  return t ? "checked" : "unchecked";
}
var Vce = Pw, $ce = Lw;
const Wce = A.forwardRef(
  ({ className: t, v1: e, onChange: n, disabled: r, ...i }, o) => /* @__PURE__ */ R.jsx(
    Vce,
    {
      className: ve(
        "peer inline-flex h-4.5 w-9 shrink-0 cursor-pointer items-center rounded-full border-3 border-solid border-transparent transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "data-[state=unchecked]:bg-neutral-400",
        e ? "data-[state=checked]:bg-skandI-400" : "data-[state=checked]:bg-primary-400",
        t
      ),
      disabled: r,
      onCheckedChange: n,
      ...i,
      ref: o,
      children: /* @__PURE__ */ R.jsx(
        $ce,
        {
          className: ve(
            "pointer-events-none block h-3 w-3 rounded-full ring-0 transition-transform bg-neutral-100",
            "data-[state=checked]:translate-x-4.5 data-[state=unchecked]:translate-x-0"
          )
        }
      )
    }
  )
);
Wce.displayName = "Switch";
var Y0 = "rovingFocusGroup.onEntryFocus", jce = { bubbles: !1, cancelable: !0 }, vf = "RovingFocusGroup", [H1, Dw, Gce] = D7(vf), [qce, kw] = Es(
  vf,
  [Gce]
), [Xce, Yce] = qce(vf), Nw = C.forwardRef(
  (t, e) => /* @__PURE__ */ R.jsx(H1.Provider, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ R.jsx(H1.Slot, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ R.jsx(Zce, { ...t, ref: e }) }) })
);
Nw.displayName = vf;
var Zce = C.forwardRef((t, e) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: i = !1,
    dir: o,
    currentTabStopId: a,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = t, f = C.useRef(null), h = bn(e, f), v = u2(o), [g = null, m] = $o({
    prop: a,
    defaultProp: s,
    onChange: l
  }), [p, y] = C.useState(!1), b = Cr(c), x = Dw(n), _ = C.useRef(!1), [M, S] = C.useState(0);
  return C.useEffect(() => {
    const P = f.current;
    if (P)
      return P.addEventListener(Y0, b), () => P.removeEventListener(Y0, b);
  }, [b]), /* @__PURE__ */ R.jsx(
    Xce,
    {
      scope: n,
      orientation: r,
      dir: v,
      loop: i,
      currentTabStopId: g,
      onItemFocus: C.useCallback(
        (P) => m(P),
        [m]
      ),
      onItemShiftTab: C.useCallback(() => y(!0), []),
      onFocusableItemAdd: C.useCallback(
        () => S((P) => P + 1),
        []
      ),
      onFocusableItemRemove: C.useCallback(
        () => S((P) => P - 1),
        []
      ),
      children: /* @__PURE__ */ R.jsx(
        Zt.div,
        {
          tabIndex: p || M === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: h,
          style: { outline: "none", ...t.style },
          onMouseDown: zt(t.onMouseDown, () => {
            _.current = !0;
          }),
          onFocus: zt(t.onFocus, (P) => {
            const E = !_.current;
            if (P.target === P.currentTarget && E && !p) {
              const w = new CustomEvent(Y0, jce);
              if (P.currentTarget.dispatchEvent(w), !w.defaultPrevented) {
                const O = x().filter((U) => U.focusable), N = O.find((U) => U.active), I = O.find((U) => U.id === g), j = [N, I, ...O].filter(
                  Boolean
                ).map((U) => U.ref.current);
                Uw(j, u);
              }
            }
            _.current = !1;
          }),
          onBlur: zt(t.onBlur, () => y(!1))
        }
      )
    }
  );
}), Iw = "RovingFocusGroupItem", Fw = C.forwardRef(
  (t, e) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: i = !1,
      tabStopId: o,
      ...a
    } = t, s = Xa(), l = o || s, c = Yce(Iw, n), u = c.currentTabStopId === l, d = Dw(n), { onFocusableItemAdd: f, onFocusableItemRemove: h } = c;
    return C.useEffect(() => {
      if (r)
        return f(), () => h();
    }, [r, f, h]), /* @__PURE__ */ R.jsx(
      H1.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: i,
        children: /* @__PURE__ */ R.jsx(
          Zt.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": c.orientation,
            ...a,
            ref: e,
            onMouseDown: zt(t.onMouseDown, (v) => {
              r ? c.onItemFocus(l) : v.preventDefault();
            }),
            onFocus: zt(t.onFocus, () => c.onItemFocus(l)),
            onKeyDown: zt(t.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                c.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget)
                return;
              const g = Qce(v, c.orientation, c.dir);
              if (g !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey)
                  return;
                v.preventDefault();
                let p = d().filter((y) => y.focusable).map((y) => y.ref.current);
                if (g === "last")
                  p.reverse();
                else if (g === "prev" || g === "next") {
                  g === "prev" && p.reverse();
                  const y = p.indexOf(v.currentTarget);
                  p = c.loop ? eue(p, y + 1) : p.slice(y + 1);
                }
                setTimeout(() => Uw(p));
              }
            })
          }
        )
      }
    );
  }
);
Fw.displayName = Iw;
var Kce = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Jce(t, e) {
  return e !== "rtl" ? t : t === "ArrowLeft" ? "ArrowRight" : t === "ArrowRight" ? "ArrowLeft" : t;
}
function Qce(t, e, n) {
  const r = Jce(t.key, n);
  if (!(e === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(e === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return Kce[r];
}
function Uw(t, e = !1) {
  const n = document.activeElement;
  for (const r of t)
    if (r === n || (r.focus({ preventScroll: e }), document.activeElement !== n))
      return;
}
function eue(t, e) {
  return t.map((n, r) => t[(e + r) % t.length]);
}
var tue = Nw, nue = Fw;
function rue(t, e) {
  return C.useReducer((n, r) => e[n][r] ?? n, t);
}
var tm = (t) => {
  const { present: e, children: n } = t, r = iue(e), i = typeof n == "function" ? n({ present: r.isPresent }) : C.Children.only(n), o = bn(r.ref, oue(i));
  return typeof n == "function" || r.isPresent ? C.cloneElement(i, { ref: o }) : null;
};
tm.displayName = "Presence";
function iue(t) {
  const [e, n] = C.useState(), r = C.useRef({}), i = C.useRef(t), o = C.useRef("none"), a = t ? "mounted" : "unmounted", [s, l] = rue(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return C.useEffect(() => {
    const c = uu(r.current);
    o.current = s === "mounted" ? c : "none";
  }, [s]), li(() => {
    const c = r.current, u = i.current;
    if (u !== t) {
      const f = o.current, h = uu(c);
      t ? l("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), i.current = t;
    }
  }, [t, l]), li(() => {
    if (e) {
      let c;
      const u = e.ownerDocument.defaultView ?? window, d = (h) => {
        const g = uu(r.current).includes(h.animationName);
        if (h.target === e && g && (l("ANIMATION_END"), !i.current)) {
          const m = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = m);
          });
        }
      }, f = (h) => {
        h.target === e && (o.current = uu(r.current));
      };
      return e.addEventListener("animationstart", f), e.addEventListener("animationcancel", d), e.addEventListener("animationend", d), () => {
        u.clearTimeout(c), e.removeEventListener("animationstart", f), e.removeEventListener("animationcancel", d), e.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [e, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: C.useCallback((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function uu(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function oue(t) {
  var r, i;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (i = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : i.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var nm = "Tabs", [aue, khe] = yd(nm, [
  kw
]), zw = kw(), [sue, rm] = aue(nm), Hw = C.forwardRef(
  (t, e) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: i,
      defaultValue: o,
      orientation: a = "horizontal",
      dir: s,
      activationMode: l = "automatic",
      ...c
    } = t, u = u2(s), [d, f] = $o({
      prop: r,
      onChange: i,
      defaultProp: o
    });
    return /* @__PURE__ */ R.jsx(
      sue,
      {
        scope: n,
        baseId: Xa(),
        value: d,
        onValueChange: f,
        orientation: a,
        dir: u,
        activationMode: l,
        children: /* @__PURE__ */ R.jsx(
          Zt.div,
          {
            dir: u,
            "data-orientation": a,
            ...c,
            ref: e
          }
        )
      }
    );
  }
);
Hw.displayName = nm;
var Bw = "TabsList", Vw = C.forwardRef(
  (t, e) => {
    const { __scopeTabs: n, loop: r = !0, ...i } = t, o = rm(Bw, n), a = zw(n);
    return /* @__PURE__ */ R.jsx(
      tue,
      {
        asChild: !0,
        ...a,
        orientation: o.orientation,
        dir: o.dir,
        loop: r,
        children: /* @__PURE__ */ R.jsx(
          Zt.div,
          {
            role: "tablist",
            "aria-orientation": o.orientation,
            ...i,
            ref: e
          }
        )
      }
    );
  }
);
Vw.displayName = Bw;
var $w = "TabsTrigger", Ww = C.forwardRef(
  (t, e) => {
    const { __scopeTabs: n, value: r, disabled: i = !1, ...o } = t, a = rm($w, n), s = zw(n), l = qw(a.baseId, r), c = Xw(a.baseId, r), u = r === a.value;
    return /* @__PURE__ */ R.jsx(
      nue,
      {
        asChild: !0,
        ...s,
        focusable: !i,
        active: u,
        children: /* @__PURE__ */ R.jsx(
          Zt.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": c,
            "data-state": u ? "active" : "inactive",
            "data-disabled": i ? "" : void 0,
            disabled: i,
            id: l,
            ...o,
            ref: e,
            onMouseDown: zt(t.onMouseDown, (d) => {
              !i && d.button === 0 && d.ctrlKey === !1 ? a.onValueChange(r) : d.preventDefault();
            }),
            onKeyDown: zt(t.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && a.onValueChange(r);
            }),
            onFocus: zt(t.onFocus, () => {
              const d = a.activationMode !== "manual";
              !u && !i && d && a.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
Ww.displayName = $w;
var jw = "TabsContent", Gw = C.forwardRef(
  (t, e) => {
    const { __scopeTabs: n, value: r, forceMount: i, children: o, ...a } = t, s = rm(jw, n), l = qw(s.baseId, r), c = Xw(s.baseId, r), u = r === s.value, d = C.useRef(u);
    return C.useEffect(() => {
      const f = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(f);
    }, []), /* @__PURE__ */ R.jsx(tm, { present: i || u, children: ({ present: f }) => /* @__PURE__ */ R.jsx(
      Zt.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !f,
        id: c,
        tabIndex: 0,
        ...a,
        ref: e,
        style: {
          ...t.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: f && o
      }
    ) });
  }
);
Gw.displayName = jw;
function qw(t, e) {
  return `${t}-trigger-${e}`;
}
function Xw(t, e) {
  return `${t}-content-${e}`;
}
var Yw = Hw, gf = Vw, yf = Ww, bf = Gw;
const Nhe = Yw, lue = C.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ R.jsx(gf, { className: ve("flex", t), ref: n, ...e }));
lue.displayName = gf.displayName;
const cue = C.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ R.jsx(
  yf,
  {
    className: ve(
      "b-solid b-0 bg-transparent uppercase cursor-pointer flex-1",
      "inline-flex items-center justify-center whitespace-nowrap px-3 pt-3",
      "disabled:pointer-events-none disabled:opacity-50",
      "focus-visible:ring-ring",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
      "data-[state=active]:pb-10px data-[state=active]:b-b-2 data-[state=active]:b-b-primary-400 data-[state=active]:text-primary-400 data-[state=active]:typo-text-s-em",
      "data-[state=inactive]:pb-12px data-[state=inactive]:b-b-1 data-[state=inactive]:b-neutral-300 data-[state=inactive]:text-neutral-500 data-[state=inactive]:typo-text-s",
      t
    ),
    ref: n,
    ...e
  }
));
cue.displayName = yf.displayName;
const uue = C.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ R.jsx(
  bf,
  {
    className: ve(
      "mt-2",
      "ring-offset-background focus-visible:ring-ring",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
      t
    ),
    ref: n,
    ...e
  }
));
uue.displayName = bf.displayName;
const Ihe = Yw, due = C.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ R.jsx(gf, { className: ve("flex gap-3", t), ref: n, ...e }));
due.displayName = gf.displayName;
const fue = C.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ R.jsx(
  yf,
  {
    className: ve(
      "b-0 b-none cursor-pointer px-1 py-0.5  rounded-1 transition-colors",
      "disabled:pointer-events-none disabled:opacity-50",
      "hover:bg-neutral-200",
      "data-[state=active]:color-neutral-700 data-[state=active]:bg-neutral-200 data-[state=active]:typo-text-s-em",
      "data-[state=inactive]:bg-transparent data-[state=inactive]:color-neutral-500 data-[state=inactive]:typo-text-s",
      t
    ),
    ref: n,
    ...e
  }
));
fue.displayName = yf.displayName;
const hue = C.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ R.jsx(bf, { className: ve(t), ref: n, ...e }));
hue.displayName = bf.displayName;
var pue = "DismissableLayer", B1 = "dismissableLayer.update", mue = "dismissableLayer.pointerDownOutside", vue = "dismissableLayer.focusOutside", Jg, Zw = C.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Kw = C.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = t, c = C.useContext(Zw), [u, d] = C.useState(null), f = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = C.useState({}), v = bn(e, (S) => d(S)), g = Array.from(c.layers), [m] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), p = g.indexOf(m), y = u ? g.indexOf(u) : -1, b = c.layersWithOutsidePointerEventsDisabled.size > 0, x = y >= p, _ = bue((S) => {
      const P = S.target, E = [...c.branches].some((w) => w.contains(P));
      !x || E || (i == null || i(S), a == null || a(S), S.defaultPrevented || s == null || s());
    }, f), M = xue((S) => {
      const P = S.target;
      [...c.branches].some((w) => w.contains(P)) || (o == null || o(S), a == null || a(S), S.defaultPrevented || s == null || s());
    }, f);
    return Y8((S) => {
      y === c.layers.size - 1 && (r == null || r(S), !S.defaultPrevented && s && (S.preventDefault(), s()));
    }, f), C.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (Jg = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), Qg(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = Jg);
        };
    }, [u, f, n, c]), C.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), Qg());
    }, [u, c]), C.useEffect(() => {
      const S = () => h({});
      return document.addEventListener(B1, S), () => document.removeEventListener(B1, S);
    }, []), /* @__PURE__ */ R.jsx(
      Zt.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: b ? x ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: zt(t.onFocusCapture, M.onFocusCapture),
        onBlurCapture: zt(t.onBlurCapture, M.onBlurCapture),
        onPointerDownCapture: zt(
          t.onPointerDownCapture,
          _.onPointerDownCapture
        )
      }
    );
  }
);
Kw.displayName = pue;
var gue = "DismissableLayerBranch", yue = C.forwardRef((t, e) => {
  const n = C.useContext(Zw), r = C.useRef(null), i = bn(e, r);
  return C.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ R.jsx(Zt.div, { ...t, ref: i });
});
yue.displayName = gue;
function bue(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Cr(t), r = C.useRef(!1), i = C.useRef(() => {
  });
  return C.useEffect(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          Jw(
            mue,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (e.removeEventListener("click", i.current), i.current = l, e.addEventListener("click", i.current, { once: !0 })) : l();
      } else
        e.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      e.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), e.removeEventListener("pointerdown", o), e.removeEventListener("click", i.current);
    };
  }, [e, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function xue(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Cr(t), r = C.useRef(!1);
  return C.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && Jw(vue, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", i), () => e.removeEventListener("focusin", i);
  }, [e, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Qg() {
  const t = new CustomEvent(B1);
  document.dispatchEvent(t);
}
function Jw(t, e, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: n });
  e && i.addEventListener(t, e, { once: !0 }), r ? GZ(i, o) : i.dispatchEvent(o);
}
var wue = "Arrow", Qw = C.forwardRef((t, e) => {
  const { children: n, width: r = 10, height: i = 5, ...o } = t;
  return /* @__PURE__ */ R.jsx(
    Zt.svg,
    {
      ...o,
      ref: e,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: t.asChild ? n : /* @__PURE__ */ R.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Qw.displayName = wue;
var _ue = Qw, im = "Popper", [e_, t_] = Es(im), [Cue, n_] = e_(im), r_ = (t) => {
  const { __scopePopper: e, children: n } = t, [r, i] = C.useState(null);
  return /* @__PURE__ */ R.jsx(Cue, { scope: e, anchor: r, onAnchorChange: i, children: n });
};
r_.displayName = im;
var i_ = "PopperAnchor", o_ = C.forwardRef(
  (t, e) => {
    const { __scopePopper: n, virtualRef: r, ...i } = t, o = n_(i_, n), a = C.useRef(null), s = bn(e, a);
    return C.useEffect(() => {
      o.onAnchorChange((r == null ? void 0 : r.current) || a.current);
    }), r ? null : /* @__PURE__ */ R.jsx(Zt.div, { ...i, ref: s });
  }
);
o_.displayName = i_;
var om = "PopperContent", [Eue, Sue] = e_(om), a_ = C.forwardRef(
  (t, e) => {
    var J, se, be, pe, Ne, ae;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: i = 0,
      align: o = "center",
      alignOffset: a = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: f = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: v,
      ...g
    } = t, m = n_(om, n), [p, y] = C.useState(null), b = bn(e, (Re) => y(Re)), [x, _] = C.useState(null), M = bd(x), S = (M == null ? void 0 : M.width) ?? 0, P = (M == null ? void 0 : M.height) ?? 0, E = r + (o !== "center" ? "-" + o : ""), w = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, O = Array.isArray(c) ? c : [c], N = O.length > 0, I = {
      padding: w,
      boundary: O.filter(Tue),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: N
    }, { refs: H, floatingStyles: j, placement: U, isPositioned: $, middlewareData: V } = Jp({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: E,
      whileElementsMounted: (...Re) => Ud(...Re, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: m.anchor
      },
      middleware: [
        b8({ mainAxis: i + P, alignmentAxis: a }),
        l && x8({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? w8() : void 0,
          ...I
        }),
        l && Id({ ...I }),
        Xp({
          ...I,
          apply: ({ elements: Re, rects: F, availableWidth: Ge, availableHeight: $e }) => {
            const { width: he, height: ue } = F.reference, Se = Re.floating.style;
            Se.setProperty("--radix-popper-available-width", `${Ge}px`), Se.setProperty("--radix-popper-available-height", `${$e}px`), Se.setProperty("--radix-popper-anchor-width", `${he}px`), Se.setProperty("--radix-popper-anchor-height", `${ue}px`);
          }
        }),
        x && P8({ element: x, padding: s }),
        Aue({ arrowWidth: S, arrowHeight: P }),
        f && y8({ strategy: "referenceHidden", ...I })
      ]
    }), [te, B] = c_(U), Z = Cr(v);
    li(() => {
      $ && (Z == null || Z());
    }, [$, Z]);
    const Q = (J = V.arrow) == null ? void 0 : J.x, ce = (se = V.arrow) == null ? void 0 : se.y, k = ((be = V.arrow) == null ? void 0 : be.centerOffset) !== 0, [G, K] = C.useState();
    return li(() => {
      p && K(window.getComputedStyle(p).zIndex);
    }, [p]), /* @__PURE__ */ R.jsx(
      "div",
      {
        ref: H.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...j,
          transform: $ ? j.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: G,
          ["--radix-popper-transform-origin"]: [
            (pe = V.transformOrigin) == null ? void 0 : pe.x,
            (Ne = V.transformOrigin) == null ? void 0 : Ne.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((ae = V.hide) == null ? void 0 : ae.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: t.dir,
        children: /* @__PURE__ */ R.jsx(
          Eue,
          {
            scope: n,
            placedSide: te,
            onArrowChange: _,
            arrowX: Q,
            arrowY: ce,
            shouldHideArrow: k,
            children: /* @__PURE__ */ R.jsx(
              Zt.div,
              {
                "data-side": te,
                "data-align": B,
                ...g,
                ref: b,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: $ ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
a_.displayName = om;
var s_ = "PopperArrow", Mue = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, l_ = C.forwardRef(function(e, n) {
  const { __scopePopper: r, ...i } = e, o = Sue(s_, r), a = Mue[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ R.jsx(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ R.jsx(
          _ue,
          {
            ...i,
            ref: n,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
l_.displayName = s_;
function Tue(t) {
  return t !== null;
}
var Aue = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var m, p, y;
    const { placement: n, rects: r, middlewareData: i } = e, a = ((m = i.arrow) == null ? void 0 : m.centerOffset) !== 0, s = a ? 0 : t.arrowWidth, l = a ? 0 : t.arrowHeight, [c, u] = c_(n), d = { start: "0%", center: "50%", end: "100%" }[u], f = (((p = i.arrow) == null ? void 0 : p.x) ?? 0) + s / 2, h = (((y = i.arrow) == null ? void 0 : y.y) ?? 0) + l / 2;
    let v = "", g = "";
    return c === "bottom" ? (v = a ? d : `${f}px`, g = `${-l}px`) : c === "top" ? (v = a ? d : `${f}px`, g = `${r.floating.height + l}px`) : c === "right" ? (v = `${-l}px`, g = a ? d : `${h}px`) : c === "left" && (v = `${r.floating.width + l}px`, g = a ? d : `${h}px`), { data: { x: v, y: g } };
  }
});
function c_(t) {
  const [e, n = "center"] = t.split("-");
  return [e, n];
}
var Pue = r_, Rue = o_, Lue = a_, Oue = l_, Due = "VisuallyHidden", u_ = C.forwardRef(
  (t, e) => /* @__PURE__ */ R.jsx(
    Zt.span,
    {
      ...t,
      ref: e,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...t.style
      }
    }
  )
);
u_.displayName = Due;
var kue = u_, [xf, Fhe] = yd("Tooltip", [
  t_
]), wf = t_(), d_ = "TooltipProvider", Nue = 700, V1 = "tooltip.open", [Iue, am] = xf(d_), f_ = (t) => {
  const {
    __scopeTooltip: e,
    delayDuration: n = Nue,
    skipDelayDuration: r = 300,
    disableHoverableContent: i = !1,
    children: o
  } = t, [a, s] = C.useState(!0), l = C.useRef(!1), c = C.useRef(0);
  return C.useEffect(() => {
    const u = c.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ R.jsx(
    Iue,
    {
      scope: e,
      isOpenDelayed: a,
      delayDuration: n,
      onOpen: C.useCallback(() => {
        window.clearTimeout(c.current), s(!1);
      }, []),
      onClose: C.useCallback(() => {
        window.clearTimeout(c.current), c.current = window.setTimeout(
          () => s(!0),
          r
        );
      }, [r]),
      isPointerInTransitRef: l,
      onPointerInTransitChange: C.useCallback((u) => {
        l.current = u;
      }, []),
      disableHoverableContent: i,
      children: o
    }
  );
};
f_.displayName = d_;
var _f = "Tooltip", [Fue, Cf] = xf(_f), h_ = (t) => {
  const {
    __scopeTooltip: e,
    children: n,
    open: r,
    defaultOpen: i = !1,
    onOpenChange: o,
    disableHoverableContent: a,
    delayDuration: s
  } = t, l = am(_f, t.__scopeTooltip), c = wf(e), [u, d] = C.useState(null), f = Xa(), h = C.useRef(0), v = a ?? l.disableHoverableContent, g = s ?? l.delayDuration, m = C.useRef(!1), [p = !1, y] = $o({
    prop: r,
    defaultProp: i,
    onChange: (S) => {
      S ? (l.onOpen(), document.dispatchEvent(new CustomEvent(V1))) : l.onClose(), o == null || o(S);
    }
  }), b = C.useMemo(() => p ? m.current ? "delayed-open" : "instant-open" : "closed", [p]), x = C.useCallback(() => {
    window.clearTimeout(h.current), m.current = !1, y(!0);
  }, [y]), _ = C.useCallback(() => {
    window.clearTimeout(h.current), y(!1);
  }, [y]), M = C.useCallback(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      m.current = !0, y(!0);
    }, g);
  }, [g, y]);
  return C.useEffect(() => () => window.clearTimeout(h.current), []), /* @__PURE__ */ R.jsx(Pue, { ...c, children: /* @__PURE__ */ R.jsx(
    Fue,
    {
      scope: e,
      contentId: f,
      open: p,
      stateAttribute: b,
      trigger: u,
      onTriggerChange: d,
      onTriggerEnter: C.useCallback(() => {
        l.isOpenDelayed ? M() : x();
      }, [l.isOpenDelayed, M, x]),
      onTriggerLeave: C.useCallback(() => {
        v ? _() : window.clearTimeout(h.current);
      }, [_, v]),
      onOpen: x,
      onClose: _,
      disableHoverableContent: v,
      children: n
    }
  ) });
};
h_.displayName = _f;
var $1 = "TooltipTrigger", p_ = C.forwardRef(
  (t, e) => {
    const { __scopeTooltip: n, ...r } = t, i = Cf($1, n), o = am($1, n), a = wf(n), s = C.useRef(null), l = bn(e, s, i.onTriggerChange), c = C.useRef(!1), u = C.useRef(!1), d = C.useCallback(() => c.current = !1, []);
    return C.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ R.jsx(Rue, { asChild: !0, ...a, children: /* @__PURE__ */ R.jsx(
      Zt.button,
      {
        "aria-describedby": i.open ? i.contentId : void 0,
        "data-state": i.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: zt(t.onPointerMove, (f) => {
          f.pointerType !== "touch" && !u.current && !o.isPointerInTransitRef.current && (i.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: zt(t.onPointerLeave, () => {
          i.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: zt(t.onPointerDown, () => {
          c.current = !0, document.addEventListener("pointerup", d, { once: !0 });
        }),
        onFocus: zt(t.onFocus, () => {
          c.current || i.onOpen();
        }),
        onBlur: zt(t.onBlur, i.onClose),
        onClick: zt(t.onClick, i.onClose)
      }
    ) });
  }
);
p_.displayName = $1;
var Uue = "TooltipPortal", [Uhe, zue] = xf(Uue, {
  forceMount: void 0
}), us = "TooltipContent", m_ = C.forwardRef(
  (t, e) => {
    const n = zue(us, t.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...o } = t, a = Cf(us, t.__scopeTooltip);
    return /* @__PURE__ */ R.jsx(tm, { present: r || a.open, children: a.disableHoverableContent ? /* @__PURE__ */ R.jsx(v_, { side: i, ...o, ref: e }) : /* @__PURE__ */ R.jsx(Hue, { side: i, ...o, ref: e }) });
  }
), Hue = C.forwardRef((t, e) => {
  const n = Cf(us, t.__scopeTooltip), r = am(us, t.__scopeTooltip), i = C.useRef(null), o = bn(e, i), [a, s] = C.useState(null), { trigger: l, onClose: c } = n, u = i.current, { onPointerInTransitChange: d } = r, f = C.useCallback(() => {
    s(null), d(!1);
  }, [d]), h = C.useCallback(
    (v, g) => {
      const m = v.currentTarget, p = { x: v.clientX, y: v.clientY }, y = Wue(p, m.getBoundingClientRect()), b = jue(p, y), x = Gue(g.getBoundingClientRect()), _ = Xue([...b, ...x]);
      s(_), d(!0);
    },
    [d]
  );
  return C.useEffect(() => () => f(), [f]), C.useEffect(() => {
    if (l && u) {
      const v = (m) => h(m, u), g = (m) => h(m, l);
      return l.addEventListener("pointerleave", v), u.addEventListener("pointerleave", g), () => {
        l.removeEventListener("pointerleave", v), u.removeEventListener("pointerleave", g);
      };
    }
  }, [l, u, h, f]), C.useEffect(() => {
    if (a) {
      const v = (g) => {
        const m = g.target, p = { x: g.clientX, y: g.clientY }, y = (l == null ? void 0 : l.contains(m)) || (u == null ? void 0 : u.contains(m)), b = !que(p, a);
        y ? f() : b && (f(), c());
      };
      return document.addEventListener("pointermove", v), () => document.removeEventListener("pointermove", v);
    }
  }, [l, u, a, c, f]), /* @__PURE__ */ R.jsx(v_, { ...t, ref: o });
}), [Bue, Vue] = xf(_f, { isInside: !1 }), v_ = C.forwardRef(
  (t, e) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": i,
      onEscapeKeyDown: o,
      onPointerDownOutside: a,
      ...s
    } = t, l = Cf(us, n), c = wf(n), { onClose: u } = l;
    return C.useEffect(() => (document.addEventListener(V1, u), () => document.removeEventListener(V1, u)), [u]), C.useEffect(() => {
      if (l.trigger) {
        const d = (f) => {
          const h = f.target;
          h != null && h.contains(l.trigger) && u();
        };
        return window.addEventListener("scroll", d, { capture: !0 }), () => window.removeEventListener("scroll", d, { capture: !0 });
      }
    }, [l.trigger, u]), /* @__PURE__ */ R.jsx(
      Kw,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: o,
        onPointerDownOutside: a,
        onFocusOutside: (d) => d.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ R.jsxs(
          Lue,
          {
            "data-state": l.stateAttribute,
            ...c,
            ...s,
            ref: e,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ R.jsx(M7, { children: r }),
              /* @__PURE__ */ R.jsx(Bue, { scope: n, isInside: !0, children: /* @__PURE__ */ R.jsx(kue, { id: l.contentId, role: "tooltip", children: i || r }) })
            ]
          }
        )
      }
    );
  }
);
m_.displayName = us;
var g_ = "TooltipArrow", $ue = C.forwardRef(
  (t, e) => {
    const { __scopeTooltip: n, ...r } = t, i = wf(n);
    return Vue(
      g_,
      n
    ).isInside ? null : /* @__PURE__ */ R.jsx(Oue, { ...i, ...r, ref: e });
  }
);
$ue.displayName = g_;
function Wue(t, e) {
  const n = Math.abs(e.top - t.y), r = Math.abs(e.bottom - t.y), i = Math.abs(e.right - t.x), o = Math.abs(e.left - t.x);
  switch (Math.min(n, r, i, o)) {
    case o:
      return "left";
    case i:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function jue(t, e, n = 5) {
  const r = [];
  switch (e) {
    case "top":
      r.push(
        { x: t.x - n, y: t.y + n },
        { x: t.x + n, y: t.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: t.x - n, y: t.y - n },
        { x: t.x + n, y: t.y - n }
      );
      break;
    case "left":
      r.push(
        { x: t.x + n, y: t.y - n },
        { x: t.x + n, y: t.y + n }
      );
      break;
    case "right":
      r.push(
        { x: t.x - n, y: t.y - n },
        { x: t.x - n, y: t.y + n }
      );
      break;
  }
  return r;
}
function Gue(t) {
  const { top: e, right: n, bottom: r, left: i } = t;
  return [
    { x: i, y: e },
    { x: n, y: e },
    { x: n, y: r },
    { x: i, y: r }
  ];
}
function que(t, e) {
  const { x: n, y: r } = t;
  let i = !1;
  for (let o = 0, a = e.length - 1; o < e.length; a = o++) {
    const s = e[o].x, l = e[o].y, c = e[a].x, u = e[a].y;
    l > r != u > r && n < (c - s) * (r - l) / (u - l) + s && (i = !i);
  }
  return i;
}
function Xue(t) {
  const e = t.slice();
  return e.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), Yue(e);
}
function Yue(t) {
  if (t.length <= 1)
    return t.slice();
  const e = [];
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    for (; e.length >= 2; ) {
      const o = e[e.length - 1], a = e[e.length - 2];
      if ((o.x - a.x) * (i.y - a.y) >= (o.y - a.y) * (i.x - a.x))
        e.pop();
      else
        break;
    }
    e.push(i);
  }
  e.pop();
  const n = [];
  for (let r = t.length - 1; r >= 0; r--) {
    const i = t[r];
    for (; n.length >= 2; ) {
      const o = n[n.length - 1], a = n[n.length - 2];
      if ((o.x - a.x) * (i.y - a.y) >= (o.y - a.y) * (i.x - a.x))
        n.pop();
      else
        break;
    }
    n.push(i);
  }
  return n.pop(), e.length === 1 && n.length === 1 && e[0].x === n[0].x && e[0].y === n[0].y ? e : e.concat(n);
}
var Zue = f_, Kue = h_, Jue = p_, y_ = m_;
const zhe = Zue, Hhe = Kue, Bhe = Jue, Que = C.forwardRef(({ className: t, sideOffset: e = 4, ...n }, r) => /* @__PURE__ */ R.jsx(
  y_,
  {
    className: ve(
      "z-50",
      // 'overflow-hidden',
      // animation classes, not in use
      // 'animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
      t
    ),
    ref: r,
    sideOffset: e,
    ...n
  }
));
Que.displayName = y_.displayName;
function Vhe({
  children: t,
  roots: e,
  walker: n,
  getKey: r,
  expandedKeys: i,
  sortCmp: o = () => 0,
  onDragEnd: a = () => {
  },
  buffer: s = 0.5,
  draggableClassName: l,
  quickListProps: c,
  selected: u,
  onSelected: d,
  draggableThreshold: f = 3,
  multiSelectClassName: h,
  dragHandle: v,
  treeNodeClassName: g
}) {
  const m = On(), [p, y] = Ke(null), [b, x] = Ke(null), _ = b == null ? void 0 : b.getBoundingClientRect(), [M, S] = Ke(/* @__PURE__ */ new Set()), [P, E] = Ke(0), [w, O] = Ke(0), [N, I] = Ke([]), [H, j] = Ke(null), [U, $] = Ke(!1), [V, te] = Ke(!1), [B, Z] = Ke(null), [Q, ce] = Ke(!1), [k, G] = Ke({ x: 0, y: 0 }), [K, J] = Ke([]), [se, be] = Ke(!1);
  Dt(() => {
    Q && I(K);
  }, [K, Q]), Dt(() => {
    const he = () => {
      if (N.length && _ && p) {
        const ue = w + _.top + _.height, Se = 0.1 * _.height, we = Math.max(1, ue - _.top), D = Math.max(1, _.bottom - ue), T = 5;
        we < Se ? p.scrollBy(-T / we) : D < Se && p.scrollBy(T / D);
      }
      m.current = requestAnimationFrame(he);
    };
    return m.current = requestAnimationFrame(he), () => {
      m.current && cancelAnimationFrame(m.current);
    };
  }, [_, N, w, p]), Dt(() => {
    i && (i.length ? Re(i) : F());
  }, [i]);
  const pe = Gt((he) => {
    E(he.clientX), O(he.clientY);
  }, []), Ne = Gt(() => {
    N.length && H && a(N, H), I([]), j(null), J([]);
  }, [H, N, a]), ae = Gt((he, ue) => {
    S(he ? (Se) => new Set(Se).add(ue) : (Se) => {
      const we = new Set(Se);
      return we.delete(ue), we;
    });
  }, []), Re = (he) => {
    S((ue) => /* @__PURE__ */ new Set([...ue, ...he]));
  }, F = () => {
    S(/* @__PURE__ */ new Set());
  }, Ge = Pn(() => {
    const he = [], ue = e.map((Se) => [Se, 0]);
    for (o && ue.sort((Se, we) => o(Se[0], we[0])); ue.length > 0; ) {
      const Se = ue.pop();
      if (!Se)
        continue;
      const [we, D] = Se, T = r(we), Y = n(we), fe = Y.length === 0, de = M.has(T), ne = (Ce) => ae(Ce, T), Le = (Ce, Te) => {
        u && J([.../* @__PURE__ */ new Set([we, ...u])]), _ && (E(Ce - _.left), O(Te - _.top - _.height));
      };
      if (he.push({
        data: we,
        depth: D,
        isLeaf: fe,
        isOpen: de,
        dragTarget: N,
        dragDestination: H,
        setOpen: ne,
        startDrag: Le
      }), de) {
        Y.sort(o);
        for (const Ce of Y)
          ue.push([Ce, D + 1]);
      }
    }
    return he;
  }, [
    _,
    H,
    N,
    r,
    ae,
    M,
    e,
    u,
    o,
    n
  ]), $e = Gt(
    ({ index: he }) => {
      const ue = Ge[he], Se = () => {
        N.length && !(N != null && N.includes(ue.data)) && j(ue.data);
      }, we = () => {
        H === ue.data && j(null);
      }, D = (de) => {
        be(!0), ce(!1), G({ x: de.clientX, y: de.clientY });
      }, T = (de) => {
        if (se) {
          const ne = { x: de.clientX, y: de.clientY };
          Math.sqrt(
            Math.pow(ne.x - k.x, 2) + Math.pow(ne.y - k.y, 2)
          ) > f && ce(!0);
        } else
          ce(!1);
      }, Y = () => {
        be(!1), ce(!1);
      }, fe = (de) => {
        const ne = de.target;
        if (!(!u || !d || ne && typeof ne.className == "string" && ne.className.includes("skand-tree-row-override")))
          if (Z(he), V)
            u.includes(ue.data) ? d(u.filter((Le) => Le !== ue.data)) : d([...u, ue.data]);
          else if (U && B !== null) {
            const Le = Math.min(B, he), Ce = Math.max(B, he), Te = Ge.slice(Le, Ce + 1).map((ke) => ke.data);
            d([.../* @__PURE__ */ new Set([...u, ...Te])]);
          } else
            d([ue.data]);
      };
      return /* @__PURE__ */ R.jsx(
        "div",
        {
          className: ve(
            u && u.includes(ue.data) && !Q && h,
            g
          ),
          onClick: fe,
          onMouseDown: D,
          onMouseEnter: Se,
          onMouseLeave: we,
          onMouseMove: T,
          onMouseUp: Y,
          children: Array.isArray(t) ? t[0](ue) : t(ue)
        }
      );
    },
    [
      Ge,
      u,
      Q,
      h,
      g,
      t,
      N,
      H,
      se,
      k.x,
      k.y,
      f,
      d,
      V,
      U,
      B
    ]
  );
  return Dt(() => {
    const he = (Se) => {
      (Se.key === "Meta" || Se.key === "Control") && te(!0), Se.key === "Shift" && $(!0);
    }, ue = (Se) => {
      (Se.key === "Meta" || Se.key === "Control") && te(!1), Se.key === "Shift" && $(!1);
    };
    return window.addEventListener("keydown", he), window.addEventListener("keyup", ue), window.addEventListener("mousemove", pe), window.addEventListener("mouseup", Ne), () => {
      window.removeEventListener("keydown", he), window.removeEventListener("keyup", ue), window.removeEventListener("mousemove", pe), window.removeEventListener("mouseup", Ne);
    };
  }, [Ne, pe]), /* @__PURE__ */ R.jsxs("div", { className: "h-full select-none", ref: x, children: [
    /* @__PURE__ */ R.jsx(lce, { buffer: s, itemCount: Ge.length, ref: y, ...c, children: $e }),
    N.length !== 0 && _ && /* @__PURE__ */ R.jsx(
      "div",
      {
        className: ve(l, "absolute", "left-0", "top-0", "pointer-events-none"),
        style: {
          transform: `translate(${P - _.left}px, ${w - _.top}px)`
        },
        children: v ?? /* @__PURE__ */ R.jsx(R.Fragment, {})
      }
    )
  ] });
}
const $he = ({ url: t, close: e, type: n }) => /* @__PURE__ */ R.jsxs(Zse, { className: "m-4 max-h-screen max-w-screen overflow-hidden", children: [
  /* @__PURE__ */ R.jsxs("div", { className: ve("flex", "flex-col", "relative"), children: [
    /* @__PURE__ */ R.jsx(
      "div",
      {
        className: ve(
          "flex",
          "flex-row",
          "items-center gap-2",
          "justify-end",
          "absolute",
          "right-2",
          "top-2"
        ),
        children: /* @__PURE__ */ R.jsx(
          "div",
          {
            className: "z-20 h-28px w-28px flex items-center justify-center border-1px border-neutral-500 rounded-4px border-solid bg-neutral-100",
            onClick: e,
            children: /* @__PURE__ */ R.jsx("div", { className: "i-skand-close cursor-pointer text-12px color-neutral-600 hover:color-primary-400" })
          }
        )
      }
    ),
    /* @__PURE__ */ R.jsx("video", { controls: !0, width: "800", children: /* @__PURE__ */ R.jsx("source", { src: t, type: n }) })
  ] }),
  /* @__PURE__ */ R.jsx("div", {})
] }), ede = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7 5V0H5V5H0V7H5V12H7V7H12V5H7Z"
    fill="currentColor"
  />
</svg>
`, tde = `
<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M11.34 16.7831C11.599 16.7211 11.817 16.5491 11.937 16.3111L14.597 11.0921C14.775 10.7391 14.709 10.3131 14.429 10.0341L10.287 5.89214C10.008 5.61214 9.581 5.54614 9.23 5.72314L4.008 8.38314C3.773 8.50414 3.601 8.72114 3.538 8.98114L1 19.3201L11.34 16.7831Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M8.74149 11.5801L1.00049 19.3201" stroke="currentColor" stroke-width="1.685"
    stroke-linecap="round" stroke-linejoin="round" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M11.2599 2.1865L12.1799 1.2665C12.5349 0.911501 13.1139 0.911501 13.4689 1.2645L19.0539 6.8505C19.4089 7.2065 19.4089 7.7855 19.0539 8.1405L18.1339 9.0605C17.7789 9.4165 17.1979 9.4165 16.8429 9.0605L11.2579 3.4755C10.9039 3.1225 10.9039 2.5415 11.2599 2.1865Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, nde = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7.37109 11V10.1875H4.83984L5.94922 8.95312C6.13151 8.76823 6.29688 8.58724 6.44531 8.41016C6.59375 8.23307 6.72135 8.05859 6.82812 7.88672C6.9375 7.71224 7.02214 7.53646 7.08203 7.35938C7.14193 7.18229 7.17188 7.0026 7.17188 6.82031C7.17188 6.49219 7.10156 6.20964 6.96094 5.97266C6.82031 5.73568 6.61458 5.55339 6.34375 5.42578C6.07292 5.29557 5.74219 5.23047 5.35156 5.23047C4.95052 5.23047 4.60417 5.3138 4.3125 5.48047C4.02083 5.64714 3.79688 5.86979 3.64062 6.14844C3.48438 6.42448 3.40625 6.73047 3.40625 7.06641H4.44141C4.44141 6.86849 4.47526 6.69271 4.54297 6.53906C4.61328 6.38542 4.71484 6.26562 4.84766 6.17969C4.98307 6.09115 5.14583 6.04688 5.33594 6.04688C5.50781 6.04688 5.65234 6.08333 5.76953 6.15625C5.88932 6.22917 5.98047 6.33203 6.04297 6.46484C6.10547 6.59505 6.13672 6.7474 6.13672 6.92188C6.13672 7.04167 6.11198 7.16797 6.0625 7.30078C6.01562 7.43099 5.9362 7.57682 5.82422 7.73828C5.71224 7.89974 5.5599 8.08984 5.36719 8.30859L3.51953 10.3047V11H7.37109ZM9.29688 11H9.92188C10.3099 11 10.6628 10.9362 10.9805 10.8086C11.2982 10.681 11.5716 10.4987 11.8008 10.2617C12.0326 10.0247 12.2096 9.74089 12.332 9.41016C12.457 9.07682 12.5195 8.70703 12.5195 8.30078V8.01562C12.5195 7.60677 12.457 7.23698 12.332 6.90625C12.2096 6.57552 12.0326 6.29167 11.8008 6.05469C11.5716 5.8151 11.2995 5.63151 10.9844 5.50391C10.6719 5.3763 10.3255 5.3125 9.94531 5.3125H9.29688H8.67188H8.22266V11H8.69531H9.29688ZM9.29688 10.1562H9.92188C10.2526 10.1562 10.5299 10.0833 10.7539 9.9375C10.9779 9.78906 11.1471 9.57682 11.2617 9.30078C11.3763 9.02214 11.4336 8.6888 11.4336 8.30078V8.00781C11.4336 7.70833 11.401 7.44401 11.3359 7.21484C11.2708 6.98568 11.1745 6.79297 11.0469 6.63672C10.9219 6.48047 10.7669 6.36198 10.582 6.28125C10.3971 6.20052 10.1849 6.16016 9.94531 6.16016H9.29688V10.1562Z"
    fill="currentColor" />
</svg>
`, rde = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="8" cy="8" r="7.5" stroke="currentColor" />
  <path
    d="M7.37109 10.1875V11H3.51953V10.3047L5.36719 8.30859C5.5599 8.08984 5.71224 7.89974 5.82422 7.73828C5.9362 7.57682 6.01562 7.43099 6.0625 7.30078C6.11198 7.16797 6.13672 7.04167 6.13672 6.92188C6.13672 6.7474 6.10547 6.59505 6.04297 6.46484C5.98047 6.33203 5.88932 6.22917 5.76953 6.15625C5.65234 6.08333 5.50781 6.04688 5.33594 6.04688C5.14583 6.04688 4.98307 6.09115 4.84766 6.17969C4.71484 6.26562 4.61328 6.38542 4.54297 6.53906C4.47526 6.69271 4.44141 6.86849 4.44141 7.06641H3.40625C3.40625 6.73047 3.48438 6.42448 3.64062 6.14844C3.79688 5.86979 4.02083 5.64714 4.3125 5.48047C4.60417 5.3138 4.95052 5.23047 5.35156 5.23047C5.74219 5.23047 6.07292 5.29557 6.34375 5.42578C6.61458 5.55339 6.82031 5.73568 6.96094 5.97266C7.10156 6.20964 7.17188 6.49219 7.17188 6.82031C7.17188 7.0026 7.14193 7.18229 7.08203 7.35938C7.02214 7.53646 6.9375 7.71224 6.82812 7.88672C6.72135 8.05859 6.59375 8.23307 6.44531 8.41016C6.29688 8.58724 6.13151 8.76823 5.94922 8.95312L4.83984 10.1875H7.37109Z"
    fill="currentColor" />
  <path
    d="M9.92188 11H8.69531L8.70312 10.1562H9.92188C10.2526 10.1562 10.5299 10.0833 10.7539 9.9375C10.9779 9.78906 11.1471 9.57682 11.2617 9.30078C11.3763 9.02214 11.4336 8.6888 11.4336 8.30078V8.00781C11.4336 7.70833 11.401 7.44401 11.3359 7.21484C11.2708 6.98568 11.1745 6.79297 11.0469 6.63672C10.9219 6.48047 10.7669 6.36198 10.582 6.28125C10.3971 6.20052 10.1849 6.16016 9.94531 6.16016H8.67188V5.3125H9.94531C10.3255 5.3125 10.6719 5.3763 10.9844 5.50391C11.2995 5.63151 11.5716 5.8151 11.8008 6.05469C12.0326 6.29167 12.2096 6.57552 12.332 6.90625C12.457 7.23698 12.5195 7.60677 12.5195 8.01562V8.30078C12.5195 8.70703 12.457 9.07682 12.332 9.41016C12.2096 9.74089 12.0326 10.0247 11.8008 10.2617C11.5716 10.4987 11.2982 10.681 10.9805 10.8086C10.6628 10.9362 10.3099 11 9.92188 11ZM9.29688 5.3125V11H8.22266V5.3125H9.29688Z"
    fill="currentColor" />
</svg>
`, ide = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM5.23047 7.69922H4.64844V7.94531V8.25781V8.49609H5.23047C5.4362 8.49609 5.61328 8.52734 5.76172 8.58984C5.91276 8.65234 6.02865 8.75 6.10938 8.88281C6.1901 9.01562 6.23047 9.1888 6.23047 9.40234C6.23047 9.58203 6.19401 9.73698 6.12109 9.86719C6.04818 9.99479 5.94271 10.0938 5.80469 10.1641C5.66927 10.2318 5.50651 10.2656 5.31641 10.2656C5.14453 10.2656 4.98958 10.2318 4.85156 10.1641C4.71615 10.0938 4.60938 9.9974 4.53125 9.875C4.45573 9.7526 4.41797 9.61328 4.41797 9.45703H3.38281C3.38281 9.72786 3.4362 9.96615 3.54297 10.1719C3.64974 10.375 3.79427 10.5443 3.97656 10.6797C4.15885 10.8125 4.36328 10.9128 4.58984 10.9805C4.81901 11.0456 5.05469 11.0781 5.29688 11.0781C5.57552 11.0781 5.83464 11.0417 6.07422 10.9688C6.3138 10.8932 6.52214 10.7839 6.69922 10.6406C6.87891 10.4974 7.01823 10.3229 7.11719 10.1172C7.21615 9.90885 7.26562 9.67188 7.26562 9.40625C7.26562 9.20312 7.22786 9.01302 7.15234 8.83594C7.07943 8.65885 6.96615 8.50391 6.8125 8.37109C6.67241 8.24763 6.49769 8.15014 6.28833 8.07863C6.44938 8.00504 6.58895 7.91633 6.70703 7.8125C6.86068 7.67708 6.97656 7.52604 7.05469 7.35938C7.13542 7.1901 7.17578 7.02083 7.17578 6.85156C7.17578 6.4974 7.09635 6.20052 6.9375 5.96094C6.78125 5.72135 6.5612 5.54036 6.27734 5.41797C5.99609 5.29297 5.66797 5.23047 5.29297 5.23047C4.94922 5.23047 4.63802 5.29688 4.35938 5.42969C4.08073 5.5625 3.85938 5.74609 3.69531 5.98047C3.53385 6.21224 3.45312 6.48177 3.45312 6.78906H4.48828C4.48828 6.63542 4.52474 6.50391 4.59766 6.39453C4.67318 6.28255 4.77344 6.19661 4.89844 6.13672C5.02604 6.07682 5.16536 6.04688 5.31641 6.04688C5.50391 6.04688 5.65755 6.08073 5.77734 6.14844C5.89974 6.21354 5.99089 6.30729 6.05078 6.42969C6.11068 6.54948 6.14062 6.69141 6.14062 6.85547C6.14062 7.02214 6.10677 7.16927 6.03906 7.29688C5.97396 7.42188 5.8737 7.52083 5.73828 7.59375C5.60547 7.66406 5.4362 7.69922 5.23047 7.69922ZM9.29688 11H9.92188C10.3099 11 10.6628 10.9362 10.9805 10.8086C11.2982 10.681 11.5716 10.4987 11.8008 10.2617C12.0326 10.0247 12.2096 9.74089 12.332 9.41016C12.457 9.07682 12.5195 8.70703 12.5195 8.30078V8.01562C12.5195 7.60677 12.457 7.23698 12.332 6.90625C12.2096 6.57552 12.0326 6.29167 11.8008 6.05469C11.5716 5.8151 11.2995 5.63151 10.9844 5.50391C10.6719 5.3763 10.3255 5.3125 9.94531 5.3125H9.29688H8.67188H8.22266V11H8.69531H9.29688ZM9.29688 10.1562H9.92188C10.2526 10.1562 10.5299 10.0833 10.7539 9.9375C10.9779 9.78906 11.1471 9.57682 11.2617 9.30078C11.3763 9.02214 11.4336 8.6888 11.4336 8.30078V8.00781C11.4336 7.70833 11.401 7.44401 11.3359 7.21484C11.2708 6.98568 11.1745 6.79297 11.0469 6.63672C10.9219 6.48047 10.7669 6.36198 10.582 6.28125C10.3971 6.20052 10.1849 6.16016 9.94531 6.16016H9.29688V10.1562Z"
    fill="currentColor" />
</svg>
`, ode = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="8" cy="8" r="7.5" stroke="currentColor" />
  <path
    d="M4.64844 7.69922H5.23047C5.4362 7.69922 5.60547 7.66406 5.73828 7.59375C5.8737 7.52083 5.97396 7.42188 6.03906 7.29688C6.10677 7.16927 6.14062 7.02214 6.14062 6.85547C6.14062 6.69141 6.11068 6.54948 6.05078 6.42969C5.99089 6.30729 5.89974 6.21354 5.77734 6.14844C5.65755 6.08073 5.50391 6.04688 5.31641 6.04688C5.16536 6.04688 5.02604 6.07682 4.89844 6.13672C4.77344 6.19661 4.67318 6.28255 4.59766 6.39453C4.52474 6.50391 4.48828 6.63542 4.48828 6.78906H3.45312C3.45312 6.48177 3.53385 6.21224 3.69531 5.98047C3.85938 5.74609 4.08073 5.5625 4.35938 5.42969C4.63802 5.29688 4.94922 5.23047 5.29297 5.23047C5.66797 5.23047 5.99609 5.29297 6.27734 5.41797C6.5612 5.54036 6.78125 5.72135 6.9375 5.96094C7.09635 6.20052 7.17578 6.4974 7.17578 6.85156C7.17578 7.02083 7.13542 7.1901 7.05469 7.35938C6.97656 7.52604 6.86068 7.67708 6.70703 7.8125C6.55599 7.94531 6.36979 8.05339 6.14844 8.13672C5.92969 8.21745 5.67839 8.25781 5.39453 8.25781H4.64844V7.69922ZM4.64844 8.49609V7.94531H5.39453C5.71484 7.94531 5.99219 7.98307 6.22656 8.05859C6.46354 8.13151 6.65885 8.23568 6.8125 8.37109C6.96615 8.50391 7.07943 8.65885 7.15234 8.83594C7.22786 9.01302 7.26562 9.20312 7.26562 9.40625C7.26562 9.67188 7.21615 9.90885 7.11719 10.1172C7.01823 10.3229 6.87891 10.4974 6.69922 10.6406C6.52214 10.7839 6.3138 10.8932 6.07422 10.9688C5.83464 11.0417 5.57552 11.0781 5.29688 11.0781C5.05469 11.0781 4.81901 11.0456 4.58984 10.9805C4.36328 10.9128 4.15885 10.8125 3.97656 10.6797C3.79427 10.5443 3.64974 10.375 3.54297 10.1719C3.4362 9.96615 3.38281 9.72786 3.38281 9.45703H4.41797C4.41797 9.61328 4.45573 9.7526 4.53125 9.875C4.60938 9.9974 4.71615 10.0938 4.85156 10.1641C4.98958 10.2318 5.14453 10.2656 5.31641 10.2656C5.50651 10.2656 5.66927 10.2318 5.80469 10.1641C5.94271 10.0938 6.04818 9.99479 6.12109 9.86719C6.19401 9.73698 6.23047 9.58203 6.23047 9.40234C6.23047 9.1888 6.1901 9.01562 6.10938 8.88281C6.02865 8.75 5.91276 8.65234 5.76172 8.58984C5.61328 8.52734 5.4362 8.49609 5.23047 8.49609H4.64844Z"
    fill="currentColor" />
  <path
    d="M9.92188 11H8.69531L8.70312 10.1562H9.92188C10.2526 10.1562 10.5299 10.0833 10.7539 9.9375C10.9779 9.78906 11.1471 9.57682 11.2617 9.30078C11.3763 9.02214 11.4336 8.6888 11.4336 8.30078V8.00781C11.4336 7.70833 11.401 7.44401 11.3359 7.21484C11.2708 6.98568 11.1745 6.79297 11.0469 6.63672C10.9219 6.48047 10.7669 6.36198 10.582 6.28125C10.3971 6.20052 10.1849 6.16016 9.94531 6.16016H8.67188V5.3125H9.94531C10.3255 5.3125 10.6719 5.3763 10.9844 5.50391C11.2995 5.63151 11.5716 5.8151 11.8008 6.05469C12.0326 6.29167 12.2096 6.57552 12.332 6.90625C12.457 7.23698 12.5195 7.60677 12.5195 8.01562V8.30078C12.5195 8.70703 12.457 9.07682 12.332 9.41016C12.2096 9.74089 12.0326 10.0247 11.8008 10.2617C11.5716 10.4987 11.2982 10.681 10.9805 10.8086C10.6628 10.9362 10.3099 11 9.92188 11ZM9.29688 5.3125V11H8.22266V5.3125H9.29688Z"
    fill="currentColor" />
</svg>
`, ade = `
<svg width="13" height="19" viewBox="0 0 13 19" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M5.86959 14.7481L10.0876 12.3121C10.5656 12.0371 11.1776 12.2001 11.4536 12.6791L12.4566 14.4171C12.7326 14.8951 12.5686 15.5071 12.0916 15.7831L7.87359 18.2181C7.39459 18.4941 6.78359 18.3301 6.50759 17.8521L5.50459 16.1141C5.22759 15.6361 5.39159 15.0231 5.86959 14.7481Z"
    fill="black" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M5.86959 14.7481L10.0876 12.3121C10.5656 12.0371 11.1776 12.2001 11.4536 12.6791L12.4566 14.4171C12.7326 14.8951 12.5686 15.5071 12.0916 15.7831L7.87359 18.2181C7.39459 18.4941 6.78359 18.3301 6.50759 17.8521L5.50459 16.1141C5.22759 15.6361 5.39159 15.0231 5.86959 14.7481Z"
    stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M1.12651 10.3155L2.46851 11.0185C3.28951 11.4925 4.07651 12.1605 4.67851 12.8925L5.77051 14.3095L5.88351 14.4555L6.02551 14.3735L9.68451 12.2605L9.82651 12.1785L9.75651 12.0075L9.07551 10.3535C8.74251 9.4665 8.55751 8.4505 8.55851 7.5025L8.61951 5.9895L0.432512 0.250504L4.08951 6.5845C4.43951 6.4405 4.85051 6.5745 5.04451 6.9105C5.25651 7.2775 5.13051 7.7465 4.76451 7.9585C4.39751 8.1695 3.92851 8.0445 3.71651 7.6775C3.52251 7.3425 3.61051 6.9215 3.90751 6.6905L0.249512 0.355504L1.12651 10.3155Z"
    fill="black" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M1.12651 10.3155L2.46851 11.0185C3.28951 11.4925 4.07651 12.1605 4.67851 12.8925L5.77051 14.3095L5.88351 14.4555L6.02551 14.3735L9.68451 12.2605L9.82651 12.1785L9.75651 12.0075L9.07551 10.3535C8.74251 9.4665 8.55751 8.4505 8.55851 7.5025L8.61951 5.9895L0.432512 0.250504L4.08951 6.5845C4.43951 6.4405 4.85051 6.5745 5.04451 6.9105C5.25651 7.2775 5.13051 7.7465 4.76451 7.9585C4.39751 8.1695 3.92851 8.0445 3.71651 7.6775C3.52251 7.3425 3.61051 6.9215 3.90751 6.6905L0.249512 0.355504L1.12651 10.3155Z"
    stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, sde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="6" cy="6" r="5.5" stroke="currentColor" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M6.30005 9.30005C7.12848 9.30005 7.80005 8.62848 7.80005 7.80005C7.80005 6.97162 7.12848 6.30005 6.30005 6.30005C5.47162 6.30005 4.80005 6.97162 4.80005 7.80005C4.80005 8.62848 5.47162 9.30005 6.30005 9.30005ZM6.30005 10.3C7.68076 10.3 8.80005 9.18076 8.80005 7.80005C8.80005 6.41934 7.68076 5.30005 6.30005 5.30005C4.91934 5.30005 3.80005 6.41934 3.80005 7.80005C3.80005 9.18076 4.91934 10.3 6.30005 10.3Z"
    fill="currentColor" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M8.10246 6.06761C8.52175 5.80163 8.80005 5.33334 8.80005 4.80005C8.80005 3.97162 8.12848 3.30005 7.30005 3.30005C6.47162 3.30005 5.80005 3.97162 5.80005 4.80005C5.80005 4.98749 5.83443 5.16691 5.89723 5.33233C5.5578 5.38731 5.24127 5.51064 4.96223 5.68774C4.85743 5.41188 4.80005 5.11267 4.80005 4.80005C4.80005 3.41934 5.91934 2.30005 7.30005 2.30005C8.68076 2.30005 9.80005 3.41934 9.80005 4.80005C9.80005 5.68867 9.33642 6.469 8.63786 6.91236C8.5172 6.59474 8.33366 6.30809 8.10246 6.06761Z"
    fill="currentColor" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M5.18774 3.46223C4.91188 3.35743 4.61267 3.30005 4.30005 3.30005C2.91934 3.30005 1.80005 4.41934 1.80005 5.80005C1.80005 7.02428 2.68001 8.04299 3.84193 8.25817C3.81443 8.10965 3.80005 7.95653 3.80005 7.80005C3.80005 7.60597 3.82216 7.41706 3.86401 7.23569C3.24825 7.04891 2.80005 6.47682 2.80005 5.80005C2.80005 4.97162 3.47162 4.30005 4.30005 4.30005C4.48749 4.30005 4.66691 4.33443 4.83233 4.39723C4.88731 4.0578 5.01064 3.74127 5.18774 3.46223Z"
    fill="currentColor" />
</svg>
  
`, lde = `
<svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 9L7 15L13 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  <path d="M8 1.5C8 0.947715 7.55228 0.5 7 0.5C6.44772 0.5 6 0.947715 6 1.5H8ZM8 15V1.5H6V15H8Z"
    fill="currentColor" />
</svg>
  
`, cde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.552734 3.37915V8.87832L5.77358 11.4768V6.27981L0.552734 3.37915Z"
    stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M5.77368 11.4768L11.4486 8.59919V3.42871L5.77368 6.27977" stroke="currentColor"
    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M11.4488 3.37919L6.12547 0.561398L0.552734 3.37919" stroke="currentColor"
    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M0.574962 6.2182L5.81915 8.94787" stroke="currentColor" />
  <path d="M5.71935 8.98092L11.5418 6.01396" stroke="currentColor" />
  <path d="M3.07304 4.82952L3.07304 10.1947" stroke="currentColor" />
  <path d="M8.68019 4.93348L8.68059 10.0908" stroke="currentColor" />
</svg>
`, ude = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M2 0C0.895431 0 0 0.895431 0 2V10C0 11.1046 0.895431 12 2 12H10C11.1046 12 12 11.1046 12 10V2C12 0.895431 11.1046 0 10 0H2ZM10.3841 3.32009C10.5609 3.10795 10.5322 2.79267 10.3201 2.61589C10.108 2.43911 9.79267 2.46777 9.61589 2.67991L4.9664 8.25929L2.35355 5.64645C2.15829 5.45118 1.84171 5.45118 1.64645 5.64645C1.45118 5.84171 1.45118 6.15829 1.64645 6.35355L4.64645 9.35355C4.74578 9.45289 4.88232 9.50585 5.02266 9.49949C5.16299 9.49312 5.29418 9.42801 5.38411 9.32009L10.3841 3.32009Z"
    fill="currentColor" />
</svg>
  
`, dde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="0.5" y="0.5" width="11" height="11" rx="1.5" stroke="currentColor" />
</svg>
  
`, fde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M8.63499 4.86187C8.63499 6.31667 7.45536 7.4962 5.99999 7.4962C4.54462 7.4962 3.36499 6.31667 3.36499 4.86187C3.36499 3.40707 4.54462 2.22754 5.99999 2.22754C7.45536 2.22754 8.63499 3.40707 8.63499 4.86187Z"
    stroke="currentColor" />
  <path
    d="M0.112043 11.159C-0.0582731 11.3764 -0.0201329 11.6907 0.197231 11.861C0.414595 12.0313 0.728872 11.9932 0.899188 11.7758L0.112043 11.159ZM0.899188 11.7758L4.56484 7.09754L3.77769 6.48077L0.112043 11.159L0.899188 11.7758Z"
    fill="currentColor" />
  <path
    d="M0.618956 8.7915C0.618956 8.7915 4.26286 9.97054 7.185 9.44057C10.1071 8.9106 10.8333 5.55984 10.9686 4.7127"
    stroke="currentColor" stroke-linecap="round" />
  <path
    d="M11.1 11.7744C11.2696 11.9924 11.5837 12.0316 11.8017 11.862C12.0196 11.6925 12.0588 11.3783 11.8893 11.1604L11.1 11.7744ZM11.8893 11.1604L8.24958 6.48213L7.46032 7.09618L11.1 11.7744L11.8893 11.1604Z"
    fill="currentColor" />
  <path
    d="M6.5 0.532593C6.5 0.25645 6.27614 0.0325928 6 0.0325928C5.72386 0.0325928 5.5 0.25645 5.5 0.532593L6.5 0.532593ZM5.5 0.532593V2.13769H6.5V0.532593L5.5 0.532593Z"
    fill="currentColor" />
</svg>
`, hde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2 6H5H10" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, pde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2 6L5 9L10 3" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, mde = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.50629 12.4H0.736328V8" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M8.50629 7.92H0.736328L5.88904 4H10.96" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M10.469 7.11575L13.6973 4.40001V8.45807L10.469 11.6" stroke="currentColor"
    stroke-width="0.4"
    stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="1.2 1.2" />
  <path d="M15.2126 9.606L8.66943 15.2V6.01595L15.2126 0.800003V9.606Z" stroke="currentColor"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>
  
`, vde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11 1L1 11" stroke="currentColor" stroke-width="1.685" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M1 1L11 11" stroke="currentColor" stroke-width="1.685" stroke-linecap="round"
    stroke-linejoin="round" />
</svg>
`, gde = `
<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.33341 1.66667L1.66675 8.33334" stroke="currentColor" stroke-width="1.685"
    stroke-linecap="round" stroke-linejoin="round" />
  <path d="M1.66675 1.66667L8.33341 8.33334" stroke="currentColor" stroke-width="1.685"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, yde = `
<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="2" cy="14" r="2" transform="rotate(-90 2 14)" fill="#4CB176" />
  <circle cx="8" cy="14" r="2" transform="rotate(-90 8 14)" fill="#8A858E" />
  <circle cx="2" cy="2" r="2" transform="rotate(-90 2 2)" fill="#D04A6B" />
  <circle cx="8" cy="2" r="2" transform="rotate(-90 8 2)" fill="#3F8AE2" />
  <circle cx="8" cy="8" r="2" transform="rotate(-90 8 8)" fill="#8A1AE3" />
  <circle cx="2" cy="8" r="2" transform="rotate(-90 2 8)" fill="#F69C64" />
</svg>
`, bde = `
<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M2.5 12C2.5 12.2761 2.27614 12.5 2 12.5C1.72386 12.5 1.5 12.2761 1.5 12H2.5ZM2 6H1.5C1.5 5.72386 1.72386 5.5 2 5.5V6ZM10.3536 5.64645C10.5488 5.84171 10.5488 6.15829 10.3536 6.35355L7.17157 9.53553C6.97631 9.7308 6.65973 9.7308 6.46447 9.53553C6.2692 9.34027 6.2692 9.02369 6.46447 8.82843L9.29289 6L6.46447 3.17157C6.2692 2.97631 6.2692 2.65973 6.46447 2.46447C6.65973 2.2692 6.97631 2.2692 7.17157 2.46447L10.3536 5.64645ZM1.5 12V6H2.5V12H1.5ZM2 5.5H10V6.5H2V5.5Z"
    fill="currentColor" />
</svg>
  
`, xde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.75 0H2.25V1.5H2C0.895431 1.5 0 2.39543 0 3.5V9.25C0 10.3546 0.895431 11.25 2 11.25H10C11.1046 11.25 12 10.3546 12 9.25V3.5C12 2.39543 11.1046 1.5 10 1.5H9.75V0H8.25V1.5H3.75V0ZM2 2.5H10C10.5523 2.5 11 2.94772 11 3.5V4.5H1V3.5C1 2.94772 1.44772 2.5 2 2.5ZM1 5.25V9.25C1 9.80228 1.44772 10.25 2 10.25H10C10.5523 10.25 11 9.80229 11 9.25V5.25H1Z"
    fill="currentColor"
  />
</svg>
`, wde = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.00073 9.19987L7.88266 15.0842L17.9918 4.99235" stroke="currentColor" stroke-width="2"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, _de = `
<svg width="16" height="16" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.1379 9.39111L7.98058 12.5484L4.82324 9.39111" stroke="currentColor"
    stroke-width="1.685"
    stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M15.0729 12.9129V15.3502C15.0729 15.8391 14.6729 16.2391 14.184 16.2391H1.7778C1.28892 16.2391 0.888916 15.8391 0.888916 15.3502V12.9129"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M7.99303 12.4158V1.74915" stroke="currentColor" stroke-width="1.685"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>
  
`, Cde = `
<svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 1L7 7L13 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
</svg>
`, Ede = `
<svg
  width="12"
  height="6"
  viewBox="0 0 12 6"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M0.135182 0.121919C0.315423 -0.0406395 0.607653 -0.0406395 0.787895 0.121919L6 4.82265L11.2121 0.121919C11.3923 -0.0406395 11.6846 -0.0406395 11.8648 0.121919C12.0451 0.284477 12.0451 0.548035 11.8648 0.710593L6 6L0.135182 0.710593C-0.0450605 0.548035 -0.0450605 0.284477 0.135182 0.121919Z"
    fill="currentColor"
  />
</svg>
`, Sde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M5.31023 0.92951C5.46923 0.692623 5.72614 0.552002 5.99996 0.552002C6.27377 0.552002 6.53068 0.692623 6.68968 0.92951L11.2518 7.72669C11.3836 7.92318 11.4545 8.15849 11.4545 8.39978V8.4611C11.4545 8.93509 11.1829 9.36138 10.7688 9.53741L6.40512 11.3921C6.14505 11.5026 5.85486 11.5026 5.59479 11.3921L1.23117 9.53741C0.816992 9.36138 0.54541 8.93509 0.54541 8.4611V8.39978C0.54541 8.15849 0.616281 7.92318 0.748145 7.72669L5.31023 0.92951Z"
    stroke="currentColor" stroke-linejoin="round" />
  <path d="M6 11.2745V0.552002" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, Mde = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.30194 0.699951V3.27625C5.30194 3.77169 4.90169 4.06895 4.50145 4.06895H1.7998L5.30194 0.699951Z" fill="currentColor"/>
<path d="M4.80176 6.94312H10.5052" stroke="currentColor" stroke-width="0.6" stroke-linecap="round"/>
<path d="M4.80176 9.32007H10.5052" stroke="currentColor" stroke-width="0.6" stroke-linecap="round"/>
<path d="M4.80176 11.7976H10.5052" stroke="currentColor" stroke-width="0.6" stroke-linecap="round"/>
<path d="M1.7998 3.67361V14.7715C1.7998 15.2669 2.20005 15.5642 2.60029 15.5642H12.7064C13.2067 15.5642 13.5069 15.1678 13.5069 14.7715V1.59275C13.5069 1.1964 13.1067 0.800049 12.7064 0.800049H4.90169L1.7998 3.67361Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.50202 15.5627L4.40196 16.1573C4.3019 16.5536 4.60208 17.0491 5.00233 17.1482L14.9084 19.1299C15.3086 19.229 15.8089 18.9317 15.909 18.5354L18.5105 5.65392C18.6106 5.25756 18.3104 4.76212 17.9102 4.66303L13.6076 3.77124" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`, Tde = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_303_16378)">
    <path
      d="M1 6.51126V3.45695C1.0015 2.98724 1.19001 2.53721 1.52437 2.20508C1.85874 1.87295 2.3118 1.68569 2.78466 1.6842H9.20681C9.67966 1.68569 10.1327 1.87295 10.4671 2.20508C10.8015 2.53721 10.99 2.98724 10.9915 3.45695V4.68771H16.8118C17.3917 4.6892 17.9474 4.91868 18.3574 5.32598C18.7675 5.73329 18.9985 6.28528 19 6.86129V15.4616C18.9985 16.1909 18.7066 16.8899 18.188 17.4061C17.6694 17.9223 16.9662 18.2137 16.2321 18.2167H3.7736C3.03892 18.2137 2.3352 17.9225 1.8157 17.4065C1.2962 16.8904 1.00299 16.1914 1 15.4616V6.51126Z"
      stroke="currentColor" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M17.9412 8H1" stroke="currentColor" stroke-width="1.68" stroke-linecap="round"
      stroke-linejoin="round" />
  </g>
  <defs>
    <clipPath id="clip0_303_16378">
      <rect width="20" height="20" fill="white" />
    </clipPath>
  </defs>
</svg>
`, Ade = `
<svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.875 1V11.984" stroke="currentColor" stroke-width="1.685" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M6.875 1.94238H15.434L13.605 4.21638L15.434 6.49238H6.875" stroke="currentColor"
    stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M16.627 10.4922C18.284 10.9952 19.309 11.6902 19.309 12.4592C19.309 13.9942 15.21 15.2402 10.154 15.2402C5.099 15.2402 1 13.9942 1 12.4592C1 11.7092 1.976 11.0292 3.563 10.5282"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, Pde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_20009_8958)">
        <path
            d="M3.82388 10.4362C3.89111 10.387 3.95983 10.331 4.02739 10.2674C4.34862 9.96508 4.50896 9.65873 4.61307 9.45984L4.61682 9.45266L4.61684 9.45262L4.62287 9.4411L3.82388 10.4362ZM3.82388 10.4362C3.82672 10.4384 3.82959 10.4407 3.83249 10.4429C4.03167 10.5986 4.31449 10.7635 4.67571 10.9149C5.39703 11.2172 6.39063 11.4483 7.55343 11.4591C8.72364 11.4699 9.75969 11.2661 10.4848 10.9487C10.848 10.7897 11.1113 10.6118 11.2772 10.4383C11.4407 10.2675 11.49 10.1239 11.4904 10.0114C11.4908 9.89895 11.4424 9.75449 11.2801 9.5806C11.1154 9.40404 10.8533 9.22129 10.4912 9.05561C9.76889 8.72507 8.73546 8.50225 7.56652 8.49105L7.56396 8.49106L7.5465 8.4912C7.53072 8.49135 7.50685 8.49166 7.47584 8.49226C7.41377 8.49347 7.32326 8.49587 7.21177 8.50063C6.98819 8.51018 6.68318 8.52909 6.35548 8.56634C6.02609 8.60379 5.68379 8.65867 5.38231 8.73763C5.1474 8.79915 4.96369 8.86871 4.83443 8.93971C4.82552 8.96375 4.81585 8.98958 4.80561 9.01652C4.75829 9.14089 4.68907 9.31471 4.6229 9.44104L3.82388 10.4362Z"
            stroke="currentColor" />
        <path
            d="M8.95225 6.16775C8.36495 6.78957 7.68688 7.18275 7.08537 7.33311C6.47744 7.48507 6.02015 7.37824 5.75004 7.12414C5.47993 6.87004 5.34608 6.42076 5.46219 5.80614C5.57708 5.19801 5.93033 4.49927 6.51764 3.87745C7.10495 3.25564 7.78301 2.86245 8.38452 2.7121C8.99245 2.56014 9.44974 2.66697 9.71985 2.92107C9.98996 3.17517 10.1238 3.62444 10.0077 4.23907C9.89281 4.8472 9.53956 5.54594 8.95225 6.16775Z"
            stroke="currentColor" />
        <path
            d="M3.23115 3.27895C2.40774 3.27133 1.68745 3.07063 1.19055 2.77817C0.680603 2.47803 0.492823 2.14282 0.493711 1.87912C0.494599 1.61541 0.684624 1.2837 1.19656 0.993019C1.6954 0.709773 2.417 0.522424 3.2404 0.530046C4.06381 0.537668 4.7841 0.738363 5.281 1.03083C5.79095 1.33097 5.97873 1.66617 5.97784 1.92988C5.97695 2.19359 5.78693 2.5253 5.27499 2.81598C4.77615 3.09922 4.05455 3.28657 3.23115 3.27895Z"
            stroke="currentColor" />
        <path
            d="M5.02998 7.58628C5.03701 8.50419 4.76839 9.31799 4.35288 9.89187C3.93723 10.4659 3.39996 10.7728 2.84958 10.7781C2.2992 10.7835 1.75731 10.487 1.33293 9.92103C0.908689 9.35527 0.627646 8.54678 0.620617 7.62886C0.613587 6.71095 0.882205 5.89715 1.29772 5.32327C1.71336 4.74921 2.25064 4.44231 2.80102 4.437C3.3514 4.43168 3.89329 4.72815 4.31767 5.29411C4.74191 5.85987 5.02295 6.66836 5.02998 7.58628Z"
            stroke="currentColor" />
    </g>
    <defs>
        <clipPath id="clip0_20009_8958">
            <rect width="12" height="12" fill="white" />
        </clipPath>
    </defs>
</svg>
`, Rde = `
<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M12.606 4.1C13.174 4.268 13.814 4.128 14.262 3.68C14.915 3.028 15.972 3.028 16.625 3.68L16.627 3.683C17.28 4.335 17.28 5.393 16.627 6.045C16.179 6.493 16.039 7.133 16.208 7.701L16.169 7.608C16.452 8.128 17.003 8.482 17.637 8.482C18.559 8.482 19.307 9.229 19.307 10.152V10.157C19.307 11.079 18.559 11.827 17.637 11.827C17.003 11.827 16.452 12.18 16.169 12.701L16.208 12.607C16.04 13.176 16.179 13.815 16.627 14.264C17.28 14.916 17.28 15.974 16.627 16.626L16.625 16.629C15.972 17.281 14.915 17.281 14.263 16.629C13.814 16.181 13.174 16.041 12.606 16.209L12.7 16.17C12.179 16.453 11.826 17.005 11.826 17.639C11.826 18.56 11.078 19.308 10.156 19.308H10.151C9.229 19.308 8.481 18.56 8.481 17.639C8.481 17.005 8.127 16.453 7.607 16.17L7.7 16.209C7.132 16.041 6.493 16.181 6.044 16.629C5.392 17.281 4.335 17.281 3.682 16.629L3.679 16.626C3.027 15.974 3.027 14.916 3.679 14.265C4.127 13.816 4.267 13.176 4.099 12.608L4.137 12.701C3.855 12.181 3.303 11.827 2.669 11.827C1.747 11.827 1 11.079 1 10.157V10.152C1 9.23 1.747 8.482 2.669 8.482C3.303 8.482 3.855 8.129 4.137 7.608L4.099 7.702C4.267 7.134 4.127 6.494 3.678 6.045C3.026 5.393 3.026 4.336 3.678 3.683L3.682 3.68C4.334 3.028 5.391 3.028 6.044 3.68C6.492 4.129 7.131 4.269 7.7 4.1L7.607 4.139C8.127 3.856 8.481 3.305 8.481 2.671C8.481 1.748 9.228 1 10.151 1H10.155C11.078 1 11.825 1.748 11.825 2.671C11.825 3.305 12.178 3.856 12.699 4.139L12.606 4.1Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M12.1528 10.1542C12.1528 11.2582 11.2568 12.1542 10.1528 12.1542C9.04883 12.1542 8.15283 11.2582 8.15283 10.1542C8.15283 9.05021 9.04883 8.15421 10.1528 8.15421C11.2568 8.15421 12.1528 9.05021 12.1528 10.1542"
    fill="currentColor" />
</svg>
`, Lde = `
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M27.0005 31.0003H5.00049C2.79049 31.0003 1.00049 29.2093 1.00049 27.0003V5.00031C1.00049 2.79131 2.79049 1.00031 5.00049 1.00031H27.0005C29.2095 1.00031 31.0005 2.79131 31.0005 5.00031V27.0003C31.0005 29.2093 29.2095 31.0003 27.0005 31.0003"
    stroke="currentColor" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M18.606 10.1C19.174 10.268 19.814 10.128 20.262 9.68C20.915 9.028 21.972 9.028 22.625 9.68L22.627 9.683C23.28 10.335 23.28 11.393 22.627 12.045C22.179 12.493 22.039 13.133 22.208 13.701L22.169 13.608C22.452 14.128 23.003 14.482 23.637 14.482C24.559 14.482 25.307 15.229 25.307 16.152V16.157C25.307 17.079 24.559 17.827 23.637 17.827C23.003 17.827 22.452 18.18 22.169 18.701L22.208 18.607C22.04 19.176 22.179 19.815 22.627 20.264C23.28 20.916 23.28 21.974 22.627 22.626L22.625 22.629C21.972 23.281 20.915 23.281 20.263 22.629C19.814 22.181 19.174 22.041 18.606 22.209L18.7 22.17C18.179 22.453 17.826 23.005 17.826 23.639C17.826 24.56 17.078 25.308 16.156 25.308H16.151C15.229 25.308 14.481 24.56 14.481 23.639C14.481 23.005 14.127 22.453 13.607 22.17L13.7 22.209C13.132 22.041 12.493 22.181 12.044 22.629C11.392 23.281 10.335 23.281 9.682 22.629L9.679 22.626C9.027 21.974 9.027 20.916 9.679 20.265C10.127 19.816 10.267 19.176 10.099 18.608L10.137 18.701C9.855 18.181 9.303 17.827 8.669 17.827C7.747 17.827 7 17.079 7 16.157V16.152C7 15.23 7.747 14.482 8.669 14.482C9.303 14.482 9.855 14.129 10.137 13.608L10.099 13.702C10.267 13.134 10.127 12.494 9.678 12.045C9.026 11.393 9.026 10.336 9.678 9.683L9.682 9.68C10.334 9.028 11.391 9.028 12.044 9.68C12.492 10.129 13.131 10.269 13.7 10.1L13.607 10.139C14.127 9.856 14.481 9.305 14.481 8.671C14.481 7.748 15.228 7 16.151 7H16.155C17.078 7 17.825 7.748 17.825 8.671C17.825 9.305 18.178 9.856 18.699 10.139L18.606 10.1Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M18.1528 16.1542C18.1528 17.2582 17.2568 18.1542 16.1528 18.1542C15.0488 18.1542 14.1528 17.2582 14.1528 16.1542C14.1528 15.0502 15.0488 14.1542 16.1528 14.1542C17.2568 14.1542 18.1528 15.0502 18.1528 16.1542Z"
    fill="currentColor" />
</svg>
`, Ode = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6ZM12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM5.53292 6.91992H6.5332C6.53599 6.70787 6.56529 6.52093 6.62109 6.3591C6.6769 6.19727 6.78432 6.0452 6.94336 5.9029C7.12472 5.7327 7.29353 5.5639 7.44978 5.39648C7.60603 5.22907 7.73158 5.04911 7.82645 4.85659C7.92132 4.66127 7.96875 4.44085 7.96875 4.19531C7.96875 3.85212 7.8962 3.55915 7.75112 3.31641C7.60882 3.07366 7.40095 2.88951 7.12751 2.76395C6.85686 2.6356 6.53041 2.57143 6.14816 2.57143C5.80218 2.57143 5.48968 2.63281 5.21066 2.75558C4.93164 2.87556 4.70982 3.05831 4.5452 3.30385C4.38058 3.5466 4.29408 3.85073 4.28571 4.21624H5.39481C5.40039 4.04046 5.43806 3.89816 5.50781 3.78934C5.57757 3.67773 5.66964 3.59542 5.78404 3.54241C5.89844 3.4894 6.01981 3.46289 6.14816 3.46289C6.30441 3.46289 6.43415 3.49358 6.53739 3.55497C6.64341 3.61356 6.72294 3.70006 6.77595 3.81445C6.83175 3.92885 6.85965 4.07115 6.85965 4.24135C6.85965 4.39202 6.83036 4.52734 6.77176 4.64732C6.71317 4.76451 6.63225 4.87751 6.52902 4.98633C6.42857 5.09235 6.31417 5.20536 6.18583 5.32534C6.024 5.47879 5.89565 5.62946 5.80078 5.77734C5.70591 5.92243 5.63756 6.08566 5.5957 6.26702C5.55664 6.44838 5.53571 6.66602 5.53292 6.91992ZM5.5957 7.80301C5.4841 7.91462 5.42829 8.05413 5.42829 8.22154C5.42829 8.38337 5.4841 8.52009 5.5957 8.6317C5.7101 8.7433 5.86356 8.79911 6.05608 8.79911C6.2486 8.79911 6.40067 8.7433 6.51228 8.6317C6.62667 8.52009 6.68387 8.38337 6.68387 8.22154C6.68387 8.05413 6.62667 7.91462 6.51228 7.80301C6.40067 7.69141 6.2486 7.6356 6.05608 7.6356C5.86356 7.6356 5.7101 7.69141 5.5957 7.80301Z"
    fill="currentColor"
  />
</svg>
`, Dde = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_287_10475)">
    <path d="M5.12087 5.12097C3.32743 6.38318 1.86193 8.05607 0.84668 10" stroke="currentColor"
      stroke-width="1.69" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M19.1532 9.99999C16.996 6.07862 13.6996 3.56854 10 3.56854C9.01532 3.56887 8.03873 3.74643 7.11694 4.09274"
      stroke="currentColor" stroke-width="1.69" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M16.5422 13.5181C17.5755 12.4756 18.4547 11.291 19.1531 10" stroke="currentColor"
      stroke-width="1.69" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M0.84668 10C3.00394 13.9214 6.30031 16.4314 9.99991 16.4314C11.7455 16.417 13.446 15.8759 14.8789 14.879"
      stroke="currentColor" stroke-width="1.69" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M11.8749 11.875C11.63 12.123 11.3379 12.3194 11.0159 12.4527C10.6939 12.586 10.3484 12.6535 9.9999 12.6512C9.29676 12.6512 8.62241 12.3719 8.12521 11.8747C7.62801 11.3775 7.34869 10.7031 7.34869 10C7.34638 9.65148 7.41386 9.30602 7.54717 8.984C7.68049 8.66198 7.87692 8.3699 8.1249 8.125"
      stroke="currentColor" stroke-width="1.69" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M10.3628 7.36896C10.9144 7.44404 11.4284 7.69088 11.8319 8.07446C12.2354 8.45805 12.5079 8.95892 12.6108 9.50605"
      stroke="currentColor" stroke-width="1.69" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M0.84668 0.846802L14.8789 14.8791L19.1531 19.1533" stroke="currentColor"
      stroke-width="1.69"
      stroke-linecap="round" stroke-linejoin="round" />
  </g>
  <defs>
    <clipPath id="clip0_287_10475">
      <rect width="20" height="20" fill="white" />
    </clipPath>
  </defs>
</svg>
`, kde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="path-1-inside-1_19958_8819" fill="white">
    <path d="M0 3.6C0 3.26863 0.268629 3 0.6 3H3.79297V12H0.6C0.268629 12 0 11.7314 0 11.4V3.6Z" />
  </mask>
  <path
    d="M-1 3.6C-1 2.71634 -0.283656 2 0.6 2H3.79297V4H1L-1 3.6ZM3.79297 13H0.6C-0.283656 13 -1 12.2836 -1 11.4L1 11H3.79297V13ZM0.6 13C-0.283656 13 -1 12.2836 -1 11.4V3.6C-1 2.71634 -0.283656 2 0.6 2L1 4V11L0.6 13ZM3.79297 3V12V3Z"
    fill="currentColor" mask="url(#path-1-inside-1_19958_8819)" />
  <mask id="path-3-inside-2_19958_8819" fill="white">
    <path
      d="M3.79297 0.6C3.79297 0.268629 4.0616 0 4.39297 0H11.4001C11.7314 0 12.0001 0.268629 12.0001 0.6V11.4C12.0001 11.7314 11.7314 12 11.4001 12H3.79297V0.6Z" />
  </mask>
  <path
    d="M3.79297 0.6C3.79297 0.268629 4.0616 0 4.39297 0H11.4001C11.7314 0 12.0001 0.268629 12.0001 0.6V11.4C12.0001 11.7314 11.7314 12 11.4001 12H3.79297V0.6Z"
    stroke="currentColor" stroke-width="2" mask="url(#path-3-inside-2_19958_8819)" />
  <line x1="4" y1="2.496" x2="12" y2="2.496" stroke="currentColor" stroke-width="1.008" />
  <line x1="4" y1="5.496" x2="12" y2="5.496" stroke="currentColor" stroke-width="1.008" />
  <line x1="4" y1="8.496" x2="12" y2="8.496" stroke="currentColor" stroke-width="1.008" />
  <line x1="7.8959" y1="12" x2="7.8959" y2="2.68227" stroke="currentColor" stroke-width="1.008" />
  <line y1="5.5" x2="5" y2="5.5" stroke="currentColor" />
  <line y1="8.49646" x2="5" y2="8.49646" stroke="currentColor" />
</svg>
`, Nde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_311_660)">
    <path
      d="M11.2398 11.5176H3.34677C3.21843 11.5176 3.09009 11.397 3.09009 11.2764V2.83416C3.09009 2.71356 3.21843 2.59296 3.34677 2.59296H11.2398C11.3682 2.59296 11.4965 2.71356 11.4965 2.83416V11.2764C11.4965 11.397 11.3682 11.5176 11.2398 11.5176Z"
      stroke="currentColor" stroke-width="1.008" stroke-miterlimit="10" />
    <path d="M3.70703 11.5176L6.14432 7.3804L8.32996 11.5176" stroke="currentColor"
      stroke-linecap="round" stroke-linejoin="round" />
    <path d="M10.8795 11.3339L8.35839 7.8259L7.43927 9.15496" stroke="currentColor"
      stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M9.46621 6.91983C9.74175 6.91983 9.96513 6.69597 9.96513 6.41983C9.96513 6.14369 9.74175 5.91983 9.46621 5.91983C9.19066 5.91983 8.96729 6.14369 8.96729 6.41983C8.96729 6.69597 9.19066 6.91983 9.46621 6.91983Z"
      stroke="currentColor" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M3.01604 9.46733H0.770051C0.641709 9.46733 0.513367 9.34673 0.513367 9.22613V0.783914C0.513367 0.60301 0.641709 0.482407 0.770051 0.482407H8.6631C8.85561 0.482407 8.98396 0.60301 8.98396 0.723613V2.53266"
      stroke="currentColor" stroke-width="1.008" stroke-miterlimit="10" />
  </g>
  <defs>
    <clipPath id="clip0_311_660">
      <rect width="12" height="12" fill="white" />
    </clipPath>
  </defs>
</svg>
`, Ide = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M8.94676 9.51803H0.802453C0.670025 9.51803 0.537598 9.39662 0.537598 9.27521V0.77663C0.537598 0.655222 0.670025 0.533813 0.802453 0.533813H8.94676C9.07919 0.533813 9.21161 0.655222 9.21161 0.77663V9.27521C9.21161 9.39662 9.07919 9.51803 8.94676 9.51803Z"
    stroke="currentColor" stroke-miterlimit="10" />
  <path d="M1.25073 9.31859L3.8236 5.45593L6.13082 9.31859" stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M8.82231 9.14709L6.16092 5.87183L5.19067 7.11271" stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round" />
  <path
    d="M7.33077 5.02523C7.62186 5.02523 7.85783 4.81639 7.85783 4.55876C7.85783 4.30113 7.62186 4.09229 7.33077 4.09229C7.03968 4.09229 6.80371 4.30113 6.80371 4.55876C6.80371 4.81639 7.03968 5.02523 7.33077 5.02523Z"
    stroke="currentColor" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M2.10278 10.676H10.2471C10.3795 10.676 10.5119 10.5546 10.5119 10.4332V1.93457"
    stroke="currentColor" stroke-width="0.5" stroke-miterlimit="10" stroke-linecap="round" />
  <path d="M3.3125 11.7376H11.4568C11.5892 11.7376 11.7217 11.6162 11.7217 11.4948V2.99622"
    stroke="currentColor" stroke-width="0.5" stroke-miterlimit="10" stroke-linecap="round" />
</svg>
`, Fde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6ZM12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM6.47656 9.60703V4.32382H5.56836V9.60703H6.47656ZM5.63184 2.55136C5.54395 2.65227 5.5 2.77597 5.5 2.92245C5.5 3.06243 5.54395 3.18287 5.63184 3.28378C5.72298 3.38144 5.85645 3.43027 6.03223 3.43027C6.20475 3.43027 6.33659 3.38144 6.42773 3.28378C6.52214 3.18287 6.56934 3.06243 6.56934 2.92245C6.56934 2.77597 6.52214 2.65227 6.42773 2.55136C6.33659 2.45045 6.20475 2.39999 6.03223 2.39999C5.85645 2.39999 5.72298 2.45045 5.63184 2.55136Z"
    fill="currentColor" />
</svg>
  
`, Ude = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M2.57314 3.70999V0.560727C1.32869 0.933213 0.530029 1.50211 0.530029 2.13873C0.530029 3.24944 2.97712 4.17052 6.00001 4.17052C9.02288 4.17052 11.47 3.26976 11.47 2.13873C11.47 1.46148 10.6203 0.899354 9.30618 0.526855V3.74386"
    stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M11.47 1.98438V9.39546C11.47 10.5297 9.01829 11.4579 6.00002 11.4579C2.98177 11.4579 0.530029 10.5434 0.530029 9.39546V1.98438"
    stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M8.10897 7.79587L4.77563 9.7959V5.7959L8.10897 7.79587Z" fill="currentColor" />
</svg>
`, zde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M9.63216 1.53342C9.7887 1.67404 9.93845 1.82082 10.088 1.96885C10.1202 1.99818 10.1525 2.02751 10.1858 2.05773C11.0059 2.81494 11.5458 4.04169 11.6957 5.13566C11.7011 5.17196 11.7064 5.20826 11.7119 5.24566C11.9085 6.83458 11.4517 8.36492 10.4869 9.62399C9.50446 10.8033 8.17726 11.5558 6.6471 11.7433C5.04335 11.8814 3.507 11.4373 2.26801 10.4075C1.23276 9.49072 0.485804 8.28056 0.295225 6.88958C0.289887 6.85328 0.284549 6.81698 0.279049 6.77958C0.0963473 5.30335 0.473343 3.74916 1.36707 2.55349C1.54946 2.33017 1.74899 2.12488 1.95171 1.92013C1.9957 1.87171 1.9957 1.87171 2.04058 1.82231C2.79779 1.00216 4.02454 0.462257 5.11851 0.312371C5.15481 0.307033 5.19111 0.301695 5.22851 0.296195C6.75813 0.106885 8.45128 0.512532 9.63216 1.53342ZM3.02355 1.67653C3.26131 1.91429 3.8666 1.87908 4.19283 1.88664C5.22488 1.88109 6.2682 1.7129 7.29265 1.59736C7.34027 1.592 7.3879 1.58664 7.43697 1.58112C7.57323 1.56573 7.70946 1.55018 7.84569 1.53456C7.88654 1.52995 7.92738 1.52533 7.96946 1.52058C8.15804 1.49876 8.34338 1.47435 8.52892 1.43293C7.0543 0.202866 4.46248 0.684094 3.02355 1.67653ZM6.87715 2.07539C6.64609 2.10388 6.41492 2.13148 6.18376 2.15908C6.06166 2.17372 5.93959 2.18856 5.81754 2.20366C5.03253 2.29907 4.25292 2.35765 3.46508 2.26726C3.41498 2.26154 3.41498 2.26154 3.36386 2.25569C3.131 2.22623 2.90945 2.1749 2.68251 2.11501C2.55858 2.07846 2.55858 2.07846 2.43891 2.11501C2.07321 2.38407 1.70761 2.87751 1.51323 3.2843C1.55517 3.27944 1.55517 3.27944 1.59796 3.27449C2.89664 3.13346 4.16884 3.28826 5.45646 3.45529C6.88638 3.63618 8.49786 3.83975 9.72998 2.94801C9.8486 2.84202 9.91673 2.74224 9.99052 2.60221C9.92276 2.52486 9.85469 2.44777 9.7865 2.37079C9.74863 2.32784 9.71076 2.28488 9.67175 2.24062C9.43649 1.98487 9.43649 1.98487 9.11383 1.89521C9.03451 1.89469 8.95516 1.89555 8.87586 1.89749C8.83173 1.89806 8.78759 1.89863 8.74212 1.89922C8.11726 1.915 7.49684 1.99866 6.87715 2.07539ZM10.2828 3.0407C10.2366 3.08992 10.1911 3.13979 10.1458 3.1899C9.49407 3.84563 8.53316 4.02261 7.64238 4.03359C7.58224 4.03352 7.52209 4.03344 7.46012 4.03337C7.42831 4.03339 7.39649 4.03341 7.36371 4.03343C6.39781 4.03151 5.43943 3.90243 4.48344 3.77473C3.90978 3.69968 3.343 3.65922 2.76472 3.65579C2.70287 3.65511 2.64102 3.65444 2.57729 3.65374C2.09626 3.65615 1.49124 3.66254 1.12347 4.0151C1.03964 4.17889 1.03964 4.17889 0.989486 4.36527C0.979579 4.39798 0.969672 4.43068 0.959464 4.46438C0.931645 4.55784 0.905699 4.65186 0.879866 4.7459C0.86831 4.78766 0.856755 4.82943 0.844849 4.87246C0.776041 5.15123 0.754009 5.43445 0.733706 5.7203C0.787842 5.7068 0.841979 5.69329 0.897756 5.67938C1.67245 5.48913 1.67245 5.48913 2.04915 5.4767C2.14552 5.47293 2.14552 5.47293 2.24384 5.46909C3.48492 5.43711 4.72959 5.64966 5.95644 5.81434C8.28776 6.1335 8.28776 6.1335 10.429 5.33054C10.7821 5.04758 10.7821 5.04758 11.0624 4.69718C11.0063 4.13612 10.6892 3.47279 10.3316 3.0407C10.3155 3.0407 10.2994 3.0407 10.2828 3.0407ZM10.9314 5.52846C9.7906 6.46589 8.2581 6.50426 6.85378 6.36717C6.40443 6.32117 5.9563 6.2648 5.50827 6.2075C5.42349 6.19671 5.33871 6.18593 5.25392 6.17515C4.57776 6.08893 4.57776 6.08893 4.24607 6.04494C2.47731 5.78937 2.47731 5.78937 0.782426 6.2075C0.595424 6.5815 0.867475 7.25328 0.972548 7.63656C0.990196 7.67945 1.00784 7.72235 1.02603 7.76654C1.21942 7.83101 1.35675 7.77426 1.54653 7.72277C1.96279 7.61815 2.35291 7.58567 2.78299 7.58993C2.83652 7.59008 2.83652 7.59008 2.89112 7.59022C3.74584 7.595 4.57864 7.7286 5.41916 7.87269C5.75299 7.92986 6.0876 7.98198 6.42226 8.03405C6.51861 8.04915 6.6149 8.06468 6.71118 8.08021C7.97996 8.28273 9.40959 8.3908 10.5148 7.61087C10.8602 7.33239 11.1545 7.07834 11.239 6.63076C11.2612 6.42316 11.2623 6.21511 11.2633 6.00653C11.2637 5.95676 11.2637 5.95676 11.264 5.90598C11.2634 5.70915 11.2464 5.52363 11.2085 5.33054C11.1076 5.33054 11.0011 5.46753 10.9314 5.52846ZM1.26963 8.25374C1.44274 8.83854 1.89042 9.31852 2.29275 9.76406C2.3217 9.79697 2.35065 9.82988 2.38048 9.86379C2.78786 10.2722 3.51714 10.2437 4.05988 10.2519C4.2731 10.2509 4.48408 10.2356 4.6964 10.2168C4.76809 10.2105 4.76809 10.2105 4.84123 10.2041C5.46981 10.1442 6.09147 10.0377 6.71409 9.93458C8.07656 9.71022 8.07656 9.71022 8.61151 9.65292C8.64665 9.64911 8.6818 9.6453 8.718 9.64138C8.93183 9.62041 9.14288 9.61507 9.3577 9.61783C9.58708 9.618 9.77917 9.61097 9.97796 9.48354C10.0987 9.357 10.1894 9.22989 10.2828 9.08198C10.3022 9.05258 10.3215 9.02318 10.3414 8.99289C10.55 8.67478 10.7276 8.38196 10.8188 8.01014C10.7418 8.04895 10.7418 8.04895 10.6633 8.08855C8.78833 9.01442 6.77056 8.56744 4.79561 8.22756C3.62518 8.02804 2.4181 7.8484 1.26963 8.25374ZM8.37362 10.1325C8.34182 10.1366 8.31002 10.1407 8.27726 10.1449C7.55474 10.2382 6.83628 10.3564 6.11781 10.4766C6.05236 10.4875 6.05236 10.4875 5.98559 10.4986C5.90415 10.5122 5.82274 10.5259 5.74134 10.5398C5.37573 10.6009 5.01252 10.6439 4.64178 10.6564C4.58384 10.6585 4.52591 10.6605 4.46622 10.6626C4.40715 10.6645 4.34808 10.6665 4.28723 10.6684C4.22646 10.6705 4.1657 10.6726 4.1031 10.6748C3.95437 10.6799 3.80565 10.6849 3.65691 10.6897C3.78792 10.8208 3.9401 10.8672 4.11062 10.9303C4.14548 10.9433 4.18034 10.9562 4.21625 10.9695C5.52444 11.4432 6.9288 11.3682 8.19282 10.7959C8.5936 10.607 8.9692 10.3933 9.30844 10.1051C9.30844 10.089 9.30844 10.0729 9.30844 10.0564C8.99202 10.0517 8.68696 10.0919 8.37362 10.1325Z"
    fill="currentColor" stroke="currentColor" stroke-width="0.4" />
</svg>
`, Hde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.44033 5.34986L0.513916 3.41743L6.61838 0.518799L11.4912 2.45122L5.44033 5.34986Z"
    stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M11.4912 4.56421L5.44033 7.40245L0.513916 5.47003" stroke="currentColor"
    stroke-linecap="round" stroke-linejoin="round" />
  <path d="M11.4912 6.60779L5.44033 9.44603L0.513916 7.574" stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M11.4912 8.59106L5.44033 11.4897L0.513916 9.55728" stroke="currentColor"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, Bde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.44033 5.34986L0.513916 3.41743L6.61838 0.518799L11.4912 2.45122L5.44033 5.34986Z"
    stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M11.4912 4.56421L5.44033 7.40245L0.513916 5.47003" stroke="currentColor"
    stroke-linecap="round" stroke-linejoin="round" />
  <path d="M11.4912 6.60779L5.44033 9.44603L0.513916 7.574" stroke="currentColor"
    stroke-linecap="round" stroke-linejoin="round" />
  <path d="M11.4912 8.59106L5.44033 11.4897L0.513916 9.55728" stroke="currentColor"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, Vde = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="9.14307" y="5.71426" width="1.61626" height="4.84879"
    transform="rotate(45 9.14307 5.71426)" fill="currentColor" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M8.65386 10.9394L7.51093 12.0823C6.51874 13.0745 4.91008 13.0745 3.9179 12.0823C2.92571 11.0901 2.92571 9.48144 3.9179 8.48925L5.06083 7.34632L4.00017 6.28566L2.85724 7.42859C1.27926 9.00657 1.27926 11.565 2.85723 13.1429C4.43521 14.7209 6.99361 14.7209 8.57159 13.1429L9.71452 12L8.65386 10.9394ZM10.9396 8.65361L12.0003 9.71427L13.1431 8.57146C14.721 6.99349 14.721 4.43509 13.1431 2.85711C11.5651 1.27914 9.00669 1.27914 7.42871 2.85711L6.28591 3.99992L7.34657 5.06058L8.48937 3.91778C9.48156 2.92559 11.0902 2.92559 12.0824 3.91777C13.0746 4.90996 13.0746 6.51862 12.0824 7.5108L10.9396 8.65361Z"
    fill="currentColor" />
</svg>
`, $de = `
<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M6.5 4.50098V3.50098C6.5 2.10098 5.4 1.00098 4 1.00098C2.6 1.00098 1.5 2.10098 1.5 3.50098V4.50098C0.65 4.50098 0 5.15098 0 6.00098V9.50098C0 10.351 0.65 11.001 1.5 11.001H6.5C7.35 11.001 8 10.351 8 9.50098V6.00098C8 5.15098 7.35 4.50098 6.5 4.50098ZM2.5 3.50098C2.5 2.65098 3.15 2.00098 4 2.00098C4.85 2.00098 5.5 2.65098 5.5 3.50098V4.50098H2.5V3.50098ZM4.55 7.75098L4.5 7.80098V8.50098C4.5 8.80098 4.3 9.00098 4 9.00098C3.7 9.00098 3.5 8.80098 3.5 8.50098V7.80098C3.2 7.50098 3.15 7.05098 3.45 6.75098C3.75 6.45098 4.2 6.40098 4.5 6.70098C4.8 6.95098 4.85 7.45098 4.55 7.75098Z"
    fill="currentColor"
  />
</svg>

`, Wde = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M5.72526 16.0569L0.895264 18.2449V3.94391L5.72526 1.75491L14.2743 3.94391L19.1043 1.75491V16.0569L14.2743 18.2449L5.72526 16.0569Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M14.2742 18.2444V3.94342" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M5.72534 1.75522V16.0572" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" />
</svg>
`, jde = `
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M26.9998 31.0003H4.99976C2.79076 31.0003 0.999756 29.2093 0.999756 27.0003V5.00031C0.999756 2.79131 2.79076 1.00031 4.99976 1.00031H26.9998C29.2088 1.00031 30.9998 2.79131 30.9998 5.00031V27.0003C30.9998 29.2093 29.2088 31.0003 26.9998 31.0003"
    stroke="currentColor" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M11.7253 22.0569L6.89526 24.2449V9.94391L11.7253 7.75491L20.2743 9.94391L25.1043 7.75491V22.0569L20.2743 24.2449L11.7253 22.0569Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M20.2742 24.2444V9.94342" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M11.7253 7.75522V22.0572" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" />
</svg>
`, Gde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.55249 3.4104V8.89062L5.45502 11.4802V6.30107L0.55249 3.4104Z" stroke="currentColor"
    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M5.45532 11.4801L11.4473 8.28837V3.10925L5.45532 6.30103" stroke="currentColor"
    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M11.447 3.10933L6.3402 0.519775L0.55249 3.41044" stroke="currentColor"
    stroke-miterlimit="10"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, qde = `
<svg width="20" height="4" viewBox="0 0 20 4" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="2" cy="2" r="2" fill="currentColor" />
  <circle cx="10" cy="2" r="2" fill="currentColor" />
  <circle cx="18" cy="2" r="2" fill="currentColor" />
</svg>
`, Xde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="6" cy="6" r="5.5" stroke="currentColor" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M6.30005 9.30005C7.12848 9.30005 7.80005 8.62848 7.80005 7.80005C7.80005 6.97162 7.12848 6.30005 6.30005 6.30005C5.47162 6.30005 4.80005 6.97162 4.80005 7.80005C4.80005 8.62848 5.47162 9.30005 6.30005 9.30005ZM6.30005 10.3C7.68076 10.3 8.80005 9.18076 8.80005 7.80005C8.80005 6.41934 7.68076 5.30005 6.30005 5.30005C4.91934 5.30005 3.80005 6.41934 3.80005 7.80005C3.80005 9.18076 4.91934 10.3 6.30005 10.3Z"
    fill="currentColor" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M8.10246 6.06761C8.52175 5.80163 8.80005 5.33334 8.80005 4.80005C8.80005 3.97162 8.12848 3.30005 7.30005 3.30005C6.47162 3.30005 5.80005 3.97162 5.80005 4.80005C5.80005 4.98749 5.83443 5.16691 5.89723 5.33233C5.5578 5.38731 5.24127 5.51064 4.96223 5.68774C4.85743 5.41188 4.80005 5.11267 4.80005 4.80005C4.80005 3.41934 5.91934 2.30005 7.30005 2.30005C8.68076 2.30005 9.80005 3.41934 9.80005 4.80005C9.80005 5.68867 9.33642 6.469 8.63786 6.91236C8.5172 6.59474 8.33366 6.30809 8.10246 6.06761Z"
    fill="currentColor" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M5.18774 3.46223C4.91188 3.35743 4.61267 3.30005 4.30005 3.30005C2.91934 3.30005 1.80005 4.41934 1.80005 5.80005C1.80005 7.02428 2.68001 8.04299 3.84193 8.25817C3.81443 8.10965 3.80005 7.95653 3.80005 7.80005C3.80005 7.60597 3.82216 7.41706 3.86401 7.23569C3.24825 7.04891 2.80005 6.47682 2.80005 5.80005C2.80005 4.97162 3.47162 4.30005 4.30005 4.30005C4.48749 4.30005 4.66691 4.33443 4.83233 4.39723C4.88731 4.0578 5.01064 3.74127 5.18774 3.46223Z"
    fill="currentColor" />
</svg>
  
`, Yde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_20005_8944)">
    <path
      d="M2.70336 7.12516C1.85416 6.78364 0.510742 5.81641 0.510742 3.94735C0.510742 2.07829 2.02592 0.56311 3.89498 0.56311C5.07626 0.56311 6.44774 1.16783 7.14521 2.88971"
      stroke="currentColor" />
    <path
      d="M5.94943 4.66833H2.86723C2.70042 4.66833 2.56519 4.80357 2.56519 4.97038V11.1348C2.56519 11.3016 2.70042 11.4368 2.86723 11.4368H9.03163C9.19844 11.4368 9.33367 11.3016 9.33367 11.1348L9.33367 7.32681"
      stroke="currentColor" />
    <path
      d="M8.37208 1.51553L11.4484 6.8439C11.5647 7.04524 11.4194 7.29697 11.1868 7.29697H5.03418C4.80167 7.29697 4.65635 7.04524 4.77261 6.8439L7.84894 1.51553C7.96517 1.31416 8.25585 1.31416 8.37208 1.51553Z"
      stroke="currentColor" />
  </g>
  <defs>
    <clipPath id="clip0_20005_8944">
      <rect width="12" height="12" fill="white" />
    </clipPath>
  </defs>
</svg>
`, Zde = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M4.91895 2.7627C4.59249 2.7527 4.29919 2.76369 4.14648 2.79297L4.14746 2.79395C3.66443 2.89252 3.36761 3.03749 3.0918 3.29492C2.65794 3.70191 2.43354 4.33547 2.46191 5.1875C2.4904 6.04102 2.77323 7.09001 3.32422 8.28223L3.38379 8.40625C3.41302 8.36695 3.44521 8.32632 3.47656 8.2832L3.71094 7.96777C4.91269 6.38954 6.55117 4.75207 8.05469 3.63867C8.05185 3.63735 8.04875 3.63609 8.0459 3.63477V3.63379C7.21783 3.24925 6.46549 2.98968 5.78125 2.84668V2.8457C5.569 2.8024 5.24239 2.77261 4.91895 2.7627ZM13.4102 11.8438C15.2095 9.8843 16.5775 7.57181 17.0527 5.71094L17.1406 5.32617C17.3152 4.45065 17.2831 3.73956 17.0801 3.20605C16.8816 2.68497 16.5132 2.31382 15.9658 2.11328L15.7207 2.03809C15.1147 1.88376 14.3178 1.92892 13.3975 2.17871C12.4806 2.4276 11.4585 2.87434 10.4131 3.50195L10.4102 3.50391C10.3953 3.51252 10.3805 3.52186 10.3662 3.53027C10.4039 3.55527 10.4431 3.5825 10.4844 3.60938H10.4834C11.377 4.18491 12.4368 5.01799 13.3115 5.8252H13.3125L13.3252 5.83691L13.332 5.49316L13.3467 4.92285C13.3532 4.7735 13.3627 4.66161 13.3779 4.57715C13.3942 4.48671 13.4217 4.39688 13.4814 4.31934C13.5409 4.2422 13.6145 4.2015 13.6602 4.17676L13.6641 4.1748L13.7324 4.14453C13.8715 4.09402 14.0328 4.0939 14.1719 4.14453L14.2393 4.1748L14.2451 4.17773H14.2441C14.2806 4.19774 14.3718 4.24182 14.4365 4.33887C14.4966 4.42906 14.5185 4.53779 14.5312 4.64941C14.557 4.87478 14.5592 5.28696 14.5645 6.06348L14.5752 7.53418L14.5771 7.78809L14.3232 7.78613L11.3213 7.76465L11.209 7.76367L11.1348 7.67969L11.0332 7.56348V7.5625C10.9898 7.5134 10.9519 7.45753 10.9248 7.40332C10.9016 7.35698 10.8682 7.27862 10.8682 7.19434C10.8682 7.08524 10.9066 6.97584 10.9492 6.89355C10.9872 6.82029 11.0589 6.70919 11.1729 6.65332C11.2032 6.63831 11.2314 6.63265 11.2393 6.63086C11.2524 6.62786 11.2656 6.62565 11.2764 6.62402C11.298 6.62075 11.3233 6.61772 11.3496 6.61523C11.4032 6.61018 11.4738 6.60506 11.5547 6.60059C11.7173 6.59161 11.9312 6.58344 12.1582 6.57812L12.3467 6.57324C11.4124 5.7331 10.0907 4.74632 9.31836 4.31152V4.3125L9.23633 4.2666L9.05957 4.39746L9.05762 4.39844C7.41949 5.57737 5.72033 7.27038 4.47754 8.95508L4.23535 9.29199L4.02246 9.59375L4.06836 9.66895L4.44434 10.2607C4.8405 10.858 5.29049 11.4639 5.73633 12.001H5.73535C7.20567 13.7654 8.96514 15.2788 10.6973 16.3486C12.4352 17.422 14.1199 18.0322 15.4463 18.0273L15.6865 18.0215C16.2213 17.9935 16.5754 17.8757 16.9111 17.6455L16.9131 17.6445L17.0625 17.5352C17.195 17.4275 17.2862 17.3155 17.4092 17.125C17.6758 16.7076 17.8071 16.0547 17.7402 15.3311L17.71 15.0625C17.6424 14.5383 17.5275 14.0855 17.3018 13.4736L17.1787 13.1533C17.1195 13.0025 17.0652 12.8543 17.0254 12.7363C17.0056 12.6776 16.9889 12.6236 16.9766 12.5801C16.9705 12.5586 16.9643 12.5373 16.96 12.5176C16.9569 12.5034 16.9502 12.4706 16.9502 12.4355C16.9502 11.9215 17.5878 11.646 17.9561 12.0205H17.9551C17.9919 12.0577 18.0219 12.1075 18.04 12.1387C18.063 12.1783 18.0888 12.2258 18.1143 12.2773C18.1653 12.3808 18.222 12.5092 18.2734 12.6377L18.2744 12.6387L18.4404 13.0811C19.2147 15.2704 19.1395 17.0939 18.0684 18.2305V18.2314C17.6588 18.6639 17.1632 18.9545 16.5703 19.1104V19.1113C14.8619 19.5559 12.5464 18.9186 10.1289 17.4326L9.64355 17.124C7.27537 15.5642 5.00592 13.3057 3.44922 10.9619L3.44824 10.9609C3.39836 10.8856 3.34947 10.8137 3.30566 10.748C3.28899 10.7771 3.27093 10.8077 3.25293 10.8398C3.11413 11.0876 2.94797 11.406 2.82422 11.6689C2.16759 13.0727 1.86857 14.3884 1.9668 15.2725H1.96582C2.03195 15.8572 2.21903 16.2939 2.50586 16.6055C2.79107 16.9153 3.19572 17.1236 3.74219 17.2139L3.87598 17.2275C4.02932 17.2391 4.23855 17.2427 4.48047 17.2324H4.48242L4.76367 17.2158C5.4121 17.1632 6.01786 17.004 6.87988 16.6592V16.6582L7.25098 16.5205C7.35816 16.4853 7.45027 16.4612 7.53027 16.4531C7.621 16.444 7.71217 16.4519 7.80078 16.4912C7.88541 16.5288 7.94684 16.5861 7.99316 16.6357L8.05957 16.7256C8.11512 16.8208 8.1377 16.9289 8.14062 17.0225C8.14444 17.1461 8.11491 17.3006 8.0127 17.418L8.00977 17.4209C7.96761 17.4675 7.91181 17.5051 7.86719 17.5322C7.81742 17.5625 7.75799 17.5936 7.69336 17.625C7.56379 17.6879 7.40016 17.7577 7.21973 17.8271C6.85884 17.966 6.41707 18.1094 6.02441 18.209L6.02539 18.21C5.38808 18.3748 4.9099 18.4412 4.35156 18.4404L4.10645 18.4355C3.33169 18.4098 2.81641 18.2758 2.27246 17.9502H2.27148C1.20232 17.3071 0.712788 16.1629 0.751953 14.7617C0.791025 13.3673 1.35043 11.6943 2.39941 9.91504L2.60156 9.57129L2.41699 9.2041C1.63944 7.65612 1.25687 6.32134 1.25684 5.08301C1.25684 4.31697 1.3501 3.86591 1.63379 3.28711L1.63477 3.28613L1.75977 3.05371C2.06024 2.53847 2.43075 2.20291 3 1.91992H3.00098L3.16797 1.84277C3.55515 1.67388 3.93887 1.58229 4.40039 1.55273L4.64648 1.54199C5.80705 1.5156 7.11683 1.84554 8.50684 2.5L8.80566 2.64551L9.19043 2.83887L9.47559 2.66113L9.78516 2.4707C11.3343 1.54213 12.8949 0.943498 14.2559 0.776367V0.777344C14.4661 0.750282 14.781 0.745109 15.0781 0.754883C15.3747 0.764649 15.681 0.789103 15.8691 0.829102L16.0518 0.873047C16.9513 1.11113 17.6719 1.67209 18.0635 2.4707L18.1436 2.64062C18.2227 2.82101 18.2969 3.02385 18.3301 3.15625L18.3828 3.39844C18.6122 4.63004 18.3117 6.14523 17.6133 7.72949C16.8766 9.4005 15.6826 11.1772 14.1396 12.8359L15.4521 12.8613L15.5557 12.8633L15.6279 12.9375L15.7197 13.0322H15.7178C15.9604 13.2739 15.9412 13.6572 15.6885 13.8828L15.6895 13.8838L15.5801 13.9824L15.5088 14.0469H12.2061V12.3721C12.2061 11.6206 12.2084 11.1993 12.2324 10.958C12.2442 10.8392 12.2637 10.7317 12.3096 10.6426C12.365 10.5349 12.4444 10.4821 12.5078 10.4482L12.5127 10.4443L12.5957 10.4131C12.6236 10.405 12.651 10.3997 12.6738 10.3955C12.7242 10.3863 12.7815 10.3799 12.8359 10.3799C12.9051 10.3799 12.99 10.3853 13.0752 10.4258C13.1597 10.4659 13.2171 10.5273 13.2598 10.5781L13.3516 10.6875L13.4102 10.7568V11.8438Z"
    fill="currentColor" stroke="currentColor" stroke-width="0.5" />
</svg>
  
`, Kde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="path-1-inside-1_1379_42451" fill="white">
    <rect width="12" height="12" rx="0.6" />
  </mask>
  <rect width="12" height="12" rx="0.6" stroke="currentColor" stroke-width="2.016"
    mask="url(#path-1-inside-1_1379_42451)" />
  <line x1="0.600098" y1="4.29605" x2="11.4001" y2="4.29605" stroke="currentColor"
    stroke-width="1.008" />
  <line x1="0.600098" y1="7.89602" x2="11.4001" y2="7.89602" stroke="currentColor"
    stroke-width="1.008" />
  <line x1="4.29605" y1="11.4" x2="4.29605" y2="0.600024" stroke="currentColor" stroke-width="1.008" />
  <line x1="7.8959" y1="11.4" x2="7.8959" y2="0.600024" stroke="currentColor" stroke-width="1.008" />
</svg>
`, Jde = `
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M0.5 0.5H1H17H17.5V1V17V17.5H17H1H0.5V17V1V0.5ZM1.5 11.8572V16.5H6.1428V11.8572H1.5ZM1.5 10.8572H6.1428V6.7143H1.5V10.8572ZM1.5 5.7143V1.5H6.1428V5.7143H1.5ZM7.1428 6.7143V10.8572H11.2858V6.7143H7.1428ZM11.2858 5.7143H7.1428V1.5H11.2858V5.7143ZM12.2858 6.7143V10.8572H16.5V6.7143H12.2858ZM16.5 5.7143H12.2858V1.5H16.5V5.7143ZM7.1428 11.8572V16.5H11.2858V11.8572H7.1428ZM16.5 16.5H12.2858V11.8572H16.5V16.5Z"
    fill="currentColor" />
</svg>
  
`, Qde = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M2.58976 2.7309V0.557913C1.34962 0.814933 0.553711 1.20747 0.553711 1.64674C0.553711 2.41313 2.99235 3.04867 6.00479 3.04867C9.01723 3.04867 11.4559 2.42715 11.4559 1.64674C11.4559 1.17943 10.6091 0.791567 9.2995 0.534546V2.75427"
    stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M11.4512 1.64673V6.68434C11.4512 7.4554 9.00796 8.08627 6.00015 8.08627C2.99234 8.08627 0.549072 7.46475 0.549072 6.68434V1.64673"
    stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M11.4512 8.47046V8.74396C11.4512 9.51502 9.00796 10.1459 6.00015 10.1459C2.99234 10.1459 0.549072 9.52437 0.549072 8.74396V8.47046"
    stroke="currentColor" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M11.4512 10.0627V10.3362C11.4512 11.1073 9.00796 11.7382 6.00015 11.7382C2.99234 11.7382 0.549072 11.1167 0.549072 10.3362V10.0627"
    stroke="currentColor" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M2.17798 7.67971L4.78783 4.44592L6.54786 7.85392" stroke="currentColor"
    stroke-linecap="round" stroke-linejoin="round" />
  <path d="M9.29011 7.79652L6.94402 4.86182L5.8103 6.15159" stroke="currentColor"
    stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M8.85135 4.9982C9.11996 4.9982 9.33771 4.7783 9.33771 4.50703C9.33771 4.23577 9.11996 4.01587 8.85135 4.01587C8.58274 4.01587 8.36499 4.23577 8.36499 4.50703C8.36499 4.7783 8.58274 4.9982 8.85135 4.9982Z"
    stroke="currentColor" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, efe = `
<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M1 18C6.66667 17.3894 12.3333 16.7789 18 16.1684C18 11.5765 18 6.98254 18 2.38646C12.3333 1.9243 6.66667 1.46215 1 1C1 6.66455 1 12.3312 1 18ZM11.9286 2.43098C10.3095 2.30378 8.69048 2.17658 7.07143 2.04938C7.07143 3.5588 7.07143 5.07033 7.07143 6.58399C8.69048 6.62215 10.3095 6.66031 11.9286 6.69847C11.9286 5.27809 11.9286 3.85559 11.9286 2.43098ZM12.5357 2.48186C12.5357 3.89375 12.5357 5.30353 12.5357 6.71119C14.1548 6.74934 15.7738 6.78326 17.3929 6.81294C17.3929 5.49433 17.3929 4.17147 17.3929 2.84437C15.7738 2.72565 14.1548 2.60481 12.5357 2.48186ZM11.9286 7.22634C10.3095 7.2009 8.69048 7.17546 7.07143 7.15002C7.07143 8.66367 7.07143 10.1773 7.07143 11.691C8.69048 11.6231 10.3095 11.5553 11.9286 11.4875C11.9286 10.0671 11.9286 8.64671 11.9286 7.22634ZM12.5357 11.462C12.5357 10.0544 12.5357 8.64671 12.5357 7.23906C14.1548 7.2645 15.7738 7.28782 17.3929 7.30902C17.3929 8.62763 17.3929 9.94625 17.3929 11.2649C15.7738 11.3285 14.1548 11.3942 12.5357 11.462ZM11.9286 12.0153C10.3095 12.0959 8.69048 12.1765 7.07143 12.257C7.07143 13.7707 7.07143 15.2801 7.07143 16.7853C8.69048 16.6199 10.3095 16.4524 11.9286 16.2828C11.9286 14.8582 11.9286 13.4357 11.9286 12.0153ZM12.5357 16.2192C14.1548 16.0539 15.7738 15.8906 17.3929 15.7295C17.3929 14.4024 17.3929 13.0796 17.3929 11.7609C15.7738 11.833 14.1548 11.9072 12.5357 11.9835C12.5357 13.3954 12.5357 14.8073 12.5357 16.2192ZM6.46429 7.1373C6.46429 8.66367 6.46429 10.19 6.46429 11.7164C4.84524 11.7843 3.22619 11.85 1.60714 11.9136C1.60714 10.2982 1.60714 8.68275 1.60714 7.06734C3.22619 7.08854 4.84524 7.11186 6.46429 7.1373ZM6.46429 12.2888C4.84524 12.3651 3.22619 12.4415 1.60714 12.5178C1.60714 14.1247 1.60714 15.7316 1.60714 17.3386C3.22619 17.1775 4.84524 17.0142 6.46429 16.8489C6.46429 15.331 6.46429 13.8109 6.46429 12.2888ZM6.46429 6.56491C6.46429 5.04277 6.46429 3.52276 6.46429 2.00486C4.84524 1.88191 3.22619 1.76107 1.60714 1.64235C1.60714 3.24504 1.60714 4.85198 1.60714 6.46315C3.22619 6.49707 4.84524 6.53099 6.46429 6.56491Z"
    fill="currentColor" stroke="currentColor" stroke-width="0.5" />
</svg>
  
`, tfe = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M2.15987 2.7136C2.45811 2.7136 2.69987 2.47062 2.69987 2.17089C2.69987 1.87115 2.45811 1.62817 2.15987 1.62817C1.86164 1.62817 1.61987 1.87115 1.61987 2.17089C1.61987 2.47062 1.86164 2.7136 2.15987 2.7136Z"
    fill="currentColor" />
  <path
    d="M4.62008 2.7136C4.91831 2.7136 5.16008 2.47062 5.16008 2.17089C5.16008 1.87115 4.91831 1.62817 4.62008 1.62817C4.32184 1.62817 4.08008 1.87115 4.08008 2.17089C4.08008 2.47062 4.32184 2.7136 4.62008 2.7136Z"
    fill="currentColor" />
  <path
    d="M7.37984 2.7136C7.67808 2.7136 7.91984 2.47062 7.91984 2.17089C7.91984 1.87115 7.67808 1.62817 7.37984 1.62817C7.08161 1.62817 6.83984 1.87115 6.83984 2.17089C6.83984 2.47062 7.08161 2.7136 7.37984 2.7136Z"
    fill="currentColor" />
  <path
    d="M9.84005 2.7136C10.1383 2.7136 10.38 2.47062 10.38 2.17089C10.38 1.87115 10.1383 1.62817 9.84005 1.62817C9.54181 1.62817 9.30005 1.87115 9.30005 2.17089C9.30005 2.47062 9.54181 2.7136 9.84005 2.7136Z"
    fill="currentColor" />
  <path
    d="M2.15987 10.3719C2.45811 10.3719 2.69987 10.1289 2.69987 9.82921C2.69987 9.52948 2.45811 9.2865 2.15987 9.2865C1.86164 9.2865 1.61987 9.52948 1.61987 9.82921C1.61987 10.1289 1.86164 10.3719 2.15987 10.3719Z"
    fill="currentColor" />
  <path
    d="M4.62008 10.3719C4.91831 10.3719 5.16008 10.1289 5.16008 9.82921C5.16008 9.52948 4.91831 9.2865 4.62008 9.2865C4.32184 9.2865 4.08008 9.52948 4.08008 9.82921C4.08008 10.1289 4.32184 10.3719 4.62008 10.3719Z"
    fill="currentColor" />
  <path
    d="M7.37984 10.3719C7.67808 10.3719 7.91984 10.1289 7.91984 9.82921C7.91984 9.52948 7.67808 9.2865 7.37984 9.2865C7.08161 9.2865 6.83984 9.52948 6.83984 9.82921C6.83984 10.1289 7.08161 10.3719 7.37984 10.3719Z"
    fill="currentColor" />
  <path
    d="M9.84005 10.3719C10.1383 10.3719 10.38 10.1289 10.38 9.82921C10.38 9.52948 10.1383 9.2865 9.84005 9.2865C9.54181 9.2865 9.30005 9.52948 9.30005 9.82921C9.30005 10.1289 9.54181 10.3719 9.84005 10.3719Z"
    fill="currentColor" />
  <path
    d="M4.62007 0.603015C4.78575 0.603015 4.92007 0.468026 4.92007 0.301508C4.92007 0.13499 4.78575 0 4.62007 0C4.45438 0 4.32007 0.13499 4.32007 0.301508C4.32007 0.468026 4.45438 0.603015 4.62007 0.603015Z"
    fill="currentColor" />
  <path
    d="M7.38008 0.603015C7.54576 0.603015 7.68008 0.468026 7.68008 0.301508C7.68008 0.13499 7.54576 0 7.38008 0C7.21439 0 7.08008 0.13499 7.08008 0.301508C7.08008 0.468026 7.21439 0.603015 7.38008 0.603015Z"
    fill="currentColor" />
  <path
    d="M4.62007 12C4.78575 12 4.92007 11.865 4.92007 11.6985C4.92007 11.532 4.78575 11.397 4.62007 11.397C4.45438 11.397 4.32007 11.532 4.32007 11.6985C4.32007 11.865 4.45438 12 4.62007 12Z"
    fill="currentColor" />
  <path
    d="M7.38008 12C7.54576 12 7.68008 11.865 7.68008 11.6985C7.68008 11.532 7.54576 11.397 7.38008 11.397C7.21439 11.397 7.08008 11.532 7.08008 11.6985C7.08008 11.865 7.21439 12 7.38008 12Z"
    fill="currentColor" />
  <path
    d="M2.15987 5.12559C2.45811 5.12559 2.69987 4.88261 2.69987 4.58287C2.69987 4.28314 2.45811 4.04016 2.15987 4.04016C1.86164 4.04016 1.61987 4.28314 1.61987 4.58287C1.61987 4.88261 1.86164 5.12559 2.15987 5.12559Z"
    fill="currentColor" />
  <path
    d="M9.84005 5.12559C10.1383 5.12559 10.38 4.88261 10.38 4.58287C10.38 4.28314 10.1383 4.04016 9.84005 4.04016C9.54181 4.04016 9.30005 4.28314 9.30005 4.58287C9.30005 4.88261 9.54181 5.12559 9.84005 5.12559Z"
    fill="currentColor" />
  <path
    d="M4.62003 5.42721C5.08395 5.42721 5.46003 5.04924 5.46003 4.58299C5.46003 4.11674 5.08395 3.73877 4.62003 3.73877C4.15611 3.73877 3.78003 4.11674 3.78003 4.58299C3.78003 5.04924 4.15611 5.42721 4.62003 5.42721Z"
    fill="currentColor" />
  <path
    d="M7.38004 5.42721C7.84396 5.42721 8.22004 5.04924 8.22004 4.58299C8.22004 4.11674 7.84396 3.73877 7.38004 3.73877C6.91612 3.73877 6.54004 4.11674 6.54004 4.58299C6.54004 5.04924 6.91612 5.42721 7.38004 5.42721Z"
    fill="currentColor" />
  <path
    d="M2.15987 7.89952C2.45811 7.89952 2.69987 7.65653 2.69987 7.3568C2.69987 7.05707 2.45811 6.81409 2.15987 6.81409C1.86164 6.81409 1.61987 7.05707 1.61987 7.3568C1.61987 7.65653 1.86164 7.89952 2.15987 7.89952Z"
    fill="currentColor" />
  <path
    d="M9.84005 7.89952C10.1383 7.89952 10.38 7.65653 10.38 7.3568C10.38 7.05707 10.1383 6.81409 9.84005 6.81409C9.54181 6.81409 9.30005 7.05707 9.30005 7.3568C9.30005 7.65653 9.54181 7.89952 9.84005 7.89952Z"
    fill="currentColor" />
  <path
    d="M4.62003 8.20102C5.08395 8.20102 5.46003 7.82305 5.46003 7.35679C5.46003 6.89054 5.08395 6.51257 4.62003 6.51257C4.15611 6.51257 3.78003 6.89054 3.78003 7.35679C3.78003 7.82305 4.15611 8.20102 4.62003 8.20102Z"
    fill="currentColor" />
  <path
    d="M7.38004 8.20102C7.84396 8.20102 8.22004 7.82305 8.22004 7.35679C8.22004 6.89054 7.84396 6.51257 7.38004 6.51257C6.91612 6.51257 6.54004 6.89054 6.54004 7.35679C6.54004 7.82305 6.91612 8.20102 7.38004 8.20102Z"
    fill="currentColor" />
  <path
    d="M11.6999 4.88439C11.8656 4.88439 11.9999 4.7494 11.9999 4.58288C11.9999 4.41636 11.8656 4.28137 11.6999 4.28137C11.5342 4.28137 11.3999 4.41636 11.3999 4.58288C11.3999 4.7494 11.5342 4.88439 11.6999 4.88439Z"
    fill="currentColor" />
  <path
    d="M11.6999 7.65831C11.8656 7.65831 11.9999 7.52332 11.9999 7.35681C11.9999 7.19029 11.8656 7.0553 11.6999 7.0553C11.5342 7.0553 11.3999 7.19029 11.3999 7.35681C11.3999 7.52332 11.5342 7.65831 11.6999 7.65831Z"
    fill="currentColor" />
  <path
    d="M0.3 4.88439C0.465685 4.88439 0.6 4.7494 0.6 4.58288C0.6 4.41636 0.465685 4.28137 0.3 4.28137C0.134315 4.28137 0 4.41636 0 4.58288C0 4.7494 0.134315 4.88439 0.3 4.88439Z"
    fill="currentColor" />
  <path
    d="M0.3 7.65831C0.465685 7.65831 0.6 7.52332 0.6 7.35681C0.6 7.19029 0.465685 7.0553 0.3 7.0553C0.134315 7.0553 0 7.19029 0 7.35681C0 7.52332 0.134315 7.65831 0.3 7.65831Z"
    fill="currentColor" />
</svg>
  
`, nfe = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="6" cy="6" r="5.5" stroke="currentColor" />
  <circle cx="6" cy="6" r="4" fill="currentColor" />
</svg>
  
`, rfe = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="6" cy="6" r="5.5" stroke="currentColor" />
</svg>
  
`, ife = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="2" cy="2" r="2" fill="currentColor" />
  <circle cx="10" cy="2" r="2" fill="currentColor" />
  <circle cx="10" cy="10" r="2" fill="currentColor" />
  <circle cx="2" cy="10" r="2" fill="currentColor" />
</svg>
`, ofe = `
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M6.27472 11.5494C9.18787 11.5494 11.5494 9.18787 11.5494 6.27472C11.5494 3.36157 9.18787 1 6.27472 1C3.36157 1 1 3.36157 1 6.27472C1 9.18787 3.36157 11.5494 6.27472 11.5494Z"
    stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M10.033 10.033L13 13" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>
  
`, afe = `
<svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.96069 6.65869H4.39722C4.55151 6.65869 4.67847 6.63232 4.77808 6.57959C4.87964 6.5249 4.95483 6.45068 5.00366 6.35693C5.05444 6.26123 5.07983 6.15088 5.07983 6.02588C5.07983 5.90283 5.05737 5.79639 5.01245 5.70654C4.96753 5.61475 4.89917 5.54443 4.80737 5.49561C4.71753 5.44482 4.60229 5.41943 4.46167 5.41943C4.34839 5.41943 4.2439 5.44189 4.14819 5.48682C4.05444 5.53174 3.97925 5.59619 3.92261 5.68018C3.86792 5.76221 3.84058 5.86084 3.84058 5.97607H3.06421C3.06421 5.74561 3.12476 5.54346 3.24585 5.36963C3.3689 5.19385 3.53491 5.05615 3.7439 4.95654C3.95288 4.85693 4.18628 4.80713 4.44409 4.80713C4.72534 4.80713 4.97144 4.854 5.18237 4.94775C5.39526 5.03955 5.5603 5.17529 5.67749 5.35498C5.79663 5.53467 5.8562 5.75732 5.8562 6.02295C5.8562 6.1499 5.82593 6.27686 5.76538 6.40381C5.70679 6.52881 5.61987 6.64209 5.50464 6.74365C5.39136 6.84326 5.25171 6.92432 5.08569 6.98682C4.92163 7.04736 4.73315 7.07764 4.52026 7.07764H3.96069V6.65869ZM3.96069 7.25635V6.84326H4.52026C4.7605 6.84326 4.96851 6.87158 5.14429 6.92822C5.32202 6.98291 5.46851 7.06104 5.58374 7.1626C5.69897 7.26221 5.78394 7.37842 5.83862 7.51123C5.89526 7.64404 5.92358 7.78662 5.92358 7.93896C5.92358 8.13818 5.88647 8.31592 5.81226 8.47217C5.73804 8.62646 5.63354 8.75732 5.49878 8.86475C5.36597 8.97217 5.20972 9.0542 5.03003 9.11084C4.85034 9.16553 4.65601 9.19287 4.44702 9.19287C4.26538 9.19287 4.08862 9.16846 3.91675 9.11963C3.74683 9.06885 3.59351 8.99365 3.45679 8.89404C3.32007 8.79248 3.21167 8.66553 3.13159 8.51318C3.05151 8.35889 3.01147 8.18018 3.01147 7.97705H3.78784C3.78784 8.09424 3.81616 8.19873 3.8728 8.29053C3.9314 8.38232 4.01147 8.45459 4.11304 8.50732C4.21655 8.55811 4.33276 8.5835 4.46167 8.5835C4.60425 8.5835 4.72632 8.55811 4.82788 8.50732C4.9314 8.45459 5.0105 8.38037 5.06519 8.28467C5.11987 8.18701 5.14722 8.0708 5.14722 7.93604C5.14722 7.77588 5.11694 7.646 5.0564 7.54639C4.99585 7.44678 4.90894 7.37354 4.79565 7.32666C4.68433 7.27979 4.55151 7.25635 4.39722 7.25635H3.96069Z" fill="currentColor"/>
<path d="M7.91577 9.13428H6.99585L7.00171 8.50146H7.91577C8.16382 8.50146 8.37183 8.44678 8.53979 8.3374C8.70776 8.22607 8.83472 8.06689 8.92065 7.85986C9.00659 7.65088 9.04956 7.40088 9.04956 7.10986V6.89014C9.04956 6.66553 9.02515 6.46729 8.97632 6.29541C8.92749 6.12354 8.85522 5.979 8.75952 5.86182C8.66577 5.74463 8.54956 5.65576 8.41089 5.59521C8.27222 5.53467 8.11304 5.50439 7.93335 5.50439H6.97827V4.86865H7.93335C8.21851 4.86865 8.47827 4.9165 8.71265 5.01221C8.94897 5.10791 9.15308 5.24561 9.32495 5.42529C9.49878 5.60303 9.63159 5.81592 9.72339 6.06396C9.81714 6.31201 9.86401 6.58936 9.86401 6.896V7.10986C9.86401 7.41455 9.81714 7.69189 9.72339 7.94189C9.63159 8.18994 9.49878 8.40283 9.32495 8.58057C9.15308 8.7583 8.948 8.89502 8.70972 8.99072C8.47144 9.08643 8.20679 9.13428 7.91577 9.13428ZM7.44702 4.86865V9.13428H6.64136V4.86865H7.44702Z" fill="currentColor"/>
<path d="M9.37801 1.53866C9.43141 1.47794 9.46048 1.39763 9.4591 1.31465C9.45771 1.23167 9.42599 1.1525 9.3706 1.09381C9.31522 1.03513 9.2405 1.00151 9.16219 1.00005C9.08388 0.998586 9.00809 1.02939 8.95078 1.08597L7.05647 3.09275C7.02503 3.12649 6.99883 3.15382 6.97586 3.17731L6.90613 3.0825L6.06175 1.93241C6.00487 1.85111 5.94293 1.77393 5.87635 1.70137C5.80541 1.62877 5.69739 1.54421 5.54383 1.53823C5.39027 1.53268 5.27661 1.60827 5.20084 1.67574C5.12962 1.74299 5.0627 1.81518 5.00053 1.89184L3.49878 3.66033C3.47122 3.69139 3.4498 3.72796 3.43576 3.76791C3.42172 3.80785 3.41534 3.85037 3.41701 3.89296C3.41867 3.93555 3.42834 3.97736 3.44546 4.01594C3.46257 4.05452 3.48678 4.08909 3.51666 4.11763C3.54654 4.14617 3.5815 4.1681 3.61949 4.18213C3.65747 4.19617 3.69772 4.20203 3.73787 4.19938C3.77802 4.19672 3.81727 4.1856 3.85331 4.16666C3.88936 4.14773 3.92147 4.12136 3.94777 4.0891L5.43944 2.333C5.47128 2.29542 5.49708 2.26467 5.52005 2.23905L5.59381 2.33855L6.43819 3.48864C6.49502 3.56637 6.55548 3.6488 6.61513 3.71029C6.68405 3.78119 6.78763 3.86233 6.93515 3.87172C7.08266 3.88155 7.19511 3.81492 7.27169 3.75343C7.34286 3.6927 7.41018 3.62707 7.47322 3.55698L9.37801 1.53866Z" fill="currentColor" stroke="currentColor" stroke-width="0.2"/>
<path d="M0.87756 1.4527C0.87756 1.33626 0.831306 1.22459 0.748973 1.14226C0.66664 1.05993 0.554973 1.01367 0.438536 1.01367C0.3221 1.01367 0.210432 1.05993 0.128099 1.14226C0.045766 1.22459 -0.000488281 1.33626 -0.000488281 1.4527V9.09465C-0.000488281 9.89484 -0.000488289 10.5405 0.0679995 11.048C0.138243 11.5748 0.290439 12.0185 0.642243 12.3709C0.994634 12.7233 1.43834 12.8744 1.96517 12.9458C2.47268 13.0137 3.11834 13.0137 3.91854 13.0137H11.5605C11.6769 13.0137 11.7886 12.9674 11.8709 12.8851C11.9533 12.8028 11.9995 12.6911 11.9995 12.5746C11.9995 12.4582 11.9533 12.3465 11.8709 12.2642C11.7886 12.1819 11.6769 12.1356 11.5605 12.1356H3.95073C3.11073 12.1356 2.52419 12.1345 2.08224 12.0753C1.65258 12.0174 1.42546 11.9114 1.26332 11.7499C1.10117 11.5877 0.995804 11.3606 0.937853 10.9304C0.878731 10.4884 0.87756 9.90245 0.87756 9.06245V1.4527Z" fill="currentColor"/>
</svg>

`, sfe = `
<svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M17.6507 3.86C17.6507 5.439 16.3707 6.719 14.7917 6.719C13.2117 6.719 11.9307 5.439 11.9307 3.86C11.9307 2.281 13.2117 1 14.7917 1C16.3707 1 17.6507 2.281 17.6507 3.86Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M17.6507 16.4567C17.6507 18.0357 16.3707 19.3157 14.7917 19.3157C13.2117 19.3157 11.9307 18.0357 11.9307 16.4567C11.9307 14.8767 13.2117 13.5967 14.7917 13.5967C16.3707 13.5967 17.6507 14.8767 17.6507 16.4567Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M6.72 10.1549C6.72 11.7339 5.44 13.0139 3.86 13.0139C2.281 13.0139 1 11.7339 1 10.1549C1 8.5759 2.281 7.2959 3.86 7.2959C5.44 7.2959 6.72 8.5759 6.72 10.1549Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M12.2493 5.14746L6.29126 8.63246" stroke="currentColor" stroke-width="1.685"
    stroke-linecap="round" stroke-linejoin="round" />
  <path d="M12.2493 15.1618L6.29126 11.6768" stroke="currentColor" stroke-width="1.685"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>
`, lfe = `
<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_287_10459)">
    <path
      d="M19.1919 7.99998C17.0707 3.93748 13.7374 1.33331 10 1.33331C6.26265 1.33331 3.03033 3.93748 0.808105 7.99998"
      stroke="currentColor" stroke-width="1.685" stroke-miterlimit="10" stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M0.808105 8C2.92932 12.0625 6.26265 14.6667 10 14.6667C13.7374 14.6667 16.9697 12.0625 19.1919 8"
      stroke="currentColor" stroke-width="1.685" stroke-miterlimit="10" stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M10 10.7084C11.4505 10.7084 12.6263 9.49579 12.6263 8.00002C12.6263 6.50425 11.4505 5.29169 10 5.29169C8.5496 5.29169 7.37378 6.50425 7.37378 8.00002C7.37378 9.49579 8.5496 10.7084 10 10.7084Z"
      stroke="currentColor" stroke-width="1.685" stroke-miterlimit="10" stroke-linecap="round"
      stroke-linejoin="round" />
  </g>
  <defs>
    <clipPath id="clip0_287_10459">
      <rect width="20" height="15" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
`, cfe = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect fill="currentColor" height="2" width="12" y="5" />
</svg>
`, ufe = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_301_211)">
    <path
      d="M4.25121 5.82917C5.26506 5.82917 6.08696 4.97423 6.08696 3.91962C6.08696 2.865 5.26506 2.01007 4.25121 2.01007C3.23735 2.01007 2.41546 2.865 2.41546 3.91962C2.41546 4.97423 3.23735 5.82917 4.25121 5.82917Z"
      fill="currentColor" />
    <path
      d="M0.386473 0.100503C0.772947 -0.100503 1.25604 0 1.54589 0.40201L2.51208 2.01005C2.02899 2.51256 1.73913 3.11558 1.73913 3.8191C1.73913 3.9196 1.73913 3.9196 1.73913 4.0201L0.0966184 1.30653C-0.0966184 0.904523 0 0.40201 0.386473 0.100503Z"
      fill="currentColor" />
    <path d="M16.2319 19.196L12.1739 14.9749L5.7971 6.43219" stroke="currentColor"
      stroke-width="1.685"
      stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M10.628 18.8944L7.63284 16.2814L8.11593 12.7638" stroke="currentColor"
      stroke-width="1.685"
      stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M3.67139 10.6533H6.56994V7.43719" stroke="currentColor" stroke-width="1.685"
      stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M7.05315 11.6583C7.34301 11.6583 7.63286 11.5578 7.8261 11.3568C8.01934 11.1558 8.11595 10.8543 8.11595 10.5527V8.9447L9.75847 11.2563C10.1449 11.8593 10.0483 12.6633 9.46861 13.1658C9.27537 13.3668 8.98552 13.4673 8.69566 13.4673C8.30919 13.4673 7.92272 13.2663 7.63286 12.9648L6.85992 11.8593H7.05315V11.6583Z"
      fill="currentColor" />
    <path
      d="M5.41064 2.01006C5.41064 2.01006 5.7005 2.21106 5.99035 2.61307C5.99035 2.61307 6.37683 2.51257 7.43963 3.6181C8.50243 4.72363 9.66185 4.62312 9.66185 4.62312C9.66185 4.62312 10.8213 4.42212 10.9179 3.5176C10.9179 3.5176 10.2416 4.32162 8.98552 3.21609C7.72949 2.11056 6.95654 1.00503 5.41064 2.01006Z"
      fill="currentColor" />
    <path
      d="M5.12078 6.33168C5.12078 6.43218 4.92755 7.03519 4.83093 7.1357C4.63769 7.63821 4.54107 8.54273 5.41064 8.94474C5.89373 9.14575 6.37682 8.84424 6.37682 8.84424L5.41064 6.63318C5.41064 6.63318 5.41064 6.03017 5.12078 6.33168Z"
      fill="currentColor" />
    <path
      d="M7.14975 8.4422C7.14975 8.4422 9.27536 8.84421 10.3382 10.3517C11.401 11.8593 14.1063 14.0703 16.6184 13.4673C19.1304 12.8643 19.5169 12.3618 19.5169 12.3618L16.715 8.4422C16.715 8.4422 13.0435 9.94974 10.0483 7.93969C7.05314 5.92964 5.99033 6.33165 5.99033 6.33165"
      stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round"
      stroke-linejoin="round" />
  </g>
  <defs>
    <clipPath id="clip0_301_211">
      <rect width="20" height="20" fill="currentColor" />
    </clipPath>
  </defs>
</svg>
  
`, dfe = `
<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="sec-nav/templates">
    <path id="Union" fill-rule="evenodd" clip-rule="evenodd"
      d="M2 1.68H16C16.1767 1.68 16.32 1.82327 16.32 2V18C16.32 18.1767 16.1767 18.32 16 18.32H2C1.82327 18.32 1.68 18.1767 1.68 18V2C1.68 1.82327 1.82327 1.68 2 1.68ZM0 2C0 0.895431 0.895431 0 2 0H16C17.1046 0 18 0.895431 18 2V18C18 19.1046 17.1046 20 16 20H2C0.89543 20 0 19.1046 0 18V2ZM4.84 4C4.37608 4 4 4.37608 4 4.84C4 5.30392 4.37608 5.68 4.84 5.68H13.16C13.6239 5.68 14 5.30392 14 4.84C14 4.37608 13.6239 4 13.16 4H4.84ZM4 9.84C4 9.37608 4.37608 9 4.84 9H13.16C13.6239 9 14 9.37608 14 9.84C14 10.3039 13.6239 10.68 13.16 10.68H4.84C4.37608 10.68 4 10.3039 4 9.84ZM4.84 14C4.37608 14 4 14.3761 4 14.84C4 15.3039 4.37608 15.68 4.84 15.68H13.16C13.6239 15.68 14 15.3039 14 14.84C14 14.3761 13.6239 14 13.16 14H4.84Z"
      fill="currentColor" />
  </g>
</svg>
`, ffe = `
<svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M8.23358 4.38753V1.49701H5.75713V10.503H7.31785V12H2.41274V10.503H3.94161V1.49701H1.48109V4.38753H0V0H9.71466V4.38753H8.23358Z"
    fill="currentColor" />
</svg>
`, hfe = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.0269 7.9891V16.5931" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M13.2583 7.9891L12.4243 16.5931" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M6.7959 7.9891L7.6289 16.5931" stroke="currentColor" stroke-linecap="round"
    stroke-linejoin="round" />
  <path
    d="M1.84229 6.408C1.84229 4.947 3.03829 3.752 4.49929 3.752H15.5543C17.0163 3.752 18.2113 4.947 18.2113 6.408"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" />
  <path
    d="M16.021 7.9998L15.021 17.1318C15.021 18.2308 14.203 19.1318 13.202 19.1318H6.85198C5.85098 19.1318 5.03198 18.2308 5.03198 17.1318L4.03198 7.9998"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M11.481 2.2967C11.481 3.1007 10.83 3.7517 10.027 3.7517C9.22402 3.7517 8.57202 3.1007 8.57202 2.2967C8.57202 1.4937 9.22402 0.842697 10.027 0.842697C10.83 0.842697 11.481 1.4937 11.481 2.2967Z"
    stroke="currentColor" stroke-width="1.685" stroke-linecap="round" />
</svg>
`, pfe = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_414_20676)">
    <path
      d="M6.73365 16.4C8.04018 17.3 9.54772 17.8 11.2563 17.8C15.5779 17.8 19.0955 14.3 19.0955 10C19.0955 5.7 15.5779 2.2 11.2563 2.2C6.93466 2.2 3.41707 5.7 3.41707 10"
      stroke="currentColor" stroke-width="1.685" stroke-miterlimit="10" stroke-linecap="round"
      stroke-linejoin="round" />
    <path d="M3.51755 13.2L4.82408 11.5L6.13062 9.79999H3.51755H0.803983L2.11052 11.5L3.51755 13.2Z"
      fill="currentColor" stroke="currentColor" stroke-width="1.685" stroke-miterlimit="10"
      stroke-linecap="round" stroke-linejoin="round" />
  </g>
  <defs>
    <clipPath id="clip0_414_20676">
      <rect width="20" height="20" fill="white" transform="matrix(-1 0 0 1 20 0)" />
    </clipPath>
  </defs>
</svg>
`, mfe = `
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_501_48086)">
<mask id="path-1-inside-1_501_48086" fill="white">
<path d="M0 1.50488H12V10.4941H0V1.50488Z"/>
</mask>
<path d="M12 1.50488H11V10.4941H12H13V1.50488H12ZM0 10.4941H1V1.50488H0H-1V10.4941H0Z" fill="currentColor" mask="url(#path-1-inside-1_501_48086)"/>
<path d="M3.52295 5.65869H3.95947C4.11377 5.65869 4.24072 5.63232 4.34033 5.57959C4.44189 5.5249 4.51709 5.45068 4.56592 5.35693C4.6167 5.26123 4.64209 5.15088 4.64209 5.02588C4.64209 4.90283 4.61963 4.79639 4.57471 4.70654C4.52979 4.61475 4.46143 4.54443 4.36963 4.49561C4.27979 4.44482 4.16455 4.41943 4.02393 4.41943C3.91064 4.41943 3.80615 4.44189 3.71045 4.48682C3.6167 4.53174 3.5415 4.59619 3.48486 4.68018C3.43018 4.76221 3.40283 4.86084 3.40283 4.97607H2.62646C2.62646 4.74561 2.68701 4.54346 2.80811 4.36963C2.93115 4.19385 3.09717 4.05615 3.30615 3.95654C3.51514 3.85693 3.74854 3.80713 4.00635 3.80713C4.2876 3.80713 4.53369 3.854 4.74463 3.94775C4.95752 4.03955 5.12256 4.17529 5.23975 4.35498C5.35889 4.53467 5.41846 4.75732 5.41846 5.02295C5.41846 5.1499 5.38818 5.27686 5.32764 5.40381C5.26904 5.52881 5.18213 5.64209 5.06689 5.74365C4.95361 5.84326 4.81396 5.92432 4.64795 5.98682C4.48389 6.04736 4.29541 6.07764 4.08252 6.07764H3.52295V5.65869ZM3.52295 6.25635V5.84326H4.08252C4.32275 5.84326 4.53076 5.87158 4.70654 5.92822C4.88428 5.98291 5.03076 6.06104 5.146 6.1626C5.26123 6.26221 5.34619 6.37842 5.40088 6.51123C5.45752 6.64404 5.48584 6.78662 5.48584 6.93896C5.48584 7.13818 5.44873 7.31592 5.37451 7.47217C5.30029 7.62646 5.1958 7.75732 5.06104 7.86475C4.92822 7.97217 4.77197 8.0542 4.59229 8.11084C4.4126 8.16553 4.21826 8.19287 4.00928 8.19287C3.82764 8.19287 3.65088 8.16846 3.479 8.11963C3.30908 8.06885 3.15576 7.99365 3.01904 7.89404C2.88232 7.79248 2.77393 7.66553 2.69385 7.51318C2.61377 7.35889 2.57373 7.18018 2.57373 6.97705H3.3501C3.3501 7.09424 3.37842 7.19873 3.43506 7.29053C3.49365 7.38232 3.57373 7.45459 3.67529 7.50732C3.77881 7.55811 3.89502 7.5835 4.02393 7.5835C4.1665 7.5835 4.28857 7.55811 4.39014 7.50732C4.49365 7.45459 4.57275 7.38037 4.62744 7.28467C4.68213 7.18701 4.70947 7.0708 4.70947 6.93604C4.70947 6.77588 4.6792 6.646 4.61865 6.54639C4.55811 6.44678 4.47119 6.37354 4.35791 6.32666C4.24658 6.27979 4.11377 6.25635 3.95947 6.25635H3.52295Z" fill="currentColor"/>
<path d="M7.47803 8.13428H6.55811L6.56396 7.50146H7.47803C7.72607 7.50146 7.93408 7.44678 8.10205 7.3374C8.27002 7.22607 8.39697 7.06689 8.48291 6.85986C8.56885 6.65088 8.61182 6.40088 8.61182 6.10986V5.89014C8.61182 5.66553 8.5874 5.46729 8.53857 5.29541C8.48975 5.12354 8.41748 4.979 8.32178 4.86182C8.22803 4.74463 8.11182 4.65576 7.97314 4.59521C7.83447 4.53467 7.67529 4.50439 7.49561 4.50439H6.54053V3.86865H7.49561C7.78076 3.86865 8.04053 3.9165 8.2749 4.01221C8.51123 4.10791 8.71533 4.24561 8.88721 4.42529C9.06104 4.60303 9.19385 4.81592 9.28564 5.06396C9.37939 5.31201 9.42627 5.58936 9.42627 5.896V6.10986C9.42627 6.41455 9.37939 6.69189 9.28564 6.94189C9.19385 7.18994 9.06104 7.40283 8.88721 7.58057C8.71533 7.7583 8.51025 7.89502 8.27197 7.99072C8.03369 8.08643 7.76904 8.13428 7.47803 8.13428ZM7.00928 3.86865V8.13428H6.20361V3.86865H7.00928Z" fill="currentColor"/>
<path d="M6 0.5C7.6282 0.5 9.08537 0.665895 10.1211 0.924805C10.6428 1.05523 11.0302 1.20231 11.2744 1.34668C11.3903 1.41518 11.4468 1.46869 11.4756 1.5C11.4468 1.53131 11.3903 1.58482 11.2744 1.65332C11.0302 1.79769 10.6428 1.94477 10.1211 2.0752C9.08537 2.3341 7.6282 2.5 6 2.5C4.3718 2.5 2.91463 2.3341 1.87891 2.0752C1.35719 1.94477 0.969845 1.79769 0.725586 1.65332C0.60914 1.58446 0.552052 1.53126 0.523438 1.5C0.552052 1.46874 0.60914 1.41554 0.725586 1.34668C0.969845 1.20231 1.35719 1.05523 1.87891 0.924805C2.91463 0.665895 4.3718 0.5 6 0.5Z" stroke="currentColor"/>
<path d="M0.000488281 10.085C0.000488281 10.085 1.41554 11.5156 6.23922 11.5156C11.0629 11.5156 12 10.085 12 10.085" stroke="currentColor" stroke-linecap="round"/>
<path d="M0.000400837 10.2082C0.000400837 10.2082 3.60565 9.49371 5.93556 9.48647C8.31554 9.47908 12.0004 10.2015 12.0004 10.2015" stroke="currentColor" stroke-width="0.8" stroke-dasharray="1 2"/>
</g>
<defs>
<clipPath id="clip0_501_48086">
<rect width="12" height="12" fill="white"/>
</clipPath>
</defs>
</svg>

`, vfe = `
<svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M13.2613 9.25001L8.49818 1.00001C7.72838 -0.333324 5.80388 -0.333328 5.03407 1.00001L0.270935 9.25001C-0.498865 10.5833 0.463382 12.25 2.00298 12.25H11.5293C13.0689 12.25 14.0311 10.5833 13.2613 9.25001ZM5.9001 1.50001C6.285 0.83334 7.24725 0.833341 7.63215 1.50001L12.3953 9.75001C12.7802 10.4167 12.2991 11.25 11.5293 11.25H2.00298C1.23318 11.25 0.75206 10.4167 1.13696 9.75001L5.9001 1.50001ZM7.28175 7.98048L7.39503 4.00001H6.29738L6.41066 7.98048H7.28175ZM6.42238 8.82032C6.31821 8.92449 6.26613 9.05339 6.26613 9.20704C6.26613 9.35808 6.31821 9.48568 6.42238 9.58985C6.52915 9.69402 6.67238 9.7461 6.85206 9.7461C7.03175 9.7461 7.17368 9.69402 7.27784 9.58985C7.38461 9.48568 7.438 9.35808 7.438 9.20704C7.438 9.05339 7.38461 8.92449 7.27784 8.82032C7.17368 8.71355 7.03175 8.66016 6.85206 8.66016C6.67238 8.66016 6.52915 8.71355 6.42238 8.82032Z"
    fill="currentColor" />
</svg>
`, gfe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  add: ede,
  annotation: tde,
  annotation2dfilled: nde,
  annotation2doutlined: rde,
  annotation3dfilled: ide,
  annotation3doutlined: ode,
  annotationcursor: ade,
  annotationgroup: sde,
  arrow: lde,
  bim: cde,
  boxchecked: ude,
  boxunchecked: dde,
  cad: fde,
  checkboxdash: hde,
  checkboxtick: pde,
  clip: mde,
  close: vde,
  closesmall: gde,
  colors: yde,
  cornerupright: bde,
  date: xde,
  done: wde,
  download: _de,
  dropdown: Cde,
  dropdownarrow: Ede,
  dxf: Sde,
  file: Mde,
  files: Tde,
  flyto: Ade,
  gaussiansplat: Pde,
  gear: Rde,
  geartrapped: Lde,
  help: Ode,
  hide: Dde,
  ifc: kde,
  image: Nde,
  imagegroup: Ide,
  info: Fde,
  insta360: Ude,
  kml: zde,
  layergroup: Hde,
  layers: Bde,
  link: Vde,
  lock: $de,
  map: Wde,
  maptrapped: jde,
  mesh3d: Gde,
  more: qde,
  nodegroup: Xde,
  obj: Yde,
  orbit: Zde,
  ortho: Kde,
  orthographic: Jde,
  panoramaimagegroup: Qde,
  perspective: efe,
  pointcloud: tfe,
  radioselected: nfe,
  radiounselected: rfe,
  reorder: ife,
  search: ofe,
  sectioning: afe,
  sharelink: sfe,
  show: lfe,
  subtract: cfe,
  superhero: ufe,
  templates: dfe,
  textfield: ffe,
  trashbin: hfe,
  undo: pfe,
  volumetrics: mfe,
  warn: vfe
}, Symbol.toStringTag, { value: "Module" })), yfe = "fs", bfe = 1740739441, xfe = {
  dem: {
    body: '<g fill="none"><path fill="#6D4C41" fill-rule="evenodd" d="M6.241.999v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#6D4C41" stroke-linecap="round" stroke-linejoin="round" d="M2 4.623v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.087c0-.484-.547-.967-1.094-.967H6.239z"/><path fill="#6D4C41" d="M4.687 13H3.614l.006-.738h1.067q.434 0 .728-.192.294-.195.444-.557.15-.365.15-.875v-.256q0-.393-.085-.694t-.253-.506a1.05 1.05 0 00-.407-.31 1.4 1.4 0 00-.557-.107H3.593v-.742h1.114q.5 0 .91.168.412.168.714.482.305.311.465.745.165.435.164.97v.25q0 .534-.164.97-.16.435-.465.746-.3.31-.718.479a2.5 2.5 0 01-.926.167M4.14 8.023V13H3.2V8.023zm6.918 4.239V13H8.412v-.738zM8.7 8.023V13h-.94V8.023zm2.013 2.055v.72h-2.3v-.72zm.335-2.055v.742H8.412v-.742zm1.073 0h.813l1.36 3.747 1.358-3.747h.817L14.619 13h-.652zm-.41 0h.796l.144 3.442V13h-.94zm4.368 0h.8V13h-.94v-1.535z"/></g>'
  },
  "dem-link": {
    body: '<g fill="none"><path fill="#6D4C41" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#6D4C41" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.483 1.094.967V9"/><path fill="#6D4C41" d="M4.374 10.267h-.92l.006-.633h.914q.372 0 .624-.164.252-.167.381-.478.13-.313.13-.75v-.22q0-.336-.074-.594a1.2 1.2 0 00-.217-.434.9.9 0 00-.348-.266 1.2 1.2 0 00-.478-.091h-.955V6h.955q.428 0 .78.144.354.143.612.413.26.266.398.638.14.372.14.832v.214q0 .457-.14.832-.138.372-.398.639a1.8 1.8 0 01-.616.41 2.1 2.1 0 01-.794.144M3.906 6v4.266H3.1V6zm5.93 3.633v.633H7.567v-.633zM7.813 6v4.266h-.806V6zm1.725 1.76v.619h-1.97v-.618zM9.826 6v.636h-2.26V6zm.92 0h.697l1.166 3.21L13.772 6h.7l-1.585 4.266h-.56zm-.352 0h.683l.123 2.95v1.316h-.806zm3.744 0h.686v4.266h-.806V8.95z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.13a.348.348 0 00.627-.263l-.041-.243a4.28 4.28 0 011.716-4.185l.402-.293 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.422"/></g>'
  },
  "dem-sync": {
    body: '<g fill="none"><path fill="#6D4C41" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#6D4C41" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#6D4C41" d="M4.375 10.266h-.92l.005-.633h.915q.372 0 .624-.164.251-.167.38-.478.13-.313.13-.75v-.22q0-.336-.074-.594a1.2 1.2 0 00-.217-.434.9.9 0 00-.348-.266 1.2 1.2 0 00-.478-.091h-.955V6h.955q.428 0 .78.144.354.143.612.413.26.266.398.638.14.373.14.832v.214q0 .457-.14.832-.138.372-.398.639a1.75 1.75 0 01-.616.41 2.1 2.1 0 01-.793.144M3.905 6v4.266H3.1V6zm5.93 3.633v.633H7.568v-.633zM7.814 6v4.266h-.806V6zM9.54 7.76v.619H7.568V7.76zM9.827 6v.636h-2.26V6zm.92 0h.697l1.166 3.21L13.773 6h.7l-1.585 4.266h-.56zm-.352 0h.683l.123 2.95v1.316h-.806zm3.744 0h.686v4.266h-.806V8.95z"/><path fill="#726F74" d="M17.14 12.466a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.703a.473.473 0 01.807.333v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  dng: {
    body: '<g fill="none"><path fill="#C2185B" fill-rule="evenodd" d="M6.241.999v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#C2185B" stroke-linecap="round" stroke-linejoin="round" d="M2 4.623v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.087c0-.484-.547-.967-1.094-.967H6.239z"/><g clip-path="url(#svgID0)"><path fill="#C2185B" d="M4.962 13H3.889l.007-.739h1.066q.434 0 .728-.191.294-.195.444-.557.15-.366.15-.875v-.257q0-.393-.085-.694t-.253-.505a1.05 1.05 0 00-.406-.311 1.4 1.4 0 00-.558-.106H3.868v-.742h1.114q.5 0 .91.167.412.168.714.482.305.312.465.745.165.434.164.971v.25q0 .533-.164.97-.16.435-.465.745-.3.312-.718.479a2.5 2.5 0 01-.926.167m-.547-4.977V13h-.94V8.022zm7.619 0V13h-.944L8.975 9.547V13h-.94V8.023h.94l2.122 3.456V8.023zm4.84 2.403v1.938a1.6 1.6 0 01-.346.304q-.232.165-.608.284-.375.116-.923.116-.475 0-.868-.157a1.9 1.9 0 01-.677-.469 2.1 2.1 0 01-.437-.752 3.1 3.1 0 01-.154-1.015v-.328q0-.57.143-1.015.147-.444.417-.752.274-.307.653-.468.383-.16.855-.16.632 0 1.039.208.41.208.629.574.218.362.273.834h-.916a1.3 1.3 0 00-.15-.455.8.8 0 00-.322-.307 1.1 1.1 0 00-.533-.113q-.276 0-.489.11a1 1 0 00-.355.317 1.6 1.6 0 00-.219.516q-.072.308-.071.704v.335q0 .4.082.711.082.308.235.52.157.209.387.318.232.106.526.106.267 0 .44-.045.18-.048.285-.113a.8.8 0 00.164-.126v-.933h-.988v-.687z"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M3 7h14v7H3z"/></clipPath></defs></g>'
  },
  "dng-link": {
    body: '<g fill="none"><path fill="#C2185B" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#C2185B" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.483 1.094.967V9"/><path fill="#C2185B" d="M4.682 10.3h-.92l.006-.633h.914q.372 0 .624-.164.252-.166.38-.478.13-.313.13-.75v-.22q0-.336-.074-.594a1.2 1.2 0 00-.217-.434.9.9 0 00-.348-.266 1.2 1.2 0 00-.478-.091h-.955v-.636H4.7q.428 0 .78.144.354.143.612.413.26.266.398.638.14.373.14.833v.213q0 .457-.14.832-.137.372-.398.64a1.8 1.8 0 01-.615.41 2.1 2.1 0 01-.794.143m-.47-4.266V10.3h-.805V6.034zm6.531 0V10.3h-.808L8.12 7.34v2.96h-.806V6.034h.806l1.82 2.962V6.034zm4.149 2.06v1.66q-.095.121-.296.262a2 2 0 01-.522.243 2.7 2.7 0 01-.79.1q-.408 0-.745-.135a1.6 1.6 0 01-.58-.402 1.8 1.8 0 01-.375-.644 2.7 2.7 0 01-.132-.87v-.282q0-.489.123-.87.126-.38.358-.644.234-.264.56-.402.327-.137.732-.137.541 0 .89.178.352.18.54.493.186.31.234.714h-.785a1.1 1.1 0 00-.13-.39.66.66 0 00-.275-.263.95.95 0 00-.457-.097.83.83 0 00-.724.366q-.123.18-.187.443a2.7 2.7 0 00-.061.604v.287q0 .342.07.609.07.264.202.445.135.18.331.273.2.09.451.09.229 0 .378-.037a1 1 0 00.243-.097.7.7 0 00.14-.109v-.8h-.846v-.588z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.13a.348.348 0 00.627-.263l-.041-.243a4.28 4.28 0 011.716-4.185l.402-.293 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.422"/></g>'
  },
  "dng-sync": {
    body: '<g fill="none"><path fill="#C2185B" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#C2185B" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#C2185B" d="M4.682 10.3h-.92l.006-.633h.914q.372 0 .624-.164.252-.166.38-.478.13-.313.13-.75v-.22q0-.336-.074-.594a1.2 1.2 0 00-.217-.434.9.9 0 00-.348-.266 1.2 1.2 0 00-.478-.091h-.955v-.636H4.7q.428 0 .78.144.354.143.612.413.26.266.398.638.14.373.14.833v.213q0 .457-.14.832-.137.372-.398.64a1.8 1.8 0 01-.615.41 2.1 2.1 0 01-.794.143m-.47-4.266V10.3h-.805V6.034zm6.531 0V10.3h-.808L8.12 7.34v2.96h-.806V6.034h.806l1.82 2.962V6.034zm4.149 2.06v1.66q-.095.121-.296.262a2 2 0 01-.522.243 2.7 2.7 0 01-.79.1q-.408 0-.745-.135a1.6 1.6 0 01-.58-.402 1.8 1.8 0 01-.375-.644 2.7 2.7 0 01-.132-.87v-.282q0-.489.123-.87.126-.38.358-.644.234-.264.56-.402.327-.137.732-.137.541 0 .89.178.352.18.54.493.186.31.234.714h-.785a1.1 1.1 0 00-.13-.39.66.66 0 00-.275-.263.95.95 0 00-.457-.097.83.83 0 00-.724.366q-.123.18-.187.443a2.7 2.7 0 00-.061.604v.287q0 .342.07.609.07.264.202.445.135.18.331.273.2.09.451.09.229 0 .378-.037a1 1 0 00.243-.097.7.7 0 00.14-.109v-.8h-.846v-.588z"/><path fill="#726F74" d="M17.14 12.466a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.703a.473.473 0 01.807.333v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  docx: {
    body: '<g fill="none"><path fill="#1B5EBE" fill-rule="evenodd" d="M6.241 1.001v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#1B5EBE" stroke-linecap="round" stroke-linejoin="round" d="M2 4.626v13.53c0 .604.547.967 1.094.967h13.812c.684 0 1.094-.484 1.094-.967V2.09c0-.483-.547-.966-1.094-.966H6.239z"/><path fill="#1B5EBE" d="m8.037 12.639 1.416-5.747h.767l.048 1.21-1.513 5.9h-.81zm-.893-5.747 1.162 5.727v1.382h-.884L5.81 6.891zm4.594 5.703 1.143-5.703h1.338l-1.612 7.11h-.883zm-1.152-5.703 1.416 5.767.083 1.342h-.81l-1.51-5.903.06-1.206z"/></g>'
  },
  "docx-link": {
    body: '<g fill="none"><path fill="#1B5EBE" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#1B5EBE" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#1B5EBE" d="M7.037 11.638 8.453 5.89h.767l.049 1.21L7.755 13h-.81zM6.144 5.89l1.162 5.727V13h-.884L4.81 5.89zm4.594 5.703 1.143-5.703h1.338L11.607 13h-.883zM9.586 5.89l1.416 5.766.083 1.343h-.81l-1.51-5.903.06-1.206z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.349.349 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.605-.073.35.35 0 00.021-.19l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.348.348 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "docx-sync": {
    body: '<g fill="none"><path fill="#1B5EBE" fill-rule="evenodd" d="M5.241 1.001v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#1B5EBE" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.123H2.094c-.547 0-1.094-.363-1.094-.967V4.626l4.24-3.503h10.666c.547 0 1.094.483 1.094.966v6.912"/><path fill="#1B5EBE" d="m7.037 11.639 1.416-5.747h.767l.049 1.21-1.514 5.9h-.81zm-.893-5.747 1.162 5.727v1.382h-.884L4.81 5.891zm4.594 5.703 1.143-5.703h1.338l-1.612 7.11h-.883zM9.586 5.892l1.416 5.766.083 1.343h-.81l-1.51-5.903.06-1.206z"/><path fill="#726F74" d="M17.14 12.468a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.703a.473.473 0 01.807.334v2.638a.47.47 0 01-.473.473h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.497.24.24 0 01.228-.18h1.13c.148 0 .259.135.232.28a4.88 4.88 0 01-4.797 3.974 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  dwg: {
    body: '<g fill="none"><path fill="#E51050" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#E51050" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><g clip-path="url(#svgID0)"><path fill="#E51050" d="M5.34 12.236h-.866l.006-.595h.86q.351 0 .587-.155a.97.97 0 00.359-.45q.12-.294.121-.705v-.207q0-.317-.069-.56a1.1 1.1 0 00-.204-.408.85.85 0 00-.328-.25 1.1 1.1 0 00-.45-.086h-.898v-.6h.899q.402 0 .733.136.335.136.576.388.246.252.375.601a2.2 2.2 0 01.133.784v.2q0 .432-.133.784a1.7 1.7 0 01-.375.601 1.65 1.65 0 01-.579.386q-.336.135-.747.135M4.9 8.221v4.015h-.76V8.221zm3.907 3.246.8-3.246h.433l.027.684-.855 3.331h-.457zM8.301 8.22l.657 3.235v.78h-.5l-.91-4.015zm2.595 3.221.645-3.22h.756l-.91 4.014h-.5zm-.65-3.22.799 3.256.047.758h-.458l-.852-3.333.033-.682zm5.663 1.938v1.563a1.3 1.3 0 01-.279.246 1.8 1.8 0 01-.49.229 2.6 2.6 0 01-.745.093 1.9 1.9 0 01-.7-.127 1.5 1.5 0 01-.546-.377 1.7 1.7 0 01-.353-.607 2.5 2.5 0 01-.124-.819v-.265q0-.46.116-.818a1.7 1.7 0 01.336-.607q.22-.248.527-.378.309-.13.689-.13.51 0 .838.169.33.168.508.463.175.293.22.673h-.739q-.03-.21-.121-.367a.63.63 0 00-.26-.248.9.9 0 00-.43-.091q-.223 0-.394.088a.8.8 0 00-.287.257q-.116.168-.176.416a2.5 2.5 0 00-.058.568v.27q0 .322.066.574.067.248.19.419a.84.84 0 00.312.256q.188.086.425.086.215 0 .356-.036a1 1 0 00.228-.091.7.7 0 00.133-.102v-.753h-.797v-.554z"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M4 8h12v4.941H4z"/></clipPath></defs></g>'
  },
  "dwg-link": {
    body: '<g fill="none"><path fill="#E51050" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#E51050" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><g clip-path="url(#svgID0)"><path fill="#E51050" d="M4.34 10.236h-.866l.006-.595h.86q.351 0 .587-.155a.97.97 0 00.359-.45q.12-.294.121-.705v-.207q0-.317-.069-.56a1.1 1.1 0 00-.204-.408.85.85 0 00-.328-.25 1.1 1.1 0 00-.45-.086h-.898v-.6h.899q.402 0 .733.136.335.136.576.388.246.252.375.601a2.2 2.2 0 01.133.784v.2q0 .432-.133.784a1.7 1.7 0 01-.375.601 1.65 1.65 0 01-.579.386q-.336.135-.747.135M3.9 6.221v4.015h-.76V6.221zm3.907 3.246.8-3.246h.433l.027.684-.855 3.331h-.457zM7.301 6.22l.657 3.235v.78h-.5l-.91-4.015zm2.595 3.221.645-3.22h.756l-.91 4.014h-.5zm-.65-3.22.799 3.256.047.758h-.458l-.852-3.333.033-.682zm5.663 1.938v1.563a1.3 1.3 0 01-.279.246 1.8 1.8 0 01-.49.229 2.6 2.6 0 01-.745.093 1.9 1.9 0 01-.7-.127 1.5 1.5 0 01-.546-.377 1.7 1.7 0 01-.353-.607 2.5 2.5 0 01-.124-.819v-.265q0-.46.116-.818a1.7 1.7 0 01.336-.607q.22-.248.527-.378.309-.13.689-.13.51 0 .838.169.33.168.508.463.175.293.22.673h-.739q-.03-.21-.121-.367a.63.63 0 00-.26-.248.9.9 0 00-.43-.091q-.223 0-.394.088a.8.8 0 00-.287.257q-.116.167-.176.416a2.5 2.5 0 00-.058.568v.27q0 .322.066.574.067.248.19.419a.84.84 0 00.312.256q.188.086.425.086.215 0 .356-.036a1 1 0 00.228-.091.7.7 0 00.133-.102v-.753h-.797V8.16z"/></g><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.349.349 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/><defs><clipPath id="svgID0"><path fill="#fff" d="M3 6h12v4.941H3z"/></clipPath></defs></g>'
  },
  "dwg-sync": {
    body: '<g fill="none"><path fill="#E51050" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#E51050" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><g clip-path="url(#svgID0)"><path fill="#E51050" d="M4.34 10.236h-.866l.006-.595h.86q.351 0 .587-.155a.97.97 0 00.359-.45q.12-.294.121-.705v-.207q0-.317-.069-.56a1.1 1.1 0 00-.204-.408.85.85 0 00-.328-.25 1.1 1.1 0 00-.45-.086h-.898v-.6h.899q.402 0 .733.136.335.136.576.388.246.252.375.601a2.2 2.2 0 01.133.784v.2q0 .432-.133.784a1.7 1.7 0 01-.375.601 1.65 1.65 0 01-.579.386q-.336.135-.747.135M3.9 6.221v4.015h-.76V6.221zm3.907 3.246.8-3.246h.433l.027.684-.855 3.331h-.457zM7.301 6.22l.657 3.235v.78h-.5l-.91-4.015zm2.595 3.221.645-3.22h.756l-.91 4.014h-.5zm-.65-3.22.799 3.256.047.758h-.458l-.852-3.333.033-.682zm5.663 1.938v1.563a1.3 1.3 0 01-.279.246 1.8 1.8 0 01-.49.229 2.6 2.6 0 01-.745.093 1.9 1.9 0 01-.7-.127 1.5 1.5 0 01-.546-.377 1.7 1.7 0 01-.353-.607 2.5 2.5 0 01-.124-.819v-.265q0-.46.116-.818a1.7 1.7 0 01.336-.607q.22-.248.527-.378.309-.13.689-.13.51 0 .838.169.33.168.508.463.175.293.22.673h-.739q-.03-.21-.121-.367a.63.63 0 00-.26-.248.9.9 0 00-.43-.091q-.223 0-.394.088a.8.8 0 00-.287.257q-.116.167-.176.416a2.5 2.5 0 00-.058.568v.27q0 .322.066.574.067.248.19.419a.84.84 0 00.312.256q.188.086.425.086.215 0 .356-.036a1 1 0 00.228-.091.7.7 0 00.133-.102v-.753h-.797V8.16z"/></g><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/><defs><clipPath id="svgID0"><path fill="#fff" d="M3 6h12v4.941H3z"/></clipPath></defs></g>'
  },
  dxf: {
    body: '<g fill="none"><path fill="#1E88E5" fill-rule="evenodd" d="M6.241.999v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#1E88E5" stroke-linecap="round" stroke-linejoin="round" d="M2 4.623v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.087c0-.484-.547-.967-1.094-.967H6.239z"/><path fill="#1E88E5" d="M6.077 13.001H5.004l.007-.738h1.066q.434 0 .728-.192.294-.194.445-.557.15-.366.15-.875v-.256q0-.393-.086-.694t-.252-.506a1.05 1.05 0 00-.407-.31 1.4 1.4 0 00-.557-.107H4.983v-.742h1.115q.498 0 .909.168.414.168.714.482.305.311.465.745.165.435.164.97v.25q0 .534-.164.97-.16.435-.465.746-.3.31-.718.479a2.5 2.5 0 01-.926.167M5.53 8.024v4.977h-.94V8.024zm4.293 0 .995 1.774.998-1.774h1.08l-1.477 2.468 1.515 2.509h-1.09l-1.026-1.808L9.796 13H8.702l1.514-2.509L8.74 8.024zm4.628 0v4.977h-.94V8.024zm2.006 2.15v.742h-2.252v-.742zm.264-2.15v.742h-2.516v-.742z"/></g>'
  },
  "dxf-link": {
    body: '<g fill="none"><path fill="#1E88E5" fill-rule="evenodd" d="M5.241.998v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#1E88E5" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.12H2.094c-.547 0-1.094-.363-1.094-.967V4.623l4.24-3.504h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#1E88E5" d="M4.974 10h-.92l.006-.633h.914q.372 0 .624-.164.252-.167.381-.477.13-.315.13-.75v-.22q0-.337-.074-.595a1.2 1.2 0 00-.217-.433.9.9 0 00-.348-.267 1.2 1.2 0 00-.478-.09h-.955v-.637h.955q.427 0 .78.144t.612.413q.26.266.398.639.14.372.14.832v.214q0 .457-.14.832-.138.372-.398.638a1.75 1.75 0 01-.616.41 2.1 2.1 0 01-.794.144m-.468-4.266V10H3.7V5.734zm3.68 0 .852 1.52.855-1.52h.926L9.554 7.85 10.85 10h-.934l-.88-1.55L8.163 10h-.938l1.298-2.15-1.265-2.116zm3.966 0V10h-.805V5.734zm1.72 1.843v.636h-1.93v-.636zm.225-1.843v.636h-2.156v-.636z"/><path fill="#726F74" d="m18.955 10.313-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.069a5.005 5.005 0 00-1.106 6.983l.82 1.13a.348.348 0 00.605-.074.35.35 0 00.021-.19l-.04-.242a4.28 4.28 0 011.716-4.185l.402-.292 1.162 1.599a.348.348 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.422"/></g>'
  },
  "dxf-sync": {
    body: '<g fill="none"><path fill="#1E88E5" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#1E88E5" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#1E88E5" d="M4.975 10.001h-.92l.006-.633h.914q.372 0 .624-.164.252-.166.38-.477.13-.315.13-.75v-.22q0-.337-.074-.595a1.2 1.2 0 00-.217-.433.9.9 0 00-.348-.267 1.2 1.2 0 00-.478-.09h-.955v-.637h.955q.427 0 .78.144.354.143.612.413.26.266.398.639.14.372.14.832v.214q0 .457-.14.832-.138.371-.398.638a1.75 1.75 0 01-.615.41 2.1 2.1 0 01-.794.144m-.47-4.266v4.266H3.7V5.735zm3.68 0 .853 1.52.856-1.52h.925L9.554 7.851 10.852 10h-.935l-.879-1.55L8.162 10h-.937l1.297-2.15-1.265-2.116zm3.967 0v4.266h-.805V5.735zm1.72 1.843v.636h-1.93v-.636zm.226-1.843v.636H11.94v-.636z"/><path fill="#726F74" d="M17.14 12.466a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.703a.473.473 0 01.807.333v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  e57: {
    body: '<g fill="none"><path fill="#74B7FF" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#74B7FF" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><path fill="#74B7FF" d="M8 12.353V13H4.666v-.647zM4.835 7v6H4V7zm2.724 2.58v.647H4.666V9.58zM7.957 7v.651H4.666V7zm2.009 4.163L9.29 11l.26-2.352h2.563v.701H10.25l-.121 1.088q.099-.06.288-.122a1.4 1.4 0 01.432-.064q.332 0 .595.11.262.105.444.306.186.202.279.493.096.288.096.653 0 .32-.096.601a1.4 1.4 0 01-.285.496 1.35 1.35 0 01-.483.34 1.8 1.8 0 01-.685.121q-.297 0-.572-.086a1.6 1.6 0 01-.49-.26 1.3 1.3 0 01-.349-.422 1.4 1.4 0 01-.14-.573h.835a.9.9 0 00.115.365.63.63 0 00.243.23q.153.08.355.08a.7.7 0 00.314-.067.6.6 0 00.22-.195.9.9 0 00.128-.294q.042-.17.042-.371 0-.195-.048-.356a.8.8 0 00-.147-.281.65.65 0 00-.25-.182.9.9 0 00-.345-.064q-.266 0-.41.08a1.2 1.2 0 00-.25.188M16 8.648v.461l-1.83 4.198h-.893l1.83-3.993H12.74v-.666z"/></g>'
  },
  "e57-link": {
    body: '<g fill="none"><path fill="#74B7FF" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#74B7FF" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#74B7FF" d="M6.767 11.041v.61h-3.14v-.61zM3.786 6v5.65H3V6zm2.566 2.43v.609H3.627v-.61zM6.726 6v.613H3.627V6zm1.892 3.92-.636-.153.244-2.215h2.414v.66H8.886l-.114 1.025q.093-.057.271-.115.18-.06.407-.06.314 0 .56.103.247.099.42.289.174.19.261.464.09.27.09.615 0 .301-.09.566-.087.262-.268.467-.18.202-.455.32a1.7 1.7 0 01-.645.114q-.28 0-.54-.081a1.5 1.5 0 01-.46-.244 1.2 1.2 0 01-.329-.398 1.3 1.3 0 01-.132-.54h.786q.02.203.109.344a.6.6 0 00.229.217q.145.075.334.075a.64.64 0 00.296-.063.6.6 0 00.208-.184.8.8 0 00.12-.277q.04-.16.04-.35a1.2 1.2 0 00-.046-.334.7.7 0 00-.139-.265.6.6 0 00-.235-.172.8.8 0 00-.325-.06.8.8 0 00-.386.075q-.132.075-.235.178m5.683-2.368v.434l-1.723 3.954h-.841l1.723-3.76h-2.23v-.628z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.348.348 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "e57-sync": {
    body: '<g fill="none"><path fill="#74B7FF" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#74B7FF" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#74B7FF" d="M6.767 11.041v.61h-3.14v-.61zM3.786 6v5.65H3V6zm2.566 2.43v.609H3.627v-.61zM6.726 6v.613H3.627V6zm1.892 3.92-.636-.153.244-2.215h2.414v.66H8.886l-.114 1.025q.093-.057.271-.115.18-.06.407-.06.314 0 .56.103.247.099.42.289.174.19.261.464.09.27.09.615 0 .301-.09.566-.087.262-.268.467-.18.202-.455.32a1.7 1.7 0 01-.645.114q-.28 0-.54-.081a1.5 1.5 0 01-.46-.244 1.2 1.2 0 01-.329-.398 1.3 1.3 0 01-.132-.54h.786q.02.203.109.344a.6.6 0 00.229.217q.145.075.334.075a.64.64 0 00.296-.063.6.6 0 00.208-.184.8.8 0 00.12-.277q.04-.16.04-.35a1.2 1.2 0 00-.046-.334.7.7 0 00-.139-.265.6.6 0 00-.235-.172.8.8 0 00-.325-.06.8.8 0 00-.386.075q-.132.075-.235.178m5.683-2.368v.434l-1.723 3.954h-.841l1.723-3.76h-2.23v-.628z"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  file: {
    body: '<g fill="none"><path fill="currentColor" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M2 4.624v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.484-.547-.967-1.094-.967H6.239z"/></g>'
  },
  "file-link": {
    body: '<g fill="none"><g clip-path="url(#svgID1)"><mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:luminance"><path fill="#fff" d="M20 0H0v20h20z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="m19.636 10.315-5.574-.55a.349.349 0 00-.317.553l.889 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.13a.348.348 0 00.626-.263l-.04-.243a4.28 4.28 0 011.715-4.185l.403-.293 1.162 1.6a.35.35 0 00.623-.13l1.199-5.471a.35.35 0 00-.306-.423"/><path fill="currentColor" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M18 8V2.088c0-.484-.547-.967-1.094-.967H6.239L2 4.624v13.53c0 .605.547.967 1.094.967H11"/></g></g><defs><clipPath id="svgID1"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></g>'
  },
  "file-lock": {
    body: '<g fill="none"><g clip-path="url(#svgID0)"><g clip-path="url(#svgID1)"><path fill="currentColor" d="M18.5 13.5v-1c0-1.4-1.1-2.5-2.5-2.5s-2.5 1.1-2.5 2.5v1c-.85 0-1.5.65-1.5 1.5v3.5c0 .85.65 1.5 1.5 1.5h5c.85 0 1.5-.65 1.5-1.5V15c0-.85-.65-1.5-1.5-1.5m-4-1c0-.85.65-1.5 1.5-1.5s1.5.65 1.5 1.5v1h-3zm2.05 4.25-.05.05v.7c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-.7c-.3-.3-.35-.75-.05-1.05s.75-.35 1.05-.05c.3.25.35.75.05 1.05"/></g><path fill="currentColor" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M10 19.121H3.094c-.547 0-1.094-.362-1.094-.966V4.625L6.24 1.12h10.666c.547 0 1.094.483 1.094.967V8.5"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath><clipPath id="svgID1"><path fill="#fff" d="M12 10h8v10h-8z"/></clipPath></defs></g>'
  },
  "file-sync": {
    body: '<g fill="none"><path fill="currentColor" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/><path fill="currentColor" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M18 8.5V2.088c0-.483-.547-.967-1.094-.967H6.239L2 4.625v13.53c0 .604.547.966 1.094.966H8"/></g>'
  },
  folder: {
    body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M1 6.511V3.457c.002-.47.19-.92.524-1.252.335-.332.788-.52 1.26-.52h6.423c.473 0 .926.188 1.26.52.335.332.523.782.524 1.252v1.23h5.82c.58.002 1.136.232 1.546.64.41.406.642.958.643 1.534v8.6a2.75 2.75 0 01-.812 1.945 2.8 2.8 0 01-1.956.81H3.774a2.8 2.8 0 01-1.958-.81A2.76 2.76 0 011 15.463z"/>'
  },
  "folder-link": {
    body: '<g fill="none"><g clip-path="url(#svgID1)"><mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:luminance"><path fill="#fff" d="M20 0H0v20h20z"/></mask><g mask="url(#svgID0)"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M11.752 18.216H3.774a2.8 2.8 0 01-1.958-.81A2.76 2.76 0 011 15.46V3.456c.002-.47.19-.92.524-1.252.335-.332.788-.52 1.26-.52h6.423c.473 0 .926.188 1.26.52.335.332.523.782.524 1.252v1.23h5.82c.58.002 1.136.232 1.546.64.41.406.642.958.643 1.534V9"/><path fill="currentColor" d="m19.636 10.315-5.574-.55a.348.348 0 00-.317.553l.889 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.605-.073.35.35 0 00.021-.19l-.04-.242a4.28 4.28 0 011.715-4.185l.403-.293 1.162 1.6a.348.348 0 00.623-.13l1.199-5.471a.35.35 0 00-.306-.423"/></g></g><defs><clipPath id="svgID1"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></g>'
  },
  "folder-lock": {
    body: '<g fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M10.467 18.216H3.774a2.8 2.8 0 01-1.958-.81A2.76 2.76 0 011 15.46V3.456c.002-.47.19-.92.524-1.252.335-.332.788-.52 1.26-.52h6.423c.473 0 .926.188 1.26.52.335.332.523.782.524 1.252v1.23h5.82c.58.002 1.136.232 1.546.639S19 6.285 19 6.86V9.5"/><g clip-path="url(#svgID0)"><path fill="currentColor" d="M18.5 13.5v-1c0-1.4-1.1-2.5-2.5-2.5s-2.5 1.1-2.5 2.5v1c-.85 0-1.5.65-1.5 1.5v3.5c0 .85.65 1.5 1.5 1.5h5c.85 0 1.5-.65 1.5-1.5V15c0-.85-.65-1.5-1.5-1.5m-4-1c0-.85.65-1.5 1.5-1.5s1.5.65 1.5 1.5v1h-3zm2.05 4.25-.05.05v.7c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-.7c-.3-.3-.35-.75-.05-1.05s.75-.35 1.05-.05c.3.25.35.75.05 1.05"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M12 10h8v10h-8z"/></clipPath></defs></g>'
  },
  "folder-sync": {
    body: '<g fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8.5 18.216H3.774a2.8 2.8 0 01-1.958-.81A2.76 2.76 0 011 15.46V3.456c.002-.47.19-.92.524-1.252.335-.332.788-.52 1.26-.52h6.423c.473 0 .926.188 1.26.52.335.332.523.782.524 1.252v1.23h5.82c.58.002 1.136.232 1.546.64.41.406.642.958.643 1.534V9"/><path fill="currentColor" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  fxl: {
    body: '<g fill="none"><path fill="#000" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><circle cx="9" cy="10.5" r="3.6" stroke="#000" stroke-width=".8"/><path stroke="#000" stroke-linecap="round" stroke-width=".8" d="M14.5 10.5 6.5 6v9z"/></g>'
  },
  "fxl-link": {
    body: '<g fill="none"><path fill="#000" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><circle cx="8" cy="9.5" r="3.6" stroke="#000" stroke-width=".8"/><path stroke="#000" stroke-linecap="round" stroke-width=".8" d="M13.5 9.5 5.5 5v9z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.348.348 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "fxl-sync": {
    body: '<g fill="none"><path fill="#000" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><circle cx="8" cy="9.5" r="3.6" stroke="#000" stroke-width=".8"/><path stroke="#000" stroke-linecap="round" stroke-width=".8" d="M13.5 9.5 5.5 5v9z"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  image: {
    body: '<g fill="none"><path fill="#28AFEA" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#28AFEA" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><path stroke="#28AFEA" d="M14.658 5.04c0 .854-.688 1.541-1.53 1.541s-1.53-.687-1.53-1.54c0-.854.687-1.541 1.53-1.541.842 0 1.53.687 1.53 1.54Z"/><path stroke="#28AFEA" stroke-linecap="round" stroke-linejoin="round" d="m2 12.19 4.226-5.11L18 17.933m-6.496-6.363 2.436-2.04L18 13.203"/></g>'
  },
  "image-link": {
    body: '<g fill="none"><path fill="#28AFEA" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#28AFEA" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path stroke="#28AFEA" d="M13.658 5.04c0 .854-.688 1.541-1.53 1.541s-1.53-.687-1.53-1.54c0-.854.687-1.541 1.53-1.541.842 0 1.53.687 1.53 1.54Z"/><path stroke="#28AFEA" stroke-linecap="round" stroke-linejoin="round" d="m1 12.19 4.226-5.11L14 15m-3.496-3.43 2.436-2.04L17 13.203"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.348.348 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "image-sync": {
    body: '<g fill="none"><path fill="#28AFEA" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#28AFEA" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path stroke="#28AFEA" d="M13.658 5.04c0 .854-.688 1.541-1.53 1.541s-1.53-.687-1.53-1.54c0-.854.687-1.541 1.53-1.541.842 0 1.53.687 1.53 1.54Z"/><path stroke="#28AFEA" stroke-linecap="round" stroke-linejoin="round" d="m1 12.19 4.226-5.11L11.5 13m-.996-1.43 2.436-2.04L14.5 11"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  kml: {
    body: '<g fill="none"><path fill="#4CAF50" fill-rule="evenodd" d="M6.241.999v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#4CAF50" stroke-linecap="round" stroke-linejoin="round" d="M2 4.623v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.087c0-.484-.547-.967-1.094-.967H6.239z"/><g clip-path="url(#svgID0)"><path fill="#4CAF50" d="M4.24 8.023V13H3.3V8.023zm2.988 0L5.232 10.45 4.09 11.67l-.167-.912.793-1.029 1.36-1.706zM6.182 13l-1.548-2.331.673-.609L7.3 13zm1.965-4.977h.814l1.36 3.747 1.357-3.747h.817L10.646 13h-.653zm-.41 0h.797l.143 3.442V13h-.94zm4.368 0h.8V13h-.94v-1.535zm4.915 4.239V13h-2.5v-.738zm-2.218-4.239V13h-.94V8.023z"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M2.5 8h15v5h-15z"/></clipPath></defs></g>'
  },
  "kml-link": {
    body: '<g fill="none"><path fill="#4CAF50" fill-rule="evenodd" d="M5.241.998v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#4CAF50" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.12H2.094c-.547 0-1.094-.363-1.094-.967V4.623l4.24-3.504h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#4CAF50" d="M3.926 5.8v4.266H3.12V5.8zm2.56 0-1.71 2.08-.98 1.046-.143-.782.68-.882L5.499 5.8zm-.896 4.266L4.263 8.068l.577-.522 1.708 2.52zM7.274 5.8h.698l1.166 3.211 1.163-3.21h.7l-1.585 4.265h-.56zm-.351 0h.682l.124 2.95v1.316h-.806zm3.744 0h.685v4.266h-.805V8.75zm4.213 3.633v.633h-2.145v-.633zM12.978 5.8v4.266h-.805V5.8z"/><path fill="#726F74" d="m18.955 10.313-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.069a5.005 5.005 0 00-1.106 6.983l.82 1.13a.348.348 0 00.605-.074.35.35 0 00.021-.19l-.04-.242a4.28 4.28 0 011.716-4.185l.402-.292 1.162 1.599a.348.348 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>',
    height: 21
  },
  "kml-sync": {
    body: '<g fill="none"><path fill="#4CAF50" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#4CAF50" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#4CAF50" d="M3.926 5.802v4.265H3.12V5.802zm2.56 0-1.71 2.08-.98 1.046-.143-.783.68-.881 1.166-1.462zm-.896 4.265L4.263 8.07l.577-.521 1.708 2.52zm1.684-4.265h.698l1.166 3.21 1.163-3.21h.7l-1.585 4.265h-.56zm-.351 0h.682l.124 2.95v1.315h-.806zm3.744 0h.685v4.265h-.805V8.752zm4.213 3.633v.632h-2.145v-.632zm-1.902-3.633v4.265h-.805V5.802z"/><path fill="#726F74" d="M17.14 12.466a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.703a.473.473 0 01.807.333v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  las: {
    body: '<g fill="none"><path stroke="#388E3C" stroke-linecap="round" stroke-linejoin="round" d="M2 4.623v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.087c0-.484-.547-.967-1.094-.967H6.239z"/><path fill="#388E3C" fill-rule="evenodd" d="M6.241.999v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><g clip-path="url(#svgID0)"><path fill="#388E3C" d="M7.231 12.262V13H4.73v-.738zM5.013 8.023V13h-.94V8.023zm4.895.756L8.489 13h-.994l1.859-4.977h.636zM11.094 13 9.668 8.779l-.085-.756h.64L12.091 13zm-.065-1.85v.743h-2.67v-.742zm4.18.558a.7.7 0 00-.044-.256.5.5 0 00-.154-.209 1.2 1.2 0 00-.311-.184 4 4 0 00-.513-.192 6 6 0 01-.65-.246 2.6 2.6 0 01-.53-.318q-.225-.18-.351-.417a1.2 1.2 0 01-.127-.553q0-.308.13-.561.133-.253.376-.434.243-.185.571-.284.332-.099.731-.099.555 0 .957.202.407.2.63.547.221.345.221.775h-.936a.83.83 0 00-.1-.41.67.67 0 00-.293-.28 1.05 1.05 0 00-.492-.102q-.288 0-.479.085a.65.65 0 00-.284.232.6.6 0 00-.092.329q0 .136.065.246.065.105.195.201.13.093.321.175.195.078.451.157.41.123.718.273.312.15.516.342a1.25 1.25 0 01.417.974q0 .322-.126.574a1.2 1.2 0 01-.362.431 1.7 1.7 0 01-.568.27 2.7 2.7 0 01-.735.092q-.361 0-.717-.095a2.2 2.2 0 01-.64-.294 1.5 1.5 0 01-.458-.5 1.4 1.4 0 01-.17-.71h.943a1 1 0 00.075.403q.079.165.219.27a1 1 0 00.335.15q.19.048.413.048.288 0 .472-.078a.6.6 0 00.28-.226.6.6 0 00.096-.328"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M3.5 7h13v7h-13z"/></clipPath></defs></g>'
  },
  "las-link": {
    body: '<g fill="none"><path stroke="#388E3C" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#388E3C" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path fill="#388E3C" d="M6.627 9.367V10H4.482v-.633zM4.726 5.734V10H3.92V5.734zm4.195.648L7.705 10h-.852l1.593-4.266h.545zM9.938 10 8.716 6.382l-.073-.648h.547L10.793 10zm-.056-1.585v.636H7.594v-.636zm3.583.478a.6.6 0 00-.038-.22.4.4 0 00-.132-.179 1 1 0 00-.267-.158 4 4 0 00-.44-.164 5 5 0 01-.556-.211 2.2 2.2 0 01-.454-.273 1.2 1.2 0 01-.302-.357 1 1 0 01-.108-.475q0-.263.111-.48.114-.218.323-.372a1.5 1.5 0 01.489-.243q.284-.085.627-.085.475 0 .82.173.348.172.54.468.19.297.19.665h-.803a.7.7 0 00-.085-.351.6.6 0 00-.252-.24.9.9 0 00-.422-.088q-.245 0-.41.073a.55.55 0 00-.243.2.5.5 0 00-.08.28q.001.118.056.211.056.091.167.173.112.08.276.15.167.068.386.134.352.106.616.235.266.128.442.293a1.07 1.07 0 01.357.835q0 .274-.108.492a1.04 1.04 0 01-.31.369 1.4 1.4 0 01-.487.231q-.28.08-.63.08-.31 0-.615-.082a1.9 1.9 0 01-.548-.252 1.3 1.3 0 01-.392-.428 1.2 1.2 0 01-.147-.61h.809q0 .202.064.346.068.14.188.232a.8.8 0 00.287.129q.164.04.354.04.247 0 .405-.067a.495.495 0 00.322-.475"/><path fill="#726F74" d="m18.955 10.314-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.069a5.005 5.005 0 00-1.106 6.983l.82 1.13a.348.348 0 00.605-.074.35.35 0 00.021-.19l-.04-.242a4.28 4.28 0 011.716-4.185l.402-.293 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.422"/></g>'
  },
  "las-sync": {
    body: '<g fill="none"><path stroke="#388E3C" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#388E3C" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path fill="#388E3C" d="M6.627 9.367V10H4.482v-.633zM4.726 5.734V10H3.92V5.734zm4.195.648L7.705 10h-.852l1.593-4.266h.545zM9.938 10 8.716 6.382l-.073-.648h.547L10.793 10zm-.056-1.585v.636H7.594v-.636zm3.583.478a.6.6 0 00-.038-.22.4.4 0 00-.132-.179 1 1 0 00-.267-.158 4 4 0 00-.44-.164 5 5 0 01-.556-.211 2.2 2.2 0 01-.454-.273 1.2 1.2 0 01-.302-.357 1 1 0 01-.108-.475q0-.263.111-.48.114-.218.323-.372a1.5 1.5 0 01.489-.243q.284-.085.627-.085.475 0 .82.173.348.172.54.468.19.297.19.665h-.803a.7.7 0 00-.085-.351.6.6 0 00-.252-.24.9.9 0 00-.422-.088q-.245 0-.41.073a.55.55 0 00-.243.2.5.5 0 00-.08.28q.001.118.056.211.056.091.167.173.112.08.276.15.167.068.386.134.352.106.616.235.266.128.442.293a1.07 1.07 0 01.357.835q0 .274-.108.492a1.04 1.04 0 01-.31.369 1.4 1.4 0 01-.487.231q-.28.08-.63.08-.31 0-.615-.082a1.9 1.9 0 01-.548-.252 1.3 1.3 0 01-.392-.428 1.2 1.2 0 01-.147-.61h.809q0 .202.064.346.068.14.188.232a.8.8 0 00.287.129q.164.04.354.04.247 0 .405-.067a.495.495 0 00.322-.475"/><path fill="#726F74" d="M17.14 12.466a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.703a.473.473 0 01.807.333v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  laz: {
    body: '<g fill="none"><path fill="#388E3C" fill-rule="evenodd" d="M6.241.999v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#388E3C" stroke-linecap="round" stroke-linejoin="round" d="M2 4.623v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.087c0-.484-.547-.967-1.094-.967H6.239z"/><path fill="#388E3C" d="M7.158 12.262V13H4.656v-.738zM4.94 8.023V13H4V8.023zm4.894.756L8.416 13h-.995l1.86-4.977h.636zM11.021 13 9.595 8.779l-.085-.756h.639L12.019 13zm-.065-1.85v.743h-2.67v-.742zm5.116 1.112V13H12.58v-.738zm-.065-3.688L12.965 13h-.646v-.564l3.056-4.413h.632zm-.335-.55v.741H12.33v-.742z"/></g>'
  },
  "laz-link": {
    body: '<g fill="none"><path fill="#388E3C" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#388E3C" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#388E3C" d="M6.642 9.367V10H4.497v-.633zM4.74 5.734V10h-.805V5.734zm4.196.648L7.72 10h-.853l1.594-4.266h.545zM9.952 10 8.73 6.382l-.073-.648h.548L10.808 10zm-.056-1.585v.636H7.608v-.636zm4.386.952V10h-2.994v-.633zm-.055-3.161L11.619 10h-.554v-.483l2.62-3.783h.542zm-.287-.472v.636h-2.866v-.636z"/><path fill="#726F74" d="m18.955 10.314-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.069a5.005 5.005 0 00-1.106 6.983l.82 1.13a.348.348 0 00.605-.074.35.35 0 00.021-.19l-.04-.242a4.28 4.28 0 011.716-4.185l.402-.293 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.422"/></g>'
  },
  "laz-sync": {
    body: '<g fill="none"><path fill="#388E3C" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#388E3C" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#388E3C" d="M6.642 9.367V10H4.497v-.633zM4.74 5.734V10h-.805V5.734zm4.196.648L7.72 10h-.853l1.594-4.266h.545zM9.952 10 8.73 6.382l-.073-.648h.548L10.808 10zm-.056-1.585v.636H7.608v-.636zm4.386.952V10h-2.994v-.633zm-.055-3.161L11.619 10h-.554v-.483l2.62-3.783h.542zm-.287-.472v.636h-2.866v-.636z"/><path fill="#726F74" d="M17.14 12.466a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.703a.473.473 0 01.807.333v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  liscad: {
    body: '<g fill="none"><path fill="#B13132" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#B13132" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><path fill="#B13132" d="M10.275 5h-2.8L4.5 15.5h9.45l.7-2.275H8z"/><path fill="#B13132" fill-rule="evenodd" d="M12.025 8.15a.18.18 0 01.175.185v2.78a.18.18 0 01-.175.185.18.18 0 01-.175-.185v-2.78a.18.18 0 01.175-.185" clip-rule="evenodd"/><path fill="#B13132" fill-rule="evenodd" d="M13.894 11.795a.175.175 0 01-.222.109l-1.656-.566a.175.175 0 01.113-.331l1.656.565c.091.032.14.131.109.223" clip-rule="evenodd"/><path fill="#B13132" fill-rule="evenodd" d="M10.316 11.998a.175.175 0 01.084-.232l1.586-.742a.175.175 0 01.148.317l-1.585.742a.175.175 0 01-.233-.085" clip-rule="evenodd"/><path fill="#B13132" d="m12.025 6.4.455 2.1h-.91zm3.695 5.952-2.135-.248.294-.861zm-7.148.461 1.71-1.301.385.824z"/></g>'
  },
  "liscad-link": {
    body: '<g fill="none"><path fill="#B13132" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#B13132" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#B13132" d="M9.275 4h-2.8L3.5 14.5h9.45l.7-2.275H7z"/><path fill="#B13132" fill-rule="evenodd" d="M11.025 7.15a.18.18 0 01.175.185v2.78a.18.18 0 01-.175.185.18.18 0 01-.175-.185v-2.78a.18.18 0 01.175-.185" clip-rule="evenodd"/><path fill="#B13132" fill-rule="evenodd" d="M12.894 10.795a.175.175 0 01-.222.109l-1.656-.566a.175.175 0 01.113-.331l1.656.565c.091.032.14.131.109.223" clip-rule="evenodd"/><path fill="#B13132" fill-rule="evenodd" d="M9.316 10.998a.175.175 0 01.084-.232l1.586-.742a.175.175 0 01.148.317l-1.585.742a.175.175 0 01-.233-.085" clip-rule="evenodd"/><path fill="#B13132" d="m11.025 5.4.455 2.1h-.91zm3.695 5.952-2.135-.248.294-.861zm-7.148.461 1.71-1.301.385.824z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.348.348 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "liscad-sync": {
    body: '<g fill="none"><path fill="#B13132" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#B13132" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#B13132" d="M9.275 4h-2.8L3.5 14.5H11l1-2.275H7z"/><path fill="#B13132" fill-rule="evenodd" d="M11.025 7.15a.18.18 0 01.175.185v2.78a.18.18 0 01-.175.185.18.18 0 01-.175-.185v-2.78a.18.18 0 01.175-.185" clip-rule="evenodd"/><path fill="#B13132" fill-rule="evenodd" d="M12.894 10.795a.175.175 0 01-.222.109l-1.656-.566a.175.175 0 01.113-.331l1.656.565c.091.032.14.131.109.223" clip-rule="evenodd"/><path fill="#B13132" fill-rule="evenodd" d="M9.316 10.998a.175.175 0 01.084-.232l1.586-.742a.175.175 0 01.148.317l-1.585.742a.175.175 0 01-.233-.085" clip-rule="evenodd"/><path fill="#B13132" d="m11.025 5.4.455 2.1h-.91zm3.695 5.952-2.135-.248.294-.861zm-7.148.461 1.71-1.301.385.824z"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  mjf: {
    body: '<g fill="none"><path fill="#26C6DA" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#26C6DA" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><path fill="#26C6DA" d="M4.372 8h.737l1.233 3.234L7.572 8h.74l-1.675 4.297h-.592zM4 8h.722l.13 2.972v1.325H4zm3.96 0h.725v4.297h-.852v-1.325zm3.433 2.992V8h.852v2.992q0 .428-.195.735-.195.304-.533.466-.339.162-.762.162-.438 0-.775-.138a1.16 1.16 0 01-.53-.431q-.189-.29-.189-.735h.855a.84.84 0 00.078.39.46.46 0 00.22.212.8.8 0 00.34.065.65.65 0 00.332-.082.6.6 0 00.226-.248.9.9 0 00.08-.396M13.943 8v4.297h-.852V8zm1.818 1.856v.64H13.72v-.64zM16 8v.64h-2.28V8z"/></g>'
  },
  "mjf-link": {
    body: '<g fill="none"><path fill="#26C6DA" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#26C6DA" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#26C6DA" d="M3.372 6h.737l1.233 3.234L6.572 6h.74l-1.675 4.296h-.592zM3 6h.722l.13 2.971v1.325H3zm3.96 0h.725v4.296h-.852V8.971zm3.433 2.992V6h.852v2.992q0 .427-.195.735-.195.304-.533.466-.339.162-.763.162-.436 0-.774-.138a1.16 1.16 0 01-.53-.431q-.189-.29-.189-.735h.855a.84.84 0 00.078.39.46.46 0 00.22.212.8.8 0 00.34.065.65.65 0 00.332-.083.6.6 0 00.226-.247.9.9 0 00.08-.396M12.943 6v4.296h-.852V6zm1.818 1.856v.64H12.72v-.64zM15 6v.64h-2.28V6z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.349.349 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "mjf-sync": {
    body: '<g fill="none"><path fill="#26C6DA" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#26C6DA" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#26C6DA" d="M3.372 6h.737l1.233 3.234L6.572 6h.74l-1.675 4.296h-.592zM3 6h.722l.13 2.971v1.325H3zm3.96 0h.725v4.296h-.852V8.971zm3.433 2.992V6h.852v2.992q0 .427-.195.735-.195.304-.533.466-.339.162-.763.162-.436 0-.774-.138a1.16 1.16 0 01-.53-.431q-.189-.29-.189-.735h.855a.84.84 0 00.078.39.46.46 0 00.22.212.8.8 0 00.34.065.65.65 0 00.332-.083.6.6 0 00.226-.247.9.9 0 00.08-.396M12.943 6v4.296h-.852V6zm1.818 1.856v.64H12.72v-.64zM15 6v.64h-2.28V6z"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  mtl: {
    body: '<g fill="none"><path fill="#8D6E63" fill-rule="evenodd" d="M6.241.999v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#8D6E63" stroke-linecap="round" stroke-linejoin="round" d="M2 4.623v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.087c0-.484-.547-.967-1.094-.967H6.239z"/><path fill="#8D6E63" d="M3.81 8.023h.814l1.36 3.747 1.357-3.747h.817L6.308 13h-.652zm-.41 0h.796l.144 3.442V13H3.4zm4.368 0h.8V13h-.94v-1.535zm3.79 0V13h-.936V8.023zm1.546 0v.742h-4.01v-.742zm3.783 4.239V13h-2.502v-.738zM14.67 8.023V13h-.94V8.023z"/></g>'
  },
  "mtl-link": {
    body: '<g fill="none"><path fill="#8D6E63" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#8D6E63" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#8D6E63" d="M3.552 5.8h.697l1.166 3.21L6.578 5.8h.7l-1.585 4.265h-.56zm-.352 0h.683l.123 2.95v1.315H3.2zm3.744 0h.686v4.265h-.806V8.75zm3.25 0v4.265H9.39V5.8zm1.324 0v.636H8.08V5.8zm3.243 3.633v.632h-2.145v-.632zM12.859 5.8v4.265h-.805V5.8z"/><path fill="#726F74" d="m18.955 10.314-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.069a5.005 5.005 0 00-1.106 6.983l.82 1.13a.348.348 0 00.605-.074.35.35 0 00.021-.19l-.04-.242a4.28 4.28 0 011.716-4.185l.402-.293 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.422"/></g>'
  },
  "mtl-sync": {
    body: '<g fill="none"><path fill="#8D6E63" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#8D6E63" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#8D6E63" d="M3.552 5.8h.697l1.166 3.21L6.578 5.8h.7l-1.585 4.265h-.56zm-.352 0h.683l.123 2.95v1.315H3.2zm3.744 0h.686v4.265h-.806V8.75zm3.25 0v4.265H9.39V5.8zm1.324 0v.636H8.08V5.8zm3.243 3.633v.632h-2.145v-.632zM12.859 5.8v4.265h-.805V5.8z"/><path fill="#726F74" d="M17.14 12.466a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.703a.473.473 0 01.807.333v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  obj: {
    body: '<g fill="none"><path fill="#7A7A7A" fill-rule="evenodd" d="M6.241.999v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#7A7A7A" stroke-linecap="round" stroke-linejoin="round" d="M2 4.623v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.087c0-.484-.547-.967-1.094-.967H6.239z"/><path fill="#7A7A7A" d="M7.918 10.385v.257a3.2 3.2 0 01-.15 1.015q-.15.447-.427.762-.277.314-.66.482a2.1 2.1 0 01-.85.167q-.463 0-.849-.167a1.9 1.9 0 01-.663-.482 2.2 2.2 0 01-.434-.762q-.153-.452-.154-1.015v-.257q0-.567.154-1.015t.43-.762q.277-.318.66-.485.387-.168.848-.168.468 0 .851.168.383.167.66.485.28.315.43.762.154.448.154 1.015m-.95.257v-.264q0-.406-.075-.714a1.6 1.6 0 00-.222-.523.95.95 0 00-.362-.318 1.06 1.06 0 00-.486-.11q-.273 0-.485.11a.96.96 0 00-.356.318 1.6 1.6 0 00-.225.523q-.075.308-.075.714v.264q0 .403.075.714.078.311.225.526.15.213.363.322.212.108.485.109.273 0 .485-.11a.96.96 0 00.356-.32q.147-.216.222-.527.075-.31.075-.714m3.654.14H9.351l-.007-.663h1.09q.28 0 .468-.079a.6.6 0 00.383-.595q0-.24-.092-.39a.5.5 0 00-.28-.218 1.4 1.4 0 00-.486-.072h-.772V13h-.94V8.023h1.712q.424 0 .756.082.335.08.567.247t.352.42q.123.254.123.602 0 .307-.143.567-.141.256-.434.417-.29.16-.739.184zM10.582 13H9.073l.393-.738h1.114q.28 0 .462-.093a.6.6 0 00.273-.253.75.75 0 00.092-.376.9.9 0 00-.082-.403.56.56 0 00-.253-.263.95.95 0 00-.45-.092h-.978l.006-.663h1.245l.215.256q.43.004.7.17.274.169.404.432t.13.567q0 .479-.209.803-.204.326-.601.489-.393.164-.954.164m4.606-1.51V8.022h.94v3.466q0 .495-.215.851-.215.352-.588.54a1.84 1.84 0 01-.84.188 2.1 2.1 0 01-.855-.16 1.3 1.3 0 01-.585-.5q-.208-.334-.208-.85h.943q0 .28.086.45a.52.52 0 00.242.247.9.9 0 00.376.075.7.7 0 00.366-.096.66.66 0 00.25-.287q.088-.188.088-.458"/></g>'
  },
  "obj-link": {
    body: '<g fill="none"><path fill="#7A7A7A" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#7A7A7A" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#7A7A7A" d="M7.216 7.759v.22q0 .483-.13.87a1.9 1.9 0 01-.365.653q-.238.27-.566.413a1.8 1.8 0 01-.73.144q-.395 0-.726-.144a1.6 1.6 0 01-.568-.413 1.9 1.9 0 01-.372-.653 2.7 2.7 0 01-.132-.87v-.22q0-.486.132-.87.131-.384.369-.654.238-.272.565-.416.331-.143.727-.143.401 0 .73.143.328.144.565.416.24.27.369.654.132.384.132.87m-.815.22v-.226q0-.349-.064-.612a1.3 1.3 0 00-.19-.449.8.8 0 00-.311-.272.9.9 0 00-.416-.094.83.83 0 00-.72.366 1.4 1.4 0 00-.194.449q-.065.263-.065.612v.226q0 .345.065.612.068.267.193.451.13.182.31.275.182.094.417.094a.82.82 0 00.72-.37 1.4 1.4 0 00.19-.45q.065-.267.065-.612m3.132.12h-1.09l-.005-.569h.934q.24 0 .401-.067a.51.51 0 00.329-.51.63.63 0 00-.08-.334.44.44 0 00-.24-.187 1.2 1.2 0 00-.416-.062h-.662V10h-.806V5.734h1.468q.363 0 .648.07.287.068.486.212a.9.9 0 01.302.36q.105.217.105.516a1 1 0 01-.123.486.9.9 0 01-.372.357 1.5 1.5 0 01-.633.159zM9.498 10H8.206l.337-.633h.955a.9.9 0 00.396-.079.53.53 0 00.234-.217.65.65 0 00.079-.322.8.8 0 00-.07-.346.48.48 0 00-.217-.225.8.8 0 00-.387-.08h-.838l.006-.568h1.067l.184.22q.369.002.6.146a.9.9 0 01.346.37q.112.225.112.486 0 .41-.179.688a1.07 1.07 0 01-.516.42q-.337.14-.817.14m3.95-1.295v-2.97h.805v2.97q0 .424-.185.73a1.23 1.23 0 01-.503.462 1.6 1.6 0 01-.721.162q-.414 0-.733-.138a1.1 1.1 0 01-.5-.428q-.18-.286-.18-.73h.81q0 .24.072.387a.45.45 0 00.208.211q.138.065.323.065a.6.6 0 00.313-.082.56.56 0 00.214-.246.9.9 0 00.076-.393"/><path fill="#726F74" d="m18.955 10.314-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.069a5.005 5.005 0 00-1.106 6.983l.82 1.13a.348.348 0 00.605-.074.35.35 0 00.021-.19l-.04-.242a4.28 4.28 0 011.716-4.185l.402-.293 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.422"/></g>'
  },
  "obj-sync": {
    body: '<g fill="none"><path fill="#7A7A7A" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#7A7A7A" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#7A7A7A" d="M7.216 7.759v.22q0 .483-.13.87a1.9 1.9 0 01-.365.653q-.238.27-.566.413a1.8 1.8 0 01-.73.144q-.395 0-.726-.144a1.6 1.6 0 01-.568-.413 1.9 1.9 0 01-.372-.653 2.7 2.7 0 01-.132-.87v-.22q0-.486.132-.87.131-.384.369-.654.238-.272.565-.416.331-.143.727-.143.401 0 .73.143.328.144.565.416.24.27.369.654.132.384.132.87m-.815.22v-.226q0-.349-.064-.612a1.3 1.3 0 00-.19-.449.8.8 0 00-.311-.272.9.9 0 00-.416-.094.83.83 0 00-.72.366 1.4 1.4 0 00-.194.449q-.065.263-.065.612v.226q0 .345.065.612.068.267.193.451.13.182.31.275.182.094.417.094a.82.82 0 00.72-.37 1.4 1.4 0 00.19-.45q.065-.267.065-.612m3.132.12h-1.09l-.005-.569h.934q.24 0 .401-.067a.51.51 0 00.329-.51.63.63 0 00-.08-.334.44.44 0 00-.24-.187 1.2 1.2 0 00-.416-.062h-.662V10h-.806V5.734h1.468q.363 0 .648.07.287.068.486.212a.9.9 0 01.302.36q.105.217.105.516a1 1 0 01-.123.486.9.9 0 01-.372.357 1.5 1.5 0 01-.633.159zM9.498 10H8.206l.337-.633h.955a.9.9 0 00.396-.079.53.53 0 00.234-.217.65.65 0 00.079-.322.8.8 0 00-.07-.346.48.48 0 00-.217-.225.8.8 0 00-.387-.08h-.838l.006-.568h1.067l.184.22q.369.002.6.146a.9.9 0 01.346.37q.112.225.112.486 0 .41-.179.688a1.07 1.07 0 01-.516.42q-.337.14-.817.14m3.95-1.295v-2.97h.805v2.97q0 .424-.185.73a1.23 1.23 0 01-.503.462 1.6 1.6 0 01-.721.162q-.414 0-.733-.138a1.1 1.1 0 01-.5-.428q-.18-.286-.18-.73h.81q0 .24.072.387a.45.45 0 00.208.211q.138.065.323.065a.6.6 0 00.313-.082.56.56 0 00.214-.246.9.9 0 00.076-.393"/><path fill="#726F74" d="M17.14 12.466a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.703a.473.473 0 01.807.333v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  pdf: {
    body: '<g fill="none"><path fill="#FF2116" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#FF2116" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><path fill="#FF2116" d="M5.873 11.223H4.62v-.752h1.254q.309 0 .499-.105a.67.67 0 00.284-.293 1 1 0 00.09-.428q0-.234-.09-.436a.75.75 0 00-.284-.327.9.9 0 00-.499-.126H4.92v4.318H4V8h1.874q.568 0 .97.212.405.21.615.582.214.37.214.844 0 .491-.214.847a1.4 1.4 0 01-.615.547q-.402.19-.97.191m3.978 1.85h-1.05l.006-.752h1.044q.425 0 .713-.195.287-.2.435-.568a2.4 2.4 0 00.147-.892v-.262q0-.4-.084-.707a1.4 1.4 0 00-.247-.516 1.04 1.04 0 00-.398-.317 1.3 1.3 0 00-.546-.108h-1.09V8h1.09q.489 0 .89.17.405.171.7.492.298.317.454.76.16.443.16.99v.254q0 .543-.16.99a2.1 2.1 0 01-.455.76q-.294.316-.702.487t-.907.17M9.316 8v5.074h-.92V8zm4.463 0v5.074h-.92V8zm1.963 2.192v.756h-2.204v-.756zM16 8v.756h-2.462V8z"/></g>'
  },
  "pdf-link": {
    body: '<g fill="none"><path fill="#FF2116" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#FF2116" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#FF2116" d="M4.873 9.223H3.62v-.752h1.254q.309 0 .499-.105a.67.67 0 00.284-.293 1 1 0 00.09-.428q0-.234-.09-.436a.75.75 0 00-.284-.327.9.9 0 00-.499-.126H3.92v4.318H3V6h1.873q.57 0 .97.213.406.208.616.582.214.369.214.843 0 .491-.214.847a1.4 1.4 0 01-.615.547q-.402.192-.97.191m3.978 1.85h-1.05l.006-.752h1.044q.424 0 .713-.195.287-.198.435-.568.147-.373.147-.892v-.261q0-.401-.084-.708a1.4 1.4 0 00-.247-.516 1.04 1.04 0 00-.399-.317 1.3 1.3 0 00-.545-.108h-1.09V6h1.09q.488 0 .89.17.405.172.7.492.297.318.454.76.16.443.16.99v.254q0 .543-.16.99a2.1 2.1 0 01-.455.76q-.294.316-.702.487t-.907.17M8.316 6v5.074h-.92V6zm4.463 0v5.074h-.92V6zm1.963 2.192v.756h-2.204v-.756zM15 6v.756h-2.462V6z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.349.349 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "pdf-sync": {
    body: '<g fill="none"><path fill="#FF2116" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#FF2116" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#FF2116" d="M4.873 9.223H3.62v-.752h1.254q.309 0 .499-.105a.67.67 0 00.284-.293 1 1 0 00.09-.428q0-.234-.09-.436a.75.75 0 00-.284-.327.9.9 0 00-.499-.126H3.92v4.318H3V6h1.873q.57 0 .97.213.406.208.616.582.214.369.214.843 0 .491-.214.847a1.4 1.4 0 01-.615.547q-.402.192-.97.191m3.978 1.85h-1.05l.006-.752h1.044q.424 0 .713-.195.287-.198.435-.568.147-.373.147-.892v-.261q0-.401-.084-.708a1.4 1.4 0 00-.247-.516 1.04 1.04 0 00-.399-.317 1.3 1.3 0 00-.545-.108h-1.09V6h1.09q.488 0 .89.17.405.172.7.492.297.318.454.76.16.443.16.99v.254q0 .543-.16.99a2.1 2.1 0 01-.455.76q-.294.316-.702.487t-.907.17M8.316 6v5.074h-.92V6zm4.463 0v5.074h-.92V6zm1.963 2.192v.756h-2.204v-.756zM15 6v.756h-2.462V6z"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  ply: {
    body: '<g fill="none"><path fill="#00BCD4" fill-rule="evenodd" d="M6.241.999v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#00BCD4" stroke-linecap="round" stroke-linejoin="round" d="M2 4.623v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.087c0-.484-.547-.967-1.094-.967H6.239z"/><path stroke="#00BCD4" stroke-linecap="round" d="M9.975 11.619v4.28m0-4.28L14 9.399m-4.025 2.22L6 9.399m3.443-2.854c.33-.194.735-.194 1.064 0l3.311 1.956c.33.195.532.554.532.942v3.912c0 .39-.203.748-.532.943l-3.311 1.956c-.33.194-.735.194-1.064 0l-3.311-1.956a1.09 1.09 0 01-.532-.943V9.443c0-.388.203-.747.532-.942z"/></g>'
  },
  "ply-link": {
    body: '<g fill="none"><path fill="#00BCD4" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#00BCD4" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.483 1.094.967V9"/><path stroke="#00BCD4" stroke-linecap="round" d="M8.975 10.619v4.28m0-4.28L13 8.399m-4.025 2.22L5 8.399m3.443-2.854c.33-.194.735-.194 1.064 0l3.311 1.956c.33.195.532.554.532.942v3.912c0 .39-.203.748-.532.943l-3.311 1.956c-.33.194-.735.194-1.064 0l-3.311-1.956a1.09 1.09 0 01-.532-.943V8.443c0-.388.203-.747.532-.942z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.13a.348.348 0 00.627-.263l-.041-.243a4.28 4.28 0 011.716-4.185l.402-.293 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.422"/></g>'
  },
  "ply-sync": {
    body: '<g fill="none"><path fill="#00BCD4" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#00BCD4" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path stroke="#00BCD4" stroke-linecap="round" d="M8.975 10.619v4.28m0-4.28L13 8.399m-4.025 2.22L5 8.399m3.443-2.854c.33-.194.735-.194 1.064 0l3.311 1.956c.33.195.532.554.532.942v3.912c0 .39-.203.748-.532.943l-3.311 1.956c-.33.194-.735.194-1.064 0l-3.311-1.956a1.09 1.09 0 01-.532-.943V8.443c0-.388.203-.747.532-.942z"/><path fill="#726F74" d="M17.14 12.466a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.703a.473.473 0 01.807.333v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  png: {
    body: '<g fill="none"><path fill="#A066AA" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#A066AA" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><path fill="#A066AA" d="M5.723 10.772H4.57v-.633h1.154q.284 0 .459-.088a.6.6 0 00.261-.246.76.76 0 00.083-.36.8.8 0 00-.083-.367.65.65 0 00-.261-.275.9.9 0 00-.459-.106h-.877v3.631H4V8.062h1.723q.523 0 .892.178.373.176.567.49.195.31.196.709 0 .413-.196.712-.194.3-.567.46a2.2 2.2 0 01-.892.161m5.92-2.71v4.266h-.85L8.89 9.368v2.96h-.846V8.062h.846l1.911 2.962V8.062zM16 10.122v1.661q-.1.12-.31.261t-.548.243a3 3 0 01-.831.1q-.428 0-.782-.135a1.69 1.69 0 01-1.003-1.046 2.5 2.5 0 01-.138-.87v-.282q0-.489.129-.87.132-.381.375-.645.247-.264.588-.401.345-.138.77-.138.568 0 .935.179.368.178.566.492.197.311.246.715h-.825a1.1 1.1 0 00-.135-.39.7.7 0 00-.29-.263 1 1 0 00-.48-.097 1 1 0 00-.44.094.86.86 0 00-.32.272 1.3 1.3 0 00-.196.443 2.6 2.6 0 00-.065.603v.288q0 .342.074.61.075.262.212.444.142.18.348.273.21.09.474.09.24 0 .397-.037.16-.041.255-.097a.7.7 0 00.148-.108v-.8h-.89v-.59z"/></g>'
  },
  "png-link": {
    body: '<g fill="none"><path fill="#A066AA" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#A066AA" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#A066AA" d="M4.723 8.772H3.57V8.14h1.154q.284 0 .459-.088a.6.6 0 00.261-.246.76.76 0 00.083-.36.8.8 0 00-.083-.367.65.65 0 00-.261-.275.9.9 0 00-.459-.106h-.877v3.631H3V6.062h1.723q.523 0 .892.178.373.176.567.49.195.31.196.709 0 .413-.196.712-.194.3-.567.46a2.2 2.2 0 01-.892.161m5.92-2.71v4.266h-.85L7.89 7.368v2.96h-.846V6.062h.846L9.8 9.024V6.062zM15 8.122v1.661q-.1.12-.31.261t-.548.243a3 3 0 01-.831.1q-.428 0-.782-.135a1.69 1.69 0 01-1.003-1.046 2.5 2.5 0 01-.138-.87v-.282q0-.489.129-.87.132-.381.375-.645.247-.264.588-.401.345-.138.77-.138.568 0 .935.179.368.178.566.492.197.31.246.715h-.825a1.1 1.1 0 00-.135-.39.7.7 0 00-.29-.263 1 1 0 00-.48-.097 1 1 0 00-.44.094.86.86 0 00-.32.272 1.3 1.3 0 00-.196.443 2.6 2.6 0 00-.065.603v.288q0 .342.074.61.075.263.212.444.142.18.348.273.21.09.474.09.24 0 .397-.037.16-.042.255-.097a.7.7 0 00.148-.108v-.8h-.89v-.59z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.349.349 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "png-sync": {
    body: '<g fill="none"><path fill="#A066AA" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#A066AA" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#A066AA" d="M4.723 8.772H3.57V8.14h1.154q.284 0 .459-.088a.6.6 0 00.261-.246.76.76 0 00.083-.36.8.8 0 00-.083-.367.65.65 0 00-.261-.275.9.9 0 00-.459-.106h-.877v3.631H3V6.062h1.723q.523 0 .892.178.373.176.567.49.195.31.196.709 0 .413-.196.712-.194.3-.567.46a2.2 2.2 0 01-.892.161m5.92-2.71v4.266h-.85L7.89 7.368v2.96h-.846V6.062h.846L9.8 9.024V6.062zM15 8.122v1.661q-.1.12-.31.261t-.548.243a3 3 0 01-.831.1q-.428 0-.782-.135a1.69 1.69 0 01-1.003-1.046 2.5 2.5 0 01-.138-.87v-.282q0-.489.129-.87.132-.381.375-.645.247-.264.588-.401.345-.138.77-.138.568 0 .935.179.368.178.566.492.197.31.246.715h-.825a1.1 1.1 0 00-.135-.39.7.7 0 00-.29-.263 1 1 0 00-.48-.097 1 1 0 00-.44.094.86.86 0 00-.32.272 1.3 1.3 0 00-.196.443 2.6 2.6 0 00-.065.603v.288q0 .342.074.61.075.263.212.444.142.18.348.273.21.09.474.09.24 0 .397-.037.16-.042.255-.097a.7.7 0 00.148-.108v-.8h-.89v-.59z"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  pptx: {
    body: '<g fill="none"><path fill="#CE4525" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#CE4525" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><path fill="#CE4525" d="M10.734 11.517h-1.83v-1.055h1.83q.45 0 .728-.147a.95.95 0 00.415-.41q.132-.263.132-.6a1.4 1.4 0 00-.132-.61 1.06 1.06 0 00-.415-.46q-.279-.175-.728-.175H9.343v6.05H8V7h2.734q.831 0 1.416.298.591.293.899.815.312.518.312 1.182 0 .688-.312 1.186a2 2 0 01-.899.767q-.585.27-1.416.269"/></g>'
  },
  "pptx-link": {
    body: '<g fill="none"><path fill="#CE4525" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#CE4525" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#CE4525" d="M9.734 9.517h-1.83V8.462h1.83q.45 0 .728-.147a.95.95 0 00.415-.41q.132-.264.132-.6a1.4 1.4 0 00-.132-.61 1.06 1.06 0 00-.415-.46q-.279-.175-.728-.175H8.343v6.05H7V5h2.734q.831 0 1.416.298.591.293.899.815.312.518.312 1.182 0 .688-.312 1.186a2 2 0 01-.899.767q-.585.27-1.416.269"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.349.349 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "pptx-sync": {
    body: '<g fill="none"><path fill="#CE4525" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#CE4525" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#CE4525" d="M9.734 9.517h-1.83V8.462h1.83q.45 0 .728-.147a.95.95 0 00.415-.41q.132-.264.132-.6a1.4 1.4 0 00-.132-.61 1.06 1.06 0 00-.415-.46q-.279-.175-.728-.175H8.343v6.05H7V5h2.734q.831 0 1.416.298.591.293.899.815.312.518.312 1.182 0 .688-.312 1.186a2 2 0 01-.899.767q-.585.27-1.416.269"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  rcp: {
    body: '<g fill="none"><path fill="#58368A" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#58368A" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><path fill="#58368A" d="M4 8.07h1.697q.532 0 .915.165.381.165.587.49t.205.797q0 .374-.128.649a1.25 1.25 0 01-.363.46 1.8 1.8 0 01-.545.29l-.276.146H4.594l-.007-.718h1.12a.9.9 0 00.452-.099.65.65 0 00.27-.275.84.84 0 00.093-.4q0-.242-.09-.417a.6.6 0 00-.273-.275 1 1 0 00-.462-.096h-.815v4.1H4zm2.637 4.817-1.08-2.157.933-.004 1.094 2.115v.046zm4.274-1.585h.883a1.9 1.9 0 01-.26.857q-.225.37-.626.582-.4.213-.972.212a1.9 1.9 0 01-.793-.159 1.7 1.7 0 01-.6-.46q-.246-.3-.378-.72a3.2 3.2 0 01-.132-.95v-.368q0-.525.135-.95.135-.423.385-.72.253-.302.606-.464Q9.516 8 9.955 8q.57 0 .966.218.394.215.613.593.218.376.263.867h-.883a1.5 1.5 0 00-.128-.517.7.7 0 00-.301-.32q-.2-.113-.53-.113a1 1 0 00-.452.1.84.84 0 00-.321.297q-.129.195-.193.49a3 3 0 00-.064.675v.374q0 .367.058.658.057.292.18.493a.84.84 0 00.314.308.94.94 0 00.459.106q.324 0 .526-.106a.7.7 0 00.311-.311q.11-.206.138-.51m3.363-.172H13.07v-.715h1.203a1 1 0 00.478-.099.64.64 0 00.273-.278.9.9 0 00.086-.407 1 1 0 00-.086-.413.7.7 0 00-.273-.311.86.86 0 00-.478-.12h-.915v4.1h-.882V8.069h1.797q.546 0 .93.202.39.2.59.553.206.35.206.8 0 .468-.205.805a1.3 1.3 0 01-.59.52q-.386.18-.931.181"/></g>'
  },
  "rcp-link": {
    body: '<g fill="none"><path fill="#58368A" fill-rule="evenodd" d="M7.241 2v3.12c0 .6-.485.96-.97.96H3z" clip-rule="evenodd"/><path stroke="#58368A" stroke-linecap="round" stroke-linejoin="round" d="M13.5 20.121H4.094c-.547 0-1.094-.362-1.094-.966V5.625L7.24 2.12h10.666c.547 0 1.094.484 1.094.967V10"/><path fill="#58368A" d="M5 7.07h1.697q.532 0 .915.165.381.165.587.49t.205.797q0 .374-.128.649a1.25 1.25 0 01-.363.46 1.8 1.8 0 01-.545.29l-.276.146H5.594l-.007-.718h1.12a.9.9 0 00.452-.099.65.65 0 00.27-.275.84.84 0 00.093-.4q0-.242-.09-.417a.6.6 0 00-.273-.275 1 1 0 00-.462-.096h-.815v4.1H5zm2.637 4.817L6.557 9.73l.933-.004 1.094 2.115v.046zm4.274-1.585h.883a1.9 1.9 0 01-.26.857q-.225.37-.626.582-.4.213-.972.212a1.9 1.9 0 01-.793-.159 1.7 1.7 0 01-.6-.46q-.246-.3-.378-.72a3.2 3.2 0 01-.132-.95v-.368q0-.525.135-.95.135-.423.385-.72.253-.302.606-.464A1.9 1.9 0 0110.955 7q.57 0 .966.218.394.215.613.593.218.377.263.867h-.883a1.5 1.5 0 00-.128-.517.7.7 0 00-.301-.32q-.2-.114-.53-.113a1 1 0 00-.452.1.84.84 0 00-.321.297q-.129.195-.193.49a3 3 0 00-.064.675v.374q0 .367.058.658.057.292.18.493a.84.84 0 00.314.308.94.94 0 00.459.106q.324 0 .526-.106a.7.7 0 00.311-.311q.11-.206.138-.51m3.363-.172H14.07v-.715h1.203a1 1 0 00.478-.099.64.64 0 00.273-.278.9.9 0 00.086-.407 1 1 0 00-.086-.413.7.7 0 00-.273-.311.86.86 0 00-.478-.12h-.915v4.1h-.882V7.069h1.797q.546 0 .93.202.39.2.59.553.206.35.206.8 0 .468-.205.805a1.3 1.3 0 01-.59.52q-.385.18-.931.181"/><path fill="#726F74" d="m20.955 11.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.349.349 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>',
    width: 22,
    height: 21
  },
  "rcp-sync": {
    body: '<g fill="none"><path fill="#58368A" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#58368A" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path fill="#58368A" d="M3 6.07h1.697q.532 0 .915.165.381.165.587.49t.205.797q0 .374-.128.649a1.25 1.25 0 01-.363.46 1.8 1.8 0 01-.545.29l-.276.146H3.594l-.007-.718h1.12a.9.9 0 00.452-.099.65.65 0 00.27-.275.84.84 0 00.093-.4q0-.241-.09-.417a.6.6 0 00-.273-.275 1 1 0 00-.462-.096h-.815v4.1H3zm2.637 4.817L4.557 8.73l.933-.004 1.094 2.115v.046zm4.274-1.585h.883a1.9 1.9 0 01-.26.857q-.225.37-.626.582-.4.213-.972.212a1.9 1.9 0 01-.793-.159 1.7 1.7 0 01-.6-.46q-.246-.3-.378-.72a3.2 3.2 0 01-.132-.95v-.368q0-.525.135-.95.135-.423.385-.72.253-.302.606-.464Q8.516 6 8.955 6q.57 0 .966.218.394.215.613.593.218.376.263.867h-.883a1.5 1.5 0 00-.128-.517.7.7 0 00-.302-.32q-.198-.114-.529-.113a1 1 0 00-.452.1.84.84 0 00-.321.297q-.129.195-.193.49a3 3 0 00-.064.675v.374q0 .367.058.658.057.292.18.493a.84.84 0 00.314.308.94.94 0 00.459.106q.324 0 .526-.106a.7.7 0 00.311-.311q.11-.206.138-.51m3.363-.172H12.07v-.715h1.203a1 1 0 00.478-.099.64.64 0 00.273-.278.9.9 0 00.086-.407 1 1 0 00-.086-.413.7.7 0 00-.273-.311.86.86 0 00-.478-.12h-.915v4.1h-.882V6.069h1.797q.546 0 .93.202.39.2.59.553.206.35.206.8 0 .468-.205.805a1.3 1.3 0 01-.59.52q-.386.18-.931.181"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  rvt: {
    body: '<g fill="none"><path fill="#004576" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#004576" stroke-linecap="round" stroke-linejoin="round" d="M2 4.624v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.484-.547-.967-1.094-.967H6.239z"/><path fill="#004576" d="M4 7.5h1.72q.54 0 .928.176.387.177.595.523t.208.851q0 .399-.13.693t-.367.49a1.8 1.8 0 01-.553.311l-.28.156H4.6l-.006-.767H5.73a.9.9 0 00.458-.106.67.67 0 00.273-.293.94.94 0 00.095-.427q0-.258-.091-.445a.65.65 0 00-.277-.293.96.96 0 00-.468-.103h-.826v4.377H4zm2.674 5.143L5.578 10.34l.946-.004 1.11 2.257v.05zm3.162-1.007 1.18-4.136h.993l-1.672 5.143h-.66zM8.746 7.5l1.174 4.136.17 1.007h-.667L7.757 7.5zm5.784 0v5.143h-.892V7.5zm1.47 0v.766h-3.816V7.5z"/></g>'
  },
  "rvt-link": {
    body: '<g fill="none"><path fill="#004576" fill-rule="evenodd" d="M7.241 2v3.12c0 .6-.485.96-.97.96H3z" clip-rule="evenodd"/><path stroke="#004576" stroke-linecap="round" stroke-linejoin="round" d="M13.5 20.121H4.094c-.547 0-1.094-.362-1.094-.966V5.625L7.24 2.12h10.666c.547 0 1.094.483 1.094.967V10"/><path fill="#004576" d="M5 7h1.72q.54 0 .928.176.387.177.595.523t.208.851q0 .399-.13.693t-.367.49q-.234.199-.553.311l-.28.156H5.6l-.006-.767H6.73a.9.9 0 00.458-.106.67.67 0 00.273-.293.94.94 0 00.095-.427q0-.258-.091-.445a.65.65 0 00-.277-.293.96.96 0 00-.468-.103h-.826v4.377H5zm2.674 5.143L6.578 9.84l.946-.004 1.11 2.257v.05zm3.162-1.007L12.016 7h.993l-1.672 5.143h-.66zM9.746 7l1.174 4.136.17 1.007h-.667L8.757 7zm5.784 0v5.143h-.892V7zM17 7v.766h-3.816V7z"/><path fill="#726F74" d="m20.955 11.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.349.349 0 00.623-.131l1.2-5.47a.35.35 0 00-.307-.423"/></g>',
    width: 22,
    height: 21
  },
  "rvt-sync": {
    body: '<g fill="none"><path fill="#004576" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#004576" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.483 1.094.967V9"/><path fill="#004576" d="M3 6h1.72q.54 0 .928.176.387.177.595.523t.208.851q0 .399-.13.693t-.367.49q-.234.199-.553.311l-.28.156H3.6l-.006-.767H4.73a.9.9 0 00.458-.106.67.67 0 00.273-.293.94.94 0 00.095-.427q0-.258-.091-.445a.65.65 0 00-.277-.293.96.96 0 00-.468-.103h-.826v4.377H3zm2.674 5.143L4.578 8.84l.946-.004 1.11 2.257v.05zm3.162-1.007L10.016 6h.993l-1.672 5.143h-.66zM7.746 6l1.174 4.136.17 1.007h-.667L6.757 6zm5.784 0v5.143h-.892V6zM15 6v.766h-3.816V6z"/><path fill="#726F74" d="M17.14 12.467a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.623l.703-.703a.473.473 0 01.807.334v2.639a.47.47 0 01-.473.473h-2.639a.472.472 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.806l-.822.823a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.135.232.28a4.88 4.88 0 01-8.17 2.623l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  splat: {
    body: '<g fill="none"><path fill="#7B1FA2" fill-rule="evenodd" d="M6.241.999v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#7B1FA2" stroke-linecap="round" stroke-linejoin="round" d="M2 4.623v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.087c0-.484-.547-.967-1.094-.967H6.239z"/><path stroke="#7B1FA2" stroke-width=".8" d="M8.048 13.348c.257.815.304 1.633.191 2.287-.115.665-.375 1.075-.67 1.24-.297.165-.699.125-1.135-.232-.43-.35-.835-.97-1.092-1.784-.256-.815-.304-1.633-.19-2.287.114-.665.374-1.075.67-1.24s.698-.125 1.135.232c.43.35.835.97 1.091 1.784Zm6.117-2.976c-.577.466-1.16.699-1.627.719-.472.02-.774-.174-.902-.475-.128-.3-.103-.758.14-1.314a4.4 4.4 0 011.252-1.603c.577-.465 1.16-.698 1.627-.718.472-.02.774.174.902.475.127.3.103.757-.14 1.314a4.4 4.4 0 01-1.252 1.602Z"/><path stroke="#7B1FA2" stroke-width=".8" d="M10.41 15.74c-1.014-.007-1.912-.193-2.542-.47-.316-.14-.545-.295-.69-.445-.144-.149-.186-.272-.186-.367s.044-.217.189-.364c.146-.148.377-.3.694-.434.632-.268 1.532-.44 2.546-.433 1.015.008 1.913.193 2.543.471.316.14.545.294.69.444.144.149.186.272.186.367s-.044.218-.189.364c-.146.148-.377.3-.694.434-.632.268-1.532.44-2.546.433Zm2.668-6.31c.008.882-.217 1.664-.566 2.214-.352.554-.795.829-1.228.832s-.881-.264-1.244-.813c-.36-.544-.599-1.323-.607-2.205s.216-1.664.565-2.214c.352-.554.795-.829 1.228-.832s.882.265 1.244.813c.36.545.6 1.323.608 2.205Z"/><path stroke="#7B1FA2" stroke-width=".8" d="M7.969 9.571c-.91-.007-1.712-.197-2.272-.48-.584-.295-.79-.624-.79-.865.001-.242.21-.568.797-.855.563-.274 1.367-.452 2.276-.445.909.006 1.711.196 2.271.48.585.295.79.624.79.865-.001.241-.21.568-.797.854-.562.275-1.366.453-2.275.446Z"/></g>'
  },
  "splat-link": {
    body: '<g fill="none"><path fill="#7B1FA2" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#7B1FA2" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.483 1.094.967V9"/><path stroke="#7B1FA2" stroke-width=".8" d="M7.048 13.348c.257.815.304 1.633.191 2.287-.115.665-.375 1.075-.67 1.24-.297.165-.699.125-1.135-.232-.43-.35-.835-.97-1.092-1.784-.256-.815-.304-1.633-.19-2.287.114-.665.374-1.075.67-1.24s.698-.125 1.135.232c.43.35.835.97 1.091 1.784Zm6.117-2.976c-.577.466-1.16.699-1.627.719-.472.02-.774-.174-.902-.475-.128-.3-.103-.758.14-1.314a4.4 4.4 0 011.252-1.603c.577-.465 1.16-.698 1.627-.718.472-.02.774.174.902.475.127.3.103.757-.14 1.314a4.4 4.4 0 01-1.252 1.602Z"/><path stroke="#7B1FA2" stroke-width=".8" d="M9.41 15.74c-1.014-.007-1.912-.193-2.542-.47-.316-.14-.545-.295-.69-.445-.144-.149-.186-.272-.186-.367s.044-.217.189-.364c.146-.148.377-.3.694-.434.632-.268 1.532-.44 2.546-.433 1.015.008 1.913.193 2.543.471.316.14.545.294.69.444.144.149.186.272.186.367s-.044.218-.189.364c-.146.148-.377.3-.694.434-.632.268-1.532.44-2.546.433Zm2.668-6.31c.008.882-.217 1.664-.566 2.214-.352.554-.795.829-1.228.832s-.881-.264-1.244-.813c-.36-.544-.599-1.323-.607-2.205s.216-1.664.565-2.214c.352-.554.795-.829 1.228-.832s.882.265 1.244.813c.36.545.6 1.323.608 2.205Z"/><path stroke="#7B1FA2" stroke-width=".8" d="M6.969 9.571c-.91-.007-1.712-.197-2.272-.48-.584-.295-.79-.624-.79-.865.001-.242.21-.568.797-.855.563-.274 1.367-.452 2.276-.445.909.006 1.711.196 2.271.48.585.295.79.624.79.865-.001.241-.21.568-.797.854-.562.275-1.366.453-2.275.446Z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.13a.348.348 0 00.627-.263l-.041-.243a4.28 4.28 0 011.716-4.185l.402-.293 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.422"/></g>'
  },
  "splat-sync": {
    body: '<g fill="none"><path fill="#7B1FA2" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#7B1FA2" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path stroke="#7B1FA2" stroke-width=".8" d="M7.048 13.348c.257.815.304 1.633.191 2.287-.115.665-.375 1.075-.67 1.24-.297.165-.699.125-1.135-.232-.43-.35-.835-.97-1.092-1.784-.256-.815-.304-1.633-.19-2.287.114-.665.374-1.075.67-1.24s.698-.125 1.135.232c.43.35.835.97 1.091 1.784Zm6.117-2.976c-.577.466-1.16.699-1.627.719-.472.02-.774-.174-.902-.475-.128-.3-.103-.758.14-1.314a4.4 4.4 0 011.252-1.603c.577-.465 1.16-.698 1.627-.718.472-.02.774.174.902.475.127.3.103.757-.14 1.314a4.4 4.4 0 01-1.252 1.602Z"/><path stroke="#7B1FA2" stroke-width=".8" d="M9.41 15.74c-1.014-.007-1.912-.193-2.542-.47-.316-.14-.545-.295-.69-.445-.144-.149-.186-.272-.186-.367s.044-.217.189-.364c.146-.148.377-.3.694-.434.632-.268 1.532-.44 2.546-.433 1.015.008 1.913.193 2.543.471.316.14.545.294.69.444.144.149.186.272.186.367s-.044.218-.189.364c-.146.148-.377.3-.694.434-.632.268-1.532.44-2.546.433Zm2.668-6.31c.008.882-.217 1.664-.566 2.214-.352.554-.795.829-1.228.832s-.881-.264-1.244-.813c-.36-.544-.599-1.323-.607-2.205s.216-1.664.565-2.214c.352-.554.795-.829 1.228-.832s.882.265 1.244.813c.36.545.6 1.323.608 2.205Z"/><path stroke="#7B1FA2" stroke-width=".8" d="M6.969 9.571c-.91-.007-1.712-.197-2.272-.48-.584-.295-.79-.624-.79-.865.001-.242.21-.568.797-.855.563-.274 1.367-.452 2.276-.445.909.006 1.711.196 2.271.48.585.295.79.624.79.865-.001.241-.21.568-.797.854-.562.275-1.366.453-2.275.446Z"/><path fill="#726F74" d="M17.14 12.466a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.703a.473.473 0 01.807.333v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  tif: {
    body: '<g fill="none"><path fill="#1565C0" fill-rule="evenodd" d="M6.241.999v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#1565C0" stroke-linecap="round" stroke-linejoin="round" d="M2 4.623v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.087c0-.484-.547-.967-1.094-.967H6.239z"/><path fill="#1565C0" d="M7.564 8.023V13h-.936V8.023zm1.545 0v.742H5.1v-.742zm1.627 0V13h-.94V8.023zm1.955 0V13h-.94V8.023zm2.007 2.15v.742h-2.253v-.742zm.263-2.15v.742h-2.516v-.742z"/></g>'
  },
  "tif-link": {
    body: '<g fill="none"><path fill="#1565C0" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#1565C0" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#1565C0" d="M6.879 5.734V10h-.803V5.734zm1.324 0v.636H4.767v-.636zm1.395 0V10h-.806V5.734zm1.675 0V10h-.805V5.734zm1.72 1.843v.636h-1.93v-.636zm.226-1.843v.636h-2.156v-.636z"/><path fill="#726F74" d="m18.955 10.314-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.069a5.005 5.005 0 00-1.106 6.983l.82 1.13a.348.348 0 00.605-.074.35.35 0 00.021-.19l-.04-.242a4.28 4.28 0 011.716-4.185l.402-.293 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.422"/></g>'
  },
  "tif-sync": {
    body: '<g fill="none"><path fill="#1565C0" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#1565C0" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#1565C0" d="M6.879 5.734V10h-.803V5.734zm1.324 0v.636H4.767v-.636zm1.395 0V10h-.806V5.734zm1.675 0V10h-.805V5.734zm1.72 1.843v.636h-1.93v-.636zm.226-1.843v.636h-2.156v-.636z"/><path fill="#726F74" d="M17.14 12.466a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.703a.473.473 0 01.807.333v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  tiff: {
    body: '<g fill="none"><path fill="#1565C0" fill-rule="evenodd" d="M6.241.999v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#1565C0" stroke-linecap="round" stroke-linejoin="round" d="M2 4.623v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.087c0-.484-.547-.967-1.094-.967H6.239z"/><path fill="#1565C0" d="M5.601 8.023V13h-.936V8.023zm1.545 0v.742h-4.01v-.742zm1.627 0V13h-.94V8.023zm1.955 0V13h-.94V8.023zm2.006 2.15v.742h-2.252v-.742zm.264-2.15v.742h-2.516v-.742zm1.579 0V13h-.94V8.023zm2.006 2.15v.742h-2.252v-.742zm.263-2.15v.742h-2.515v-.742z"/></g>'
  },
  "tiff-link": {
    body: '<g fill="none"><path fill="#1565C0" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#1565C0" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#1565C0" d="M5.312 5.734V10H4.51V5.734zm1.325 0v.636H3.2v-.636zm1.394 0V10h-.806V5.734zm1.676 0V10H8.9V5.734zm1.72 1.843v.636H9.496v-.636zm.225-1.843v.636H9.496v-.636zm1.354 0V10H12.2V5.734zm1.72 1.843v.636h-1.931v-.636zm.225-1.843v.636h-2.156v-.636z"/><path fill="#726F74" d="m18.955 10.314-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.069a5.005 5.005 0 00-1.106 6.983l.82 1.13a.348.348 0 00.605-.074.35.35 0 00.021-.19l-.04-.242a4.28 4.28 0 011.716-4.185l.402-.293 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.422"/></g>'
  },
  "tiff-sync": {
    body: '<g fill="none"><path fill="#1565C0" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#1565C0" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#1565C0" d="M5.313 5.734V10H4.51V5.734zm1.324 0v.636H3.2v-.636zm1.394 0V10h-.805V5.734zm1.676 0V10h-.806V5.734zm1.72 1.843v.636h-1.93v-.636zm.225-1.843v.636H9.496v-.636zm1.354 0V10H12.2V5.734zm1.72 1.843v.636h-1.931v-.636zm.225-1.843v.636h-2.156v-.636z"/><path fill="#726F74" d="M17.14 12.466a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.703a.473.473 0 01.807.333v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  videos: {
    body: '<g fill="none"><path fill="red" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="red" stroke-linecap="round" stroke-linejoin="round" d="M2 4.625v13.53c0 .604.547.966 1.094.966h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.483-.547-.967-1.094-.967H6.239z"/><path stroke="red" stroke-width="1.25" d="m13.312 10.32-5.113 3.194a.375.375 0 01-.574-.318V6.805c0-.295.324-.474.574-.318l5.113 3.197a.375.375 0 010 .636Z"/></g>'
  },
  "videos-link": {
    body: '<g fill="none"><path fill="red" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="red" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path stroke="red" stroke-width="1.25" d="m12.312 9.32-5.113 3.194a.375.375 0 01-.574-.318V5.805c0-.295.324-.474.574-.318l5.113 3.197a.375.375 0 010 .636Z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.348.348 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/></g>'
  },
  "videos-sync": {
    body: '<g fill="none"><path fill="red" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="red" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><path stroke="red" stroke-width="1.25" d="m12.312 9.32-5.113 3.194a.375.375 0 01-.574-.318V5.805c0-.295.324-.474.574-.318l5.113 3.197a.375.375 0 010 .636Z"/><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  xlsx: {
    body: '<g fill="none"><path fill="#107C41" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#107C41" stroke-linecap="round" stroke-linejoin="round" d="M2 4.624v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.484-.547-.967-1.094-.967H6.239z"/><path fill="#107C41" d="m7.922 6 1.705 3.04L11.337 6h1.853l-2.532 4.23 2.596 4.301h-1.87l-1.757-3.1-1.752 3.1H6l2.596-4.3L6.064 6z"/></g>'
  },
  "xlsx-link": {
    body: '<g fill="none"><path fill="#107C41" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#107C41" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.483 1.094.967V9"/><path fill="#107C41" d="m7.422 5 1.705 3.04L10.837 5h1.853l-2.532 4.23 2.596 4.301h-1.87l-1.757-3.1-1.752 3.1H5.5l2.596-4.3L5.564 5z"/><path fill="#726F74" d="m18.955 10.315-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.626-.263l-.04-.242a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.349.349 0 00.623-.131l1.2-5.47a.35.35 0 00-.307-.423"/></g>'
  },
  "xlsx-sync": {
    body: '<g fill="none"><path fill="#107C41" fill-rule="evenodd" d="M6.241 2v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#107C41" stroke-linecap="round" stroke-linejoin="round" d="M9.5 20.121H3.094c-.547 0-1.094-.362-1.094-.966V5.625L6.24 2.12h10.666c.547 0 1.094.483 1.094.967V10"/><path fill="#107C41" d="m8.422 6 1.705 3.04L11.837 6h1.853l-2.532 4.23L13 13l-1.115 1.531-1.758-3.1-1.752 3.1H6.5l2.596-4.3L6.564 6z"/><path fill="#726F74" d="M18.14 13.467a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.623l.703-.703a.473.473 0 01.807.334v2.639a.47.47 0 01-.473.473h-2.639a.472.472 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.806l-.822.823a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.135.232.28a4.88 4.88 0 01-8.17 2.623l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>',
    width: 21,
    height: 21
  },
  xml: {
    body: '<g fill="none"><path fill="#00695C" fill-rule="evenodd" d="M6.241.999v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#00695C" stroke-linecap="round" stroke-linejoin="round" d="M2 4.623v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.087c0-.484-.547-.967-1.094-.967H6.239z"/><path fill="#00695C" d="m4.121 8.023.995 1.774.998-1.774h1.08l-1.477 2.468L7.231 13h-1.09l-1.025-1.808L4.094 13H3l1.514-2.509-1.476-2.468zm4.098 0h.814l1.36 3.747 1.357-3.747h.817L10.717 13h-.652zm-.41 0h.796l.144 3.442V13h-.94zm4.368 0h.8V13h-.94v-1.535zm4.915 4.239V13H14.59v-.738zm-2.218-4.239V13h-.94V8.023z"/></g>'
  },
  "xml-link": {
    body: '<g fill="none"><path fill="#00695C" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#00695C" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#00695C" d="m3.9 5.734.852 1.52.855-1.52h.926L5.268 7.85 6.565 10h-.934l-.88-1.55L3.877 10h-.938l1.298-2.15-1.265-2.116zm3.512 0h.697l1.166 3.211 1.163-3.21h.7L9.555 10h-.56zm-.351 0h.682l.123 2.95V10h-.805zm3.744 0h.685V10h-.805V8.685zm4.213 3.633V10h-2.145v-.633zm-1.902-3.633V10h-.806V5.734z"/><path fill="#726F74" d="m18.955 10.314-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.069a5.005 5.005 0 00-1.106 6.983l.82 1.13a.348.348 0 00.605-.074.35.35 0 00.021-.19l-.04-.242a4.28 4.28 0 011.716-4.185l.402-.293 1.162 1.6a.349.349 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.422"/></g>'
  },
  "xml-sync": {
    body: '<g fill="none"><path fill="#00695C" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#00695C" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.483 1.094.967v6.912"/><path fill="#00695C" d="m3.9 5.734.852 1.52.855-1.52h.926L5.268 7.85 6.565 10h-.934l-.88-1.55L3.877 10h-.938l1.298-2.15-1.265-2.116zm3.512 0h.697l1.166 3.211 1.163-3.21h.7L9.555 10h-.56zm-.351 0h.682l.123 2.95V10h-.805zm3.744 0h.685V10h-.805V8.685zm4.213 3.633V10h-2.145v-.633zm-1.902-3.633V10h-.806V5.734z"/><path fill="#726F74" d="M17.14 12.466a3.312 3.312 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.703a.473.473 0 01.807.333v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/></g>'
  },
  zip: {
    body: '<g fill="none"><path fill="#E9B233" fill-rule="evenodd" d="M6.241 1v3.12c0 .6-.485.96-.97.96H2z" clip-rule="evenodd"/><path stroke="#E9B233" stroke-linecap="round" stroke-linejoin="round" d="M2 4.624v13.53c0 .605.547.967 1.094.967h13.812c.684 0 1.094-.483 1.094-.966V2.088c0-.484-.547-.967-1.094-.967H6.239z"/><g clip-path="url(#svgID0)"><path stroke="#E9B233" stroke-dasharray="1 1" stroke-width="1.3" d="M-5 10.017h18.667"/><path fill="#E9B233" d="m11 9.333 3.393-.848a1.562 1.562 0 110 3.03L11 10.667z"/><circle cx="13.667" cy="10" r=".667" fill="#fff"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M2 8h15v4H2z"/></clipPath></defs></g>'
  },
  "zip-link": {
    body: '<g fill="none"><path fill="#E9B233" fill-rule="evenodd" d="M5.241.999v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#E9B233" stroke-linecap="round" stroke-linejoin="round" d="M11.5 19.12H2.094c-.547 0-1.094-.362-1.094-.966V4.624L5.24 1.12h10.666c.547 0 1.094.484 1.094.967v6.912"/><g clip-path="url(#svgID0)"><path stroke="#E9B233" stroke-dasharray="1 1" stroke-width="1.3" d="M-6 8.016h18.667"/><path fill="#E9B233" d="m10 7.332 3.393-.848a1.562 1.562 0 110 3.03L10 8.666z"/><circle cx="12.667" cy="7.999" r=".667" fill="#fff"/></g><path fill="#726F74" d="m18.955 10.314-5.573-.55a.348.348 0 00-.317.553l.888 1.223-.094.068a5.006 5.006 0 00-1.106 6.984l.82 1.129a.348.348 0 00.626-.262l-.04-.243a4.28 4.28 0 011.716-4.186l.402-.292 1.162 1.6a.35.35 0 00.623-.13l1.2-5.471a.35.35 0 00-.307-.423"/><defs><clipPath id="svgID0"><path fill="#fff" d="M1 5.999h15v4H1z"/></clipPath></defs></g>'
  },
  "zip-sync": {
    body: '<g fill="none"><path fill="#E9B233" fill-rule="evenodd" d="M5.241 1v3.12c0 .6-.485.96-.97.96H1z" clip-rule="evenodd"/><path stroke="#E9B233" stroke-linecap="round" stroke-linejoin="round" d="M8.5 19.121H2.094c-.547 0-1.094-.362-1.094-.966V4.625L5.24 1.12h10.666c.547 0 1.094.484 1.094.967V9"/><g clip-path="url(#svgID0)"><path stroke="#E9B233" stroke-dasharray="1 1" stroke-width="1.3" d="M-6 8.017h18.667"/><path fill="#E9B233" d="m10 7.333 3.393-.848a1.562 1.562 0 110 3.03L10 8.667z"/><circle cx="12.667" cy="8" r=".667" fill="#fff"/></g><path fill="#726F74" d="M17.14 12.467a3.31 3.31 0 00-5.467 1.607.24.24 0 01-.228.18h-1.129a.236.236 0 01-.232-.28 4.884 4.884 0 018.172-2.622l.703-.704a.473.473 0 01.807.334v2.64c0 .26-.211.472-.473.472h-2.639a.473.473 0 01-.334-.807zm-6.667 3.203h2.638c.422 0 .631.51.334.807l-.822.822a3.28 3.28 0 002.262.89 3.31 3.31 0 003.205-2.498.24.24 0 01.228-.18h1.13c.148 0 .259.136.232.28a4.88 4.88 0 01-4.797 3.975 4.87 4.87 0 01-3.373-1.352l-.703.703a.473.473 0 01-.807-.334v-2.64c0-.26.21-.473.473-.473"/><defs><clipPath id="svgID0"><path fill="#fff" d="M1 6h15v4H1z"/></clipPath></defs></g>'
  }
}, wfe = {
  video: {
    parent: "videos"
  },
  "video-link": {
    parent: "videos-link"
  },
  "video-sync": {
    parent: "videos-sync"
  }
}, _fe = 20, Cfe = 20, Efe = {
  prefix: yfe,
  lastModified: bfe,
  icons: xfe,
  aliases: wfe,
  width: _fe,
  height: Cfe
}, Sfe = "#fff", Mfe = "#F5F3F6", Tfe = "#D8D6D9", Afe = "#BCB9BE", Pfe = "#8A858E", Rfe = "#726F74", Lfe = "#4C494E", Ofe = "#333234", Dfe = "#E5ECFF", kfe = "#B2C6FF", Nfe = "#809FFF", Ife = "#0040FF", Ffe = "#002699", Ufe = "#E5F1ED", zfe = "#E5F1ED", Hfe = "#4CB176", Bfe = "#0B883D", Vfe = "#F6E3EB", $fe = "#EBB4C4", Wfe = "#D04A6B", jfe = "#A60C31", Gfe = "#FBEEEA", qfe = "#FAD5C1", Xfe = "#F69C64", Yfe = "#F47C31", Zfe = "#E3ECFB", Kfe = "#B0CEF4", Jfe = "#3F8AE2", Qfe = "#015BC5", e0e = "#FEF6F0", t0e = "#FCD7C0", n0e = "#F9B890", r0e = "#F47C31", i0e = "#CB550B", o0e = "400 56px/64px Raleway", a0e = "400 40px/48px Raleway", s0e = "600 28px/32px Raleway", l0e = "600 20px/24px Raleway", e6 = "400 20px/24px 'Roboto Flex'", t6 = "400 16px/20px 'Roboto Flex'", n6 = "600 16px/20px 'Roboto Flex'", r6 = "400 12px/20px 'Roboto Flex'", i6 = "600 12px/20px 'Roboto Flex'", c0e = "400 10px/14px 'Roboto Flex'", u0e = "600 10px/14px 'Roboto Flex'", d0e = "600 10px/14px 'Roboto Flex'", f0e = "400 8px/12px 'Roboto Flex'", h0e = "600 8px/12px 'Roboto Flex'", o6 = "600 16px/20px 'Roboto Flex'", a6 = "600 12px/16px 'Roboto Flex'", p0e = "600 10px/14px 'Roboto Flex'", m0e = "600 8px/12px 'Roboto Flex'", v0e = "4px", g0e = "8px", y0e = "12px", b0e = "16px", x0e = "20px", w0e = "24px", _0e = "28px", C0e = "32px", E0e = "4px", S0e = "8px", M0e = "12px", T0e = "16px";
function A0e(t) {
  return t != null && typeof t == "object" && t["@@functional/placeholder"] === !0;
}
var sm = A0e, P0e = sm;
function R0e(t) {
  return function e(n) {
    return arguments.length === 0 || P0e(n) ? e : t.apply(this, arguments);
  };
}
var b_ = R0e, Z0 = b_, el = sm;
function L0e(t) {
  return function e(n, r) {
    switch (arguments.length) {
      case 0:
        return e;
      case 1:
        return el(n) ? e : Z0(function(i) {
          return t(n, i);
        });
      default:
        return el(n) && el(r) ? e : el(n) ? Z0(function(i) {
          return t(i, r);
        }) : el(r) ? Z0(function(i) {
          return t(n, i);
        }) : t(n, r);
    }
  };
}
var x_ = L0e, du = b_, ba = x_, hn = sm;
function O0e(t) {
  return function e(n, r, i) {
    switch (arguments.length) {
      case 0:
        return e;
      case 1:
        return hn(n) ? e : ba(function(o, a) {
          return t(n, o, a);
        });
      case 2:
        return hn(n) && hn(r) ? e : hn(n) ? ba(function(o, a) {
          return t(o, r, a);
        }) : hn(r) ? ba(function(o, a) {
          return t(n, o, a);
        }) : du(function(o) {
          return t(n, r, o);
        });
      default:
        return hn(n) && hn(r) && hn(i) ? e : hn(n) && hn(r) ? ba(function(o, a) {
          return t(o, a, i);
        }) : hn(n) && hn(i) ? ba(function(o, a) {
          return t(o, r, a);
        }) : hn(r) && hn(i) ? ba(function(o, a) {
          return t(n, o, a);
        }) : hn(n) ? du(function(o) {
          return t(o, r, i);
        }) : hn(r) ? du(function(o) {
          return t(n, o, i);
        }) : hn(i) ? du(function(o) {
          return t(n, r, o);
        }) : t(n, r, i);
    }
  };
}
var w_ = O0e;
function D0e(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
var k0e = D0e;
function N0e(t, e) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
var I0e = N0e, F0e = w_, fu = I0e, U0e = /* @__PURE__ */ F0e(function(e, n, r) {
  var i = {}, o;
  n = n || {}, r = r || {};
  for (o in n)
    fu(o, n) && (i[o] = fu(o, r) ? e(o, n[o], r[o]) : n[o]);
  for (o in r)
    fu(o, r) && !fu(o, i) && (i[o] = r[o]);
  return i;
}), z0e = U0e, H0e = w_, s6 = k0e, B0e = z0e, V0e = /* @__PURE__ */ H0e(function t(e, n, r) {
  return B0e(function(i, o, a) {
    return s6(o) && s6(a) ? t(e, o, a) : e(i, o, a);
  }, n, r);
}), $0e = V0e, W0e = x_, j0e = $0e, G0e = /* @__PURE__ */ W0e(function(e, n) {
  return j0e(function(r, i, o) {
    return i;
  }, e, n);
}), q0e = G0e;
const X0e = /* @__PURE__ */ q1(q0e), l6 = {
  colors: {
    alert: {
      100: Vfe,
      200: $fe,
      300: Wfe,
      400: jfe
    },
    info: {
      100: Zfe,
      200: Kfe,
      300: Jfe,
      400: Qfe
    },
    neutral: {
      100: Sfe,
      200: Mfe,
      300: Tfe,
      400: Afe,
      500: Pfe,
      600: Rfe,
      700: Lfe,
      800: Ofe
    },
    primary: {
      100: Dfe,
      200: kfe,
      300: Nfe,
      400: Ife,
      500: Ffe
    },
    skandI: {
      100: e0e,
      200: t0e,
      300: n0e,
      400: r0e,
      500: i0e
    },
    success: {
      100: Ufe,
      200: zfe,
      300: Hfe,
      400: Bfe
    },
    warning: {
      100: Gfe,
      200: qfe,
      300: Xfe,
      400: Yfe
    }
  },
  spacing: {
    1: v0e,
    2: g0e,
    3: y0e,
    4: b0e,
    5: x0e,
    6: w0e,
    7: _0e,
    8: C0e
  },
  borderRadius: {
    1: E0e,
    2: S0e,
    3: M0e,
    4: T0e
  },
  boxShadow: {
    general: "0px 2px 2px 0px rgba(0,0,0,0.15)"
  }
}, Whe = ({ includeReset: t, themeOverrides: e } = {}) => {
  const n = e ? X0e(e, l6) : l6;
  return {
    name: "presetSkand",
    preflights: [
      {
        getCSS: () => t ? "*, *:before, *:after { box-sizing: border-box; margin: 0; padding: 0; }" : void 0
      }
    ],
    presets: [
      S_({
        collections: {
          skand: gfe,
          fs: () => Efe
        }
      })
    ],
    theme: n,
    rules: [
      ["typo-button-xs", { font: d0e }],
      ["typo-heading-1", { font: o0e }],
      ["typo-heading-2", { font: a0e }],
      ["typo-heading-3", { font: s0e }],
      ["typo-heading-4", { font: l0e }],
      ["typo-link-m", { font: o6 }],
      ["typo-link-s", { font: a6 }],
      ["typo-link-xs", { font: p0e }],
      ["typo-link-xxs", { font: m0e }],
      ["typo-text-l", { font: e6 }],
      ["typo-text-m-em", { font: n6 }],
      ["typo-text-m", { font: t6 }],
      ["typo-text-s-em", { font: i6 }],
      ["typo-text-s", { font: r6 }],
      ["typo-text-xs-em", { font: u0e }],
      ["typo-text-xs", { font: c0e }],
      ["typo-text-xxs-em", { font: h0e }],
      ["typo-text-xxs", { font: f0e }],
      ["typo-link-medium", { font: o6 }],
      ["typo-link-small", { font: a6 }],
      ["typo-text-large", { font: e6 }],
      ["typo-text-medium-em", { font: n6 }],
      ["typo-text-medium", { font: t6 }],
      ["typo-text-small-em", { font: i6 }],
      ["typo-text-small", { font: r6 }]
    ]
  };
};
export {
  md as Button,
  X6 as Calendar,
  ZS as CheckBox,
  pM as CheckBoxV2,
  ihe as ColorPicker,
  ohe as ColorSelect,
  ahe as DatePicker,
  G8 as Dropdown,
  she as DropdownItem,
  fhe as EmptyDesc,
  bY as EmptyRoot,
  dhe as EmptyTitle,
  uhe as EmptyToast,
  xhe as ImagePreview,
  whe as Input,
  Xse as Menu,
  Yse as MenuItem,
  Zse as Modal,
  zZ as ModalV2,
  _he as Pagination,
  _x as PaginationContent,
  F1 as PaginationEllipsis,
  Qa as PaginationLink,
  Ex as PaginationNext,
  Cx as PaginationPrevious,
  wx as PaginationRoot,
  Ehe as Popover,
  Mhe as PopoverAnchor,
  oce as PopoverContent,
  She as PopoverTrigger,
  L7 as Progress,
  ace as ProgressButton,
  lce as QuickList,
  Rhe as ResizeHandle,
  Phe as ResizePanel,
  Ahe as ResizePanelGroup,
  pG as Rnd,
  mq as Select,
  Lhe as Skeleton,
  q7 as Slider,
  Ohe as Spinner,
  Wce as Switch,
  Nhe as Tabs,
  uue as TabsContent,
  hue as TabsContentV2,
  lue as TabsList,
  due as TabsListV2,
  cue as TabsTrigger,
  fue as TabsTriggerV2,
  Ihe as TabsV2,
  q8 as Toast,
  che as ToastRoot,
  Hhe as Tooltip,
  Que as TooltipContent,
  zhe as TooltipProvider,
  Bhe as TooltipTrigger,
  Vhe as Tree,
  $he as VideoPreview,
  J0e as button,
  vM as chip,
  nhe as chipClose,
  ehe as chipIcon,
  the as chipProbe,
  ve as cn,
  yY as dismiss,
  rhe as inverted,
  Whe as presetSkand,
  l6 as theme,
  lhe as toast,
  Jse as usePagination,
  r2 as useToast
};
//# sourceMappingURL=index.es.js.map
